export const SHOWS = [
  {
    id: 1,
    url: "https://www.tvmaze.com/shows/1/under-the-dome",
    name: "Under the Dome",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/81/202627.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/81/202627.jpg",
    },
    summary:
      "<p><b>Under the Dome</b> is the story of a small town that is suddenly and inexplicably sealed off from the rest of the world by an enormous transparent dome. The town's inhabitants must deal with surviving the post-apocalyptic conditions while searching for answers about the dome, where it came from and if and when it will go away.</p>",
    officialSite: "http://www.cbs.com/shows/under-the-dome/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-06-24",
  },
  {
    id: 2,
    url: "https://www.tvmaze.com/shows/2/person-of-interest",
    name: "Person of Interest",
    genres: ["Action", "Crime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/163/407679.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/163/407679.jpg",
    },
    summary:
      "<p>You are being watched. The government has a secret system, a machine that spies on you every hour of every day. I know because I built it. I designed the Machine to detect acts of terror but it sees everything. Violent crimes involving ordinary people. People like you. Crimes the government considered \"irrelevant\". They wouldn't act so I decided I would. But I needed a partner. Someone with the skills to intervene. Hunted by the authorities, we work in secret. You'll never find us. But victim or perpetrator, if your number is up, we'll find you.</p>",
    officialSite: "http://www.cbs.com/shows/person_of_interest/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-22",
  },
  {
    id: 3,
    url: "https://www.tvmaze.com/shows/3/bitten",
    name: "Bitten",
    genres: ["Drama", "Horror", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/15.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/15.jpg",
    },
    summary:
      '<p>Based on the critically acclaimed series of novels from Kelley Armstrong. Set in Toronto and upper New York State, <b>Bitten</b> follows the adventures of 28-year-old Elena Michaels, the world\'s only female werewolf. An orphan, Elena thought she finally found her "happily ever after" with her new love Clayton, until her life changed forever. With one small bite, the normal life she craved was taken away and she was left to survive life with the Pack.</p>',
    officialSite: "http://bitten.space.ca/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 7,
      name: "CTV Sci-Fi Channel",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2014-01-11",
  },
  {
    id: 4,
    url: "https://www.tvmaze.com/shows/4/arrow",
    name: "Arrow",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/213/534017.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/213/534017.jpg",
    },
    summary:
      "<p>After a violent shipwreck, billionaire playboy Oliver Queen was missing and presumed dead for five years before being discovered alive on a remote island in the Pacific. He returned home to Starling City, welcomed by his devoted mother Moira, beloved sister Thea and former flame Laurel Lance. With the aid of his trusted chauffeur/bodyguard John Diggle, the computer-hacking skills of Felicity Smoak and the occasional, reluctant assistance of former police detective, now beat cop, Quentin Lance, Oliver has been waging a one-man war on crime.</p>",
    officialSite: "http://www.cwtv.com/shows/arrow",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-10-10",
  },
  {
    id: 5,
    url: "https://www.tvmaze.com/shows/5/true-detective",
    name: "True Detective",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/178/445621.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/178/445621.jpg",
    },
    summary:
      "<p>Touch darkness and darkness touches you back. <b>True Detective</b> centers on troubled cops and the investigations that drive them to the edge. Each season features a new cast and a new case.</p>",
    officialSite: "http://www.hbo.com/true-detective",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-12",
  },
  {
    id: 6,
    url: "https://www.tvmaze.com/shows/6/the-100",
    name: "The 100",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/257/642675.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/257/642675.jpg",
    },
    summary:
      "<p>Ninety-seven years ago, nuclear Armageddon decimated planet Earth, destroying civilization. The only survivors were the 400 inhabitants of 12 international space stations that were in orbit at the time. Three generations have been born in space, the survivors now number 4,000, and resources are running out on their dying \"Ark\" - the 12 stations now linked together and repurposed to keep the survivors alive. Draconian measures including capital punishment and population control are the order of the day, as the leaders of the Ark take ruthless steps to ensure their future, including secretly exiling a group of 100 juvenile prisoners to the Earth's surface to test whether it's habitable.</p>",
    officialSite: "http://www.cwtv.com/shows/the-100/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-03-19",
  },
  {
    id: 7,
    url: "https://www.tvmaze.com/shows/7/homeland",
    name: "Homeland",
    genres: ["Drama", "Thriller", "Espionage"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/230/575652.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/230/575652.jpg",
    },
    summary:
      "<p>The winner of 6 Emmy Awards including Outstanding Drama Series, <b>Homeland</b> is an edge-of-your-seat sensation. Marine Sergeant Nicholas Brody is both a decorated hero and a serious threat. CIA officer Carrie Mathison is tops in her field despite being bipolar. The delicate dance these two complex characters perform, built on lies, suspicion, and desire, is at the heart of this gripping, emotional thriller in which nothing short of the fate of our nation is at stake.</p>",
    officialSite: "http://www.sho.com/sho/homeland/home",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-10-02",
  },
  {
    id: 8,
    url: "https://www.tvmaze.com/shows/8/glee",
    name: "Glee",
    genres: ["Drama", "Music", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/73.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/73.jpg",
    },
    summary:
      "<p><b>Glee </b>is a musical comedy about a group of ambitious and talented young adults in search of strength, acceptance and, ultimately, their voice.</p>",
    officialSite: "http://www.fox.com/glee",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-05-19",
  },
  {
    id: 9,
    url: "https://www.tvmaze.com/shows/9/revenge",
    name: "Revenge",
    genres: ["Drama", "Thriller", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/82/206879.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/82/206879.jpg",
    },
    summary:
      "<p>This is not a story about forgiveness; <b>Revenge</b> is a show about retribution. Meet Emily Thorne, the newest resident of The Hamptons. When she was a little girl (and known as Amanda Clarke) her father, David Clarke, was framed for a horrific crime and subsequently sent to prison. While serving his time, the conspirators plotted and murdered David in order to prevent the truth from coming out. Emily is now back with a new identity and ready to take vengeance on the people that murdered her father and stole her childhood.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-21",
  },
  {
    id: 10,
    url: "https://www.tvmaze.com/shows/10/grimm",
    name: "Grimm",
    genres: ["Drama", "Crime", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/69/174906.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/69/174906.jpg",
    },
    summary:
      "<p><b>Grimm </b>is a drama series inspired by the classic Grimm Brothers' Fairy Tales. After Portland homicide detective Nick Burkhardt discovers he's descended from an elite line of criminal profilers known as \"Grimms\", he increasingly finds his responsibilities as a detective at odds with his new responsibilities as a Grimm.</p>",
    officialSite: "http://www.nbc.com/grimm",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-10-28",
  },
  {
    id: 11,
    url: "https://www.tvmaze.com/shows/11/gotham",
    name: "Gotham",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/189/474715.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/189/474715.jpg",
    },
    summary:
      "<p>The good. The evil. The beginning.</p><p>Everyone knows the name Commissioner Gordon. He is one of the crime world's greatest foes, a man whose reputation is synonymous with law and order. But what is known of Gordon's story and his rise from rookie detective to Police Commissioner? What did it take to navigate the multiple layers of corruption that secretly ruled Gotham City, the spawning ground of the world's most iconic villains? And what circumstances created them – the larger-than-life personas who would become Catwoman, The Penguin, The Riddler, Two-Face and The Joker?</p><p><b>Gotham </b>is an origin story of the great DC Comics Super-Villains and vigilantes, revealing an entirely new chapter that has never been told. It follows one cop's rise through a dangerously corrupt city teetering between good and evil, and chronicles the birth of one of the most popular super heroes of our time.</p>",
    officialSite: "http://www.fox.com/gotham",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-22",
  },
  {
    id: 12,
    url: "https://www.tvmaze.com/shows/12/lost-girl",
    name: "Lost Girl",
    genres: ["Drama", "Fantasy", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/137.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/137.jpg",
    },
    summary:
      "<p><b>Lost Girl</b> follows supernatural seductress Bo, a Succubus who feeds on the sexual energy of humans. Growing up with human parents, Bo had no reason to believe she was anything other than the girl next door — until she drained her boyfriend to death in their first sexual encounter. Now she has hit the road alone and afraid. <br /> She discovers she is one of the Fae, creatures of legend and folklore, who pass as humans while feeding off them secretly and in different ways, as they have for millennia. Relieved yet horrified to find out that she is not alone, Bo decides to take the middle path between the humans and the Fae while embarking on a personal mission to unlock the secrets of her origin.</p><p>With the help of her human sidekick, Kenzi, and Dyson, a sexy police detective, Bo takes on a challenge every week helping a Fae or human client who comes to her to solve a mystery, or to right a wrong.</p>",
    officialSite: "http://www.showcase.ca/lostgirl",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 6,
      name: "Showcase",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2010-09-12",
  },
  {
    id: 13,
    url: "https://www.tvmaze.com/shows/13/the-flash",
    name: "The Flash",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/296/740329.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/296/740329.jpg",
    },
    summary:
      '<p>After a particle accelerator causes a freak storm, CSI Investigator Barry Allen is struck by lightning and falls into a coma. Months later he awakens with the power of super speed, granting him the ability to move through Central City like an unseen guardian angel. Though initially excited by his newfound powers, Barry is shocked to discover he is not the only "meta-human" who was created in the wake of the accelerator explosion -- and not everyone is using their new powers for good. Barry partners with S.T.A.R. Labs and dedicates his life to protect the innocent. For now, only a few close friends and associates know that Barry is literally the fastest man alive, but it won\'t be long before the world learns what Barry Allen has become...The Flash!</p>',
    officialSite: "http://www.cwtv.com/shows/the-flash/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-07",
  },
  {
    id: 14,
    url: "https://www.tvmaze.com/shows/14/continuum",
    name: "Continuum",
    genres: ["Drama", "Crime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/184.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/184.jpg",
    },
    summary:
      "<p><b>Continuum </b>is a one-hour police drama centered on Kiera Cameron, a regular cop from 65 years in the future who finds herself trapped in present day Vancouver. She is alone, a stranger in a strange land, and has eight of the most ruthless criminals from the future, known as Liber8, loose in the city.</p><p>Lucky for Kiera, through the use of her CMR (cellular memory recall), a futuristic liquid chip technology implanted in her brain, she connects with Alec Sadler, a seventeen-year-old tech genius. When Kiera calls and Alec answers, a very unique partnership begins.</p><p>Kiera's first desire is to get \"home.\" But until she figures out a way to do that, she must survive in our time period and use all the resources available to her to track and capture the terrorists before they alter history enough to change the course of the future. After all, what's the point of going back if the future isn't the one you left?</p>",
    officialSite: "http://www.showcase.ca/Continuum",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 6,
      name: "Showcase",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2012-05-27",
  },
  {
    id: 15,
    url: "https://www.tvmaze.com/shows/15/constantine",
    name: "Constantine",
    genres: ["Drama", "Action", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/154.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/154.jpg",
    },
    summary:
      "<p>Based on the wildly popular comic book series \"Hellblazer\" from DC Comics, seasoned demon hunter and master of the occult John Constantine is armed with a ferocious knowledge of the dark arts and a wickedly naughty wit. He fights the good fight - or at least he did. With his soul already damned to hell, he's decided to abandon his campaign against evil until a series of events thrusts him back into the fray, and he'll do whatever it takes to protect the innocent. With the balance of good and evil on the line‎, <b>Constantine </b>will use his skills to travel the country, find the supernatural terrors that threaten our world and send them back where they belong. After that, who knows... maybe there's hope for him and his soul after all.</p>",
    officialSite: "https://www.nbc.com/constantine",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-24",
  },
  {
    id: 16,
    url: "https://www.tvmaze.com/shows/16/penny-dreadful",
    name: "Penny Dreadful",
    genres: ["Horror", "Thriller", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/48/122260.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/48/122260.jpg",
    },
    summary:
      "<p>Some of literature's most terrifying characters, including Dr. Frankenstein and his monster, Dorian Gray, and iconic figures from the novel Dracula are lurking in the darkest corners of Victorian London. They are joined by a core of original characters in a complex, frightening new narrative. <b>Penny Dreadful </b>is a psychological thriller filled with dark mystery and suspense, where personal demons from the past can be stronger than vampires, evil spirits and immortal beasts.</p>",
    officialSite: "http://www.sho.com/penny-dreadful",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-05-11",
  },
  {
    id: 18,
    url: "https://www.tvmaze.com/shows/18/the-amazing-race",
    name: "The Amazing Race",
    genres: ["Action", "Adventure", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/237/592579.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/237/592579.jpg",
    },
    summary:
      "<p>From athletes and actors to tattoo artists, social workers and musicians - a diverse mix of teams will need to utilize their street smarts and savvy know-how to compete in the race of their lifetime.</p>",
    officialSite: "http://www.cbs.com/shows/amazing_race/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-09-05",
  },
  {
    id: 19,
    url: "https://www.tvmaze.com/shows/19/supernatural",
    name: "Supernatural",
    genres: ["Drama", "Action", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/268/672051.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/268/672051.jpg",
    },
    summary:
      "<p>This haunting series follows the Winchester brothers as they crisscross the lonely and mysterious back roads of the country in their '67 Chevy Impala, hunting down every evil supernatural force they encounter along the way.</p>",
    officialSite: "http://www.cwtv.com/shows/supernatural",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-09-13",
  },
  {
    id: 20,
    url: "https://www.tvmaze.com/shows/20/the-strain",
    name: "The Strain",
    genres: ["Drama", "Horror", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/70/175363.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/70/175363.jpg",
    },
    summary:
      "<p><b>The Strain</b> is a high-concept thriller that tells the story of Dr. Ephraim Goodweather, the head of the Center for Disease Control Canary Team in New York City. He and his team are called upon to investigate a mysterious viral outbreak with hallmarks of an ancient and evil strain of vampirism. As the strain spreads, Goodweather, his team, and an assembly of everyday New Yorkers wage war for the fate of humanity itself.</p>",
    officialSite: "http://www.fxnetworks.com/thestrain",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-13",
  },
  {
    id: 21,
    url: "https://www.tvmaze.com/shows/21/the-last-ship",
    name: "The Last Ship",
    genres: ["Drama", "Action", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/164/412464.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/164/412464.jpg",
    },
    summary:
      "<p>Their mission is simple: Find a cure. Stop the virus. Save the world. When a global pandemic wipes out eighty percent of the planet's population, the crew of a lone and unaffected Navy destroyer, the USS Nathan James, must find a way to pull humanity from the brink of extinction.</p>",
    officialSite: "http://www.tntdrama.com/shows/the-last-ship",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-06-22",
  },
  {
    id: 22,
    url: "https://www.tvmaze.com/shows/22/true-blood",
    name: "True Blood",
    genres: ["Drama", "Romance", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/236/590987.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/236/590987.jpg",
    },
    summary:
      "<p><b>True Blood </b>is a horror/drama based on a series of novels called <i>The Southern American Vampires Mysteries</i>. It focuses on Sookie Stackhouse and her various encounters with vampires and other supernatural beings. The show is centred in the small town of Bon Temps in Louisiana. The show focuses heavily on the co-existence of humans with vampires. The show also touches on several other controversial issues involving equal rights, violence, discrimination and religion.</p>",
    officialSite: "http://www.hbo.com/true-blood",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-09-07",
  },
  {
    id: 23,
    url: "https://www.tvmaze.com/shows/23/once-upon-a-time-in-wonderland",
    name: "Once Upon a Time in Wonderland",
    genres: ["Drama", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/73/183661.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/73/183661.jpg",
    },
    summary:
      "<p>In Victorian England, the young and beautiful Alice tells a tale of a strange new land that exists on the other side of a rabbit hole. An invisible cat, a hookah smoking caterpillar and playing-cards that talk are just some of the fantastic things she's seen during this impossible adventure. Surely this troubled girl must be insane, and her doctors aim to cure her with a treatment that will make her forget everything. Alice seems ready to put it all behind her, especially the painful memory of the genie she fell in love with and lost forever -- the handsome and mysterious Cyrus . But deep down Alice knows this world is real, and just in the nick of time the sardonic Knave of Hearts and the irrepressible White Rabbit arrive to save her from a doomed fate. Together the trio will take a tumble down the rabbit hole to this Wonderland where nothing is impossible.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-10-10",
  },
  {
    id: 24,
    url: "https://www.tvmaze.com/shows/24/hawaii-five-0",
    name: "Hawaii Five-0",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/213/532575.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/213/532575.jpg",
    },
    summary:
      "<p><b>Hawaii Five-0</b> is a contemporary take on the classic series about a new elite federalized task force whose mission is to wipe out the crime that washes up on the Islands' sun-drenched beaches. Detective Steve McGarrett, a decorated Naval officer-turned-cop, returned to Oahu to investigate his father's murder and stayed after Hawaii's former governor persuaded him to head up the new team: his rules, no red tape and full blanket authority to hunt down the biggest \"game\" in town. Joining McGarrett is Detective Danny \"Danno\" Williams, a relocated ex-New Jersey cop - a working man in paradise who prefers skyscrapers to the coastline - but who's committed to keeping the Islands safe for his young daughter; Chin Ho Kelly, an ex-Honolulu police detective and former protégé of McGarrett's father who was wrongly accused of corruption; Dr. Max Bergman, the quirky coroner; Chin's cousin, Kono Kalakaua, a beautiful and fearless native; and Captain Lou Grover, who formerly headed Hawaii's SWAT unit. Joining them is Jerry Ortega, a former classmate of Chin's and the Island's local conspiracy theorist. The state's brash FIVE-0 unit, who may spar and jest among themselves, remain determined to eliminate the seedy elements from the 50th state.</p>",
    officialSite: "http://www.cbs.com/shows/hawaii_five_0/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-20",
  },
  {
    id: 25,
    url: "https://www.tvmaze.com/shows/25/hellsing",
    name: "Hellsing",
    genres: ["Anime", "Horror", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/178/446544.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/178/446544.jpg",
    },
    summary:
      "<p><b>Hellsing </b>is a 13-part anime based on the manga of the same name. The plot is significantly difficult to that of the the manga although the characters are the same. The show mainly focuses on the hellsing institute that houses the anti-hero named Alucard who swore loyalty to the Helsing family many years before. Alucard being the first ever vampire takes on a new apprentice named Sera's.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 131,
      name: "Fuji TV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2001-10-10",
  },
  {
    id: 26,
    url: "https://www.tvmaze.com/shows/26/hellsing-ultimate",
    name: "Hellsing Ultimate",
    genres: ["Drama", "Action", "Anime", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/178/446780.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/178/446780.jpg",
    },
    summary:
      "<p><b>Hellsing Ultimate</b>, unlike the 13-part <i>Hellsing</i> series, follows the manga of the same name very closely. Alucard being the main protagonist and anti-hero/vampire. <i>Hellsing Ultimate</i> is a 10-part series of OVAs whereby Alucard turns Sera's into a vampire. The main focus of the plot being on an enemy neo-nazi group.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 159,
      name: "TBS",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2006-02-10",
  },
  {
    id: 27,
    url: "https://www.tvmaze.com/shows/27/berserk",
    name: "Berserk",
    genres: ["Anime", "Fantasy", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/249.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/249.jpg",
    },
    summary:
      "<p><b>Berserk </b>is a 25-part anime set in a dark fantasy/horror environment whereby the series focuses on the main character guts; a lone swordman who later meets up with a group of mercenaries called the band of the hawk. The leader of this band holds a strange necklace called a behelit that will only lead to evil.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 137,
      name: "NTV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1997-10-07",
  },
  {
    id: 28,
    url: "https://www.tvmaze.com/shows/28/californication",
    name: "Californication",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/38/95017.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/38/95017.jpg",
    },
    summary:
      "<p><b>Californication </b>is a series based around the writer Hank Moody. He moves to California and suffers a writers block as well as many other family and personal issues. His drinking and generally unhealthy lifestyle interrupts his relationships with his long term lover Karen and his daughter Becca as he struggles with his manager Charlie Runkle.</p>",
    officialSite: "http://www.sho.com/sho/californication/home",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-08-13",
  },
  {
    id: 29,
    url: "https://www.tvmaze.com/shows/29/vikings",
    name: "Vikings",
    genres: ["Drama", "Action", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/286/715906.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/286/715906.jpg",
    },
    summary:
      "<p><b>Vikings</b> transports us to the brutal and mysterious world of Ragnar Lothbrok, a Viking warrior and farmer who yearns to explore - and raid - the distant shores across the ocean.</p>",
    officialSite: "https://www.history.ca/shows/vikings/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 118,
      name: "History",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2013-03-03",
  },
  {
    id: 30,
    url: "https://www.tvmaze.com/shows/30/american-horror-story",
    name: "American Horror Story",
    genres: ["Drama", "Horror", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/282/706314.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/282/706314.jpg",
    },
    summary:
      "<p><b>American Horror Story </b>is an horror television anthology series. Each season is conceived as a self-contained miniseries, following a disparate set of characters and settings, and a storyline with its own beginning, middle, and end. While some actors appear for more than one year, they play completely different roles in each season.</p>",
    officialSite: "http://www.fxnetworks.com/shows/american-horror-story",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-10-05",
  },
  {
    id: 31,
    url: "https://www.tvmaze.com/shows/31/marvels-agents-of-shield",
    name: "Marvel's Agents of S.H.I.E.L.D.",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/253/634071.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/253/634071.jpg",
    },
    summary:
      "<p>Phil Coulson heads an elite team of fellow agents with the worldwide law-enforcement organization known as S.H.I.E.L.D. (Strategic Homeland Intervention Enforcement and Logistics Division), as they investigate strange occurrences around the globe. Its members -- each of whom brings a specialty to the group -- work with Coulson to protect those who cannot protect themselves from extraordinary and inconceivable threats.</p>",
    officialSite: "http://abc.go.com/shows/marvels-agents-of-shield",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-24",
  },
  {
    id: 32,
    url: "https://www.tvmaze.com/shows/32/fargo",
    name: "Fargo",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/267/669639.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/267/669639.jpg",
    },
    summary:
      '<p><b>Fargo </b>is a seasonal anthology crime drama with some dark comical elements, inspired by the film <i>Fargo</i> written by the Coen brothers. Each season follows a new case and new characters, all entrenched in the trademark humor, murder and "Minnesota nice" that has made the film an enduring classic.</p>',
    officialSite: "http://www.fxnetworks.com/fargo",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-04-15",
  },
  {
    id: 33,
    url: "https://www.tvmaze.com/shows/33/hemlock-grove",
    name: "Hemlock Grove",
    genres: ["Drama", "Horror", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/305.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/305.jpg",
    },
    summary:
      "<p>Secrets are just a part of daily life in the small Pennsylvania town of <b>Hemlock Grove</b>, where the darkest evils hide in plain sight.</p>",
    officialSite: "https://www.netflix.com/title/70242310",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2013-04-19",
  },
  {
    id: 34,
    url: "https://www.tvmaze.com/shows/34/helix",
    name: "Helix",
    genres: ["Horror", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/126/316697.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/126/316697.jpg",
    },
    summary:
      "<p><b>Helix </b>is a science fiction thriller that focuses on a CDC expedition into the arctic. They go there to investigate the potential outbreak of a disease with no idea what they are getting themselves into. They encounter an almost zombie-like threat that could threaten mankind itself whilst the operator of the facility seems to know more than what he is saying.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-10",
  },
  {
    id: 35,
    url: "https://www.tvmaze.com/shows/35/the-killing",
    name: "The Killing",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/216/540157.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/216/540157.jpg",
    },
    summary:
      "<p><b>The Killing</b> follows Seattle homicide detectives Stephen Holder and Sarah Linden and their work as detectives investigating murders. Sarah Linden takes cases very seriously and has issues keeping her work and family separate, as she pairs up with recovering addict Stephen Holder to solve dark murders.</p>",
    officialSite: "http://www.amc.com/shows/the-killing",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 20,
      name: "AMC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-04-03",
  },
  {
    id: 37,
    url: "https://www.tvmaze.com/shows/37/intruders",
    name: "Intruders",
    genres: ["Drama", "Fantasy", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/126/316698.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/126/316698.jpg",
    },
    summary:
      "<p>A contemporary, chilling, paranormal tale set in the moody Pacific Northwest, the series spins a fascinating and complex web of drama. As strange, apparently unrelated events start happening, multiple story-lines - a missing wife, an assassin covering his crimes, a child on the run - begin to intertwine to reveal a conspiracy that will forever change our understanding of human nature.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b04nf78f",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 15,
      name: "BBC America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-08-23",
  },
  {
    id: 38,
    url: "https://www.tvmaze.com/shows/38/z-nation",
    name: "Z Nation",
    genres: ["Action", "Horror", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/170/426759.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/170/426759.jpg",
    },
    summary:
      "<p><b>Z Nation</b> starts three years after the zombie virus has gutted the country, a team of everyday heroes must transport the only known survivor of the plague from New York to California, where the last functioning viral lab waits for his blood. Although the antibodies he carries are the world's last, best hope for a vaccine, he hides a dark secret that threatens them all. With humankind's survival at stake, the ragtag band embarks on a journey of survival across three thousand miles of rusted-out post-apocalyptic America.</p>",
    officialSite: "http://www.syfy.com/znation",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-12",
  },
  {
    id: 39,
    url: "https://www.tvmaze.com/shows/39/resurrection",
    name: "Resurrection",
    genres: ["Drama", "Science-Fiction", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/350.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/350.jpg",
    },
    summary:
      "<p>The people of Arcadia, Missouri are forever changed when their deceased loved ones suddenly start to reappear. An 8-year-old American boy wakes up alone in a rice paddy in a rural Chinese province with no idea how he got there. Details start to emerge when the boy, who calls himself Jacob, recalls that his hometown is Arcadia, and an Immigration agent, J. Martin Bellamy, takes him there. The home he claims as his own is occupied by a 60-year-old couple, Henry and Lucille Langston, who lost their son, Jacob, more than 30 years ago. While they look different, young Jacob recognizes them as his parents. Lucille is overjoyed at the seeming miracle of her son's reappearance. Henry is reluctant to accept that Jacob is back. Those closest to the family want answers, including Sheriff Fred Langston, whose wife Barbara drowned 30 years ago while trying to save Jacob, and Fred's daughter, Maggie, a local doctor. Pastor Tom Hale seeks a spiritual reason for what's happening in his community. When things take an even more shocking turn, Maggie's life-long friend, Elaine Richards, finds herself drawn into Arcadia's growing mystery. Bellamy, an outsider in the town, joins forces with Maggie to figure out why the unexplainable is happening in Arcadia. As their investigation plays out, Maggie learns some unsettling truths about her own past. Will they be able to solve the mystery of Arcadia before the rest of the world catches on to events there? And will they be able to protect Jacob from forces beyond their control?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-03-09",
  },
  {
    id: 40,
    url: "https://www.tvmaze.com/shows/40/death-note",
    name: "Death Note",
    genres: ["Drama", "Anime", "Thriller", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/361.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/361.jpg",
    },
    summary:
      "<p><b>Death Note </b>is an anime series based around a manga of the same name whereby a human finds a death god's notebook. Any person's name written in this notebook will die. The main character who finds this noteboook is Light Yagami who faces off against an unfaced character named L who tries to challenge him.</p>",
    officialSite: "http://www.j-deathnote.com/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 137,
      name: "NTV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2006-10-03",
  },
  {
    id: 41,
    url: "https://www.tvmaze.com/shows/41/last-man-standing",
    name: "Last Man Standing",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/294/736804.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/294/736804.jpg",
    },
    summary:
      "<p><b>Last Man Standing</b> follows Mike Baxter, a married father of three girls, who tries to maintain his manliness, despite being surrounded by women.</p>",
    officialSite: "https://www.fox.com/last-man-standing/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-10-11",
  },
  {
    id: 42,
    url: "https://www.tvmaze.com/shows/42/sleepy-hollow",
    name: "Sleepy Hollow",
    genres: ["Drama", "Mystery", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/81/204166.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/81/204166.jpg",
    },
    summary:
      "<p><b>Sleepy Hollow</b> is a thrilling mystery-adventure drama series spanning two and a half centuries, in which a resurrected Ichabod Crane pairs up with a present-day police lieutenant to save the enigmatic town of Sleepy Hollow--and the world--from unprecedented evil.</p>",
    officialSite: "http://www.fox.com/sleepy-hollow",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-16",
  },
  {
    id: 43,
    url: "https://www.tvmaze.com/shows/43/outlander",
    name: "Outlander",
    genres: ["Adventure", "Romance", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/234/586470.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/234/586470.jpg",
    },
    summary:
      "<p><b>Outlander </b>follows the story of Claire Randall, a married combat nurse from 1945 who is mysteriously swept back in time to 1743, where she is immediately thrown into an unknown world where her life is threatened. When she is forced to marry Jamie, a chivalrous and romantic young Scottish warrior, a passionate affair is ignited that tears Claire's heart between two vastly different men in two irreconcilable lives.</p><p>The <i>Outlander</i> series, adapted from Diana Gabaldon's international best-selling books, spans the genres of romance, science fiction, history and adventure into one epic tale.</p>",
    officialSite: "http://www.starz.com/originals/outlander",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 17,
      name: "Starz",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-08-09",
  },
  {
    id: 44,
    url: "https://www.tvmaze.com/shows/44/scorpion",
    name: "Scorpion",
    genres: ["Drama", "Action", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/128/322484.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/128/322484.jpg",
    },
    summary:
      "<p><b>Scorpion</b>, inspired by a true story, is a high-octane drama about eccentric genius Walter O'Brien and his team of brilliant misfits who comprise the last line of defense against complex, high-tech threats of the modern age. As Homeland Security's new think tank, O'Brien's \"Scorpion\" team includes Toby Curtis an expert behaviorist who can read anyone; Happy Quinn, a mechanical prodigy; and Sylvester Dodd, a statistics guru. Pooling their extensive technological knowledge to solve mind-boggling predicaments amazes federal agent Cabe Gallo, who shares a harrowing history with O'Brien. However, while this socially awkward group is comfortable with each other's humor and quirks, life outside their circle confounds them, so they rely on Paige Dineen, who has a young, gifted son, to translate the world for them. At last, these nerdy masterminds have found the perfect job: a place where they can apply their exceptional brainpower to solve the nation's crises, while also helping each other learn how to fit in.</p>",
    officialSite: "http://www.cbs.com/shows/scorpion/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-22",
  },
  {
    id: 45,
    url: "https://www.tvmaze.com/shows/45/ncis-new-orleans",
    name: "NCIS: New Orleans",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/280/701985.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/280/701985.jpg",
    },
    summary:
      '<p><b>NCIS: New Orleans </b>is a drama about the local field office that investigates criminal cases involving military personnel in The Big Easy, a city known for its music, entertainment and decadence. Leading the team is Special Agent Dwayne Pride, a.k.a. "King," a native of New Orleans who is driven by his need to do what is right. Working with Pride is Special Agent Christopher LaSalle, who plays hard but works harder and former ATF agent Sonja Percy, who is still adjusting to the team after years of solo undercover assignments. Supporting them is coroner Dr. Loretta Wade, who is as eccentric as she is smart; her brilliant, quirky Forensic Scientist, Sebastian Lund; and Investigative Computer Specialist Patton Plame, an animated and talented hacker. New to the team is Special Agent Tammy Gregorio, a tough, acerbic FBI agent with a mysterious past in New Orleans, who is sent from D.C. to investigate the NCIS team, but also work with Pride when high-risk cases threaten the city. This colorful city that harbors a dark side is a magnet for service personnel on leave, and when overindulgence is followed by trouble, Pride\'s team is at its best</p>',
    officialSite: "http://www.cbs.com/shows/ncis-new-orleans/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-23",
  },
  {
    id: 46,
    url: "https://www.tvmaze.com/shows/46/forever",
    name: "Forever",
    genres: ["Drama", "Crime", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/383.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/383.jpg",
    },
    summary:
      "<p>Doctor Henry Morgan, New York City's star medical examiner, has a secret. He doesn't just study the dead to solve criminal cases, he does it to solve the mystery that has eluded him for 200 years - the answer to his own inexplicable immortality. This long life has given Henry remarkable observation skills which impresses his new partner, Detective Jo Martinez. Each week, a new case and their budding friendship will reveal layers of Henry's long and colorful past. Only his best friend and confidant, Abe knows Henry's secret.</p>",
    officialSite: "http://abc.go.com/shows/forever",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-22",
  },
  {
    id: 47,
    url: "https://www.tvmaze.com/shows/47/witches-of-east-end",
    name: "Witches of East End",
    genres: ["Drama", "Fantasy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/392.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/392.jpg",
    },
    summary:
      "<p>Based on Melissa de la Cruz's best-selling novel, <b>Witches of East End</b> centers on the mysterious Beauchamp family who live in the secluded seaside town of East End. Free-spirited artist Joanna Beauchamp is the mother of wild-child bartender Freya and shy librarian Ingrid, who are both gifted -- and cursed -- with a magic birthright, of which they are unaware. Freya notices bizarre occurrences in her life when she inexplicably finds herself drawn to the troubled brother of her wealthy fiance. But it isn't until Joanna's estranged sister appears with a warning that could change the family's fate that the matriarch must reveal to her daughters that they are immortal witches with untapped powers, a revelation that turns their small-town life upside down.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-10-06",
  },
  {
    id: 48,
    url: "https://www.tvmaze.com/shows/48/madam-secretary",
    name: "Madam Secretary",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/214/536175.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/214/536175.jpg",
    },
    summary:
      "<p><b>Madam Secretary</b> follows Elizabeth McCord, the shrewd, determined, newly appointed Secretary of State who drives international diplomacy, battles office politics and circumvents protocol as she negotiates global and domestic issues, both at the White House and at home. A college professor and a brilliant former CIA analyst who left for ethical reasons, Elizabeth returns to public life at the request of the President following the suspicious death of her predecessor. The President values her apolitical leanings, her deep knowledge of the Middle East, her flair for languages and her ability to not just think outside the box, but to not even acknowledge there is a box.</p>",
    officialSite: "http://www.cbs.com/shows/madam-secretary/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-21",
  },
  {
    id: 49,
    url: "https://www.tvmaze.com/shows/49/brooklyn-nine-nine",
    name: "Brooklyn Nine-Nine",
    genres: ["Comedy", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/235/587547.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/235/587547.jpg",
    },
    summary:
      "<p><b>Brooklyn Nine-Nine</b> is an ensemble comedy about a talented-but-carefree detective, a by-the-book police captain and their precinct colleagues. While based in the workplace, Brooklyn Nine-Nine is not really about the job – it's about the men and women behind the badge.</p>",
    officialSite: "https://www.nbc.com/brooklyn-nine-nine",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-17",
  },
  {
    id: 50,
    url: "https://www.tvmaze.com/shows/50/the-lottery",
    name: "The Lottery",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/146/366444.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/146/366444.jpg",
    },
    summary:
      "<p>Set within a dystopian future driven by a global fertility crisis, <b>The Lottery </b>reveals a world staring down the barrel of impending extinction as women have mysteriously stopped bearing children. After years of research, Dr. Alison Lennon and her team remarkably fertilize 100 embryos. However, her victory is short-lived when the Director of the U.S. Fertility Commission, Darius Hayes, takes government control of the lab and informs the President of the monumental scientific breakthrough. To determine which women will carry the prized embryos to term, Chief of Staff Vanessa Keller convinces the President to hold a national lottery and a battle over the control of the 100 embryos begins.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-20",
  },
  {
    id: 51,
    url: "https://www.tvmaze.com/shows/51/the-knick",
    name: "The Knick",
    genres: ["Drama", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/417.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/417.jpg",
    },
    summary:
      "<p>New York City, 1900: The Knickerbocker Hospital is home to groundbreaking surgeons, nurses and staff who push the boundaries of medicine in a time of astonishingly high mortality rates and zero antibiotics. The newly appointed leader of the surgery staff is the brilliant, arrogant renegade Dr. John Thackery, whose addiction to cocaine and opium is trumped only by his ambition for medical discovery and renown among his peers. Into the all-white staff and patient hospital comes the equally gifted Harvard graduate Dr. Algernon Edwards, who must fight for respect while trying to navigate the racially charged city. Trying to maintain its reputation for quality care while realizing a profit, the Knickerbocker makes an effort to attract wealthy clientele, while literally struggling to keep the lights on.</p>",
    officialSite: "http://www.cinemax.com/the-knick/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 19,
      name: "Cinemax",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-08-08",
  },
  {
    id: 52,
    url: "https://www.tvmaze.com/shows/52/how-to-get-away-with-murder",
    name: "How to Get Away with Murder",
    genres: ["Drama", "Thriller", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/212/531512.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/212/531512.jpg",
    },
    summary:
      "<p>The brilliant, charismatic and seductive Professor Annalise Keating gets entangled with four law students from her class, <b>How to Get Away with Murder</b>. Little do they know that they will have to apply what they learned to real life, in this masterful, sexy, suspense-driven legal thriller.</p>",
    officialSite: "http://abc.go.com/shows/how-to-get-away-with-murder",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-25",
  },
  {
    id: 53,
    url: "https://www.tvmaze.com/shows/53/nashville",
    name: "Nashville",
    genres: ["Drama", "Music", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/142/357495.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/142/357495.jpg",
    },
    summary:
      "<p><b>Nashville</b> is set against the backdrop of the city's music scene and follows Rayna Jaymes and Juliette Barnes. Both women face personal and professional challenges as they navigate their paths as artists and individuals. Surrounding them, and often complicating their lives, are their family, friends and, in some cases, lovers, as well as the up-and-coming performers and songwriters trying to get ahead in the business. Music City can mean so many things to different people. In Nashville, musicians and songwriters are at the heart of the storm driven by their own ambitions. Some are fueled by their creativity and passion for fame. Others struggle to cope with the pressures of success and are doing everything in their power to stay on top.</p>",
    officialSite: "http://www.cmt.com/shows/nashville/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 173,
      name: "CMT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-10-10",
  },
  {
    id: 54,
    url: "https://www.tvmaze.com/shows/54/legends",
    name: "Legends",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/36/92018.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/36/92018.jpg",
    },
    summary:
      "<p>Sean Bean stars in <b>Legends, </b>a suspense-filled drama based on the award-winning book by master spy novelist Robert Littell. Bean plays Martin Odum, an undercover agent working for the FBI's Deep Cover Operations (DCO) division. Martin has the uncanny ability to transform himself into a completely different person for each job. But he begins to question his own identity when a mysterious stranger suggests that Martin isn't the man he believes himself to be.</p>",
    officialSite: "http://www.tntdrama.com/shows/legends.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-08-13",
  },
  {
    id: 55,
    url: "https://www.tvmaze.com/shows/55/red-band-society",
    name: "Red Band Society",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/441.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/441.jpg",
    },
    summary:
      "<p>What if a hospital was your high school, boarding school and summer camp rolled into one? What if it was the place where you fell in love for the first time and made friendships that lasted a lifetime? And what if it was all weirdly hilarious and the most fun you ever had in your entire life? This is the world of <b>Red Band Society</b>.</p>",
    officialSite:
      "https://web.archive.org/web/20170615064321/http://www.fox.com/red-band-society",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-17",
  },
  {
    id: 56,
    url: "https://www.tvmaze.com/shows/56/chicago-pd",
    name: "Chicago P.D.",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/277/693380.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/277/693380.jpg",
    },
    summary:
      "<p>District 21 of the Chicago Police Department is made up of two distinctly different groups. There are the uniformed cops who patrol the beat and go head to head with the city's street crimes. And there's the Intelligence Unit, the team that combats the city's major offenses - organized crime, drug trafficking, high profile murders and beyond. These are their stories.</p>",
    officialSite: "http://www.nbc.com/chicago-pd",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-08",
  },
  {
    id: 57,
    url: "https://www.tvmaze.com/shows/57/black-ish",
    name: "black-ish",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/298/747253.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/298/747253.jpg",
    },
    summary:
      "<p>Andre 'Dre' Johnson has a great job, a beautiful wife, Rainbow, four kids, and a colonial home in the 'burbs. But has success brought too much assimilation for this black family? With a little help from his dad, Dre sets out to establish a sense of cultural identity for his family that honors their past while embracing the future.</p>",
    officialSite: "https://abc.com/shows/blackish",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-24",
  },
  {
    id: 58,
    url: "https://www.tvmaze.com/shows/58/new-girl",
    name: "New Girl",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/145/364581.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/145/364581.jpg",
    },
    summary:
      "<p><b>New Girl</b> is a single-camera ensemble comedy starring Zooey Deschanel as Jess, an offbeat girl who - after a bad breakup - moves in with three single guys and essentially sets a bomb off in their lives.</p>",
    officialSite: "http://www.fox.com/new-girl/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-20",
  },
  {
    id: 59,
    url: "https://www.tvmaze.com/shows/59/chicago-fire",
    name: "Chicago Fire",
    genres: ["Drama", "Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/277/693381.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/277/693381.jpg",
    },
    summary:
      "<p>No job is more stressful, dangerous or exhilarating than those of the Firefighters, Rescue Squad and Paramedics of Chicago Firehouse 51. These are the courageous men and women who forge headfirst into danger when everyone else is running the other way and whose actions make the difference between life and death. These are their stories.</p>",
    officialSite: "http://www.nbc.com/chicago-fire",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-10-10",
  },
  {
    id: 60,
    url: "https://www.tvmaze.com/shows/60/ncis",
    name: "NCIS",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/280/701983.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/280/701983.jpg",
    },
    summary:
      "<p><b>NCIS</b> (Naval Criminal Investigative Service) is more than just an action drama. With liberal doses of humor, it's a show that focuses on the sometimes complex and always amusing dynamics of a team forced to work together in high-stress situations. Leroy Jethro Gibbs, a former Marine gunnery sergeant, whose skills as an investigator are unmatched, leads this troupe of colorful personalities. Rounding out the team are Anthony DiNozzo, an ex-homicide detective whose instincts in the field are unparalleled and whose quick wit and humorous take on life make him a team favorite; the youthful and energetic forensic specialist Abby Sciuto, a talented scientist whose sharp mind matches her Goth style and eclectic tastes; Caitlin Todd, an ex-Secret Service Agent; and Timothy McGee, an MIT graduate whose brilliance with computers far overshadows his insecurities in the field; Assisting the team is medical examiner Dr. Donald \"Ducky\" Mallard, who knows it all because he's seen it all, and he's not afraid to let you know. From murder and espionage to terrorism and stolen submarines, these special agents travel the globe to investigate all crimes with Navy or Marine Corps ties.</p>",
    officialSite: "http://www.cbs.com/shows/ncis/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-09-23",
  },
  {
    id: 61,
    url: "https://www.tvmaze.com/shows/61/orphan-black",
    name: "Orphan Black",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/53/132716.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/53/132716.jpg",
    },
    summary:
      '<p><b>Orphan Black</b> is about Sarah, an outsider and orphan whose life changes dramatically after witnessing the suicide of a woman, "Beth", who looks just like her. Sarah takes her identity, her boyfriend and her money. But instead of solving her problems, the street-smart chameleon is thrust headlong into a kaleidoscopic mystery. She makes the dizzying discovery that she and the dead woman are clones... but are they the only ones? Sarah quickly finds herself caught in the middle of a deadly conspiracy, racing to find answers.</p>',
    officialSite: "http://orphanblack.space.ca/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 7,
      name: "CTV Sci-Fi Channel",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2013-03-30",
  },
  {
    id: 62,
    url: "https://www.tvmaze.com/shows/62/the-originals",
    name: "The Originals",
    genres: ["Drama", "Romance", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/156/391233.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/156/391233.jpg",
    },
    summary:
      "<p><b>The Originals</b> is a spin-off show from the supernatural drama <i>The Vampire Diaries</i>. It is based in the city of New Orleans where the originals represent the original vampires. The show is primarily based around conflict between vampires, werewolves and witches in the city.</p>",
    officialSite: "http://www.cwtv.com/shows/the-originals/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-10-03",
  },
  {
    id: 63,
    url: "https://www.tvmaze.com/shows/63/the-vampire-diaries",
    name: "The Vampire Diaries",
    genres: ["Drama", "Romance", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/88/220908.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/88/220908.jpg",
    },
    summary:
      "<p><b>The Vampire Diaries</b> is a supernatural drama/romance based around Elena Gilbert who falls in love with a 163 year old vampire.</p><p>Based on a novel series by L.J. Smith.</p>",
    officialSite: "http://www.cwtv.com/shows/the-vampire-diaries",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-09-10",
  },
  {
    id: 64,
    url: "https://www.tvmaze.com/shows/64/utopia",
    name: "Utopia",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/275/688620.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/275/688620.jpg",
    },
    summary:
      "<p><b>Utopia</b> based initially around a small group of people who find a rare manuscript of the same name. This leads the group to be targeted by a large organisation with little knowledge of the manuscript's relevance or importance.</p>",
    officialSite: "http://www.channel4.com/programmes/utopia",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-01-15",
  },
  {
    id: 65,
    url: "https://www.tvmaze.com/shows/65/bones",
    name: "Bones",
    genres: ["Drama", "Crime", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/80/201202.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/80/201202.jpg",
    },
    summary:
      '<p>F.B.I. Agent Seeley Booth is teamed up with forensic anthropologist Dr. Temperance "Bones" Brennan to solve some of the most baffling and bizarre crimes ever. Booth depends on clues from the living, witnesses and suspects, while Brennan gathers evidence from the dead, relying on her uncanny ability to read clues left behind in the bones of the victims.</p>',
    officialSite: "http://www.fox.com/bones",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-09-13",
  },
  {
    id: 66,
    url: "https://www.tvmaze.com/shows/66/the-big-bang-theory",
    name: "The Big Bang Theory",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/173/433868.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/173/433868.jpg",
    },
    summary:
      '<p><b>The Big Bang Theory</b> is a comedy about brilliant physicists, Leonard and Sheldon, who are the kind of "beautiful minds" that understand how the universe works. But none of that genius helps them interact with people, especially women. All this begins to change when a free-spirited beauty named Penny moves in next door. Sheldon, Leonard\'s roommate, is quite content spending his nights playing Klingon Boggle with their socially dysfunctional friends, fellow Cal Tech scientists Wolowitz and Koothrappali. However, Leonard sees in Penny a whole new universe of possibilities... including love.</p>',
    officialSite: "http://www.cbs.com/shows/big_bang_theory/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-09-24",
  },
  {
    id: 67,
    url: "https://www.tvmaze.com/shows/67/greys-anatomy",
    name: "Grey's Anatomy",
    genres: ["Drama", "Romance", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/273/684728.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/273/684728.jpg",
    },
    summary:
      "<p>The doctors of Grey Sloan Memorial Hospital deal with life-or-death consequences on a daily basis -- it's in one another that they find comfort, friendship and, at times, more than friendship. Together they're discovering that neither medicine nor relationships can be defined in black and white. Real life only comes in shades of grey.</p>",
    officialSite: "http://abc.go.com/shows/greys-anatomy/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-03-27",
  },
  {
    id: 68,
    url: "https://www.tvmaze.com/shows/68/castle",
    name: "Castle",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/315/787602.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/315/787602.jpg",
    },
    summary:
      "<p><b>Castle</b> follows Rick Castle who is one of the world's most successful crime authors. But when his rock star lifestyle isn't enough, this bad boy goes looking for new trouble and finds it working with smart, beautiful Detective Kate Beckett. Inspired by her professional record and intrigued by her buttoned-up personality, Castle's found the model for his bold new character whether she likes it or not. Now with the mayor's permission, Castle is helping solve crime with his own twist.</p>",
    officialSite: "http://abc.go.com/shows/castle",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-03-09",
  },
  {
    id: 69,
    url: "https://www.tvmaze.com/shows/69/the-blacklist",
    name: "The Blacklist",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/279/698540.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/279/698540.jpg",
    },
    summary:
      "<p><b>The Blacklist</b> is a crime drama involving a former government agent who turned into a high-profile criminal turning himself in to the FBI offering to help catch criminals.</p>",
    officialSite: "http://www.nbc.com/the-blacklist",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-23",
  },
  {
    id: 70,
    url: "https://www.tvmaze.com/shows/70/the-voice",
    name: "The Voice",
    genres: ["Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/298/745981.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/298/745981.jpg",
    },
    summary:
      "<p><b>The Voice</b> is a reality singing competition show where the idea is to find new singing talent via a series of auditions.</p>",
    officialSite: "http://www.nbc.com/the-voice",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-04-26",
  },
  {
    id: 71,
    url: "https://www.tvmaze.com/shows/71/dancing-with-the-stars",
    name: "Dancing with the Stars",
    genres: ["Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/274/687110.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/274/687110.jpg",
    },
    summary:
      "<p>The hit series in which celebrities perform choreographed dance routines that are judged by a panel of renowned ballroom experts</p>",
    officialSite: "https://abc.com/shows/dancing-with-the-stars",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-06-01",
  },
  {
    id: 72,
    url: "https://www.tvmaze.com/shows/72/ncis-los-angeles",
    name: "NCIS: Los Angeles",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/280/701984.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/280/701984.jpg",
    },
    summary:
      "<p><b>NCIS: Los Angeles</b> is a drama about the high-stakes world of a division of NCIS that is charged with apprehending dangerous and elusive criminals that pose a threat to the nation's security. By assuming false identities and utilizing the most advanced technology, this team of highly-trained agents goes deep undercover, putting their lives on the line in the field to bring down their targets.</p>",
    officialSite: "http://www.cbs.com/shows/ncis_los_angeles/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-09-22",
  },
  {
    id: 73,
    url: "https://www.tvmaze.com/shows/73/the-walking-dead",
    name: "The Walking Dead",
    genres: ["Drama", "Action", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/297/744148.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/297/744148.jpg",
    },
    summary:
      "<p><b>The Walking Dead</b> tells the story of the months and years that follow after a zombie apocalypse. It follows a group of survivors, led by former police officer Rick Grimes, who travel in search of a safe and secure home. As the world overrun by the dead takes its toll on the survivors, their interpersonal conflicts present a greater danger to their continuing survival than the walkers that roam the country. Over time, the characters are changed by the constant exposure to death and some grow willing to do anything to survive.</p><p>Based on the comic book series of the same name by Robert Kirkman, Tony Moore, and Charlie Adlard.</p>",
    officialSite: "http://www.amc.com/shows/the-walking-dead",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 20,
      name: "AMC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-10-31",
  },
  {
    id: 74,
    url: "https://www.tvmaze.com/shows/74/hell-on-wheels",
    name: "Hell on Wheels",
    genres: ["Drama", "Action", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/526.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/526.jpg",
    },
    summary:
      '<p><b>Hell on Wheels</b> is an American Western television series about the construction of the First Transcontinental Railroad across the United States. The series follows the Union Pacific Railroad and its surveyors, laborers, prostitutes, mercenaries, and others who lived, worked and died in the mobile encampment called "Hell on Wheels" that followed the railhead west across the Great Plains. In particular, the story focuses on Cullen Bohannon, a former Confederate soldier who, while working as foreman and chief engineer on the railroad, initially attempts to track down the Union soldiers who murdered his wife and young son during the American Civil War.</p>',
    officialSite: "http://www.amctv.com/shows/hell-on-wheels",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 20,
      name: "AMC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-11-06",
  },
  {
    id: 75,
    url: "https://www.tvmaze.com/shows/75/the-mindy-project",
    name: "The Mindy Project",
    genres: ["Comedy", "Romance", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/298/745731.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/298/745731.jpg",
    },
    summary:
      "<p><b>The Mindy Project</b> is a single-camera comedy series which follows a skilled OB/GYN navigating the tricky waters of both her personal and professional life.</p>",
    officialSite: "http://www.hulu.com/the-mindy-project",
    webChannel: {
      id: 2,
      name: "Hulu",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2012-09-25",
  },
  {
    id: 76,
    url: "https://www.tvmaze.com/shows/76/sons-of-anarchy",
    name: "Sons of Anarchy",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/537.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/537.jpg",
    },
    summary:
      '<p><b>Sons of Anarchy</b> is an American television drama series created by Kurt Sutter, about the lives of a close-knit outlaw motorcycle club operating in Charming, a fictional town in California\'s Central Valley. The show centers on protagonist Jackson "Jax" Teller (Charlie Hunnam), initially the vice president of the club, who begins questioning the club and himself.</p>',
    officialSite: "http://www.fxnetworks.com/shows/sons-of-anarchy/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-09-03",
  },
  {
    id: 77,
    url: "https://www.tvmaze.com/shows/77/the-middle",
    name: "The Middle",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/562.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/562.jpg",
    },
    summary:
      "<p>Forget about athletes, movie stars and politicians. Parents are the real heroes - but we think Frankie Heck, must be some kind of superhero. A loving wife and mother of three, she's middle class in the middle of the country and is rapidly approaching middle age.</p><p>Frankie and her husband, Mike, have lived in Orson, Indiana, their whole lives. A man of few words (every one a zinger), Mike is a manager at the town quarry and Frankie is the third-best used car salesman (out of the three) at the local dealership. She may not be a high-powered career woman, but when it comes to her family, she'll go to just about any length. And with kids like these, she had better. There's Axl, her semi-nudist teenage son conceived while under the influence of Guns N' Roses; Sue, the awkward teenage daughter who fails at everything... but with the utmost of gusto; and their seven-year-old son Brick, whose best friend is his backpack.</p><p>Sometimes it seems like everyone is trying to get to the top, or struggling not to hit bottom, but we think Frankie and her family will find a lot of love, and a lot of laughs, somewhere in <b>The Middle</b>.</p>",
    officialSite: "http://abc.go.com/shows/the-middle",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-09-30",
  },
  {
    id: 78,
    url: "https://www.tvmaze.com/shows/78/the-mysteries-of-laura",
    name: "The Mysteries of Laura",
    genres: ["Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/568.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/568.jpg",
    },
    summary:
      '<p>Laura Diamond is a brilliant NYPD homicide detective who balances her "Columbo" day job with a crazy family life that includes two unruly twin boys and a soon-to-be ex-husband - also a cop - who just can\'t seem to sign the divorce papers. Between cleaning up after her boys and cleaning up the streets, she\'d be the first to admit she has her "hot mess" moments in this hilariously authentic look at what it really means to be a working mom today. Somehow, she makes it all work with the help of her sexy and understanding partner, and things becomes even more complicated when her husband becomes her boss at the precinct. For Laura, every day is a high-wire balancing act.</p>',
    officialSite: "http://www.nbc.com/the-mysteries-of-laura",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-17",
  },
  {
    id: 79,
    url: "https://www.tvmaze.com/shows/79/the-goldbergs",
    name: "The Goldbergs",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/301/752628.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/301/752628.jpg",
    },
    summary:
      "<p>Before there were parenting blogs, trophies for showing up and peanut allergies, there was a simpler time called the '80s. For geeky and movie obsessed youngest child Adam, these were his wonder years, and he faced them armed with a video camera to capture all the crazy. <b>The Goldbergs</b> are a loving family like any other -- just with a lot more yelling. Mom Beverly is a classic \"smother,\" an overbearing, overprotective matriarch who loves her delicious kids, but still rules this brood with 100% authority and zero sense of boundaries. Dad Murray is gruff and sometimes oblivious, parenting with half his attention span but all his heart. Sister Erica is popular and terrifying, doing her best to cover up that she's the smartest of the clan. Barry is a passionate dreamer, who maybe dreams a little too big and who always gets the short end of the stick. Adam is the youngest, a camera-wielding future director who's navigating first love, and growing up with his family. Rounding out the family is beloved grandfather Al \"Pops\" Solomon, the wild man of the clan, a shameless Don Juan who's learning as much from his family as he teaches them.</p>",
    officialSite: "http://abc.go.com/shows/the-goldbergs",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-24",
  },
  {
    id: 80,
    url: "https://www.tvmaze.com/shows/80/modern-family",
    name: "Modern Family",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/240/600519.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/240/600519.jpg",
    },
    summary:
      "<p><b>Modern Family</b> revolves around three different types of families (nuclear, step- and same-sex) living in the Los Angeles area, who are interrelated through Jay Pritchett and his children, Claire Dunphy (née Pritchett) and Mitchell Pritchett. Patriarch Jay is remarried to a much younger woman, Gloria Delgado Pritchett (née Ramirez), a passionate Colombian with whom he has an infant son, Fulgencio (Joe) Pritchett, and a son from Gloria's previous marriage, Manny Delgado.</p><p>Jay's daughter Claire was a homemaker, but has returned to the business world. She is now the chief executive of her father's previous business, Pritchett's Closets and Blinds. She is married to Phil Dunphy, a realtor and self-professed \"cool dad\". They have three children: Haley Dunphy, a stereotypical ditzy teenage girl; Alex Dunphy, a nerdy, smart middle child; and Luke Dunphy, the off-beat only son.</p><p>Jay's lawyer son Mitchell and his husband Cameron Tucker have one daughter, Lily Tucker-Pritchett. As the name suggests, this family represents a modern-day family, and episodes are comically based on situations which many families encounter in real life.</p>",
    officialSite: "http://abc.go.com/shows/modern-family",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-09-23",
  },
  {
    id: 81,
    url: "https://www.tvmaze.com/shows/81/criminal-minds",
    name: "Criminal Minds",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/237/592589.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/237/592589.jpg",
    },
    summary:
      "<p><b>Criminal Minds</b> revolves around an elite team of FBI profilers who analyze the country's most twisted criminal minds, anticipating their next moves before they strike again.</p>",
    officialSite: "http://www.cbs.com/shows/criminal_minds/",
    webChannel: { id: 107, name: "Paramount+", country: null },
    language: "English",
    status: "Running",
    network: null,
    premiered: "2005-09-22",
  },
  {
    id: 82,
    url: "https://www.tvmaze.com/shows/82/game-of-thrones",
    name: "Game of Thrones",
    genres: ["Drama", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/190/476117.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/190/476117.jpg",
    },
    summary:
      "<p>Based on the bestselling book series <i>A Song of Ice and Fire</i> by George R.R. Martin, this sprawling new HBO drama is set in a world where summers span decades and winters can last a lifetime. From the scheming south and the savage eastern lands, to the frozen north and ancient Wall that protects the realm from the mysterious darkness beyond, the powerful families of the Seven Kingdoms are locked in a battle for the Iron Throne. This is a story of duplicity and treachery, nobility and honor, conquest and triumph. In the <b>Game of Thrones</b>, you either win or you die.</p>",
    officialSite: "http://www.hbo.com/game-of-thrones",
    webChannel: {
      id: 22,
      name: "HBO Go",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-04-17",
  },
  {
    id: 83,
    url: "https://www.tvmaze.com/shows/83/the-simpsons",
    name: "The Simpsons",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/317/792709.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/317/792709.jpg",
    },
    summary:
      "<p><b>The Simpsons</b> is the longest running scripted show in US television history. It captures the adventures of Homer, Marge, Maggie, Bart and Lisa who are living in a fictional town called Springfield.</p>",
    officialSite: "http://www.fox.com/the-simpsons/full-episodes",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1989-12-17",
  },
  {
    id: 84,
    url: "https://www.tvmaze.com/shows/84/family-guy",
    name: "Family Guy",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/309/773280.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/309/773280.jpg",
    },
    summary:
      "<p><b>Family Guy</b> follows Peter Griffin the endearingly ignorant dad, and his hilariously offbeat family of middle-class New Englanders in Quahog, RI. Lois is Peter's wife, a stay-at-home mom with no patience for her family's antics. Then there are their kids: 18-year-old Meg is an outcast at school and the Griffin family punching bag; 13-year-old Chris is a socially awkward teen who doesn't have a clue about the opposite sex; and one-year-old Stewie is a diabolically clever baby whose burgeoning sexuality is very much a work in progress. Rounding out the Griffin household is Brian the family dog and a ladies' man who is one step away from AA.</p>",
    officialSite: "http://www.fox.com/family-guy",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-01-31",
  },
  {
    id: 86,
    url: "https://www.tvmaze.com/shows/86/stalker",
    name: "Stalker",
    genres: ["Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/647.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/647.jpg",
    },
    summary:
      "<p><b>Stalker</b> is a psychological thriller about detectives who investigate stalking incidents - including voyeurism, cyber harassment and romantic fixation - for the Threat Assessment Unit of the LAPD. Det. Jack Larsen is a recent transfer to the Unit from New York City's homicide division, whose confidence, strong personality and questionable behavior has landed him in trouble before - but whose past behavior may also prove valuable in his new job. His boss, Lt. Beth Davis, is strong, focused and an expert in the field, driven by her traumatic personal experience as a victim. With the rest of their team, young but eager Det. Ben Caldwell and deceptively smart Det. Janice Lawrence Larsen and Davis assess the threat level of cases and respond before the stalking and intimidation spirals out of control, all while trying to keep their personal obsessions at bay.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-01",
  },
  {
    id: 87,
    url: "https://www.tvmaze.com/shows/87/the-bridge",
    name: "The Bridge",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/649.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/649.jpg",
    },
    summary:
      "<p>When the body of a cartel member is found on US soil, Sonya Cross from El Paso PD and her Mexican counterpart, Marco Ruiz must work together to solve the case.</p><p>A present-day crime thriller exploring the tensions on the US-Mexico border. When an American judge known for her anti-immigration views is found dead on the bridge connecting El Paso and Juarez, Sonya Cross from El Paso PD must work with her Mexican counterpart from Chihuahua State Police, Marco Ruiz, to catch a serial killer operating on both sides of the border. Marco understands the slippery politics of Mexican law enforcement, and while his police force slowly succumbs to the pressures and demands of the cartel, he's one of the last good men in the department. He's charming but will do whatever it takes to get what he needs -- which doesn't sit well with Sonya, who has Asperger's and strictly follows rules and protocol. The case quickly pulls them into a string of murders on the border, a scene already consumed by illegal immigration, drug trafficking, violence, and prostitution.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-07-10",
  },
  {
    id: 88,
    url: "https://www.tvmaze.com/shows/88/reign",
    name: "Reign",
    genres: ["Drama", "Romance", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/81/204119.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/81/204119.jpg",
    },
    summary:
      "<p>Hidden between the lines of the history books is the story of Mary Stuart, the young woman the world would come to know as Mary, Queen of Scots. Queen of Scotland since she was six days old, the teenage Mary is already a headstrong monarch - beautiful, passionate, and poised at the very beginning of her tumultuous rise to power. Arriving in France with four close friends as her ladies-in-waiting, Mary has been sent to secure Scotland's strategic alliance by formalizing her arranged engagement to the French king's dashing son, Prince Francis. But the match isn't signed and sealed, it depends more on politics, religion and secret agendas than affairs of the heart. With danger and sexual intrigue around every dark castle corner, Mary rallies her ladies-in-waiting and steels herself, ready to rule the new land and balance the demands of her country and her heart.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-10-17",
  },
  {
    id: 89,
    url: "https://www.tvmaze.com/shows/89/unforgettable",
    name: "Unforgettable",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/663.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/663.jpg",
    },
    summary:
      "<p><b>Unforgettable</b> follows Carrie Wells, an enigmatic former police detective with a rare condition that makes her memory so flawless that every place, every conversation, every moment of joy and every heartbreak is forever embedded in her mind. It's not just that she doesn't forget anything - she can't; except for one thing: the details that would help solve her sister's long-ago murder. Carrie has tried to put her past behind her, but she's unexpectedly reunited with her ex-boyfriend and partner, NYPD Detective Al Burns when she consults on a homicide case.</p>",
    officialSite: "http://www.aetv.com/unforgettable",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-20",
  },
  {
    id: 90,
    url: "https://www.tvmaze.com/shows/90/haven",
    name: "Haven",
    genres: ["Drama", "Crime", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/672.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/672.jpg",
    },
    summary:
      '<p>When FBI Special Agent Audrey Parker is dispatched to the small town of <b>Haven</b>, Maine, on a routine case, she soon finds herself increasingly involved in the return of "The Troubles", a plague of supernatural afflictions that have occurred in the town at least twice before. With an openness to the possibility of the paranormal, she also finds a more personal link in Haven that may lead her to the mother she has never known.</p><p>She and her partner, police detective Nathan Wuornos, find themselves frequently facing problems caused by both the effects of the Troubles, as well as the activities of town folk who take more drastic measures against those who are Troubled.</p>',
    officialSite: "http://www.syfy.com/haven",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-07-09",
  },
  {
    id: 91,
    url: "https://www.tvmaze.com/shows/91/bad-judge",
    name: "Bad Judge",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/678.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/678.jpg",
    },
    summary:
      "<p>No excuses, no apologies, no compromises. Wild child Rebecca Wright knows how to have a good time, but she also happens to be one of L.A.'s toughest and most respected criminal court judges. She has a reputation for unorthodox behavior in the courtroom, including creative rulings and saying exactly what's on her mind. Her private life, on the other hand, is anything but innocent. She parties too much and rocks out on the drums in a band with her best friend, Jenny. While there's no shortage of male admirers who would love to spend time with her, she's not ready to settle down... except when an 8-year-old boy - whose parents were put in jail by Rebecca - needs her help. He may, in fact, be the one thing that starts to tame this <b>Bad Judge</b>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-02",
  },
  {
    id: 92,
    url: "https://www.tvmaze.com/shows/92/a-to-z",
    name: "A to Z",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/679.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/679.jpg",
    },
    summary:
      "<p>This is the <b>A to Z</b> story of Andrew and Zelda - a pair that almost wasn't - and all that happened from the day they met. Andrew has always been a secret romantic... not above crooning to Celine Dion while driving to work, with dreams of finding \"the one.\" He imagines her to be just like that shimmering beauty he spotted that night in that silver dress at that concert two years ago. Zelda, having grown up with a hippie mom who believed the universe would provide for everything, rebelled into a no-nonsense practical lawyer who prefers the control of online dating. But when a computer glitch sends her a total mismatch, she's asked to come in for an interview at the Internet dating site where Andrew works, and this is where it all begins. Andrew and Zelda meet for the first time and despite their differences, sparks fly. She thinks it's chance. He thinks it's fate. After all, he's convinced she's the shimmering girl in the silver dress. Is it true love forever or just a detour in destiny?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-02",
  },
  {
    id: 93,
    url: "https://www.tvmaze.com/shows/93/parenthood",
    name: "Parenthood",
    genres: ["Drama", "Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/685.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/685.jpg",
    },
    summary:
      "<p><b>Parenthood</b> is the critically acclaimed one-hour drama inspired by the box office hit of the same name. This reimagined and updated Universal Television/Imagine Entertainment production follows the trials and tribulations of the very large, colorful and imperfect Braverman family. Sarah Braverman is a single mother with two kids - the bright but rebellious Amber who is living on her own, and sullen and sensitive Drew who returns to Berkeley this year.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-03-02",
  },
  {
    id: 94,
    url: "https://www.tvmaze.com/shows/94/defiance",
    name: "Defiance",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/700.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/700.jpg",
    },
    summary:
      "<p>Set on a future Earth, <b>Defiance</b> introduces players and viewers to a world where humans and aliens live together on a planet ravaged by decades of war and transformed by alien terra-forming machines. It centers on Jeb Nolan, the law-keeper in a bustling frontier boomtown that is one of the new world's few oasis of civility and inclusion. Nolan is a former Marine who fought in the alien conflict and suffered the loss of his wife and child in the war. The trauma transformed him into a lone wanderer in the wilds of this new and dangerous world.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-04-15",
  },
  {
    id: 95,
    url: "https://www.tvmaze.com/shows/95/falling-skies",
    name: "Falling Skies",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/716.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/716.jpg",
    },
    summary:
      "<p>The series tells the story of the aftermath of a global invasion by several races of extraterrestrials that neutralizes the world's power grid and technology, quickly destroys the combined militaries of all the world's countries, and apparently kills over 90% of the human population within a few days.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-06-19",
  },
  {
    id: 96,
    url: "https://www.tvmaze.com/shows/96/manhattan-love-story",
    name: "Manhattan Love Story",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/729.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/729.jpg",
    },
    summary:
      "<p>Have you ever wondered what your date was thinking? This romantic comedy exposes the differences between men and women through the unfiltered thoughts, and often contradictory actions, of a new couple who have just begun dating.</p>",
    officialSite: "https://abc.go.com/shows/manhattan-love-story",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-30",
  },
  {
    id: 97,
    url: "https://www.tvmaze.com/shows/97/the-biggest-loser",
    name: "The Biggest Loser",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/730.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/730.jpg",
    },
    summary:
      '<p>NBC\'s <b>The Biggest Loser</b>, a show known for its incredible weight loss makeovers, will reveal an exciting makeover of its own when the popular series returns on Monday, January 4 (9-11 p.m. ET) with new host Bob Harper, a new "Temptation" theme, an updated state-of-the-art gym, a new logo, fun format changes and a return to the popular team vs. team competition. Dolvett Quince and Jen Widerstrom return to train eight contestant teams of two, all with compelling stories. Seven teams (spouses, parent/adult child, siblings, relatives, best friends) will know each other, but one team will be two strangers - former "Celebrity Apprentice" contestant and the original "Survivor" winner, Richard Hatch, and \'The Voice\' season two semi-finalist Erin Willett. Having both been in the NBC family previously, the two share the same goal as the other 14 contestants - to change their lives and get healthy. The renovated "Biggest Loser" gym, featuring a new interior and exterior branded with the new logo, has modernized equipment to help contestants better achieve their fitness goals, including eight high-tech monitors on the walls of each side of the gym that will track contestants\' calorie burns as well as heart rates. Half of the gym will be dedicated to Team Dolvett and the other half dedicated to Team Jen. The weigh-in will be very different this season with a new look and double scales, so contestants on opposing teams can weigh-in side by side, making the weigh-in even more compelling to watch. The contestant house is also getting a whole new look for season 17.</p>',
    officialSite: "https://www.usanetwork.com/the-biggest-loser",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-10-19",
  },
  {
    id: 98,
    url: "https://www.tvmaze.com/shows/98/scandal",
    name: "Scandal",
    genres: ["Drama", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/303/758518.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/303/758518.jpg",
    },
    summary:
      "<p>Everyone has secrets… and Olivia Pope has dedicated her life to protecting and defending the public images of the nation's elite by keeping those secrets under wraps. Pope's team are at the top of their game when it comes to getting the job done for their clients, but it becomes apparent that these \"gladiators in suits\", who specialize in fixing the lives of other people, have trouble fixing those closest at hand -- their own.</p>",
    officialSite: "http://abc.go.com/shows/scandal",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-04-05",
  },
  {
    id: 99,
    url: "https://www.tvmaze.com/shows/99/americas-next-top-model",
    name: "America's Next Top Model",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/147/369365.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/147/369365.jpg",
    },
    summary:
      "<p>Created by supermodel Tyra Banks, <b>America's Next Top Model</b> follows a group of young women of various backgrounds, shapes and sizes who live together in a loft and vie for a modeling contract. The show exposes the transformation of everyday young women into potentially fierce supermodels, with participants facing weekly tests that determine who can make the cut. With mentoring by supermodel Tyra Banks and exposure to high-profile fashion-industry gurus, the finalists compete in a highly accelerated modeling boot camp--a crash course to supermodel fame.</p>",
    officialSite: "http://www.vh1.com/shows/americas-next-top-model",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 55,
      name: "VH1",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-05-20",
  },
  {
    id: 100,
    url: "https://www.tvmaze.com/shows/100/blue-bloods",
    name: "Blue Bloods",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/317/793614.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/317/793614.jpg",
    },
    summary:
      "<p><b>Blue Bloods </b>is a drama about a multi-generational family of cops dedicated to New York City law enforcement. Frank Reagan is the New York Police Commissioner and heads both the police force and the Reagan brood. He runs his department as diplomatically as he runs his family, even when dealing with the politics that plagued his unapologetically bold father, Henry, during his stint as Chief. A source of pride and concern for Frank is his eldest son Danny, a seasoned detective, family man and Iraq War vet who on occasion uses dubious tactics to solve cases with his loyal and tough partner, Detective Jackie Curatola. The Reagan women in the family include Erin, a N.Y. Assistant D.A., who also serves as the legal compass for her siblings and father, and single parent to her teenage daughter Nicky; and Linda, Danny's supportive wife. Jamie is the youngest Reagan, a recent grad of Harvard Law and the family's \"golden boy.\" Unable to deny the family tradition, Jamie has decided to give up a lucrative future in law and follow in the family footsteps as a cop.</p>",
    officialSite: "http://www.cbs.com/shows/blue_bloods/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-24",
  },
  {
    id: 101,
    url: "https://www.tvmaze.com/shows/101/the-good-wife",
    name: "The Good Wife",
    genres: ["Drama", "Crime", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/59/148162.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/59/148162.jpg",
    },
    summary:
      "<p><b>The Good Wife</b> follows Alicia Florrick, a wife and mother who boldly assumes full responsibility for her family and re-enters the workforce after her husband's very public sex and political corruption scandal lands him in jail. Pushing aside the betrayal and crushing public humiliation caused by her husband Peter, Alicia starts over by pursuing her original career as a defense attorney.</p>",
    officialSite: "http://www.cbs.com/shows/the_good_wife/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-09-22",
  },
  {
    id: 102,
    url: "https://www.tvmaze.com/shows/102/boardwalk-empire",
    name: "Boardwalk Empire",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/82/205023.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/82/205023.jpg",
    },
    summary:
      "<p>As the country struggles to cope with the Great Depression and the end of Prohibition looms, Nucky Thompson looks to legitimize himself through alliances with liquor producers, while rivals Lucky Luciano and Meyer Lansky seek to consolidate their power in the wake of Arnold Rothstein's death and eliminate all competition - by any means necessary on <b>Boardwalk Empire</b>.</p>",
    officialSite: "http://www.hbo.com/boardwalk-empire",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-19",
  },
  {
    id: 103,
    url: "https://www.tvmaze.com/shows/103/law-order-special-victims-unit",
    name: "Law & Order: Special Victims Unit",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/279/699062.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/279/699062.jpg",
    },
    summary:
      "<p>In the criminal justice system, sexually-based offenses are considered especially heinous. In New York City, the dedicated detectives who investigate these vicious felonies are members of an elite squad known as the Special Victims Unit. These are their stories.</p>",
    officialSite: "http://www.nbc.com/law-and-order-special-victims-unit",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-09-20",
  },
  {
    id: 104,
    url: "https://www.tvmaze.com/shows/104/dominion",
    name: "Dominion",
    genres: ["Action", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/775.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/775.jpg",
    },
    summary:
      '<p><b>Dominion </b>is an epic supernatural drama set in the near future. Specifically, 25 years after "The Extinction War," when an army of lower angels, assembled by the archangel Gabriel, waged war against mankind. The archangel Michael, turning against his own kind, chose to side with humanity. Rising out of the ashes of this long battle are newly fortified cities which protect human survivors. At the center of the series is the city of Vega, a glistening empire that has formed from the ruins of what was once Las Vegas.</p>',
    officialSite: "http://www.syfy.com/dominion",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-06-19",
  },
  {
    id: 105,
    url: "https://www.tvmaze.com/shows/105/from-dusk-till-dawn-the-series",
    name: "From Dusk Till Dawn: The Series",
    genres: ["Action", "Crime", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/70/176381.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/70/176381.jpg",
    },
    summary:
      '<p><b>From Dusk Till Dawn: The Series</b>, based on the thrill-ride film of the same name, is a supernatural crime saga centered around bank robber, Seth Gecko and his violent, unpredictable brother, Richard "Richie" Gecko, who are wanted by the FBI and Texas Rangers Earl McGraw and Freddie Gonzalez after a bank heist leaves several people dead. While on the run to Mexico, Seth and Richie encounter former pastor Jacob Fuller and his family, whom they take hostage. Using the family RV to cross the border, chaos ensues when the group detours to a strip club that is populated by vampires. They are forced to fight until dawn in order to get out alive.</p>',
    officialSite:
      "http://www.elreynetwork.com/originals/from-dusk-till-dawn-s3",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 21,
      name: "El Rey Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-03-11",
  },
  {
    id: 106,
    url: "https://www.tvmaze.com/shows/106/justified",
    name: "Justified",
    genres: ["Drama", "Crime", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/808.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/808.jpg",
    },
    summary:
      '<p>Deputy U.S. Marshal Raylan Givens is something of a 19th century-style officer in modern times, whose unconventional enforcement of justice makes him a target with criminals and a problem for his superiors in the U.S. Marshals Service. As a result of an eager but "justified" shooting of a Miami fugitive while on assignment in Florida, Givens is reassigned to Lexington, Kentucky, in a district that includes his hometown of Harlan, a rural mining town in the east of the state.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-03-16",
  },
  {
    id: 107,
    url: "https://www.tvmaze.com/shows/107/bobs-burgers",
    name: "Bob's Burgers",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/309/773276.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/309/773276.jpg",
    },
    summary:
      "<p>The series follows Bob who runs <b>Bob's Burgers</b>, with the help of his wife and their three kids. Bob has big ideas about burgers, but the rest of the clan falls short on service. Despite the greasy counters and lousy location, the Belchers are determined to make every \"Grand Re-Re-Re-opening\" a success. Bob's wife, Linda, stands by her man and often does so by bursting into song. Their eldest daughter, 13-year-old Tina has a slight obsession with boys and zombies. Middle child Gene is an aspiring musician with a thirst for life. Louise is the bunny ears-wearing youngest daughter with an off-kilter sense of humor that makes her somewhat of a liability in the kitchen – and with the public.</p>",
    officialSite: "http://www.fox.com/bobs-burgers",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-01-09",
  },
  {
    id: 108,
    url: "https://www.tvmaze.com/shows/108/mulaney",
    name: "Mulaney",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/846.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/846.jpg",
    },
    summary:
      "<p>John Mulaney is a 29-year-old comedian working the stand-up circuit and looking for his big break. But life drastically changes when self-centered comedy legend and game show host Lou Cannon hires Mulaney as a writer. Lou may be John's entrée into the world of big-money show business, but he's also a total nightmare. Still, the job represents everything Mulaney thinks he wants. But does he really? And, at what cost? And what does it say about him if he quits? And what does it say about him if he stays? And has Lou had work done?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-05",
  },
  {
    id: 109,
    url: "https://www.tvmaze.com/shows/109/csi-crime-scene-investigation",
    name: "CSI: Crime Scene Investigation",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/887.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/887.jpg",
    },
    summary:
      "<p><b>CSI: Crime Scene Investigation</b> is a drama about a team of forensic investigators trained to solve criminal cases by scouring the crime scene, collecting irrefutable evidence and finding the missing pieces that solve the mystery.</p>",
    officialSite: "http://www.cbs.com/shows/csi/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-10-06",
  },
  {
    id: 110,
    url: "https://www.tvmaze.com/shows/110/gracepoint",
    name: "Gracepoint",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/862.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/862.jpg",
    },
    summary:
      "<p>When a young boy is found dead on an idyllic beach, a major police investigation gets underway in the small California seaside town where the tragedy occurred. Soon deemed a homicide, the case sparks a media frenzy, which throws the boy's family into further turmoil and upends the lives of all of the town's residents. Welcome to <b>Gracepoint</b>, a new 10-episode mystery event series based on \"Broadchurch,\" the U.K.'s critically acclaimed hit crime drama.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-02",
  },
  {
    id: 111,
    url: "https://www.tvmaze.com/shows/111/once-upon-a-time",
    name: "Once Upon a Time",
    genres: ["Drama", "Fantasy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/127/319360.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/127/319360.jpg",
    },
    summary:
      "<p><b>Once Upon a Time</b> is Fairy Tale Land. It's filled with magic, monsters and all of the characters we all know from stories growing up. It's real, and so are the people in it. But unlike the \"happily ever after\" you may have heard about, their stories continued, and The Evil Queen cast a Dark Curse over the land...</p><p>This is Storybrooke. It's a quiet, little New England town filled with people who go about their everyday lives with no idea who they really are. The Queen's Curse has trapped them here and placed her in near-complete control. They have no real memories and no real hope.</p>",
    officialSite: "http://abc.go.com/shows/once-upon-a-time",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-10-23",
  },
  {
    id: 112,
    url: "https://www.tvmaze.com/shows/112/south-park",
    name: "South Park",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/935.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/935.jpg",
    },
    summary:
      "<p><b>South Park</b> is an adult comedy animation show centred around 4 children in the small town of south park. Its humour is often dark involving satirical elements and mocking current real-life events.</p>",
    officialSite: "http://southpark.cc.com",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1997-08-13",
  },
  {
    id: 114,
    url: "https://www.tvmaze.com/shows/114/survivor",
    name: "Survivor",
    genres: ["Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/237/592561.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/237/592561.jpg",
    },
    summary:
      "<p>Eighteen to twenty castaways will compete against each other on <b>Survivor</b>. All castaways will compete to outwit, outplay, outlast and ultimately be crowned Sole Survivor.</p>",
    officialSite: "http://www.cbs.com/shows/survivor/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-05-31",
  },
  {
    id: 115,
    url: "https://www.tvmaze.com/shows/115/king-of-the-hill",
    name: "King of the Hill",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/45/113875.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/45/113875.jpg",
    },
    summary:
      "<p><b>King of the Hill</b> follows the life of Hank Hill, his wife Peggy, their 13-year-old son Bobby, their 18-year-old niece Luanne, her husband Lucky, their newborn baby girl Gracie and his beer guzzling neighborhood buddies, Dale, Bill and Boomhauer.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1997-01-12",
  },
  {
    id: 116,
    url: "https://www.tvmaze.com/shows/116/the-mentalist",
    name: "The Mentalist",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/1239.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/1239.jpg",
    },
    summary:
      "<p>Patrick Jane, an independent consultant with the California Bureau of Investigation (CBI), has a remarkable track record for solving serious crimes by using his razor sharp skills of observation. Within the Bureau, Jane is notorious for his blatant lack of protocol and his semi-celebrity past as a psychic medium, whose paranormal abilities he now admits he feigned. No-nonsense Senior Agent Teresa Lisbon openly resists having Jane in her unit and alternates between reluctantly acknowledging Jane's usefulness and blasting him for his theatrics, narcissism, and dangerous lack of boundaries. Lisbon's team includes agents Kimball Cho, Wayne Rigsby and rookie member Grace Van Pelt, who all think Jane's a loose cannon but admire his charm and knack for clearing cases.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-09-23",
  },
  {
    id: 117,
    url: "https://www.tvmaze.com/shows/117/star-wars-rebels",
    name: "Star Wars Rebels",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/26/66846.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/26/66846.jpg",
    },
    summary:
      "<p><b>Star Wars Rebels</b>, set five years before the events of Star Wars: Episode IV - A New Hope, tells the story of the Rebellion's beginnings while the Empire spreads tyranny through the galaxy.</p>",
    officialSite: "http://disneyxd.disney.com/star-wars-rebels",
    webChannel: {
      id: 83,
      name: "DisneyNOW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: {
      id: 25,
      name: "Disney XD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-29",
  },
  {
    id: 118,
    url: "https://www.tvmaze.com/shows/118/house",
    name: "House",
    genres: ["Drama", "Mystery", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/43/109527.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/43/109527.jpg",
    },
    summary:
      "<p>Sink your teeth into meaty drama and intrigue with <b>House</b>, FOX's take on mystery, where the villain is a medical malady and the hero is an irreverent, controversial doctor who trusts no one, least of all his patients.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-11-16",
  },
  {
    id: 120,
    url: "https://www.tvmaze.com/shows/120/transparent",
    name: "Transparent",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/210/525553.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/210/525553.jpg",
    },
    summary:
      "<p>In <b>Transparent</b>, an LA family with serious boundary issues have their past and future unravel when a dramatic admission causes everyone's secrets to spill out.</p>",
    officialSite: "https://www.amazon.com/dp/B017I3KWX6",
    webChannel: { id: 3, name: "Amazon Prime Video", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2014-09-26",
  },
  {
    id: 122,
    url: "https://www.tvmaze.com/shows/122/nikita",
    name: "Nikita",
    genres: ["Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/1366.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/1366.jpg",
    },
    summary:
      "<p>When she was a deeply troubled teenager, Nikita was rescued from death row by a secret U.S. agency known only as Division, who trained her as a spy and assassin. Nikita was eventually betrayed by the only people she thought she could trust. Now, after three years in hiding, Nikita is seeking retribution and making it clear to her former boss, Percy and her former friends Michael and Birkhoff that she will stop at nothing to expose and destroy their covert operation.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-09",
  },
  {
    id: 123,
    url: "https://www.tvmaze.com/shows/123/lost",
    name: "Lost",
    genres: ["Drama", "Adventure", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/1389.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/1389.jpg",
    },
    summary:
      "<p>Out of the blackness, the first thing Jack senses is pain. Then burning sun. A Bamboo forest. Smoke. Screams. With a rush comes the horrible awareness that the plane he was on tore apart in mid-air and crashed on a Pacific island. From there it's a blur, as his doctor's instinct kicks in: people need his help.</p><p>Stripped of everything, the 48 survivors scavenge what they can from the plane for their survival. Some panic. Some pin their hopes on rescue. A few find inner strength they never knew they had -- like Kate, who, with no medical training, suddenly finds herself suturing the doctor's wounds. Hurley - a man with a warm sense of humor despite the desperate situation - does his best to keep his cool as he helps those around him to survive. Charlie is a faded rock star who harbors a painful secret. Sayid is a Middle Eastern man who must wrestle with the racial profiling directed at him by some of his fellow survivors. Jin and Sun are a Korean couple whose traditions, values and language are foreign, and thus causes much to get lost in the translation. Sawyer has an air of danger surrounding him, and his intense sense of mistrust for everyone around him could prove to be fatal to his fellow castaways. Michael has just gained custody of his nine-year-old son, Walt, after the death of his ex-wife - they are a father and son who don't even know each other. Locke is a mysterious man who keeps to himself, and who harbors a deeper connection to the island than any of the others. Self-centered Shannon - who actually gives herself a pedicure amid the chaos - and her estranged controlling brother, Boone , constantly bicker and must learn to get along if they are to survive. And young Claire is eight months pregnant and ill-prepared for the hardships of motherhood - especially on a deserted island.</p>",
    officialSite: "http://abc.go.com/shows/lost",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-09-22",
  },
  {
    id: 124,
    url: "https://www.tvmaze.com/shows/124/2-broke-girls",
    name: "2 Broke Girls",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/63/158548.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/63/158548.jpg",
    },
    summary:
      "<p><b>2 Broke Girls</b> is a comedy about two young women waitressing at a greasy spoon diner who strike up an unlikely friendship in the hopes of launching a successful business - if only they can raise the cash. Sassy, streetwise Max Black works two jobs just to get by, one of which is waiting tables during the night shift at the retro-hip Williamsburg Diner. Sophisticated Caroline Channing is an uptown trust fund princess who's having a run of bad luck that forces her to reluctantly give waitressing a shot. At first, Max sees Caroline as yet another in a long line of inept servers she must cover for, but she's surprised to find that Caroline has as much substance as she does style.</p><p>When Caroline discovers Max's knack for baking amazing cupcakes, she sees a lucrative future for them, but first they need to raise the start-up money. While they save their tips, they'll stay at the restaurant, working with Oleg, an overly flirtatious Russian cook; Earl, a 75-year-old kool-kat cashier; and Han Lee, the new, eager-to-please owner of the diner. Working together, these two broke girls living in one expensive city might just find the perfect recipe for their big break.</p>",
    officialSite: "http://www.cbs.com/shows/2_broke_girls/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-19",
  },
  {
    id: 125,
    url: "https://www.tvmaze.com/shows/125/selfie",
    name: "Selfie",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/1756.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/1756.jpg",
    },
    summary:
      "<p>Eliza Dooley has 263,000 followers who hang on to her every post, tweet and selfie. But one lonely day, she has a revelation: being friended is not the same as having actual friends. She asks marketing guru Henry to 'rebrand' her self-obsessed reputation and teach her how to connect with people in the real world. Loosely based on <i>My Fair Lady</i>, <b>Selfie</b> explores the modern struggles of Eliza and Henry, as he tries to teach her how to live life offline - whether she 'likes' it or not.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-30",
  },
  {
    id: 126,
    url: "https://www.tvmaze.com/shows/126/mom",
    name: "Mom",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/300/751117.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/300/751117.jpg",
    },
    summary:
      "<p>Christy is a single mom who, after years of questionable choices, is now sober and trying to get her life on track. She's tested daily by her newly sober mother, Bonnie, who is trying to make up for all the ways she's let Christy down. Christy is further challenged by her relationships with her own kids. Her daughter Violet is engaged to a man twice her age and her ten-year-old son, Roscoe, would rather live with his father Baxter, a former slacker who has only recently gotten himself together. To help her stay sober, Christy relies on her support system from AA, comprised of her sponsor Marjorie, her wealthy sponsee, Jill, and her emotional friend, Wendy. Christy tries to remain positive as she attempts to overcome her past and build a better future, but with her dysfunctional family and life's many setbacks, it's always an uphill battle.</p>",
    officialSite: "http://www.cbs.com/shows/mom/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-23",
  },
  {
    id: 127,
    url: "https://www.tvmaze.com/shows/127/the-affair",
    name: "The Affair",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/203/509941.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/203/509941.jpg",
    },
    summary:
      "<p>At once deeply observed and intriguingly elusive, <b>The Affair</b> explores the emotional effects of an extramarital relationship.</p><p>Noah is a New York City schoolteacher and novelist who is happily married, but resents his dependence on his wealthy father-in-law. Alison is a young waitress trying to piece her life and marriage back together in the wake of a tragedy. The provocative drama unfolds when Alison and Noah meet in Montauk at the end of Long Island.</p>",
    officialSite: "http://www.sho.com/sho/the-affair/home",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-12",
  },
  {
    id: 128,
    url: "https://www.tvmaze.com/shows/128/jane-the-virgin",
    name: "Jane the Virgin",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/186/466352.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/186/466352.jpg",
    },
    summary:
      "<p>When Jane Villanueva was a young girl, her grandmother, Alba, convinced her of two things: telenovelas are the highest form of entertainment, and women must protect their virginity at all costs. Jane the Virgin, although she has always tried to be the good girl who does the right thing, Jane's life has suddenly become as dramatic and complicated as the telenovelas she has always loved.</p>",
    officialSite: "http://www.cwtv.com/shows/jane-the-virgin",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-13",
  },
  {
    id: 129,
    url: "https://www.tvmaze.com/shows/129/marry-me",
    name: "Marry Me",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/1836.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/1836.jpg",
    },
    summary:
      "<p>Six years ago, Annie and Jake bonded over their mutual love of nachos and they've been inseparable ever since. Now, after returning from a romantic two-week island vacation, Jake's all set to pop the question. Before he can ask, though, Annie lets loose on Jake for his inability to commit. She was expecting him to \"put a ring on it\" in paradise and now Jake's perfect proposal is ruined. Not wanting to spend the next 60 years talking about that mess of a proposal, Jake and Annie decide to hold off on the engagement until they can do it right. Yet if history tells us anything, it's when we really want things to go right that they all tend to go wrong. The only thing we know for sure is these two are destined to be together whether they can get it together or not.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-14",
  },
  {
    id: 130,
    url: "https://www.tvmaze.com/shows/130/two-and-a-half-men",
    name: "Two and a Half Men",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/271/677682.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/271/677682.jpg",
    },
    summary:
      "<p>Charlie is a well-to-do bachelor with a house at the beach, a Jaguar in the front, and an easy way with women. His casual Malibu lifestyle is interrupted when his tightly wound brother Alan, who's facing a divorce, and his son Jake, come to live with him. Together, these two and a half men confront the challenges of growing up; finally. Complicating matters are the brothers' self-obsessed, controlling mother, Evelyn, Alan's estranged wife, Judith and Charlie's crazy neighbor Rose, who wants to be a part of his life and is willing to do anything to be around. After the death of his brother, Alan Harper meets and befriends a lonely young man named Walden Schmidt who turns out to be a billionaire. Unable to afford his brother's home, Alan sells Walden the house, and as a way of showing his gratitude, Walden allows Alan and his son Jake to move in with him.</p>",
    officialSite: "http://www.cbs.com/shows/two_and_a_half_men/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-09-22",
  },
  {
    id: 131,
    url: "https://www.tvmaze.com/shows/131/about-a-boy",
    name: "About a Boy",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/1880.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/1880.jpg",
    },
    summary:
      "<p>Will Freeman lives a charmed existence as the ultimate man-child. After writing a hit song, he was granted a life of free time, free love and freedom from financial woes. He's single, unemployed and loving it. So imagine his surprise when Fiona, a needy, single mom and her oddly charming 11-year-old son Marcus move in next door and disrupt his perfect world.</p>",
    officialSite: "http://www.nbc.com/about-a-boy?nbc=1",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-02-22",
  },
  {
    id: 132,
    url: "https://www.tvmaze.com/shows/132/the-millers",
    name: "The Millers",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/1886.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/1886.jpg",
    },
    summary:
      "<p><b>The Millers</b> follows Nathan Miller, a recently divorced local roving news reporter looking forward to living the singles life until his parents' marital problems unexpectedly derail his plans. After Nathan finally breaks the news of his divorce to his parents Carol and Tom, his father is inspired to follow suit and stuns the family when he leaves his wife of 43 years. Already in shock, Nathan is even more aghast when his meddlesome mom decides to move in with him. Meanwhile, his absent-minded dad imposes upon Nathan's sister Debbie, her husband Adam and their daughter. Nathan's best friend and news cameraman Ray was excited to be Nathan's wingman in the dating scene, but Carol manages to even cramp his style. Now, as Nathan and his sister settle in with their truly impossible parents, they both wonder just how long the aggravating adjustment period is going to last.</p>",
    officialSite: "http://www.cbs.com/shows/the-millers/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-10-03",
  },
  {
    id: 133,
    url: "https://www.tvmaze.com/shows/133/elementary",
    name: "Elementary",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/195/488201.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/195/488201.jpg",
    },
    summary:
      "<p><b>Elementary </b>is a modern-day take on the classic Sherlock Holmes story about a crime-solving duo that cracks the NYPD's most impossible cases. Following his fall from grace in London and a stint in rehab, eccentric Sherlock escapes to Manhattan where his wealthy father forces him to live with his worst nightmare - a sober companion, Dr. Watson.</p>",
    officialSite: "http://www.cbs.com/shows/elementary/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-09-27",
  },
  {
    id: 134,
    url: "https://www.tvmaze.com/shows/134/heroes",
    name: "Heroes",
    genres: ["Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/1904.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/1904.jpg",
    },
    summary:
      "<p>This epic chronicles the lives of ordinary people who discover they possess extraordinary abilities. As a total eclipse casts a shadow across the globe, viewers follow a genetics professor in India whose father's disappearance leads him to uncover a secret theory<i>—</i>there are people with super powers living among us. A young dreamer tries to convince his politician brother that he can fly. A high school cheerleader learns that she is totally indestructible. A Las Vegas stripper, struggling to make ends meet to support her young son, uncovers that her mirror image has a secret. A prison inmate mysteriously finds himself waking up outside of his cell. A gifted artist, whose drug addiction is destroying his life and the relationship with his girlfriend, can paint the future. A down-on-his-luck beat cop can hear people's thoughts, including the secrets of a captured terrorist. In Japan, a young man develops a way to stop time through sheer will power. Their ultimate destiny is nothing less than saving the world.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-09-25",
  },
  {
    id: 136,
    url: "https://www.tvmaze.com/shows/136/the-mccarthys",
    name: "The McCarthys",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/1900.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/1900.jpg",
    },
    summary:
      "<p><b>The McCarthys</b> is a multi-camera comedy about a close-knit, sports-crazed Boston family whose somewhat athletically challenged son, Ronny, is chosen by his father to be his assistant high school basketball coach, much to the surprise of his more qualified siblings. Ronny wants nothing more than to move away, join the singles scene and find a partner. His distraught mother, Marjorie is not upset that her favorite son is gay, but that he wants to leave Boston and his family.</p><p>Ronny's plans change, however, when his politically incorrect and outspoken father, Arthur stuns everyone with his choice for an assistant. Touched by his father's offer, Ronny embarks on a completely different future and he can be sure that his loving family, including his twin brothers Sean and Gerard and his sister Jackie, are going to have a very vocal opinion about it.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-30",
  },
  {
    id: 137,
    url: "https://www.tvmaze.com/shows/137/cristela",
    name: "Cristela",
    genres: ["Comedy", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/1932.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/1932.jpg",
    },
    summary:
      "<p>Cristela's dream of becoming a lawyer is something her traditional Mexican-American family doesn't quite understand. She's entering her sixth year of law school after juggling home obligations and working multiple jobs to pay her way.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-10",
  },
  {
    id: 138,
    url: "https://www.tvmaze.com/shows/138/the-leftovers",
    name: "The Leftovers",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/107/267799.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/107/267799.jpg",
    },
    summary:
      '<p>Three years after millions of people—some 2% of the world\'s population—vanished into thin air, residents of Mapleton, NY weigh the pros and cons of a "Heroes Day" tribute to the local "Departed". Attempting to maintain a sense of normalcy in his strained community, police chief Kevin Garvey faces additional challenges at home with his daughter, Jill, who\'s lost in a cloud of apathy with her friend Aimee, and son, Tom, who has gravitated to a cult led by the charismatic Holy Wayne. Also of concern is a silent, white-clad group of chain-smoking men and women called the Guilty Remnant, who team up in pairs to stake out people and places around town. As tension in Mapleton escalates, the lives of Laurie, an unexpected member of the Guilty Remnant, and Meg, a recently engaged young woman, converge.</p>',
    officialSite: "http://www.hbo.com/the-leftovers",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-06-29",
  },
  {
    id: 139,
    url: "https://www.tvmaze.com/shows/139/girls",
    name: "Girls",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/31/78286.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/31/78286.jpg",
    },
    summary:
      "<p>This Emmy winning series is a comic look at the assorted humiliations and rare triumphs of a group of girls in their 20s.</p>",
    officialSite: "http://www.hbo.com/girls",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-04-15",
  },
  {
    id: 140,
    url: "https://www.tvmaze.com/shows/140/looking",
    name: "Looking",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/1961.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/1961.jpg",
    },
    summary:
      "<p><b>Looking</b> offers up the unfiltered experiences of three close friends living - and loving - in modern-day San Francisco. Friendship may bind them, but each is at a markedly different point in his journey: Patrick is the 29-year-old video game designer getting back into the dating world in the wake of his ex's engagement; aspiring artist Agustín, 31, is questioning the idea of monogamy amid a move to domesticate with his boyfriend; and the group's oldest member - longtime waiter Dom, 39 - is facing middle age with romantic and professional dreams still unfulfilled.</p><p>The trio's stories intertwine and unspool dramatically as they search for happiness and intimacy in an age of unparalleled choices - and rights - for gay men. Also important to the ‘Looking' mix is the progressive, unpredictable, sexually open culture of the Bay Area, with real San Francisco locations serving as a backdrop for the group's lives. Rounding out the ‘Looking' world are a bevy of dynamic gay men including Kevin, Lynn, and Richie, as well as a wide-range of supporting characters like Dom's roommate Doris, Agustín's boyfriend Frank, and Patrick's co-worker Owen.</p>",
    officialSite: "http://www.hbo.com/looking",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-19",
  },
  {
    id: 141,
    url: "https://www.tvmaze.com/shows/141/getting-on",
    name: "Getting On",
    genres: ["Comedy", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/1970.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/1970.jpg",
    },
    summary:
      "<p>From creators Mark V. Olsen and Will Scheffer, the series follows the daily lives of nurses and doctors as they struggle with the darkly comic realities of caring for the elderly in an overwhelmed healthcare system, skewering the petty bureaucracies of modern medical practice in America.</p>",
    officialSite: "http://www.hbo.com/getting-on",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-11-24",
  },
  {
    id: 142,
    url: "https://www.tvmaze.com/shows/142/veep",
    name: "Veep",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/189/472887.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/189/472887.jpg",
    },
    summary:
      "<p>Former Senator Selina Meyer has accepted the call to serve as Vice President of the United States. The job is nothing like she imagined and everything she was warned about. <b>Veep</b> follows Meyer and her staff as they attempt to make their mark and leave a lasting legacy, without getting tripped up in the day-to-day political games that define Washington.</p>",
    officialSite: "http://www.hbo.com/veep/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-04-22",
  },
  {
    id: 143,
    url: "https://www.tvmaze.com/shows/143/silicon-valley",
    name: "Silicon Valley",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/215/538434.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/215/538434.jpg",
    },
    summary:
      "<p>In the high-tech gold rush of modern Silicon Valley, the people most qualified to succeed are the least capable of handling success. From Mike Judge comes this satire about a programmer whose game-changing algorithm becomes the subject of a valley-wide bidding war.</p>",
    officialSite: "http://www.hbo.com/silicon-valley/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-04-06",
  },
  {
    id: 144,
    url: "https://www.tvmaze.com/shows/144/the-comeback",
    name: "The Comeback",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/280/700748.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/280/700748.jpg",
    },
    summary:
      "<p>The limited comedy series stars Lisa Kudrow as the embattled Valerie Cherish, a fading TV \"It Girl\" who was once so desperate to stay in the spotlight that she allowed cameras to follow her every move as she appeared on a new sitcom - with disastrous results. Now, it's ten years later, and Valerie thinks she has it all figured out this time. She doesn't.</p>",
    officialSite: "http://www.hbo.com/the-comeback",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-06-05",
  },
  {
    id: 145,
    url: "https://www.tvmaze.com/shows/145/house-of-lies",
    name: "House of Lies",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/2003.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/2003.jpg",
    },
    summary:
      "<p>Charming, fast talking Marty Kaan and his crack team of management consultants know how to play the corporate game better than anyone, by using every dirty trick in the book to woo powerful CEOs and close huge deals. In the board rooms, barrooms, and bedrooms of the power elite, corruption is business as usual and everyone's out for themselves first. Nothing is sacred in this scathing, irreverent satire of corporate America today.</p>",
    officialSite: "http://www.sho.com/sho/house-of-lies/home",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-01-08",
  },
  {
    id: 146,
    url: "https://www.tvmaze.com/shows/146/episodes",
    name: "Episodes",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/123/309535.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/123/309535.jpg",
    },
    summary:
      "<p>Matt LeBlanc stars as Matt LeBlanc in <b>Episodes</b>, the hilarious comedy series about remaking a comedy series. When husband and wife writing team Sean and Beverly set out to reproduce their British TV hit for an American network, all of their worst fears come true as Hollywood lives up to its reputation for absurdity. Not only does the network cast Matt LeBlanc in the starring role, but Matt takes the lead in deviously twisting their beloved series into a terrible cliché, while testing the couple's marriage with diversions and temptations.</p>",
    officialSite: "http://www.sho.com/sho/episodes/home",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-01-09",
  },
  {
    id: 147,
    url: "https://www.tvmaze.com/shows/147/nurse-jackie",
    name: "Nurse Jackie",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/2021.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/2021.jpg",
    },
    summary:
      "<p>Every day is a matter of life and death in a hectic New York City hospital, but for <b>Nurse Jackie</b> that's the easiest part. Between chronic back pain that won't quit, and a personal life on the constant edge of collapse, it's going to take a white lie here, a bent rule there, and a handful of secret strategies to relieve the pain, and stay one step ahead of total disaster.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-06-08",
  },
  {
    id: 148,
    url: "https://www.tvmaze.com/shows/148/web-therapy",
    name: "Web Therapy",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/2036.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/2036.jpg",
    },
    summary:
      "<p>Fiona Wallice is a therapist with little patience for her patients. Tired of hearing about people's problems for fifty long minutes, she devises a new treatment, the three-minute video chat. And still, the sessions end up being largely about her. If she's your therapist, you've got problems. Emmy Award® winner Lisa Kudrow co-created, produces and stars in this outrageous therapeutic send-up. Originally produced as webisodes, <b>Web Therapy</b> features an A-list guest cast who, along with Kudrow, improvise their performances with hilarious results.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-07-19",
  },
  {
    id: 149,
    url: "https://www.tvmaze.com/shows/149/masters-of-sex",
    name: "Masters of Sex",
    genres: ["Drama", "Romance", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/46/117234.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/46/117234.jpg",
    },
    summary:
      "<p><b>Masters of Sex</b> is a drama that portrays the real-life pioneers of the science of human sexuality, William Masters and Virginia Johnson. The series chronicles the unusual lives, romance, and pop culture trajectory of Masters and Johnson. Their research touched off the sexual revolution and took them from a midwestern teaching hospital in St. Louis to the cover of Time magazine and nearly a dozen appearances on Johnny Carson's couch.</p>",
    officialSite: "http://www.sho.com/sho/masters-of-sex/home",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-29",
  },
  {
    id: 150,
    url: "https://www.tvmaze.com/shows/150/shameless",
    name: "Shameless",
    genres: ["Drama", "Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/284/712350.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/284/712350.jpg",
    },
    summary:
      "<p><b>Shameless</b> is a fiercely engaging and fearlessly twisted series. Chicagoan Frank Gallagher is the proud single dad of six smart, industrious, independent kids, who without him would be... perhaps better off. When Frank's not at the bar spending what little money they have, he's passed out on the floor. But the kids have found ways to grow up in spite of him. They may not be like any family you know, but they make no apologies for being exactly who they are.</p>",
    officialSite: "http://www.sho.com/sho/shameless/home",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-01-09",
  },
  {
    id: 151,
    url: "https://www.tvmaze.com/shows/151/the-newsroom",
    name: "The Newsroom",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/2066.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/2066.jpg",
    },
    summary:
      "<p><b>The Newsroom</b> follows the members of a cable news team on their quixotic mission to do the news well in the face of a fickle audience, corporate mandates and tangled personal relationships.</p>",
    officialSite: "https://www.hbo.com/the-newsroom",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-06-24",
  },
  {
    id: 152,
    url: "https://www.tvmaze.com/shows/152/ray-donovan",
    name: "Ray Donovan",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/212/531511.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/212/531511.jpg",
    },
    summary:
      "<p>Set in the sprawling mecca of the rich and famous, Ray Donovan does the dirty work for LA's top power players as the go-to guy who makes the problems of the city's celebrities, superstar athletes, and business moguls disappear. This powerful drama unfolds when his father is unexpectedly released from prison, setting off a chain of events that shakes the Donovan family to its core.</p>",
    officialSite: "http://www.sho.com/sho/ray-donovan/home",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-06-30",
  },
  {
    id: 153,
    url: "https://www.tvmaze.com/shows/153/utopia",
    name: "Utopia",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/2090.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/2090.jpg",
    },
    summary:
      "<p>Get ready to witness the birth of a brave new world. On the daring unscripted series <b>Utopia</b>, 15 pioneering Americans wave goodbye - for an entire year - to the lives they've known, move to a remote location and set out to create a society from scratch. They've got limited supplies, wildly diverse backgrounds and zero bathrooms.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-07",
  },
  {
    id: 154,
    url: "https://www.tvmaze.com/shows/154/sanctuary",
    name: "Sanctuary",
    genres: ["Drama", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/2119.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/2119.jpg",
    },
    summary:
      "<p><b>Sanctuary</b> follows the adventures of the beautiful, enigmatic and always surprising Dr. Helen Magnus, a brilliant scientist who holds the secrets of a clandestine population and a group of strange and sometimes terrifying beings that hide among humans.</p><p>Along with her new recruit, forensic psychiatrist Dr. Will Zimmerman, her quirky tech wiz Henry and her fearless daughter Ashley, Magnus seeks to protect this threatened phenomena as well as unlock the mysteries behind their existence.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-10-03",
  },
  {
    id: 155,
    url: "https://www.tvmaze.com/shows/155/beauty-and-the-beast",
    name: "Beauty and the Beast",
    genres: ["Drama", "Horror", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/2128.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/2128.jpg",
    },
    summary:
      "<p>Detective Catherine Chandler is a smart, no-nonsense homicide detective. When she was a teenager, she witnessed the murder of her mother at the hands of two gunmen and herself was saved by someone – or something. Years have passed and while investigating a murder, Catherine discovers a clue that leads her to Vincent Keller, who was reportedly killed in 2002. Catherine learns that Vincent is actually still alive and that it was he who saved her many years before. For mysterious reasons that have forced him to live outside of traditional society, Vincent has been in hiding for the past 10 years to guard his secret – when he is enraged, he becomes a terrifying beast, unable to control his super-strength and heightened senses.</p>",
    officialSite: "http://www.cwtv.com/shows/beauty-and-the-beast",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-10-11",
  },
  {
    id: 156,
    url: "https://www.tvmaze.com/shows/156/twin-peaks",
    name: "Twin Peaks",
    genres: ["Drama", "Crime", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/99/249543.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/99/249543.jpg",
    },
    summary:
      "<p>Set in the fictional town of Twin Peaks in northeast Washington state, this is the story of FBI Special Agent Dale Cooper and his investigation of the murder of a popular local teenage schoolgirl, Laura Palmer.</p>",
    officialSite: "http://www.sho.com/twin-peaks",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1990-04-08",
  },
  {
    id: 157,
    url: "https://www.tvmaze.com/shows/157/the-americans",
    name: "The Americans",
    genres: ["Drama", "Espionage"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/146/366911.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/146/366911.jpg",
    },
    summary:
      "<p><b>The Americans</b> is a period drama about the complex marriage of two KGB spies posing as Americans in suburban Washington D.C. shortly after Ronald Reagan is elected President.</p>",
    officialSite: "http://www.fxnetworks.com/theamericans",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-01-30",
  },
  {
    id: 158,
    url: "https://www.tvmaze.com/shows/158/fringe",
    name: "Fringe",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/2245.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/2245.jpg",
    },
    summary:
      "<p>When an international flight lands at Boston's Logan Airport and the passengers and crew have all died grisly deaths, FBI Special Agent Olivia Dunham is called in to investigate. After her partner is nearly killed during the investigation, a desperate Olivia searches frantically for someone to help, leading her to Dr. Walter Bishop, our generation's Einstein. There's only one catch: he's been institutionalized for the last twenty years, and the only way to question him requires pulling his estranged son Peter in to help. When Olivia's investigation leads her to a manipulative corporate executive, she and her team will discover that what happened on Flight 627 is only a small piece of a larger, more shocking truth and will explore the blurring line between the possible and the impossible.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-09-09",
  },
  {
    id: 159,
    url: "https://www.tvmaze.com/shows/159/state-of-affairs",
    name: "State of Affairs",
    genres: ["Drama", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/280/700731.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/280/700731.jpg",
    },
    summary:
      "<p>Each day the President is faced with dozens of life and death decisions, and to prioritize the biggest international crises facing the country, one top CIA analyst — Charleston Tucker — assembles the President's Daily Briefing (PDB). This list of the most vital security issues facing the nation brings with it moral and political judgment calls for Charleston and... her trusted group of brilliant analysts at the agency. Aside from the political minefields she has to walk, Charlie has a close personal relationship with the President because she was once engaged to her son before a tragic terrorist attack took his life. Charlie survived that attack and is now determined to bring the perpetrators to justice. Navigating a complex personal life and a pressure-cooker profession is, of course, a challenge, and Charlie sometimes engages in boundary-pushing behavior to avoid facing her grief. But when the clock strikes 2 a.m., she is all about her job — protecting her nation, serving her President and still trying to get to the bottom of her fiancé's murder that will reveal itself as a shocking mystery.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-17",
  },
  {
    id: 160,
    url: "https://www.tvmaze.com/shows/160/weeds",
    name: "Weeds",
    genres: ["Drama", "Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/2216.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/2216.jpg",
    },
    summary:
      "<p><b>Weeds</b> is based around an american widow (Nancy Botwin) with 2 children who begins selling cannabis for financial gain after the death of her husband. Her family become involved in more and more illegal activities as the show progresses.</p>",
    officialSite: "http://www.sho.com/sho/weeds/home",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-08-07",
  },
  {
    id: 161,
    url: "https://www.tvmaze.com/shows/161/dexter",
    name: "Dexter",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/39/99907.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/39/99907.jpg",
    },
    summary:
      "<p><b>Dexter</b> is a crime drama series based around the main character, a serial killer named Dexter Morgan. Dexter only kills other killers and criminals and works in blood splatter analysis at crime scenes.</p>",
    officialSite: "http://www.sho.com/sho/dexter/home",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-10-01",
  },
  {
    id: 162,
    url: "https://www.tvmaze.com/shows/162/carnivale",
    name: "Carnivàle",
    genres: ["Drama", "Fantasy", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/2256.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/2256.jpg",
    },
    summary:
      "<p><b>Carnivàle</b> is set in the United States during the Great Depression and Dust Bowl. In tracing the lives of two disparate groups of people, its overarching story depicts the battle between good and evil and the struggle between free will and destiny, the storyline mixes Christian theology with Gnosticism and Masonic lore, particularly that of the Knights Templar.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-09-14",
  },
  {
    id: 163,
    url: "https://www.tvmaze.com/shows/163/human-target",
    name: "Human Target",
    genres: ["Action", "Adventure", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/42/106702.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/42/106702.jpg",
    },
    summary:
      "<p>Christopher Chance is a unique private contractor/security expert/bodyguard hired when an unusual or imminent threat cannot be solved through normal means of protection. Chance works with his business partner and trusted friend, Winston, and hired gun, Guerrero, to integrate himself completely into his clients' lives and eliminate the threat by becoming the <b>Human Target</b>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-01-17",
  },
  {
    id: 164,
    url: "https://www.tvmaze.com/shows/164/banshee",
    name: "Banshee",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/80/201761.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/80/201761.jpg",
    },
    summary:
      "<p><b>Banshee</b> stars Antony Starr as Lucas Hood, an ex-con and master thief who assumes the identity of the sheriff of Banshee, Pennsylvania, where he continues his criminal activities, even as he's hunted by the shadowy gangsters he betrayed years earlier.</p>",
    officialSite: "http://www.cinemax.com/banshee/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 19,
      name: "Cinemax",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-01-11",
  },
  {
    id: 165,
    url: "https://www.tvmaze.com/shows/165/bionic-woman",
    name: "Bionic Woman",
    genres: ["Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/2303.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/2303.jpg",
    },
    summary:
      "<p>When a devastating car accident leaves Jaime Sommer at death's door, her only hope of survival is a cutting-edge, top-secret technology performed by her boyfriend, Dr. Will Anthros and with her new bionics come a covert life that she is not sure she is ready to lead.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-09-26",
  },
  {
    id: 166,
    url: "https://www.tvmaze.com/shows/166/battlestar-galactica",
    name: "Battlestar Galactica",
    genres: ["Drama", "Science-Fiction", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/2313.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/2313.jpg",
    },
    summary:
      "<p>The world ended with no warning, and all that was left… was hope.</p><p>A truce between the humans of the Twelve Colonies and the Cylons—intelligent robots designed by humankind—lasts for 40 tense and silent years. <b>Battlestar Galactica</b> picks up just as the Cylons commit mass genocide against humanity. Only the Battlestar Galactica (an old warship about to be decommissioned and turned into a museum) and those souls fortunate enough to be aboard other starships were able to survive the attack. In the aftermath, the Galactica's commanding officer, William Adama, finds himself responsible for safeguarding the last remnants of the human race—fewer than 50,000 desperate survivors. Meanwhile, the annihilation of the Colonial government results in the succession of the Secretary of Education, Laura Roslin, to the presidency. Driven by prophetic visions and political necessity, the Galactica travels through uncharted space in hopes of finding the mythical, lost 13th colony—Earth.</p>",
    officialSite: "http://www.syfy.com/battlestargalactica",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-12-08",
  },
  {
    id: 167,
    url: "https://www.tvmaze.com/shows/167/24",
    name: "24",
    genres: ["Drama", "Action", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/2330.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/2330.jpg",
    },
    summary:
      "<p>Jack Bauer, agent of CTU (Counter Terrorist Unit) faces threats against his country and himself in this action packed show. Each season contains of one day, each episode shows one hour of Jack Bauer's day. <b>24</b> is the only action show in real time and gained a lot of fans during the years with this concept.</p>",
    officialSite: "http://www.fox.com/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-11-06",
  },
  {
    id: 168,
    url: "https://www.tvmaze.com/shows/168/chuck",
    name: "Chuck",
    genres: ["Drama", "Comedy", "Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/2385.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/2385.jpg",
    },
    summary:
      "<p><b>Chuck</b> Bartowski is a computer geek that gets catapulted into a new career as the government's most vital secret agent. When Chuck opens an e-mail subliminally encoded with government secrets, he unwittingly downloads an entire server of sensitive data into his brain. With the government's most precious secrets in Chuck's head, Major John Casey of the National Security Agency assumes the responsibility of protecting him. His partner is the CIA's top agent, Sarah Walker.</p>",
    officialSite: "http://www.nbc.com/chuck",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-09-24",
  },
  {
    id: 169,
    url: "https://www.tvmaze.com/shows/169/breaking-bad",
    name: "Breaking Bad",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/2400.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/2400.jpg",
    },
    summary:
      "<p><b>Breaking Bad</b> follows protagonist Walter White, a chemistry teacher who lives in New Mexico with his wife and teenage son who has cerebral palsy. White is diagnosed with Stage III cancer and given a prognosis of two years left to live. With a new sense of fearlessness based on his medical prognosis, and a desire to secure his family's financial security, White chooses to enter a dangerous world of drugs and crime and ascends to power in this world. The series explores how a fatal diagnosis such as White's releases a typical man from the daily concerns and constraints of normal society and follows his transformation from mild family man to a kingpin of the drug trade.</p>",
    officialSite: "http://www.amc.com/shows/breaking-bad",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 20,
      name: "AMC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-01-20",
  },
  {
    id: 170,
    url: "https://www.tvmaze.com/shows/170/orange-is-the-new-black",
    name: "Orange Is the New Black",
    genres: ["Drama", "Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/203/508250.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/203/508250.jpg",
    },
    summary:
      "<p><b>Orange Is the New Black</b> is the story of Piper Chapman, a woman in her thirties who is sentenced to fifteen months in prison after being convicted of a decade-old crime of transporting money for her drug-dealing girlfriend.</p>",
    officialSite: "https://www.netflix.com/title/70242311",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2013-07-11",
  },
  {
    id: 171,
    url: "https://www.tvmaze.com/shows/171/how-i-met-your-mother",
    name: "How I Met Your Mother",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/2451.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/2451.jpg",
    },
    summary:
      "<p><b>How I Met Your Mother</b> is a comedy about Ted and how he fell in love. It all starts when Ted's best friend, Marshall drops the bombshell that he's going to propose to his long-time girlfriend, Lilya kindergarten teacher. At that moment, Ted realizes that he had better get a move on if he too hopes to find true love. Helping him in his quest is Barney a friend with endless, sometimes outrageous opinions, a penchant for suits and a foolproof way to meet women. When Ted meets Robin he's sure it's love at first sight, but destiny may have something else in store.</p>",
    officialSite: "http://www.cbs.com/shows/how_i_met_your_mother",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-09-19",
  },
  {
    id: 172,
    url: "https://www.tvmaze.com/shows/172/suits",
    name: "Suits",
    genres: ["Drama", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/205/513582.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/205/513582.jpg",
    },
    summary:
      "<p><b>Suits</b> delves into the fast-paced, high-stakes world of a top Manhattan corporate law firm where hotshot associate Harvey Specter makes a risky move by hiring Mike Ross a brilliant but unmotivated college dropout, as his associate. As he becomes enmeshed in this unfamiliar world, Mike relies heavily on the firm's best paralegal Rachel Zane and Harvey's no-nonsense assistant Donna Paulsen to help him serve justice. With a photographic memory and the street smarts of a hustler, Mike proves to be a legal prodigy despite the absence of bonafide legal credentials.</p>",
    officialSite: "http://www.usanetwork.com/suits",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-06-23",
  },
  {
    id: 174,
    url: "https://www.tvmaze.com/shows/174/parks-and-recreation",
    name: "Parks and Recreation",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/0/2439.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/0/2439.jpg",
    },
    summary:
      "<p><b>Parks and Recreation</b> is a comedy series based around the main character Leslie Knope (a bureaucrat) in the parks department of Pawnee.</p>",
    officialSite: "http://www.nbc.com/parks-and-recreation",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-04-09",
  },
  {
    id: 175,
    url: "https://www.tvmaze.com/shows/175/house-of-cards",
    name: "House of Cards",
    genres: ["Drama", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/169/424482.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/169/424482.jpg",
    },
    summary:
      "<p>Based on the BBC miniseries of the same name, <b>House of Cards</b> follows Francis Underwood, the politician's politician – masterful, beguiling, charismatic and ruthless. He and his equally ambitious wife Claire will stop at nothing to ensure their ascendancy. This wicked political drama slithers beneath the curtain and through the back halls of greed, sex, love and corruption in modern Washington D.C.</p>",
    officialSite: "https://www.netflix.com/title/70178217",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2013-02-01",
  },
  {
    id: 176,
    url: "https://www.tvmaze.com/shows/176/teen-wolf",
    name: "Teen Wolf",
    genres: ["Drama", "Romance", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/30/75365.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/30/75365.jpg",
    },
    summary:
      "<p>Always an outsider and often unnoticed, Scott McCall yearns to be recognized in some small way that takes him out of his typical state of high school anonymity. When his best friend, Stiles, convinces him to go into the woods one night to join a police search for a dead body, Scott encounters a creature in the darkness. Narrowly escaping an attack with a vicious bite in his side, the next day brings strange surprises for Scott at school and his life will never be the same.</p><p>MTV's reboot of the classic 1980s cult movie <b>Teen Wolf</b>.</p>",
    officialSite: "http://www.mtv.com/shows/teen-wolf",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-06-05",
  },
  {
    id: 177,
    url: "https://www.tvmaze.com/shows/177/pretty-little-liars",
    name: "Pretty Little Liars",
    genres: ["Romance", "Thriller", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/125/314775.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/125/314775.jpg",
    },
    summary:
      '<p>Rosewood is a perfect little town. So quiet and pristine, you\'d never guess it holds so many secrets. Some of the ugliest ones belong to the prettiest girls in town: Aria, Spencer, Hanna and Emily, four friends whose darkest secrets have been unraveling since Alison, the Queen Bee of their group disappeared. As the mystery surrounding Ali\'s disappearance resurfaces, the girls begin getting messages from a mysterious "A," who they quickly realize is out to get them. Now, after years of tormenting and numerous shocking revelations, the Liars are united and ready to kick some "A" and uncover the truth! No longer just wanting to sit by and wait for "A\'s" latest cruel attack, Aria, Emily, Hanna and Spencer take matters into their own hands and try to finally put a stop to their tormentor. As relationships are put to the test, new and old secrets are revealed and the stakes are raised higher than ever before as the Liars come closer to the truth. Will all of their sacrifices be worth it in the end?</p>',
    officialSite: "http://freeform.go.com/shows/pretty-little-liars",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-06-08",
  },
  {
    id: 178,
    url: "https://www.tvmaze.com/shows/178/the-legend-of-korra",
    name: "The Legend of Korra",
    genres: ["Action", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/260/650489.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/260/650489.jpg",
    },
    summary:
      "<p>Avatar Korra fights to keep Republic City safe from the evil forces of both the physical and spiritual worlds.</p>",
    officialSite: "http://www.nick.com/legend-of-korra/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-04-14",
  },
  {
    id: 179,
    url: "https://www.tvmaze.com/shows/179/the-wire",
    name: "The Wire",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/2527.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/2527.jpg",
    },
    summary:
      "<p>The first season of <b>The Wire</b> (2002) concentrated on the often-futile efforts of police to infiltrate a West Baltimore drug ring headed by Avon Barksdale and his lieutenant, Stringer Bell. In Seasons Two and Three, as the Barksdale investigation escalated, new storylines involving pressures on the working class and the city's political leadership were introduced. Season Four focused on the stories of several young boys in the public school system, struggling with problems at home and the lure of the corner - set against the rise of a new drug empire in West Baltimore and a new Mayor in City Hall. The fifth and final season of <i>The Wire</i> centers on the media's role in addressing - or failing to address - the fundamental political, economic and social realities depicted over the course of the series, while also resolving storylines of the numerous characters woven throughout the narrative arc of the show.</p>",
    officialSite: "http://www.hbo.com/the-wire",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-06-02",
  },
  {
    id: 180,
    url: "https://www.tvmaze.com/shows/180/firefly",
    name: "Firefly",
    genres: ["Drama", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/2600.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/2600.jpg",
    },
    summary:
      "<p>Five hundred years in the future, a renegade crew aboard a small spacecraft tries to survive as they travel the unknown parts of the galaxy and evade warring factions as well as authority agents out to get them.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-09-20",
  },
  {
    id: 181,
    url: "https://www.tvmaze.com/shows/181/extant",
    name: "Extant",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/54/136509.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/54/136509.jpg",
    },
    summary:
      "<p>Molly Woods is an astronaut who returns home from a year-long solo mission in space and tries to reconnect with her husband and son in their everyday life. Her experiences in space and home lead to events that ultimately will change the course of human history.</p>",
    officialSite: "http://www.cbs.com/shows/extant/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-09",
  },
  {
    id: 182,
    url: "https://www.tvmaze.com/shows/182/black-sails",
    name: "Black Sails",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/78/195951.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/78/195951.jpg",
    },
    summary:
      "<p>1715. The Golden Age of Piracy. New Providence Island is a lawless territory, controlled by history's most notorious pirate captains. The most feared is Captain Flint.</p><p>As the British Navy returns to redeem their land and exterminate Flint and his crew, another side of him emerges. Captain Flint aligns himself with Eleanor Guthrie, daughter of the local kingpin, to hunt the ultimate prize and ensure their survival.</p><p>Many opponents stand in their way: rival captains, jealous of Flint's power; Eleanor's ambitious and intrusive father; and a young sailor recently recruited onto Flint's crew, John Silver, who constantly undermines his captain's agenda.</p>",
    officialSite: "http://www.starz.com/originals/blacksails",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 17,
      name: "Starz",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-25",
  },
  {
    id: 183,
    url: "https://www.tvmaze.com/shows/183/tyrant",
    name: "Tyrant",
    genres: ["Drama", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/2649.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/2649.jpg",
    },
    summary:
      "<p><b>Tyrant</b> is a drama that follows a typical American family whose members find themselves embroiled in the geopolitical intrigue of a volatile Middle Eastern country. Barry Al-Fayeed is a California pediatrician who also happens to be the second son of a Middle Eastern dictator. Barry reluctantly agrees to return home with his American family for his nephew's wedding. Events thrust him into the complex and turbulent growing pains of a nation straining to break free from dictatorial rule.</p>",
    officialSite: "http://www.fxnetworks.com/tyrant",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-06-24",
  },
  {
    id: 184,
    url: "https://www.tvmaze.com/shows/184/bojack-horseman",
    name: "BoJack Horseman",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/236/590384.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/236/590384.jpg",
    },
    summary:
      "<p>Meet the most beloved sitcom horse of the '90s, 20 years later. He's a curmudgeon with a heart of... not quite gold... but something like gold. Copper?</p>",
    officialSite: "https://www.netflix.com/title/70300800",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2014-08-22",
  },
  {
    id: 185,
    url: "https://www.tvmaze.com/shows/185/salem",
    name: "Salem",
    genres: ["Drama", "Thriller", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/73/184895.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/73/184895.jpg",
    },
    summary:
      '<p>Set in 17th century colonial Massachusetts—a significant time in the history of American politics, religion and society— <b>Salem</b> brings you the real story behind the infamous witch trials. In Salem, witches are real, and they\'re behind it all. Salem Village and Salem Town feuded over property, grazing rights and church rights. The government was dominated by Puritan leaders. People were scrutinized closely and this resulted in obvious discord. They were afraid of being persecuted for anything that may offend the Puritan mindset. The word "witch" seemed an easy and appropriate curse hurled at someone who behaved abnormally.</p>',
    officialSite: "http://www.wgnamerica.com/series/salem",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 28,
      name: "WGN America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-04-20",
  },
  {
    id: 186,
    url: "https://www.tvmaze.com/shows/186/turn-washingtons-spies",
    name: "Turn: Washington's Spies",
    genres: ["Drama", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/57/143037.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/57/143037.jpg",
    },
    summary:
      "<p><b>Turn: Washington's Spies</b> takes viewers into the stirring and treacherous world of the Revolutionary War and introduces Abraham Woodhull who, after aligning with a group of childhood friends, forms the Culper Ring--America's first spy ring.</p>",
    officialSite: "http://www.amc.com/shows/turn",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 20,
      name: "AMC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-04-06",
  },
  {
    id: 187,
    url: "https://www.tvmaze.com/shows/187/intelligence",
    name: "Intelligence",
    genres: ["Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/2715.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/2715.jpg",
    },
    summary:
      "<p><b>Intelligence</b> is a dramatic thriller about a high-tech intelligence operative enhanced with a super-computer microchip in his brain. With this implant, Gabriel Vaughn is the first human ever to be connected directly into the worldwide information grid and have complete access to Internet, WiFi, telephone and satellite data. He can hack into any data center and access key Intel in the fight to protect the United States from its enemies. Leading the elite government cyber-security agency created to support him is Director Lillian Strand, a straightforward and efficient boss who oversees the unit's missions. Strand assigns Riley Neal, a Secret Service agent, to protect Gabriel from outside threats, as well as from his appetite for reckless, unpredictable behavior and disregard for protocol. Other skilled members of the Cybercom team include Chris Jameson and Gonzalo \"Gonzo\" Rodriguez two resourceful federal investigators. The brains behind the design of the chip is Dr. Shenendoah Cassidy, whose son, Nelson is jealous of Gabriel's prominent place in his father's life. As the first supercomputer with a beating heart, Gabriel is the most valuable piece of technology the country has ever created and is the U.S.'s secret weapon.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-07",
  },
  {
    id: 188,
    url: "https://www.tvmaze.com/shows/188/believe",
    name: "Believe",
    genres: ["Drama", "Action", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/51/127824.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/51/127824.jpg",
    },
    summary:
      '<p>Levitation, telekinesis, the ability to control nature and even predict the future... Since she was 2 years old, Bo has had gifts she could neither fully understand, nor control. Raised by a small group known as the "True Believers," the orphaned girl has been safeguarded from harmful outsiders who would use her forces for personal gain. But now that she is 10, her powers have become stronger and the threat has grown more dangerous. With her life and future now in jeopardy, the "Believers" turn to the only person they see fit to be her full-time protector. That is, once they break him out of jail. Tate, a wrongfully imprisoned death row inmate who\'s lost his will, is initially reluctant until he witnesses one of her extraordinary abilities. Bo sees people for who they truly are... and who they may become. Tate and Bo begin their journey, one in which trust must be earned. Traveling from city to city, every place they stop and everyone they meet will be changed forever. But they\'ll have to keep going to stay one step ahead of the sinister forces after Bo\'s power... because it will take a miracle to keep them safe forever.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-03-10",
  },
  {
    id: 189,
    url: "https://www.tvmaze.com/shows/189/star-crossed",
    name: "Star-Crossed",
    genres: ["Drama", "Romance", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/2776.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/2776.jpg",
    },
    summary:
      "<p>When Emery was 6 years old, an alien spacecraft crash-landed in her small town. Whether they came in peace or with more sinister intentions didn't matter: a fierce battle erupted as humans fought for control over their new rivals, an alien species called the Atrians. In the midst of the conflict, Roman, a 6-year-old Atrian boy, found his way to a shed behind Emery's house, where she protected him from harm, bringing him food, comfort - and friendship. In their brief time together, Emery and Roman forged a deep bond, but the authorities wasted no time tracking Roman down and capturing him in a violent confrontation. Emery has grown up believing that Roman was killed that day. Ten years later, the Atrians have been acclimated to life on Earth, but they are interned in a heavily-guarded camp known as the Sector to keep them separate from humans. Now, for the first time, a group of Atrian teens will enroll in a suburban human high school, with the goal of testing the feasibility of human/alien integration. The eyes of the nation and the whole world are fixed on this historical social experiment, an endeavor fraught with suspicion and fear. In the mayhem of the first day, Emery is amazed to learn that Roman was not killed by the authorities and is, in fact, one of the Atrian students. Their childhood bond is quickly rekindled - in a school and a society that distrusts everything about the Atrians, Emery and Roman have found each other again. However, their relationship is threatened by the small-mindedness of their respective communities and the political agendas of people in power. While the world around them rages with anger and prejudice, their bond becomes increasingly strong and increasingly dangerous. As an epic Romeo and Juliet romance unfolds, a violent encounter between Roman's father and Emery's father occurs in the Sector. Can Roman and Emery's love - and peace between the species - survive?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-02-17",
  },
  {
    id: 190,
    url: "https://www.tvmaze.com/shows/190/crisis",
    name: "Crisis",
    genres: ["Drama", "Action", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/2786.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/2786.jpg",
    },
    summary:
      "<p>It's field trip day for the students of Ballard High School, a place that educates the children of Washington, D.C.'s elite, top-of-their-industry CEOs, international diplomats, political power players and even the president's son. But when their bus is ambushed on a secluded rural road, the teenagers and their chaperones are taken, igniting a national crisis. Now with some of the country's most powerful parents at the mercy of one vengeful mastermind, the question arises: How far would you go and what would you become to ensure your child's safe return? With so many parents and dignitaries put into play with nowhere to turn and no one to trust, this unthinkable scenario grows from the select families at risk to an entire nation at stake.</p>",
    officialSite: "http://www.nbc.com/crisis/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-03-16",
  },
  {
    id: 191,
    url: "https://www.tvmaze.com/shows/191/halt-and-catch-fire",
    name: "Halt and Catch Fire",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/2798.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/2798.jpg",
    },
    summary:
      "<p><b>Halt and Catch Fire</b> is set roughly one year after IBM all but corners the market with the release of its first major product – the IBM PC. In this fictional drama, a former IBM executive, Joe MacMillan plans to reverse engineer the flagship product of his former employer and forces his current company, Cardiff Electric, into the personal computer race. MacMillan enlists the help of Gordon Clark, a great engineer whose unrealized dreams of creating a revolutionary product have created tension in his marriage to Donna, and Cameron Howe, a volatile prodigy who puts her future in jeopardy to join MacMillan's rogue PC project. Halt and Catch Fire thrives on the spirit of innovation and explores what it's like to stand at the forefront of something world-changing and work towards it, no matter the risk.</p>",
    officialSite: "http://www.amc.com/shows/halt-and-catch-fire",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 20,
      name: "AMC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-06-01",
  },
  {
    id: 192,
    url: "https://www.tvmaze.com/shows/192/hello-ladies",
    name: "Hello Ladies",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/2826.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/2826.jpg",
    },
    summary:
      "<p>Stewart is a gawky, 6' 7\" Englishman searching for the woman of his dreams in Los Angeles. Half as charming - and twice as desperate - as he thinks he is, he's obsessed with infiltrating the glamorous world of beautiful people, who won't let him in.</p>",
    officialSite: "http://www.hbo.com/hello-ladies",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-29",
  },
  {
    id: 193,
    url: "https://www.tvmaze.com/shows/193/dads",
    name: "Dads",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/2831.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/2831.jpg",
    },
    summary:
      "<p>Honor thy father. Way easier said than done. Especially when your dad's broke, living in your house and ruining your life. <b>Dads</b> explores the often treacherous terrain of the father-son landscape. This series follows two successful guys - and childhood best friends - now in their mid-30s whose relatively stable lives get turned upside down when their pain-in-the-neck patriarchs move in.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-17",
  },
  {
    id: 194,
    url: "https://www.tvmaze.com/shows/194/hannibal",
    name: "Hannibal",
    genres: ["Drama", "Crime", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/160/401855.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/160/401855.jpg",
    },
    summary:
      "<p>Criminal profiler Will Graham is tasked by FBI agent Jack Crawford, the head of Behavioral Sciences, to help investigate the disappearances of eight young girls across Minnesota. Graham and Crawford's team investigate several subsequent murders, while also trying to catch the Chesapeake Ripper. With the investigation weighing heavily on Graham, Crawford decides to have him supervised by psychiatrist Dr. Hannibal Lecter, who, unbeknownst to them, is the Chesapeake Ripper himself, actively seeking to derail the investigation.</p>",
    officialSite: "http://www.nbc.com/hannibal",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-04-04",
  },
  {
    id: 195,
    url: "https://www.tvmaze.com/shows/195/bates-motel",
    name: "Bates Motel",
    genres: ["Drama", "Horror", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/177/444429.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/177/444429.jpg",
    },
    summary:
      "<p><b>Bates Motel</b> is a contemporary prequel to the genre-defining film Psycho, and gives viewers an intimate portrayal of how Norman Bates' psyche unravels through his teenage years.</p><p>Following the tragic death of her husband, Norma Bates buys a motel on the outskirts of the idyllic coastal town of White Pine Bay, seeking a fresh start. As Norma and Norman get ensconced in their new home, they discover this town isn't quite what it seems, and the locals aren't so quick to let them in on their secrets. But the Bates' are done being pushed around and will do whatever it takes to survive - and will do whatever it takes to protect their own secrets.</p>",
    officialSite: "http://www.aetv.com/shows/bates-motel",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-03-18",
  },
  {
    id: 196,
    url: "https://www.tvmaze.com/shows/196/the-following",
    name: "The Following",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/2868.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/2868.jpg",
    },
    summary:
      "<p>The FBI estimates there are currently over 300 active serial killers in the United States. What would happen if these killers had a way of communicating and connecting with each other? What if they were able to work together and form alliances across the country? What if one brilliant psychotic serial killer was able to bring them all together and activate a following? Welcome to <b>The Following</b>, a terrifying new thriller.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-01-21",
  },
  {
    id: 197,
    url: "https://www.tvmaze.com/shows/197/da-vincis-demons",
    name: "Da Vinci's Demons",
    genres: ["Drama", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/2892.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/2892.jpg",
    },
    summary:
      "<p>In a world where thought and faith are controlled, one man fights to set knowledge free. Leonardo da Vinci is tortured by a gift of superhuman genius. He finds himself in a conflict between truth and lies, religion and reason, past and future. His aspirations are used against him by opposing forces – luring him into a game of seduction where those who despise his intellect need him most.</p><p>His quest for knowledge nearly becomes his undoing, but da Vinci's genius prevails and he emerges as an unstoppable force that lifts an entire era out of darkness and propels it into light. His story becomes a mirror into our own world, calling us all to join his fight to free the future.</p>",
    officialSite: "http://www.starz.com/originals/davincisdemons/featured",
    webChannel: { id: 46, name: "Starz Play", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2013-04-12",
  },
  {
    id: 198,
    url: "https://www.tvmaze.com/shows/198/the-fosters",
    name: "The Fosters",
    genres: ["Drama", "Family", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/116/292055.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/116/292055.jpg",
    },
    summary:
      "<p><b>The Fosters</b> is a critically-acclaimed series that centers on biracial lesbian couple Stef and Lena Foster, who are raising a multi-ethnic family mix of foster and biological kids. The second season will continue to explore the growing Fosters clan, with all the triumphs and travails, twists and turns, that fans of the series have come to expect. Callie and Jude will try to adjust to their new roles in the family, and everyone will deal with the fallout from their previous actions. Past mistakes will come home to roost, consequences will be handed out, and victories will be hard fought, and ultimately well-won. Their deep bonds will grow, enabling America's most modern family to face the future head on, with love in their hearts.</p>",
    officialSite: "http://freeform.go.com/shows/the-fosters",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-06-03",
  },
  {
    id: 199,
    url: "https://www.tvmaze.com/shows/199/mistresses",
    name: "Mistresses",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/2950.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/2950.jpg",
    },
    summary:
      "<p>Based on the hit UK television series of the same name, <b>Mistresses</b> is a provocative and thrilling drama about the scandalous lives of a sexy and sassy group of four girlfriends, each on her own path to self-discovery. These four friends find support and guidance with each other as they brave their turbulent journeys and life's storms of excitement, secrecy and betrayal, all the while bound by the complex relationships they've created.</p>",
    officialSite: "http://abc.go.com/shows/mistresses",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-06-03",
  },
  {
    id: 200,
    url: "https://www.tvmaze.com/shows/200/the-tomorrow-people",
    name: "The Tomorrow People",
    genres: ["Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/55/138044.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/55/138044.jpg",
    },
    summary:
      "<p>They are the next evolutionary leap of mankind, a generation of humans born with paranormal abilities - <b>The Tomorrow People</b>. Stephen Jameson stands at the crossroads between the world we know and the shifting world of the future. Up until a year ago, Stephen was a \"normal\" teenager - until he began hearing voices and teleporting in his sleep, never knowing where he might wake up. Now, Stephen's issues have gone far beyond the usual teenage angst, and he is beginning to question his sanity. In desperation, Stephen decides to listen to one of the voices in his head, and it leads him to his first encounter with the Tomorrow People - John, Cara and Russell - a genetically advanced race with the abilities of telekinesis, teleportation and telepathic communication. The Tomorrow People are being hunted down by a paramilitary group of scientists known as Ultra. Led by Dr. Jedikiah Price, Ultra sees the Tomorrow People as a very real existential threat from a rival species, and the outcast group has been forced to hide out in an abandoned subway station just beneath the surface of the human world. Trading in secrets, Jedikiah offers Stephen the chance for a normal life with his family and best friend, Astrid, if he will help in the struggle to isolate and eradicate the Tomorrow People. On the other hand, Cara, John and Russell offer Stephen a different type of family and a home where he truly belongs. Unwilling to turn his back on humanity or the world of the Tomorrow People, Stephen sets out on his own path - a journey that could take him into the shadowy past to uncover the truth about his father's mysterious disappearance, or into an unknown future with The Tomorrow People.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-10-09",
  },
  {
    id: 201,
    url: "https://www.tvmaze.com/shows/201/devious-maids",
    name: "Devious Maids",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3005.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3005.jpg",
    },
    summary:
      "<p><b>Devious Maids</b> is set in a world where murder and mayhem collide in the mansions of Beverly Hills' wealthiest and most powerful families. Class warfare has never been as fun and dirty as it is in the tiny enclave where the staff is as clever, witty and downright devilish as their employers. The series centers on a close-knit group of maids, Marisol, Rosie, Carmen Valentina and Zoila, who are bonded together by their jobs, life struggles and the melodramatic universe that engulfs their employers.</p>",
    officialSite: "http://www.mylifetime.com/shows/devious-maids",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-06-23",
  },
  {
    id: 202,
    url: "https://www.tvmaze.com/shows/202/almost-human",
    name: "Almost Human",
    genres: ["Drama", "Crime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3020.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3020.jpg",
    },
    summary:
      '<p><b>Almost Human</b> is an action-packed police drama set 35 years in the future, when police officers are partnered with highly evolved human-like androids. The year is 2048. Meet John Kennex a cop who survived one of the most catastrophic attacks ever made against the police department. After waking up from a 17-month coma, he can\'t remember much - except that his partner was killed; his girlfriend, Anna Moore, left him after the attack; and he lost one of his legs and is now outfitted with a highly sophisticated synthetic appendage. Suffering from depression, mental atrophy, trauma-onset OCD, PTSD and the "psychological rejection of his synthetic body part," John returns to work at the behest of longtime ally Captain Sandra Maldonado. By mandate, every cop must partner with a robot. And despite his passionate aversion to androids, John is paired up with a battle-ready MX-43. But he abruptly terminates his partnership after the robot discovers incriminating information about him. So technician Rudy Lom introduces John to Dorian, a discontinued android with unexpected emotional responses. Although such responses were deemed flaws, it is in these "flaws" that John relates to Dorian most. After all, John is part-machine now, and Dorian is part-human. John and Dorian\'s understanding of each other not only complements them, it connects them. As he adjusts to working with his new partner, John also must learn to get along with his new colleagues, including the eager and somewhat starstruck Detective Valerie Stahl and the distrustful Detective Richard Paul, who does not welcome John back with open arms. Almost Human will follow the week-to-week missions of John and Dorian, as they fight crime across this futuristic landscape, while the mysteries surrounding his attack and the larger mythology of this new world unfold.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-11-17",
  },
  {
    id: 203,
    url: "https://www.tvmaze.com/shows/203/the-carrie-diaries",
    name: "The Carrie Diaries",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3037.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3037.jpg",
    },
    summary:
      "<p>It's the summer of 1985, and, for the first time, 17-year-old Carrie Bradshaw can call Manhattan home. After her boyfriend Sebastian and best friend Maggie betrayed her, Carrie is happy to accept the offer to spend the summer living in the downtown loft apartment of her Interview magazine boss Larissa But as summer turns to fall and Carrie heads into her senior year, she and her friends and family discover that letting go of old loves and embracing new dreams comes with some tough new realities but also incredible new opportunities.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-01-14",
  },
  {
    id: 204,
    url: "https://www.tvmaze.com/shows/204/stargate-sg-1",
    name: "Stargate SG-1",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3027.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3027.jpg",
    },
    summary:
      "<p><b>Stargate SG-1</b> is a science fiction series based on the original film <i>Stargate</i>. It involves the team SG-1 going on various adventures to different alien worlds through Stargates. Throughout the series they encounter various alien threats and allies including but not limited to the Goa'uld and the Asgard.</p>",
    officialSite: "http://stargate.mgm.com/view/series/1/index.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1997-07-27",
  },
  {
    id: 205,
    url: "https://www.tvmaze.com/shows/205/graceland",
    name: "Graceland",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/54/137054.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/54/137054.jpg",
    },
    summary:
      "<p>Every year, the top graduates from the FBI Academy move from their classrooms at Quantico to their first assignments in the real world. For Agent Mike Warren, the dream has always been a post in Washington D.C. But the powers that be have other plans, and the young rookie is soon packing his bags for Graceland, a palatial beachfront mansion in Southern California that has become a cross-departmental boarding house for top undercover agents in the FBI, DEA and ICE.</p>",
    officialSite: "http://www.usanetwork.com/graceland",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-06-06",
  },
  {
    id: 206,
    url: "https://www.tvmaze.com/shows/206/stargate-atlantis",
    name: "Stargate Atlantis",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3059.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3059.jpg",
    },
    summary:
      "<p>Atlantis, built thousands of years ago by the highly evolved Ancients, is home base for an elite expedition from Earth. These courageous military commanders and scientists leap through the city's Stargate to explore the wondrous Pegasus galaxy and battle the treacherous Wraith, who seek control of Atlantis -- at any cost.</p>",
    officialSite: "http://stargate.mgm.com/view/series/2/index.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-07-16",
  },
  {
    id: 207,
    url: "https://www.tvmaze.com/shows/207/stargate-universe",
    name: "Stargate Universe",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/81/204195.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/81/204195.jpg",
    },
    summary:
      "<p><b>Stargate Universe</b> follows a band of soldiers, scientists and civilians, who must fend for themselves as they are forced through a Stargate when their hidden base comes under attack. The desperate survivors emerge aboard an ancient ship, which is locked on an unknown course and unable to return to Earth. Faced with meeting the most basic needs of food, water and air, the group must unlock the secrets of the ship's Stargate to survive. The danger, adventure and hope they find on board the Destiny will reveal the heroes and villains among them.</p>",
    officialSite: "http://stargate.mgm.com/view/series/3/index.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-10-02",
  },
  {
    id: 208,
    url: "https://www.tvmaze.com/shows/208/the-chair",
    name: "The Chair",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3167.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3167.jpg",
    },
    summary:
      "<p><b>The Chair</b> is a competition documentary series that follows two directors through the process of bringing their first feature to the screen. The up-and-coming directors, who have unique backgrounds and skill sets, will be provided with an identical screenplay which they must craft as their own film. <i>The Chair</i> will document the creation, marketing and theatrical release of both adaptations, which will also air on STARZ. Both directors will be given the same budget, and both versions will use locations in the same city. Through multiplatform voting, the audience will determine which director will be awarded $250,000.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 17,
      name: "Starz",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-06",
  },
  {
    id: 209,
    url: "https://www.tvmaze.com/shows/209/survivors-remorse",
    name: "Survivor's Remorse",
    genres: ["Drama", "Comedy", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3168.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3168.jpg",
    },
    summary:
      "<p><b>Survivor's Remorse</b> follows Cam Calloway, a basketball phenom in his early 20's who is suddenly thrust into the limelight after signing a multi-million dollar contract with a professional basketball team in Atlanta. Cam, along with his cousin, and confidant Reggie Vaughn, move to Georgia to start Cam's journey to success. The two confront the challenges of carrying opportunistic family members and their strong ties to the impoverished community that they come from. Cam, Reggie, and an unforgettable group of characters wrestle with the rewards and pitfalls of stardom, love, and loyalty.</p>",
    officialSite: "http://www.starz.com/originals/survivorsremorse/featured",
    webChannel: { id: 46, name: "Starz Play", country: null },
    language: "English",
    status: "Ended",
    network: {
      id: 17,
      name: "Starz",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-04",
  },
  {
    id: 210,
    url: "https://www.tvmaze.com/shows/210/doctor-who",
    name: "Doctor Who",
    genres: ["Drama", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/231/579166.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/231/579166.jpg",
    },
    summary:
      "<p>Adventures across time and space with the time travelling alien and companions.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006q2x0",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2005-03-26",
  },
  {
    id: 211,
    url: "https://www.tvmaze.com/shows/211/666-park-avenue",
    name: "666 Park Avenue",
    genres: ["Drama", "Mystery", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3523.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3523.jpg",
    },
    summary:
      "<p><b>666 Park Avenue</b> is a supernatural drama based around the building of the same name run by Gavin Doran. The story follows a couple and mysterious happenings as they first move in to the establishment.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-09-30",
  },
  {
    id: 212,
    url: "https://www.tvmaze.com/shows/212/alcatraz",
    name: "Alcatraz",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/120/302148.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/120/302148.jpg",
    },
    summary:
      "<p>Switching between eras, <b>Alcatraz</b> focuses on the Alcatraz prison, which was shut down in 1963 due to unsafe conditions for its prisoners and guards. The show's premise is that both the prisoners and the guards disappeared in 1963 and have abruptly reappeared in modern-day San Francisco, where they are being tracked down by a government agency.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-01-16",
  },
  {
    id: 213,
    url: "https://www.tvmaze.com/shows/213/the-gates",
    name: "The Gates",
    genres: ["Drama", "Crime", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/161/404453.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/161/404453.jpg",
    },
    summary:
      "<p>Nick Monohan and his family move from Chicago to a quiet, upscale planned community called <b>The Gates</b>, where he will be chief of police. They soon realize that their neighbors are not who they seem to be. The Gates is filled with such beings as vampires, witches, werewolves, and a succubus.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-06-20",
  },
  {
    id: 214,
    url: "https://www.tvmaze.com/shows/214/kingdom",
    name: "Kingdom",
    genres: ["Drama", "Family", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/116/291395.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/116/291395.jpg",
    },
    summary:
      "<p><b>Kingdom</b> is a raw family drama set against the world of Mixed Martial Arts (MMA) in Venice, California. Alvey Kulina owns Navy St. MMA with the help of his girlfriend Lisa Prince. He is willing to go through extraordinary means to make sure his fighters are taken care of, but all of this responsibility comes at a steep price. He has complicated relationships with both of his sons, Jay and Nate, who are both struggling with their own identities and places within Alvey's life and gym.</p>",
    officialSite: "http://kingdom.directv.com/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 31,
      name: "Audience Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-08",
  },
  {
    id: 215,
    url: "https://www.tvmaze.com/shows/215/american-dad",
    name: "American Dad!",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/317/792710.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/317/792710.jpg",
    },
    summary:
      "<p>In <b>American Dad!</b>, Stan Smith leads the all-American family in this animated sitcom filled with wild and crazy extremes. Everyday life is taken to the limit as Stan applies the same drastic measures used in his job at the CIA to his home life. Driven by machismo and the American dream, he often is blind to how horribly he fails at his attempts. This father might not know best, but he never stops trying.</p>",
    officialSite: "http://www.tbs.com/shows/american-dad.html",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 32,
      name: "TBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-02-06",
  },
  {
    id: 216,
    url: "https://www.tvmaze.com/shows/216/rick-and-morty",
    name: "Rick and Morty",
    genres: ["Comedy", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3603.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3603.jpg",
    },
    summary:
      "<p>Rick is a mentally gifted, but sociopathic and alcoholic scientist and a grandfather to Morty; an awkward, impressionable, and somewhat spineless teenage boy. Rick moves into the family home of Morty, where he immediately becomes a bad influence.</p>",
    officialSite: "http://www.adultswim.com/videos/rick-and-morty",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-12-02",
  },
  {
    id: 217,
    url: "https://www.tvmaze.com/shows/217/hostages",
    name: "Hostages",
    genres: ["Drama", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3617.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3617.jpg",
    },
    summary:
      "<p><b>Hostages</b> concerns the family of a doctor that is taken hostage by a group led by a rogue FBI agent. This occurs the night before surgery is due to be performed on the President.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-23",
  },
  {
    id: 218,
    url: "https://www.tvmaze.com/shows/218/being-human",
    name: "Being Human",
    genres: ["Drama", "Horror", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3627.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3627.jpg",
    },
    summary:
      "<p><b>Being Human</b> is a series based on the UK series of the same name. It is a supernatural orientated around a vampire, ghost and werewolf trying to live under the same household.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-01-17",
  },
  {
    id: 219,
    url: "https://www.tvmaze.com/shows/219/alphas",
    name: "Alphas",
    genres: ["Drama", "Science-Fiction", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3632.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3632.jpg",
    },
    summary:
      "<p><b>Alphas</b> is a science fiction drama focusing on a team that investigates people with supernatural abilities.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-07-11",
  },
  {
    id: 220,
    url: "https://www.tvmaze.com/shows/220/crossing-lines",
    name: "Crossing Lines",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/231/577869.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/231/577869.jpg",
    },
    summary:
      "<p>The series taps into a fictional unit mandated by the International Criminal Court (ICC) to investigate cross-border crimes and ultimately bring global criminals to justice. <b>Crossing Lines</b> is set in the world's most exotic locales, where an elite team of eager cops work to solve the most notorious international crimes.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 129,
      name: "TF1",
      country: { name: "France", code: "FR", timezone: "Europe/Paris" },
    },
    premiered: "2013-06-23",
  },
  {
    id: 221,
    url: "https://www.tvmaze.com/shows/221/rectify",
    name: "Rectify",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3655.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3655.jpg",
    },
    summary:
      "<p><b>Rectify</b> is a haunting story of a man released from prison after spending nearly two decades on death row.</p>",
    officialSite: "http://www.sundance.tv/series/rectify",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 33,
      name: "Sundance TV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-04-22",
  },
  {
    id: 222,
    url: "https://www.tvmaze.com/shows/222/happyland",
    name: "Happyland",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3681.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3681.jpg",
    },
    summary:
      "<p><b>Happyland</b> is a soapy teen dramedy exploring the underbelly of one of the country's most popular theme parks, going behind the scenes to reveal the not so magical reality of the park workers. The series centers on Lucy, the cynical teenage daughter of idealistic park princess mom, Elena. Having grown up in a world of manufactured happiness, Lucy wants to get out and experience something real. When Ian, the new park owner's son, arrives and sweeps her off her feet, Lucy is left wondering if fairy tale endings do exist after all. But when a scandalous secret turns her life upside down, she learns Happyland is far from a walk in the park.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-30",
  },
  {
    id: 224,
    url: "https://www.tvmaze.com/shows/224/twisted",
    name: "Twisted",
    genres: ["Drama", "Thriller", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3692.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3692.jpg",
    },
    summary:
      "<p>A one-hour mystery full of twists and turns that follows Danny Desai, a charismatic 16-year-old with a troubled past who returns to his hometown after spending five years in juvenile detention. Immediately branded an outcast, Danny attempts to reconnect with his two childhood best friends, Jo and Lacey. But when a fellow student is found dead in her home, Danny instantly becomes the prime suspect and town spirals into a frenzy of suspicion and mystery. Jo and Lacey must decide if their childhood friend is unforgivable, or if he's really a victim being persecuted for his own twisted secrets.</p>",
    officialSite: "http://abcfamily.go.com/shows/twisted",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-03-19",
  },
  {
    id: 225,
    url: "https://www.tvmaze.com/shows/225/ravenswood",
    name: "Ravenswood",
    genres: ["Drama", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3700.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3700.jpg",
    },
    summary:
      "<p><b>Ravenswood</b> centered on a town not far from Rosewood, Pa., which has suffered under a deadly curse for generations. Five strangers find themselves connected by this fatal curse and need to dig into the town's mysterious and terrible history before it's too late for all of them.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-10-22",
  },
  {
    id: 226,
    url: "https://www.tvmaze.com/shows/226/the-crazy-ones",
    name: "The Crazy Ones",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3713.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3713.jpg",
    },
    summary:
      "<p><b>The Crazy Ones</b> is a comedy about a larger-than-life advertising genius whose unorthodox methods and unpredictable behavior would get him fired... if he weren't the boss. Simon Roberts is the head of a powerful agency, with the biggest clients and brands in the world, but even more important to him is that his daughter Sydney is by his side. As his partner, Sydney is Simon's exact opposite - focused, organized and eager to make a name for herself, but also too busy parenting her father, which she'd resent if he wasn't so brilliant at what he does. Joining them in the firm are the dashing and talented Zach art director Andrew, who's as hard-working as he is neurotic; and the beautiful and deceptively smart assistant Lauren. With his team and his daughter behind him, Simon continues to set the advertising world on fire, and it looks like they are definitely buying what these crazy ones are selling.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-26",
  },
  {
    id: 227,
    url: "https://www.tvmaze.com/shows/227/mob-city",
    name: "Mob City",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/117/293987.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/117/293987.jpg",
    },
    summary:
      "<p>The epic battle between a determined police chief and a dangerous mobster inflames 1940s Los Angeles in TNT's eagerly anticipated television event <b>Mob City</b>. This powerful drama comes to TNT from Frank Darabont, who wrote and directed the pilot and serves as executive producer on the series. Based on the critically acclaimed book L.A. Noir: The Struggle for the Soul of America's Most Seductive City, by John Buntin, Mob City opens in post-war Los Angeles, home to glamorous movie stars, powerful studio heads and returning war heroes. But it's also a city caught between a powerful and corrupt police force and an even more dangerous criminal network determined to make L.A. its West Coast base. Los Angeles Police Chief William Parker has made it his mission to free the city of criminals like Ben \"Bugsy\" Siegel and Mickey Cohen, the ruthless king of the Los Angeles underworld. Parker also won't hesitate to go after anyone from his own police force who sells out honor and duty for the sake of a big payout. To carry out his sweep of organized crime, Parker sets up a new mob task force within the LAPD. Headed by Det. Hal Morrison, the task force includes Det. Joe Teague, an ex-Marine who holds his cards close to his chest.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-12-04",
  },
  {
    id: 228,
    url: "https://www.tvmaze.com/shows/228/last-resort",
    name: "Last Resort",
    genres: ["Drama", "Action", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3741.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3741.jpg",
    },
    summary:
      "<p>500 feet beneath the ocean's surface, the U.S. ballistic missile submarine Colorado receive their orders. Over a radio channel, designed only to be used if their homeland has been wiped out, they're told to fire nuclear weapons at Pakistan. Captain Marcus Chaplin demands confirmation of the orders only to be unceremoniously relieved of duty by the White House. XO Sam Kendal finds himself suddenly in charge of the submarine and facing the same difficult decision. When he also refuses to fire without confirmation of the orders, the Colorado is targeted, fired upon, and hit. The submarine and its crew find themselves crippled on the ocean floor, declared rogue enemies of their own country. Now, with nowhere left to turn, Chaplin and Kendal take the sub on the run and bring the men and women of the Colorado to an exotic island. Here they will find refuge, romance and a chance at a new life, even as they try to clear their names and get home.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-09-27",
  },
  {
    id: 229,
    url: "https://www.tvmaze.com/shows/229/the-neighbors",
    name: "The Neighbors",
    genres: ["Comedy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3763.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3763.jpg",
    },
    summary:
      '<p><b>The Neighbors</b> revolves around a family that has relocated to a gated townhouse community in New Jersey called "Hidden Hills". Upon their arrival, they discover that the entire community is populated by residents from another planet. Amongst their myriad quirks, these aliens identify themselves by the names of sports celebrities, patrol the community in golf carts, dress alike, receive nourishment through their eyes and mind by reading books rather than eating, and cry green goo from their ears. The aliens have assumed human form, but they can revert to their natural appearance by clapping their hands above their heads. They have been stuck on Earth for 10 years, still awaiting instructions to return home.</p>',
    officialSite: "http://abc.go.com/shows/the-neighbors",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-09-26",
  },
  {
    id: 230,
    url: "https://www.tvmaze.com/shows/230/go-on",
    name: "Go On",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3773.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3773.jpg",
    },
    summary:
      "<p>Following the sudden death of his wife, sports radio personality Ryan King is forced to attend grief counseling. Feeling it unnecessary, he does so reluctantly, and with minimal participation, until it becomes clear that this may actually help him in unexpected ways.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-08-08",
  },
  {
    id: 231,
    url: "https://www.tvmaze.com/shows/231/vegas",
    name: "Vegas",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3781.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3781.jpg",
    },
    summary:
      "<p><b>Vegas</b> is a drama inspired by the true story of former Las Vegas Sheriff Ralph Lamb, a fourth-generation rancher tasked with bringing order to Las Vegas in the 1960s, a gambling and entertainment mecca emerging from the tumbleweeds. Ralph Lamb wants to be left in peace to run his ranch, but Las Vegas is now swelling with outsiders and corruption which are intruding on his simple life. Recalling Lamb's command as a military police officer during World War II, the Mayor appeals to his sense of duty to look into a murder of a casino worker - and so begins Lamb's clash with Vincent Savino, a ruthless Chicago gangster who plans to make Vegas his own. Assisting Lamb in keeping law and order are his two deputies: his diplomatic, even-keeled brother Jack and his charming but impulsive son Dixon. Ambitious Assistant District Attorney Katherine O'Connell, who grew up on the ranch next to the Lambs, also lends a hand in preserving justice. In Vegas, two powerful men - Lamb and Savino - are engaged in a fierce battle for control of the budding oasis, and for both of them, folding is not an option.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-09-25",
  },
  {
    id: 232,
    url: "https://www.tvmaze.com/shows/232/the-river",
    name: "The River",
    genres: ["Drama", "Horror", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3788.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3788.jpg",
    },
    summary:
      "<p><b>The River</b> follows the story of wildlife expert and TV personality Emmet Cole. Emmet set course around the world with his wife, Tess, and son, Lincoln, while filming what would become one of the most popular shows in television. After he goes missing deep in the Amazon, his family, friends and crew set out on a mysterious and deadly journey to find him. Famed explorer Dr. Emmet Cole went looking for magic deep in the uncharted Amazon and never returned. The shocking truth about his disappearance is out there, somewhere, just waiting to be discovered. To the millions of kids who grew up watching his nature show, Dr. Cole was a hero. To his own son, Lincoln he was more of an enigma. Now, six months after he vanished, Lincoln is finally ready to bury the past when Dr. Cole's emergency beacon suddenly goes off. At the urging of his mother, Tess Lincoln reluctantly joins her on a search for his father. To fund the rescue, they agree to let Dr. Cole's cagey ex-producer, Clark film the mission documentary-style.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-02-07",
  },
  {
    id: 233,
    url: "https://www.tvmaze.com/shows/233/awake",
    name: "Awake",
    genres: ["Drama", "Fantasy", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3799.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3799.jpg",
    },
    summary:
      "<p><b>Awake</b> is an intriguing drama about Detective Michael Britten who finds he's living two parallel lives. He's involved in a car accident that seems to have killed both his son and wife yet his mind creates an ingenious coping mechanism in which he now lives two separate lives - one where his wife survived and the other where his son did. Trying to regain some normalcy, Michael returns to solving crimes in both worlds with the help of two different partners, Detective Isaiah \"Bird\" Freeman and Detective Efrem Vega Michael is assigned a different case in each reality and quickly discovers that his dual existence is actually a powerful tool. He begins to solve impossible cases by using his two realities to gain unique perspectives and link clues that cross over from world to world. Helping Michael to navigate his two realities are his bureau-assigned therapists Dr. Evans and Dr. Lee While both therapists work to untangle his two worlds, Michael has no interest in proving either one is false. But when memories of the accident begin to haunt him, he is forced to confront the truth about what really happened the night of the crash.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-03-01",
  },
  {
    id: 234,
    url: "https://www.tvmaze.com/shows/234/missing",
    name: "Missing",
    genres: ["Drama", "Action", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3808.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3808.jpg",
    },
    summary:
      "<p>Becca Winstone learns that her son, Michael, disappears while studying abroad, and it's a race against time when she travels to Europe to track him down. A surprising turn of events reveals just how far one mother will go to protect her family. Exotic locations and thrilling twists will keep you riveted in <b>Missing</b>. How far would you go to save the only thing you have left in the world? At 8 years old, Michael watched as his father, CIA Agent Paul Winstone, was murdered. Now 10 years later, Paul's wife, Becca, is faced with the reality of her son growing up. When Michael is afforded the opportunity to study abroad, his mother reluctantly agrees it's time to let him go. Just a few weeks into his trip Michael disappears, and Becca immediately suspects foul play. When she arrives in Rome, she begins piecing together the clues left behind. It isn't long before the kidnappers realize they've picked a fight with the wrong woman. Becca Winstone has a secret of her own -- before Paul's death, she was also a lethal CIA Agent. But if she wants to find her son alive, Becca will have to rely on old friends and reopen old wounds. Her resourcefulness, skill and determination will be put to the test - but a mother's love knows no limits.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-03-15",
  },
  {
    id: 235,
    url: "https://www.tvmaze.com/shows/235/the-new-normal",
    name: "The New Normal",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3817.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3817.jpg",
    },
    summary:
      "<p>These days, families come in all forms - single dads, double moms, sperm donors, egg donors, one-night-stand donors. Bryan and David are a Los Angeles couple and they have it all. Well, almost. With successful careers and a committed, loving partnership, there is one thing that this couple is missing: a baby. Just when they think the stars will never align, enter Goldie an extraordinary young woman with a checkered past. A midwestern waitress and single mother looking to escape her dead-end life and small-minded grandmother Goldie decides to change everything and move out west with her precocious eight year-old daughter. Desperate and broke - but also fertile - Goldie quickly becomes the guys' surrogate and quite possibly the girl of their dreams. Surrogate mother, surrogate family.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-09-10",
  },
  {
    id: 236,
    url: "https://www.tvmaze.com/shows/236/gcb",
    name: "GCB",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/84/212122.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/84/212122.jpg",
    },
    summary:
      "<p>Amanda Vaughn once the ultimate high school \"mean girl\", is forced to return home in disgrace after her marriage ends in scandal. Amanda is nothing like the girl she was 20 years ago, but as her old classmates reacquaint themselves with the new Amanda, will her home town welcome her with open arms or seek revenge? No one in this town is a saint, but that doesn't mean they can't have a heart. As Amanda and her teenage kids try to adjust to their new lives, the ladies from her past alternate between sympathy and scheming.</p>",
    officialSite: "http://abc.go.com/shows/gcb",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-03-04",
  },
  {
    id: 237,
    url: "https://www.tvmaze.com/shows/237/revolution",
    name: "Revolution",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/55/138043.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/55/138043.jpg",
    },
    summary:
      "<p>What would you do without it all? In this epic adventure, a family struggles to reunite in an American landscape void of electricity: a world of empty cities, local militias and heroic freedom fighters, where every single piece of technology -- computers, planes, cars, phones, even lights -- has mysteriously blacked out forever.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-09-17",
  },
  {
    id: 238,
    url: "https://www.tvmaze.com/shows/238/dallas",
    name: "Dallas",
    genres: ["Drama", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3848.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3848.jpg",
    },
    summary:
      "<p><b>Dallas</b> follows Bobby Ewing, now the senior member of the Ewing family following the death of his older brother J.R. Ewing. Following the death of his revered father, John Ross is out to prove he can be just as powerful an ally or enemy as his infamous father. Bobby's adopted son Christopher is newly single and determined to make a name for himself and his family in the world of natural gas. Elena Ramos is the former girlfriend of both John Ross and Christopher who is now blinded by thoughts of justice for previous wrongs. Pamela Rebecca Barnes is John Ross' wife and the daughter of Cliff Barnes, a longtime rival of the Ewings. She is determined to have a happy ending with her husband and make a home on Southfork Ranch. Also featured is Bobby's wife Ann and Harris Ryland, her scheming ex-husband. Emma Ryland is Ann and Harris' daughter, who has been taught by her father and grandmother.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-06-13",
  },
  {
    id: 239,
    url: "https://www.tvmaze.com/shows/239/anger-management",
    name: "Anger Management",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/3885.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/3885.jpg",
    },
    summary:
      "<p>In <b>Anger Management</b>, Charlie is a non-traditional therapist specializing in anger management. He has a successful private practice, holding sessions with his group of primary patients each week, as well as performing pro-bono counseling for an inmate group at a state prison.</p>",
    officialSite: "http://www.fxnetworks.com/angermanagement",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-06-28",
  },
  {
    id: 240,
    url: "https://www.tvmaze.com/shows/240/cops",
    name: "Cops",
    genres: ["Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4185.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4185.jpg",
    },
    summary:
      "<p><b>COPS</b> follows police officers, constables, and sheriff's deputies during patrols and various police activities by embedding camera crews with their units. The show's formula adheres to a classic <i>cinéma vérité</i> ethos. With no narration or scripted dialog, it depends entirely on the commentary of the officers and on the actions of the people with whom they come into contact.</p>",
    officialSite: "http://www.cops.com",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 34,
      name: "Paramount Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1989-03-11",
  },
  {
    id: 241,
    url: "https://www.tvmaze.com/shows/241/benched",
    name: "Benched",
    genres: ["Comedy", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4351.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4351.jpg",
    },
    summary:
      "<p><b>Benched</b> is a single-camera comedy about a high-powered corporate lawyer's fall from grace into the rough-and-tumble world of the public defenders. From ABC Signature Studio, it stars Coupe as Nina Whitley, a distinguished corporate lawyer who has given up everything in her climb to the top. However, when she's hit with her ex-fiancé's engagement announcement and learns that she hasn't made partner at her high power firm, Nina snaps -- breaking vases and burning bridges.</p><p>Now that Nina is shunned from the corporate world, the only place she can get a job is at the Public Defender's office: home to the underfunded, understaffed, overworked, \"if you can't afford a lawyer, one will be provided... \" lawyers. In addition to her new clients, Nina must learn to connect with her co-workers, including the roguish Phil, the idealistic Carlos, the useless empathetic Cheryl and the dedicated intern Micah. If that didn't sound tough enough for Nina, she'll also be going head-to-head with her ex-fiancé, Trent, the rising star of the District Attorney's office.</p>",
    officialSite: "http://www.usanetwork.com/benched",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-28",
  },
  {
    id: 242,
    url: "https://www.tvmaze.com/shows/242/the-great-fire",
    name: "The Great Fire",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4358.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4358.jpg",
    },
    summary:
      "<p>As the great fire tears London apart, this brand new epic drama details the heart-wrenching stories of a city and its people in crisis.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-10-16",
  },
  {
    id: 243,
    url: "https://www.tvmaze.com/shows/243/conan",
    name: "Conan",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4583.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4583.jpg",
    },
    summary:
      "<p>The biggest celebrities, the hottest musical guests, the craziest sketches... and Andy Richter, to boot? Yes, some would say Conan O'Brien's talk show on TBS has everything a late night viewer could want.</p>",
    officialSite: "https://teamcoco.com",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 32,
      name: "TBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-11-08",
  },
  {
    id: 244,
    url: "https://www.tvmaze.com/shows/244/strange-empire",
    name: "Strange Empire",
    genres: ["Drama", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4585.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4585.jpg",
    },
    summary:
      "<p><b>Strange Empire</b> is a Western whose heroes are women. With most of their men gone, and those who remain battling for control, the women struggle to survive, to find their independence, and to build a life in which to thrive and raise families. As the stories of Janestown's citizens unfold we see the clash between a power-hungry father and son and the deep prejudices among races, but also the start of something akin to community in this Wild West. Western stories take civilization as a goal; they begin in blood, and end in the morality of Main Street.</p>",
    officialSite: "http://www.cbc.ca/strangeempire/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 36,
      name: "CBC",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2014-10-06",
  },
  {
    id: 245,
    url: "https://www.tvmaze.com/shows/245/town-of-the-living-dead",
    name: "Town of the Living Dead",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4590.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4590.jpg",
    },
    summary:
      "<p>In <b>Town of the Living Dead</b>, the colorful folks of Jasper, Alabama are determined, once and for all, to complete their zombie movie, Thr33 Days Dead... now six long years in the making. Based on a town urban legend, their film centers on a group of friends trying to survive a zombie apocalypse in rural Alabama. The series will follow the intrepid and motley crew of amateur filmmakers as they struggle against every obstacle imaginable to get to a final cut of their film... which could someday become a Syfy movie.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-07",
  },
  {
    id: 246,
    url: "https://www.tvmaze.com/shows/246/long-shadow",
    name: "Long Shadow",
    genres: ["War", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4591.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4591.jpg",
    },
    summary:
      "<p>David Reynolds traces the legacy of the Great War across 100 years and 10 different countries, examining how the war haunted a generation and shaped the peace that followed.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b04jqxtl",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-09-24",
  },
  {
    id: 247,
    url: "https://www.tvmaze.com/shows/247/the-colbert-report",
    name: "The Colbert Report",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/326/817399.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/326/817399.jpg",
    },
    summary:
      "<p>Feel the news along with Stephen Colbert, America's ballsiest pundit.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-10-17",
  },
  {
    id: 248,
    url: "https://www.tvmaze.com/shows/248/transporter-the-series",
    name: "Transporter: The Series",
    genres: ["Action", "Adventure", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4593.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4593.jpg",
    },
    summary:
      "<p>Frank Martin returns as the Transporter with one very simple task - to deliver the package against all the odds. However, something that sounds so simple, is rarely so.</p><p>Joined by two new team members, Caterina Boldieu, an ex- DGSE agent and later in the series, Jules Faroux, a computer and mechanical whizz, Frank is hired to deliver a diverse range of packages - from pop princesses to priceless paintings.</p><p>Frank Martin takes the jobs no other transporter will touch or can achieve - simply because they are too challenging and the odds seemingly insurmountable. That is why he is considered the best transporter in the world.</p><p>Frank's jobs take him to many beautiful locations around the world, but they also draw him into danger and mystery. And more often than not, solving that mystery will lead Frank to successfully completing his mission.</p><p>However Frank's jobs aren't solely about the packages he must deliver but also about the people he meets. While his emphasis is always on completing the mission, Frank is unable to avoid the human emotions that come with dealing with clients in difficult situations - no matter how hard he tries.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 38,
      name: "The Movie Network",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2013-01-04",
  },
  {
    id: 249,
    url: "https://www.tvmaze.com/shows/249/the-daily-show-with-jon-stewart",
    name: "The Daily Show with Jon Stewart",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/327/818871.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/327/818871.jpg",
    },
    summary:
      "<p>One anchor, several correspondents, zero credibility.</p><p>If you're tired of the stodginess of the evening newscasts and you can't bear to sit through the spinmeisters and shills on the 24-hour cable news network, don't miss <b>The Daily Show with Jon Stewart</b>, the nightly half-hour series unburdened by objectivity, journalistic integrity or even accuracy.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-01-11",
  },
  {
    id: 250,
    url: "https://www.tvmaze.com/shows/250/kirby-buckets",
    name: "Kirby Buckets",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4600.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4600.jpg",
    },
    summary:
      "<p>The single-camera series that mixes live-action and animation stars Jacob Bertrand as the title character. <b>Kirby Buckets</b> introduces viewers to the vivid imagination of charismatic 13-year-old Kirby Buckets, who dreams of becoming a famous animator like his idol, Mac MacCallister. With his two best friends, Fish and Eli, by his side, Kirby navigates his eccentric town of Forest Hills where the trio usually find themselves trying to get out of a predicament before Kirby's sister, Dawn, and her best friend, Belinda, catch them. Along the way, Kirby is joined by his animated characters, each with their own vibrant personality that only he and viewers can see.</p>",
    officialSite: "http://disneyxd.disney.com/kirby-buckets",
    webChannel: {
      id: 83,
      name: "DisneyNOW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: {
      id: 25,
      name: "Disney XD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-20",
  },
  {
    id: 251,
    url: "https://www.tvmaze.com/shows/251/downton-abbey",
    name: "Downton Abbey",
    genres: ["Drama", "Family", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4601.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4601.jpg",
    },
    summary:
      "<p>The Downton Abbey estate stands a splendid example of confidence and mettle, its family enduring for generations and its staff a well-oiled machine of propriety. But change is afoot at Downton--change far surpassing the new electric lights and telephone. A crisis of inheritance threatens to displace the resident Crawley family, in spite of the best efforts of the noble and compassionate Earl, Robert Crawley; his American heiress wife, Cora his comically implacable, opinionated mother, Violet and his beautiful, eldest daughter, Mary, intent on charting her own course. Reluctantly, the family is forced to welcome its heir apparent, the self-made and proudly modern Matthew Crawley himself none too happy about the new arrangements. As Matthew's bristly relationship with Mary begins to crackle with electricity, hope for the future of Downton's dynasty takes shape. But when petty jealousies and ambitions grow among the family and the staff, scheming and secrets--both delicious and dangerous--threaten to derail the scramble to preserve Downton Abbey. <i>Downton Abbey</i> offers a spot-on portrait of a vanishing way of life.</p>",
    officialSite: "http://www.itv.com/downtonabbey",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-09-26",
  },
  {
    id: 252,
    url: "https://www.tvmaze.com/shows/252/girl-meets-world",
    name: "Girl Meets World",
    genres: ["Drama", "Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/316/792450.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/316/792450.jpg",
    },
    summary:
      "<p><b>Girl Meets World</b> is based on ABC's hugely popular sitcom, Boy Meets World (1993). Set in New York City, the show tells the wonderfully funny heartfelt stories that Boy Meets World is renowned for - only this time from a tween girl's perspective - as the curious and bright 7th grader Riley Matthews and her quick-witted friend Maya Fox embark on an unforgettable middle school experience. But their plans for a carefree year will be adjusted slightly under the watchful eyes of Riley's parents - dad Cory, who's also a faculty member (and their new History teacher), and mom Topanga, who owns a trendy after school hangout that specializes in pudding.</p>",
    officialSite: "http://disneychannel.disney.com/girl-meets-world",
    webChannel: {
      id: 83,
      name: "DisneyNOW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: {
      id: 78,
      name: "Disney Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-06-27",
  },
  {
    id: 253,
    url: "https://www.tvmaze.com/shows/253/hells-kitchen",
    name: "Hell's Kitchen",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/324/811405.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/324/811405.jpg",
    },
    summary:
      "<p>In <b>Hell's Kitchen</b>, aspiring chefs are put through an intense culinary academy to prove they possess the right combination of ingredients to win a life-changing grand prize.</p>",
    officialSite: "http://www.fox.com/hells-kitchen",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-05-30",
  },
  {
    id: 254,
    url: "https://www.tvmaze.com/shows/254/world-series-of-poker",
    name: "World Series of Poker",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4656.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4656.jpg",
    },
    summary:
      "<p>The <b>World Series of Poker</b> is where the world's best poker players battle for the title.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 180,
      name: "ESPN2",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-08-22",
  },
  {
    id: 255,
    url: "https://www.tvmaze.com/shows/255/anthony-bourdain-parts-unknown",
    name: "Anthony Bourdain: Parts Unknown",
    genres: ["Food", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4660.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4660.jpg",
    },
    summary:
      "<p><b>Anthony Bourdain: Parts Unknown</b> has chef Anthony Bourdain traveling to extraordinary locations around the globe to sample a variety of local cuisines.</p>",
    officialSite: "https://explorepartsunknown.com/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 40,
      name: "CNN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-04-14",
  },
  {
    id: 256,
    url: "https://www.tvmaze.com/shows/256/comic-book-men",
    name: "Comic Book Men",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4661.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4661.jpg",
    },
    summary:
      "<p>AMC's popular unscripted series <b>Comic Book Men</b> takes another dive into world of geekdom by following the antics in and around master fanboy Kevin Smith's New Jersey comic shop, Jay and Silent Bob's Secret Stash. Leading the team behind the shop's counter are Walt, Bryan, Michael and Ming, who geek out over mind-blowing pop culture artifacts and the legends behind them. Whether it's buying and selling memorabilia or embarking on wild adventures away from the store, the Stash cast shares all the juicy details with Kevin during their hilarious podcast, which is woven in throughout the series.</p>",
    officialSite: "http://www.amc.com/shows/comic-book-men",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 20,
      name: "AMC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-02-12",
  },
  {
    id: 257,
    url: "https://www.tvmaze.com/shows/257/key-peele",
    name: "Key & Peele",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4662.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4662.jpg",
    },
    summary:
      "<p>Keegan-Michael Key and Jordan Peele are the stars of <b>Key &amp; Peele</b>, a show that examines life in a distinctively provocative and irreverent way. Whether it's anger-translating the president, spoofing Nazis or ordering up some soul food, Key &amp; Peele showcases the guys' camaraderie and unique point of view, born from their experiences growing up biracial in a not-quite-post-racial world.</p>",
    officialSite: "http://www.cc.com/shows/key-and-peele",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-01-31",
  },
  {
    id: 258,
    url: "https://www.tvmaze.com/shows/258/glue",
    name: "Glue",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/118/295401.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/118/295401.jpg",
    },
    summary:
      "<p>Bafta-winning writer Jack Thorne's compelling eight-part drama series about murder and secrets set in the English countryside.</p>",
    officialSite: "http://www.channel4.com/programmes/glue",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 41,
      name: "E4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-09-15",
  },
  {
    id: 259,
    url: "https://www.tvmaze.com/shows/259/southern-justice",
    name: "Southern Justice",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/304/760085.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/304/760085.jpg",
    },
    summary:
      "<p>Follow the Sheriff Deputies of Sullivan County, TN and Ashe County, NC as they work to keep the peace in the Blue Ridge Mountains on <b>Southern Justice</b>. Get an unprecedented look into crime in Appalachia, where guns, drugs and alcohol challenge lawmen 24/7.</p>",
    officialSite: "http://channel.nationalgeographic.com/southern-justice/",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-04-15",
  },
  {
    id: 260,
    url: "https://www.tvmaze.com/shows/260/tosh0",
    name: "Tosh.0",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4676.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4676.jpg",
    },
    summary:
      "<p><b>Tosh.0</b> is a weekly topical series that delves into all aspects of the Internet, featuring razor sharp humor and biting commentary from comedian Daniel Tosh. From the absolutely absurd to the incredibly ingenious, the series features viral clips, sketches, and \"Web Redemptions\" which give subjects of infamous viral videos a second chance to redeem themselves from the embarrassment with which they've become synonymous. Now in its third hit season, Tosh.0 continues to be cable TV's most trusted source for exhibitionist weirdos, injurious idiots and all things Web.</p>",
    officialSite: "http://tosh.cc.com/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-06-04",
  },
  {
    id: 261,
    url: "https://www.tvmaze.com/shows/261/the-soup",
    name: "The Soup",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/235/587894.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/235/587894.jpg",
    },
    summary:
      "<p><b>The Soup</b> reigns in the week's wildest and most memorable moments in the world of television with hilarious commentary, outrageous clips and surprise celebrity guests.</p>",
    officialSite: "https://www.eonline.com/shows/the_soup",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 43,
      name: "E!",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-07-30",
  },
  {
    id: 262,
    url: "https://www.tvmaze.com/shows/262/the-driver",
    name: "The Driver",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4681.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4681.jpg",
    },
    summary:
      "<p>Vince McKee's life is turned upside down when he agrees to be the driver for a criminal gang.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b04jtk4m",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-09-23",
  },
  {
    id: 263,
    url: "https://www.tvmaze.com/shows/263/last-week-tonight-with-john-oliver",
    name: "Last Week Tonight with John Oliver",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/295/738267.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/295/738267.jpg",
    },
    summary:
      "<p>On <b>Last Week Tonight with John Oliver</b>, John Oliver presents a satirical look at the week in news, politics and current events.</p>",
    officialSite: "http://www.hbo.com/last-week-tonight-with-john-oliver",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-04-27",
  },
  {
    id: 265,
    url: "https://www.tvmaze.com/shows/265/the-late-show-with-david-letterman",
    name: "The Late Show with David Letterman",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4702.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4702.jpg",
    },
    summary:
      "<p>A mix of comedy and talk show, including alot of celebrity guests and musical performances.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-08-30",
  },
  {
    id: 266,
    url: "https://www.tvmaze.com/shows/266/mount-pleasant",
    name: "Mount Pleasant",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4706.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4706.jpg",
    },
    summary:
      "<p>A who's who of British talent, from Sally Lindsay to the legendary Bobby Ball, take up residence in a homegrown comedy drama that's honest, relatable and big on laughs.</p>",
    officialSite: "https://www.sky.com/watch/channel/sky-1/mount-pleasant",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 63,
      name: "Sky 1",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-08-24",
  },
  {
    id: 267,
    url: "https://www.tvmaze.com/shows/267/lovesick",
    name: "Lovesick",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/143/359769.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/143/359769.jpg",
    },
    summary:
      "<p>An infectious comedy series following the disastrous exploits of 20-something romantic Dylan, who plans to use his STI diagnosis as a positive journey of self discovery.</p>",
    officialSite: "https://www.netflix.com/title/80041601",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2014-10-02",
  },
  {
    id: 268,
    url: "https://www.tvmaze.com/shows/268/package-deal",
    name: "Package Deal",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4708.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4708.jpg",
    },
    summary:
      '<p>When Kim starts dating Danny he seems too good to be true – a successful lawyer, charming, and single. Then, she discovers he\'s already committed – to his two older brothers, Sheldon and Ryan Will Danny ever grow up and be his own man? Or will Kim have to accept that his brothers are part of a "package deal"?</p>',
    officialSite:
      "https://web.archive.org/web/20140623105741/http://packagedeal.citytv.com/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 151,
      name: "Citytv",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2013-06-18",
  },
  {
    id: 269,
    url: "https://www.tvmaze.com/shows/269/peaky-blinders",
    name: "Peaky Blinders",
    genres: ["Drama", "Crime", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/48/122213.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/48/122213.jpg",
    },
    summary:
      "<p>An epic gangster drama set in the lawless streets of 1920s Birmingham.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b045fz8r",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-09-12",
  },
  {
    id: 270,
    url: "https://www.tvmaze.com/shows/270/the-league",
    name: "The League",
    genres: ["Comedy", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4720.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4720.jpg",
    },
    summary:
      "<p><b>The League</b> follows Kevin, a happily married father and commissioner of the fantasy football league; Jenny, Kevin's wife and his better half - especially when it comes to fantasy football; Pete, the perennial league champ who is struggling to become an adult; Taco, Kevin's little brother, a part-time musician and full-time stoner with little interest in fantasy other than hanging with his buddies; Ruxin, who believes he is the smartest of the group but can't figure out how exactly the other guys are screwing him over; and Andre, the punching bag of the group since their high school days - a fact that hasn't changed despite the fact he is now a successful plastic surgeon.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 47,
      name: "FXX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-10-29",
  },
  {
    id: 271,
    url: "https://www.tvmaze.com/shows/271/saving-hope",
    name: "Saving Hope",
    genres: ["Drama", "Fantasy", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/91/229823.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/91/229823.jpg",
    },
    summary:
      "<p>When Hope Zion Hospital's Chief of Surgery, Charlie Harris ends up in a coma, he finds himself wandering the halls in spirit form. Stuck between worlds, he watches as his fiancée and the staff of the hospital fight to keep patients - and hope - alive.</p>",
    officialSite: "http://www.ctv.ca/SavingHope.aspx",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 48,
      name: "CTV",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2012-06-07",
  },
  {
    id: 272,
    url: "https://www.tvmaze.com/shows/272/talking-dead",
    name: "Talking Dead",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/169/424141.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/169/424141.jpg",
    },
    summary:
      "<p>A live after show about <i>Fear/The Walking Dead</i>, hosted by Chris Hardwick. <b>Talking Dead</b> features Hardwick spending time with fans, actors, producers and TV enthusiasts, recapping the most recent <i>Fear/The Walking Dead</i> episodes and taking questions and comments from viewers.</p>",
    officialSite: "http://www.amc.com/shows/talking-dead",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 20,
      name: "AMC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-10-17",
  },
  {
    id: 273,
    url: "https://www.tvmaze.com/shows/273/black-dynamite",
    name: "Black Dynamite",
    genres: ["Comedy", "Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4742.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4742.jpg",
    },
    summary:
      "<p>Dynamite is a 1970s renaissance man with a kung-fu grip. A lover and a fighter who is not afraid to leap before he looks. His sidekick extraordinaire is Bullhorn, the brains and cunning that complements Black Dynamite's hard-hittin', bone-crushin' style. Providing comic relief on the mean streets is Cream Corn and classing up the place is the gorgeous Honey Bee.</p>",
    officialSite: "http://www.adultswim.com/videos/black-dynamite/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-07-15",
  },
  {
    id: 274,
    url: "https://www.tvmaze.com/shows/274/bad-education",
    name: "Bad Education",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/202/506068.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/202/506068.jpg",
    },
    summary:
      "<p>Comedy series about a teacher who is a bigger kid than the kids he teaches.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p01djw5m",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-08-14",
  },
  {
    id: 275,
    url: "https://www.tvmaze.com/shows/275/ali-g-rezurection",
    name: "Ali G: Rezurection",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/60/152357.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/60/152357.jpg",
    },
    summary:
      "<p><b>Ali G: Rezurection</b> includes every episode of Da Ali G Show with new, original introductions by star, creator/writer Sacha Baron Cohen, along with the BAFTA(R) Award-winning English episodes of Da Ali G Show which have never aired on American television and The Best of Ali G.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 47,
      name: "FXX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-02-26",
  },
  {
    id: 276,
    url: "https://www.tvmaze.com/shows/276/new-tricks",
    name: "New Tricks",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/48/121589.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/48/121589.jpg",
    },
    summary:
      "<p>Drama about a police unit, made up of retired detectives and a long-suffering boss, looking at unsolved crimes.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006t0qx",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2004-04-01",
  },
  {
    id: 277,
    url: "https://www.tvmaze.com/shows/277/brickleberry",
    name: "Brickleberry",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4787.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4787.jpg",
    },
    summary:
      '<p><b>Brickleberry</b> follows the hapless rangers at Brickleberry National Park as they do their worst to keep the park open. Having been through everything from "Steve\'s" invention of Squabbits to the birth of the anti-Christ, the rangers are back and ready for anything.</p>',
    officialSite: "http://www.cc.com/shows/brickleberry",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-09-25",
  },
  {
    id: 278,
    url: "https://www.tvmaze.com/shows/278/face-off",
    name: "Face Off",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4794.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4794.jpg",
    },
    summary:
      "<p><b>Face Off</b> is a competition/elimination series exploring the world of special-effects make-up artists and the unlimited imagination that allows them to create amazing works of living art. Each week the artists are tasked with using their considerable talent to create original movie-worthy characters such as aliens, human-animal hybrids, horror villains, cyborgs and others. Challenges incorporate a wide range of skill sets including design, sculpting, molding and application. It all builds to incredible reveals of the competitors' finished work and the drama of one artist being sent home by the expert panel of judges.</p>",
    officialSite: "http://www.syfy.com/faceoff",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-01-26",
  },
  {
    id: 279,
    url: "https://www.tvmaze.com/shows/279/real-time-with-bill-maher",
    name: "Real Time with Bill Maher",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/288/722171.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/288/722171.jpg",
    },
    summary:
      '<p><b>Real Time with Bill Maher</b> includes an opening monologue, roundtable discussions with panelists, and interviews with in-studio and satellite guests. Politico hailed Maher as "a pugnacious debater and a healthy corrective to the claptrap of cable news", while Variety noted, "There may not be a more eclectic guest list on all of television".</p>',
    officialSite: "http://www.hbo.com/real-time-with-bill-maher.html",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-02-21",
  },
  {
    id: 280,
    url: "https://www.tvmaze.com/shows/280/franklin-bash",
    name: "Franklin & Bash",
    genres: ["Drama", "Comedy", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4800.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4800.jpg",
    },
    summary:
      "<p>Two young, fly-by-the-seat-of-their-pants street lawyers cause a seismic culture clash when they join a legendary, button-down law firm.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-06-01",
  },
  {
    id: 281,
    url: "https://www.tvmaze.com/shows/281/mock-the-week",
    name: "Mock the Week",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/61/154228.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/61/154228.jpg",
    },
    summary:
      "<p>Comedy show combining the best elements of panel show, stand-up and improvised games with two teams of comedians taking a satirical swipe at the news and world events.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006t6vf",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2005-06-05",
  },
  {
    id: 282,
    url: "https://www.tvmaze.com/shows/282/awkward",
    name: "Awkward.",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4811.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4811.jpg",
    },
    summary:
      "<p>This series takes an irreverent look at the conflict, chaos and humor that defines teenage life through the eyes of 15-year-old Jenna Hamilton, whose life begins to change when a simple accident becomes an epic misunderstanding and is blown way out of proportion.</p><p>Narrated in the first-person voice of Jenna's blog posts, <b>Awkward</b> captures the humor within the struggles and experiences everyone can relate to from their formative years. The series picks up in the aftermath of the accident as she must deal with a new not-so-fun stigma, while at the same time managing the other daily drama that comes with being a teenager. From a secret relationship with a popular guy, to being undermined by a mean girl, and parents who just don't get it - Jenna's misfortune will eventually serve as the catalyst for amazing change, but it's not without some missteps and mishaps along the way.</p>",
    officialSite: "http://www.mtv.com/shows/awkward",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-07-19",
  },
  {
    id: 283,
    url: "https://www.tvmaze.com/shows/283/faking-it",
    name: "Faking It",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4824.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4824.jpg",
    },
    summary:
      "<p><b>Faking It</b> is a romantic comedy about two best friends who love each other - in slightly different ways. After numerous failed attempts to become popular, the girls are mistakenly outed as lesbians, which launches them to instant celebrity status. Seduced by their newfound fame, Karma and Amy decide to keep up their romantic ruse.</p>",
    officialSite: "http://www.mtv.com/shows/faking-it",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-04-22",
  },
  {
    id: 284,
    url: "https://www.tvmaze.com/shows/284/mr-selfridge",
    name: "Mr. Selfridge",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/34/85954.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/34/85954.jpg",
    },
    summary:
      "<p><b>Mr. Selfridge</b> tells the story of 'Mile a Minute Harry', a man with a mission to make shopping as thrilling as sex.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-01-06",
  },
  {
    id: 285,
    url: "https://www.tvmaze.com/shows/285/signed-sealed-delivered",
    name: "Signed, Sealed, Delivered",
    genres: ["Romance", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/179/448532.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/179/448532.jpg",
    },
    summary:
      "<p><b>Signed, Sealed, Delivered</b> is a wonderful combination of romance, comedy and drama that follows the lives of four postal detectives who transform themselves into a team of detectives to track down intended recipients of undeliverable mail. Their missions take them out of the office and into an unpredictable world where redirected letters and packages can save lives, solve crimes, reunite old loves and change futures by arriving late but somehow always on time.</p><p>The team includes charming Oliver O'Toole, a genius postal detective and the group's leader; new team member Shane McInerney, a technophile who brings 21st century sensibility to the group; free-spirited, \"girl next door\" Rita Haywith who has a photographic memory; and lovable Norman Dorman, a master in conventional research methods.</p>",
    officialSite:
      "http://www.hallmarkmoviesandmysteries.com/signed-sealed-delivered",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 252,
      name: "Hallmark Movies & Mysteries",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-10-12",
  },
  {
    id: 286,
    url: "https://www.tvmaze.com/shows/286/happy-valley",
    name: "Happy Valley",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4886.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4886.jpg",
    },
    summary:
      "<p>When a kidnap spirals out of control, Yorkshire police sergeant Catherine Cawood comes face to face with the man who destroyed her family.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b06zqjpj",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-04-29",
  },
  {
    id: 287,
    url: "https://www.tvmaze.com/shows/287/kroll-show",
    name: "Kroll Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4895.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4895.jpg",
    },
    summary:
      "<p>With unforgettable recurring characters like Bobby Bottleservice, the PubLIZity Girls, Ref Jeff, C-Czar and more, Kroll Show skewers our television-obsessed culture and the rabid fan base it breeds. More than just a collection of sketches, it's Nick Kroll's one-of-a-kind take on pop culture and the meaning of celebrity.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-01-16",
  },
  {
    id: 288,
    url: "https://www.tvmaze.com/shows/288/american-idol",
    name: "American Idol",
    genres: ["Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/298/745979.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/298/745979.jpg",
    },
    summary:
      "<p><b>American Idol </b>is an American singing competition show, where contestants perform in front of a panel of star judges, representing the music industry. The winner is determined by viewers' vote.</p>",
    officialSite: "http://www.americanidol.com",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-06-11",
  },
  {
    id: 289,
    url: "https://www.tvmaze.com/shows/289/americas-got-talent",
    name: "America's Got Talent",
    genres: ["Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/319/797803.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/319/797803.jpg",
    },
    summary:
      "<p>With the talent search open to acts of all ages, <b>America's Got Talent</b> has brought the variety format back to the forefront of American culture by showcasing performers from across the country. The series is a true celebration of the American spirit, featuring a colorful array of singers, dancers, comedians, contortionists, impressionists, jugglers, magicians, ventriloquists and hopeful stars, all vying for their chance to win America's hearts and the $1 million prize.</p>",
    officialSite: "http://www.nbc.com/americas-got-talent",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-06-21",
  },
  {
    id: 290,
    url: "https://www.tvmaze.com/shows/290/adventure-time",
    name: "Adventure Time",
    genres: ["Comedy", "Adventure", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4898.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4898.jpg",
    },
    summary:
      "<p><b>Adventure Time's</b> unlikely heroes Finn and Jake are buddies who traverse the mystical Land of Ooo and encounter its colorful inhabitants.</p>",
    officialSite: "http://www.cartoonnetwork.com/video/adventuretime/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-12-07",
  },
  {
    id: 291,
    url: "https://www.tvmaze.com/shows/291/motive",
    name: "Motive",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4903.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4903.jpg",
    },
    summary:
      '<p><b>Motive</b> is an unconventional way to watch a crime drama unfold. Each episode begins by revealing not only the victim, but the killer as well. It\'s not a "whodunit", it\'s a "whydunit", a question faced by spirited female Vancouver homicide detective Angie Flynn as she begins to piece together the clues from the crime. How are the victim and killer connected? What is the motive? As the mystery unfolds, the audience navigates a complicated maze of clues alongside the detective and her team.</p>',
    officialSite: "http://www.ctv.ca/Motive.aspx",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 48,
      name: "CTV",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2013-02-03",
  },
  {
    id: 292,
    url: "https://www.tvmaze.com/shows/292/the-new-celebrity-apprentice",
    name: "The NEW Celebrity Apprentice",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/64/161700.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/64/161700.jpg",
    },
    summary:
      "<p>Sixteen celebrities are set to compete for their favorite charities when <b>The NEW Celebrity Apprentice</b> shifts to Los Angeles for its eighth season, where twice-elected California governor and international movie superstar Arnold Schwarzenegger reigns over the Boardroom.</p><p>Advising the new head of the Boardroom this season will be world-class business minds, including investment guru Warren Buffett, one of the most successful businessmen in the world; former Microsoft CEO and Los Angeles Clippers owner Steve Ballmer; Tyra Banks, a supermodel, actress, TV host, producer, accomplished businesswoman and CEO of the Tyra Banks Company and cosmetics brand, TYRA Beauty; actress, author and entrepreneur Jessica Alba, the founder and chief creative officer of The Honest Company and Honest Beauty; and Schwarzenegger's trusted confidante and nephew, prominent entertainment attorney Patrick Knapp Schwarzenegger.</p>",
    officialSite: "http://www.nbc.com/the-celebrity-apprentice",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-01-03",
  },
  {
    id: 293,
    url: "https://www.tvmaze.com/shows/293/newswipe",
    name: "Newswipe",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4911.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4911.jpg",
    },
    summary:
      "<p>Charlie Brooker sets his sights firmly on news and current affairs.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00qbq57",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 51,
      name: "BBC Four",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-03-25",
  },
  {
    id: 294,
    url: "https://www.tvmaze.com/shows/294/the-night-shift",
    name: "The Night Shift",
    genres: ["Drama", "Action", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/126/315025.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/126/315025.jpg",
    },
    summary:
      "<p>Welcome to <b>The Night Shift</b>, where the toughest and craziest cases always seem to come through the door. Every shift is a fight between the heroic efforts of saving lives and the hard truths of running an underfunded hospital.</p><p>At San Antonio Memorial, the men and women who work the night shift are an irreverent and special breed, particularly adrenaline junkie TC Callahan. After three grueling tours of duty in Afghanistan, TC is about to learn that his toughest battles will be fought right here at home.</p>",
    officialSite: "http://www.nbc.com/the-night-shift",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-05-27",
  },
  {
    id: 295,
    url: "https://www.tvmaze.com/shows/295/top-chef",
    name: "Top Chef",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/257/643868.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/257/643868.jpg",
    },
    summary:
      "<p><b>Top Chef</b> is a competition show in which chefs competing against each other in various culinary challenges, judged by the team of professional chefs and notable people from food industry.</p>",
    officialSite: "http://www.bravotv.com/top-chef",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-03-08",
  },
  {
    id: 296,
    url: "https://www.tvmaze.com/shows/296/top-gear",
    name: "Top Gear",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4922.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4922.jpg",
    },
    summary:
      "<p>Hosts Tanner Foust, Adam Ferrara and Rutledge Wood embark on a new set of adventures as they test cars in extreme stunts, intense challenges and first-person reviews using their unique perspectives.</p>",
    officialSite: "http://www.history.com/shows/top-gear",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-11-21",
  },
  {
    id: 297,
    url: "https://www.tvmaze.com/shows/297/undateable",
    name: "Undateable",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/44/111506.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/44/111506.jpg",
    },
    summary:
      "<p><b>Undateable </b>is a comedy series about a group of friends who are this close to finding a relationship - they just need a little help.</p><p>Whether it's due to a lack of style, the wrong job or even just a bad haircut, everyone goes through a time in their lives when they're undateable. Most of us eventually grow out of it, but some people need a little more help than others. Enter Danny Burton Confident, attractive and impervious to outside opinions, 29-year-old Danny - who may be in a state of arrested development himself - decides to help out his new roommate, Justin Kearney the owner of an unsuccessful bar and a chronic overthinker, and Justin's group of oddball friends - Shelly, Burski and Brett Danny introduces the gang to his recently divorced older sister, Leslie who immediately bonds with this group of guys, as she feels a little stuck in her own life as well. The gang spends most of their time at Justin's bar, helping solve each other's respective problems over beers, and while they love to give each other a hard time, they always have each other's back.</p>",
    officialSite: "http://www.nbc.com/undateable",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-05-29",
  },
  {
    id: 298,
    url: "https://www.tvmaze.com/shows/298/chasing-life",
    name: "Chasing Life",
    genres: ["Drama", "Romance", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/1/4924.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/1/4924.jpg",
    },
    summary:
      "<p>April is a smart, charismatic and quick witted twenty-something aspiring journalist. When not pursuing the latest scoop, April tries to balance her ambitious career with her family, which includes her widowed mom Sara rebellious little sister Brenna and her grandmother We meet April at a pivotal moment in her life: she's landed a fantastic opportunity to impress her hard-nosed Boston newspaper editor and an office romance with her super-sexy co-worker Dominic is just beginning to blossom. In an unexpected twist of fate, April lands in the hospital where her estranged uncle, George works as an oncologist, and she learns the devastating news that she has cancer. The series follows April through her journey in the face of this daunting revelation, during a time in her life when the challenges of finding love and success would be enough to keep any girl occupied. But April is determined to fight and refuses to give up her dreams and goals. Along the way, she'll find new reserves of strength and passion within and discover that facing death may really be the only way to truly live.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-06-10",
  },
  {
    id: 299,
    url: "https://www.tvmaze.com/shows/299/power",
    name: "Power",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/204/511371.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/204/511371.jpg",
    },
    summary:
      "<p><b>Power </b>tells the story of James \"Ghost\" St. Patrick, a wealthy New York City nightclub owner who caters to the city's elite. He wants to build an empire, turn the club into a Fortune 500 business, but there's just one problem: Ghost is living a double life. When he is not in the club, he is the kingpin of the most lucrative drug network in New York for a very high-level clientele. His marriage, family and business all become unknowingly threatened as he is tempted to leave his criminal life behind and become the rags-to-riches businessman he wants to be most of all.</p>",
    officialSite: "https://www.starz.com/series/power/episodes",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 17,
      name: "Starz",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-06-07",
  },
  {
    id: 300,
    url: "https://www.tvmaze.com/shows/300/murder-in-the-first",
    name: "Murder in the First",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/192/481470.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/192/481470.jpg",
    },
    summary:
      "<p><b>Murder in the First</b> follows homicide detectives Terry English and Hildy Mulligan as they investigate two seemingly unrelated murders. The mystery deepens, however, when they find both murders have a common denominator in a Silicon Valley wunderkind.</p>",
    officialSite: "http://www.tntdrama.com/shows/murder-in-the-first.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-06-09",
  },
  {
    id: 301,
    url: "https://www.tvmaze.com/shows/301/hart-of-dixie",
    name: "Hart of Dixie",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/82/205570.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/82/205570.jpg",
    },
    summary:
      "<p>Fast-talking New Yorker and brand new doctor Zoe Hart has it all figured out - after graduating top of her class from medical school, she'll follow in her father's footsteps and become a cardio-thoracic surgeon. But when her dreams fall apart, Zoe decides to accept an offer from a stranger, Dr. Harley Wilkes, to work with him at his small practice in Bluebell, Alabama. Zoe arrives in this small Gulf Coast town only to find that Harley has passed away and left his half of the medical practice to her in his will.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-26",
  },
  {
    id: 302,
    url: "https://www.tvmaze.com/shows/302/trailer-park-boys",
    name: "Trailer Park Boys",
    genres: ["Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5013.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5013.jpg",
    },
    summary:
      "<p>Follow the booze-fueled misadventures of three longtime pals and petty serial criminals who run scams from their Nova Scotia trailer park.</p>",
    officialSite: "https://www.netflix.com/title/70153385",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "To Be Determined",
    network: null,
    premiered: "2001-04-22",
  },
  {
    id: 303,
    url: "https://www.tvmaze.com/shows/303/deadbeat",
    name: "Deadbeat",
    genres: ["Comedy", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5023.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5023.jpg",
    },
    summary:
      "<p><b>Deadbeat</b> follows Kevin Pacalioglu, who may have no money and no clue, but he can see dead people, so that's pretty cool. Faced with a constant stream of stubborn spirits, Pac goes to whatever lengths require the least amount of effort to help New York City's most frivolous ghosts finish their unfinished business.</p>",
    officialSite: "http://www.hulu.com/deadbeat",
    webChannel: {
      id: 2,
      name: "Hulu",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2014-04-09",
  },
  {
    id: 304,
    url: "https://www.tvmaze.com/shows/304/the-venture-bros",
    name: "The Venture Bros.",
    genres: ["Comedy", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5028.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5028.jpg",
    },
    summary:
      '<p><b>The Venture Bros.</b> is an American animated television series that premiered on Cartoon Network\'s Adult Swim on February 16, 2003. The series mixes action and comedy together while it chronicles the adventures of the Venture family: well-meaning but incompetent teenagers Hank and Dean Venture; their emotionally insecure, ethically challenged super-scientist father Dr. Thaddeus "Rusty" Venture; the family\'s bodyguard, originally the ultra-violent and macho secret agent Brock Samson and his later replacement, reformed super villain and "cured" pedophile Sergeant Hatred; and the family\'s self-proclaimed arch-nemesis, the Monarch, a butterfly-themed super villain.</p>',
    officialSite: "http://www.adultswim.com/videos/the-venture-bros/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-08-07",
  },
  {
    id: 305,
    url: "https://www.tvmaze.com/shows/305/black-mirror",
    name: "Black Mirror",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/240/601964.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/240/601964.jpg",
    },
    summary:
      "<p>Over the last ten years, technology has transformed almost every aspect of our lives before we've had time to stop and question it. In every home; on every desk; in every palm - a plasma screen; a monitor; a smartphone--a black mirror of our 21st Century existence. <b>Black Mirror</b> is a contemporary British re-working of <i>The Twilight Zone</i> with stories that tap into the collective unease about our modern world.</p>",
    officialSite: "https://www.netflix.com/title/70264888",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "To Be Determined",
    network: null,
    premiered: "2011-12-04",
  },
  {
    id: 306,
    url: "https://www.tvmaze.com/shows/306/broadchurch",
    name: "Broadchurch",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5036.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5036.jpg",
    },
    summary:
      "<p>David Tennant, Olivia Colman, Andrew Buchan and Jodie Whittaker, star in <b>Broadchurch</b> – a brand new powerful, thought provoking drama series by Kudos Film and Television for ITV.</p><p>The sadness of losing a child consumes the family, Beth and Mark Latimer their daughter 15-year-old Chloe and Beth's mum Liz as they attempt to cope with their grief, everyday normal life and the abruptness of the unwarranted attention heaped upon them. Devastated by their loss, it's the most stressful and emotional time in their lives as they struggle to relate to their friends, neighbours, the church, the press, and the police.</p>",
    officialSite: "http://www.itv.com/theendiswhereitbegins",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-03-04",
  },
  {
    id: 307,
    url: "https://www.tvmaze.com/shows/307/bluestone-42",
    name: "Bluestone 42",
    genres: ["Drama", "Comedy", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5052.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5052.jpg",
    },
    summary:
      "<p>Comedy drama series following the lives of a bomb disposal detachment serving in Afghanistan.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b03n3bsz",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-03-05",
  },
  {
    id: 308,
    url: "https://www.tvmaze.com/shows/308/matador",
    name: "Matador",
    genres: ["Drama", "Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5061.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5061.jpg",
    },
    summary:
      '<p>Shot in Los Angeles, the irreverent, adrenaline-filled series chronicles the unlikely rise of Tony "<b>Matador</b>" Bravo a professional soccer player for the LA Riot who comes to be known as much for his antics off the field as his moves on it. But what his fans and family don\'t realize is that it\'s all a cover - in truth, he is a skilled covert operative executing missions for the CIA. Agent Bravo, nicknamed Matador after he takes out a top player known as "The Bull" during tryouts for the team, finds himself suddenly thrust into a clandestine world. But, in balancing his dueling roles, he will be forced to confront the question of his true identity... and it is this mission that may prove to be his most dangerous.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 21,
      name: "El Rey Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-15",
  },
  {
    id: 309,
    url: "https://www.tvmaze.com/shows/309/rogue",
    name: "Rogue",
    genres: ["Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/55/138114.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/55/138114.jpg",
    },
    summary:
      "<p>Grace has left her life as an undercover cop to be a better mother to her daughter. She's recently separated from Tom and with the arrival of her estranged mother, she's got plenty of drama at home. Grace's new job as a handler for an FBI task force has her investigating corporate espionage in San Francisco. But when her undercover operative, Sarah, goes missing, Grace is forced to go back undercover to save her. That's when she meets Ethan the owner of the security consultancy Sarah investigated before disappearing. Grace looks to gain Ethan's trust to learn what happened to Sarah, but Ethan has his own agenda. His close friend and business partner was murdered the night Sarah vanished. He's determined to find who's responsible—creating a dangerous game of cat and mouse. As Grace gets closer to Ethan, her feelings grow. But can she trust him?</p>",
    officialSite: "http://rogue.directv.com/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 31,
      name: "Audience Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-04-03",
  },
  {
    id: 310,
    url: "https://www.tvmaze.com/shows/310/married",
    name: "Married",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/170/427163.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/170/427163.jpg",
    },
    summary:
      "<p><b>Married</b> is about being miserably in love. Russ and Lina Bowman can barely remember what it was like before kids, debt, and suburbia rained on their romance. But every once in a while, in between arguments about their declining sex life and who's driving carpool, they are reminded what drew them together in the first place — they're best friends.</p>",
    officialSite: "http://www.fxnetworks.com/shows/married/about",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-17",
  },
  {
    id: 311,
    url: "https://www.tvmaze.com/shows/311/satisfaction",
    name: "Satisfaction",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/213/534976.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/213/534976.jpg",
    },
    summary:
      "<p>In <b>Satisfaction</b>, investment advisor Neil Truman and his wife Grace are sifting through their stagnant relationship when Neil discovers that Grace has been seeing a male escort. After an unusual chain of events, he gains a new perspective on his life and what motivates women, while Grace contemplates whether her needs are being met and if her marriage is worth saving.</p>",
    officialSite: "http://www.usanetwork.com/satisfaction",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-17",
  },
  {
    id: 312,
    url: "https://www.tvmaze.com/shows/312/youre-the-worst",
    name: "You're the Worst",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/181/453177.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/181/453177.jpg",
    },
    summary:
      "<p><b>You're the Worst </b>is a comedic love story about what happens when two toxic, self-destructive people fall in love despite themselves and attempt the impossible - a relationship...</p>",
    officialSite: "http://www.fxnetworks.com/shows/youre-the-worst",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 47,
      name: "FXX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-17",
  },
  {
    id: 313,
    url: "https://www.tvmaze.com/shows/313/plebs",
    name: "Plebs",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/153/382980.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/153/382980.jpg",
    },
    summary:
      "<p>Rome is traditionally imagined as the home of emperors and senators, generals and gladiators, a dignified theatre of pomp and ceremony. But what about the little guys, the wasters - new to the big city, stuck in office jobs, unable to get the girls? <b>Plebs</b> follows three desperate young men from the suburbs as they try to get laid, hold down jobs and climb the social ladder in the big city - a city that happens to be Ancient Rome.</p>",
    officialSite:
      "https://www.itvmedia.co.uk/programmes/programme-planner/plebs",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 54,
      name: "ITV2",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-03-25",
  },
  {
    id: 314,
    url: "https://www.tvmaze.com/shows/314/vice",
    name: "VICE",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/47/119018.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/47/119018.jpg",
    },
    summary:
      "<p><b>VICE</b> explores today's most pressing issues, from civil unrest and hotbeds of terrorism, to unchecked government corruption and looming environmental catastrophes.</p>",
    officialSite: "https://www.sho.com/vice",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-04-05",
  },
  {
    id: 315,
    url: "https://www.tvmaze.com/shows/315/archer",
    name: "Archer",
    genres: ["Comedy", "Action", "Adult"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/202/507118.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/202/507118.jpg",
    },
    summary:
      "<p><b>Archer</b> is an animated, half-hour comedy set at the International Secret Intelligence Service, a spy agency where espionage and global crises are merely opportunities for its highly trained employees to confuse, undermine, betray and royally screw each other.</p>",
    officialSite: "http://www.fxnetworks.com/archer",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 47,
      name: "FXX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-09-17",
  },
  {
    id: 316,
    url: "https://www.tvmaze.com/shows/316/the-missing",
    name: "The Missing",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5109.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5109.jpg",
    },
    summary:
      "<p>Thriller series exploring the emotional fallout of a child's abduction not only on the family but on the wider community.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b07xt09g",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-10-28",
  },
  {
    id: 317,
    url: "https://www.tvmaze.com/shows/317/vicious",
    name: "Vicious",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5128.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5128.jpg",
    },
    summary:
      "<p><b>Vicious</b> tells the story of partners Freddie and Stuart, who have lived together in a small central London flat for nearly 50 years. Constantly picking each other apart and holding on to petty slights for decades, Freddie and Stuart are always at each other s throats, cracking snide remarks aimed at the other's age, appearance and flaws. However, underneath their vicious, co-dependent fighting, they have a deep love for one another. Freddie and Stuart are often joined by feisty best friend Violet and Ash, their young, upstairs neighbor.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-04-29",
  },
  {
    id: 318,
    url: "https://www.tvmaze.com/shows/318/community",
    name: "Community",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5134.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5134.jpg",
    },
    summary:
      "<p><b>Community </b>is a smart, exuberant comedy that is consistently ranked as one of the most inventive and original half-hours on television. This ensemble comedy centers around a tight-knit group of friends who all met at what is possibly the world's worst educational institution - Greendale Community College.</p>",
    officialSite: "http://www.nbc.com/community",
    webChannel: {
      id: 5,
      name: "YAHOO! View",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2009-09-17",
  },
  {
    id: 319,
    url: "https://www.tvmaze.com/shows/319/cougar-town",
    name: "Cougar Town",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5195.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5195.jpg",
    },
    summary:
      "<p>Jules Cobb is a mom in her forties facing the often humorous challenges, pitfalls and rewards of life's next chapter. Along for the journey is her son, her ex-husband, her husband/neighbor and her friends who together make up her dysfunctional, but supportive and caring extended family... even if they have a funny way of showing it sometimes.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 32,
      name: "TBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-09-23",
  },
  {
    id: 320,
    url: "https://www.tvmaze.com/shows/320/the-fall",
    name: "The Fall",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/75/188991.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/75/188991.jpg",
    },
    summary:
      "<p>This gripping psychological thriller forensically examines the lives of two hunters; one a serial killer that stalks his victims at random, and the other a high-powered detective superintendent brought in to catch him.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p0295tcf",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-05-13",
  },
  {
    id: 321,
    url: "https://www.tvmaze.com/shows/321/arrested-development",
    name: "Arrested Development",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/184/461652.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/184/461652.jpg",
    },
    summary:
      "<p>After being passed over as partner at The Bluth Co., widower Michael resolves to quit the family business and move away to spend more quality time with his 13-year-old son, George Michael. But when his father George Bluth Sr. is arrested for shifty accounting practices and the family assets are frozen, Michael is forced to stay in Orange County to help his wildly eccentric family pick up the pieces.</p>",
    officialSite: "https://www.netflix.com/title/70140358",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2003-11-02",
  },
  {
    id: 322,
    url: "https://www.tvmaze.com/shows/322/hit-the-floor",
    name: "Hit the Floor",
    genres: ["Drama", "Romance", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5228.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5228.jpg",
    },
    summary:
      "<p><b>Hit the Floor</b> explores the sexy world of professional basketball and the dancers who make the fans (and players) go wild. The Los Angeles Devils are the number one team in the league. When the arena lights go on all of Hollywood comes out to support the million dollar players. But in this city these men share the fame, adrenalin, money, sex and power with their dancers, the Devil Girls.</p>",
    officialSite: "https://www.bet.com/shows/hit-the-floor/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 56,
      name: "BET",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-05-27",
  },
  {
    id: 323,
    url: "https://www.tvmaze.com/shows/323/white-collar",
    name: "White Collar",
    genres: ["Drama", "Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5238.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5238.jpg",
    },
    summary:
      "<p>The series focuses on the unlikely partnership between the very intelligent and charming con-artist Neal Caffrey and the hard-working and earnest FBI agent Peter Burke. In exchange for his freedom, and on the condition that he wear an ankle bracelet at all times, Caffrey provides his expertise in thievery to help Burke and agents Clinton Jones and Diana Berrigan catch other elusive white collar criminals.</p>",
    officialSite: "https://www.usanetwork.com/whitecollar",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-10-23",
  },
  {
    id: 324,
    url: "https://www.tvmaze.com/shows/324/masterchef",
    name: "MasterChef",
    genres: ["Food", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/324/811404.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/324/811404.jpg",
    },
    summary:
      "<p>Three celebrated food experts put the latest group of contestants through a series of challenging elimination rounds and turn one home cook into a culinary master.</p>",
    officialSite: "http://www.fox.com/masterchef",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-07-27",
  },
  {
    id: 325,
    url: "https://www.tvmaze.com/shows/325/being-mary-jane",
    name: "Being Mary Jane",
    genres: ["Drama", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50602.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50602.jpg",
    },
    summary:
      "<p>Mary Jane Paul is a one-woman show: a successful TV news anchor, entirely self-sufficient – an all-around powerhouse who remains devoted to a family that doesn't share her motivation. <br /><br /> As Mary Jane juggles her life, her work and her commitment to her family, we find out how far she's willing to go to find the puzzle pieces that she, and society, insist are missing from her life as a single Black female.</p>",
    officialSite: "http://www.bet.com/shows/being-mary-jane.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 56,
      name: "BET",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-07-02",
  },
  {
    id: 326,
    url: "https://www.tvmaze.com/shows/326/undercover-boss",
    name: "Undercover Boss",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/22/56931.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/22/56931.jpg",
    },
    summary:
      "<p><b>Undercover Boss</b> is a reality series that follows high level corporate executives as they slip anonymously into the lowest level jobs within their companies. Once undercover, they'll get their hands dirty with the rank and file, find out what their employees REALLY think of them and discover how smoothly their companies are REALLY run. In the process, these senior executives learn about themselves, the perception of their company and the spirit of their work force.</p>",
    officialSite: "http://www.cbs.com/shows/undercover_boss/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-02-07",
  },
  {
    id: 327,
    url: "https://www.tvmaze.com/shows/327/inside-amy-schumer",
    name: "Inside Amy Schumer",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/55/137572.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/55/137572.jpg",
    },
    summary:
      "<p><b>Inside Amy Schumer</b> is the new series featuring Schumer's provocative and hilariously wicked mind, as she explores topics revolving around sex, relationships, and the general clusterf*ck that is life through a series of scripted vignettes, stand-up comedy, and man-on-the-street interviews.</p>",
    officialSite: "http://www.cc.com/shows/inside-amy-schumer",
    webChannel: { id: 107, name: "Paramount+", country: null },
    language: "English",
    status: "Running",
    network: null,
    premiered: "2013-04-30",
  },
  {
    id: 328,
    url: "https://www.tvmaze.com/shows/328/midsomer-murders",
    name: "Midsomer Murders",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/303/758151.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/303/758151.jpg",
    },
    summary:
      "<p>Based originally on the books by Caroline Graham, each self-contained episode of two hours is a classic whodunit revolving around Detective Chief Inspector Barnaby and his partner, and their efforts to solve the numerous gruesome murders which take place in the picturesque countryside of Midsomer County.</p>",
    officialSite: "http://www.itv.com/hub/midsomer-murders/Ya1096",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1998-03-22",
  },
  {
    id: 329,
    url: "https://www.tvmaze.com/shows/329/shark-tank",
    name: "Shark Tank",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/280/701966.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/280/701966.jpg",
    },
    summary:
      '<p>An exciting new reality show that, in these trying economic times, gives budding entrepreneurs a chance to make their dreams come true and become successful - and possibly wealthy - business people. But the entrepreneurs must first try to convince five tough, multi-millionaire tycoons to part with their own hard-earned cash and give them the funding they need to jumpstart their business ideas.</p><p>Enter the Sharks of <b>Shark Tank</b>, who lifted themselves up by their bootstraps to make their own entrepreneurial dreams come true and turned their ideas into empires. The five Sharks of this ruthless panel are real estate mogul Barbara Corcoran, "infomercial" industry pioneer Kevin Harrington, technology innovator Robert Herjavec, fashion icon Daymond John and financial expert Kevin O\'Leary.</p>',
    officialSite: "http://abc.go.com/shows/shark-tank",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-08-09",
  },
  {
    id: 330,
    url: "https://www.tvmaze.com/shows/330/on-the-menu",
    name: "On the Menu",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31649.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31649.jpg",
    },
    summary:
      "<p>On the Menu is the first cooking competition show ever to give viewers the chance to taste the winning dish after every episode. Each week a group of passionate home cooks are challenged to create a new signature dish for well-known national restaurants.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-03",
  },
  {
    id: 331,
    url: "https://www.tvmaze.com/shows/331/deal-with-it",
    name: "Deal With It",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5299.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5299.jpg",
    },
    summary:
      "<p>From executive producer Howie Mandel comes a hidden-camera game show in which everyday people are secretly dared to pull a prank on their unwitting companions with no time to prepare. By agreeing to participate, the contestant must obey all instructions given through an earpiece by host Theo Von and his celebrity guest hiding in a secret control room nearby. These unsuspecting members of the public will be tasked with pulling off some of the most ridiculous behavior ever caught on camera for the opportunity to win cash prizes... if they can deal with it!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 32,
      name: "TBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-07-17",
  },
  {
    id: 332,
    url: "https://www.tvmaze.com/shows/332/alpha-house",
    name: "Alpha House",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5300.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5300.jpg",
    },
    summary:
      "<p>Delivering hilarious insider insights from the master of political satire, the new season of <b>Alpha House</b> finds the Senators maneuvering the hallways of Capitol Hill with a looming midterm election and an unclear political future. Republican Senators Biggs, Bettencourt, and Laffer, having survived bruising primaries, are facing strong Democratic challengers and will use every trick in the book to woo voters on the road to re-election. Meanwhile, Senator Guzman prepares for a 2016 bid for the presidency, a pursuit that will bring him into possible competition with one of his roommates.</p>",
    officialSite: "https://www.amazon.com/Alpha-House-Season-1/dp/B00CDZFRAI",
    webChannel: { id: 3, name: "Amazon Prime Video", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2013-04-19",
  },
  {
    id: 333,
    url: "https://www.tvmaze.com/shows/333/the-game",
    name: "The Game",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5301.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5301.jpg",
    },
    summary:
      "<p>From creators Mara Brock Akil and Kelsey Grammer, comes a comedy about three special woman, each in a relationship with one of three hard-working football players. Melanie is trying to work her relationship with Derwin, her boyfriend, while Tasha Mack balances the relationship she has with her son, Malik and with her job. Kelly and Jason are also working hard to make their relationship last.<br><b>The Game</b> focuses on each of the relationships present in these women's lives -- those with both friends and lovers -- as they learn the rules of the game.</p>",
    officialSite: "http://www.bet.com/shows/the-game.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 56,
      name: "BET",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-10-01",
  },
  {
    id: 334,
    url: "https://www.tvmaze.com/shows/334/drunk-history",
    name: "Drunk History",
    genres: ["Comedy", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/205/513148.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/205/513148.jpg",
    },
    summary:
      "<p>Based on the popular web series, <b>Drunk History</b> is the liquored-up narration of our nation's history. Host Derek Waters, along with an ever-changing cast of actors and comedians, travels across the country to present the rich tales that every city in this land has to offer. Booze helps bring out the truth. It's just that sometimes the truth is a little incoherent.</p>",
    officialSite: "http://www.cc.com/shows/drunk-history",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-07-09",
  },
  {
    id: 335,
    url: "https://www.tvmaze.com/shows/335/sherlock",
    name: "Sherlock",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/171/428042.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/171/428042.jpg",
    },
    summary:
      "<p>Sherlock Holmes and Dr. John Watson's adventures in 21st Century London. A thrilling, funny, fast-paced contemporary reimagining of the Arthur Conan Doyle classic.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b018ttws",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-07-25",
  },
  {
    id: 336,
    url: "https://www.tvmaze.com/shows/336/marvels-agent-carter",
    name: "Marvel's Agent Carter",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/143/357815.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/143/357815.jpg",
    },
    summary:
      "<p><b>Marvel's Agent Carter</b>, starring <i>Captain America's</i> Hayley Atwell, follows the story of Peggy Carter. It's 1946, and peace has dealt Peggy Carter a serious blow as she finds herself marginalized when the men return home from fighting abroad. Working for the covert SSR (Strategic Scientific Reserve), Peggy must balance doing administrative work and going on secret missions for Howard Stark all while trying to navigate life as a single woman in America, in the wake of losing the love of her life—Steve Rogers. Inspired by the feature films <i>Captain America: The First Avenger</i> and <i>Captain America: The Winter Soldier</i>, along with the short <i>Marvel One-Shot: Agent Carter</i>.</p>",
    officialSite: "http://abc.go.com/shows/marvels-agent-carter",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-06",
  },
  {
    id: 337,
    url: "https://www.tvmaze.com/shows/337/ramsays-costa-del-nightmares",
    name: "Ramsay's Costa Del Nightmares",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/27/68464.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/27/68464.jpg",
    },
    summary:
      "<p>Gordon Ramsay visits some of Europe's holiday hotspots, meeting Brits abroad struggling with restaurants in crisis.</p>",
    officialSite:
      "http://www.channel4.com/programmes/ramsays-costa-del-nightmares",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-09-23",
  },
  {
    id: 338,
    url: "https://www.tvmaze.com/shows/338/secrets-and-lies",
    name: "Secrets and Lies",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/67/167976.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/67/167976.jpg",
    },
    summary:
      "<p>The explosive power of people's secrets and lies will once again take center stage in season two of ABC's hit drama, <b>Secrets and Lies</b>. No matter who you are, everyone has secrets and everybody tells lies. What will people do to keep their most intimate, devastating indiscretions from ruining their lives?</p>",
    officialSite:
      "http://abc.go.com/shows/secrets-and-lies/news/updates/secrets-and-lies-returning-for-season-2-050815",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-01",
  },
  {
    id: 339,
    url: "https://www.tvmaze.com/shows/339/american-crime",
    name: "American Crime",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/100/252315.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/100/252315.jpg",
    },
    summary:
      "<p><b>American Crime </b>is an American anthology crime drama. The series centers on race, class and gender politics. Season 1 follows a racially charged murder and the subsequent trial, while season 2 tells you the story of a sexual assualt with a high school trying to cover it up.</p>",
    officialSite: "http://abc.go.com/shows/american-crime/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-05",
  },
  {
    id: 340,
    url: "https://www.tvmaze.com/shows/340/the-librarians",
    name: "The Librarians",
    genres: ["Action", "Adventure", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/135/338167.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/135/338167.jpg",
    },
    summary:
      "<p>In <b>The Librarians</b>, four ordinary people from around the world are selected to work for the Library, an ancient order dedicated to solving supernatural mysteries and protecting the innocent from the secret magical world all around us.</p>",
    officialSite: "http://www.tntdrama.com/shows/the-librarians.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-12-07",
  },
  {
    id: 341,
    url: "https://www.tvmaze.com/shows/341/aquarius",
    name: "Aquarius",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/38/95845.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/38/95845.jpg",
    },
    summary:
      "<p>It's 1967 and the era of free love, drug experimentation and Vietnam is in full effect. When the teenage daughter of a respected lawyer goes missing, LA Police Sergeant Sam Hodiak starts asking around. He soon discovers that the hippie kids he's questioning don't take kindly to cops, especially one with hair as short as his. Needing the help of someone they trust, he partners with rebellious undercover cop Brian Shafe, a man who's more comfortable rolling a joint than patrolling a beat. It's not long before they stumble upon a small-time cult leader seeking out vulnerable women to join his cause. From there, they follow this man's trail down a rabbit hole of drugs, sex, murder and cultural revolution.</p>",
    officialSite: "http://www.nbc.com/aquarius",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-28",
  },
  {
    id: 342,
    url: "https://www.tvmaze.com/shows/342/louie",
    name: "Louie",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5334.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5334.jpg",
    },
    summary:
      "<p><b>Louie</b> is a comedy filtered through the observational humor of Louis C.K. Each episode puts a spotlight on Louis' hectic life as a successful stand-up comedian and newly single father raising his two daughters. The single-camera comedy is a mix of Louis C.K.'s stand-up comedy and scripted short films.</p>",
    officialSite: "http://www.fxnetworks.com/louie/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-06-29",
  },
  {
    id: 343,
    url: "https://www.tvmaze.com/shows/343/atlantis",
    name: "Atlantis",
    genres: ["Drama", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5335.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5335.jpg",
    },
    summary:
      "<p>A fantasy drama set in a world of legendary heroes and mythical creatures. Far from home, Jason washes up on the shores of the ancient and mysterious city of <b>Atlantis</b>.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b04st48f",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-09-28",
  },
  {
    id: 344,
    url: "https://www.tvmaze.com/shows/344/rizzoli-isles",
    name: "Rizzoli & Isles",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5342.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5342.jpg",
    },
    summary:
      "<p>On <b>Rizzoli &amp; Isles</b>, Boston detective Jane Rizzoli and medical examiner Maura Isles are complete opposites and good friends who solve crimes and bust some of Boston's most notorious criminals. Jane, the only female detective in Boston's homicide division, is a tough and gutsy cop who doesn't let her guard down (except with Maura), dodges her overprotective mother, and is better at basketball than her brother. Maura, meanwhile, is usually more comfortable among the dead than the living. She is always impeccably dressed in designer duds with a steady, sometimes icy temperament. Jane and Maura often find themselves working together as both use their brilliant minds and expertise to figure out the \"who done it\" as well as the \"how done it\" of Boston's most complex cases.</p>",
    officialSite: "http://www.tntdrama.com/shows/rizzoli-isles.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-07-12",
  },
  {
    id: 345,
    url: "https://www.tvmaze.com/shows/345/covert-affairs",
    name: "Covert Affairs",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5349.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5349.jpg",
    },
    summary:
      "<p>New jobs are tough—especially when your new employer is the CIA. Annie Walker is fluent in six languages, has traveled the world and is besting her fellow CIA trainees in every test. But that doesn't explain why she's suddenly summoned by CIA headquarters to report for active duty as a field operative one month before her training is over. She doesn't know there may be something—or someone—from her past that her CIA bosses are really after.<br><br> Annie's unofficial guide to the CIA is Auggie Anderson, a tech ops expert who was blinded while on assignment. As Annie navigates this new world of intrigue, danger and bureaucratic red tape, Auggie is there to make sure this quick study won't be kept in the dark for long. Also starring Peter Gallagher, Kari Matchett, Sendhil Ramamurthy and Anne Dudek.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-07-13",
  },
  {
    id: 346,
    url: "https://www.tvmaze.com/shows/346/hot-in-cleveland",
    name: "Hot in Cleveland",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5358.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5358.jpg",
    },
    summary:
      "<p><b>Hot in Cleveland</b> revolves around three fabulous L.A. women of a certain age who are best friends. Their lives are changed forever when their plane -- headed to Paris for a girls-only celebration -- unexpectedly lands in Cleveland and they soon rediscover themselves in a new 'promised land'. Loving their new home, the women find themselves living under one roof and battling the sassy caretaker of the property they have rented.</p>",
    officialSite: "http://www.tvland.com/shows/hot-in-cleveland",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 57,
      name: "TV Land",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-06-16",
  },
  {
    id: 347,
    url: "https://www.tvmaze.com/shows/347/its-always-sunny-in-philadelphia",
    name: "It's Always Sunny in Philadelphia",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/208/521986.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/208/521986.jpg",
    },
    summary:
      "<p><b>It's Always Sunny in Philadelphia</b> is an American comedy series about four friends in their late 20s with clear sociopathic tendencies who run an unsuccessful Irish bar, \"Paddy's Pub,\" in South Philadelphia. The series deals with a variety of controversial topics, including abortion, gun control, physical disabilities, racism, sexism, religion, the Israeli/Palestinian situation, terrorism, transsexuality, slavery, incest, sexual harassment in education, the homeless, statutory rape, drug addiction, pedophilia, child abuse, mental illness, gay rights and dumpster babies.</p>",
    officialSite:
      "http://www.fxnetworks.com/shows/its-always-sunny-in-philadelphia",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 47,
      name: "FXX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-08-04",
  },
  {
    id: 348,
    url: "https://www.tvmaze.com/shows/348/melissa-joey",
    name: "Melissa & Joey",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/44/111223.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/44/111223.jpg",
    },
    summary:
      '<p>Mel is the grown-up former wild child of a political family who is now a local politician herself. When her sister ends up in prison and brother-in-law flees after a scandal hits, Mel must take responsibility for her teenaged niece Lennox and adolescent nephew Ryder. Spread too thin to manage by herself, help comes in the unlikely form of Joe who, desperate for a job, moves in and becomes the family\'s "manny".</p>',
    officialSite: "http://abcfamily.go.com/shows/melissa-joey",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-08-17",
  },
  {
    id: 349,
    url: "https://www.tvmaze.com/shows/349/the-wrong-mans",
    name: "The Wrong Mans",
    genres: ["Comedy", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5375.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5375.jpg",
    },
    summary:
      "<p>Comedy thriller about two well-meaning idiots who become entangled in a hideous world of crime, conspiracy and corruption.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p02bhkmm",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-09-24",
  },
  {
    id: 350,
    url: "https://www.tvmaze.com/shows/350/last-comic-standing",
    name: "Last Comic Standing",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5378.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5378.jpg",
    },
    summary:
      "<p>Who will get the last laugh on <b>Last Comic Standing</b>? With hilarious celebrity judges, all-star one-on-one mentors and hand-picked stand-up comics, the ultimate comedy showdown is back and better than ever.</p>",
    officialSite: "http://www.nbc.com/last-comic-standing",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-06-10",
  },
  {
    id: 351,
    url: "https://www.tvmaze.com/shows/351/baby-daddy",
    name: "Baby Daddy",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5387.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5387.jpg",
    },
    summary:
      "<p><b>Baby Daddy</b> follows Ben, a young man in his early 20s living the life of a bachelor in New York City with his buddy, Tucker, and his brother, Danny. Their lives are turned upside down when they come home one day to find a baby girl left on the doorstep by an ex-girlfriend of Ben's. After much deliberation, Ben decides to raise the baby with the help of his friends and his protective and sometimes over-bearing mother, Bonnie, and his close female friend, Riley.</p>",
    officialSite: "http://freeform.go.com/shows/baby-daddy",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-06-20",
  },
  {
    id: 352,
    url: "https://www.tvmaze.com/shows/352/the-exes",
    name: "The Exes",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5392.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5392.jpg",
    },
    summary:
      "<p><b>The Exes</b> revolves around three divorced men, ladies man Phil, homebody Haskell and newly-single and needy Stuart. The men live together in an apartment across the hall from their divorce attorney Holly, who also happens to be their landlord. Holly avoids her own relationship and commitment issues by becoming immersed in the men's affairs as they put their lives back together and return to the dating scene.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 57,
      name: "TV Land",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-11-30",
  },
  {
    id: 353,
    url: "https://www.tvmaze.com/shows/353/line-of-duty",
    name: "Line of Duty",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755260.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755260.jpg",
    },
    summary:
      "<p>A drama about the investigations of AC-12, a controversial Police Anti-Corruption Unit.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p00yzlr0",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-06-26",
  },
  {
    id: 354,
    url: "https://www.tvmaze.com/shows/354/ground-floor",
    name: "Ground Floor",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5407.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5407.jpg",
    },
    summary:
      "<p>In this brand-new comedy series from the creator of <i>Cougar Town</i> &amp; <i>Scrubs</i>, a young hot-shot falls for a beautiful woman who works on the ground floor.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 32,
      name: "TBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-11-14",
  },
  {
    id: 355,
    url: "https://www.tvmaze.com/shows/355/mike-molly",
    name: "Mike & Molly",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5415.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5415.jpg",
    },
    summary:
      "<p>Police officer Mike Biggs knows his way around the Streets. As a cop, Mike's not scared of anything—except dating, so he's joined Overeaters Anonymous to lose those extra pounds and gain some Much-needed confidence. When he meets Molly at a meeting, the attraction is immediate, and suddenly Mike is excited about the prospect of a new life. But now he must find the willpower to give up his beloved junk food for the apple of his eye.</p>",
    officialSite: "https://www.cbs.com/shows/mike_and_molly/8/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-20",
  },
  {
    id: 356,
    url: "https://www.tvmaze.com/shows/356/man-down",
    name: "Man Down",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5425.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5425.jpg",
    },
    summary:
      "<p>Comedy series written by and starring Greg Davies as Dan, a childish idiot whose world is on the brink of collapse.</p>",
    officialSite: "http://www.channel4.com/programmes/man-down",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-10-18",
  },
  {
    id: 357,
    url: "https://www.tvmaze.com/shows/357/perception",
    name: "Perception",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/150/376028.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/150/376028.jpg",
    },
    summary:
      "<p>One of the most unique crime solvers on television, eccentric neuroscience professor Dr. Daniel Pierce, is recruited by the FBI to help solve complex cases. Dr. Pierce possesses an intimate knowledge of human behavior and a masterful understanding of the way the mind works. Although Pierce's mind may be brilliant, it's also damaged, as he suffers from paranoid schizophrenia.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-07-09",
  },
  {
    id: 358,
    url: "https://www.tvmaze.com/shows/358/spartacus-gods-of-the-arena",
    name: "Spartacus: Gods of the Arena",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5449.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5449.jpg",
    },
    summary:
      "<p>The mini-series features the bloody history of the House of Batiatus and the city of Capua before the arrival of Spartacus. Quintus Lentulus Batiatus becomes a lanista (manager) when he takes over his father's ludus of gladiators. He has ambitions of stepping out of his father's shadow by seeking recognition for his own name and achieving further greatness for his house. By his side stands his beautiful wife Lucretia who will help her husband achieve his ambitions, whatever the cost. Batiatus puts all his fortunes on the man who will gain him fame and glory. That would be his best gladiator, the Celt, Gannicus, a skilled warrior who wields dual swords with deadly purpose. Those who oppose Batiatus and his future champion(s) of Capua do so at their own peril.</p><p>Purchased as an undisciplined and disheveled recruit in the first episode, Crixus the Gaul endures mockery and threats of death to become the champion after Gannicus. As Batiatus fends off repeated attempts by his professional rival Tullius to obtain Gannicus, his relationships with his father Titus and friend Solonius begin to suffer the strain of his relentless ambition. Former champion, Oenomaus, reluctantly becomes Doctore, while Syrian recruits Ashur and Dagan try to prove themselves worthy of being gladiators. Veteran gladiators Barca and Gannicus note the rising star of Crixus, as the machinations of Batiatus and Lucretia end in tragedy for several members of the household. Against all of this, the city's splendid new arena nears completion and with it the opening games that will make slaves into gods. When the arena opens, Batiatus' gladiators prevail in the contest. Gannicus again proves himself to be the champion of Capua and a god of the arena. By virtue of his win against Solonius' gladiators, he gains his freedom and Crixus becomes the new champion.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 17,
      name: "Starz",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-01-21",
  },
  {
    id: 359,
    url: "https://www.tvmaze.com/shows/359/triptank",
    name: "TripTank",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5459.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5459.jpg",
    },
    summary:
      "<p><b>TripTank</b> showcases animated shorts so volatile that they should come with a recommended dosage. Combining a range of animation styles and diverse talent, including Wayne Brady, Kumail Nanjiani and Zach Galifianakis, the show promises to offer all the euphoria of a potent hallucinogen without any of the puking.</p>",
    officialSite: "http://www.cc.com/shows/triptank",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-04-02",
  },
  {
    id: 360,
    url: "https://www.tvmaze.com/shows/360/ripper-street",
    name: "Ripper Street",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5461.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5461.jpg",
    },
    summary:
      "<p>The Whitechapel police fight to bring law to the lawless in the wake of Jack the Ripper's reign of terror.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b03fvc1c",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-12-30",
  },
  {
    id: 361,
    url: "https://www.tvmaze.com/shows/361/saturday-night-live",
    name: "Saturday Night Live",
    genres: ["Comedy", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5468.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5468.jpg",
    },
    summary:
      '<p><b>Saturday Night Live</b> is an Emmy Award-winning late-night comedy showcase.</p><p>Since its inception in 1975, "SNL" has launched the careers of many of the brightest comedy performers of their generation. As The New York Times noted on the occasion of the show\'s Emmy-winning 25th Anniversary special in 1999, "in defiance of both time and show business convention, \'SNL\' is still the most pervasive influence on the art of comedy in contemporary culture." At the close of the century, "Saturday Night Live" placed seventh on Entertainment Weekly\'s list of the Top 100 Entertainers of the past fifty years.</p>',
    officialSite: "http://www.nbc.com/saturday-night-live",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1975-10-11",
  },
  {
    id: 362,
    url: "https://www.tvmaze.com/shows/362/switched-at-birth",
    name: "Switched at Birth",
    genres: ["Drama", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5470.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5470.jpg",
    },
    summary:
      "<p><b>Switched at Birth</b> tells the story of two teenage girls who discover they were accidentally switched as newborns in the hospital. Bay Kennish grew up in a wealthy family with two parents and a brother, while Daphne Vasquez, who lost her hearing at an early age due to a case of meningitis, grew up with a single mother in a poor neighborhood. Things come to a dramatic head when both families meet and struggle to learn how to live together for the sake of the girls.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-06-06",
  },
  {
    id: 363,
    url: "https://www.tvmaze.com/shows/363/late-night-with-seth-meyers",
    name: "Late Night with Seth Meyers",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/206/515186.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/206/515186.jpg",
    },
    summary:
      '<p>Seth Meyers, who is Saturday Night Live\'s longest serving anchor on the show\'s wildly popular "Weekend Update," takes over as host of NBC\'s <b>Late Night</b> — home to A-list celebrity guests, memorable comedy and the best in musical talent.</p><p>As the Emmy Award-winning head writer for "SNL," Meyers has established a reputation for sharp wit and perfectly timed comedy, and has gained fame for his spot-on jokes and satire. Meyers takes his departure from "SNL" to his new post at "Late Night," as Jimmy Fallon moves to The Tonight Show.</p>',
    officialSite: "https://www.nbc.com/late-night-with-seth-meyers",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-02-24",
  },
  {
    id: 364,
    url: "https://www.tvmaze.com/shows/364/single-ladies",
    name: "Single Ladies",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5478.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5478.jpg",
    },
    summary:
      "<p>Set in Atlanta, <b>Single Ladies</b> follows the lives of three best friends who have very different and unique philosophies on love, sex and relationships. Keisha, Raquel and April navigate the dating scene-- with a few bumps and bruises along the way-- and beg the question: what do women really want?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 58,
      name: "Centric",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-05-30",
  },
  {
    id: 365,
    url: "https://www.tvmaze.com/shows/365/the-after",
    name: "The After",
    genres: ["Drama", "Science-Fiction", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5479.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5479.jpg",
    },
    summary:
      "<p>From Chris Carter, creator of The X-Files. Eight strangers are thrown together by mysterious forces and must help each other survive in a violent world that defies explanation.</p>",
    officialSite: null,
    webChannel: { id: 3, name: "Amazon Prime Video", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2014-02-06",
  },
  {
    id: 366,
    url: "https://www.tvmaze.com/shows/366/sirens",
    name: "Sirens",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5490.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5490.jpg",
    },
    summary:
      "<p>From the distinct comedic point of view of Denis Leary and Bob Fisher, <b>Sirens</b> follows three of Chicago's best EMTs whose sometimes silly, self-righteous and even self-destructive personalities make them unqualified for sustaining relationships, friendships and most occupations. They are, however, uniquely qualified for saving anyone who winds up in their ambulance. Johnny is a good-looking, sports-loving, Chicago EMT working with his best friend Hank. Brian is a wide-eyed and excitable new EMT who still lives with his parents. Theresa, a smart female cop with the Chicago PD still loves her ex Johnny, but ultimately has to move on when he wouldn't commit.</p>",
    officialSite: "http://www.usanetwork.com/sirens",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-03-06",
  },
  {
    id: 367,
    url: "https://www.tvmaze.com/shows/367/six-feet-under",
    name: "Six Feet Under",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5480.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5480.jpg",
    },
    summary:
      "<p>When death is your business, what is your life? For the Fisher family, the world outside of their family-owned funeral home continues to be at least as challenging as--and far less predictable than--the one inside on <b>Six Feet Under</b>.</p>",
    officialSite: "http://www.hbo.com/six-feet-under",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-06-03",
  },
  {
    id: 368,
    url: "https://www.tvmaze.com/shows/368/red-dwarf",
    name: "Red Dwarf",
    genres: ["Comedy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5497.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5497.jpg",
    },
    summary:
      "<p>Lost in space and light years away from earth is the Jupiter Mining Ship <i>Red Dwarf</i>. In the late 22nd century, an on-board radiation leak kills all of the crew except for low-ranking technician Dave Lister, who is in suspended animation at the time, and his pregnant cat, Frankenstein, who is safely sealed in the cargo hold.</p>",
    officialSite: "http://dave.uktv.co.uk/shows/red-dwarf/",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 59,
      name: "Dave",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1988-02-15",
  },
  {
    id: 369,
    url: "https://www.tvmaze.com/shows/369/wizards-vs-aliens",
    name: "Wizards vs Aliens",
    genres: ["Fantasy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5507.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5507.jpg",
    },
    summary:
      "<p><b>Wizards vs Aliens</b> sees two worlds collide as young wizard Tom Clarke and his best friend Benny defend the Earth from Magic-eating aliens. Aided by the hobgoblin Randal Moon, Tom must stop the Nekross from draining the Earth of Magic!</p>",
    officialSite: "http://www.bbc.co.uk/cbbc/shows/wizards-vs-aliens",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 60,
      name: "CBBC",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-10-29",
  },
  {
    id: 370,
    url: "https://www.tvmaze.com/shows/370/workaholics",
    name: "Workaholics",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5510.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5510.jpg",
    },
    summary:
      "<p>Graduating from college and entering the real world isn't easy, especially for these three unmotivated roommates on <b>Workaholics</b>.</p>",
    officialSite: "http://www.cc.com/shows/workaholics",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-04-06",
  },
  {
    id: 371,
    url: "https://www.tvmaze.com/shows/371/the-red-road",
    name: "The Red Road",
    genres: ["Drama", "Crime", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5516.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5516.jpg",
    },
    summary:
      "<p>Lines will be crossed when tragedy forces two men, an ex-con &amp; a local cop, to face devastating secrets.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 33,
      name: "Sundance TV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-02-27",
  },
  {
    id: 372,
    url: "https://www.tvmaze.com/shows/372/see-dad-run",
    name: "See Dad Run",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5526.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5526.jpg",
    },
    summary:
      "<p>David Hobbs has been America's favorite Dad for the past 10 years, but that is all coming to an end. As David says goodbye to his life of sitcom T.V., reality awaits him at home with his wife and three kids. When the stay-at-home parent roles switch, David must learn the ins and outs of being a house-dad, while his wife Amy returns to the big screen. Suddenly, looking after three quirky kids and keeping their home in check becomes his newest starring role!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 62,
      name: "nick@nite",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-10-06",
  },
  {
    id: 373,
    url: "https://www.tvmaze.com/shows/373/moone-boy",
    name: "Moone Boy",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5530.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5530.jpg",
    },
    summary:
      "<p>Chris O'Dowd brings his childhood to life in <b>Moone Boy</b>. In Boyle, Ireland, in 1989, 11-year-old Martin Moone has a somewhat unusual friend.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 63,
      name: "Sky 1",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-09-14",
  },
  {
    id: 374,
    url: "https://www.tvmaze.com/shows/374/inside-no-9",
    name: "Inside No. 9",
    genres: ["Comedy", "Thriller", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/62/156641.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/62/156641.jpg",
    },
    summary:
      "<p>An anthology of darkly comic twisted tales by Steve Pemberton and Reece Shearsmith, each one taking place behind a door marked 'number 9'.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b05p650r",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-02-05",
  },
  {
    id: 375,
    url: "https://www.tvmaze.com/shows/375/broad-city",
    name: "Broad City",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/52/130656.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/52/130656.jpg",
    },
    summary:
      "<p><b>Broad City</b> is an odd-couple comedy about two best friends navigating their 20s in New York City. Abbi and Ilana are broke and flawed, and they don't shy away from the sticky situations NYC throws at them -- they dive right into the muck. No matter how bad it gets, these broads are always down with whatever hits them.</p>",
    officialSite: "http://www.cc.com/shows/broad-city",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-22",
  },
  {
    id: 376,
    url: "https://www.tvmaze.com/shows/376/portlandia",
    name: "Portlandia",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/150/375346.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/150/375346.jpg",
    },
    summary:
      '<p><b>Portlandia</b> is a follow up to the Fred Armisen (SNL)/Carrie Brownstein comedy collaboration, Thunderant. In the new IFC series (executive- produced by Lorne Michaels), the pair lovingly skewer the people and values of Portland, Ore. by introducing us to Portland archetypes like a militant bike messenger, feminist bookstore owners and an arts &amp; crafts couple who "put birds on things."</p>',
    officialSite: "http://www.ifc.com/shows/portlandia",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 65,
      name: "IFC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-01-21",
  },
  {
    id: 377,
    url: "https://www.tvmaze.com/shows/377/the-musketeers",
    name: "The Musketeers",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5545.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5545.jpg",
    },
    summary:
      "<p>A thrilling world of action, adventure and romance inspired by Dumas' legendary characters.</p><p>On the streets of 17th century Paris, law and order is more a fledgling idea than reality, and the Musketeers, Athos, Aramis and Porthos, are far more than merely royal bodyguards for King Louis XIII; they are inseparable, loyal unto death and committed to upholding justice. Together, this crack team of highly trained soldiers fight for honour, for valour, for love, and just for the pure thrill of it.</p>",
    officialSite: "https://www.bbc.co.uk/programmes/b04ww8fq",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-01-19",
  },
  {
    id: 378,
    url: "https://www.tvmaze.com/shows/378/citizen-khan",
    name: "Citizen Khan",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5550.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5550.jpg",
    },
    summary:
      "<p>Sitcom set in Birmingham, following the trials and tribulations of larger-than-life self-appointed Muslim community leader Mr Khan and his long suffering family.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b03c8nd8",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-08-27",
  },
  {
    id: 379,
    url: "https://www.tvmaze.com/shows/379/mythbusters",
    name: "Mythbusters",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/140/350120.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/140/350120.jpg",
    },
    summary:
      "<p>Hosted by Jamie Hyneman and Adam Savage, with Tory Belleci, Kari Byron and Grant Imahara, the <b>Mythbusters</b> mix scientific method with gleeful curiosity and plain old-fashioned ingenuity to create their own signature style of explosive experimentation. The team's combined backgrounds in animatronics, robotics, model building and prototyping arm them with the ability to create anything they need to test a myth.</p>",
    officialSite:
      "https://www.sciencechannel.com/tv-shows/mythbusters-on-science/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 77,
      name: "Science",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-01-23",
  },
  {
    id: 380,
    url: "https://www.tvmaze.com/shows/380/birds-of-a-feather",
    name: "Birds of a Feather",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5559.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5559.jpg",
    },
    summary:
      "<p>Return of the classic sitcom. Sharon is back living in her council flat and Tracey is still in Chigwell with younger son Travis - but what has become of Dorien?</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p00f6ftj",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1989-10-16",
  },
  {
    id: 382,
    url: "https://www.tvmaze.com/shows/382/aqua-teen-hunger-force",
    name: "Aqua Teen Hunger Force",
    genres: ["Comedy", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/78/196672.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/78/196672.jpg",
    },
    summary:
      "<p><b>Aqua Teen Hunger Force</b> follows the adventures of the aptly named Aqua Teen Hunger Force, a group of mystery-solving fast food items. The team consists of Master Shake, or Shake, a rather sadistic, lazy, ordering milkshake who loves to torture Meatwad. Frylock, the floating box of fries, is the brains the group, and contains the one thing that the rest of the group lacks: common sense. Meatwad is a loving, caring, gentle ball of meat that crawls wherever he goes, who is frequently tortured by Shake.</p>",
    officialSite: "http://www.adultswim.com/shows/aquateenhungerforce/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-12-30",
  },
  {
    id: 383,
    url: "https://www.tvmaze.com/shows/383/peep-show",
    name: "Peep Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5567.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5567.jpg",
    },
    summary:
      "<p>Award-winning sitcom. David Mitchell and Robert Webb play two dysfunctional flatmates who reveal all their inner thoughts - whether dark, stupid or embarrassing. Or, occasionally, all three...</p>",
    officialSite: "http://www.channel4.com/programmes/peep-show",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2003-09-19",
  },
  {
    id: 384,
    url: "https://www.tvmaze.com/shows/384/major-crimes",
    name: "Major Crimes",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/136/340671.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/136/340671.jpg",
    },
    summary:
      "<p>Captain Sharon Raydor faces the challenge of earning the trust and loyalty of her officers in <b>Major Crimes</b>, who are still in shock over their former Deputy Chief's exit, while trying to close the department's highest-profile cases. Raydor decides to house Rusty Beck, the key witness for a murder case, in her own home, paying for him to attend the Catholic high school her children attended.</p>",
    officialSite: "http://www.tntdrama.com/shows/major-crimes.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-08-13",
  },
  {
    id: 385,
    url: "https://www.tvmaze.com/shows/385/mad-men",
    name: "Mad Men",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5589.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5589.jpg",
    },
    summary:
      "<p>The series revolves around the conflicted world of Don Draper, the biggest ad man in the business, and his colleagues at the Sterling Cooper Draper Pryce Advertising Agency. As Don makes the plays in the boardroom and the bedroom, he struggles to stay a step ahead of the rapidly changing times and the young executives nipping at his heels. The series also depicts authentically the roles of men and women in this era while exploring the true human nature beneath the guise of 1960s traditional family values.</p>",
    officialSite: "http://www.amc.com/shows/mad-men",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 20,
      name: "AMC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-07-19",
  },
  {
    id: 386,
    url: "https://www.tvmaze.com/shows/386/yonderland",
    name: "Yonderland",
    genres: ["Comedy", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5606.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5606.jpg",
    },
    summary:
      "<p>A 33-year old mum Debbie Maddox unexpectedly find herself in an extraordinary world inhabited by a collection of eccentric and usually idiotic characters - some of whom happen to be puppets - with only an Elf by her side.</p><p>Fortunately most of the imagining for Sky 1 HD's comedy, <b>Yonderland</b> is done for you by those terribly clever people behind the Horrible Histories series.</p><p>The story begins with Debbie dropping her five year old twins off for their first day of school. For the first time in five long years, she has her days entirely to herself, and by the time shes cleaned the house from top to bottom and become frighteningly-addicted to a daytime quiz show, she starts to think she may be going mad.</p><p>And perhaps she is, as a wildly enthusiastic Elf appears from a kitchen cupboard, telling her that she is needed in another world. Apparently she is their unlikely saviour, prophesied to save the world from the dark forces that are gathering to subdue it.</p><p>Debbie's convinced that there has been some kind of mistake. (Well you would, wouldn't you?) But nevertheless decides that whatever the Elf might need her to do cant be any worse than watching another episode of Whats in the Box?, so she lets him drag her through a portal to the other world.</p><p>As she does her best to help incompetent knights, monks who are incapable of lying and a race of people intent on firing the cleverest among them into the sun, the big question is never far away: can she fulfil the prophecy? And will she make it back to the real world in time for the school pick up?</p>",
    officialSite: "https://www.sky.com/watch/channel/sky-1/yonderland",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 63,
      name: "Sky 1",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-11-10",
  },
  {
    id: 387,
    url: "https://www.tvmaze.com/shows/387/rookie-blue",
    name: "Rookie Blue",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5609.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5609.jpg",
    },
    summary:
      "<p>The stakes are high for five young cops fresh out of the Academy and ready for their first day with one of the most elite units in the city. Under the watchful guidance of their officers, Andy McNally and her four fellow rookies quickly learn that no amount of training could prepare them for this new world where every day is a first. Each case they tackle and choice they make will impact their lives, but it's their personal relationships that may play an even greater role in defining the cops they become.</p>",
    officialSite: "http://www.globaltv.com/rookieblue/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 67,
      name: "Global",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2010-06-24",
  },
  {
    id: 388,
    url: "https://www.tvmaze.com/shows/388/the-late-late-show-with-craig-ferguson",
    name: "The Late Late Show with Craig Ferguson",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5775.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5775.jpg",
    },
    summary:
      "<p>Craig Ferguson entered the world of late night comedy following a diverse and eclectic career that encompasses film, television and the stage. Since taking the helm of The Late Late Show with Craig Ferguson on January 3, 2005, the show has set all-time viewer records and achieved the highest ratings since the shows inception in 1995.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-01-03",
  },
  {
    id: 390,
    url: "https://www.tvmaze.com/shows/390/last-call-with-carson-daly",
    name: "Last Call with Carson Daly",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5774.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5774.jpg",
    },
    summary:
      "<p>Currently in its 13th season on NBC, <b>Last Call with Carson Daly</b> continues to push the boundaries of late night television. Each night, Last Call hits the streets, taking the entire show on location and bringing viewers along for the ride. Host Carson Daly introduces his audience to the emerging artists, stories and music you simply won't find anywhere else. In recent years, Last Call has garnered acclaim for its gritty documentary style, emphasis on great storytelling and status as late night TV's unofficial music tastemaker.</p>",
    officialSite: "https://www.nbc.com/last-call-with-carson-daly",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-01-08",
  },
  {
    id: 391,
    url: "https://www.tvmaze.com/shows/391/life-is-toff",
    name: "Life Is Toff",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5943.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5943.jpg",
    },
    summary:
      "<p>Factual entertainment series following the eccentric and aristocratic Fulford family at home on their 800-year-old country estate, as the children grapple with coming-of-age.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b04n64wm",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-10-28",
  },
  {
    id: 392,
    url: "https://www.tvmaze.com/shows/392/hunted",
    name: "Hunted",
    genres: ["Drama", "Action", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5944.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5944.jpg",
    },
    summary:
      "<p>Sam is a spy, a hunter who now finds herself hunted by a ruthless hidden enemy. Trapped in an intricate web of suspense and paranoia, she must discover who wants her dead by confronting her past.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p00vndpl",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-10-04",
  },
  {
    id: 393,
    url: "https://www.tvmaze.com/shows/393/video-game-high-school",
    name: "Video Game High School",
    genres: ["Comedy", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5952.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5952.jpg",
    },
    summary:
      "<p><b>Video Game High School</b> (VGHS) is an action/comedy web series about best friends, first loves, and landing that perfect head shot.</p><p>The series is set in the near future where video gaming elevates its best players to stardom by its position as the world's most popular competitive sport. VGHS is an elite and prestigious facility that teaches a curriculum of video games of all genres.</p><p>A classic high school dramedy, mixed with kick ass action and more than a little love of video games.</p>",
    officialSite: "https://www.rocketjump.com/category/vghs",
    webChannel: { id: 7, name: "rocketjump.com", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2012-05-11",
  },
  {
    id: 394,
    url: "https://www.tvmaze.com/shows/394/call-the-midwife",
    name: "Call the Midwife",
    genres: ["Drama", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/5960.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/5960.jpg",
    },
    summary:
      "<p>Drama following the lives of a group of midwives working in the poverty-stricken East End of London during the 1950s, based on the best-selling memoirs of Jennifer Worth.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p0118t80",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-01-15",
  },
  {
    id: 395,
    url: "https://www.tvmaze.com/shows/395/longmire",
    name: "Longmire",
    genres: ["Drama", "Thriller", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/74/186713.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/74/186713.jpg",
    },
    summary:
      "<p><b>Longmire</b>, a contemporary crime thriller set in Big Sky country, is based on the Walt Longmire Mystery novels by best-selling author Craig Johnson. It focuses on a Wyoming sheriff who's rebuilding his life and career following the death of his wife.</p>",
    officialSite: "https://www.netflix.com/title/70269479",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2012-06-03",
  },
  {
    id: 396,
    url: "https://www.tvmaze.com/shows/396/gravity-falls",
    name: "Gravity Falls",
    genres: ["Adventure", "Mystery", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/6140.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/6140.jpg",
    },
    summary:
      "<p>Twin brother and sister Dipper and Mabel Pines are in for an unexpected adventure when they spend the summer with their great Uncle in the mysterious town of Gravity Falls, Oregon.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 25,
      name: "Disney XD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-06-15",
  },
  {
    id: 397,
    url: "https://www.tvmaze.com/shows/397/dont-trust-the-b-in-apartment-23",
    name: "Don't Trust the B---- in Apartment 23",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/6145.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/6145.jpg",
    },
    summary:
      "<p>After a naive Midwestern girl's big city dreams are dashed during her first week in New York, she finds herself living with her worst nightmare, in a hilarious, contemporary comedy about a female odd couple who are surrounded by an outrageous cast of characters.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-04-11",
  },
  {
    id: 398,
    url: "https://www.tvmaze.com/shows/398/duck-dynasty",
    name: "Duck Dynasty",
    genres: ["Comedy", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/6152.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/6152.jpg",
    },
    summary:
      "<p>In <b>Duck Dynasty</b>, A&amp;E Network introduces the Robertsons, a Louisiana bayou family living the American dream as they operate a thriving business while staying true to their family values and lifestyle. Ask anyone in Louisiana and they'll tell you that the bayou state's favorite first family doesn't live in the governor's mansion but in the backwoods, where the Robertsons' rags-to-riches story is still unfolding. A ...homegrown mom-and-pop operation, Duck Commander has become a sporting empire by fabricating top-of-the-line duck calls and decoys out of salvaged swamp wood.<br><br> This newly minted multimillionaire family is kept in line by business-savvy Willie, who runs Duck Commander with the help of his brother Jase, their respective wives Korie and Missy, patriarch and founder of the company, Phil, and uncle Si. Together they run a booming business that employs half their neighborhood, but at the end of the day, you can find the whole family around matriarch Miss Kay's dinner table. Each episode brings a new set of challenges, met with a special brand of Southern know-how and a down-home sense of humor.</p>",
    officialSite: "http://www.aetv.com/duck-dynasty",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-03-21",
  },
  {
    id: 399,
    url: "https://www.tvmaze.com/shows/399/the-client-list",
    name: "The Client List",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/6159.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/6159.jpg",
    },
    summary:
      "<p><b>The Client List</b> is about Texas housewife; Riley Parks, who, after being deserted by her husband, is left in serious financial straits and takes a job at a seemingly traditional day spa in a neighboring town. But when she realizes some of her co-workers also provide other services, Riley must make the difficult decision whether or not to embrace an opportunity for her to resolve her financial hardships. The series will follow Riley as she delicately balances a moral conflict between two starkly different lives -- one as a single mother in a conservative town struggling to provide for her family and the other as a savvy and ambitious businesswoman working with a raucous, sexy and unpredictable group of women. As Riley becomes more involved, she struggles while working in secrecy knowing her family and friends would disapprove of her decision.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-04-08",
  },
  {
    id: 400,
    url: "https://www.tvmaze.com/shows/400/copper",
    name: "Copper",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/6166.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/6166.jpg",
    },
    summary:
      "<p><b>Copper</b> is an American saga set in 1865 New York City, picks-up on the brink of Lincoln's assassination - with shifts in politics and society altering the landscape for Irish immigrants and African-Americans. At the center, Detective Kevin Corcoran struggles to tame the wartime metropolis while wrestling with personal demons, including the betrayal of his wife and best friend. And when Tammany Hall's outspoken General Brendan Donovan returns from the Civil War to restore law and order in the Sixth Ward, loyalties will be bought and sold both Uptown and in the slums of the Five Points as Corcoran, and those around him, fight to find their places in an unforgiving city.</p>",
    officialSite: "http://www.bbcamerica.com/shows/copper",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 15,
      name: "BBC America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-08-19",
  },
  {
    id: 401,
    url: "https://www.tvmaze.com/shows/401/smash",
    name: "Smash",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/6176.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/6176.jpg",
    },
    summary:
      "<p>The hit-making Broadway writing team of Julia Houston and Tom Levitt unites with producer Eileen Rand to create a new musical based on the life of Marilyn Monroe, and seasoned chorus girl Ivy Lynn vies with newcomer Karen Cartwright for the dream role.</p>",
    officialSite: "https://www.nbc.com/smash",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-02-06",
  },
  {
    id: 402,
    url: "https://www.tvmaze.com/shows/402/a-young-doctors-notebook",
    name: "A Young Doctor's Notebook",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/6183.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/6183.jpg",
    },
    summary:
      "<p>Daniel Radcliffe and Jon Hamm star in a comedy drama based on Mikhail Bulgakov's experiences as an inexperienced doctor in a remote Russian village.</p>",
    officialSite:
      "https://www.sky.com/watch/title/series/001c4384-53ee-4c9d-8b53-e04239bb10ee",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 69,
      name: "Sky Arts",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-12-10",
  },
  {
    id: 403,
    url: "https://www.tvmaze.com/shows/403/touch",
    name: "Touch",
    genres: ["Drama", "Science-Fiction", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/6186.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/6186.jpg",
    },
    summary:
      "<p>Martin Bohm is a widower and single father who is haunted by an inability to connect to his emotionally challenged 11-year-old son Jake. But when Martin discovers that Jake can predict events before they happen, everything changes. Martin meets social worker Clea Hopkins and Professor Arthur Teller who may have the keys to help unlock Jake's mind.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-01-25",
  },
  {
    id: 404,
    url: "https://www.tvmaze.com/shows/404/magic-city",
    name: "Magic City",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/179/449238.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/179/449238.jpg",
    },
    summary:
      "<p>Miami Beach, 1959.</p><p>As Ike Evans rings in the New Year at his luxurious Miramar Playa Hotel, Havana falls to Castro's rebels. It's a turbulent time in Miami, but it's the place to be. The Kennedys, the mob and the CIA all hold court here. And Ike, he's the star of his hotel. But everything comes at a price. To finance his dream, he sold his soul to mob boss Ben \"The Butcher\" Diamond. Ike's wife Vera, a former showgirl, and his three kids think he's an honorable man, but he can't break his pact with the devil. His life is a façade. In fact, nothing at the Miramar Playa is what it seems. By day, it's diving clowns and cha-cha lessons. By night, escorts have secret liaisons with husbands in the family cabanas, while Miami's seedier residents and the law drift together to hear legendary singers, musicians and comics. As Ike's world threatens to implode, he fights for his family, and the Miramar Playa, in <b>Magic City</b>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 17,
      name: "Starz",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-03-30",
  },
  {
    id: 405,
    url: "https://www.tvmaze.com/shows/405/derek",
    name: "Derek",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/6206.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/6206.jpg",
    },
    summary:
      "<p>An Award-winning bittersweet comedy-drama about a group of outsiders living on society's margins, <b>Derek</b> centers around Derek Noakes (a tender, innocent man whose love for his job at a retirement home shines through. Derek cares deeply for the home's residents, because they are kind and funny and tell him stories of what life used to be like. Working alongside Derek is Dougie his landlord who is one of life's unlucky individuals; Kev a loveable train wreck; and Hannah a care worker in the home and Derek's best friend. She is smart, witty and hardworking, but unlucky in love, and, like Derek, always puts other people first.</p>",
    officialSite: "http://www.channel4.com/programmes/derek",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-04-12",
  },
  {
    id: 406,
    url: "https://www.tvmaze.com/shows/406/men-at-work",
    name: "Men at Work",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/6214.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/6214.jpg",
    },
    summary:
      '<p><b>Men at Work</b> is a brazen new original comedy about four hip, young professionals set to take on New York and live life "Full Steam" - ahead just like the name of the magazine that they work for. They follow the "boys will be boys" mantra of single, 30-somethings navigating work, friendship, and women.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 32,
      name: "TBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-05-24",
  },
  {
    id: 407,
    url: "https://www.tvmaze.com/shows/407/mortal-kombat-legacy",
    name: "Mortal Kombat: Legacy",
    genres: ["Action", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/6219.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/6219.jpg",
    },
    summary:
      "<p>In the beginning, the universe and its realms were in harmony, but even gods are not immune to power and greed. This balance was soon thrown into discord. The power-hungry gods challenged each other over the fates of their respective realms. They battled to the death in tournaments alongside mortal champions chosen from each realm. For millennia, Shao Kahn—the Emperor of Outworld—has successfully expanded his domain by defeating other realms. Edenia was the last realm to lose the tournament and fall to Shao Kahn. Ten years ago in the last tournament, Outworld and Earth-realm's warriors clashed, and Liu Kang emerged victorious. Earth-realm was spared. But now Shao Kahn's challenge has come again, and a new war is about to commence. The fate of Earth-realm and its inhabitants rests upon the outcome of this tournament. Let the kombat begin.</p>",
    officialSite: null,
    webChannel: {
      id: 8,
      name: "Machinima.com",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2011-04-12",
  },
  {
    id: 408,
    url: "https://www.tvmaze.com/shows/408/jane-by-design",
    name: "Jane by Design",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755993.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755993.jpg",
    },
    summary:
      "<p><b>Jane by Design</b> follows Jane Quimby a quirky teen with an eclectic chic fashion sense who lands a job at a hip fashion house when they mistake her for an adult. Torn between her love of fashion and the need to finish high school, Jane conceals her true age to assist the demanding, but talented Gray Chandler Murray who travels the world in search of the next big style trend.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-01-03",
  },
  {
    id: 409,
    url: "https://www.tvmaze.com/shows/409/invader-zim",
    name: "Invader ZIM",
    genres: ["Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/6242.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/6242.jpg",
    },
    summary:
      '<p><b>Invader ZIM</b> is an eccentric alien soldier from the planet Irk. He was banished from the Irken Empire after nearly destroying his home planet on an early mission. After begging his superiors, the Almighty Tallest Red and Purple, for another chance, they decide to get rid of him once and for all. They trick him into going on a "secret mission" to an obscure planet at the edge of the universe, a planet with the unlikely name of Earth, in hopes that he\'ll die along the way. But their trick backfires when ZIM safely reaches Earth and begins his ever-so-subtle conquest of it. He disguises himself as a schoolboy, and now the only person who can stop him is one kid - Dib, a somewhat insane paranormal researcher, who sees straight through ZIM\'s disguise and is intent on stopping his reign of "terror". The only problem is that neither of them is very good at stopping the other.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-03-30",
  },
  {
    id: 410,
    url: "https://www.tvmaze.com/shows/410/rival-survival",
    name: "Rival Survival",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31459.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31459.jpg",
    },
    summary:
      "<p>At a time when partisanship in U.S. politics litters the media landscape, Discovery Channel's <b>Rival Survival</b> brings together two real world political adversaries and maroons them on a remote island for a week. Disconnected from the world on an uninhabited island surrounded by shark infested waters that mirror the seemingly treacherous terrain of the U.S. Congress, Sen. Jeff Flake (R-AZ) and Sen. Martin Heinrich (D-NM) must put their political differences aside and work together for six days and six nights to find common ground through compromise if they want to survive in <i>Rival Survival</i>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: null,
  },
  {
    id: 411,
    url: "https://www.tvmaze.com/shows/411/the-cape",
    name: "The Cape",
    genres: ["Drama", "Crime", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/6361.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/6361.jpg",
    },
    summary:
      '<p>Fueled by a desire to reunite with his wife Dana and son Trip, Vince Faraday takes the law into his own hands to battle criminal forces that have overtaken Palm City. Faraday is joined by Max Malini, the ringleader of a circus gang of bank robbers, who mentors Faraday and trains him to become <b>The Cape</b>, as well as investigative blogger Orwell who wages war on crime and corruption in Palm City. Together, they must battle Ark corporation billionaire Peter Fleming -- The Cape\'s nemesis -- who moonlights as the twisted killer "Chess."</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-01-09",
  },
  {
    id: 412,
    url: "https://www.tvmaze.com/shows/412/fairly-legal",
    name: "Fairly Legal",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/6371.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/6371.jpg",
    },
    summary:
      "<p><b>Fairly Legal</b> centers on Kate Reed, a top litigator frustrated with the endless bureaucracy and daily injustices of the system, who takes a hard left to become the ultimate anti-lawyer: a mediator. Using her knowledge of the law, along with her savvy, intuition and a whatever-it-takes approach to resolving conflict, Kate finds the middle ground for a wide variety of adversaries - from Fortune 500 corporations to bitter divorces. After the sudden death of her father, she finds herself at odds with the new boss, her stepmother Lauren Reed... and in bed with her soon-to-be ex-husband, Justin Patrick, a top gun in the DA's office. Helping her keep all of this chaos at bay is her trusted, geek-chic assistant Leonardo.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-01-20",
  },
  {
    id: 413,
    url: "https://www.tvmaze.com/shows/413/whitney",
    name: "Whitney",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/6377.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/6377.jpg",
    },
    summary:
      "<p>They say marriage is the number one cause of divorce. For Alex and Whitney, it's one of many reasons they're determined not to take the plunge.</p><p>After going to yet another one of their friends' weddings, Whitney realizes that she and Alex are dangerously close to relationship boredom. She sees it happen all the time: pretty soon you're not dressing up for each other, you're not having enough sex, and you start fighting. Determined not to let that happen to them, Whitney consults her close circle of (opinionated) friends and snaps into action. A few awkward sexy costumes and one botched seductive evening later, they end up in the ER after Alex gets a concussion from a compromising position. Not exactly the mind-blowing experience she wanted, but you know what? That's all right. Their relationship might not be perfect on paper, but it works and they really do love each other.</p><p>Bright young comedian Whitney Cummings brings her unique and hilarious perspective on love to this new comedy series that proves there's no right way to be together... but there are plenty of wrong ways.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-22",
  },
  {
    id: 414,
    url: "https://www.tvmaze.com/shows/414/duckman-private-dickfamily-man",
    name: "Duckman: Private Dick/Family Man",
    genres: ["Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/6606.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/6606.jpg",
    },
    summary:
      "<p>With the help of his pig partner, a sarcastic Duckman is solving crimes.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1994-03-05",
  },
  {
    id: 415,
    url: "https://www.tvmaze.com/shows/415/olive-kitteridge",
    name: "Olive Kitteridge",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/6858.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/6858.jpg",
    },
    summary:
      "<p>Based on Elizabeth Strout's Pulitzer Prize-winning novel of the same name, <b>Olive Kitteridge</b> tells the poignantly sweet, acerbically funny and devastatingly tragic story of a seemingly placid New England town wrought with illicit affairs, crime and tragedy, told through the lens of a woman whose wicked wit and harsh demeanor mask a warm but troubled heart and a staunch moral center.</p>",
    officialSite: "http://www.hbo.com/olive-kitteridge",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-02",
  },
  {
    id: 416,
    url: "https://www.tvmaze.com/shows/416/are-you-the-one",
    name: "Are You the One?",
    genres: ["Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/6864.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/6864.jpg",
    },
    summary:
      "<p><b>Are You the One?</b> will follow a group of 10 single women and 10 single men who are self-admittedly horrible at relationships, as they jet off to Puerto Rico in the hopes they'll leave their bad relationship habits behind and surrender to their perfect match.</p><p>Prior to arrival, the singles will undergo a rigorous matchmaking process involving in-depth interviews and compatibility testing, using a team of professional matchmakers, psychologists, and the contestants' family, friends, and exes. An ideal match for each person will be selected - the catch is that the results are not revealed. The singles will begin their quest to find their perfect match in the house. If the entire group succeeds in finding their matches during the season, they'll walk away not only with love, but their share of one million dollars. All 10 couples must match, or they'll all go home without the cash!</p>",
    officialSite: "http://www.mtv.com/shows/are_you_the_one/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-21",
  },
  {
    id: 417,
    url: "https://www.tvmaze.com/shows/417/masterchef-junior",
    name: "MasterChef Junior",
    genres: ["Children", "Food", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/208/521096.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/208/521096.jpg",
    },
    summary:
      "<p><b>MasterChef Junior</b> goes back for seconds...and thirds! This culinary competition series gives talented kids between the ages of eight and 13 the chance to showcase their culinary abilities and passion for food through a series of delicious challenges.</p><p>Host and award-winning chef Gordon Ramsay is joined by restaurateur and winemaker Joe Bastianich and acclaimed chef Graham Elliot on the judging panel. Together, the celebrated food experts will coach and encourage the promising hopefuls to cook like a pro and teach them the tricks of the trade along the way.</p><p>After a nationwide search, 16 of the best junior home cooks in the country will compete in the kitchen where they will face exciting challenges, including a surprise mystery box, a three-legged race and the fan-favorite restaurant takeover, until one talented kid is named America's newest MasterChef Junior.</p>",
    officialSite: "http://www.fox.com/masterchef-junior",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-27",
  },
  {
    id: 418,
    url: "https://www.tvmaze.com/shows/418/chrisley-knows-best",
    name: "Chrisley Knows Best",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/206/515109.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/206/515109.jpg",
    },
    summary:
      '<p><b>Chrisley Knows Best</b> is a real-life family comedy, which broke its ratings record on its second season premiere, follows the entertaining lives of Atlanta-based "Patriarch of Perfection" Todd Chrisley, and his colorful clan including his wife, five children and two grandchildren.</p>',
    officialSite: "https://www.usanetwork.com/chrisley-knows-best",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-03-11",
  },
  {
    id: 419,
    url: "https://www.tvmaze.com/shows/419/snooki-jwoww",
    name: "Snooki & JWoww",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/6872.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/6872.jpg",
    },
    summary:
      '<p>The show returns with 12 all-new episodes chronicling the zany antics of Nicole "Snooki" Polizzi, Jenni "JWOWW" Farley, their fiancés Jionni LaValle and Roger Mathews, and their new babies. In what is sure to be their wildest season yet, fans will witness the besties as they tackle life milestones including new motherhood and upcoming nuptials.</p><p>Over the past five years, viewers have fallen in love with Snooki and JWOWW, who have become a modern day Laverne and Shirley, watching them go from party girls to motherhood and roommates to wombmates, while trading in beer for baby bottles. Now it\'s time to say goodbye and see how it all ends.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-06-21",
  },
  {
    id: 420,
    url: "https://www.tvmaze.com/shows/420/slednecks",
    name: "Slednecks",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/6873.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/6873.jpg",
    },
    summary:
      "<p>MTV is heading to Alaska with new series, <b>Slednecks</b>. The weekly half-hour comedic docu-series follows a close group of adventurous friends living in rural Wasilla, Alaska.</p><p>Polar Bear plunges, airboating on ice, glacier parties, river wakeboarding, and human catapulting are just some of the action-packed adventures these 'Slednecks' get into, while also navigating dramatic friendships and relationships in the prime of their lives. With mountains and rivers as their playground, these friends make the most of what they have while always having a blast.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-30",
  },
  {
    id: 421,
    url: "https://www.tvmaze.com/shows/421/rugrats",
    name: "Rugrats",
    genres: ["Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/6898.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/6898.jpg",
    },
    summary:
      '<p><b>Rugrats</b> reveals the world from a baby\'s point of view. Everything looks bigger, more mysterious and uncontrollable. Angelica, the oldest, likes to terrorize her cousin, Tommy, and his friends, and is famous for screaming, "You stupid babies!" The adults in the series are often clueless.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1991-08-11",
  },
  {
    id: 422,
    url: "https://www.tvmaze.com/shows/422/a-gifted-man",
    name: "A Gifted Man",
    genres: ["Drama", "Fantasy", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/7317.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/7317.jpg",
    },
    summary:
      "<p><b>A Gifted Man</b> is a drama about a brilliant, charismatic surgeon whose life changes forever when his deceased ex-wife begins teaching him the meaning of life from the \"hereafter\". Michael Holt is an exceptional doctor who lives a materialistic life of luxury thanks to his work-obsessed career and powerful and wealthy patients; however, Michael's ordered world is rocked when his ex-wife, Anna, an idealistic free-clinic doctor and the love of his life, mysteriously appears to him. In an attempt to go back to his \"normal\" life, Michael visits Anton, a carpenter who moonlights as a Shaman to try and extract Anna's spirit from his body, but when Anna reappears and asks Michael to go to her clinic to help keep it running, he realizes she needs him more now then ever. Curious about Michael's sudden change in behavior is his efficient assistant, Rita, who works tirelessly to facilitate his schedule in order to accommodate his added responsibilities at the clinic. Touched by those in need and accepting of Anna's compassionate \"presence\", Michael's attitude toward serving the rich and poor is turned upside down, and he begins to see that there's room in his life for everyone.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-23",
  },
  {
    id: 423,
    url: "https://www.tvmaze.com/shows/423/lifes-too-short",
    name: "Life's Too Short",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/7335.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/7335.jpg",
    },
    summary:
      "<p>Observational comedy starring Warwick Davis and written by Ricky Gervais and Stephen Merchant.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b017cj76",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-11-10",
  },
  {
    id: 424,
    url: "https://www.tvmaze.com/shows/424/kourtney-khloe-take-the-hamptons",
    name: "Kourtney & Khloe Take the Hamptons",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/7366.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/7366.jpg",
    },
    summary:
      "<p>From the producers of E!'s mega-hit series, <i>Keeping Up with the Kardashians</i>, Kourtney, a newly single Khloé, and Lord Disick himself are back in the Big Apple, and are taking the city by storm. The girls have their work cut out for them as they set out to relocate the Dash New York store to a hot new property while managing the initial struggles of opening their first pop-up store in the Hamptons.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 43,
      name: "E!",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-02",
  },
  {
    id: 425,
    url: "https://www.tvmaze.com/shows/425/the-passing-bells",
    name: "The Passing Bells",
    genres: ["Drama", "War", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/7487.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/7487.jpg",
    },
    summary:
      "<p>World War I drama. At the outbreak of war, two teenage boys - one German and one British - defy their parents to sign up.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b04nz99y",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-11-03",
  },
  {
    id: 426,
    url: "https://www.tvmaze.com/shows/426/the-people-remember",
    name: "The People Remember",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31443.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31443.jpg",
    },
    summary:
      "<p>History series presented by Sophie Raworth and Andy Torbet, honouring the heroes of war on the battlefield and the home front.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b06nsc42",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-11-03",
  },
  {
    id: 427,
    url: "https://www.tvmaze.com/shows/427/buffy-the-vampire-slayer",
    name: "Buffy the Vampire Slayer",
    genres: ["Drama", "Action", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/2/7490.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/2/7490.jpg",
    },
    summary:
      '<p><i>"Into every generation, there is a chosen one. She alone will stand against the vampires, the demons, and the forces of darkness. She is the slayer."</i></p><p>Buffy Summers is the latest in a line of young women known as "Vampire Slayers" who have to battle vampires, demons and other forces of evil, all while growing up and dealing with love and teenage angst in this iconic cult series. She and her "Scooby Gang" fight the good fight in a small town called Sunnydale.</p>',
    officialSite: null,
    webChannel: {
      id: 178,
      name: "20th Television",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: {
      id: 70,
      name: "UPN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1997-03-10",
  },
  {
    id: 428,
    url: "https://www.tvmaze.com/shows/428/angel",
    name: "Angel",
    genres: ["Drama", "Action", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/7507.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/7507.jpg",
    },
    summary:
      "<p>\"If you need help, then look no further. Angel Investigations is the best. Our rates are low but our standards are high. When the chips are down, and you're at the end of your rope you need someone that you can count on. And that's what you'll find here, someone that will go all the way, no matter what. So don't lose hope. Come on over to our offices and you'll see that there's still heroes in this world.\"</p><p><b>Angel</b> was the spin-off series of \"Buffy the Vampire Slayer\". It aired from 1999 to 2004. Angel runs a private invetigation bureau and fights demons, Wolfram &amp; Hart and all other existing evil in Los Angeles. There were several crossovers and many guest appearances from \"Buffy The Vampire Slayer\" during its five season run.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-10-05",
  },
  {
    id: 429,
    url: "https://www.tvmaze.com/shows/429/farscape",
    name: "Farscape",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/7531.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/7531.jpg",
    },
    summary:
      "<p>Astronaut John Crichton assumes he'll be home in time for dinner. But a freak accident during an experimental space mission catapults him across a thousand galaxies to an alien battlefield. Suddenly, he's trapped among alien creatures wielding deadly technology - a battle that 20th century sci-fi pop culture never prepared him for. Hunted by a merciless military race, Crichton begins his quest for home from a galaxy far, far away...</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-03-19",
  },
  {
    id: 430,
    url: "https://www.tvmaze.com/shows/430/the-x-files",
    name: "The X-Files",
    genres: ["Drama", "Crime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/143/357928.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/143/357928.jpg",
    },
    summary:
      "<p>Two FBI agents, Fox Mulder (a believer) and Dana Scully (a skeptic), investigate unexplained cases where the paranormal might be involved while hidden forces work to impede their efforts.</p>",
    officialSite: "http://www.fox.com/the-x-files",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-09-10",
  },
  {
    id: 431,
    url: "https://www.tvmaze.com/shows/431/friends",
    name: "Friends",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/41/104550.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/41/104550.jpg",
    },
    summary:
      "<p>Six young (20-something) people from New York City (Manhattan), on their own and struggling to survive in the real world, find the companionship, comfort and support they get from each other to be the perfect antidote to the pressures of life.</p><p>This average group of buddies goes through massive mayhem, family trouble, past and future romances, fights, laughs, tears and surprises as they learn what it really means to be a friend.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1994-09-22",
  },
  {
    id: 432,
    url: "https://www.tvmaze.com/shows/432/dollhouse",
    name: "Dollhouse",
    genres: ["Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/91/227855.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/91/227855.jpg",
    },
    summary:
      '<p>In <b>Dollhouse</b>, Echo is an "Active," a member of a highly illegal and underground group of individuals who have had their personalities wiped clean so they can be imprinted with any number of new personas. Hired by the wealthy, powerful and connected, the Actives don\'t just perform their hired roles; they wholly become - with mind, personality and physiology - whomever the client wants or needs them to be. Whether imprinted to be a lover, an assassin, a corporate negotiator or a best friend, the Actives know no other life than the specific engagements they are in at that time.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-02-13",
  },
  {
    id: 433,
    url: "https://www.tvmaze.com/shows/433/caprica",
    name: "Caprica",
    genres: ["Drama", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/8928.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/8928.jpg",
    },
    summary:
      "<p>Set 58 years before <i>Battlestar Galactica</i>, <b>Caprica</b> follows two rival families - the Graystones and the Adamas - as they grow, compete, and thrive in the vibrant world of the peaceful 12 Colonies, living in a society close to our own. Entangled in the burgeoning technology of artificial intelligence and robotics that will eventually lead to the creation of the Cylons, the two houses go toe-to-toe, blending action with corporate conspiracy and sexual politics.</p><p>Daniel Graystone, a computer genius, is owner of a large computer corporation that is spearheading the development of artificial intelligence. He and his wife Amanda, who's a brilliant surgeon, are both relentless in their scientific pursuits. The Adama clan is helmed by Joseph Adama, a renowned criminal defense attorney and father of future Battlestar commander William Adama. When tragedy strikes both families, lines are drawn that will determine the fate of the human race.</p>",
    officialSite: "http://www.syfy.com/caprica/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-01-22",
  },
  {
    id: 434,
    url: "https://www.tvmaze.com/shows/434/warehouse-13",
    name: "Warehouse 13",
    genres: ["Drama", "Science-Fiction", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/160/402219.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/160/402219.jpg",
    },
    summary:
      "<p>After saving the life of the President, two Secret Service agents find themselves abruptly transferred to Warehouse 13 -- a massive, top-secret storage facility in windswept South Dakota that houses every strange artifact, mysterious relic, fantastical object and supernatural souvenir ever collected by the U.S. government. The Warehouse's caretaker Artie charges Pete and Myka with chasing down reports of supernatural and paranormal activity in search of new objects to cache at the Warehouse, as well as helping him to control the warehouse, itself. Rounding out the team is technology specialist Claudia and former ATF Steve Jinks.</p>",
    officialSite: "http://www.syfy.com/warehouse13",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-07-07",
  },
  {
    id: 435,
    url: "https://www.tvmaze.com/shows/435/smallville",
    name: "Smallville",
    genres: ["Drama", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/79/199609.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/79/199609.jpg",
    },
    summary:
      "<p>The end of the beginning starts here. Taking flight in its tenth and final season, this modern retelling of a hero's legendary origins continues to blend realism, action, heart and humor as Clark Kent soars toward claiming his birthright.<br><br> Clark has emerged from his darkest hour, only to find the path to his destiny blocked by ghosts from the past -- shadows in the present tempting Clark toward the darkness at every turn. Despite insurmountable odds, is Clark strong enough to step into the light and claim his rightful place as Earth's mightiest protector?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-10-16",
  },
  {
    id: 436,
    url: "https://www.tvmaze.com/shows/436/dead-like-me",
    name: "Dead Like Me",
    genres: ["Drama", "Comedy", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9014.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9014.jpg",
    },
    summary:
      "<p>You're about to be collected. When an errant toilet seat from the falling Mir space station puts an abrupt end to her life, George discovers that death is nothing like she thought it would be. Recruited to collect the souls of others as they die, she suddenly finds herself an unwilling participant in a line of work she never knew existed: Grim Reaping!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-06-27",
  },
  {
    id: 437,
    url: "https://www.tvmaze.com/shows/437/xena-warrior-princess",
    name: "Xena: Warrior Princess",
    genres: ["Action", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9021.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9021.jpg",
    },
    summary:
      '<p>"In a time of ancient gods, warlords, and kings, a land in turmoil cried out for a hero. She was Xena, a mighty princess, forged in the heat of battle. The power... the passion... the danger... Her courage will change the world".</p><p>This spin-off from Hercules: The Legendary Journeys (1995), Xena is a feisty and fearless warrior princess who fights everything evil along with her sidekick Gabrielle in <b>Xena: Warrior Princess</b>.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1995-09-04",
  },
  {
    id: 438,
    url: "https://www.tvmaze.com/shows/438/the-adventures-of-sinbad",
    name: "The Adventures of Sinbad",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9024.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9024.jpg",
    },
    summary:
      '<p>An adventure set in a land of myth and magic in the Middle East.The series tells of the adventures of Sinbad and his brother as they gather a crew, and set sail in the ship "Nomad" from Baghdad in search of wealth and adventure. Along the way they face wizards, witches strange tribes and fantastic creatures.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-09-28",
  },
  {
    id: 439,
    url: "https://www.tvmaze.com/shows/439/wolverine-and-the-x-men",
    name: "Wolverine and the X-Men",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/254/636101.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/254/636101.jpg",
    },
    summary:
      "<p>After a mysterious explosion at the Xavier mansion, and the resulting disappearances of Professor Xavier and Jean Grey, the distraught X-Men disband. But soon, Wolverine, Storm. Beast and the others find themselves together again to battle the increasingly powerful Mutant Response Division, and to prevent a catastrophic future that Xavier has warned must never come to pass.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 73,
      name: "Nicktoons",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-09-08",
  },
  {
    id: 440,
    url: "https://www.tvmaze.com/shows/440/everwood",
    name: "Everwood",
    genres: ["Drama", "Family", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/81/204375.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/81/204375.jpg",
    },
    summary:
      "<p>As a world-class neurosurgeon, Dr. Andrew Brown is a hero. As a father, he's a zero. But that is changing. Tragedy makes him a single parent to his two children. And as the first act of his new life, Andy leaves Manhattan and moves his family to <b>Everwood</b>, the tiny Colorado town where big dreams can grow.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-09-16",
  },
  {
    id: 443,
    url: "https://www.tvmaze.com/shows/443/once-a-thief",
    name: "Once a Thief",
    genres: ["Comedy", "Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9068.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9068.jpg",
    },
    summary:
      "<p><b>Once a Thief</b> is a canadian action/comedy show loosely based and inspired by the John Woo movie of the same name.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 48,
      name: "CTV",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "1997-09-15",
  },
  {
    id: 444,
    url: "https://www.tvmaze.com/shows/444/xiii-the-series",
    name: "XIII: The Series",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9073.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9073.jpg",
    },
    summary:
      "<p><b>XIII: The Series</b> is a follow up to the TV movie: XIII: The Prodigy. A man suffering from amnesia tries to uncover his past in this action filled canadian show.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 6,
      name: "Showcase",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2011-04-20",
  },
  {
    id: 445,
    url: "https://www.tvmaze.com/shows/445/metal-hurlant-chronicles",
    name: "Metal Hurlant Chronicles",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9081.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9081.jpg",
    },
    summary:
      "<p>Based on the popular French comics anthology <i>Métal Hurlant</i> (known as <i>Heavy Metal</i> in the United States) each of the 12 episodes take place on a different planet with a different cast, linked together by the presence of an asteroid, which plays a vital role in their lives--and the future of their civilization. This is an originally French series, although all of the episodes are spoken in English (in France they were dubbed or subtitled) except season 1 episode 3 which is in French.</p>",
    officialSite: "http://www.france4.fr/emissions/metal-hurlant",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 405,
      name: "France 4",
      country: { name: "France", code: "FR", timezone: "Europe/Paris" },
    },
    premiered: "2012-10-27",
  },
  {
    id: 446,
    url: "https://www.tvmaze.com/shows/446/defying-gravity",
    name: "Defying Gravity",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9089.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9089.jpg",
    },
    summary:
      "<p>Hurtling into the vast challenge of infinite space, the eight astronauts and the ground personnel who support them are on a mission that has a powerful and awesome mystery at its core. The intimate and interconnected relationships among the astronauts and the ground crew, as well as their past actions, have a strangely karmic effect on the present. Episodes are divided between the present, as the Antares travels towards Venus, and the past, with flashbacks to earlier years when the astronauts were in the grueling selection and training process.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 48,
      name: "CTV",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2009-08-02",
  },
  {
    id: 447,
    url: "https://www.tvmaze.com/shows/447/charlies-angels",
    name: "Charlie's Angels",
    genres: ["Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9107.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9107.jpg",
    },
    summary:
      "<p>Everyone deserves a second chance -- even a thief, a street racer and a cop who got in a little too deep. After all, the three women who solve cases for their elusive boss, Charlie Townsend, are no saints. They're angels... <b>Charlie's Angels</b>. Set in Miami, this fun, glamorous, action-packed take on the 1970s smash hit series introduces us to three new angels, all fearless detectives, head-turning beauties and close friends. There's Abby, a Park Avenue princess who became a world-class thief. Then there's Kate, a Miami cop who fell from grace, losing both her career and her fiancé. Finally there's Gloria, a disgraced army lieutenant who has a way with explosives.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-22",
  },
  {
    id: 448,
    url: "https://www.tvmaze.com/shows/448/the-universe",
    name: "The Universe",
    genres: ["Adventure", "Family", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9118.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9118.jpg",
    },
    summary:
      "<p>From the planets to the stars and out to the edge of the unknown, history and science collide in this epic exploration of the Universe and its mysteries. It's a very old universe. Yet just 50 years since man first ventured into outer space, the heavens are yielding their greatest secrets. Robotic rovers give us eyes on the red rock of Mars--NASA probes slam into comets at hyper speed--deep-space telescopes capture violent images of the birth of stars and their collapse into black holes. All have significantly changed the way we see ourselves. We wonder, is there anywhere else out there that that can support life? Using cutting-edge computer graphics, this series brings the universe down to earth to show what life would be like on other planets, and to imagine what kind of life forms might evolve in alien atmospheres. Episodes examine how discoveries were made and the scientists and explorers who dared to venture into the uncharted territory of the universe.</p>",
    officialSite: "http://www.history.com/shows/the-universe",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 74,
      name: "H2",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-05-29",
  },
  {
    id: 449,
    url: "https://www.tvmaze.com/shows/449/true-justice",
    name: "True Justice",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/289/724880.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/289/724880.jpg",
    },
    summary:
      "<p><b>True Justice</b> stars Steven Seagal as Elijah Kane who leads a hardcore undercover team of Seattle based cops who take on the local criminal element with a high-octane style of enforcement. Kane and his team will take on gangs, drug lords and crime syndicates as they fight to clean up the streets.</p>",
    officialSite: "http://www.reelz.com/truejustice/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 75,
      name: "REELZ",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-03-30",
  },
  {
    id: 450,
    url: "https://www.tvmaze.com/shows/450/wolf-lake",
    name: "Wolf Lake",
    genres: ["Drama", "Crime", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9132.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9132.jpg",
    },
    summary:
      "<p>Seattle police detective John Kanin, finds his world turned upsidedown when his girlfriend Ruby mysteriously disappears one night after leaving his apartment. After months of searching, an anonymous tip leads Kanin back to Ruby's hometown Wolf Lake, a place where the residents are hiding a dark secret...</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 70,
      name: "UPN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-09-19",
  },
  {
    id: 451,
    url: "https://www.tvmaze.com/shows/451/knight-rider",
    name: "Knight Rider",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9133.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9133.jpg",
    },
    summary:
      '<p>On the heels of NBC\'s hit movie, the iconic 1980s television classic comes roaring back to life as a reinvented, updated and super-charged action series showcasing the new KITT (Knight Industries Three Thousand). Absolutely the coolest car ever created, KITT is equipped with an "AI" (artificial intelligence) that is capable of hacking almost any system. Its weapons systems match that of a jet fighter, and its body is capable of actually transforming into other vehicles and using sophisticated holographic imagery to elude villains.</p><p>The driver of the new KITT is Mike Traceur, the estranged son of Michael Knight from the earlier series. Traceur later changes his name to Knight as he joins KITT on their mission of fighting crime.</p>',
    officialSite: "https://www.nbc.com/knight-rider",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-09-24",
  },
  {
    id: 452,
    url: "https://www.tvmaze.com/shows/452/the-deep",
    name: "The Deep",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9141.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9141.jpg",
    },
    summary:
      "<p>In the state-of-the-art research submarine Orpheus, Captain Frances Kelly leads a team of scientists deep below the Arctic ice. They are following the path of an earlier, disastrous expedition; searching the final frontiers of Earth for unknown and remarkable life forms, attempting to find the solution to the world's escalating energy crisis.<br /><br />Enduring crushing pressure, boiling vent gases, freezing temperatures and total darkness, the Orpheus arrives at the Lomonosov Ridge, an enormous area of sea bed which is disputed territory, currently under the United Nations' jurisdiction. Nobody comes here. But there is something else out here: something huge and bewildering. And, as the Orpheus crew struggle for survival and attempt to unravel the mystery, they uncover secrets more terrifying than they ever could have imagined…</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00tc8r5",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-08-03",
  },
  {
    id: 453,
    url: "https://www.tvmaze.com/shows/453/tales-from-the-crypt",
    name: "Tales from the Crypt",
    genres: ["Comedy", "Fantasy", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9142.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9142.jpg",
    },
    summary:
      "<p>Cadaverous scream legend/all-around punster the Crypt Keeper hosts these forays of fright and fun based on classic E.C. Comics tales from back in the day – and drawing on the talents of top filmmakers Richard Donner, Walter Hill, Joel Silver, Robert Zemeckis and others. So belly up to the bar and name your poison. Is it a deranged Santa on a personal slay ride? A man surgically implanted with as many lives (and deaths) as a cat? Honeymooners who each want the other to fulfill the 'til-death vow pronto? These and more terror-rific tales await. Ghoul love 'em!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1989-06-10",
  },
  {
    id: 454,
    url: "https://www.tvmaze.com/shows/454/pacific-blue",
    name: "Pacific Blue",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9144.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9144.jpg",
    },
    summary:
      "<p>From producer of hit TV series <i>21 Jump Street</i>, <i>Renegade</i> and <i>North Shore</i> comes this flashy cop series about an elite bycicle cop unit of the Santa Monica Police Department. From chasing down pick pockets and drug dealers to investigating homicides, these law enforcement officers are on patrol to keep the warm, sunny L.A. beaches safe, no matter the cost. Featuring a stellar, sexy cast of characters, their relationships sizzle as temptation and desire stir up conflicting personal and professional interests.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-03-02",
  },
  {
    id: 455,
    url: "https://www.tvmaze.com/shows/455/blade-the-series",
    name: "Blade: The Series",
    genres: ["Action", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9153.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9153.jpg",
    },
    summary:
      "<p><b>Blade: The Series</b> follows the title character who is half-man, half-vampire and employs his extraordinary powers in a crusade to save mankind from the demonic creatures who walk the night. Set in Detroit, Blade investigates the vampire house of Chthon. Along the way he forms an uneasy alliance with Krista Starr, a former military veteran who becomes entrenched in the world of vampires while investigating the murder of her twin brother.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 34,
      name: "Paramount Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-06-28",
  },
  {
    id: 456,
    url: "https://www.tvmaze.com/shows/456/moonlight",
    name: "Moonlight",
    genres: ["Drama", "Horror", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9159.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9159.jpg",
    },
    summary:
      "<p>Mick St. John is a captivating, charming- and immortal- private investigator from Los Angeles who defies the traditional blood-sucking norms of his vampire tendencies by using his wit and powerful supernatural abilities to help the living. In a life-altering twist of fate, Mick was \"bitten\" 60 years ago by his new bride, the seductive Coraline. Forever 30 years of age, Mick's as handsome and charismatic as the day he was \"turned,\" and he eschews others of his kind who view humans only as a source of nourishment. With only a handful of like-minded confidantes for company, including the eternally young, wealthy and mischievous Josef, a hedge fund trader who relishes his uniqueness, Mick fills his infinite days protecting the living. But one night years ago, a single act of kindness changed Mick when he saved a young girl's life, making him want to be a better vampire. Now their paths cross again and Mick develops a distinctive bond with Beth Turner who has grown into a beautiful, ambitious Internet investigative reporter. Reconnecting with her unleashes feelings Mick knows he can't pursue without exposing the part of him that would make him a monster in Beth's eyes. As Mick lives between two realities, fighting his adversaries among the undead and falling in love, he discovers the mysteries and pleasures that a valuable life has to offer.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-09-28",
  },
  {
    id: 457,
    url: "https://www.tvmaze.com/shows/457/the-event",
    name: "The Event",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9164.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9164.jpg",
    },
    summary:
      "<p>Sean Walker, stumbles into a national conspiracy after his girlfriend Leila mysteriously disappears from a Caribbean cruise. Elsewhere, President Elias Martinez is scheduled to announce the release of a group of detainees led by Sophia Maguire -- despite the disapproval of his Director of National Intelligence, Blake Sterling. Their futures are on a collision course in a global conspiracy that could ultimately change the fate of mankind.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-20",
  },
  {
    id: 458,
    url: "https://www.tvmaze.com/shows/458/flashforward",
    name: "FlashForward",
    genres: ["Drama", "Crime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9176.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9176.jpg",
    },
    summary:
      "<p>What would you do if you were given a glimpse of the future? Would you accept what you saw and live life to its fullest, or would you do everything in your power to change your destiny? When the world's population is given a glimpse of their future, it forces everyone to come to grips with whether their destinies can be fulfilled or avoided.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-09-24",
  },
  {
    id: 459,
    url: "https://www.tvmaze.com/shows/459/harpers-island",
    name: "Harper's Island",
    genres: ["Horror", "Thriller", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/30/77028.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/30/77028.jpg",
    },
    summary:
      "<p><b>Harper's Island</b> is about a group of family and friends who travel to a secluded island for a destination wedding. They've come to laugh... to love... and, though they don't know it... to die. As the wedding festivities begin, friendships are tested and secrets exposed as a murderer claims victims, one by one, transforming the wedding week of fun and celebration into a terrifying struggle for survival. In every episode, someone is killed and every person is a suspect, from the wedding party to the island locals. By the end of the 13 episodes, all questions will be answered, the killer will be revealed and only a few will survive.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-04-09",
  },
  {
    id: 460,
    url: "https://www.tvmaze.com/shows/460/adventure-inc",
    name: "Adventure Inc.",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9193.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9193.jpg",
    },
    summary:
      "<p>When adventure calls... no place is too far, no risk is too high, and no task is too difficult for Adventure Inc. From his base in the Florida Keys, Judson Cross has assembled a team of young renegades - Mackenzie Previn and Gabriel Patterson, each with their own extraordinary skills and willing to risk it all for the love of adventure. Their methods may not be orthodox and they might risk their own safety, but they always get the job done.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-09-30",
  },
  {
    id: 461,
    url: "https://www.tvmaze.com/shows/461/legend-of-the-seeker",
    name: "Legend of the Seeker",
    genres: ["Action", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9195.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9195.jpg",
    },
    summary:
      "<p>In a mythical land, one man, Richard Cypher, discovers his true destiny as he, a mysterious young woman, a wise old wizard and a magical sword are all that stand between the evil tyrant Darken Rahl and his quest for total domination.<br><br> Based on <i>The Sword of Truth</i> series of books by Terry Goodkind.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-11-01",
  },
  {
    id: 462,
    url: "https://www.tvmaze.com/shows/462/tekwar",
    name: "TekWar",
    genres: ["Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9202.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9202.jpg",
    },
    summary:
      '<p>In the year 2045, an addictive computer-based reality drug call "tek" has ignited a war that stretches throughout society. Recruited by a mysterious benefactor to stop the advancing drug is Jake Cardigan, a cop who teams up with a colorful array of partners as the government plots to stop him from revealing the truth. This riveting series is based on the hit sci-fi novel series by William Shatner, who also makes special appearances throughout these 22 action-packed episodes!</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1994-12-22",
  },
  {
    id: 463,
    url: "https://www.tvmaze.com/shows/463/dark-skies",
    name: "Dark Skies",
    genres: ["Drama", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9203.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9203.jpg",
    },
    summary:
      "<p>On July 2, 1947, a spacecraft of unknown origin crashed in the New Mexico desert outside Roswell Army Air Base. Four bodies - known as the Grays - were recovered. Everything you think to true about American history, from that moment on, has been influenced by that event.</p><p>On February 17, 1962, another event occurred, related to the first, but one that has, until now, been kept completely suppressed.</p><p>You are being trusted with that secret.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-09-21",
  },
  {
    id: 464,
    url: "https://www.tvmaze.com/shows/464/the-pacific",
    name: "The Pacific",
    genres: ["Drama", "Action", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9204.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9204.jpg",
    },
    summary:
      "<p><b>The Pacific</b> is an epic ten-part miniseries. The Pacific tracks the intertwined real-life stories of three U.S. Marines – Robert Leckie, John Basilone, and Eugene Sledge – across the vast canvas of the Pacific Theater during World War II. The miniseries follows these men and their fellow Marines from their first battle with the Japanese on Guadalcanal, through the rain forests of Cape Gloucester and the strongholds of Peleliu, across the bloody sands of Iwo Jima and through the horror of Okinawa, and finally to their triumphant but uneasy return home after V-J Day.</p>",
    officialSite: "http://www.hbo.com/the-pacific/index.html",
    webChannel: {
      id: 22,
      name: "HBO Go",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-03-14",
  },
  {
    id: 465,
    url: "https://www.tvmaze.com/shows/465/band-of-brothers",
    name: "Band of Brothers",
    genres: ["Drama", "Action", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/80/201679.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/80/201679.jpg",
    },
    summary:
      "<p>Drawn from interviews with survivors of Easy Company, as well as their journals and letters, <b>Band of Brothers</b> chronicles the experiences of these men from paratrooper training in Georgia through the end of the war. As an elite rifle company parachuting into Normandy early on D-Day morning, participants in the Battle of the Bulge, and witness to the horrors of war, the men of Easy knew extraordinary bravery and extraordinary fear - and became the stuff of legend. Based on Stephen E. Ambrose's acclaimed book of the same name.</p>",
    officialSite: "http://www.hbo.com/band-of-brothers",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-09-09",
  },
  {
    id: 466,
    url: "https://www.tvmaze.com/shows/466/columbo",
    name: "Columbo",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9270.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9270.jpg",
    },
    summary:
      "<p>This is the detective series that inspired them all. Legendary actor Peter Falk is back in his 4-time Emmy® Award winning role, as the ruffled, cigar-chomping, trenchcoat-wearing police lieutenant who is asking all the right questions.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1968-02-20",
  },
  {
    id: 467,
    url: "https://www.tvmaze.com/shows/467/blood-ties",
    name: "Blood Ties",
    genres: ["Drama", "Action", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9272.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9272.jpg",
    },
    summary:
      "<p>After witnessing a horrific demonic murder at the side of a Toronto roadway, private investigator Vicki Nelson finds herself on a collision course with another citizen investigating the case. He is Henry Fitzroy – former Duke of Richmond, cutting-edge graphic novelist and 470-year old vampire.</p><p>To solve the brutal murder, Vicky finds herself collaborating against her better judgment, with the suave and seductive Fitzroy. The relationship soon progresses beyond a pretty professional arrangement, complicating her long-term love affair with ex-partner Detective Mike Celluci...and pretty well everything else in her life.</p><p>As the cases become more bizarre &amp; complex, the relationship between Vicki &amp; Mike becomes fractured. Meanwhile, Henry's behavior creates suspicion for all involved in the cases, casting doubt among the three.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-03-11",
  },
  {
    id: 468,
    url: "https://www.tvmaze.com/shows/468/walker-texas-ranger",
    name: "Walker, Texas Ranger",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/70/176011.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/70/176011.jpg",
    },
    summary:
      "<p>Texas Ranger Cordell Walker, one of the last old-fashioned heroes in the West, is a protective friend but a relentless foe who will stop at nothing to bring a criminal to justice.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-04-21",
  },
  {
    id: 469,
    url: "https://www.tvmaze.com/shows/469/regenesis",
    name: "ReGenesis",
    genres: ["Drama", "Science-Fiction", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9283.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9283.jpg",
    },
    summary:
      "<p>Cloning, bioterrorism, genetic engineering, not since the atom bomb has science had such potential to change the world. Canada, Mexico, and the United States have created a trilateral taskforce, The North American Biotechnology Advisory Commission, or NorBAC, to investigate questionable advances in the fields of biotechnology, bio-weaponry and nanotechnology.</p><p>Under the charismatic leadership of Chief Scientist David Sandstrom and Executive Director Caroline Morrison, the Toronto-based organisation struggles to understand the political, legal, and personal underbrush in which new science has become entangled.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 38,
      name: "The Movie Network",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2004-10-24",
  },
  {
    id: 470,
    url: "https://www.tvmaze.com/shows/470/the-prisoner",
    name: "The Prisoner",
    genres: ["Drama", "Science-Fiction", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9292.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9292.jpg",
    },
    summary:
      '<p>A British secret agent retires from his position... and is whisked away to a mysterious Village where people who know too much but can\'t be killed are kept for the security of the State. Which State? No one knows. The unnamed agent, dubbed "Number Six" since everyone in the Village, is only known by a number, defies the Village authorities and alternates between trying to escape and undermining his captors.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1967-10-01",
  },
  {
    id: 471,
    url: "https://www.tvmaze.com/shows/471/the-prisoner",
    name: "The Prisoner",
    genres: ["Drama", "Science-Fiction", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9294.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9294.jpg",
    },
    summary:
      "<p><b>The Prisoner</b> tells the story of a man, Six, who wakes up to find himself inexplicably trapped in a mysterious and surreal place, The Village, with no memory of how he arrived. As he frantically explores his new environment, he discovers that Village residents are identified by number, have no memory of any prior existence, and are under constant surveillance. The Village is controlled by one man - the sinister and charismatic Two . Throughout the series, Six and Two are locked in a battle of wits, as Six challenges the oppressive nature of The Village and struggles to learn the truth behind it.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 20,
      name: "AMC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-11-15",
  },
  {
    id: 472,
    url: "https://www.tvmaze.com/shows/472/x-men",
    name: "X-Men",
    genres: ["Children", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9295.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9295.jpg",
    },
    summary:
      "<p>With stories adapted directly from the original comic books, this show is a piece of Marvel history and a must-have for every X-Men fan. Discover the origins of your favorite characters and uncover the secrets of Magneto and more of the world's most diabolical villains in X-Men.</p><p>Due to budget issues and issues with animation production deadlines not been met most episodes from Season 3 onwards aired out of production order, leading to some storylines not making any sense and creating plot holes, however this was somewhat rectified later with the DVD and streaming releases.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1457,
      name: "Fox Kids",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1992-10-31",
  },
  {
    id: 473,
    url: "https://www.tvmaze.com/shows/473/veronica-mars",
    name: "Veronica Mars",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/204/512460.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/204/512460.jpg",
    },
    summary:
      "<p>In the wealthy, seaside community of Neptune, the rich and powerful make the rules. They own the town and are desperately trying to keep their dirty little secrets just that... secret. Unfortunately for them, there's Veronica Mars, a smart, fearless private investigator dedicated to solving the town's toughest mysteries. During the day, Veronica studies hard, but by night, she helps her father Keith with his private investigator business, sneaking through back alleys and scoping out no-tell motels with a telescopic-lens camera in an attempt to uncover the California beach town's darkest secrets.</p>",
    officialSite:
      "https://www.hulu.com/series/veronica-mars-4626972c-9da7-40fe-aed7-977f55f48fc5",
    webChannel: {
      id: 2,
      name: "Hulu",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2004-09-22",
  },
  {
    id: 474,
    url: "https://www.tvmaze.com/shows/474/charlies-angels",
    name: "Charlie's Angels",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9311.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9311.jpg",
    },
    summary:
      "<p>Once upon a time, Jill, Sabrina and Kelly were police officers whose skills were being wasted in menial duties such as answering phones and filing. A mysterious millionaire named Charles Townsend took them away from all that by opening his own private investigation agency and hiring these gorgeous ladies as his operatives with John Bosley acting as their assistant and liaison.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1976-09-22",
  },
  {
    id: 475,
    url: "https://www.tvmaze.com/shows/475/babylon-5",
    name: "Babylon 5",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/80/200201.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/80/200201.jpg",
    },
    summary:
      "<p>\"It was the dawn of the Third Age of Mankind ten years after the Earth-Minbari War The Babylon Project was a dream given form. Its goal: to prevent another war by creating a place where Humans and aliens could work out their differences peacefully. It's a port of call – home away from home for diplomats, hustlers, entrepreneurs, and wanderers. Humans and aliens wrapped in two million, five-hundred thousand tons of spinning metal, all alone in the night. It can be a dangerous place, but it's our last best hope for peace. This is the story of the last of the Babylon stations. The year is 2258. The name of the place is <b>Babylon 5</b>\".</p><p>A five season space opera written by J. Michael Straczynsky.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-02-22",
  },
  {
    id: 476,
    url: "https://www.tvmaze.com/shows/476/dead-set",
    name: "Dead Set",
    genres: ["Comedy", "Fantasy", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9335.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9335.jpg",
    },
    summary:
      "<p>Starring Jaime Winstone, <b>Dead Set</b> is E4's horror series in which the dead are returning to life and attacking the living. Curiously there are a few people left in Britain who aren't worried about any of this - that's because they're the remaining contestants in Big Brother. Cocooned in the safety of the Big Brother house, they're blissfully unaware of the horrific events unfolding in the outside world. Until an eviction night when all hell breaks loose...</p><p>Kelly, a production runner working on a fictional series of Big Brother, finds herself trying to fend off the walking dead alongside her producer boss Patrick, boyfriend Riq and the remaining Big Brother housemates. Featuring cameos from Davina McCall and several former housemates, this is a cruel and twisted take on one of TV's biggest game shows.</p>",
    officialSite: "http://www.channel4.com/programmes/dead-set",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 41,
      name: "E4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-10-27",
  },
  {
    id: 477,
    url: "https://www.tvmaze.com/shows/477/son-of-the-beach",
    name: "Son of the Beach",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9346.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9346.jpg",
    },
    summary:
      "<p>His unit may not be the biggest, but it's definitely the best...and the funniest! Notch Johnson is the world's greatest lifeguard, duty-bound to patrol and protect the shores of Malibu Adjacent with his crack team of sexy hardbodies. Together they keep the laughs coming...again and again...</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-03-14",
  },
  {
    id: 478,
    url: "https://www.tvmaze.com/shows/478/terminator-the-sarah-connor-chronicles",
    name: "Terminator: The Sarah Connor Chronicles",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/51/127822.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/51/127822.jpg",
    },
    summary:
      "<p>The mother of all destiny. Her son, the future leader of mankind. Their protector, a Terminator from the future. Together they must take back the future as Sarah Connor prepares her son to fight the war against machines determined to annihilate the human race. The clock is ticking. Can they stop Judgment Day?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-01-13",
  },
  {
    id: 479,
    url: "https://www.tvmaze.com/shows/479/witchblade",
    name: "Witchblade",
    genres: ["Action", "Crime", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9356.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9356.jpg",
    },
    summary:
      "<p>New York homicide detective Sara Pezzini doesn't know why the forces of the universe have chosen her to possess the awesome living weapon called the <b>Witchblade</b>. But it is hers to wear and to wield in the fight against crime, although it comes with a terrifying price. Evil foes seek the Witchblade, setting in motion an ongoing battle that may cost the lives of those Sara holds dearest.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-06-12",
  },
  {
    id: 480,
    url: "https://www.tvmaze.com/shows/480/birds-of-prey",
    name: "Birds of Prey",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/70/176012.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/70/176012.jpg",
    },
    summary:
      "<p>Who will stand up to villains now that a heartbroken Dark Knight has mysteriously vanished? Never fear, New Gothamites, a trio of champions is ready to take wing – and Helena, the daughter of Batman and Catwoman, is among them. She calls herself Huntress and crime is her prey. Teenaged Dinah is the youngest of the group, learning as she goes and gifted in clairvoyance. And overseeing the awesome threesome's high-tech nerve center is Batgirl. Left wheelchair-bound by The Joker, she has reinvented herself as Oracle, the team's cyber expert. Huntress, Dinah, Oracle: They are the <b>Birds of Prey</b>. Fighting together. Living together.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-10-09",
  },
  {
    id: 481,
    url: "https://www.tvmaze.com/shows/481/the-batman",
    name: "The Batman",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9370.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9370.jpg",
    },
    summary:
      "<p>Hidden in the shadows, The Batman casts a protective eye while tracking the thugs, thieves and criminal masterminds that claim Gotham City's dark alleys each night. In one magnificent swoop, he descends up on opponents and battles with a fierceness that seems almost inhuman. This is the young Bruce Wayne who assumes the role of Gotham's greatest defender in a fresh retelling of the Dark Knight's beginnings.</p><p>With incredible gadgets, awesome animation and a cool new vibe, these 13 exciting episodes from the hit series showcase The Batman taking on your favourite villains – The Joker, The Penguin, Mr. Freeze, Catwoman, Bane – and new crazies you'll love to hate!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-09-11",
  },
  {
    id: 482,
    url: "https://www.tvmaze.com/shows/482/masters-of-horror",
    name: "Masters of Horror",
    genres: ["Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9371.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9371.jpg",
    },
    summary:
      "<p>Chilling horror stories from the most prominent directors of the genre.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-10-28",
  },
  {
    id: 483,
    url: "https://www.tvmaze.com/shows/483/the-4400",
    name: "The 4400",
    genres: ["Drama", "Science-Fiction", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9372.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9372.jpg",
    },
    summary:
      "<p><b>The 4400</b> explores the travails of the 4400 people who all at once returned in a ball of light to Earth; though the returnees had not aged physically, many of them reappeared with dramatic abilities ranging from enhanced reflexes to precognition. NTAC (National Threat Assessment Command) is the government agency responsible for keeping track of the returnees and investigating all things related to the 4400.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-07-11",
  },
  {
    id: 484,
    url: "https://www.tvmaze.com/shows/484/painkiller-jane",
    name: "Painkiller Jane",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9387.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9387.jpg",
    },
    summary:
      "<p>In a very imaginable future, the world battles terrorism and unrest. Out of this chaos emerges a new hero: Jane Vasco, a.k.a. Painkiller Jane. Once the DEA's top agent, Jane Vasco is formidable, both mentally and physically. As a child, her father nicknamed her Painkiller Jane, describing her ability to mentally push through even the most painful situations. But her strength is about to be tested. Jane is recruited by a covert government agency dedicated to containing and, if necessary, neutralizing the threat of \"Neuros\" — individuals with superhuman neurological powers. No one knows what caused the aberrations that led to their enhanced abilities, which range from from telekinesis and telepathic suggestion to induced hallucinations. During her first investigation with her new team, Jane discovers that she too possesses an odd ability: she can't be killed. Unfortunately, she can still feel pain. Her newfound powers make Jane even more determined to learn everything there is to know about Neuros. Seldom malicious, Neuros often can't control their powers. Consequently, they tend to leave a trail of death and destruction. To prevent a panic, the government has kept the discovery of Neuros a secret, assembling a covert unit to identify and contain Neuros. Operating from a secure abandoned subway platform, the core members of the unit are Andre McBride, the seasoned team leader; Connor King, a special agent regularly armed with a smart remark; Riley Jensen, an evolved computer whiz in charge of surveillance and communications; Dr. Seth Carpenter, the unit's doctor and scientist; Joe Waterman, the middle-aged caretaker of the subway; and Maureen Bowers, Jane's former DEA partner and friend, who, like Jane, was recruited after discovering top-secret information about Neuros. Painkiller Jane is based on the comic-book series of the same name created by Jimmy Palmiotti and Joe Quesada.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-12-10",
  },
  {
    id: 485,
    url: "https://www.tvmaze.com/shows/485/day-break",
    name: "Day Break",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9395.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9395.jpg",
    },
    summary:
      "<p>Detective Brett Hopper is having a hellacious day; the kind of day where nothing goes his way and he just cant wait to put it behind him... only he cant, because hes living the same day over and over again.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-11-15",
  },
  {
    id: 486,
    url: "https://www.tvmaze.com/shows/486/andromeda",
    name: "Andromeda",
    genres: ["Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9402.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9402.jpg",
    },
    summary:
      "<p>Dylan Hunt is the courageous captain of the most glorious starship in the universe, the <b>Andromeda</b> Ascendant. After 300 years frozen in time at the event horizon of a black hole. Dylan Hunt wakes... to a universe in chaos. The Systems Commonwealth, the greatest civilization in history, has fallen. But together with an unlikely band of renegades and aliens who become his crew, Dylan begins his quest to rekindle the light of civilization and push back the evils that grip the universe!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-10-02",
  },
  {
    id: 487,
    url: "https://www.tvmaze.com/shows/487/harsh-realm",
    name: "Harsh Realm",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9412.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9412.jpg",
    },
    summary:
      "<p>A month before leaving the army, Lieutenant Tom Hobbes is rousted from bed in the middle of the night and taken to a secret location for one last mission: test a simulated virtual reality game used to teach situation war strategy. After being briefed on the top-secret project, code-named Harsh Realm, Hobbes is given his objective: eliminate Major Omar Santiago, who has taken the game hostage. But upon entering Harsh Realm, Hobbes discovers he is trapped there - and the deadly game will never end unless he completes his mission.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-10-08",
  },
  {
    id: 488,
    url: "https://www.tvmaze.com/shows/488/naruto-shippuuden",
    name: "Naruto: Shippuuden",
    genres: ["Action", "Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9413.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9413.jpg",
    },
    summary:
      "<p><b>Naruto: Shippuden</b> is the continuation of the original animated TV series Naruto.The story revolves around an older and slightly more matured Uzumaki Naruto and his quest to save his friend Uchiha Sasuke from the grips of the snake-like Shinobi, Orochimaru. After 2 and a half years Naruto finally returns to his village of Konoha, and sets about putting his ambitions to work, though it will not be easy, as he has amassed a few (more dangerous) enemies, in the likes of the shinobi organization; Akatsuki.</p>",
    officialSite: "http://www.tv-tokyo.co.jp/anime/naruto/index2.html",
    webChannel: {
      id: 20,
      name: "Crunchyroll",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "Japanese",
    status: "Ended",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2007-02-15",
  },
  {
    id: 489,
    url: "https://www.tvmaze.com/shows/489/sonic-boom",
    name: "Sonic Boom",
    genres: ["Comedy", "Action", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9460.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9460.jpg",
    },
    summary:
      "<p><b>Sonic Boom</b> is a CGI animated show based on the massive popular game Sonic the Hedgehog.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 456,
      name: "Boomerang",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-08",
  },
  {
    id: 490,
    url: "https://www.tvmaze.com/shows/490/star-trek",
    name: "Star Trek",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/292/730791.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/292/730791.jpg",
    },
    summary:
      "<p>The original <b>Star Trek</b> series focuses on the 23rd century adventures of Captain James T. Kirk and the U.S.S. <i>Enterprise </i>(NCC-1701), a powerful interstellar spacecraft dispatched by Earth-based Starfleet Command to explore the galaxy. Kirk commands a crew of 430 men and women aboard his starship, which can travel at speeds surpassing the speed of light. Kirk's five-year mission—and his mandate from Starfleet—is to seek out new life and new civilizations, and to boldly go where no man has gone before.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1964-06-24",
  },
  {
    id: 491,
    url: "https://www.tvmaze.com/shows/491/star-trek-the-next-generation",
    name: "Star Trek: The Next Generation",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/292/730798.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/292/730798.jpg",
    },
    summary:
      "<p><b>Star Trek: The Next Generation</b> (TNG) focuses on the 24th century adventures of Captain Jean-Luc Picard aboard the U.S.S. Enterprise (NCC-1701-D). This incarnation of the famous starship is much larger than the one captained by James T. Kirk a century earlier, and, accordingly, it carries a larger crew complement: 1,012 men, women…and, surprisingly, children. This era's Starfleet Command believes that men and women are more likely to sign up for long-term exploratory missions if they think of their ship as home. Thus, Picard's crew enjoys many of the comforts they'd have otherwise left behind, including a wide variety of recreational opportunities, \"replicated\" food dishes to suit every palate, and quarters large enough to share with spouses and offspring. There are schools for the children and a bar (stocked with synthetic alcohol, or synthehol) where the adults can unwind. However, the ongoing mission—no longer limited to a mere five years—remains virtually the same as it was during Kirk's time: to seek out new life and new civilizations, and to boldly go where no one has gone before.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1987-09-28",
  },
  {
    id: 492,
    url: "https://www.tvmaze.com/shows/492/star-trek-voyager",
    name: "Star Trek: Voyager",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/292/730797.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/292/730797.jpg",
    },
    summary:
      "<p><b>Star Trek: Voyager</b> (VOY) focuses on the 24th century adventures of Captain Kathryn Janeway aboard the U.S.S. Voyager. Smaller than either Kirk's or Picard's starships—its crew complement is only 150—Voyager is fast and powerful, and has the ability to land on a planet's surface. It is one of the most technologically advanced vessels in Starfleet, utilizing computer circuitry that incorporates synthetic neural tissue. Ironically, Janeway's inaugural mission aboard Voyager was to be her last in the Alpha quadrant. While attempting to capture the crew of a renegade Maquis vessel, both her ship and that of the Maquis were pulled into the distant Delta quadrant by powerful alien technology. Unfortunately, there would be no similar \"express\" route to take them home again. Stranded 70,000 light-years from Earth, Janeway convinced the Maquis to join her Starfleet crew and serve together during the long voyage back to Federation space.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 70,
      name: "UPN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1995-01-16",
  },
  {
    id: 493,
    url: "https://www.tvmaze.com/shows/493/star-trek-deep-space-nine",
    name: "Star Trek: Deep Space Nine",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/163/407853.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/163/407853.jpg",
    },
    summary:
      "<p><b>Star Trek: Deep Space Nine</b> (DS9) focuses on the 24th century adventures of Captain Benjamin Sisko on space station Deep Space 9, an outpost situated near the mouth of a stable wormhole on the far reaches of explored space. Although Sisko commands Deep Space 9, the station actually belongs to the inhabitants of nearby Bajor, who requested Starfleet's protective presence after Bajoran freedom fighters put an end to the brutal Cardassian occupation of their world. Approximately a sixth of the station's 300 permanent residents are Starfleet personnel; there is also a sizable Bajoran militia presence. The rest of Deep Space 9's inhabitants are civilians, most of whom work in the station's Promenade, a kind of indoor marketplace. Initially, Sisko's mandate from Starfleet was to protect Bajor and the station from any hostiles who ventured into the area. But with the discovery of the nearby wormhole—a shortcut through space that leads directly to the uncharted Gamma quadrant—Sisko's mandate has expanded exponentially, as the region becomes the gateway to all manner of visitors, both friendly and extremely hostile.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-01-03",
  },
  {
    id: 494,
    url: "https://www.tvmaze.com/shows/494/v",
    name: "V",
    genres: ["Drama", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/91/227932.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/91/227932.jpg",
    },
    summary:
      "<p>Simultaneously appearing over every major city in the world, the Visitors (or <b>V</b>'s) arrived offering us the wonders of their technology and promoting peace. While the world quickly embraced the V's as saviors, an FBI Counter Terrorist Agent, and others making up the resistance group called The Fifth Column, quickly discovered that the Visitors are not who they said they were. Will humanity stop being fooled and realize the Visitors true intentions before it becomes too late and they take over Earth?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-11-03",
  },
  {
    id: 495,
    url: "https://www.tvmaze.com/shows/495/naruto",
    name: "Naruto",
    genres: ["Action", "Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/3/9744.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/3/9744.jpg",
    },
    summary:
      "<p><b>Naruto</b> closely follows the life of a boy who is feared and detested by the villagers of the hidden leaf village of Konoha. The distrust of the boy has little to do with the boy himself, but it's what's inside him that causes anxiety. Long before Naruto came to be, a Kyuubi (demon fox) with great fury and power waged war taking many lives. The battle ensued for a long time until a man known as the Fourth Hokage, Yondaime, the strongest ninja in Konoha, fiercely fought the Kyuubi. The fight was soon won by Yondaime as he sealed the evil demon in a human body. Thus the boy, Naruto, was born. As Naruto grows he decides to become the strongest ninja in Konoha in an effort to show everyone that he is not as they perceive him to be, but is a human being worthy of love and admiration. But the road to becoming Hokage, the title for the strongest ninja in Konoha, is a long and arduous one. It is a path filled with betrayal, pain, and loss; but with hard work, Naruto may achieve Hokage.</p>",
    officialSite: "http://www.tv-tokyo.co.jp/anime/naruto/index2.html",
    webChannel: {
      id: 20,
      name: "Crunchyroll",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "Japanese",
    status: "Ended",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2002-10-03",
  },
  {
    id: 496,
    url: "https://www.tvmaze.com/shows/496/100-things-to-do-before-high-school",
    name: "100 Things to Do Before High School",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31612.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31612.jpg",
    },
    summary:
      "<p><b>100 Things to Do Before High School</b> was created by Big Time Rush executive producer and creator Scott Fellows, this new show will follow three best friends as they navigate the highs and lows of middle school, with the help of a bucket list of adventures that help them overcome class cliques, terrifying bullies and clueless teachers. With real life and teen drama awaiting her after 8th grade graduation, CJ Parker has only a short time left to make the most of her middle school years. Together with her two lifelong best friends Fenwick and Crispo, she is determined to get the most out of this time, using an ever-expanding list of challenges as a guide. For this group, growing up means trying everything and taking chances while they still can.</p>",
    officialSite:
      "http://www.nick.com/videos/clip/100-things-to-do-before-high-school-clip-two.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-30",
  },
  {
    id: 497,
    url: "https://www.tvmaze.com/shows/497/strip-the-cosmos",
    name: "Strip the Cosmos",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/10309.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/10309.jpg",
    },
    summary:
      "<p>In each episode of <b>Strip the Cosmos</b>, stunning CGI strips major planets, moons, black holes, stars and galaxies of gases, minerals, rock, magma and gravitational force-fields – layer by layer – revealing the destiny, origins and structure of the universe. <i>Strip the Cosmos</i> will also explore fascinating mysteries including: What happens inside an exploding star?; Can you escape from being sucked into a black hole?; Do the insides of comets harbor life?; and can we travel through the cosmos inside an asteroid?</p>",
    officialSite: "http://www.sciencechannel.com/tv-shows/strip-the-cosmos/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 77,
      name: "Science",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-12",
  },
  {
    id: 498,
    url: "https://www.tvmaze.com/shows/498/dogs-of-war",
    name: "Dogs of War",
    genres: ["War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/10310.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/10310.jpg",
    },
    summary:
      "<p><b>Dogs of War</b> documents Jim and Lindsey Stanek, a married couple who started a nonprofit organization called Paws and Stripes, benefiting PTSD veterans paired with adopted dogs who help them adjust back to regular life after returning home from war. Each episode will feature the story of one or two veterans as they get matched with a potentially life-saving best friend and begin their journey out of darkness.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-11",
  },
  {
    id: 499,
    url: "https://www.tvmaze.com/shows/499/married-with-children",
    name: "Married... with Children",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/10311.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/10311.jpg",
    },
    summary:
      "<p><b>Married... with Children</b> follows the lives of Al Bundy, a once glorious high school football player turned hard-luck women's shoe salesman; his obnoxious wife, Peggy; their attractive, promiscuous, and clueless daughter, Kelly; and their girl-crazy, wisecracking son, Bud. Their neighbors are the upwardly-mobile Steve Rhoades and his feminist wife Marcy, who later gets remarried to Jefferson D'Arcy, a white-collar criminal who becomes her \"trophy husband\" and Al's sidekick.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1987-04-05",
  },
  {
    id: 500,
    url: "https://www.tvmaze.com/shows/500/mutant-x",
    name: "Mutant X",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/10319.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/10319.jpg",
    },
    summary:
      "<p>Protecting a world that doesn't know they exist. <b>Mutant X</b> is a team of human mutants who possess extraordinary powers as a result of genetic engineering. Like hundreds of other unsuspecting subjects, these people were altered in secret experiments conducted in a covert government project. Realising that events have spun out of control, the organization that created them is now hunting them down in an urgent \"product recall\". Mutant X's mission is to seek out their fellow new mutants, to help them come to terms with their astonishing abilities and protect them from their creators.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-10-06",
  },
  {
    id: 501,
    url: "https://www.tvmaze.com/shows/501/northern-exposure",
    name: "Northern Exposure",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/10327.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/10327.jpg",
    },
    summary:
      "<p>Fresh out of New York's Columbia University, cocky young Dr. Joel Fleischman is looking forward to his comfortable position in Alaska's largest city. Upon his arrival, Joel finds himself a fish-out-of-water as he's instead assigned to a tiny Alaskan village where the offbeat locals would love him to stay forever.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1990-07-12",
  },
  {
    id: 502,
    url: "https://www.tvmaze.com/shows/502/the-lost-world",
    name: "The Lost World",
    genres: ["Action", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/10831.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/10831.jpg",
    },
    summary:
      "<p>Determined to prove the existence of The Lost World, dashing adventurer and scholar Professor Edward Challenger mounts a British expedition team consisting of a mismatched group of enthusiasts, all with less than selfless reasons for making the journey. Traveling through the uncharted Amazon jungle to this prehistoric plateau, the group encounters incredible adventures: tribal headhunters, vicious ape men, giant crocodiles, and terrifying dinosaurs!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-04-03",
  },
  {
    id: 503,
    url: "https://www.tvmaze.com/shows/503/the-lost-room",
    name: "The Lost Room",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/10835.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/10835.jpg",
    },
    summary:
      "<p>A mysterious event at the Sunshine Motel caused ordinary things in Room 10 to transform into indestructible objects with extraordinary powers. Detective Joe Miller discovers the dangerous potential of these objects when his daughter becomes lost in the room. His only hope of saving her is to find The Key, but shadowy figures will stop at nothing to keep it - and the other objects - for themselves.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-12-11",
  },
  {
    id: 504,
    url: "https://www.tvmaze.com/shows/504/batman-beyond",
    name: "Batman Beyond",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/10842.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/10842.jpg",
    },
    summary:
      "<p><b>Batman Beyond</b> tells the story of Terry McGinnis was just an ordinary teenager...until his father was mysteriously murdered. Suspecting foul play at his father's company Wayne/Powers Corporation, Terry meets Bruce Wayne and learns a secret identity hidden for decades. Now too old to battle injustice, Wayne is a bitter shell of his former self and refuses to help. So Terry does what any brash young kid would do: steal the Batsuit and take matters into his own hands! Vowing to avenge his father's death, Terry dons the high-tech suit - tricked out with jetpacks for flying, a supersensitive microphone for eavesdropping and even camouflage capabilities - in search of his father's assassin.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-01-10",
  },
  {
    id: 505,
    url: "https://www.tvmaze.com/shows/505/justice-league-unlimited",
    name: "Justice League Unlimited",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/10846.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/10846.jpg",
    },
    summary:
      "<p>The New <b>Justice League Unlimited</b> consists of Superman, Batman, Wonder Woman, The Flash, Green Lantern, Martian Manhunter and Hawkgirl – they have all saved countless lives from unspeakable dangers, using their unique powers to fight evil on Earth and across the galaxy. And until now, they have all worked alone. But after an alien invasion that took their combined powers to defeat, these seven super heroes unite to become the Justice League.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-07-31",
  },
  {
    id: 506,
    url: "https://www.tvmaze.com/shows/506/charmed",
    name: "Charmed",
    genres: ["Drama", "Romance", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/258/646784.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/258/646784.jpg",
    },
    summary:
      '<p>The discovery that they are descendants of a long line of witches finds three sisters battling demons and warlocks - and occasionally each other.</p><p>When the beautiful Halliwell sisters inherit a house from their grandmother and discover a secret "Book Of Shadows," they learn that they each have a unique power. The strong-willed Prue can move objects, reserved Piper is able to freeze time, and the uninhibited Phoebe sees the future. Individually, each is strong, but it is only by putting aside their differences and banding together as the "Power of Three" that they will be able to protect the innocent and vanquish evil.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-10-07",
  },
  {
    id: 507,
    url: "https://www.tvmaze.com/shows/507/angels-in-america",
    name: "Angels in America",
    genres: ["Drama", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/10866.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/10866.jpg",
    },
    summary:
      "<p>Al Pacino, Meryl Streep and Emma Thompson lead an all-star cast in an epic movie event directed Mike Nichols and screenplay by Tony Kushner based on his Pulitzer Prize-winning play: <b>Angels in America</b>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-12-07",
  },
  {
    id: 508,
    url: "https://www.tvmaze.com/shows/508/the-grid",
    name: "The Grid",
    genres: ["Drama", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/10867.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/10867.jpg",
    },
    summary:
      "<p>Turner Network Television (TNT) and the BBC tackle one of the most dramatic issues of modern times-international terrorism-in THE GRID, an original limited series that explores both sides of the escalating war on terrorism.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-07-19",
  },
  {
    id: 509,
    url: "https://www.tvmaze.com/shows/509/mr-sunshine",
    name: "Mr. Sunshine",
    genres: ["Comedy", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11135.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11135.jpg",
    },
    summary:
      "<p>In <b>Mr. Sunshine</b>, Ben Donovan is a self-involved manager of a San Diego sports arena, the Sunshine Center, where curious mishaps and bizarre requests are nothing more than ordinary. Working alongside him is his boss and arena owner Crystal attractive, powerful and highly erratic; Alice the cute, tomboyish marketing director and Ben's friend with benefits; Alonzo a former basketball player, handsome and unbelievably happy; Ben's assistant, Heather, pretty, sweet, but terrifying because she once lit a boyfriend on fire; and Crystal's son, Roman, sweet-faced, clueless and Ben's newest employee.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-02-09",
  },
  {
    id: 510,
    url: "https://www.tvmaze.com/shows/510/breaking-in",
    name: "Breaking In",
    genres: ["Comedy", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/22035.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/22035.jpg",
    },
    summary:
      "<p>Contra Security, a high-tech security firm that takes extreme - and often questionable - measures to sell its protection services is corporate America's answer to \"The A-Team\", giving clients a sense of security by first ripping it away. In the opener, Contra's man of mystery owner, Oz, blackmails his newest recruit, computer hacker Cameron, to join his team. Cameron quickly learns that cracking into state-of-the-art security systems is a lot easier than dealing with his co-workers, including the alluring Melanie, prank-pulling Cash and competitive Josh.</p>",
    officialSite:
      "https://web.archive.org/web/20120701202417/http://www.fox.com/breakingin/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-04-06",
  },
  {
    id: 511,
    url: "https://www.tvmaze.com/shows/511/the-chicago-code",
    name: "The Chicago Code",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11142.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11142.jpg",
    },
    summary:
      "<p><b>The Chicago Code</b> follows the Windy City's most powerful and respected cops as they navigate the city's underbelly to fight crime and expose corruption.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-02-07",
  },
  {
    id: 512,
    url: "https://www.tvmaze.com/shows/512/up-all-night",
    name: "Up All Night",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11150.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11150.jpg",
    },
    summary:
      "<p>Determined not to compromise her career or cool reputation to the clichés of motherhood, Reagan Brinkley adjusts to life with a baby and returns to work with the support of her stay-at-home husband, Chris As if motherhood weren't enough, as a talk-show executive producer, Reagan must also tend to the endless needs of her friend and boss Ava an ambitious but vulnerable talk-show host. </p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-14",
  },
  {
    id: 513,
    url: "https://www.tvmaze.com/shows/513/the-nine-lives-of-chloe-king",
    name: "The Nine Lives of Chloe King",
    genres: ["Drama", "Action", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/90/226240.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/90/226240.jpg",
    },
    summary:
      "<p>This scripted action drama follows Chloe King, who is looking forward to celebrating her 16th birthday with her friends and single mother -- just like every other year - that is until she starts developing heightened abilities and discovers she's being pursued by a mysterious figure. Chloe soon learns she's part of an ancient race called the Mai, which has been hunted by human assassins for millennia - and that she may ultimately be their only hope for survival.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-06-14",
  },
  {
    id: 514,
    url: "https://www.tvmaze.com/shows/514/jessie",
    name: "Jessie",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/24/61588.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/24/61588.jpg",
    },
    summary:
      "<p><b>Jessie</b> is a comedy series about a small-town girl who leaves behind her Texas roots and finds a job in the Big Apple as nanny to a high-flying couple's four precocious kids.</p>",
    officialSite: "http://disneychannel.disney.com/jessie",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 78,
      name: "Disney Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-30",
  },
  {
    id: 515,
    url: "https://www.tvmaze.com/shows/515/the-borgias",
    name: "The Borgias",
    genres: ["Drama", "Romance", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/306/765764.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/306/765764.jpg",
    },
    summary:
      "<p>This expansive drama series stars Oscar winner Jeremy Irons in his Golden Globe-nominated role as Pope Alexander VI, the cunning, manipulative patriarch of the infamous Borgia dynasty, who builds an empire by bribing, buying and muscling his way into the papacy.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-04-03",
  },
  {
    id: 516,
    url: "https://www.tvmaze.com/shows/516/terra-nova",
    name: "Terra Nova",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/31/79577.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/31/79577.jpg",
    },
    summary:
      "<p>From executive producers Steven Spielberg Peter Chernin, René Echevarria and Brannon Braga comes an epic family adventure 85 million years in the making. <b>Terra Nova </b>follows an ordinary family on an incredible journey back in time to prehistoric Earth as a small part of a daring experiment to save the human race. In the year 2149, the world is dying. The planet is overdeveloped and overcrowded, with the majority of plant and animal life extinct. The future of mankind is in jeopardy, and its only hope for survival is in the distant past. When scientists at the FERMI Particle Accelerator unexpectedly discovered a fracture in time that made it possible to construct a portal into primeval history, the bold notion was born to resettle humanity in the past - a second chance to rebuild civilization and get it right this time.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-26",
  },
  {
    id: 517,
    url: "https://www.tvmaze.com/shows/517/psych",
    name: "Psych",
    genres: ["Drama", "Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11255.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11255.jpg",
    },
    summary:
      "<p><b>Psych</b> is a quick-witted comedy starring James Roday as young police consultant Shawn Spencer, who solves crimes with powers of observation so acute that Santa Barbara PD detectives think he's psychic. <i>Psych</i> also stars Dule Hill as Shawn's best friend and reluctant sidekick, Gus, and Corbin Bernsen as Shawn's disapproving father, Henry, who ironically was the one who honed his son's \"observation\" skills as a child.</p>",
    officialSite: "http://www.usanetwork.com/psych",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-07-07",
  },
  {
    id: 518,
    url: "https://www.tvmaze.com/shows/518/bad-girls-club",
    name: "Bad Girls Club",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11274.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11274.jpg",
    },
    summary:
      "<p>This season on <b>Bad Girls Club</b>, the best of the bad move into a LA mansion, ready to ride the rocky road to change, while making new friends and facing off with old enemies along the way. Life coach Laura returns to help each girl empower themselves, curb their temper and reach their personal goals and aspirations, but will old habits die hard or will these alpha females be ready to change for the better?</p>",
    officialSite: "http://www.oxygen.com/bad-girls-club",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 79,
      name: "Oxygen",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-12-05",
  },
  {
    id: 519,
    url: "https://www.tvmaze.com/shows/519/preachers-of-la",
    name: "Preachers of L.A.",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/12384.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/12384.jpg",
    },
    summary:
      "<p>Season two is full of self-discovery and change with growing families and ministries, incredible women of strength beside them, and ever-changing relationships. Bishop Jones and Loretta's relationship is still evolving, but Bishop Gibson and Lady LaVette's strong convictions keep them from accepting the nature of their friends' close bond, causing a devastating rift. With his focus on ministry and not his personal life, Bishop Jones enlists the help of his fellow preachers to create an event that will positively impact the community of Los Angeles. Meanwhile, after much turmoil, Deitrick and Dominique are now married and have a new addition to their family - but their marital bliss is short-lived when Pastor Jay accuses Deitrick of deceiving him at their wedding. Family dynamics are also rocked when Pastor Jay and Christy's relationship is put to the test as Pastor Jay struggles to forgive a family member for their past demons. Bishop McClendon is focused on the expansion of his new ministry in Atlanta, but he is challenged when he must deal with every father's fear-giving his daughter away to another man. Pastor Wayne Chaney and First Lady Myesha must balance business with personal now that she is the newly appointed Executive Pastor of their church. And while Myesha is feeling better than ever after getting healthy and shedding 40 pounds, the couple struggles with a life-altering decision about the future of their family.</p>",
    officialSite: "http://www.oxygen.com/preachers-of-la",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 79,
      name: "Oxygen",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-10-09",
  },
  {
    id: 520,
    url: "https://www.tvmaze.com/shows/520/lie-to-me",
    name: "Lie to Me",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11275.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11275.jpg",
    },
    summary:
      "<p>This compelling new drama series stars Tim Roth as Dr. Cal Lightman, the world's leading deception expert who studies facial expressions and involuntary body language to discover not only if someone is lying, but why. Based on the real-life scientific discoveries of Dr. Paul Ekman, the series follows Lightman and his team of deception experts as they assist law enforcement and government agencies to expose the truth behind the lies.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-01-21",
  },
  {
    id: 521,
    url: "https://www.tvmaze.com/shows/521/the-real-housewives-of-new-jersey",
    name: "The Real Housewives of New Jersey",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/205/514752.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/205/514752.jpg",
    },
    summary:
      "<p>There won't be any lazy days of summer with Bravo Media's <b>The Real Housewives of New Jersey</b>, returning for its much anticipated seventh season. Teresa Giudiceand Melissa Gorga are joined by new Housewives, Dolores Catania and Siggy Flicker, along with the return of a true Jersey veteran, Jacqueline Laurita. Also appearing this season are sisters Kathy Wakile and Rosie Pierri.</p><p>This season, Teresa looks to repair fractured relationships with her family and friends. Although her release from prison brings the Giudice family back together, the reunion is short-lived as they only have a few months before Joe begins his sentence. After growing closer to the Gorga family while Teresa was away, Melissa now fears it may all crumble and hopes she can start fresh with her sister-in-law, permanently putting the past behind them. Meanwhile, Jacqueline, whose main focus continues to be helping her autistic son, longs for the \"Lucy and Ethel\" friendship she had with Teresa and is willing to bury their history if it means a more lighthearted future. Teresa and Jacqueline's longtime friend, Dolores, is a divorced mom of two, focusing on a road toward independence as she emotionally and financially recovers from two failed relationships. Siggy, another friend of Jacqueline's, fits right in with the Jersey group with her dynamic personality and high energy, as she navigates her relationships with her children who find her overbearing at times. But just as these five 'Wives begin to form strong bonds, relationships are on the verge of breaking – and when old friends meet new friends, it may mean no friends for some.</p>",
    officialSite: "http://www.bravotv.com/the-real-housewives-of-new-jersey",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-05-12",
  },
  {
    id: 522,
    url: "https://www.tvmaze.com/shows/522/top-gear",
    name: "Top Gear",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/243/608020.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/243/608020.jpg",
    },
    summary:
      "<p><b>Top Gear</b> is a British television series about motor vehicles, primarily cars, and the most widely watched factual television programme in the world.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006mj59",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2002-10-20",
  },
  {
    id: 523,
    url: "https://www.tvmaze.com/shows/523/the-west-wing",
    name: "The West Wing",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11284.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11284.jpg",
    },
    summary:
      "<p>The entire White House staff bristles with activity when it's learned that the President injured himself during a bicycle accident, and his absence becomes a factor as chief of staff Leo McGarry must juggle a host of impending crises, including a mass boatlift of Cuban refugees approaching the Florida coast and the reaction of conservative Christians to a controversial televised comment by deputy chief of staff Josh Lyman.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-09-22",
  },
  {
    id: 524,
    url: "https://www.tvmaze.com/shows/524/moonshiners",
    name: "Moonshiners",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11289.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11289.jpg",
    },
    summary:
      "<p>The secret and illegal world of moonshining stretches all across Appalachia raking in a pretty penny for those who choose to shine. <b>Moonshiners</b> will go to unprecedented extremes in their efforts to hide their still sites and cloak their distribution networks, some can hide in plain sight. With new styles of shine being tested and sold there is a king's ransom waiting for those bold enough to grab it. But those who enforce the law are wise to shiner deceptions and more determined than ever to catch them red handed and in the act of making Moonshine. The day of reckoning may be around the corner, but don't sell the Moonshiners short. Each has a keen understanding of how to stay one step ahead of the law in their region, and in this ongoing cat and mouse game you never know who will end up in the trap.</p>",
    officialSite: "http://www.discovery.com/tv-shows/moonshiners/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-12-06",
  },
  {
    id: 525,
    url: "https://www.tvmaze.com/shows/525/gilmore-girls",
    name: "Gilmore Girls",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11308.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11308.jpg",
    },
    summary:
      "<p><b>Gilmore Girls</b> is a drama centering around the relationship between a thirtysomething single mother and her teen daughter living in Stars Hollow, Connecticut.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-10-05",
  },
  {
    id: 526,
    url: "https://www.tvmaze.com/shows/526/the-office",
    name: "The Office",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11322.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11322.jpg",
    },
    summary:
      "<p>Steve Carell stars in <b>The Office</b>, a fresh and funny mockumentary-style glimpse into the daily interactions of the eccentric workers at the Dunder Mifflin paper supply company. Based on the smash-hit British series of the same name and adapted for American Television by Greg Daniels, this fast-paced comedy parodies contemporary American water-cooler culture. Earnest but clueless regional manager Michael Scott believes himself to be an exceptional boss and mentor, but actually receives more eye-rolls than respect from his oddball staff.</p>",
    officialSite: "http://www.nbc.com/the-office",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-03-24",
  },
  {
    id: 527,
    url: "https://www.tvmaze.com/shows/527/the-sopranos",
    name: "The Sopranos",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11341.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11341.jpg",
    },
    summary:
      "<p><b>The Sopranos</b>, writer-producer-director David Chase's extraordinary television series, is nominally an urban gangster drama, but its true impact strikes closer to home: Like 1999's other screen touchstone, American Beauty, the HBO series chronicles a dysfunctional, suburban American family in bold relief. And for protagonist Tony Soprano, there's the added complexity posed by heading twin families, his collegial mob clan and his own, nouveau riche brood.</p>",
    officialSite: "http://www.hbo.com/the-sopranos",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-01-10",
  },
  {
    id: 528,
    url: "https://www.tvmaze.com/shows/528/the-flash",
    name: "The Flash",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11360.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11360.jpg",
    },
    summary:
      "<p>The Flash is Barry Allen, a police scientist, who was working one night during a terrible thunder storm when a bolt of lightning crashes through the lab window, electrocuting him. Barry survives and soon learns that he is now able to move at almost incomprehensible speed.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1990-09-20",
  },
  {
    id: 529,
    url: "https://www.tvmaze.com/shows/529/cupcake-wars",
    name: "Cupcake Wars",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11364.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11364.jpg",
    },
    summary:
      "<p>In <b>Cupcake Wars</b> the créme de la créme of the cupcake world take their skills to the next level when they return to Food Network for the sweetest competition yet in five-part special series Cupcake Champions premiering Sunday, May 13th at 8pm ET/PT. Each week, four previous Cupcake Wars winners face off in three tasty elimination challenges until only one decorator remains and wins the opportunity to showcase their cupcakes at the winning gig. For the four winners from each episode, the competition for the coveted title of Cupcake Champion and a $50,000 cash prize culminates in the finale.</p>",
    officialSite: "http://www.foodnetwork.com/shows/cupcake-wars.html",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 174,
      name: "Cooking Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-06-13",
  },
  {
    id: 530,
    url: "https://www.tvmaze.com/shows/530/seinfeld",
    name: "Seinfeld",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/301/752548.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/301/752548.jpg",
    },
    summary:
      "<p><b>Seinfeld</b> is the story of a fictionalized version of stand-up comedian Jerry Seinfeld, his life in New York City and his quirky group of friends who join him in wrestling with life's most perplexing, yet often trivial questions. Often described as \"a show about nothing,\" Seinfeld mines the humor in life's mundane situations like waiting in line, searching for a lost item, or the trials and tribulations of dating.</p>",
    officialSite: "http://www.sonypictures.com/tv/seinfeld/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1989-07-05",
  },
  {
    id: 531,
    url: "https://www.tvmaze.com/shows/531/breaking-amish",
    name: "Breaking Amish",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/82/206571.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/82/206571.jpg",
    },
    summary:
      "<p><b>Breaking Amish</b> follows a fresh group of young men and women as they leave their conservative, rural communities behind for a chance to live in New York and fully experience English life. The new cast of five heads to Brooklyn, N.Y., to explore life beyond their Amish culture. Throughout their journey, their relationships are tested and life-altering choices must be made. By leaving their communities, they risk changing their lives and ties with their families for good, but they all believe that the chance to live in New York and pursue their dreams is well worth it.</p><p>This season presents new and different challenges as the cast adjusts to life in Brooklyn, where the cultures are countless and the temptations are at an all-time high. Using this opportunity to find themselves, the cast navigates through the nuances of the Brooklyn lifestyle and also makes time to visit the famous New York City landmarks to enjoy all the English things that the city has to offer. While they all have similar, conservative backgrounds, they must get used to not only a new city, but also each other and endure growing pains along the way. The trip to Brooklyn chronicles the tough decisions they must make to leave their families and friends behind.</p>",
    officialSite: "http://www.tlc.com/tv-shows/breaking-amish/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-09-09",
  },
  {
    id: 532,
    url: "https://www.tvmaze.com/shows/532/scrubs",
    name: "Scrubs",
    genres: ["Drama", "Comedy", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11371.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11371.jpg",
    },
    summary:
      "<p>Fresh out of medical school, new doctors John \"J.D.\" Dorian, his best friend Christopher Turk, and Elliot Reid start their internship at Sacred Heart Hospital. There, they meet the harsh Chief of Medicine Dr. Bob Kelso, J.D.'s reluctant mentor Dr. Perry Cox, nurse Carla Espinosa, and the deceitful and prankish Janitor. Also at the hospital are the wide range of personalities of Sacred Heart's staff, including the religious nurse Laverne Roberts, incompetent lawyer Ted Buckland, and spiteful board member Jordan Sullivan who also happens to be Cox's ex-wife. Other interns make the cut, such as the high-fiving Todd Quinlan and nervous Doug Murphy. Over the next 9 years they face personal and professional highs and lows, realizing that they can't make it through life - much less a hectic job as a doctor - on their own.</p>",
    officialSite: "http://abc.go.com/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-10-02",
  },
  {
    id: 533,
    url: "https://www.tvmaze.com/shows/533/instant-mom",
    name: "Instant Mom",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/306/766262.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/306/766262.jpg",
    },
    summary:
      "<p><b>Instant Mom</b> is scripted half-hour comedy series that follows Stephanie, a former party girl who becomes a full-time stepmom to three kids when she marries the more traditional Charlie. Stephanie manages to keep it all together using her own unique style, never losing her sense of fun, and with the help of her mother Maggie, she learns what being a mom really means.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 57,
      name: "TV Land",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-29",
  },
  {
    id: 534,
    url: "https://www.tvmaze.com/shows/534/pawn-stars",
    name: "Pawn Stars",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/171/429547.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/171/429547.jpg",
    },
    summary:
      "<p>Long before banks, ATMS and check-cashing services, there were pawn shops. Pawning was the leading form of consumer credit in the United States until the 1950s, and pawn shops are still helping everyday people make ends meet. <b>Pawn Stars</b> takes you inside the colorful world of the pawn business. At the Gold &amp; Silver Pawn Shop on the outskirts of Las Vegas, three generations of the Harrison family - grandfather Richard, son Rick and grandson Corey - jointly run the family business, and there's clashing and camaraderie every step of the way. The three men use their sharp eyes and skills to assess the value of items from the commonplace to the truly historic, including a 16th-century samurai sword, a Super Bowl ring, a Picasso painting and a 17th-century stay of execution. It's up to them to determine what's real and what's fake, as they reveal the often surprising answer to the questions on everyone's mind, \"What's the story behind it?\" and \"What's it worth?\"</p>",
    officialSite: "http://www.history.com/shows/pawn-stars",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-07-19",
  },
  {
    id: 535,
    url: "https://www.tvmaze.com/shows/535/anthony-bourdain-no-reservations",
    name: "Anthony Bourdain: No Reservations",
    genres: ["Food", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11386.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11386.jpg",
    },
    summary:
      "<p>In his Emmy Award winning series, Anthony Bourdain travels the globe to explore the cities, villages and countries that offer life's truest surprises.</p>",
    officialSite: "http://www.travelchannel.com/shows/anthony-bourdain",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 82,
      name: "Travel Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-07-25",
  },
  {
    id: 536,
    url: "https://www.tvmaze.com/shows/536/whose-line-is-it-anyway",
    name: "Whose Line Is It Anyway?",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11387.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11387.jpg",
    },
    summary:
      "<p><b>Whose Line Is It Anyway?</b> features cast members who, along with a special guest each episode, must put their comedic skills to the test through a series of spontaneous improv games, prompted only by random ideas supplied by the studio audience.</p>",
    officialSite: "http://cwseed.com/shows/whose-line-is-it-anyway",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-08-05",
  },
  {
    id: 537,
    url: "https://www.tvmaze.com/shows/537/30-rock",
    name: "30 Rock",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/64/160233.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/64/160233.jpg",
    },
    summary:
      "<p>Multiple award-winning comedy <b>30 Rock</b> is told through the comedic voice of Emmy and two-time Golden Globe winner Tina Fey as variety show producer Liz Lemon. The series also features two-time Emmy and three-time Golden Globe winner Alec Baldwin as top network executive Jack Donaghy and Emmy nominee Tracy Morgan as Tracy Jordan, the unpredictable star of Lemon's hit variety show, TGS with Tracy Jordan, Lemon constantly has her hands full, juggling corporate interference from Donaghy and off-the-handle star antics from Jordan, all while attempting to salvage her own personal life.</p>",
    officialSite: "http://www.nbc.com/30-rock",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-10-11",
  },
  {
    id: 538,
    url: "https://www.tvmaze.com/shows/538/futurama",
    name: "Futurama",
    genres: ["Comedy", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11403.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11403.jpg",
    },
    summary:
      "<p><b>Futurama</b> follows pizza guy Philip J. Fry, who reawakens in 31st century New New York after a cryonics lab accident. Now part of the Planet Express delivery crew, Fry travels to the farthest reaches of the universe with his robot buddy Bender and cyclopsian love interest Leela, discovering freaky mutants, intergalactic conspiracies and other strange stuff.</p>",
    officialSite: "http://www.cc.com/shows/futurama",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-03-28",
  },
  {
    id: 539,
    url: "https://www.tvmaze.com/shows/539/the-it-crowd",
    name: "The IT Crowd",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11405.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11405.jpg",
    },
    summary:
      "<p>Emmy-award winning sitcom written by Graham Linehan, set in an IT department starring Chris O'Dowd, Richard Ayoade and Katherine Parkinson.</p>",
    officialSite: "http://www.channel4.com/programmes/the-it-crowd",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-02-03",
  },
  {
    id: 540,
    url: "https://www.tvmaze.com/shows/540/frasier",
    name: "Frasier",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/238/596647.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/238/596647.jpg",
    },
    summary:
      "<p><b>Fraiser</b> is a half-hour comedy series set in Seattle, which chronicles the lives of an eloquently pompous radio show host Dr. Frasier Crane, his brazen radio producer Roz and his competitive, high-brow brother Niles.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-09-16",
  },
  {
    id: 541,
    url: "https://www.tvmaze.com/shows/541/prison-break",
    name: "Prison Break",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/104/261034.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/104/261034.jpg",
    },
    summary:
      "<p>Lincoln Burrows is currently on death row and scheduled to die in a few months for an assassination his younger brother Michael is convinced he did not commit. With no other options and time winding down, Michael takes drastic measures to get himself incarcerated alongside his brother in Fox River State Penitentiary. Once he's inside, Michael - a structural engineer with the blueprints for the prison - begins to execute an elaborate plan to break Lincoln out and prove him innocent. When Michael arrives at Fox River State Penitentiary, he meets the prison denizens who will, unknowingly, help in his escape plans - his cellmate, the lovelorn Sucre; beautiful prison doctor Dr. Sara Tancredi, who happens to be the governor's daughter; former mob boss John Abruzzi; and Warden Henry Pope. Meanwhile, outside the prison walls, the brothers' childhood friend and Lincoln's lost love, attorney Veronica Donovan, works within the law to free them; Lincoln's teenage son LJ may be going down a path similar to his convicted father's; and Secret Service Agent Paul Kellerman's investigation into Lincoln's case proves that there may be a national conspiracy.</p>",
    officialSite: "http://www.fox.com/prisonbreak",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-08-29",
  },
  {
    id: 542,
    url: "https://www.tvmaze.com/shows/542/eureka",
    name: "Eureka",
    genres: ["Drama", "Comedy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/183/459344.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/183/459344.jpg",
    },
    summary:
      "<p>With the help of Albert Einstein and other trusted advisors, President Harry S. Truman commissioned a top-secret residential development in a remote area of the Pacific Northwest, one that would serve to protect and nurture America's most valuable intellectual resources. There our nation's greatest thinkers, the über-geniuses working on the next era of scientific achievement, would be able to live and work in a supportive environment.</p><p>The best architects and planners were commissioned to design a welcoming place for these superlative geniuses to reside, an area that would offer the best education for their children, the best healthcare, the best amenities and quality of life. A community was created to rival the most idyllic of America's small towns— with one major difference: this town would never appear on any maps. At least, none that haven't been classified \"eyes only\" by the Pentagon.</p><p>Thus, the town of <b>Eureka</b> was born. But for all its familiar, small-town trappings, things in this secret hamlet are anything but ordinary. The stereotype of the absent-minded professor exists for a reason, and most of the quantum leaps in science and technology during the past 50 years were produced by Eureka's elite researchers. Unfortunately, scientific exploration is rarely what one expects, and years of experiments gone awry have yielded some peculiar by-products.</p><p>With the population's unique talents, troubled psyches and limitless resources, these small-town concerns have a way of becoming big-time problems. It is at that intersection, where human frailty and super-science collide, that Eureka began…</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-07-18",
  },
  {
    id: 543,
    url: "https://www.tvmaze.com/shows/543/monk",
    name: "Monk",
    genres: ["Drama", "Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11451.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11451.jpg",
    },
    summary:
      "<p>An ex-cop suffering from obsessive-compulsive disorder solves crimes with various (and usually exasperated) sidekicks. The 'defective detective' may have an abundance of phobias (heights, crowds, and even milk), but also razor-sharp deductive skills, which he uses to help the San Francisco police with especially baffling cases.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-07-12",
  },
  {
    id: 544,
    url: "https://www.tvmaze.com/shows/544/home-improvement",
    name: "Home Improvement",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11457.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11457.jpg",
    },
    summary:
      '<p>The universal themes of family, parenting, the battle of the sexes -- and of course, man\'s need for "more power" -- come to play each and every weekday on <b>Home Improvement</b>. Every episode finds Tim the "Tool Man" Taylor causing his share of goof-ups and mishaps and leaving his long-suffering wife, Jill, family and friends to mop up the mess.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1991-09-17",
  },
  {
    id: 545,
    url: "https://www.tvmaze.com/shows/545/halo-nightfall",
    name: "Halo: Nightfall",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11467.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11467.jpg",
    },
    summary:
      "<p>A strange and treacherous world exposes elite UNSC operatives to a much deeper danger. Halo: Nightfall is a live action series from 343 Industries and Scott Free Productions.</p>",
    officialSite: null,
    webChannel: { id: 10, name: "XBOX Live", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2014-11-11",
  },
  {
    id: 546,
    url: "https://www.tvmaze.com/shows/546/babylon",
    name: "Babylon",
    genres: ["Drama", "Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11489.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11489.jpg",
    },
    summary:
      "<p>Razor-sharp comedy drama that takes a wry look at the people and politics of London's police force. With James Nesbitt and Brit Marling.</p>",
    officialSite:
      "https://web.archive.org/web/20180618022047/https://www.channel4.com/programmes/babylon",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-02-09",
  },
  {
    id: 547,
    url: "https://www.tvmaze.com/shows/547/er",
    name: "ER",
    genres: ["Drama", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11490.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11490.jpg",
    },
    summary:
      "<p><b>ER</b> explores the inner workings of an urban teaching hospital and the critical issues faced by the dedicated physicians and staff of its overburdened emergency room. The highly acclaimed drama series holds the distinction of being recognized as the most Emmy-nominated series in the history of television.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1994-09-19",
  },
  {
    id: 548,
    url: "https://www.tvmaze.com/shows/548/skins",
    name: "Skins",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11516.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11516.jpg",
    },
    summary:
      "<p>Irreverent comedy drama from the makers of <i>Shameless</i>, which follows the messy lives, loves, delirious highs and inevitable lows of a group of raucous teenage friends in Bristol.</p>",
    officialSite: "http://www.channel4.com/programmes/skins",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 41,
      name: "E4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2007-01-25",
  },
  {
    id: 549,
    url: "https://www.tvmaze.com/shows/549/will-grace",
    name: "Will & Grace",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/215/539636.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/215/539636.jpg",
    },
    summary:
      "<p>Every straight girl needs a gay best friend, and interior designer Grace Adler found an ultimate accessory in her lawyer pal Will Truman. It's through this neurotic pair that the show's real stars -- Jack &amp; Karen - come together. \"Just Jack\" McFarland and his boozy, pill-popping sidekick Karen Walker fill in the foursome that made <b>Will &amp; Grace</b> classic TV and brought primetime to a whole new level of fabulous, while also winning 16 Emmy Awards in the process. With show-stopping guest appearances by Cher, Madonna, Britney, Janet, J-Lo, Ellen, Elton and most every gay icon under the sun, the milestones that Will &amp; Grace hit provided a foundation for all LGBT portrayals on TV today.</p>",
    officialSite: "https://www.nbc.com/will-and-grace",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-09-21",
  },
  {
    id: 550,
    url: "https://www.tvmaze.com/shows/550/desperate-housewives",
    name: "Desperate Housewives",
    genres: ["Drama", "Comedy", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11549.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11549.jpg",
    },
    summary:
      "<p>In the town of Fairview there's a street called Wisteria Lane; a peaceful cul-de-sac with manicured lawns and beautiful houses. It's a place where you know all your neighbors and your neighbors know all about you. It's the perfect suburban fantasy. But, behind every picket fence there are secrets. And, in every seemingly happy home, you'll find jealousy, lust, passion, and sometimes…murder.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-10-03",
  },
  {
    id: 551,
    url: "https://www.tvmaze.com/shows/551/curb-your-enthusiasm",
    name: "Curb Your Enthusiasm",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/231/577597.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/231/577597.jpg",
    },
    summary:
      "<p><b>Curb Your Enthusiasm</b> stars <i>Seinfeld</i> co-creator Larry David as himself in an unsparing but tongue-in-cheek depiction of his life. Shot in a verite style and featuring celebrities playing themselves, the episodes are improvised by the actors from an outline created by David.</p>",
    officialSite: "http://www.hbo.com/curb-your-enthusiasm",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-10-15",
  },
  {
    id: 552,
    url: "https://www.tvmaze.com/shows/552/the-king-of-queens",
    name: "The King of Queens",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/94/235537.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/94/235537.jpg",
    },
    summary:
      "<p>Set in the working-class suburb of Queens, New York, the show follows Doug Heffernan, an amiable deliveryman, and his wife, spitfire secretary Carrie Heffernan, as they explore the everyday challenges of love, life, family and marriage.</p>",
    officialSite: "http://www.sonypictures.com/tv/thekingofqueens/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-09-21",
  },
  {
    id: 553,
    url: "https://www.tvmaze.com/shows/553/cheers",
    name: "Cheers",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/96/241434.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/96/241434.jpg",
    },
    summary:
      "<p><b>Cheers</b> takes viewers back to the Boston bar where everybody knows your name. As former baseball star Sam Malone and his colleague Diane Chambers fight their mutual attractions, they cater to their regulars including Norm Petersen and Cliff Claven. Talking about their problems, laughing at each other's flaws and trying to be there when someone needs them, the gang are joined by naïve farm boy Woody, bitter waitress Carla , troubled psychiatrist Frasier and his wife.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1982-09-30",
  },
  {
    id: 554,
    url: "https://www.tvmaze.com/shows/554/dark-angel",
    name: "Dark Angel",
    genres: ["Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11610.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11610.jpg",
    },
    summary:
      "<p>In the year 2019 the U.S. has become a third world country in the wake of the Pulse - an electromagnetic shockwave unleashed by nuclear terrorists in 2009. This is Max's world, an unforgiving place even for a genetically engineered soldier like her. On the run from her creators and constantly in search of her past, Max joins forces with the idealistic cyberjournalist \"Eyes Only\". She's a revved-up girl trying to make a run-down world a better place.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-10-03",
  },
  {
    id: 555,
    url: "https://www.tvmaze.com/shows/555/avatar-the-last-airbender",
    name: "Avatar: The Last Airbender",
    genres: ["Action", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/79/199224.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/79/199224.jpg",
    },
    summary:
      "<p>Water. Earth. Fire. Air. Only the Avatar was the master of all four elements. Only he could stop the ruthless Fire Nation from conquering the world. But when the world needed him most, he disappeared. Until now... On the South Pole, a lone Water Tribe village struggles to survive. It's here that a young Waterbender named Katara and her warrior brother Sokka rescue a strange boy named Aang from a cavernous iceberg. Not only is Aang an Airbender--a race of people no one has seen in a century--but they soon discover that Aang is also the long lost Avatar. Now it's up to Katara and Sokka to make sure Aang faces his destiny to save the tribe--and himself. Did we mention he's only 12?</p>",
    officialSite: "https://www.nick.com/shows/avatar",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-02-21",
  },
  {
    id: 556,
    url: "https://www.tvmaze.com/shows/556/wilfred",
    name: "Wilfred",
    genres: ["Drama", "Comedy", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11623.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11623.jpg",
    },
    summary:
      "<p>Everyone else sees Wilfred as a dog, but Ryan sees a crude, surly, irrepressibly brave and honest man in a dog suit.</p>",
    officialSite: "http://www.fxnetworks.com/wilfred",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 47,
      name: "FXX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-06-23",
  },
  {
    id: 557,
    url: "https://www.tvmaze.com/shows/557/alias",
    name: "Alias",
    genres: ["Drama", "Action", "Espionage"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11627.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11627.jpg",
    },
    summary:
      "<p>Sydney Bristow is not exactly your average grad student. Her life might appear normal, but she's hiding a secret life working as a spy for the CIA.</p><p>Sydney's world is turned upside down when she learns she may work for the very enemy she thought she was fighting. Now she's entangled in a covert lifestyle where she is forced to question the allegiances of everyone, including those closest to her.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-09-30",
  },
  {
    id: 558,
    url: "https://www.tvmaze.com/shows/558/persons-unknown",
    name: "Persons Unknown",
    genres: ["Drama", "Thriller", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11645.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11645.jpg",
    },
    summary:
      "<p><b>Persons Unknown</b> is a one-hour mystery drama in which a group of strangers must come together to solve the puzzle of their lives.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-06-07",
  },
  {
    id: 559,
    url: "https://www.tvmaze.com/shows/559/entourage",
    name: "Entourage",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11656.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11656.jpg",
    },
    summary:
      "<p>The hit comedy series that takes a look at the day-to-day life of Vincent (Vince) Chase, a hot young actor in Hollywood, and his inner circle. He's brought with him from their hometown in Queens, NY: manager Eric, half-brother Drama, and friend Turtle. The series draws on the experiences of industry insiders to illustrate both the heady excesses of today's celebrity lifestyle, as well as the highs and lows of love and success in show biz. Eric, along with super-agent Ari, keep Vince's star rising while making sound decisions for a long-lasting career in a world of fleeting fame.</p>",
    officialSite: "http://www.hbo.com/entourage",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-07-18",
  },
  {
    id: 560,
    url: "https://www.tvmaze.com/shows/560/one-tree-hill",
    name: "One Tree Hill",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11665.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11665.jpg",
    },
    summary:
      "<p><b>One Tree Hill</b> explores the delicate balance that contemporary young people face as they endeavor to build and define what their lives will be, while overcoming difficulties and embracing the good things that they sometimes take for granted. The series celebrates the most important things -- among them the quest for love, laughter, health, friends, career and family -- timeless pursuits that have always mattered, and matter still.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-09-23",
  },
  {
    id: 561,
    url: "https://www.tvmaze.com/shows/561/la-femme-nikita",
    name: "La Femme Nikita",
    genres: ["Action", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11684.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11684.jpg",
    },
    summary:
      "<p>Framed for killing a cop, Nikita agrees to work for a secret government agency.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1997-01-13",
  },
  {
    id: 562,
    url: "https://www.tvmaze.com/shows/562/law-order",
    name: "Law & Order",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47569.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47569.jpg",
    },
    summary:
      "<p>In the criminal justice system, the people are represented by two separate, yet equally important, groups: the police, who investigate crime; and the district attorneys, who prosecute the offenders. These are their stories.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1990-09-13",
  },
  {
    id: 563,
    url: "https://www.tvmaze.com/shows/563/star-wars-the-clone-wars",
    name: "Star Wars: The Clone Wars",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/237/593387.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/237/593387.jpg",
    },
    summary:
      "<p>The Clone Wars television series chronicles the events taking place between Star Wars Episode II: Attack of the Clones and Star Wars Episode III: Revenge of the Sith. The Clone Wars will ultimately lead to the downfall of the Jedi and the rise of the Galactic Empire.</p>",
    officialSite: null,
    webChannel: { id: 287, name: "Disney+", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2008-10-03",
  },
  {
    id: 564,
    url: "https://www.tvmaze.com/shows/564/niptuck",
    name: "Nip/Tuck",
    genres: ["Drama", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11715.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11715.jpg",
    },
    summary:
      "<p>Two plastic surgeons who are close friends and business partners, own an overwhelmingly successful plastic surgery practice and attempt to bring inner peace and visceral contentment to their patients through external cosmetic procedures. Although their clients aspire to cover up their pain, it is the surgeons who truly wear the masks of anguish and unhappiness, sadness and disillusionment. For more than two decades, they have shared a love for the same woman, who despite being married to one, has loved both. And at midlife, the doctors question the prosperity that has brought them so much -- and has offered so little.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-07-22",
  },
  {
    id: 565,
    url: "https://www.tvmaze.com/shows/565/deadwood",
    name: "Deadwood",
    genres: ["Drama", "Crime", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11724.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11724.jpg",
    },
    summary:
      "<p>The outlaw camp of <b>Deadwood</b> marches slowly towards civilization, facing its first elections. But the power struggles continue over everything in Deadwood—influence, money, and whores—as the founding camp members form strategic alliances to face down the threat of a powerful newcomer, seeking to remake Deadwood in his image.</p>",
    officialSite: "https://www.hbo.com/deadwood",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-03-21",
  },
  {
    id: 566,
    url: "https://www.tvmaze.com/shows/566/ghost-whisperer",
    name: "Ghost Whisperer",
    genres: ["Drama", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11745.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11745.jpg",
    },
    summary:
      '<p>Ever since she was a young girl, Melinda Gordon has been able to see and talk to dead people--earth bound spirits who have yet to cross over to the other side and who seek her help in communicating and resolving unfinished business with the living. Melinda sometimes has a hard time accepting her "gift," especially now that she\'s a newlywed and looking forward to starting her new life with her husband, Jim Clancy, a paramedic. Her friend and business partner in the antique store, Andrea Moreno, is fascinated by Melinda\'s talent. Although Melinda embraces her unique "abilities" as a blessing and sometimes a curse, she always helps her clients--alive or dead--find emotional closure.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-09-23",
  },
  {
    id: 567,
    url: "https://www.tvmaze.com/shows/567/gossip-girl",
    name: "Gossip Girl",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/42/106320.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/42/106320.jpg",
    },
    summary:
      "<p>The privileged prep school teens on Manhattan's Upper East Side first learn that notorious party girl Serena van der Woodsen is back in town the way they learn all the important news in their lives -- from the blog of the all-knowing albeit ultra-secretive <b>Gossip Girl</b>. No one knows Gossip Girl's identity, but everyone in this exclusive and complicated vicious circle relies on her website and text messages for the latest scoop. Even Serena's closest and most competitive friend, Blair Waldorf, is surprised to find that Serena has suddenly ended her self-imposed exile to boarding school and returned to Manhattan. This is a world you have to be born into, full of wealth, power, and prestige, keeping track of the constantly shifting friendships, jealousies and turmoil in this complex world isn't easy, but it's what Gossip Girl does best.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-09-19",
  },
  {
    id: 568,
    url: "https://www.tvmaze.com/shows/568/malcolm-in-the-middle",
    name: "Malcolm in the Middle",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11763.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11763.jpg",
    },
    summary:
      '<p>In the words of They Might Be Giants\' rollicking Grammy-winning theme song, "life is unfair." The inventive and wholly original sitcom <b>Malcolm in the Middle</b> has been honored with a Peabody Award and Emmys for directing and writing, but if life was fair, it would have earned an Emmy for Best Comedy Series, not to mention statuettes for its pitch-perfect cast. With his perpetual "yes, me worry" expression, Frankie Muniz instantly earns audience empathy as Malcolm, whose chances for a normal life are thwarted not only by his genius IQ, but also by his outrageously dysfunctional family: Lois, his obsessive, control-freak mother; Hal, his loving but ineffectual father; Francis, his eldest brother waging his own private war at military school; middle brother Reese, a delinquent savant; and Dewey, the put-upon youngest. As Malcolm observes at one point, "This family may be rude, loud and gross, and have no shame whatsoever, but with them you know where you stand."</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-01-09",
  },
  {
    id: 569,
    url: "https://www.tvmaze.com/shows/569/dharma-greg",
    name: "Dharma & Greg",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11770.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11770.jpg",
    },
    summary:
      "<p>When free-spirited yoga instructor Dharma Finkelstein meets conservative attorney Greg Montgomery, it's love at first sight. Unfortunately, there is absolutely no love in the air when Dharma's hippie parents and Greg's blue-blood establishment parents finally meet after their children have already married at a drive-thru chapel in Reno. With friends and family all suggesting that a quick annulment would be best, it's no surprise that the couple begins to second-guess their impulsive nuptials. But it's soon evident that nothing can stand in the way of true love!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1997-09-24",
  },
  {
    id: 570,
    url: "https://www.tvmaze.com/shows/570/nypd-blue",
    name: "NYPD Blue",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11779.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11779.jpg",
    },
    summary:
      "<p>The gritty details of life as a member of a New York City police unit.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-09-21",
  },
  {
    id: 571,
    url: "https://www.tvmaze.com/shows/571/the-glades",
    name: "The Glades",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11802.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11802.jpg",
    },
    summary:
      "<p>In <b>The Glades</b>, Jim Longworth, is a brilliant homicide detective from Chicago who moves to South Florida after being shot by his captain. He assumes it will afford him a more relaxing lifestyle, but he finds things are more complicated than he had imagined when he finds himself solving unlikely crimes in the town of Palm Glade, Florida.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-07-11",
  },
  {
    id: 572,
    url: "https://www.tvmaze.com/shows/572/american-pickers",
    name: "American Pickers",
    genres: ["Travel", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/183/458948.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/183/458948.jpg",
    },
    summary:
      "<p>This isn't your grandmother's antiquing. Pickers like Mike Wolfe and Frank Fritz are on a mission to recycle America, even if it means diving into countless piles of grimy junk or getting chased off a gun-wielding homeowner's land. Hitting back roads from coast to coast, the two men earn a living by restoring forgotten relics to their former glory, transforming one person's trash into another's treasure. <b>American Pickers</b> follows them as they scour the country for hidden gems in junkyards, basements, garages and barns, meeting quirky characters and hearing their amazing stories. If you think the antique business is all about upscale boutiques and buttoned-up dealers, this show may change your mind - and teach you a thing or two about American history along the way.</p>",
    officialSite: "http://www.history.com/shows/american-pickers",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-01-18",
  },
  {
    id: 573,
    url: "https://www.tvmaze.com/shows/573/everybody-loves-raymond",
    name: "Everybody Loves Raymond",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11810.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11810.jpg",
    },
    summary:
      "<p>Ray Barone is a successful sportswriter who deals with his brother and parents, who happen to live across the street.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-09-13",
  },
  {
    id: 574,
    url: "https://www.tvmaze.com/shows/574/happy-endings",
    name: "Happy Endings",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11820.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11820.jpg",
    },
    summary:
      "<p>Forget who gets to keep the ring - when a couple splits, the real question is, who gets to keep the friends? Alex and Dave's wedding was supposed to be the happiest day of their lives, for them and their long-time friends - until Alex leaves groom-to-be Dave at the altar. The breakup, in the words of one pal, is a \"huge game changer\" that will complicate everyone's lives and make everyone question their own choices.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-04-13",
  },
  {
    id: 575,
    url: "https://www.tvmaze.com/shows/575/keeping-up-with-the-kardashians",
    name: "Keeping Up with the Kardashians",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/254/636340.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/254/636340.jpg",
    },
    summary:
      '<p><b>Keeping Up with the Kardashians</b> has grown steadily from a familial docu-series into a global phenomenon. From breakups to makeups, weddings, births and all the drama in between, fans have "kept up" with the family\'s constant evolution.</p>',
    officialSite: "http://www.eonline.com/shows/kardashians",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 43,
      name: "E!",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-10-14",
  },
  {
    id: 576,
    url: "https://www.tvmaze.com/shows/576/csi-miami",
    name: "CSI: Miami",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11828.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11828.jpg",
    },
    summary:
      "<p><b>CSI: Miami</b> is a drama that follows a South Florida team of forensic investigators who use both cutting-edge scientific methods and old-fashioned police work to solve crimes.<br><br> Horatio Caine, a former homicide detective, heads a group of investigators who work crimes amid the steamy tropical surroundings and cultural crossroads of Miami. His team includes Calleigh Duquesne, a bilingual Southern beauty with a specialty in ballistics; Eric Delko, an underwater recovery expert who knows all the twists and turns of the Florida waterways, and Ryan Wolfe, a former patrol officer who specializes in blood and trace evidence.<br><br> Rounding out the team is Alexx Woods, the no-nonsense know-it-all coroner, and Natalia Boa Vista, the enigmatic DNA specialist. Helping Horatio with cases is Det. Frank Tripp, a tough yet thorough police officer.<br><br> Together, these investigators collect and analyze the evidence to solve the crimes and to avenge those who cannot speak for themselves--the victims.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-09-23",
  },
  {
    id: 577,
    url: "https://www.tvmaze.com/shows/577/fawlty-towers",
    name: "Fawlty Towers",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11842.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11842.jpg",
    },
    summary:
      "<p><b>Fawlty Towers</b> is set in a fictional hotel in the seaside town of Torquay. The plots centre on tense, rude and put-upon owner Basil Fawlty, his bossy wife Sybil, comparatively normal chambermaid Polly, who is often the peacemaker and voice of reason, and hapless Spanish waiter Manuel, showing their attempts to run the hotel amidst farcical situations and an array of demanding and eccentric guests.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006xxvg",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1975-09-19",
  },
  {
    id: 578,
    url: "https://www.tvmaze.com/shows/578/90210",
    name: "90210",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/193/483684.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/193/483684.jpg",
    },
    summary:
      "<p>The fifth season of <b>90210</b> will find the gang struggling with the biggest issues of their lives. Having put their relatively carefree days at West Beverly behind them and launched themselves into adulthood, they will search for answers to their trials and tribulations with only their friendships to lean on.</p><p>They will experience new love and old flames, loyalties being challenged and shocking betrayals. Some friendships will be tested, others will be renewed and new people who will try to infiltrate the close circle of friends. There are some things money can't buy, even in 90210.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-09-02",
  },
  {
    id: 579,
    url: "https://www.tvmaze.com/shows/579/harrys-law",
    name: "Harry's Law",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11862.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11862.jpg",
    },
    summary:
      "<p>In Season 2, Harry is back with an attitude as she hones her courtroom arguments and winning style. On the heels of Harry's rising reputation, Harry's Law and Fine Shoes starts landing larger cases, and alongside her newfound success, Harry is looking to bring in some new hotshot attorneys to help out the team.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-01-17",
  },
  {
    id: 580,
    url: "https://www.tvmaze.com/shows/580/raising-hope",
    name: "Raising Hope",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11870.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11870.jpg",
    },
    summary:
      "<p>At 23 years old, Jimmy Chance is going nowhere in life. He skims pools for a living, parties every night and still lives at home with his family, including his parents and his cousin, Mike. Jimmy's life takes a drastic turn when a chance romantic encounter with Lucy goes awry once he discovers she is a wanted felon. Months later, when Jimmy pays a visit to the local prison, he discovers Lucy gave birth to their baby, who he is now charged with raising.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-21",
  },
  {
    id: 581,
    url: "https://www.tvmaze.com/shows/581/jag",
    name: "JAG",
    genres: ["Drama", "Crime", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/292/730789.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/292/730789.jpg",
    },
    summary:
      '<p>Lieutenant Commander "Harm" Rabb, Jr., a brave, outstanding Navy Lawyer and officer in the Judge Advocate General (J.A.G.) Corps, investigates and prosecutes all crimes, accidents, acts of terrorism and espionage related to the Navy and Marine Corps.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1995-09-23",
  },
  {
    id: 582,
    url: "https://www.tvmaze.com/shows/582/the-fresh-prince-of-bel-air",
    name: "The Fresh Prince of Bel-Air",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11889.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11889.jpg",
    },
    summary:
      "<p>Will Smith plays a young man transplanted from the tough streets of Philadelphia to live with his wealthy Bel-Air relatives, causing everyone to adjust how they live and think.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1990-09-10",
  },
  {
    id: 583,
    url: "https://www.tvmaze.com/shows/583/sliders",
    name: "Sliders",
    genres: ["Adventure", "Fantasy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11896.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11896.jpg",
    },
    summary:
      '<p>Brilliant grad student Quinn has created a device that opens a wormhole to an infinite number of parallel universes where history has taken different paths. His first test trip goes awry stranding his physics professor Arturo, his friend Wade, and bystander Rembrandt "Crying Man" Brown in parallel San Francisco. Now, this foursome of <b>Sliders</b> must travel from one alternate reality to another in the hope of somehow finding their way home.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1995-03-22",
  },
  {
    id: 584,
    url: "https://www.tvmaze.com/shows/584/las-vegas",
    name: "Las Vegas",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11905.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11905.jpg",
    },
    summary:
      "<p>Take a spin on the wheel of TV's most electrifying series ever, <b>Las Vegas</b>. The slots are hot and the girls are even hotter starring some of today's biggest guest stars. Follow the fast-paced exploits and action-packed escapades at the Montecito Hotel and Casino with an elite Las Vegas surveillance team, led by commanding Big Ed Deline and his slick, good-looking right hand man, Danny McCoy. Along with the sexiest support team to hit the Strip, they're out to catch card-counting cheaters, costly streaks of random luck and the schemes of rival casinos. It's Sin City like you've never seen it before in the series Variety declares is \"Bottom line: Jackpot\".</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-09-22",
  },
  {
    id: 585,
    url: "https://www.tvmaze.com/shows/585/ghost-hunters",
    name: "Ghost Hunters",
    genres: ["Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11914.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11914.jpg",
    },
    summary:
      "<p><b>Ghost Hunters</b> follows a group of real-life ghostbusters as they investigate reported hauntings throughout the country. Plumbers by trade, Jason Hawes and Grant Wilson head up a group of intrepid souls that are far from the usual collection of be-spectacled Ph.D.s. They're ordinary, everyday people with an interest in getting to the bottom of your otherworldly disturbances.</p>",
    officialSite: "http://www.scifi.com/ghosthunters/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-10-06",
  },
  {
    id: 586,
    url: "https://www.tvmaze.com/shows/586/breakout-kings",
    name: "Breakout Kings",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11915.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11915.jpg",
    },
    summary:
      '<p><b>Breakout Kings</b> follows an unconventional partnership between the U.S. Marshals\' office and a group of convicts as they work to catch fugitives on the run. In Breakout Kings, veteran U.S. Marshals Charlie Duchamp and Ray Zancanelli decide to reject protocol and take an unorthodox approach to their work: using former criminals to catch current ones. They form a special task force composed of the three most elusive convicts Ray ever captured: Lloyd Lowery a former child prodigy and behaviorist/psychiatric expert who excels in psychoanalysis; Shea Daniels, an ex-gang banger who knows how to work the system, both in prison and on the street; and Erica Reed, a sexy expert tracker who learned her trade from her bounty hunter father. Charlie and Ray also employ the services of Julianne Simms, a civilian who acts as the "funnel" for the group - all information, tips and data go through her.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-03-06",
  },
  {
    id: 587,
    url: "https://www.tvmaze.com/shows/587/that-70s-show",
    name: "That '70s Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11921.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11921.jpg",
    },
    summary:
      "<p>Crank up the 8-track and flash back to a time when platform shoes and puka shells were all the rage in this hilarious retro-sitcom. For Eric, Kelso, Jackie, Hyde, Donna and Fez, a group of high school teens who spend most of their time hanging out in Eric's basement, life in the ‘70s isn't always so groovy. But between trying to figure out the meaning of life, avoiding their parents, and dealing with out-of-control hormones, they've learned one thing for sure: they'll always get by with a little help from their friends.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-08-23",
  },
  {
    id: 588,
    url: "https://www.tvmaze.com/shows/588/ntsfsdsuv",
    name: "NTSF:SD:SUV",
    genres: ["Comedy", "Espionage"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11934.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11934.jpg",
    },
    summary:
      "<p><b>NTSF:SD:SUV::</b> (National Terrorism Strike Force: San Diego: Sport Utility Vehicle), is a clandestine team of government agents working together to protect San Diego from numerous terrorist threats coming in daily from such evil countries as Mexico, Canada and Guam. This team of highly trained operatives has only one job: saving your ass so you can drive your Prius and see your movies in 3-D without worrying about living in a country run by no-good terrorists. As with many other acronym-ed police procedurals that dominate the airwaves, NTSF:SD:SUV::'s season of 15-minute episodes is ripped from the headlines and full of suspense, action, drama, cliffhangers, yelling, passionate love-making, more yelling, death and plenty of pregnant pauses.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-07-22",
  },
  {
    id: 589,
    url: "https://www.tvmaze.com/shows/589/bad-teacher",
    name: "Bad Teacher",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/11941.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/11941.jpg",
    },
    summary:
      "<p>Based on the hit feature film, <b>Bad Teacher</b> follows Meredith Davis as an always inappropriate, fearless and unapologetic former trophy wife who masquerades as a teacher in order to find a new man after her wealthy husband leaves her penniless.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-04-24",
  },
  {
    id: 590,
    url: "https://www.tvmaze.com/shows/590/pokemon",
    name: "Pokémon",
    genres: ["Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/97/243593.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/97/243593.jpg",
    },
    summary:
      "<p><b>The Sun and Moon</b> series follows Ash Ketchum on his new Journey in Alola with his companion, Pikachu. He and his mother, Deliah leave for the Alola region on a vacation, however once seeing the Pokémon School, Ash decides to stay in Alola on a new journey.</p><p>From there he adventures across the region with his new RotomDex, as well as his new classmates.</p>",
    officialSite:
      "http://www.cartoonnetwork.com/video/pokemon/index.html?atclk_vn=nav_Pokeacutemon-the-Series-XY",
    webChannel: null,
    language: "Japanese",
    status: "Running",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1997-04-01",
  },
  {
    id: 591,
    url: "https://www.tvmaze.com/shows/591/eat-the-story-of-food",
    name: "Eat: The Story of Food",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/35/89010.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/35/89010.jpg",
    },
    summary:
      '<p>From the way Spam helped defeat Hitler, to how sausage spread the Roman Empire, to how spices created the global economy, <b>Eat: The Story of Food</b> leaves no morsel of information on the plate. Each of the six one-hour episodes is centered on a different theme: food revolutionaries, meat, sugar, seafood, junk food and grains. Throughout the episodes this incredible group of food ambassadors share their personal stories and reflections on food, not just looking back at history but looking forward to the future and at the cultural impact of our food consumption. Author Simon Majumdar summarizes this in his interview when he notes, "There are very few occasions in any family\'s life in any culture that aren\'t marked by a meal; from a new baby to an Irish wake and all points in between".</p><p>"What makes food really personal is that it makes you think", adds chef Marcus Samuelsson. "What tribe are you? Who are you? Who are we as a family? Who are we as a community? And what does this specific dish mean to us? It connects us".</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-21",
  },
  {
    id: 592,
    url: "https://www.tvmaze.com/shows/592/dr-oakley-yukon-vet",
    name: "Dr. Oakley, Yukon Vet",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/213/533092.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/213/533092.jpg",
    },
    summary:
      "<p>In the frozen Yukon Territory in Northern Canada, you've got to be hearty and tough. You've got to expect solitude across frigid, remote landscapes with freezing temperatures, but even in the desolate wilderness you need a vet to help your ailing wiener dog. Enter <b>Dr. Oakley, Yukon Vet</b>, that follows the experienced Dr. Michelle Oakley, veterinarian, as she makes house calls across thousands of square miles in the Yukon. Helping many species of animals, including an angry muskox, a caribou with a tumor, a defensive mama lynx, and a grey owl with an amputated wing. Accompanied by her teenage daughters and armed with humor as sharp as a scalpel, Dr. Oakley deftly juggles being a full-time veterinarian, wife and mom while taking us into the isolated regions of the Yukon.</p>",
    officialSite:
      "https://www.nationalgeographic.com/tv/shows/dr-oakley-yukon-vet",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 83,
      name: "National Geographic WILD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-04-12",
  },
  {
    id: 593,
    url: "https://www.tvmaze.com/shows/593/murdoch-mysteries",
    name: "Murdoch Mysteries",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/22/57253.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/22/57253.jpg",
    },
    summary:
      "<p>Set in Toronto at the dawn of the 20th century, <b>Murdoch Mysteries </b>is a one-hour drama series that explores the intriguing world of William Murdoch, a methodical and dashing detective who pioneers innovative forensic techniques to solve some of the city's most gruesome murders. Murdoch's colleagues include the love of his life, coroner and psychiatrist Dr. Julia Ogden, a staunch ally who shares the detective's fascination for science; Constable George Crabtree, Murdoch's eager but sometimes naïve right-hand man; Inspector Brackenreid, Murdoch's skeptical yet reluctantly supportive boss; and coroner Dr. Emily Grace, Dr. Ogden's protégé.</p>",
    officialSite: "http://www.cbc.ca/murdochmysteries/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 36,
      name: "CBC",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2008-01-24",
  },
  {
    id: 594,
    url: "https://www.tvmaze.com/shows/594/henry-danger",
    name: "Henry Danger",
    genres: ["Comedy", "Family", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/235/588083.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/235/588083.jpg",
    },
    summary:
      "<p>Henry Hart's afterschool job? Kid Danger: Captain Man's superhero sidekick. Fighting crime AND finishing homework? Villains, beware!</p>",
    officialSite: "http://www.nick.com/henry-danger/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-26",
  },
  {
    id: 595,
    url: "https://www.tvmaze.com/shows/595/the-thundermans",
    name: "The Thundermans",
    genres: ["Comedy", "Family", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/61/154982.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/61/154982.jpg",
    },
    summary:
      '<p>Phoebe and Max Thunderman are 14-year-old fraternal twins turbocharged by freeze breath and the power to move objects via telekinesis. Phoebe, a good-natured sister, always tries to do the right thing, while Max, a troublemaker, dreams of one day becoming a super villain. Brother Billy moves at super speed, while younger sister Nora cuts solid objects with her laser beam eyes. Rounding out the family are parents Hank, who possesses extraordinary strength and the ability to fly, and Barb, who can generate lightning from her hands. Ultimately, the family must attempt keep their powers under wraps and lead a "normal" life... but can life ever be "normal" in a family of superheroes?</p>',
    officialSite: "http://www.nick.com/the-thundermans/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-10-14",
  },
  {
    id: 597,
    url: "https://www.tvmaze.com/shows/597/the-real-housewives-of-atlanta",
    name: "The Real Housewives of Atlanta",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/257/643857.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/257/643857.jpg",
    },
    summary:
      '<p>An up-close and personal look at life in Hotlanta, <b>The Real Housewives of Atlanta</b> follows five glamorous southern belles as they balance motherhood, demanding careers and a fast-paced social calendar, and shows what life is like in the most exclusive areas of Atlanta. These driven and ambitious women prove that they\'re not just "housewives," but entrepreneurs, doting mothers and classy southern women. These ladies show the world what it takes to live large in some of the hottest zip codes in the south.</p>',
    officialSite: "http://www.bravotv.com/the-real-housewives-of-atlanta",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-10-07",
  },
  {
    id: 598,
    url: "https://www.tvmaze.com/shows/598/boston-legal",
    name: "Boston Legal",
    genres: ["Drama", "Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/12026.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/12026.jpg",
    },
    summary:
      "<p>Sometimes irreverent and funny, sometimes intense and moving, <b>Boston Legal</b> prides itself on being at the forefront of issue-oriented television, often addressing issues that are underreported by the media. Fast-paced and wildly comedic, the series confronts social and moral issues, while its characters continually stretch the boundaries of the law.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-10-03",
  },
  {
    id: 599,
    url: "https://www.tvmaze.com/shows/599/hair-jacked",
    name: "Hair Jacked",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/12282.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/12282.jpg",
    },
    summary:
      "<p><b>Hair Jacked</b> is a hilarious, high-energy ambush game show in which unsuspecting contestants have the chance to win cash, all while getting a haircut. But they have to play smart because one wrong answer could send them packing with the worst hairstyle of their lives.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 84,
      name: "truTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-27",
  },
  {
    id: 600,
    url: "https://www.tvmaze.com/shows/600/crowd-control",
    name: "Crowd Control",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/12289.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/12289.jpg",
    },
    summary:
      "<p>In Crowd Control, viewers will discover that sometimes all you need is a little science to help make the world a better place. Best-selling author and behavior change expert Daniel Pink will use behavioral science to lead a series of experiments that show how we can apply the power of persuasion in our daily lives to reduce stress, minimize annoyances, improve health and increase happiness. Using hidden cameras to record his results, Pink will tackle the seemingly impossible task of righting everyday wrongs - from convincing partygoers to clean up their streets to stopping the senseless rush at an airport baggage claim.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-24",
  },
  {
    id: 601,
    url: "https://www.tvmaze.com/shows/601/fake-off",
    name: "Fake Off",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/12290.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/12290.jpg",
    },
    summary:
      "<p><b>Fake Off</b> will take viewers into the visually stunning world of faking, a mix of theater, acrobatics, black light and illusion. In an elimination competition unlike anything American audiences have seen, teams will be challenged to reimagine iconic moments in pop culture to see who's got the creativity and skills to be named Fake Off Champions and take home a prize of $100,000</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 84,
      name: "truTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-27",
  },
  {
    id: 602,
    url: "https://www.tvmaze.com/shows/602/euros-of-hollywood",
    name: "Euros of Hollywood",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/12292.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/12292.jpg",
    },
    summary:
      '<p><b>Euros of Hollywood</b> follows six Europeans living in Los Angeles with personalities as big as their native countries while they strive to achieve their version of the American Dream. From a pop diva known as the "Madonna of Albania" to a Prada-wearing Italian Renaissance man whose goal is to win an Oscar, these ambitious and unfiltered men and women will stop at nothing to rise to the top. With their hearts on their sleeves and a shared bond as Europeans, they will help each other out in their pursuit of fame, fortune and family.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-03",
  },
  {
    id: 603,
    url: "https://www.tvmaze.com/shows/603/godfather-of-pittsburgh",
    name: "Godfather of Pittsburgh",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31650.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31650.jpg",
    },
    summary:
      "<p>For Vince Isoldi nothing is more important than family. Some may say he's a gangster but according to Vince, he's just a good businessman. An entrepreneur with a sordid past, Vince has built an empire in Pittsburgh, from nightclubs to real estate, all in hopes of providing a better life for his family. Unfortunately, getting to the top means making a lot of enemies and in Vince's case some of them are family.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-10",
  },
  {
    id: 604,
    url: "https://www.tvmaze.com/shows/604/booze-traveler",
    name: "Booze Traveler",
    genres: ["Food", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/143/359008.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/143/359008.jpg",
    },
    summary:
      "<p>While working in the bars of South Boston, Jack Maxwell learned one thing - sit down with a stranger and a couple of drinks, and the whole world opens up. In <b>Booze Traveler</b>, Maxwell sets out across the globe to find the world's most interesting beverages and the people who drink them. Over the course of 15 episodes, viewers will follow Maxwell as he travels to various locations around the world including Armenia, Belize, Lithuania, Mongolia and Nepal. At each stop, he connects with locals, immerses himself in regional activities, learns about the country's unique relationship with liquor and sometimes even participates in the alcohol-making process.</p>",
    officialSite: "http://www.travelchannel.com/shows/booze-traveler/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 82,
      name: "Travel Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-24",
  },
  {
    id: 605,
    url: "https://www.tvmaze.com/shows/605/eric-greenspan-is-hungry",
    name: "Eric Greenspan is Hungry",
    genres: ["Food", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/12308.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/12308.jpg",
    },
    summary:
      "<p>Chef Eric Greenspan is, without a doubt, one of the funniest, loudest, most innovative chefs on the planet. But there's really only one thing you need to know about Eric: He's no vegetarian. Eric and his trusted friend and carnivorous gastronome, Mauzner, travel on the meatiest road trip, discovering Americana through rare homegrown family recipes, to satisfy their wildest imaginations and to get inspiration for Eric's critically acclaimed restaurants in Los Angeles.</p><p><b>Eric Greenspan is Hungry</b> takes viewers on a cross-country, off-the-beaten-path adventure, looking for wild hog in Warren, Arkansas, for wild turkey in Tunica, Mississippi, for Buffalo in Jasper, Arkansas, and for goat in Grand Coteau, Louisiana, just to mention a few of his stops. Traveling in the heartland, Eric goes directly to the source of local recipes to meet the people who farm, raise, nurture, hunt and butcher animals such as bison, prehistoric gar, goat, crawfish, pig and wild turkey. It's meat unlike what you get from a purveyor. Eric and his cohort will break down the animal, butcher it and prepare the recipe all on location to crank out the best dishes imaginable.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-24",
  },
  {
    id: 607,
    url: "https://www.tvmaze.com/shows/607/air-warriors",
    name: "Air Warriors",
    genres: ["Drama", "Action", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31481.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31481.jpg",
    },
    summary:
      "<p>A winged fighter that hasn't lost a fight in 26 years, a lifesaver that's part plane and part chopper, and an attack helicopter our enemies call the Black Death. These are America's undisputed kings of the sky: the F-15 Eagle, the V-22 Osprey, and the AH-64 Apache. And their success stories are as remarkable as they are improbable. Witness their turbulent journeys, brought to life through rarely seen combat footage and the stories of the dedicated pilots and teams who fly and maintain these ultimate <b>Air Warriors</b>.</p>",
    officialSite:
      "http://www.smithsonianchannel.com/shows/air-warriors/1003487",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 86,
      name: "Smithsonian Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-09",
  },
  {
    id: 609,
    url: "https://www.tvmaze.com/shows/609/the-astronaut-wives-club",
    name: "The Astronaut Wives Club",
    genres: ["Drama", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/30480.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/30480.jpg",
    },
    summary:
      "<p><b>The Astronaut Wives Club</b> tells the story of the women who were key players behind some of the biggest events in American history.</p>",
    officialSite: "http://abc.go.com/shows/the-astronaut-wives-club",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-18",
  },
  {
    id: 610,
    url: "https://www.tvmaze.com/shows/610/galavant",
    name: "Galavant",
    genres: ["Comedy", "Fantasy", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/37/94356.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/37/94356.jpg",
    },
    summary:
      '<p>Once upon a time, the dashing hero <b>Galavant</b> lost the love of his life, Madalena, to the evil King Richard. Now, our fallen hero is ready to take revenge and restore his "happily ever after". But it won\'t be without a few twists and turns along the way.</p>',
    officialSite: "http://abc.go.com/shows/galavant",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-04",
  },
  {
    id: 611,
    url: "https://www.tvmaze.com/shows/611/wake-up-call",
    name: "Wake Up Call",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/93/232896.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/93/232896.jpg",
    },
    summary:
      "<p>By the time Dwayne \"The Rock\" Johnson was 23, he had multiple arrests, his family was evicted and his dreams of being a football player were shattered. He was living at home with no future, no direction and had seven bucks in his pocket. That's when he made a choice - to challenge himself every day. And to turn himself around. The rest is history. <br /><br /> And now Rock is returning to his roots - to help those who are struggling - to show them that there can be a better way. From dysfunctional homes and dead-beat dads to runaway teens and businesses struggling to survive, The Rock descends into the chaos of everyday problems to pull good people up by the bootstraps, reminding them what hard work, passion and true discipline can accomplish. It's time for your <b>Wake Up Call</b>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-12-12",
  },
  {
    id: 612,
    url: "https://www.tvmaze.com/shows/612/expedition-unknown",
    name: "Expedition Unknown",
    genres: ["Adventure", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/147/369350.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/147/369350.jpg",
    },
    summary:
      "<p>In the hit series <b>Expedition Unknown</b>, Travel Channel's witty explorer Josh Gates seeks answers to some of the world's most captivating unsolved stories and legends. Gates is on a mission to find the truth behind each iconic legend, digging through years of historical evidence, facts and myths. Leaving no stone unturned, his adventures take him around the globe as he immerses himself in the core locales linked to each tale. From excavating ruins in search of the real Robin Hood to sailing the high seas investigating Christopher Columbus and exploring Nepal's \"sky caves\" for Shangri La, Gates' archaeological background and ubiquitous sense of humor generate a new take on age-old stories.</p>",
    officialSite: "https://www.discovery.com/tv-shows/expedition-unknown/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-08",
  },
  {
    id: 613,
    url: "https://www.tvmaze.com/shows/613/eye-candy",
    name: "Eye Candy",
    genres: ["Drama", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/47/118686.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/47/118686.jpg",
    },
    summary:
      "<p>The hour-long, 10-episode drama centers on tech genius Lindy, a 21-year-old hacker with a gift for seeing clues and connections in the digital world that others can't. Persuaded by her roommate to try online dating, Lindy begins to suspect that one of her suitors is a deadly cyber stalker. When the local cyber-crimes unit uncovers a potential serial killer in Manhattan, all signs point to this mysterious stalker. Teaming up with the cyber unit and some hacker friends, Lindy leads the charge to solve these murders while unleashing her own style of justice on the streets of New York City.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-12",
  },
  {
    id: 614,
    url: "https://www.tvmaze.com/shows/614/12-monkeys",
    name: "12 Monkeys",
    genres: ["Drama", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/155/389213.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/155/389213.jpg",
    },
    summary:
      "<p>Inspired by the classic blockbuster film, which commemorated its 20th anniversary in 2015, <b>12 Monkeys</b> explores the provocative story of a time traveler from a decimated future in a high-stakes race against the clock. Utilizing a dangerous and untested method of time travel, he journeys from 2043 to the present day on a mission to locate and eradicate the source of a deadly plague that will all but annihilate the human race.</p>",
    officialSite: "http://www.syfy.com/12monkeys",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-16",
  },
  {
    id: 615,
    url: "https://www.tvmaze.com/shows/615/sons-of-liberty",
    name: "Sons of Liberty",
    genres: ["Drama", "Action", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/22064.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/22064.jpg",
    },
    summary:
      "<p>The three-night, six-hour event follows a defiant and radical group of young men - Sam Adams, John Adams, Paul Revere, John Hancock and Dr. Joseph Warren - as they band together in secrecy to change the course of history and make America a nation. The Sons of Liberty sparked a revolution, the cast depicting them includes: Ben Barnes as Sam Adams, a natural born leader with charisma and a penchant for mischief; Ryan Eggold as Dr. Joseph Warren, a doctor and man of conscience and integrity; Michael Raymond-James as Paul Revere, a veteran who wholeheartedly joins forces with Sam Adams; Rafe Spall as John Hancock, the wealthiest man in Boston at the time; and Henry Thomas as John Adams, a lawyer and the conservative, smart cousin of Sam Adams. Additionally, Marton Csokas plays the ferocious General Thomas Gage who is sent to handle the colonial unrest in Boston; Emily Berrington as Margaret Gage; Jason O'Mara as General George Washington and Dean Norris as the brilliant yet mischievous diplomat Benjamin Franklin.</p>",
    officialSite: "http://www.history.com/shows/sons-of-liberty/about",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-25",
  },
  {
    id: 616,
    url: "https://www.tvmaze.com/shows/616/street-art-throwdown",
    name: "Street Art Throwdown",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755248.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755248.jpg",
    },
    summary:
      "<p>World-renowned street artist Justin BUA serves as host, co-judge and executive producer on the show, which pits 10 of the country's most promising artists against one another. The series tests not only their physical stamina, but also pushes their artistic skills to the limit in hopes of jumpstarting their career with a $100,000 grand prize. <b>Street Art Throwdown</b> is shot at some of the most iconic Los Angeles locations as young, passionate hopefuls strive to bring their vision to life and showcase their work to the world. Furiously scaling walls, climbing fences and navigating underground tunnels, these artists must have the talent, style and hustle to battle it out to the end. <i>Street Art Throwdown</i> is part of Oxygen's rebrand, launching on Tuesday, October 7th with the network's new look and tagline, very real, targeting young, modern women.</p>",
    officialSite: "http://www.oxygen.com/street-art-throwdown",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 79,
      name: "Oxygen",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-03",
  },
  {
    id: 617,
    url: "https://www.tvmaze.com/shows/617/allegiance",
    name: "Allegiance",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20832.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20832.jpg",
    },
    summary:
      "<p>Alex O'Connor, a young idealistic CIA analyst specializing in Russian affairs, learns a shocking secret and his close-knit, affluent family is about to be split apart when its revealed that his parents, Mark and Katya are covert Russian spies deactivated decades ago. But today the Kremlin has re-enlisted them into service as they plan a terrorist operation inside the U.S. border that will bring America to its knees. Years ago, Russian-born Katya was tasked by the KGB to recruit American businessman Mark O'Connor as a spy -- and the two fell in love. A deal was struck: As long as Katya remained an asset for Russia, and it was agreed that her services could be called on in the future, she would be allowed to marry Mark and move to America. After years in America building a happy life and without word from Moscow, they thought they had escaped. Now it seems that the new Mother Russia has one more mission - turning Alex into a spy. For these anguished parents, the choice is clear: Betray their country or risk their family.</p>",
    officialSite: "https://www.nbc.com/allegiance?nbc=1",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-05",
  },
  {
    id: 618,
    url: "https://www.tvmaze.com/shows/618/better-call-saul",
    name: "Better Call Saul",
    genres: ["Drama", "Crime", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/235/587815.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/235/587815.jpg",
    },
    summary:
      '<p><b>Better Call Saul</b> is the prequel to the award-winning series Breaking Bad, set six years before Saul Goodman became Walter White\'s lawyer. When we meet him, the man who will become Saul Goodman is known as Jimmy McGill, a small-time lawyer searching for his destiny, and, more immediately, hustling to make ends meet. Working alongside, and often against, Jimmy is "fixer" Mike Ehrmantraut, a beloved character introduced in Breaking Bad. The series will track Jimmy\'s transformation into Saul Goodman, the man who puts "criminal" in "criminal lawyer.</p>',
    officialSite: "http://www.amc.com/shows/better-call-saul",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 20,
      name: "AMC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-08",
  },
  {
    id: 619,
    url: "https://www.tvmaze.com/shows/619/outlaw-country",
    name: "Outlaw Country",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31633.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31633.jpg",
    },
    summary:
      "<p>Set in the town of Buckner, Missouri, \"Outlaw Country\" chronicles the perennial battle between law enforcement and crime by following Steve and Mike Cook, brothers who act as Sheriff and head of the Buckner Criminal Task Force, respectively, as they clash with John and Josh Monk, brothers they suspect are responsible for the town's surge in crime. In this one hour docudrama, producers were given full access to both the police force and the Monk Brothers' camp, providing an unprecedented look at crime in a small town from both sides of the law.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 28,
      name: "WGN America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-24",
  },
  {
    id: 620,
    url: "https://www.tvmaze.com/shows/620/the-last-man-on-earth",
    name: "The Last Man on Earth",
    genres: ["Comedy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/127/319518.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/127/319518.jpg",
    },
    summary:
      "<p><b>The Last Man on Earth</b> is a single-camera comedy chronicles the life and adventures of an average guy - and humanity's last hope - who discovers what life is like when no one is telling you what you can and cannot do.</p>",
    officialSite: "http://www.fox.com/the-last-man-on-earth",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-01",
  },
  {
    id: 621,
    url: "https://www.tvmaze.com/shows/621/backstrom",
    name: "Backstrom",
    genres: ["Drama", "Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/19620.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/19620.jpg",
    },
    summary:
      "<p>The series follows Detective Everett Backstrom, an unhealthy, offensive, irascible - albeit brilliant - detective who sees the worst in everyone, and he's usually right.</p>",
    officialSite: "http://www.fox.com/backstrom/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-22",
  },
  {
    id: 622,
    url: "https://www.tvmaze.com/shows/622/wrestling-with-death",
    name: "Wrestling with Death",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31651.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31651.jpg",
    },
    summary:
      "<p>A unique family docuseries that introduces The Lathams of Osceola, Arkansas: morticians by day who run The Wilson Funeral Home, and professional wrestlers by night who run The Mid-Southern Championship Wrestling League.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 28,
      name: "WGN America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-13",
  },
  {
    id: 623,
    url: "https://www.tvmaze.com/shows/623/younger",
    name: "Younger",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/310/775414.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/310/775414.jpg",
    },
    summary:
      "<p><b>Younger</b> follows 40-year old Liza, a suddenly single mother who tries to get back into the working world, only to find it's nearly impossible to start at the bottom at her age. When a chance encounter with a young guy at a bar convinces her she looks younger than she is, Liza tries to pass herself off as 26 - with the help of a makeover, courtesy of her best friend Maggie. Armed with new confidence, she lands a job as an assistant to the temperamental Diana and teams up with her new co-worker and 20-something Kelsey to make it in the career of her dreams. Now she just has to make sure no one finds out the secret only she and Maggie share.</p>",
    officialSite: "https://www.paramountplus.com/shows/younger/",
    webChannel: { id: 107, name: "Paramount+", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-03-31",
  },
  {
    id: 624,
    url: "https://www.tvmaze.com/shows/624/hindsight",
    name: "Hindsight",
    genres: ["Drama", "Comedy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/22042.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/22042.jpg",
    },
    summary:
      "<p>What if you could go back in time and do it all over again? What would you do differently?</p><p>We meet Becca on the eve of her second wedding. It all seems perfect this time around, but she is still plagued by doubt. What if she could fix everything, and make the 'right' choices this time? Becca finds herself thinking about her former best friend Lolly with whom she had a falling out many years ago. If only she could talk to her once again... Suddenly, after a freakish elevator ride, Becca gets the opportunity to do just that as she wakes up in New York City on the morning of her first wedding day in 1995. She's about to marry Sean, a bad-boy artist who is all wrong for her - and she knows her first move must be to reconnect with Lolly to re-live that day. Can she 'make it right' by living her life all over while readapting to life in New York City in the 90's - a time of smoking in bars, carrying pagers, having an AOL email address? Becca will soon discover there's no sure-fire way to make the right choices in life - even knowing everything she thinks she knows now.</p>",
    officialSite: "http://www.vh1.com/shows/hindsight",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 55,
      name: "VH1",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-07",
  },
  {
    id: 625,
    url: "https://www.tvmaze.com/shows/625/polka-kings",
    name: "Polka Kings",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/36/90712.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/36/90712.jpg",
    },
    summary:
      "<p><b>Polka Kings</b> shows the incredible journey The Chardon Polka Band embarks upon as they try to survive each other and keep their personal and professional lives from derailing their quest for stardom. The group is always finding themselves in crazy situations ranging from private parties in nursing homes, Ukrainian summer camps to the Duct Tape Festival in Avon, Ohio. Each week Polka Kings follows the dynamic group's attempts to break through and achieve mainstream status and their ultimate goal of headlining their dream event: Oktoberfest in Germany.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 75,
      name: "REELZ",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-11",
  },
  {
    id: 626,
    url: "https://www.tvmaze.com/shows/626/ad-the-bible-continues",
    name: "A.D. The Bible Continues",
    genres: ["Drama", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/25053.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/25053.jpg",
    },
    summary:
      "<p>In the follow-up to the eye-opening success of The Bible miniseries on History, the 12-hour miniseries <b>A.D. The Bible Continues</b> - from producers Mark Burnett and Roma Downey - will look at the lives that were instantly altered following the death of Christ. His disciples, mother Mary and key political religious leaders at the time saw their world turned upside down and their lives forever altered. Beginning at that fateful moment of the Crucifixion and the Resurrection, part two of the greatest story ever told will focus on the disciples who had to go forward and disseminate the teachings of Christ to a world dominated by political unrest and the start of a whole new religion that would dramatically reshape the history of the world.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-05",
  },
  {
    id: 627,
    url: "https://www.tvmaze.com/shows/627/dig",
    name: "Dig",
    genres: ["Drama", "Thriller", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22898.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22898.jpg",
    },
    summary:
      "<p><b>Dig</b> tells the story of a murder mystery set against the backdrop of modern day Jerusalem, a city shrouded in ancient intrigue. FBI agent Peter Connelly has had his fair share of heartbreak. Anxious to leave his personal demons behind, Peter takes a job stationed in Israel under the guidance of his new boss, and occasional lover, Lynn Monahan. When he sets out to solve the murder of a young American, Peter soon finds himself embroiled in an international mystery that delves into the Holy Land's darkest secrets. What he discovers is a conspiracy thousands of years in-the -making that threatens to change the course of history. While Peter races to figure out what it all means, he quickly finds that he may not be the only one searching for answers.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-05",
  },
  {
    id: 628,
    url: "https://www.tvmaze.com/shows/628/rock-this-boat-new-kids-on-the-block",
    name: "Rock This Boat: New Kids on the Block",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755249.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755249.jpg",
    },
    summary:
      "<p>Die-hard fans take the vacation of a lifetime when they board a cruise with the sole intention of being near the members of their favorite band for just a few days. New Kids on the Block (NKOTB), one of the hottest boy bands in music history with more than 80 million albums sold worldwide, will set sail on their wildly popular, sold-out cruise, joining their most loyal fans for a four-day adventure at sea. The cast includes a whole range of NKOTB devotees, including three sisters taking the family cruise they've always dreamt about to and a group of single moms looking to let their hair down by partying with rock stars. Sail on back to your youth with ROCK THIS BOAT - celebrating fandom like never before.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 88,
      name: "Pop",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-14",
  },
  {
    id: 629,
    url: "https://www.tvmaze.com/shows/629/kitchen-inferno",
    name: "Kitchen Inferno",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755250.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755250.jpg",
    },
    summary:
      "<p>The game is simple but the stakes are red hot. Each episode features talented chefs going head-to-head in culinary showdowns over four possible rounds. Each round will have a blind taste-test judged by the Inferno's panel of judges to determine which dish is best. If the competing chef is victorious, they have the chance to move up to the next level, with each round advancement growing in difficulty as they bring the skills of a new culinary talent to battle against. The contestants also face a pivotal choice: take the money and run, or risk it all for a chance to reach the final round and win up to $25,000, all in front of a studio audience. If they lose, they will watch their winnings go up in smoke and leave with nothing. Can these chefs cook their way through four rounds in this blazing competition for the ultimate prize?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 81,
      name: "Food Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-05",
  },
  {
    id: 630,
    url: "https://www.tvmaze.com/shows/630/murder-book",
    name: "Murder Book",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/32/81662.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/32/81662.jpg",
    },
    summary:
      "<p>Contained within dusty storage drawers and dented metal cabinets of police stations everywhere, is a library of binders comprising detailed information about gruesome crimes. They may look like ordinary notebooks and folders, but each of them holds the plea of their victim waiting for the day that someone will finally catch their killer on Investigation Discovery's <b>Murder Book</b>.</p>",
    officialSite: "http://www.investigationdiscovery.com/tv-shows/murder-book/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-12-02",
  },
  {
    id: 631,
    url: "https://www.tvmaze.com/shows/631/my-strange-criminal-addiction",
    name: "My Strange Criminal Addiction",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/22062.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/22062.jpg",
    },
    summary:
      "<p>MY STRANGE CRIMINAL ADDICTION reveals what happens when bizarre compulsions spin out of control and push people into a life of crime. From a lewd subway commuter to a diaper-wearing man, or a urine drinker to a toe sucker, first-hand accounts of these true crime tales plunges viewers into a world where strange addictions took an illegal turn. Dr. Mike Dow, addiction specialist and expert in the fields of relationships, food, and behavior, explains how these unhealthy habits turned to uncontrollable addictions and helps viewers understand the triggers for these compulsive behaviors. With the perpetrators telling their own stories of how they plunged so deep into darkness, some appear on screen or disguised to conceal their identity while others speak to us from their jail cells.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-12-01",
  },
  {
    id: 632,
    url: "https://www.tvmaze.com/shows/632/momsters-when-moms-go-bad",
    name: "Momsters: When Moms Go Bad",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/32/81663.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/32/81663.jpg",
    },
    summary:
      "<p>With the help of TV's beloved loud-mouth mom and infamous comedienne, Roseanne Barr, <b>Momsters: When Moms Go Bad</b> uncovers a bizarre world where mothers will do anything for their children's happiness. From the little league mama who stalks and threatens her son's coach to the pageant parent who will stop at nothing to get her daughter the crown, these mothers are not afraid to cross boundaries and get their hands dirty.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-28",
  },
  {
    id: 633,
    url: "https://www.tvmaze.com/shows/633/food-truck-face-off",
    name: "Food Truck Face Off",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755251.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755251.jpg",
    },
    summary:
      "<p>Four talented teams compete to make their culinary dreams come true by winning their very own customized food truck for a year on new series <b>Food Truck Face Off</b>, premiering Thursday, October 2nd at 8:00pm ET/PT on Food Network. On each of the 13 episodes, hosted by Jesse Palmer,four teams present their unique food truck concepts to an expert panel of judges. Based on the viability and quality of their ideas, two teams will be selected to face off in an intense two-day showdown. The team that earns the most will drive away with the grand prize!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 81,
      name: "Food Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-28",
  },
  {
    id: 634,
    url: "https://www.tvmaze.com/shows/634/love-the-way-you-lie",
    name: "Love the Way You Lie",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/30356.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/30356.jpg",
    },
    summary:
      "<p>There may be two sides to every story but when it comes to murder, whose story will you believe? Inspired by the best-selling blockbuster novel, Gone Girl, Investigation Discovery's (ID) new series, <b>Love the Way You Lie</b> brings viewers real life crime stories in which the truth is disputed. From suicides that could be staged, to murder disguised as self-defense, <i>Love the Way You Lie</i> examines the fine line between evil and innocent. Filmed in a classic he said-she said style, episodes follow both versions as events in the relationship unfold simultaneously, leaving viewers to ultimately decide the truth.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-12",
  },
  {
    id: 635,
    url: "https://www.tvmaze.com/shows/635/ascension",
    name: "Ascension",
    genres: ["Drama", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/12410.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/12410.jpg",
    },
    summary:
      "<p>In 1963 the American government begins a covert mission sending hundreds of people on a century long journey aboard the starship Ascension. Its goal: to populate a new world. Nearly 50 years into the trip, the murder of a young woman -- as Ascension approaches the point of no return -- prompts some to question the project.</p>",
    officialSite: "http://www.syfy.com/ascension",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-12-15",
  },
  {
    id: 636,
    url: "https://www.tvmaze.com/shows/636/the-pioneers",
    name: "The Pioneers",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755253.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755253.jpg",
    },
    summary:
      "<p><b>The Pioneers</b> is a social experiment that follows four couples for three months as they trade in their 21st-century comforts for covered wagons, campfires, and the harsh reality of life on the American prairie.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-12-09",
  },
  {
    id: 637,
    url: "https://www.tvmaze.com/shows/637/girlfriends-guide-to-divorce",
    name: "Girlfriends' Guide to Divorce",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/162/405182.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/162/405182.jpg",
    },
    summary:
      "<p><b>Girlfriends' Guide to Divorce</b> follows Abby McCarthy, a self-help book author and guru of all things family, who shocks the world when she reveals that her seemingly perfect life has all been a lie. After publicly admitting that she has separated from her husband, Jake, America's once-favorite girlfriend finds her career and marriage in a free fall. As she starts to navigate life as a single woman in her 40s, Abby turns to her new divorced friends, rather than her married ones, for advice. Her friend Lyla is a legendary no-nonsense entertainment lawyer who is in a constant 'War of the Roses' battle with her ex-husband, and Phoebe is a former model and budding entrepreneur who has a very unique relationship with her ex. Meanwhile, a rival attorney at Lyla's firm, Delia, is hired as Abby's divorce attorney.</p><p>Inspired by the \"Girlfriends' Guide\" book series by Vicki Iovine.</p>",
    officialSite: "http://www.bravotv.com/girlfriends-guide-to-divorce",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-12-02",
  },
  {
    id: 638,
    url: "https://www.tvmaze.com/shows/638/sacred-journeys-with-bruce-feiler",
    name: "Sacred Journeys with Bruce Feiler",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755254.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755254.jpg",
    },
    summary:
      "<p>Join best-selling author/adventurer Bruce Feiler on an epic journey as he travels with contemporary pilgrims on six historic pilgrimages around the world and explores how these sacred landscapes and revitalized routes are reshaping faith.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 85,
      name: "PBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-12-16",
  },
  {
    id: 640,
    url: "https://www.tvmaze.com/shows/640/hitler-the-junkie",
    name: "Hitler the Junkie",
    genres: ["Drama", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755255.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755255.jpg",
    },
    summary:
      "<p><b>Hitler the Junkie</b> is a hard-hitting and in-depth special examines the medications Hitler was taking, how much he took and how often, and whether drugs played a role in his behavior and actions.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-12-14",
  },
  {
    id: 641,
    url: "https://www.tvmaze.com/shows/641/biblical-conspiracies",
    name: "Biblical Conspiracies",
    genres: ["Drama", "Mystery", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/22059.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/22059.jpg",
    },
    summary:
      "<p>Each year, amazing new discoveries bring the Biblical ancient world to life, but rather than solve riddles, the discoveries only seem to shroud the era deeper in controversy and myth. <b>Biblical Conspiracies</b> will explore several of the most unexpected finds of the last few years-and uncover the bizarre secrets behind them. With the aid of cutting-edge technology, this four-part series brings viewers to the crumbling tombs, palaces and ruins of the Holy Land in search of ancient conspiracies hidden away for thousands of years.</p>",
    officialSite:
      "http://www.sciencechannel.com/tv-shows/biblical-conspiracies/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 77,
      name: "Science",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-12-14",
  },
  {
    id: 643,
    url: "https://www.tvmaze.com/shows/643/amish-renogades",
    name: "Amish Renogades",
    genres: ["Travel", "DIY"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/76/191498.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/76/191498.jpg",
    },
    summary:
      "<p>Master craftsmen Albert, Robert and Leon from DIY Network's <i>Vanilla Ice Goes Amish</i> are fish out of water when they travel across the country to work on home improvement projects outside of their Amish community. From Boston to the bright lights of Las Vegas and the beaches of Southern California, it's a brave new world when they tackle modern tasks like managing social media and driving a car.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 90,
      name: "DIY Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-22",
  },
  {
    id: 644,
    url: "https://www.tvmaze.com/shows/644/the-carbonaro-effect",
    name: "The Carbonaro Effect",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/159/398027.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/159/398027.jpg",
    },
    summary:
      "<p>truTV's hit comedic series <b>The Carbonaro Effect</b> features Michael Carbonaro, magician by trade and prankster at heart. In each new episode, Michael performs ingenious tricks on unsuspecting members of the public, all caught on hidden camera. Watch jaws drop when he causes a car to disappear into thin air or turns a tuft of hair into a living puppy. Whether posing as a coffee shop barista, museum curator or seemingly unremarkable store clerk, Michael Carbonaro's effect on people will leave you laughing out loud with his bewildering and thrilling illusions.</p>",
    officialSite: "http://www.trutv.com/shows/the-carbonaro-effect/index.html",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 84,
      name: "truTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-05-15",
  },
  {
    id: 645,
    url: "https://www.tvmaze.com/shows/645/barmageddon",
    name: "Barmageddon",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/307/769071.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/307/769071.jpg",
    },
    summary:
      "<p>The Shake Up is a fun, competition series that seeks to settle once and for all which bar owner has the best recipe for success. In each episode, comedian Mo Mandel travels to a different city and pits two bar owners against each other. The goal is to see who can turn the most profit...while running the other owner's bar. The result is a wild rollercoaster ride of comical conflicts and one-upmanship as the bosses compete to see who can win over new staff and customers with their charm and skill.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 84,
      name: "truTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-29",
  },
  {
    id: 646,
    url: "https://www.tvmaze.com/shows/646/my-crazy-love",
    name: "My Crazy Love",
    genres: ["Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755256.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755256.jpg",
    },
    summary:
      "<p>This anthology series follows the wild, romantic and hilarious things men and women have done in the name of love. Each week, real people share their personal stories about a time in their life when the intoxication of love led them to extreme behavior and embarrassing acts. From jumping out of a plane to hiding out in a girlfriend's closet, this series reveals it all through stylized reenactments and interviews. Celebrities such as Adrienne Bailon and Cheryl Burke also confess their outrageous stories. With amazing twists, turns and shocking revelations, did these lovers' bold gestures work or did they take it too far? \"My Crazy Love\" is part of Oxygen's rebrand, which launches on Tuesday, October 7th across all platforms, showcasing the network's new logo and tagline, very real, targeting young, modern women.</p>",
    officialSite: "http://www.oxygen.com/my-crazy-love",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 79,
      name: "Oxygen",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-28",
  },
  {
    id: 647,
    url: "https://www.tvmaze.com/shows/647/friends-of-the-people",
    name: "Friends of the People",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/312/780270.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/312/780270.jpg",
    },
    summary:
      '<p>In the show, comedians Kevin Barnett, Jennifer Bartels, Jermaine Fowler, Lil Rel Howery, The Lucas Bros. and Josh Rabinowitz will take sketch comedy to the next level, with a combination of scripted scenes, man-on-the-street segments and more, including a previously-untold story from television history, and the adventures of "Tracy Morgan Freeman." truTV has ordered 10 episodes of Friends of the People, which is being produced by 3 Arts Entertainment and Marobru Productions.</p>',
    officialSite: "http://www.trutv.com/shows/friends-of-the-people/index.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 84,
      name: "truTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-28",
  },
  {
    id: 648,
    url: "https://www.tvmaze.com/shows/648/bye-felicia",
    name: "Bye Felicia!",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/99/249748.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/99/249748.jpg",
    },
    summary:
      '<p>White women of LA are getting a serious confidence boost and a little dose of reality with the series premiere of "Bye Felicia!," premiering Tuesday, December 9 at 9PM. This 8-episode, hour long series follows Atlanta-based life coaches Deborah Hawkes and Missy Young as they set out to help white girls across the Los Angeles area. Each closed-ended episode aims to empower two different women who could use a dose of honesty in order to turn their lives around. Hoping to impart their unique experience and wisdom through motherly tough love, Deb and Missy teach these women to say hello to their better selves and goodbye to Felicia.</p>',
    officialSite: "http://www.vh1.com/shows/bye-felicia",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 55,
      name: "VH1",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-12-09",
  },
  {
    id: 649,
    url: "https://www.tvmaze.com/shows/649/naild-it",
    name: "Nail'd It!",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/147/367675.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/147/367675.jpg",
    },
    summary:
      "<p><b>Nail'd It</b> pits 18 of the best up-and-coming nail artists against one another as they claw their way to the top to claim a life-changing grand prize of $100,000. The series premiere coincides with Oxygen's rebrand on Tuesday, October 7th across all platforms, launching the network's new logo and tagline, very real, targeting young, modern women.</p>",
    officialSite: "http://www.oxygen.com/naild-it",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 79,
      name: "Oxygen",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-07",
  },
  {
    id: 650,
    url: "https://www.tvmaze.com/shows/650/the-red-tent",
    name: "The Red Tent",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/307/769078.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/307/769078.jpg",
    },
    summary:
      "<p><b>The Red Tent</b> is a sweeping tale that takes place during the times of the Old Testament, told through the eyes of Dinah, the daughter of Leah and Jacob. Airing over two nights, the all-star cast includes Academy Award, Golden Globe and Emmy nominee Minnie Driver, Emmy nominee Morena Baccarin, Golden Globe nominee Rebecca Ferguson Iain Glen, Will Tudor and Academy Award, Golden Globe and Emmy nominee Debra Winger. The miniseries begins with Dinah's happy childhood spent inside the red tent where the women of her tribe gather and share the traditions and turmoil of ancient womanhood. The film recounts the story of Dinah's mothers Leah Rachel, Zilpah and Bilhah, the four wives of Jacob. Dinah matures and experiences an intense love that subsequently leads to a devastating loss, and the fate of her family is forever changed. Winger portrays Rebecca, Jacob's mother while Tudor stars as Joseph, Dinah's brother.</p>",
    officialSite: "http://www.mylifetime.com/movies/the-red-tent",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-12-07",
  },
  {
    id: 651,
    url: "https://www.tvmaze.com/shows/651/risking-it-all",
    name: "Risking It All",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/4/12438.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/4/12438.jpg",
    },
    summary:
      "<p>Three families not only unplug their smartphones and tablets, but they also give up electricity and running water for a life off the grid in a drastic last resort to reconnect with each other. From attempting to save their marriage to dealing with family illness to regaining control of their relationships, each family has a different reason for embarking on the journey of a lifetime. The three families pack up their homes, say their good-byes to loved ones, and prepare for the challenges that come with trading in the luxuries of modern-day society for a self-sufficient life.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-18",
  },
  {
    id: 652,
    url: "https://www.tvmaze.com/shows/652/the-sisterhood-becoming-nuns",
    name: "The Sisterhood: Becoming Nuns",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/29379.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/29379.jpg",
    },
    summary:
      "<p>The Sisterhood follows five young women who are considering the life-changing decision of taking religious vows to become Catholic nuns. For the first time ever, cameras were granted access to three convents* where the women live and work together alongside nuns during the discernment phase, the process wherein they decide if they want to formally continue on their holy path.</p><p>In observance of the sacred vows of chastity, poverty and obedience, they leave behind everything they have come to love - boyfriends, family members and all their worldly possessions - to see if they have what it takes to become servants of the church and brides of Christ.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-25",
  },
  {
    id: 653,
    url: "https://www.tvmaze.com/shows/653/lucha-underground",
    name: "Lucha Underground",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/264/660553.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/264/660553.jpg",
    },
    summary:
      '<p><b>Lucha Underground</b>, El Rey Network\'s addictive, lucha libre wrestling series from Emmy Award(R)-winning producer Mark Burnett, United Artists Media Group,Robert Rodriguez and FactoryMade Ventures will return for an all-new second season on Wednesday, January 27 at 8 PM ET/PT, it was announced today. The hour-long weekly series currently in production in Boyle Heights, CA, will continue to bring fans ringside for blood-pumping, chant-starting, fierce lucha libre drama and excitement as the masked heroes and villains battle it out for wrestling supremacy. Leading into the new season, El Rey Network offers fans a chance to get reacquainted with the luchadores, who combine ancient tradition with extraordinary athleticism, with five hours of back-to-back episodes from season one on Wednesdays at 8pm ET/PT beginning January 6th, culminating with an epic weekend long, 40-hour marathon of the entire season from Saturday, January 23rd at 10 AM ET, to Sunday, January 24th at 2 AM ET. "Season two of \'Lucha Underground\' absolutely stands on the shoulders of last season with even more excitement and high-flying drama than ever before," said El Rey Network Chairman and Founder Robert Rodriguez. "Mark Burnett and his team have delivered a truly compelling series and we are proud to bring the ancient traditions of Luche Libre to life in an unexpected and action packed format that has become a favorite for wrestling fans everywhere."</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 21,
      name: "El Rey Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-29",
  },
  {
    id: 654,
    url: "https://www.tvmaze.com/shows/654/country-buck",
    name: "Country Buck$",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31641.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31641.jpg",
    },
    summary:
      "<p><b>Country Buck$</b> follows the Busbice family who founded Wildgame Innovations, a small hunting gear business that has grown into a multi-million dollar wildlife sporting empire. Their 55,000-acre ranch (three times the size of Manhattan), a sportsman fantasy camp in Louisiana, serves as the testing ground for their new products. Follow the Busbice clan as they strive to perfect their high-tech hunting innovations, family-style.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-19",
  },
  {
    id: 655,
    url: "https://www.tvmaze.com/shows/655/ally-mcbeal",
    name: "Ally McBeal",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/13018.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/13018.jpg",
    },
    summary:
      "<p>Meet <b>Ally McBeal</b>, a single lawyer both blessed and cursed with eccentric colleagues, a now-married-to-someone-else childhood sweetheart, and an incredibly overactive imagination that's working overtime!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1997-09-08",
  },
  {
    id: 656,
    url: "https://www.tvmaze.com/shows/656/spin-city",
    name: "Spin City",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/13641.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/13641.jpg",
    },
    summary:
      "<p><b>Spin City</b> is a smart, sophisticated sitcom about the behind-the-scenes workings of City Hall in the biggest city in America. Workaholic Mike Flaherty is the Deputy Mayor of New York City, serving as Mayor Randall Winston's key strategist and much-needed handler. Mike runs the city with the help of his oddball staff: an anxious and insecure press secretary; a sexist, boorish chief of staff; an impeccably groomed gay activist running minority affairs; a sharp and efficient, man-crazy accountant; and an idealistic young speechwriter. Like Mike, they are all professionally capable but personally challenged.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-09-17",
  },
  {
    id: 657,
    url: "https://www.tvmaze.com/shows/657/spooks",
    name: "Spooks",
    genres: ["Drama", "Thriller", "Espionage"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/13652.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/13652.jpg",
    },
    summary:
      '<p>Tense drama series about the different challenges faced by the British Security Service as they work against the clock to safeguard the nation.</p><p>A team of agents in the British security intelligence service work to protect the U.K. from terrorists and other threats to national security. A repackaged version of the BBC series "Spooks," "MI-5" follows a counterterrorism unit based in the highly secure suite of offices called The Grid, where Harry Pearce oversees the team and deals with the often dirty politics of the spy game.</p>',
    officialSite: "http://www.bbc.co.uk/programmes/b006mf4b",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2002-05-13",
  },
  {
    id: 658,
    url: "https://www.tvmaze.com/shows/658/crossbones",
    name: "Crossbones",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/13668.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/13668.jpg",
    },
    summary:
      "<p>It's 1715 on the Bahamian island of Santa Campana, the first functioning democracy in the Americas, where the diabolical pirate Edward Teach, a.k.a. Blackbeard, reigns over a rogue nation of thieves, outlaws and miscreant sailors. Part shantytown, part marauder's paradise, this is a place like no other on earth - and a mounting threat to international commerce. To gain control of this fearsome society, Tom Lowe, a highly skilled undercover assassin, is sent to the buccaneers' haven to take down the brilliant and charismatic Blackbeard. But the closer Lowe gets, the more he finds that his quest is not so simple. Lowe can't help but admire the political ideals of Blackbeard, whose thirst for knowledge knows no bounds - and no law. But Lowe is not the only danger to Blackbeard's rule. He is a man with many villainous rivals and one great weakness - a passionately driven woman whom he cannot deny.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-05-30",
  },
  {
    id: 659,
    url: "https://www.tvmaze.com/shows/659/torchwood",
    name: "Torchwood",
    genres: ["Drama", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/161/404457.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/161/404457.jpg",
    },
    summary:
      "<p>Captain Jack Harkness is a man from the 51st century trapped in the past who leads the last remnants of the Torchwood Institute, a top secret British agency outside the government whose job it is to investigate alien goings on in the world, act in mankind's best interest, and, if needed, be the Earth's last line of defense.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006m8ln",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 17,
      name: "Starz",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-10-22",
  },
  {
    id: 660,
    url: "https://www.tvmaze.com/shows/660/joey",
    name: "Joey",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/13685.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/13685.jpg",
    },
    summary:
      "<p><b>Joey</b> is a spin-off of Friends (1994), continuing the story of charming and still-single Joey, who has struck out on his own and moved to Hollywood, hoping to truly make it as an actor. Joey says goodbye to a time when his friends were his family and welcomes the chance to turn his family into his friends. After reuniting with his high-strung sister Gina a strong and sexy hairdresser, Joey moves in with her genius 20-year-old son, graduate student Michael who literally is a rocket scientist. What Joey lacks in book smarts, however, he more than makes up for with his people skills, making him the best new friend his nephew could ask for.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-09-09",
  },
  {
    id: 661,
    url: "https://www.tvmaze.com/shows/661/the-great-christmas-light-fight",
    name: "The Great Christmas Light Fight",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/88/220242.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/88/220242.jpg",
    },
    summary:
      "<p>It's beginning to look a lot like Christmas with the hit holiday decorating competition series, <b>The Great Christmas Light Fight</b>. Decorating their homes to the extreme for Christmas, families and neighborhoods across America compete to win a cash prize and the coveted Light Fight trophy.</p>",
    officialSite: "http://abc.go.com/shows/the-great-christmas-light-fight",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-12-09",
  },
  {
    id: 662,
    url: "https://www.tvmaze.com/shows/662/leverage",
    name: "Leverage",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/125/313702.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/125/313702.jpg",
    },
    summary:
      "<p><b>Leverage</b> is a slick and crafty drama following a team of expert thieves that take down corrupt corporations in elaborate high-tech schemes. Insurance investigator Nate Ford exposed scams and recovered stolen items worth millions. But his life hit the skids when his insurance company allowed his ailing 8-year-old son to die. Years later, Nate gets even as the leader of a specialized team of thieves, computer experts and con artists that right corporate and governmental injustices against honest citizens. To expose corruption, Nate will do wrong for all the right reasons –– he will provide <i>Leverage</i>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-12-07",
  },
  {
    id: 663,
    url: "https://www.tvmaze.com/shows/663/the-shield",
    name: "The Shield",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/55/138892.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/55/138892.jpg",
    },
    summary:
      "<p>Detective Vic Mackey is the leader of an elite Strike Team unit, a group of cops effective at eliminating crime but also operating under Vic's own set of rules. But his rules sometimes cross the fine line between legal and illegal. Now the precinct has a new captain who doesn't like Vic's tactics and wants to bust him off the force - even as the captain finds himself going to Vic for help whenever the going gets rough.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-03-12",
  },
  {
    id: 664,
    url: "https://www.tvmaze.com/shows/664/make-it-or-break-it",
    name: "Make It or Break It",
    genres: ["Drama", "Comedy", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14720.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14720.jpg",
    },
    summary:
      "<p>Set in the realm of competitive gymnastics, <b>Make It or Break It</b> follows a group of teen Olympic hopefuls in training for the biggest event of their lives.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-06-22",
  },
  {
    id: 665,
    url: "https://www.tvmaze.com/shows/665/mash",
    name: "M*A*S*H",
    genres: ["Comedy", "War", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14728.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14728.jpg",
    },
    summary:
      '<p>Loosely based on the real-life M*A*S*H unit 8055, life at the 4077 revolved around the day-to-day routines of Captain "Hawkeye" Pierce, Captain "Trapper" McIntyre, Lieutenant Colonel Henry Blake, Major Margaret Houlihan, Major Franklin Burns and Corporal "Radar" O\'Reilly. Through these characters, viewers traveled beyond the long hours and the horrors of the operating room to a place where friendships were forged, laughter was found and drinks were served.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1972-09-17",
  },
  {
    id: 666,
    url: "https://www.tvmaze.com/shows/666/drop-dead-diva",
    name: "Drop Dead Diva",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14740.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14740.jpg",
    },
    summary:
      "<p>Life can really throw you curves -- especially in this breakthrough comedic drama. <b>Drop Dead Diva</b> tells the story of Deb, a shallow model who dies in a sudden accident. By a twist of fate and a bolt of divine intervention, her soul resurfaces in the body of Jane, a smart, plus-sized and recently deceased attorney. As she confronts the challenges of her adventurous new life, love and career, she must learn to reconcile her beauty queen ways with her brilliant new mind -- finding surprises at every turn.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-07-12",
  },
  {
    id: 667,
    url: "https://www.tvmaze.com/shows/667/burn-notice",
    name: "Burn Notice",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14749.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14749.jpg",
    },
    summary:
      "<p>My name is Michael Westen. I used to be a spy. Until I got a burn notice, I was blacklisted. When you're burned, you've got nothing: no cash, no credit, no job history. You're stuck in whatever city they decide to dump you in. Miami. You do whatever work comes your way. You rely on anyone who's still talking to you. A trigger-happy ex-girlfriend... An old friend who used to inform on you to the FBI... Family too... if you're desperate... Bottom line? Until you figure out who burned you... you're not going anywhere.</p>",
    officialSite: "http://www.usanetwork.com/burnnotice",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-06-28",
  },
  {
    id: 668,
    url: "https://www.tvmaze.com/shows/668/teenage-mutant-ninja-turtles",
    name: "Teenage Mutant Ninja Turtles",
    genres: ["Comedy", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14755.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14755.jpg",
    },
    summary:
      "<p>Leo, Donnie, Raph and Mikey are mutant turtles who have been trained in the art of ninjutsu by their rat sensei, Master Splinter. Emerging from their sewer lair, the reptile brothers confront the wondrous world of New York City, facing villains more dangerous and pizza more delicious than anything they could have imagined.</p><p>Through battles with Shredder, the Kraang and loads of super-powerful mutants, the Turtles learn to rely on themselves and each other as they grow to become the heroes they are destined to be.</p>",
    officialSite: "http://www.nick.com/ninja-turtles/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 73,
      name: "Nicktoons",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-09-28",
  },
  {
    id: 669,
    url: "https://www.tvmaze.com/shows/669/in-the-flesh",
    name: "In the Flesh",
    genres: ["Drama", "Horror", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/32/80591.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/32/80591.jpg",
    },
    summary:
      "<p>Thousands of dead people have risen from their graves and nearly destroyed Britain. A cure has been found - but can the treated zombies be rehabilitated back into living society?</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b042ckss",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-03-17",
  },
  {
    id: 670,
    url: "https://www.tvmaze.com/shows/670/luther",
    name: "Luther",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/179/448007.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/179/448007.jpg",
    },
    summary:
      "<p>A dark psychological crime drama starring Idris Elba as Luther, a man struggling with his own terrible demons, who might be as dangerous as the depraved murderers he hunts.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00vk2lp",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-05-04",
  },
  {
    id: 671,
    url: "https://www.tvmaze.com/shows/671/avengers-earths-mightiest-heroes",
    name: "Avengers: Earth's Mightiest Heroes",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14777.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14777.jpg",
    },
    summary:
      "<p>When the planet is threatened by Super Villains, time-traveling conquerors, alien invaders, mythical monsters or mad robots bent on the total destruction of humanity; when the forces of evil are so overwhelming that no single hero has the power to save the world; when there is no hope left, the Avengers Assemble!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 25,
      name: "Disney XD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-22",
  },
  {
    id: 672,
    url: "https://www.tvmaze.com/shows/672/phineas-and-ferb",
    name: "Phineas and Ferb",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14778.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14778.jpg",
    },
    summary:
      "<p><b>Phineas and Ferb</b> are Phineas Flynn and his stepbrother, Ferb Fletcher who are determined to make every day of their summer vacation fun. They try building a full-scale roller coaster, becoming musicians, building a backyard beach, and traveling back in time to meet dinosaurs. Their family pet, Perry the Platypus, doubles as a secret agent and battles evil. Meanwhile, older sister Candace is tattling on them to Mom and Dad, though she can never seem to catch them in the act.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 78,
      name: "Disney Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-08-17",
  },
  {
    id: 673,
    url: "https://www.tvmaze.com/shows/673/roswell",
    name: "Roswell",
    genres: ["Drama", "Romance", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/189/474579.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/189/474579.jpg",
    },
    summary:
      "<p>Human/Alien hybrids, must hide their alien sides to fit into their New Mexico-high school, while attempting to learn about their past, their gifts, and love as outsiders. Their destinies clash with their feelings as they discover the extraordinary circumstances that led them to Earth, and may eventually lead them home.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 70,
      name: "UPN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-10-06",
  },
  {
    id: 674,
    url: "https://www.tvmaze.com/shows/674/southland",
    name: "Southland",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14795.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14795.jpg",
    },
    summary:
      "<p>From Emmy Award winners John Wells, Ann Biderman and Chris Chulack comes a raw and authentic look at the police unit in Los Angeles. From the beaches of Malibu to the streets of East LA, <b>Southland</b> is a fast-moving drama that will take you inside the lives of cops, criminals, victims and their families.</p><p>Michael Cudlitz plays John Cooper a seasoned Los Angeles cop, assigned to train young rookie Ben Sherman. Cooper's honest, no-nonsense approach to the job leaves Sherman questioning whether or not he has what it takes to become a police officer.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-04-09",
  },
  {
    id: 675,
    url: "https://www.tvmaze.com/shows/675/ancient-aliens",
    name: "Ancient Aliens",
    genres: ["Drama", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14804.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14804.jpg",
    },
    summary:
      "<p><b>Ancient Aliens</b> explores the controversial theory that extraterrestrials have visited Earth for millions of years. From the age of the dinosaurs to ancient Egypt, from early cave drawings to continued mass sightings in the US, each episode in this hit History series gives historic depth to the questions, speculations, provocative controversies, first-hand accounts and grounded theories surrounding this age old debate. Did intelligent beings from outer space visit Earth thousands of years ago?</p>",
    officialSite: "http://www.history.com/shows/ancient-aliens",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-03-08",
  },
  {
    id: 676,
    url: "https://www.tvmaze.com/shows/676/sex-and-the-city",
    name: "Sex and the City",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/107/269795.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/107/269795.jpg",
    },
    summary:
      "<p>A candid, comic view of sex and relationships, <b>Sex and the City</b> stars Sarah Jessica Parker as Carrie Bradshaw, a New York-based writer who explores and experiences the unique world of Manhattan's dating scene, chronicling the mating habits of single New Yorkers. Executive produced by Michael Patrick King, the series also stars cast regulars Kim Cattrall as PR executive Samantha Jones, who's seen -- and done -- it all; Kristin Davis as Charlotte York, still trying to hold on to the idea of happily ever after; and Cynthia Nixon as corporate lawyer and mother Miranda Hobbes, a pragmatist trying to balance the idea of love with the realities of life. Mikhail Baryshnikov (as Aleksandr Petrovsky), Mario Cantone (Anthony Marentino), David Eigenberg (Steve Brady), Willie Garson (Stanford Blatch), Evan Handler (Harry Goldenblatt) and Jason Lewis (Smith Jerrod) also star.</p>",
    officialSite: "http://www.hbo.com/sex-and-the-city",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-06-06",
  },
  {
    id: 677,
    url: "https://www.tvmaze.com/shows/677/rome",
    name: "Rome",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14810.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14810.jpg",
    },
    summary:
      "<p>Four hundred years after the founding of the Republic, Rome is the wealthiest city in the world. The Republic was founded on principals of shared power, never allowing one man to seize absolute control. But now, those foundations are crumbling...and two soldiers unwittingly become entwined in the historical events of ancient Rome. A drama of love and betrayal, masters and slaves, husbands and wives, Rome chronicles a turbulent era that saw the death of a republic and the birth of an empire.</p>",
    officialSite: "https://www.hbo.com/rome",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-08-28",
  },
  {
    id: 678,
    url: "https://www.tvmaze.com/shows/678/my-name-is-earl",
    name: "My Name is Earl",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14824.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14824.jpg",
    },
    summary:
      "<p>Karma is a funny thing. Just ask Earl who's learning the hard way that when you do something bad, it has a way of coming back and biting you in the ass! Hoping to turn his life around, Earl's got a lengthy list of detestable deeds to make up for.</p>",
    officialSite: "http://www.nbc.com/my-name-is-earl",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-09-20",
  },
  {
    id: 679,
    url: "https://www.tvmaze.com/shows/679/damages",
    name: "Damages",
    genres: ["Drama", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14830.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14830.jpg",
    },
    summary:
      "<p>Set in New York's world of high stakes litigation, <b>Damages</b> follows the lives of Patty Hewes, the nation's most revered and most reviled litigator, and her bright, ambitious protégée Ellen Parsons as they become embroiled in a class action lawsuit targeting Arthur Frobisher, one of the country's wealthiest CEOs. As Patty battles Frobisher and his attorney, Ellen learns what it takes to win at all costs -- and that lives, not just fortunes, are at stake.</p><p>The series premiered on July 24, 2007 on FX and aired for three seasons before moving to the DirecTV channel Audience Network in 2010, airing for two further seasons, and concluding in 2012.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 31,
      name: "Audience Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-07-24",
  },
  {
    id: 680,
    url: "https://www.tvmaze.com/shows/680/airwolf",
    name: "Airwolf",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14841.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14841.jpg",
    },
    summary:
      "<p>Stringfellow Hawke is a reclusive renegade pilot who's assigned to top-secret missions for the CIA by the mysterious \"Archangel\". Hawke's weapon of choice is the high-tech battle helicopter of the future, <b>Airwolf</b>. Loaded with cutting-edge surveillance equipment and unbelievable firepower, Airwolf takes Hawke and his friend Dominic around the globe in search of dangerous international spies and criminals.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1984-01-22",
  },
  {
    id: 681,
    url: "https://www.tvmaze.com/shows/681/the-pretender",
    name: "The Pretender",
    genres: ["Drama", "Adventure", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14846.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14846.jpg",
    },
    summary:
      "<p>Jarod is a<b> Pretender</b> - a genius whose exceptional intelligence allows him to assume various identities at will, be it doctor, test pilot or lawyer. Taken from his parents at an early age, Jarod was brought up in the Centre, a think-tank facility where he believed his computer-like mind was being used to benefit mankind. But when he learned the simulations he solved were being sold to the highest-bidder no matter what their intent, Jarod escaped. Now on the run, Jarod embarks on a search for his true identity while also attempting to balance out any wrong his simulations have caused by helping people who are as powerless as he once was.</p>",
    officialSite: "https://www.thepretenderlives.com/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-09-19",
  },
  {
    id: 682,
    url: "https://www.tvmaze.com/shows/682/numb3rs",
    name: "Numb3rs",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14852.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14852.jpg",
    },
    summary:
      "<p>FBI Special Agent Don Eppes recruits his mathematical genius brother Charlie to help the Bureau solve a wide range of challenging crimes in Los Angeles. The two brothers take on the most confounding criminal cases from a very distinctive perspective. Dr. Larry Fleinhardt is Charlie's friend and colleague who urges Charlie to focus more on his university studies than on FBI business. Don and Charlie's father, Alan Eppes is pleased to see his two sons working together, but fears their competitive nature will lead to trouble.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-01-23",
  },
  {
    id: 683,
    url: "https://www.tvmaze.com/shows/683/boy-meets-world",
    name: "Boy Meets World",
    genres: ["Drama", "Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14863.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14863.jpg",
    },
    summary:
      "<p>Cory is your average guy. He has a best friend from the other side of the tracks, a teacher that constantly keeps him on his toes, and a friend named Topanga whom he has trouble understanding. With the support of his parents and his brother Eric, Cory learns to cope with the roller coaster called growing up.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-09-24",
  },
  {
    id: 684,
    url: "https://www.tvmaze.com/shows/684/necessary-roughness",
    name: "Necessary Roughness",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14877.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14877.jpg",
    },
    summary:
      "<p><b>Necessary Roughness</b> focuses on tough sexy Long Island divorcee Dani who re-energizes her life and career when she becomes a therapist for a professional football team. Underestimated at every turn, she succeeds beyond all expectations and soon finds herself the most sought-after therapist for high-profile clients. Athletes, musicians, politicians and others living in the spotlight - all in a moment of crisis - clamor for her unique brand of tough love therapy. As a newly single mom raising two teenagers, her start-up practice wreaks havoc on her life. But recognizing that she's changing people's lives for the better, she is determined to make her new career work by striking a balance between her personal and professional worlds.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-06-29",
  },
  {
    id: 685,
    url: "https://www.tvmaze.com/shows/685/dance-moms",
    name: "Dance Moms",
    genres: ["Drama", "Family", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/325/812522.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/325/812522.jpg",
    },
    summary:
      "<p>Abby Lee Miller and the nation's favorite tween dancers take on Hollywood in this all-new season of <b>Dance Moms</b> (#DanceMoms). New auditions, new competitions and new dance studios raise the stakes higher than ever before.</p>",
    officialSite: "http://www.mylifetime.com/shows/dance-moms",
    webChannel: {
      id: 181,
      name: "mylifetime.com",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "To Be Determined",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-07-13",
  },
  {
    id: 686,
    url: "https://www.tvmaze.com/shows/686/robot-chicken",
    name: "Robot Chicken",
    genres: ["Comedy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14886.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14886.jpg",
    },
    summary:
      "<p><b>Robot Chicken</b> uses stop-motion animation to bring pop-culture parodies to life in a modern take on the variety/sketch show format.</p>",
    officialSite: "http://www.adultswim.com/videos/robot-chicken/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-02-20",
  },
  {
    id: 687,
    url: "https://www.tvmaze.com/shows/687/project-runway",
    name: "Project Runway",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/189/474517.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/189/474517.jpg",
    },
    summary:
      "<p><b>Project Runway</b> designers are given an opportunity to launch their careers in fashion.</p>",
    officialSite: "http://www.bravotv.com/project-runway",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-12-01",
  },
  {
    id: 688,
    url: "https://www.tvmaze.com/shows/688/manhattan",
    name: "Manhattan",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/46/116919.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/46/116919.jpg",
    },
    summary:
      "<p>Set in Los Alamos, N.M., at the Manhattan Project during the race to build the world's first atomic bomb, <b>Manhattan</b> explores the cost of secrets and the corrosive effect they have on individuals, families and their relationships.</p>",
    officialSite: "http://wgnamerica.com/series/manhattan",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 28,
      name: "WGN America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-27",
  },
  {
    id: 689,
    url: "https://www.tvmaze.com/shows/689/young-justice",
    name: "Young Justice",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14943.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14943.jpg",
    },
    summary:
      "<p><b>Young Justice</b> is an animated series about a squad of teenage superheroes from the DC Comics universe. Three years after<i> Young Justice</i> was cancelled by Cartoon Network, the cult action-animated series came back on DC Universe.</p>",
    officialSite: "https://www.dcuniverse.com/videos/young-justice/58/season-1",
    webChannel: {
      id: 329,
      name: "HBO Max",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Running",
    network: null,
    premiered: "2010-11-26",
  },
  {
    id: 690,
    url: "https://www.tvmaze.com/shows/690/roseanne",
    name: "Roseanne",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/146/365953.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/146/365953.jpg",
    },
    summary:
      "<p>A groundbreaking American television sitcom, following the fortunes of the down-to-earth, blue collar Conner family in the small town of Lanford, Illinois.</p>",
    officialSite: "http://abc.go.com/shows/roseanne",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1988-10-18",
  },
  {
    id: 691,
    url: "https://www.tvmaze.com/shows/691/daniel-tigers-neighborhood",
    name: "Daniel Tiger's Neighborhood",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14968.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14968.jpg",
    },
    summary:
      "<p><b>Daniel Tiger's Neighborhood</b> is a animated program for preschoolers ages 2 to 4 which builds on the pioneering PBS series, Mister Rogers' Neighborhood. This new series, for a new generation of children, tells its engaging stories about the life of a preschooler using musical strategies grounded in Fred Rogers' landmark social-emotional curriculum. Through imagination, creativity and music, Daniel and his friends learn the key social skills necessary for school and for life.</p>",
    officialSite: "https://pbskids.org/daniel/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 85,
      name: "PBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-09-03",
  },
  {
    id: 692,
    url: "https://www.tvmaze.com/shows/692/everybody-hates-chris",
    name: "Everybody Hates Chris",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14969.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14969.jpg",
    },
    summary:
      "<p>Inspired by his childhood experiences, comedian Chris Rock narrates the hilarious, touching story of a teenager growing up as the eldest of children in Brooklyn, New York during the early 1980s.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-09-22",
  },
  {
    id: 693,
    url: "https://www.tvmaze.com/shows/693/jeeves-and-wooster",
    name: "Jeeves and Wooster",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14977.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14977.jpg",
    },
    summary:
      "<p>Perfectly capturing the wit of P.G Wodehouse's novels, this impeccable series traces the insane shenanigans of Bertram Wooster and his faithful butler Jeeves. Set against a 1930s backdrop of Hooray Henries and splendidly indomitable aunts, Jeeves battles against Wooster's relentless list of prospective brides to hilarious consequences.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1990-04-22",
  },
  {
    id: 694,
    url: "https://www.tvmaze.com/shows/694/monty-pythons-flying-circus",
    name: "Monty Python's Flying Circus",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14980.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14980.jpg",
    },
    summary:
      "<p>And now for something completely different: <b>Monty Python's Flying Circus</b> was simply the most influential comedy program television has ever seen. Five Englishmen, all working under the constraints of conventional TV shows such as The Frost Report (for which the five Englishmen wrote), gathered together with an expatriate American in the spring of 1969 to break the rules. The result, first airing on BBC-1 on October 5, 1969, has influenced countless future men and women in the media and comedy since.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1969-10-05",
  },
  {
    id: 695,
    url: "https://www.tvmaze.com/shows/695/durarara",
    name: "Durarara!!",
    genres: ["Drama", "Action", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14981.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14981.jpg",
    },
    summary:
      "<p>Mikado Ryugamine is a young man who yearns for the city like no other. At the invitation of his childhood friend, Masaomi Kida, he moves to Ikebukuro, Tokyo and enters school there.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 24,
      name: "MBS",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2010-01-08",
  },
  {
    id: 696,
    url: "https://www.tvmaze.com/shows/696/the-x-factor",
    name: "The X Factor",
    genres: ["Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/165/414782.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/165/414782.jpg",
    },
    summary:
      "<p>Thousands audition. Only one can win. The search is on for the next singing Superstar.</p><p><b>The X Factor</b> is a talent show in which the participants have to audition before a jury.</p>",
    officialSite: "http://www.itv.com/xfactor",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2004-09-04",
  },
  {
    id: 697,
    url: "https://www.tvmaze.com/shows/697/the-critic",
    name: "The Critic",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14997.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14997.jpg",
    },
    summary:
      '<p>From the producers of "The Simpsons"! Jon Lovitz is the animated Jay Sherman, a TV movie critic who is forced to review the most pathetic films which he always rates as "It stinks." In addition to the film parodies, the show also deals with his personal life: working for a tyrannical media mogul boss, his lovelife and his family.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1994-01-26",
  },
  {
    id: 698,
    url: "https://www.tvmaze.com/shows/698/peg-cat",
    name: "Peg + Cat",
    genres: ["Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14998.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14998.jpg",
    },
    summary:
      "<p><b>Peg + Cat</b> inspires preschool children to see math as exciting, accessible, and fun.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 85,
      name: "PBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-10-07",
  },
  {
    id: 699,
    url: "https://www.tvmaze.com/shows/699/play-for-today",
    name: "Play for Today",
    genres: ["Drama", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/5/14999.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/5/14999.jpg",
    },
    summary:
      "<p><b>Play for Today</b>, an anthology series of plays carrying on in the tradition of its predecessor <i>The Wednesday Play</i>, presented controversial works by such writers as Dennis Potter, David Mercer, Alan Bennett, and Jim Allen, with such directors as Ken Loach, Alan Clarke, Philip Saville, and Mike Newell. Several plays in the series led to various spin-offs, including <i>Play for Tomorrow</i> and <i>Rumpole of the Bailey</i>.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00cnhjw",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1970-10-15",
  },
  {
    id: 700,
    url: "https://www.tvmaze.com/shows/700/marco-polo",
    name: "Marco Polo",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/61/153841.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/61/153841.jpg",
    },
    summary:
      "<p>In a world replete with greed, betrayal, sexual intrigue and rivalry, <b>Marco Polo</b> is based on the famed explorer's adventures in Kublai Khan's court in 13th century China.</p>",
    officialSite: "https://www.netflix.com/title/70305883",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2014-12-12",
  },
  {
    id: 701,
    url: "https://www.tvmaze.com/shows/701/dancing-on-the-edge",
    name: "Dancing on the Edge",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15002.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15002.jpg",
    },
    summary:
      "<p>An explosive 1930s drama following a jazz band in London at a time of huge change.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p013qqwt",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-02-04",
  },
  {
    id: 702,
    url: "https://www.tvmaze.com/shows/702/gold-rush",
    name: "Gold Rush",
    genres: ["Action", "Adventure", "Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/244/610985.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/244/610985.jpg",
    },
    summary:
      "<p><b>Gold Rush</b> follows six men who, in the face of an economic meltdown, risk everything - their families, their dignity, and in some cases, their lives - to strike it rich mining for gold in the wilds of Alaska. Inspired by his father Jack, Todd Hoffman of Sandy, Oregon, leads a group of greenhorn miners to forge a new frontier and save their families from dire straits. While leasing a gold claim in Alaska, Todd and his company of newbies face the grandeur of Alaska as well as its hardships, including an impending winter that will halt operations and the opportunity to strike gold. In an effort to keep the operation running, the team takes fate into their own hands with a make or break venture that will change their lives forever.</p>",
    officialSite: "http://www.discovery.com/tv-shows/gold-rush/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-12-03",
  },
  {
    id: 703,
    url: "https://www.tvmaze.com/shows/703/qi",
    name: "QI",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/147/368908.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/147/368908.jpg",
    },
    summary:
      "<p>Comedy quiz show in which contestants are rewarded if their answers are quite interesting.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006ml0g",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2003-09-11",
  },
  {
    id: 704,
    url: "https://www.tvmaze.com/shows/704/shaun-the-sheep",
    name: "Shaun the Sheep",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15005.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15005.jpg",
    },
    summary:
      "<p>Clever sheep Shaun, loyal dog Bitzer and the rest of the Mossy Bottom gang cook up oodles of fun and mischief on the farm.</p>",
    officialSite: "http://www.bbc.co.uk/cbbc/shows/shaun-the-sheep",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Running",
    network: null,
    premiered: "2007-03-05",
  },
  {
    id: 705,
    url: "https://www.tvmaze.com/shows/705/fast-n-loud",
    name: "Fast N' Loud",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/207/518600.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/207/518600.jpg",
    },
    summary:
      "<p>Motor mastermind and entrepreneur Richard Rawlings of Gas Monkey Garage searches for derelict classic cars. To some, the cars look like rust buckets but to this crew, they're gold and ready to be brought back to life.</p>",
    officialSite: "http://www.discovery.com/tv-shows/fast-n-loud/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-06-06",
  },
  {
    id: 706,
    url: "https://www.tvmaze.com/shows/706/teen-titans-go",
    name: "Teen Titans Go!",
    genres: ["Comedy", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15007.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15007.jpg",
    },
    summary:
      "<p><b>Teen Titans Go!</b> is a character-driven comedy series focuses on the funny that happens in between saving the world and living together as teenagers without adult supervision. The comedic mayhem of the animated series is punctuated by pranks and the occasional need to fight crime, but it will also deal with the everyday issues of adolescence. With epic staring contests to decide who does the laundry, a series of quests and battles to construct the perfect sandwich or fighting crime in Jump City, one thing is for sure, these Titans will always be ready for an adventure inside the house and out.</p>",
    officialSite: "http://www.cartoonnetwork.com/video/teen-titans-go/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-04-23",
  },
  {
    id: 707,
    url: "https://www.tvmaze.com/shows/707/sofia-the-first",
    name: "Sofia the First",
    genres: ["Adventure", "Children", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15008.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15008.jpg",
    },
    summary:
      "<p><b>Sofia the First</b> is a about a little girl, a commoner, until her mom marries the king and suddenly she's royalty.</p>",
    officialSite: "https://www.disneyjunior.disney.com/sofia-the-first",
    webChannel: {
      id: 83,
      name: "DisneyNOW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: {
      id: 78,
      name: "Disney Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-01-11",
  },
  {
    id: 708,
    url: "https://www.tvmaze.com/shows/708/lilyhammer",
    name: "Lilyhammer",
    genres: ["Drama", "Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15009.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15009.jpg",
    },
    summary:
      '<p><b>Lilyhammer</b> follows New York mobster Frank "The Fixer" Tagliano as he enters the federal witness protection program after ratting on his boss. A sports fan, Frank wants to make his new life in Lillehammer, the Norwegian town that hosted the 1994 Winter Olympics - or as he calls it "Lilyhammer." Frank has visions of a paradise of "clean air, fresh white snow and gorgeous broads" far away from the temptations of the Big Apple and from mob hit men. Reality, of course, turns out to be spectacularly different.</p>',
    officialSite: "https://tv.nrk.no/serie/lilyhammer",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 91,
      name: "NRK1",
      country: { name: "Norway", code: "NO", timezone: "Europe/Oslo" },
    },
    premiered: "2012-01-25",
  },
  {
    id: 709,
    url: "https://www.tvmaze.com/shows/709/an-idiot-abroad",
    name: "An Idiot Abroad",
    genres: ["Comedy", "Adventure", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/37/92764.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/37/92764.jpg",
    },
    summary:
      "<p>Ricky Gervais and Stephen Merchant's partner in crime, Karl Pilkington, isn't much of a traveller, but now he is set to experience a variety of people and cultures as he explores the Seven Wonders of the World in this unmissable series.</p>",
    officialSite:
      "https://www.sky.com/new-search/an-idiot-abroad-959d38fd-f9c0-43b7-a59e-76b95039efb4?q=An%20Idiot",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 63,
      name: "Sky 1",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-09-23",
  },
  {
    id: 710,
    url: "https://www.tvmaze.com/shows/710/mickey-mouse-clubhouse",
    name: "Mickey Mouse Clubhouse",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15020.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15020.jpg",
    },
    summary:
      '<p>Disney\'s <b>Mickey Mouse Clubhouse</b> is the first computer generated 3-D animation television series to feature the "Sensational Six." Mickey Mouse, Minnie Mouse, Donald Duck, Daisy Duck, Goofy, and Pluto star in this series, which focuses on interactivity with its primarily preschool-aged audience to stimulate problem solving. Each episode involves the characters helping its viewers to "solve a specific age-appropriate problem utilizing basic skills, such as identifying shapes and counting through ten." The series uses Playhouse Disney\'s "whole child" curriculum of cognitive, social and creative learning opportunities.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 78,
      name: "Disney Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-05-06",
  },
  {
    id: 711,
    url: "https://www.tvmaze.com/shows/711/whos-the-boss",
    name: "Who's the Boss?",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15021.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15021.jpg",
    },
    summary:
      '<p>When a career-ending injury forces a baseball star into early retirement, he takes a job as a live-in housekeeper for a pushy advertising executive and her nosy mother-but <i>"Who\'s the Boss?"</i></p>.',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1984-09-20",
  },
  {
    id: 712,
    url: "https://www.tvmaze.com/shows/712/the-tudors",
    name: "The Tudors",
    genres: ["Drama", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15022.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15022.jpg",
    },
    summary:
      "<p>Jonathan Rhys Meyers stars in this original, history-based drama series as the young, vibrant King Henry VIII, a competitive and lustful monarch who navigates the intrigues of the English court and the human heart with equal vigor and justifiable suspicion.</p>",
    officialSite: "http://www.sho.com/the-tudors",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-04-01",
  },
  {
    id: 713,
    url: "https://www.tvmaze.com/shows/713/spongebob-squarepants",
    name: "SpongeBob SquarePants",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/202/505278.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/202/505278.jpg",
    },
    summary:
      "<p>Come follow the adventures of the world's most lovable sponge and his starfish sidekick! Though they have the best intentions, SpongeBob and Patrick are always causing trouble… and plenty of laughs!<br /><br />When he's not at the Krusty Krab grilling up some epic Krabby Patties, SpongeBob can be found jellyfishing with Patrick, blowing bubbles, or annoying his favorite neighbor, Squidward!<br /><br />Bikini Bottom is home to the coolest creatures under the sea, and you CAN'T miss out on any of their adventures. Is mayonnaise an instrument? Watch <i>SpongeBob SquarePants</i> to find out!<br /><br />Are you ready, kids? AYE AYE CAPTAIN!</p>",
    officialSite: "http://www.nick.com/spongebob-squarepants/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-05-01",
  },
  {
    id: 714,
    url: "https://www.tvmaze.com/shows/714/star-trek-enterprise",
    name: "Star Trek: Enterprise",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/292/730796.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/292/730796.jpg",
    },
    summary:
      "<p><b>Star Trek: Enterprise</b> (ENT) focuses on the 22nd century adventures of Captain Jonathan Archer aboard the Enterprise NX-01 during the early days of interstellar travel. The NX designation indicates that this Enterprise is an experimental prototype; Unlike the starships of the four other <i>Star Trek </i>series, this Enterprise doesn't have deflector shields or phasers, but it does come equipped with a phase cannon and a rudimentary transporter that functions efficiently most of the time.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 70,
      name: "UPN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-09-26",
  },
  {
    id: 716,
    url: "https://www.tvmaze.com/shows/716/spartacus",
    name: "Spartacus",
    genres: ["Action", "Adventure", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15053.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15053.jpg",
    },
    summary:
      "<p>Betrayed by his country. Beaten into slavery. Reborn as a warrior. <b>Spartacus</b> is a graphic and visceral account of Rome's most famous gladiator. When he is separated from the love of his life, Spartacus is forced into the gruesome and bloodthirsty arena, where a grisly death is primetime entertainment. Spartacus must fight for survival, befriend his enemies and play politics in this new world of corruption, violence, sex and fame. He will be seduced by power and tormented by vengeance. But his passion will give him the strength to prevail over every obstacle, in this modern and uninhibited tale of death, honour and endurance.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 17,
      name: "Starz",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-01-22",
  },
  {
    id: 717,
    url: "https://www.tvmaze.com/shows/717/quantum-leap",
    name: "Quantum Leap",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15077.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15077.jpg",
    },
    summary:
      '<p>Get ready to join Dr. Sam Beckett on the adventure of many lifetimes! Who will he be this time? Mafia hit man. Air Force test pilot. Professional boxer. Sam Beckett is a time traveler who never knows whose body he is going to "leap" into next and at what moment in history he may find himself. Sam is joined by a helpful but easily distracted holographic guide Al, who assists him on his missions and aids Sam in his ultimate goal of returning to his own life in the present.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1989-03-26",
  },
  {
    id: 718,
    url: "https://www.tvmaze.com/shows/718/the-tonight-show-starring-jimmy-fallon",
    name: "The Tonight Show Starring Jimmy Fallon",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15080.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15080.jpg",
    },
    summary:
      '<p>Emmy Award and Grammy Award winner Jimmy Fallon brought NBC\'s "The Tonight Show" back to its New York origins when he launched <b>The Tonight Show Starring Jimmy Fallon </b>from Rockefeller Center. Fallon puts his own stamp on the storied NBC late-night franchise with his unique comedic wit, on-point pop culture awareness, welcoming style and impeccable taste in music with the award-winning house band, The Roots.</p>',
    officialSite: "http://www.nbc.com/the-tonight-show",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-02-17",
  },
  {
    id: 719,
    url: "https://www.tvmaze.com/shows/719/tanked",
    name: "Tanked",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15085.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15085.jpg",
    },
    summary:
      "<p>Following the antics of two brothers-in-law as they run the largest aquarium manufacturing company in the nation, <b>Tanked</b> dunks viewers into the high-decibel, family-owned business of Acrylic Tank Manufacturing (ATM). Led by business partners, best friends and rivals Wayde King and Brett Raymer and housed in a state-of-the-art, cavernous facility located in the center of Sin City, ATM has created thousands of enormous, conceptual aquariums for high-profile clients. Working with opinionated and outrageous family and staff, the duo takes on jaw-dropping aquarium builds from such intricate and interesting locations as inside restaurants, casinos, bank, hotels, churches, offices, mansions, museums and zoos. Their tanks are for celebrities and ordinary Joes, and their aquariums and their business are filled with the most unusual and larger-than-life creatures in the world.</p>",
    officialSite: "http://www.animalplanet.com/tv-shows/tanked/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 92,
      name: "Animal Planet",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-08-07",
  },
  {
    id: 720,
    url: "https://www.tvmaze.com/shows/720/rules-of-engagement",
    name: "Rules of Engagement",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/42/107168.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/42/107168.jpg",
    },
    summary:
      "<p>A comedy that follows two couples and a single guy as they navigate the jungles of dating, engagement and marriage.</p>",
    officialSite: "http://www.cbs.com/shows/rules_of_engagement",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-02-05",
  },
  {
    id: 721,
    url: "https://www.tvmaze.com/shows/721/pawnography",
    name: "Pawnography",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/323/808770.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/323/808770.jpg",
    },
    summary:
      "<p>In each episode of <b>Pawnography</b>, contestants will compete against each other and 'The Pawn Stars' in three rounds of trivia style questions - that escalate in difficulty as the rounds advance - to win money and coveted items from the World Famous Gold &amp; Silver Pawnshop. Rick, Corey &amp; Chumlee are featured in each episode as they vigorously defend their treasured items from confident and brainy contestants. The cherished items up for grabs are from Rick's personal collection and he doesn't want to give them up - this is the only game show that doesn't want the contestants to win!</p>",
    officialSite: "http://www.history.com/shows/pawnography",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-10",
  },
  {
    id: 722,
    url: "https://www.tvmaze.com/shows/722/the-golden-girls",
    name: "The Golden Girls",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15097.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15097.jpg",
    },
    summary:
      "<p><b>The Golden Girls</b> follows four South Florida seniors sharing a house, their dreams, and a whole lot of cheesecake. Bright, promiscuous, clueless, and hilarious, these lovely mismatched ladies form the perfect circle of friends.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1985-09-14",
  },
  {
    id: 725,
    url: "https://www.tvmaze.com/shows/725/where-on-earth-is-carmen-sandiego",
    name: "Where on Earth is Carmen Sandiego?",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15102.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15102.jpg",
    },
    summary:
      "<p>The world s greatest thief is on the loose, and it s up to you to find her! The world famous thief, Carmen Sandiego, plays an intricate game of cat and mouse with teen ACME detectives, Zack and Ivy. Based on the award-winning line of educational computer games, this energizing series is rich in both excitement and education as Carmen Sandiego attempts to steal the most valuable objects in the world. It s up to our detectives and the audience to figure out where in the world she is. Filled with unique characters, wonderful story lines and humor, this Emmy® award-winning animated series, educates kids of all ages in the subjects of history, geography and fun through its action-packed adventures!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1994-02-05",
  },
  {
    id: 726,
    url: "https://www.tvmaze.com/shows/726/wwii-in-hd",
    name: "WWII in HD",
    genres: ["War", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15103.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15103.jpg",
    },
    summary:
      "<p><b>WWII in HD</b> is the first-ever World War II documentary presented in full, immersive HD color. Culled from thousands of hours of lost and rare color archival footage gathered from a worldwide search through basements and archives, WWII in HD will change the way the world sees this defining conflict. Using footage never before seen by most Americans–converted to HD for unprecedented clarity—viewers will experience the war as if they were actually there, surrounded by the real sights and sounds of the battlefields. Along the way, they'll meet a diverse group of soldiers whose wartime diaries and journals show in visceral detail what the war was really like.</p><p>This visually astonishing landmark series presents the story of World War II through the eyes of 12 Americans who experienced the war firsthand. Viewers will hear the story of Army nurse June Wandrey, who served from the beginning of the war in North Africa to the liberation of the camps in Germany. They will meet Shelby Westbrook, a young African American from Toledo, who became a member of the famed Tuskegee Airmen; Jimmie Kanaya, the son of Japanese immigrants, who served in the U.S. Army and was imprisoned in Europe; and Jack Werner, a Jewish émigré who escaped from Austria before the war and wound up fighting not against Hitler and the hated Nazis, but in the Pacific Theater.</p>",
    officialSite: "http://www.history.com/shows/wwii-in-hd",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-11-15",
  },
  {
    id: 727,
    url: "https://www.tvmaze.com/shows/727/pee-wees-playhouse",
    name: "Pee-Wee's Playhouse",
    genres: ["Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15104.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15104.jpg",
    },
    summary:
      "<p>Scream along to the SECRET WORD with Pee-wee Herman and his pals — Jambi the Genie, Miss Yvonne, Cowboy Curtis, Reba the mail lady, Captain Carl, Magic Screen, Conky, Globey, Chairry, Pterri, Randy and many more! Aaaaarrrrrrrrr!!! I know you are, but what am I!?! Mecka-lecka hi... Mecka-hiney ho!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1986-09-13",
  },
  {
    id: 728,
    url: "https://www.tvmaze.com/shows/728/the-profit",
    name: "The Profit",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15106.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15106.jpg",
    },
    summary:
      "<p>When Marcus Lemonis isn't running his multi-billion dollar company, Camping World, he goes on the hunt for struggling businesses that are desperate for cash and ripe for a deal. In the past 10 years, he's successfully turned around over 100 companies. Now he's bringing those skills to CNBC and doing something no one has ever done on TV before ... he's putting over $2 million of his own money on the line.</p><p>In each episode of <b>The Profit</b>, Lemonis makes an offer that's impossible to refuse; his cash for a piece of the business and a percentage of the profits. And once inside these companies, he'll do almost anything to save the business and make himself a profit; even if it means firing the president, promoting the secretary or doing the work himself.</p>",
    officialSite: "https://www.cnbc.com/the-profit/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 93,
      name: "CNBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-07-30",
  },
  {
    id: 729,
    url: "https://www.tvmaze.com/shows/729/casualty",
    name: "Casualty",
    genres: ["Drama", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/320/801208.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/320/801208.jpg",
    },
    summary:
      "<p>Drama series about the staff and patients at Holby City Hospital's emergency department, charting the ups and downs in their personal and professional lives.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006m8wd",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1986-09-06",
  },
  {
    id: 730,
    url: "https://www.tvmaze.com/shows/730/blue-mountain-state",
    name: "Blue Mountain State",
    genres: ["Comedy", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15136.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15136.jpg",
    },
    summary:
      "<p><b>Blue Mountain State</b> follows the on and off-field antics of college football powerhouse, Blue Mountain State. Former NFL running back and veteran actor, Ed Marinaro (Hill Street Blues), stars as no-nonsense Coach Daniels. In season 3, Coach Daniels will have his authority challenged when the boosters force him to hire a hotshot offensive coordinator/head coach-in-waiting. Alex, played by Emmy Award(R)-winner Darin Brooks (Blue Crush), will have to step up from being a fun-loving second-string to the starting quarterback.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 34,
      name: "Paramount Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-01-11",
  },
  {
    id: 731,
    url: "https://www.tvmaze.com/shows/731/bar-rescue",
    name: "Bar Rescue",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/206/515093.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/206/515093.jpg",
    },
    summary:
      "<p><b>Bar Rescue</b> follows Jon Taffer, one of the country's top restaurant and bar consultants, will give failing establishments one last chance to succeed. The show will delve into every business facet of running a bar from creating a profitable drink/food menu to crowd management to music selection to managing disgruntled employees. This marks the first food/beverage-themed show for Spike TV, furthering its effort to expand and broaden its audience.</p>",
    officialSite: "http://www.paramountnetwork.com/shows/bar-rescue",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 34,
      name: "Paramount Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-07-17",
  },
  {
    id: 732,
    url: "https://www.tvmaze.com/shows/732/fresh-off-the-boat",
    name: "Fresh Off the Boat",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/211/528833.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/211/528833.jpg",
    },
    summary:
      "<p>It's the '90s and 12 year old, hip-hop loving Eddie just moved to suburban Orlando from DC's Chinatown with his parents. It's culture shock for his immigrant family in this comedy about pursuing the American Dream. <b>Fresh Off the Boat</b> is based on Chef Eddie Huang's memoir \"Fresh Off the Boat\".</p>",
    officialSite: "http://abc.go.com/shows/fresh-off-the-boat",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-04",
  },
  {
    id: 733,
    url: "https://www.tvmaze.com/shows/733/the-whispers",
    name: "The Whispers",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/62/155062.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/62/155062.jpg",
    },
    summary:
      "<p>We love to play games with our children. But what happens when someone else starts to play with them too? Someone we don't know. Can't see. Can't hear. In The Whispers, someone - or something - is manipulating the ones we love most to accomplish the unthinkable.</p>",
    officialSite: "http://abc.go.com/shows/the-whispers",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-01",
  },
  {
    id: 734,
    url: "https://www.tvmaze.com/shows/734/battle-creek",
    name: "Battle Creek",
    genres: ["Drama", "Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/81/202751.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/81/202751.jpg",
    },
    summary:
      "<p>A series about two mismatched law enforcement officers whose polar opposite views of the world and crime-solving breed frustration, disdain and humor as they clean up the hardscrabble streets of <b>Battle Creek</b>, Mich.</p>",
    officialSite:
      "https://web.archive.org/web/20150913220908/http://www.cbs.com/shows/battle-creek/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-01",
  },
  {
    id: 735,
    url: "https://www.tvmaze.com/shows/735/csi-cyber",
    name: "CSI: Cyber",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/47/119954.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/47/119954.jpg",
    },
    summary:
      '<p><b>CSI: Cyber </b>is a drama inspired by the advanced technological work of real-life Cyber Psychologist Mary Aiken. Special Agent Avery Ryan heads the Cyber Crime Division of the FBI, a unit at the forefront of solving illegal activities that start in the mind, live online and play out in the real world. While other FBI agents search for criminals in dark homes and alleys, Ryan and her team search the "dark net," a place deep in the bowels of the Web where criminals are anonymous, money is untraceable and where everything is for sale with just a keystroke.</p>',
    officialSite: "http://www.cbs.com/shows/csi-cyber",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-04",
  },
  {
    id: 736,
    url: "https://www.tvmaze.com/shows/736/teenage-mutant-ninja-turtles",
    name: "Teenage Mutant Ninja Turtles",
    genres: ["Comedy", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15145.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15145.jpg",
    },
    summary:
      "<p>Terrapin martial artists battle a global criminal group, The Foot, led by their arch nemesis The Shredder, who's in league with a technological madman, Baxter Stockman.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-02-08",
  },
  {
    id: 737,
    url: "https://www.tvmaze.com/shows/737/bubble-guppies",
    name: "Bubble Guppies",
    genres: ["Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15146.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15146.jpg",
    },
    summary:
      "<p>Jump into a watery world of learning and laughter with <b>Bubble Guppies</b>, a hilarious, rockin', interactive show that teaches kids about a wide range of topics--from dinosaurs to dentists, rock &amp; roll to recycling, and colors to cowboys. Through these topics, kids learn about science, math, literacy, and much more in this preschool musical comedy set in a vibrant, aquarium-inspired underwater classroom. Molly, Gil, and their fish-tailed classmates are just like all preschoolers--learning about the world around them through playful investigation.<br /><br /> Set within an eye-popping 3D CGI world of swaying kelp forests, fantastical coral reefs, and undersea gardens and featuring original pop, rock, country, and hip-hop music, the show teaches and models school-readiness skills through songs, dances, and lots of laughs. So put on your water-wings, and jump in for learning and laughs with Bubble Guppies!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 206,
      name: "Nick Jr.",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-01-24",
  },
  {
    id: 738,
    url: "https://www.tvmaze.com/shows/738/pregnant-in-heels",
    name: "Pregnant in Heels",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15147.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15147.jpg",
    },
    summary:
      "<p>Rosie Pope has managed to create a thriving business as the owner/designer of Rosie Pope Maternity, the ultra high-end maternity brand for the most sophisticated and urban mothers-to-be. Rosie - the tough talking, straight shooting coach for the most privileged expecting mothers of Manhattan -- advises her clients on everything from planning baby showers and hiring staff to decorating nurseries and organizing Brazilian waxing for the labor room.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-04-05",
  },
  {
    id: 739,
    url: "https://www.tvmaze.com/shows/739/the-odd-couple",
    name: "The Odd Couple",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/22050.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/22050.jpg",
    },
    summary:
      "<p><b>The Odd Couple</b> features endearing slob Oscar Madison and uptight neat freak Felix Unger, two former college buddies who become unlikely roommates after the demise of their marriages. It's not long after Oscar lets Felix move in that Oscar fears he's made a monumental mistake. However, despite how exasperated they make each other, these mismatched friends agree they can help each other move on from their divorces and somehow make their crazy living arrangement work.</p>",
    officialSite: "http://www.cbs.com/shows/the-odd-couple/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-19",
  },
  {
    id: 740,
    url: "https://www.tvmaze.com/shows/740/zoo",
    name: "Zoo",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/213/532577.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/213/532577.jpg",
    },
    summary:
      "<p><b>Zoo</b> is a global thriller about a wave of violent animal attacks against humans sweeping the planet. Jackson Oz is a young, renegade American zoologist who spends his days running safaris in the wilds of Africa when he begins noticing the strange behavior of the animals. As the assaults become more cunning, coordinated and ferocious, he is thrust into the race to unlock the mystery of the pandemic before there's no place left for people to hide.<br /><br />Based on James Patterson's #1 bestselling novel.</p>",
    officialSite: "http://www.cbs.com/shows/zoo/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-30",
  },
  {
    id: 741,
    url: "https://www.tvmaze.com/shows/741/are-you-smarter-than-a-5th-grader",
    name: "Are You Smarter Than a 5th Grader?",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/194/485915.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/194/485915.jpg",
    },
    summary:
      "<p>Class is back in session with all new half hour episodes of the hit quiz show, <b>Are You Smarter Than a 5th Grader?</b> Acclaimed comedian Jeff Foxworthy is at the head of the class as host of this atypical game show, which measures adults' lack of knowledge – as revealed by how much they've forgotten since grammar school. <br /><br /> Adult contestants find themselves revisiting their youth in a classroom setting, tackling subjects they've already been taught – from art to geography and math to social studies.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-02-27",
  },
  {
    id: 742,
    url: "https://www.tvmaze.com/shows/742/10-things-i-hate-about-you",
    name: "10 Things I Hate About You",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/116/292160.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/116/292160.jpg",
    },
    summary:
      "<p>After just one term, the Stratford sisters are making their mark on Padua High. Outspoken Kat is a known campus activist, and she's let down her guard just enough to hook up with mysterious bad boy Patrick. Meanwhile, her social-butterfly sister, Bianca, has taken on self-centered head cheerleader Chastity, and just might be dating her ex, would-be male model Joey... much to the sorrow of love-struck nerd Cameron.</p><p>Things just keep getting more interesting as these changes rock Padua's social order. Meanwhile, back at home, overprotective Dr. Stratford is NOT happy about this boy invasion, but he has ways of keeping his girls in line.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-07-07",
  },
  {
    id: 743,
    url: "https://www.tvmaze.com/shows/743/the-bachelorette",
    name: "The Bachelorette",
    genres: ["Family", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/320/801431.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/320/801431.jpg",
    },
    summary:
      "<p><b>The Bachelorette</b> is the female version of The Bachelor, where an eligible bachelorette must find true love among a group of guys, one rose at a time.</p>",
    officialSite: "http://abc.go.com/shows/the-bachelorette",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-01-08",
  },
  {
    id: 744,
    url: "https://www.tvmaze.com/shows/744/ny-med",
    name: "NY Med",
    genres: ["Drama", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15157.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15157.jpg",
    },
    summary:
      '<p>What do grandmothers, addicts and celebrities have in common? All of them seek care at Columbia and Weill Cornell Hospitals, the crown jewels of the prestigious New York-Presbyterian Hospital in New York City. For a full year ABC cameras had unprecedented access to document the mayhem and the miracles that occur daily in these world class facilities. "NY Med" follows the irascible, compassionate and, at times, cocky attending surgeons who try to change the trajectory of lives by relying on sheer medical brilliance and a healthy dose of old fashioned good luck.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-07-10",
  },
  {
    id: 745,
    url: "https://www.tvmaze.com/shows/745/the-real-housewives-of-beverly-hills",
    name: "The Real Housewives of Beverly Hills",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/257/643856.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/257/643856.jpg",
    },
    summary:
      "<p><b>The Real Housewives of Beverly Hills</b> offers a glimpse inside the world of luxurious wealth and pampered privilege, where being seen and who you know is everything. These women are in the center of it all and they have the mansions, the cars, and the diamonds to prove it. From heiresses to entrepreneurs to a family of child actresses - they deliver the star power and the drama.</p>",
    officialSite: "http://www.bravotv.com/the-real-housewives-of-beverly-hills",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-10-14",
  },
  {
    id: 746,
    url: "https://www.tvmaze.com/shows/746/shameless",
    name: "Shameless",
    genres: ["Drama", "Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15159.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15159.jpg",
    },
    summary:
      "<p>Paul Abbott's critically acclaimed, offbeat drama about the rollercoaster lives and loves of the dysfunctional Gallagher clan.</p>",
    officialSite: "http://www.channel4.com/programmes/shameless",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2004-01-13",
  },
  {
    id: 747,
    url: "https://www.tvmaze.com/shows/747/naked-and-afraid",
    name: "Naked and Afraid",
    genres: ["Drama", "Adventure", "Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/236/590401.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/236/590401.jpg",
    },
    summary:
      "<p>Each week on <b>Naked and Afraid</b>, a new pair of complete and total strangers - one man and one woman - will find themselves stranded in and, quite literally, exposed to one of the world's most extreme weather environments. This duo will be left high and dry with no food, no water... and no clothes. They must survive on their own for a full 21 days, with nothing but one personal item each and the knowledge that the only prize is their pride and sense of accomplishment.</p>",
    officialSite: "http://www.discovery.com/tv-shows/naked-and-afraid/",
    webChannel: { id: 173, name: "discovery+", country: null },
    language: "English",
    status: "Running",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-06-23",
  },
  {
    id: 748,
    url: "https://www.tvmaze.com/shows/748/oz",
    name: "Oz",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15172.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15172.jpg",
    },
    summary:
      "<p>HBO's violent men-behind-bars drama is an addictive, testosterone-driven soap opera for guys. The eight episodes of the first season set the style for the show: a massive cast of a vivid characters on both sides of the bars, four or five stories unleashed at a breakneck pace and framed by angry, oddball introductions, and a soaring casualty rate. Created by Homicide producer Tom Fontana, this drama quickly earned its rightful reputation as the most brutal show on TV. It's simple chemistry: combine volatile ingredients in a confined space, shut tight, and shake.</p>",
    officialSite: "http://www.hbo.com/oz/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1997-07-12",
  },
  {
    id: 749,
    url: "https://www.tvmaze.com/shows/749/csi-ny",
    name: "CSI: NY",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15173.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15173.jpg",
    },
    summary:
      "<p>The third edition of the <i>CSI</i> franchise sets up shop in the Big Apple, where taciturn former Marine, Detective Mac Taylor leads a crime-solving team of police officers and forensics specialists. In the city that never sleeps, <b>CSI: NY</b> never rests, and while people may lie, the evidence rarely does.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-09-22",
  },
  {
    id: 750,
    url: "https://www.tvmaze.com/shows/750/the-real-housewives-of-new-york-city",
    name: "The Real Housewives of New York City",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/257/643858.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/257/643858.jpg",
    },
    summary:
      "<p><b>The Real Housewives of New York City</b> will feature an elite and powerful set of New York socialites as they juggle their careers and home lives with busy calendars packed with charity fund-raising galas, the social whirl of the Hamptons, and interviews for elite private schools. These driven and ambitious women show everyone what it takes to make it in the upper echelon of society, where money and status are an essential way of life.</p>",
    officialSite: "http://www.bravotv.com/the-real-housewives-of-new-york-city",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-03-04",
  },
  {
    id: 751,
    url: "https://www.tvmaze.com/shows/751/the-graham-norton-show",
    name: "The Graham Norton Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/154/386664.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/154/386664.jpg",
    },
    summary:
      "<p>Chat show featuring celebrities, music and fabulous weirdness from the British public.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006xnzc",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2007-02-22",
  },
  {
    id: 752,
    url: "https://www.tvmaze.com/shows/752/my-boys",
    name: "My Boys",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15187.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15187.jpg",
    },
    summary:
      "<p>A comedy/drama centering on PJ Franklin, a twenty-something female sports writer for the Chigaco Sun-Times, whose 'family' consists of a bunch of lovable guys who share all her favorite pastimes - sports, poker and beer, but finding a boyfriend and making a future for herself can be tricky for a girl with so many men in her life!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 32,
      name: "TBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-11-28",
  },
  {
    id: 753,
    url: "https://www.tvmaze.com/shows/753/comedy-bang-bang",
    name: "Comedy Bang! Bang!",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15195.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15195.jpg",
    },
    summary:
      "<p><b>Comedy Bang! Bang!</b> cleverly riffs on the well-known format of the late night talk show, infusing celebrity appearances and comedy sketches with a tinge of the surreal. In each episode, Aukerman engages his guests with unfiltered and improvisational lines of questioning, punctuated by banter and beats provided by bandleader, one-man musical mastermind Reggie Watts to reinvent the traditional celebrity interview. Packed with character cameos, filmic shorts, sketches and games set amongst an off-beat world, <i>Comedy Bang! Bang!</i> delivers thirty minutes of absurd laugh-loaded fun featuring some of the biggest names in comedy.</p>",
    officialSite: "http://www.ifc.com/shows/comedy-bang-bang",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 65,
      name: "IFC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-06-08",
  },
  {
    id: 754,
    url: "https://www.tvmaze.com/shows/754/kill-la-kill",
    name: "Kill la Kill",
    genres: ["Action", "Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15196.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15196.jpg",
    },
    summary:
      "<p>After 6 years since their collaboration on the ground breaking anime series, ‘Tengen Toppa Gurren Lagann,' Hiroyuki Imaishi and Kazuki Nakashima are back to shock the world! Ryuko Matoi is a vagrant school girl traveling from place to place searching for clues to the truth behind her father's death—the ‘woman with the scissor blade.' The journey has led Ryuko to Honnouji Academy.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 24,
      name: "MBS",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2013-10-04",
  },
  {
    id: 755,
    url: "https://www.tvmaze.com/shows/755/freaks-and-geeks",
    name: "Freaks and Geeks",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15209.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15209.jpg",
    },
    summary:
      "<p><b>Freaks and Geeks</b>, the Emmy® award-winning series about the trials and tribulations of high school outsiders in 1980 Michigan.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-09-25",
  },
  {
    id: 756,
    url: "https://www.tvmaze.com/shows/756/not-going-out",
    name: "Not Going Out",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/93/233062.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/93/233062.jpg",
    },
    summary:
      "<p>Sitcom following the jokes, jibes and general misunderstandings of happy-go-lucky Lee and his friends. Starring comedian and actor Lee Mack.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006mw70",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-10-06",
  },
  {
    id: 757,
    url: "https://www.tvmaze.com/shows/757/batman-the-animated-series",
    name: "Batman: The Animated Series",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/80/202273.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/80/202273.jpg",
    },
    summary:
      "<p>Experience the thrills of vigilante justice as millionaire playboy Bruce Wayne and alter-ego Batman protect the streets of Gotham City from a host of villains including archnemesis The Joker, deadly-beautiful Poison Ivy and primitive Killer Croc in a fresh take on super hero storytelling. Intelligent, dramatic stories, unique characters and sharp dialog shaped this edgy TV series into an Emmy®-winning powerhouse that brought the Caped Crusader out of the dark alleys of TV history and into the present for fans of all ages.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1457,
      name: "Fox Kids",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1992-09-05",
  },
  {
    id: 758,
    url: "https://www.tvmaze.com/shows/758/the-secret-life-of-the-american-teenager",
    name: "The Secret Life of the American Teenager",
    genres: ["Drama", "Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15243.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15243.jpg",
    },
    summary:
      "<p>The teens at Grant High are living life in the fast lane. Between their love triangles, secrets, drama, accusations, gossip, confusion, and scandalous rumors, there's never a dull moment. The he-said, she-said gets intense! Their parents' lives are just as complicated. From paternity questions to happy reunions and unexpected romances (past and present), there's always something going on. You can't stop watching, because you've just gotta know what'll happen next.</p>",
    officialSite:
      "https://www.freeform.com/shows/the-secret-life-of-the-american-teenager",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-07-01",
  },
  {
    id: 759,
    url: "https://www.tvmaze.com/shows/759/good-luck-charlie",
    name: "Good Luck Charlie",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/158/396339.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/158/396339.jpg",
    },
    summary:
      '<p>The series follows two teenagers, Teddy and PJ Duncan and their 10-year-old brother, Gabe whose parents enlist their help when they return to work after the birth of their fourth child, Charlotte (nicknamed "Charlie"). With their parents juggling full time careers, they pitch in, getting very familiar with baby formula, burps, clothes, and babysitting while navigating typical teenage life. In each episode, Teddy creates a personalized video diary for Charlie. Each video will chronicle Teddy\'s daily adventures and mishaps for Charlie to use as advice when her big sister is no longer living at home.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 78,
      name: "Disney Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-04-04",
  },
  {
    id: 760,
    url: "https://www.tvmaze.com/shows/760/miami-vice",
    name: "Miami Vice",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15255.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15255.jpg",
    },
    summary:
      '<p>The cops. The cars. The clothes. <b>Miami Vice</b> is the explosive, groundbreaking detective show that redefined the word "cool." Set against the seamy and steamy Miami underworld, ride shotgun with suave Vice cops Sonny Crockett and Rico Tubbs as they battle a never-ending gallery of criminals. Set to an electrifying soundtrack of rock legends, including Glenn Frey, Phil Collins, U2 and Peter Gabriel, every episode crackles with excitement and stylish flair.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1984-09-28",
  },
  {
    id: 761,
    url: "https://www.tvmaze.com/shows/761/edge-of-alaska",
    name: "Edge of Alaska",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15270.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15270.jpg",
    },
    summary:
      "<p>Hidden deep in the wilderness of eastern Alaska is the toughest town in America: McCarthy. Once considered to be the state's very own \"Sin City,\" McCarthy is now an isolated town - a refuge for people who don't want to be found that's surrounded by extreme wilderness. While some believe in continuing the town's frontier way of life, others feel the future of McCarthy depends on dragging itself into the modern age. Which way of life will reign supreme on <b>Edge of Alaska</b>?</p>",
    officialSite: "http://www.discovery.com/tv-shows/edge-of-alaska/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-24",
  },
  {
    id: 762,
    url: "https://www.tvmaze.com/shows/762/the-big-c",
    name: "The Big C",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15271.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15271.jpg",
    },
    summary:
      "<p><b>The Big C</b> follows Minneapolis Westhill High School teacher Cathy Jamison – a reserved, suburban wife and mother – who is diagnosed with melanoma. The realization of this forces her to really begin to live for the first time in her adult life. At first she chooses to keep her diagnosis from her family, behaving in ways they find puzzling and increasingly bizarre. She finds new freedom to express herself. As the show progresses, Cathy allows her family and some new friends to support her as she copes with her terminal prognosis, and finds both humor and pathos in the many idiosyncratic relationships in her life.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-08-16",
  },
  {
    id: 763,
    url: "https://www.tvmaze.com/shows/763/the-honourable-woman",
    name: "The Honourable Woman",
    genres: ["Drama", "Thriller", "Espionage"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15276.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15276.jpg",
    },
    summary:
      "<p><b>The Honourable Woman</b> tells the story of one woman's personal journey to right her father's wrongs. Featuring a stellar cast including Academy Award nominee Maggie Gyllenhaal in the lead role as Nessa Stein, this compelling drama written and directed by BAFTA winning Hugo Blick (The Shadow Line) draws Nessa into a complex and dangerous world of international conspiracy and espionage.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p01z78nq",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-07-03",
  },
  {
    id: 764,
    url: "https://www.tvmaze.com/shows/764/bored-to-death",
    name: "Bored to Death",
    genres: ["Drama", "Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15283.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15283.jpg",
    },
    summary:
      "<p>Jonathan Ames continues to ply his trade as an unlicensed private detective, getting caught up in increasingly risky jobs and absurd adventures around New York City with George and Ray, his always supportive partners in solving crime. In addition, a shocking revelation drives him to embark on one of his most important cases yet, the quest to find his biological father. As if that wasn't enough, Jonathan's writing career is finally starting to look up with the publication of his long-delayed second book.</p>",
    officialSite: "http://www.hbo.com/bored-to-death",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-09-20",
  },
  {
    id: 765,
    url: "https://www.tvmaze.com/shows/765/teen-titans",
    name: "Teen Titans",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15290.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15290.jpg",
    },
    summary:
      "<p>Five teen superheroes led by Robin the Boy Wonder team up to protect Earth from a new generation of villains. His partners are Starfire, an alien who can fly; Cyborg, a half-human, half-robot with great strength; Raven, an introvert with telekinetic powers; and Beast Boy, who can change into any ki.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-07-19",
  },
  {
    id: 766,
    url: "https://www.tvmaze.com/shows/766/doctor-who",
    name: "Doctor Who",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15291.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15291.jpg",
    },
    summary:
      "<p><b>Doctor Who</b> is the longest-running science fiction TV series in history, airing initially from 1963 to 1989. <i>Doctor Who</i> is about ideas. It pioneered sophisticated mixed-level storytelling. Its format was the key to its longevity: the Doctor, a mysterious traveller in space and time, travels in his ship, the TARDIS. The TARDIS can take him and his companions anywhere in time and space. Inevitably he finds evil at work wherever he goes..</p>",
    officialSite: "https://www.bbc.co.uk/programmes/b006q2x0",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1963-11-23",
  },
  {
    id: 767,
    url: "https://www.tvmaze.com/shows/767/how-its-made",
    name: "How It's Made",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/67/168064.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/67/168064.jpg",
    },
    summary:
      "<p><b>How It's Made</b> is the addictive assembly line series that returns to give viewers an exclusive look at how their favorite items are manufactured. The series visits dozens of factories where raw materials transform into final products in the scope of a 30-minute episode.</p>",
    officialSite: "https://www.discovery.ca/Discovery-Science/How-It-s-Made",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 298,
      name: "Discovery Channel",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2001-01-06",
  },
  {
    id: 768,
    url: "https://www.tvmaze.com/shows/768/planet-earth",
    name: "Planet Earth",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15320.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15320.jpg",
    },
    summary:
      "<p>David Attenborough celebrates the amazing variety of the natural world in this epic documentary series, filmed over four years across 64 different countries.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006mywy",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-03-05",
  },
  {
    id: 769,
    url: "https://www.tvmaze.com/shows/769/better-off-ted",
    name: "Better Off Ted",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15323.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15323.jpg",
    },
    summary:
      "<p><b>Better Off Ted</b> is a satirical office comedy about successful good guy, Ted Crisp, who runs research and development at Veridian Dynamics, a company with a morally questionable approach to its employees. Whether it's standing by a memo with a typo that encourages employees to now (as opposed to not) use offensive language with each other, to championing interoffice dating based on DNA matching to save money on health care, Veridian is a company that puts its bottom line first and employees last. Ted's a single dad to a seven year old girl, and he loves his job, but he's starting to take a closer look at the company's extremely dubious practices.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-03-18",
  },
  {
    id: 770,
    url: "https://www.tvmaze.com/shows/770/private-practice",
    name: "Private Practice",
    genres: ["Drama", "Romance", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15330.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15330.jpg",
    },
    summary:
      "<p><b>Private Practice</b> is the story of a team of gifted doctors working together to change the lives of their patients for the better as they look to one another for friendship and love. The doctors of Seaside Health and Wellness work on the most difficult cases, patients whose medical needs often pose moral and ethical dilemmas. Though they may heatedly disagree at work, and their personal lives may complicate matters, at the end of the day, they are the best of friends, always ready to be there for one another.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-09-26",
  },
  {
    id: 771,
    url: "https://www.tvmaze.com/shows/771/royal-pains",
    name: "Royal Pains",
    genres: ["Drama", "Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15355.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15355.jpg",
    },
    summary:
      "<p><b>Royal Pains</b> centers on young doctor Hank Lawson who seems to have it all... thriving career, beautiful girlfriend, and swank NYC apartment. With one fateful and principled decision in the ER, Hank loses it all. Months later, single and blackballed from the medical community, Hank goes for a weekend in the Hamptons with his best friend. Crashing a party at a mega-mansion on the beach, Hank jumps into action when a guest requires medical attention that only he is able to diagnose. The next morning, Hank is summoned to another mansion. And then another. Hank's career is revived, but in a way he's not exactly happy about, as he becomes the on-call doctor for the rich, famous and infamous. Anyone who's anyone in the Hamptons has a lawyer on retainer. Now meet the newest accessory - the concierge doctor.</p>",
    officialSite: "http://www.usanetwork.com/royalpains",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-06-04",
  },
  {
    id: 772,
    url: "https://www.tvmaze.com/shows/772/cold-case",
    name: "Cold Case",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15363.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15363.jpg",
    },
    summary:
      "<p><b>Cold Case</b> is a drama about Lilly Rush, an enigmatic and highly effective detective on the Philadelphia Homicide Squad. Rush's instinctive understanding of the criminal mind and her singular passion for uncovering the truth makes her the perfect fit for investigating cold cases, yester-crimes that have remained unsolved - some only a few months old, others going back decades. Rush and her team use their wits to take on aging evidence and witnesses with buried secrets, uncovering fresh clues, digging into old wounds and doggedly pursuing the truth.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-09-28",
  },
  {
    id: 773,
    url: "https://www.tvmaze.com/shows/773/medium",
    name: "Medium",
    genres: ["Drama", "Crime", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15370.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15370.jpg",
    },
    summary:
      "<p><b>Medium</b> Allison DuBois is a strong-willed mother of three who has struggled since childhood to make sense of her visions of dead people. Hoping to prove to Allison that her dreams are stress induced, her scientist husband, Joe, sends descriptions of Allison's visions to a number of law enforcement agencies, expecting nothing to come of it. To his surprise, one of Allison's dreams bears an eerie similarity to a Texas homicide case involving a 17-year-old murder suspect. The case pits Allison against Capt. Kenneth Push, a cynical Texas Ranger who is suspicious of her psychic abilities. By the end of the investigation, Capt. Push has a new respect for Allison—and she makes a life-altering decision of her own.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-01-03",
  },
  {
    id: 774,
    url: "https://www.tvmaze.com/shows/774/the-cleveland-show",
    name: "The Cleveland Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15388.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15388.jpg",
    },
    summary:
      "<p>Everyone's favorite soft-spoken neighbor, Cleveland Brown, is on the move after he decides it's time for him and Cleveland Jr. to leave Quahog and go west. On their way to California, the duo makes a pit stop in Cleveland's hometown of Stoolbend, VA, where he reunites with his old high school crush, Donna Tubbs. Although she comes with baggage in the form of a rebellious teenage daughter and a sharp-tongued 5-year-old son, Cleveland is still in love with Donna and is determined to start a new life.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-09-27",
  },
  {
    id: 775,
    url: "https://www.tvmaze.com/shows/775/the-closer",
    name: "The Closer",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/83/209825.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/83/209825.jpg",
    },
    summary:
      "<p>Deputy Police Chief Brenda Leigh Johnson transfers from Atlanta to Los Angeles to head up a special unit of the LAPD that handles sensitive, high-profile murder cases. Despite a tendency to step on people's toes, Johnson manages to convert even her strongest adversaries with her unique ability to get to the truth, and more importantly, to close cases.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-06-13",
  },
  {
    id: 776,
    url: "https://www.tvmaze.com/shows/776/the-oc",
    name: "The O.C.",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15394.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15394.jpg",
    },
    summary:
      "<p>A slick hit about a troubled L.A. teen taken in by an idealistic lawyer and his family in affluent Orange County. The series filled the youth-soap hole left by the departed '90210,' but quickly proved itself far more gritty---and witty. In addition, early plots set up an appealing balance between the kids and grown-ups, who were portrayed as real people with real problems, instead of sounding boards for the unblemished Romeos and Juliets.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-08-05",
  },
  {
    id: 777,
    url: "https://www.tvmaze.com/shows/777/hannah-montana",
    name: "Hannah Montana",
    genres: ["Comedy", "Family", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15391.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15391.jpg",
    },
    summary:
      "<p>A pop singer moves to Malibu, Cal., where she keeps her celebrity status under wraps as she tries to maintain some semblance of a 'normal' life among her new schoolmates.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 78,
      name: "Disney Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-03-24",
  },
  {
    id: 778,
    url: "https://www.tvmaze.com/shows/778/army-wives",
    name: "Army Wives",
    genres: ["Drama", "Family", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/78/197347.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/78/197347.jpg",
    },
    summary:
      "<p><b>Army Wives</b> follows the struggles, dreams and friendships of a diverse group of women—and one man—living with their spouses and families on an active Army post.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-06-03",
  },
  {
    id: 779,
    url: "https://www.tvmaze.com/shows/779/brothers-sisters",
    name: "Brothers & Sisters",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/90/225022.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/90/225022.jpg",
    },
    summary:
      "<p><b>Brothers &amp; Sisters</b> is a one-hour hit drama that follows the California-based Walker family through the complicated maze of American life today. It revolves around a collection of enmeshed and somewhat damaged adult siblings and their strong but passionately devoted mother, Nora Walker. The Walkers' lives have not been without challenge. Romance, parenting, illness, divorce, infidelity, addiction, war and even death have pushed them to the limit. But they continue to work toward living their lives as individuals, while loving each other unconditionally and trying to maintain some semblance of normalcy.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-09-24",
  },
  {
    id: 780,
    url: "https://www.tvmaze.com/shows/780/flashpoint",
    name: "Flashpoint",
    genres: ["Action", "Adventure", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/206/515202.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/206/515202.jpg",
    },
    summary:
      "<p><b>Flashpoint</b> is a drama which depicts the emotional journey into the tough, risk-filled lives of a group of cops in the SRU (inspired by Toronto's Emergency Task Force). It's a unique unit that rescues hostages, busts gangs, defuses bombs, climbs the sides of buildings and talks down suicidal teens. Members of a highly-skilled tactical team, they're also trained in negotiating, profiling and getting inside the suspect's head to diffuse the situation to try and save lives.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 48,
      name: "CTV",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2008-07-11",
  },
  {
    id: 781,
    url: "https://www.tvmaze.com/shows/781/friday-night-lights",
    name: "Friday Night Lights",
    genres: ["Drama", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15436.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15436.jpg",
    },
    summary:
      "<p>In the town of Dillon, Texas, football is life, and no one knows that better than new head Coach Eric Taylor. Pressure mounts as the Dillon Panthers led by star quarterback Jason Street, enter pre-season surrounded by a swirl of press, recruiters and State Championship sized expectations. Backup quarterback Matt Saracen prepares to ride the bench in the shadow of Jason Street, as running back Tim Riggins struggles with a serious vice. As the season opener grows near, the town of Dillon is focused on what they believe to be most important, winning.</p>",
    officialSite: "https://www.nbc.com/friday-night-lights",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-10-03",
  },
  {
    id: 782,
    url: "https://www.tvmaze.com/shows/782/gunsmoke",
    name: "Gunsmoke",
    genres: ["Action", "Adventure", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15470.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15470.jpg",
    },
    summary:
      "<p>Marshall Matt Dillon is responsible for keeping the law and respectability in Dodge City in this western action-drama. <b>Gunsmoke</b> captured the courage, character and spirit of the Western Frontier.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1955-09-10",
  },
  {
    id: 785,
    url: "https://www.tvmaze.com/shows/785/body-of-proof",
    name: "Body of Proof",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15457.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15457.jpg",
    },
    summary:
      "<p>Dr. Megan Hunt is in a class of her own, a brilliant and world-renowned neurosurgeon at the top of her game, although success and notoriety have cost her her marriage and her relationship with her 12-year-old daughter. Then Megan's world is turned upside down by a devastating car accident that puts an end to her career as a surgeon. Broken but determined, with her love of medicine intact but a lack of feeling in her hands, Megan is pointed in the only direction she can turn, to a career as a medical examiner. Now a committed advocate for the dead, Megan solves the mysteries of their deaths while telling the stories of their lives.</p>",
    officialSite: "http://abc.go.com/shows/body-of-proof",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-03-29",
  },
  {
    id: 786,
    url: "https://www.tvmaze.com/shows/786/law-order-criminal-intent",
    name: "Law & Order: Criminal Intent",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47563.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47563.jpg",
    },
    summary:
      "<p>In New York City's war on crime, the worst criminal offenders are pursued by the detectives of the Major Case Squad. These are their stories.</p>",
    officialSite: "http://www.usanetwork.com/criminalintent/cast",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-09-30",
  },
  {
    id: 787,
    url: "https://www.tvmaze.com/shows/787/the-twilight-zone",
    name: "The Twilight Zone",
    genres: ["Fantasy", "Horror", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/308/772149.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/308/772149.jpg",
    },
    summary:
      "<p>A groundbreaking series by Rod Serling, this half-hour anthology featured tales of the strange, the macabre, and the unusual. Some were science fiction, some were supernatural, and some defied easy categorization.This five-season series is best known for its twist endings. Many of the stories were written by Serling himself, others were crafted by Richard Matheson, Charles Beaumont, Earl Hammer Jr. and Ray Bradbury.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1959-10-02",
  },
  {
    id: 788,
    url: "https://www.tvmaze.com/shows/788/greek",
    name: "GREEK",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15483.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15483.jpg",
    },
    summary:
      "<p>Rusty begins his freshman year at Cyprus-Rhodes University determined to change his life and rush a fraternity. However, his sister Casey, who is already ensconced as a sorority siren, is not too keen on having her younger brother invade her world.</p>",
    officialSite: "http://freeform.go.com/shows/greek",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-07-09",
  },
  {
    id: 789,
    url: "https://www.tvmaze.com/shows/789/merlin",
    name: "Merlin",
    genres: ["Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/55/139159.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/55/139159.jpg",
    },
    summary:
      "<p>Fantasy drama based on the legend of King Arthur and <b>Merlin</b>.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00mjlxv",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-09-20",
  },
  {
    id: 790,
    url: "https://www.tvmaze.com/shows/790/the-unit",
    name: "The Unit",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/87/219977.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/87/219977.jpg",
    },
    summary:
      "<p>The Unit is a covert Special Forces team that does not exist. Their cover is the 303rd logistical studies group. They are assigned covert military operations by the President and never get credit for their actions. Their wives are also a tight group protecting their husbands. They protect their husband's secrets and maintain their cover.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-03-07",
  },
  {
    id: 791,
    url: "https://www.tvmaze.com/shows/791/misfits",
    name: "Misfits",
    genres: ["Drama", "Comedy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15508.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15508.jpg",
    },
    summary:
      "<p>When five young outsiders on Community Service get caught in a strange storm, they discover that they have developed superpowers.</p>",
    officialSite: "http://www.channel4.com/programmes/misfits",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 41,
      name: "E4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-11-12",
  },
  {
    id: 792,
    url: "https://www.tvmaze.com/shows/792/the-tonight-show-with-jay-leno",
    name: "The Tonight Show with Jay Leno",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15517.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15517.jpg",
    },
    summary:
      "<p>The Tonight Show with Jay Leno is an American late-night talk show currently hosted by Jay Leno, on NBC. It made its debut on May 25, 1992, following Johnny Carson's retirement as host of The Tonight Show. The nightly broadcast at 23:35 (Eastern) originates from NBC's studios, in Burbank, California.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1992-05-25",
  },
  {
    id: 793,
    url: "https://www.tvmaze.com/shows/793/eastenders",
    name: "EastEnders",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/266/666087.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/266/666087.jpg",
    },
    summary:
      "<p>Set in the East End of London, the show focuses on the tensions between love and family with stories ranging from hard-hitting social issues, to personal, human tragedies. And there's plenty of funny moments too. <br /><br />Classic characters old and new across thousands of episodes have shared a drink in The Queen Vic, shed tears of despair or joy, sat on Arthur's bench in the Square... and at some point or other they probably crossed paths with Ian Beale.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006m86d",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1985-02-19",
  },
  {
    id: 794,
    url: "https://www.tvmaze.com/shows/794/power-rangers",
    name: "Power Rangers",
    genres: ["Action", "Children", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15520.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15520.jpg",
    },
    summary:
      '<p><b>Power Rangers</b> is a children\'s television series adapted from the Japanese tokusatsu Super Sentai Series. A team of five high school students are selected by Zordon to battle evil. Using martial arts, special weapons, and gigantic robots called "Zords", they protect their city Angel Grove from monsters and witches.</p>',
    officialSite: "http://www.powerrangers.com/tv-shows/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-08-28",
  },
  {
    id: 795,
    url: "https://www.tvmaze.com/shows/795/jericho",
    name: "Jericho",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/292/730790.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/292/730790.jpg",
    },
    summary:
      "<p><b>Jericho</b> is a drama about what happens in the aftermath of a nuclear explosion in the once peaceful town of Jericho. Following the battle with New Bern, the citizens of Jericho begin reconstruction efforts to restore the town's power and communication with the outside world. As the country's new leaders, the Cheyenne government, attempt to establish their stronghold in the region, Jericho's citizens become suspicious of their new leaders and question why their community is so important to this newly formed government.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-09-20",
  },
  {
    id: 796,
    url: "https://www.tvmaze.com/shows/796/ugly-betty",
    name: "Ugly Betty",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15559.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15559.jpg",
    },
    summary:
      "<p>Smart but wholesome Betty embraces her unique appearance and independent attitude in the cutthroat world of New York fashion. It's amazing how Betty can stay true to herself, no matter how much drama the fashionistas throw her way. With the help of her proud yet far-from-glamorous family from Queens, Betty will continue to have big dreams and deal with any obstacle in her own unique style.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-09-28",
  },
  {
    id: 797,
    url: "https://www.tvmaze.com/shows/797/rescue-me",
    name: "Rescue Me",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15588.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15588.jpg",
    },
    summary:
      "<p>Tommy Gavin is a lifesaver. Whether he is pulling survivors from fiery high-rise infernos or the twisted steel of a subway collision, Gavin takes great pride in leading the heroic but often overwhelmed firefighters of New York City's Truck Company 62. Gavin is also a man drifting between sorrow and anger over a recent separation from his wife and three kids, and recurring memories of comrades and other New-Yorkers who fell victim to the tragedy of 9/11.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-07-21",
  },
  {
    id: 798,
    url: "https://www.tvmaze.com/shows/798/deadliest-catch",
    name: "Deadliest Catch",
    genres: ["Action", "Adventure", "Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/251/629311.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/251/629311.jpg",
    },
    summary:
      "<p>It's the deadliest job on earth: crab fishing off the Alaskan coast on the icy Bering Sea. These adventurers will battle Arctic weather, brutal waves, and a ticking clock for big money in this modern-day gold rush from which they may never return.</p>",
    officialSite: "https://www.discovery.com/tv-shows/deadliest-catch/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-04-12",
  },
  {
    id: 799,
    url: "https://www.tvmaze.com/shows/799/7th-heaven",
    name: "7th Heaven",
    genres: ["Drama", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/64/161712.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/64/161712.jpg",
    },
    summary:
      "<p>Reverend Eric Camden and his wife Annie have always had their hands full caring for seven children, not to mention the friends, sweethearts and spouses that continually come and go in the Camden household. This year, Eric and Annie will find their family back together in Glenoak with the return of Matt and Simon. As is often the case when the house is overflowing with Camdens, Eric and Annie are in for a bumpy ride as their children take landmark steps in their lives. Meanwhile, Eric and Annie continue their journey as soul mates, parents and grandparents whose love and respect for each other brings them ever closer. Through all the ups and downs, Eric and Annie have managed to keep their romance alive and their family together. Not only are they raising their own seven children, they've picked up several additional family members along the way.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-08-26",
  },
  {
    id: 800,
    url: "https://www.tvmaze.com/shows/800/kyle-xy",
    name: "Kyle XY",
    genres: ["Drama", "Science-Fiction", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15591.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15591.jpg",
    },
    summary:
      "<p><b>Kyle XY</b> is an incredible mystery about a teenager with no past. The series tells the surprising journey of Kyle, a 16 year-old teenage savant who is missing instinctive human behavior such as anger, joy and love, and the family who found him. After coming out of the woods and found walking into traffic, Kyle is sent to a youth detention center where he comes into contact with his first experience of eating food and human interaction: not all of it friendly. At the center they realize that Kyle is not like any ordinary teenager, especially once they find that he is missing his belly-button. With questions of 'Who is this kid?' and 'Where did he come from?' psychologist Nicole Trager is called in to help get some much needed answers.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-06-26",
  },
  {
    id: 801,
    url: "https://www.tvmaze.com/shows/801/jersey-shore",
    name: "Jersey Shore",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15613.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15613.jpg",
    },
    summary:
      "<p>Grab your hair gel, wax that Cadillac and get those tattooed biceps ready to fist pump with the best this summer at the Jersey Shore. MTV's newest docu-soap exposes one of the tri-state area's most misunderstood species, the Guido. Our Guidos and Guidettes will move into the ultimate beach house rental and indulge in everything the Seaside Heights, New Jersey scene has to offer. Beach by day, dancing and partying all night. They'll live, work, and rage together until the summer ends. There's no spray tan too orange, no hair too spiked, and no bod too tight for this crew.</p>",
    officialSite: "http://www.mtv.com/shows/jersey-shore",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-12-03",
  },
  {
    id: 802,
    url: "https://www.tvmaze.com/shows/802/wwe-monday-night-raw",
    name: "WWE Monday Night RAW",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/178/445311.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/178/445311.jpg",
    },
    summary:
      "<p><b>WWE Monday Night RAW</b> is World Wrestling Entertainment's (formerly the WWF and the WWWF before that) premiere wrestling event and brand. Since its launch in 1993, WWE Monday Night RAW continues to air live on Monday nights. It is generally seen as the company's flagship program due to its prolific history, high ratings, weekly live format, and emphasis on pay-per-views. Monday Night RAW is high profile enough to attract frequent visits from celebrities who usually serve as guest hosts for a single live event. Since its first episode, the show has been broadcast live or recorded from more than 197 different arenas in 165 cities and towns in seven different nations: including the United States, Canada, the United Kingdom twice a year, Afghanistan for a special Tribute to the Troops, Germany, Japan, Italy and Mexico.</p>",
    officialSite: "http://www.wwe.com/",
    webChannel: {
      id: 15,
      name: "WWE Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Running",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-01-11",
  },
  {
    id: 803,
    url: "https://www.tvmaze.com/shows/803/wwe-friday-night-smackdown",
    name: "WWE Friday Night SmackDown",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/230/576308.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/230/576308.jpg",
    },
    summary:
      "<p>Featuring a star-studded cast of WWE Superstars, <b>SmackDown Live</b> delivers a shot of adrenaline to viewers and bring fans over-the-top action, feats of athleticism beyond the reach of mortal men, and WWE's special brand of drama.</p>",
    officialSite: "https://www.fox.com/wwe-friday-night-smackdown/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-04-29",
  },
  {
    id: 804,
    url: "https://www.tvmaze.com/shows/804/strike-back",
    name: "Strike Back",
    genres: ["Drama", "Action", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/235/587592.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/235/587592.jpg",
    },
    summary:
      "<p><b>Strike Back</b> is a British/American action and military television series, based on a novel of the same name by novelist and former Special Air Service (SAS) soldier Chris Ryan. The series follows the actions of Section 20, a secretive branch of the British Defence Intelligence service (DI), who operate several high risk, priority missions throughout the globe.</p>",
    officialSite: "https://www.cinemax.com/strike-back",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 19,
      name: "Cinemax",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-05-05",
  },
  {
    id: 805,
    url: "https://www.tvmaze.com/shows/805/kitchen-nightmares",
    name: "Kitchen Nightmares",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15627.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15627.jpg",
    },
    summary:
      "<p>Chef Gordon Ramsay of Hell's Kitchen fame is back, and this time he's hitting the road, exposing restaurants that are barely staying afloat.</p>",
    officialSite: "http://www.fox.com/kitchen-nightmares",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-09-19",
  },
  {
    id: 806,
    url: "https://www.tvmaze.com/shows/806/the-bold-and-the-beautiful",
    name: "The Bold and the Beautiful",
    genres: ["Drama", "Family", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/233/583612.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/233/583612.jpg",
    },
    summary:
      "<p>They created a dynasty where passion rules, they are the Forresters, the first name in Fashion. <b>The Bold and the Beautiful</b>, a world of fashion, glamor and romance. A place where power, money and success are there for the taking in a city where dreams really do come true. Follow the lives and loves of the Forresters on <i>The Bold and the Beautiful</i>...</p>",
    officialSite: "https://www.cbs.com/shows/the_bold_and_the_beautiful/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1987-03-23",
  },
  {
    id: 807,
    url: "https://www.tvmaze.com/shows/807/wizards-of-waverly-place",
    name: "Wizards of Waverly Place",
    genres: ["Comedy", "Family", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15629.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15629.jpg",
    },
    summary:
      "<p>Alex, Justin and Max Russo are not your ordinary kids - they're wizards in training! While their parents run the Waverly Sub Station, the siblings struggle to balance their ordinary lives while learning to master their extraordinary powers. But when they turn 18, only one will be deemed worthy enough to become the family wizard.</p>",
    officialSite: "http://disneychannel.disney.com/wizards-of-waverly-place",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 78,
      name: "Disney Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-10-12",
  },
  {
    id: 808,
    url: "https://www.tvmaze.com/shows/808/icarly",
    name: "iCarly",
    genres: ["Comedy", "Children", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/149/374423.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/149/374423.jpg",
    },
    summary:
      "<p>Carly Shay led a pretty normal life... until she and her friends started their own web show. When <b>iCarly</b> becomes an instant hit, Carly and her pals have to balance their newfound success with the problems of everyday life. With her parents overseas, Carly relies on the help of her best friend/co-star, Sam, her longtime pal/technical producer, Freddie, and her eccentric older brother/guardian, Spencer, to keep it all together. Sam and Freddie's constant bickering and Spencer's odd habits make for a lot of good material...but is it enough to fill a new show every week?</p>",
    officialSite: "http://www.nick.com/icarly/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-09-08",
  },
  {
    id: 809,
    url: "https://www.tvmaze.com/shows/809/being-human",
    name: "Being Human",
    genres: ["Drama", "Comedy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15636.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15636.jpg",
    },
    summary:
      "<p>Comedy-drama series about three twenty-something housemates trying to live normal lives, despite struggling with unusual afflictions - one is a werewolf, one is a vampire and the other is a ghost.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00hqlc4",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-01-25",
  },
  {
    id: 810,
    url: "https://www.tvmaze.com/shows/810/in-plain-sight",
    name: "In Plain Sight",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15649.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15649.jpg",
    },
    summary:
      "<p><b>In Plain Sight</b> follows the story of a Federal Marshall with the Witness Protection program who must hide her high-risk, high-impact job from her family. To those that know her, Mary Shannon is a glorified meter maid, but her real job is much more dangerous. She must oversee federal witnesses who have been relocated through the Witness Protection program and make sure that they stay safe.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-06-01",
  },
  {
    id: 811,
    url: "https://www.tvmaze.com/shows/811/suburgatory",
    name: "Suburgatory",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15657.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15657.jpg",
    },
    summary:
      "<p>Single father George Altman is doing his best to raise his sixteen-year-old daughter Tessa in the big city. When he discovers a box of condoms in her bedroom, though, he decides the time has come to move her to a more wholesome and nurturing environment: the suburbs. But behind the beautiful homes and perfect lawns lurk the Franken-moms, spray tans, nose jobs, and Red Bull-guzzling teens who have nothing in common with Tessa. It's a whole new world, one that makes George wonder if they haven't jumped out of the frying pan and into the fire.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-28",
  },
  {
    id: 812,
    url: "https://www.tvmaze.com/shows/812/days-of-our-lives",
    name: "Days of Our Lives",
    genres: ["Drama", "Family", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/87/218576.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/87/218576.jpg",
    },
    summary:
      "<p><b>Days of our Lives</b> is set in the fictitious Midwestern town of Salem. The core families are the Bradys, the Hortons and the DiMeras, and the multi-layered storylines involve elements of romance, adventure, mystery, comedy and drama.</p>",
    officialSite: "http://www.nbc.com/days-of-our-lives",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1965-12-09",
  },
  {
    id: 813,
    url: "https://www.tvmaze.com/shows/813/without-a-trace",
    name: "Without a Trace",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15665.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15665.jpg",
    },
    summary:
      '<p><b>Without a Trace</b> is a fast-paced procedural drama about the Missing Persons Squad of the Federal Bureau of Investigation. The sole responsibility of the special task force is to find missing persons by applying advanced psychological profiling techniques to peel back the layers of the victims\' lives and trace their whereabouts in an effort to discover whether they have been abducted, been murdered, committed suicide, or simply run away. The team reconstructs a "<i>Day of Disappearance</i>" timeline that details every minute of the 24 hours prior to the disappearance, following one simple rule: learn who the victim is in order to learn where the victim is. Senior agent Jack Malone heads the dedicated team that knows too well that every second counts when someone vanishes.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-09-26",
  },
  {
    id: 814,
    url: "https://www.tvmaze.com/shows/814/no-ordinary-family",
    name: "No Ordinary Family",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15673.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15673.jpg",
    },
    summary:
      "<p><b>No Ordinary Family</b> follows the Powell Family, who go from ordinary to extraordinary. After 16 years of marriage, Jim feels disconnected from his workaholic wife, Stephanie, and two teenage children, Daphne and JJ. To encourage family bonding time, Jim decides the family will join Stephanie on her business trip to South America. When their plane crashes into the Amazon River, they barely enjoy a moment to celebrate their survival before returning to the grind of everyday life. But they soon realize that their lives have been forever changed. Each member of the family starts to show signs of new, unique and distinct super powers. Will their newfound abilities finally bring them together or push them further apart?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-28",
  },
  {
    id: 815,
    url: "https://www.tvmaze.com/shows/815/reaper",
    name: "Reaper",
    genres: ["Drama", "Comedy", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15681.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15681.jpg",
    },
    summary:
      "<p>On his twenty-first birthday, Sam Oliver discovers his parents sold his soul to the devil before he was born, and he must now serve as the devil's personal bounty hunter or Reaper, catching escaped souls and sending them back to Hell.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-09-25",
  },
  {
    id: 816,
    url: "https://www.tvmaze.com/shows/816/so-you-think-you-can-dance",
    name: "So You Think You Can Dance",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15688.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15688.jpg",
    },
    summary:
      "<p>The summer hit <b>So You Think You Can Dance</b>, hosted by Cat Deeley, keeps viewers moving to a different beat as dancers skilled in everything from the 'street' styles of Hip-Hop, Krumping and Popping to Ballroom's Salsa, Quickstep and Jive compete to be named the nation's favorite. In the performance round, the 20 finalists dance for America's votes, and each week the six contestants comprising the bottom three couples are given a chance to perform solo routines to encourage viewers to keep them on the show. Then the judges decide which dancers stay in the competition and which two are eliminated.</p>",
    officialSite: "http://www.fox.com/so-you-think-you-can-dance",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-07-20",
  },
  {
    id: 817,
    url: "https://www.tvmaze.com/shows/817/big-love",
    name: "Big Love",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15689.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15689.jpg",
    },
    summary:
      "<p>Bill Henrickson seems like a typical suburban husband and father, except for the fact that he has three wives, seven kids and three homes to maintain. The Salt Lake City polygamist has to juggle his families' needs while overseeing his growing chain of home-improvement stores and attempting to reconnect with his fundamentalist relatives.</p>",
    officialSite: "http://www.hbo.com/big-love",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-03-12",
  },
  {
    id: 818,
    url: "https://www.tvmaze.com/shows/818/beverly-hills-90210",
    name: "Beverly Hills, 90210",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15698.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15698.jpg",
    },
    summary:
      "<p>This long-running drama dealt with the experiences of a group of young people in Beverly Hills, CA as they navigated high school, college and ultimately the real world. The series focused on their travails as they tried to maintain their friendship while dealing with romances, family and personal crises, tragedies and countless drug addictions.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1990-10-04",
  },
  {
    id: 819,
    url: "https://www.tvmaze.com/shows/819/wife-swap",
    name: "Wife Swap",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15701.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15701.jpg",
    },
    summary:
      "<p>Have you ever wondered whether the grass is greener on the other side of the fence? Two wives discover that it often isn't when they hand over the keys to their homes and literally switch families — but not bedrooms — for two weeks on the new reality show Wife Swap, already a critically-acclaimed smash hit in its third season in the U.K.<br /><br />Wife Swap is not a competition or a contest. It is a reality show unlike any other, where the battlegrounds are the kitchens and living rooms, child-rearing is a subject of intense and heated debate, and the outcome isn't a cash prize, but a couple's opportunity to re-discover why they love each other and decided to marry in the first place.<br /><br />In the first week of the swap, the wives move in with their new family and adopt their very different lifestyle. They agree to follow a manual written by the departing wife that sets out the rules of their new household – how they parent, shop, do the house work, manage their budgets and their social life. But then, in the second week, everything changes. The new wives take charge. They introduce their own set of rules and get to run the new household their way. It's a radical shock to both families. The results are explosive, enlightening and often very funny. This is a show about the things that really matter to families across America.<br /><br />At the end of the show, the two couples meet for the first time. In a highly-charged exchange of views, both couples make a frank assessment of each other and talk about what they've learned from the experience.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-09-26",
  },
  {
    id: 820,
    url: "https://www.tvmaze.com/shows/820/hung",
    name: "Hung",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/43/109608.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/43/109608.jpg",
    },
    summary:
      "<p><b>Hung</b> follows Ray Drecker, a middle-aged basketball coach and high school history teacher who figures out how to put his exceptional physical endowments to use and change his fortunes. Forced to find an alternative sources of income after a series of unfavorable events, Ray takes on a whole new profession aided by his pimp and business partner, Tanya Skagle.</p>",
    officialSite: "http://www.hbo.com/hung",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-06-28",
  },
  {
    id: 821,
    url: "https://www.tvmaze.com/shows/821/macgyver",
    name: "MacGyver",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/237/592622.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/237/592622.jpg",
    },
    summary:
      "<p><b>MacGyver</b> follows the adventures of the laid-back, extremely resourceful secret agent Angus MacGyver. He prefers non-violent conflict resolution whenever possible and refuses to carry or use a gun. MacGyver works as a problem solver for the Phoenix Foundation in Los Angeles. Utilizing his education as a scientist and his experience as an operative in the Department of External Services (DXS), he is able to solve a range of problems usually with the help of his ever-present Swiss Army knife.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1985-09-29",
  },
  {
    id: 822,
    url: "https://www.tvmaze.com/shows/822/penn-teller-bullshit",
    name: "Penn & Teller: Bullshit!",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15710.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15710.jpg",
    },
    summary:
      "<p>In society, there are many products and ideas that we buy into. Some of these products, services or ideas are just plain bullshit. Well known magicians: Penn and Teller are here to knock some sense into people in a humorous and informal way and to explain why some things in life are just bullshit.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-01-24",
  },
  {
    id: 823,
    url: "https://www.tvmaze.com/shows/823/the-l-word",
    name: "The L Word",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15747.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15747.jpg",
    },
    summary:
      "<p>An intimate drama series about a group of lesbian friends struggling with romance and careers in Los Angeles.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-01-15",
  },
  {
    id: 824,
    url: "https://www.tvmaze.com/shows/824/ice-road-truckers",
    name: "Ice Road Truckers",
    genres: ["Drama", "Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/323/808635.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/323/808635.jpg",
    },
    summary:
      "<p><b>Ice Road Truckers</b> charts the lives of extraordinary men who haul vital supplies to diamond mines over frozen lakes that double as roads. The livelihood of many depends on these tenuous roads, which through the years have been responsible for the deaths of dozens of men. With one hand on the wheel and one on the door at all times, always prepared for the ice to give way under the weight of their trucks, these drivers put their lives and financial security of their families on the line in an exhilarating dash for cash. This adrenaline packed series reveals the raw, gripping quest of ice road truckers.</p><p>The desolate white landscape stretches as far as the eye can see in a world where the land meets the sky at an invisible horizon, just miles from the Arctic Circle. The fascinating, yet little-known ice road trucking industry, stationed just outside of Yellowknife in Canada's Northwest Territory, is responsible for supporting the diamond mines there. Each year, the many lakes of this region completely freeze over and engineers build an ice road over them that can withstand the weight of tractor trailers, hopefully. Jackknifing, breakdowns and accidents are commonplace. Since the terrain in this region is virtually impenetrable, and there are so few paved roads, the only way for supplies to reach the mines is by traveling over the ice road. The entire industry depends on the weather and the courage of the ice road truckers, who go 48-hour stretches with no sleep and who constantly hear the cracking of the ice right beneath their wheels.</p>",
    officialSite: "http://www.history.com/shows/ice-road-truckers",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-06-17",
  },
  {
    id: 825,
    url: "https://www.tvmaze.com/shows/825/knight-rider",
    name: "Knight Rider",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15722.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15722.jpg",
    },
    summary:
      "<p>The series follows the thrilling adventures of Michael Knight, a detective thought to be dead, who's been given a new face and identity. His assignment: to fight crime with the help of an artificially intelligent, talking car named K.I.T.T., a high-speed, futuristic weapon outfitted with high-tech gadgets and a personality of its own. Driven by justice, they set out to take down criminals who operate above the law.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1982-09-26",
  },
  {
    id: 826,
    url: "https://www.tvmaze.com/shows/826/bewitched",
    name: "Bewitched",
    genres: ["Comedy", "Family", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/206/515175.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/206/515175.jpg",
    },
    summary:
      "<p><b>Bewitched</b> starts off with a simple married couple; but what we soon find out is that Samantha, Darrin's wife, is a witch! Although they agree that Sam is not to use witchcraft now that they are married, a problem always seems to crop up and Samantha always resorts to spells. Things become even more complicated when Endora, Samantha's witch mother, starts to interfere.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1964-09-17",
  },
  {
    id: 827,
    url: "https://www.tvmaze.com/shows/827/the-cleaner",
    name: "The Cleaner",
    genres: ["Drama", "Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15736.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15736.jpg",
    },
    summary:
      "<p><b>The Cleaner</b> follows William Banks, a recovering addict who must balance his unwavering dedication to helping others get clean with an increasingly rocky personal life and the ghosts of his addictions. Banks and his teammates Akani Cuesta and Arnie Swenton employ an unconventional and often by any means necessary approach to getting addicts and those who surround them to realize they've reached rock-bottom and help them begin the process of recovery. With every success and failure, William wrestles with his commitment to his work and his love for his wife Melissa and their children through an unusual relationship with God.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-07-15",
  },
  {
    id: 828,
    url: "https://www.tvmaze.com/shows/828/mistresses",
    name: "Mistresses",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15744.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15744.jpg",
    },
    summary:
      "<p>Drama series about four female friends' marital and extramarital relationships.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00hht8l",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-01-08",
  },
  {
    id: 829,
    url: "https://www.tvmaze.com/shows/829/hotel-impossible",
    name: "Hotel Impossible",
    genres: ["Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15746.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15746.jpg",
    },
    summary:
      "<p>Competition is fierce in the hotel business. Online review sites can kill a business' reputation with one bad review. Staffs are untrained, surly or apathetic in a profession that lives or dies on service. So what's a struggling hotel operator to do? Bring in Anthony Melchiorri, a hotel \"fixer,\" who can turn any establishment around in weeks ... and he does just that in <b>Hotel Impossible</b>.</p>",
    officialSite: "http://www.travelchannel.com/shows/hotel-impossible",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 82,
      name: "Travel Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-04-09",
  },
  {
    id: 830,
    url: "https://www.tvmaze.com/shows/830/homicide-life-on-the-street",
    name: "Homicide: Life on the Street",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15762.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15762.jpg",
    },
    summary:
      "<p>One of the most critically acclaimed shows in TV history, <b>Homicide: Life on the Street</b> reinvigorated a tired genre by focusing on the grueling work of solving murders instead of an endless succession of bloody crimes and car chases. Inspired by David Simon's Edgar Award-winning account of Baltimore homicide detectives and brought to television by writer Paul Attanasio and director Barry Levinson, Homicide boasted a powerhouse ensemble cast featuring Ned Beatty, Yaphet Kotto, Richard Belzer, and breakout star Andre Braugher.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-01-31",
  },
  {
    id: 831,
    url: "https://www.tvmaze.com/shows/831/made-in-chelsea",
    name: "Made in Chelsea",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15775.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15775.jpg",
    },
    summary:
      "<p>A look at the lifestyles of a group of 20-something residents of the exclusive postcode in London, Chelsea, SW3.</p>",
    officialSite: "http://www.channel4.com/programmes/made-in-chelsea",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 41,
      name: "E4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-05-09",
  },
  {
    id: 832,
    url: "https://www.tvmaze.com/shows/832/the-rockford-files",
    name: "The Rockford Files",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15776.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15776.jpg",
    },
    summary:
      "<p>Jim Rockford is an ex-con-turned-private-investigator who would rather fish than fight, but whose instinct on closed cases is more golden than his classic Pontiac Firebird. From his mobile home in Malibu, this wisecracking private eye takes on the cases of the lost and the dispossessed, chasing down seemingly long-dead clues in the sun-baked streets and seamy alleys of Los Angeles.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1974-09-13",
  },
  {
    id: 833,
    url: "https://www.tvmaze.com/shows/833/hustle",
    name: "Hustle",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15780.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15780.jpg",
    },
    summary:
      '<p><b>Hustle</b> is a series that follows a group of con artists who specialise in "long cons"—extended deceptions which require greater commitment, but which return a higher reward than simple confidence tricks.</p>',
    officialSite: "http://www.bbc.co.uk/programmes/b007gf9k",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2004-02-24",
  },
  {
    id: 834,
    url: "https://www.tvmaze.com/shows/834/the-secret-circle",
    name: "The Secret Circle",
    genres: ["Drama", "Horror", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/50/125782.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/50/125782.jpg",
    },
    summary:
      "<p>After Diana introduces Cassie to other members of the circle, they reveal themselves as witches, and that she is one as well. Initially, Cassie refuses to believe them - until Adam shows her how to unlock her magical powers. After Cassie reluctantly joins the circle, Adam, Diana, Faye, and the other members of the coven quickly discover that with Cassie in their circle, they are able to cast spells more powerful than they ever could before.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-15",
  },
  {
    id: 835,
    url: "https://www.tvmaze.com/shows/835/boss",
    name: "Boss",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15801.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15801.jpg",
    },
    summary:
      "<p>Kelsey Grammer returns for season two as Chicago Mayor Tom Kane, the role in which he won a Golden Globe for Best Actor. This season, Kane ferociously beats back the physical symptoms of his illness with high doses of medication. But this comes at a cost -- experiencing heightened psychological manifestations of the disease. Without his longtime advisors Stone and Kitty, Kane is also forced to reconfigure his inner circle. Surrounded by strangers and without much time left, he acts quickly to protect and repair his legacy by cutting out the cancers within the political machine. But as corrupt heads roll and his list of enemies grows, Kane's virtuous actions begin to erode the very foundation of power he's worked a lifetime to build. In order to maintain it, Kane must govern as he always has - ruthlessly.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 17,
      name: "Starz",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-10-21",
  },
  {
    id: 836,
    url: "https://www.tvmaze.com/shows/836/late-night-with-conan-obrien",
    name: "Late Night with Conan O'Brien",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15808.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15808.jpg",
    },
    summary:
      "<p>\"Keep Cool My Babies!\" Smart-alecky, ribald and whimsical, <b>Late Night with Conan O'Brien</b> rose to become a critical darling and dorm favorite after a rocky start in 1993. There are many recurring characters (including Triumph the Insult Comic Dog, Vomiting Kermit, Eyeballs O'Shaughnessy, NASCAR-driving gun-toting Jesus, Masturbating Bear) and comedy bits (including New State Quarters, What in the World, Celebrity Survey, Actual Items, Conan Hates My Homeland) that entertain us night after night. New episodes air Tuesday through Friday, with reruns on Mondays and occasional breaks where reruns air all week long. It airs weekdays at 12:37 a.m. ET/PT. (Simulcast in HDTV) Next-day encores air on CNBC at 7pm ET.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-09-13",
  },
  {
    id: 837,
    url: "https://www.tvmaze.com/shows/837/full-throttle-saloon",
    name: "Full Throttle Saloon",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15807.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15807.jpg",
    },
    summary:
      "<p>The world's largest biker bar, the <b>Full Throttle Saloon</b>, is open for only 10 days a year in August. This year, owner Michael Ballard has to turn a profit during the Sturgis Motorcycle Rally. From managing a full staff of bartenders and dancing girls to hosting big name concerts, burlesque shows and other biker-friendly acts; keeping it all together is more than most people could handle.</p>",
    officialSite:
      "https://web.archive.org/web/20141011022153/http://www.trutv.com/shows/full-throttle-saloon/index.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 107,
      name: "Destination America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-11-10",
  },
  {
    id: 838,
    url: "https://www.tvmaze.com/shows/838/dirty-jobs",
    name: "Dirty Jobs",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15809.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15809.jpg",
    },
    summary:
      "<p><b>Dirty Jobs </b>videos follow the unsung laborers who make a living in some of the most unthinkable ways.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-11-07",
  },
  {
    id: 839,
    url: "https://www.tvmaze.com/shows/839/according-to-jim",
    name: "According to Jim",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15811.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15811.jpg",
    },
    summary:
      "<p>In this earthy family comedy, Jim is the macho Everyman who challenges his gorgeous and feisty wife, Cheryl, with his stubborn manliness but contagious charm. Tagging along with this duo of happily married opposites are their three precocious kids. A success at his construction business and the family breadwinner at home, Jim feeds his other passion - blues music - playing with his six-man garage band. He keeps Cheryl in turmoil with his boyish bravado and ever willful antics, but their underlying love guarantees that they are in this marriage for keeps.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-10-03",
  },
  {
    id: 840,
    url: "https://www.tvmaze.com/shows/840/treme",
    name: "Treme",
    genres: ["Drama", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/173/433306.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/173/433306.jpg",
    },
    summary:
      "<p>New Orleans, 38 months after Hurricane Katrina: Barack Obama has just been elected to the White House, giving this battered, majority-black city reason for optimism. Yet for every entrenched resident who hopes to improve his or her lot - or just return to a sense of pre-Katrina normalcy - others are intent on capitalizing on the city's vulnerability and suffocating its culture.</p>",
    officialSite: "https://www.hbo.com/treme",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-04-11",
  },
  {
    id: 841,
    url: "https://www.tvmaze.com/shows/841/quincy-me",
    name: "Quincy, M.E.",
    genres: ["Drama", "Crime", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15814.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15814.jpg",
    },
    summary:
      "<p>Television icon Jack Klugman is the crusading and headstrong medical examiner Dr. Quincy, the distinguished role that earned him 4 Emmy nominations. Aided by his loyal lab assistant Sam Fujiyama, Quincy's not afraid to stand up for his convictions, and he'll battle anyone who stands in his way: his skeptical boss Dr. Asten, City Hall, and even sometimes his own friends and mentors.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1976-10-03",
  },
  {
    id: 842,
    url: "https://www.tvmaze.com/shows/842/geordie-shore",
    name: "Geordie Shore",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/125/314798.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/125/314798.jpg",
    },
    summary:
      "<p>Following on from the International success of <i>Jersey Shore</i>, <b>Geordie Shore</b> follows the real life dramas of a group of Newcastle's finest.</p>",
    officialSite: "http://www.mtv.co.uk/geordie-shore",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 94,
      name: "MTV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-05-24",
  },
  {
    id: 843,
    url: "https://www.tvmaze.com/shows/843/in-treatment",
    name: "In Treatment",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/313/784631.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/313/784631.jpg",
    },
    summary:
      "<p>In the first three seasons, as Dr. Paul Weston continues to struggle with the aftermath of his divorce, he faces new emotional and physical challenges - including hand tremors that he fears might be the onset of Parkinson's Disease, which killed his father. Meanwhile, he takes on three challenging new patients and turns to a new therapist of his own.</p><p>In fourth season, the reimagining of the series is set in 2021 Los Angeles and brings a diverse trio of patients in session with the observant, empathetic Dr. Brooke Taylor to help navigate a variety of modern concerns. Issues such as the global pandemic and recent major social and cultural shifts are a backdrop to the work Brooke will undertake – all while she deals with complications in her own personal life.</p>",
    officialSite: "https://www.hbo.com/in-treatment",
    webChannel: {
      id: 329,
      name: "HBO Max",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Running",
    network: null,
    premiered: "2008-01-28",
  },
  {
    id: 844,
    url: "https://www.tvmaze.com/shows/844/heroes-unmasked",
    name: "Heroes Unmasked",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15826.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15826.jpg",
    },
    summary:
      '<p>A behind-the-scenes look at the series "Heroes" narrated by Anthony Stewart Head.</p>',
    officialSite: "http://www.bbc.co.uk/programmes/b007vzls",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2007-07-25",
  },
  {
    id: 845,
    url: "https://www.tvmaze.com/shows/845/dawsons-creek",
    name: "Dawson's Creek",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/81/204413.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/81/204413.jpg",
    },
    summary:
      "<p>Dawson Leery, Joey Potter, and Pacey Witter are life long friends, whose lives start to rapidly change when a new girl, Jen Lindley, moves in next door to Dawson and the foursome start high school. Chronicling the passage from adolescence to young adulthood, they are joined by two other newcomers to Capeside: brother and sister Jack and Andie McPhee and, when they go to college, by Audrey Liddell. Set in the fictional town of Capeside, MA., <b>Dawson's Creek</b> is the coming of age story of a close knit group of friends on the verge of adulthood.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-01-20",
  },
  {
    id: 846,
    url: "https://www.tvmaze.com/shows/846/the-real-housewives-of-orange-county",
    name: "The Real Housewives of Orange County",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/205/514751.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/205/514751.jpg",
    },
    summary:
      "<p>These ladies show no signs of slowing down and although they may be enjoying the sunny SoCal lifestyle, replete with plastic surgery and frequent shopping sprees, real life still manages to find them, even in the land of excess and indulgence on <b>The Real Housewives of Orange County</b>.</p>",
    officialSite: "http://www.bravotv.com/the-real-housewives-of-orange-county",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-03-21",
  },
  {
    id: 847,
    url: "https://www.tvmaze.com/shows/847/the-hard-times-of-rj-berger",
    name: "The Hard Times of RJ Berger",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15841.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15841.jpg",
    },
    summary:
      "<p><i><b>\"The Hard Times of RJ Berger\"</b></i> orbits the hilariously-hellish lives of a deeply unpopular 15 year-old and his scheming, sex-obsessed best friend, Miles Jenner. Other than pining after the girl of his dreams, Jenny Swanson, receiving daily beatings from the meanest jock in school, Max Owens and evading the stalker-ish advances of Lily Miran, there really isn't much excitement in RJ's life. That is, until his anatomical gift is accidentally exposed to the entire school.</p><p>In a single moment, RJ goes from anonymous to infamous, and for the first time in his life, he feels a tiny sliver of confidence. Swept up in this man-sized wave of recognition, we'll watch RJ claw his way out of the popularity basement. Whether it's trying to get laid, dealing with his bizarre parents, or simply navigating the treacherous waters of sophomore year, RJ will live out the stories -- good, bad and ugly -- that we all remember from high school. One mis-adventure at a time, we'll see him grow from a shy, awkward boy into a slightly less shy and awkward young man. Part The Wonder Years and part Superbad, <i>The Hard Times of RJ Berger</i> is a loud, funny, raunchy, sexy look at the life of lovable loser.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-06-06",
  },
  {
    id: 848,
    url: "https://www.tvmaze.com/shows/848/alf",
    name: "ALF",
    genres: ["Comedy", "Family", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15848.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15848.jpg",
    },
    summary:
      "<p>One starry night in 1986, the Tanner family get an unexpected houseguest - a furry, four-foot-high Alien Life Form they call <b>ALF</b>, who quickly becomes part of the family.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1986-09-22",
  },
  {
    id: 849,
    url: "https://www.tvmaze.com/shows/849/im-a-celebrity-get-me-out-of-here",
    name: "I'm a Celebrity, Get Me Out of Here!",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15854.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15854.jpg",
    },
    summary:
      "<p><b>I'm a Celebrity, Get Me Out of Here! </b>(often shortened to <i>I'm a Celebrity</i> or <i>I'm a Celeb</i>) is a British reality television show, first aired in 2002, in which celebrities live in jungle conditions with few creature comforts. The show has been hosted by Ant &amp; Dec since its beginning. It is filmed in Murwillumbah, New South Wales, Australia and broadcast on ITV in the United Kingdom.</p>",
    officialSite: "http://www.itv.com/imacelebrity",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2002-08-25",
  },
  {
    id: 850,
    url: "https://www.tvmaze.com/shows/850/life-on-mars",
    name: "Life on Mars",
    genres: ["Drama", "Crime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15855.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15855.jpg",
    },
    summary:
      "<p>Drama about a present-day Manchester detective who, after suffering near-fatal injuries in a car-crash, awakes to find himself living in 1973.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006t85s",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-01-09",
  },
  {
    id: 851,
    url: "https://www.tvmaze.com/shows/851/time-team",
    name: "Time Team",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15861.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15861.jpg",
    },
    summary:
      "<p>In this popular and (literally) groundbreaking programme, Tony Robinson and a team of experts travel the country to investigate a wide range of archaeological sites of historical importance.</p>",
    officialSite: "http://www.channel4.com/programmes/time-team",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1994-01-16",
  },
  {
    id: 854,
    url: "https://www.tvmaze.com/shows/854/luck",
    name: "Luck",
    genres: ["Drama", "Crime", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15862.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15862.jpg",
    },
    summary:
      '<p>A provocative look at the worlds of horseracing and gambling, told through a diverse group of characters surrounding a California racetrack. The series centers on an intuitive tough guy named Chester "Ace" Bernstein, who has always been involved with gambling, from bookmaking and money laundering to casino operations. Recently released from prison after three years, he teams with Gus Economou, his longtime chauffeur and muscle, to craft a complex plan involving the Santa Anita Racetrack in California. As they plot out Ace\'s strategy, the pair recruits Turo Escalante, a successful trainer with a sordid reputation. In the meantime, an old trainer nurtures a possible breakthrough thoroughbred, while a ragtag group of four racetrack groupies band together to try to catch lightning in a bottle – as winners of an elusive Pick Six bet.</p>',
    officialSite: "http://www.hbo.com/luck",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-01-29",
  },
  {
    id: 855,
    url: "https://www.tvmaze.com/shows/855/drugs-inc",
    name: "Drugs, Inc.",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15874.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15874.jpg",
    },
    summary:
      "<p>Drugs: A multi-billion-dollar industry that fuels crime and violence like no other substance on the planet. Turning cartel leaders into billionaires, the illegal drug industry also provides vital income to hundreds of thousands of poor workers across the globe. While some users sacrifice their lives to an addiction they can't escape, others find drugs to be their only saving grace from physical or emotional pain almost impossible to overcome. Where should the lines be drawn in this lucrative industry?</p>",
    officialSite: "http://channel.nationalgeographic.com/drugs-inc/",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-07-11",
  },
  {
    id: 856,
    url: "https://www.tvmaze.com/shows/856/sinbad",
    name: "Sinbad",
    genres: ["Action", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15875.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15875.jpg",
    },
    summary:
      "<p>Sinbad is a young man on a quest for redemption, condemned to keep searching for a way to lift the curse that chains him to the seas, until he can find the goodness in himself. Sinbad provides for himself and his family by fighting for money, but inadvertently kills a man, causing him to escape to sea as a stowaway. The 8th century Arabia is a melting pot of cultures, faiths and creatures; full of life and color, but also threatening and volatile. Before their journey is over, Sinbad and his crew of outcasts will not only have to brave their own demons, but some of the most dangerous enemies imaginable.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 63,
      name: "Sky 1",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-07-08",
  },
  {
    id: 857,
    url: "https://www.tvmaze.com/shows/857/later-with-jools-holland",
    name: "Later... with Jools Holland",
    genres: ["Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15886.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15886.jpg",
    },
    summary:
      "<p>Jools Holland presents BBC Two's flagship music show, with legendary musicians and brand new acts from around the world, all performing live.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006ml0l",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1992-10-08",
  },
  {
    id: 858,
    url: "https://www.tvmaze.com/shows/858/outcasts",
    name: "Outcasts",
    genres: ["Drama", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15887.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15887.jpg",
    },
    summary:
      "<p>A group of courageous pioneers face a unique opportunity: the chance to build a new and better future on another planet.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00x8fw4",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-02-07",
  },
  {
    id: 859,
    url: "https://www.tvmaze.com/shows/859/hardcore-pawn",
    name: "Hardcore Pawn",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15898.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15898.jpg",
    },
    summary:
      '<p><i><b>"Hardcore Pawn"</b></i> takes viewers behind the scenes of the immense American Jewelry &amp; Loan, a family business owned by third-generation pawnbroker Les Gold. Working with Les are his son, Seth, who is being groomed to eventually take over the store, and daughter, Ashley, who thinks Seth isn\'t ready for the top job.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 84,
      name: "truTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-08-16",
  },
  {
    id: 860,
    url: "https://www.tvmaze.com/shows/860/storage-wars",
    name: "Storage Wars",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/313/783929.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/313/783929.jpg",
    },
    summary:
      '<p><b>Storage Wars</b> follows professional buyers and their teams as they scour repossessed storage units in search of hidden treasure. Part gamblers, part detectives, these auction pros have found everything from coffins to the world\'s most valuable comic book collection, paying as little as ten dollars for items valued in the millions.</p><p>Each episode of "Storage Wars" follows a group of bidders as they get a quick peek inside the units, aided only by the beam of a flashlight. They then must assess on the spot if the unit is worth a bid and how high they will actually go to grasp the gold. The high-stakes fun begins as we see if the resulting buy is full of mostly trash... or true treasure.</p>',
    officialSite: "http://www.aetv.com/shows/storage-wars",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-12-01",
  },
  {
    id: 861,
    url: "https://www.tvmaze.com/shows/861/dirty-sexy-money",
    name: "Dirty Sexy Money",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15900.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15900.jpg",
    },
    summary:
      "<p>The absurdly wealthy Darlings of New York City continues to mix with the wrong people and become embroiled in untenable situations. Fortunately for the preeminent family, idealistic lawyer Nick George is there to take care of their legal needs -- which often run into shady territory.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-09-26",
  },
  {
    id: 862,
    url: "https://www.tvmaze.com/shows/862/being-erica",
    name: "Being Erica",
    genres: ["Drama", "Comedy", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15912.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15912.jpg",
    },
    summary:
      "<p><b>Being Erica</b> is a one-hour series that explores the life of Erica Strange, a woman who has been given a wonderful gift. Every episode, Erica goes back to relive a regret from her past, in order to come back and make a positive change in her present.</p>",
    officialSite: "http://www.cbc.ca/beingerica/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 36,
      name: "CBC",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2009-01-05",
  },
  {
    id: 863,
    url: "https://www.tvmaze.com/shows/863/dallas",
    name: "Dallas",
    genres: ["Drama", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15927.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15927.jpg",
    },
    summary:
      "<p>The world's first mega-soap, and one of the most popular ever produced, <b>Dallas</b> had it all. Beautiful women, expensive cars, and men playing Monopoly with real buildings. Famous for one of the best cliffhangers in TV history, as the world asked \"Who shot J.R.?\" A slow-burner to begin with, Dallas hit its stride in the 2nd season, with long storylines and expert character development. Dallas ruled the airwaves in the 1980's.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1978-04-02",
  },
  {
    id: 864,
    url: "https://www.tvmaze.com/shows/864/the-firm",
    name: "The Firm",
    genres: ["Drama", "Crime", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15930.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15930.jpg",
    },
    summary:
      "<p>Based on the best-selling novel by John Grisham, <b>The Firm</b> continues the story of attorney Mitchell McDeere who, as a young associate 10 years earlier, had brought down the prestigious Memphis law firm of Bendini, Lambert &amp; Locke, which had been operating as a front for the Chicago mob. After a difficult decade, which included a stay in the Federal Witness Protection Program, McDeere and his family now emerge from isolation to reclaim their lives and their future -- only to find that past dangers are still lurking and new threats are everywhere. </p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-01-08",
  },
  {
    id: 865,
    url: "https://www.tvmaze.com/shows/865/secret-diary-of-a-call-girl",
    name: "Secret Diary of a Call Girl",
    genres: ["Drama", "Adult"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15931.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15931.jpg",
    },
    summary:
      "<p>Drama series based on the best-selling, real life diaries of an upmarket escort. This programme is a deeper look into the world of the glamorous and intelligent Belle de Jour - Hannah to her family.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 54,
      name: "ITV2",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2007-09-27",
  },
  {
    id: 866,
    url: "https://www.tvmaze.com/shows/866/the-finder",
    name: "The Finder",
    genres: ["Drama", "Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15936.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15936.jpg",
    },
    summary:
      "<p>In <b>The Finder</b>, an Iraq war vet suffers a brain injury that triggers the ability to see connections between seemingly unrelated events, objects or people.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-01-12",
  },
  {
    id: 867,
    url: "https://www.tvmaze.com/shows/867/law-order-la",
    name: "Law & Order: LA",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/262/657208.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/262/657208.jpg",
    },
    summary:
      "<p>In the City of Los Angeles, the people are represented by two separate yet equally important groups: the police who investigate crime and the district attorneys who prosecute the offenders. These are their stories.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-29",
  },
  {
    id: 868,
    url: "https://www.tvmaze.com/shows/868/regular-show",
    name: "Regular Show",
    genres: ["Comedy", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15947.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15947.jpg",
    },
    summary:
      "<p>The<b> Regular Show</b> is about Mordecai and Rigby who are two best friends who take the problems and mundane tasks of their boring job to fantastical places.</p>",
    officialSite: "http://www.cartoonnetwork.com/tv_shows/regular-show/video",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-06",
  },
  {
    id: 869,
    url: "https://www.tvmaze.com/shows/869/deadly-women",
    name: "Deadly Women",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/208/521806.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/208/521806.jpg",
    },
    summary:
      "<p>Hell hath no fury like a woman scorned, especially when she's on a mission to murder. <b>Deadly Women</b> investigates the motives and modus operandi of female murderers. While males are often driven by anger, impulse and destruction, women usually have more complex, long-term reasons to kill. Through dramatized reconstructions the series investigates the driving force behind female thrill killers. What turns love affairs into fatal attractions. How twisted minds and dark secrets send other women on murdering rampages. <i>Deadly Women</i> also investigates the most ruthless female killers of them all-predators. Tune in as experts sift forensic fact from fanciful fiction. Former FBI agent and profiler, Candice DeLong offers insights into the psychology of female killers, while Dr Janis Amatuzio, a Mid West forensic pathologist known as \"The Compassionate Coroner\", provides expert commentary on the tell-tale evidence that Deadly Women leave behind. They are history's most intriguing and horrifying women. A sisterhood whose crimes are written in blood on history's pages.</p>",
    officialSite: "http://investigationdiscovery.com/tv-shows/deadly-women/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-02-08",
  },
  {
    id: 870,
    url: "https://www.tvmaze.com/shows/870/battlestar-galactica-blood-chrome",
    name: "Battlestar Galactica: Blood & Chrome",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15949.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15949.jpg",
    },
    summary:
      "<p><b>Battlestar Galactica: Blood &amp; Chrome</b> (a prequel to the critically acclaimed hit series, Battlestar Galactica) takes place in the midst of the First Cylon war. As the battle between humans and their creation, the sentient robotic Cylons, rages across the 12 colonial worlds, a young, talented fighter pilot, William Adama, finds himself assigned to one of the most powerful battlestars in the Colonial fleet: the Galactica. Full of ambition and in pursuit of the intense action that the Cylon war promises, Adama quickly finds himself at odds with his co-pilot, the battle-weary officer Coker. With only 47 days left in his tour of duty, Coker desires an end to battle just as much as Adama craves the start of it. Though they clash at first, the two men forge an unlikely bond when a routine escort mission with an enigmatic passenger turns dangerous and becomes a pivotal one for the desperate fleet.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-11-09",
  },
  {
    id: 871,
    url: "https://www.tvmaze.com/shows/871/bunheads",
    name: "Bunheads",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15953.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15953.jpg",
    },
    summary:
      "<p>A former ballerina turned Vegas showgirl decides to take a gamble on a new marriage and a fresh start in Paradise, CA.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-06-11",
  },
  {
    id: 872,
    url: "https://www.tvmaze.com/shows/872/how-its-made-dream-cars",
    name: "How It's Made: Dream Cars",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15954.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15954.jpg",
    },
    summary:
      "<p>Ever wonder how common, everyday objects are made? Science Channel fan favorite HOW IT'S MADE returns for another season of exploring how many of the everyday objects or products we seldom stop to think about are made. From hockey pucks and hand saws to drill bits and frozen french fries, 'How It's Made' offers viewers a first-hand look at how these deceptively simple objects are constructed. Thousands of humdrum items are put to good use on a daily basis, but it's easy to overlook how things like aluminum ladders, firefighter helmets, matches and engine blocks are constructed. <b>How It's Made: Dream Cars</b> visits dozens of assembly lines where raw materials become finished products right before the viewers' eyes. In each episode of the series, viewers will be amazed to see how many common items are manufactured in high-tech factories around the world.</p>",
    officialSite: "http://www.velocity.com/tv-shows/how-its-made-dream-cars/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 77,
      name: "Science",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-06-13",
  },
  {
    id: 873,
    url: "https://www.tvmaze.com/shows/873/george-clarkes-amazing-spaces",
    name: "George Clarke's Amazing Spaces",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/321/803230.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/321/803230.jpg",
    },
    summary:
      "<p>George Clarke explores the extraordinary world of small builds, where people turn tiny spaces into the most incredible places to live, work and play. He even tries making a few of his own.</p>",
    officialSite:
      "http://www.channel4.com/programmes/george-clarkes-amazing-spaces",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-10-23",
  },
  {
    id: 874,
    url: "https://www.tvmaze.com/shows/874/taboo",
    name: "Taboo",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15956.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15956.jpg",
    },
    summary:
      "<p>We've taken you around the world exploring behaviors and lifestyles that are acceptable in some cultures but forbidden, illegal or reviled in others. But this season, we're looking in our own backyard. <i>Taboo USA </i>goes behind the closed doors and picket fences of America's most normal looking homes to find a fringe few that can only be described as... taboo. And we're showcasing those willing to push the boundaries of taste, societal acceptance; those obsessive about their hobbies, their relationships, and their lifestyles.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-09-30",
  },
  {
    id: 875,
    url: "https://www.tvmaze.com/shows/875/question-time",
    name: "Question Time",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/178/447014.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/178/447014.jpg",
    },
    summary:
      "<p>Topical debate in which guests from the worlds of politics and the media answer questions posed by members of the public.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006t1q9",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1979-09-25",
  },
  {
    id: 877,
    url: "https://www.tvmaze.com/shows/877/extreme-weight-loss",
    name: "Extreme Weight Loss",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15958.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15958.jpg",
    },
    summary:
      "<p><i><b>\"Extreme Weight Loss\"</b></i> is a unique undertaking that's unlike anything you've ever seen TV. The show documents the amazing makeover of seventeen courageous, obese individuals who set out to safely lose half of their body weight over the course of a year. The metamorphosis is truly amazing. Trainer/transformation specialist Chris Powell (The 650-Pound Virgin) guides each of the seventeen participants through the process after moving into their homes. He's there to make sure the participants get the proper nourishment and exercise movement. Chris provides a fresh perspective to individuals whose lives have become unmanageable because of their weight.</p>",
    officialSite: "http://abc.go.com/shows/extreme-weight-loss",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-05-30",
  },
  {
    id: 878,
    url: "https://www.tvmaze.com/shows/878/pit-bulls-parolees",
    name: "Pit Bulls & Parolees",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/114/285823.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/114/285823.jpg",
    },
    summary:
      "<p><b>Pit Bulls &amp; Parolees</b> follows the turbulent drama and bittersweet moments as ex-convicts and ill-reputed dogs come together to strengthen one another. Sharing the same dominant traits of a pit bull -- determination, agility, strength and energy -- Torres has the power to make a positive change for the prison community and the dog world. Watch as one woman pulls the weight of 1,000 men to fulfill her dream of saving pit bulls from dangerous situations and giving parolees a chance to repair their reputations and their lives.</p>",
    officialSite:
      "https://www.animalplanet.com/tv-shows/pitbulls-and-parolees/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 92,
      name: "Animal Planet",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-10-30",
  },
  {
    id: 879,
    url: "https://www.tvmaze.com/shows/879/rude-tube",
    name: "Rude Tube",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15960.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15960.jpg",
    },
    summary:
      "<p>In a fast-paced review of the video viral revolution, Alex Zane presents a countdown of the funniest, rudest and most bizarre video clips to have taken the internet by storm.</p>",
    officialSite: "http://www.channel4.com/programmes/rude-tube",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 41,
      name: "E4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-11-05",
  },
  {
    id: 880,
    url: "https://www.tvmaze.com/shows/880/tattoos-after-dark",
    name: "Tattoos After Dark",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755257.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755257.jpg",
    },
    summary:
      "<p><b>Tattoos After Dark</b> is a U.S. reality show following after-hours events at two Los Angeles tattoo parlours and the antics of their staff and customers.</p>",
    officialSite: "http://www.oxygen.com/tattoos-after-dark",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 79,
      name: "Oxygen",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-01",
  },
  {
    id: 881,
    url: "https://www.tvmaze.com/shows/881/chips",
    name: "CHiPs",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15962.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15962.jpg",
    },
    summary:
      "<p>Where the rubber meets the road and the bad guys meet the badge -- that's where you'll find California Highway Patrol motorcycle officers Jon and Ponch. Set in the sun-drenched sprawl of Los Angeles, <b>CHiPs</b> combines action, heroics and fun.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1977-09-15",
  },
  {
    id: 882,
    url: "https://www.tvmaze.com/shows/882/agatha-christies-marple",
    name: "Agatha Christie's Marple",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15975.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15975.jpg",
    },
    summary:
      "<p>Agatha Christie's crime thrillers featuring the author's much-loved spinster sleuth Miss Jane Marple.</p>",
    officialSite: "https://www.itv.com/hub/agatha-christies-marple/L1286",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2004-12-12",
  },
  {
    id: 883,
    url: "https://www.tvmaze.com/shows/883/posh-people-inside-tatler",
    name: "Posh People: Inside Tatler",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15978.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15978.jpg",
    },
    summary:
      "<p>Documentary which goes behind the scenes at Tatler, the world's oldest magazine. The publication has been reporting on the lives of Britain's most privileged and powerful for 300 years.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b04smrqh",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-11-24",
  },
  {
    id: 884,
    url: "https://www.tvmaze.com/shows/884/8-out-of-10-cats-does-countdown",
    name: "8 Out of 10 Cats Does Countdown",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15979.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15979.jpg",
    },
    summary:
      "<p>Jimmy Carr hosts as Sean Lock and Jon Richardson play the words and numbers game.</p>",
    officialSite:
      "http://www.channel4.com/programmes/8-out-of-10-cats-does-countdown",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-01-02",
  },
  {
    id: 885,
    url: "https://www.tvmaze.com/shows/885/rewrapped",
    name: "Rewrapped",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755258.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755258.jpg",
    },
    summary:
      "<p>Iconic snack foods are transformed in Rewrapped, a new competition series hosted by Joey Fatone. From Twinkies to Goldfish to SpaghettiOs, three competitors use their talents to recreate and innovate America's most beloved snacks. First, the challengers attempt to duplicate the original item from scratch. Then it's onto the second round, where they must use the snack food in a completely original dish. Led by head judge Marc Summers and a panel of expert judges, only one can be crowned the Rewrapped champ!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 81,
      name: "Food Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-04-21",
  },
  {
    id: 886,
    url: "https://www.tvmaze.com/shows/886/the-legend-of-mick-dodge",
    name: "The Legend of Mick Dodge",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15981.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15981.jpg",
    },
    summary:
      "<p>25 years ago, Mick Dodge walked away from the modern world, leaving civilization behind to live alongside nature's wonders in the Olympic Peninsula. Following a primal instinct present throughout generations of his family, Mick ventured deep into the Hoh Rainforest, making his home in the trees and hidden in the moss. Experience the wild life of Mick Dodge, a quirky character whose unique brand of Zen comes from living by his own code – off the land and off the grid.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-07",
  },
  {
    id: 887,
    url: "https://www.tvmaze.com/shows/887/project-runway-threads",
    name: "Project Runway: Threads",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15982.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15982.jpg",
    },
    summary:
      "<p><b>Project Runway: Threads</b> is a competition series showcasing America's most talented young fashion designers. Each week, three new contestants pull out their scissors, sketchbooks and skills to see who can out-design the competition and set the new standard for the future of fashion. Challenges will be fast-paced, unpredictable and far from child's play as these nascent fashion powerhouses compete for $10,000 to be used at any Jo-Ann Fabrics and Crafts Store or Joann.com, a prestigious scholarship to the summer program at FIDM including travel expenses and a top-of-the-line sewing and embroidery studio courtesy of Brother International Corporation.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-23",
  },
  {
    id: 888,
    url: "https://www.tvmaze.com/shows/888/top-chef-duels",
    name: "Top Chef Duels",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15983.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15983.jpg",
    },
    summary:
      '<p>Bravo Media turns up the heat in a new culinary competition series <b>Top Chef Duels</b> premiering Wednesday, August 6 at 10 PM ET/PT as the network brings back the best culinary talent ever seen on "Top Chef" and "Top Chef Masters" for a gastronomic battle royale of epic proportions. Hosted by celebrity chef Curtis Stone, the newest iteration of the Emmy Award-winning franchise pits eighteen of the biggest, boldest and most talked-about personalities from past seasons against one another in high-stakes cooking challenges designed to test their passion and imagination in the kitchen. In addition to his role as host, Curtis Stone will also anchor the judges\' table with Gail Simmons, while chefs Wolfgang Puck and Hugh Acheson along with other special guests will round out the judging panel throughout the series. In each episode, two chefs will face-off in three rounds of head-to-head battles testing their skill, creativity and speed. Rivalries will be intensified as "Top Chef Duels" ups the ante and allows the competing chefs to each pick one mini-duel based on the other\'s perceived weaknesses in the kitchen. The third and final challenge of each episode will decide who moves on to compete in the ultimate high-stakes season finale where 10 chefs will be confronted with split second decisions as they lay it all on the line in the greatest challenge of their careers. In the end, only one chef will earn bragging rights and win the $100,000 grand prize and a culinary adventure that will be featured in Food and Wine Magazine.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-08-06",
  },
  {
    id: 889,
    url: "https://www.tvmaze.com/shows/889/benidorm",
    name: "Benidorm",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/147/369353.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/147/369353.jpg",
    },
    summary:
      "<p>Comedy series following regular and first-time holidaymakers as they visit the Solana Resort in Benidorm. All the guests have one thing in common: a quest to get value for their hard-earned Euros.</p>",
    officialSite: "http://www.itv.com/benidorm",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2007-02-01",
  },
  {
    id: 890,
    url: "https://www.tvmaze.com/shows/890/young-dracula",
    name: "Young Dracula",
    genres: ["Comedy", "Children", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/99/249076.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/99/249076.jpg",
    },
    summary:
      "<p>Fitting in is hard enough, but when your dad is Count Dracula, things go from hard to worse! Follow the comic misadventures of Vlad and Ingrid as they move from Transylvania to Britain with their narcissistic single dad, the Count.</p>",
    officialSite: "http://www.bbc.co.uk/cbbc/shows/young-dracula",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 60,
      name: "CBBC",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-09-21",
  },
  {
    id: 891,
    url: "https://www.tvmaze.com/shows/891/hard-knocks",
    name: "Hard Knocks",
    genres: ["Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/267/669212.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/267/669212.jpg",
    },
    summary:
      "<p>HBO Sports, NFL Films and the Cincinnati Bengals team up for an all-access look at what it takes to make it in the National Football League when the first sports-based reality series - and one of the fastest-turnaround programs on TV.</p>",
    officialSite: "https://www.hbo.com/hard-knocks",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-08-01",
  },
  {
    id: 892,
    url: "https://www.tvmaze.com/shows/892/the-haunted",
    name: "The Haunted",
    genres: ["Horror", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15987.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15987.jpg",
    },
    summary:
      "<p><b>The Haunted</b> is a chilling and frightening show featuring true horror stories about animals, humans and the paranormal. Each program features one or two stories recounted by the people who actually experienced them. Cinematic recreations serve to heighten the drama caused by animal and human contact with the unexplainable and to bring the witnesses' testimonies to life.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 92,
      name: "Animal Planet",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-11-22",
  },
  {
    id: 894,
    url: "https://www.tvmaze.com/shows/894/paw-patrol",
    name: "Paw Patrol",
    genres: ["Comedy", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15988.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15988.jpg",
    },
    summary:
      '<p><b>Paw Patrol</b> stars a pack of six heroic rescue pups - Chase, Marshall, Rocky, Rubble, Zuma and Skye - who are led by a tech-savvy boy named Ryder. Together they work hard to protect the Adventure Bay community believing, "no job is too big, no pup is too small!" The series features a curriculum that focuses on citizenship, social skills and problem-solving.</p>',
    officialSite: "http://www.nickjr.com/paw-patrol/videos/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-08-27",
  },
  {
    id: 895,
    url: "https://www.tvmaze.com/shows/895/rake",
    name: "Rake",
    genres: ["Drama", "Comedy", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15989.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15989.jpg",
    },
    summary:
      '<p>On a single day, Keegan Deane is described as many things. His ex-wife-calls him "unreliable"; his son calls him a "pal"; most judges think he\'s "an outrage"; the IRS calls him a "defendant"; and to his former dealer, he\'s simply a "tragic loss." Brilliant, frustratingly charming and with zero filter, Keegan is one of life\'s great addicts. His staggering lack of discretion and inability to self-censor land him the cases that nobody else will touch, but behind that lies a resolute optimism and belief in justice that fuel his dogged determination to defend those who seem beyond redemption. He always tries to do the right thing, but at the same time struggles to save himself from the many self-destructive elements that plague his own life, such as his overindulgence of various excesses, including women and gambling.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-23",
  },
  {
    id: 896,
    url: "https://www.tvmaze.com/shows/896/sanjay-and-craig",
    name: "Sanjay and Craig",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15997.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15997.jpg",
    },
    summary:
      "<p><b>Sanjay and Craig</b> is a 20-episode series that tells a beautiful story about two best friends -- one of whom is a snake -- and the true adventures of being a kid.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 73,
      name: "Nicktoons",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-05-25",
  },
  {
    id: 897,
    url: "https://www.tvmaze.com/shows/897/reckless",
    name: "Reckless",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/50/125774.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/50/125774.jpg",
    },
    summary:
      "<p><b>Reckless</b> is set in Charleston, S.C., where a gorgeous Yankee litigator and a charming southern attorney must hide their intense mutual attraction as a police sex scandal threatens to tear the city apart.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-06-29",
  },
  {
    id: 898,
    url: "https://www.tvmaze.com/shows/898/storage-hunters",
    name: "Storage Hunters",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/15999.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/15999.jpg",
    },
    summary:
      "<p>Brandon Bernier and his wife Lori are the toughest players in this high-stakes game of bid or be out-bid.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 84,
      name: "truTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-06-21",
  },
  {
    id: 899,
    url: "https://www.tvmaze.com/shows/899/great-continental-railway-journeys",
    name: "Great Continental Railway Journeys",
    genres: ["Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/228/572487.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/228/572487.jpg",
    },
    summary:
      "<p>Michael Portillo travels on the great train routes of Europe, as he retraces the journeys featured in George Bradshaw's 1913 Continental Railway Guide.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b01rdqn7",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-11-08",
  },
  {
    id: 900,
    url: "https://www.tvmaze.com/shows/900/batman-the-brave-and-the-bold",
    name: "Batman: The Brave and the Bold",
    genres: ["Action", "Crime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16001.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16001.jpg",
    },
    summary:
      "<p>Batman isn't going at it alone this time! From Warner Bros. Animation comes the latest interpretation of the classic Batman franchise. Our caped crusader is teamed up with heroes from across the DC Universe, delivering nonstop action and adventure with a touch of comic relief. Blue Beetle, Green Arrow, Aquaman and countless others will get a chance to uphold justice alongside Batman. Though still based in Gotham, Batman will frequently find himself outside city limits, facing situations that are both unfamiliar and exhilarating. With formidable foes around every corner, Batman will still rely on his stealth, resourcefulness and limitless supply of cool gadgets to bring justice home.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-11-13",
  },
  {
    id: 901,
    url: "https://www.tvmaze.com/shows/901/pioneers-of-television",
    name: "Pioneers of Television",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16003.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16003.jpg",
    },
    summary:
      "<p>Each episode melds compelling new interviews with irresistible clips to offer a fresh take on TV's biggest celebrities. Featured stars in this season's four new episodes include Jerry Seinfeld, Robin Williams, Roseanne Barr, Bill Cosby, Tim Allen, Ray Romano, Noah Wyle, Anthony Edwards, Diahann Carroll, Howie Mandel, Bob Newhart and many more.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 85,
      name: "PBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-01-02",
  },
  {
    id: 902,
    url: "https://www.tvmaze.com/shows/902/dont-tell-the-bride",
    name: "Don't Tell the Bride",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/163/409674.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/163/409674.jpg",
    },
    summary:
      "<p>The groom is put in charge of the big day, with the budget and every detail of the brides dream wedding day in their control. Originally airing on BBC Three, the show moved to Sky in 2016 and to E4 in 2017.</p>",
    officialSite: "http://www.channel4.com/programmes/dont-tell-the-bride",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 41,
      name: "E4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2007-11-08",
  },
  {
    id: 903,
    url: "https://www.tvmaze.com/shows/903/eggheads",
    name: "Eggheads",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16005.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16005.jpg",
    },
    summary:
      "<p>General knowledge quiz in which teams from all over the UK battle to beat the formidable <b>Eggheads</b>.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006z736",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2003-11-10",
  },
  {
    id: 904,
    url: "https://www.tvmaze.com/shows/904/antiques-roadshow",
    name: "Antiques Roadshow",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16006.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16006.jpg",
    },
    summary:
      "<p><b>Antiques Roadshow </b>experts examine and value antiques and collectables.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006mj2y",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1979-02-18",
  },
  {
    id: 905,
    url: "https://www.tvmaze.com/shows/905/hercules-the-legendary-journeys",
    name: "Hercules: The Legendary Journeys",
    genres: ["Action", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16007.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16007.jpg",
    },
    summary:
      "<p>Long ago... In a time of myth and legend, when ancient gods plagued man with suffering - only one man dared to challenge their power. Hercules!</p><p>Kevin Sorbo's fresh, hip and good-natured spin on the legendary hero carried this witty, adventure-filled action drama to high critical acclaim. Smartly combining ancient myth with contemporary sensibilities, the series became one of television's highest rated programs.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1995-01-29",
  },
  {
    id: 906,
    url: "https://www.tvmaze.com/shows/906/girlfriends",
    name: "Girlfriends",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/42/106159.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/42/106159.jpg",
    },
    summary:
      "<p><b>Girlfriends</b> is a sophisticated comedy series that invites viewers into the lives of three professional African American women living in Los Angeles who are struggling with the weighty issues of life - men, love, money -- and more men. Girlfriends returns for its triumphant final year, providing an open, honest exploration of the hot-button issues about family, friends, relationships and life facing women today. With fearlessness and sincerity, the show takes on universal issues that interest all women. Whether it is being recently engaged, exploring your career or balancing friendships and a new baby, Girlfriends treats them all with tenderness, care and respect.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-09-11",
  },
  {
    id: 907,
    url: "https://www.tvmaze.com/shows/907/the-practice",
    name: "The Practice",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/60/151385.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/60/151385.jpg",
    },
    summary:
      "<p>Set in Boston, <b>The Practice</b> centers on a firm of passionate attorneys to whom every case is important and every client worth a fight to the end. Pursuing justice, however, sometimes means crossing the line...</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1997-03-04",
  },
  {
    id: 908,
    url: "https://www.tvmaze.com/shows/908/queer-as-folk",
    name: "Queer As Folk",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16017.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16017.jpg",
    },
    summary:
      "<p>Brash humor and genuine emotion make up this original series revolving around the lives, loves, ambitions, careers and friendships of a group of gay men and women living on Liberty Avenue in contemporary Pittsburgh, PA. The show offers an unapologetic look at modern, urban gay and lesbian lives while addressing the most critical health and political issues affecting the community. Sometimes racy, sometimes sensitive and always straight to the heart, <b>Queer As Folk</b> is groundbreaking television at its best.</p>",
    officialSite: "https://www.sho.com/queer-as-folk",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-12-03",
  },
  {
    id: 909,
    url: "https://www.tvmaze.com/shows/909/perry-mason",
    name: "Perry Mason",
    genres: ["Drama", "Crime", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16036.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16036.jpg",
    },
    summary:
      "<p>Perry Mason is an attorney who specializes in defending seemingly indefensible cases. With the aid of his secretary Della Street and investigator Paul Drake, he often finds that by digging deeply into the facts, startling facts can be revealed. Often relying on his outstanding courtroom skills, he often tricks or traps people into unwittingly admitting their guilt.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1957-09-21",
  },
  {
    id: 910,
    url: "https://www.tvmaze.com/shows/910/beavis-and-butt-head",
    name: "Beavis and Butt-Head",
    genres: ["Comedy", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16043.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16043.jpg",
    },
    summary:
      "<p>A national treasure in an age of idiocy… When <b>Beavis and Butt-Head</b> first appeared on MTV more than a decade ago, critics dismissed them as brainless couch potatoes who did nothing but watch TV and make lewd jokes about bodily functions. Today we know they were ahead of their time. Beavis and Butt-Head's unique idiocy profoundly changed television, movies, pop culture and the world.</p>",
    officialSite: "http://www.mtv.com/shows/beavis-butt-head",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-03-08",
  },
  {
    id: 911,
    url: "https://www.tvmaze.com/shows/911/some-girls",
    name: "Some Girls",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16044.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16044.jpg",
    },
    summary:
      "<p>A comedy about group of quirky teenage girls who live on the same inner city estate.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p01gkh5q",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-11-06",
  },
  {
    id: 912,
    url: "https://www.tvmaze.com/shows/912/the-boondocks",
    name: "The Boondocks",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16045.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16045.jpg",
    },
    summary:
      '<p>In <b>The Boondocks</b>, Robert "Granddad" Freeman is the cantankerous legal guardian of his rambunctious grandkids Huey and Riley and has moved them from the south side of Chicago to the quiet and safety of "The Boondocks" (in this case, suburban Woodcrest), hoping that he can ignore them altogether and enjoy the golden years of his life in peace. But Huey, a 10-year-old left wing revolutionary, is determined not to enjoy the affluence of suburbia. This attitude is seconded by his 8-year-old brother, Riley, a proud product of contemporary rap culture. Although they torture each other and provoke the neighborhood, they are no match for Granddad, who is eccentric even by "crazy-ass-old-black-man" standards.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-11-06",
  },
  {
    id: 913,
    url: "https://www.tvmaze.com/shows/913/man-vs-wild",
    name: "Man vs. Wild",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23449.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23449.jpg",
    },
    summary:
      "<p>Join survival expert Bear Grylls as he takes on some of the harshest locations on the planet and shares invaluable survival strategies along the way.</p>",
    officialSite: "http://www.discovery.com/tv-shows/man-vs-wild/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-10-27",
  },
  {
    id: 914,
    url: "https://www.tvmaze.com/shows/914/the-bachelor",
    name: "The Bachelor",
    genres: ["Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/288/722293.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/288/722293.jpg",
    },
    summary:
      "<p><b>The Bachelor</b> is an American dating and relationship reality television series, revolving around a single former bachelor, who starts with a pool of candidates from whom the bachelor is expected to select a wife through an elimination process.</p>",
    officialSite: "https://abc.com/shows/the-bachelor",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-03-25",
  },
  {
    id: 915,
    url: "https://www.tvmaze.com/shows/915/the-suite-life-of-zack-and-cody",
    name: "The Suite Life of Zack and Cody",
    genres: ["Comedy", "Children", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16051.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16051.jpg",
    },
    summary:
      "<p>Meet <i>Zack and Cody</i>, 11 year-old identical twins and the newest residents of Boston's swanky Tipton Hotel on <b>The Suite Life of Zack and Cody</b>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 78,
      name: "Disney Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-03-18",
  },
  {
    id: 916,
    url: "https://www.tvmaze.com/shows/916/ridiculousness",
    name: "Ridiculousness",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/172/432121.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/172/432121.jpg",
    },
    summary:
      '<p><b>Ridiculousness</b> and Rob Dyrdek return with another incredible season of hysterical and absurd internet videos. Sterling "Stee-Lo" Brim and Chanel "West Coast" join Rob and another unbelievable line up of special guests, including rapper phenom Future, R&amp;B singer/ songwriter Ne-Yo, and internet video super-team Smosh. This season\'s storm of new categories like "Power Kiss", "Everyday Demons", "Human Glitches", and "Magnet Feet" will leave you belly laughing for the rest of your life.</p>',
    officialSite: "http://www.mtv.com/shows/ridiculousness",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-08-29",
  },
  {
    id: 917,
    url: "https://www.tvmaze.com/shows/917/ringer",
    name: "Ringer",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16078.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16078.jpg",
    },
    summary:
      "<p>Bridget Kelly is six-months sober and starting to turn her life around when she is the sole witness in a murder trial. Despite the assurances of her FBI protector, Agent Victor Machado, Bridget knows her life is on the line. She flees to New York, telling no one, and reunites with her estranged twin, Siobhan Martin. Wealthy, pampered and married to the strikingly handsome Andrew Martin, Siobhan lives what appears to be a fairy tale life - a life where no one knows that Bridget exists. The sisters seem to be mending their frayed relationship - until Siobhan disappears mysteriously, and Bridget makes the split decision to take on her sister's identity. She discovers shocking secrets, not only about her sister and her marriage, but also about Siobhan's best friend, Gemma Butler and Gemma's husband...</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-13",
  },
  {
    id: 918,
    url: "https://www.tvmaze.com/shows/918/pushing-daisies",
    name: "Pushing Daisies",
    genres: ["Drama", "Mystery", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16104.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16104.jpg",
    },
    summary:
      "<p>As a young boy Ned discovers that he can return the dead briefly back to life with just one touch. But his random gift isn't without deadly consequences, as he soon finds out. Grown up Ned puts his talent to good use by touching dead fruit and making it ripe with everlasting flavor. He opens a pie shop. But his gift leaves him wary of becoming close to anyone, as beautiful waitress Olive Snook finds out. His life as a pie maker gets more complicated when private investigator Emerson Cod finds out about Ned's secret. Emerson convinces the cash-strapped Ned to help him solve murder cases (and collect a hefty reward fee) by raising the dead and getting them to name their killers.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-10-03",
  },
  {
    id: 919,
    url: "https://www.tvmaze.com/shows/919/attack-on-titan",
    name: "Attack on Titan",
    genres: ["Action", "Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/311/779751.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/311/779751.jpg",
    },
    summary:
      "<p>Known in Japan as Shingeki no Kyojin, many years ago, the last remnants of humanity were forced to retreat behind the towering walls of a fortified city to escape the massive, man-eating Titans that roamed the land outside their fortress. Only the heroic members of the Scouting Legion dared to stray beyond the safety of the walls – but even those brave warriors seldom returned alive. Those within the city clung to the illusion of a peaceful existence until the day that dream was shattered, and their slim chance at survival was reduced to one horrifying choice: kill – or be devoured!</p>",
    officialSite: "http://shingeki.tv/",
    webChannel: null,
    language: "Japanese",
    status: "Running",
    network: {
      id: 281,
      name: "NHK",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2013-04-07",
  },
  {
    id: 920,
    url: "https://www.tvmaze.com/shows/920/waterloo-road",
    name: "Waterloo Road",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/140/351584.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/140/351584.jpg",
    },
    summary:
      "<p>Contemporary drama series set in a challenging comprehensive school.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006t1p7",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-03-09",
  },
  {
    id: 921,
    url: "https://www.tvmaze.com/shows/921/cake-boss",
    name: "Cake Boss",
    genres: ["Food", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16129.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16129.jpg",
    },
    summary:
      "<p><b>Cake Boss</b> is a popular docu-series following beloved baker Buddy Valastro, his larger-than-life family and burgeoning businesses.</p>",
    officialSite: "http://www.tlc.com/tv-shows/cake-boss/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 176,
      name: "Discovery Family",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-05-25",
  },
  {
    id: 922,
    url: "https://www.tvmaze.com/shows/922/the-ultimate-fighter",
    name: "The Ultimate Fighter",
    genres: ["Drama", "Action", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/166/416708.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/166/416708.jpg",
    },
    summary:
      "<p>In <b>The Ultimate Fighter</b>, fighters are competing for a UFC contract.</p>",
    officialSite: "https://ufc.com/tuf",
    webChannel: {
      id: 265,
      name: "ESPN+",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Running",
    network: null,
    premiered: "2005-01-17",
  },
  {
    id: 923,
    url: "https://www.tvmaze.com/shows/923/primeval",
    name: "Primeval",
    genres: ["Drama", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16152.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16152.jpg",
    },
    summary:
      '<p>When rips in time called anomalies started opening across the UK, dangerous creatures from the past and future began appearing in the most unexpected places, endangering lives and placing the whole of humanity at risk.</p><p>A crack team of specialists were appointed by the government to investigate and control "creature incursions," creating the Anomaly Research Center (ARC), which was later privatized. Matt, Abby, Connor and Becker do the field work while Jess mans the ARC control station under the leadership of government official James Lester and the mysterious scientist, Philip Burton</p>',
    officialSite: "http://watch.uktv.co.uk/shows/primeval/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 295,
      name: "W",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2007-02-10",
  },
  {
    id: 924,
    url: "https://www.tvmaze.com/shows/924/naked-and-afraid-uncensored",
    name: "Naked and Afraid: Uncensored",
    genres: ["Drama", "Adventure", "Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/220/550665.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/220/550665.jpg",
    },
    summary:
      '<p>Each week on <b>Naked and Afraid: Uncensored</b>, a new pair of total strangers are faced with the ultimate survival challenge: survive for 21 days together with no clothes or supplies in some of the most dangerous environments in the world. In addition to the landscape itself working against the duo, the local wildlife stalks looks to prey on them as well. Of course, the biggest complication for any of the couples might end up being their own clashing egos. This "uncensored" variation includes never-before-seen footage.</p>',
    officialSite: "http://www.discovery.com/tv-shows/naked-and-afraid/videos",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-06-30",
  },
  {
    id: 926,
    url: "https://www.tvmaze.com/shows/926/ghost-adventures",
    name: "Ghost Adventures",
    genres: ["Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/220/552187.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/220/552187.jpg",
    },
    summary:
      "<p>Are you ready for the lockdown?<br /><br /><b>Ghost Adventures</b> crew -- Zak Bagans, Aaron Goodwin, Billy Tolley, and Jay Wasley -- is back to investigate the scariest, most notorious, haunted places in the world.<br /><br />The trio will interview eyewitnesses and historians at each location, arming themselves with the stories of the ghosts they will later provoke and confront during their dusk-to-dawn lockdowns. (Note: They don't always come out unscathed!) Then they'll review and analyze their findings with some the most respected experts and specialists in the paranormal field.</p>",
    officialSite: "http://www.travelchannel.com/shows/ghost-adventures",
    webChannel: { id: 173, name: "discovery+", country: null },
    language: "English",
    status: "Running",
    network: null,
    premiered: "2008-10-17",
  },
  {
    id: 927,
    url: "https://www.tvmaze.com/shows/927/strange-sex",
    name: "Strange Sex",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16167.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16167.jpg",
    },
    summary:
      '<p>With first hand accounts and commentary from medical professionals, each half-hour episode sends viewers on an unrestricted journey into an entirely new world of sex. The focus of the show will be bizarre conditions, such as the fictional sex addiction, fetishes and kinky sexual behavior.<br><br> An Iraq war veteran who only experiences pain during intercourse and a former Broadway star and sex educator who learned to "think" herself into having an orgasm would be some of the cases featured in the series. Other examples are someone with balloon fetish and a woman who wants orgasm during childbirth.</p>',
    officialSite: "http://www.tlc.com/tv-shows/strange-sex/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-07-18",
  },
  {
    id: 928,
    url: "https://www.tvmaze.com/shows/928/metalocalypse",
    name: "Metalocalypse",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16168.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16168.jpg",
    },
    summary:
      "<p>Metalocalypse is an eleven-minute flash animated comedy airing on Cartoon Network's Adult Swim, created by Brendon Small and Tommy Blacha. The series follows the exploits of a fictitious half American/half Scandinavian death metal band known as Dethklok. The band and its members are huge the world over, but incredibly stupid - a death metal version of Spinal Tap. Watch as they leave a trail of destruction and mayhem in their wake with their ear-melting onslaught of metal!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-08-06",
  },
  {
    id: 929,
    url: "https://www.tvmaze.com/shows/929/the-x-factor",
    name: "The X Factor",
    genres: ["Family", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16170.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16170.jpg",
    },
    summary:
      '<p>Worldwide, <b>The X Factor</b> has created global superstars such as Leona Lewis, One Direction, Cher Lloyd, Olly Murs, Little Mix and Rebecca Ferguson. Artists discovered by "The X Factor" format have sold more than 100 million records worldwide, including 110 No.1, 270 Top 10 and 501 Top 50 releases. Local versions of "The X Factor" are now produced in more than 40 territories and THE X FACTOR (USA) airs in 166 countries.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-21",
  },
  {
    id: 930,
    url: "https://www.tvmaze.com/shows/930/the-hills",
    name: "The Hills",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16171.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16171.jpg",
    },
    summary:
      "<p>In the final season of <b>The Hills</b> - Kristin, Audrina and Heidi learn that the people they love the most can be the hardest to hold on to.</p><p>Kristin has made some enemies in LA, but now that her summer romance with Justin is fading, she wants to make friends. But when Kristin ditches the girls in Miami, rumors about her partying and late nights surface. Luckily, she's got her friend Brody to stand by her.</p><p>She never really let Brody off the hook, and now they're both single -- and before they know it they go from friends, to friends with benefits. But Brody isn't looking to settle down, and soon he meets a new girl. That means Kristin taking a backseat, and that means trouble for everyone. In a city full of women that he's conquered, Brody may also have his eye on someone he's never been able to get a hold of -- Audrina.</p><p>Audrina finds a fresh start and a true shot at happiness when she starts dating her old friend, Ryan Cabrera. Ryan is everything that Justin isn't -- and he's ready to commit. But no matter how many times she swears him off, Justin is never really out of Audrina's life. Seeing Justin playing with his band makes her wonder if Ryan is the man she really wants.</p><p>No one has changed more than Heidi. Because of her cosmetic surgeries, Heidi has to endure the disapproval of her mother and friends. As bad as that seems, what comes next for her is even harder. A year into their marriage, Spencer is more distant from his family and friends than ever before. After years of fighting for him and their relationship, Heidi has to decide if she's ready to stand by him -- for better or worse.</p><p><i>The Hills</i> may be coming to an end, but it's not over until it's over. The end is just beginning.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-05-31",
  },
  {
    id: 931,
    url: "https://www.tvmaze.com/shows/931/american-chopper-senior-vs-junior",
    name: "American Chopper: Senior vs. Junior",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755259.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755259.jpg",
    },
    summary:
      "<p>What was once a family business is now a family feud. All bets are off for what new fireworks await in <b>American Chopper: Senior vs. Junior</b>. Paul Senior builds world famous custom bikes at Orange County Choopers while Paul Junior operates his competing shop, Paul Jr. Designs, just a stone's throw down the road, with brother Mikey and former OCC employees firmly by his side. Will the family be made whole again? And what new out of this world build assignments will they take on to stretch their teams creatively and mechanically?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-08-12",
  },
  {
    id: 932,
    url: "https://www.tvmaze.com/shows/932/modern-marvels",
    name: "Modern Marvels",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/292/732485.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/292/732485.jpg",
    },
    summary:
      "<p>In <b>Modern Marvels</b>, Adam Richman travels the country to behemoth factory lines and locally owned shops going behind-the-scenes of iconic brands and giving an inside look into how our favorite foods such as cookies, cheese and ice cream are made.</p>",
    officialSite: "https://www.history.com/shows/modern-marvels",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-12-10",
  },
  {
    id: 933,
    url: "https://www.tvmaze.com/shows/933/american-chopper",
    name: "American Chopper",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16176.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16176.jpg",
    },
    summary:
      "<p>It's make it or break it time for each of the Teutul men as they head off in separate directions after a bruising family breakup. Who will come out on top as OCC and Paul Jr Designs start cranking out competing bikes, side by side, each week on <b>American Chopper?</b></p>",
    officialSite: "https://www.discovery.com/tv-shows/american-chopper/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-09-29",
  },
  {
    id: 934,
    url: "https://www.tvmaze.com/shows/934/swamp-people",
    name: "Swamp People",
    genres: ["Adventure", "Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/242/606946.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/242/606946.jpg",
    },
    summary:
      "<p>The <b>Swamp People</b> featured in this History series are the proud descendants of French Canadian refugees who settled in the swamp region of Louisiana in the 18th century. Cameras follow members of this fiercely independent group as they struggle to preserve their way of life in the Atchafalaya Basin during the most important time of the year for them: alligator-hunting season.</p>",
    officialSite: "http://www.history.com/shows/swamp-people",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-08-22",
  },
  {
    id: 935,
    url: "https://www.tvmaze.com/shows/935/reno-911",
    name: "Reno 911!",
    genres: ["Comedy", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/268/672171.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/268/672171.jpg",
    },
    summary:
      "<p>From the network that has no business bringing you a cop show—it's <b>Reno 911!</b> Ride shotgun with the brave—and shameless—officers of the Reno Sheriff's Department for their unscripted adventures and high-octane thrills.</p>",
    officialSite: "https://quibi.com/shows/reno-911-595/",
    webChannel: { id: 325, name: "Quibi", country: null },
    language: "English",
    status: "Running",
    network: null,
    premiered: "2003-07-23",
  },
  {
    id: 936,
    url: "https://www.tvmaze.com/shows/936/la-ink",
    name: "LA Ink",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16179.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16179.jpg",
    },
    summary:
      "<p>In her time on <b>LA Ink</b>, fans have watched Kat go from celebrated tattoo artist to fully developed entrepreneur. In the past year, Kat launched a successful line of cosmetics at Sephora and had her book hit The New York Time's Best Sellers List. As her profile has risen, so has the shop's business - and the pressure to succeed.</p><p>All of this leads into a new season that finds Kat facing familiar challenges, but quickly explodes with a level of drama and action never seen before. Kat Von D, known for her no-nonsense, tell-it-like-it-is demeanor has made an indelible mark on the tattoo industry. Her success in a male dominated field is inspiring, but it comes with its share of stress. While Kat is focused on expanding her product line and writing a new book, the shop faces unexpected - and unwelcome - changes. The introduction of new shop manager, Aubry Fisher, (from <i>Rock of Love</i> fame) is just one example.</p><p>Playing by her own rules, Kat lives a fast-paced, rebel lifestyle. Hers is a life of freedom: she sets her own schedule, picks her clients, sleeps late,and parties all night. For her shop to be a continued success, Kat will need to learn how to balance her lifestyle and her business while managing a colorful staff of renowned artists. <i>LA Ink</i> offers a rare glimpse into an LA that is seldom seen, through the eyes of a true insider.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-08-07",
  },
  {
    id: 937,
    url: "https://www.tvmaze.com/shows/937/dark-blue",
    name: "Dark Blue",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16180.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16180.jpg",
    },
    summary:
      "<p>Officer Carter Shaw and his team go undercover - sometimes too deep, among the criminals of modern-day Los Angeles.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-07-15",
  },
  {
    id: 938,
    url: "https://www.tvmaze.com/shows/938/silent-witness",
    name: "Silent Witness",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/234/587498.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/234/587498.jpg",
    },
    summary:
      "<p>Expert forensic pathologists speak on behalf of the voiceless in this compelling crime drama.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b007y6k8",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1996-02-21",
  },
  {
    id: 939,
    url: "https://www.tvmaze.com/shows/939/ax-men",
    name: "Ax Men",
    genres: ["Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755261.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755261.jpg",
    },
    summary:
      "<p>For more than a hundred years, larger than life characters, many of whom are members of logging families who go back to the time when the West was being settled, have spent their days among towering trees and powerful machines and their nights in outposts far from the comforts of civilization. <b>Ax Men</b> tells their remarkable story, detailing the history of the logging industry and how technology has transformed life for today's logger, while the struggle of man versus nature stays the same. Danger is a full-time job, as these brave men put everything on the line each and every day to retrieve timber. Snapped cables, runaway logs and razor-sharp chainsaws are just some of the dangers that threaten their lives daily. Even with new technology that should make the job easier, it all boils down to the toughness and perseverance of the logging crews. Anything and everything can and does go wrong. Not everyone will survive, but those who do will earn their place in a long line of men who call themselves <i>Ax Men</i>.</p>",
    officialSite: "https://www.history.com/shows/ax-men",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-03-09",
  },
  {
    id: 940,
    url: "https://www.tvmaze.com/shows/940/the-dead-zone",
    name: "The Dead Zone",
    genres: ["Drama", "Fantasy", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16191.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16191.jpg",
    },
    summary:
      "<p>Based on the characters and story from the best-selling novel by Stephen King, <b>The Dead Zone</b> is a unique psychological thriller that combines a rich mix of the paranormal, action, and a continuing quest for justice.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-06-16",
  },
  {
    id: 941,
    url: "https://www.tvmaze.com/shows/941/eli-stone",
    name: "Eli Stone",
    genres: ["Drama", "Fantasy", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16196.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16196.jpg",
    },
    summary:
      "<p>Follow <b>Eli Stone</b> on his quirky quest for answers in this exciting and upbeat comedic drama. When Eli awakens to an unending George Michael soundtrack that only he can hear, gets dive-bombed by a WWI biplane on a busy San Francisco street, and faces a fire-breathing dragon outside his office window, there are two possible explanations: delusions caused by a potentially fatal brain aneurysm or the chance that something greater is at work. He might just be a prophet sent to change the world.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-01-31",
  },
  {
    id: 942,
    url: "https://www.tvmaze.com/shows/942/pan-am",
    name: "Pan Am",
    genres: ["Drama", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16205.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16205.jpg",
    },
    summary:
      "<p>Passion, jealousy, espionage. They do it all and they do it at 30,000 feet. Mad Men's style meets Grey's Anatomy's entanglements in this thrilling and highly original new drama from producer Nancy Hult Ganis , writer Jack Orman and director Tommy Schlamme.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-25",
  },
  {
    id: 943,
    url: "https://www.tvmaze.com/shows/943/saving-grace",
    name: "Saving Grace",
    genres: ["Drama", "Crime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16211.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16211.jpg",
    },
    summary:
      "<p>Holly Hunter stars as a detective who kills a man in a drunken car crash and is given a second chance at life from an angel.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-07-23",
  },
  {
    id: 944,
    url: "https://www.tvmaze.com/shows/944/reba",
    name: "Reba",
    genres: ["Drama", "Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16218.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16218.jpg",
    },
    summary:
      "<p>Single mother of three, Reba Hart, tackles parenthood and other obstacles along the way. After her dentist husband of 20 years, Brock, leaves her for his dental hygienist, Barbra Jean, Reba's seemingly perfect world is turned upside down.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-10-05",
  },
  {
    id: 945,
    url: "https://www.tvmaze.com/shows/945/life-on-mars",
    name: "Life on Mars",
    genres: ["Drama", "Crime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16226.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16226.jpg",
    },
    summary:
      "<p>From the studio that brought you Lost, comes the groundbreaking series that captured the imaginations of fans from coast to coast. With an irresistible soundtrack and one of the most celebrated casts on television, including Harvey Keitel, Michael Imperioli, Gretchen Mol and Jason O Mara, <b>Life on Mars</b> is a smart, suspenseful drama with a finish that will blow you away. Its one of those endings I believe will make you watch the series again, says Executive Producer Josh Appelbaum. There s a fine line between delusion and reality. NYPD detective Sam Tyler finds himself walking both sides of that line when he is suddenly hurtled back in time to 1973 after being struck by a car in 2008.</p><p>Journey back to the 70s and uncover the secrets of Life on Mars. It s a strange and exhilarating ride raves the New York Times. Plus, with unique and exciting bonus features including an insiders view of where the shows concept began, a six million dollar moment in which 1970s legend Lee Majors steps back into the past with the cast and crew, and much more.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-10-09",
  },
  {
    id: 946,
    url: "https://www.tvmaze.com/shows/946/waking-the-dead",
    name: "Waking the Dead",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16232.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16232.jpg",
    },
    summary:
      "<p>Drama series following the members of a Cold Case investigation team as they use advanced forensic techniques to uncover the truth and bring criminals to justice.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006r9ys",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2000-09-04",
  },
  {
    id: 947,
    url: "https://www.tvmaze.com/shows/947/friends-with-benefits",
    name: "Friends with Benefits",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16233.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16233.jpg",
    },
    summary:
      "<p><b>Friends with Benefits</b> is a half-hour comedy revolving around a group of twenty-something singles as they navigate the difficult, sometimes rewarding, often confusing world of dating. Loyal and devoted to one another, these friends are never too busy to help a member of the group who might be in need. In fact, their companionship often extends into a more intimate setting - the bedroom.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-08-05",
  },
  {
    id: 948,
    url: "https://www.tvmaze.com/shows/948/crossing-jordan",
    name: "Crossing Jordan",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16239.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16239.jpg",
    },
    summary:
      "<p>Brash, stubborn and resourceful medical examiner Jordan Cavanaugh revives her career in Boston, occasionally breaking the rules and ticking off the cops or her co-workers, including a neurotic boss. On the home front, she gets crime-solving help from her retired-cop dad.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-09-24",
  },
  {
    id: 949,
    url: "https://www.tvmaze.com/shows/949/the-village",
    name: "The Village",
    genres: ["Drama", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16270.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16270.jpg",
    },
    summary:
      "<p>The story of 20th Century England is played out through a family in a Derbyshire village.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b04dybc1",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-03-31",
  },
  {
    id: 950,
    url: "https://www.tvmaze.com/shows/950/family-ties",
    name: "Family Ties",
    genres: ["Drama", "Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16287.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16287.jpg",
    },
    summary:
      "<p>Steve and Elyse Keaton, once 1960s radicals, now find themselves in Reagan-Era American trying to raise a traditional suburban family. Son Alex P. Keaton is an ambitious Young Republican and his sister Mallory is a shallow victim of the corporate culture, obsessed with music, clothes and boys. Their only normal kid is young Jennifer a bit of a tomboy.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1982-09-22",
  },
  {
    id: 951,
    url: "https://www.tvmaze.com/shows/951/ben-10",
    name: "Ben 10",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16288.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16288.jpg",
    },
    summary:
      '<p>First premiering in January 2006, <b>Ben 10</b> is a Cartoon Network Original Animation Series that finds our hero, 10-year-old Ben Tennyson, discovering an alien "Omnitrix" watch that allows him the ability to transform into any one of ten alien superheroes! With the help of his Grandpa Max and "dweeb" cousin Gwen, Ben defeats his arch-nemesis Vilgax in the "Secret of the Omnitrix" movie special, leaving the planet earth safe from evil alien threats. In "Ben 10: Alien Force" (premiered April 2008), our hero is now fifteen years old and must once again use the Omnitrix to protect the earth from a new, sinister alien conspiracy that threatens to conquer the entire universe! This time around he has the help of not only his cousin Gwen (who is learning to master alien powers of her own), but his old nemesis Kevin Levin. Together, our trio of heroes span the globe (and galaxy!) to protect the earth from threats as they arise. Picking up immediately where "Ben 10: Alien Force" leaves off, "Ben 10: Ultimate Alien" (premiering April 2010) follows the now 16-year-old Ben as his life changes in major ways! The Omnitrix has been destroyed and Ben must now learn to master the secrets of the mysterious Ultimatrix, a new watch-like device that not only allows him to transform into a variety of alien super heroes, but also gives him the ability to activate evolved (or "ultimate") versions of some of his most powerful alien entities! That\'s only half of the changes in store for our hero, as a young savvy fanboy discovers Ben\'s secret identity and reveals it to the world! Faced with newfound stardom, Ben must deal with obsessive fans and skeptics who view him as a nuisance. With Gwen and Kevin still at his side, Ben continues his battle against incredible alien threats to the galaxy!</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-12-27",
  },
  {
    id: 952,
    url: "https://www.tvmaze.com/shows/952/my-wife-and-kids",
    name: "My Wife and Kids",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16291.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16291.jpg",
    },
    summary:
      "<p>Michael Kyle longs for a traditional life, but his day-trader wife Janet, gangsta rap-worshipping son Michael Jr., and brooding daughters Claire and Kady make his dream just that ... a dream.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-03-28",
  },
  {
    id: 953,
    url: "https://www.tvmaze.com/shows/953/the-inbetweeners",
    name: "The Inbetweeners",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16301.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16301.jpg",
    },
    summary:
      "<p>Sitcom about a bunch of middle-class adolescent lads. Welcome to a world of futile crushes, sibling brawls, getting drunk too quickly and casting constant aspersions about your friends' sexuality...</p>",
    officialSite: "http://www.channel4.com/programmes/the-inbetweeners",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 41,
      name: "E4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-05-01",
  },
  {
    id: 954,
    url: "https://www.tvmaze.com/shows/954/chopped",
    name: "Chopped",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/237/592911.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/237/592911.jpg",
    },
    summary:
      "<p><b>Chopped </b>is a cooking competition show that is all about skill, speed and ingenuity. Each week, four chefs compete before a panel of expert judges and turn baskets of mystery ingredients into an extraordinary three-course meal. Course by course, the chefs will be \"chopped\" from the competition until only one winner remains. The challenge? They have seconds to plan and 30 minutes to cook an amazing course with the basket of mystery ingredients given to them moments before the clock starts ticking! And the pressure doesn't stop there. Once they've completed their dish, they've got to survive the Chopping Block where our three judges are waiting to be wowed and not shy about voicing their culinary criticisms! Our host, Ted Allen, leads this high-energy, high-pressure show that will have viewers rooting for a winner and cheering for the losers. <i>Chopped</i> is a game of passion, expertise and skill — and in the end, only one chef will survive the Chopping Block. Who will make the cut? The answer is on <i>Chopped!</i></p>",
    officialSite: "http://www.foodnetwork.com/shows/chopped",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 81,
      name: "Food Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-01-13",
  },
  {
    id: 955,
    url: "https://www.tvmaze.com/shows/955/american-restoration",
    name: "American Restoration",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/43/108916.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/43/108916.jpg",
    },
    summary:
      "<p><b>American Restoration </b>follows five of the best restoration shops in the United States as they not only restore pieces of America's history, but create new and awe-inspiring works from vintage items. Each shop has a unique focus—from classic cars, to rare antique signs, to one-of-a-kind bikes. They'll prove their prowess as masters of restoration, while exploring each item's original glory, place in history and effect on pop-culture.</p>",
    officialSite: "https://www.history.com/shows/american-restoration",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-10-25",
  },
  {
    id: 956,
    url: "https://www.tvmaze.com/shows/956/magnum-pi",
    name: "Magnum, P.I.",
    genres: ["Drama", "Action", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16309.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16309.jpg",
    },
    summary:
      "<p>Pursued by thugs and lovely ladies alike, Thomas Magnum is a witty but tough private investigator in Hawaii who works for a mysterious novelist.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1980-12-11",
  },
  {
    id: 957,
    url: "https://www.tvmaze.com/shows/957/the-dresden-files",
    name: "The Dresden Files",
    genres: ["Drama", "Fantasy", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16314.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16314.jpg",
    },
    summary:
      "<p><b>The Dresden Files</b> chronicles the cases of no ordinary detective. Harry Dresden is a wizard, the only one listed in the Chicago phone book. He's got a handle on the crimes that can't be solved by anyone else. Paranormal? No problem. Dresden deals in all matters of supernatural threats. If you need a little hocus pocus or some other worldly advice, Dresden's your man.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-01-21",
  },
  {
    id: 958,
    url: "https://www.tvmaze.com/shows/958/gangland",
    name: "Gangland",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16320.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16320.jpg",
    },
    summary:
      "<p>They rob, kill, and terrorize, and they've left their bloody mark on American history. This is the world of <b>Gangland</b>.</p><p>The <i>Gangland</i> series tells the insider story of some of America's most notorious street gangs. We learn how they've shaped their times and affected the neighborhoods that they controlled. From the destruction wrought by the heroin kingpins in Harlem of the 1970s to today's most dangerous gang MS-13, which has spread out from the inner city to infect unexpected turf —suburban communities—gangs have a rich yet deadly history. They usually start out as a form of protection for their members and community but then grow predatory as they feed on the very people that they purport to defend. With exclusive interviews and rarely seen footage, this is a raw look at life inside these gangs—from those who live it and the agencies that are working to stop them.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-11-01",
  },
  {
    id: 959,
    url: "https://www.tvmaze.com/shows/959/operation-repo",
    name: "Operation Repo",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16321.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16321.jpg",
    },
    summary:
      "<p>It's the fast-paced, high-pressure world of car repossession with a team of highly-trained professionals from California's San Fernando Valley. No matter how angry you get, they're taking back your car.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 84,
      name: "truTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-11-17",
  },
  {
    id: 960,
    url: "https://www.tvmaze.com/shows/960/melrose-place",
    name: "Melrose Place",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16331.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16331.jpg",
    },
    summary:
      "<p>A nighttime soap opera about the lives, careers, trials and tribulations of a group of young people living in an apartment building in the trendy neighborhood of <b>Melrose Place</b>. The show was a spin off of Beverly Hills 90210 and starred Heather Locklear as the scheming Amanda Woodward, head of her own advertising agency and owner of the apartment building.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1992-07-08",
  },
  {
    id: 961,
    url: "https://www.tvmaze.com/shows/961/the-lying-game",
    name: "The Lying Game",
    genres: ["Drama", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16387.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16387.jpg",
    },
    summary:
      "<p><b>The Lying Game</b> follows Emma, a kind-hearted foster kid who learns she has an identical twin sister, Sutton. Sutton, unlike Emma, was adopted by wealthy parents and is seemingly living an ideal life. After their initial meeting, Sutton talks Emma into stepping into her life for a few days while she pursues a lead on the mysterious identity of their birth mother. After Sutton inexplicably fails to return to the girls' designated meeting place, Emma must decide whether to come clean about her identity and risk her own safety in the hope of uncovering her twin sister's whereabouts, along with the truth about why they were separated in the first place.</p>",
    officialSite: "http://abcfamily.go.com/shows/lying-game",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-08-15",
  },
  {
    id: 962,
    url: "https://www.tvmaze.com/shows/962/hawaii-five-o",
    name: "Hawaii Five-O",
    genres: ["Action", "Adventure", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16397.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16397.jpg",
    },
    summary:
      '<p><b>Hawaii Five-0</b> was filmed entirely on location in Hawaii, the show followed Jack Lord as he played Steve McGarrett, head of an elite state police unit investigating "organized crime, murder, assassination attempts, foreign agents, felonies of every type." James MacArthur played his second-in-command Danny ("Danno") Williams, with local actors Kam Fong, Zulu, Al Harrington, and Herman Wedemeyer, among others, playing members of the Five-O team.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1968-09-20",
  },
  {
    id: 963,
    url: "https://www.tvmaze.com/shows/963/til-death",
    name: "'Til Death",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/174/436947.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/174/436947.jpg",
    },
    summary:
      "<p>In this new comedy, a pair of newlyweds, Jeff Woodcock and Steph Woodcock, who have been married 12 days, move in next door to a long-married couple. Eddie Stark and Joy Stark, who have been married for over 8,000 days, provide the younger couple with a surprising look at what their future might hold <b>'Til Death</b>. Real-life husband &amp; wife Josh Goldsmith and Cathy Yuspa are the show writers.</p>",
    officialSite: "http://www.sonypictures.com/tv/tildeath/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-09-07",
  },
  {
    id: 964,
    url: "https://www.tvmaze.com/shows/964/united-states-of-tara",
    name: "United States of Tara",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16409.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16409.jpg",
    },
    summary:
      '<p>She\'s got a husband, two kids and multiple personalities. Emmy® and Golden Globe® winner Toni Collette never knows what or who will happen in this smart, unique and totally unpredictable Showtime Original Comedy Series from executive producer Steven Spielberg. Tara\'s Alters include "T" the wild-child teenager, "Buck" the rough and tumble biker dude, and "Alice" the type-A homemaker. But with a family that loves her just the way she is. Tara never gives up hope that someday she can just be herself.</p>',
    officialSite: "http://www.sho.com/united-states-of-tara",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-01-18",
  },
  {
    id: 965,
    url: "https://www.tvmaze.com/shows/965/hawthorne",
    name: "Hawthorne",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16414.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16414.jpg",
    },
    summary:
      "<p>At Richmond Trinity Hospital, Director of Nursing Christina <b>Hawthorne</b> is locked in a battle against forces far too large for any one person to handle. Whether fighting to see that a homeless woman is treated like a human being, talking a close friend and suicidal cancer patient off a ledge, accommodating the clashing egos of the hospital's talented doctors and administrators, or managing a nursing staff of grizzled veterans and idealistic young rookies, she's the much-needed conscience for an organization that all too often forgets whom it's there to serve. Still learning to cope with the death of her husband and make peace with her powerful and grieving mother-in-law, Christina looks to balance her pressure cooker career with raising a smart but willful teenage girl as she tries to change a broken system, one patient at a time.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-06-16",
  },
  {
    id: 966,
    url: "https://www.tvmaze.com/shows/966/house-of-anubis",
    name: "House of Anubis",
    genres: ["Drama", "Fantasy", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16422.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16422.jpg",
    },
    summary:
      "<p>It's up to Eddie and his friends to reform Sibuna in order to stop an ancient curse from being unleashed. But when teachers and even friends are not what they seem, who can be trusted?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-01-01",
  },
  {
    id: 967,
    url: "https://www.tvmaze.com/shows/967/deception",
    name: "Deception",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16423.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16423.jpg",
    },
    summary:
      "<p>The death of wealthy party girl Vivian Bowers doesn't add up for FBI agent Will Moreno, especially in a family as suspicious as the Bowers. Convinced that the tabloid staple's death was a homicide, he recruits his former SFPD partner and Vivian's childhood best friend, Joanna Padget Locasto to re-establish ties with the Bowers. Determined to find justice for her estranged best friend, Joanna infiltrates the dynasty she once considered family, and quickly begins to uncover why Vivian's life was very much in danger.</p><p><br></p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-01-07",
  },
  {
    id: 968,
    url: "https://www.tvmaze.com/shows/968/rubicon",
    name: "Rubicon",
    genres: ["Drama", "Thriller", "Espionage"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16431.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16431.jpg",
    },
    summary:
      "<p><b>Rubicon</b> is a conspiracy thriller set in a NYC-based government intelligence agency, API, where nothing is what it seems. The series focuses on a beleaguered analyst, Will Travers, who, faced with a shocking tragedy, begins to uncover clues that point to a complex and sinister conspiracy.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 20,
      name: "AMC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-06-13",
  },
  {
    id: 969,
    url: "https://www.tvmaze.com/shows/969/19-kids-and-counting",
    name: "19 Kids and Counting",
    genres: ["Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16436.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16436.jpg",
    },
    summary:
      "<p><b>19 Kids and Counting</b> (formerly <i>17/18 Kids and Counting</i>) follows Michelle and Bob Duggar as they deal with the challenges of raising a family of ten boys, eight girls and baby Josie Duggar.</p>",
    officialSite: "http://www.tlc.com/tv-shows/19-kids-and-counting/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-09-29",
  },
  {
    id: 970,
    url: "https://www.tvmaze.com/shows/970/the-sarah-jane-adventures",
    name: "The Sarah Jane Adventures",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16437.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16437.jpg",
    },
    summary:
      "<p>Follow Sarah Jane Smith, Luke, Clyde, Rani and Sky as they save the world from a whole universe of aliens and monsters in <b>The Sarah Jane Adventures</b>.</p>",
    officialSite: "http://www.bbc.co.uk/cbbc/shows/the-sarah-jane-adventures",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2007-01-01",
  },
  {
    id: 971,
    url: "https://www.tvmaze.com/shows/971/chaos",
    name: "Chaos",
    genres: ["Drama", "Comedy", "Espionage"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16444.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16444.jpg",
    },
    summary:
      "<p><b>Chaos</b> is a comedic drama about a group of rogue CIA spies in the Clandestine Administration and Oversight Services.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-04-01",
  },
  {
    id: 972,
    url: "https://www.tvmaze.com/shows/972/dirt",
    name: "Dirt",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16453.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16453.jpg",
    },
    summary:
      "<p><b>Dirt</b> features Hollywood scandals ripped from the headlines. Lucy Spiller is the stalwart, unrelenting editor-in-chief of the tabloid magazine Dirt Now. With an uncanny sixth sense for the truth and an infallible instinct for cover-ups, Lucy exposes the secrets and lies of the famous and the infamous through her magazine with rancorous accuracy.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-01-02",
  },
  {
    id: 973,
    url: "https://www.tvmaze.com/shows/973/little-people-big-world",
    name: "Little People, Big World",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/315/788489.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/315/788489.jpg",
    },
    summary:
      "<p><b>Little People, Big World</b> features the Roloffs, an extraordinary family comprised of both little and average-height people, capturing their everyday successes and struggles, and presenting an intimate view of life as a little person.</p>",
    officialSite: "http://www.tlc.com/tv-shows/little-people-big-world/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-03-04",
  },
  {
    id: 974,
    url: "https://www.tvmaze.com/shows/974/snapped",
    name: "Snapped",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/205/513102.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/205/513102.jpg",
    },
    summary:
      "<p>Each year, approximately 16,000 people are murdered in the United States. 7% of the killers are female.*</p><p>Who are these women and what drives them to kill? Oxygen's hit true crime series, <i>Snapped</i>, profiles the fascinating cases of women accused of murder. Did they really do it? And, if they did, why? Whether the motivation was revenge against a cheating husband, the promise of a hefty insurance payoff, or putting an end to years of abuse, the reasons are as varied as the women themselves. From socialites to secretaries, female killers share one thing in common: at some point, they all snapped. <b>Snapped </b>is produced in conjunction with Jupiter Entertainment, the creators of <i>City Confidential</i> and <i>Dominick Dunne's Power</i>, <i>Privilege &amp; Justice</i>, and narrated by veteran news reporter Sharon Martin. Each episode of <i>Snapped</i> chronicles the life of a woman who has been charged with murder. These shocking but true stories turn common assumptions about crime and criminals upside down, and prove that even the most unlikely suspects can be capable of murder.</p>",
    officialSite: "http://www.oxygen.com/snapped",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 79,
      name: "Oxygen",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-08-06",
  },
  {
    id: 975,
    url: "https://www.tvmaze.com/shows/975/batman",
    name: "Batman",
    genres: ["Comedy", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16463.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16463.jpg",
    },
    summary:
      "<p>Wealthy entrepreneur Bruce Wayne and his ward Dick Grayson lead a double life: they are actually crime fighting duo Batman and Robin. A secret Batpole in the Wayne mansion leads to the Batcave, where Police Commissioner Gordon often calls with the latest emergency threatening Gotham City. Racing to the scene of the crime in the Batmobile, Batman and Robin must (with the help of their trusty Bat-utility-belt) thwart the efforts of a variety of master criminals, including Catwoman, Egghead, The Joker, King Tut, The Penguin, and The Riddler.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1966-01-12",
  },
  {
    id: 976,
    url: "https://www.tvmaze.com/shows/976/sabrina-the-teenage-witch",
    name: "Sabrina, the Teenage Witch",
    genres: ["Comedy", "Family", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/214/536178.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/214/536178.jpg",
    },
    summary:
      "<p>When Sabrina Spellman is informed by her aunts, Hilda and Zelda, that she is a witch on her 16th birthday, she is hesitant to believe them. Having been sent to live with them in Massachusetts by her Warlock father and mortal mother, Sabrina learns the tricks of magic in order to receive her witch's license. Along the way, she gets into many scrapes while figuring out how certain spells work. She also has to keep the secret from her boyfriend, Harvey, friends Jenny and later Valerie, stuck-up nemesis Libby, and her ever-suspicious vice-principal, Mr. Kraft.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-09-27",
  },
  {
    id: 977,
    url: "https://www.tvmaze.com/shows/977/chase",
    name: "Chase",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16501.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16501.jpg",
    },
    summary:
      "<p><b>Chase</b> is a fast-paced drama that drops viewers smack into the middle of a game of cat-and-mouse as a team of U.S. marshals hunts down America's most dangerous fugitives. U.S. Marshal Annie Frost is a cowboy boot-wearing deputy whose sharp mind and unique Texas upbringing help her track down the violent criminals on the run.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-20",
  },
  {
    id: 978,
    url: "https://www.tvmaze.com/shows/978/chowder",
    name: "Chowder",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16507.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16507.jpg",
    },
    summary:
      "<p>Then show follows Chowder, a young chef in Mung Daal's catering company and his daily advantures.</p>",
    officialSite: "https://www.cartoonnetwork.com/shows/chowder/characters/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-11-02",
  },
  {
    id: 979,
    url: "https://www.tvmaze.com/shows/979/good-eats",
    name: "Good Eats",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/208/521150.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/208/521150.jpg",
    },
    summary:
      "<p>Pop culture, comedy and plain good eating: host Alton Brown explores the origins of ingredients, decodes culinary customs, and presents food and equipment trends. Punctuated by unusual interludes, simple preparations and unconventional discussions, he'll bring you food in its finest and funniest form.</p>",
    officialSite: "https://www.foodnetwork.com/shows/good-eats",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 81,
      name: "Food Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-07-07",
  },
  {
    id: 980,
    url: "https://www.tvmaze.com/shows/980/wipeout",
    name: "Wipeout",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16509.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16509.jpg",
    },
    summary:
      "<p>Human cannonballs! Human pinballs! Crashes, smashes and mud splashes! Each week thrill-seekers compete in the world's largest extreme obstacle course designed to provide the most spills, face plants and wipeouts ever seen on television.</p><p>Each week 24 daring new contestants of all ages, shapes and sizes will go head to head through a grueling but wildly hilarious obstacle course to win the title of <b>Wipeout</b> Champion. In the end, only one contestant will win, while everyone else will Wipeout!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-06-24",
  },
  {
    id: 981,
    url: "https://www.tvmaze.com/shows/981/cleopatra-2525",
    name: "Cleopatra 2525",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16510.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16510.jpg",
    },
    summary:
      '<p>It is the year 2525 AD, and most of mankind has been driven underground by huge flying mechanical creatures known as the Baileys. The team of Hel, Sarge and Cleo (a recently defrosted 21st century exotic dancer who was cryogenically frozen following complications during her cosmetic surgery operation) are guided by the mysterious "Voice" and aided by Mauser (a reprogrammed robotic enforcer) to fight a war to reclaim the Earth\'s surface.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-01-17",
  },
  {
    id: 982,
    url: "https://www.tvmaze.com/shows/982/jack-of-all-trades",
    name: "Jack of All Trades",
    genres: ["Comedy", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16514.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16514.jpg",
    },
    summary:
      "<p>American spy Jack Stiles is sent by Thomas Jefferson to the tiny East Indies island of Palau Palau, where he teams up with British agent and inventor Emilia Rothschild to thwart the efforts of Napoleon and France in that region of the world. While acting as Emilia's man servant, Jack dons the mask garb of the legendary Daring Dragoon and fights the local French governor as well as thwarting various other schemes against America.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-01-22",
  },
  {
    id: 983,
    url: "https://www.tvmaze.com/shows/983/hollywood-heights",
    name: "Hollywood Heights",
    genres: ["Drama", "Music", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/53/134485.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/53/134485.jpg",
    },
    summary:
      "<p>Romance and deceit. Fame and heartbreak. Success and secrets. Welcome to <b>Hollywood Heights</b>, where they put the DRAMA in family drama. Follow Loren, an aspiring songwriter and straight-A high school student, as her life drastically changes. When Loren gets thrown into the spotlight suddenly, and meets her musical idol, Eddie Duran, nothing will ever be the same for anyone. The obstacles that come with life and fame become instantly apparent, but it's the strong bond between friends and family that help them all through.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 62,
      name: "nick@nite",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-06-11",
  },
  {
    id: 984,
    url: "https://www.tvmaze.com/shows/984/8-simple-rules",
    name: "8 Simple Rules",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/64/161762.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/64/161762.jpg",
    },
    summary:
      "<p>Legendary sitcom stars John Ritter and Katey Sagal team up in <b>8 Simple Rules</b>, ABC's hit family comedy that is laugh-out-loud funny. \"If you make my daughters cry, I'll make you cry.\" That's the rallying cry of Paul Hennessy. A little rusty in the parenting department, Paul is forced to meet fatherhood head-on when his wife Cate returns to work. Two teenage daughters and a wisecracking son make Paul's new situation daunting but never dull.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-09-17",
  },
  {
    id: 985,
    url: "https://www.tvmaze.com/shows/985/the-new-adventures-of-old-christine",
    name: "The New Adventures of Old Christine",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16526.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16526.jpg",
    },
    summary:
      "<p><b>The New Adventures of Old Christine</b> is a comedy about a divorced working mom who's juggling the daily stresses of motherhood, work and dating, while maintaining a positive relationship with her ex-husband, which is easier when his pretty new girlfriend isn't around to complicate the picture. Christine Campbell has a busy life - after all, she's prone to taking NyQuil to get to sleep and leaving voicemail messages to herself in the middle of the night. She co-owns a women's 30-minute workout gym with her best friend, Barb, and manages to send her 13-year-old son, Ritchie, to a posh private school, where she endures endless encounters with two snooty, condescending stay-at-home moms, Marly and Lindsay. Her inexperienced therapist brother, Matthew, helps Christine care for Ritchie and serves as her emotional rock. Christine gets along with her ex-husband, Richard, even better than when they were married, but since Richard's been in relationship with \"new\" Christine\" - making her the \"Old Christine\" - she feels the pressure to take that same leap.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-03-13",
  },
  {
    id: 986,
    url: "https://www.tvmaze.com/shows/986/the-sarah-silverman-program",
    name: "The Sarah Silverman Program",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16527.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16527.jpg",
    },
    summary:
      '<p>Welcome back to the wacky world of Sarah Silverman. Follow Sarah and the rest of the gang as she takes on pedophile vans, rigs a mayoral election, takes a stance on "Real Time with Bill Maher" and reconnects with her imaginary childhood friend (played by Andy Samberg), among other adventures in this irreverent new season.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-02-01",
  },
  {
    id: 987,
    url: "https://www.tvmaze.com/shows/987/hellcats",
    name: "Hellcats",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16528.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16528.jpg",
    },
    summary:
      '<p>Marti Perkins (Michalka), a law student at Lancer University, discovers that her scholarship has been cancelled and her well-meaning but irresponsible mother, Wanda (Gail O\'Grady, "NYPD Blue," "American Dreams") has neglected to inform her. Broke and out of options, Marti realizes the only way she can stay in school is to win a place on the Hellcats - Lancer\'s legendary cheer squad - and the scholarship that comes with it.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-08",
  },
  {
    id: 988,
    url: "https://www.tvmaze.com/shows/988/drake-josh",
    name: "Drake & Josh",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/258/647005.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/258/647005.jpg",
    },
    summary:
      "<p>Fifteen-year-old Drake and Josh are schoolmates, but not close friends. As a matter of fact, Drake thinks Josh is a bit of a goof. Imagine his shock when he discovers this goof is about to become his stepbrother and new roommate when his mother marries Josh's father!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-01-11",
  },
  {
    id: 989,
    url: "https://www.tvmaze.com/shows/989/bang-goes-the-theory",
    name: "Bang Goes the Theory",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16530.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16530.jpg",
    },
    summary:
      "<p>Investigating the science behind the headlines and making sense of the issues that matter.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00lwxj1",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-07-27",
  },
  {
    id: 990,
    url: "https://www.tvmaze.com/shows/990/doc-martin",
    name: "Doc Martin",
    genres: ["Drama", "Comedy", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16531.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16531.jpg",
    },
    summary:
      "<p>Successful surgeon Dr Martin Ellingham relocates to the seaside village of Portwenn in Cornwall; but his gruff demeanour and poor bedside manner bring him into conflict with the locals as he begins his new life as a GP.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2004-09-02",
  },
  {
    id: 991,
    url: "https://www.tvmaze.com/shows/991/the-real-world",
    name: "The Real World",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16540.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16540.jpg",
    },
    summary:
      "<p>Each year, <b>The Real World</b> producers choose a group of seven people in their 20s, from different backgrounds and countries, to live together in a major city. The series presents their spontaneous, unscripted interactions with one another and the world around them.</p>",
    officialSite: null,
    webChannel: { id: 202, name: "Facebook Watch", country: null },
    language: "English",
    status: "Running",
    network: null,
    premiered: "1992-05-21",
  },
  {
    id: 992,
    url: "https://www.tvmaze.com/shows/992/dog-the-bounty-hunter",
    name: "Dog the Bounty Hunter",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16541.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16541.jpg",
    },
    summary:
      '<p>The world\'s most famous bounty hunter, Duane "Dog" Chapman, is back with action-packed, high-stakes hunts from Hawaii to Colorado, tracking down fugitives along side his wife Beth and fearless family-based posse. The intensity of bounty hunting is taking its toll on the Chapman family this year - Baby Lyssa has a run-in with the law after a night of drinking, Duane Lee is fighting with Dog and Beth about his responsibilities to the family business and Leland is stuck in the middle. Dog and Beth are trying to keep the family working together, and in this season, they have some of the most adrenaline fueled, heart pumping chases and catches to date.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-08-31",
  },
  {
    id: 993,
    url: "https://www.tvmaze.com/shows/993/life-unexpected",
    name: "Life Unexpected",
    genres: ["Drama", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/214/536177.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/214/536177.jpg",
    },
    summary:
      "<p>After spending all of her 15 years bouncing from one foster family to another in Portland, Oregon, Lux has decided it's time to take control of her life and become an emancipated minor. Her journey through the legal system leads Lux to her biological parents, local radio personality Cate Cassidy and thirty-something Nate \"Baze\" Bazile, who had a one-night stand back in high school. Although they haven't seen each other in 15 years, it doesn't take Cate and Baze long to fall into the same contentious relationship they had as teenagers. However, when a judge decides that Lux isn't ready for emancipation and unexpectedly grants temporary joint custody to Baze and Cate, they agree to try to get past the arguments and awkwardness and make a belated attempt to give Lux the family she deserves. The cast also Math, Baze's childhood friend and current roommate, and Ryan Thomas, Cate's fiancé and co-host on K100.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-01-18",
  },
  {
    id: 994,
    url: "https://www.tvmaze.com/shows/994/flight-of-the-conchords",
    name: "Flight of the Conchords",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/41/103111.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/41/103111.jpg",
    },
    summary:
      '<p><b>Flight of the Conchords</b> follows the trials and tribulations of a two man, digi-folk band from New Zealand as they try to make a name for themselves in their adopted home of New York City. The band is made up of Bret McKenzie on guitar and vocals, and Jemaine Clement on guitar and vocals. Bret and Jemaine have moved to New York in the hope of forging a successful music career. So far they\'ve managed to find a manager (whose "other" job is at the New Zealand Consulate), one fan (a married obsessive) and one friend (who owns the local pawn shop) -- but not much else.</p>',
    officialSite: "http://www.hbo.com/flight-of-the-conchords",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-06-17",
  },
  {
    id: 995,
    url: "https://www.tvmaze.com/shows/995/the-dog-whisperer",
    name: "The Dog Whisperer",
    genres: ["Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16544.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16544.jpg",
    },
    summary:
      "<p>From London to the Jersey shore, Cesar travels far and wide this season to help problem pups, including those of Kelsey Grammer, Jillian Michaels and Hugh Hefner. Watch as Cesar rehabilitates dogs and trains people to achieve a balanced and natural relationship between humans and their pets.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 83,
      name: "National Geographic WILD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-09-13",
  },
  {
    id: 996,
    url: "https://www.tvmaze.com/shows/996/men-in-trees",
    name: "Men in Trees",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31440.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31440.jpg",
    },
    summary:
      "<p>To help Marin get rid of issues that weigh her down, Cash takes her to visit a guru. On the way back down the mountain trail, an arctic cyclone erupts. Jack goes out to look for them and a pregnant Lynn can't do anything to stop him. Everyone hunkers down at the Chieftain to wait out the storm, and they learn some surprising things about each other. Mai and Buzz argue over his first choice of a wife, the engaged Patrick and Annie see her competitive spirit at work, Celia and Dick take their relationship to a new intimacy level, and Sara tells Ben about her mysterious court summons much to the chagrin of wife Theresa.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-09-12",
  },
  {
    id: 997,
    url: "https://www.tvmaze.com/shows/997/catfish-the-tv-show",
    name: "Catfish: The TV Show",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/324/810375.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/324/810375.jpg",
    },
    summary:
      '<p><b>Catfish: The TV Show</b> tackles the mystery and complexities of dating in a digital world. The hour-long series follows Nev Schulman, whose own online love drama was the subject of the "Catfish" film, and director-filmmaker Max Joseph as they take viewers on a deeply personal journey that goes inside the stories of young people as their online-only romantic relationships collide with first-time, real-life encounters.</p>',
    officialSite: "https://www.mtv.com/shows/catfish-the-tv-show",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-11-12",
  },
  {
    id: 998,
    url: "https://www.tvmaze.com/shows/998/detroit-1-8-7",
    name: "Detroit 1-8-7",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16547.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16547.jpg",
    },
    summary:
      "<p>Welcome to Detroit Homicide. These are the detectives who dedicate their lives to protecting a city they love. Get an insiders glimpse at what it means to serve and protect. It's their city, everything is personal.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-21",
  },
  {
    id: 999,
    url: "https://www.tvmaze.com/shows/999/flash-gordon",
    name: "Flash Gordon",
    genres: ["Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16548.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16548.jpg",
    },
    summary:
      "<p>Placing a 21st century spin on a science fiction classic, SCI FI's contemporized version of <b>Flash Gordon</b> follows the all-new adventures of Flash and his companions, Dale Arden and Dr. Hans Zarkov. Ordinary people thrust into extraordinary circumstances, they find themselves as Earth's last line of defense against the forces of the merciless dictator Ming.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-08-10",
  },
  {
    id: 1000,
    url: "https://www.tvmaze.com/shows/1000/squidbillies",
    name: "Squidbillies",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16556.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16556.jpg",
    },
    summary:
      "<p>Watch the <b>Squidbillies</b> as the Cuylers kick the ass of America's toughest issues, including marriage inequality, taint cancer, speciesism, and the impending Russian snake apocalypse. It's good clean family fun for childless families!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-10-16",
  },
  {
    id: 1001,
    url: "https://www.tvmaze.com/shows/1001/bag-of-bones",
    name: "Bag of Bones",
    genres: ["Drama", "Horror", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16571.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16571.jpg",
    },
    summary:
      "<p><b>Bag of Bones</b> is a ghost story of grief and lost love's enduring bonds, about an innocent child caught in a terrible crossfire and a new love haunted by past secrets.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-12-11",
  },
  {
    id: 1002,
    url: "https://www.tvmaze.com/shows/1002/camelot",
    name: "Camelot",
    genres: ["Drama", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16578.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16578.jpg",
    },
    summary:
      "<p>The 10-episode epic drama, redefines the classic medieval tale of King Arthur with an exciting ensemble cast including Joseph Fiennes reimagining the iconic role of Merlin, Jamie Campbell Bower as the young and reckless Arthur, and Eva Green in her television debut as the darkly powerful Morgan.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 17,
      name: "Starz",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-02-25",
  },
  {
    id: 1003,
    url: "https://www.tvmaze.com/shows/1003/talking-bad",
    name: "Talking Bad",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16586.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16586.jpg",
    },
    summary:
      "<p><b>Talking Bad</b> features Hardwick spending time with fans, actors, producers and tv enthusiasts, recapping the most recent <i>Breaking Bad</i> episode, and taking questions and comments from viewers. Fans may continue to engage with the after-show following the on-air conclusion, online, at amc.com for more videos, weekly polls and photo galleries of the guests featured on the series.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 20,
      name: "AMC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-08-11",
  },
  {
    id: 1005,
    url: "https://www.tvmaze.com/shows/1005/happy-town",
    name: "Happy Town",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16587.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16587.jpg",
    },
    summary:
      "<p>The residents of the sun-splashed town of Haplin, Minnesota -- also known as <b>Happy Town</b> -- have enjoyed an uneasy peace for the past five years -- but that is about to change. Still haunted by a number of unsolved kidnappings, Haplin now faces a disturbing new crime that brings all of its unresolved fears to the surface. Has the elusive \"Magic Man\" -- who many believe is responsible for the bizarre abductions -- returned to claim yet another innocent victim? As Haplin's mysteries are revealed, many of its prominent citizens' motives come under scrutiny as their own secrets and personalities are peeled back one layer at a time.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-04-28",
  },
  {
    id: 1007,
    url: "https://www.tvmaze.com/shows/1007/tru-calling",
    name: "Tru Calling",
    genres: ["Drama", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16597.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16597.jpg",
    },
    summary:
      "<p>What would you do if you could relive a day? If you're Tru Davies, you'd save lives.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-10-30",
  },
  {
    id: 1008,
    url: "https://www.tvmaze.com/shows/1008/masters-of-science-fiction",
    name: "Masters of Science Fiction",
    genres: ["Drama", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16603.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16603.jpg",
    },
    summary:
      "<p>Six thought-provoking tales of present and future Earth are brought to life in the all-new anthology series, featuring a stellar lineup of actors and directors, and narrated by acclaimed physicist Professor Stephen Hawking. <b>Masters of Science Fiction</b>, from Starz Media in association with Industry Entertainment and its Vancouver partner, Reunion Pictures, is based on some of the genre's most popular and highly regarded short stories.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-08-04",
  },
  {
    id: 1009,
    url: "https://www.tvmaze.com/shows/1009/do-no-harm",
    name: "Do No Harm",
    genres: ["Drama", "Horror", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16604.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16604.jpg",
    },
    summary:
      "<p>Dr. Jason Cole is a highly respected neurosurgeon who has it all - a lucrative career, confident charm and the gift of compassion. But he also has a deep, dark secret. One morning, after waking up disoriented in a wrecked hotel room amidst near-naked women he's never seen before, he knows one thing: it happened again. Every night at the same hour, something inside Jason changes, leaving him almost unrecognizable - seductive, devious, borderline sociopathic. This new man is his dangerous alternate personality, who goes by the name Ian Price. For years Jason has battled Ian, keeping him in check with a powerful experimental sedative. But now his - their - body has developed a resistance to the serum, setting Ian free once again. And to make matters worse, after being suppressed for so long, Ian is hell-bent on taking revenge on his oppressor. With everyone Jason cares about at risk - patients, friends, coworkers and even the woman he loves - he must stop Ian once and for all. Will they find some common ground, or will they bring each other down? Hell hath no fury like an alter ego scorned.</p>",
    officialSite: "http://www.nbc.com/do-no-harm/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-01-31",
  },
  {
    id: 1010,
    url: "https://www.tvmaze.com/shows/1010/zero-hour",
    name: "Zero Hour",
    genres: ["Drama", "Thriller", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16617.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16617.jpg",
    },
    summary:
      "<p><b>Zero Hour</b> follows Hank Galliston, who has spent his life debunking myths, only to be drawn into one of the most compelling mysteries in human history after his wife's shocking disappearance.</p>",
    officialSite: "https://abc.com/shows/zero-hour",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-02-14",
  },
  {
    id: 1011,
    url: "https://www.tvmaze.com/shows/1011/vanderpump-rules",
    name: "Vanderpump Rules",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/141/353200.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/141/353200.jpg",
    },
    summary:
      "<p><b>Vanderpump Rules</b> follows the passionate, volatile and hot-and-bothered-staff at Lisa Vanderpump's West Hollywood mainstay SUR. Lisa balances her motherly instincts and shrewd business sense to keep control over this wild group of employees as they pursue their dreams and each other while working at her \"Sexy, Unique Restaurant\". Often seen on <i>Real Housewives of Beverly Hills</i>, SUR has been the backdrop for many memorable moments, including the unexpected encounter between Brandi Glanville and Scheana Marie, a female server who famously had an affair with Brandi's ex-husband.</p>",
    officialSite: "http://www.bravotv.com/vanderpump-rules",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-01-07",
  },
  {
    id: 1012,
    url: "https://www.tvmaze.com/shows/1012/undercovers",
    name: "Undercovers",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16624.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16624.jpg",
    },
    summary:
      '<p>"Undercovers" is a sexy, fun, action-packed spy drama that proves once and for all that marriage is still the world\'s most dangerous partnership.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-22",
  },
  {
    id: 1013,
    url: "https://www.tvmaze.com/shows/1013/the-playboy-club",
    name: "The Playboy Club",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16630.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16630.jpg",
    },
    summary:
      "<p><b>The Playboy Club</b> is a provocative drama about a time and place that challenged the social mores, where a visionary entrepreneur created an empire and an icon changed American culture. It's the early '60s, and the legendary Playboy Club in Chicago is the door to all of your fantasies -- and the key is the most sought-after status symbol of its kind. Inside the seductive world of the bunny, the epitome of beauty and service, the clientele rubs shoulders with the decade's biggest mobsters, politicos and entertainers.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-19",
  },
  {
    id: 1014,
    url: "https://www.tvmaze.com/shows/1014/the-pillars-of-the-earth",
    name: "The Pillars of the Earth",
    genres: ["Drama", "Romance", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16638.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16638.jpg",
    },
    summary:
      "<p><b>The Pillars of the Earth</b> is a sweeping epic of good and evil, treachery and intrigue, violence and beauty. This sensuous, spirited and passionate story is set against a backdrop of war, religious strife and power struggles which tears lives and families apart. In that time, there rises a magnificent Cathedral in Kingsbridge.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 17,
      name: "Starz",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-07-23",
  },
  {
    id: 1015,
    url: "https://www.tvmaze.com/shows/1015/newport-harbor-the-real-orange-county",
    name: "Newport Harbor: The Real Orange County",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16654.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16654.jpg",
    },
    summary:
      "<p>Chrissy, Clay, Allie, Grant, Chase, Taylor and Sasha are heading home for the holidays. It's Chrissy's first trip back to Newport since leaving for college and deciding to make her long-distance relationship with Clay work. But did the absence make their hearts grow fonder or was this first love easy to forget? Chase has moved on from his unpredictable relationship with Taylor, and jumped head first into a new romance with Kylie, Chrissy's sorority sister. And back from Europe, Allie is trying to make her way in the big city of Los Angeles. Will she be able to leave the pampered life of Newport behind and forge a new independence? New loves, lost loves, life-changing decisions and a group of friends that will try to stay together forever. Newport Harbor: you can always come home.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-09-28",
  },
  {
    id: 1016,
    url: "https://www.tvmaze.com/shows/1016/fear-itself",
    name: "Fear Itself",
    genres: ["Drama", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16655.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16655.jpg",
    },
    summary:
      "<p><b>Fear Itself</b> is a provocative suspense and horror anthology series pushing the boundaries of this classic genre through a host of provocative talent, both in front of and behind the camera.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-06-05",
  },
  {
    id: 1017,
    url: "https://www.tvmaze.com/shows/1017/halo-4-forward-unto-dawn",
    name: "Halo 4: Forward Unto Dawn",
    genres: ["Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16656.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16656.jpg",
    },
    summary:
      "<p>In this long awaited epic series, Halo fans will be taken back to the infamous beginning of the Human/Covenant war, when the Master Chief inspired a young cadet who would eventually become the commander of the UNSC's greatest vessel ever: the UNSC Infinity.</p>",
    officialSite: null,
    webChannel: {
      id: 8,
      name: "Machinima.com",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2012-10-05",
  },
  {
    id: 1018,
    url: "https://www.tvmaze.com/shows/1018/legend-of-earthsea",
    name: "Legend of Earthsea",
    genres: ["Drama", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16659.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16659.jpg",
    },
    summary:
      "<p>A reckless youth is destined to become the greatest sorcerer that the mystical land of Earthsea has ever known. When the young wizard Ged discovers that he possesses infinite magical powers, he seeks to master the ancient arts. As he journeys to manhood, he will combat dragons, fall in love, cross death's threshold, and ultimately wield the power to reunite a kingdom.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-12-13",
  },
  {
    id: 1019,
    url: "https://www.tvmaze.com/shows/1019/the-inside",
    name: "The Inside",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16663.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16663.jpg",
    },
    summary:
      "<p>When one of the profilers in the FBI's L.A.-based Violent Crimes Unit (VCU) is brutally murdered by a serial killer they've been tracking, rookie FBI Agent Rebecca Locke is recruited to join the team and help find the madman despite her lack of field experience. Unbeknownst to Rebecca, famed Supervisory Special Agent VIRGIL \"WEB\" WEBSTER has personally selected her to join his rogue division - not for her impressive profiling skills, but because of a secret she's keeping. Web knows that Rebecca was abducted and held captive as a child, and the traumatic experience has afforded her unique insight into the mindset of villain and victim alike.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-06-08",
  },
  {
    id: 1020,
    url: "https://www.tvmaze.com/shows/1020/criminal-minds-suspect-behavior",
    name: "Criminal Minds: Suspect Behavior",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16670.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16670.jpg",
    },
    summary:
      "<p><b>Criminal Minds: Suspect Behavior</b> is a drama about an elite team of agents within the FBI's Behavioral Analysis Unit (BAU) who use unconventional methods of investigation and aggressive tactics to capture the nation's most nefarious criminals. Unit chief Special Agent Sam Cooper is a mentally and physically fierce natural leader who is not afraid to put his career on the line in order to stand by his convictions. Cooper strives to avoid political bureaucracy and has handpicked an eclectic group of profilers to work outside the confines of Quantico. They include strong-willed and outspoken Beth Griffith, the newest member of the team who joins them from the FBI Threat Assessment Task Force; former British Special Forces soldier Mick Rawson, who is confident and handsome and works as a highly skilled marksman with an undiluted eye for rooting out evil; John \"Prophet\" Sims, a former convict with a street-smart edge and a calm, Zen-like presence who is determined to make amends for past sins; Gina LaSalle, an attractive, tough agent armed with a cunning sense of perception; and Penelope Garcia, a computer wizard who has spent years aiding Agent Hotchner and his BAU team on its toughest cases. This exceptional group of FBI operatives is strong in their beliefs and steadfast in their mission to bring the country's most dangerous criminals to justice.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-02-16",
  },
  {
    id: 1021,
    url: "https://www.tvmaze.com/shows/1021/cult",
    name: "Cult",
    genres: ["Drama", "Thriller", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16676.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16676.jpg",
    },
    summary:
      "<p>Investigative journalist Jeff Sefton has learned to laugh off his younger brother Nate's relentless string of obsessions, especially his latest rant that a hit TV show intends to harm him. However, when his brother mysteriously disappears, Jeff takes Nate's paranoia seriously, and in the process uncovers the dark underworld of the TV series <b>Cult</b> and its rabid fans, who are obsessed with the show's charismatic cult leader, Billy Grimm. As the show's gruesome plot twists begin to play out in the real world, Jeff enlists the help of a young research assistant, Skye, in a race to save Nate and unravel the mystery behind the TV series whose hardcore fans would literally kill to see what happens next...</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-02-19",
  },
  {
    id: 1022,
    url: "https://www.tvmaze.com/shows/1022/dr-horribles-sing-along-blog",
    name: "Dr. Horrible's Sing-Along Blog",
    genres: ["Comedy", "Music", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16681.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16681.jpg",
    },
    summary:
      "<p>Neil Patrick Harris stars as Billy, A.K.A. Dr. Horrible, a budding super-villain whose plans for world domination continually go awry. His two goals: getting accepted into the Evil League of Evil, and working up the guts to speak to his laundromat crush Penny, played by Felicia Day. The only thing standing in his way is Captain Hammer, Billy's superhero arch-nemesis played by Nathan Fillion With one big score, Billy could get into the E.L.E. and earn the respect of Penny, but only if he can keep her away from the dashing Captain Hammer...</p>",
    officialSite: null,
    webChannel: {
      id: 2,
      name: "Hulu",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2008-07-15",
  },
  {
    id: 1023,
    url: "https://www.tvmaze.com/shows/1023/the-glee-project",
    name: "The Glee Project",
    genres: ["Drama", "Family", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16685.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16685.jpg",
    },
    summary:
      '<p>During the 11 week run of season two of <b>The Glee Project</b>, 14 talented contenders will be narrowed down as the creative forces of "Glee" carefully assess who has what it takes to win the prize of a lifetime - a seven episode guest starring role on the hit FOX series. Ryan Murphy joins casting director Robert Ulrich, choreographer, "Glee" co-producer Zach Woodlee and vocal producer Nikki Anders in the final deliberations of each installment of the series.</p>',
    officialSite: "http://www.oxygen.com/the-glee-project",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 79,
      name: "Oxygen",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-06-12",
  },
  {
    id: 1024,
    url: "https://www.tvmaze.com/shows/1024/alice",
    name: "Alice",
    genres: ["Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16686.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16686.jpg",
    },
    summary:
      "<p>Abandoned by her father as a child, <b>Alice</b> is accustomed to men being unpredictable, but Jack Chase is on a completely different level. Just moments after surprising her with a rare family ring, he's suddenly kidnapped by two thugs and expelled into the ether. Alice is then confronted by a sharply dressed stranger who answers to the name White Rabbit, and who promises to reveal all of Jack's secrets. Alice follows him through the enormous liquid glass of an ornate mirror and ends up in Wonderland, an outlandish underground city of twisted towers and parapets conceived of in a Dali-like dream.</p>",
    officialSite: "http://www.syfy.com/alice",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-12-06",
  },
  {
    id: 1025,
    url: "https://www.tvmaze.com/shows/1025/lights-out",
    name: "Lights Out",
    genres: ["Drama", "Crime", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16691.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16691.jpg",
    },
    summary:
      "<p>Patrick 'Lights' Leary is an aging former heavyweight boxing champion who struggles to find his identity and support his wife and three daughters after retiring from the ring. The financial downturn coupled with a series of failed investments leave him at a perilous crossroads - battling the urge to return to boxing or reluctantly accepting a job as a brutal and intimidating debt collector.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-01-11",
  },
  {
    id: 1026,
    url: "https://www.tvmaze.com/shows/1026/the-city",
    name: "The City",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/114/286118.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/114/286118.jpg",
    },
    summary:
      "<p>In its second season, new betrayals and new alliances add up to 12 all-new, jaw-dropping episodes as Whitney Port, Roxy Olin, Olivia Palermo and Erin Kaplan continue to traverse the New York City fashion industry and their relationships with each other. During the first season, fans were captivated as Whitney transformed her life by leaving Los Angeles behind for New York where she risked everything to start her own clothing line. When the show returns, Whitney and the rest of the cast will learn the hard way that in New York City climbing your way to the top means doing it alongside both friends and enemies.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-12-29",
  },
  {
    id: 1027,
    url: "https://www.tvmaze.com/shows/1027/angel-o-demonio",
    name: "Angel o Demonio",
    genres: ["Drama", "Fantasy", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16698.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16698.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "Spanish",
    status: "Ended",
    network: {
      id: 96,
      name: "Telecinco",
      country: { name: "Spain", code: "ES", timezone: "Europe/Madrid" },
    },
    premiered: "2011-02-01",
  },
  {
    id: 1028,
    url: "https://www.tvmaze.com/shows/1028/audrina",
    name: "Audrina",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16699.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16699.jpg",
    },
    summary:
      "<p>Besides Audrina's blossoming career and tumultuous love life, the television personality has something else to focus on - her family. VH1's <b>Audrina</b> will introduce the world to a never-before-seen side of Audrina - her large, outrageous, Orange County family. As she advances her acting, modeling and business career, she is juggling a prominent role in her large, tight-knit family. With her tell-it-like-it-is mom, Lynn, and chilled-out dad, Mark, at the center of this crazy bunch, Audrina is still expected to have an active presence in the lives of her three younger siblings: former wild child Casey, now married to motocross star Kyle Loza and mother of two; genial younger brother Marky, who aspires to pro motocross himself and has an annoying habit of befriending Audrina's exes; and 15-year-old sister Samantha, who is already exhibiting a rebellious streak that could put Casey and Audrina's to shame. Work-focused and family-oriented, yet still sexy and dynamic, Audrina shows a personal side of herself on VH1 that is funny, relatable and endearing to anyone who's ever had to balance the expectations of family and friends against their own hopes and dreams. From her #1 debuting album Kaleidoscope Heart, Sara Bareilles' anthemic song \"Uncharted\" is the theme music for VH1's Audrina. Other songs from \"Kaleidoscope Heart\" will also be used throughout the series as featured placements.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 55,
      name: "VH1",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-04-17",
  },
  {
    id: 1029,
    url: "https://www.tvmaze.com/shows/1029/punta-escarlata",
    name: "Punta Escarlata",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16700.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16700.jpg",
    },
    summary:
      "<p>Misterio, suspense y elementos característicos del thriller se suceden en esta serie que plantea en nueve episodios la resolución de un oscuro caso en un lugar lleno de secretos, vicios inconfesables y conflictos que han prevalecido a lo largo de los años. Al llegar a Punta Escarlata,Bosco (Carles Francino) y Max (Antonio Hortelano) se encuentran con serias dificultades para esclarecer lo sucedido, pese a la ayuda del sargento Reyes (Fernando Cayo), que dirigió la investigación en el pasado. Los habitantes del pueblo son reacios a remover el pasado y prefieren ocultar lo que saben, vieron o escucharon. Pronto descubren que nada es lo que parece. Además, a medida que avanzan en la investigación se suceden una serie de nuevos e inquietantes asesinatos que podrían estar relacionados con los ocurridos ocho años atrás en su intento por desenmascarar a los culpables.</p>",
    officialSite: null,
    webChannel: null,
    language: "Spanish",
    status: "Ended",
    network: {
      id: 96,
      name: "Telecinco",
      country: { name: "Spain", code: "ES", timezone: "Europe/Madrid" },
    },
    premiered: "2011-07-25",
  },
  {
    id: 1030,
    url: "https://www.tvmaze.com/shows/1030/acusados",
    name: "Acusados",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16701.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16701.jpg",
    },
    summary:
      '<p>El incendio de la discoteca Metrópolis será el punto de partida de la investigación llevada por la jueza Rosa Ballester (Blanca Portillo). Su principal sospechoso, Joaquín de la Torre (José Coronado), un importante político del país, se verá involucrado en una trama de misterios, sospechas y secretos, que le llevarán al desplome de su reputación frente a su partido político. Junto a su hijo Alejandro de la Torre (Alberto Amarilla) y su abogado Ricardo Díaz (Aitor Mazo), intentarán salir del caso, pero la jueza Ballester y su equipo, formado por Jorge Vega (Daniel Grao), Julio Almagro (Joseba Apaolaza) e Isabel Holgado (Isabel Serrano), no perderán ni un minuto en demostrar la culpabilidad del político en el caso Metrópolis, descubriendo que el suceso no gira en torno a un "simple" incendio, sino a ocultar en él el asesinato de una chica, Ana Sánchez (Andrea Guasch). Tendrán que enfrentarse a la novia de Jorge, Laura (Silvia Abascal) y a la hermana de ésta, la periodista Sonia Nieto (Anna Allen), sin saber que todo el asunto salpicará al círculo familiar de la jueza. Sus hijas Marina (Natalia Sánchez) y Patricia Domenech (Carla Nieto) serán la pieza clave que permita la resolución del caso.</p>',
    officialSite: null,
    webChannel: null,
    language: "Spanish",
    status: "Ended",
    network: {
      id: 96,
      name: "Telecinco",
      country: { name: "Spain", code: "ES", timezone: "Europe/Madrid" },
    },
    premiered: "2009-01-28",
  },
  {
    id: 1031,
    url: "https://www.tvmaze.com/shows/1031/el-internado",
    name: "El Internado",
    genres: ["Drama", "Thriller", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16703.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16703.jpg",
    },
    summary:
      "<p><b>El Internado</b> was a Spanish television drama thriller focusing on the students of a fictional boarding school in a forest, where teenagers are sent by their parents to study. The boarding school is situated in a forest far from the city, on the outskirts on which macabre events occur.</p>",
    officialSite: "https://www.antena3.com/series/el-internado/",
    webChannel: null,
    language: "Spanish",
    status: "Ended",
    network: {
      id: 97,
      name: "Antena 3",
      country: { name: "Spain", code: "ES", timezone: "Europe/Madrid" },
    },
    premiered: "2007-05-24",
  },
  {
    id: 1032,
    url: "https://www.tvmaze.com/shows/1032/motivos-personales",
    name: "Motivos Personales",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16704.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16704.jpg",
    },
    summary:
      "<p>La historia comienza en la fiesta de conmemoración del 50º aniversario de los Laboratorios Acosta. Todo parece ir bien hasta que aparece muerta la secretaria del presidente de los laboratorios, estampada contra un techo de cristal dentro del edificio, Mara Yimou. Los indicios en principio indican que el culpable es el marido de la periodista Natalia Nadal, Arturo Acosta. En el juicio es declarado culpable y encerrado en prisión. Natalia descubre gracias a un video, que el juicio se basó en pruebas falsas y va a comunicárselo a su marido a la cárcel. Allí le dan una noticia: su marido se ha suicidado. A partir de este momento, Natalia empieza a investigar junto a su amiga Virginia, la abogada de los laboratorios, y juntas se ven envueltas en una complicada red de secretos y crímenes. Las causas de las muertes se remontan muchos años atrás y son fruto de una fría venganza contra Natalia.</p>",
    officialSite: null,
    webChannel: null,
    language: "Spanish",
    status: "Ended",
    network: {
      id: 96,
      name: "Telecinco",
      country: { name: "Spain", code: "ES", timezone: "Europe/Madrid" },
    },
    premiered: "2005-02-01",
  },
  {
    id: 1033,
    url: "https://www.tvmaze.com/shows/1033/hay-alguien-ahi",
    name: "Hay alguien ahí",
    genres: ["Thriller", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16706.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16706.jpg",
    },
    summary:
      "<p>Mientras Diego Pardo, el cabeza de familia, cierra el acuerdo en la inmobiliaria para mudarse con los suyos a la casa de sus sueños. Los obreros se encargan de los últimos retoques en la reforma de la vivienda. Es entonces cuando sucede algo inesperado y, desde el interior del pozo que hay en el sótano, una fuerza sobrenatural se cobra su primera víctima...<br><br> Ajenos a lo sucedido, la familia hace la mudanza con todas sus esperanzas puestas en una vida mejor y sobre todo más tranquila. Sin embargo, las presencias que habitan en la casa no tardan en manifestarse. Con la intención de contactar con ellas, Íñigo se las ingenia para quedarse solo en casa y organizar una sesión de espiritismo con su novia Silvia y sus amigos. Algo que jamás habría hecho si hubiera sospechado las terribles consecuencias... Y es que hay puertas que nunca se deben abrir.</p>",
    officialSite: null,
    webChannel: null,
    language: "Spanish",
    status: "Ended",
    network: {
      id: 98,
      name: "Cuatro",
      country: { name: "Spain", code: "ES", timezone: "Europe/Madrid" },
    },
    premiered: "2009-03-16",
  },
  {
    id: 1034,
    url: "https://www.tvmaze.com/shows/1034/sorority-sisters",
    name: "Sorority Sisters",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16714.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16714.jpg",
    },
    summary:
      "<p>Nine women, who continue to honor the traditions and legacies of their respective sororities and chapters, all agree on one main principle: sisterhood doesn't end after graduation, it's for life. For these friends and sisters (or 'sorors') from celebrated historically black colleges and universities in Atlanta, strong ties to their organizations lead to fierce rivalries, but through thick and thin, these women stand united and share an unbreakable bond. \"Sorority Sisters\" follows the lives of women from four different sororities. Since these 'sorors' are pledges for life, they are expected to continue their community work long after graduation. From long-awaited reunions, to managing the men in their lives, for these line sisters, it's homecoming all across the ATL. These ladies have a lot at stake - their aspirations, reputations, livelihoods, friendships, and families - and the legacies of their sororities.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 55,
      name: "VH1",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-12-15",
  },
  {
    id: 1035,
    url: "https://www.tvmaze.com/shows/1035/life",
    name: "Life",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16786.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16786.jpg",
    },
    summary:
      "<p>After spending twelve years in prison for a crime he didn't commit, Charlie Crews rejoins the force with a shiny new Detective badge. Crews, accompanied by his new partner Dani Reese, works to solve the inexplicable murder of a young boy. Crews' unconventional tactics put Reese on edge causing both Reese and Lt. Karen Davis to question his motives for rejoining the force.</p><p><br></p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-09-26",
  },
  {
    id: 1036,
    url: "https://www.tvmaze.com/shows/1036/robin-hood",
    name: "Robin Hood",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16798.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16798.jpg",
    },
    summary:
      "<p>Drama series which gives a contemporary feel to the classic Robin Hood legend, focusing on Robin Hood's fight against the evil and corrupt Sheriff of Nottingham.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006m8g7",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-10-07",
  },
  {
    id: 1037,
    url: "https://www.tvmaze.com/shows/1037/sons-of-guns",
    name: "Sons of Guns",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16816.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16816.jpg",
    },
    summary:
      "<p>Will Hayden is an American success story. Having turned his Louisiana-based small business, Red Jacket Firearms, into a regional powerhouse, he's ready for the next step for himself and his family. Like so many American small businesses, Will's journey from garage based gun shop to the pride of Baton Rouge is rife with personal sacrifices and some risky decisions.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-01-26",
  },
  {
    id: 1038,
    url: "https://www.tvmaze.com/shows/1038/zoey-101",
    name: "Zoey 101",
    genres: ["Drama", "Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16819.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16819.jpg",
    },
    summary:
      "<p>Pacific Coast Academy, an all boys boarding school is accepting female students for the first time since the school was established. Zoey's little brother Dustin is currently a student there. Zoey decides to be one of the first girls to become a student at PCA. This is very exciting, but also very scary; fitting in at a new school is hard enough, but going away to boarding school and living on your own at age 13 can get crazy! Especially when the girls are heavily outnumbered by the boys...</p>",
    officialSite: "http://www.nick.com/zoey-101/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-01-09",
  },
  {
    id: 1039,
    url: "https://www.tvmaze.com/shows/1039/v",
    name: "V",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16843.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16843.jpg",
    },
    summary:
      "<p>A year after Liberation Day, courtesy of the red-dust bacteria, the humanoid, lizard-like aliens develop a resistance to the micro-organism and try to regain control of the Earth--only now some humans are knowingly working with them.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1983-05-01",
  },
  {
    id: 1040,
    url: "https://www.tvmaze.com/shows/1040/the-young-indiana-jones-chronicles",
    name: "The Young Indiana Jones Chronicles",
    genres: ["Action", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16904.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16904.jpg",
    },
    summary:
      "<p><b>The Young Indiana Jones Chronicles</b> was based on the Indiana Jones series of films. The series follows the Indiana Jones character (as a young boy and as a young man) as he was growing up and experiencing his early adventures, where he gets into trouble, learns life lessons and encounters various historical figures along the way. <i>The Young Indiana Jones Chronicles</i> was filmed on location all over the world ~ including England, Russia, Spain, Czechoslovakia, Kenya, France, India, China, Austria, Egypt, the United States, Morocco, Ireland, Italy, Africa, Turkey, Greece and Thailand.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1992-03-04",
  },
  {
    id: 1041,
    url: "https://www.tvmaze.com/shows/1041/world-without-end",
    name: "World Without End",
    genres: ["Drama", "Romance", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16908.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16908.jpg",
    },
    summary:
      "<p>A paid assassin is sent to murder a king. A mysterious knight flees to the countryside, hotly pursued by the Queen's men. Two teenagers witness an incident in the woods that will change the course of a nation. Ken Follett's worldwide bestseller, <b>World Without End</b>, comes to life as a monumental eight-hour event series.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 6,
      name: "Showcase",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2012-09-04",
  },
  {
    id: 1042,
    url: "https://www.tvmaze.com/shows/1042/wonderfalls",
    name: "Wonderfalls",
    genres: ["Drama", "Comedy", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16927.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16927.jpg",
    },
    summary:
      "<p>From the producer of Angel and Firefly comes <b>Wonderfalls</b>. Although a recent graduate of Brown University, Jaye Tyler decides to ignore her degree, live in a trailer and work at a tourist gift shop in Niagara Falls called Wonderfalls—-much to the despair of her well-to-do family. But Jaye's aimless life takes a startling turn after a lion figurine begins talking to her. Her family calls it an \"episode,\" but Jaye knows better.</p><p>Fearing for her sanity, Jaye nevertheless starts doing exactly what an increasing number of inanimate objects tell her to do and is amazed when her outrageous actions begin changing people's lives in unexpected ways.</p>",
    officialSite: "http://savewonderfalls.com/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 827,
      name: "VisionTV",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2004-10-04",
  },
  {
    id: 1043,
    url: "https://www.tvmaze.com/shows/1043/the-white-queen",
    name: "The White Queen",
    genres: ["Drama", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16935.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16935.jpg",
    },
    summary:
      "<p><b>The White Queen</b> is a riveting portrayal of one of the most dramatic and turbulent times in English history. A story of love and lust, seduction and deception, betrayal and murder, it is uniquely told through the perspective of three different, yet equally relentless women - Elizabeth Woodville, Margaret Beaufort and Anne Neville. In their quest for power, they will scheme, manipulate and seduce their way onto the English throne.<br><br> The year is 1464, before the Tudor dynasty ruled the country, and war has been ravaging throughout England over who is the rightful King. It is a bitter dispute between two sides of the same family, The House of York and The House of Lancaster.<br><br> The House of York's young and handsome Edward IV is crowned King of England with the help of the master manipulator, Lord Warwick \"The Kingmaker.\" But when Edward falls in love with a beautiful Lancastrian commoner, Elizabeth Woodville, Warwick's plan to control the throne comes crashing down.<br><br> A violent, high-stakes struggle ensues between Elizabeth, her most fierce adversary, Lancastrian Margaret Beaufort, and Anne Neville, the pawn in her father's power game - each woman vying for the crown.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p018sxqp",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-06-16",
  },
  {
    id: 1044,
    url: "https://www.tvmaze.com/shows/1044/whitechapel",
    name: "Whitechapel",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16936.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16936.jpg",
    },
    summary:
      "<p>Set against the contrasting facades of Whitechapel, London, a series of bloody, tragic and impossible crimes are carried out.</p><p>A fast-tracked inspector, a hardened detective sergeant, and an expert in historical homicides investigate modern crimes with connections to the past in the Whitechapel district of London.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-02-02",
  },
  {
    id: 1045,
    url: "https://www.tvmaze.com/shows/1045/viper",
    name: "Viper",
    genres: ["Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16940.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16940.jpg",
    },
    summary:
      '<p>Viper was an action-adventure TV series about a secretive task force set up by the federal government to fight crime in the fictional city of Metro City, California, that is perpetually under siege from one crime wave after another. The weapon used by this task force is an urban assault vehicle that is disguised as a 1993 Flame Red Dodge Viper RT/10 Roadster and, later, a 1998 Cobalt Blue Metallic Dodge Viper GTS Coupe (which replaced the Roadster convertible). The series takes place in "the near future". The primary brand of vehicles driven in the show were Chrysler or their subsidiary companies.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1994-01-02",
  },
  {
    id: 1046,
    url: "https://www.tvmaze.com/shows/1046/verano-azul",
    name: "Verano Azul",
    genres: ["Drama", "Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16942.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16942.jpg",
    },
    summary:
      "This series is about the adventures of a bunch of youngsters during their Summer holiday in a small town in the Southern Coast of Spain. The seven kids: Quique, Javi, Pancho, Bea, Desi, Tito and Piraña, within an age range of eight to sixteen, meet there two adults, with whom they share many new experiences, Julia, a painter, and Chanquete, an old, wise and lovable retired sailor who lives in a boat set on a hilltop. Throughout the 19 episodes several key themes are dealt with: teenage, coming of age, death, generational gap, the right to protest, ethical values, family relations, building companies' speculation in the Spanish coastline etc.",
    officialSite: null,
    webChannel: null,
    language: "Spanish",
    status: "Ended",
    network: {
      id: 99,
      name: "TVE",
      country: { name: "Spain", code: "ES", timezone: "Europe/Madrid" },
    },
    premiered: "1981-10-11",
  },
  {
    id: 1047,
    url: "https://www.tvmaze.com/shows/1047/upstairs-downstairs",
    name: "Upstairs Downstairs",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16943.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16943.jpg",
    },
    summary:
      "<p>Revival of the iconic '70s series. Life in a London townhouse in the late 1930s, where the fates of the servants 'downstairs' and their masters 'upstairs' are intimately linked.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p00njdvp",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-12-26",
  },
  {
    id: 1048,
    url: "https://www.tvmaze.com/shows/1048/ultimate-survival-alaska",
    name: "Ultimate Survival Alaska",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16949.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16949.jpg",
    },
    summary:
      "<p>One of the toughest competitions in the world is back for round three as 12 of the world's toughest outdoorsmen face off against each other, Mother Nature, and their own will to survive. This fight to the finish isn't about money or a prize; it's about pushing the limits of human endurance. It's a dangerous test of strength and determination. And in the end, only one team will be crowned the winner. Four teams—<b>Military</b>, <b>Endurance</b>, <b>Alaskans</b>, and this season's new team, <b>Lower 48</b>—face peaks, deadly tidal waves, massive glaciers, bottomless crevasses, man-eating predators and treacherous white water. In each of the 13 legs this season, teams have just 60 hours to make it from start to finish … surviving off the land with only the gear on their backs. No GPS. No phones. No mercy.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-05-12",
  },
  {
    id: 1049,
    url: "https://www.tvmaze.com/shows/1049/trophy-wife",
    name: "Trophy Wife",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16950.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16950.jpg",
    },
    summary:
      "<p>They say the third time's the charm, and reformed party girl Kate is hoping that's true when she becomes Pete's third wife. She fell into his arms (literally) at a karaoke bar, and a year later Kate's got an insta-family, complete with three stepchildren and two ex-wives. Diane is ex-wife number one, an intense, over-achieving doctor and the mother of twin teenagers Hillary and Warren. Diane is quick to convey her withering disapproval of Kate's barely tapped maternal instinct. Ex-wife number two, Jackie, is mother to adopted son Bert, and can pull Pete's strings with her special blend of neurotic, new-ageyness. Juggling all this baggage is uncharted territory for Kate, who finds support with her best friend Meg, a party-hearty singleton and the only woman Kate knows who has less experience with kids than she has.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-24",
  },
  {
    id: 1050,
    url: "https://www.tvmaze.com/shows/1050/top-of-the-lake",
    name: "Top of the Lake",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16957.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16957.jpg",
    },
    summary:
      "<p>A woman haunted by her past, Detective Robin Griffin, investigates complex and unsettling cases in Jane Campion's mystery drama.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p057mh5s",
    webChannel: {
      id: 26,
      name: "BBC iPlayer",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2013-03-18",
  },
  {
    id: 1051,
    url: "https://www.tvmaze.com/shows/1051/the-10th-kingdom",
    name: "The 10th Kingdom",
    genres: ["Drama", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16966.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16966.jpg",
    },
    summary:
      "<p>Mixing the universal themes of European folklore and mythology with a healthy dose of contemporary storytelling results in this fantastic fable in which two worlds come together for one fantastic adventure.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-02-27",
  },
  {
    id: 1052,
    url: "https://www.tvmaze.com/shows/1052/21-jump-street",
    name: "21 Jump Street",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16974.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16974.jpg",
    },
    summary:
      "<p>A group of young cops are used for their youthful appearance in order to go undercover at high schools. These young officers solve crimes involving teenagers and young adults, most often involving drugs, but also issues such as alcoholism, hate crimes, drug abuse, homophobia, AIDS, child abuse, and sexual promiscuity.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1987-04-12",
  },
  {
    id: 1053,
    url: "https://www.tvmaze.com/shows/1053/3rd-rock-from-the-sun",
    name: "3rd Rock from the Sun",
    genres: ["Comedy", "Family", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16980.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16980.jpg",
    },
    summary:
      "<p>Sent to Earth to investigate civilization, an alien high commander and his quirky crew -- military officer Sally, information expert Tommy and transmitter Harry -- assume human identities to blend in. Although they possess superior intelligence, their naïveté about the human condition turns everyday events into farcical fun.</p>",
    officialSite: "http://www.3rdrock.com",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-01-09",
  },
  {
    id: 1054,
    url: "https://www.tvmaze.com/shows/1054/absolutely-fabulous",
    name: "Absolutely Fabulous",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16989.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16989.jpg",
    },
    summary:
      "<p>Award-winning comedy set in the world of fashion and PR with Jennifer Saunders as the immature fun-loving mother and Julia Sawalha as her sensible daughter.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00jm3ms",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1992-11-12",
  },
  {
    id: 1055,
    url: "https://www.tvmaze.com/shows/1055/the-adventures-of-tintin",
    name: "The Adventures of Tintin",
    genres: ["Adventure", "Children", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/16996.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/16996.jpg",
    },
    summary:
      "<p>This animated series tells of the adventures of boy reporter Tintin, his dog, Snowy, and their friend Captain Haddock. From the stories by Herge.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 100,
      name: "Family Channel",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "1992-10-18",
  },
  {
    id: 1056,
    url: "https://www.tvmaze.com/shows/1056/allo-allo",
    name: "'Allo 'Allo!",
    genres: ["Comedy", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/62/156789.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/62/156789.jpg",
    },
    summary:
      "<p>In this spoof of World War II, René Artois runs a café in German-occupied France. He always seems to have his hands full: He's having affairs with most of his waitresses, he's keeping his wife happy, he's trying to please the German soldiers who frequent his café, and he's running a major underground operation for the Resistance.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006xyt3",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1982-12-30",
  },
  {
    id: 1057,
    url: "https://www.tvmaze.com/shows/1057/the-assets",
    name: "The Assets",
    genres: ["Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17012.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17012.jpg",
    },
    summary:
      "<p><b>The Assets</b> is an eight-part limited series based on the real life events of CIA counter-intelligence officer Sandy Grimes. The year 1985 serves as the backdrop to the final showdown of the Cold War when Sandy and her partner Jeanne Vertefeuille vowed to find the mole who would turn out to be the most notorious traitor in US History, Aldrich Ames. Sandy is in a race against time to save the Soviet intelligence officers from being caught and killed. Living her own double life at home, this beautiful wife and mother vowed to stop at nothing until she uncovered the truth.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-02",
  },
  {
    id: 1058,
    url: "https://www.tvmaze.com/shows/1058/the-a-team",
    name: "The A-Team",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17013.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17013.jpg",
    },
    summary:
      "<p><b>The A-Team</b> is an American action-adventure television series, running from 1983 to 1987, about a fictional group of ex–United States Army Special Forces.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1983-01-23",
  },
  {
    id: 1059,
    url: "https://www.tvmaze.com/shows/1059/battlestar-galactica",
    name: "Battlestar Galactica",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17017.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17017.jpg",
    },
    summary:
      '<p>When the 12 Colonies of Man are wiped out by a cybernetic race called the Cylons, Commander Adama (Lorne Greene) and the crew of the battlestar Galactica lead a ragtag fleet of human survivors in search of a "mythical planet" called Earth.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1978-09-17",
  },
  {
    id: 1060,
    url: "https://www.tvmaze.com/shows/1060/titanic",
    name: "Titanic",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17029.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17029.jpg",
    },
    summary:
      "<p><b>Titanic </b>is a four part serial created by BAFTA-winning producer Nigel Stafford-Clark and written by Oscar and Emmy winner Julian Fellowes to mark the hundredth anniversary of the world's most famous maritime disaster in April 1912. It sets out to tell the story not just of a single ship, but of an entire society--one that was heading towards its own nemesis in the shape of the First World War as carelessly as <i>Titanic </i>towards the iceberg.</p>",
    officialSite: "http://titanic.globaltv.com/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-03-25",
  },
  {
    id: 1061,
    url: "https://www.tvmaze.com/shows/1061/terriers",
    name: "Terriers",
    genres: ["Drama", "Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/167/419117.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/167/419117.jpg",
    },
    summary:
      '<p><b>Terriers</b>, from creator/executive producer Ted Griffin and executive producer Shawn Ryan is a comedic drama starring Donal Logue and Michael Raymond-James. It centers on "Hank Dolworth" , an ex-cop who partners with his best friend "Britt Pollack" to launch an unlicensed private investigation business. The duo, both struggling with maturity issues, solve crimes while avoiding danger and responsibility.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-08",
  },
  {
    id: 1062,
    url: "https://www.tvmaze.com/shows/1062/survivors",
    name: "Survivors",
    genres: ["Drama", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17037.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17037.jpg",
    },
    summary:
      "<p>When a deadly virus wipes out most of the world's population, a handful of survivors struggle to stay alive.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-11-23",
  },
  {
    id: 1063,
    url: "https://www.tvmaze.com/shows/1063/studio-60-on-the-sunset-strip",
    name: "Studio 60 on the Sunset Strip",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17045.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17045.jpg",
    },
    summary:
      "<p>The executive producer of a late night sketch comedy show sparks a media frenzy when he has an on-air meltdown during a live broadcast. The newly minted network president has to scramble to make things right by hiring back two former prized employees to become the new executive producers of her network's flagship program.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-09-18",
  },
  {
    id: 1064,
    url: "https://www.tvmaze.com/shows/1064/the-state-within",
    name: "The State Within",
    genres: ["Drama", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17054.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17054.jpg",
    },
    summary:
      "<p>Nothing is what it first appears...</p><p>Sir Mark Brydon is the British Ambassador to Washington, who finds himself at the centre of a terrifying conspiracy that could bring down Western Government.</p><p>As Mark the Ambassador fights to prevent a looming war, Mark the man is faced with a terrible dilemma. In a world of high stakes where manipulation of information means ultimate power – who can Brydon trust? As Mark slowly realises that he's being played by an invisible puppeteer, he cannot even begin to imagine where the conspiracy ends.</p><p>At what point do you sacrifice the truth for the sake of your nation? At what point do you sacrifice your nation for the truth?</p>",
    officialSite: "http://www.bbc.co.uk/drama/thestatewithin/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-11-02",
  },
  {
    id: 1065,
    url: "https://www.tvmaze.com/shows/1065/spaced",
    name: "Spaced",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17057.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17057.jpg",
    },
    summary:
      "<p>Surreal cult sitcom starring Simon Pegg and Jessica Stevenson, with more pop culture references than you can shake a light sabre at.</p>",
    officialSite: "http://www.channel4.com/programmes/spaced",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1999-09-24",
  },
  {
    id: 1066,
    url: "https://www.tvmaze.com/shows/1066/south-riding",
    name: "South Riding",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17061.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17061.jpg",
    },
    summary:
      "<p>The lives and loves of a 1930s Yorkshire town explored in a passionate tale of politics in small places, written by Andrew Davies, starring David Morrissey and Anna Maxwell Martin.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00y5gm3",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-02-20",
  },
  {
    id: 1067,
    url: "https://www.tvmaze.com/shows/1067/south-of-nowhere",
    name: "South of Nowhere",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17063.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17063.jpg",
    },
    summary:
      "<p><b>South of Nowhere</b> is about a group of teens in Los Angeles trying to bridge the gap between who they are and who they want to be.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 101,
      name: "TeenNick",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-11-04",
  },
  {
    id: 1068,
    url: "https://www.tvmaze.com/shows/1068/six-degrees",
    name: "Six Degrees",
    genres: ["Drama", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/158/397090.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/158/397090.jpg",
    },
    summary:
      "<p>They say that anyone on the planet can be connected to any other person through a chain of six people, which means that no one is a stranger for long. In this new drama from the producers of Lost and Alias, six very different New Yorkers go about their lives without realizing the impact they're having on one another, but a mysterious web of coincidences gradually draws them closer, changing the course of their lives forever, on <b>Six Degrees</b>, a new ensemble drama about the possibilities of a greater force at work guiding everyone together and connecting the lives of us all.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-09-21",
  },
  {
    id: 1069,
    url: "https://www.tvmaze.com/shows/1069/samantha-who",
    name: "Samantha Who?",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/52/130610.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/52/130610.jpg",
    },
    summary:
      '<p>Samantha "Sam" Newly is a corporate executive and hit-and-run victim who awakens after being in a coma for eight days, only to find she has amnesia. With no memories of the past, she must rediscover everything about her life and herself by looking for clues from her past.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-10-15",
  },
  {
    id: 1070,
    url: "https://www.tvmaze.com/shows/1070/baywatch",
    name: "Baywatch",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/206/515174.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/206/515174.jpg",
    },
    summary:
      "<p>This long-running series follows the adventures of a team of lifeguards on the crowded beaches of Los Angeles County. Veteran lifeguard Mitch Buchannon watches over the younger lifeguards that come and go with each passing season as they keep the beaches safe for vacationers. Frequently he must take action to save them from the raging seas and from the raging tempers that sometimes flare up between the young guards in this stressful job.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1989-04-23",
  },
  {
    id: 1071,
    url: "https://www.tvmaze.com/shows/1071/birdsong",
    name: "Birdsong",
    genres: ["Drama", "Romance", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17100.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17100.jpg",
    },
    summary:
      "<p>Epic love story set against the First World War, based on Sebastian Faulks' novel about a soldier who finds himself fighting in the area where he had an illicit affair before the war.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b01bcltb",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-01-22",
  },
  {
    id: 1072,
    url: "https://www.tvmaze.com/shows/1072/blackadder",
    name: "Blackadder",
    genres: ["Comedy", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17102.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17102.jpg",
    },
    summary:
      "<p>Comedy set in different historical periods that features the ill-fated exploits of the mean-spirited Edmund Blackadder and his dim sidekick Baldrick.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006xxw3",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1983-06-15",
  },
  {
    id: 1073,
    url: "https://www.tvmaze.com/shows/1073/bomb-girls",
    name: "Bomb Girls",
    genres: ["Drama", "Romance", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17549.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17549.jpg",
    },
    summary:
      "<p>Set in the 1940s, <b>Bomb Girls</b> tells the remarkable stories of the women who risked their lives in a munitions factory building bombs for the Allied forces fighting on the European front. The series delves into the lives of these exceptional women – peers, friends and rivals – who find themselves thrust into new worlds and changed profoundly as they are liberated from their home and social restrictions.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 67,
      name: "Global",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2012-01-04",
  },
  {
    id: 1074,
    url: "https://www.tvmaze.com/shows/1074/bonekickers",
    name: "Bonekickers",
    genres: ["Drama", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/82/205389.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/82/205389.jpg",
    },
    summary:
      "<p>Set against the backdrop of Bath, a city steeped in 3,000 years of history, Gillian and her team – Dr. Ben Akomfrah (forensic, objective), Professor Gregory Parton (encyclopaedic but terminally louche) and eager young post-grad intern Viv Davis – are brought in under a variety of imperatives to extract bodies, books, weapons and all manner of artefacts which lead them into an investigation of the past that will unlock dangers and mysteries in the present.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00cl92f",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-07-08",
  },
  {
    id: 1075,
    url: "https://www.tvmaze.com/shows/1075/brideshead-revisited",
    name: "Brideshead Revisited",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17122.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17122.jpg",
    },
    summary:
      "<p>Based on the novel by Evelyn Waugh, two years in the making, and the equivalent of seven feature films back-to-back, this epic drama tells a story of romantic yearning and loss in the glittering but fading world of the British aristocracy between the wars.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1981-10-12",
  },
  {
    id: 1076,
    url: "https://www.tvmaze.com/shows/1076/children-of-dune",
    name: "Children of Dune",
    genres: ["Drama", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17123.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17123.jpg",
    },
    summary:
      "<p>The spectacular epic that began in the Emmy Award-winning Frank Herbert's Dune mini-series continues in this dazzling new journey into sweeping interstellar intrigue and visionary sci-fi adventure! On the desert planet of Dune, the ancient prophecy has been fulfilled: the rule of the legendary Muad'dib has triggered a miraculous transformation of the arid wastelands. But as always, the Great Houses of the Empire are alive with rumors of conspiracy, plotting and betrayal. And when Muad'dib no longer wields absolute power as the Emperor, his young son Leto Atreides and daughter Ghanima face the prospect of a disastrous civil war on Arrakis - and chaos on a galactic scale. Now, with the future of the vital Spice trade in the balance, the destiny of humanity itself will depend on the courage, strength and otherworldly wisdom of The<b> Children of Dune</b>!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-03-16",
  },
  {
    id: 1078,
    url: "https://www.tvmaze.com/shows/1078/the-riches",
    name: "The Riches",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17147.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17147.jpg",
    },
    summary:
      '<p>Blackmail. Murder. And back to life in the RV. The Malloys, after successfully passing themselves off as "The Riches," a yuppie family living in suburban America, face big trouble in Season Two. Wayne Malloy tries to clean up the mess in Eden Falls while his con artist family hits the road.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-03-12",
  },
  {
    id: 1080,
    url: "https://www.tvmaze.com/shows/1080/profiler",
    name: "Profiler",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17167.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17167.jpg",
    },
    summary:
      "<p>A crime drama following a criminal profiler working with the F.B.I.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-09-21",
  },
  {
    id: 1081,
    url: "https://www.tvmaze.com/shows/1081/primeval-new-world",
    name: "Primeval: New World",
    genres: ["Drama", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17178.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17178.jpg",
    },
    summary:
      "<p>A spin-off of the UK hit. Primeval: New World follows a team of scientists and animal experts that's called to action when dinosaurs appear in Vancouver.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 7,
      name: "CTV Sci-Fi Channel",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2012-10-29",
  },
  {
    id: 1082,
    url: "https://www.tvmaze.com/shows/1082/political-animals",
    name: "Political Animals",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17185.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17185.jpg",
    },
    summary:
      "<p>Elaine Barrish's husband Bud Hammond was a popular President of the United States during the 1990s despite his extramarital affairs. After leaving the White House, Elaine Barrish was elected Governor of Illinois and ran for the Democratic nomination for President, but lost to Paul Garcetti. The night Barrish conceded the nomination, she asked her husband for a divorce. Two years later, as Garcetti's Secretary of State, Barrish deals with State Department issues while trying to keep her family together.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-07-15",
  },
  {
    id: 1083,
    url: "https://www.tvmaze.com/shows/1083/reacttothat",
    name: "ReactToThat",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17195.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17195.jpg",
    },
    summary:
      "<p>In the new series, the kids and celebrity reactors not only watch and respond to viral videos, but participate in epic showdowns where they take on a challenge based on a video they just watched. Whether it's a basketball trick shot or the world record for fastest clapping, the challenges bring a physical element to the show that's never been seen in the online version.</p><p>In its three years since launching online, the React franchise has garnered over 1 billion video views and over 10 million subscribers. The success of Kids React has yielded spinoffs Teens React, Elders React and YouTubers React.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-12-15",
  },
  {
    id: 1084,
    url: "https://www.tvmaze.com/shows/1084/commander-in-chief",
    name: "Commander in Chief",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17196.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17196.jpg",
    },
    summary:
      "<p>Mackenzie Allen, the 45-year-old Independent Vice President of the United States, is about to venture into territory no woman has entered before. While at an official ceremony with husband and Chief of Staff, Rod Allen, she is informed by the President's Chief of Staff, Jim Gardner, and the Attorney General that President Bridges is about to undergo emergency brain surgery for a tumor.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-09-27",
  },
  {
    id: 1085,
    url: "https://www.tvmaze.com/shows/1085/coupling",
    name: "Coupling",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17197.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17197.jpg",
    },
    summary:
      "<p>Britcom about a group of six friends - three men and three women - and the ups and downs they encounter playing the 21st century dating game.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p006cwvz",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2000-05-12",
  },
  {
    id: 1086,
    url: "https://www.tvmaze.com/shows/1086/coupling",
    name: "Coupling",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17198.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17198.jpg",
    },
    summary:
      "<p><b>Coupling</b> centers on the dating, sexual adventures, and mishaps of six friends in their late twenties and thirties, often depicting the three women and the three men each talking among themselves about the same events, but in entirely different terms.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-09-25",
  },
  {
    id: 1087,
    url: "https://www.tvmaze.com/shows/1087/cranford",
    name: "Cranford",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17199.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17199.jpg",
    },
    summary:
      "<p>A rich and comic drama about the people of <i>Cranford</i>, a small Cheshire town on the cusp of change in the 1840s. Adapted from the novels by Elizabeth Gaskell.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00ps1xh",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2007-11-18",
  },
  {
    id: 1088,
    url: "https://www.tvmaze.com/shows/1088/the-crimson-petal-and-the-white",
    name: "The Crimson Petal and the White",
    genres: ["Drama", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17200.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17200.jpg",
    },
    summary:
      "<p>Follow Sugar into the underbelly of Victorian London seething with vitality, sexuality, ambition and emotion.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00zxc4d",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-04-06",
  },
  {
    id: 1089,
    url: "https://www.tvmaze.com/shows/1089/crusade",
    name: "Crusade",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17201.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17201.jpg",
    },
    summary:
      "<p>In 2267 the Earth is quarantined, having been infected with a deadly plague by an attacking alien force. Scientists estimate that it will kill every inhabitant within 5 years, not nearly enough time for a cure to be developed. So the planet's only hope lies with the Excalibur, an advanced prototype starship sent out to search ancient alien ruins for their former inhabitant's secrets, hoping that somewhere out there a cure can be found.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-06-09",
  },
  {
    id: 1090,
    url: "https://www.tvmaze.com/shows/1090/cupid",
    name: "Cupid",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17209.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17209.jpg",
    },
    summary:
      "<p>Hale belives, that as a punishmwnt for his arrogance, that he needs to get 100 couples romantically involved.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-09-26",
  },
  {
    id: 1091,
    url: "https://www.tvmaze.com/shows/1091/cupid",
    name: "Cupid",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17212.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17212.jpg",
    },
    summary:
      "<p>Trevor Pierce is a larger than life character who insists that he is <b>Cupid</b>, the Roman god of love. He claims that he has been sent to New York City by Zeus to bring 100 romantically challenged couples together before being allowed to return to Mt. Olympus. His persistence eventually lands him in a mental institution. Three months later, Trevor is found to be harmless to himself and others and is released -- but under certain conditions. Placed under the care of psychiatrist and self-help author Dr. Claire McCrae, he must attend her singles group therapy sessions on a regular basis so that she can monitor his progress. Trevor returns to his rented room upstairs from the struggling Tres Equis Cantina, owned by Felix Araiza and his sister, Lita. In exchange for rent, Trevor becomes a bartender and creates an atmosphere for singles looking for lasting love. His ideas, such as half-price margarita nights and mariachi karaoke duets, could help him bring couples together and ultimately take him closer to the day that he gets to return to Mt. Olympus. No one believes Trevor's story, but everyone finds him to be quite charming. Although he possesses a great knowledge of Greek mythology, Claire finds that Trevor constantly interferes and contradicts her when it comes to her pragmatic style of helping lonely hearts find their soul mates. In true love, Claire believes it's all about friendship and mutual respect; for Trevor, heat and passion conquer all. Only time will tell who will win this battle for love.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-03-31",
  },
  {
    id: 1092,
    url: "https://www.tvmaze.com/shows/1092/death-comes-to-pemberley",
    name: "Death Comes to Pemberley",
    genres: ["Drama", "Romance", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17213.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17213.jpg",
    },
    summary:
      "<p>Adaptation of PD James's bestselling homage to Pride and Prejudice. Elizabeth and Darcy, now six years married, are preparing for their annual ball when festivities are brought to an abrupt halt.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p01mqkm5",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-12-26",
  },
  {
    id: 1093,
    url: "https://www.tvmaze.com/shows/1093/the-devils-whore",
    name: "The Devil's Whore",
    genres: ["Drama", "War", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/58/146339.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/58/146339.jpg",
    },
    summary:
      "<p>Colourful four-part drama about the seismic events of 17th-century England, when political disobedience turned to revolution and bloody civil war.</p>",
    officialSite: "http://www.channel4.com/programmes/the-devils-whore",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-11-19",
  },
  {
    id: 1094,
    url: "https://www.tvmaze.com/shows/1094/dinotopia",
    name: "Dinotopia",
    genres: ["Adventure", "Family", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/26/65437.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/26/65437.jpg",
    },
    summary:
      "<p>Fantasy about an uncharted island where humans and dinosaurs coexist. The show was based on the books by James Gurney, and picked up where the miniseries left off.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-11-28",
  },
  {
    id: 1095,
    url: "https://www.tvmaze.com/shows/1095/doogie-howser-md",
    name: "Doogie Howser, M.D.",
    genres: ["Comedy", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17223.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17223.jpg",
    },
    summary:
      "<p>Steven Bochco and David E. Kelley created this comedy about a 16-year-old wunderkind physician who graduated from medical school at age 14 and began his residency at an L.A. hospital. Making sure Doogie's head didn't get too big for his stethoscope were his father, also a doctor, and his friend Vinnie, who kept him apprised of all things adolescent.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1989-09-19",
  },
  {
    id: 1096,
    url: "https://www.tvmaze.com/shows/1096/drive",
    name: "Drive",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17224.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17224.jpg",
    },
    summary:
      "<p>A select group of people from around the country are coerced or invited to compete in a highly-secretive, cross-county road race with a rumored prize of $32 million. Those competing include: Alex Tully, whose wife has been kidnapped and who has become convinced that competing in The Race will lead to her whereabouts; Wendy Patrakas, a new mother fleeing from her husband, Richard; Rob Laird, a soldier just back from fighting in Iraq, and his wife Ellie; Winston Salazar, a convict who has been mysteriously let out of jail, and his newly discovered half-brother Sean; Hurricane Katrina survivors Ivy, Leigh and Susan; father and daughter team John and Violet; and mysterious stowaway Corinna Wiles.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-04-13",
  },
  {
    id: 1097,
    url: "https://www.tvmaze.com/shows/1097/dr-quinn-medicine-woman",
    name: "Dr. Quinn, Medicine Woman",
    genres: ["Drama", "Family", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17225.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17225.jpg",
    },
    summary:
      "<p>The trials and adventures of a female doctor in a small wild west town.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-01-01",
  },
  {
    id: 1098,
    url: "https://www.tvmaze.com/shows/1098/early-edition",
    name: "Early Edition",
    genres: ["Drama", "Fantasy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17226.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17226.jpg",
    },
    summary:
      "<p>This is an hour-long drama about Chicago native Gary Hobson who becomes a reluctant hero when his morning newspaper reports tomorrow's headlines. Commodities trader Gary Hobson (Kyle Chandler) is losing it: his job, his home and his brilliant attorney wife. He thinks he may even be losing his mind when tomorrow's newspaper mysteriously arrives today – giving him a disconcerting look into the future. What will he do with tomorrow's news? While his best friend Chuck (Fisher Stevens) sees the newspaper as a ticket to personal gain, co-worker Marissa (Shanesia Davis) convinces Gary that the \"early edition\" should be used to better peoples' lives. So each day Gary begins anew the struggle to make sense of a world turned upside-down by the changing course of events that come from reading the \"early edition.\"</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-09-28",
  },
  {
    id: 1099,
    url: "https://www.tvmaze.com/shows/1099/enlisted",
    name: "Enlisted",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17227.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17227.jpg",
    },
    summary:
      "<p>A military-set family comedy, <b>Enlisted</b> centers on three brothers on a small Florida Army post and the group of misfits who surround them. Charming, funny and a natural-born leader Staff Sergeant Pete Hill was on a path for a huge military career until one mistake overseas got him booted stateside to Fort McGee, the post where his two younger brothers - Corporal Derrick Hill and Private Randy Hill are stationed.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-10",
  },
  {
    id: 1100,
    url: "https://www.tvmaze.com/shows/1100/the-fades",
    name: "The Fades",
    genres: ["Drama", "Thriller", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17228.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17228.jpg",
    },
    summary:
      "<p>Seventeen-year old Paul can see the spirits of the dead. When one of these restless spirits crosses back into the living world, he is forced into a fight to prevent the apocalypse.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b0129tkw",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-09-21",
  },
  {
    id: 1101,
    url: "https://www.tvmaze.com/shows/1101/dune",
    name: "Dune",
    genres: ["Drama", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17229.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17229.jpg",
    },
    summary:
      "<p>A three-part miniseries on politics, betrayal, lust, greed and the coming of a Messiah. Based on Frank Herbert's classic science fiction novel.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-12-03",
  },
  {
    id: 1102,
    url: "https://www.tvmaze.com/shows/1102/hatfields-mccoys",
    name: "Hatfields & McCoys",
    genres: ["Drama", "Romance", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17230.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17230.jpg",
    },
    summary:
      "<p>The Hatfield-McCoy saga begins with 'Devil' Anse Hatfield (Costner) and Randall McCoy (Paxton). Close friends and comrades during the Civil War, they returned to their neighboring homes - Hatfield in West Virginia, McCoy just across the Tug River border in Kentucky - to increasing tensions, misunderstandings and resentments that soon exploded into all-out warfare between the two families. As hostilities grew, friends, neighbors and outside forces joined the fight, bringing the two states to the brink of another Civil War.</p>",
    officialSite: "https://www.history.com/shows/hatfields-and-mccoys",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-05-28",
  },
  {
    id: 1103,
    url: "https://www.tvmaze.com/shows/1103/the-hour",
    name: "The Hour",
    genres: ["Drama", "Thriller", "Espionage"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17231.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17231.jpg",
    },
    summary:
      "<p>A behind-the-scenes drama and espionage thriller in Cold War-era England that centers on a journalist, a producer, and an anchorman for an investigative news programme.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p00wkgxw",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-07-19",
  },
  {
    id: 1104,
    url: "https://www.tvmaze.com/shows/1104/i-claudius",
    name: "I, Claudius",
    genres: ["Drama", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17232.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17232.jpg",
    },
    summary:
      "<p>Acclaimed blackly comic historical drama series. Set amidst a web of power, corruption and lies, it chronicles the reigns of the Roman emperors - Augustus, Tiberius, Caligula and finally Claudius.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006mhmk",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1976-09-20",
  },
  {
    id: 1105,
    url: "https://www.tvmaze.com/shows/1105/in-a-land-of-plenty",
    name: "In a Land of Plenty",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23460.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23460.jpg",
    },
    summary:
      "<p>Television adaptation of Tim Pears' novel, charting the ups and downs of the Freeman family over three generations. In 1951, industrialist Charles Freeman weds the enigmatic but naive Mary and whisks her away to a large house overlooking the town where he owns his factory. Their union produces three sons - Simon, James and Robert - and a daughter, Alice, whose lives go on to be touched by tragedy despite their privileged background.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2001-01-10",
  },
  {
    id: 1107,
    url: "https://www.tvmaze.com/shows/1107/jack-jill",
    name: "Jack & Jill",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/73/182504.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/73/182504.jpg",
    },
    summary:
      "<p>This sitcom in named after two of the six main characters, each with a name rather suggesting the other gender: Jaqueline 'Jack' and David 'Jill' Jillefski, who gradually realize they were in love at first sight. The other main characters are brilliant but insecure med student Barto, philosopher-barman Mikey, a natural womanizer who cultivates immaturity and disarming charm, Broadway-actress-dancer Audrey, who becomes Barto's girl, and Elisa Cronkite, Jack's colleague at the TV station.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-09-26",
  },
  {
    id: 1108,
    url: "https://www.tvmaze.com/shows/1108/jekyll",
    name: "Jekyll",
    genres: ["Drama", "Horror", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17233.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17233.jpg",
    },
    summary:
      "<p>Adapted from the famous novel by Robert Louis Stephenson, this contemporary thriller follows Dr. Tom Jackman as he uses an array of modern technlogy in an increasingly desperate attempt to hold at bay a deadly foe: Mr. Hyde, his savage and ruthless alter ego. Although they time-share the same body, Mr. Hyde is significantly stronger and faster than Tom -- and his strength is still growing. The stakes get even higher when Hyde learns of the existence of Tom's beautiful wife, Claire, and their two children, whom he uses as pawns in his power play against Tom. The doctor relies heavily on his assistant, psychiatric nurse Katherine Reimer, to help him somehow keep Hyde in check. Peter Syme is Tom's best friend, Miranda Callendar is a private eye who stumbles onto Tom's bizarre double life, and Benjamin is an American overseeing a mission to overtake and capture Hyde.</p>",
    officialSite: "http://www.bbc.co.uk/drama/jekyll/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2007-06-16",
  },
  {
    id: 1109,
    url: "https://www.tvmaze.com/shows/1109/judging-amy",
    name: "Judging Amy",
    genres: ["Drama", "Family", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/44/111279.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/44/111279.jpg",
    },
    summary:
      "<p><b>Judging Amy</b> is a drama about a single mother who has left New York behind to become a Family Court judge in Hartford, Connecticut. Judge Amy Gray is divorced and raising her young daughter, Lauren. They live with Amy's very opinionated mother Maxine, a social worker who is often at odds with her boss Sean. Amy has reestablished relationships with her younger brother Vincent, her older brother Peter and his wife Gillian. Assisting Amy in the courtroom are her Court Services officer Bruce Van Exel and her eager court-clerk-turned-lawyer Donna Kozlowski. Judging Amy is about three generations of women living together as they confront the personal and professional dilemmas in their changing, challenging lives.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-09-19",
  },
  {
    id: 1110,
    url: "https://www.tvmaze.com/shows/1110/kings",
    name: "Kings",
    genres: ["Drama", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17235.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17235.jpg",
    },
    summary:
      "<p><b>Kings</b> is a modern variation on the David-and-Goliath story, David Shepherd, a brave warrior in a city under siege, wins the gratitude of his king by rescuing the prince from enemy territory. His ensuing fame and rise through the ranks earns him the affection of the king's daughter, but David begins to realize it's getting harder and harder to tell his allies from his enemies. Although the series is loosely based on the Biblical story of King David, it is set in a kingdom that is culturally and technologically similar to the present-day United States.</p>",
    officialSite: "https://www.nbc.com/kings",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-03-15",
  },
  {
    id: 1111,
    url: "https://www.tvmaze.com/shows/1111/klondike",
    name: "Klondike",
    genres: ["Drama", "Adventure", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17244.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17244.jpg",
    },
    summary:
      '<p><b>Klondike</b> follows the lives of two childhood best friends, Bill and Epstein, in the late 1890s as they flock to the gold rush capital in the untamed Yukon Territory. This man-versus-nature tale places our heroes in a land full of undiscovered wealth, but ravaged by harsh conditions, unpredictable weather and desperate, dangerous characters including greedy businessmen, seductive courtesans and native tribes witnessing the destruction of their people and land by opportunistic entrepreneurs.</p><p>Based on Charlotte Gray\'s book "Gold Diggers: Striking It Rich in the Klondike".</p>',
    officialSite: "http://klondiketv.com/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-20",
  },
  {
    id: 1112,
    url: "https://www.tvmaze.com/shows/1112/um-mundo-catita",
    name: "Um Mundo Catita",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17246.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17246.jpg",
    },
    summary:
      "<p>The burlesque and nonsensical biography of a singer, bohemian and broke, who falls in love with his sexy dentist who is already the fiancée of a well-off executive. The adventures and misadventures of the singer in this wonderful new world are told with tongue-in-cheek and several adult situations.</p>",
    officialSite: null,
    webChannel: null,
    language: "Portuguese",
    status: "Ended",
    network: {
      id: 102,
      name: "RTP1",
      country: { name: "Portugal", code: "PT", timezone: "Europe/Lisbon" },
    },
    premiered: "2008-11-05",
  },
  {
    id: 1113,
    url: "https://www.tvmaze.com/shows/1113/k-ville",
    name: "K-Ville",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17245.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17245.jpg",
    },
    summary:
      '<p>Two years after Hurricane Katrina, much of New Orleans is still in chaos, so Felony Action Squad officer Marlin Boulet isn\'t worried about bending a few rules. His new partner, Trevor Cobb, is a veteran of the war in Afghanistan in search of redemption. Also on the squad are hotheaded Billy "K-9" Faust, wise guy Jeff "Glue Boy" Gooden, hardbitten Ginger "Love Tap" LeBeau and Capt. James Embry, who runs his team with equal parts humor and sheer grit.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-09-17",
  },
  {
    id: 1114,
    url: "https://www.tvmaze.com/shows/1114/lip-service",
    name: "Lip Service",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17247.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17247.jpg",
    },
    summary:
      "<p>Lesbian drama series with irreverent humour as a group of friends search for happiness.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p00qnjk5",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-10-12",
  },
  {
    id: 1115,
    url: "https://www.tvmaze.com/shows/1115/mad-about-you",
    name: "Mad About You",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17248.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17248.jpg",
    },
    summary:
      "<p><b>Mad About You</b> tells the story of Paul and Jamie Buchman, a husband and wife trying their best to be married and stay in love. Along the way, this urban duo must contend with their sometimes difficult friends and family — not to mention the daily inconveniences of daily life — and learn to savor the everyday miracles.</p><p><b>Initially aired on NBC from September 23, 1992 to May 24, 1999</b></p>",
    officialSite: "https://spectrumoriginals.com/madaboutyou/",
    webChannel: {
      id: 316,
      name: "Spectrum On Demand",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "To Be Determined",
    network: null,
    premiered: "1992-09-23",
  },
  {
    id: 1116,
    url: "https://www.tvmaze.com/shows/1116/the-middleman",
    name: "The Middleman",
    genres: ["Drama", "Comedy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17249.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17249.jpg",
    },
    summary:
      "<p>When vile villains threaten to dominate the world, one man walks the line between ordinary and extraordinary. That man is <b>The Middleman</b>. But saving the world is no longer a one man job! Meet Wendy Watson, The Middleman's unlikely new partner. Armed with gadgets, gizmos and doohickeys, they fight evil so you don't have to!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-06-16",
  },
  {
    id: 1117,
    url: "https://www.tvmaze.com/shows/1117/mildred-pierce",
    name: "Mildred Pierce",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17250.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17250.jpg",
    },
    summary:
      "<p><b>Mildred Pierce</b> brings to life the memorable character introduced in James M. Cain's classic 1941 novel. The five-part drama offers an intimate portrait of a uniquely independent woman who finds herself newly divorced during the Depression years, as she struggles to carve out a new life for herself and her family. The story explores Mildred's unreasonable devotion to her insatiable daughter, Veda, as well as the complex relationships she shares with the indolent men in her life.</p>",
    officialSite: "https://www.hbo.com/mildred-pierce",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-03-27",
  },
  {
    id: 1118,
    url: "https://www.tvmaze.com/shows/1118/my-family",
    name: "My Family",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17251.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17251.jpg",
    },
    summary:
      "<p>Domestic sitcom following the fortunes of Ben and Susan Harper and their children, starring Robert Lindsay and Zoe Wanamaker.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006xj32",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2000-09-19",
  },
  {
    id: 1119,
    url: "https://www.tvmaze.com/shows/1119/the-nanny",
    name: "The Nanny",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17252.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17252.jpg",
    },
    summary:
      "<p>In <b>The Nanny</b>, a cosmetics saleswoman stumbles upon the opportunity to become a nanny to the three rambunctious children of rich, widowed Broadway producer Maxwell Sheffield. With her off-beat style of nurturing and straightforward honesty, she turns out to be the best thing that has ever happened to the family... whether they realize it or not.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-11-03",
  },
  {
    id: 1121,
    url: "https://www.tvmaze.com/shows/1121/cowboy-bebop",
    name: "Cowboy Bebop",
    genres: ["Action", "Adventure", "Anime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/178/446548.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/178/446548.jpg",
    },
    summary:
      '<p>In the year 2071, the crew of the spaceship Bebop travel the solar system trying to apprehend bounties. In the slang of the era, "Cowboys" are bounty hunters. Most episodes revolve around a specific bounty, but the show often shares its focus with the pasts of one of each of the four main characters and of more general past events, which are revealed and brought together as the series progresses. (The show originally aired on TV Tokyo, but due to what the network considered "excessive violence", only a few episodes, out of order, were ever shown. The channel WOWOW later picked up the series and aired the entire 26 episode run, in order.)</p>',
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 158,
      name: "WOWOW",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1998-10-24",
  },
  {
    id: 1122,
    url: "https://www.tvmaze.com/shows/1122/amazing-stories",
    name: "Amazing Stories",
    genres: ["Fantasy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17262.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17262.jpg",
    },
    summary:
      "<p>As one experience ends, another adventure begins… in the extraordinary worlds of <b>Amazing Stories</b>! From acclaimed director-producer Steven Spielberg and Amblin Entertainment comes the Emmy Award-winning TV series. Join a roster of cinema's most illustrious stars, including Kiefer Sutherland, Charlie Sheen, Tim Robbins, John Lithgow, Kevin Costner and more, as well as some of Hollywood's greatest directorial talents. Relive all the mesmerizing magic, mystery and suspense in these unique episodes from some of filmmaking's finest storytellers!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1985-09-29",
  },
  {
    id: 1123,
    url: "https://www.tvmaze.com/shows/1123/american-gothic",
    name: "American Gothic",
    genres: ["Drama", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/216/542321.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/216/542321.jpg",
    },
    summary:
      "<p>The rural community of Trinity, South Carolina, a postcard-pretty enclave of antebellum houses and manicured lawns, is a town tormented and seduced by the ominous presence of one man, Sheriff Lucas Buck.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1995-09-22",
  },
  {
    id: 1124,
    url: "https://www.tvmaze.com/shows/1124/becoming-human",
    name: "Becoming Human",
    genres: ["Drama", "Fantasy", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17271.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17271.jpg",
    },
    summary:
      "<p>Follow Adam, Being Human's teenage vampire, as he becomes embroiled in a dark and dangerous mystery. At the heart of <b>Becoming Human</b> are the eight episodes where the story unfolds... but there's more. You can get deeper into the mystery with mobile phone videos, newspaper clippings, character profiles and other updates revealed by the characters themselves as they try and track down the killer.</p>",
    officialSite: "http://www.bbc.co.uk/blogs/becominghuman",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-01-30",
  },
  {
    id: 1125,
    url: "https://www.tvmaze.com/shows/1125/brimstone",
    name: "Brimstone",
    genres: ["Action", "Fantasy", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/83/207963.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/83/207963.jpg",
    },
    summary:
      "<p>A dead cop, sentenced to Hell, is returned to Earth by the Devil to recover 113 escaped evil spirits.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-10-23",
  },
  {
    id: 1126,
    url: "https://www.tvmaze.com/shows/1126/clone",
    name: "Clone",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17273.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17273.jpg",
    },
    summary:
      "<p>Comedy series revolving around the education of the first human clone.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00fscf6",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-11-17",
  },
  {
    id: 1128,
    url: "https://www.tvmaze.com/shows/1128/cosmos",
    name: "Cosmos",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/236/591582.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/236/591582.jpg",
    },
    summary:
      "<p>Hosted by renowned astrophysicist Neil deGrasse Tyson, <b>Cosmos</b> will explore how we discovered the laws of nature and found our coordinates in space and time. It will bring to life never-before-told stories of the heroic quest for knowledge and transport viewers to new worlds and across the universe for a vision of the cosmos on the grandest scale. Cosmos will invent new modes of scientific storytelling to reveal the grandeur of the universe and re-invent celebrated elements of the legendary original series, including the Cosmic Calendar and the Ship of the Imagination. The most profound scientific concepts will be presented with stunning clarity, uniting skepticism and wonder, and weaving rigorous science with the emotional and spiritual into a transcendent experience.</p>",
    officialSite:
      "https://www.nationalgeographic.com/tv/shows/cosmos-possible-worlds",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1980-09-28",
  },
  {
    id: 1129,
    url: "https://www.tvmaze.com/shows/1129/dungeons-dragons",
    name: "Dungeons & Dragons",
    genres: ["Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17276.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17276.jpg",
    },
    summary:
      "<p>Animated series based on the extremely popular TSR role-playing game.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1983-09-17",
  },
  {
    id: 1130,
    url: "https://www.tvmaze.com/shows/1130/journeyman",
    name: "Journeyman",
    genres: ["Drama", "Science-Fiction", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17277.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17277.jpg",
    },
    summary:
      "<p><b>Journeyman</b> is a romantic mystery-drama about Dan Vasser, a San Francisco newspaper reporter and family man who inexplicably begins to travel through time and change the course of people's lives. Along the way, he must also deal with the difficulties and strife at work and home brought on by his sudden disappearances. His freewheeling travels through the decades reunite him with his long-lost fiance Livia--which complicates his blissful, present-day life with his vivacious wife Katie and son.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-09-24",
  },
  {
    id: 1131,
    url: "https://www.tvmaze.com/shows/1131/neverland",
    name: "Neverland",
    genres: ["Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17282.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17282.jpg",
    },
    summary:
      "<p>Neverland, a prequel to author J.M. Barrie's classic, Peter Pan, sweeps in time from the turbulent seas of the pirates of the Caribbean and the back alleys of Dickensian London to a world of pure imagination</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-12-04",
  },
  {
    id: 1132,
    url: "https://www.tvmaze.com/shows/1132/neverwhere",
    name: "Neverwhere",
    genres: ["Drama", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17287.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17287.jpg",
    },
    summary:
      "<p>Urban fantasy drama created by cult author Neil Gaiman about a nightmarish journey set in a parallel world that exists below the streets of London.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1996-09-12",
  },
  {
    id: 1133,
    url: "https://www.tvmaze.com/shows/1133/planet-of-the-apes",
    name: "Planet of the Apes",
    genres: ["Drama", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17292.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17292.jpg",
    },
    summary:
      "<p>After their spacecraft travels through a time warp, two astronauts from 1981 crash-land back on Earth in the year 3085--a time when intelligent apes rule and humans have been reduced to servants or pets. Captured by the apes and sentenced to death, they are saved by a curious chimpanzee name Galen. But now all three are on the run, trying to keep one step ahead of the gorilla army led by General Urko, who is determined to kill the renegades.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1974-09-13",
  },
  {
    id: 1134,
    url: "https://www.tvmaze.com/shows/1134/thundercats",
    name: "ThunderCats",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17296.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17296.jpg",
    },
    summary:
      "<p>A new take on the original 1980s animated series, combining fantasy with science as the heroes and villains on the show fight for the Stones of Power. The <b>ThunderCats </b>are on the move! After the kingdom of Thundera is attacked by the lizard people, Lion-O leads Tygra, Cheetara and the other heroes on a quest for the Book of Omens and the magic stones of legend. But he'll have to face villains like Mumm-Ra, the ancient evil sorcerer, and Slithe, the dangerous lizard general. Luckily, he has the Sword of Omens and its amazing powers at his disposal. ThunderCats, ho!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-07-29",
  },
  {
    id: 1135,
    url: "https://www.tvmaze.com/shows/1135/the-time-tunnel",
    name: "The Time Tunnel",
    genres: ["Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17299.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17299.jpg",
    },
    summary:
      "<p>The Control of time is potentially the most valuable treasure that man will ever find, or so believe the scientists of Project Tic Toc. Located beneath the Arizona desert, the ten-year project's focus is the feasibility of time travel. But when the government reconsiders the project, the scientists have only 24 hours to prove their untested time tunnel will actually work. Determined to save the project, Dr. Tony Newman and Dr. Doug Phillips go through the tunnel and quickly find themselves catapulted from one historical event to another, barely escaping with their lives as their colleagues back in Arizona race to figure out a way to bring them back home.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1966-09-09",
  },
  {
    id: 1136,
    url: "https://www.tvmaze.com/shows/1136/tron-uprising",
    name: "Tron: Uprising",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17306.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17306.jpg",
    },
    summary:
      "<p>A young program becomes the unlikely leader of a revolution.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 25,
      name: "Disney XD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-05-18",
  },
  {
    id: 1137,
    url: "https://www.tvmaze.com/shows/1137/party-down",
    name: "Party Down",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17310.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17310.jpg",
    },
    summary:
      "<p><b>Party Down</b> follows a group of Hollywood dreamers - struggling actors and writers - stuck working as caterers while waiting for their big show business break.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 17,
      name: "Starz",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-03-20",
  },
  {
    id: 1138,
    url: "https://www.tvmaze.com/shows/1138/the-inbetweeners",
    name: "The Inbetweeners",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17317.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17317.jpg",
    },
    summary:
      '<p><b>The Inbetweeners</b> takes a comedic look at a group of teenagers navigating high school and charging into adulthood the way everyone does... by taking one step forward and three steps back. Whether humiliating themselves in an effort to impress the girl of their dreams, or mercilessly mocking their friend for driving a bright yellow clunker with a cassette player and one blue door, get ready to embrace the "inbetween".</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-08-20",
  },
  {
    id: 1139,
    url: "https://www.tvmaze.com/shows/1139/impractical-jokers",
    name: "Impractical Jokers",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17323.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17323.jpg",
    },
    summary:
      "<p>Four longtime friends take dares to outrageous new levels in truTV's hilarious series <b>Impractical Jokers</b>. Q, Murr, Joe and Sal bravely face some of the most unbelievably awkward and brazen hijinks yet, daring each other with over-the-top challenges that are guaranteed to set a new side-splitting standard.</p>",
    officialSite: "http://www.trutv.com/shows/impractical-jokers/index.html",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 84,
      name: "truTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-12-15",
  },
  {
    id: 1140,
    url: "https://www.tvmaze.com/shows/1140/gates",
    name: "Gates",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17324.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17324.jpg",
    },
    summary: "<p>Sky sitcom about parental rivalries on the school run.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 44,
      name: "Sky Witness",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-08-14",
  },
  {
    id: 1141,
    url: "https://www.tvmaze.com/shows/1141/eastbound-down",
    name: "Eastbound & Down",
    genres: ["Drama", "Comedy", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17326.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17326.jpg",
    },
    summary:
      "<p>Burned out and broke, former big-league pitcher Kenny Powers returns home to North Carolina to teach PE at the local middle school he once attended--and sets his sights on winning back his high-school flame April.</p>",
    officialSite: "http://www.hbo.com/eastbound-and-down",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-02-15",
  },
  {
    id: 1142,
    url: "https://www.tvmaze.com/shows/1142/celebrity-motor-homes",
    name: "Celebrity Motor Homes",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17332.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17332.jpg",
    },
    summary:
      "<p>In this fast-paced new series, host Drew Waters tours three luxurious motor homes in every episode. Waters travels around the country - making stops in California, Texas, Montana, Virginia, Florida, Georgia, North Carolina, South Carolina, and Tennessee - to catch up with celebrities on the move and get a look inside their highly customized coaches and rolling road homes. Many of the stars give him a personal tour - pointing out to viewers all of the special add-ons, must-have features and unique design touches created for their individual tastes to make life on the go a smoother ride.</p>",
    officialSite:
      "http://www.greatamericancountry.com/shows/celebrity-motor-homes",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 103,
      name: "Great American Country",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-12-22",
  },
  {
    id: 1143,
    url: "https://www.tvmaze.com/shows/1143/extra",
    name: "Extra",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17334.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17334.jpg",
    },
    summary:
      "<p><b>Extra</b> (originally titled <i>Extra: The Entertainment Magazine</i> from 1994 to 1996) is an American syndicated television newsmagazine that is distributed by Warner Bros. Television Distribution and premiered on September 5, 1994. The program serves as a straight rundown of news headlines and gossip throughout the entertainment industry, providing coverage of events and celebrities; however, since 2013, it has also placed an even greater emphasis on interviews and insider previews of upcoming film and television projects.</p><p>As of 2014, the program's weekday broadcasts are currently anchored by Mario Lopez, Tracey Edmonds and Charissa Thompson; its weekend editions are co-anchored by Lopez and Renee Bargh, who also serves as a correspondent for the weekday editions.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1994-09-05",
  },
  {
    id: 1144,
    url: "https://www.tvmaze.com/shows/1144/mecum-dealmakers",
    name: "Mecum Dealmakers",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17335.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17335.jpg",
    },
    summary:
      '<p><i><b>"Mecum Dealmakers"</b></i> provides car enthusiasts with a unique, behind-the-scenes look at the high-intensity world of Mecum Auctions, as collector cars change hands with the smack of an auction gavel. Mecum Dealmakers dovetails off of the Mecum Auctions series, and tells the story of President and Founder Dana Mecum and his son Frank Mecum. The father-son tandem works together to manage the high pressure of the auction floor, where buyers and sellers hope to make the deal of a lifetime, often with hundreds of thousands of dollars on the line.</p>',
    officialSite: "http://www.nbcsports.com/show/mecum-dealmakers",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 104,
      name: "NBCSN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-31",
  },
  {
    id: 1145,
    url: "https://www.tvmaze.com/shows/1145/beat-bobby-flay",
    name: "Beat Bobby Flay",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/205/513458.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/205/513458.jpg",
    },
    summary:
      "<p>In order to <b>Beat Bobby Flay</b>, you have to get to him first. This new series is the ultimate throwdown-showdown... . Three culinary masters, each with their own signature dish, a dish that they'd stake their reputations on, travel to New York for the chance to challenge Bobby Flay to a head-to-head cook-off of their specialty. But first, these contenders must battle it out to see who has the culinary prowess to ultimately go one-on-one against Bobby on his own turf.</p>",
    officialSite: "http://www.foodnetwork.com/shows/beat-bobby-flay",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 81,
      name: "Food Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-03-03",
  },
  {
    id: 1146,
    url: "https://www.tvmaze.com/shows/1146/a-stranger-in-my-home",
    name: "A Stranger in My Home",
    genres: ["Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/67/169495.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/67/169495.jpg",
    },
    summary:
      "<p>Your house should be a place where you feel most comfortable, but to someone who poses a threat, there's no better way to get inside your life than to get inside your home. <b>A Stranger in My Home</b> is the perfect blend of mystery and suspense, telling stories of what happens when strangers come together under one roof. You might think you can trust this new acquaintance, but looks can be deceiving.</p>",
    officialSite:
      "http://www.investigationdiscovery.com/tv-shows/a-stranger-in-my-home/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-10-13",
  },
  {
    id: 1147,
    url: "https://www.tvmaze.com/shows/1147/krod-mandoon-and-the-flaming-sword-of-fire",
    name: "Kröd Mändoon and the Flaming Sword of Fire",
    genres: ["Comedy", "Action", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/326/816187.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/326/816187.jpg",
    },
    summary:
      "<p>Fantasy comedy series starring Sean Maguire and Matt Lucas.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-04-09",
  },
  {
    id: 1148,
    url: "https://www.tvmaze.com/shows/1148/life-as-we-know-it",
    name: "Life As We Know It",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/128/321528.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/128/321528.jpg",
    },
    summary:
      "<p><b>Life As We Know It</b> defines the spirit of life through the eyes of Dino Whitman, Jonathan Fields and Ben Connor, three hormone-charged teenage boys on the brink of becoming young men. This coming-of-age story is not just about sex - which does dominate their every thought - girlfriends and sports, but about how the pressures of growing up affect their attitudes toward the things and people they love, and how these experiences with their families, friends, coaches and teachers shape them into men.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-10-07",
  },
  {
    id: 1149,
    url: "https://www.tvmaze.com/shows/1149/seven-ages-of-rock",
    name: "Seven Ages of Rock",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17361.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17361.jpg",
    },
    summary:
      "<p>A definitive landmark series charting the emergence and re-emergence of rock music as a global force, told through the musicians who have shaped this most enduring of genres.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2007-05-19",
  },
  {
    id: 1150,
    url: "https://www.tvmaze.com/shows/1150/life-as-we-know-it",
    name: "Life As We Know It",
    genres: ["Comedy"],
    image: null,
    summary:
      "<p>This is a sitcom about an couple growing old and follows their life and their children as they try to remain active and young, but their children who still live at home don't make it easy for them.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2001-07-22",
  },
  {
    id: 1151,
    url: "https://www.tvmaze.com/shows/1151/the-young-ones",
    name: "The Young Ones",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/62/155416.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/62/155416.jpg",
    },
    summary:
      "<p>Anarchic sitcom about degenerate North London students in the 80s.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00glhzn",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1982-11-09",
  },
  {
    id: 1152,
    url: "https://www.tvmaze.com/shows/1152/the-net",
    name: "The Net",
    genres: ["Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17369.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17369.jpg",
    },
    summary:
      "<p><b>The Net</b> is the story of freelance programmer Angela Bennett, who receives a mysterious email which leads her into an internet chat with 'The Sorcerer'. Within minutes, her bank account has been closed, her credit cards have been canceled and she's been arrested. For some reason everyone believes she is Elizabeth Marx, an international criminal of some repute. Everyone she knows is dead and her former life no longer exists for all intents and purposes. However, when she is released by a NSA agent claiming to know who set her up, Angela sets out to prove her innocence while evading the evil forces at work.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-07-19",
  },
  {
    id: 1153,
    url: "https://www.tvmaze.com/shows/1153/new-amsterdam",
    name: "New Amsterdam",
    genres: ["Drama", "Crime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17370.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17370.jpg",
    },
    summary:
      '<p><b>New Amsterdam</b> centers on a brilliant New York homicide detective with a profound secret he is immortal. In response to a heroic action, John Amsterdam will not age a day until he finds "the one." He has had many lives as he has roamed the city of New York for the past 400 years searching for his one true love.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-03-04",
  },
  {
    id: 1154,
    url: "https://www.tvmaze.com/shows/1154/the-nine",
    name: "The Nine",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17375.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17375.jpg",
    },
    summary:
      "<p><b>The Nine</b> is a complex character drama series that will unravel the mystery of what transpired during a bank robbery turned 52-hour hostage situation in Los Angeles. Chronological flashbacks of what happened inside the bank will open each episode, but the heart of the series is how that harrowing experience impacts the key characters in their present day lives as they continue to intertwine, deepen and complicate the connections to one another.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-10-04",
  },
  {
    id: 1155,
    url: "https://www.tvmaze.com/shows/1155/no-heroics",
    name: "No Heroics",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17386.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17386.jpg",
    },
    summary:
      "<p>ITV sitcom about four old friends who just happen to be off-duty superheroes. Based in the heroes-only pub The Fortress, the series focuses on their day-to-day lives - which, for supposed saviours of the world, are more run of the mill than one might expect.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 54,
      name: "ITV2",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-09-18",
  },
  {
    id: 1156,
    url: "https://www.tvmaze.com/shows/1156/north-south",
    name: "North & South",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/32/80594.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/32/80594.jpg",
    },
    summary:
      "<p>Set against the backdrop of Victorian England's industrial north, it follows the fortunes of Margaret Hale, one of 19th century literature's most original heroines.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00kq3rz",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2004-11-14",
  },
  {
    id: 1157,
    url: "https://www.tvmaze.com/shows/1157/north-and-south",
    name: "North and South",
    genres: ["Drama", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17403.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17403.jpg",
    },
    summary:
      "<p>Patrick Swayze, Kirstie Alley and Lesley-Anne Down star in a 1985 miniseries based on John Jakes' novel about the Civil War and its effect on two families.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1985-11-03",
  },
  {
    id: 1158,
    url: "https://www.tvmaze.com/shows/1158/october-road",
    name: "October Road",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/138/345686.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/138/345686.jpg",
    },
    summary:
      "<p>Can you ever really go home again? That's the question that confronts acclaimed novelist Nick Garrett when he returns home -- after being away for ten years -- to take up an offer to teach a one-day course at Dufresne College in his native Knights Ridge, Massachusetts. But once back, Nick finds the response to his homecoming less than effusive; he's had no contact with family or friends since leaving, and some resent how they were portrayed as characters in his novel.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-03-15",
  },
  {
    id: 1159,
    url: "https://www.tvmaze.com/shows/1159/once-and-again",
    name: "Once and Again",
    genres: ["Drama", "Family", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17432.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17432.jpg",
    },
    summary:
      "<p><b>Once and Again</b> explored brave new territory with the compelling story of two families blending at the seams. The second marriage of Lily Manning to Rick Sammler pushes both to the limit as they try for domestic normalcy while navigating divorce, parenting, financial hardship and many other life lessons.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-09-21",
  },
  {
    id: 1160,
    url: "https://www.tvmaze.com/shows/1160/out-of-practice",
    name: "Out of Practice",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17436.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17436.jpg",
    },
    summary:
      "<p><b>Out Of Practice</b> is a comedy about a family of physicians who share the same profession but have little else in common. Ben Barnes is an earnest young couples' counselor whose family doesn't consider him to be a \"real\" doctor because he doesn't have \"M.D.\" after his name. They're the real doctors: Ben's brother, Oliver is good-looking, self-centered and a plastic surgeon who enjoys dating the prettiest women in town, some of whom he helped make that way; and his sister Regina is an E.R. doctor who's hooked on the non-stop action there. Their divorcing parents are Stewart, a gastroenterologist who is glad to be free from the reins of his controlling wife, and Lydia, a driven, status conscious cardiologist whose career eclipsed her ex's years ago. But despite their lofty credentials, Ben might be the best prescription for the future of this family.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-09-19",
  },
  {
    id: 1161,
    url: "https://www.tvmaze.com/shows/1161/parades-end",
    name: "Parade's End",
    genres: ["Drama", "War", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17437.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17437.jpg",
    },
    summary:
      "<p>In the dying days of the Edwardian Empire, Christopher Tietjens enters into a destructive marriage with the beautiful but cruel socialite Sylvia.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b01m7rn8",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-08-24",
  },
  {
    id: 1162,
    url: "https://www.tvmaze.com/shows/1162/the-paradise",
    name: "The Paradise",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17441.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17441.jpg",
    },
    summary:
      "<p>An intoxicating love story set in England's first department store in the 1870s.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p00vhpsv",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-09-25",
  },
  {
    id: 1163,
    url: "https://www.tvmaze.com/shows/1163/parker-lewis-cant-lose",
    name: "Parker Lewis Can't Lose",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/48/122177.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/48/122177.jpg",
    },
    summary:
      "<p>For most teenagers, high school is filled with obstacles nearly impossible to traverse. But then there is Parker Lewis, the one teenager able to overcome any barrier with the use of his wits and the help of his best buds, rock n roller Mikey and their quintessential nerd assistant Jerry. Of course, that does not mean Principal Grace Musso will give up her attempts to foil the Buds' plans to maintain total coolness!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1990-09-02",
  },
  {
    id: 1164,
    url: "https://www.tvmaze.com/shows/1164/party-of-five",
    name: "Party of Five",
    genres: ["Drama", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17454.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17454.jpg",
    },
    summary:
      "<p>In <b>Party of Five</b>, five children orphaned by their parent's fatal auto accident seek to make their way in San Francisco.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1994-09-12",
  },
  {
    id: 1165,
    url: "https://www.tvmaze.com/shows/1165/picket-fences",
    name: "Picket Fences",
    genres: ["Drama", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17468.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17468.jpg",
    },
    summary:
      "<p><b>Picket Fences</b> follows the lives of the residents of the small town of Rome, Wisconsin, where weird things happen, including cows' udders exploding and a spate of people turning up dead in freezers. Struggling to maintain order in the community is Sheriff Jimmy Brock. Sheriff Brock is married to the town doctor Jill, his second wife. They attempt to raise their three children; Kimberly (from Jimmy's first marriage to Lydia), Matthew and Zachary. Max and Kenny are impulsive and somewhat immature sheriff's deputies.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1992-09-18",
  },
  {
    id: 1166,
    url: "https://www.tvmaze.com/shows/1166/agatha-christies-poirot",
    name: "Agatha Christie's Poirot",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17471.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17471.jpg",
    },
    summary:
      "<p>Reunited with old friends, Poirot takes on challenging new investigations, once again testing his ‘little grey cells'.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1989-01-08",
  },
  {
    id: 1167,
    url: "https://www.tvmaze.com/shows/1167/maison-close",
    name: "Maison Close",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17477.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17477.jpg",
    },
    summary:
      "<p><b>Les filles du Paradis avaient conquis de haute lutte leur liberté à l'issue de la saison 1. Mais le retour à l'Ordre moral dans la France de 1870 met brutalement fin à leur rêve d'indépendance. L'époque n'est pas à l'émancipation des femmes, encore moins des prostituées, et la police des mœurs tente de renvoyer les filles à leur ancien statut. Véra, Rose, Hortense et les autres décident alors de s'associer à des malfrats...</b></p>",
    officialSite: null,
    webChannel: null,
    language: "French",
    status: "Ended",
    network: {
      id: 105,
      name: "Canal+",
      country: { name: "France", code: "FR", timezone: "Europe/Paris" },
    },
    premiered: "2010-10-04",
  },
  {
    id: 1168,
    url: "https://www.tvmaze.com/shows/1168/les-revenants",
    name: "Les Revenants",
    genres: ["Drama", "Fantasy", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/272/680355.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/272/680355.jpg",
    },
    summary:
      "<p><b>Les Revenants</b> is a unique, stylish and powerful supernatural drama. It follows the residents of a small French alpine town as they come to terms with a series of mysterious and unbelievable occurrences. As a small group of unknowingly deceased men, women and children return from the dead and attempt to re-join the family and friends they left behind years before, the town begins to experience a series of chilling local murders….Beautifully filmed, expertly plotted, and featuring superbly believable performances and an unforgettably atmospheric soundtrack by cult Scottish group Mogwai, The Returned is the most original and enthralling series in years.</p>",
    officialSite: "http://lesrevenants.canalplus.fr/",
    webChannel: null,
    language: "French",
    status: "Ended",
    network: {
      id: 105,
      name: "Canal+",
      country: { name: "France", code: "FR", timezone: "Europe/Paris" },
    },
    premiered: "2012-11-26",
  },
  {
    id: 1169,
    url: "https://www.tvmaze.com/shows/1169/les-rois-maudits",
    name: "Les Rois Maudits",
    genres: ["Drama", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/6/17491.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/6/17491.jpg",
    },
    summary:
      "<p>Set during the reigns of the last five kings of the Capetian dynasty and the first two kings of the House of Valois, the series begins as the French King Philip the Fair, already surrounded by scandal and intrigue, brings a curse upon his family when he persecutes the Knights Templar. The succession of monarchs that follows leads France and England to the Hundred Years' War.</p>",
    officialSite: null,
    webChannel: null,
    language: "French",
    status: "Ended",
    network: {
      id: 106,
      name: "France 2",
      country: { name: "France", code: "FR", timezone: "Europe/Paris" },
    },
    premiered: "2005-11-07",
  },
  {
    id: 1170,
    url: "https://www.tvmaze.com/shows/1170/mysteries-at-the-castle",
    name: "Mysteries at the Castle",
    genres: ["Mystery", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/43/108413.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/43/108413.jpg",
    },
    summary:
      "<p>Behind the gates of the world's most impressive castles, manor houses and mansions are secrets waiting to be revealed. See these amazing structures in all their glory and hear the remarkable, mysterious and bizarre tales tied to the rich and powerful who once resided there. From a German castle where a real life Dr. Frankenstein tried to breathe life into the dead to the magnificent Highclere Castle, which is now the setting for Downton Abbey, but was once the home of an English lord who unearthed King Tut's tomb, these stories will captivate and amaze. Go inside the castles, manors and mansions with our behind-the-scenes photos, and watch exclusive video of the stories and secrets hidden in their history. The first season of <b>Mysteries at the Castle</b> aired under the name 'Castles, Secrets and Legends'.</p>",
    officialSite: "http://www.travelchannel.com/shows/mysteries-at-the-castle",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 82,
      name: "Travel Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-19",
  },
  {
    id: 1171,
    url: "https://www.tvmaze.com/shows/1171/branson-famous",
    name: "Branson Famous",
    genres: ["Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17501.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17501.jpg",
    },
    summary:
      '<p>truTV breaks new ground in this first-ever "reality musical" and goes behind the scenes of the longest-running variety show in Branson, MO with the Mabe family. With the backdrop of decades-old feuds, burning jealousies, and sequined costume changes, the Mabes take their legacy, "The Baldknobbers Jamboree", very seriously. But get ready, because their passion for country music is not confined to the stage, and they just might break into song when you least expect it.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 84,
      name: "truTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-12-29",
  },
  {
    id: 1172,
    url: "https://www.tvmaze.com/shows/1172/big-women-big-love",
    name: "Big Women: Big Love",
    genres: ["Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17502.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17502.jpg",
    },
    summary:
      "<p>Dating can be one of the most difficult parts of a woman's life, but being extra curvy can make it that much more complicated. <b>Big Women: Big Love</b> examines the lives of five plus-sized women as they navigate the tricky waters of the turbulent and sometimes harsh dating scene, struggling through bad dates and worse judgments. Shining a light on a group of women who are rarely the focus of TV cameras, the show provides a unique point of view on their experiences in love and life.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-01",
  },
  {
    id: 1173,
    url: "https://www.tvmaze.com/shows/1173/child-genius",
    name: "Child Genius",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17503.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17503.jpg",
    },
    summary:
      "<p>Lifetime's all-new competition series <i><b>\"Child Genius\"</b></i> (#ChildGenius) centers on America's most extraordinary and gifted children and their families as they prepare for a national intelligence competition. In cooperation with American Mensa, the competition takes place over eight weeks and tests the nation's brightest young minds on their knowledge of Math, Spelling, Geography, Memory, the Human Body, U.S. Presidents, Vocabulary, Current Events, Zoology, Astronomy and Space, Inventions, Literature and the Arts, Earth Science and Logic.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-06",
  },
  {
    id: 1174,
    url: "https://www.tvmaze.com/shows/1174/open-heart",
    name: "Open Heart",
    genres: ["Drama", "Mystery", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/48/121784.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/48/121784.jpg",
    },
    summary:
      "<p>In the wake of her father's disappearance, 16-year-old Dylan Blake falls in with the wrong crowd, gets arrested, and earns court-ordered community service volunteering at Open Heart Memorial, the hospital where her mother and sister are doctors, where her grandparents are board members and benefactors and where her father was last seen the day he vanished.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 101,
      name: "TeenNick",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-20",
  },
  {
    id: 1175,
    url: "https://www.tvmaze.com/shows/1175/nightwatch",
    name: "Nightwatch",
    genres: ["Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/301/754711.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/301/754711.jpg",
    },
    summary:
      "<p>In the historic city of New Orleans, police officers, firefighters and EMTs working the overnight shift answer as many as a thousand emergency calls a night. <b>Nightwatch</b> follows multiple sets of partners in the New Orleans Emergency Medical Services unit who cover the intense and unpredictable period from 8 PM to 4 AM as they battle time and circumstance to save lives. The skills, dedication and determination that these critical and dangerous jobs require are on full display nightly while each new traumatic call comes in. As the city's heroes, one thing remains clear - the job of an emergency responder in NOLA is not only about saving lives, it's being there as a support system for the community of people in this diverse and inspiring city.</p>",
    officialSite: "http://www.aetv.com/shows/nightwatch",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-22",
  },
  {
    id: 1176,
    url: "https://www.tvmaze.com/shows/1176/the-slap",
    name: "The Slap",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/51/128171.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/51/128171.jpg",
    },
    summary:
      "<p>Meet Hector: a public servant, husband, father and valued friend on the cusp of his 40th. Meet Aisha: Hector's beautiful and intelligent wife who is planning his birthday party filled with friends and his very boisterous Greek family. Sounds like the makings of a great day, right? Wrong. As Hector tries to navigate family politics, awkward friendships and the young woman he is dangerously captivated by, the built-up tension explodes when Hector's hotheaded cousin slaps another couple's misbehaving child. Everyone is understandably stunned, and the party abruptly ends with the child's parents vowing legal action. But what the hosts and guests don't know is that this moment will ignite a chain of events that will uncover long-buried secrets within this group of friends and family ... and vigorously challenge the core values of everyone involved.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-12",
  },
  {
    id: 1177,
    url: "https://www.tvmaze.com/shows/1177/good-witch",
    name: "Good Witch",
    genres: ["Family", "Romance", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/317/792661.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/317/792661.jpg",
    },
    summary:
      "<p>Cassie Nightingale, Middleton's favorite enchantress, and her young-teenage daughter Grace, who shares that same special intuition as her mom, welcome Dr. Sam Radford and his son to town. When the New York transplants move in next to the Grey House, they are immediately spellbound by the mother-daughter duo next door, but Sam and Cassie quickly find they may not see eye to eye. With her signature charm, Cassie attempts to bring everyone together, ensuring all of Middleton is in for new changes, big surprises and, of course, a little bit of magic!</p><p>Based on the <b>Good Witch</b> series of cable movies.</p>",
    officialSite: "http://www.hallmarkchannel.com/good-witch",
    webChannel: {
      id: 98,
      name: "Hallmark Channel Everywhere",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Running",
    network: {
      id: 50,
      name: "Hallmark Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-01-18",
  },
  {
    id: 1178,
    url: "https://www.tvmaze.com/shows/1178/american-odyssey",
    name: "American Odyssey",
    genres: ["Action", "Adventure", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/76/191429.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/76/191429.jpg",
    },
    summary:
      "<p>When Sgt. Odelle Ballard stumbles upon an explosive secret, she must do whatever it takes to survive and find a way back to her family.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-05",
  },
  {
    id: 1179,
    url: "https://www.tvmaze.com/shows/1179/wayward-pines",
    name: "Wayward Pines",
    genres: ["Drama", "Science-Fiction", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/54/135773.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/54/135773.jpg",
    },
    summary:
      "<p>Imagine the perfect American town... beautiful homes, manicured lawns, children playing safely in the streets. Now imagine never being able to leave. You have no communication with the outside world. You think you're going insane. You must be in <b>Wayward Pines</b>.</p>",
    officialSite: "http://www.fox.com/wayward-pines/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-14",
  },
  {
    id: 1180,
    url: "https://www.tvmaze.com/shows/1180/museum-men",
    name: "Museum Men",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31662.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31662.jpg",
    },
    summary:
      "<p>Whether it's the famous steps of the Titanic or the legendary lunar landing of Apollo 13, there is no museum exhibit that the expert builders at Creative Arts Unlimited, Inc. can't re-create. Viewers will follow these highly skilled craftsmen as they use their expertise to meticulously rebuild history in museums across the nation. Led by Roger Barganier (co-founder, president and creative director), the team at Creative Arts Unlimited, approach each build with a determination to tell a story.</p><p>Every exhibit that is produced by the Museum Men is engaging, informative, and historically accurate. No detail is overlooked, because for Creative Arts authenticity is everything. In addition to building for museums, Creative Arts also re-creates items for private collections. But whoever the recipient may be, every build poses unique challenges, including hard-to-find research, demanding schedules, and obsolete methods of construction.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 74,
      name: "H2",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-29",
  },
  {
    id: 1181,
    url: "https://www.tvmaze.com/shows/1181/sex-sent-me-to-the-er",
    name: "Sex Sent Me to the ER",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17522.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17522.jpg",
    },
    summary:
      "<p>Having sex while skydiving? Falling in a grave after having sex in a cemetery? Being bit by a giant centipede during sex? These are just some of the extraordinary situations ordinary people get themselves into while being too adventurous with their significant others. But when dreaming up these outrageous fantasies, most don't expect such activities to land them in the emergency room as a result. We head into the emergency room for horrifying and hilarious sex adventures turned medical mishaps, retold by emergency room physicians and the actual couples who took part in the sexual escapades.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-12-28",
  },
  {
    id: 1182,
    url: "https://www.tvmaze.com/shows/1182/id-kill-for-you",
    name: "I'd Kill for You",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31450.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31450.jpg",
    },
    summary:
      "<p>How far would you go for the person you love? Would you lie for them, die for them... or even kill for them? <b>\"I'd Kill For You\"</b> lifts the lid on unbelievable crimes in which one human's love is chosen over another's life. These pre-meditated, highly calculated killings were all orchestrated by a twisted manipulator who used their love as the ultimate murder weapon.</p>",
    officialSite:
      "https://www.investigationdiscovery.com/tv-shows/id-kill-for-you/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-11-02",
  },
  {
    id: 1183,
    url: "https://www.tvmaze.com/shows/1183/railroad-alaska",
    name: "Railroad Alaska",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17524.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17524.jpg",
    },
    summary:
      '<p>Stretching over 500 miles of wilderness, cutting through dense forest and plowing into thick snow, lies the Alaskan Railroad. This October, Destination America makes a return trip through the Last Frontier with a second season of <i><b>"Railroad Alaska"</b></i>, chronicling everyday challenges faced by isolated homesteaders living along Alaska\'s critical railway. The series follows an elite crew who tirelessly work to keep the train rolling 365 days a year in order to deliver life-sustaining supplies to Americans living off the grid and miles away from civilization. With dedication, tenacity and a bit of grit, these Alaskans have truly mastered the splendor of living life on the track.</p>',
    officialSite: "http://www.destinationamerica.com/tv-shows/railroad-alaska/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 107,
      name: "Destination America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-11-16",
  },
  {
    id: 1184,
    url: "https://www.tvmaze.com/shows/1184/america-unearthed",
    name: "America Unearthed",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/215/537845.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/215/537845.jpg",
    },
    summary:
      '<p>Forensic geologist Scott Wolter, a real-life Indiana Jones, reveals that the history we all learned in school may not always be the whole story. Across the country, ancient symbols, religious relics and unexplained artifacts suggest that civilizations from around the world have left their mark for us to find today. Wolter not only digs through the surprising burial ground that is America for archaeological secrets, but he also uncovers compelling evidence that pre-dates the official "discovery" of the New World and turns a lot of what we think we know about American history on its head.</p>',
    officialSite: "https://www.travelchannel.com/shows/america-unearthed",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 82,
      name: "Travel Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-12-21",
  },
  {
    id: 1185,
    url: "https://www.tvmaze.com/shows/1185/fatal-vows",
    name: "Fatal Vows",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755216.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755216.jpg",
    },
    summary:
      "<p>When marriages fail, divorce can turn ugly - even, deadly: what was once a passionate union becomes plagued by spite, greed, betrayal and, literally, backstabbing. Each episode explores tumultuous, shocking, and disturbing divorces, and delves into the criminal psychology behind what actually happens when one spouse determines that the only way out is murder. Guiding viewers through these crimes of passion are Dr. Brian Russell, an attorney as well as a forensic and clinical psychologist, and Stacy Kaiser, a licensed psychotherapist and relationship expert. In each episode, the two experts examine the couple featured and provide analysis on marriages that break down to the point that divorce and murder collide.</p>",
    officialSite: "https://www.investigationdiscovery.com/tv-shows/fatal-vows/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-11-17",
  },
  {
    id: 1186,
    url: "https://www.tvmaze.com/shows/1186/extreme-escapes",
    name: "Extreme Escapes",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23748.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23748.jpg",
    },
    summary:
      "<p><b>Extreme Escapes</b> brings the shock, wonder and danger of escapology to television with astonishing performances by artists including America's Got Talent contestant Spencer Horsman, Masters of Illusion LIVE! performer Farrell Dillon, Las Vegas Laugh Factory's headlining comic magician Murray Sawchuck and his counterpart Jan Rouven and Hungarian escape artist David Merlini. Other daring stunts attempted on Extreme Escapes include illusionist Jonathan Pendragon putting himself in the line of fire for a dangerous and often deadly feat - attempting to catch a speeding bullet. The series also features a precarious escape set in China where internationally acclaimed illusionist Franz Harary must break free from the chains binding him to railroad tracks in the face of a powerful locomotive.</p>",
    officialSite: "http://www.reelz.com/extreme-escapes/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 75,
      name: "REELZ",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-29",
  },
  {
    id: 1187,
    url: "https://www.tvmaze.com/shows/1187/caught-on-camera-with-nick-cannon",
    name: "Caught on Camera with Nick Cannon",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/40/102452.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/40/102452.jpg",
    },
    summary:
      "<p><b>Caught on Camera with Nick Cannon</b> lets viewers in on the hijinks captured by the unblinking eyes of cell phones, dash cams, security cameras, news crews and camcorders around the world.</p><p>This riveting new series is storytelling at its best, providing a first-person account of what's happening on-screen from those who lived it, recorded it and saw it happen, as told in their own words.</p>",
    officialSite: "http://www.nbc.com/caught-on-camera",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-12-19",
  },
  {
    id: 1189,
    url: "https://www.tvmaze.com/shows/1189/say-yes-to-the-dress-since-the-big-day",
    name: "Say Yes to the Dress: Since the Big Day",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/30357.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/30357.jpg",
    },
    summary:
      "<p>Ever wondered what happens to the couples from <b>Say Yes to the Dress: Since the Big Day</b> after they exchange vows? For the first time, get an unprecedented look at the everyday lives these unforgettable couples share.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-12-26",
  },
  {
    id: 1190,
    url: "https://www.tvmaze.com/shows/1190/wives-with-knives",
    name: "Wives with Knives",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755215.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755215.jpg",
    },
    summary:
      "<p><b>Wives with Knives</b> features gripping stories of women who fight at close range. Some women endured years of sexual, emotional, and physical abuse before fighting back. Others were motivated by greed and jealousy. Some of the victims died and others lived to testify against their attackers. Through personal accounts from the actual women who committed the crimes, as well as the victims themselves, each episode reveals the traumatic events that led to the pair's disturbing demise.</p>",
    officialSite:
      "http://www.investigationdiscovery.com/tv-shows/wives-with-knives/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-11-23",
  },
  {
    id: 1191,
    url: "https://www.tvmaze.com/shows/1191/something-borrowed-something-new",
    name: "Something Borrowed, Something New",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17529.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17529.jpg",
    },
    summary:
      "<p>In <i>Something Borrowed</i>, <i>Something New</i>, brides must choose between a borrowed and reworked wedding dress or a brand-new gown.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-02-08",
  },
  {
    id: 1192,
    url: "https://www.tvmaze.com/shows/1192/brad-meltzers-lost-history",
    name: "Brad Meltzer's Lost History",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17530.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17530.jpg",
    },
    summary:
      "<p>American history is vanishing one artifact at a time. Some of our most important historical and cultural treasures have been lost or stolen. Every year, dozens of treasures, from George Washington's teeth to the Apollo 11 moon landing tapes to even the iconic ground zero flag from the September 11 attacks, vanish from the shelves of famous museums, government archives and private collections.</p><p>Now, host Brad Meltzer leads the hunt to return these treasures to their rightful owners–the American people. Many lost artifacts are circulating on the black market, but dozens of previously lost objects have already been found—by ordinary citizens—in attics, at garage sales and even online. Brad will also enlist the help of viewers, giving the public the chance to help restore our history too.</p>",
    officialSite: "http://www.history.com/shows/brad-meltzers-lost-history",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 74,
      name: "H2",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-31",
  },
  {
    id: 1193,
    url: "https://www.tvmaze.com/shows/1193/who-the-bleep-did-i-marry",
    name: "Who The (Bleep) Did I Marry?",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17531.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17531.jpg",
    },
    summary:
      '<p><b>Who The (Bleep) Did I Marry?</b> showcases spouses of liars, cheaters, and thieves, these women have unknowingly signed up for much more than a happy honeymoon and a new last name. All told in shocking first-hand accounts, each episode tells the story of an "I do" turned "You did WHAT?"</p>',
    officialSite:
      "http://www.investigationdiscovery.com/tv-shows/who-the-bleep-did-i-marry/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-08-25",
  },
  {
    id: 1194,
    url: "https://www.tvmaze.com/shows/1194/finding-bigfoot",
    name: "Finding Bigfoot",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17532.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17532.jpg",
    },
    summary:
      "<p><b>Finding Bigfoot</b> follows four passionate researchers and explorers investigating potential evidence of Bigfoot.</p>",
    officialSite: "http://www.animalplanet.com/tv-shows/finding-bigfoot/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 92,
      name: "Animal Planet",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-05-30",
  },
  {
    id: 1195,
    url: "https://www.tvmaze.com/shows/1195/alaska-the-last-frontier",
    name: "Alaska: The Last Frontier",
    genres: ["Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/120/301771.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/120/301771.jpg",
    },
    summary:
      "<p><b>Alaska: The Last Frontier </b>follows the Kilcher family and their simple, off-the-grid lifestyle.The show documents the extended Kilcher family, descendants of a Swiss immigrant Alaska pioneer, at their homestead 11 miles outside of Homer. By living without plumbing or modern heating, the clan must subsist by hunting and preparing for the long winters. The Kilcher family are relatives of the singer Jewel.</p>",
    officialSite: "http://www.discovery.com/tv-shows/alaska-the-last-frontier/",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-12-29",
  },
  {
    id: 1196,
    url: "https://www.tvmaze.com/shows/1196/most-evil",
    name: "Most Evil",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17534.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17534.jpg",
    },
    summary:
      "<p>In <b>Most Evil</b>, clinical and forensic psychologist Dr. Kris Mohandie examines the criminal mind to decode a killer's motive, method and thought process.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-07-13",
  },
  {
    id: 1197,
    url: "https://www.tvmaze.com/shows/1197/a-haunting",
    name: "A Haunting",
    genres: ["Drama", "Horror", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/317/793830.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/317/793830.jpg",
    },
    summary:
      '<p>"When the door between the spirit world and ours is opened, the stuff of nightmares becomes reality". That\'s according to the introduction of this series, <b>A Haunting</b>, which dramatizes the "true" stories of people who have been haunted or experienced a haunting. In this docu-drama, the actual people involved recount their stories on-camera, as the frightening events of their stories are re-enacted....</p>',
    officialSite: "https://www.travelchannel.com/shows/a-haunting",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 82,
      name: "Travel Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-10-28",
  },
  {
    id: 1198,
    url: "https://www.tvmaze.com/shows/1198/cutthroat-kitchen",
    name: "Cutthroat Kitchen",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17536.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17536.jpg",
    },
    summary:
      "<p>Just how far is a chef willing to go to win a cooking competition? <b>Cutthroat Kitchen</b> hands four chefs each $25,000 and the opportunity to spend that money on helping themselves or sabotaging their competitors. Ingredients will be thieved, utensils destroyed and valuable time on the clock lost when the chefs compete to cook delicious dishes while also having to outplot the competition. With Alton Brown as the devilish provocateur, nothing is out of bounds when money changes hands and we see just how far chefs will go to ensure they have the winning dish.</p>",
    officialSite: "http://www.foodnetwork.com/shows/cutthroat-kitchen.html",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 81,
      name: "Food Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-08-11",
  },
  {
    id: 1200,
    url: "https://www.tvmaze.com/shows/1200/alaska-off-road-warriors",
    name: "Alaska Off-Road Warriors",
    genres: ["Adventure", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17537.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17537.jpg",
    },
    summary:
      "<p><b>Alaska Off-Road Warriors</b> pits five teams of two in a grueling off-road challenge across Alaska. Journeying from the Pacific Ocean to the Arctic Ocean, this is an intense expedition and an adventure of epic proportions. From the muddy terrain to the unpredictable wilderness, these teams will travel across eight of the most dangerous and rugged trails in the world. The trails will be divided into two legs and the team with the lowest aggregated time from all the trails will be named the winner. As they race against time–and each other–the perils of their journey will not only test their trusty vehicles, but the teams themselves. Which team will be the victor of this quest to find out who can navigate the extreme wilderness of Alaska?</p>",
    officialSite: "http://www.history.com/shows/alaska-off-road-warriors",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-30",
  },
  {
    id: 1201,
    url: "https://www.tvmaze.com/shows/1201/bizarre-foods-with-andrew-zimmern",
    name: "Bizarre Foods with Andrew Zimmern",
    genres: ["Food", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17538.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17538.jpg",
    },
    summary:
      "<p><b>Bizarre Foods with Andrew Zimmern</b> is back with another round of exotic eats from around the globe! After 6 seasons of Bizarre Foods America exploring unusual edibles in his own backyard, Zimmern is dusting off his passport once again to crisscross the globe in search of the world's most bizarre foods. Zimmern believes that the best way to explore other cultures is by sharing food, even though what's common fare in one country may be a challenge for the western palate. In Bizarre Foods, this adventurous eater infiltrates markets and restaurants taking viewers behind the scenes to savor the local cuisine - even if that means gulping down ant eggs in Mexico City or slurping on snails in Portugal. This curious traveler is game for anything and knows the most interesting food is found closest to the source.</p>",
    officialSite: "http://www.travelchannel.com/shows/bizarre-foods",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 82,
      name: "Travel Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-02-26",
  },
  {
    id: 1202,
    url: "https://www.tvmaze.com/shows/1202/street-outlaws-full-throttle",
    name: "Street Outlaws: Full Throttle",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/82/205073.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/82/205073.jpg",
    },
    summary:
      '<p><b>Street Outlaws: Full Throttle</b> is a series that airs extended enhanced episodes with extra information, deleted scenes and bonus unseen footage from the show "Street Outlaws" that also airs on the Discovery Channel. With a more competitive list, the bets are higher, the smack talk is louder, and the races are faster than ever before. This season, the 405 face their fastest challengers yet, putting their status as the "fastest racers in the country" on the line. The stakes are high for the "baddest" and best on the scene, with the 405 members fighting to get on the "list" of the 10 fastest cars in Oklahoma City. These guys will do anything to get and stay ranked, even if it means running from the law! This season, Midwest Streetcars\' business is booming, making Shawn, Big Chief, and Kamikaze\'s goal of moving up the ranks even more fierce. The antics continue, as Farmtruck and AZN create a 61 MPH mobility scooter and haunt the Oklahoma City streets in their driverless hearse.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-06-21",
  },
  {
    id: 1203,
    url: "https://www.tvmaze.com/shows/1203/the-little-couple",
    name: "The Little Couple",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17543.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17543.jpg",
    },
    summary:
      "<p><b>The Little Couple</b>, following newlyweds Bill Klein and Jen Arnold. Bill, a successful businessman, and Jen, a pediatrician, who are both under four feet tall, share their unique perspectives on life, love, and marriage.</p>",
    officialSite: "https://www.tlc.com/tv-shows/little-couple/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-05-26",
  },
  {
    id: 1204,
    url: "https://www.tvmaze.com/shows/1204/a-crime-to-remember",
    name: "A Crime to Remember",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17544.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17544.jpg",
    },
    summary:
      '<p>Styles may change, but murder lasts forever. <b>A Crime to Remember</b> invites viewers to step into the past and unravel the intricacies of real-life murder cases of the ‘50s and ‘60s. Set against the backdrop of Studebakers, fedoras, and three-martini lunches, these stories of truly mad men and women reveal complicated relationships where thwarted dreams and repressed passions led to terrible crimes. With A Crime to Remember, ID inaugurates a new high-end cinematic style, using the visual grammar of movies to bring the era to life. To properly illustrate each time period, the series stays true to the fashion and styles while highlighting the cultural taboos and social norms that informed each case. Each story is driven by the narrative of a fictional bystander who "knew" the victim, while reporters who covered the case explain how the crime and investigation impacted society.</p>',
    officialSite:
      "http://www.investigationdiscovery.com/tv-shows/a-crime-to-remember/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-11-12",
  },
  {
    id: 1205,
    url: "https://www.tvmaze.com/shows/1205/suave-says",
    name: "Suave Says",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31687.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31687.jpg",
    },
    summary:
      "<p>Funny, fun and full of heart, Suave Says will follow famous lain lover turned preacher, Gerardo Mejia, as he fights to keep his family together the only way he knows how; with laughter and love.</p><p>In the early 1990s Gerardo Mejia had it all. Thanks to his smash-hit single, \"Rico Suave,\" he was living the good life with all of the fame, fortune, and women to show for it. Twenty years later, Gerardo's life is still pretty good if not just a little bit different. While he is no longer a rockstar, Gerardo continues to be adored by many (as a record exec turned minister) and remains surrounded by beautiful women -- only now they are his wife and daughters.</p><p>Following the success of his big single, Gerardo went on to become an influential A&amp;R executive at Interscope Records, married Kathy (a former beauty queen), and had 3 beautiful children— Bianca, Nadia and Jaden. However, despite Gerardo's early success, life was not always easy in the Mejia household.</p><p>Over the years, Kathy and the kids weathered the storm of success and what comes after it. With the admission of infidelities spanning a decade, Gerardo and Kathy are now trying to pick up the pieces of their marriage and reconnect with their children.</p><p>But even without a marriage to repair, Gerardo and Kathy would have their hands full. At least two of their three kids plan to follow in their father's famous footsteps. Nadia is an aspiring singer/model and Jaden wants to make it as a rapper. Meanwhile, older sister, Bianca, just moved back into the family home..and brought her new boyfriend, Zack, with her. Rounding out the hectic household is Gerardo's 20 year-old niece, Lexi, as well as her toddler son.</p><p>So get ready because in this family, the only constant is craziness. And while dad might be Mr. Suave himself, life in the Mejia household is anything but smooth.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 55,
      name: "VH1",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-12-03",
  },
  {
    id: 1206,
    url: "https://www.tvmaze.com/shows/1206/little-women-la",
    name: "Little Women: LA",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17546.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17546.jpg",
    },
    summary:
      "<p>Terra Jolé, Tonya Banks, Elena Gant, Christy McGinity Gibel, Traci Harrison Tsou and Briana Manson all return for the second season of <b>Little Women: LA,</b> and the stakes are higher than ever. When a shocking baby announcement is made and there's a new little lady in town, the group's friendships are pushed to the limit. In each hour-long episode, viewers get a unique glimpse into the lives of these girlfriends as they wade through the ups and downs of life, supporting one another every step of the way as they prove, once again, that height is just a number.</p>",
    officialSite: "http://www.mylifetime.com/shows/little-women-la",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-05-27",
  },
  {
    id: 1207,
    url: "https://www.tvmaze.com/shows/1207/the-millionaire-matchmaker",
    name: "The Millionaire Matchmaker",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17547.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17547.jpg",
    },
    summary:
      "<p>Bravo Media rolls out the red carpet for a slew of celebrity and Bravolebrity guests when The Millionaire Matchmaker returns. Patti Stanger is shaking things up this season with fresh methods, a new team and dozens of celebrities appearing as daters, experts and Patti's co-conspirators. <br><br> This season, Patti is back like you've never seen her before with a new bag of tricks to find love for her successful and high-profile clients. Her guidance leads to a surprise on-screen proposal, but can she use her expertise to help the couple seal the deal? Patti's clients and experts are a \"who's who\" of Hollywood ranging from music artist Rozonda \"Chilli\" Thomas of TLC to famed television personality and designer Kristin Cavallari. Bravolebrities will also make appearances at The Millionaires Club including Reza Farahan, Caroline Manzo, Sonja Morgan and more. <br><br> Patti has a dream team of new and familiar faces to help her roll up her sleeves and return to her matchmaking roots. David Cruz returns as Patti's Director of Matchmaking with new staffer Candace Smith who will serve as the Director of Recruiting.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-01-22",
  },
  {
    id: 1208,
    url: "https://www.tvmaze.com/shows/1208/alaskan-bush-people",
    name: "Alaskan Bush People",
    genres: ["Adventure", "Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/205/513185.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/205/513185.jpg",
    },
    summary:
      '<p>In <b>Alaskan Bush People</b>, a family of nine strives to be self-sufficient against all odds- often shunning modern society to live off the wilderness and to walk where no man has ever walked before. After the tragic death of his parents and sister that left him orphaned at 16, Billy Brown vowed to live life on his own terms and create his own family to reclaim the love that he lost. With Ami by his side, Billy traveled the lower 48 states and eventually found home in the sprawling landscape of the last frontier, where they have spent most of the last 30 years raising their children. "Our family is doing what is natural for human beings to do. We survive on what we hunt, fish, trap and barter for," Brown says. "We explore, we wander, we live. If you think about it, it\'s the life we were meant to live."</p>',
    officialSite: "http://www.discovery.com/tv-shows/alaskan-bush-people/",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-05-06",
  },
  {
    id: 1209,
    url: "https://www.tvmaze.com/shows/1209/the-curse-of-oak-island",
    name: "The Curse of Oak Island",
    genres: ["Adventure", "Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/279/698507.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/279/698507.jpg",
    },
    summary:
      "<p><b>The Curse of Oak Island</b> documents brothers Rick and Marty Lagina as they pursue their lifelong dream of solving more than a 220-year old Oak Island mystery. For over two centuries, teams of searchers, including Franklin D. Roosevelt, have attempted to crack the code that will unearth the treasure believed to be buried on the small island off the coast of Nova Scotia. Armed with the knowledge of those that came before them, the muscle of heavy machinery and decades of engineering know-how, the Lagina's and their partners may be closer than anyone in history to finding the treasure that has so far claimed the lives of six men.</p>",
    officialSite: "http://www.history.com/shows/the-curse-of-oak-island",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-05",
  },
  {
    id: 1210,
    url: "https://www.tvmaze.com/shows/1210/how-to-make-it-in-america",
    name: "How to Make It in America",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17558.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17558.jpg",
    },
    summary:
      "<p><b>How to Make It in America</b> follows two enterprising Brooklyn twentysomethings as they hustle their way through New York City, determined to achieve the American Dream. Trying to make a name for themselves in New York's competitive fashion scene, Ben Epstein and his friend and business partner Cam Calderon use their street knowledge and connections to bring their ambitions to fruition. With the help of Cam's cousin Rene, who is trying to market his own high-energy drink, and their well-connected friend Domingo, the burgeoning entrepreneurs set out to make it big, encountering obstacles along the way that will require all their ingenuity to overcome.</p>",
    officialSite: "https://www.hbo.com/how-to-make-it-in-america",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-02-14",
  },
  {
    id: 1211,
    url: "https://www.tvmaze.com/shows/1211/mixology",
    name: "Mixology",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17559.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17559.jpg",
    },
    summary:
      "<p>When Tom is dumped by his fiancee, friends Cal and Bruce force him back into the dating pool at Mix, a high-end bar in Manhattan's meat-packing district. Out on the town for the first time in a decade, his first encounter -- with a beautiful but brutal attorney -- ends in tears, and things get worse from there. Other members of Union's chic crowd include an engaged-for-now woman, an aggressive single mom, a bubbly waitress, a mysterious bartender, and a failed entrepreneur, who is having the worst night of his life.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-02-26",
  },
  {
    id: 1212,
    url: "https://www.tvmaze.com/shows/1212/almost-royal",
    name: "Almost Royal",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17570.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17570.jpg",
    },
    summary:
      "<p>In the first season of <b>Almost Royal</b>, Georgie and Poppy Carlton, the 57th and 58th in line to the throne, travelled all over the United States - from Texas to Michigan and California to New York - familiarizing themselves with this great country and its even greater citizens. Now, Georgie and Poppy return to continue their examination of American culture, exploring subjects like beauty, holidays, sport and law and order. Leaving no stone unturned, they will dig deep to push the boundaries of documentary journalism to show the world what America looks like from a British - almost royal - point of view.</p>",
    officialSite: "http://www.bbcamerica.com/almost-royal/show/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 15,
      name: "BBC America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-06-21",
  },
  {
    id: 1213,
    url: "https://www.tvmaze.com/shows/1213/cleaners",
    name: "Cleaners",
    genres: ["Action", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17584.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17584.jpg",
    },
    summary:
      "<p><b>Cleaners</b> follows two gorgeous young women who turn out to be a team of highly trained and lethal contract killers. In season one, an errand for their boss goes bad and the duo quickly find themselves as the target of their boss' client, the FBI - and even their own boss - whose team of assassins is now out to eliminate them. Season 2 opens on a Caribbean island two weeks after the end of season one. Veronica and Roxie realize they have not escaped their past just yet... The female assassins find themselves trying to take down a major drug cartel and are entangled in the trappings of Mother who is trying to hunt them down. All the while, Agent Barnes is on a mission to take down Mother.</p>",
    officialSite: null,
    webChannel: {
      id: 4,
      name: "Crackle",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2013-10-03",
  },
  {
    id: 1214,
    url: "https://www.tvmaze.com/shows/1214/come-fly-with-me",
    name: "Come Fly with Me",
    genres: ["Comedy", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17599.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17599.jpg",
    },
    summary:
      "<p>Comedy series set in a busy airport written by and starring Matt Lucas and David Walliams.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00trc9v",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-12-25",
  },
  {
    id: 1215,
    url: "https://www.tvmaze.com/shows/1215/hollands-hoop",
    name: "Hollands Hoop",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/243/609741.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/243/609741.jpg",
    },
    summary:
      "<p>When forensic psychiatrist Fokke Augustine inherited a farm from his father, he's at home with a burnout. He decides to move to the Groningen countryside with his family. The farm appears to be a marijuana empire and is part of a criminal network. The ethical sense of Fokke is crumbling, especially when he is successful with doubtful activities.</p>",
    officialSite: "http://www.hollandshoop.nl/",
    webChannel: null,
    language: "Dutch",
    status: "Ended",
    network: {
      id: 1020,
      name: "NPO 3",
      country: {
        name: "Netherlands",
        code: "NL",
        timezone: "Europe/Amsterdam",
      },
    },
    premiered: "2014-09-27",
  },
  {
    id: 1216,
    url: "https://www.tvmaze.com/shows/1216/bosch",
    name: "Bosch",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/324/811995.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/324/811995.jpg",
    },
    summary:
      "<p>Based on Michael Connelly's best-selling novels, Harry Bosch, an LAPD homicide detective, stands trial for the fatal shooting of a serial murder suspect. A cold case involving the remains of a missing boy forces Bosch to confront his past.</p>",
    officialSite: "https://www.amazon.com/dp/B00I3MQNWG/",
    webChannel: { id: 3, name: "Amazon Prime Video", country: null },
    language: "English",
    status: "Running",
    network: null,
    premiered: "2014-02-06",
  },
  {
    id: 1217,
    url: "https://www.tvmaze.com/shows/1217/the-defenders",
    name: "The Defenders",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17604.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17604.jpg",
    },
    summary:
      "<p><b>The Defenders</b> is a drama about two colorful Las Vegas defense attorneys who go all-in when it comes to representing their clients. Nick and Pete are the local go-to guys with an eclectic client list who are still looking to hit their own jackpot. Leading the law firm of Morelli &amp; Kaczmarek are Nick Morelli, an earnest, hard-charging attorney who represents his clients to the best of his ability, no matter how big or small the case; and his partner, Pete Kaczmarek, whose passion for the law is matched only by his love of fast cars, beautiful women and expensive clothes. Joining them in their growing law practice is new associate Lisa Tyler, an enthusiastic young attorney looking to put her exotic dancing days behind her; and their young assistant, Sophie, a spunky and sweet ingénue who is eager to please her bosses. While Lady Luck shines on their legal careers, the partners have their hands full when it comes to their personal lives. With Pete busy cruising the Vegas Strip for his latest romantic conquest, Nick is focused on repairing a fractured marriage to his estranged wife and remaining present in the life of their young son. No matter the offense, Nick and Pete aim to prove that when the stakes are high, they're willing to bet the house on the clients they defend in Sin City.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-22",
  },
  {
    id: 1218,
    url: "https://www.tvmaze.com/shows/1218/family-tree",
    name: "Family Tree",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17607.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17607.jpg",
    },
    summary:
      "<p>Down on his luck in love and life, having recently lost his job and girlfriend, 30-year-old Tom Chadwick has an unsure sense of his own identity. But when he inherits a mysterious box, Tom starts investigating his lineage and uncovers a world of unusual stories and characters, acquiring a growing sense of who he and his entire family are.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-05-12",
  },
  {
    id: 1220,
    url: "https://www.tvmaze.com/shows/1220/wallander",
    name: "Wallander",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17620.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17620.jpg",
    },
    summary:
      "<p>This drama follows Inspector Kurt Wallander – a middle-aged everyman – as he struggles against a rising tide of violence in the apparently sleepy backwaters in and around Ystad in Skane, southern Sweden. Based on the international best-selling books by Henning Mankell.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00pxtct",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-11-30",
  },
  {
    id: 1221,
    url: "https://www.tvmaze.com/shows/1221/super-fun-night",
    name: "Super Fun Night",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17632.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17632.jpg",
    },
    summary:
      '<p>Junior attorney Kimmie Boubier and her two best friends, Helen-Alice and Marika , have had a standing date every Friday night for the last 13 years. They even have a motto for what they call "Friday Night Fun Night": "Always together! Always Inside!" However Kimmie\'s recent promotion throws a monkey wrench into the tradition. Not only is she now working with her idol, "Lady Lawyer of the Year" Felicity Vanderstone, but she meets a dashingly handsome British attorney, Richard Lovell, who invites her to his party at a trendy club. Determined to spend time with Richard and heed Felicity\'s advice to network, Kimmie sets out to convince her friends to take <b>Super Fun Night</b> on the road.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-10-02",
  },
  {
    id: 1222,
    url: "https://www.tvmaze.com/shows/1222/sleeper-cell",
    name: "Sleeper Cell",
    genres: ["Drama", "Crime", "Espionage"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17638.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17638.jpg",
    },
    summary:
      "<p>The controversial and unconventional drama delves into the harsh inner-workings of a Los Angeles-based Islamic terrorist cell headed by a charismatic and fanatical extremist (Fehr) and an Muslim undercover FBI agent (Ealy) who infiltrates it. Last year's mini-series featured a powerful and engrossing two-hour finale that will set the stage for the new <b>Sleeper Cell</b>, which will continue to combine timely, meticulously researched storylines and complex characters to create an entertaining and thought-provoking television event.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-12-04",
  },
  {
    id: 1224,
    url: "https://www.tvmaze.com/shows/1224/unsere-mutter-unsere-vater",
    name: "Unsere Mütter, unsere Väter",
    genres: ["Drama", "Action", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17646.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17646.jpg",
    },
    summary:
      "<p>The story of five German friends in the years from 1941 to 1945. Their friendship was meant to last their whole lives, but the war changed everything.</p>",
    officialSite:
      "http://www.zdf.de/unsere-muetter-unsere-vaeter/unsere-muetter-unsere-vaeter-26223848.html",
    webChannel: null,
    language: "German",
    status: "Ended",
    network: {
      id: 109,
      name: "ZDF",
      country: { name: "Germany", code: "DE", timezone: "Europe/Busingen" },
    },
    premiered: "2013-03-17",
  },
  {
    id: 1225,
    url: "https://www.tvmaze.com/shows/1225/red-widow",
    name: "Red Widow",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17647.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17647.jpg",
    },
    summary:
      "<p><b>Red Widow</b> is a riveting drama about one woman's journey into the world of organized crime, and how far she will go to keep her family safe.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-03-03",
  },
  {
    id: 1226,
    url: "https://www.tvmaze.com/shows/1226/profugos",
    name: "Profugos",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17658.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17658.jpg",
    },
    summary:
      "<p>Four men are recruited by Kika Ferragut, head of the powerful Chilean drug cartel, for a job that will change their lives: transporting tons of cocaine from Bolivia to the Chilean port of Iquique, in exchange for a million dollars.</p>",
    officialSite: null,
    webChannel: null,
    language: "Spanish",
    status: "Ended",
    network: {
      id: 110,
      name: "HBO Latin America",
      country: { name: "Chile", code: "CL", timezone: "America/Santiago" },
    },
    premiered: "2011-09-04",
  },
  {
    id: 1227,
    url: "https://www.tvmaze.com/shows/1227/prime-suspect",
    name: "Prime Suspect",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17659.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17659.jpg",
    },
    summary:
      "<p><b>Prime Suspect</b> follows tough-as-nails Detective Jane Timoney, who finds that being a homicide detective in New York City is tough enough and having to contend with a male-dominated police department to get respect makes it that much tougher. She's an outsider who has just transferred to a new precinct dominated by an impenetrable clique of a boys' club. Timoney has her own vices too -- with a questionable past -- and she tends to be forceful, rude and reckless. But she's also a brilliant cop who keeps her eye on one thing: the prime suspect.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-22",
  },
  {
    id: 1228,
    url: "https://www.tvmaze.com/shows/1228/penoza",
    name: "Penoza",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/186/465916.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/186/465916.jpg",
    },
    summary:
      "<p>Housewife Carmen van Walraven is forced to take over her family's criminal business when her husband is assassinated for trying to snitch.</p>",
    officialSite: "https://www.npostart.nl/penoza/KN_1691991",
    webChannel: null,
    language: "Dutch",
    status: "Ended",
    network: {
      id: 1020,
      name: "NPO 3",
      country: {
        name: "Netherlands",
        code: "NL",
        timezone: "Europe/Amsterdam",
      },
    },
    premiered: "2010-09-12",
  },
  {
    id: 1229,
    url: "https://www.tvmaze.com/shows/1229/paradox",
    name: "Paradox",
    genres: ["Drama", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17687.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17687.jpg",
    },
    summary:
      "<p>Mysterious images that show incidents 18 hours before they happen are transmitted from space. As a space scientist attempts to explain their source, detectives race against time to change the future.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00p70x4",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-11-24",
  },
  {
    id: 1230,
    url: "https://www.tvmaze.com/shows/1230/outsourced",
    name: "Outsourced",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17688.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17688.jpg",
    },
    summary:
      "<p>When manager Todd Dempsy returns to work after management training, he learns that the Mid America Novelties call center has been outsourced to Mumbai, India. In order to keep his job, Todd is left no choice but to relocate to India. There he meets his eclectic group of employees, and soon realizes that teaching them to understand America will be the first of many hurdles that he needs to overcome. Todd also discovers other foreign transplants working in his office building, including American expatriate Charlie Davies who runs the All American Hunter call center, and Tonya a beautiful Australian who runs the call center for Koala Air.</p><p><br></p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-23",
  },
  {
    id: 1231,
    url: "https://www.tvmaze.com/shows/1231/north-america",
    name: "North America",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17710.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17710.jpg",
    },
    summary:
      "<p>For many of us, North America is our home. We live in this extraordinary continent each and every day, but have we ever truly experienced first-hand the wide scope of incredible dangers challenging our diverse and tenacious continent? If you think you know North America, you can think again. In this unforgettable television event, Discovery Channel turns the lens toward its homeland and captures a land where life collides with hostile, untamed wilderness in the most diverse, deadly environment on Earth.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-05-19",
  },
  {
    id: 1232,
    url: "https://www.tvmaze.com/shows/1232/nieuwe-buren",
    name: "Nieuwe Buren",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/191/478228.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/191/478228.jpg",
    },
    summary:
      "<p>Dutch drama about a darkly developing relationship between two couples who are neighbours.</p>",
    officialSite: null,
    webChannel: {
      id: 12,
      name: "Videoland",
      country: {
        name: "Netherlands",
        code: "NL",
        timezone: "Europe/Amsterdam",
      },
    },
    language: "Dutch",
    status: "To Be Determined",
    network: null,
    premiered: "2014-09-14",
  },
  {
    id: 1234,
    url: "https://www.tvmaze.com/shows/1234/the-mob-doctor",
    name: "The Mob Doctor",
    genres: ["Drama", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17718.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17718.jpg",
    },
    summary:
      "<p>Dr. Grace Devlin is a top resident at Chicago's Roosevelt Medical Center. Smart and self-assured, she's heralded as one of the country's most promising young surgeons. But family ties keep her glued to her Southside roots. To pay off her brother's life-threatening gambling debt, she makes a deal with the devil and agrees to work \"off book\" for the mafia men she once despised.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-09-17",
  },
  {
    id: 1235,
    url: "https://www.tvmaze.com/shows/1235/low-winter-sun",
    name: "Low Winter Sun",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17727.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17727.jpg",
    },
    summary:
      "<p><b>Low Winter Sun</b> is a contemporary story of murder, deception, revenge and corruption in a world where the line between cops and criminals is blurred. The series begins with the murder of a cop by a fellow Detroit detective. Seemingly the perfect crime, in reality the murder activates forces that will forever alter the detective's life, and pull him into the heart of the Detroit underworld.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 20,
      name: "AMC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-08-11",
  },
  {
    id: 1236,
    url: "https://www.tvmaze.com/shows/1236/king-maxwell",
    name: "King & Maxwell",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17736.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17736.jpg",
    },
    summary:
      "<p>Sean King and Michelle Maxwell aren't your typical private investigators. Both are former Secret Service agents, and their unique skills - not to mention their razor-sharp chemistry - give them a leg up on conventional law enforcement. Maxwell is a former Olympic athlete who uses her brains, beauty and Beltway connections to solve cases. King's career in the Secret Service ended when the presidential candidate he was assigned to protect was assassinated, sending him on a downward spiral. Today, King has added a law degree to his arsenal of skills, allowing him to navigate the system in ways a typical private investigator never could. Along the way, King and Maxwell clash over everything, from her garbage-strewn car to his love of wine over beer. <b>King &amp; Maxwell</b> also features F.B.I. Special Agents Rigby and Carter, who clash with King and Maxwell over their less-than-legal methods.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-06-10",
  },
  {
    id: 1237,
    url: "https://www.tvmaze.com/shows/1237/the-kill-point",
    name: "The Kill Point",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17742.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17742.jpg",
    },
    summary:
      '<p><b>The Kill Point</b>, an eight-hour event focusing on two men as they square off during a bank heist gone horribly wrong and the hostage negotiations that ensue. John Leguizamo is "Mr. Wolf," the leader of a small group of military veterans who set out to rob a major bank in Pittsburgh. When things go awry, they\'re forced to take more than a dozen hostages from all walks of life, including a wealthy and powerful businessman\'s daughter. Suddenly, "Mr. Wolf" finds himself battling the police, the hostages and members of his own team while at the same time, fighting his own personal demons from the Iraq war and from his own war at home. Will he be sharp enough to hold it all together or lose control of the situation? And will he find redemption before it\'s too late -- and does he even care to? On the opposite side of the perimeter is "Horst Cali," the Pittsburgh Police Department Hostage Negotiator, played by Donnie Wahlberg, who must go toe-to-toe with "Mr. Wolf." "Cali" must use his wit and negotiating skills, while managing his own personal issues, to manipulate the situation and convince Wolf to free the hostages before the FBI takes control, or worse. With time of the essence and the uncertainty of the unfolding events, both men need to remain resourceful and collected or risk losing lives. <i>The Kill Point</i> reveals how the hostage takers leverage their situation and how the negotiator tries to unravel their plans. Which man will blink? Who will outsmart the other? Who will survive? It\'s a dangerous game of chess played out with human lives at stake.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 34,
      name: "Paramount Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-07-22",
  },
  {
    id: 1238,
    url: "https://www.tvmaze.com/shows/1238/the-kennedys",
    name: "The Kennedys",
    genres: ["Drama", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17745.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17745.jpg",
    },
    summary:
      "<p>The dramatic event <b>The Kennedys</b> relives the public and private joys and tragedies of the most influential family in the world, including fraternal rivalries, mob associations, drugs, and women. The event recreates the political crises that John F. Kennedy dealt with in the early days of his presidency, including the Bay of Pigs invasion, the Cuban Missile Crisis that brought the world to the brink of nuclear war, and the Civil Rights Movement.</p>",
    officialSite: "http://www.reelz.com/kennedys/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 75,
      name: "REELZ",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-04-03",
  },
  {
    id: 1239,
    url: "https://www.tvmaze.com/shows/1239/gang-related",
    name: "Gang Related",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17804.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17804.jpg",
    },
    summary:
      "<p>The series follows RYAN LOPEZ a rising star in Los Angeles' elite Gang Task Force - led by SAM CHAPEL - who teams up with longtime Task Force member CASSIUS GREEN to take on the city's most dangerous gangs, including one that he swore an allegiance to as a boy.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-05-22",
  },
  {
    id: 1240,
    url: "https://www.tvmaze.com/shows/1240/generation-kill",
    name: "Generation Kill",
    genres: ["Drama", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/42/105696.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/42/105696.jpg",
    },
    summary:
      "<p><b>Generation Kill</b> follows the highly trained Marines of First Recon Battalion through the first 40 days of the Iraq war. The seven-part miniseries portrays the true story of the young Marines' experience at the tip of the spear of the American invasion, as they contend with equipment shortages, incompetent commanding officers, ever evolving Rules of Engagement and an unclear strategy. 'Generation Kill' is based on the award-winning book by Evan Wright, who was embedded with First Recon and originally reported the story in a series of articles for Rolling Stone. The series also benefited greatly from the presence of two of the real-life Marines it depicts - Sgt. Eric Kocher and Cpl. Jeffrey Carisalez - who served as consultants. A third First Recon Marine, Sgt. Rudy Reyes, appears in the miniseries, portraying himself.</p>",
    officialSite: "http://www.hbo.com/generation-kill",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-07-13",
  },
  {
    id: 1241,
    url: "https://www.tvmaze.com/shows/1241/golden-boy",
    name: "Golden Boy",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/224/561034.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/224/561034.jpg",
    },
    summary:
      "<p>Drama about the meteoric rise of an ambitious cop who becomes the youngest police commissioner in the history of New York City.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-02-26",
  },
  {
    id: 1242,
    url: "https://www.tvmaze.com/shows/1242/hit-miss",
    name: "Hit & Miss",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/41/104210.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/41/104210.jpg",
    },
    summary:
      "<p>Mia's a contract killer with a big secret - she used to be a man. As the series starts her ex-girlfriend reveals that she's dying and that they had a child. The show follows Mia's trials as she tries to separate her killer instincts with her parental ones.</p>",
    officialSite:
      "http://go.sky.com/tvboxsets/series/content/series/d03fc67462657310VgnVCM1000000b43150a____",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 113,
      name: "Sky Atlantic",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-05-22",
  },
  {
    id: 1243,
    url: "https://www.tvmaze.com/shows/1243/houdini",
    name: "Houdini",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17834.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17834.jpg",
    },
    summary:
      "<p>The event miniseries follows the epic tales of Harry Houdini as he emerges as America's first bonafide world-renowned superstar. From humble beginnings at circus sideshows to sold-out concert halls, Eastern European immigrant Erich Weiss rose to become a household name across the globe - Houdini. Academy Award(R) winner Adrien Brody stars as The Great Harry Houdini as he finds fame, engages in espionage, battles spiritualists, and encounters the greatest names of the era, from U.S. presidents to Arthur Conan Doyle and Rasputin. A thrilling ride throughout Harry's psyche, <b>Houdini</b> delves deep behind the curtain into his life through his stunts, his visions, and his mastery of illusion.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-01",
  },
  {
    id: 1244,
    url: "https://www.tvmaze.com/shows/1244/how-to-live-with-your-parents-for-the-rest-of-your-life",
    name: "How to Live with Your Parents (for the Rest of Your Life)",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17837.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17837.jpg",
    },
    summary:
      "<p><b>How to Live with Your Parents (for the Rest of Your Life)</b> follows Polly, a recently divorced single mom who moves back in with her eccentric parents.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-04-03",
  },
  {
    id: 1245,
    url: "https://www.tvmaze.com/shows/1245/ironside",
    name: "Ironside",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17844.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17844.jpg",
    },
    summary:
      "<p>In the gritty world of the NYPD, no one's tougher than Det. Robert Ironside. He's a fearless cop who won't stop until the guilty are brought to justice. He and his trusted, handpicked team of specialists - Virgil, Holly and Teddy, as well as his former partner Gary and boss, Det. Ed Rollins- will do whatever it takes to solve New York's most difficult and notorious crimes. As a detective, Ironside's instincts are second to none, and those around him have to stay on their toes if they want to keep up because when his spine was shattered by a bullet two years ago, Ironside swore he'd never let a wheelchair slow him down.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-10-02",
  },
  {
    id: 1246,
    url: "https://www.tvmaze.com/shows/1246/the-jeff-dunham-show",
    name: "The Jeff Dunham Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17850.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17850.jpg",
    },
    summary:
      '<p><i><b>"The Jeff Dunham Show"</b></i> is a new half-hour comedy-reality show from Levity Entertainment starring ventriloquist-comedian Jeff Dunham.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-10-22",
  },
  {
    id: 1247,
    url: "https://www.tvmaze.com/shows/1247/gooische-vrouwen",
    name: "Gooische Vrouwen",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17852.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17852.jpg",
    },
    summary:
      "<p>Follows four friends in 't Gooi, a Dutch region where rich people live. One of those four friends, Cheryl, married Dutch singer Martin Morero. She moved from Amsterdam to 't Gooi. Anouk is an artist. She makes mostly erotic art. Willemijn is married to Evert. They have children together. Their marriage is reserved and sexless. She eats because of her frustrations about Evert. Claire is a lawyer and married to Anton. They have a 15 year old daughter: Merel. Anouk, Willemijn and Claire are born in 't Gooi, Cheryl is a newcomer. These four friends have to deal with the problems of well-being and richness.</p>",
    officialSite: null,
    webChannel: null,
    language: "Dutch",
    status: "Ended",
    network: {
      id: 112,
      name: "RTL4",
      country: {
        name: "Netherlands",
        code: "NL",
        timezone: "Europe/Amsterdam",
      },
    },
    premiered: "2005-10-30",
  },
  {
    id: 1248,
    url: "https://www.tvmaze.com/shows/1248/blossom",
    name: "Blossom",
    genres: ["Drama", "Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17907.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17907.jpg",
    },
    summary:
      "<p>The series changed the face of prime-time sitcoms by introducing young audiences to an eccentric teenaged girl from a broken home on the mend. A video blogger predating the Internet, <b>Blossom</b> Russo chronicled the events of her teenage life in full, hilarious and sometimes heartbreaking detail, providing inspiration to youngsters and their families for five very special seasons.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1990-07-05",
  },
  {
    id: 1249,
    url: "https://www.tvmaze.com/shows/1249/the-brady-bunch",
    name: "The Brady Bunch",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17917.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17917.jpg",
    },
    summary:
      "<p><b>The Brady Bunch</b> tells the story of Carol, a single mother of three girls – Marcia, Jan and Cindy and architect Mike Brady, a single father of three boys – Greg, Peter and Bobby who get married and blend the two families into one. Added to the mix are housekeeper Alice and dog Tiger. The Bradys' experience the same obstacles as any family, from adjusting to their new extended family, to sibling rivalry.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1969-09-26",
  },
  {
    id: 1250,
    url: "https://www.tvmaze.com/shows/1250/family-matters",
    name: "Family Matters",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17918.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17918.jpg",
    },
    summary:
      "<p>A spinoff of <i>Perfect Strangers</i>, <b>Family Matters</b> began as the at-home adventures of elevator operator Harriette Winslow and her multigenerational family. But midway through the first season, Jaleel White made a one-shot appearance as neighborhood nerd Urkel. With oversized glasses, undersized body, screechy voice and indomitable self-confidence, Urkel proved irresistibly funny, turning White into an overnight sensation and a new star of the show.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1989-09-22",
  },
  {
    id: 1251,
    url: "https://www.tvmaze.com/shows/1251/full-house",
    name: "Full House",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17933.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17933.jpg",
    },
    summary:
      "<p><b>Full House</b> follows Danny Tanner, widowed father of three young and rambunctious girls recruits his two buddies--his rock 'n' roller brother-in-law, Jesse, and his best friend, Joey, an infrequently employed stand-up comic--to move in and help him raise the brood.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1987-09-18",
  },
  {
    id: 1252,
    url: "https://www.tvmaze.com/shows/1252/saved-by-the-bell",
    name: "Saved by the Bell",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17943.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17943.jpg",
    },
    summary:
      "<p>Set in the fictional town of Palisades, California, the series follow six teenagers through their fun-filled days at Bayside School and their antic-filled nights at their favorite hang-out, The Max. Heartthrobs Zack and A.C. are forever vying for the attention of Kelly, the prettiest and most popular girl in school. Screech is the class clown and electronic genius, and fashion conscience Lis a is mostly occupied with expanding her wardrobe. Jessie is the neutralizing force, often trying to convince the gang to do the rig ht thing all while school principal Mr. Belding is continuously trying to connect with the younger generation.</p>",
    officialSite: "https://www.nbc.com/saved-by-the-bell",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1989-08-20",
  },
  {
    id: 1253,
    url: "https://www.tvmaze.com/shows/1253/punky-brewster",
    name: "Punky Brewster",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/292/731593.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/292/731593.jpg",
    },
    summary:
      "<p>Soleil Moon-Frye stars as the orphaned little girl with an indomitable spirit, who, with her faithful dog Brandon, brings light and laughter into the life of a grumpy, old photographer played by George Gaynes.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1984-09-16",
  },
  {
    id: 1254,
    url: "https://www.tvmaze.com/shows/1254/my-so-called-life",
    name: "My So-Called Life",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17956.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17956.jpg",
    },
    summary:
      "<p>An authentic portrayal of teenage and parental angst, <b>My So-Called Life</b> expressed the challenges of growing up and growing older.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1994-08-25",
  },
  {
    id: 1255,
    url: "https://www.tvmaze.com/shows/1255/pippi-longstocking",
    name: "Pippi Longstocking",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17966.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17966.jpg",
    },
    summary:
      '<p>Canadian produced animated version of the best selling <i><b>"Pippi Longstocking"</b></i> children\'s stories written by Astrid Lindgren.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 376,
      name: "Teletoon",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "1998-07-04",
  },
  {
    id: 1256,
    url: "https://www.tvmaze.com/shows/1256/kingdom-hospital",
    name: "Kingdom Hospital",
    genres: ["Horror", "Thriller", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17967.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17967.jpg",
    },
    summary:
      '<p><b>Kingdom Hospital</b> is the haunting new 15-hour drama series developed directly for television by the award-winning, best-selling master of horror. Using Lars Von Trier\'s Danish miniseries "Riget" (a.k.a. "The Kingdom") as a point of inspiration, King tells the terrifying story of The Kingdom, a hospital with a bizarre population that includes a nearly blind security guard, a nurse who regularly faints at the sight of blood and a paraplegic artist whose recovery is a step beyond miraculous. When patients and staff hear the tortured voice of a little girl crying through the halls, they are dismissive of any suggestion of mysticism of unseen powers ... but at their own peril.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-03-03",
  },
  {
    id: 1257,
    url: "https://www.tvmaze.com/shows/1257/psychoville",
    name: "Psychoville",
    genres: ["Comedy", "Thriller", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/49/123998.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/49/123998.jpg",
    },
    summary:
      "<p><b>Psychoville</b> is a BBC dark mystery psychological thriller television sit-com written by and starring The League of Gentlemen members Reece Shearsmith and Steve Pemberton. It debuted on BBC Two on 18 June 2009. Pemberton and Shearsmith each play numerous characters, with Dawn French and Jason Tompkins in additional starring roles. The first series was followed by a Halloween special, broadcast on 31 October 2010, which saw Imelda Staunton added to the main cast along with previously supporting actors Eileen Atkins and Daniel Kaluuya. The second series started broadcasting on 5 May 2011 and ended on 6 June. Reece Shearsmith has officially announced that there will not be a third series.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00vw45s",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-06-18",
  },
  {
    id: 1258,
    url: "https://www.tvmaze.com/shows/1258/my-mad-fat-diary",
    name: "My Mad Fat Diary",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/17978.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/17978.jpg",
    },
    summary:
      "<p>Drama looking at life from the perspective of funny, music-mad Rae.</p>",
    officialSite: "https://www.channel4.com/programmes/my-mad-fat-diary",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 41,
      name: "E4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-01-14",
  },
  {
    id: 1259,
    url: "https://www.tvmaze.com/shows/1259/star-wars-clone-wars",
    name: "Star Wars: Clone Wars",
    genres: ["Action", "Family", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18007.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18007.jpg",
    },
    summary:
      "<p>The Clone Wars television series chronicles the events taking place between Star Wars Episode II: Attack of the Clones and Star Wars Episode III: Revenge of the Sith. The Clone Wars will ultimately lead to the downfall of the Jedi and the rise of the Galactic Empire.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-11-07",
  },
  {
    id: 1260,
    url: "https://www.tvmaze.com/shows/1260/melrose-place",
    name: "Melrose Place",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18008.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18008.jpg",
    },
    summary:
      "<p>In an elegant Spanish-style apartment building in the trendy Melrose neighborhood of Los Angeles, a diverse group of 20-somethings have formed a close-knit surrogate family. Sydney Andrews is the landlady, still beautiful at 40, and a central figure in the lives of all her tenants, especially handsome and rebellious David Breck. Sydney started an affair with David despite her turbulent history with his estranged father, Dr. Michael Mancini. Both father and son learned through experience that Sydney was not above using blackmail to control people. Another tenant, high-powered publicist Ella Simms, once considered Sydney her mentor, but their friendship was destroyed by betrayal, and Sydney threatened to evict Ella and ruin her career. Sydney also played a pivotal role in the career of Auggie Kirkpatrick. After they met at an AA meeting, she became Auggie's sponsor and encouraged his dream to become a chef. Now a successful sous chef at the trendy restaurant Coal, Auggie has been avoiding Sydney since she began drinking again. The other tenants include Lauren Yung, a medical student in desperate need of money to pay her student loans, and Jonah Miller, an aspiring filmmaker who has just proposed to his live-in girlfriend Riley Richmond, a first-grade teacher. The newest tenant, 18-year-old Violet Foster, has just arrived in LA with her own secret connection to Sydney. When a bloody body is found floating in the courtyard pool, David is the leading suspect. However, as the police are soon to discover, almost everyone living at <b>Melrose Place</b> had a reason to want the deceased out of the way.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-09-08",
  },
  {
    id: 1262,
    url: "https://www.tvmaze.com/shows/1262/law-order-uk",
    name: "Law & Order: UK",
    genres: ["Drama", "Crime", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18188.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18188.jpg",
    },
    summary:
      "<p>In the criminal justice system, the people are represented by two separate, yet equally important groups: the police who investigate crime, and the Crown Prosecutors who prosecute the offenders. These are their stories.<i><br></i></p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-02-23",
  },
  {
    id: 1263,
    url: "https://www.tvmaze.com/shows/1263/ben-10-ultimate-alien",
    name: "Ben 10: Ultimate Alien",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18277.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18277.jpg",
    },
    summary:
      "<p>An all-new animated series follows 16-year-old Ben Tennyson as his secret identity has been revealed to the world and he's now an international mega-star super hero, loved by kids the world over but distrusted by many adults. Armed with a mysterious new Omnitrix, Ben will see action in places he's never been.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-04-23",
  },
  {
    id: 1264,
    url: "https://www.tvmaze.com/shows/1264/ben-10-omniverse",
    name: "Ben 10: Omniverse",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18280.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18280.jpg",
    },
    summary:
      '<p>Ben takes on new fiendish forms in <b>Ben 10: Omniverse</b>, Galactic Monsters. Halloween is coming early to Bellwood, and to beat scary new villains like zombie clowns and evil vampires, Ben will have to take some monster alien forms of his own. Get to know two of them, Snare-oh and Blitzwolfer, in the Ben 10 Game Creator, and check out the monstrously remixed show opening here! Monsters, mummies and werewolves may be taking over, but Ben has defended the universe from the worst of the worst. Now it\'s hero time on Monster Planet! The spooky fun begins with "Something Zombozo This Way Comes", when Ben and Rook must stop Zombozo and the Circus Freaks from turning everyone in Bellwood into zombie clowns. Tune-in to Cartoon Network every Saturday morning to see who comes out of the shadows next!</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-08-01",
  },
  {
    id: 1265,
    url: "https://www.tvmaze.com/shows/1265/angry-boys",
    name: "Angry Boys",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/77/193410.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/77/193410.jpg",
    },
    summary:
      "<p>Chris Lilley's highly anticipated series <b>Angry Boys</b> introduces you to identical Dunt twins Daniel &amp; Nathan Sims and their prison officer grandmother Gran, tyrannical Japanese mother Jen Okazaki, U.S hip hop sensation S.mouse! and Mucca Mad Boys founder Blake Oakfield.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 114,
      name: "ABC",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2011-05-11",
  },
  {
    id: 1266,
    url: "https://www.tvmaze.com/shows/1266/dreamworks-dragons",
    name: "DreamWorks Dragons",
    genres: ["Adventure", "Family", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18291.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18291.jpg",
    },
    summary:
      "<p><b>DreamWorks Dragons</b> picks up where the critically-acclaimed feature film, <i>How to Train Your Dragon</i>, left off, this weekly animated series follows the continuing adventures of Hiccup and his dragon Toothless on the island of Berk, along with the band of dragon trainers, all of whom now have dragons of their own!<br /><br /> Through their training, the kids are finding out the cool things dragons can do. Not only will they learn more about their dragons, they'll also discover new ones and battle against enemies as they explore worlds they never dreamed existed.</p>",
    officialSite: "https://www.howtotrainyourdragon.com/tv",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-08-07",
  },
  {
    id: 1267,
    url: "https://www.tvmaze.com/shows/1267/emma",
    name: "Emma",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18301.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18301.jpg",
    },
    summary:
      "<p>Nothing delights Emma more than meddling in the love lives of others. But when she takes protege Harriet Smith under her wing, her plans can only end in disaster...</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00n8s6x",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-10-04",
  },
  {
    id: 1268,
    url: "https://www.tvmaze.com/shows/1268/endeavour",
    name: "Endeavour",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/240/601298.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/240/601298.jpg",
    },
    summary:
      "<p>The early days of a young Endeavour Morse, whose experiences as a detective constable with the Oxford City Police will ultimately shape his future.</p>",
    officialSite: "http://www.itv.com/hub/endeavour/2a1229",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-04-14",
  },
  {
    id: 1269,
    url: "https://www.tvmaze.com/shows/1269/enlightened",
    name: "Enlightened",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18314.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18314.jpg",
    },
    summary:
      "<p><b>Enlightened</b> focuses on a self-destructive woman who has a spiritual awakening after a meltdown. Determined to live a more enlightened existence, the former career executive's new lifestyle wreaks havoc both at home and at work.</p>",
    officialSite: "http://www.hbo.com/enlightened",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-10-10",
  },
  {
    id: 1270,
    url: "https://www.tvmaze.com/shows/1270/extras",
    name: "Extras",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18320.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18320.jpg",
    },
    summary:
      "<p>Sitcom set in the world of film and TV extras, from the Ricky Gervais and Stephen Merchant team that dreamt up The Office.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b0070rj8",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2005-07-21",
  },
  {
    id: 1271,
    url: "https://www.tvmaze.com/shows/1271/forbrydelsen",
    name: "Forbrydelsen",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18353.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18353.jpg",
    },
    summary:
      "<p>An intense crime drama which is set in Copenhagen and revolves around Detective Inspector Sarah Lund. Each series follows a murder case day-by-day. Each episode covers twenty-four hours of the investigation. The series is noted for its plot twists, season-long storylines, dark tone and for giving equal emphasis to the stories of the murdered victim's family and the effect in political circles alongside the police investigation.</p>",
    officialSite: null,
    webChannel: null,
    language: "Danish",
    status: "Ended",
    network: {
      id: 115,
      name: "DR1",
      country: { name: "Denmark", code: "DK", timezone: "Europe/Copenhagen" },
    },
    premiered: "2007-01-07",
  },
  {
    id: 1272,
    url: "https://www.tvmaze.com/shows/1272/foyles-war",
    name: "Foyle's War",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18354.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18354.jpg",
    },
    summary:
      "<p>Post-WWII drama. Foyle, now working for British Intelligence, is drawn into the world of corrupt Nazi businessmen when a London university professor is found murdered.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2002-10-27",
  },
  {
    id: 1273,
    url: "https://www.tvmaze.com/shows/1273/important-things-with-demetri-martin",
    name: "Important Things with Demetri Martin",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18360.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18360.jpg",
    },
    summary:
      "<p><b>Important Things with Demetri Martin</b> is a stream-of-consciousness sketch and variety show that explores issues of the utmost importance, from coolness to the afterlife. With props, music, animation and stand-up, it's a great and strange journey through all-around person Demetri Martin's mind.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-02-11",
  },
  {
    id: 1274,
    url: "https://www.tvmaze.com/shows/1274/jamie-private-school-girl",
    name: "Ja'mie: Private School Girl",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18361.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18361.jpg",
    },
    summary:
      "<p><i><b>\"Ja</b></i><b>'</b><i><b>mie</b></i><b>: </b><i><b>Private School Girl\"</b></i> brings back all the things we love about Ja'mie King even though we know we probably shouldn't.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 114,
      name: "ABC",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2013-10-23",
  },
  {
    id: 1275,
    url: "https://www.tvmaze.com/shows/1275/john-adams",
    name: "John Adams",
    genres: ["Drama", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18363.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18363.jpg",
    },
    summary:
      "<p>This seven-part epic miniseries event explores American history through one of its greatest founding fathers, a fiercely independent spirit whose unwavering vision steered America through a tumultuous period.</p>",
    officialSite: "https://www.hbo.com/john-adams",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-03-16",
  },
  {
    id: 1276,
    url: "https://www.tvmaze.com/shows/1276/john-from-cincinnati",
    name: "John from Cincinnati",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/184/461278.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/184/461278.jpg",
    },
    summary:
      "<p>Just north of the border, in a tired coastal town, live three generations of the Yosts, surfing royalty turned society misfits. The Yosts' reign and reputation, once defined in the curl of a perfect wave, have been eroded by years of bad luck, addiction and hubris. But just as things are looking like they can't get worse, a stranger named John arrives – and the Yosts' banal existence is lifted into something profound, miraculous and, possibly, universal. Set in Imperial Beach, California, the last great surf-break before Tijuana, where the U.S. meets Mexico, and water meets land, John From Cincinnati tells the story of the Yosts, a family of surfers whose awesome athletic talents have seemed for generations to come with a curse attached. The gifts of 13-year-old Shaun rival those of Butchie, his addict-derelict father, and his now-ascetically-withdrawn grandfather Mitch, both of whom defined the sport in their heydays. In shaping Shaun's career, his grandmother Cissy strives to achieve a commercial and athletic success that will compensate for the frustrations and failures of her life with her husband and son. Into this world, where even simple joy has been turned into a commodity, steps a mysterious stranger named John. Soon after, things begin to happen to the Yosts, and those whose lives they touch, that test the boundaries of past and present, the mundane and the miraculous, the natural world and what lies beyond it.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-06-10",
  },
  {
    id: 1277,
    url: "https://www.tvmaze.com/shows/1277/jonah-from-tonga",
    name: "Jonah from Tonga",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18371.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18371.jpg",
    },
    summary:
      "<p>Banished to Tonga to live with his uncle, 14-year-old Jonah is causing more trouble than ever. His dad takes him back to Sydney to start a new life but he quickly forms a new school gang and it's not long till trouble starts.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 114,
      name: "ABC",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2014-05-07",
  },
  {
    id: 1278,
    url: "https://www.tvmaze.com/shows/1278/kidnapped",
    name: "Kidnapped",
    genres: ["Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18372.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18372.jpg",
    },
    summary:
      "<p>On a rainy New York morning, the idyllic existence of self-made millionaire Conrad Cain and his well-to-do wife, Ellie,is torn apart when their 15-year-old son, Leopold, is kidnapped on his way to school and his bodyguard, Virgil, is left to die. Desperate to find his son, Cain enlists the services of Knapp a professional investigator who, alongside his partner, Turner works outside the law's strict rulebook to retrieve kidnapping victims. Meanwhile, operating opposite Knapp are Special Agent Latimer King, an experienced FBI agent who postpones his retirement due to a vested interest in this complicated case, as well as King's colleague and antithesis Agent Andy Archer.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-09-20",
  },
  {
    id: 1280,
    url: "https://www.tvmaze.com/shows/1280/life",
    name: "Life",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18380.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18380.jpg",
    },
    summary:
      "<p>David Attenborough looks at the extraordinary ends to which animals and plants go in order to survive. Featuring epic spectacles, amazing TV firsts and examples of new wildlife behaviour.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00lbpcy",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-10-12",
  },
  {
    id: 1281,
    url: "https://www.tvmaze.com/shows/1281/off-the-map",
    name: "Off the Map",
    genres: ["Drama", "Adventure", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18382.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18382.jpg",
    },
    summary:
      "<p>Six doctors who have lost their way will go to the ends of the earth to try to remember the reasons why they wanted to become doctors in the first place.</p>",
    officialSite: "https://abc.go.com/shows/off-the-map",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-01-12",
  },
  {
    id: 1282,
    url: "https://www.tvmaze.com/shows/1282/prime-suspect",
    name: "Prime Suspect",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18390.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18390.jpg",
    },
    summary:
      "<p>This tense, uncompromising drama starring the Oscar®-winning actress Helen Mirren and from the distinguished dramatist and novelist Lynda La Plante, has been critically acclaimed on both sides of the Atlantic and has won a total of 14 international awards including BAFTAs for 'Drama Serial' and 'TV Actress'.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1991-04-07",
  },
  {
    id: 1283,
    url: "https://www.tvmaze.com/shows/1283/slings-arrows",
    name: "Slings & Arrows",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18392.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18392.jpg",
    },
    summary:
      "<p>Geoffrey Tennant is the passionate but unstable artistic director of the New Burbage Theatre Festival. Haunted by the ghost of his predecessor, he struggles to realize his creative vision while handling touchy actors, a jittery general manager, a pretentious guest director and his own tempestuous romance with the festival's leading lady The backstage bedlam mirrors the onstage angst as Geoffrey directs three of Shakespeare's masterpieces -- Hamlet, Macbeth and King Lear -- one in each season.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 38,
      name: "The Movie Network",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2003-11-03",
  },
  {
    id: 1284,
    url: "https://www.tvmaze.com/shows/1284/sports-night",
    name: "Sports Night",
    genres: ["Drama", "Comedy", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18393.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18393.jpg",
    },
    summary:
      "<p>Taut, exciting, realistic dramedy about the lives of sports journalists. It's a show about a show about sports, that isn't about sports at all.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-09-22",
  },
  {
    id: 1285,
    url: "https://www.tvmaze.com/shows/1285/summer-heights-high",
    name: "Summer Heights High",
    genres: ["Drama", "Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18400.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18400.jpg",
    },
    summary:
      "<p>Over one term, a documentary crew films the everyday activities of <b>Summer Heights High</b> and the revelations are hilarious, absurd and frequently shocking.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 114,
      name: "ABC",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2007-09-05",
  },
  {
    id: 1286,
    url: "https://www.tvmaze.com/shows/1286/swingtown",
    name: "Swingtown",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18402.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18402.jpg",
    },
    summary:
      '<p><b>Swingtown</b> traces two generations of friends and neighbors as they forge intimate connections and explore new freedoms during the culturally transformative decade of the 1970s. Swingtown portrays the ever-shifting "swing" of the pendulum that reflected the change in America\'s collective value system - morally, politically and socially. After moving to an upscale lakeside Chicago suburb in July of 1976, Susan and Bruce Miller must confront temptation in the form of their provocative new neighbors, Tom and Trina Decker, while not abandoning their old friends Janet and Roger Thompson. As the adult couples evaluate whether to embrace or avoid newfound personal freedoms, the curious Miller and Thompson children begin to discover and assert their own morality and sexual identities as they come of age in a world on the precipice of change. In a shifting social climate - defined by its music, fashion and style - everyone in Swingtown is confronted with personal choices, experimentation and attitudes.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-06-05",
  },
  {
    id: 1287,
    url: "https://www.tvmaze.com/shows/1287/the-black-donnellys",
    name: "The Black Donnellys",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18408.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18408.jpg",
    },
    summary:
      "<p>The Donnellys are four young working-class Irish-American brothers who live by this motto despite their involvement with organized crime in New York City. Police investigators question Joey Ice Cream, a childhood friend and the unreliable narrator who introduces the Donnelly brothers and sets the scene. Kevin Donnelly is convinced he's lucky, but when his gambling bets add up, his oldest brother Jimmy Donnelly kidnaps the mob-connected bookie Kevin owes money to. When word around the neighborhood connects the Donnellys to the disappearance, Sean Donnelly, the youngest, pays a severe price for sharing his last name. Tommy Donnelly, the reliable one, is forced to make difficult sacrifices for his family when Jimmy's plans fall apart and Sean ends up in the hospital.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-02-26",
  },
  {
    id: 1288,
    url: "https://www.tvmaze.com/shows/1288/the-deep-end",
    name: "The Deep End",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18416.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18416.jpg",
    },
    summary:
      "<p>Sterling Law is one of L.A.'s most prestigious law firms. Each year it recruits four new young lawyers from the finest law schools worldwide. It will nurture, guide and shape these recruits into the best damned lawyers they can possibly be or else. This year the lucky four are Dylan, a blue collar kid made-good; Addy, a sweet mid-Westerner with a lethal legal mind; Beth, a brilliant Brentwood babe; and Liam, an Australian with serious drive. Sterling Law is under the control of ruthless senior partner Cliff Huddle, aka \"The Prince of Darkness.\" But when legendary partner Hart Sterling returns to the firm after a long hiatus caring for his dying wife, he's ready to shake things up. The only way for these first years to survive being caught in the middle of this major power struggle is to support each other, even as they compete against one another in the cutthroat arena of corporate law. They discover unlikely allies in their mercurial recruiter Rowdy and litigating whirlwind Susan, who is Cliff's icy, but talented wife. Dylan also manages to make a deeper connection with an ace paralegal named Addy, but every alliance at Sterling is complicated. Addy is drawn to Dylan, but it seems she hasn't quite broken off her affair with Cliff.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-01-21",
  },
  {
    id: 1289,
    url: "https://www.tvmaze.com/shows/1289/the-forsyte-saga",
    name: "The Forsyte Saga",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18425.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18425.jpg",
    },
    summary:
      "<p>This sexy and powerful drama spans three generations of the upwardly mobile Forsyte family at the turn of the 20th century and is based on the classic novels by Nobel Prize-winning author John Galsworthy.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2002-04-07",
  },
  {
    id: 1290,
    url: "https://www.tvmaze.com/shows/1290/the-job",
    name: "The Job",
    genres: ["Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18426.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18426.jpg",
    },
    summary:
      '<p>Mike McNeil is an unorthodox New York detective who\'s trying to juggle work with his complicated personal life, which includes his wife -- and a girlfriend on the side. McNeil also smokes, drinks and abuses prescription medications. The show comes off as a semi-satirical take of contemporary ABC drama "NYPD Blue."</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-03-14",
  },
  {
    id: 1291,
    url: "https://www.tvmaze.com/shows/1291/the-michael-j-fox-show",
    name: "The Michael J. Fox Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18427.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18427.jpg",
    },
    summary:
      "<p>Look who's making the news again. One of New York's most beloved news anchors, Mike Henry put his career on hold to spend more time with his family and focus on his health after he was diagnosed with Parkinson's disease. But five years later, with the kids busy growing up and Mike growing restless, it just might be time for him to get back to work. Having never wanted Mike to leave in the first place, his old boss Harris Green jumped at the chance to get him back on TV. The trick, as it's always been, was to make Mike think it was his idea. Now the plan is in motion and Mike will be back to juggling home, family, and career - just like the old days, but only better.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-26",
  },
  {
    id: 1292,
    url: "https://www.tvmaze.com/shows/1292/the-office",
    name: "The Office",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/93/234802.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/93/234802.jpg",
    },
    summary:
      "<p>A mockumentary about life in a mid-sized suboffice paper merchants in a bleak British industrial town, where manager David Brent thinks he's the coolest, funniest, and most popular boss ever. He isn't. That doesn't stop him from embarrassing himself in front of the cameras on a regular basis, whether from his political sermonizing, his stand-up 'comedy', or his incredibly unique dancing. Meanwhile, long-suffering Tim longs after Dawn the engaged receptionist and keeps himself sane by playing childish practical jokes on his insufferable, army-obsessed deskmate Gareth. Will the Slough office be closed? Will the BBC give David a game show? Will Tim and Dawn end up with each other? And more importantly, will Gareth realize what a hopeless prat he is?</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00jd68z",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2001-07-09",
  },
  {
    id: 1293,
    url: "https://www.tvmaze.com/shows/1293/the-street",
    name: "The Street",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18437.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18437.jpg",
    },
    summary:
      "<p>Prolific television writer Jimmy McGovern is the creative force behind this award-winning drama, which first aired on the BBC. Each season consists of six one-hour episodes that tell stand-alone stories about the residents who live on the same street in Manchester, England. Timothy Spall, Jim Broadbent, Gina McKee, Jane Horrocks and David Thewlis are among the all-star cast who have appeared on <i>The Street</i>.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b008cbds",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-04-13",
  },
  {
    id: 1294,
    url: "https://www.tvmaze.com/shows/1294/the-wonder-years",
    name: "The Wonder Years",
    genres: ["Drama", "Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18438.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18438.jpg",
    },
    summary:
      "<p>Set in 1968-1973, the series tackles the social issues and historic events of that time through the eyes of main character Kevin Arnold. Kevin also deals with typical teenage social issues, including those prompted by his main love interest, Winnie Cooper, as well as typical family troubles. The story is narrated by an older, wiser Kevin, describing what is happening and what he learned from his experiences in an alternately nostalgic and ironic tone.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1988-01-31",
  },
  {
    id: 1295,
    url: "https://www.tvmaze.com/shows/1295/togetherness",
    name: "Togetherness",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18447.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18447.jpg",
    },
    summary:
      "<p>Brett and Michelle are struggling to rekindle the spark in their relationship, which has puttered out from the stresses of marriage and children. When Brett's friend Alex and Michelle's sister, Tina, move in with them, the foursome engage in a tragically comedic struggle to follow their personal dreams, while still remaining good friends, siblings and spouses to each other.</p><p>On March 25, 2016, it was announced that <i>Togetherness</i> would not be renewed for a third season.</p>",
    officialSite: "http://www.hbo.com/togetherness/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-11",
  },
  {
    id: 1296,
    url: "https://www.tvmaze.com/shows/1296/wives-and-daughters",
    name: "Wives and Daughters",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18456.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18456.jpg",
    },
    summary:
      "<p>The daughter of a country doctor copes with an unwanted stepmother, an impetuous stepsister, burdensome secrets, the town gossips, and the tug on her own heartstrings for a man who thinks of her only as a friend.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1999-11-28",
  },
  {
    id: 1297,
    url: "https://www.tvmaze.com/shows/1297/every-witch-way",
    name: "Every Witch Way",
    genres: ["Comedy", "Children", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18455.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18455.jpg",
    },
    summary:
      "<p><b>Every Witch Way</b> follows 14-year-old Emma Alonso, as she moves to Miami and her ordinary life is turned upside-down when she discovers that she is a witch. Luckily Emma quickly finds a friend in tomboy Andi but when Emma develops a crush on the boy next door, Daniel, she also has to deal with his Queen Bee ex-girlfriend Maddie, a girl who has her own magical family secret.<br><br> Just as Emma's new found witch skills start to materialise, she also has to negotiate the halls of Iridium High. Maddie and her clique The Panthers run the school and the boys on the swim team, the Sharks, are always up to something to win or impress a girl. Plus there's no chance of getting away with any social blunders as Miss Information, the school gossip, documents everything on her blog read by the entire school.</p>",
    officialSite: "http://www.nick.com/every-witch-way/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-01",
  },
  {
    id: 1298,
    url: "https://www.tvmaze.com/shows/1298/lab-rats",
    name: "Lab Rats",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18457.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18457.jpg",
    },
    summary:
      '<p>Leo discovers three teen super-humans Adam, Bree and Chase, living in a secret underground lab in the high-tech home he shares with his inventor stepdad, Donald Davenport, his mom, Tasha, and Eddy, the "smart house" computer. Leo takes the trio to school, but when they are unable to contain their bionic abilities on campus, Davenport sends them away to a remote secret lab and now Leo must find a way to save his new friends.</p>',
    officialSite: "http://www.bbc.co.uk/programmes/b00cngdg",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-07-10",
  },
  {
    id: 1299,
    url: "https://www.tvmaze.com/shows/1299/nowhere-boys",
    name: "Nowhere Boys",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18458.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18458.jpg",
    },
    summary:
      "<p>Follow the action-packed adventure of four teenage boys who return from a school excursion to discover they're stuck in a parallel world into which they were never born.</p>",
    officialSite: "http://www.abc.net.au/tv/programs/nowhere-boys/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 116,
      name: "ABC ME",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2013-11-07",
  },
  {
    id: 1300,
    url: "https://www.tvmaze.com/shows/1300/wolfblood",
    name: "Wolfblood",
    genres: ["Drama", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18459.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18459.jpg",
    },
    summary:
      "<p>Being a teenager is hard enough.<br />Being a Wolfblood teenager is ten times more complicated.</p>",
    officialSite: "http://www.bbc.co.uk/cbbc/shows/wolfblood",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 60,
      name: "CBBC",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-09-10",
  },
  {
    id: 1301,
    url: "https://www.tvmaze.com/shows/1301/ben-10-alien-force",
    name: "Ben 10: Alien Force",
    genres: ["Action", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18463.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18463.jpg",
    },
    summary:
      "<p>Five years after the original Ben 10 series, Ben Tennyson is a normal teenager who has put away his toys, including the Omnitrix that gave him his powers.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-04-18",
  },
  {
    id: 1302,
    url: "https://www.tvmaze.com/shows/1302/millennium",
    name: "Millennium",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18464.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18464.jpg",
    },
    summary:
      '<p>Retired serial-profiler Frank Black has moved his family to Seattle to escape the violence and horror he dealt with while working for the FBI in Washington, D.C. Although his uncanny and often unsettling ability to see into the twisted minds of serial killers has caused him much inner torment, Black knows his "gift" can still be used to help protect and save others. For that reason he has joined the mysterious <b>Millennium</b> Group, a team of underground ex-law enforcement experts dedicated to fighting against the ever-growing forces of evil and darkness in the world.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-10-25",
  },
  {
    id: 1303,
    url: "https://www.tvmaze.com/shows/1303/the-lone-gunmen",
    name: "The Lone Gunmen",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18469.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18469.jpg",
    },
    summary:
      '<p>Spin-off of <i>The X-Files </i>featuring the trio of computer-hacking conspiracy geeks popularly known as The Lone Gunmen. Never ones to stray far from the center of corporate and government intrigue, the threesome of John Byers, Melvin Frohike, and Richard Langly play like a misguided Mission Impossible team, embarking on a series of comic adventures that simultaneously highlight their genius and ineptitude. While their newfound independence inspires them to investigate even the most shadowy of conspiracies, their social skills remain stagnant, which only makes their lives more difficult when they learn their chief competitor in the "information business" is the brilliant and beautiful Yves Adele Harlow. Perpetually short of funds to publish <i>The Lone Gunmen </i>newspaper, Byers, Frohike, and Langly begrudgingly take on Jimmy Bond as an unlikely benefactor who bankrolls their missions and joins them in their investigations to uncover the truth.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-03-04",
  },
  {
    id: 1304,
    url: "https://www.tvmaze.com/shows/1304/7-days",
    name: "7 Days",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18473.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18473.jpg",
    },
    summary:
      "<p>A secret branch of the NSA travels through time using a device found at Roswell.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 70,
      name: "UPN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-10-07",
  },
  {
    id: 1305,
    url: "https://www.tvmaze.com/shows/1305/the-adventures-of-brisco-county-jr",
    name: "The Adventures of Brisco County, Jr.",
    genres: ["Action", "Adventure", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18481.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18481.jpg",
    },
    summary:
      "<p><b>The Adventures of Brisco County, Jr. </b>follows a man seeking vengeance against the man who murdered his father. He becomes a bounty hunter although he was trained as a lawyer. Unfortunately his father's killer, John Bly, has his own criminal gang to keep Brisco at bay. But Brisco is aided by his own gang of sorts: dance hall girl extraordinaire Dixie Cousins, rival bounty hunter Lord Bowler, fellow lawyer Socrates Poole and scientist Professor Wickwire. Although the series was set in the Old West, Brisco had an assortment of nifty modern gadgets and then there were the mysterious Orbs scattered about which almost seemed to have supernatural powers.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-08-27",
  },
  {
    id: 1306,
    url: "https://www.tvmaze.com/shows/1306/adventures-of-superman",
    name: "Adventures of Superman",
    genres: ["Action", "Adventure", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18484.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18484.jpg",
    },
    summary:
      "<p><b>Adventures of Superman</b> (originally known as <i>The Adventures of Superman</i>) is an American syndicated children's television series based on comic book characters and concepts created in 1938 by Jerry Siegel and Joe Shuster. The series saw six seasons and one-hundred-four half-hour episodes. Sponsored by cereal manufacturer Kellogg's, the show's initial and final air dates are sometimes disputed but generally accepted as September 19, 1952 to April 28, 1958. The show's first two seasons were filmed in black-and-white while seasons four through six were filmed in color, though broadcast monochromatically.</p><p>Adventures of Superman was the first television series to feature Superman though the superhero had appeared as a character in a radio program starring Bud Collyer, two theatrical serials starring Kirk Alyn and Noel Neill, and a series of Max Fleischer cartoons. The television series began filming in 1951 in Culver City, California with exterior locations filmed in and around the Los Angeles area and the San Fernando Valley. Episodes follow Superman as he battles gangsters, thugs, mad scientists, meteors and malfunctioning radioactive machines in the city of Metropolis. In the first episode, his origin on the planet Krypton and his arrival on Earth are dramatized while in succeeding episodes, he conceals his identity by posing as mild mannered Daily Planet reporter Clark Kent who, in times of crisis, scoots to a broom closet, sheds his civvies, and reappears in superhero tights and trunks to rescue hapless folk from the clutches of ne'er-do-wells. In the last seasons, the kindly but absent-minded Professor Pepperwinkle creates problems for Superman with his bizarre inventions.</p><p>Adventures of Superman won no major awards but was popular with its audience and remains popular today. Its opening theme, The Superman March, has become a classic of its kind and is instantly recognizable by most television buffs. Since the show's cancellation, several of its stars have participated in Superman-related conventions, autograph signings, and other events. In 2003, Noel Neill published her memoirs Truth, Justice, and The American Way: The Life and Times of Noel Neill. In 2006, the death of George Reeves was dramatized in the film Hollywoodland with Ben Affleck starring in the role of Reeves. In 2006, the series became available in its entirety on DVD and reruns of the show still hold a place on television programming schedules.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1952-09-19",
  },
  {
    id: 1307,
    url: "https://www.tvmaze.com/shows/1307/anyone-but-me",
    name: "Anyone But Me",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/250/626286.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/250/626286.jpg",
    },
    summary:
      "<p>Introducing a new generation: gay, straight, and ethnically diverse struggling with identity and modern relationships.</p>",
    officialSite: "http://www.anyonebutmeseries.com/",
    webChannel: {
      id: 2,
      name: "Hulu",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2008-12-07",
  },
  {
    id: 1308,
    url: "https://www.tvmaze.com/shows/1308/bad-girls",
    name: "Bad Girls",
    genres: ["Drama", "Crime", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18492.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18492.jpg",
    },
    summary:
      "<p>Step inside HMP Larkhall and meet the women of G-Wing, who've committed various offences that range from shoplifting to murder. <b>Bad Girls</b> shows what life is like for these women in the 'inside world' and also shows the real-life problems (and maybe behaviour!) of the officers who watch them!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1999-06-01",
  },
  {
    id: 1309,
    url: "https://www.tvmaze.com/shows/1309/boomtown",
    name: "Boomtown",
    genres: ["Action", "Adventure", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18525.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18525.jpg",
    },
    summary:
      "<p>Each episode of this series, set in present day Los Angeles, examines one crime from many different viewpoints - uniformed cops, detectives, witnesses, the media, the fire department and rescue squad, even the criminals themselves.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-09-29",
  },
  {
    id: 1310,
    url: "https://www.tvmaze.com/shows/1310/boston-med",
    name: "Boston Med",
    genres: ["Drama", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18527.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18527.jpg",
    },
    summary:
      "<p>Picking up where \"Hopkins\" left off, <b>Boston Med</b> travels to a city renowned for medical excellence and home to three superb American hospitals, Massachusetts General Hospital, Brigham and Women's Hospital, and Children's Hospital. Over four months, ABC cameras had unparalleled access to hospital staffs and patients. From operating rooms to end-of-life meetings, Boston Med explores the culture of doctors and nurses and the conversations that happen outside the patient's earshot. This unsparing look at the ups and downs of hospital care holds many surprises for viewers.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-06-24",
  },
  {
    id: 1311,
    url: "https://www.tvmaze.com/shows/1311/bostons-finest",
    name: "Boston's Finest",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18528.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18528.jpg",
    },
    summary:
      "<p>This gripping new series follows the men and women of the Boston Police Department, encompassing multiple units including the exclusive and highly decorated Gang Unit. Featuring detectives, investigators, beat officers, and others, we get an up close and personal look at what it takes to patrol and secure one of America's greatest and most distinctive cities. <b>Boston's Finest</b> (working title) comes to TNT from Jarrett Creative Group, along with executive producer Donnie Wahlberg's Donnie D. Productions.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-02-27",
  },
  {
    id: 1312,
    url: "https://www.tvmaze.com/shows/1312/cashmere-mafia",
    name: "Cashmere Mafia",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18529.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18529.jpg",
    },
    summary:
      "<p>Four ambitious women who have been friends since business school use their close-knit relationship as a support line as they try to crack the male-dominated glass ceiling of the corporate world.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-01-06",
  },
  {
    id: 1313,
    url: "https://www.tvmaze.com/shows/1313/the-class",
    name: "The Class",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18536.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18536.jpg",
    },
    summary:
      "<p><b>The Class </b>is about a group of 20-somethings who are linked through attending the same third-grade class. An impromptu reunion begins on the 20th anniversary of the day they all met --and each is wondering if they'll have anything in common. Some are eager to show off, some want to rekindle old playground crushes, but most just want to satisfy their curiosity.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-09-18",
  },
  {
    id: 1314,
    url: "https://www.tvmaze.com/shows/1314/cold-justice",
    name: "Cold Justice",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/181/453450.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/181/453450.jpg",
    },
    summary:
      "<p>From Executive Producer Dick Wolf, Oxygen revives <b>Cold Justice</b>, a real life crime series that follows former prosecutor Kelly Siegler and her team of detectives as they dig into small town murder cases that have lingered for years without answers or closure. Together with local law enforcement from across the country, the Cold Justice team has helped bring about an astounding 40 arrests and 19 convictions.</p>",
    officialSite: "http://www.oxygen.com/cold-justice",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 79,
      name: "Oxygen",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-03",
  },
  {
    id: 1315,
    url: "https://www.tvmaze.com/shows/1315/combat-hospital",
    name: "Combat Hospital",
    genres: ["Drama", "War", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18548.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18548.jpg",
    },
    summary:
      "<p>The war zone of Southern Afghanistan is the workplace for the doctors, nurses and medics of the Role 3 Medical Unit, a Canadian-led NATO team delivering the highest level of care available in Kandahar. Leading the hospital staff on behalf of the Canadian forces is Col. Xavier Marks, a career military surgeon. His new recruits include Maj. Rebecca Gordon, a trauma surgeon who is eager to get noticed, and Capt. Bobby Trang, who is given a tough team leader assignment upon his arrival to the unit. Australian psychiatrist Maj. Grace Pedersen looks after the troops' mental well being, and Dr. Simon Hill is considered a brilliant neurosurgeon, although others wonder what the nonmilitary staffer was thinking when he volunteered to work in a war zone.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 67,
      name: "Global",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2011-06-21",
  },
  {
    id: 1316,
    url: "https://www.tvmaze.com/shows/1316/conviction",
    name: "Conviction",
    genres: ["Drama", "Crime", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47561.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47561.jpg",
    },
    summary:
      "<p><b>Conviction</b> is a legal drama series from Dick Wolf is a fast-paced, character-oriented story focusing on young assistant district attorneys of the New York District Attorney's office, headed by bureau chief Alexandra Cabot, who handle tough, high-profile cases that challenge their experience.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-03-03",
  },
  {
    id: 1317,
    url: "https://www.tvmaze.com/shows/1317/emily-owens-md",
    name: "Emily Owens, M.D.",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18557.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18557.jpg",
    },
    summary:
      "<p>At long last, Emily Owens feels like she is an actual grown-up. She can finally put her high school days as the geeky-girl-with-flop-sweats behind her; she's graduated from medical school and is now a first-year intern at Denver Memorial Hospital, where she'll have the chance to work with world-famous cardiologist Dr. Gina Beckett - and where, not-so-coincidentally, her med-school crush Will Rider is also an intern. So why does everyone keep warning her that the hospital is just like high school? Emily soon finds out the hard way - her high school nemesis, the gorgeous, popular Cassandra Kopelson, is also just starting out at Denver Memorial, and it seems like they're rivals all over again - not only as surgical interns, but for Will's attention. Fellow intern Tyra Granger warns Emily that the cliques at Denver Memorial are all too familiar: the jocks have become orthopedic surgeons; the mean girls are in plastics; the rebels are in the ER, and Tyra has her own awkward place as the principal's kid - her father is the chief resident. Emily's the new kid all over again, and it's just as awkward as high school. Only this time around, Emily will have to balance the personal and emotional turmoil of social politics with the high-stakes world of life-and-death medical decisions. At least she has fellow intern Tyra and nerdy-but-cute resident Micah, to count on as friends. Emily is growing to realize that although she may be a geek, she may also grow to be a great doctor, flop sweats and all.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-10-16",
  },
  {
    id: 1318,
    url: "https://www.tvmaze.com/shows/1318/exes-ohs",
    name: "Exes & Ohs",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18562.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18562.jpg",
    },
    summary:
      "<p>Meet Jennifer, a documentary filmmaker with a vivid fantasy life (which we see) and a floundering career (which we also see). Jennifer wants to find Ms. Right. but first she must navigate the rules of lesbian life, most of which she learns the hard way. Fortunately, her friends are there to help: Sam, a sexy commitment-phobe who flips women faster than real estate; Chris and Kris, a lesbian couple expanding both their pet accessory business and their family; and Crutch, a young musician who wants to be taken seriously but still has some growing up to do. Surviving singlehood, couplehood - and each other - has never looked quite like this.</p>",
    officialSite: "http://www.logotv.com/shows/exes-and-ohs",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 117,
      name: "Logo TV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-10-08",
  },
  {
    id: 1319,
    url: "https://www.tvmaze.com/shows/1319/heroes-of-cosplay",
    name: "Heroes of Cosplay",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18563.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18563.jpg",
    },
    summary:
      "<p>The series follows some of the hottest cosplay stars as they make a splash at comic book conventions around the country. The show dives deep into their lives, following their process as they create extravagant and visually arresting costumes each week. These individuals will constantly defy odds and race against the clock to transform themselves into amazing fictional characters that push the boundaries between fantasy and reality, all in hopes of impressing the convention judges to win a cash prize and the chance to become a cosplay legend.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-08-13",
  },
  {
    id: 1320,
    url: "https://www.tvmaze.com/shows/1320/hollywood-game-night",
    name: "Hollywood Game Night",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/206/515185.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/206/515185.jpg",
    },
    summary:
      "<p>In <b>Hollywood Game Night</b>, two contestants in each episode will be transported from their everyday lives into a once-in-a-lifetime night of fun and celebration as they step beyond the velvet rope and rub shoulders with the celebrity crowd. Part Hollywood club and part casual game night, the series promises viewers a fresh look into the lives of the rich and famous.</p>",
    officialSite: "http://www.nbc.com/hollywood-game-night",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-07-11",
  },
  {
    id: 1321,
    url: "https://www.tvmaze.com/shows/1321/ink-master",
    name: "Ink Master",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/206/515110.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/206/515110.jpg",
    },
    summary:
      "<p>An estimated 40 million Americans have at least one tattoo. So who is the country's preeminent tattoo artist? <b>Ink Master</b> is the first-ever tattoo competition series featuring some of the nation's top tattoo artists on a quest to determine who is the best at their craft and win a huge cash prize. The stakes are high as the artists showcase their irrevocable artwork on real people's bodies. The dramatic tension is ever-present as the artists will ultimately face the opinion of the living canvas who now bears a permanent souvenir of the Ink Master etched into his or her skin.</p>",
    officialSite: "http://www.paramountnetwork.com/shows/ink-master",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 34,
      name: "Paramount Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-01-17",
  },
  {
    id: 1322,
    url: "https://www.tvmaze.com/shows/1322/killer-women",
    name: "Killer Women",
    genres: ["Drama", "Crime", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18566.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18566.jpg",
    },
    summary:
      "<p><b>Killer Women</b> takes us inside the dangerous world of the Texas Rangers from a female perspective. Molly is committed to finding the truth and seeing justice served. In a male-dominated world, she is aided by her sixth sense for why women kill -- rarely out of hatred, usually for what they love. Standing squarely behind her is her boss, Company Commander Luis Zea. Molly also has the support of her loving family, including her brother Billy and his wife Becca. On the verge of getting divorced from her narcissistic husband, Jake, Molly relishes her newfound freedom as she begins an affair with a sexy, dangerously handsome DEA agent, Dan Winston.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-07",
  },
  {
    id: 1323,
    url: "https://www.tvmaze.com/shows/1323/lois-clark-the-new-adventures-of-superman",
    name: "Lois & Clark: The New Adventures of Superman",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18569.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18569.jpg",
    },
    summary:
      "<p>A sleek, sexy, Emmy-nominated 1990s take on the enduring superhero, culled from DC Comics, which has spawned numerous successful film and TV versions of him as boy and man. All of which further demonstrated that while Kryptonite can kill the Man of Steel, changing times can't. Here, leads Dean Cain and Teri Hatcher have the looks and the chemistry, and the timeless question (seriously, how can Lois NOT know Clark is Superman?) plays itself out until they find true love.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-09-12",
  },
  {
    id: 1324,
    url: "https://www.tvmaze.com/shows/1324/malibu-country",
    name: "Malibu Country",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18577.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18577.jpg",
    },
    summary:
      "<p>Reba McKenzie very publicly discovers that her country music legend husband, Bobby Gallagher, has been cheating on her. Determined to get a fresh start and perhaps revive her own country music career, Reba packs up her sharp-tongued mother and two kids and drives cross country to live in Bobby's Malibu beach-front party pad. Once there, gregarious and over-sharing neighbor Kim immediately reaches out with an offer to mentor Reba as she adjusts to Southern California. With a new home and a much more liberal west coast set of rules, Reba, her kids and mom welcome the change, but soon realize that the open-mindedness of Southern California goes much farther than they'd expected. When Reba finds that trying to get her foot back in the music business is going to be an uphill battle, she befriends Geoffrey, the assistant to her record label's president -- who never seems to be in the office. Though overwhelmed and feeling out of place, Reba realizes that, all in all, family is what matters most, and they must learn to view their new Malibu lifestyle as a chance for a new beginning.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-11-02",
  },
  {
    id: 1325,
    url: "https://www.tvmaze.com/shows/1325/mental",
    name: "Mental",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18582.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18582.jpg",
    },
    summary:
      "<p>When Dr. Jack Gallagher arrives for his first day as Director of Psychiatric Services at Los Angeles' Wharton Memorial Hospital, his unique style is evident from the start as he employs an unusual tactic to gain a delusional patient's trust. Meanwhile, Jack must reconcile his effective, yet highly unorthodox treatment methods with not only his new colleagues but also his conservative boss, hospital administrator Nora Skoff.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-05-26",
  },
  {
    id: 1326,
    url: "https://www.tvmaze.com/shows/1326/the-mole",
    name: "The Mole",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21189.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21189.jpg",
    },
    summary:
      '<p><b>The Mole</b> follows a group of 12 players as they try to figure out who among them is The Mole, a saboteur trying to keep them from winning money. Players must decide who they think The Mole is and then learn as much about him or her as they can, because, at the end of each one-hour episode, the player who knows the least about The Mole is immediately "Executed" from the game. In the final dramatic episode, The Mole is revealed and one of two final players wins a substantial cash prize.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-01-09",
  },
  {
    id: 1327,
    url: "https://www.tvmaze.com/shows/1327/naked-vegas",
    name: "Naked Vegas",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18590.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18590.jpg",
    },
    summary:
      "<p>Set amidst the fast-paced glitter of life on the Las Vegas Strip, Syfy will transport viewers inside the provocative and imaginative world of body painting art in this new six-part docuseries. Just in time for Halloween, the first episode follows the Naked Vegas Team as they plan an over-the-top zombie-themed wedding at Eli Roth's Goretorium at Planet Hollywood. Not only does the wedding couple want to stagger down the aisle in zombie body paint, but they want the entire wedding party painted to match the theme! Can the Team pull off this challenging make-up assignment - and convince the wedding party to go naked?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-10-29",
  },
  {
    id: 1328,
    url: "https://www.tvmaze.com/shows/1328/nostradamus-effect",
    name: "Nostradamus Effect",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18591.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18591.jpg",
    },
    summary:
      '<p>The end is near. At least that\'s what the doomsday predictions from Nostradamus, the Book of Revelation, the Mayan "long count" calendar and others would have us believe. Many unsettling forecasts of global destruction even pinpoint the year: 2012. How worried should we be? If these prophecies are accurate and inevitable, is there any way to avoid or at least postpone them from coming true? In Nostradamus Effect, a timely new 12-episode series, History examines various end-of-days prophecies that loom large in the 21st century.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-09-09",
  },
  {
    id: 1329,
    url: "https://www.tvmaze.com/shows/1329/opposite-worlds",
    name: "Opposite Worlds",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18592.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18592.jpg",
    },
    summary:
      "<p><b>Opposite Worlds</b> is based on the hit Chilean format, Mundos Opuestos, originally broadcast on Canal 13 and distributed by Banijay International. In <i>Opposite Worlds</i>, 14 people from all walks of life go head-to-head in opposing teams that live in a house separated into two distinctly different worlds: one future and one past, each with its own unique advantages and disadvantages. Adding to the drama is a glass wall dividing the house into the two environments, allowing the teams to watch, envy and dread each other's every move. Viewers can contribute to the chatter about Opposite Worlds - and affect each weekly challenge - by following the handle @syfyoppworlds and using the hashtag #oppositeworlds on Twitter.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-21",
  },
  {
    id: 1330,
    url: "https://www.tvmaze.com/shows/1330/significant-others",
    name: "Significant Others",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18594.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18594.jpg",
    },
    summary:
      "<p>A coming-of-age drama about three twenty-something best friends living in Los Angeles and having the best..and worst times of their lives.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-03-11",
  },
  {
    id: 1331,
    url: "https://www.tvmaze.com/shows/1331/standoff",
    name: "Standoff",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18595.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18595.jpg",
    },
    summary:
      "<p><b>Standoff</b> centers on Matt Flannery and Emily Lehman, top-ranked FBI crisis negotiators who are forced to come clean about their secret relationship after it is revealed during a tense hostage standoff that they are sleeping together. Too valuable as a team to be split up, they are now under the watchful eye of their boss and their colleagues. Standoff combines the crackling romantic relationship at its core with intense drama and humor as these negotiators vow not to cross the line and let their personal feelings get in the way of the job. But they learn quickly that, in life and in love, everything is a negotiation.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-09-05",
  },
  {
    id: 1332,
    url: "https://www.tvmaze.com/shows/1332/tattoo-nightmares",
    name: "Tattoo Nightmares",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18602.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18602.jpg",
    },
    summary:
      "<p><b>Tattoo Nightmares</b> showcases real people with really bad tattoos who seek the help of some of the best cover-up artists in the business to fix them.</p>",
    officialSite: "http://www.spike.com/shows/tattoo-nightmares",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 34,
      name: "Paramount Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-10-16",
  },
  {
    id: 1333,
    url: "https://www.tvmaze.com/shows/1333/third-watch",
    name: "Third Watch",
    genres: ["Drama", "Crime", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/126/316896.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/126/316896.jpg",
    },
    summary:
      "<p>The exploits of a group of men and women who serve the City of New York as police officers, firemen, and paramedics in the fictional 55th Precinct.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-09-23",
  },
  {
    id: 1335,
    url: "https://www.tvmaze.com/shows/1335/vikings",
    name: "Vikings",
    genres: ["Drama", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18620.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18620.jpg",
    },
    summary:
      "<p>Neil Oliver goes in search of the truth about the <b>Vikings</b> beyond their violent reputation.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b01ms4sh",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-09-11",
  },
  {
    id: 1336,
    url: "https://www.tvmaze.com/shows/1336/whodunnit",
    name: "Whodunnit?",
    genres: ["Drama", "Crime", "Mystery"],
    image: null,
    summary:
      "<p>Actors play victims, suspects and investigators in a staged mystery, during which three contestants and a panel of experts gather clues to identify the murderer.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1979-04-12",
  },
  {
    id: 1337,
    url: "https://www.tvmaze.com/shows/1337/whodunnit",
    name: "Whodunnit?",
    genres: ["Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18621.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18621.jpg",
    },
    summary:
      "<p>Anthony E. Zuiker, the creator of the \"CSI\" franchise, begins production on his first primetime reality series, <b>Whodunnit?</b> Cris Abrego partners with Zuiker for the new nine-episode alternative series that puts 13 contestants' investigative skills to the test in a mystery reality competition. Each week players will use a variety of crime scene investigation techniques to meticulously uncover evidence that will ultimately reveal who among them is the killer. The interactive series will pit 13 amateur sleuths against each other in a quest to solve a series of puzzling murders. Some will form alliances and others will choose to go it alone just to get them closer to the grand prize. The contestants will reside on a glamorous estate where each week they must solve a new crime in order to advance in the game. Failure to solve the crime will lead to a player's demise, until only three are left. In the final episode, one player will unmask the killer and take home the $250,000 prize.</p>",
    officialSite: "https://abc.com/shows/whodunnit",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-06-23",
  },
  {
    id: 1338,
    url: "https://www.tvmaze.com/shows/1338/the-whole-truth",
    name: "The Whole Truth",
    genres: ["Drama", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18622.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18622.jpg",
    },
    summary:
      "<p>With a unique alternative narrative structure that chronicles the way a case is built from the perspectives of both the defense and prosecution, <b>The Whole Truth</b> shows each side equally and keeps its audience guessing, shifting allegiances of guilt or innocence until the very final scene. Kathryn Peale (Tierney), the product of a New England background and a sheriff father, is a deputy bureau chief in the Manhattan District Attorney's office. Jimmy Brogan (Rob Morrow, <i>\"Numb3rs\"</i>), born and raised in Hell's Kitchen and a friend of Kathryn's since their days at Yale Law School, is one of New York's rising criminal attorney stars. These two evenly matched legal masters will square off each week as the central characters of the series.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-22",
  },
  {
    id: 1339,
    url: "https://www.tvmaze.com/shows/1339/wire-in-the-blood",
    name: "Wire in the Blood",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18629.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18629.jpg",
    },
    summary:
      '<p><b>Wire in the Blood</b> is a British crime drama television series. The series is based on characters created by <i>Val McDermid</i>, including a university clinical psychologist, <i>Dr Anthony "Tony" Valentine Hill</i> (played by <i>Robson Green</i>), who is able to tap into his own dark side to get inside the heads of serial killers. Working with detectives, Hill takes on tough and seemingly impenetrable cases in an attempt to track down the killers before they strike again.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2002-11-14",
  },
  {
    id: 1340,
    url: "https://www.tvmaze.com/shows/1340/womens-murder-club",
    name: "Women's Murder Club",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18630.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18630.jpg",
    },
    summary:
      "<p>Based on author James Patterson's bestselling novels, <b>Women's Murder Club</b> is a one-hour drama series about four successful working women in San Francisco. Homicide Inspector Lindsay Boxer, Medical Examiner Claire Washburn, Assistant D.A. Jill Bernhardt and crime reporter Cindy Thomas who use their expertise, their close friendship and their instincts to solve murder cases. Each a success in her own field, they work together to uncover clues to the city's most grisly homicides.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-10-12",
  },
  {
    id: 1341,
    url: "https://www.tvmaze.com/shows/1341/wonder-woman",
    name: "Wonder Woman",
    genres: ["Action", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18638.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18638.jpg",
    },
    summary:
      "<p>A colorful spin on Charles Moulton's comic about the Amazon goddess battling evil during World War II and later, in more recent times, against new enemies. The change came after the series jumped from ABC to CBS, with the heroine joining a covert military agency. <b>Wonder Woman</b> began as two TV-movies (the first in 1974 with Cathy Lee Crosby) and several specials before finding a regular prime-time home in late 1976. Debra Winger appeared occasionally as Drusilla, Wonder Woman's kid sister.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1975-11-07",
  },
  {
    id: 1342,
    url: "https://www.tvmaze.com/shows/1342/street-outlaws",
    name: "Street Outlaws",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/239/599404.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/239/599404.jpg",
    },
    summary:
      "<p><b>Street Outlaws</b> follows the street racers of Oklahoma City as they hit the streets to prove that OKC has the fastest drivers in the country.</p>",
    officialSite: "http://www.discovery.com/tv-shows/street-outlaws/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-06-10",
  },
  {
    id: 1343,
    url: "https://www.tvmaze.com/shows/1343/ice-cold-killers",
    name: "Ice Cold Killers",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/120/301382.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/120/301382.jpg",
    },
    summary:
      "<p><b>Ice Cold Killers</b> is a diabolically dark true crime series set in the harshest of climates against a backdrop of pristine, rugged wilderness as unforgiving as the murderers themselves. Each episode is a psychological thriller that profiles a single sadistic act of evil...from the brutal rape and murder of an 11-year-old child...to a woman who narrowly escapes the clutches of a serial killer only to be hunted to her death...to a cross country killer who hibernates like a bear in the winter only to feast on the blood of another victim each spring. Dramatic recreations allow a distinctive stylistic approach, allowing each mysterious tale to fluctuate between moments of uneasy calm and blood curdling fright.</p>",
    officialSite:
      "http://www.investigationdiscovery.com/tv-shows/ice-cold-killers/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-01-25",
  },
  {
    id: 1344,
    url: "https://www.tvmaze.com/shows/1344/60-minutes-sports",
    name: "60 Minutes Sports",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755262.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755262.jpg",
    },
    summary:
      "<p>The first name in news magazines is now the last word in sports on <b>60 Minutes Sports</b>. The award-winning team behind 60 Minutes now turns its investigative eye towards the world of sports. From in-depth reporting to the most compelling interviews… to get the whole story you need sixty minutes.</p>",
    officialSite: "http://www.sho.com/sho/60-minutes-sports/home",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-01-09",
  },
  {
    id: 1345,
    url: "https://www.tvmaze.com/shows/1345/7-little-johnstons",
    name: "7 Little Johnstons",
    genres: ["Drama", "Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/250/627224.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/250/627224.jpg",
    },
    summary:
      '<p>Amber and Trent Johnston are living the American dream. They have been happily married for 14 years and have five children ranging from 6 to 13 years old. On paper, they might seem like your average family...yet in person, they attract a lot of attention.... because all seven members of the Johnston family – Amber, Trent, their two biological children, Jonah and Elizabeth, as well as their three adopted children, Anna, Emma and Alex – happen to have Achondroplasia Dwarfism. Together, these spunky seven make up the largest known family of Achondroplastic dwarfs in the world, and even describe themselves as "the real life seven dwarfs".</p>',
    officialSite: "http://www.tlc.com/tv-shows/7-little-johnstons/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-31",
  },
  {
    id: 1346,
    url: "https://www.tvmaze.com/shows/1346/obsession-dark-desires",
    name: "Obsession: Dark Desires",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/231/578189.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/231/578189.jpg",
    },
    summary:
      "<p>When desire overtakes reason, the human mind can unleash deadly obsession. In <b>Obsession: Dark Desires,</b> women share their emotional stories of survival against obsessive stalkers who would do anything to satisfy their all-consuming infatuation. In the beginning, a persistent suitor, unshakeable new friend, or nosy neighbor may seem harmless… until one wrong move causes them to snap, revealing their true selves and horrifying motivations. <i>Obsession: Dark Desires</i> provides a chilling look into the mechanics of an obsessive mind and the devastating impact of delusional fantasy. When boundaries are crossed, the lives of victim and stalker become tragically interlaced as dangerous compulsions replace rationality and leave the victim with nowhere to hide. With their safety and sanity at risk, victims fight to protect themselves and their families from an irrepressible torment.</p>",
    officialSite:
      "https://www.investigationdiscovery.com/tv-shows/obsession-dark-desires/",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-14",
  },
  {
    id: 1347,
    url: "https://www.tvmaze.com/shows/1347/wild-transport",
    name: "Wild Transport",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18655.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18655.jpg",
    },
    summary:
      '<p><b>Wild Transport</b> follows the passionate team at the premier animal rescue, removal and relocation company that specializes in the dangerous and deadly. The "Wild Transport" team is led by dynamic duo, Rick and Andrew, who are extreme opposites but share a childlike enthusiasm for creatures big and small, taking advantage of any opportunity to get up close and personal with the animals they transport. From lions and tigers to alligators and cobras, each transport proves to be an adventure with its own set of challenges as they travel across the country with unique and risky cargo in tow.</p>',
    officialSite: "http://www.aetv.com/shows/wild-transport",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-06",
  },
  {
    id: 1348,
    url: "https://www.tvmaze.com/shows/1348/framework",
    name: "Framework",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31461.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31461.jpg",
    },
    summary:
      "<p>Spike TV is building a new original non-scripted franchise with the first-ever furniture design competition series, <b>Framework</b>, hosted by renowned hip-hop artist, actor, and author, Common.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 34,
      name: "Paramount Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-06",
  },
  {
    id: 1349,
    url: "https://www.tvmaze.com/shows/1349/impact-wrestling",
    name: "iMPACT Wrestling",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31685.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31685.jpg",
    },
    summary:
      "<p>Originally known as <i>TNA iMPACT!</i> now known as <b>iMPACT Wrestling</b> is 2 hours of fast paced, innovative, usually high flying, sometimes brutal pro-wrestling. Featuring a mix of stars you know and love and new, up and coming talent, it'll blow away the cobwebs and leave you wanting more.</p>",
    officialSite: "https://impactwrestling.com/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 170,
      name: "AXS TV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-06-04",
  },
  {
    id: 1350,
    url: "https://www.tvmaze.com/shows/1350/mob-wives",
    name: "Mob Wives",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18658.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18658.jpg",
    },
    summary:
      '<p><b>Mob Wives</b> is a docu-soap series which follows the lives of a group of ("according to the federal government") associated women at a crossroads, struggling to establish their own identities and carry on while their loved ones do time for Mob-related activities. Along the way they battle their friends, families, and each other as they try to do what\'s best for themselves, their children, and their future.</p><p>When lines are crossed and when true colors come out - Who will unite and who will fight? Over the course of five seasons, <i>Mob Wives</i> viewers have witnessed moments of genuine struggle, friendship, and betrayal among a tight-knit group of Staten Island women united by a connection never before seen on television. But one thing remained clear throughout - it\'s family connections that count the most. Now those bonds are put to the ultimate test in the sixth and final season of <i>Mob Wives</i> coined <i>Mob Wives: The Last Stand</i>.</p><p>For the final, emotionally-charged cycle, <i>Mob Wives: The Last Stand</i> returns the focus exclusively to where it all began – New York City. The Philly girls have left the building, and the "OG" cast is back together on Staten Island, where they always keep it "one-hundred" with each other. But amongst this sisterhood could there be enemies within?</p><p>Since the series premiere in 2011, the women have created new lives for themselves as their loved ones do time for alleged mob-related activities. For each of these women, the struggle is real, and sometimes betrayal is a way of life. Season 6 covers a particularly full range of stories: writing a personal tell-all, battling cancer and shutting a beloved business, dealing with a rebellious teenage daughter, coping with a father\'s imprisonment, calling out supposed friends for being fake, or being the new girl and having to prove that you\'re authentic. Despite the high-octane drama these ladies are known for, they are more than just their "reputed" mob connections. They are mothers and wives, businesswomen and entrepreneurs, and for the last time, they\'re putting it all on the line to survive. Complicating the situation even more, two local newcomers are about to make their presence known in no uncertain terms.</p>',
    officialSite: "http://www.vh1.com/shows/mob_wives/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 55,
      name: "VH1",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-04-17",
  },
  {
    id: 1351,
    url: "https://www.tvmaze.com/shows/1351/my-600-lb-life",
    name: "My 600-Lb. Life",
    genres: ["Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/291/728268.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/291/728268.jpg",
    },
    summary:
      "<p>TLC follows medical journeys of morbidly obese people as they attempt to save their own lives. The featured individuals -- each weighing more than 600 pounds -- confront lifelong emotional and physical struggles as they make the courageous decision to undergo high-risk gastric bypass surgery. In addition to drastically changing their appearances, they hope to reclaim their independence, mend relationships with friends and family, and renew their feelings of self-worth.</p>",
    officialSite: "https://www.tlc.com/tv-shows/my-600-lb-life/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-02-01",
  },
  {
    id: 1352,
    url: "https://www.tvmaze.com/shows/1352/evil-twins",
    name: "Evil Twins",
    genres: ["Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/130/327092.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/130/327092.jpg",
    },
    summary:
      "<p>Channeling sibling rivalries and deadly childhood pacts, <b>Evil Twins</b> follows true-crime mysteries surrounding cases of these double-duty archetypes. Each episode reveals a pair of sinister siblings: twins who tag team to kill together, twins who turn on each other, and even the good twin versus the evil.</p>",
    officialSite: "http://www.investigationdiscovery.com/tv-shows/evil-twins/",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-07-26",
  },
  {
    id: 1353,
    url: "https://www.tvmaze.com/shows/1353/wild-grinders",
    name: "Wild Grinders",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18661.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18661.jpg",
    },
    summary:
      "<p>From the mind of pro-skateboarder, Rob Dyrdek, come this rad new series based on Dyrdek's younger years as a skateboarder packed with a whole lot of awesome!</p><p>Lil Rob and his wacky crew of energetic skateboarders, the Wild Grinders, are all about having fun and grinding their way through Sprawl City! Whether it's filming stunts on homemade ramps or the local skate park, the Wild Grinders always seem to come up against their \"evil nemesis\" Stubford Hucksterball, clumsy skater and son of local industrialist, Track Hucksterball of Hucksterball Industries. No matter what the adventure, the Wild Grinders have what it takes to find their way out of trouble and make it home in time for dinner.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 73,
      name: "Nicktoons",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-04-27",
  },
  {
    id: 1354,
    url: "https://www.tvmaze.com/shows/1354/ufo-conspiracies",
    name: "UFO Conspiracies",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18662.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18662.jpg",
    },
    summary: "<p>UFO conspiracies are investigated.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 77,
      name: "Science",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-19",
  },
  {
    id: 1355,
    url: "https://www.tvmaze.com/shows/1355/empire",
    name: "Empire",
    genres: ["Drama", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/217/544852.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/217/544852.jpg",
    },
    summary:
      "<p><b>Empire</b> is a powerful drama about a family dynasty set within the glamorous and sometimes dangerous world of hip-hop music. The show revolves around the Lyon family and their media company, Empire Entertainment. The founder, Lucious Lyon, is the king of hip-hop, but his company and reign are constantly threatened by his family, including his ex-wife, Cookie Lyon; his sons, Jamal, Hakeem and Andre; and a volatile and competitive music industry.</p>",
    officialSite: "http://www.fox.com/empire",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-07",
  },
  {
    id: 1356,
    url: "https://www.tvmaze.com/shows/1356/wahlburgers",
    name: "Wahlburgers",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18664.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18664.jpg",
    },
    summary:
      '<p><b>Wahlburgers</b> goes behind-the-scenes of one of Boston\'s most well-known families, the Wahlbergs. Brothers Mark, Donnie and Paul join forces to embark on a hometown-based business venture, a hamburger restaurant that touts the family name. An homage to their humble beginnings, the restaurant is home base for the gang from the old neighborhood, including Mark\'s sidekicks, the real Johnny "Drama" and Henry "Nacho" Laun, Paul\'s trusty assistant Kari Burke and of course, the matriarch of the Wahlberg family, their spirited mother Alma. In the new season, Mark and Donnie juggle their roles at the restaurant while working abroad. Mark heads to China to promote a film and convinces "Drama" and "Nacho" to tag along. Donnie is on tour in London with New Kids On The Block when his fiancée Jenny McCarthy arranges for a surprise visitor to help stave off his homesickness. Back in Boston, Paul gets in over his head when he decides to join a fantasy football league, so he seeks help from family friend Rob Gronkowski. Brandon finds himself caught in a prank war with Kari, while Alma has a new love in her life - her new smartphone.</p>',
    officialSite: "http://www.aetv.com/wahlburgers",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-22",
  },
  {
    id: 1357,
    url: "https://www.tvmaze.com/shows/1357/black-market",
    name: "Black Market",
    genres: ["Crime"],
    image: null,
    summary:
      "<p>From the illegal weapons to the underground sex trade, nothing is off limits and everything is for sale in illegal, underground markets. It's an industry that is brutal, exploitative, and corrupt where what you buy isn't always what it seems. Despite efforts to crack down on these illegal trades, more than $625 billion makes it's way into the US economy each year for illegal trade goods. Unprecedented inside access brings light to the inner workings of the last bastion of \"free\" enterprise, charting a global path to the underworld economy. Workers, suppliers, sellers, customers – and the law enforcement trying to keep it in check - share their experience of a hidden world that touches us all.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-07",
  },
  {
    id: 1358,
    url: "https://www.tvmaze.com/shows/1358/valentine",
    name: "Valentine",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/18857.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/18857.jpg",
    },
    summary:
      "<p>Sent down from Mount Olympus to contemporary Los Angeles to bring soul mates together, the Valentine family uses a little old fashioned magic to ensure that true love blossoms on earth. Grace Valentine, better known as Aphrodite, the Goddess of Love, is concerned for the future of her family business, as well as for the family's immortality. To bring a fresh perspective to the job of matchmaking, Grace enlists the help of romance novelist Kate Providence, much to the chagrin of her son Danny, a.k.a. Eros, the God of Erotic Love. The Valentines attempt to spark romance between a pair of soul-mates who have been long-time best friends.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-10-05",
  },
  {
    id: 1362,
    url: "https://www.tvmaze.com/shows/1362/lab-rats-bionic-island",
    name: "Lab Rats: Bionic Island",
    genres: ["Comedy", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/136/341455.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/136/341455.jpg",
    },
    summary:
      '<p><b>Lab Rats: Bionic Island</b> introduces Leo just as he settles into the high-tech home he shares with his inventor stepdad, Donald Davenport, his mom, Tasha, and Eddy, the "smart house" computer. There he discovers a secret underground lab with three experiments, super-human teens: Adam the strong one, Bree the fast one and Chase the smart one. The trio, eager to leave their confines, convinces Leo and his parents to let them join him at school where they try to fit in while trying to manage their unpredictable bionic strengths. Along the way, they help Leo build self confidence while he figures out a way to keep their bionic abilities a secret from the world.</p>',
    officialSite: "http://disneyxd.disney.com/lab-rats",
    webChannel: {
      id: 83,
      name: "DisneyNOW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: {
      id: 25,
      name: "Disney XD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-02-27",
  },
  {
    id: 1363,
    url: "https://www.tvmaze.com/shows/1363/humans",
    name: "Humans",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/182/457420.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/182/457420.jpg",
    },
    summary:
      "<p><b>Humans</b> is set in a parallel present where the latest must-have gadget for any busy family is a <i>Synth</i> – a highly-developed robotic servant eerily similar to its live counterpart. In the hope of transforming the way they live, one strained suburban family purchases a refurbished synth only to discover that sharing life with a machine has far-reaching and chilling consequences.</p>",
    officialSite: "http://www.channel4.com/programmes/humans",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-06-14",
  },
  {
    id: 1364,
    url: "https://www.tvmaze.com/shows/1364/powers",
    name: "Powers",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/60/151212.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/60/151212.jpg",
    },
    summary:
      "<p>Combining the genres of superhero fantasy, crime noir and police procedural, <b>Powers</b> is set in a world full of people with superhuman abilities and where all of those powers are just another catalyst for mayhem and murder. The series follows Detective Christian Walker, who is in charge of protecting humans like us and investigating cases involving the God-like men and women, referred to as <i>Powers</i>, who glide through the sky on lightning bolts and fire and who clash above cities in epic battle, oblivious to the mortals below.</p>",
    officialSite:
      "http://www.playstation.com/en-us/explore/playstation-plus/powers/",
    webChannel: {
      id: 14,
      name: "Playstation",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-03-10",
  },
  {
    id: 1365,
    url: "https://www.tvmaze.com/shows/1365/man-seeking-woman",
    name: "Man Seeking Woman",
    genres: ["Comedy", "Fantasy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/46/116897.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/46/116897.jpg",
    },
    summary:
      '<p><b>Man Seeking Woman</b> follows naïve twenty-something "Josh Greenberg" on his unrelenting quest for love. Josh soldiers through one-night stands, painful break-ups, a blind date with a troll, time travel, sex aliens, many deaths and a Japanese penis monster named Tanaka on his fantastical journey to find love.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 47,
      name: "FXX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-14",
  },
  {
    id: 1366,
    url: "https://www.tvmaze.com/shows/1366/fortitude",
    name: "Fortitude",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/176/441318.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/176/441318.jpg",
    },
    summary:
      "<p><b>Fortitude</b> is a place like nowhere else. Although surrounded by the savage beauty of the Arctic landscape, Fortitude is one of the safest towns on earth. There has never been a violent crime here. Until now. In such a close-knit community a murder touches everyone and the unsettling, mysterious horror of this crime threatens the future of the town itself.</p>",
    officialSite: "https://www.sky.com/watch/channel/sky-atlantic/fortitude",
    webChannel: {
      id: 117,
      name: "Sky Go",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-01-29",
  },
  {
    id: 1367,
    url: "https://www.tvmaze.com/shows/1367/sense8",
    name: "Sense8",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/154/387311.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/154/387311.jpg",
    },
    summary:
      "<p>A group of people around the world are suddenly linked mentally, and must find a way to survive being hunted by those who see them as a threat to the world's order.</p>",
    officialSite: "https://www.netflix.com/title/80025744",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-06-05",
  },
  {
    id: 1368,
    url: "https://www.tvmaze.com/shows/1368/unbreakable-kimmy-schmidt",
    name: "Unbreakable Kimmy Schmidt",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/182/456853.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/182/456853.jpg",
    },
    summary:
      "<p>When a woman is rescued from a doomsday cult and lands in New York City, she must navigate a world she didn't think even existed anymore.</p>",
    officialSite: "https://www.netflix.com/title/80025384",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-03-06",
  },
  {
    id: 1369,
    url: "https://www.tvmaze.com/shows/1369/marvels-daredevil",
    name: "Marvel's Daredevil",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/171/429391.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/171/429391.jpg",
    },
    summary:
      "<p>Matt Murdock, a Marvel Comics hero who's a lawyer by day but fights the bad guys at night to avenge the murder of his father, a boxer. But what sets Matt apart from most superheroes isn't his back story it's his handicap. Matt is blind, the result of a childhood accident that removed his ability to see but gifted him with heightened senses of touch, taste, hearing and smell.</p>",
    officialSite: "https://www.netflix.com/title/80018294",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-04-10",
  },
  {
    id: 1370,
    url: "https://www.tvmaze.com/shows/1370/marvels-jessica-jones",
    name: "Marvel's Jessica Jones",
    genres: ["Action", "Crime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/200/502332.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/200/502332.jpg",
    },
    summary:
      "<p>Haunted by a traumatic past, Jessica Jones uses her gifts as a private eye to find her tormentor before he can harm anyone else in Hell's Kitchen.</p>",
    officialSite: "https://www.netflix.com/title/80002311",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-11-20",
  },
  {
    id: 1371,
    url: "https://www.tvmaze.com/shows/1371/westworld",
    name: "Westworld",
    genres: ["Drama", "Science-Fiction", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/241/602832.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/241/602832.jpg",
    },
    summary:
      "<p><b>Westworld</b> is a dark odyssey about the dawn of artificial consciousness and the evolution of sin. Set at the intersection of the near future and the reimagined past, it explores a world in which every human appetite, no matter how noble or depraved, can be indulged.</p>",
    officialSite: "http://www.hbo.com/westworld",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2016-10-02",
  },
  {
    id: 1372,
    url: "https://www.tvmaze.com/shows/1372/bloodline",
    name: "Bloodline",
    genres: ["Drama", "Thriller", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/177/444579.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/177/444579.jpg",
    },
    summary:
      "<p><b>Bloodline</b> is a dramatic thriller that explores the demons lurking beneath the surface of a contemporary American family. The Rayburns are hard-working pillars of their Florida Keys community. But when the black sheep son comes home for the 45th anniversary of his parents' hotel, he threatens to expose the Rayburns' dark secrets and shameful past, pushing his siblings to the limits of family loyalty.</p>",
    officialSite: "https://www.netflix.com/title/80010655",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-03-20",
  },
  {
    id: 1374,
    url: "https://www.tvmaze.com/shows/1374/mcleods-daughters",
    name: "McLeod's Daughters",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/19089.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/19089.jpg",
    },
    summary:
      '<p>The four female leads carry the heart of each story throughout the series, which Posie believes reflects much of the truth of what\'s happening in Australia.</p><p>"The timing was right for this type of show - a rural-based series which showcases a predominately female cast and tells stories that reflect the lives and desires of contemporary Australian women," said Posie.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 120,
      name: "Nine Network",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2001-08-08",
  },
  {
    id: 1375,
    url: "https://www.tvmaze.com/shows/1375/touched-by-an-angel",
    name: "Touched by an Angel",
    genres: ["Drama", "Family", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/19094.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/19094.jpg",
    },
    summary:
      "<p>A trio of angels Monica, Tess and Andrew are dispatched from heaven with a special mission: to inspire people facing sometimes unseen crossroads in their lives. Monica, an angel who at times still needs some guidance with her earthly assignments, reports to Tess, her tough, wise and always loving supervisor. Also on hand is Andrew, who, in addition to his duties as the Angel of Death, now helps out as a caseworker on various assignments. Gloria, an angel for the 21st century, continues to seek guidance from Monica performing her angelic duties. While the angels may not bring solutions to every problem, they always deliver a message of hope.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1994-09-21",
  },
  {
    id: 1376,
    url: "https://www.tvmaze.com/shows/1376/flikken",
    name: "Flikken",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/19096.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/19096.jpg",
    },
    summary:
      "<p>In Flikken wordt het politieteam van Gent gevolgd. We zien ook wat er zich in het privéleven van de agenten afspeelt.</p>",
    officialSite: null,
    webChannel: null,
    language: "Dutch",
    status: "Ended",
    network: {
      id: 121,
      name: "één",
      country: { name: "Belgium", code: "BE", timezone: "Europe/Brussels" },
    },
    premiered: "1999-10-17",
  },
  {
    id: 1377,
    url: "https://www.tvmaze.com/shows/1377/the-spoils-of-babylon",
    name: "The Spoils of Babylon",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/19133.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/19133.jpg",
    },
    summary:
      "<p>The six-part dark comedy is the bizarre adaptation of a non-existent novel penned by fictional author Eric Jonrosh. The show follows a dysfunctional family of oil tycoons led by Jonas Morehouse. His children are set to inherit the fortune if they can fight their forbidden love for each other.</p>",
    officialSite: "http://www.ifc.com/shows/the-spoils-of-babylon",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 65,
      name: "IFC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-09",
  },
  {
    id: 1379,
    url: "https://www.tvmaze.com/shows/1379/siberia",
    name: "Siberia",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/19245.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/19245.jpg",
    },
    summary:
      "<p>In 1908, a meteor hit deep into the remote Siberian territory of Tunguska. Now, more than 100 years later, 16 contestants descend on Tunguska unknowing of the land's mysterious past. When a contestant is badly injured and no help arrives, the contestants are met with the chilling realization that the strange occurrences are not part of the show. With their safety threatened, competing contestants must band together in an effort to survive.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-07-01",
  },
  {
    id: 1380,
    url: "https://www.tvmaze.com/shows/1380/outlaw",
    name: "Outlaw",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/19248.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/19248.jpg",
    },
    summary:
      "<p>Cyrus Garza is a U.S. Supreme Court justice who abruptly quits the high-level position. A playboy and a gambler, Garza had always adhered to a strict interpretation of the law until he realized the system he believed in was flawed. Now that he's quit the bench and returned to private practice, he's determined to represent \"the little guy\" and use his inside knowledge of the justice system to take on today's biggest legal cases -- and he's making plenty of powerful people unhappy along the way.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-15",
  },
  {
    id: 1381,
    url: "https://www.tvmaze.com/shows/1381/the-first-48",
    name: "The First 48",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/244/612268.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/244/612268.jpg",
    },
    summary:
      "<p><b>The First 48</b> follows detectives from around the country during these first critical hours as they race against time to find the suspect. Gritty and fast-paced, it takes viewers behind the scenes of real-life investigations with unprecedented access to crime scenes, autopsies, forensic processing, and interrogations.</p>",
    officialSite: "http://www.aetv.com/shows/the-first-48",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-06-03",
  },
  {
    id: 1382,
    url: "https://www.tvmaze.com/shows/1382/dracula",
    name: "Dracula",
    genres: ["Drama", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/19413.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/19413.jpg",
    },
    summary:
      "<p>Golden Globe winner Jonathan Rhys Meyers (\"The Tudors\") stars in this provocative new drama as one of the world's most iconic characters. It's the late 19th century and the mysterious Dracula (Rhys Meyers) has arrived in London, posing as an American entrepreneur who wants to bring modern science to Victorian society. He's especially interested in the new technology of electricity, which promises to brighten the night - useful for someone who avoids the sun. But he has another reason for his travels: He hopes to take revenge on those who cursed him with immortality centuries earlier. Everything seems to be going according to plan... until he becomes infatuated with a woman who appears to be a reincarnation of his dead wife.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-10-25",
  },
  {
    id: 1383,
    url: "https://www.tvmaze.com/shows/1383/garfunkel-and-oates",
    name: "Garfunkel and Oates",
    genres: ["Comedy", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/19545.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/19545.jpg",
    },
    summary:
      "<p><b>Garfunkel and Oates</b> centers on the aspirations and misadventures of the female comedy-folk duo Riki Lindhome (Garfunkel) and Kate Micucci (Oates), and will spotlight the personal and professional lives of the duo whose career choices - singing satirical and sometimes dirty songs - leaves them with little in common with their peers, and no one but each other to turn to for support and understanding.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 65,
      name: "IFC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-08-07",
  },
  {
    id: 1384,
    url: "https://www.tvmaze.com/shows/1384/kate-plus-8",
    name: "Kate Plus 8",
    genres: ["Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/19548.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/19548.jpg",
    },
    summary:
      "<p><b>Kate Plus 8</b> is a spin-off of <i>Jon and Kate Plus 8</i>, which follows Kate Gosselin as she raises her supersize brood.</p>",
    officialSite: "http://www.tlc.com/tv-shows/kate-plus-8/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-08-30",
  },
  {
    id: 1385,
    url: "https://www.tvmaze.com/shows/1385/kendra-on-top",
    name: "Kendra on Top",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/19549.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/19549.jpg",
    },
    summary:
      "<p>She seemed to have the picture perfect family: perfect husband, perfect son and a beautiful, newborn baby girl. But just five weeks after the birth of her daughter, a shocking claim involving her husband surfaces and instantly turns Kendra's world upside down on <b>Kendra on Top</b>.</p>",
    officialSite: "http://www.wetv.com/shows/kendra-on-top",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 122,
      name: "WE tv",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-06-05",
  },
  {
    id: 1386,
    url: "https://www.tvmaze.com/shows/1386/my-five-wives",
    name: "My Five Wives",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/19550.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/19550.jpg",
    },
    summary:
      "<p>The Williams family are progressive polygamists. They offer a fresh, honest look at a controversial lifestyle.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-03-09",
  },
  {
    id: 1387,
    url: "https://www.tvmaze.com/shows/1387/richkids-of-beverly-hills",
    name: "#RichKids of Beverly Hills",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/55/139453.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/55/139453.jpg",
    },
    summary:
      "<p>Welcome back to the 90210, which has acquired a new resident as EJ Johnson relocates to Los Angeles and joins his friends in the fabuluxe zip code over flowing with sunshine, designer fashions, and plenty of plastic by way of surgery and credit cards. The new season of <b>#RichKids of Beverly Hills</b> kicks off with a trip to China for the opening of an elite department store that just so happens to be owned by Dorothy's retail mogul father. Joining Dorothy on the trip are Morgan, Brendan, Jonny, and Roxy who is growing tired of Dorothy's reoccurring jabs about her career, style and being financially cut-off by her parents. However, Roxy isn't the only one carrying drama in her couture luggage as Dorothy's boyfriend Cooper is inexplicably absent from the crew's overseas adventures. Even with the galas, VIP treatments, amazing sightseeing and being surrounded by her #BFFs, Dorothy is still distracted by what appears to be a major bump in her relationship and an opportunity to show Cooper the Wang empire. Sounds like love is a battlefield, even when that battlefield is a multimillion dollar property in Beverly Hills and you're worth billions of dollars.</p>",
    officialSite: "http://uk.eonline.com/shows/rich_kids_of_beverly_hills",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 43,
      name: "E!",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-19",
  },
  {
    id: 1388,
    url: "https://www.tvmaze.com/shows/1388/jimmy-kimmel-live",
    name: "Jimmy Kimmel Live",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/157/394970.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/157/394970.jpg",
    },
    summary:
      "<p><b>Jimmy Kimmel Live</b> features a diverse lineup of guests that include celebrities, athletes, musical acts, comedians and human-interest subjects, along with comedy bits and a house band.</p>",
    officialSite: "http://abc.go.com/shows/jimmy-kimmel-live/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-01-26",
  },
  {
    id: 1389,
    url: "https://www.tvmaze.com/shows/1389/the-nightly-show-with-larry-wilmore",
    name: "The Nightly Show with Larry Wilmore",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/19554.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/19554.jpg",
    },
    summary:
      "<p>Continuing in Comedy Central's grand tradition of producing groundbreaking late night formats, <i><b>\"The Nightly Show\"</b></i> will provide viewers with Larry Wilmore's distinct point of view and comedic take on current events and pop culture. Hosted by Wilmore, the series will feature a diverse panel of voices, providing a perspective largely missing in the late night television landscape.</p>",
    officialSite: "http://www.cc.com/shows/the-nightly-show",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-19",
  },
  {
    id: 1390,
    url: "https://www.tvmaze.com/shows/1390/sister-wives",
    name: "Sister Wives",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/293/732872.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/293/732872.jpg",
    },
    summary:
      '<p><b>Sister Wives</b> explores the complex daily life of a polygamist family. <i>Sister Wives</i> introduces audiences to husband Kody -- along with his three wives; Meri, Janelle and Christine and their combined 13 children -- showing how they attempt to navigate life as a "normal" family in a society that shuns their lifestyle. From their unconventional family structure and living arrangements to financial challenges, each half hour episode exposes the inner workings of a polygamist household, revealing the unexpectedly tight-knit and loving relationships between Kody\'s wives.</p>',
    officialSite: "https://www.tlc.com/tv-shows/sister-wives/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-26",
  },
  {
    id: 1391,
    url: "https://www.tvmaze.com/shows/1391/total-divas",
    name: "Total Divas",
    genres: ["Drama", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/19565.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/19565.jpg",
    },
    summary:
      "<p>Revealing the real women behind the WWE Divas for the first time, this new one-hour series proves that the drama is even bigger when the sexy superstars step outside the ring. <b>Total Divas</b> goes inside the personal lives of these glitzy, glamorous celebrities who entertain sold-out crowds in arenas around the world and are adored by millions.</p>",
    officialSite: "http://www.eonline.com/shows/total_divas",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 43,
      name: "E!",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-07-28",
  },
  {
    id: 1392,
    url: "https://www.tvmaze.com/shows/1392/welcome-to-sweden",
    name: "Welcome to Sweden",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/19567.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/19567.jpg",
    },
    summary:
      "<p>American Bruce Evans moves from New York to Stockholm with his Swedish girlfriend Emma to start a new life. But it will not be easy for Bruce with the conversion, it means moving to a new country with a different culture and the question is whether their love will survive.</p>",
    officialSite: null,
    webChannel: null,
    language: "Swedish",
    status: "Ended",
    network: {
      id: 123,
      name: "TV4",
      country: { name: "Sweden", code: "SE", timezone: "Europe/Stockholm" },
    },
    premiered: "2014-03-21",
  },
  {
    id: 1393,
    url: "https://www.tvmaze.com/shows/1393/breaking-point",
    name: "Breaking Point",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/22061.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/22061.jpg",
    },
    summary:
      "<p>This show features subjects who believe they are participating in a documentary about their life of crime. What they don't know is they will soon face an intervention that offers only two choices: accept treatment or face the possibility of prison time. Each surprise intervention is conducted by top criminal defense attorney and certified intervention professional Darren Kavinoky.</p>",
    officialSite:
      "http://www.investigationdiscovery.com/tv-shows/breaking-point/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-15",
  },
  {
    id: 1394,
    url: "https://www.tvmaze.com/shows/1394/love-thy-sister",
    name: "Love Thy Sister",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23749.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23749.jpg",
    },
    summary:
      '<p><i><b>"Love Thy Sister"</b></i> follows The Ruckers - Ruby, Ellen and Ione - educated, sexy, and sassy southern sisters who love hard and fight even harder.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 122,
      name: "WE tv",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-08",
  },
  {
    id: 1395,
    url: "https://www.tvmaze.com/shows/1395/alaska-battle-on-the-bay",
    name: "Alaska: Battle on the Bay",
    genres: ["Adventure", "Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23753.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23753.jpg",
    },
    summary:
      "<p><b>Alaska: Battle on the Bay</b> submerges viewers within a high-stakes fishing drama as 1,800 captains and their crews draw the battle lines to help protect Alaska's ecosystem from the 44 million strong sockeye salmon migration and reel in a massive payday.</p><p>On the bay, the arm of the law is long, tempers are short and every single decision is the difference between drawing a huge income and settling for pennies. The series opens just days before the annual migration of more than 44 million sockeye salmon in Alaska's Bristol Bay and closely follows five captains and their ships. This battle comes with several tough challenges: all 1,800 boats must fight the elements and each other within highly policed areas of water \"districts\" during a tight four-week fishing season.It's environmentally necessary to fish for almost half a billion salmon since they may wreak havoc on Alaska's waterways, so fish and game dictate very stringent times and boundaries for fishing and utilize recon helicopters and police squads to monitor the quantity of the fish hauled out. But, the police presence does nothing to deter fishing boats from becoming battering rams and crashing into one another for prime position.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 92,
      name: "Animal Planet",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-08",
  },
  {
    id: 1396,
    url: "https://www.tvmaze.com/shows/1396/king-of-the-nerds",
    name: "King of the Nerds",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/22057.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/22057.jpg",
    },
    summary:
      "<p>The show invites competitors spanning the full nerd spectrum to come together to face challenges that will test their intellect, ingenuity, skills and pop-culture prowess. The nerds will first compete as teams before moving on to individual challenges, all with the goal of being named the quintessential master of all things nerdy.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 32,
      name: "TBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-01-17",
  },
  {
    id: 1397,
    url: "https://www.tvmaze.com/shows/1397/love-lust-or-run",
    name: "Love, Lust or Run",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23752.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23752.jpg",
    },
    summary:
      '<p>Style maven Stacy London coaches each woman on her fashion choices and under Stacy\'s tutelage she discovers what impact her choices are actually making in her life. At the beginning of each episode, viewers are given a glimpse at how defensive a woman dedicated to outrageous fashion can become when Stacy reveals how strangers on the street rate her style: either <b>Love, Lust or Run</b>. Next, each woman strips off her hair extensions, wild clothes, and garish makeup in order to start with a blank slate. Stacy then guides each woman through a transformative make-under, which will dramatically change her look and allow her to channel what she really wants from the outside world. Episodes will culminate when Stacy again takes to the streets to ask strangers to rate the woman\'s transformed style as "Love" "Lust" or "Run".</p>',
    officialSite: "http://www.tlc.com/tv-shows/love-lust-run/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-23",
  },
  {
    id: 1398,
    url: "https://www.tvmaze.com/shows/1398/preachers-daughters",
    name: "Preachers' Daughters",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/22056.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/22056.jpg",
    },
    summary:
      "<p>A profound and hard-hitting, but often humorous, look at the daily pressures typical teenagers face, Preachers' Daughters captures the intense moral, social, sexual and spiritual conflicts these daughters endure as they weigh whether or not to break free from the strong beliefs, time-honored traditions and rituals their loving, but strict, parents have raised them on.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-03-12",
  },
  {
    id: 1399,
    url: "https://www.tvmaze.com/shows/1399/big-giant-swords",
    name: "Big Giant Swords",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/19691.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/19691.jpg",
    },
    summary:
      "<p>When it comes to gigantic swords, no one makes them bigger and badder than Irishman Michael Craughwell. Irish Mike is putting it all on the line to make his passion his profession by attempting to make a living designing and building these larger-than-life works of art. Joined by his trusty sidekick AmeriMike and a motley crew of artists and builders, this master of steel will attempt to bring to life the stuff of fairytales and legends. Will it be a soaring tale of triumph... or a bitter saga of defeat?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-13",
  },
  {
    id: 1401,
    url: "https://www.tvmaze.com/shows/1401/2020",
    name: "20/20",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/320/801952.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/320/801952.jpg",
    },
    summary:
      "<p>The ABC News primetime news magazine <b>20/20</b> has distinguished itself as one of the most esteemed programs in broadcast journalism. Celebrating its 36th anniversary this season, 20/20 continues to combine hard-hitting investigative reports, newsmaker interviews and compelling human interest and feature stories. The program is anchored by award-winning journalists Elizabeth Vargas and David Muir. For over three decades 20/20 has offered viewers reports and stories that have changes lives.</p>",
    officialSite: "http://abcnews.go.com/2020",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1978-06-06",
  },
  {
    id: 1402,
    url: "https://www.tvmaze.com/shows/1402/felicity",
    name: "Felicity",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/19720.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/19720.jpg",
    },
    summary:
      "<p>A smart series about an idealistic student getting lessons in life and love at a Manhattan university after following her high-school crush east from California. Throughout most of the series' run, she was emotionally torn between somber Ben and sensitive Noel. A doctor's daughter, she also struggled to decide if she should follow in his footsteps or pursue her first love, art.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-09-29",
  },
  {
    id: 1403,
    url: "https://www.tvmaze.com/shows/1403/rosemarys-baby",
    name: "Rosemary's Baby",
    genres: ["Drama", "Horror", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/7/19805.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/7/19805.jpg",
    },
    summary:
      "<p><b>Rosemary's Baby</b> centers on a young married couple who move into a Paris apartment that has a haunted past. After getting pregnant, the wife becomes increasingly suspicious that both her husband and their neighbors will have ulterior motives when her child is born.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-05-11",
  },
  {
    id: 1405,
    url: "https://www.tvmaze.com/shows/1405/betas",
    name: "Betas",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20009.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20009.jpg",
    },
    summary:
      "<p>Four computer geeks have what they think is a brilliant idea -- a social networking app that, in the words of ringleader Trey, \"introduces you to the people you should know,\" unlike other popular sites, that simply let you keep up with people you already know. They have the app working (which required hacking into the already popular social networking sites for personal data), but they need an angel -- someone to invest some cash in their dream. They target George Murcheson, an investor who has passed on the likes of Facebook, Foursquare and Pinterest. Unable to get an appointment with the man, they crash his party and demo their app, which his investment adviser proclaims a stalker's dream. Murcheson's money could make or break the guys' futures. Raunchy, and with a lot of emphasis on sex and drugs, this Amazon original is not for the younger crowd, but offers grown-ups a look inside the workings of Silicon Valley and the roller-coaster ride of the start-up.</p>",
    officialSite: "http://www.amazon.com/betas",
    webChannel: { id: 3, name: "Amazon Prime Video", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2013-04-19",
  },
  {
    id: 1406,
    url: "https://www.tvmaze.com/shows/1406/stranded",
    name: "Stranded",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20010.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20010.jpg",
    },
    summary:
      "<p>Ping Pong Productions (Destination Truth, Finding Bigfoot) joins forces with Josh Gates (star of Syfy's travel-adventure series Destination Truth) and Jason Blum's Blumhouse (Paranormal Activity, The River) to create Stranded, an all-new six-episode reality series that documents an unconventional - and terrifying - paranormal and psychological experiment. Each hour-long episode features the self-recorded footage of a diverse group of every-day paranormal enthusiasts - from newlyweds and a brother-in-law to a trio of roommates. Each team of three will be stranded at one of the most haunted locations in America and record the entire experience with hand-held cameras. The footage from the subjects' cameras will be supplemented by strategically-placed security cameras at each location, creating a suspenseful, completely unscripted first-hand account of each group's stay. Over the course of the confinement, the subjects contend with increasingly pervasive feelings of fear and desolation, resulting in an experiment that represents a unique combination of psychology and the paranormal. Stranded is executive produced by Brad Kuhlman, Casey Brumels and Josh Gates (who also serves as showrunner) for Ping Pong Productions and Jason Blum for Blumhouse (the production company behind the Paranormal Activity feature film franchise and movies like Insidious and Sinister). Gerard Bocaccio who heads up Blumhouse TV will be a consultant on the project.(indefinite hiatus)</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-02-27",
  },
  {
    id: 1407,
    url: "https://www.tvmaze.com/shows/1407/1600-penn",
    name: "1600 Penn",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20011.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20011.jpg",
    },
    summary:
      "<p>The Gilchrists are just the average American family dealing with all the everyday issues, like a grown kid who's forced to move back home, teenagers who are smarter than their teachers and a stepmom desperately trying to win over the kids. They're loving, fun and a little crazy. In other words, just like everyone else - with one exception: they live in a very special house. The White House!</p><p>Whether it's entertaining foreign dignitaries, holding secret cabinet meetings or putting out fires - figuratively and sometimes literally - there's never a dull moment in the Gilchrist White House. For example, the First Son is one of the administration's biggest liabilities but also the glue that holds this family together. The President knows too well that the only thing harder than being Head of State is being head of the family.</p>",
    officialSite: "http://www.nbc.com/1600-penn",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-12-17",
  },
  {
    id: 1408,
    url: "https://www.tvmaze.com/shows/1408/thats-so-raven",
    name: "That's So Raven",
    genres: ["Comedy", "Children", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20019.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20019.jpg",
    },
    summary:
      "<p><b>That's So Raven</b> is a hit live-action sitcom about Raven Baxter, a winsome teen whose ability to glimpse flashes of the future often gets her into hot water.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 78,
      name: "Disney Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-01-17",
  },
  {
    id: 1409,
    url: "https://www.tvmaze.com/shows/1409/the-yard",
    name: "The Yard",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/125/313624.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/125/313624.jpg",
    },
    summary:
      "<p>Eleven-year-old Nick and his crew: idealistic younger brother J.J. – the brains of the outfit, weird pal Johnny – his lieutenant, big girl Suzi – the muscle, and their six-year-old sidekick Adam, jockey for school yard supremacy with the bully Frankie and his henchmen as a film crew documents the proceedings. Nick stepped in to end their reign of terror and restore the natural order – but it's tough staying on top – and Frankie will stop at nothing to regain power. The rival gangs make their own rules in a skewed world that reflects and refracts the reality we live in. The Yard is the world in microcosm, run by and for the kids; it is a funny fast paced Goodfellas in a school playground with a Romeo and Juliet twist.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 124,
      name: "HBO Canada",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2011-07-08",
  },
  {
    id: 1410,
    url: "https://www.tvmaze.com/shows/1410/the-booth-at-the-end",
    name: "The Booth at the End",
    genres: ["Drama", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20027.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20027.jpg",
    },
    summary:
      "<p>A mysterious Man sits at a booth at the end of a diner. People approach him because they've heard The Man has a gift. He can solve their problems: A parent with a sick child, a woman who wants to be prettier, a nun who has lost her faith. The Man can give these people what they want. For a price. The Man makes a proposition. In exchange for realizing their desires, these individuals must complete a task, return to The Man, and describe every step in detail. The trick is that these tasks are things that would normally be inconceivable to them. But The Man never forces anyone to do anything. It's always up to the individual to start - or stop. The Booth at the End asks the question: How far would you go to get what you want?</p>",
    officialSite: "http://www.hulu.com/the-booth-at-the-end",
    webChannel: {
      id: 207,
      name: "Citytv.com",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2010-08-27",
  },
  {
    id: 1411,
    url: "https://www.tvmaze.com/shows/1411/whites",
    name: "Whites",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20029.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20029.jpg",
    },
    summary:
      "<p>Roland is a fantastic chef who was on the brink of success 15 years ago, but has since lost the sparkle and drive needed to win that long coveted Michelin star. When he puts his mind to it he can cook with the best of them, but laziness gets the better of him, much to the annoyance of the restaurant's manager and Roland's secret admirer, Caroline (Katherine Parkinson). Joining them in the kitchen is quirky waitress Kiki (Isy Suttie), the hotel's owner Celia (Maggie Steed) and ambitious new apprentice chef, Skoose (Stephen Wight), whose ambition it is to replace the constantly under-pressure and long-suffering Bib! Amidst fine-dining and beautiful countryside, Whites should be a tranquil slice of heaven – but with this disparate group of characters behind the scenes, things can regularly heat up in the kitchen...</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00v3736",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-09-28",
  },
  {
    id: 1412,
    url: "https://www.tvmaze.com/shows/1412/last-tango-in-halifax",
    name: "Last Tango in Halifax",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/89/224678.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/89/224678.jpg",
    },
    summary:
      "<p>Celia and Alan are both widowed and in their seventies. When their respective grandsons put their details on Facebook, they rediscover a passionate relationship that started over sixty years ago.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b03h4107",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-11-20",
  },
  {
    id: 1413,
    url: "https://www.tvmaze.com/shows/1413/our-world-war",
    name: "Our World War",
    genres: ["Drama", "War", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20631.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20631.jpg",
    },
    summary:
      "<p>Tense combat drama series revealing experiences of British soldiers in World War I. Inspired by the Bafta-winning series <i>Our War</i>, which tracked the first-hand experiences of British troops on the front line in Afghanistan, this series immerses viewers in the real stories of British troops serving on the front line during World War I.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p022twsy",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-08-07",
  },
  {
    id: 1414,
    url: "https://www.tvmaze.com/shows/1414/air-crash-investigation",
    name: "Air Crash Investigation",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/114/285296.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/114/285296.jpg",
    },
    summary:
      "<p>Flying is one of the safest forms of transport. But what happens when tragedy strikes? From human error and accidents to mechanical faults and design flaws, the success of aviation history is punctuated with disaster and catastrophe. It's rare, but it does happen. Follow experts as they determine what went wrong and work out how to prevent these horrific tragedies from happening again. Examine the wrecks and official records, and hear from eyewitnesses, passengers and aviation experts as we reconstruct some of the most tragic disasters in aviation history. <b>Air Crash Investigation</b> looks at what went wrong and how future disasters can be averted.</p>",
    officialSite:
      "http://www.natgeotv.com/uk/shows/natgeo/air-crash-investigation",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 723,
      name: "National Geographic Channel",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2003-09-03",
  },
  {
    id: 1415,
    url: "https://www.tvmaze.com/shows/1415/heroes-reborn",
    name: "Heroes Reborn",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/197/493254.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/197/493254.jpg",
    },
    summary:
      '<p>The saga behind the 2006 breakout series <i>Heroes </i>continues as creator Tim Kring returns to the fold and develops new layers to his original superhero concept. This highly anticipated 13-episode miniseries will reconnect with the basic elements of the show\'s first season where ordinary people were waking up to the fact that they had extraordinary abilities. This series will be preceded by a new digital series that will introduce audiences to the new characters and storylines that will take the "Heroes" phenomenon to new places.</p>',
    officialSite: "http://www.nbc.com/heroes-reborn",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-24",
  },
  {
    id: 1417,
    url: "https://www.tvmaze.com/shows/1417/epic-meal-empire",
    name: "Epic Meal Empire",
    genres: ["Comedy", "Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20643.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20643.jpg",
    },
    summary:
      '<p>With more than 600 million views in weekly webisodes and over 6 million YouTube subscribers to date, Harley Morenstein, aka the "Sauce Boss," and his kitchen crew are ready for primetime television. From whiskey-laced, burger-stuffed lasagnas to donut casseroles to Jack &amp; Coke cupcakes — The Epic Meal Time team delivers recipes that are visually mind-blowing spins on food preparation and presentation. This new FYI series will follow the ingenious group as they invent spectacular new dishes, on a whole new "epic" level.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 125,
      name: "FYI,",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-26",
  },
  {
    id: 1418,
    url: "https://www.tvmaze.com/shows/1418/tiny-house-nation",
    name: "Tiny House Nation",
    genres: ["DIY"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/324/811142.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/324/811142.jpg",
    },
    summary:
      "<p>In <b>Tiny House Nation</b>, renovation experts and hosts, John Weisbarth and Zack Giffin, travel across America to show off ingenious small spaces and the inventive people who live in them, as well as help new families design and construct their own mini-dream home in a space no larger than 500 square feet. From a micro-apartment in New York City to a caboose car turned home in Montana to a micro-sized mobile home for road tripping – this is a series that celebrates the exploding movement of tiny homes. From pricey to budget friendly, \"Tiny House Nation\" is not a typical design show, but one that proves size doesn't always matter – it's creativity that counts.</p>",
    officialSite: "https://www.aetv.com/shows/tiny-house-nation",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-09",
  },
  {
    id: 1420,
    url: "https://www.tvmaze.com/shows/1420/dual-survival",
    name: "Dual Survival",
    genres: ["Drama", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20647.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20647.jpg",
    },
    summary:
      "<p>Experts agree there are some very basic — and universal — rules for surviving in the wild. Find shelter, find water, find food, find help. Beyond that, there's not much they agree on. Meet military trained Dave Canterbury and naturalist Cody Lundin — trained survival experts who have very different methods of meeting survival challenges. <br /><br /> Together, with their drastically different backgrounds, the pair are dropped into scenarios that could happen to anyone: marooned sailors, lost hikers, trapped divers and stranded mountain climbers. Equipped with minimal gear that would have been carried in the real-life situations, Cody and Dave must draw upon their arsenal of skills to devise extraordinary ways to use what they can find in their surroundings to demonstrate what it takes to stay alive.</p>",
    officialSite: "http://www.discovery.com/tv-shows/dual-survival/",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-06-11",
  },
  {
    id: 1421,
    url: "https://www.tvmaze.com/shows/1421/flying-wild-alaska",
    name: "Flying Wild Alaska",
    genres: ["Adventure", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20648.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20648.jpg",
    },
    summary:
      "<p>For the small, isolated communities of Northern Alaska, the only way in (and the only way out) is by bush plane. Here, the Tweto family - husband and wife Jim and Ferno and their daughters Ariel and Ayla - provide the only lifeline to America's last frontier via their regional airline, Era Alaska.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-01-14",
  },
  {
    id: 1422,
    url: "https://www.tvmaze.com/shows/1422/arctic-air",
    name: "Arctic Air",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20649.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20649.jpg",
    },
    summary:
      "<p><b>Arctic Air</b> is a one-hour adventure series set in the booming Arctic, about a maverick airline and the unconventional family who runs it. That world is Yellowknife, and the High Arctic that lies beyond. The vast terrain and unforgiving climate mean the stakes are sky-high. This is life without a safety net.</p>",
    officialSite: "http://www.cbc.ca/arcticair/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 36,
      name: "CBC",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2012-01-10",
  },
  {
    id: 1423,
    url: "https://www.tvmaze.com/shows/1423/worst-place-to-be-a-pilot",
    name: "Worst Place to be a Pilot",
    genres: ["Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/110/275081.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/110/275081.jpg",
    },
    summary:
      "<p>A visually jaw-dropping series that follows young British pilots flying in some of the most breathtaking, remote and dangerous locations on earth.</p>",
    officialSite:
      "http://www.channel4.com/programmes/worst-place-to-be-a-pilot",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-08-19",
  },
  {
    id: 1424,
    url: "https://www.tvmaze.com/shows/1424/bush-pilots",
    name: "Bush Pilots",
    genres: ["Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/99/249670.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/99/249670.jpg",
    },
    summary:
      "<p>Set in the breath-taking landscape of the Okavango Delta, Bush Pilots is the brand new and exclusive Dave original that follows plucky pilots as they battle treacherous weather, dangerous wildlife and a harsh wilderness.</p>",
    officialSite: "http://dave.uktv.co.uk/shows/bush-pilots/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 59,
      name: "Dave",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-07-02",
  },
  {
    id: 1425,
    url: "https://www.tvmaze.com/shows/1425/our-zoo",
    name: "Our Zoo",
    genres: ["Drama", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20658.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20658.jpg",
    },
    summary:
      "<p><b>Our Zoo</b> is a drama series based on the true story of the Mottershead family who, in the face of staunch opposition and huge personal sacrifice, founded Chester Zoo in the 1930s.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b04gvbkz",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-09-03",
  },
  {
    id: 1426,
    url: "https://www.tvmaze.com/shows/1426/iris",
    name: "Iris",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20662.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20662.jpg",
    },
    summary:
      "<p>Seven-part drama series about the lone female veterinarian Iris de Weerdt, who in her hometown, the rural village Rodenburg, has to deal with rural intolerance and misunderstanding.</p>",
    officialSite: null,
    webChannel: null,
    language: "Dutch",
    status: "Ended",
    network: {
      id: 1018,
      name: "NPO 1",
      country: {
        name: "Netherlands",
        code: "NL",
        timezone: "Europe/Amsterdam",
      },
    },
    premiered: "1992-09-28",
  },
  {
    id: 1427,
    url: "https://www.tvmaze.com/shows/1427/athena-goddess-of-war",
    name: "Athena: Goddess of War",
    genres: ["Action", "Thriller", "Espionage"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20678.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20678.jpg",
    },
    summary:
      "<p>A terrorist group known as <b>Athena</b> and led by evil mastermind Son Hyuk threatens South Korea and the world. It is now up to special agent Lee Jung Woo of the National Security Agency to foil their terrifying conspiracy. Jo Soo Young, the daughter of the South Korean president, is kidnapped and hidden away in Italy. Jung Woo and his team are given the assignment to find her and bring her back.</p>",
    officialSite: "http://tv.sbs.co.kr/athena/",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 127,
      name: "SBS",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2010-12-13",
  },
  {
    id: 1428,
    url: "https://www.tvmaze.com/shows/1428/iris",
    name: "IRIS",
    genres: ["Drama", "Action", "Espionage"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/90/226597.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/90/226597.jpg",
    },
    summary:
      "<p>Two elite National Security System (NSS) agents, Hyung Jun and Sa Woo who were sworn blood brothers, both fall for fellow agent Seung Hee. Sa Woo attempts to suppress his feelings for Seung Hee and wishes the couple the best.</p>",
    officialSite: "http://www.kbs.co.kr/drama/iris2/",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 128,
      name: "KBS2",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2009-10-14",
  },
  {
    id: 1429,
    url: "https://www.tvmaze.com/shows/1429/noord-zuid",
    name: "Noord Zuid",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/43/109035.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/43/109035.jpg",
    },
    summary:
      "<p>Noord Zuid gaat over de Amsterdamse rechercheur Dana, gespeeld door Ariane Schluter, die haar achtergrond als psychologe inzet bij het oplossen van misdaden. Na haar scheiding van Wouter, met wie ze 19 jaar getrouwd is geweest, probeert ze samen met haar dochter Roos, een puber van 16, haar privéleven weer vorm te geven. Dana is teamleider van het rechercheteam. In de eerste aflevering wordt Dana geconfronteerd met een dubbele moord. Deze zaak loopt als een rode draad door de serie. Daarnaast worden er per aflevering losse zaken opgelost.</p>",
    officialSite: "http://noordzuid.kro.nl/",
    webChannel: null,
    language: "Dutch",
    status: "Ended",
    network: {
      id: 1018,
      name: "NPO 1",
      country: {
        name: "Netherlands",
        code: "NL",
        timezone: "Europe/Amsterdam",
      },
    },
    premiered: "2015-01-02",
  },
  {
    id: 1430,
    url: "https://www.tvmaze.com/shows/1430/resistance",
    name: "Résistance",
    genres: ["Drama", "War", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21373.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21373.jpg",
    },
    summary:
      "<p>Lili is 17 years old. In occupied France, she encounters war before love, and joins the Resistance. Through the interconnecting destinies of its teenage heroes, Resistance tells the story of young people going to any lengths to defend their country.</p>",
    officialSite: "http://www.tf1.fr/resistance/",
    webChannel: null,
    language: "French",
    status: "Ended",
    network: {
      id: 129,
      name: "TF1",
      country: { name: "France", code: "FR", timezone: "Europe/Paris" },
    },
    premiered: "2014-05-19",
  },
  {
    id: 1431,
    url: "https://www.tvmaze.com/shows/1431/lauren",
    name: "Lauren!",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/34476.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/34476.jpg",
    },
    summary:
      "<p>Lauren Verster is doing research to special and unknown worlds to her. Worlds that are mostly dominated by men. Raw, Rough and Tough. Lauren takes you on a journey of Discovery.</p>",
    officialSite: "http://www.avrotros.nl/lauren/home/",
    webChannel: null,
    language: "Dutch",
    status: "Running",
    network: {
      id: 1020,
      name: "NPO 3",
      country: {
        name: "Netherlands",
        code: "NL",
        timezone: "Europe/Amsterdam",
      },
    },
    premiered: "2014-12-01",
  },
  {
    id: 1432,
    url: "https://www.tvmaze.com/shows/1432/wolf-hall",
    name: "Wolf Hall",
    genres: ["Drama", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/56/142098.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/56/142098.jpg",
    },
    summary:
      "<p>Historical drama chronicling the rise of Thomas Cromwell, the son of a humble blacksmith who became King Henry VIII's chief minister, as he navigated the corridors of power in the Tudor court.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p02gfy02",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-01-21",
  },
  {
    id: 1433,
    url: "https://www.tvmaze.com/shows/1433/war-and-remembrance",
    name: "War and Remembrance",
    genres: ["Drama", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/22128.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/22128.jpg",
    },
    summary:
      "<p><br>Filmed on location in ten countries, this extraordinary production is the largest and most ambitious undertaking in television and motion picture history. Featuring an all-star cast and spectacular reenactments of the Allied invasions at Normandy and the Philippines, Herman Wouk s classic novel is brought to life in an award-winning mini-series that vividly recreates one of history s most unforgettable chapters.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1988-11-13",
  },
  {
    id: 1434,
    url: "https://www.tvmaze.com/shows/1434/tokyo-airport-air-traffic-service",
    name: "Tokyo Airport : Air Traffic Service",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20714.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20714.jpg",
    },
    summary:
      '<p>The story takes place at the Tokyo International Airport, more commonly known as, Haneda Airport. This drama will portray the strong bond shared by all those working for the airport, including the air traffic controllers who takes over 62.58 million lives into their hands yearly and the aviation industry staff who oversees the safety of everyone who uses the airport. This will be the first time that a television drama will focus on air traffic controllers, considered to be the "most difficult occupation."</p><p>At Haneda Airport, every 2 minutes a plane will land and take-off, and is Japan\'s most busiest and congested airways. And every day, various dramas are born there.</p><p>Fukada Kyoko plays the role of the main character, Shinoda Kaori, who works in the airport control tower as an air traffic controller. As a single small error of judgment can lead to a catastrophe, air traffic controllers must be on alert at all times. And this is why it is considered to be one of the most difficult occupations in the world. This drama will portray the teamwork and struggles between Shinoda and the other staff, dramas that arise at the airport and the secrets of airports... As well, along with real life stories that have occurred in the airport, it will portray how the aiport staff ensures the safety of people and the importance of protecting lives.</p>',
    officialSite: "http://www.fujitv.co.jp/tokyo-airport/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 131,
      name: "Fuji TV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2010-10-14",
  },
  {
    id: 1435,
    url: "https://www.tvmaze.com/shows/1435/the-winds-of-war",
    name: "The Winds of War",
    genres: ["Drama", "Romance", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31600.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31600.jpg",
    },
    summary:
      "<p><i>The Winds of War</i> captures the world changing events leading up to WWII and the Japanese attack on Pearl Harbor in 1941.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1983-02-06",
  },
  {
    id: 1436,
    url: "https://www.tvmaze.com/shows/1436/the-game",
    name: "The Game",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20717.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20717.jpg",
    },
    summary:
      "<p>In the secret world of espionage, the players are set and the fight to save Britain begins. A complex invisible war is being fought by skilled spies trained in the high stakes world of covert espionage. In 1972 London, tensions are at a terrifying peak as the world's super powers plot against their enemies. The threat: a dangerous and deadly Soviet plot, designed to bring Britain to its knees, dubbed Operation Glass. This is where The Game begins – a stylish, character-driven spy drama that explores the lives and lies of the invisible soldiers fighting a secret war.<br></p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 15,
      name: "BBC America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-05",
  },
  {
    id: 1437,
    url: "https://www.tvmaze.com/shows/1437/death-in-paradise",
    name: "Death in Paradise",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/177/444065.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/177/444065.jpg",
    },
    summary:
      "<p>Detective Inspector Richard Poole is transferred to Saint Marie, an island in the Caribbean. Totally unsuited to the Caribbean way of life, Richard hates the sun, sea and sand and isn't used to the Saint Marie style of policing. Working with the exotic Camille each week Richard investigates intricate and intriguing murders.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b01pvmf6",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-10-25",
  },
  {
    id: 1438,
    url: "https://www.tvmaze.com/shows/1438/chasing-shadows",
    name: "Chasing Shadows",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20806.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20806.jpg",
    },
    summary:
      "<p><b>Chasing Shadows</b> follows a team of special operatives who are tracking down serial killers.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-09-04",
  },
  {
    id: 1439,
    url: "https://www.tvmaze.com/shows/1439/the-field-of-blood",
    name: "The Field of Blood",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20807.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20807.jpg",
    },
    summary:
      "<p>Adaptation of Denise Mina's thriller set in 1982. When the story of a murder has huge implications for her family, newspaper copy boy Paddy Meehan battles prejudices to get to the truth. As she inches closer to revealing the truth, her investigations place her in mortal danger.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b037z2yj",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-08-29",
  },
  {
    id: 1440,
    url: "https://www.tvmaze.com/shows/1440/tokyo-ghoul",
    name: "Tokyo Ghoul",
    genres: ["Drama", "Anime", "Horror", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20809.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20809.jpg",
    },
    summary:
      "<p>The story follows Ken Kaneki, a college student who meets a woman named Rize Kamishiro at Anteiku, a coffee shop. They share an interest in literature and plan a date. While walking Rize home, Ken is attacked by her. Rize reveals that she is a ghoul, a human-like creature that hunts and devours human flesh. As she is about to finish him off, she is crushed by a falling platform. Kaneki is taken to the hospital in critical condition. The doctor decides to transplant Rize's organs into Ken. He then must deal with life as a half-human/half-ghoul, including interacting with ghoul society and its conflicting factions, while striving to keep his identity secret from other humans.</p>",
    officialSite: "http://www.marv.jp/special/tokyoghoul/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 132,
      name: "Tokyo MX",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2014-07-03",
  },
  {
    id: 1441,
    url: "https://www.tvmaze.com/shows/1441/aldnoahzero",
    name: "Aldnoah.Zero",
    genres: ["Action", "Adventure", "Anime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/121/302958.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/121/302958.jpg",
    },
    summary:
      "<p>In 1972, the Apollo 17 mission discovered a hypergate to Mars on the surface of the moon. Soon a war breaks out between Earth and Mars, and Martian soldiers begin to descend from the sky, riding steel giants, intent on exterminating humanity.</p>",
    officialSite: "http://www.aldnoahzero.com/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 133,
      name: "BS11",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2014-07-06",
  },
  {
    id: 1442,
    url: "https://www.tvmaze.com/shows/1442/the-returned",
    name: "The Returned",
    genres: ["Drama", "Fantasy", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23492.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23492.jpg",
    },
    summary:
      "<p><b>The Returned </b>focuses on a small town that is turned upside down when several local people who have been long presumed dead suddenly reappear, having not aged and unaware of their own fatality. As they attempt to resume their lives, strange phenomena and gruesome murders begin to occur. <i>The Returned</i> takes an incredibly unique approach, filled with suspense and twists and turns, to the subject of the living dead.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-09",
  },
  {
    id: 1443,
    url: "https://www.tvmaze.com/shows/1443/review",
    name: "Review",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/326/816663.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/326/816663.jpg",
    },
    summary:
      "<p><b>Review with Forrest MacNeil </b>is a half-hour comedy starring [Andrew] Daly as \"Forrest MacNeil.\" Unlike typical critics who review boring things like films, food or art, MacNeil reviews the most intense experiences of life itself... by living them. He reviews anything his TV audience throws at him: the adrenaline rush of stealing, the trauma of divorce, the harrowing effects of murder, the wonder and joy of anonymous sex and stops at nothing to show us what any and every experience in life feels like. And, for our convenience, he rates every adventure on a scale of zero to five stars. MacNeil's unwavering commitment to his work means his answers to life's most challenging questions often come at the expense of his wife, his children, his co-workers and humanity in general.</p>",
    officialSite: "http://www.cc.com/shows/review",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-03-06",
  },
  {
    id: 1444,
    url: "https://www.tvmaze.com/shows/1444/tokyo-control",
    name: "Tokyo Control",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20918.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20918.jpg",
    },
    summary:
      '<p>The drama\'s setting is the Tokyo Area Control Center (nicknamed "Tokyo Control"), which serves as the air traffic control center for Tokyo and surrounding regions. Kawahara plays one of the cool-headed controllers at the center. Although her job focuses on resolving various situations encountered by the aircraft, the show will explore the lives of the people at Tokyo Control.</p>',
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 131,
      name: "Fuji TV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2012-10-14",
  },
  {
    id: 1445,
    url: "https://www.tvmaze.com/shows/1445/worlds-funniest-fails",
    name: "Worlds Funniest Fails",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20920.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20920.jpg",
    },
    summary:
      '<p>An irreverent one-hour series, <i><b>"WORLD\'S FUNNIEST FAILS"</b></i> is inspired by the hit YouTube channel, FailArmy, which showcases the best "epic fail" viral videos in the most entertaining ways possible. Each week a panel of celebrities and comedians will analyze the videos which have exploded across the internet, with the goal of awarding one with the ultimate "Fail of the Week."</p>',
    officialSite: "http://www.fox.com/worlds-funniest",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-16",
  },
  {
    id: 1446,
    url: "https://www.tvmaze.com/shows/1446/treehouse-masters",
    name: "Treehouse Masters",
    genres: ["DIY"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/71/178414.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/71/178414.jpg",
    },
    summary:
      "<p>Often described as a tree whisperer by his clients, colleagues and contemporaries, Pete Nelson dedicates his life granting people's dreams of turning peaceful nooks in nature into the ultimate escapes. In <b>Treehouse Masters</b>, Nelson and his team execute the most outrageous treehouses designed to delight every whimsy, form and function. Whether he's contriving magnificent multi-bedroom treehouses with state-of-the-art kitchens and bathrooms or rendering simpler, peaceful one-room escapes, Nelson always goes out on a limb to create the most breathtaking treehouses with spectacular vistas.</p>",
    officialSite: "http://www.animalplanet.com/tv-shows/treehouse-masters/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 92,
      name: "Animal Planet",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-05-31",
  },
  {
    id: 1447,
    url: "https://www.tvmaze.com/shows/1447/nazi-megastructures",
    name: "Nazi Megastructures",
    genres: ["War", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/298/747373.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/298/747373.jpg",
    },
    summary:
      "<p>Did you know, in the quest for world domination, the Nazis built some of the biggest and deadliest pieces of military hardware and malevolent technology in history?</p><p>Creating huge terror machines, hi-tech superguns and some of the original weapons of mass destruction, their aim was to control a nation, conquer a continent and win the war!</p><p>Nazi Megastructures uncovers the hidden remains of Hitler's most ambitious Megastructures, telling the stories of the engineering geniuses that designed them and revealing how these structures sparked a technological revolution that changed warfare forever.</p>",
    officialSite:
      "https://www.nationalgeographic.com/tv/shows/nazi-megastructures",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 242,
      name: "National Geographic Channel",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-11-18",
  },
  {
    id: 1449,
    url: "https://www.tvmaze.com/shows/1449/life-below-zero",
    name: "Life Below Zero°",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20923.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20923.jpg",
    },
    summary:
      "<p><b>Life Below Zero°</b> follows seven people as they battle for the most basic necessities in the state with the lowest population density in the United States. Living at the ends of the world's loneliest roads and subsisting off the rugged Alaskan bush, they battle whiteout snow storms, man-eating carnivores, questionable frozen terrain, and limited resources through a long and bitter winter. Some of them are lone wolves; others have their families beside them. All must overcome despairing odds to brave the wild and survive through to the spring. Only the mentally fit will be able to endure the extreme test of isolation and endless work required to survive the many months of winter in the Alaska bush.</p>",
    officialSite: "https://www.nationalgeographic.com/tv/shows/life-below-zero",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-05-19",
  },
  {
    id: 1450,
    url: "https://www.tvmaze.com/shows/1450/hack-my-life",
    name: "Hack My Life",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20924.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20924.jpg",
    },
    summary:
      "<p>Welcome to the weekly half hour show that provides a comedic spin on the never-ending supply of everyday life hacks. Hosted by Kevin Pereira and Brooke Van Poppelen, this series demonstrates how to incorporate eye popping shortcuts guaranteed to save today's busy adults a lot of time, effort and money. From learning how to open a bottle of wine with your shoe, to finding out the multiple uses for a toilet paper roll, there is never a shortage of hacks to discover. Viewers beware: your lives will never be the same after watching <b>Hack My Life.</b></p>",
    officialSite: "http://www.trutv.com/shows/hack-my-life/index.html",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 84,
      name: "truTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-06",
  },
  {
    id: 1451,
    url: "https://www.tvmaze.com/shows/1451/a-place-to-call-home",
    name: "A Place to Call Home",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/164/410284.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/164/410284.jpg",
    },
    summary:
      "<p>From the creator of Packed to the Rafters comes the sweeping and romantic drama, <b>A Place to Call Home</b>.</p><p>It tells the story of a mysterious woman perched between the harsh legacy of World War II and the hope of a new life in Australia and of a wealthy family forced by her to embrace the winds of social change.</p>",
    officialSite:
      "https://www.showcasechannel.com.au/shows/a-place-to-call-home/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 270,
      name: "Showcase",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2013-04-28",
  },
  {
    id: 1452,
    url: "https://www.tvmaze.com/shows/1452/hacking-the-system",
    name: "Hacking the System",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/20939.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/20939.jpg",
    },
    summary:
      "<p>For 15 years, Brian Brushwood has made a career out of social manipulation and thinking like a criminal and now he's here to reveal how to avoid people who cheat the system and show you how to use the legal tips, tricks, and shortcuts to get ahead in life. One hack at a time.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-19",
  },
  {
    id: 1453,
    url: "https://www.tvmaze.com/shows/1453/big-brother",
    name: "Big Brother",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/266/665158.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/266/665158.jpg",
    },
    summary:
      "<p><b>Big Brother</b> follows a group of people living together in a house outfitted with dozens of high-definition cameras and microphones recording their every move, 24 hours a day. Each week, the Houseguests will vote someone out of the house. At the end, the last remaining Houseguest will receive the grand prize of $500,000.</p>",
    officialSite: "http://www.cbs.com/shows/big_brother/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-07-05",
  },
  {
    id: 1456,
    url: "https://www.tvmaze.com/shows/1456/back-to-you",
    name: "Back to You",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21026.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21026.jpg",
    },
    summary:
      "<p>In the '90s, Chuck Darling and Kelly Carr had dominated the local TV news scene in Pittsburgh. While they had primetime news chemistry on-screen, off-screen Chuck was a bit of a self-centered womanizer, and Kelly a bit of an uptight know-it-all. When Chuck grabbed the chance to move up to a larger market, no tears were shed. But after an embarrassing on-air tirade ended up on the Internet, Chuck found himself on the downswing career-wise. He even questioned whether his lifestyle of chasing women and living in hotels was as exciting as it used to be. So when he gets the call to return to Pittsburgh to reunite with Kelly and try to take the newscast back to No. 1, it's an offer he can't refuse. Back in Pittsburgh, Chuck must adapt to a new, chaotic newsroom. In addition to Kelly, he re-teams with familiar faces including Marsh McGinley, the affable, endlessly inappropriate sports anchor, and Gary Crezyzewski the perennially put-upon field reporter who always seems to get left out in the cold; and he has a few new coworkers: Ryan Church the under-qualified, overstressed news director, and Montana Diaz Herrera, the perky, sexy, somewhat inept weather anchor. But perhaps the biggest change is that Kelly is now single mom to 10-year-old Gracie With ego aplenty, Chuck and his former partner Kelly once made primetime news magic, but they wonder if they can make it happen again.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-09-19",
  },
  {
    id: 1457,
    url: "https://www.tvmaze.com/shows/1457/becker",
    name: "Becker",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21033.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21033.jpg",
    },
    summary:
      "<p><b>Becker</b> centers on the life of Dr. John Becker, a cantankerous, yet dedicated and talented physician, who, in spite of his constant rants, has a decent heart underneath the sarcasm.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-11-02",
  },
  {
    id: 1458,
    url: "https://www.tvmaze.com/shows/1458/big-shots",
    name: "Big Shots",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21042.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21042.jpg",
    },
    summary:
      "<p>The lines between boardroom and bedroom blur in <b>Big Shots</b>, the story of four friends who are at the top of their game... until the women in their lives enter the room. These competitive but dysfunctional New York CEOs take refuge in their friendship, discussing business, confiding secrets, seeking advice and supporting one another through life's twists and turns.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-09-27",
  },
  {
    id: 1459,
    url: "https://www.tvmaze.com/shows/1459/black-gold",
    name: "Black Gold",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21053.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21053.jpg",
    },
    summary:
      "<p><b>Black Gold</b> follows roughneck crews in the oil fields of Texas as they struggle against the elements, equipment and each other to bring in the next big gusher. When it comes to drilling for oil, there is no room for error as crews must work through conflicts, handle dangerous equipment and balance the sometimes-overwhelming demands of their jobs and their families.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 84,
      name: "truTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-06-18",
  },
  {
    id: 1460,
    url: "https://www.tvmaze.com/shows/1460/buck-rogers-in-the-25th-century",
    name: "Buck Rogers in the 25th Century",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21054.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21054.jpg",
    },
    summary:
      '<p>Blast off with every groundbreaking episode of the action-packed sci-fi adventure, <b>Buck Rogers in the 25th Century</b>! Join legendary intergalactic crimefighters William "Buck" Rogers and Colonel Wilma Deering as they lead the crew of the starship Searcher against a galaxy of evil from the past, present and faraway future.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1979-09-20",
  },
  {
    id: 1461,
    url: "https://www.tvmaze.com/shows/1461/cavemen",
    name: "Cavemen",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21061.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21061.jpg",
    },
    summary:
      "<p>They've been around since the dawn of time, survived the Ice Age and witnessed the evolution of the Homo sapiens. Keeping mostly to themselves over the millennia and living in remote communities, a small number of cavemen and cavewomen have been slowly migrating from these sub-societies and attempting to acclimate themselves to the Homo sapien world. Needless to say, this has proven difficult. Meet three cavemen who have successfully made the move to San Diego and are just trying to fit in. Joel is a sophisticated and intelligent man who has a beautiful girlfriend, a decent job and shares an apartment with his younger brother, Andy and his best friend, Nick. Nick is wary of the Homo sapien world and feels like he's running away from his heritage. Andy, on the other hand, looks at this new world with his eyes wide open and is willing to take risks in order to learn and live life to the fullest. Nick questions Joel on many of his choices, including his girlfriend, Kate, a beautiful Homo sapien woman. The fact that Kate's eccentric mother, Leslie owns Joel's condominium complex makes things even more complicated for the three roommates. Meanwhile, Kate's best friend, Thorne, is intent on discovering the cavemen's wilder side. On the premiere episode, \"Her Embarrassed of Caveman,\" Joel attempts to hide the fact that he's dating a \"sape\" aka Homo sapien woman from Nick, Andy and friend Maurice, but also feels that she may be embarrassed to tell her friends that she's dating a caveman. Meanwhile Andy comes to town to get away from his girlfriend, who cheated on him.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-10-02",
  },
  {
    id: 1462,
    url: "https://www.tvmaze.com/shows/1462/combat",
    name: "Combat!",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/80/202316.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/80/202316.jpg",
    },
    summary:
      "<p><b>Combat!</b> was one of the television's most popular series, the groundbreaking Combat!! offers a gritty, unflinching look at American soldiers battling in Europe during World War II, confronting imposing odds and demonstrating remarkable levels of ingenuity and courage.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1962-10-02",
  },
  {
    id: 1463,
    url: "https://www.tvmaze.com/shows/1463/crash",
    name: "Crash",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21072.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21072.jpg",
    },
    summary:
      "<p>Set in Los Angeles, <b>Crash</b> focuses on a multi-ethnic group of people from different socio-economic backgrounds and their lives as they intertwine and connect and their personal dramas unfold.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 17,
      name: "Starz",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-10-17",
  },
  {
    id: 1464,
    url: "https://www.tvmaze.com/shows/1464/criss-angel-mindfreak",
    name: "Criss Angel: Mindfreak",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21081.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21081.jpg",
    },
    summary:
      '<p><i><b>"Criss Angel: Mindfreak"</b></i> on A&amp;E is the most successful magic show in television history, resulting in more hours of magic during prime time than any other show! It was viewed regularly by over 100 million people per season in 90 countries. During its 6 seasons and over 100 episodes, Criss created and performed over 1,000 mind-blowing demonstrations that still amaze and astound viewers.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-07-20",
  },
  {
    id: 1465,
    url: "https://www.tvmaze.com/shows/1465/crusoe",
    name: "Crusoe",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21082.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21082.jpg",
    },
    summary:
      "<p>After exhausting all of his business ventures in London, <b>Crusoe</b> is forced to leave his family and travel to the new world in hopes of getting out his impending debt. After almost being killed by an assassin on the ship, Crusoe awakens to find himself stranded on a deserted island. Crusoe then saves a native man from the jaws of cannibals and makes a friend for life. Crusoe and his faithful friend Friday then struggle to survive on a deserted island with a little more than their wits. They must overcome marauding militias, hungry cannibals, pirates and starvation, Crusoe dreams of the day he will be reunited with his beloved family. Crusoe constantly is reminded of his wife Susannah and children left behind in England and their love story will unfold from meeting to marriage, as will his relationship with his mentor and patron, the mysterious Jeremiah Blackthorn.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-10-17",
  },
  {
    id: 1466,
    url: "https://www.tvmaze.com/shows/1466/dilbert",
    name: "Dilbert",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21083.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21083.jpg",
    },
    summary:
      "<p>Dilbert has to deal with hostile co-workers, a moronic boss and his dog Dogbert.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 70,
      name: "UPN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-01-25",
  },
  {
    id: 1467,
    url: "https://www.tvmaze.com/shows/1467/the-district",
    name: "The District",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21084.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21084.jpg",
    },
    summary:
      "<p>Newark PD Chief Jack Mannion is trying to cut Washington DC's crimerate in half in this gritty crime show.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-10-07",
  },
  {
    id: 1468,
    url: "https://www.tvmaze.com/shows/1468/the-drew-carey-show",
    name: "The Drew Carey Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21085.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21085.jpg",
    },
    summary:
      "<p>Drew Carey is your everyday blue-collar guy who's struggling through life's ups and downs with his closest friends, Oswald, Lewis and Kate. Stuck in the same job for ten years, Drew performs a balancing act between sucking up to his boss and doing his best to irritate his annoying co-worker, Mimi. When he's not at work, he's trying to have some success in the romance department and indulging in a few of his own beers he brews in his garage with his friends.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1995-09-13",
  },
  {
    id: 1469,
    url: "https://www.tvmaze.com/shows/1469/earth-final-conflict",
    name: "Earth: Final Conflict",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21093.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21093.jpg",
    },
    summary:
      "<p>In the early twenty-first century Earth is visited by the Taelons', an alien species, claiming to be companions of humanity. They use their superior technology and wisdom to help Earth solve its most pressing problems – famine, disease, war – but suspicions arise that a darker agenda may be part of the Taelons' ultimate plans.</p><p><br> The only hope to discover the truth falls to a small team of humans lead by William Boone, a former Special Forces soldier turned cop. After rescuing Da'an, the Taelon \"overseer\" for North America from assassination, Boone is made their interspecies liaison. Along with members of a budding underground human resistance movement, Boone investigates the purpose behind the Taelons' acts of benevolence to uncover the true intentions of their visit to Earth. Only one thing is certain, what they might discover will change humanity forever.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1997-10-06",
  },
  {
    id: 1470,
    url: "https://www.tvmaze.com/shows/1470/emergency",
    name: "Emergency!",
    genres: ["Drama", "Action", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21100.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21100.jpg",
    },
    summary:
      "<p>Filmed in a semi-documentary style, Squad 51 takes on life-or-death challenges.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1972-01-22",
  },
  {
    id: 1471,
    url: "https://www.tvmaze.com/shows/1471/gomer-pyle-usmc",
    name: "Gomer Pyle, U.S.M.C.",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21101.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21101.jpg",
    },
    summary:
      "<p>Gomer Pyle, a naive country boy, leaves his home in Mayberry, NC to join the U.S. Marine corps. His perpetual wide-eyed innocence frequently gets on the nerves of his tough, loudmouthed sergeant.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1964-09-25",
  },
  {
    id: 1472,
    url: "https://www.tvmaze.com/shows/1472/good-times",
    name: "Good Times",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21104.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21104.jpg",
    },
    summary:
      "<p>Money was scare, but laughs and love were abundant for Florida, her hard-working husband James, and their three kids living in the projects of South Side Chicago. From the outrageous antics of budding artist J.J., to the romantic dramas of sister Thelma and pint-sized Michael's activist causes, these parents had their hands full.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1974-02-08",
  },
  {
    id: 1473,
    url: "https://www.tvmaze.com/shows/1473/grounded-for-life",
    name: "Grounded for Life",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21106.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21106.jpg",
    },
    summary:
      "<p>Raising kids is tough, especially when you're <b>Grounded for Life! </b>Sean and Claudia Finnerty, a fun-loving Staten Island couple got pregnant and married by age 18. Now in their 30s, they aren't bad parents, but they're still just kids themselves.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-01-10",
  },
  {
    id: 1474,
    url: "https://www.tvmaze.com/shows/1474/happy-days",
    name: "Happy Days",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21115.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21115.jpg",
    },
    summary:
      '<p>Set in Milwaukee, Wisconsin in the 1950\'s, <b>Happy Days</b> revolves around Richie Cunningham and his family and friends. A "wholesome" young man, Richie is a Jefferson High School student who would do anything to get a date and he spends plenty of time with his friends at Arnold\'s, the local burger joint. Contrasting with his wholesome nature is Arthur Fonzarelli, best known as Fonzie, a rough-around-the-edges motorcycle riding high school dropout famous for his slicked hair, leather jacket, and the catchphrase "aaayyyy!" Fonzie is a regular around the Cunningham house, with Mrs. Cunningham doting on him and Richie turning to him for advice on how to attract girls.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1974-01-15",
  },
  {
    id: 1475,
    url: "https://www.tvmaze.com/shows/1475/hogans-heroes",
    name: "Hogan's Heroes",
    genres: ["Comedy", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21123.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21123.jpg",
    },
    summary:
      "<p><b>Hogan's Heroes</b> focuses on a group of American soldiers, led by Colonel Hogan, who are confined in a Nazi prisoner of war camp called Stalag 13 during World War II. While trapped in Stalag 13, the inmates conduct an espionage and sabotage campaign right under the noses of their warders. Because the Germans, led by the bumbling Colonel Wilhelm Klink, are often gullible, the real strength of Hogan's men are the elaborate ruses and sometimes dangerous lengths they will go to complete their mission.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1965-09-17",
  },
  {
    id: 1476,
    url: "https://www.tvmaze.com/shows/1476/in-search-of",
    name: "In Search of.....",
    genres: ["Mystery", "History", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21127.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21127.jpg",
    },
    summary:
      "<p>Leonard Nimoy, hosts and narrates this documentary series that takes you to the world of Unsolved Mysteries and those strange and unusual things in the world that defy explanation and often understanding. The world is filled with unexplained mysteries, paranormal phenomena, strange creatures, and other things that go bump in the night. The topics are entertaining and engrossing. Lost civilizations, extraterrestrials, myths and monsters, missing persons, magic and witchcraft, unexplained phenomena. In Search Of cameras travel the world, seeking out these great mysteries. This program was the result the work of scientists, researchers and a group of highly-skilled technicians and results in a series of programs that are varied and each is worth viewing.</p><p>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1977-04-17",
  },
  {
    id: 1477,
    url: "https://www.tvmaze.com/shows/1477/invasion",
    name: "Invasion",
    genres: ["Science-Fiction", "Thriller", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21128.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21128.jpg",
    },
    summary:
      "<p>For centuries man has searched the skies for signs of intelligent life forms. But what if those life forms were already here, and what if a storm was masking something far more menacing?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-09-21",
  },
  {
    id: 1478,
    url: "https://www.tvmaze.com/shows/1478/jeremiah",
    name: "Jeremiah",
    genres: ["Drama", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21138.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21138.jpg",
    },
    summary:
      '<p><b>Jeremiah</b> is one of the many young survivors of the "Big Death" that claimed the lives of every adult in the world 15 years ago. Now forging his way through a bleak wilderness fraught with danger and conspiracy, Jeremiah and his most trusted friend, Kurdy , are plunged into thrilling adventures that test every facet of their humanity…and ultimately the fate of the human race itself!</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-03-03",
  },
  {
    id: 1479,
    url: "https://www.tvmaze.com/shows/1479/the-john-larroquette-show",
    name: "The John Larroquette Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/37195.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/37195.jpg",
    },
    summary:
      "<p>Recovering alcoholic John Hemingway runs into an assortment of crazy characters while working as night manager of a seedy bus terminal, aided by his sarcastic assistant, Mahalia. Others in the building include Dexter, the acerbic snack-bar operator and Heavy Gene, the surly janitor who hates to clean. Frequently dropping in to visit are hooker Watkins, who has a heart of gold, and doughnut-mooching cops Hampton and Eggers.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-09-02",
  },
  {
    id: 1480,
    url: "https://www.tvmaze.com/shows/1480/jurassic-fight-club",
    name: "Jurassic Fight Club",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21144.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21144.jpg",
    },
    summary:
      "<p>A dinosaur's life was not easy. Volatile pre-historic terrain, harsh climate conditions, insufficient food and water, as well as unrelenting enemy predators made survival anything but a given. With cutting edge forensics leading to new discoveries every day, researchers are gaining remarkable insight into the psychology and physiology of these ancient beasts.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-07-29",
  },
  {
    id: 1481,
    url: "https://www.tvmaze.com/shows/1481/la-law",
    name: "L.A. Law",
    genres: ["Drama", "Crime", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21145.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21145.jpg",
    },
    summary:
      "<p><b>L.A. Law</b> takes us inside the law firm of McKenzie, Brackman, Chaney and Kuzak. There, a team of ambitious and competitive attorneys must face the conflicts between their personal desires, their obligations as lawyers, and their principles as human beings. A portrayal of the law and its litigators that was both realistic and irreverent, L.A. Law became a favorite of critics and audiences alike.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1986-09-15",
  },
  {
    id: 1482,
    url: "https://www.tvmaze.com/shows/1482/lipstick-jungle",
    name: "Lipstick Jungle",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/115/288663.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/115/288663.jpg",
    },
    summary:
      '<p>Based on the best-selling book by Candace Bushnell ("Sex and the City"), this sexy drama follows three high-powered friends as they weather the ups and downs of lives lived at the top of their game.</p><p>Movie exec Wendy does everything she can to balance career and family. Nico, editor-in-chief of a hot fashion magazine, has her eye on becoming CEO. And free-spirited designer Victory longs to make her dreams come true -- and maybe find "Mr. Right" along the way.</p><p>Armed with humor and strength, these three modern New York women support one another through the triumphs and tears that are all part of making it big in the Big Apple.</p>',
    officialSite: "http://www.nbc.com/lipstick-jungle",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-02-07",
  },
  {
    id: 1483,
    url: "https://www.tvmaze.com/shows/1483/lost-in-space",
    name: "Lost in Space",
    genres: ["Drama", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21161.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21161.jpg",
    },
    summary:
      "<p>The Robinson family was supposed to set off on a five-year mission to explore a distant planet, but an act of sabotage by the scheming Dr. Zachary Smith - who managed to get himself trapped aboard the spaceship - leaves them adrift in space for three years. The Robinsons, pilot Don West, Dr. Smith and their trusty robot move from planet to planet, always searching for a way to return to Earth.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1965-09-15",
  },
  {
    id: 1484,
    url: "https://www.tvmaze.com/shows/1484/the-love-boat",
    name: "The Love Boat",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21183.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21183.jpg",
    },
    summary:
      "<p>Each week, passengers looking for romance board the beautiful Pacific Princess cruise ship as it sails to tropical and exotic lands. Captain Stubing, Julie, Gopher, Dr. Adam, and Isaac help them to get the most out of their trips and do their best to help them fall in love.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1977-09-24",
  },
  {
    id: 1485,
    url: "https://www.tvmaze.com/shows/1485/man-from-atlantis",
    name: "Man from Atlantis",
    genres: ["Drama", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21186.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21186.jpg",
    },
    summary: "<p>The adventures of a man with amphibious abilities.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1977-09-22",
  },
  {
    id: 1487,
    url: "https://www.tvmaze.com/shows/1487/moonlighting",
    name: "Moonlighting",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21190.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21190.jpg",
    },
    summary:
      "<p>Maddie Hayes, a wealthy former model, discovers one morning that her business manager has stolen all the money she has in the bank. However, it turns out that she still owns some non-liquid assets -- money-losing companies which were maintained as tax write-offs -- one of which is a detective agency run by David Addison. Maddie meets with him to inform him that the company is to be shut down, but he persuades her to keep it open by convincing her that the detective agency can make money. Maddie becomes David's new boss and accompanies him on adventure after adventure. While their personalities clash, a sexual tension arises in the time they spend together. But the question always remains... will they or won't they?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1985-03-03",
  },
  {
    id: 1488,
    url: "https://www.tvmaze.com/shows/1488/newhart",
    name: "Newhart",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21195.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21195.jpg",
    },
    summary:
      '<p>Bob Newhart returns to the TV as Dick Loudon, as he and his wife Joanna decide to leave life in New York City and buy a little inn in Vermont. Dick is a how-to book writer, who eventually becomes a local TV celebrity as host of "Vermont Today."</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1982-10-25",
  },
  {
    id: 1489,
    url: "https://www.tvmaze.com/shows/1489/night-court",
    name: "Night Court",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21196.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21196.jpg",
    },
    summary:
      "<p>A young and unusual judge arrives in Manhattan's <b>Night Court</b> and begins deciding cases in a most unusual manner, much to the horror of his court clerk and all else in the courtroom.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1984-01-04",
  },
  {
    id: 1490,
    url: "https://www.tvmaze.com/shows/1490/one-day-at-a-time",
    name: "One Day at a Time",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21207.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21207.jpg",
    },
    summary:
      "<p>The struggles of a 1970s single mother raising two teenage daughters gets its first TV slot with this instant hit sitcom.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1975-12-16",
  },
  {
    id: 1491,
    url: "https://www.tvmaze.com/shows/1491/the-partridge-family",
    name: "The Partridge Family",
    genres: ["Comedy", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21208.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21208.jpg",
    },
    summary:
      "<p>It's TV's favorite family of rock 'n 'rollers, who hit the road in their groovy bus and turn the world on to the catchy pop songs such as \"I Think I Love You\", \"I Woke Up In Love This Morning\", and \"Somebody Wants to Love You\". The Partridge Family's six members feature mom Shirley and her five kids: Keith, Laurie, Danny, Tracy and Chris. And who can forget the Partridge's frequently exasperated manager Reuben Kincaid, who would become an important member of their family whether he liked it or not?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1970-09-25",
  },
  {
    id: 1492,
    url: "https://www.tvmaze.com/shows/1492/pirate-master",
    name: "Pirate Master",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/199/498620.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/199/498620.jpg",
    },
    summary:
      '<p>Join 16 modern-day pirates as they embark on a high seas adventure around the Caribbean island of Dominica in search of hidden treasure that will total $1 million. Over the course of 33 days, the pirates will live aboard a massive 179-foot pirate ship.<br><br> Each week, these buccaneers will go on extraordinary expeditions and decipher clues along the way. Gold coins - real money that the pirates can take with them beyond the show - will be awarded after each treasure hunt, but only to some.<br><br> The prized gold will then play a key role as pirates strike deals with each other and vie for long-term security.<br><br> Claiming the lion\'s share of the week\'s riches, one pirate will become the captain of the ship and will assign roles and chores to the remaining crew members, setting the tone for law and order or betrayal and sabotage, which could lead to mutiny by the crew. Such fates will be decided on the ship at Pirate\'s Court, a lively gathering of public speaking and judgment where one individual will be "cut adrift" every episode.<br><br> In the end, captain or not, only one pirate will win the largest booty, worth $500,000, and claim the title of "Pirate Master."</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-05-31",
  },
  {
    id: 1493,
    url: "https://www.tvmaze.com/shows/1493/playmakers",
    name: "Playmakers",
    genres: ["Drama", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21210.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21210.jpg",
    },
    summary:
      "<p><b>Playmakers</b> is a gritty ensemble drama chronicling the behind-the-scenes and off-the-field lives of the players, families, coaches and owner of a fictional professional football team. The series weaves multiple storylines into an intricately patterned saga that changes minute-to-minute as the characters struggle to negotiate the red zone between fame and real life.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 39,
      name: "ESPN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-08-26",
  },
  {
    id: 1494,
    url: "https://www.tvmaze.com/shows/1494/prototype-this",
    name: "Prototype This!",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21211.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21211.jpg",
    },
    summary:
      "<p>In a warehouse on an island in San Francisco Bay, a team of engineers and PhD's are inventing the future one prototype at a time. From finding solutions to today's problems, to conceiving cool machines that are just fun to have around, the Prototype This crew imagines and then invents the future by using emerging technologies to build the craziest, one-of-a-kind prototypes of tomorrow. Tune in Wednesdays at 10 e/p for loads of zany brilliance, hi-tech wizardry, and a inside look at some of the latest tools and gadgets that just may change the way we live and work.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-10-15",
  },
  {
    id: 1495,
    url: "https://www.tvmaze.com/shows/1495/punkd",
    name: "Punk'd",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21212.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21212.jpg",
    },
    summary:
      "<p>What happens when the biggest stars in the world get too high on the Hollywood hog? When their bank accounts start swelling bigger than their heads? Master prankster Ashton Kutcher is there to PUNK 'em down to earth. It's a reality show with a twist as Asthon makes superstars suffer for your viewing pleasure. To misquote the acclaimed thespian Steven Seagal: \"You guys think you're above the law…but you ain't above ours.\"</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-03-17",
  },
  {
    id: 1496,
    url: "https://www.tvmaze.com/shows/1496/remington-steele",
    name: "Remington Steele",
    genres: ["Comedy", "Action", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21213.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21213.jpg",
    },
    summary:
      "<p>Private eye Laura Holt grudgingly accepts a new partner when a mystery man assumes the identity of her fictitious boss, Remington Steele. Together, the two battle crime as as their feelings for each other.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1982-10-01",
  },
  {
    id: 1497,
    url: "https://www.tvmaze.com/shows/1497/riptide",
    name: "Riptide",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21217.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21217.jpg",
    },
    summary:
      '<p>Come aboard the <b>Riptide</b>, home to the hottest detective agency in Los Angeles. Cody Allen and Nick Ryder are longtime pals who have seen more than their share of danger -- and action. Along with a buddy from their days in the military, the brilliant but socially inept scientist Murray "Boz" Bozinsky, they solve a series of mysterious cases involving stakeouts, seduction, and the law. Detective work has never been this hot!</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1984-01-03",
  },
  {
    id: 1498,
    url: "https://www.tvmaze.com/shows/1498/shear-genius",
    name: "Shear Genius",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21221.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21221.jpg",
    },
    summary:
      "<p><b>Shear Genius</b> premieres with 12 talented hair stylists, one high-stakes salon and the industry's most renowned talent. In the first episode, the stylists face their first short-cut challenge - one hour to show off their signature style on a mannequin head. In the elimination challenge, the stylists are tasked with creating a work of art using professional models with long hair and various arts and crafts materials.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-04-11",
  },
  {
    id: 1499,
    url: "https://www.tvmaze.com/shows/1499/simon-simon",
    name: "Simon & Simon",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21222.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21222.jpg",
    },
    summary:
      "<p>Rick and AJ Simon are two brothers working as private investigators in San Diego, California. They have different ideas on how to solve problems: Rick more laid back while AJ is more business-like and thier cases take them all over California as well as Hawai'i and France. They are more than brothers, they are the best of friends.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1981-11-24",
  },
  {
    id: 1500,
    url: "https://www.tvmaze.com/shows/1500/the-six-million-dollar-man",
    name: "The Six Million Dollar Man",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21225.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21225.jpg",
    },
    summary:
      '<p>Grievously injured in the crash of an experimental aircraft, Colonel Steve Austin\'s shattered body is covertly rebuilt via the miracle of modern science known as bionics. Equipped with atomic-powered limbs that make him "better, stronger, faster" than the average mortal, Austin can now run at speeds exceeding 60 miles per hour, overturn cars with ease, and spot an encroaching enemy from over a mile away. Under the watchful eye of OSI director Oscar Goldman, Steve repays his debt to the taxpayers by taking on perilous missions of a highly classified nature. Season 1 chronicles Steve Austin\'s amazing metamorphosis from "a man barely alive" to cyborg to patriotic superspy. Armed with futuristic abilities, Austin is dispatched to do battle with kidnappers, arms smugglers, evil scientists, political assassins, and a diabolical robot—with time enough to spare to counsel a troubled astronaut and clear his dead father\'s name.</p>',
    officialSite: "https://www.nbc.com/the-six-million-dollar-man",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1974-01-18",
  },
  {
    id: 1501,
    url: "https://www.tvmaze.com/shows/1501/smash-lab",
    name: "Smash Lab",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21227.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21227.jpg",
    },
    summary:
      "<p>The next generation in destruction instruction, <b>Smash Lab</b> features a team of maverick engineers as they take on everyday technology and apply it in revolutionary new ways. First they break down the technology to see how it works and then use their know-how to see how it could be used in a different, supersized way. Could bulletproof Kevlar protect an airliner from bombs? Could a car airbag be reinvented to stop a helicopter from sinking after ditching at sea? The Smash Lab team aims to find out.<br /><br /> Filmed at their Crash Lab in California, the team puts their ambitious plans to the test and captures them from every camera angle imaginable. Smash Lab is a visual feast of fireballs, explosions, crashes, collapses, collisions and impacts, because sometimes destruction is good for you.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-12-26",
  },
  {
    id: 1502,
    url: "https://www.tvmaze.com/shows/1502/still-standing",
    name: "Still Standing",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21228.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21228.jpg",
    },
    summary:
      "<p><b>Still Standing</b> is a comedy about a blue-collar Chicago couple working to raise their three children responsibly and not lose sight of their own youthfulness. After 18 years of marriage, high school sweethearts Bill and Judy Miller still make each other laugh and try to keep their marriage intact, even when their family pulls them in different directions. Judy's married sister, Linda, butts heads with Bill, and the Millers' precocious teenage daughter, Lauren, thinks her parents are uncool. Meanwhile, their uptight, studious son, Brian, is discovering girls, and their youngest child, Tina, would prefer to run around naked. In addition to spending time with his family, Bill spends a good deal of time with his best friend, Danny Fitzsimmons, who is working to raise his own son, who happens to be gay. Since Bill has a far more immature approach to marriage and raising children than Judy does, they work at striking a balance and remembering why they love each other, quirks and all.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-09-30",
  },
  {
    id: 1503,
    url: "https://www.tvmaze.com/shows/1503/that-girl",
    name: "That Girl",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21229.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21229.jpg",
    },
    summary:
      "<p>A perky aspiring actress tries to start a career in New York, getting encouragement from her boyfriend, Don, and her family. For many young women, Ann Marie was an independent role model for the times (the late '60s) for having left the nest in pursuit of a career. She also inspired trends in fashion with her flipped-up hairdo and cute, mod clothes.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1966-09-08",
  },
  {
    id: 1504,
    url: "https://www.tvmaze.com/shows/1504/top-design",
    name: "Top Design",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21232.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21232.jpg",
    },
    summary:
      "<p>In the second season of the interior design competition, the drama is more intense and the stakes are higher than ever as the 13 contestants are critiqued by some of the most influential names in the design industry. With challenges ranging from redesigning a fall out shelter to competing in a full-on design triathlon, eccentric personalities and creative egos combine to fuel the competition. World renowned designer Todd Oldham will return to mentor the designers. Head judge Jonathan Adler, along with series judges Margaret Russell and Kelly Wearstler, will decide which designer wins the $100,000 cash prize and a four-page editorial showcase in Elle Décor magazine.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-01-31",
  },
  {
    id: 1505,
    url: "https://www.tvmaze.com/shows/1505/one-piece",
    name: "One Piece",
    genres: ["Action", "Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/128/320242.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/128/320242.jpg",
    },
    summary:
      "<p><b>One Piece</b> animation is based on the successful comic by Eiichiro Oda. The comic has sold more than 260 million copies. The success doesn't stop; the <i>One Piece</i> animation series is in its top 5 TV ratings for kids programs in Japan for past few years and the series' most recent feature film title <i>\"One Piece Film Z\" </i>which was released on December 2012 has gathered 5.6 million viewers so far. The success goes beyond borders; receives high popularity on animation at terrestrial channel in Taiwan, no.1 rating on animation at a DTT channel in France, received high popularity among age 3-13 on a terrestrial channel in Germany in year 2010. The animation series has been broadcasted in many parts of the world: USA, UK, Australia, France, Spain, Portugal, Germany, Italy, Greece, Turkey, Israel, South Korea, Taiwan, China, Hong Kong, Philippine, Thailand, Singapore, Malaysia, Indonesia, Ecuador, Nicaragua, Chile, Mexico, Brazil, and etc.</p>",
    officialSite: "http://www.toei-anim.co.jp/tv/onep/",
    webChannel: null,
    language: "Japanese",
    status: "Running",
    network: {
      id: 131,
      name: "Fuji TV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1999-10-20",
  },
  {
    id: 1506,
    url: "https://www.tvmaze.com/shows/1506/two-guys-and-a-girl",
    name: "Two Guys and a Girl",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21233.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21233.jpg",
    },
    summary:
      "<p>Two Boston grad students work in a pizza joint and hang out with their sexy neighbor in an above-average sitcom that was originally titled 'Two Guys, a Girl and a Pizza Place'.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-03-10",
  },
  {
    id: 1507,
    url: "https://www.tvmaze.com/shows/1507/voyagers",
    name: "Voyagers!",
    genres: ["Adventure", "Family", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21239.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21239.jpg",
    },
    summary:
      "<p>A kids-oriented fantasy about a 'time cop' and his young companion who travel through history. Their stops include ancient Egypt, World War I France and 1903 Ohio (to visit the Wright Brothers). The lead character is named Phineas Bogg, a nod to Jules Verne's 'Around the World in Eighty Days' hero, Phileas Fogg.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1982-10-03",
  },
  {
    id: 1508,
    url: "https://www.tvmaze.com/shows/1508/what-i-like-about-you",
    name: "What I Like About You",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/32/80610.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/32/80610.jpg",
    },
    summary:
      '<p>"You are my sister. You\'re supposed to drive me crazy." Twenty-eight-year-old organization freak Valerie Tyler loves her 16-year-old sister Holly. Even if Holly is rambunctious. Spontaneous. Impulsive. Disconcerting. And definitely disorganized. Then Holly moves in with Val, and the sisters discover they may make better siblings than roomies in this bright, giddy comedy set in Manhattan - and in the hearts of sisters everywhere.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-09-20",
  },
  {
    id: 1509,
    url: "https://www.tvmaze.com/shows/1509/whats-happening-now",
    name: "What's Happening Now!",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21251.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21251.jpg",
    },
    summary:
      "<p>A sitcom reuniting characters from 'What's Happening!!' (1976-79).</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1985-09-02",
  },
  {
    id: 1510,
    url: "https://www.tvmaze.com/shows/1510/wings",
    name: "Wings",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21252.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21252.jpg",
    },
    summary:
      "<p>The sky's the limit when estranged brothers - Joe and Brian Hackett reunite to run a commuter airline together. On the small island of Nantucket, the Hacketts run with a first-class crew of neighbors and co-workers, including lunch counter manager and childhood friend Helen Chappel. Their rival Roy Biggins keeps them on their guard, while sharp-tongued ex-stewardess Fay keeps them on their toes. Big-hearted Italian cab driver Antonio and eccentric mechanic Lowell always keep life around the terminal interesting.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1990-04-19",
  },
  {
    id: 1511,
    url: "https://www.tvmaze.com/shows/1511/yes-dear",
    name: "Yes, Dear",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21260.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21260.jpg",
    },
    summary:
      "<p><b>Yes, Dear</b> is a comedy about two young couples and their outrageously contrasting views on parenting. Greg and Kim Warner struggle on a daily basis to become perfect at the job. Kim is a neurotic, stay-at-home mother, and although her husband, Greg, is a success in his career, his more difficult job is keeping his wife calm as they raise their two young children. While Kim is determined to be the perfect mother and perfect wife and to raise the perfect children, her sister, Christine Hughes, a very down-to-earth mother of two, continually reminds her that life will never be perfect. Christine's husband, Jimmy, often feels compelled to share with his brother-in-law his philosophy about being a husband and a parent while still remaining a man.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-10-02",
  },
  {
    id: 1512,
    url: "https://www.tvmaze.com/shows/1512/almost-heroes",
    name: "Almost Heroes",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21266.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21266.jpg",
    },
    summary:
      "<p><b>Almost Heroes</b> is a new comedy about two brothers who are forced to work together at their dad's comic book store. When his dad dies unexpectedly, Terry must return home from Harvard Business School for the funeral. For the now straight-laced Terry, coming home and facing his geeky past is always a challenge...he ran away from his nerdery a long time ago!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 6,
      name: "Showcase",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2011-06-02",
  },
  {
    id: 1514,
    url: "https://www.tvmaze.com/shows/1514/big-brother",
    name: "Big Brother",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/113/283575.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/113/283575.jpg",
    },
    summary:
      "<p><b>Big Brother</b> is the UK's biggest reality TV show and is one of the most talked-about shows in British TV history. Big Brother takes place entirely within the confines of the Big Brother House. It's essentially a competition between the housemates, the object of which is to be the last remaining housemate in the House. At least one housemate will leave the House every week by a process of nomination and public eviction. Housemates will nominate each other for eviction and those with the most votes from their peers face a public vote. The housemate that receives most public votes leaves the House and is out of the competition. Housemates are provided with a shopping budget each week to buy food and other necessities. Throughout the series housemates will be asked to complete tasks set by Big Brother. If the group does well in the tasks they get rewarded with a bigger shopping budget, plus special treats. On the final night of Big Brother the public vote on which housemate they want to win the show. The housemate with most votes wins a fabulous cash prize!</p>",
    officialSite: "http://bigbrother.channel5.com",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 135,
      name: "Channel 5",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2000-07-18",
  },
  {
    id: 1515,
    url: "https://www.tvmaze.com/shows/1515/big-brother-canada",
    name: "Big Brother Canada",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21269.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21269.jpg",
    },
    summary:
      '<p><b>Big Brother Canada</b> is a reality television show in which a group of contestants, known as "HouseGuests", are sequestered in the Big Brother House, under the surveillance of cameras and microphones, for the chance to win a grand prize of $100,000 by being the last remaining HouseGuest. Each week, the HouseGuests vote to evict one of their own until two HouseGuests remain on finale night. The winner is decided by the last seven evicted HouseGuests, known as the Big Brother Jury.</p>',
    officialSite: "http://bigbrothercanada.globaltv.com",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 67,
      name: "Global",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2013-02-27",
  },
  {
    id: 1516,
    url: "https://www.tvmaze.com/shows/1516/celebrity-big-brother",
    name: "Celebrity Big Brother",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/164/410898.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/164/410898.jpg",
    },
    summary:
      "<p>Originally created as a one-off tie-in series by Channel 4 in association with the BBC's Comic Relief charity telethon, <b>Celebrity Big Brother</b> is now a full spin-off of Big Brother in the UK, airing on Channel 5. The series features a number of celebrity contestants living in the Big Brother House, trying to avoid eviction by the public. Emma Willis is the current presenter of the series, as she has become the face of Channel 5's Big Brother, she replaced Brian Dowling who presented the first four series on Channel 5 (2011-2013) and Davina McCall who hosted the first seven series for original broadcaster Channel 4 (2001-2010). Since the show moved to Channel 5 in 2011, the series traditionally airs two series a year, with one at the start of the year and one after the normal civilian run of Big Brother in August/September.</p>",
    officialSite: "http://bigbrother.channel5.com",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 135,
      name: "Channel 5",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2001-03-10",
  },
  {
    id: 1517,
    url: "https://www.tvmaze.com/shows/1517/digimon-digital-monsters",
    name: "Digimon: Digital Monsters",
    genres: ["Action", "Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21271.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21271.jpg",
    },
    summary:
      "<p>While at summer camp, seven kids - Tai, Matt, Sora, Izzy, Mimi, Joe, and T.K. - come across seven Digivices and are transported to a strange digital world. In this new world they make friends with creatures that call themselves Digimon - short for Digital Monsters - who were born to defend their world from various evil forces. The children learn they have the ability to help their new Digimon friends digivolve into different Digital Monsters and fight as a team to defend enemies and ultimately find their way home.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 25,
      name: "Disney XD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-08-14",
  },
  {
    id: 1518,
    url: "https://www.tvmaze.com/shows/1518/drawn-together",
    name: "Drawn Together",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21274.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21274.jpg",
    },
    summary:
      "<p>This is the true story of eight animated characters, picked to live together in a house to find out what happens when people stop being polite and start getting real. Meet the stars of <i>Drawn Together</i>, eight cartoons from all walks of life who have to deal with each others quirks, differences and drunken gropings in a hot tub. From Clara, the racist fairy tale princess, to Foxxy Love, the sassy, sexy musician to Woldoor Sockbat the... whatever he is, these housemates fast learn the art of loving, punching and licking each other.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-10-27",
  },
  {
    id: 1519,
    url: "https://www.tvmaze.com/shows/1519/dtla",
    name: "DTLA",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21278.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21278.jpg",
    },
    summary:
      '<p><b>DTLA</b> tells the story of a diverse group of friends, all at crossroads in their lives. Darryl Stephens stars as Lenny, a civil litigation attorney who reunites with his college friend SJ during the breaking point in her marriage and while his own long-term relationship with Bryan starts to crumble. Also in the mix are Kai, a young teacher obsessed with hooking up with his celeb crush; Marky, a young Marine cadet, and his boyfriend Matthew, a newcomer to LA who will stop at "nothing" to make it as an actor; and Stefan, an outspoken lawyer struggling to make his relationship work with his much younger boyfriend Trey after finding out about his secret life.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 117,
      name: "Logo TV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-10-24",
  },
  {
    id: 1520,
    url: "https://www.tvmaze.com/shows/1520/happily-divorced",
    name: "Happily Divorced",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21281.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21281.jpg",
    },
    summary:
      "<p><b>Happily Divorced</b> centers around Los Angeles florist Fran as she deals with dating after finding out her realtor husband of 18 years is gay. Fran juggles her new relationships, while still living under the same roof with her ex-husband. The cast is rounded out by Fran's best friend Judi, her parents Dori and Glen and her flower delivery employee Cesar.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 57,
      name: "TV Land",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-06-15",
  },
  {
    id: 1521,
    url: "https://www.tvmaze.com/shows/1521/little-mosque-on-the-prairie",
    name: "Little Mosque on the Prairie",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21288.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21288.jpg",
    },
    summary:
      '<p><i><b>Little Mosque on the Prairie</b></i> is a comedy from CBC Television about a small Muslim community in the prairie town of Mercy, many of whose residents are wary of their new, more "exotic" neighbors. The series takes an unabashedly funny look at the congregation of a rural mosque and their attempt to live in harmony with the often skeptical, even downright suspicious, residents of their little town. The sitcom reveals that, although different, we are all surprisingly similar when it comes to family, love, the generation gap and our attempts to balance our secular and religious lives.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 36,
      name: "CBC",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2007-01-09",
  },
  {
    id: 1522,
    url: "https://www.tvmaze.com/shows/1522/mrs-browns-boys",
    name: "Mrs. Brown's Boys",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21298.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21298.jpg",
    },
    summary:
      "<p>Comedy starring Brendan O'Carroll as loud-mouthed Irish matriarch Agnes Brown, whose favourite pastime is meddling in the lives of her six children.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00x98tn",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-02-21",
  },
  {
    id: 1523,
    url: "https://www.tvmaze.com/shows/1523/partners",
    name: "Partners",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21300.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21300.jpg",
    },
    summary:
      "<p><b>Partners</b> is a comedy based on the lives of creators David Kohan and Max Mutchnick, about two life-long best friends and business partners whose \"bromance\" is tested when one of them is engaged to be married. Joe is an accomplished architect who leads with his head and not his heart, especially in his love life. That's in stark contrast to his gay co-worker, Louis, who is spontaneous, emotional and prone to exaggeration. Both have found joy in their love lives: Joe is newly engaged to Ali, a beautiful and sophisticated jewelry designer, while Louis is dating Wyatt, a vegan nurse who Louis insists is just a promotion away from becoming a doctor. As news of Joe's engagement settles, time will tell if their business and personal bond can adapt to the addition of two other important relationships.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-09-24",
  },
  {
    id: 1524,
    url: "https://www.tvmaze.com/shows/1524/queer-as-folk",
    name: "Queer As Folk",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21306.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21306.jpg",
    },
    summary:
      "<p>Set in and around the Manchester 'scene', this groundbreaking Channel 4 drama written by Russell T Davies, documents the lives and loves of three young gay men: Stuart, Vince and Nathan.</p>",
    officialSite: "http://www.channel4.com/programmes/queer-as-folk",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1999-02-23",
  },
  {
    id: 1525,
    url: "https://www.tvmaze.com/shows/1525/ronin-warriors",
    name: "Ronin Warriors",
    genres: ["Action", "Adventure", "Anime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21308.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21308.jpg",
    },
    summary:
      "<p>After a thousand years of exile, Talpa, ruler of the Netherworld, returns to claim the Earth as his own. The only thing that can stop him and his minions are five young men and their mystical suits of armor.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 136,
      name: "Nagoya Broadcasting Network",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1988-04-30",
  },
  {
    id: 1526,
    url: "https://www.tvmaze.com/shows/1526/rupauls-drag-race",
    name: "RuPaul's Drag Race",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/291/729282.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/291/729282.jpg",
    },
    summary:
      "<p>RuPaul's Drag Race is a Primetime Emmy Award winning American reality competition television series, hosted by five time Emmy Award Winning Host and international Drag superstar RuPaul. The show features drag queen contestants competeing in weekly challenges such as photo shoots, comedy performances and stomping the runway in the hopes of avoiding the bottom two - where they will have to lip sync for their lives.</p>",
    officialSite: "http://www.vh1.com/shows/rupauls-drag-race",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 55,
      name: "VH1",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-02-02",
  },
  {
    id: 1527,
    url: "https://www.tvmaze.com/shows/1527/sean-saves-the-world",
    name: "Sean Saves the World",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21310.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21310.jpg",
    },
    summary:
      "<p>Sean is a divorced gay dad who juggles a lot - his successful but demanding career, offbeat employees, pushy mom Lorna and weekends with his teenage daughter, Ellie . So when she moves in full-time, it's a whole new world. Never one to do anything halfway, Sean's intent on being the best dad ever, so he loads up on parenting how-to books and plans Pinterest-worthy family dinners. But it seems his company's new owner has decided Sean and his team should work longer hours, putting a damper on his homemaking plans and throwing a kink in Sean's perfectly constructed work/life balance. Ellie sees this development as a plus. She loves her dad, but he's clearly going overboard. From keeping his boss happy, employees motivated and enduring his mother's tactless \"advice\" to raising a smart, grounded and healthy kid, it's going to be a growing experience, to say the least. But if anyone can handle it all, it's Sean.</p>",
    officialSite: "http://www.nbc.com/sean-saves-the-world",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-10-03",
  },
  {
    id: 1528,
    url: "https://www.tvmaze.com/shows/1528/seed",
    name: "Seed",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21317.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21317.jpg",
    },
    summary:
      '<p><i><b>"Seed"</b></i> is a half-hour comedy following Harry, a likeable bachelor and bartender whose previous foray into sperm donation has resulted in offspring he was unaware of – until now.<br><br> Harry discovers that his foray into the world of sperm donation has resulted in kids – lots of kids!<br><br> This ill-equipped bachelor finds himself entangled in the lives of his newfound children and their less-than-thrilled families – a lesbian couple and their 9-year-old oddball son, an up-tight, upper-class husband and wife and their rebellious teenage daughter, and an impulsive single woman with a ticking biological clock …</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 151,
      name: "Citytv",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2013-02-04",
  },
  {
    id: 1529,
    url: "https://www.tvmaze.com/shows/1529/spider-man-unlimited",
    name: "Spider-Man Unlimited",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21324.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21324.jpg",
    },
    summary:
      "<p>Believed to be dead after saving a life in a fire, Peter Parker uses this shroud to embark on a mission to retrieve John Jameson on Counter-Earth! Strap in to your seats and experience Spider-Man Unlimited!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1457,
      name: "Fox Kids",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-10-02",
  },
  {
    id: 1530,
    url: "https://www.tvmaze.com/shows/1530/the-vicar-of-dibley",
    name: "The Vicar of Dibley",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21325.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21325.jpg",
    },
    summary:
      "<p>Award-winning sitcom starring Dawn French who is assigned as the Vicar of the rural parish of Dibley.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006qgfj",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1994-11-10",
  },
  {
    id: 1531,
    url: "https://www.tvmaze.com/shows/1531/welcome-to-the-family",
    name: "Welcome to the Family",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21330.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21330.jpg",
    },
    summary:
      "<p>A single-camera comedy about two teens whose disparate families are bonded together after they fall in love and get pregnant.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-10-03",
  },
  {
    id: 1532,
    url: "https://www.tvmaze.com/shows/1532/fleming-the-man-who-would-be-bond",
    name: "Fleming: The Man Who Would Be Bond",
    genres: ["Drama", "Action", "Espionage"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21337.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21337.jpg",
    },
    summary:
      "<p>There's no questioning the iconic status of the man they call 007, but before his thrilling adventures hit the page or screen, they were experienced first-hand by author-to-be, Ian Fleming. Stylish and explosive - BBC America's <b>Fleming: The Man Who Would Be Bond</b> tells the fascinating story of the man whose own life and escapades were the inspiration for one of the most iconic figures in modern literature - James Bond. The new original four-part drama stars Dominic Cooper as Fleming, a charming and sophisticated maverick, whose pleasure-seeking life was turned around by WWII and led to the creation of the greatest spy the world has ever known.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 15,
      name: "BBC America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-29",
  },
  {
    id: 1533,
    url: "https://www.tvmaze.com/shows/1533/into-the-west",
    name: "Into the West",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21339.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21339.jpg",
    },
    summary:
      "<p>Chronicling the struggles, heartache and conquests of two inspiring families, Into the West captures the hopes and perseverance of both the explorers who risked everything to fulfill their dreams and the land's indigenous people forced to watch their way of life disappear.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-06-10",
  },
  {
    id: 1534,
    url: "https://www.tvmaze.com/shows/1534/spies-of-warsaw",
    name: "Spies of Warsaw",
    genres: ["Drama", "Thriller", "Espionage"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/218/547492.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/218/547492.jpg",
    },
    summary:
      "<p>French and German intelligence operatives are locked in a life-and-death struggle in the espionage arena. At the French embassy, a decorated war hero of the 1914 war, Colonel Jean-Francois Mercier, is sucked into a world of abduction, betrayal and international intrigue from the diplomatic salons to the back alleys of Warsaw. Mercier simultaneously finds himself in a passionate love affair with Anna, a Parisian lawyer for the League of Nations. Their complicated love affair intensifies as German tanks drive through the Black Forest.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b01pw43c",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 51,
      name: "BBC Four",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-01-09",
  },
  {
    id: 1535,
    url: "https://www.tvmaze.com/shows/1535/restless",
    name: "Restless",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/71/179776.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/71/179776.jpg",
    },
    summary:
      "<p>Based on the bestselling novel by William Boyd, enter a cloak and dagger world where everyone and everything is under suspicion. Haunted by the death of her brother at the hands of fascist thugs, Russian émigré Eva Delectorskaya is recruited to be a British secret agent by the shadowy figure, Lucas Romer. After proving her merit in the field, she is sent on the most dangerous mission of her life. She must use any means necessary to manipulate the American press and draw the States into World War II. Unbeknownst to her, there are more sinister powers at work, and a deadly betrayal forces her into hiding. But once a spy, always a spy. Years later, she is gripped with paranoia when she fears her cover has been blown. With no one else to turn to, she recruits her unsuspecting daughter to help uncover the truth and confront the elusive Romer. After a life of conspiracy and intrigue, Eva wonders if she'll ever feel safe. Time is running out, and she must unravel all the mysteries before it's too late. A 2-part miniseries starring Hayley Atwell (<i>Captain America: The First Avenger</i>), Charlotte Rampling (<i>Swimming Pool</i>), Michael Gambon (<i>Harry Potter</i>), and Rufus Sewell (<i>The Illusionist</i>).</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p0108tpb",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-12-27",
  },
  {
    id: 1536,
    url: "https://www.tvmaze.com/shows/1536/hunter-x-hunter",
    name: "Hunter x Hunter",
    genres: ["Action", "Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/223/559165.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/223/559165.jpg",
    },
    summary:
      "<p>Remake of the 1999 TV series of Hunter x Hunter based on the manga by Togashi Yoshihiro. A Hunter is one who travels the world doing all sorts of dangerous tasks. From capturing criminals to searching deep within uncharted lands for any lost treasures. Gon is a young boy whose father disappeared long ago, being a Hunter. He believes if he could also follow his father's path, he could one day reunite with him. After becoming 12, Gon leaves his home and takes on the task of entering the Hunter exam, notorious for its low success rate and high probability of death to become an official Hunter. He befriends the revenge-driven Kurapica, the doctor-to-be Leorio and the rebellious ex-assassin Killua in the exam, with their friendship prevailing throughout the many trials and threats they come upon taking on the dangerous career of a Hunter.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 137,
      name: "NTV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2011-10-02",
  },
  {
    id: 1537,
    url: "https://www.tvmaze.com/shows/1537/hunter-x-hunter",
    name: "Hunter x Hunter",
    genres: ["Action", "Anime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21448.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21448.jpg",
    },
    summary:
      "<p>The story of Hunter × Hunter focuses on a young boy named Gon Freecss, who one day discovers that the father he had always been told was dead was alive and well. He learns that his father, Ging Freecss, is a legendary Hunter, a person that has proven themselves by examination to be an elite member of humanity, with a license to go anywhere or do anything. Despite the fact that his father abandoned Gon with his relatives in order to pursue his dreams, Gon becomes determined to follow in his father's footsteps, pass the Hunter examination, and eventually find his father, to prove himself as a Hunter in his own right.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 131,
      name: "Fuji TV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1999-10-16",
  },
  {
    id: 1538,
    url: "https://www.tvmaze.com/shows/1538/preachers-of-detroit",
    name: "Preachers of Detroit",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23542.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23542.jpg",
    },
    summary:
      "<p>The series focuses on seven men and women of the cloth who share their lives, transformations and triumphs in and out of the pulpit. Leading up to the series debut, Oxygen will air two hour-long specials featuring Minister Deitrick Haddon from <i>Preachers of L.A.</i> as he returns to his hometown of Detroit to reunite with his family and help the community. In addition, fans can access even more exclusive content on Video On Demand including bonus footage and interviews with the cast beginning on February 12. <b>Preachers of Detroit</b> follows the strong and resilient pastors who are not afraid to push boundaries in their communities from the challenges of being a woman bishop in a field that is dominated by men to keeping faith alive in a city that has faced tremendous hardship.</p>",
    officialSite: "http://www.oxygen.com/preachers-of-detroit",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 79,
      name: "Oxygen",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-13",
  },
  {
    id: 1539,
    url: "https://www.tvmaze.com/shows/1539/love-lust-or-run-wear-are-they-now",
    name: "Love, Lust or Run: Wear Are They Now",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23751.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23751.jpg",
    },
    summary:
      '<p>Updates on women who sought fashion advice from Stacy London ("What Not to Wear") to see if they toned down their over-the-top styles and opted for more appropriate attire.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-13",
  },
  {
    id: 1540,
    url: "https://www.tvmaze.com/shows/1540/penn-zero-part-time-hero",
    name: "Penn Zero: Part-Time Hero",
    genres: ["Comedy", "Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21638.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21638.jpg",
    },
    summary:
      "<p><b>Penn Zero: Part-Time Hero</b> follows Penn Zero and his best friends Sashi, an overqualified part-time sidekick, and Boone, an under-qualified part-time wise man, as they zap to other dimensions to fill in for heroes in need. Each mission takes the team to unpredictable epic worlds where they must battle evil part-time villain Rippen and his part-time minion, Larry. Whether superhero, fish-prince, clown cop, giant monster or tiny action-figure, Penn uses his unconventional heroic skills to save the day - his own way.</p>",
    officialSite: "http://disneyxd.disney.com/penn-zero",
    webChannel: {
      id: 83,
      name: "DisneyNOW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: {
      id: 25,
      name: "Disney XD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-12-05",
  },
  {
    id: 1541,
    url: "https://www.tvmaze.com/shows/1541/bella-and-the-bulldogs",
    name: "Bella and the Bulldogs",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21639.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21639.jpg",
    },
    summary:
      "<p>Middle schooler Bella Dawson left her life as a popular cheerleader behind to join the Bulldogs as their new star quarterback. Trading in her pom-poms for a pigskin was a total dream come true, but now Bella must find a balance between football and her cheerleading BFFs. Does she have what it takes to overcome the doubters and lead her team to victory, without compromising who she is? And what will happen when those worlds collide?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-17",
  },
  {
    id: 1542,
    url: "https://www.tvmaze.com/shows/1542/the-jinx-the-life-and-deaths-of-robert-durst",
    name: "The Jinx: The Life and Deaths of Robert Durst",
    genres: ["Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21643.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21643.jpg",
    },
    summary:
      "<p>From Andrew Jarecki and Marc Smerling (the Oscar® nominees behind <i>Capturing the Friedmans </i>), comes <i>The Jinx: The Life and Deaths of Robert Durst</i>, a six-part examination of the reclusive millionaire at the heart of three killings spanning four decades. Robert Durst, the scion of a New York real estate empire, has long been a suspect in the notorious 1982 disappearance of his wife, Kathie. Further suspicion was raised with the unsolved killing of his confidante, Susan Berman, thought to be a key witness in the investigation into Kathie's disappearance in 2000, as well as the subsequent killing and dismemberment of a neighbor in Galveston, Texas. Durst has consistently maintained his innocence and remains a free man today.</p>",
    officialSite: "http://www.thejinxhbo.com/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-08",
  },
  {
    id: 1543,
    url: "https://www.tvmaze.com/shows/1543/rugged-justice",
    name: "Rugged Justice",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31452.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31452.jpg",
    },
    summary:
      "<p><b>Rugged Justice</b> follows Washington State's Department of Fish and Wildlife Law Enforcement Program as they police the Evergreen State's unforgiving mountain terrains, twisted rainforest back roads and densely populated coastal areas. In the six-episode series, viewers follow the WDFW Police Officers as they patrol more than 42 million acres of rugged terrain, half of it heavily forested and filled with wild animals, and often dangerous people. The department's dispatchers relay more 225,000 calls annually. Each day brings new challenges and extreme danger. Whether busting poachers along the USA-Canada border, going undercover to take down traffickers in the illegal animal parts trade, or tracking and capturing bears and cougars with the one-of-a-kind Karelian Bear-Dog Unit, the officers of <i>Rugged Justice</i> risk life and limb to protect natural resources and serve the people of Washington.</p>",
    officialSite: "http://www.animalplanet.com/tv-shows/rugged-justice/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 92,
      name: "Animal Planet",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-18",
  },
  {
    id: 1544,
    url: "https://www.tvmaze.com/shows/1544/sports-illustrated-swimsuit",
    name: "Sports Illustrated Swimsuit",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23755.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23755.jpg",
    },
    summary:
      "<p><b>Sports Illustrated Swimsuit</b> is a yearly special showing the making of that year's SI Swimsuit issue and all of the behind the scenes activity that goes into the making of this very expensive magazine issue as well as interviews with some of the most beautiful swimsuit models in the world.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 31,
      name: "Audience Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1992-02-09",
  },
  {
    id: 1545,
    url: "https://www.tvmaze.com/shows/1545/ghosts-in-my-house",
    name: "Ghosts in My House",
    genres: ["Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23541.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23541.jpg",
    },
    summary:
      "<p>Doors slam, faucets turn on by themselves, lights flicker for all inexplicable reasons, until now. <b>Ghosts in My House</b> uses psychic Nadine Mercey and paranormal investigator Michelle McCay as the ghost gurus questing to find the answers behind these odd occurrences, on the hunt to find who else might be living in your home?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 107,
      name: "Destination America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-08",
  },
  {
    id: 1546,
    url: "https://www.tvmaze.com/shows/1546/christina-milian-turned-up",
    name: "Christina Milian Turned Up",
    genres: ["Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/34/87094.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/34/87094.jpg",
    },
    summary:
      '<p>As part of this loud, loving, opinionated and multi-talented Cuban-American family, Christina Milian has always been the focus, often to the consternation of her two sisters, Danielle and Lizzy. Now, Christina is learning how to share the spotlight, and this all-new E! docu series "Christina Milian Turned Up," follows Christina as she reinvigorates her music career with a new label, a new sound and a new look, all while raising her young daughter Violet with help from mom Carmen and sisters Danielle and Lizzy. This season is all about family when middle-sister Danielle tries to balance a new marriage and motherhood; baby sister Lizzy begins a new chapter as a trained culinary chef and converts to Orthodox Judaism, and Carmen attempts to find a happy medium managing Christina\'s professional life while keeping a very close watch over her entire family.</p>',
    officialSite: "http://www.eonline.com/shows/christina_milian_turned_up",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 43,
      name: "E!",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-18",
  },
  {
    id: 1548,
    url: "https://www.tvmaze.com/shows/1548/grantchester",
    name: "Grantchester",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/184/460760.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/184/460760.jpg",
    },
    summary:
      "<p>Eavesdropping on the life of Sidney Chambers, a charismatic, charming, crime-fighting clergyman, and his partner in crime Police Inspector Geordie Keating, became a highlight for the audience who revelled in their on screen partnership. Geordie's plain-speaking, down to earth approach to policing complemented Sidney's more gentle technique of coaxing information from witnesses and suspects. Their unlikely pairing became a true friendship as each offered a different insight into the crimes they unravelled.</p>",
    officialSite: "http://www.itv.com/hub/grantchester/2a2958",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-10-06",
  },
  {
    id: 1549,
    url: "https://www.tvmaze.com/shows/1549/kids-baking-championship",
    name: "Kids Baking Championship",
    genres: ["Children", "Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/88/220914.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/88/220914.jpg",
    },
    summary:
      "<p>Hosts and judges Duff Goldman and Valerie Bertinelli lead eight talented kid bakers through tasty challenges designed to find the most impressive and creative young baker on <b>Kids Baking Championship</b>. In each challenge, the kid contestants (ranging in age from 10 to 13) will be tested on their baking skills and originality, as they whip up delectable desserts including creative cakes, mouthwatering cookies and pastries making it seem as easy as pie. At stake, a sweet prize package that includes a complete set of Food Network bakeware products, a profile in Food Network Magazine, an original cake featured at Charm City Cakes and a $10,000 grand prize. Only one will take the cake to become the Kids Baking Champion!</p>",
    officialSite: "http://www.foodnetwork.com/shows/kids-baking-championship",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 81,
      name: "Food Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-02",
  },
  {
    id: 1550,
    url: "https://www.tvmaze.com/shows/1550/vanity-fair-confidential",
    name: "Vanity Fair Confidential",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23788.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23788.jpg",
    },
    summary:
      "<p>Offering unprecedented access to the magazine's writers and editors, <b>Vanity Fair Confidential</b> takes viewers to the heart of some of the most controversial dramas in history - dramas centered at the cross section of power, wealth and celebrity.</p>",
    officialSite:
      "https://www.investigationdiscovery.com/tv-shows/vanity-fair-confidential/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-19",
  },
  {
    id: 1551,
    url: "https://www.tvmaze.com/shows/1551/star-vs-the-forces-of-evil",
    name: "Star vs. the Forces of Evil",
    genres: ["Comedy", "Adventure", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/65/164482.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/65/164482.jpg",
    },
    summary:
      "<p><b>Star vs. The Forces of Evil</b> follows fiercely awesome teen princess Star Butterfly. After receiving an all-powerful magic wand for her 14th birthday, Star is sent by her Royal Parents to live with the Diaz family on Earth, bringing along her own unique inter-dimensional style to her new home. Together with the Diaz's teenage son, Marco, they navigate high school and embark on dimension-hopping adventures across the multiverse while keeping her wand out of the clutches of arch-nemesis Ludo and his monstrous forces of evil.</p>",
    officialSite: "http://disneyxd.disney.com/star-vs-the-forces-of-evil",
    webChannel: {
      id: 83,
      name: "DisneyNOW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: {
      id: 25,
      name: "Disney XD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-18",
  },
  {
    id: 1552,
    url: "https://www.tvmaze.com/shows/1552/friends-to-lovers",
    name: "Friends to Lovers?",
    genres: ["Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/313/784832.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/313/784832.jpg",
    },
    summary:
      '<p>From casual to complicated, innocent to intimate, this social experiment of the heart follows five sets of singles who take a leap of faith and try to become more than "just friends." Throughout the season, the couples must deal with the unique challenges of dating such as awkward first kisses, tests of jealousy and the inevitable reveal to friends and family. While some count their years of friendship as the foundation for their relationship, others want to be swooned all over again.</p>',
    officialSite: "http://www.bravotv.com/friends-to-lovers",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-12",
  },
  {
    id: 1553,
    url: "https://www.tvmaze.com/shows/1553/mud-sweat-and-gears",
    name: "Mud, Sweat and Gears",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31453.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31453.jpg",
    },
    summary:
      "<p>BBC America's <b>Mud, Sweat and Gears</b> is a competitive car show, where each week hosts Tom ‘Wookie' Ford and Jonny Smith captain a team of two car nuts and go head-to-head to transform everyday vehicles. They have 24 hours to mutate, supersize and reconstruct — once transformed, the vehicles are raced in three extreme missions involving head-to-head sprints, timed challenges and stunts, lots of stunts.</p><p>The missions are daring, adventurous, fun, and competitive — and all tied to different episode themes rolling out each week.</p>",
    officialSite: "http://www.bbcamerica.com/shows/mud-sweat-and-gears",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 15,
      name: "BBC America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-26",
  },
  {
    id: 1554,
    url: "https://www.tvmaze.com/shows/1554/the-manipulation-game",
    name: "The Manipulation Game",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/52/130331.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/52/130331.jpg",
    },
    summary:
      "<p>A psychological illusionist shows how the mind (and people) can be manipulated.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 77,
      name: "Science",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-26",
  },
  {
    id: 1555,
    url: "https://www.tvmaze.com/shows/1555/what-on-earth",
    name: "What on Earth?",
    genres: ["Mystery", "Nature", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/205/513459.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/205/513459.jpg",
    },
    summary:
      "<p><b>What on Earth?</b> is a documentary series using satellite images of strange geological occurrences and man-made structures on Earth to examine such matters as the planet's extreme locations, phenomena and species.</p>",
    officialSite: "http://www.sciencechannel.com/tv-shows/what-on-earth/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 77,
      name: "Science",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-10",
  },
  {
    id: 1556,
    url: "https://www.tvmaze.com/shows/1556/the-italian-americans",
    name: "The Italian Americans",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755264.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755264.jpg",
    },
    summary:
      '<p>The series, written and produced by John Maggio and narrated by Academy Award-nominated actor Stanley Tucci, explores the evolution of Italian Americans from the late nineteenth century to today, from "outsiders" once viewed with suspicion and mistrust to some of the most prominent leaders of business, politics and the arts today.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 85,
      name: "PBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-17",
  },
  {
    id: 1558,
    url: "https://www.tvmaze.com/shows/1558/barn-hunters",
    name: "Barn Hunters",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23787.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23787.jpg",
    },
    summary:
      "<p>Pennsylvania's jack-of-all-trades, Sean Tracy, is crisscrossing America, finding the oldest, broken-down barns in the country and transforming them into dream homes. He rescues the dilapidated barns just before they're set to be demolished and either refurbishes them on the spot, or dismantles them piece by piece, carefully transporting them to his shop in Bucks County and turning the old structures into ultimate, one-of-a-kind barn homes.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 103,
      name: "Great American Country",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-18",
  },
  {
    id: 1559,
    url: "https://www.tvmaze.com/shows/1559/see-no-evil",
    name: "See No Evil",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/205/513158.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/205/513158.jpg",
    },
    summary:
      "<p><b>See No Evil</b> pieces together the truth when shocking surveillance footage reveals breakthrough clues to solve a murder.</p>",
    officialSite:
      "https://www.investigationdiscovery.com/tv-shows/see-no-evil/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-17",
  },
  {
    id: 1560,
    url: "https://www.tvmaze.com/shows/1560/our-little-family",
    name: "Our Little Family",
    genres: ["Drama", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755263.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755263.jpg",
    },
    summary:
      "<p>TLC's newest faces, the Hamills, are not the typical American family. Parents Dan and Michelle along with their son and twin daughters are all little people - all five family members have achondroplasia, a form of dwarfism. TLC follows their life in new series OUR LITTLE FAMILY premiering February 17th at 10PM ET/PT. Both parents are proud little people who are even more thrilled their kids (Jack, Cate and CeCe) are little just like them; however, growing up in an average-sized world has its complications, and they know the road ahead for their children is not going to be easy.</p>",
    officialSite: "http://www.tlc.com/tv-shows/our-little-family/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-17",
  },
  {
    id: 1561,
    url: "https://www.tvmaze.com/shows/1561/match-made-in-heaven",
    name: "Match Made in Heaven",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/291/729359.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/291/729359.jpg",
    },
    summary:
      "<p>Meet Shawn Bullard, an African American real estate magnate and former college athlete looking for true love. And who better to help him find The One than the man upstairs - or someone with a close connection? Enter Pastor Ken Johnson (spiritual advisor to the Indianapolis Colts) who guides Shawn and observes the authenticity and godliness of 24 women living under one roof hoping to find a love connection with Shawn. Not only does the pastor weigh in on Shawn's choices, but when his very outspoken mother moves in, she too has a say on who could potentially be her daughter-in-law. While some ladies are sane and sweet, others are downright devilish leading to plenty of drama and bad behavior. After a series of dates, romantic rendezvous, harsh eliminations, and solicited (and unsolicited) advice from the Pastor and his mother, find out if Shawn finally meets his match.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 122,
      name: "WE tv",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-04",
  },
  {
    id: 1562,
    url: "https://www.tvmaze.com/shows/1562/rv-nation",
    name: "RV Nation",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31428.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31428.jpg",
    },
    summary:
      "<p>In <b>RV Nation</b>, go behind the scenes to explore the design and construction process for the biggest, most elaborate recreational vehicles on the market. See how motor home distributors transform trailers into glamorous celebrity coaches.</p>",
    officialSite: "http://www.greatamericancountry.com/shows/rv-nation",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 103,
      name: "Great American Country",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-21",
  },
  {
    id: 1563,
    url: "https://www.tvmaze.com/shows/1563/would-you-rather-with-graham-norton",
    name: "Would You Rather...? with Graham Norton",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/232/580417.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/232/580417.jpg",
    },
    summary:
      "<p>Graham Norton brings his trademark style of wit and humor to BBC America's first original comedy series. Based on popular British panel-style shows, each week celebrities and comedians are asked to contemplate and discuss ridiculous predicaments and moral quandaries. Would you rather everything you ever said for the rest of your life was the absolute truth or an absolute lie? Would you rather live the rest of your life with Darth Vader's voice or Alvin the Chipmunk's voice? Would you rather sleep with your best friend's partner or sleep with your partner's best friend? After a hilarious and candid debate the panelists must ultimately decide what they'd rather do and Graham picks his favorite response.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 15,
      name: "BBC America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-12-03",
  },
  {
    id: 1564,
    url: "https://www.tvmaze.com/shows/1564/wwe-slam-city",
    name: "WWE Slam City",
    genres: ["Comedy", "Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23484.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23484.jpg",
    },
    summary:
      "<p>Animated adventures from the WWE universe. In this series all of the WWE superstars are fired from the ring by a masked wrestler known as The Finisher and are forced to take up jobs in Slam City.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 73,
      name: "Nicktoons",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-03-17",
  },
  {
    id: 1565,
    url: "https://www.tvmaze.com/shows/1565/best-new-restaurant",
    name: "Best New Restaurant",
    genres: ["Food", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/313/784842.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/313/784842.jpg",
    },
    summary:
      "<p>Acclaimed chef and restaurateur Tom Colicchio dines across the U.S. as host, judge, and executive producer, taking a look at the food world from a fresh direction: the restaurant. The series is also executive produced by restaurateur and TV personality Gordon Ramsay. The majority of the series takes place on location in the restaurants themselves to highlight each establishment's unique point of view. In the end, only one will be crowned Best New Restaurant and win an editorial feature in Bon Appétit, a featured spot at America's number one global food festival, Vegas Uncork'd by Bon Appétit 2015, and $100,000.</p>",
    officialSite: "http://www.bravotv.com/best-new-restaurant/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-21",
  },
  {
    id: 1566,
    url: "https://www.tvmaze.com/shows/1566/kart-life",
    name: "Kart Life",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23785.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23785.jpg",
    },
    summary:
      "<p>Kart Life is a mix of high-speed and high-stakes as it takes viewers into the fascinating world of kart racing. The series will follow kart-racing kids - along with their parents in the pits - as they go full throttle in pursuit of the racing holy grail: landing a national ranking and a shot at one day becoming a professional driver.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 84,
      name: "truTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-28",
  },
  {
    id: 1567,
    url: "https://www.tvmaze.com/shows/1567/mississippi-men",
    name: "Mississippi Men",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755265.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755265.jpg",
    },
    summary:
      "<p><b>Mississippi Men </b>follows the real-life drama on America's greatest waterway, the Mississippi River, and the extraordinary lives of the modern-day \"Huck Finns\" whose very existence is dependent on the river. Whether she's called the Big Muddy, Old Blue, or the Mighty Miss, the river embodies a personality all her own. Just when the Mississippi Menthink they've got her figured out, she surprises them. They will learn quickly that there are no rules on the river, and if they're not careful they'll get that lesson the hard way. Ultimately, the Mississippi River controls their fate, and only the strong survive.</p>",
    officialSite: "http://www.history.ca/mississippi-men/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-28",
  },
  {
    id: 1568,
    url: "https://www.tvmaze.com/shows/1568/earth-a-new-wild",
    name: "Earth: A New Wild",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21648.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21648.jpg",
    },
    summary:
      "<p>EARTH A NEW WILD, hosted by leading conservation scientist Dr. M. Sanjayan, who takes a fresh look at humanity's relationship to the wild places and fascinating species of our planet.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 85,
      name: "PBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-04",
  },
  {
    id: 1569,
    url: "https://www.tvmaze.com/shows/1569/fire-in-the-hole",
    name: "Fire in the Hole",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21649.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21649.jpg",
    },
    summary:
      "<p>Explosives expert Matt Barnett, founder and president of Texplo Explosives, is the man to call when you need something blown up. He fields calls from all over the world for detonation jobs, from 250 pound bombs from World War II to meth labs to armored vehicles for the military.</p><p>Each job has it's own unique challenges, so Matt relies on his Texplo crew, comprised of long-time friends and fellow explosives experts. With each detonation job, Matt and his Texplo team have to figure out the right plan, tools, and explosives to use to make sure that in the end, they have a happy client and an amazing explosion, without anyone getting hurt in the process.</p>",
    officialSite: "http://www.discovery.com/tv-shows/fire-in-the-hole/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-21",
  },
  {
    id: 1570,
    url: "https://www.tvmaze.com/shows/1570/all-american-makers",
    name: "All-American Makers",
    genres: ["DIY"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/126/315502.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/126/315502.jpg",
    },
    summary:
      "<p>America's do-it-yourselfers, innovators and entrepreneurs are getting the opportunity of a lifetime - to turn their big ideas into big money.. Every week four top makers from around the nation pitch their products to a panel of three experts featuring Printrbot founder and owner Brook Drumm, mechanical designer and robotics expert Brian Roe, and venture capitalist Marc Portney. Each maker's homegrown product is put through a series of rigorous tests by Drumm and Roe to find out how it works and if it lives up to its claim. Should the product make the grade it's then subjected to the scrutiny of real consumer focus groups. Based on the feedback of Drumm and Roe plus the focus groups, Portney decides if he wants to invest his own money in the maker's business and help bring the product to store shelves. From dog toys, thermal radar and grill gadgets to personal robots, hybrid recreational vehicles and stain repellent, the products featured on <b>All-American Makers</b> span the everyday to the amazing.</p>",
    officialSite: "https://www.sciencechannelgo.com/all-american-makers/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 77,
      name: "Science",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-21",
  },
  {
    id: 1572,
    url: "https://www.tvmaze.com/shows/1572/a-very-barry-branson",
    name: "A Very Barry Branson",
    genres: ["Adventure", "Music", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/68/171479.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/68/171479.jpg",
    },
    summary:
      "<p>Barry Williams of The Brady Bunch fame - he played oldest son Greg Brady - is moving from Hollywood to Branson, Missouri to pursue his singing career. This is not a stunt for him, or short residency to make some quick cash. He's bought a condo on a lake. He's financially invested into creating a memorable show. And he's doing this because he loves Branson and he knows that if he's going to make it there, he's going to have to become part of the community, because the people of Branson are very kind, but they do not take well to carpetbaggers. Barry feels very good about his prospects in Branson but knows there's a lot of work ahead of him.</p>",
    officialSite:
      "http://www.greatamericancountry.com/shows/a-very-barry-branson",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 103,
      name: "Great American Country",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-05",
  },
  {
    id: 1573,
    url: "https://www.tvmaze.com/shows/1573/the-mind-of-a-murderer",
    name: "The Mind of a Murderer",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/60/150592.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/60/150592.jpg",
    },
    summary:
      "<p>Investigation Discovery presents the modern-day Clarice Starling as Dr. Michelle Ward goes behind bars to interview violent murderers and offer insight into what drives people to kill with the new series <b>The Mind of a Murderer</b> premiering Thursday, February 19 at 10/9c. From her early doctorate research on psychopathy, to her ongoing study of criminal behavior, Dr. Ward possesses a unique ability to push murderers to the limit, getting them to admit things they wouldn't confess to anyone else. She is trained to go beyond excuses and get to the psychological core of why people commit heinous acts - and she does it alone in a room, face-to-face with coldblooded killers.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-19",
  },
  {
    id: 1574,
    url: "https://www.tvmaze.com/shows/1574/insane-pools-off-the-deep-end",
    name: "Insane Pools: Off the Deep End",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/223/559162.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/223/559162.jpg",
    },
    summary:
      "<p>There are custom pools and gardens - and then there are Lucas Lagoons. Animal Planet's new series, <b>Insane Pools: Off the Deep End</b>, follows award-winning pool designer Lucas Congdon as he turns high and dry homes into exotic waterfront properties through grand, nature-inspired designs to encourage his clients to rediscover their love of the outdoors.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 92,
      name: "Animal Planet",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-20",
  },
  {
    id: 1575,
    url: "https://www.tvmaze.com/shows/1575/coaching-bad",
    name: "Coaching Bad",
    genres: ["Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21650.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21650.jpg",
    },
    summary:
      "<p>Good coaches motivate us, inspire us, and teach us the skills to win. However, there is a growing crisis of coaches with uncontrollable anger issues spreading across today's sports landscape. From Bobby Knight to Mike Rice, too many men and women coaching American athletes, of all ages, often cross the line in what is acceptable behavior on the sidelines or in the dugout. Spike TV has brought together NFL legend Ray Lewis and acclaimed anger management specialist and author Dr. Christian Conte to work with nine coaches who have recognized that they need to change their combative and often bombastic ways if they want to continue in the profession they love. The coaches, who come from a variety of different sports from all around the country, move into a Coaching Center in Los Angeles for intense retraining and reconditioning. During the course of the retraining program, various sports figures will lend their perspective on the negative effects of caustic coaching.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 34,
      name: "Paramount Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-08",
  },
  {
    id: 1576,
    url: "https://www.tvmaze.com/shows/1576/its-a-manns-world",
    name: "It's a Mann's World",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755266.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755266.jpg",
    },
    summary:
      "<p><b>It's a Mann's World</b> takes a peek behind their celebrity on-screen personas, exclusive events, and famous friends, to the down home lives of the real David and Tamela Mann. In eaxh episodes, viewers get a taste of their careful balancing act among being celebrities, entrepreneurs, and parents to four adult children - all while maintaining their 26-year old marriage. Viewers may have met the Browns, but this show introduces the The Manns like you've never seen them before!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 56,
      name: "BET",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-14",
  },
  {
    id: 1577,
    url: "https://www.tvmaze.com/shows/1577/bizarre-foods-delicious-destinations",
    name: "Bizarre Foods: Delicious Destinations",
    genres: ["Adventure", "Food", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21651.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21651.jpg",
    },
    summary:
      "<p>Every traveler wants to try a crepe in Paris, gelato in Florence, Italy, or a po'boy in New Orleans. But how many really know where those dishes came from or how they are made? Andrew Zimmern digs into the not-to-be-missed legendary foods that define a location on <b>Bizarre Foods: Delicious Destinations</b>.</p>",
    officialSite:
      "https://www.cookingchanneltv.com/shows/bizarre-foods-delicious-destinations",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 174,
      name: "Cooking Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-26",
  },
  {
    id: 1581,
    url: "https://www.tvmaze.com/shows/1581/gangland-undercover",
    name: "Gangland Undercover",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23782.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23782.jpg",
    },
    summary:
      "<p>The only man brave enough to sneak into three outlaw biker gangs and live to tell the tale, Charles Falco, author of \"Vagos, Mongols and Outlaws\", goes from convict to infiltrator as he secretly documents the Vagos' illegal activities and ultimately brings them to justice. With the real Charles Falco starting each episode in a silhouetted interview, his story is brought to life in this fact-based docudrama series that sees Falco work as an informant for the Feds on a covert mission inside the dangerous Vagos' world of violence, murder and drug trafficking. Having climbed the gang's ranks while facilitating 62 arrests, Charles Falco exposes how he crippled the criminal enterprise from the core of the biker underworld in this mind-blowing true story, <b>Gangland Undercover</b>.</p>",
    officialSite: "http://www.history.ca/gangland-undercover/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 118,
      name: "History",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2015-02-24",
  },
  {
    id: 1582,
    url: "https://www.tvmaze.com/shows/1582/kosher-soul",
    name: "Kosher Soul",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755268.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755268.jpg",
    },
    summary:
      "<p>The adage says opposites attract... and in the case of Lifetime's all-new docu-sitcom <b>Kosher Soul</b> (#KosherSoul), which follows the lives of Los Angeles stylist Miriam Sternoff, who is Jewish, and her fiancé, southern and African-American comedian O'Neal McKnight, they do. Divergent worlds will clash as Miriam and O'Neal's friends and family prepare for the couple's nuptials, including O'Neal's conversion to Judaism and their future as husband and wife. Despite doubts and concerns from their loved ones, recently engaged Miriam and O'Neal are preparing to marry and begin their lives in a Jewish home. Madly in love, O'Neal is ready to prove his dedication to Miriam by converting to Judaism in order to be accepted by her mother, Nancy, who wants her future grandchildren to be raised Jewish. At the same time, Miriam is trying to blend O'Neal's southern upbringing and traditions into her life. What results is a hilarious and touching peek into the love and affection between two soul mates whose deep and emotional connection overcomes cultural barriers.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-25",
  },
  {
    id: 1583,
    url: "https://www.tvmaze.com/shows/1583/sex-box",
    name: "Sex Box",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21652.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21652.jpg",
    },
    summary:
      "<p>The series takes therapy to a whole new level with couples not only discussing their relationship issues with a panel of experts, but also spending time in a camera-free, soundproof box on the show's set to have sex... all in front of a live studio audience! In each of the 11 hour-long episodes, couples speak candidly with a panel of \"sexperts\" for the chance to reignite their connection. Experts include: Dr. Fran Walfish, a leading Beverly Hills psychotherapist, Dr. Chris Donaghue, a licensed clinical nationally certified sex therapist (one of only 600 in the world) and Dr. Yvonne Capehart, pastor and couples' counselor. Experts are also joined by Danielle Stewart, who provides commentary and on-the-street interviews.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 122,
      name: "WE tv",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-27",
  },
  {
    id: 1584,
    url: "https://www.tvmaze.com/shows/1584/sex-sent-me-to-the-slammer",
    name: "Sex Sent Me to the Slammer",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23779.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23779.jpg",
    },
    summary:
      "<p>With Valentine's Day around the corner, couples will be tempted to turn up the heat on their bedroom antics, but this series cautions those sexual capers can lead to hot water with the law. Each episode features two darkly funny stories of people who literally get caught with their pants down while engaging in serious hanky-panky, or otherwise dare to tickle their fancy with sexcapades that end in not-so-sexy cuffs.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-06",
  },
  {
    id: 1586,
    url: "https://www.tvmaze.com/shows/1586/all-star-academy",
    name: "All-Star Academy",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/123/308425.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/123/308425.jpg",
    },
    summary:
      "<p>Ten talented and successful home cooks from around the country compete in intense culinary challenges as they are mentored by some of Food Network's most popular chefs, while competing for a $50,000 grand prize in <b>All-Star Academy</b>. Hosted by Ted Allen, each competitor, with the guidance of their mentor, must compete over eight episodes in challenges that would propose difficulties for even professional chefs, while elevating their culinary skills to make it to the finish line. With the support of superstar chefs Bobby Flay, Alex Guarnaschelli, Curtis Stone and Michael Symon, each home cook not only has to impress their world-class chef mentor but the special guest judges as well, who help determine who will make the cut in the dreaded elimination round. One-by-one, the challengers are eliminated, leaving one final contender standing with a $50,000 grand prize.</p>",
    officialSite: "http://www.foodnetwork.com/shows/all-star-academy",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 81,
      name: "Food Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-01",
  },
  {
    id: 1587,
    url: "https://www.tvmaze.com/shows/1587/billy-billie",
    name: "Billy & Billie",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23775.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23775.jpg",
    },
    summary:
      "<p><b>Billy &amp; Billie</b> is a drama which centers on two young adults, Billy (Adam Brody) and Billie (Lisa Joyce), as they fall in love, a romance complicated by the fact that they're stepbrother and sister</p>",
    officialSite: "http://billyandbillie.directv.com/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 31,
      name: "Audience Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-03",
  },
  {
    id: 1588,
    url: "https://www.tvmaze.com/shows/1588/the-royals",
    name: "The Royals",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/147/368319.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/147/368319.jpg",
    },
    summary:
      "<p><b>The Royals</b> is an hour-long drama centered on a fictional modern day royal family. Queen Helena and King Simon try to present an aura of class and grace to the public, but the truth of the family's life is much different, as tainted politics and family issues threaten to cause chaos and turmoil. The monarchs' rebellious daughter, Princess Eleanor, provides fodder for the tabloids with a life full of sex, drugs, and even hung-over helicopter rides. Her twin brother, Prince Liam, is a playboy who takes full advantage of being one of the planet's most eligible bachelors. It's a life Liam enjoys until his older brother -- and heir to the throne -- dies, making Liam next in line to inherit the throne. Power is everything, there are no limits, and trust is nonexistent for this royal family.</p>",
    officialSite: "http://uk.eonline.com/shows/the_royals",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 43,
      name: "E!",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-15",
  },
  {
    id: 1589,
    url: "https://www.tvmaze.com/shows/1589/izombie",
    name: "iZombie",
    genres: ["Drama", "Crime", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/192/480555.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/192/480555.jpg",
    },
    summary:
      "<p>Olivia \"Liv\" Moore is a rosy-cheeked, disciplined, over-achieving medical resident who had her life path completely mapped out... until the night she attended a party that unexpectedly turned into a zombie feeding frenzy. As one of the newly undead, Liv has devised a way to resist her baser urges to devour fresh human brains--she's taken a job in the Seattle coroner's office.</p><p>In this appropriately dead-end job, she can secretly snack on the brains of the many Jane and John Doe corpses that make a final stop in the morgue. Liv remains resigned to an eternity without hope or purpose, until she realizes that with every brain she consumes, she retains a portion of that person's memories, and she begins to experience visions from the point of view of the murder victims. It's not the same as being alive again, but at least she can find purpose in her undead existence by helping to solve the murders of those who are indeed fully dead.</p>",
    officialSite: "http://www.cwtv.com/shows/izombie",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-17",
  },
  {
    id: 1590,
    url: "https://www.tvmaze.com/shows/1590/neighbors-with-benefits",
    name: "Neighbors with Benefits",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/277/693628.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/277/693628.jpg",
    },
    summary:
      "<p>The series follows multiple married couples as they court prospective partners and interact with friends and participants, all while going about their typical everyday lives as parents, professionals, soccer moms and little league coaches. Even with a strict set of rules to prevent taking extramarital relationships too far, each couple must deal with the varying effects of living this lifestyle, both inside and outside of their marriages. The series will examine the pitfalls that the lifestyle creates for some, proving that it's not without its challenges and possible personal devastation. While some of the couples on the block believe this way of living strengthens their union, others try to warn potential recruits against the consequences along with its disregard for the sanctity of marriage.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-22",
  },
  {
    id: 1591,
    url: "https://www.tvmaze.com/shows/1591/funny-girls",
    name: "Funny Girls",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31653.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31653.jpg",
    },
    summary:
      "<p>The series follows the professional and personal lives of six female comics in Los Angeles who are climbing their way to the top of the stand-up ladder. While the comediennes differ in their levels of experience, styles of comedy and ultimate career goals, they share the ambition - and the passion - needed to make it in the City of Dreams. From working multiple jobs, to clashing with parents' expectations, to yet another bad date, the comics provide a fresh, witty perspective on experiences to which young millennial women can relate.</p>",
    officialSite: "http://www.oxygen.com/funny-girls",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 79,
      name: "Oxygen",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-07",
  },
  {
    id: 1592,
    url: "https://www.tvmaze.com/shows/1592/cedrics-barber-battle",
    name: "Cedric's Barber Battle",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31442.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31442.jpg",
    },
    summary:
      "<p>CEDRIC'S <i>BARBER BATTLE</i>, an all-new reality competition series hosted by actor and comedian Cedric The Entertainer</p><p>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-17",
  },
  {
    id: 1593,
    url: "https://www.tvmaze.com/shows/1593/the-messengers",
    name: "The Messengers",
    genres: ["Drama", "Mystery", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/25876.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/25876.jpg",
    },
    summary:
      "<p>An apocalyptic event on Earth gives five strangers angelic powers, and it also brings a mysterious dark figure to the planet.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-17",
  },
  {
    id: 1594,
    url: "https://www.tvmaze.com/shows/1594/the-comedians",
    name: "The Comedians",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23777.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23777.jpg",
    },
    summary:
      '<p>In <i><b>"The Comedians"</b></i>, Billy Crystal plays a comedy legend who is reluctantly paired with Josh Gad, an edgier up-and-coming star, in an unfiltered, behind-the-scenes look at a fictional late night sketch comedy show where egos and generations collide.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-09",
  },
  {
    id: 1595,
    url: "https://www.tvmaze.com/shows/1595/grace-and-frankie",
    name: "Grace and Frankie",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/230/577328.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/230/577328.jpg",
    },
    summary:
      "<p>Two nemeses become bonded jilted wives after their husbands reveal they have been having an affair with each other since the 1990s and now plan to get married.</p>",
    officialSite: "https://www.netflix.com/title/80017537",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Running",
    network: null,
    premiered: "2015-05-08",
  },
  {
    id: 1596,
    url: "https://www.tvmaze.com/shows/1596/ufc-fight-night",
    name: "UFC Fight Night",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/293/734642.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/293/734642.jpg",
    },
    summary:
      "<p><b>UFC Fight Night</b> is a part of the Ultimate Fighting Championship (UFC) which is the largest mixed martial arts promotion company in the world featuring most of the top-ranked fighters in the sport. Based in the United States, the UFC produces events worldwide. The organization showcases nine weight divisions and abides by the Unified Rules of Mixed Martial Arts. The UFC has held over 300 events to date. Dana White serves as the president of the UFC while brothers Frank and Lorenzo Fertitta control the UFC's parent company, Zuffa, LLC. The first UFC event was held on November 12, 1993 at the McNichols Sports Arena in Denver, Colorado. The purpose of the early UFC competitions was to identify the most effective martial art in a real fight between competitors of different fighting disciplines, including boxing, Brazilian jiu-jitsu, Sambo, wrestling, Muay Thai, karate, judo, and other styles. In subsequent competitions, fighters began adopting effective techniques from more than one discipline, which indirectly helped create an entirely separate style of fighting known as present-day mixed martial arts.</p>",
    officialSite: "http://www.ufc.com/",
    webChannel: {
      id: 265,
      name: "ESPN+",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Running",
    network: null,
    premiered: "2005-08-06",
  },
  {
    id: 1597,
    url: "https://www.tvmaze.com/shows/1597/ufc-ppv-events",
    name: "UFC PPV Events",
    genres: ["Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21673.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21673.jpg",
    },
    summary:
      "<p>The fastest growing sports organization in the world, the Ultimate Fighting Championship® (UFC®), started in 1993 as a professional mixed martial arts (MMA) organization. UFC has revolutionized the fight business, and today stands as the world's leading MMA promoter, offering the premier series of MMA sports events that have sold out some of the biggest arenas and stadiums across the globe.</p>",
    officialSite: "http://www.ufc.com",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 138,
      name: "Pay-Per-View",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-11-12",
  },
  {
    id: 1598,
    url: "https://www.tvmaze.com/shows/1598/a-bit-of-fry-and-laurie",
    name: "A Bit of Fry and Laurie",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/64/162030.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/64/162030.jpg",
    },
    summary:
      '<p>Stephen Fry and Hugh Laurie were among the most successful acts of the alternative comedy show Saturday Live/Friday Night Live and after a Christmas pilot in 1987, the BBC commissioned a series in 1989.</p><p>"My father wouldn\'t have a television in the house, so we used to gather round every night and watch it on the lawn".</p><p>Fry and Laurie explored a seemingly inexhaustible list of subjects with a delicious turn of phrase and elaborate wordplay. The hilarity-included regular acts such as not so super spy Tony Mercheson and his boss Control, yuppies, John and Peter, as well as the concluding cocktail recipe to the accompaniment of Mr. Music with plenty of Vox Pops.</p>',
    officialSite: "http://www.bbc.co.uk/programmes/b00rv4zp",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1987-12-26",
  },
  {
    id: 1599,
    url: "https://www.tvmaze.com/shows/1599/the-ambassador",
    name: "The Ambassador",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/22049.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/22049.jpg",
    },
    summary:
      '<p><i><b>"The Ambassador"</b></i> follows the private and political problems facing the UK ambassador to Ireland, Harriet Smith (Pauline Collins -<i> Shirley Valentine</i>, <i>City of Joy</i>). She has to deal with international political skullduggery, child custody cases, Anglo-Irish relations as well as the affairs of her family. She is assisted by a team including John Stone (Denis Lawson - <i>Star Wars</i>,<i>Local Hero</i>), an MI5 agent in charge of embassy security as well as unofficial intelligence gathering.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1998-01-04",
  },
  {
    id: 1600,
    url: "https://www.tvmaze.com/shows/1600/have-i-got-news-for-you",
    name: "Have I Got News for You",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21786.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21786.jpg",
    },
    summary:
      "<p>Based on the week's news, <b>Have I Got News for You</b> is fronted by guest hosts and features two regular team captains, Paul Merton and Ian Hislop. Each week the show invites two guests to cast a jaundiced eye over the week's news, resulting in a fast flow of anarchic, spontaneous and hugely entertaining wit and humour. Guests typically represent the world of politics, comedy, show-business and journalism, and are often themselves particularly newsworthy participants. The final touches of Have I Got News for You are put together only hours before recording, allowing guests to comment on the late-breaking news stories of the day.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006mkw3",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1990-09-29",
  },
  {
    id: 1601,
    url: "https://www.tvmaze.com/shows/1601/mind-your-language",
    name: "Mind Your Language",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/87/218704.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/87/218704.jpg",
    },
    summary:
      "<p>The series focuses on adult students in a London school. The classes take place in the early evening, and are taught by Mr. Brown, though on occasion other individuals take over the class if he is not available. The class consists of foreigners with varying degrees of English proficiency. The humour of the show is derived from the students misunderstanding English words or terms, and plays up to the cultural stereotype of their individual nation of origin.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1977-12-30",
  },
  {
    id: 1602,
    url: "https://www.tvmaze.com/shows/1602/prophets-of-science-fiction",
    name: "Prophets of Science Fiction",
    genres: ["Drama", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21798.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21798.jpg",
    },
    summary:
      "<p>An auteur of science fiction himself, Scott goes from behind the camera to on-air guide to explore the relationship between genre and the constantly-evolving worlds of science and technology. From Isaac Asimov, to Jules Verne, to Robert Heinlein, to George Lucas, the dreams of storytellers often become the inspiration for researchers seeking mankind's next transformative discovery.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 77,
      name: "Science",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-11-09",
  },
  {
    id: 1603,
    url: "https://www.tvmaze.com/shows/1603/samurai-jack",
    name: "Samurai Jack",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/33/82695.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/33/82695.jpg",
    },
    summary:
      "<p><b>Samurai Jack</b> is a brave and honorable samurai from the distant past trapped in a nightmarish future. He is terrorized by his sworn enemy, the evil shapeshifting demon Aku. He quests for a way back to the past so that he may stop Aku once and for all.</p>",
    officialSite: "http://www.adultswim.com/videos/samurai-jack/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-08-10",
  },
  {
    id: 1604,
    url: "https://www.tvmaze.com/shows/1604/survivorman",
    name: "Survivorman",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21800.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21800.jpg",
    },
    summary:
      "<p>On <b>Survivorman</b>, filmmaker, musician and outdoor adventurer Les Stroud once again ventures into the wild with no food, no water and no crew. He must rely on his years of training, raw instincts and sheer will to survive. And if that weren't enough, he refuses to bring along a film crew, preferring instead to maintain an authentic survival situation and film the journey himself, dragging 65 pounds of camera gear every inch of the way.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 77,
      name: "Science",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-04-06",
  },
  {
    id: 1605,
    url: "https://www.tvmaze.com/shows/1605/through-the-wormhole",
    name: "Through the Wormhole",
    genres: ["Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21801.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21801.jpg",
    },
    summary:
      "<p>Hosted by Morgan Freeman, <i>Through the Wormhole</i> explores the deepest mysteries of existence - the questions that have puzzled mankind for eternity. Can we eliminate evil? What is nothing? Is there a superior race? Now, science has evolved to the point where hard facts and evidence may be able to provide us with answers instead of philosophical theories. <i>Through the Wormhole</i> brings together the brightest minds and best ideas from the very edges of science - Astrophysics, Astrobiology, Quantum Mechanics, String Theory, and more - to reveal the extraordinary truth of our Universe.</p>",
    officialSite:
      "http://www.sciencechannel.com/tv-shows/through-the-wormhole/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 77,
      name: "Science",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-06-09",
  },
  {
    id: 1606,
    url: "https://www.tvmaze.com/shows/1606/yes-minister",
    name: "Yes Minister",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21802.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21802.jpg",
    },
    summary:
      "<p>Satirical sitcom set in the office of a UK Cabinet minister, Jim Hacker MP, who struggles with Civil Service bureaucracy and political machinations as he tries to get on with government business.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006xtc3",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1980-02-25",
  },
  {
    id: 1607,
    url: "https://www.tvmaze.com/shows/1607/survivors",
    name: "Survivors",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21806.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21806.jpg",
    },
    summary:
      "<p>A handful of <i>survivors</i> struggle to stay alive in the wake of a global disaster.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1975-04-16",
  },
  {
    id: 1608,
    url: "https://www.tvmaze.com/shows/1608/x-company",
    name: "X Company",
    genres: ["Drama", "War", "Espionage"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/148/370099.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/148/370099.jpg",
    },
    summary:
      "<p>Five highly skilled young recruits – Canadian, American and British are torn from their ordinary lives to train as agents in an ultra-secret facility on the shores of Lake Ontario. These agents parachute behind enemy lines, where they're fair game for torture and execution. From elegant hotels to hellholes in the field, it's one risky operation after another.</p>",
    officialSite: "http://www.cbc.ca/xcompany/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 36,
      name: "CBC",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2015-02-18",
  },
  {
    id: 1609,
    url: "https://www.tvmaze.com/shows/1609/wicked-tuna",
    name: "Wicked Tuna",
    genres: ["Action", "Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/244/611003.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/244/611003.jpg",
    },
    summary:
      "<p><b>Wicked Tuna</b> follows a group of salty fishermen from the nation's oldest seaport, Gloucester, Massachusetts, as they make their living the way it's been done for centuries - rod and reel fishing, one catch at a time - all in pursuit of the bluefin tuna. One \"monstah\" bluefin can be worth more than $20,000, and with that kind of money on the line, every captain is fighting to be the best in the fleet.</p>",
    officialSite: "https://www.nationalgeographic.com/tv/shows/wicked-tuna",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-04-01",
  },
  {
    id: 1611,
    url: "https://www.tvmaze.com/shows/1611/spider-man",
    name: "Spider-Man",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21945.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21945.jpg",
    },
    summary:
      "<p><b>Spider-Man</b> (1994) tells the story of a 19-year-old Peter Parker in his first year at Empire State University, and his alter-ego Spider-Man. The show features Spider-Man's classic villains, including the Kingpin, the Green Goblin, the Lizard, the Scorpion, Doctor Octopus, Mysterio, the Rhino, the Shocker, The Vulture and the Chameleon, as well as more recent villains such as Venom, Carnage and the Hobgoblin.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1994-11-19",
  },
  {
    id: 1612,
    url: "https://www.tvmaze.com/shows/1612/x-men-evolution",
    name: "X-Men: Evolution",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/21946.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/21946.jpg",
    },
    summary:
      "<p>American-Canadian animated series about the X-Men. Contrary to the other X-men shows, the characters are teenagers instead of adults.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-11-04",
  },
  {
    id: 1613,
    url: "https://www.tvmaze.com/shows/1613/underemployed",
    name: "Underemployed",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/22134.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/22134.jpg",
    },
    summary:
      '<p>From Emmy-nominated producer Craig Wright ("Dirty Sexy Money," "Six Feet Under"), MTV\'s new scripted comedic drama "Underemployed" follows a group a five friends--Sophia, Daphne, Lou, Raviva and Miles--all filled with lofty goals, romantic dreams and hopefulness for complete world domination on their road to adulthood. But what happens when things don\'t go exactly according to plan?</p><p>"Underemployed" picks up one year after their college graduation when reality has set in and the group struggles, often comically, to stay optimistic through the major life changes young twentysomethings know all too well, including dead-end jobs, terrible bosses and romantic mistakes. This group of old friends becomes a new family as they go through all the highs and lows in their newfound adult lives and prove together that if life is about living, none of them are underemployed. The series, which is currently in production in Chicago, will feature 12 hour-long episodes and is slated to launch in fall 2012.</p><p>Sophia struggles to hold on to her dreams of becoming a writer, as she serves maple bacon bars at Donut Girl, while Daphne continues to toil as an unpaid and unnoticed intern at an advertising agency. Lou and Raviva ended their relationship when she left for Los Angeles to become a famous singer, leaving Lou on his quest to save the environment, but all that changes when she shows up on his doorstep nine-months pregnant. Meanwhile, Miles aspires to be a world famous model, the face of a major ad campaign, but instead finds himself serving mojitos and mini-tacos in his skivvies.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-10-16",
  },
  {
    id: 1614,
    url: "https://www.tvmaze.com/shows/1614/bureau-raampoort",
    name: "Bureau Raampoort",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/215/538281.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/215/538281.jpg",
    },
    summary:
      "<p>Bureau Raampoort is a Dutch dramaseries which is aired on SBS 6. The series premiered on December 3, 2014.</p>",
    officialSite: null,
    webChannel: null,
    language: "Dutch",
    status: "Ended",
    network: {
      id: 139,
      name: "SBS 6",
      country: {
        name: "Netherlands",
        code: "NL",
        timezone: "Europe/Amsterdam",
      },
    },
    premiered: "2014-12-03",
  },
  {
    id: 1615,
    url: "https://www.tvmaze.com/shows/1615/steven-universe",
    name: "Steven Universe",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/22200.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/22200.jpg",
    },
    summary:
      "<p><b>Steven Universe</b>, from Adventure Time writer-artist Rebecca Sugar, is a coming-of-age story told from the perspective of Steven, the youngest member of a team of magical Guardians of the Universe.</p>",
    officialSite:
      "http://www.cartoonnetwork.com/video/steven-universe/index.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-11-04",
  },
  {
    id: 1616,
    url: "https://www.tvmaze.com/shows/1616/wander-over-yonder",
    name: "Wander Over Yonder",
    genres: ["Comedy", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/22201.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/22201.jpg",
    },
    summary:
      "<p>Emmy-winning producer Craig McCracken, among the most sought-after talent in TV animation, is the creator/executive producer of Disney Channel's <b>Wander Over Yonder</b>, an animated comedy series about best friends and epic enemies, set in surreal places across the universe. Wander is an overly-optimistic intergalactic traveler who, along with his loyal but bullish steed, Sylvia, goes from planet to planet helping people to live free and have fun, all against the evil reign of Lord Hater and his army of Watchdogs.</p>",
    officialSite: "http://disneyxd.disney.com/wander-over-yonder",
    webChannel: {
      id: 83,
      name: "DisneyNOW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: {
      id: 25,
      name: "Disney XD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-08-16",
  },
  {
    id: 1617,
    url: "https://www.tvmaze.com/shows/1617/uncle-grandpa",
    name: "Uncle Grandpa",
    genres: ["Comedy", "Children", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/8/22202.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/8/22202.jpg",
    },
    summary:
      '<p><b>Uncle Grandpa</b>, from Pete Browngardt, is based upon an Emmy-nominated short and follows the exploits of everyone in the world\'s "magical" uncle and grandpa.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-02",
  },
  {
    id: 1618,
    url: "https://www.tvmaze.com/shows/1618/stone-quackers",
    name: "Stone Quackers",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31519.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31519.jpg",
    },
    summary:
      "<p><b>Stone Quackers</b> revolves around the misadventures of two ducks, Whit and Clay, along with their friends Barf and Dottie, plus the authority Officer Barry.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 47,
      name: "FXX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-31",
  },
  {
    id: 1619,
    url: "https://www.tvmaze.com/shows/1619/danger-5",
    name: "Danger 5",
    genres: ["Comedy", "Action", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/48/120736.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/48/120736.jpg",
    },
    summary:
      "<p>Set in a bizarre, 1960s inspired version of World War II, action comedy series <b>Danger 5</b> follows a team of five spies on a mission to kill Adolf Hitler.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 140,
      name: "SBS",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2012-02-27",
  },
  {
    id: 1620,
    url: "https://www.tvmaze.com/shows/1620/mozart-in-the-jungle",
    name: "Mozart in the Jungle",
    genres: ["Drama", "Comedy", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/138/345853.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/138/345853.jpg",
    },
    summary:
      "<p>Based on the critically acclaimed memoir Mozart in the Jungle: Sex, Drugs &amp; Classical Music by Blair Tindall, <b>Mozart in the Jungle</b> draws back the curtain at the New York Symphony, where artistic dedication and creativity collide with mind games, politicking and survival instincts.</p>",
    officialSite: "https://www.amazon.com/Mozart-Jungle-Season-1/dp/B00I3MNGCG",
    webChannel: { id: 3, name: "Amazon Prime Video", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2014-02-06",
  },
  {
    id: 1621,
    url: "https://www.tvmaze.com/shows/1621/cabin-fever",
    name: "Cabin Fever",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31669.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31669.jpg",
    },
    summary:
      "<p>Log cabins are the ultimate dream sanctuaries, and this team of skilled builders makes their clients' cabin fantasies a reality. Whether nestled at the base of a mountain or in a suburban backyard, these craftsmen create unique log homes sprung from their clients' imaginations.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-24",
  },
  {
    id: 1622,
    url: "https://www.tvmaze.com/shows/1622/my-citys-just-not-that-into-me",
    name: "My City's Just Not That Into Me",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755214.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755214.jpg",
    },
    summary:
      "<p><i>My City's Just Not That Into Me</i> explores an issue facing many home seekers today – loving their current city, but being priced out, and deciding on where to move to improve their quality of life.</p><p>Break-ups are hard. Leaving something you like because it's clearly not working out is a tough decision, whether that involves matters of the heart, or real estate. With the cost of home ownership out of reach for many, some people are deciding whether or not a major move promising an improvement in lifestyle is worth it.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 125,
      name: "FYI,",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-04",
  },
  {
    id: 1623,
    url: "https://www.tvmaze.com/shows/1623/strange-love",
    name: "Strange Love",
    genres: ["Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/60/152292.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/60/152292.jpg",
    },
    summary:
      "<p>It's been said that love is blind, love conquers all, and that above all else, love will find a way. In the TLC series <b>Strange Love</b> we follow the lives of the people who are living proof that there is someone for everyone — even if that someone is a bit out of the ordinary. We explore the romantic, shocking and sometimes provocative relationships of some of America's most surprising duos.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-04",
  },
  {
    id: 1624,
    url: "https://www.tvmaze.com/shows/1624/moment-of-truth",
    name: "Moment of Truth",
    genres: [],
    image: null,
    summary:
      "<p>Moment of Truth is a user-generated documentary series that invites viewers into the secret lives of ordinary Australians. Revelatory and confronting, Moment of Truth speaks to who we are as Australians and who we want to be.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 114,
      name: "ABC",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2016-07-18",
  },
  {
    id: 1625,
    url: "https://www.tvmaze.com/shows/1625/born-in-the-wild",
    name: "Born in the Wild",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31514.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31514.jpg",
    },
    summary:
      "<p>In this new series, families take one step beyond homebirth and make the powerful choice to experience childbirth in the great outdoors. No inductions, no epidurals... just expectant mothers facing and giving birth in the arms of Mother Nature. They'll take on the unique challenges of their natural environment, tackling every obstacle the wilderness can dish out in order to realize their dream of an outdoor birth.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-03",
  },
  {
    id: 1626,
    url: "https://www.tvmaze.com/shows/1626/aloha-vet",
    name: "Aloha Vet",
    genres: ["Nature", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755271.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755271.jpg",
    },
    summary:
      "<p>On the Hawaiian island of Kauai there is only one large animal vet who is also trained to work on endangered species and he is Dr. Scott Sims. With his assistants Dia and Ella, Dr. Scott traverses the islands of Hawaii in his plane as he is called to save animals both great and small.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 83,
      name: "National Geographic WILD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-21",
  },
  {
    id: 1627,
    url: "https://www.tvmaze.com/shows/1627/supercar-superbuild",
    name: "Supercar Superbuild",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22587.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22587.jpg",
    },
    summary:
      "<p><b>Supercar Superbuild</b> showcases the passion, artistry and engineering behind some of the fastest and most lust-worthy supercars in the world. Behind each story lies a dedicated team of passionate automotive artists that overcome tremendous obstacles as they dream big and think outside of the box in order to create the ultimate automotive fantasies for car fans across the globe.</p>",
    officialSite: "http://www.questtv.co.uk/?attachment_id=8956",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 368,
      name: "Quest",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-10-09",
  },
  {
    id: 1628,
    url: "https://www.tvmaze.com/shows/1628/min-krig",
    name: "Min Krig",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22611.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22611.jpg",
    },
    summary:
      "<p>DR3's new documentary ' My War ' shows the battlefield in Afghanistan from the soldiers perspective. The series about the Danish soldiers in Afghanistan is up close and shows the war captured by the soldiers' helmet cameras</p>",
    officialSite: null,
    webChannel: null,
    language: "Danish",
    status: "Ended",
    network: {
      id: 141,
      name: "DR3",
      country: { name: "Denmark", code: "DK", timezone: "Europe/Copenhagen" },
    },
    premiered: "2014-09-29",
  },
  {
    id: 1629,
    url: "https://www.tvmaze.com/shows/1629/u-boat-war",
    name: "U-Boat War",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22616.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22616.jpg",
    },
    summary:
      '<p>In World War II, lethal German U-Boats sailed all over the world wreaking havoc and destruction. This unique DVD charts the true, close-run fight that took place. With rare, original footage of actual battle scenes and interviews with U-Boat commanders and crew members from both the Allied and Axis naval forces, these three programs give the viewer an inside look at the destructive nature of these deadly "Iron Coffins".</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1997-07-01",
  },
  {
    id: 1630,
    url: "https://www.tvmaze.com/shows/1630/patrol-boat",
    name: "Patrol Boat",
    genres: ["Drama", "Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/37198.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/37198.jpg",
    },
    summary:
      "<p><b>Patrol Boat</b> was about the activities of the crew of a Royal Australian Navy patrol boat which patrolled Australia's coastline. The series was produced with the co-operation of the Royal Australian Navy.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 114,
      name: "ABC",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "1979-06-28",
  },
  {
    id: 1631,
    url: "https://www.tvmaze.com/shows/1631/kc-undercover",
    name: "K.C. Undercover",
    genres: ["Comedy", "Action", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/118/296024.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/118/296024.jpg",
    },
    summary:
      "<p><b>K.C. Undercover </b>is about K.C. who is 16, very outspoken and confident technology wiz and is a skilled black belt who discovers that both her parents are spies and they expect her to follow in their footsteps.</p>",
    officialSite: "https://www.disneychannel.disney.com/kc-undercover",
    webChannel: {
      id: 83,
      name: "DisneyNOW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-01-18",
  },
  {
    id: 1632,
    url: "https://www.tvmaze.com/shows/1632/horatio-hornblower",
    name: "Horatio Hornblower",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22757.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22757.jpg",
    },
    summary:
      "<p>The epic saga of legendary seafaring hero Horatio Hornblower comes to swashbuckling life in these epic films based on C.S. Forester's classic novels. As the Napoleonic wars rage, Hornblower survives battle after battle, evades capture, and works his way up the ranks in the king's royal navy. With danger at every turn and unending adventures, Hornblower must use every ounce of his wit and courage to prevail.</p>",
    officialSite: "https://itvstudios.com/programmes/hornblower",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1998-10-07",
  },
  {
    id: 1633,
    url: "https://www.tvmaze.com/shows/1633/overhaulin",
    name: "Overhaulin'",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755272.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755272.jpg",
    },
    summary:
      "<p>For more than 10 years Chip Foose and his <b>Overhaulin'</b> A-Team have been the industry's leading experts of for car fabrication. They've rendered, welded, sanded and painted their way into iconic car history. This November, Velocity debuts an all-new season featuring the crew's biggest milestone to date: 100 automotive builds, and a special reunion with a familiar face from the series' past, Adrienne Janic.</p>",
    officialSite: "http://www.velocity.com/tv-shows/overhaulin/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 142,
      name: "MotorTrend",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-04-20",
  },
  {
    id: 1634,
    url: "https://www.tvmaze.com/shows/1634/misfit-garage",
    name: "Misfit Garage",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22799.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22799.jpg",
    },
    summary:
      "<p>A spin-off of the hit series Fast N' Loud, the #1 car show on television, <b>Misfit Garage</b> features four mechanics who have all done business with Richard Rawling's Gas Monkey Garage and join forces to create their own hot rod shop to rival Gas Monkey. Will this band of misfits be able to turn their garage into a money-making machine, or will their mistakes sink their business before it gets off the ground?</p>",
    officialSite: "http://www.discovery.com/tv-shows/misfit-garage/",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-13",
  },
  {
    id: 1635,
    url: "https://www.tvmaze.com/shows/1635/graveyard-carz",
    name: "Graveyard Carz",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/239/598364.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/239/598364.jpg",
    },
    summary:
      '<p>The <b>Graveyard Carz</b> crew - Mark, Daren, Josh and Royal - take wrecked muscle cars and restore them to assembly-line condition. Led by Mark "The Warmachine" Worman, the crew works some serious magic to get these Mopar racing classics across the finish line every week. As a leading Chrysler muscle car specialist and body shop owner, Worman doesn\'t settle for anything less than perfect restorations. Neither does his team as there is too much beauty in a quality Detroit automobile to let them go to rust. Even if it is a Herculean effort, these cars will rise again.</p>',
    officialSite: "https://www.graveyardcarz.com",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 142,
      name: "MotorTrend",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-06-14",
  },
  {
    id: 1636,
    url: "https://www.tvmaze.com/shows/1636/fifth-gear",
    name: "Fifth Gear",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/166/415276.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/166/415276.jpg",
    },
    summary:
      "<p><b>Fifth Gear</b> returns as the British magazine show dedicated to uncovering the most exclusive information about cars' performance. Motor sports alumni themselves, hosts of the show take you under the hoods of the latest speedsters and conduct tests and stunts to see what a variety of cars-from exotic to everyday-are capable of.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 368,
      name: "Quest",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2002-04-08",
  },
  {
    id: 1637,
    url: "https://www.tvmaze.com/shows/1637/fat-n-furious-rolling-thunder",
    name: "Fat n' Furious: Rolling Thunder",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22803.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22803.jpg",
    },
    summary:
      "<p>The boys of Christmas automotive are back, with faster cars and bigger appetites. These large-and-in-charge car junkies of Christmas Automotive continue to boost business by hunting down left-for-dead cars and bringing them back to life. The series returns to Motor Mondays, which has been revving up ratings for the Discovery Channel, landing the coveted #1 cable network spot for Men 25-54 delivery in 4Q 2014 (October-December 2014)...beating all other cable networks (excluding sports). Owned and operated by Tommy Christmas, Christmas Automotive helps car owners with their need for speed. With business bigger than ever before, the gang is moving to a larger shop to keep up with demand. Tommy, along with his three best friends: Steve, Chuck and Andy, welcome a new generation of Christmas staff - Tommy's son and daughter, Jess and Nick, to rebuild these classic muscle cars and put the pedal to the metal on the track. Fixing up old cars is always challenging, but the faster the car, the fatter the pay check.</p>",
    officialSite: "http://www.discovery.com/tv-shows/fat-n-furious/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-06-23",
  },
  {
    id: 1638,
    url: "https://www.tvmaze.com/shows/1638/37-days",
    name: "37 Days",
    genres: ["Drama", "War", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22873.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22873.jpg",
    },
    summary:
      "<p>Covering the final weeks before the outbreak of war, <b>37 Days</b> follows the rapidly changing crisis through the eyes of the principal players, during a hot summer, from the assassination of Archduke Franz Ferdinand on 28 June 1914, to the declaration of war between Britain and Germany on 4 August.</p><p>The drama serial will overturn orthodox assumptions about the war's inevitability. Such a disaster did not happen by chance, and nor was it a foregone conclusion. It took considerable effort and terrific ingenuity, as well as staggering bad luck, to destroy a system that had kept the general peace in Europe for the 99 years that followed the Battle of Waterloo and the fall of Napoleon.</p><p>Writer Mark Hayhurst comes fresh from the success of Hitler on Trial for BBC Two, which starred Ed Stoppard and Ian Hart. He has previously written award-winning docu-dramas for major broadcasters, such as Robespierre and the French Revolution, Last Days of the Raj and The Somme and the Year London Blew Up.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p01pf7dx",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-03-06",
  },
  {
    id: 1639,
    url: "https://www.tvmaze.com/shows/1639/andrew-marrs-history-of-the-world",
    name: "Andrew Marr's History of the World",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/77/192541.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/77/192541.jpg",
    },
    summary:
      "<p>Andrew Marr sets off on an epic journey through the explosive events, changes, conflicts and triumphs that shaped 70,000 years of human history. From our earliest beginnings in Africa, Marr traces the story of our nomadic ancestors as they spread out around the world and settled down to become the first farmers and townspeople. With spectacular images, compelling characters and incisive narration, this is an epic journey through human history and the story of the world we live in today, featuring dramatic reconstruction, documentary filming around the world and cutting-edge computer graphics.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b03ty0wf",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-09-23",
  },
  {
    id: 1640,
    url: "https://www.tvmaze.com/shows/1640/apparitions",
    name: "Apparitions",
    genres: ["Drama", "Mystery", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/78/196574.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/78/196574.jpg",
    },
    summary:
      "<p><b>Apparitions</b> is a drama series starring Martin Shaw. The series is written by Joe Ahearne. Father Jacob is a Jesuit priest working for the Congregation for the Causes of Saints. He investigates strange occurrences.</p>",
    officialSite: "https://www.bbc.co.uk/programmes/b00fjgdg",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-11-13",
  },
  {
    id: 1641,
    url: "https://www.tvmaze.com/shows/1641/black-books",
    name: "Black Books",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/81/204617.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/81/204617.jpg",
    },
    summary:
      "<p><b>Black Books</b> is a second-hand bookshop in London run by an Irishman named Bernard Black. He is probably the planet's worst-suited person to run such an establishment: he makes no effort to sell, closes at strange hours on a whim, is in a perpetual alcoholic stupor, abhors his customers (sometimes physically abusing them) and is often comatose at his desk. Help comes in the lumpy shape of Manny Bianco, a hairy, bumbling individual who (almost by osmosis) becomes Bernard's assistant. Manny is not exactly great at the job either but he is a million times better than Bernard. Next door is Fran, an anxious, frustrated woman who runs a sort of new-age shop selling the most unlikely bits of arty junk. Fran is friends with Bernard and, through him, with Manny; together the trio become embroiled in escapades that are sometimes extreme or violent or fantastically ludicrous, and always bizarre.</p>",
    officialSite: "http://www.channel4.com/programmes/black-books",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2000-09-29",
  },
  {
    id: 1642,
    url: "https://www.tvmaze.com/shows/1642/brazil-red",
    name: "Brazil Red",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/82/206489.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/82/206489.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "Portuguese",
    status: "Ended",
    network: {
      id: 102,
      name: "RTP1",
      country: { name: "Portugal", code: "PT", timezone: "Europe/Lisbon" },
    },
    premiered: "2013-03-03",
  },
  {
    id: 1643,
    url: "https://www.tvmaze.com/shows/1643/clone-high",
    name: "Clone High",
    genres: ["Comedy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22881.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22881.jpg",
    },
    summary:
      "<p>A secret government plan to dig up historical figures and clone them has worked. It is 16 years later, and the clones are now in high school. The five main characters are Abe Lincoln, an all around nice but naive guy who lusts after the school sexpot Cleopatra, who is dating the macho JFK. Also, Abe's two best friends are Joan of Arc, an angst ridden goth girl who is in love with him, and Gandhi, a non-stop party animal. Clone High bravely tackles challenging teen issues, such as sleep deprivation, catching ADD from toilet seats, the evils of litter, and having the guy you like not like you back the same way you like him. Will Abe get together with Cleo, or be thwarted by the handsome JFK? Will Joan finally get Abe to notice her? Who's to say?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-11-02",
  },
  {
    id: 1644,
    url: "https://www.tvmaze.com/shows/1644/code-name-eternity",
    name: "Code Name: Eternity",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22882.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22882.jpg",
    },
    summary:
      "<p>An alien lands on Earth, its mission is to find one of its own kind who is attempting to turn Earth into a planet where he and his race can live and breath without having to make themselves look human. The fact that this will kill all life on Earth doesn't really matter to him. Can Ethaniel and his human friend, Laura, find others who will, and can help them prevent this from happening?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-05-14",
  },
  {
    id: 1645,
    url: "https://www.tvmaze.com/shows/1645/comedians-in-cars-getting-coffee",
    name: "Comedians in Cars Getting Coffee",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/203/509996.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/203/509996.jpg",
    },
    summary:
      "<p>In <b>Comedians in Cars Getting Coffee</b>, comedian Jerry Seinfeld takes his comedy pals out for coffee in a selection of his classic automobiles. Larry David sums it up best when he says, 'You've finally made a show about nothing.</p>",
    officialSite: "https://www.netflix.com/title/80171362",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2012-07-19",
  },
  {
    id: 1646,
    url: "https://www.tvmaze.com/shows/1646/crossbow",
    name: "Crossbow",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22884.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22884.jpg",
    },
    summary:
      "<p><b>Crossbow</b> follows the adventures of William Tell (Will Lyman) and takes place in the 14th-century in Switzerland. William Tell and his son Matthew are imprisoned by the tyrannical Gessler (Jeremy Clyde). As Governor of Austria, Gessler plans to stop the Swiss uprising. Having split the apple on his son's head with his crossbow, much to Gessler's chagrin, there is no stopping William Tell's legendary strength and skill.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1987-08-30",
  },
  {
    id: 1647,
    url: "https://www.tvmaze.com/shows/1647/os-filhos-do-rock",
    name: "Os Filhos do Rock",
    genres: ["Drama", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22885.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22885.jpg",
    },
    summary:
      '<p>Oh... The 80\'s. From the unforgivable haircuts and \'Passeio dos Alegres\'. AIDS and Bairro Alto. From UHF, Xutos, GNR, Heróis do Mar and Rui Veloso. And "Os Barões", worth to mention. Every revolution needs a spokesperson. For the Portuguese Rock, Xavier Bastos takes that role. Friend of Jorge Palma and connoisseur of music and musicians, he makes of his radio show "Dias do Rock" the epicenter of the sounding earthquake that shakens the portuguese radio. Another trio that will make history starts at the same. João Pedro, Zé Paulo and Garrafa are pure rockers and their talent starts to be recognised by everyone. By Xavier, the rock radio host who offers them a contract; by Pedro, the worthless businessman who gets ahead and steals them for his label; by their friends, girlfriends, even by their families. By the world of music and the public.</p>',
    officialSite: null,
    webChannel: null,
    language: "Portuguese",
    status: "Ended",
    network: {
      id: 102,
      name: "RTP1",
      country: { name: "Portugal", code: "PT", timezone: "Europe/Lisbon" },
    },
    premiered: "2013-12-08",
  },
  {
    id: 1648,
    url: "https://www.tvmaze.com/shows/1648/fallen",
    name: "Fallen",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22886.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22886.jpg",
    },
    summary:
      "<p>Aaron Corbett is the son of a fallen Angel. Aaron is part human and part Angel, which makes him a nephilim. Aaron doesn't know that he's a nephilim till his 18th birthday. Finding out his new destiny. He will have to help the fallen angels before him.<br></p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-08-04",
  },
  {
    id: 1649,
    url: "https://www.tvmaze.com/shows/1649/first-wave",
    name: "First Wave",
    genres: ["Drama", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22887.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22887.jpg",
    },
    summary:
      "<p>In 1564 Nostradamus predicted the destruction of Earth in 3 terrifying waves. . . The <b>First Wave</b> is here! Cade Foster thought he had seen everything; then he learned of the secrets hidden within the quatrains of the ancient prophet Nostradamus, predictions of an alien invasion that would come in three waves and conquer the human race. The invaders would be known as the Gua, and their conquest was foretold... Or was it? Cade, together with his allies Eddie, Joshua, Jordan, and the Resistance, wage an underground battle to protect Earth's future from the First Wave of the Gua invasion, and to seek out clues hidden in the ancient prophecies, clues that might mean the difference between survival and extinction for all humanity. Can disaster be averted? Can the future be rewritten? Can the Gua be stopped? For Cade Foster, surrender is not an option.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-09-09",
  },
  {
    id: 1650,
    url: "https://www.tvmaze.com/shows/1650/fresh-meat",
    name: "Fresh Meat",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22888.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22888.jpg",
    },
    summary:
      "<p>A comedy drama series about the hilarious and painful truths of being a student. The latest creation from Sam Bain and Jesse Armstrong, Fresh Meat follows a group of six students about to embark on the most exciting period of their lives so far - university.</p>",
    officialSite: "http://www.channel4.com/programmes/fresh-meat",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-09-21",
  },
  {
    id: 1651,
    url: "https://www.tvmaze.com/shows/1651/god-the-devil-and-bob",
    name: "God, The Devil and Bob",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/277/693163.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/277/693163.jpg",
    },
    summary:
      "<p>God is disappointed in the world today. So many people are doing wrong, not using good judgment, and God is getting sick of it. God is just thinking of giving it all up. That is, unless he can find one person that can prove the world is worth saving, then he won't destroy it. God decides to let the Devil choose who that person should be. The Devil picks Bob Alman, an autoworker who has a bit of an attitude, and is also pretty lazy. Out of fear, Bob agrees to help make the world a better place. Without any hints or suggestions from God, Bob is all on his own to prove that humanity deserves to be saved.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-03-09",
  },
  {
    id: 1652,
    url: "https://www.tvmaze.com/shows/1652/great-expectations",
    name: "Great Expectations",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22890.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22890.jpg",
    },
    summary:
      "<p>Lavish adaptation of the classic Charles Dickens novel in which orphan Pip becomes a gentleman when his life is transformed by a mystery benefactor.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b018wmhr",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-12-27",
  },
  {
    id: 1653,
    url: "https://www.tvmaze.com/shows/1653/highlander-the-animated-series",
    name: "Highlander: The Animated Series",
    genres: ["Action", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22895.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22895.jpg",
    },
    summary:
      "<p>Seven centuries have passed since the Earth plunged into darkness, seven centuries since the Jettator swore to regain from man his lost knowledge and freedom, all the Immortals took the oath, all except one. Who dominates the world, but soon an Immortal will come to confront him, his name is Quentin MacLeod, he is the Highlander. This animated series followed the adventures of Quentin MacLeod, the Last of the MacLeods. Set in a post apocalyptic world almost barren of technology and civilization. The Jettator's or Immmortals oath was to lay down their swords and when Kortan decided not to swear the oath so began the wait for the Highlander. It was contended by this series, which was made before Highlander Endgame that Kortan took Conner MacLeod's quickening.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1994-10-16",
  },
  {
    id: 1654,
    url: "https://www.tvmaze.com/shows/1654/human-planet",
    name: "Human Planet",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22896.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22896.jpg",
    },
    summary:
      "<p>Following in the footsteps of Planet Earth and Life, this epic eight-part blockbuster is a breathtaking celebration of the amazing, complex, profound and sometimes challenging relationship between humankind and nature. Humans are the ultimate animals – the most successful species on the planet. From the frozen Arctic to steamy rainforests, from tiny islands in vast oceans to parched deserts, people have found remarkable ways to adapt and survive in the harshest environments imaginable. We've done this by harnessing our immense courage and ingenuity; learning to live with and utilise the other creatures that share these wild places. Human Planet weaves together eighty inspiring stories, many never told before on television, set to a globally influenced soundtrack by award-winning composer Nitin Sawhney.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00llpvp",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-01-13",
  },
  {
    id: 1655,
    url: "https://www.tvmaze.com/shows/1655/inside-men",
    name: "Inside Men",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22897.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22897.jpg",
    },
    summary:
      "<p>Inside Men is a drama series which sees John Coniston working as the manager of a cash counting house who finds himself involved in the middle of an armed robbery. His family are taken hostage and the gang make him open the safe at gunpoint but not everything is as it seems</p>",
    officialSite: "https://www.bbc.co.uk/programmes/b01bpkjl",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-02-02",
  },
  {
    id: 1656,
    url: "https://www.tvmaze.com/shows/1656/lexx",
    name: "Lexx",
    genres: ["Drama", "Horror", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22933.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22933.jpg",
    },
    summary:
      "<p>Hailed as \"the most imaginative Sci-Fi since <i>The Hitchhiker's Guide to the Galaxy</i>\" (New York Daily News), <b>Lexx</b> follows the nomadic existence of four misfit characters who have inadvertently stolen the most powerful weapon of destruction ever made: a Manhattan-sized, genetically-modified insect-ship. In its debut season, the Lexx's quirky crew-former security guard, Captain Stanley Tweedle; the luscious love slave Zev; the dead-but-deadly assassin Kai; and the robot head 790.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 7,
      name: "CTV Sci-Fi Channel",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "1997-04-18",
  },
  {
    id: 1657,
    url: "https://www.tvmaze.com/shows/1657/mankind-the-story-of-all-of-us",
    name: "Mankind: The Story of All of Us",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22939.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22939.jpg",
    },
    summary:
      "<p>The amazing journey of our species reaches the present day. The end of the Civil War marks the beginning of the age of innovation. Japan becomes a superpower, and the demand for rubber devastates Africa. Mankind enters the Atomic Age, while continuing to grow and evolve.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-11-13",
  },
  {
    id: 1658,
    url: "https://www.tvmaze.com/shows/1658/mortal-kombat-conquest",
    name: "Mortal Kombat: Conquest",
    genres: ["Action", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755273.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755273.jpg",
    },
    summary:
      "<p>In each of us, there burns a soul of a warrior. In every generation, a few are chosen to prove it. Centuries ago, in a time of darkness and fury, that fate befell three strangers. A monk, Kung Lao, an exiled guard, Siro, and a thief, Taja, who have to defend our Earth Realm from the forces of Outworld. By fighting for their lives, by fighting for their honour and by fighting for their realm in a tournament called Mortal Kombat.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-10-03",
  },
  {
    id: 1659,
    url: "https://www.tvmaze.com/shows/1659/my-hero",
    name: "My Hero",
    genres: ["Comedy", "Fantasy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22942.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22942.jpg",
    },
    summary:
      "<p>The series adopted the well-mined 'alien adapting to life on Earth' device featured in American comedies such as <i>3rd Rock from the Sun</i>, <i>The Coneheads</i> and <i>Mork and Mindy</i>. Thermoman's alter ego is George Sunday, the proprietor of a health food shop. In spite of his numerous superhero powers, George is a lovable buffoon whose ignorance of human life leads to frequent misunderstandings with (mildly) amusing consequences.</p>",
    officialSite: "http://www.bbc.co.uk/comedy/myhero/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2000-02-04",
  },
  {
    id: 1660,
    url: "https://www.tvmaze.com/shows/1660/off-centre",
    name: "Off Centre",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22944.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22944.jpg",
    },
    summary:
      "<p>An American and a Brit are sharing an apartment in New York City and trying to pick uip supermodels.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-10-14",
  },
  {
    id: 1661,
    url: "https://www.tvmaze.com/shows/1661/the-pjs",
    name: "The PJs",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22950.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22950.jpg",
    },
    summary:
      "<p>Follow the adventures of Thurgood Stubbs (Eddie Murphy) and the other tenants of the Hilton Jacobs housing project as they find themselves in and out of trouble.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-01-10",
  },
  {
    id: 1662,
    url: "https://www.tvmaze.com/shows/1662/reboot",
    name: "ReBoot",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22952.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22952.jpg",
    },
    summary:
      "<p>In the inner computer world of Mainframe, a guardian program sprite and his friends defend the system from threats from viruses and the User.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 144,
      name: "YTV",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "1994-09-10",
  },
  {
    id: 1663,
    url: "https://www.tvmaze.com/shows/1663/robin-of-sherwood",
    name: "Robin of Sherwood",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22953.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22953.jpg",
    },
    summary:
      "<p>This acclaimed British series adds a bit of sorcery and mysticism to the swordplay and social justice that make the Robin Hood legend so enduring. Heading up the superb ensemble cast are Michael Praed (<i>Dynasty</i>) as Robin of Loxley, Ray Winstone (<i>Beowulf</i>) as seething-mad Scarlet, and Nickolas Grace (<i>Brideshead Revisited</i>) as the greedy, conniving Sheriff of Nottingham. In the final 13 episodes, Robert of Huntingdon (Jason Connery, <i>Shanghai Noon</i>) assumes Robin's mantle. Shot entirely on location in England, the series also features an award-winning score by the Irish band Clannad.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1984-04-28",
  },
  {
    id: 1664,
    url: "https://www.tvmaze.com/shows/1664/s-club-7",
    name: "S Club 7",
    genres: ["Drama", "Comedy", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22956.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22956.jpg",
    },
    summary:
      "<p>A comedy series starring the popular british group <b>S Club 7</b> and their adventures within the music business.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1999-04-08",
  },
  {
    id: 1665,
    url: "https://www.tvmaze.com/shows/1665/the-shadow-line",
    name: "The Shadow Line",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22957.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22957.jpg",
    },
    summary:
      "<p>Series about a murder investigated by both sides of the line, cops and criminals, and the opposing methods they use to solve it.</p>",
    officialSite: "https://www.bbc.co.uk/programmes/b0111dqc",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-05-05",
  },
  {
    id: 1666,
    url: "https://www.tvmaze.com/shows/1666/thats-my-bush",
    name: "That's My Bush!",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22969.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22969.jpg",
    },
    summary:
      "<p><b>That's My Bush!</b>, the live-action series from South Park creators Matt Stone and Trey Parker, offers a glimpse of life at 1600 Pennsylvania Avenue as George W. makes his debut in his very own prime time television show. The challenge to the country's newest President is in balancing the volatile issues of the day with his equally demanding personal life in this parody of the classic sitcom genre.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-04-04",
  },
  {
    id: 1667,
    url: "https://www.tvmaze.com/shows/1667/the-thick-of-it",
    name: "The Thick of It",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22970.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22970.jpg",
    },
    summary:
      "<p>Join the farce that is the department of Social afairs and Citizenship as it farcically stumbles its way through the corridors of power.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006qgrd",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 51,
      name: "BBC Four",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2005-05-19",
  },
  {
    id: 1668,
    url: "https://www.tvmaze.com/shows/1668/the-tick",
    name: "The Tick",
    genres: ["Comedy", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22972.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22972.jpg",
    },
    summary:
      "<p>In a world where criminals rule the streets, evil has finally met its match. There is a new protector of the weak and oppressed, the hilarious blue defender of goodness, known as The Tick! Together with his sidekick Arthur and their friends - the insatiable Batmanuel, and the alluring Captain Liberty - these heroes will prove they are more than just big, dumb guys in silly-looking suits. So let this be a warning to naughty people everywhere, for you have met The Tick!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-11-08",
  },
  {
    id: 1669,
    url: "https://www.tvmaze.com/shows/1669/the-tick",
    name: "The Tick",
    genres: ["Comedy", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22977.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22977.jpg",
    },
    summary:
      "<p>Attention evil-doers! <b>The Tick</b> is here, and he's wearing the blue tights of justice! Together with his trusty moth-costumed sidekick Arthur, The Tick keeps the streets of The City safe from a rogue's gallery of hilariously malevolent villains. So grab a snack, put your feet up, and get ready to laugh and cheer as everyone's favorite brawny hero swats evil on the snout with the rolled-up newspaper of goodness!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1994-09-10",
  },
  {
    id: 1670,
    url: "https://www.tvmaze.com/shows/1670/treasure-island",
    name: "Treasure Island",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/22979.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/22979.jpg",
    },
    summary:
      "<p>Set in the dangerous world of buccaneers, this adaptation of the much-loved Robert Louis Stevenson classic <b>Treasure Island</b> will take viewers on a high octane adventure following the story of Jim Hawkins as he discovers Flint's treasure map. The two part drama follows the story of Jim Hawkins who's unexpectedly drawn into the world of piracy when he discovers Flint's treasure map. However, Long John Silver will stop at nothing to get hold of the gold for himself. As they set sail for Treasure Island, Jim embarks on an action adventure that will change his life forever.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 63,
      name: "Sky 1",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-01-01",
  },
  {
    id: 1671,
    url: "https://www.tvmaze.com/shows/1671/virtuality",
    name: "Virtuality",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/45/112501.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/45/112501.jpg",
    },
    summary:
      "<p>The crew of the Phaeton is approaching the go/no-go point of their epic 10-year journey through outer space. With the fate of Earth in their hands, the pressure is intense. The best bet for helping the crew members maintain their sanity is the cutting-edge virtual reality technology installed on the ship. It's the perfect stress-reliever until they realize a glitch in the system has unleashed a virus on to the ship. Tensions mount as the crew decides how to contain the virus and complete their mission. Meanwhile, their lives are being taped for a reality show back on Earth.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-06-26",
  },
  {
    id: 1672,
    url: "https://www.tvmaze.com/shows/1672/watchmen-the-motion-comic",
    name: "Watchmen: The Motion Comic",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23000.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23000.jpg",
    },
    summary:
      "<p>An outlaw superhero's investigation of a possible conspiracy against his colleagues changes all their lives even as evidence builds toward a horrific conclusion.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-07-17",
  },
  {
    id: 1673,
    url: "https://www.tvmaze.com/shows/1673/suikoden",
    name: "Suikoden",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/247/619177.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/247/619177.jpg",
    },
    summary:
      '<p>The ancient sages said, "do not despise the snake for having no horns, for who is to say it will not become a dragon?". So may one just man become an army. Nearly a thousand years ago in ancient China, at the time of the Sung dynasty, there was a cruel and corrupt government. These men riding are outlaws - heroes - who have been driven to live in the Water Margins of Liang Shan Po, far to the south of the capital city. Each fights tyranny with a price on his head, in a world very different from our own. The story starts in legend even then - for our heroes, it was said, were perhaps the souls reborn of other, earlier knights...</p>',
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 137,
      name: "NTV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1973-10-02",
  },
  {
    id: 1674,
    url: "https://www.tvmaze.com/shows/1674/odisseia",
    name: "Odisseia",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23083.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23083.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "Portuguese",
    status: "Ended",
    network: {
      id: 102,
      name: "RTP1",
      country: { name: "Portugal", code: "PT", timezone: "Europe/Lisbon" },
    },
    premiered: "2013-01-20",
  },
  {
    id: 1676,
    url: "https://www.tvmaze.com/shows/1676/dragon-ball-kai",
    name: "Dragon Ball Kai",
    genres: ["Action", "Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23106.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23106.jpg",
    },
    summary:
      "<p>A remastered version of Dragon Ball Z that adheres more to the manga's story. This version includes newly recorded dialog by the original voice actors, new sound effects, new OP/ED sequences, and a brand new HD video transfer.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 131,
      name: "Fuji TV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2009-04-05",
  },
  {
    id: 1678,
    url: "https://www.tvmaze.com/shows/1678/poldark",
    name: "Poldark",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/144/360117.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/144/360117.jpg",
    },
    summary:
      "<p>Britain is in the grip of a chilling recession... falling wages, rising prices, civil unrest - only the bankers are smiling. It's 1783 and Ross Poldark returns from the American War of Independence to his beloved Cornwall to find his world in ruins: his father dead, the family mine long since closed, his house wrecked and his sweetheart pledged to marry his cousin. But Ross finds that hope and love can be found when you are least expecting it in the wild but beautiful Cornish landscape.</p>",
    officialSite: "https://www.bbc.co.uk/programmes/b07pn8mz",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-03-08",
  },
  {
    id: 1679,
    url: "https://www.tvmaze.com/shows/1679/the-slim-shady-show",
    name: "The Slim Shady Show",
    genres: ["Comedy", "Adult"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/60/152373.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/60/152373.jpg",
    },
    summary:
      "<p><b>The Slim Shady Show</b> was a series of animated cartoons that were first broadcast on the on the Internet and later released on DVD. Each episode was approximately 5 minutes in length. They focused on the fictional adventures of Eminem's alter-egos Slim Shady, Marshall Mathers and Ken Kaniff. The series was directed by Mark Brooks and Peter Gilstrap. Most of the characters were voiced by Eminem himself, with contributions by the directors and others such as Paul Rosenberg and Xzibit. Due to the show's explicit nature, it received a OFLC classification of R18+.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 145,
      name: "MTV2",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-09-16",
  },
  {
    id: 1680,
    url: "https://www.tvmaze.com/shows/1680/beauty-and-the-geek",
    name: "Beauty and the Geek",
    genres: ["Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23613.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23613.jpg",
    },
    summary:
      "<p>The CW hit reality show, <b>Beauty and the Geek</b> returns with an outrageously fun fourth season where the new contestants are thrown a curveball that is as shocking as it is hilarious. The contestants expected business as usual -- gorgeous but academically impaired women pairing with brilliant but socially challenged men to test intellect and social skills for a chance to win the $250,000 grand prize. But in their first days, they learn that they'll have to compete against one pair that's the opposite - a hot guy and a geeky girl - which immediately throws the rest of the house into turmoil. How will the geeks take to a jock in their midst? Will the beauties try to give a makeover to the geeky girl? Among the new challenges, the geeks will perform an autobiographical rap in a nightclub and participate in the ultimate social test: the competition for Prom King. The beauties will delve into today's hot topics for the first-ever American Beauty Debate and go back to basics when they find themselves serving as a substitute teacher for a third-grade class. Each of the previous seasons resulted in an unlikely romantic connection between a beauty and a geek. But what happens when one hot guy and one geeky girl get in on the action? During each competition, the geek tries to pass brains on to the beauty, while the beauty helps the geek overcome social awkwardness. At the end of the 13-week series, each contestant comes out a changed person, and one couple will walk away with a quarter of a million dollars.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-06-01",
  },
  {
    id: 1681,
    url: "https://www.tvmaze.com/shows/1681/the-elegant-universe",
    name: "The Elegant Universe",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23614.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23614.jpg",
    },
    summary:
      '<p>Brian Greene, a Columbia University physics professor and best-selling author of <i><b>"The Elegant Universe"</b></i>, hosts this fascinating exploration of string theory, beginning with an overview of general physics concepts. Greene then moves on to a straightforward and visually stimulating explanation of the more recent string theory that unites relativity and quantum mechanics.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 85,
      name: "PBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-10-28",
  },
  {
    id: 1682,
    url: "https://www.tvmaze.com/shows/1682/fm",
    name: "FM",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23615.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23615.jpg",
    },
    summary:
      "<p>ITV2 sitcom focusing on a group of fame-hungry friends who run a daily indie-inspired radio show.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 54,
      name: "ITV2",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-02-25",
  },
  {
    id: 1683,
    url: "https://www.tvmaze.com/shows/1683/friday-night-with-jonathan-ross",
    name: "Friday Night with Jonathan Ross",
    genres: ["Comedy", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23617.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23617.jpg",
    },
    summary:
      "<p>Jonathan Ross presents an entertaining show featuring comedy, celebrity chat and the latest music.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006m99d",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2001-11-02",
  },
  {
    id: 1684,
    url: "https://www.tvmaze.com/shows/1684/how-to-be-a-gentleman",
    name: "How to Be a Gentleman",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23618.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23618.jpg",
    },
    summary:
      "<p><b>How to Be a Gentleman</b>, inspired by the book of the same name, is a comedy about the unlikely friendship between a traditional, refined writer and an unrefined personal trainer. Andrew Carlson is an etiquette columnist whose devotion to ideals from a more civilized time has lead to a life detached from modern society. Infectiously optimistic, Bert Lansing is a reformed \"bad boy\" from Andrew's past who inherited a fitness center, but can still be rude, loud and sloppy. When Andrew's editor, Jerry, tells him to put a modern, sexy twist on his column or be fired, he hires Bert as a life coach in the hopes of learning to be less \"gentle man\" and more \"real man.\" Andrew's mom, Diane and his bossy sister, Janet, support the plan, as would Janet's husband, Mike, if he was allowed to have an opinion. Though Andrew and Bert's views may be centuries apart, they may find they're each other's missing link.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-29",
  },
  {
    id: 1685,
    url: "https://www.tvmaze.com/shows/1685/the-jonathan-ross-show",
    name: "The Jonathan Ross Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/320/801209.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/320/801209.jpg",
    },
    summary:
      "<p>Jonathan Ross, the king of chat, is back. Employing his infectious wit and sense of fun, he chats to some terrific celebrity guests and asks the questions to which everyone wants to know the answers.</p>",
    officialSite: "http://www.itv.com/thejonathanrossshow",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-09-03",
  },
  {
    id: 1686,
    url: "https://www.tvmaze.com/shows/1686/trust-me",
    name: "Trust Me",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23620.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23620.jpg",
    },
    summary:
      "<p>Set against the backdrop of the high-pressure world of advertising, <b>Trust Me</b> focuses on Mason and Conner, a pair of ad men whose strong creative partnership has served the firm of Rothman Greene &amp; Mohr extremely well over the years. Mason is an art director and a responsible, workaholic family man with a beautiful wife Erin, two children and an undying loyalty to the brands he helps sell. By contrast, his writing partner Conner is a single, impulsive copywriter with the attention span of a teenager. Their yin-yang relationship is put to the test when Mason is named a creative director of the agency, making him Conner's boss. The series follows the changing dynamics between the two friends, who are better together than they are apart. Also working in the same creative group is new hire Sarah Krajicek-Hunter, an award-winning copywriter whose forceful personality has a tendency to rub people the wrong way. Hector and Tom are a junior creative team with nontraditional ideas that don't always sit well with their new boss. The entire team is supervised by Tony Mink, a man who lives and dies by the advertising business but has a growing sense his days in this young person's business may be numbered. Trust Me follows these memorable characters as they try to navigate the waters of inter-office politics, personality conflicts, easily bruised egos, professional jealousies and unreasonable client demands.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-01-26",
  },
  {
    id: 1687,
    url: "https://www.tvmaze.com/shows/1687/sex-death-and-the-meaning-of-life",
    name: "Sex, Death and the Meaning of Life",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23626.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23626.jpg",
    },
    summary:
      "<p>Ideas about the soul and the afterlife, of sin and God's purpose have shaped human thinking for thousands of years. Religious rituals remain embedded in the major events of our lives. <br /><br /> In this thought-provoking series, evolutionary biologist Richard Dawkins asks what happens if we leave religion behind. He explores what reason and science might offer to inspire and guide our lives in religion's place. Can science bring understanding in the face of death, help us tell right from wrong, or reveal the meaning of life?</p>",
    officialSite:
      "https://web.archive.org/web/20161204085835/http://www.channel4.com/programmes/sex-death-and-the-meaning-of-life",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-10-12",
  },
  {
    id: 1688,
    url: "https://www.tvmaze.com/shows/1688/scoundrels",
    name: "Scoundrels",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23627.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23627.jpg",
    },
    summary:
      "<p><b>Scoundrels</b> is a one-hour comedy/drama series produced by ABC Studios that focuses on a family of small-time criminals who try to go straight after the father is sent to prison. Cheryl West is the mother who must take charge and try to keep her kids on the straight and narrow.</p>",
    officialSite: "http://www.abc.go.com/shows/scoundrels",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-06-20",
  },
  {
    id: 1689,
    url: "https://www.tvmaze.com/shows/1689/ramsays-kitchen-nightmares",
    name: "Ramsay's Kitchen Nightmares",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23635.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23635.jpg",
    },
    summary:
      "<p>There's no shortage of abrasive straight talk and no-nonsense critique as superstar chef Gordon Ramsay visits troubled restaurants across the United States and the UK. Gordon offers his expert advice and gives each restaurant one week to get their act together and turn their business around.</p>",
    officialSite:
      "http://www.channel4.com/programmes/ramsays-kitchen-nightmares",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2004-04-27",
  },
  {
    id: 1690,
    url: "https://www.tvmaze.com/shows/1690/players",
    name: "Players",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/287/719675.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/287/719675.jpg",
    },
    summary:
      "<p><b>Players</b> follows two brothers (Walsh and Ian Roberts) with conflicting personalities trying to run a successful sports bar. Spike TV's new original half-hour comedy premieres Tuesday, March 2 at 10:30 PM, ET/PT. \"Players\" stars Walsh as Bruce Fitzgerald, a free-spirited, fun-loving, guy's guy who is living out his fantasy of owning a sports bar that allows him to bet on games, drink for free and date the cocktail waitresses. His older, uptight brother, Ken (Ian Roberts), tries to keep the focus on turning a profit while avoiding lawsuits and health code violations. The series also features Krista (Danielle Schneider), the promiscuous waitress who has an affinity for B-list athletes and married men, Barb (June Diane Raphael), the insecure and neurotic waitress who falls in love with Bruce, Hickey (Jack McGee), a retired cop who got Bruce out of a gambling debt and was rewarded with a job where, instead of actually working, he spends most of his time bidding on sports memorabilia on eBay, and Calvin (James Pumphrey), the young, simple-minded bartender who lives in the store room and is an aspiring sports model who idolizes Bruce.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 34,
      name: "Paramount Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-03-02",
  },
  {
    id: 1691,
    url: "https://www.tvmaze.com/shows/1691/the-listener",
    name: "The Listener",
    genres: ["Drama", "Crime", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23690.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23690.jpg",
    },
    summary:
      "<p>In this one-hour drama, Toby Logan is a 24-year-old paramedic living with a secret: he can read people's minds. This telepathic procedural takes viewers into the heart of a tortured hero who struggles to solve crimes with his unique gift. Week-to-week, <b>The Listener</b> balances high-stakes drama with irreverent humor and sends Toby on an intellectual and emotional adventure.</p>",
    officialSite: "http://www.ctv.ca/TheListener",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 48,
      name: "CTV",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2009-06-03",
  },
  {
    id: 1692,
    url: "https://www.tvmaze.com/shows/1692/lone-star",
    name: "Lone Star",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23701.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23701.jpg",
    },
    summary:
      "<p>A charismatic, brilliant schemer leads two different lives in two different parts of Texas. In Houston, he goes by Bob Allen and is married to Cat, part of a wealthy oil family. More than 400 miles away, in Midland, he's known as Robert and lives with naive girlfriend Lindsay. Bob's motive is to become part of the oil family with the goal of eventually cleaning it out. But when he fears his secret lives may unravel, Bob puts everything on the line in an attempt to keep his two separate relationships afloat.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-20",
  },
  {
    id: 1693,
    url: "https://www.tvmaze.com/shows/1693/masters-of-money",
    name: "Masters of Money",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23709.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23709.jpg",
    },
    summary:
      "<p>BBC economics editor Stephanie Flanders examines how three extraordinary thinkers, Keynes, Hayek and Marx, helped shape the 20th century.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b01mzqw9",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-09-17",
  },
  {
    id: 1694,
    url: "https://www.tvmaze.com/shows/1694/men-of-a-certain-age",
    name: "Men of a Certain Age",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23711.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23711.jpg",
    },
    summary:
      "<p><b>Men of a Certain Age</b> explores the unique bonds of male friendship among three men experiencing the changes and challenges of mid-life. They have been best friends since college but now, in their 40s, are navigating through the second act of their lives. Joe is a friendly, slightly neurotic, recently separated father of two who had dreams of being a professional golfer. Now he owns and runs a party store. Terry is a laid-back, handsome actor who seems to breeze through life (and women). Lately, he's spending more time working as a temp than as an actor and Owen is an overstressed husband and father of three who endures constant criticism from his father, for whom he works as a car salesman.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-12-07",
  },
  {
    id: 1695,
    url: "https://www.tvmaze.com/shows/1695/cuentame-como-paso",
    name: "Cuéntame como pasó",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23740.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23740.jpg",
    },
    summary:
      '<p><i><b>Cuéntame cómo pasó</b></i> (English: Tell me how it happened), also known as <i><b>Cuéntame</b></i>, is a Spanish television series which has been broadcast by the Spanish public TV channel TVE1 since 2001. Its original name (<i>Tell me</i>) had to be changed for copyright reasons.</p><p>The series recounts the experiences of a middle-class family, the Alcántaras (in Spanish <i>Los Alcántara</i>), during the last years of the rule of Francisco Franco and the beginning of the Spanish Transition to democracy. Its name comes from a famous song by the Spanish 1960s pop group Fórmula V, titled <i>Tell Me.</i> The producer of the series is Miguel Ángel Bernardeau.</p><p>The series was created to celebrate the first 25 years since Spain\'s transition to democracy, and its didactic spirit is clearly evident in some of the episodes. It includes documentary interviews with historical figures of the era, such as people concerned with the assassination of then prime minister Carrero Blanco and the death of Franco.</p><p>The first episode was broadcast on September 13, 2001. The series begins in April 1968 with the victory in the Eurovision song contest of the singer Massiel. The story reflects changes in Spain beginning in that year.</p><p>In December 2008, TVE and Ganga Group announced that the series, in its 10th season, had achieved very good audience levels, and would be renewed for up to 3 more seasons, with the storyline moving firmly into the 1980s and the "Movida madrileña".</p><p>Through situations, characters, and attitudes of the era, the series evokes a wistful reminiscence of those times. In this respect it can be compared to the series The Wonder Years, which did the same thing for US history.</p><p>This series influenced the Portuguese series Conta-me como foi, which starts the same year (1968) and goes to 1974, the year of the 25 de Abril. It has the participation of Portuguese actors such as Rita Blanco and Miguel Guilherme.</p>',
    officialSite: "http://www.rtve.es/television/cuentame/",
    webChannel: null,
    language: "Spanish",
    status: "Running",
    network: {
      id: 146,
      name: "La 1",
      country: { name: "Spain", code: "ES", timezone: "Europe/Madrid" },
    },
    premiered: "2001-09-13",
  },
  {
    id: 1697,
    url: "https://www.tvmaze.com/shows/1697/cuestion-de-sexo",
    name: "Cuestión de Sexo",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23883.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23883.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "Spanish",
    status: "Ended",
    network: {
      id: 98,
      name: "Cuatro",
      country: { name: "Spain", code: "ES", timezone: "Europe/Madrid" },
    },
    premiered: "2007-09-25",
  },
  {
    id: 1698,
    url: "https://www.tvmaze.com/shows/1698/vientos-de-agua",
    name: "Vientos de Agua",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23884.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23884.jpg",
    },
    summary:
      "<p>A drama series that traces a Spanish man's emigration to Argentina in the 1930s, and, years later, his son's return to modern-day Spain.</p>",
    officialSite: null,
    webChannel: null,
    language: "Spanish",
    status: "Ended",
    network: {
      id: 96,
      name: "Telecinco",
      country: { name: "Spain", code: "ES", timezone: "Europe/Madrid" },
    },
    premiered: "2006-01-03",
  },
  {
    id: 1699,
    url: "https://www.tvmaze.com/shows/1699/unidad-central-operativa",
    name: "Unidad Central Operativa",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23887.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23887.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "Spanish",
    status: "Ended",
    network: {
      id: 147,
      name: "RTVE",
      country: { name: "Spain", code: "ES", timezone: "Europe/Madrid" },
    },
    premiered: "2009-05-28",
  },
  {
    id: 1700,
    url: "https://www.tvmaze.com/shows/1700/fisica-o-quimica",
    name: "Física o Química",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23889.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23889.jpg",
    },
    summary:
      "<p>The students are hyaenas, never show them your fears. Never! A spanish series centered around the teachers and students at Zurbarán secondary school. Love, action, drama, friendship, lots of surprising and funny moments! It all begins with a dark secret that cost two students their life. But that's just the first shocking moment that will capture your breath.</p>",
    officialSite: null,
    webChannel: null,
    language: "Spanish",
    status: "Ended",
    network: {
      id: 97,
      name: "Antena 3",
      country: { name: "Spain", code: "ES", timezone: "Europe/Madrid" },
    },
    premiered: "2008-02-04",
  },
  {
    id: 1701,
    url: "https://www.tvmaze.com/shows/1701/la-chica-de-ayer",
    name: "La Chica de Ayer",
    genres: ["Drama", "Crime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23890.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23890.jpg",
    },
    summary: "<p>Spanish remake of UK cult TV series, <i>Life on Mars</i>.</p>",
    officialSite: null,
    webChannel: null,
    language: "Spanish",
    status: "Ended",
    network: {
      id: 97,
      name: "Antena 3",
      country: { name: "Spain", code: "ES", timezone: "Europe/Madrid" },
    },
    premiered: "2009-04-26",
  },
  {
    id: 1702,
    url: "https://www.tvmaze.com/shows/1702/los-protegidos",
    name: "Los Protegidos",
    genres: ["Drama", "Fantasy", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23893.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23893.jpg",
    },
    summary:
      '<p>The protected tells the story of a number of people living in the fictional town of Lost Valley posing as a family, Castillo Rey. The reason, the supernatural powers that unless the "fathers" of this family, possessed by members of the same, which lead them to be chased by a group of people with unknown intentions. Its members are Mario (Antonio Garrido) and his son Carlos (Daniel Avilés), a child who mastered telekinesis, Jimena (Angie Cepeda), whose daughter Blanca, endowed with precognitive powers was kidnapped by people who hide themselves Culebra ( Luis Fernandez), a teenager with the ability to become invisible at will, Sandra (Ana Fernandez), holder of a power related to electricity, the little Lucy (Priscilla Delgado), adopted daughter of a social worker and has the ability to read people\'s thoughts and Lucas (Mario March), a boy of 14 years with the option of transforming int...</p>',
    officialSite: null,
    webChannel: null,
    language: "Spanish",
    status: "Running",
    network: {
      id: 97,
      name: "Antena 3",
      country: { name: "Spain", code: "ES", timezone: "Europe/Madrid" },
    },
    premiered: "2010-01-12",
  },
  {
    id: 1703,
    url: "https://www.tvmaze.com/shows/1703/pesadilla-en-la-cocina",
    name: "Pesadilla en la Cocina",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23896.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23896.jpg",
    },
    summary: null,
    officialSite: "https://www.lasexta.com/programas/pesadilla-en-la-cocina/",
    webChannel: null,
    language: "Spanish",
    status: "Running",
    network: {
      id: 148,
      name: "La Sexta",
      country: { name: "Spain", code: "ES", timezone: "Europe/Madrid" },
    },
    premiered: "2012-10-25",
  },
  {
    id: 1704,
    url: "https://www.tvmaze.com/shows/1704/inhumans",
    name: "Inhumans",
    genres: ["Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23902.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23902.jpg",
    },
    summary:
      "<p><b>The Inhumans</b> have always been one of Marvel's most enduring oddities. A race of genetic outsiders, they live secluded in their island kingdom of Attilan, preferring not to mix with the outside world. Even stranger, their genetic mutations are self-endowed; each Inhuman, as a coming-of-age ritual, endures exposure to the Terrigen Mists, a strange substance that imparts unearthly powers--some extraordinary, some monstrous. But now the kingdom of Attilan is under attack from without and within. Can the Royal Family, led by Black Bolt, repel the foreign invaders who blast at their outer defenses, as well as the internal threat of Black Bolt's insane brother, Maximus the Mad?</p><p>This popular series takes a classic Marvel cast of characters, and infuses it with a modern sensibility that includes international politics and an awareness of class systems. Dark and grimly compelling, the \"Inhumans\" is one story that won't be forgotten any time soon.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-04-23",
  },
  {
    id: 1705,
    url: "https://www.tvmaze.com/shows/1705/dates",
    name: "Dates",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23903.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23903.jpg",
    },
    summary:
      "<p>From the creator of <i>Skins</i>, a witty, sexy and emotional drama series about the complicated and hilarious ways that strangers interact on dates in their quest to find love.</p>",
    officialSite:
      "https://web.archive.org/web/20161129005959/http://www.channel4.com/programmes/dates",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-06-10",
  },
  {
    id: 1706,
    url: "https://www.tvmaze.com/shows/1706/rush",
    name: "Rush",
    genres: ["Drama", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23904.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23904.jpg",
    },
    summary:
      '<p>USH examines the world of renegade physician Dr. William Rush (Tom Ellis, "Miranda"), a "medical fixer" who privately caters to LA\'s elite and whose service comes with a hefty price tag. Though the hard-partying doctor claims that he doesn\'t make judgments about his less-than-squeaky-clean clients, he\'s not immune to the ugliness that he encounters.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-17",
  },
  {
    id: 1707,
    url: "https://www.tvmaze.com/shows/1707/the-escape-artist",
    name: "The Escape Artist",
    genres: ["Drama", "Thriller", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23908.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23908.jpg",
    },
    summary:
      "<p>A chilling and bloody legal thriller that explores the line between law and justice.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p01jmyrk",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-10-29",
  },
  {
    id: 1708,
    url: "https://www.tvmaze.com/shows/1708/chiringuito-de-pepe",
    name: "Chiringuito de Pepe",
    genres: ["Drama", "Comedy", "Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23920.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23920.jpg",
    },
    summary: null,
    officialSite: "http://www.telecinco.es/chiringuitodepepe/",
    webChannel: null,
    language: "Spanish",
    status: "Ended",
    network: {
      id: 96,
      name: "Telecinco",
      country: { name: "Spain", code: "ES", timezone: "Europe/Madrid" },
    },
    premiered: "2014-06-09",
  },
  {
    id: 1709,
    url: "https://www.tvmaze.com/shows/1709/los-hombres-de-paco",
    name: "Los Hombres de Paco",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23921.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23921.jpg",
    },
    summary:
      "<p>Los hombres de Paco is a Spanish television series created by Daniel Écija and Álex Pina. Produced by Globo Media S.A., the show is a tragicomedy based on the lives of three Spanish national police detectives: Paco Miranda, Mariano Moreno, and Lucas Fernández.</p>",
    officialSite: null,
    webChannel: null,
    language: "Spanish",
    status: "Running",
    network: {
      id: 97,
      name: "Antena 3",
      country: { name: "Spain", code: "ES", timezone: "Europe/Madrid" },
    },
    premiered: "2005-10-09",
  },
  {
    id: 1710,
    url: "https://www.tvmaze.com/shows/1710/one-big-happy",
    name: "One Big Happy",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/51/127823.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/51/127823.jpg",
    },
    summary:
      "<p>Best friends Lizzy and Luke are like family. As kids, they saw each other's parents go through divorce and have ever since formed an inseparable bond. Now, all grown up and still single, they've decided to start a family of their own, but in a non-traditional way. Lizzy, who is a lesbian, wants to raise a child with Luke by her side. Then one night, Luke falls for Prudence, a free-spirited British girl who's due to go back to England in a matter of days. Then, just as Lizzy discovers that she's actually pregnant, Luke announces that he and Prudence have gotten married and in an instant - a different kind of family is born.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-17",
  },
  {
    id: 1711,
    url: "https://www.tvmaze.com/shows/1711/the-dovekeepers",
    name: "The Dovekeepers",
    genres: ["Drama", "Romance", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23998.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23998.jpg",
    },
    summary:
      '<p>Based on Alice Hoffman\'s historical novel about the Siege of Masada, the miniseries focuses on four extraordinary women whose lives intersect in a fight for survival at the siege of Masada. Set in ancient Israel, <i><b>"The Dovekeepers"</b></i> is based on the true events at Masada in 70 C.E. After being forced out of their home in Jerusalem by the Romans, 900 Jews were ensconced in a fortress at Masada, a mountain in the Judean desert. Besieged at Masada, the Jews held out for months against the vast Roman armies. The project will recount the events from the perspective of a few extraordinary women who arrive at Masada with unique backstories, but a common bond for survival. Additionally, these women, who work together daily as dovekeepers, are all concealing substantial secrets.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-31",
  },
  {
    id: 1712,
    url: "https://www.tvmaze.com/shows/1712/weird-loners",
    name: "Weird Loners",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/23999.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/23999.jpg",
    },
    summary:
      "<p>This un-romantic comedy follows four single mid-30-somethings who are unexpectedly thrust into one another's lives and form an unlikely bond in a Queens, NY, townhouse.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-31",
  },
  {
    id: 1713,
    url: "https://www.tvmaze.com/shows/1713/repeat-after-me",
    name: "Repeat After Me",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24003.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24003.jpg",
    },
    summary:
      "<p>In <b>Repeat After Me</b>, Wendi McLendon-Covey will instruct her celebrity friends, via a remote ear piece, to interact with everyday people in high-energy, comedic hidden-camera situations. At the end of each half-hour episode, the best moment of the night will be crowned in front of a live studio audience.</p>",
    officialSite: "http://abc.go.com/shows/repeat-after-me",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-17",
  },
  {
    id: 1714,
    url: "https://www.tvmaze.com/shows/1714/wpc-56",
    name: "WPC 56",
    genres: ["Drama", "Crime", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24011.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24011.jpg",
    },
    summary:
      "<p>Drama following Gina Dawson, the first <i>WPC</i> to serve in her West Midlands hometown in 1956.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-03-18",
  },
  {
    id: 1715,
    url: "https://www.tvmaze.com/shows/1715/counting-cars",
    name: "Counting Cars",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/323/807695.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/323/807695.jpg",
    },
    summary:
      '<p>Most people in Las Vegas bet with chips, but Danny "The Count" Koker bets with cars. Known from his numerous appearances on Pawn Stars, this Sin City legend walks, talks and breathes classic American muscle cars. When he sees a car he wants, he will do whatever it takes to get his hands on it—including making on-the-spot cash offers to unsuspecting owners. On the HISTORY series <b>Counting Cars</b>, Danny and his team restore, customize and sell cars in a hurry, scrambling to keep their Las Vegas shop in the black. From vintage Thunderbirds to classic Corvettes, toy cars to souped-up sidecar motorcycles, Danny and the crew of Count\'s Kustoms will stop at nothing to find and flip the greatest rides of all time.</p>',
    officialSite: "http://www.history.com/shows/counting-cars",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-08-13",
  },
  {
    id: 1716,
    url: "https://www.tvmaze.com/shows/1716/little-britain",
    name: "Little Britain",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24068.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24068.jpg",
    },
    summary:
      "<p>The zany comedy show with Matt Lucas and David Walliams, featuring characters from all over <b>Little Britain</b>.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006q2zd",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2003-09-16",
  },
  {
    id: 1717,
    url: "https://www.tvmaze.com/shows/1717/little-britain-usa",
    name: "Little Britain USA",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24069.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24069.jpg",
    },
    summary:
      "<p>Adaptation of the British sketch-comedy series, featuring some characters from the original, such as hospital receptionist Carol Beer and Prime Minister Sebastian Love, and new ones in the U.S., including astronaut Bing Gordyn and a foul-mouthed little girl named Ellie-Grace.</p>",
    officialSite: "http://www.hbo.com/little-britain-usa",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-09-28",
  },
  {
    id: 1718,
    url: "https://www.tvmaze.com/shows/1718/goodness-gracious-me",
    name: "Goodness Gracious Me",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/176/441540.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/176/441540.jpg",
    },
    summary:
      "<p>Sketch show starring Sanjeev Bhaskar, Kulvinder Ghir, Meera Syal and Nina Wadia.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b007xm15",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1998-01-12",
  },
  {
    id: 1719,
    url: "https://www.tvmaze.com/shows/1719/mr-bean",
    name: "Mr. Bean",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/45/113952.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/45/113952.jpg",
    },
    summary:
      "<p>The first episode of the original <b>Mr. Bean</b> series starring Rowan Atkinson was first broadcast on 1st January 1990. Since then <i>Mr. Bean</i> has become known all over the world. Created by Rowan Atkinson, Richard Curtis and Robin Driscoll, there were only 14 episodes ever made. The original series emerged from Rowan Atkinson's stage revues of the 1980′s which featured the silent odd-ball. Rowan Atkinson's comic acting genius has created a highly original work for television. The <i>Mr. Bean</i> series has been sold to 190 territories worldwide and has won an International Emmy and the Golden Rose of Montreux.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1990-01-01",
  },
  {
    id: 1720,
    url: "https://www.tvmaze.com/shows/1720/the-league-of-gentlemen",
    name: "The League of Gentlemen",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24073.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24073.jpg",
    },
    summary:
      "<p>Dark, surreal comedy about the strange inhabitants of the small town of Royston Vasey.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006t8d1",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1999-01-11",
  },
  {
    id: 1721,
    url: "https://www.tvmaze.com/shows/1721/the-bible",
    name: "The Bible",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24077.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24077.jpg",
    },
    summary:
      "<p><b>The Bible</b> comes to life in HISTORY's epic new series. From Genesis to Revelation, these unforgettable stories unfold through live action and cutting-edge computer-generated imagery, offering new insight into famous scenes and iconic characters. Created by producer Mark Burnett and featuring an international cast that includes Roma Downey, this 10-hour docudrama explores the sacred text's most significant episodes, including Noah's journey in the ark, the Exodus and the life of Jesus.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-03-03",
  },
  {
    id: 1722,
    url: "https://www.tvmaze.com/shows/1722/walk-of-shame-shuttle",
    name: "Walk of Shame Shuttle",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755274.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755274.jpg",
    },
    summary:
      "<p>In this all-new series, VH1 takes an uninhibited ride with hard-partying merrymakers rehashing the previous night's escapades in the harsh daylight of the following morning.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 55,
      name: "VH1",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-12",
  },
  {
    id: 1723,
    url: "https://www.tvmaze.com/shows/1723/walking-the-nile",
    name: "Walking the Nile",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24081.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24081.jpg",
    },
    summary:
      "<p>It's known as a holy grail in exploration because its sheer length alone contributes to its timeless mystery. The Nile, the planet's longest river, is a life source to six African countries (Rwanda, Tanzania, Uganda, South Sudan, Republic of Sudan and Egypt) - some of whose names currently are synonymous with danger and conflict. The Nile also is known as the cradle of civilization; the first cities known to man were developed on its storied shores. It snakes its way through a region that's full of duality: it's both peaceful and dangerous; it is both a source of life and cause of death; it's remote and urban; and it's the epicenter for a diverse mix of religions and cultures, both modern and primitive. Now, dauntless explorer and former British Army paratrooper Levison Wood is <b>Walking the Nile</b> - from source to sea - to uncover its many perplexities and to be the first person ever to endure something of extraordinary magnitude.</p>",
    officialSite: "http://www.channel4.com/programmes/walking-the-nile",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-01-04",
  },
  {
    id: 1724,
    url: "https://www.tvmaze.com/shows/1724/surviving-the-cut",
    name: "Surviving the Cut",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24082.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24082.jpg",
    },
    summary:
      "<p><b>Surviving the Cut</b> brings you the inside scoop on the intense world of military special forces training.</p>",
    officialSite: "http://www.discovery.com/tv-shows/surviving-the-cut/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-18",
  },
  {
    id: 1725,
    url: "https://www.tvmaze.com/shows/1725/breaking-borders",
    name: "Breaking Borders",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31467.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31467.jpg",
    },
    summary:
      "<p><b>Breaking Borders</b> follows seasoned journalist Mariana van Zeller and acclaimed chef Michael Voltaggio as they travel into conflict zones to get the story behind the story. Together, they have a unique and challenging goal: to gather people from all sides of the conflict to break bread and explore the issues that divide them.<br><br> In each episode, Mariana and Michael take viewers on a journey through a different country in conflict. They meet people affected by the unrest, while exploring the history and culture that has created it. As Mariana digs deeper into the issues, Michael goes on a culinary adventure, collecting ideas and ingredients to create an unbelievable meal inspired by the people he has met.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 82,
      name: "Travel Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-15",
  },
  {
    id: 1726,
    url: "https://www.tvmaze.com/shows/1726/hot-grits",
    name: "Hot GRITS",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755210.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755210.jpg",
    },
    summary:
      "<p>Welcome to Valdosta, Georgia. It's a small town with everything you'd expect in the South - warm air, picturesque sunsets, and true Southern hospitality. It's also home to some of the most beautiful girls around. <i><b>\"Hot GRITS\"</b></i> follows a group of loud, brash, and hilarious girls raised in the south. Emily, Bear, Ratchet, Jenna, Sarah, Hailey, and Jennifer may have similar southern twang in their voices, but they all wear their daisy dukes a little differently.</p>",
    officialSite: "http://www.vh1.com/shows/hot-grits/series.jhtml",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 55,
      name: "VH1",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-25",
  },
  {
    id: 1727,
    url: "https://www.tvmaze.com/shows/1727/little-women-ny",
    name: "Little Women: NY",
    genres: ["Drama", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31457.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31457.jpg",
    },
    summary:
      '<p>If fans thought the ladies of LA had challenges, wait until they see "Little Women: NY." This group of friends navigates the Big Apple while facing obstacles that test people even of average height, including hailing cabs, catching subways, traversing the crowded streets and just about everything else that\'s part of a New Yorker\'s hectic life. Viewers first got a glimpse of New York\'s Lila Call, when she made waves with the "Little Women: LA" cast and now they\'ll get to see her in action on her home turf with her group of east coast besties including Jordanna, Misty, Dawn, Jazmin, Kristin and Jason. While they all scramble to try to make it big in Manhattan, the unique clique supports one another every step of the way as they prove that "if they can make it there, they\'ll make it anywhere."</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-25",
  },
  {
    id: 1728,
    url: "https://www.tvmaze.com/shows/1728/big-time-in-hollywood-fl",
    name: "Big Time in Hollywood, FL",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755277.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755277.jpg",
    },
    summary:
      "<p>After their parents decide to kick them out, delusional brothers and self-proclaimed filmmakers Ben and Jack Dolfe stage an elaborate ruse to maintain their financial dependence on Mom and Dad. But when their plan takes a dark and dangerous turn, the brothers find themselves embroiled in an increasingly messy situation that threatens both their artistic ambitions and their lives.</p>",
    officialSite: "http://www.cc.com/shows/big-time-in-hollywood--fl",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-25",
  },
  {
    id: 1729,
    url: "https://www.tvmaze.com/shows/1729/harvey-beaks",
    name: "Harvey Beaks",
    genres: ["Comedy", "Family", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24089.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24089.jpg",
    },
    summary:
      "<p><b>Harvey Beaks</b> is a 29-episode series, created and executive produced by C.H. Greenblatt (Chowder), tells the story of the unlikely friendship between Harvey, a kid who's never broken the rules, and Fee and Foo, his two friends who've never lived by any.</p>",
    officialSite: "http://www.nick.com/harvey-beaks/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 73,
      name: "Nicktoons",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-29",
  },
  {
    id: 1730,
    url: "https://www.tvmaze.com/shows/1730/cancer-the-emperor-of-all-maladies",
    name: "Cancer: The Emperor of All Maladies",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31426.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31426.jpg",
    },
    summary:
      "<p><b>Cancer: The Emperor of All Maladies</b> tells the complete story of cancer, from its first description in an ancient Egyptian scroll to the gleaming laboratories of modern research institutions. At six hours, the film interweaves a sweeping historical narrative; with intimate stories about contemporary patients; and an investigation into the latest scientific breakthroughs that may have brought us, at long last, to the brink of lasting cures.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 85,
      name: "PBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-30",
  },
  {
    id: 1731,
    url: "https://www.tvmaze.com/shows/1731/olympus",
    name: "Olympus",
    genres: ["Drama", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24091.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24091.jpg",
    },
    summary:
      "<p>The 13-part mythological drama series <b>Olympus</b> takes viewers into the action-packed world of humans, Gods and monsters. Starring Matt Frewer (Max Headroom, Orphan Black), Sonita Henry (Star Trek, The Fifth Element), Cas Anvar (Argo, The Expanse) and Graham Shiels (Guardians of the Galaxy, Thor: Dark World), the gripping series captures the dangerous courage of a few brave men and women who banished the Gods to the realm of the unconscious - a place they called the Underworld or the Kingdom of Hades.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-02",
  },
  {
    id: 1732,
    url: "https://www.tvmaze.com/shows/1732/lip-sync-battle",
    name: "Lip Sync Battle",
    genres: ["Comedy", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/85/213468.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/85/213468.jpg",
    },
    summary:
      "<p><b>Lip Sync Battle</b> is already a huge viral sensation. Now Spike is taking it to the next level with its very own show, hosted by LL Cool J and with colorful commentary by social media maven and supermodel co-host, Chrissy Teigen. Each episode will feature two A-list celebrities like you've never seen them before - synching their hearts out in hysterically epic performances. The mic is off, the battle is on!</p>",
    officialSite: "http://www.paramountnetwork.com/shows/lip-sync-battle",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 34,
      name: "Paramount Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-02",
  },
  {
    id: 1733,
    url: "https://www.tvmaze.com/shows/1733/meet-the-smiths",
    name: "Meet the Smiths",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27539.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27539.jpg",
    },
    summary:
      "<p>The family at the center of The Smiths is headed by Kenny and Gwen, who probably never would have guessed when they got married that their conflicting parenting styles, whirlwind schedules and family chemistry would turn their quiet home into an absolute mad house - albeit a loving one.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 32,
      name: "TBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-03",
  },
  {
    id: 1734,
    url: "https://www.tvmaze.com/shows/1734/the-lizzie-borden-chronicles",
    name: "The Lizzie Borden Chronicles",
    genres: ["Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24093.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24093.jpg",
    },
    summary:
      "<p><b>The Lizzie Borden Chronicles </b>delivers an intense and fictionalized account of actual events and people surrounding Lizzie's life after her controversial acquittal of the horrific double murder of her father and stepmother in 1892, when the exonerated figure lives a life awash in newfound celebrity filled with scandalous love affairs. But when numerous people close to Lizzie - ranging from her half-brother William, to Broadway luminaries and her business associate/underworld kingpin Mr. Flowers - start to mysteriously die under brutal and strange circumstances, legendary Pinkerton detective Charlie Siringo becomes determined to prove her involvement in their ultimate demise.</p>",
    officialSite:
      "http://www.mylifetime.com/shows/the-lizzie-borden-chronicles",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-05",
  },
  {
    id: 1735,
    url: "https://www.tvmaze.com/shows/1735/happyish",
    name: "Happyish",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24094.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24094.jpg",
    },
    summary:
      '<p><b>Happyish</b> is a scathing examination of our pursuit of happiness, a pursuit that might just be the very thing causing our unhappiness in the first place. The new half-hour pilot stars Steve Coogan as Thom Payne, a 44 year-old man whose world is thrown into disarray when his 25 year-old "wunderkind" boss arrives, saying things like "digital," "social" and "viral." Is he in need of a "rebranding," as his mentor insists, or does he just have a "low joy ceiling," as his corporate headhunter suggests? Maybe pursuing happiness is a fool\'s errand? Maybe, after 44 years on this ludicrous planet, settling for happyish is the best one can expect.</p>',
    officialSite: "http://www.sho.com/sho/happyish/home",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-26",
  },
  {
    id: 1738,
    url: "https://www.tvmaze.com/shows/1738/did-he-do-it",
    name: "Did He Do It?",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755278.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755278.jpg",
    },
    summary:
      "<p><b>Did He Do It?</b> puts the accused center stage as viewers are invited to play jury. At the beginning of each hour-long episode, one victim and one defendant are presented to viewers. Piece-by-piece, investigators, defense attorneys, witnesses and even family members reveal crucial details of the investigation, leaving viewers with one question: <i>Did He Do It?</i></p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-02",
  },
  {
    id: 1739,
    url: "https://www.tvmaze.com/shows/1739/100-miles-from-nowhere",
    name: "100 Miles from Nowhere",
    genres: ["Adventure", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/174/436900.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/174/436900.jpg",
    },
    summary:
      "<p>From the producers of Naked and Afraid comes <b>100 Miles from Nowhere</b>, an Animal Planet series that follows adventurer Matt Galland and his two best buddies, Danny Bryson and Blake Josephson.</p><p>In each episode, the trio of fun-loving regular guys chooses remote, extreme locations throughout the globe where cameras - let alone people - rarely have gone. Matt, Danny and Blake's mission is straightforward: to get off life's usual humdrum path for a more exciting, daring and off-the-beaten one. In just three or four days, the guys trek approximately 100 miles and burn up to 10,000 calories on foot, raft, skis and even skateboard while they document and shoot their own escapades with absolutely no crew. Every single second on the ground is self-shot. Each expedition causes major wear and tear on their bodies, so the guys must reach their bear box drops, which are pre-arranged at set points to replenish their supplies, strength and stamina. Their incredible journeys take them to extreme landscapes - including steep mountains, insufferably hot deserts, freezing-cold canyons and snake-infested jungles. They push their endurance to the limit and sometimes even their friendship. The quests are never easy and are sometimes dangerous, but they always are packed with thrilling surprises and breathtaking footage of the planet's splendor.</p>",
    officialSite:
      "http://www.animalplanet.com/tv-shows/100-miles-from-nowhere/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 92,
      name: "Animal Planet",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-05",
  },
  {
    id: 1740,
    url: "https://www.tvmaze.com/shows/1740/your-family-or-mine",
    name: "Your Family or Mine",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/82/205563.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/82/205563.jpg",
    },
    summary:
      '<p><b>Your Family or Mine</b> revolves around Oliver and Kelli Weston, who are living proof of the adage, "When you marry someone, you don\'t just marry them, you marry their whole family".</p><p>Based on the Israeli series <i>Sabri Maranan</i>.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 32,
      name: "TBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-07",
  },
  {
    id: 1742,
    url: "https://www.tvmaze.com/shows/1742/jump",
    name: "Jump!",
    genres: ["Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755279.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755279.jpg",
    },
    summary:
      "<p>Lifetime's all-new docu-series <b>Jump!</b> chronicles the journey of one of the hottest jump roping teams in the country, Floyd-Little Double Dutch (FLDD), as they compete to defend their championship titles. Known as the face of Double Dutch, the team performed at the White House Easter celebration and opened up the 2014 BET Awards with Pharrell and Missy Elliot. Premiering Friday, April 10, at 10pm ET/PT, <i>Jump!</i> provides an inside look at the international competitive event filled with tricks, turns, tears and triumphs, and examines what it really takes to make it as the fiercest team in the country.</p><p>Each one hour episode of <i>Jump!</i> features coaches and best friends Quani Floyd and Laila Little as they whip their students into gear, working to uphold their status as world champions of Double Dutch. With 19 World Championships under their belt, the team is revered for their fancy footwork and one-of-a-kind tricks, and stop at nothing to win. For this team, the only place is first place.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-10",
  },
  {
    id: 1743,
    url: "https://www.tvmaze.com/shows/1743/good-work",
    name: "Good Work",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755281.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755281.jpg",
    },
    summary:
      "<p>Each week the three hosts will break down every aspect of celebrity beauty secrets, cosmetic procedures, and plastic surgery... who's had what done and who's doing it wrong. <b>Good Work</b> will leave no stone unturned when these three insiders amp up the water cooler conversation and get to bottom of what everyone else is already talking about.</p>",
    officialSite: "http://www.eonline.com/uk/shows/good_work",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 43,
      name: "E!",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-14",
  },
  {
    id: 1744,
    url: "https://www.tvmaze.com/shows/1744/over-the-garden-wall",
    name: "Over the Garden Wall",
    genres: ["Drama", "Fantasy", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24252.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24252.jpg",
    },
    summary:
      "<p>Created by Patrick McHale (Adventure Time), the 10-episode tale follows two brothers, Wirt and Greg (voiced by Elijah Wood and Collin Dean), who mysteriously find themselves outside of the world they know and in a forest called the Unknown. In a Wizard of Oz-like twist, they have stumbled into a fantasy universe of the past filled with the things of folk tales, as well as talking and singing animals, all wrapped up in the seemingly constant backdrop of harvest time.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-03",
  },
  {
    id: 1745,
    url: "https://www.tvmaze.com/shows/1745/young-hungry",
    name: "Young & Hungry",
    genres: ["Comedy", "Food", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24374.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24374.jpg",
    },
    summary:
      "<p>In <b>Young &amp; Hungry</b>, two worlds collide when Josh, a wealthy young tech entrepreneur, meets Gabi, a feisty young food blogger, looking to be his personal chef.</p><p>Gabi is desperate for the job and must prove herself, mostly to Josh's aide, who prefers a famous chef for the job. When Josh enlists Gabi to prepare a romantic meal for him and his girlfriend, the dinner goes awry and Gabi finds herself in a very awkward position. With the help of her best friend Sofia and Josh's housekeeper, Gabi turns a difficult situation into an opportunity for employment and maybe even love.</p>",
    officialSite: "http://freeform.go.com/shows/young-and-hungry",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-06-25",
  },
  {
    id: 1746,
    url: "https://www.tvmaze.com/shows/1746/cucumber",
    name: "Cucumber",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24422.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24422.jpg",
    },
    summary:
      "<p>The hour-long <b>Cucumber</b> will explore the lives and misadventures of Henry Best and his long-suffering boyfriend of nine years, Lance Sullivan.</p>",
    officialSite: "http://www.channel4.com/programmes/cucumber",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-01-22",
  },
  {
    id: 1747,
    url: "https://www.tvmaze.com/shows/1747/texas-rising",
    name: "Texas Rising",
    genres: ["Drama", "Action", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24430.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24430.jpg",
    },
    summary:
      '<p><b>Texas Rising</b> is an 8-hour miniseries that details the Texas Revolution and the rise of the Texas Rangers.</p><p>In 1836, west of the Mississippi was considered the Wild West and the Texas frontier was viewed as hell on earth. Crushed from the outside by Mexican armadas and attacked from within by ferocious Comanche tribes—no one was safe. But this was a time of bravery, a time to die for what you believed in and a time to stand tall against the cruel rule of the Mexican General Santa Anna. The heroic General Sam Houston, the rag tag Rangers and the legendary "Yellow Rose of Texas" lead this story of the human will to win against insurmountable odds. At the end, the Texas flags stood tall and victorious, claiming a piece of history for all eternity.</p>',
    officialSite: "http://www.history.com/shows/texas-rising",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-25",
  },
  {
    id: 1748,
    url: "https://www.tvmaze.com/shows/1748/matlock",
    name: "Matlock",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24437.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24437.jpg",
    },
    summary:
      "<p><b>Matlock </b>is a legal drama series starring Andy Griffith as defense attorney Ben Matlock - a Harvard-educated, fiery southerner who charges $100,000 a case to brilliantly defend his clients by finding the real killer.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1986-03-03",
  },
  {
    id: 1749,
    url: "https://www.tvmaze.com/shows/1749/the-goodies",
    name: "The Goodies",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24480.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24480.jpg",
    },
    summary:
      '<p>This British version of <i>The Monkees</i> features three madcap comedians--Tim Brooke-Taylor, Graeme Gordon, and Bill Oddie--who would do "Anything, Anytime, Anywhere" to make money.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 406,
      name: "London Weekend Television",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1970-11-08",
  },
  {
    id: 1750,
    url: "https://www.tvmaze.com/shows/1750/black-butler",
    name: "Black Butler",
    genres: ["Drama", "Action", "Anime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24483.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24483.jpg",
    },
    summary:
      "<p>One of the noble families of England - Phantomhive, has a butler, Sebastian Michaelis. He has unquestionably perfect knowledge, manners, talent with materials. martial arts and much more. But for some reason, he serves a 12 year old master...</p>",
    officialSite: "http://www.kuroshitsuji.tv/boc",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 24,
      name: "MBS",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2008-10-02",
  },
  {
    id: 1751,
    url: "https://www.tvmaze.com/shows/1751/the-three-stooges",
    name: "The Three Stooges",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24485.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24485.jpg",
    },
    summary:
      "<p>Watch as Moe, Larry and Curly go through life the only way a stooge can, with laughs and a lot of mischief.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1934-05-05",
  },
  {
    id: 1752,
    url: "https://www.tvmaze.com/shows/1752/the-starlost",
    name: "The Starlost",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24486.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24486.jpg",
    },
    summary:
      '<p>This low budget Canadian sci-fi series from 1973 ran for sixteen episodes before it was cancelled due to low ratings. It was created in Canada by Glen Warren Productions and partially funded by Twentieth Century Fox, who now own the broadcast and syndication rights to the series. It was also compiled down into five movies, each composed of two episodes each, with new credit sequences. The series was written by renowned science fiction author Harlan Ellison under a pseudonym of Cordwainer Bird, with additional episodes being written by other sci-fi authors. The plot concerned a giant Noah\'s Ark-like spaceship, composed of hundreds of huge "domes", each containing a sample culture from the planet Earth, which has long since died out due to an unknown disaster. The Ark, damaged from an asteroid collision, goes off course and heads into the path of a distant sun, its crew dead.</p><p>Foreseeing the destruction of the Earth, humanity builds a multi-generational starship called Earthship Ark, 80 kilometres (50 mi) wide and 320 kilometres (200 mi) long. The ship contains dozens of biospheres, each kilometres across and housing people of different cultures; their goal is to find and seed a new world of a distant star. More than one hundred years into the voyage, an unexplained accident occurs, and the ship goes into emergency mode, whereby each biosphere is sealed off from the others.<br>Four hundred and five years after the accident, Devon (Keir Dullea) a resident of Cypress Corners, a conservative agrarian community with a culture resembling that of the Amish, discovers that his world is far larger and more mysterious than he had realized. Considered an outcast because of his questioning of the way things are, especially his refusal to accept the arranged marriage of his love Rachel (Gay Rowan) to his friend Garth (Robin Ward), Devon finds the Cypress Corners elders have been deliberately manipulating the local computer terminal, which they call "The Voice of The Creator". The congregation pursues Devon for attacking the elders and stealing a computer cassette on which they have recorded their orders, and its leaders plot to execute him, but the elderly Abraham, who also questions the elders, gives Devon a key to a dark, mysterious doorway, which Abraham himself is afraid to enter. The frightened Devon escapes into the service areas of the ship and accesses a computer data station that explains the nature and purpose of the Ark and hints at its problems.<br>When Devon returns to Cypress Corners to tell his community what he has learned, he is put on trial for heresy and condemned to death by stoning. Escaping on the night before his execution with the aid of Garth, Devon convinces Rachel to come with him, and Garth pursues them. When Rachel refuses to return with Garth, he joins her and Devon. Eventually they make their way to the ship\'s bridge, containing the skeletal remains of its crew. It is badly damaged and its control systems are inoperative. The three discover that the Ark is on a collision course with a Class G star similar to the Sun, and realize that the only way to save The Ark and its passengers is to find the backup bridge and reactivate the navigation and propulsion systems. Occasionally, they are aided by the ship\'s partially functioning computer system.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 48,
      name: "CTV",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "1973-09-22",
  },
  {
    id: 1753,
    url: "https://www.tvmaze.com/shows/1753/jonathan-creek",
    name: "Jonathan Creek",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24490.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24490.jpg",
    },
    summary:
      "<p>Working from his home in a converted windmill, <b>Jonathan Creek</b> is a magician with a natural ability for solving puzzles. He soon puts this ability to the use of solving impossible crimes and mysterious murders.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b008jg9q",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1997-05-10",
  },
  {
    id: 1754,
    url: "https://www.tvmaze.com/shows/1754/ironside",
    name: "Ironside",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24494.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24494.jpg",
    },
    summary:
      "<p>Wheelchair-bound detective Robert T. Ironside battles the bad guys on the streets of San Francisco.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1967-09-14",
  },
  {
    id: 1755,
    url: "https://www.tvmaze.com/shows/1755/the-world-wars",
    name: "The World Wars",
    genres: ["War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/221/552664.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/221/552664.jpg",
    },
    summary:
      "<p>This is the story of a generation of men who come of age in the trenches of World War I, only to become the leaders of World War II. The lessons they learn on the frontlines shape them as they rise to power—and haunt them as the deadly fighting breaks out again. Some become heroes, forged in courage under fire. Others emerge as the most infamous villains the world has ever seen.</p>",
    officialSite: "http://www.history.com/shows/the-world-wars",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-05-26",
  },
  {
    id: 1756,
    url: "https://www.tvmaze.com/shows/1756/marchlands",
    name: "Marchlands",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24585.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24585.jpg",
    },
    summary:
      "<p>Alex Kingston and Jodie Whittaker lead the cast of this gripping supernatural drama about three different families living in the same house in the 1960's, 1980's and present day, linked by the spirit of a girl who died in mysterious circumstances.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-02-03",
  },
  {
    id: 1757,
    url: "https://www.tvmaze.com/shows/1757/lightfields",
    name: "Lightfields",
    genres: ["Drama", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24588.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24588.jpg",
    },
    summary:
      "<p><b>Lightfields</b> follows the story of three families that each lived in Lightfields farmhouse at different time periods (1944, 1975 and 2012) but who are linked by a spine-chilling presence: the ghost of a teenage girl who died in mysterious and tragic circumstances. </p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-02-27",
  },
  {
    id: 1758,
    url: "https://www.tvmaze.com/shows/1758/dci-banks",
    name: "DCI Banks",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24589.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24589.jpg",
    },
    summary:
      "<p>Dark and harrowing crime drama, starring Stephen Tompkinson as Detective Chief Inspector Alan Banks.</p>",
    officialSite: "http://www.itv.com/hub/dci-banks/1a9089",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-09-27",
  },
  {
    id: 1759,
    url: "https://www.tvmaze.com/shows/1759/5ive-days-to-midnight",
    name: "5ive Days to Midnight",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24594.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24594.jpg",
    },
    summary:
      "<p>A college professor's life is turned upside down when he finds a police briefcase from five days in the future. But even more shocking are its contents-a file on his own death, which he must now race against time to prevent.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-06-07",
  },
  {
    id: 1760,
    url: "https://www.tvmaze.com/shows/1760/anne-of-green-gables",
    name: "Anne of Green Gables",
    genres: ["Drama", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24599.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24599.jpg",
    },
    summary:
      "<p>One hundred years ago, Anne of Green Gables introduced readers to one of the most enduring characters in fiction and launched Canada's most lucrative literary franchise. The heartwarming story of the plucky red-headed orphan has gone on to sell hundreds of millions of copies and become the basis for an unprecedented television phenomenon. But behind the fictional and feisty Anne Shirley lurked the often-tormented life of author Lucy Maud Montgomery. CBC Archives takes a look at the life, death and lasting legacy of the woman who created Anne.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 36,
      name: "CBC",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "1985-12-05",
  },
  {
    id: 1761,
    url: "https://www.tvmaze.com/shows/1761/anne-of-green-gables",
    name: "Anne of Green Gables",
    genres: ["Drama", "Anime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24689.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24689.jpg",
    },
    summary:
      "<p><b>Anne of Green Gables</b> is an animated television series, part of Nippon Animation's World Masterpiece Theater. It was adapted from the novel, Anne of Green Gables, by Lucy Maud Montgomery. Produced by Nippon Animation in 1979, it was first broadcast on Fuji TV from January 7, 1979 to December 30, 1979. Fifty episodes were produced in total.</p><p>It has been exported to neighbouring Asian countries and also to Europe and Canada. As with the novels, the animated version of Anne is much beloved in Japan to this day and \"DVD memorial BOX set\" was released on August 22, 2008 and a new anime series that serves as a prequel to the series, Kon'nichiwa Anne 〜 Before Green Gables, which premiered on April 5, 2009 in Japan.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 131,
      name: "Fuji TV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1979-01-07",
  },
  {
    id: 1762,
    url: "https://www.tvmaze.com/shows/1762/the-adventures-of-tom-sawyer",
    name: "The Adventures of Tom Sawyer",
    genres: ["Drama", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24770.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24770.jpg",
    },
    summary:
      '<p><i><b>The Adventures of Tom Sawyer</b></i> (トム・ソーヤーの冒険 <i>Tomu Sōyā no Bōken</i><b>?</b>) is a Japanese anime series, directed byHiroshi Saitô which was aired in 1980. It is based on the well-known and popular novel <i>The Adventures of Tom Sawyer</i>by Mark Twain.</p><p>The series was broadcast on the World Masterpiece Theater, an animation staple on Fuji TV that showcased each year an animated version of a different classical book or story of Western literature, and was originally titled "Tom Sawyer no Bōken". It was the second installment of the series, after 1977\'s <i>Rascal the Raccoon</i>, to feature the work of an American author.</p><p>This series was also dubbed to English by Saban International and aired on HBO circa 1988 under the title "The Adventures of Tom Sawyer." It aired during the 7:30AM time slot and alternated with the later <i>WMT</i> version of "Little Women." Celebrity Home Entertainment released videos in the United States under the title "All New Adventures of Tom Sawyer".</p><p>In 1997, 2008, 2010, and 2014, it was aired on ABS-CBN in the Philippines.</p><p>As of January 2011, the anime is airing in the United States (in the original Japanese) on the NHK\'s cable channel TV Japan.</p>',
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 131,
      name: "Fuji TV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1980-01-06",
  },
  {
    id: 1763,
    url: "https://www.tvmaze.com/shows/1763/el-ministerio-del-tiempo",
    name: "El Ministerio del Tiempo",
    genres: ["Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/247/617874.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/247/617874.jpg",
    },
    summary:
      "<p>A warrior from the 16th century, the first female university student from the 19th century and a nurse from the 21st century, join a secret agency to prevent people to change the Spanish history by using time-traveling doors.</p>",
    officialSite: "http://www.rtve.es/television/ministerio-del-tiempo/",
    webChannel: null,
    language: "Spanish",
    status: "Running",
    network: {
      id: 146,
      name: "La 1",
      country: { name: "Spain", code: "ES", timezone: "Europe/Madrid" },
    },
    premiered: "2015-02-24",
  },
  {
    id: 1764,
    url: "https://www.tvmaze.com/shows/1764/the-first-world-war",
    name: "The First World War",
    genres: ["War", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/289/722835.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/289/722835.jpg",
    },
    summary:
      "<p>A new history in 10 parts of the global conflict which shaped the 20th century, produced by Wark Clements for Channel 4 and Southern Star.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2003-09-20",
  },
  {
    id: 1765,
    url: "https://www.tvmaze.com/shows/1765/tour-of-duty",
    name: "Tour of Duty",
    genres: ["Drama", "Action", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24696.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24696.jpg",
    },
    summary:
      "<p>As the first television drama series about the Vietnam War, <b>Tour of Duty</b> focuses on a single platoon of young U.S. soldiers through their one-year tour of combat duty in Vietnam during the late 1960's. While their own country is rocked by a massive anti-war movement, these young men find themselves thrown into combat in Southeast Asia, where they face enemy troops they can not see and sometimes can not kill. They also face their own fears, as they struggle in a hostile environment just to keep themselves and their fellow soldiers alive.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1987-09-24",
  },
  {
    id: 1766,
    url: "https://www.tvmaze.com/shows/1766/spotless",
    name: "Spotless",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24715.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24715.jpg",
    },
    summary:
      "<p>He's a professional at cleaning up the crimes of others. His own life is getting dirtier by the minute.</p>",
    officialSite: null,
    webChannel: null,
    language: "French",
    status: "Ended",
    network: {
      id: 105,
      name: "Canal+",
      country: { name: "France", code: "FR", timezone: "Europe/Paris" },
    },
    premiered: "2015-03-16",
  },
  {
    id: 1767,
    url: "https://www.tvmaze.com/shows/1767/the-bletchley-circle",
    name: "The Bletchley Circle",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/147/369403.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/147/369403.jpg",
    },
    summary:
      "<p><b>The Bletchley Circle</b> follows the journey of four ordinary women with extraordinary skills that helped to end World War II.</p><p>Set in 1952, Susan, Millie, Lucy and Jean have returned to their normal lives, modestly setting aside the part they played in producing crucial intelligence, which helped the Allies to victory and shortened the war. When Susan discovers a hidden code behind an unsolved murder she is met by skepticism from the police. She quickly realises she can only begin to crack the murders and bring the culprit to justice with her former friends.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-09-06",
  },
  {
    id: 1768,
    url: "https://www.tvmaze.com/shows/1768/the-catherine-tate-show",
    name: "The Catherine Tate Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/33/82623.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/33/82623.jpg",
    },
    summary:
      "<p>Perrier Award nominated for her performance in Lee Mack's sketch show at The Edinburgh Festival 2000 and critically acclaimed for her one-woman sketch show at Edinburgh 2001, Catherine Tate now writes and stars in her own sketch show. Catherine's irreverent characters include the rancid pensioner, the overprotective new parents and the randy nurse. The show's theme tune is \"In These Shoes?\" by Kirsty MacColl.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006m8fh",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2004-02-16",
  },
  {
    id: 1769,
    url: "https://www.tvmaze.com/shows/1769/those-who-kill",
    name: "Those Who Kill",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24778.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24778.jpg",
    },
    summary:
      "<p><b>Those Who Kill</b> is a Danish format based on the bestselling work of author Elsebeth Egholm. A&amp;E has secured the U.S. format for the critically acclaimed crime series in Denmark. The series is about violent criminals who are surrounded by fear and mystique- the serial killer. When murders are not grounded in traditional motives and patterns of behavior, it takes a very particular kind of person to catch the serial killer; someone who knows and understands the killer's dark side and the fantasies that plague him. Someone like the two lead characters- a police detective that is trying to understand her own mysterious personal connection in to the mind of a serial killer, and a \"profiler\" (forensic psychiatrist), who both in very different ways possess a deep psychological understanding that connects them to the killer's victims and to the killer himself, driving them to pursue each case to the end of the line, again and again.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-03-03",
  },
  {
    id: 1770,
    url: "https://www.tvmaze.com/shows/1770/top-boy",
    name: "Top Boy",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24784.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24784.jpg",
    },
    summary:
      "<p>A thrilling and raw drama about young lives lived on the edge in east London - an honest and gripping rendition of inner-city drug and gang culture.</p>",
    officialSite:
      "https://web.archive.org/web/20180827163853/http://www.channel4.com/programmes/top-boy",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-10-31",
  },
  {
    id: 1771,
    url: "https://www.tvmaze.com/shows/1771/8-minutes",
    name: "8 Minutes",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/309/772706.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/309/772706.jpg",
    },
    summary:
      "<p>In Houston, Texas, the epicenter of human trafficking in the United States, Brown and his team of victim's advocates and other volunteers, embark on a mission to help some of the thousands of young women forced into prostitution each year in America.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-02",
  },
  {
    id: 1772,
    url: "https://www.tvmaze.com/shows/1772/the-grace-helbig-show",
    name: "The Grace Helbig Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/9/24832.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/9/24832.jpg",
    },
    summary:
      '<p>"The Grace Helbig Show" delivers Grace\'s "uber fan" take on all things pop culture while enlisting fans to help drive the direction of the show through social media. In addition, the series will feature guest interviews in an assortment of everyday locations, ranging from grocery stores to Grace\'s own living room, her car and everywhere in between, providing an environment where her guests can let loose and be themselves.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 43,
      name: "E!",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-03",
  },
  {
    id: 1773,
    url: "https://www.tvmaze.com/shows/1773/the-watch",
    name: "The Watch",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755211.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755211.jpg",
    },
    summary:
      '<p>"The mind, when left alone, is an interesting thing to watch..." Out on the fringe of society, on the edge of town, up in the mountains and far up the coast are four loners living in total isolation. In West Virginia, Billy, the watchman at an abandoned amusement park, feels the presence of Shawn, the little girl who is rumored to have died on the swings at Lake Shawnee Amusement Park. Dave, the caretaker on a Montana ranch, expects to encounter extraterrestrials, but instead hosts a different kind of uninvited guest that mess around with his food supplies and his peace of mind. Brooks, a 68-year-old lighthouse keeper out in the Atlantic, must stand her ground and survive a storm all by her lonesome in Race Rock. In Picher, Oklahoma, Cheeto patrols the empty streets of an abandoned toxic mining town.<br></p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-09",
  },
  {
    id: 1774,
    url: "https://www.tvmaze.com/shows/1774/everything-you-didnt-know-about-animals",
    name: "Everything You Didn't Know About Animals",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31427.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31427.jpg",
    },
    summary:
      "<p>Did you know a cat's purr could help keep astronauts alive in space, or that dogs can drive? Were you aware that elephants can hear with their feet, or that owls can \"see\" with their ears? And have you heard that the 4-inch long mantis shrimp is inspiring the next generation of explosion proof armor? Everything You Didn't Know About Animals aims to surprise, entertain, and inform animal lovers with amazing, never before heard facts about some truly incredible animals.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 83,
      name: "National Geographic WILD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-13",
  },
  {
    id: 1775,
    url: "https://www.tvmaze.com/shows/1775/schitts-creek",
    name: "Schitt's Creek",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/279/697623.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/279/697623.jpg",
    },
    summary:
      "<p><b>Schitt's Creek</b> centers on a formerly filthy rich video store magnate Johnny Rose, his soap star wife Moira, and their two kids, über-hipster son David and socialite daughter Alexis, who suddenly find themselves broke. They are forced to live in Schitt's Creek, a small depressing town they once bought as a joke.</p>",
    officialSite: "http://www.cbc.ca/schittscreek/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 36,
      name: "CBC",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2015-01-13",
  },
  {
    id: 1776,
    url: "https://www.tvmaze.com/shows/1776/porridge",
    name: "Porridge",
    genres: ["Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/48/122414.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/48/122414.jpg",
    },
    summary:
      "<p>Classic comedy series about the inmates and wardens of HM Prison Slade.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006m9kn",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1974-09-05",
  },
  {
    id: 1777,
    url: "https://www.tvmaze.com/shows/1777/heroes-of-aviation",
    name: "Heroes of Aviation",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/219/549535.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/219/549535.jpg",
    },
    summary:
      "<p>Take to the skies with courageous military pilots of the past century – from the early fliers of WWI to the amazing aerial acrobats of today. This exciting 10-part documentary series combines thrilling combat footage, extraordinary stories of daring and eye-opening first-hand interviews with those who risk their lives in the cockpit. Go deep behind enemy lines and experience the crews' heroic efforts. Plus, get an up-close look at more than 200 historic aircraft. Covers the Great War, WWII, the Ploesti Oil Fields, the Vietnam War, the Gulf War, and more. Superb footage of real aerial combat -More than 200 aircraft, including fighters, bombers and jets. Meet the men and women – and the remarkable aircraft – that helped shape history by determining the outcome of critical military battles.</p>",
    officialSite: null,
    webChannel: { id: 3, name: "Amazon Prime Video", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2006-04-15",
  },
  {
    id: 1778,
    url: "https://www.tvmaze.com/shows/1778/hinterland",
    name: "Hinterland",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/25008.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/25008.jpg",
    },
    summary:
      "<p>DCI Tom Mathias comes to Aberystwyth having abandoned his life in London. He's a brilliant but troubled man. Despite his faults he is an excellent detective, who knows that the key to solving the crime lies not in where you look for truth, but how you look. From the windswept sand dunes of the coastline to the badlands of the hinterland, Y Gwyll is a series of stories that are original and local, yet timeless and universal.</p>",
    officialSite: "http://www.s4c.cymru/en/drama/y-gwyll/",
    webChannel: null,
    language: "Welsh",
    status: "Ended",
    network: {
      id: 64,
      name: "S4C",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-10-29",
  },
  {
    id: 1779,
    url: "https://www.tvmaze.com/shows/1779/remedy",
    name: "Remedy",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/25284.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/25284.jpg",
    },
    summary:
      "<p>A unique, high-stakes medical drama that goes beyond the operating room and the ER, to reveal a compelling community of hospital staff who make the healing happen. The series follows Griffin Conners, son of the Chief of Staff, brother to both a surgeon and a nurse, and now – medical school dropout. Having been kicked out in a haze of disgrace, Griffin is forced to return to Broadview Hospital as its newest orderly, where he gets a new perspective on a world he thought he knew through a colorful cast of cleaners, project aides, transport workers and more.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 67,
      name: "Global",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2014-02-24",
  },
  {
    id: 1780,
    url: "https://www.tvmaze.com/shows/1780/finding-carter",
    name: "Finding Carter",
    genres: ["Drama", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/25309.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/25309.jpg",
    },
    summary:
      "<p><b>Finding Carter</b> is a family drama that centers on Carter, a teenage girl who thinks she has the perfect life until one night after a police bust at a high school party she is told that the woman who she believes to be her biological mother actually abducted her as a toddler.</p>",
    officialSite: "http://www.mtv.com/shows/finding-carter/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-08",
  },
  {
    id: 1781,
    url: "https://www.tvmaze.com/shows/1781/swab-stories",
    name: "Swab Stories",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/139/349744.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/139/349744.jpg",
    },
    summary:
      '<p>\'Who am I?\' This is where Jared Rosenthal and his assistant, medical technician Ana Lopez, step in - he owns and operates the \'Who\'s Your Daddy\' DNA testing truck. When the clinic on wheels hits the streets, people often gawk, laugh, snap photos, and have even been known to jump out of their cars at traffic lights. The truck sparks reactions wherever it goes, from Manhattan to the Bronx - plus on road trips to New Jersey, Maryland, DC, Chicago, and beyond. When clients climb aboard, they are often seeking answers to burning questions they have kept buried deep inside of them - sometimes for decades. They reveal the doubts that keep them awake at night, and ask for Jared\'s help in putting an end to their most personal mysteries. From astonishing stories like "I think I was kidnapped at birth and have found my mother" and "I think the man I\'m dating might be my brother," to personal revelations such as "I may have found my sperm donor father," to touching stories like "I think I have a twin sister" there are no limits to the variety of questions people have about their DNA - right in the middle of traffic.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 55,
      name: "VH1",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-27",
  },
  {
    id: 1782,
    url: "https://www.tvmaze.com/shows/1782/500-questions",
    name: "500 Questions",
    genres: ["Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/64/161105.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/64/161105.jpg",
    },
    summary:
      "<p>Hosted by Dan Harris, <b>500 Questions</b> challenges the smartest people in the country to achieve the seemingly impossible task of answering 500 of the most difficult general knowledge questions ever devised. There's only one simple rule: never get three wrong in a row — or you're gone. No saves, no helps, no multiple choice, 500 Questions keeps you on the edge of your seat to see if any of these geniuses can do it. It is the ultimate test, where intellect, strategy and stamina are all equally essential in order to win.</p>",
    officialSite: "http://abc.go.com/shows/500-questions",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-20",
  },
  {
    id: 1783,
    url: "https://www.tvmaze.com/shows/1783/celebrity-wife-swap",
    name: "Celebrity Wife Swap",
    genres: ["Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755282.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755282.jpg",
    },
    summary:
      "<p>The spouses in two celebrity families with vastly diverse values switch homes (but not bedrooms) -- embarking on a journey like no other and revealing the various ways some controversial celebrities live their lives.</p>",
    officialSite: "http://abc.go.com/shows/celebrity-wife-swap/about-the-show",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-01-02",
  },
  {
    id: 1784,
    url: "https://www.tvmaze.com/shows/1784/all-in-the-family",
    name: "All In the Family",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/75/189680.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/75/189680.jpg",
    },
    summary:
      '<p><b>All In the Family</b> was first seen in January of 1971 and immediately changed the face of television. Not only was this the number one television series from 1971 through 1976, but it also signified an avalanche of other situation comedies that dealt with controversial subjects in realistic ways, including Chico and the Man, The Jeffersons, Maude, Good Times and Sanford and Son.</p><p>The series centered around the Bunker family who lived in a home located at 704 Houser Street in Queens, New York. Archie Bunker was the main character, and what a character he was. He was televisons most famous bigot, crass and down right rude. Yet he was loveable, with a soft side just beneath the surface. Edith Bunker was his somewhat dizzy wife whom he called "Dingbat". Edith put up with Archie and had qualities about her that made her one of television\'s most unforgetable characters. Also living in the Bunker household were Archie and Edith\'s daughter, Gloria, and her husband Mike, or "Meathead".</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1971-01-12",
  },
  {
    id: 1785,
    url: "https://www.tvmaze.com/shows/1785/the-stand",
    name: "The Stand",
    genres: ["Drama", "Fantasy", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/25437.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/25437.jpg",
    },
    summary:
      "<p>When a government-run lab accidentally lets loose a deadly virus, the population of the world is decimated. Survivors begin having dreams about two figures: a mystical old woman, or a foreboding, scary man. As the story tracks various people, we begin to realize that the two figures exemplify basic forces of good and evil, and the stage is set for a final confrontation between the representatives of each.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1994-05-08",
  },
  {
    id: 1786,
    url: "https://www.tvmaze.com/shows/1786/the-shining",
    name: "The Shining",
    genres: ["Drama", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/61/153506.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/61/153506.jpg",
    },
    summary:
      "<p><b>The Shining</b> is a television adaptation of a Stephen King novel that follows a recovering alcoholic professor. He ends up taking a job as a winter caretaker for a remote Colorado hotel which he seeks as an opportunity to finish a piece of work. With his wife and son with him, the caretaker settles in, only to see visions of the hotel's long deceased employees and guests. With evil intentions, they manipulate him into his dark side which takes a toll on him and his family.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1997-04-27",
  },
  {
    id: 1787,
    url: "https://www.tvmaze.com/shows/1787/zwarte-tulp",
    name: "Zwarte Tulp",
    genres: ["Drama", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/219/548147.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/219/548147.jpg",
    },
    summary:
      '<p><b>Zwarte Tulp</b> evolves about the developments between two families from the "bollenstreek" in The Netherlands, which have become hereditary enemies because of a mysterious accident in the past. Their many years ongoing feud is strengthened and kept up to date by the race to the black tulip. Step by step, the mystery is unravelled. Nothing is what it seems, but surely important decisions are to be taken about life and death, love and hate, release and hold, harmony and chaos.</p>',
    officialSite: "http://zwartetulp.videoland.com/",
    webChannel: {
      id: 12,
      name: "Videoland",
      country: {
        name: "Netherlands",
        code: "NL",
        timezone: "Europe/Amsterdam",
      },
    },
    language: "Dutch",
    status: "Ended",
    network: null,
    premiered: "2015-03-30",
  },
  {
    id: 1788,
    url: "https://www.tvmaze.com/shows/1788/killjoys",
    name: "Killjoys",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/206/515143.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/206/515143.jpg",
    },
    summary:
      "<p><b>Killjoys</b> follows a fun-loving, hard living trio of interplanetary bounty hunters sworn to remain impartial as they chase deadly warrants throughout the Quad, a distant system on the brink of a bloody, multi-planetary class war.</p>",
    officialSite: "http://www.space.ca/show/killjoys/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 7,
      name: "CTV Sci-Fi Channel",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2015-06-19",
  },
  {
    id: 1789,
    url: "https://www.tvmaze.com/shows/1789/friday-night-dinner",
    name: "Friday Night Dinner",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/43/109637.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/43/109637.jpg",
    },
    summary:
      "<p>For the Goodman family, <b>Friday Night Dinner</b> is just like Sunday lunch: just take two days away, change the meal to dinner, and you've pretty much got it. Adam and his brother, Jonny, view Friday night dinner as a necessary annoyance - necessary because they get fed, and annoying because, well, they have to spend the evening with mum and dad.</p>",
    officialSite: "http://www.channel4.com/programmes/friday-night-dinner",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-02-25",
  },
  {
    id: 1790,
    url: "https://www.tvmaze.com/shows/1790/prey",
    name: "Prey",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/25704.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/25704.jpg",
    },
    summary:
      "<p>On the run accused of a terrible crime, Manchester Detective Marcus Farrow tries to prove his innocence while being hunted by his former friends and colleagues.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-04-28",
  },
  {
    id: 1791,
    url: "https://www.tvmaze.com/shows/1791/scream-the-tv-series",
    name: "Scream: The TV Series",
    genres: ["Horror", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/203/508247.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/203/508247.jpg",
    },
    summary:
      "<p><b>Scream: The TV Series </b>is based on the eponymous, international hit horror franchise. After a cyber-bullying incident results in a brutal murder, the shocking violence stirs up memories of a killing spree from the past that has haunted some, intrigued others and maybe just inspired a new killer. A group of teens - with two old friends struggling to reconnect at its heart - become lovers, enemies, suspects, targets and victims of a killer who's out for blood.</p>",
    officialSite: "http://www.vh1.com/shows/scream-the-tv-series",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 55,
      name: "VH1",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-30",
  },
  {
    id: 1792,
    url: "https://www.tvmaze.com/shows/1792/place-of-execution",
    name: "Place of Execution",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/25725.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/25725.jpg",
    },
    summary:
      "<p>On a freezing December night in 1963 a 13-year-old girl vanished without trace - the mystery was never solved. More than 40 years later, the dramatic events surrounding the disappearance and the hunt for the killer resurface when a high-flying TV journalist makes a documentary about the case. But what she finds will shatter the past - and the lives of everyone involved…</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-09-22",
  },
  {
    id: 1794,
    url: "https://www.tvmaze.com/shows/1794/complications",
    name: "Complications",
    genres: ["Drama", "Thriller", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/29475.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/29475.jpg",
    },
    summary:
      "<p><b>Complications</b> centers on disillusioned suburban doctor John Ellison who, while still dealing with the emotional effects of his daughter's death, unexpectedly becomes a vigilante hero when he intervenes in a drive-by shooting, saving a young boy's life. When John learns the boy is still marked for death, he's compelled to save him at any cost. Through this journey, he must compromise his morals, often doing the wrong thing for all the right reasons.</p><p>The series also features Gretchen, a reckless but capable nurse; John's wife, Samantha, who while attempting to support her husband is struggling with her own issues; and John's by-the-book coworker, Dr. Bridget O'Neill, who finds herself dealing with the aftermath of his actions.</p>",
    officialSite: "https://www.usanetwork.com/complications",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-18",
  },
  {
    id: 1796,
    url: "https://www.tvmaze.com/shows/1796/other-space",
    name: "Other Space",
    genres: ["Comedy", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/26138.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/26138.jpg",
    },
    summary:
      "<p>In the early 22nd century the human race has mapped most of the known universe but failed to find alien life, and frankly gotten a little tired of the whole thing. A spaceship on a routine collection mission stumbles into the greatest discovery in history: an alternate universe, far stranger and way more dangerous than ours. Now the ship's crew - a collection of over-matched rookies, feuding siblings, burned-out veterans and obsolete robots - has to explore this new universe to try and find a way back home alive.</p>",
    officialSite: null,
    webChannel: {
      id: 5,
      name: "YAHOO! View",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-04-14",
  },
  {
    id: 1797,
    url: "https://www.tvmaze.com/shows/1797/the-ride",
    name: "The Ride",
    genres: ["Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31688.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31688.jpg",
    },
    summary:
      "<p>There's nothing more powerful than an artist speaking their truth. The Ride gives today's most talented performers a direct link to fans to tell their story—like no one's ever heard before.</p>",
    officialSite: "http://www.mtv.pt/programas/the-ride/9aympj",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 1322,
      name: "MTV Portugal",
      country: { name: "Portugal", code: "PT", timezone: "Europe/Lisbon" },
    },
    premiered: "2015-04-18",
  },
  {
    id: 1798,
    url: "https://www.tvmaze.com/shows/1798/tatau",
    name: "Tatau",
    genres: ["Drama", "Crime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/25819.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/25819.jpg",
    },
    summary:
      "<p>Joe Layton (<i>New Worlds, Father Brown</i>) and Theo Barklem-Biggs (<i>Silk, The Inbetweeners Movie</i>) have been cast as Kyle Connor and Paul 'Budgie' Griffiths – the lead roles in BBC AMERICA's new drama <b>Tatau</b>. Set in the Cook Islands, the (8×60) series, written by Richard Zajdlic, is co-produced by Touchpaper TV (<i>Being Human</i>) and New Zealand's largest screen production company, South Pacific Pictures, for BBC Three and BBC AMERICA.</p><p>Tatau follows Kyle (Layton) and Budgie (Barklem-Biggs), two twenty-something friends from London that set off to travel the world. Ahead of the journey, Kyle gets a Maori-style tattoo to celebrate their eventual destination: the Cook Islands.</p><p>When snorkeling in a lagoon, Kyle finds the dead body of a local girl, Aumea, tied up underwater. Returning to the lagoon with the police, Kyle finds her corpse has disappeared. But Kyle knows what he saw. Desperate to uncover what happened, Kyle and Budgie find themselves sucked deeper and deeper into a world of Maori myths, symbols, and hallucinatory visions… until finally the full meaning of Kyle's tattoo is revealed.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p02ldr6x",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-04-12",
  },
  {
    id: 1799,
    url: "https://www.tvmaze.com/shows/1799/the-prancing-elites-project",
    name: "The Prancing Elites Project",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31665.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31665.jpg",
    },
    summary:
      "<p>The Prancing Elites, an all African American, gay, and gender-nonconforming dance team from Mobile, Alabama, dance their way to success as they look to overcome bigotry and rejection.</p>",
    officialSite: "http://www.oxygen.com/the-prancing-elites-project",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 79,
      name: "Oxygen",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-22",
  },
  {
    id: 1800,
    url: "https://www.tvmaze.com/shows/1800/beyond-the-tank",
    name: "Beyond the Tank",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/25821.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/25821.jpg",
    },
    summary:
      "<p><b>Beyond the Tank</b> is the companion series from the producers of the Emmy-winning reality series, Shark Tank. Each episode of Beyond the Tank features captivating and surprising outcomes, and examines the highs and lows after the Sharks strike a deal with the entrepreneurs on Shark Tank.</p>",
    officialSite:
      "http://abc.go.com/shows/beyond-the-tank/episode-guide/season-01",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-01",
  },
  {
    id: 1801,
    url: "https://www.tvmaze.com/shows/1801/arctic-rescue",
    name: "Arctic Rescue",
    genres: ["Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/78/196720.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/78/196720.jpg",
    },
    summary:
      "<p>Fairbanks, Alaska is home to some of the harshest weather conditions in North America, making roadways impassible in only a matter of minutes. When motorists become stranded, three towing companies are called on to pull them to safety: Borealis, Ron's and Lucky 7.</p><p>These three teams have worked through the worst that nature can throw at them, but with snowfall capable of topping 12 feet and temperatures that drop as low as 60 degrees below zero, every rescue attempt comes with a high-degree of risk. Only the strong can survive, Alaska's brutal winter. Are these teams up to the challenge?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-23",
  },
  {
    id: 1802,
    url: "https://www.tvmaze.com/shows/1802/this-old-house",
    name: "This Old House",
    genres: ["DIY"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/320/801118.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/320/801118.jpg",
    },
    summary:
      "<p>The mission of <b>This Old House</b> is to demystify the home improvement process and to celebrate the fusion of old world craftsmanship and modern technology. Each season features two renovation projects. Project One traditionally consists of eighteen or so episodes and is filmed in Massachusetts. Project Two is generally taped in a different region of the country to highlight the variety of American architectural styles and renovation issues.</p>",
    officialSite: "http://www.thisoldhouse.com/toh/tv/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 85,
      name: "PBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1980-01-01",
  },
  {
    id: 1804,
    url: "https://www.tvmaze.com/shows/1804/the-man-in-the-high-castle",
    name: "The Man in the High Castle",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/216/541957.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/216/541957.jpg",
    },
    summary:
      "<p><b>The Man in the High Castle</b> is a startling depiction of an alternate history as imagined by author Philip K. Dick in his best-selling novel; a world in which Nazi Germany and Japan were victorious in World War II. The year is 1962 and the Axis Powers occupy the United States, where fascism rules and the few surviving Jews hide under assumed names.</p>",
    officialSite: "https://www.amazon.com/gp/product/B00RSGFRY8",
    webChannel: { id: 3, name: "Amazon Prime Video", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-01-15",
  },
  {
    id: 1805,
    url: "https://www.tvmaze.com/shows/1805/are-you-afraid-of-the-dark",
    name: "Are You Afraid of the Dark?",
    genres: ["Drama", "Fantasy", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/51/129520.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/51/129520.jpg",
    },
    summary:
      '<p><b>Are You Afraid of the Dark? </b>is a show based upon a group of kids known as "The Midnight Society". Members meet in the woods and take turns telling their own spooky tales. The series aired on Nickelodeon in the United States as part of their SNICK line-up in 1992. It lasted for 5 seasons until it was canceled in 1996. Later on, it returned to Nickelodeon\'s SNICK block with a new cast for two seasons from 1999-2000.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1992-08-15",
  },
  {
    id: 1806,
    url: "https://www.tvmaze.com/shows/1806/resident-advisors",
    name: "Resident Advisors",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/26070.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/26070.jpg",
    },
    summary:
      "<p><b>Resident Advisors</b> is an outrageous comedy set in the most hormonally-overloaded, sexually active, out-of-control workplace in the world: a college dorm. The show follows a group of resident assistants as they navigate sex, drugs, and midterms.</p>",
    officialSite: null,
    webChannel: {
      id: 2,
      name: "Hulu",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-04-09",
  },
  {
    id: 1807,
    url: "https://www.tvmaze.com/shows/1807/round-the-twist",
    name: "Round the Twist",
    genres: ["Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/26169.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/26169.jpg",
    },
    summary:
      "<p>From the hilarious mind of author Paul Jennings comes the off-the-wall adventures of the Twist family – Tony, Pete, Linda and Bronson – who leave the comforts of the big smoke to live in an old lighthouse in the rugged sea-side village of Port Niranda. But all is not as it seems, and strange things are starting to happen...</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 114,
      name: "ABC",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "1990-08-26",
  },
  {
    id: 1808,
    url: "https://www.tvmaze.com/shows/1808/underbelly",
    name: "Underbelly",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/26170.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/26170.jpg",
    },
    summary:
      "<p><b>Underbelly</b> is part review, part expose', and part skit comedy. We delve into the seedy underbelly of gaming, movies, comics, and the internets and attack its vulnerable underbelly for massive damage.</p>",
    officialSite: "https://www.9now.com.au/underbelly",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 120,
      name: "Nine Network",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2008-02-13",
  },
  {
    id: 1809,
    url: "https://www.tvmaze.com/shows/1809/kath-and-kim",
    name: "Kath and Kim",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/26190.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/26190.jpg",
    },
    summary:
      "<p><b>Kath and Kim</b> is a comedy series about a mother and daughter in the fictional outer suburb of Fountain Lakes. Kath Day (Jane Turner) is enjoying life as an empty nester and has a new man in her life, gourmet sausage-maker Kel Knight (Glenn Robbins). She's none too happy when her lazy, self-involved daughter Kim (Gina Riley) moves back home after problems in her marriage to Brett Craig (Peter Rowsthorn), a computer salesman at Fountain Gate, Kath and Kim's local shopping complex and favourite haunt. Kim's second-best friend, allergy-plagued sports enthusiast Sharon Strezlecki (Magda Szubanski), is another regular fixture at Kath's place.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 251,
      name: "Seven Network",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2002-05-16",
  },
  {
    id: 1810,
    url: "https://www.tvmaze.com/shows/1810/harvey-birdman-attorney-at-law",
    name: "Harvey Birdman, Attorney at Law",
    genres: ["Comedy", "Science-Fiction", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/26196.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/26196.jpg",
    },
    summary:
      "<p>Once a third-rate superhero, Harvey Birdman is now a third-rate lawyer trying like hell to get by in a fancy law firm. It's not clear whether Harvey actually went to law school, but he definitely knows the things to say to sound like a lawyer. And he has a suit now, that's for sure.</p>",
    officialSite:
      "http://www.adultswim.com/videos/harvey-birdman-attorney-at-law/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-12-30",
  },
  {
    id: 1811,
    url: "https://www.tvmaze.com/shows/1811/we-can-be-heroes",
    name: "We Can Be Heroes",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/26197.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/26197.jpg",
    },
    summary:
      "<p><b>We Can Be Heroes</b> is the internationally acclaimed hit comedy series created and written by Chris Lilley. This ground breaking mockumentary follows the daily lives of five very special individuals who are among the thousands of citizens nominated for the prestigious title of Australian of the Year. As portrayed by Lilley, the five nominees are from different parts of the country and represent the full spectrum of Australian society: young and old, male and female, urban and rural; native and emigrant.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 114,
      name: "ABC",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2005-07-27",
  },
  {
    id: 1812,
    url: "https://www.tvmaze.com/shows/1812/the-body-farm",
    name: "The Body Farm",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/26198.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/26198.jpg",
    },
    summary:
      "<p>Crime drama series following Eve Lockhart, one of Britain's leading forensic pathologists, and her team of scientists at a state-of-the-art forensic research facility.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b014sp3c",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-09-13",
  },
  {
    id: 1813,
    url: "https://www.tvmaze.com/shows/1813/scott-and-bailey",
    name: "Scott and Bailey",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/26204.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/26204.jpg",
    },
    summary:
      "<p><b>Scott and Bailey</b> is a crime drama series which follows the personal and professional lives of two female detectives working for the Manchester Metropolitan Police.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-05-29",
  },
  {
    id: 1814,
    url: "https://www.tvmaze.com/shows/1814/the-doctor-blake-mysteries",
    name: "The Doctor Blake Mysteries",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/113/284395.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/113/284395.jpg",
    },
    summary:
      "<p>Doctor Lucien Blake returns to Ballarat to once again solve a series of strange and baffling murders, only to find change is afoot, nothing is sacred, and no one is safe.</p>",
    officialSite: "http://www.abc.net.au/tv/programs/doctor-blake-mysteries/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 114,
      name: "ABC",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2013-02-01",
  },
  {
    id: 1815,
    url: "https://www.tvmaze.com/shows/1815/bondi-rescue",
    name: "Bondi Rescue",
    genres: ["Drama", "Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/150/377279.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/150/377279.jpg",
    },
    summary:
      "<p><b>Bondi Rescue</b> follows the work of the elite professional Lifeguards who patrol Australia's busiest beach - 365 days a year. With helicopter footage and behind the scenes access, get side-by-side the lifeguards as they put themselves in danger to help save others.</p><p>The head lifeguard expects his team to give it everything they've got. But with a maximum eight lifeguards on duty at any one time, and over 40,000 beachgoers on a summer's day, the question arises 'is everything they've got enough'? Performing around 2,500 rescues each season and with crowds exceeding 2.5 million people per year, the team certainly has their work cut out for them. The tight knit group work and play together, keeping each other in check and their feet planted firmly on the ground. Experience the action through the eyes of lifeguards as they deal with everything from shark scares to mass rescues, resuscitations, lost children and thieves.</p><p>Bondi Rescue celebrates the unsung heroes of Australia's best asset - the beach.</p>",
    officialSite: "http://tenplay.com.au/channel-ten/bondi-rescue",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 149,
      name: "Network 10",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2006-02-06",
  },
  {
    id: 1816,
    url: "https://www.tvmaze.com/shows/1816/flipping-ships",
    name: "Flipping Ships",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755283.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755283.jpg",
    },
    summary:
      "<p><b>Flipping Ships </b>follows McCain and his Boats Have Souls business in a six-part series. In each episode, this quirky band of gear heads perform acts of nautical salvation on boats that have been abandoned for so long, they're beginning to forge with nature ... and not in a good way! When boat's floorboards have long been replaced by grass and dirt, the team goes to work reinventing these disasters into fishing vessels, open water cruisers and family houseboats.</p>",
    officialSite: "http://www.animalplanet.com/tv-shows/flipping-ships/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 92,
      name: "Animal Planet",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-24",
  },
  {
    id: 1817,
    url: "https://www.tvmaze.com/shows/1817/the-truth-about-cats",
    name: "The Truth About Cats",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31637.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31637.jpg",
    },
    summary:
      "<p>Making use of the latest technology, militarygrade GPS trackers, x-rays, cat-cams and specialized photography, <b>The Truth About Cats</b> explores how a cat learns to function as a wild animal in a domestic world; the extraordinary ways in which cats are able to use their senses to interpret their environment; and the remarkable feline skill of inter-species communication and co-operation.</p>",
    officialSite:
      "http://channel.nationalgeographic.com/wild/the-truth-about-cats/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 83,
      name: "National Geographic WILD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-24",
  },
  {
    id: 1818,
    url: "https://www.tvmaze.com/shows/1818/i-can-do-that",
    name: "I Can Do That",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/121/304635.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/121/304635.jpg",
    },
    summary:
      '<p>NBC puts six celebrities to the test in its new one-hour comedy variety series, <b>I Can Do That</b>.<br /><br />Comedian-actor-producer Marlon Wayans ("Scary Movie" franchise) serves as host. Six of America\'s brightest entertainers come together to compete and showcase their talents with breathtaking and unique acts - featuring skills they did not even know they had.</p><p>Joining Wayans for this summer series will be acclaimed dancer and choreographer Cheryl Burke ("Dancing with the Stars"), superstar recording artists Ciara, Joe Jonas and Nicole Scherzinger, national stand-up comedian Jeff Dye ("Last Comic Standing") and actor Alan Ritchson ("The Wedding Ringer").</p><p>Each week, in front of a live audience, the six cast members will enter a friendly rivalry as they choose their favorite act - what they think they can master - and who they would like to pair up with to master that act. The acts will span every variety of entertainment from song and dance to magic and danger. They will also feature some of America\'s biggest-name performers in guest-starring roles.</p><p>With their acts selected, the duos make their way into the training studio, where they work with their expert coach for five days to produce an amazing act to perform on the next week\'s show. After a week of intensive training, the celebrities return to the stage to perform their act in hopes of scoring the top slot on the night\'s scoreboard.</p><p>With no judges or eliminations, <i>I Can Do That</i> allows the cast to show off their untapped talents and enjoy a little friendly competition along the way. After six weeks of exploring their own unique talent range, one cast member will be revealed as the season\'s ultimate entertainer.</p>',
    officialSite: "http://www.nbc.com/i-can-do-that",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-26",
  },
  {
    id: 1819,
    url: "https://www.tvmaze.com/shows/1819/dark-matter",
    name: "Dark Matter",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/122/305066.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/122/305066.jpg",
    },
    summary:
      "<p>In <b>Dark Matter</b>, the crew of a derelict spaceship is awakened from stasis with no memories of who they are or how they got on board. Facing threats at every turn, they have to work together to survive a voyage charged with vengeance, betrayal and hidden secrets.</p>",
    officialSite: "http://www.space.ca/show/dark-matter/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 7,
      name: "CTV Sci-Fi Channel",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2015-06-12",
  },
  {
    id: 1820,
    url: "https://www.tvmaze.com/shows/1820/proof",
    name: "Proof",
    genres: ["Drama", "Mystery", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/29511.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/29511.jpg",
    },
    summary:
      "<p>Jennifer Beals plays Dr. Carolyn Tyler, who has suffered the recent, devastating loss of her teenage son, the breakup of her marriage and a growing estrangement from her daughter. Carolyn is persuaded by Ivan Turing (Modine), a cancer-stricken tech inventor and billionaire to investigate cases of reincarnation, near-death experiences, hauntings and other phenomena, all of it in the search for evidence that death is not the end.</p>",
    officialSite: "http://www.tntdrama.com/shows/proof.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-16",
  },
  {
    id: 1821,
    url: "https://www.tvmaze.com/shows/1821/ballers",
    name: "Ballers",
    genres: ["Drama", "Comedy", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/207/519929.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/207/519929.jpg",
    },
    summary:
      "<p>Looking at the lives of former and current football players, <b>Ballers</b> follows former superstar Spencer Strasmore as he gets his life on track in retirement while mentoring other current and former players through the daily grind of the business of football.</p>",
    officialSite: "http://www.hbo.com/ballers",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-21",
  },
  {
    id: 1822,
    url: "https://www.tvmaze.com/shows/1822/the-brink",
    name: "The Brink",
    genres: ["Comedy", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/29606.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/29606.jpg",
    },
    summary:
      "<p><b>The Brink</b> focuses on a geopolitical crisis and its effect on three disparate and desperate men: Walter Larson, the US Secretary of State; Alex Talbot, a lowly Foreign Service officer; and Zeke Tilson, an ace Navy fighter pilot. These three compromised souls must pull through the chaos around them to save the planet from World War Three.</p>",
    officialSite: "http://www.hbo.com/the-brink",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-21",
  },
  {
    id: 1823,
    url: "https://www.tvmaze.com/shows/1823/between",
    name: "Between",
    genres: ["Drama", "Science-Fiction", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/61/153690.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/61/153690.jpg",
    },
    summary:
      "<p><b>Between </b>is the story of a town under siege from a mysterious disease that has wiped out everybody except those 21 years old and under. The series explores the power vacuum that results when a government has quarantined a 10-mile diameter area and left the inhabitants to fend for themselves.</p>",
    officialSite: "https://www.netflix.com/title/80022632",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-05-21",
  },
  {
    id: 1824,
    url: "https://www.tvmaze.com/shows/1824/fear-the-walking-dead",
    name: "Fear the Walking Dead",
    genres: ["Drama", "Action", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/299/748757.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/299/748757.jpg",
    },
    summary:
      "<p>Living in the same universe as <i>The Walking Dead</i>, <b>Fear the Walking Dead </b>is a gritty drama that explores the onset of the undead apocalypse through the lens of a fractured family. Set in a city where people come to escape, shield secrets, and bury their pasts, a mysterious outbreak threatens to disrupt what little stability high school guidance counselor Madison Clark and English teacher Travis Manawa have managed to assemble. The everyday pressure of blending two families while dealing with resentful, escapist, and strung out children takes a back seat when society begins to break down. A forced evolution, a necessary survival of the fittest takes hold, and our dysfunctional family must either reinvent themselves or embrace their darker histories.</p>",
    officialSite: "http://www.amc.com/shows/fear-the-walking-dead",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 20,
      name: "AMC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-23",
  },
  {
    id: 1825,
    url: "https://www.tvmaze.com/shows/1825/the-expanse",
    name: "The Expanse",
    genres: ["Science-Fiction", "Thriller", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/283/709553.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/283/709553.jpg",
    },
    summary:
      "<p>A thriller set two hundred years in the future, <b>The Expanse</b> follows the case of a missing young woman who brings a hardened detective and a rogue ship's captain together in a race across the solar system to expose the greatest conspiracy in human history.</p>",
    officialSite: "https://www.amazon.com/dp/B07YL9WK1S/",
    webChannel: { id: 3, name: "Amazon Prime Video", country: null },
    language: "English",
    status: "Running",
    network: null,
    premiered: "2015-12-14",
  },
  {
    id: 1827,
    url: "https://www.tvmaze.com/shows/1827/black-work",
    name: "Black Work",
    genres: ["Drama", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31205.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31205.jpg",
    },
    summary:
      "<p><b>Black Work</b> is the story of Jo Gillespie, a woman who's husband is shot dead in the line of action, in his job as a undercover cop. Jo, a police officer herself soon has to confront issues in her marriage and family life in order to discover who really killed her husband.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-06-21",
  },
  {
    id: 1828,
    url: "https://www.tvmaze.com/shows/1828/wentworth",
    name: "Wentworth",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/158/396176.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/158/396176.jpg",
    },
    summary:
      "<p>Fans of the iconic Prisoner Cell Block H series, which pushed boundaries over three decades ago and still boasts a loyal following worldwide today, will remember Bea Smith as gutsy and fearless, ruling Wentworth Correctional Centre with an iron fist. But who was Bea Smith before prison? How did a wife and mother from the suburbs become a top dog without rival? Wentworth Prison is a dynamic, often confronting, drama series that begins with Bea's early days in prison. Set in the present day, it is a modern adaptation of Prisoner Cell Block H that contemporises legendary characters and their stories for today's audience.</p><p>This series takes the viewer inside to an uncompromising environment that explores the politics of women in a world without men, and how such a threatening experience both challenges and often changes those confined and working behind the razor wire. The audience will be introduced to Bea all over again and meet her allies and enemies in the form of iconic inmates: Doreen Anderson, Liz Birdsworth and Franky Doyle, and there are new faces such as Jacs Holt, the ruthless matriarch of a crime family who now reigns over Wentworth. Favourite offices will also return. Meg Jackson carries a shameful secret; Vera Bennett, the well-meaning officer who discovers everyone has a price; Erica Davidson, the crusading Lawyer and Matthew Fletcher who believes in retribution rather than rehabilitation. And a new face, Meg's husband Will Jackson, whose past still haunts him.</p><p>Each episode explores an individual character's back story, providing an insight to what makes them tick and the circumstances that led them to Wentworth. In doing so we discover that the difference between an inmate and an officer is sometimes simply geography, because they're all prisoners in surprisingly different ways. Like the original Prisoner Cell Block H, Wentworth Prison is, at its heart, a series about survival, a character drama featuring women living in a pressure cooker environment. Despite the rivalries and power struggles, this family of misfits and rebels are forced to forge unlikely friendships and allegiances if they want to survive their time inside.</p>",
    officialSite: "https://www.showcasechannel.com.au/shows/wentworth/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 270,
      name: "Showcase",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2013-05-01",
  },
  {
    id: 1829,
    url: "https://www.tvmaze.com/shows/1829/psychic-matchmaker",
    name: "Psychic Matchmaker",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755209.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755209.jpg",
    },
    summary:
      '<p>Love is all about finding the perfect connection, and according to psychic Deborah Graham, that connection is a subconscious link that lives inside a person\'s soul. Deborah is an expert at discovering that bond, and she specializes in helping people find true love that can last a lifetime. Follow Deborah as she uses her psychic gift and an ever-growing "date-a-base" to find her clients their soulmate, even if it means searching in unlikely places to get the perfect lead.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-01",
  },
  {
    id: 1830,
    url: "https://www.tvmaze.com/shows/1830/the-willis-family",
    name: "The Willis Family",
    genres: ["Family", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755284.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755284.jpg",
    },
    summary:
      "<p><b>The Willis Family</b> is a new series following a musically gifted family of fourteen — 4 boys, 8 girls and parents Brenda and Toby — as they make music at home and on the road.</p>",
    officialSite: "http://www.tlc.com/tv-shows/the-willis-family/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-05",
  },
  {
    id: 1831,
    url: "https://www.tvmaze.com/shows/1831/the-briefcase",
    name: "The Briefcase",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/280/701988.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/280/701988.jpg",
    },
    summary:
      "<p>The show features a social experiment element. In each episode, two hard-working American families experiencing financial setbacks are presented by the show's producers with a briefcase containing $101,000 and a potentially life-altering decision: they can keep all of the money for themselves, or give all or part of it to another family in need.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-27",
  },
  {
    id: 1832,
    url: "https://www.tvmaze.com/shows/1832/the-secret-war",
    name: "The Secret War",
    genres: ["War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/26695.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/26695.jpg",
    },
    summary:
      "<p>The series traces the moves and countermoves between British and German scientists on land, sea, and in the air.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1977-01-05",
  },
  {
    id: 1833,
    url: "https://www.tvmaze.com/shows/1833/banished",
    name: "Banished",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/80/201739.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/80/201739.jpg",
    },
    summary:
      "<p>At its heart, <b>Banished</b> is a story of survival. Though it is set in the stark historical reality of the founding of the penal colony in Australia in 1788 after the arrival of the First Fleet, it is not the story of Australia and how it came to be. Rather, it is a tale of love, faith, justice and morality played out on an epic scale in a confined community where the stakes are literally life and death.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p02jfvpn",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-03-05",
  },
  {
    id: 1834,
    url: "https://www.tvmaze.com/shows/1834/1864",
    name: "1864",
    genres: ["Drama", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/62/157336.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/62/157336.jpg",
    },
    summary:
      "<p>When Germany and Prussia declare war on Denmark, two brothers are called to serve in the bloodiest battle in Denmark's history. We follow the brothers Peter and Laust during the years of the Second Schleswig War, two brothers in love with the same woman.</p>",
    officialSite: "http://www.dr.dk/diverse/drama/1864/index",
    webChannel: null,
    language: "Danish",
    status: "Ended",
    network: {
      id: 115,
      name: "DR1",
      country: { name: "Denmark", code: "DK", timezone: "Europe/Copenhagen" },
    },
    premiered: "2014-10-12",
  },
  {
    id: 1835,
    url: "https://www.tvmaze.com/shows/1835/reno-rumble",
    name: "Reno Rumble",
    genres: ["DIY"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/26896.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/26896.jpg",
    },
    summary:
      "<p><b>Reno Rumble</b> is an Australian reality television series that pit former contestants from The Block on the Nine Network against former contestants from House Rules on the Seven Network.</p><p>Contestants renovate two suburban houses, with one team eliminated each week. The winner will receive a $100,000 cheque with half going to the winning couple's favourite charity. Each home will be judged by interior design experts who have been briefed by the home owners on the style they want for their renovation. The runner up will receive $50,000 with half going to charity</p><p>Each week, each home will be blind judged (unaware of which team renovated which one – or the rooms assigned to each individual couple) and the team with the lowest score that week will be eliminated from the competition.</p><p><i>Reno Rumble: East v West</i> is the second season of Australian reality television series <i>Reno Rumble</i>, it will air on the Nine Network. Unlike the first season which pit former contestants from <i>The Block</i> against former contestants from <i>House Rules</i>, this season will have state based rookie teams from either The East or West Side of Australia competing against each other. It will be hosted by Scott Cam and Shelley Craft and will be judged by Colin McAllister and Justin Ryan. It will premiere Monday 21 March 2016. The winning couple will receive $100,000.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 120,
      name: "Nine Network",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2015-05-05",
  },
  {
    id: 1836,
    url: "https://www.tvmaze.com/shows/1836/the-block",
    name: "The Block",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/26834.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/26834.jpg",
    },
    summary:
      "<p><b>The Block </b>is an Australian reality television show. The show sees four couples compete against each other to renovate a home in an apartment block and sell it at auction for the highest price.</p>",
    officialSite: "https://9now.nine.com.au/the-block",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 120,
      name: "Nine Network",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2003-06-01",
  },
  {
    id: 1837,
    url: "https://www.tvmaze.com/shows/1837/frontline",
    name: "Frontline",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27545.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27545.jpg",
    },
    summary:
      "<p>Since it began in 1983, <b>Frontline</b> has been airing public-affairs documentaries that explore a wide scope of the complex human experience. Frontline's goal is to extend the impact of the documentary beyond its initial broadcast by serving as a catalyst for change.</p><p>.</p>",
    officialSite: "http://www.pbs.org/wgbh/frontline/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 85,
      name: "PBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1989-01-18",
  },
  {
    id: 1838,
    url: "https://www.tvmaze.com/shows/1838/sons-of-winter",
    name: "Sons of Winter",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755285.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755285.jpg",
    },
    summary:
      "<p>Meet the Barks family, homesteaders who have rejected modern living in favor of living off the grid and maintaining a prairie lifestyle in Northern Saskatchewan, a remote province in Canada. This winter, their entire world is about to change. The two eldest sons, 20-year-old Dale and 19-year-old Shane, will embark on an epic, 90-day journey hundreds of miles away from home in order to survive the unforgiving wilderness on their own.</p>",
    officialSite: "https://www.discovery.com/tv-shows/sons-of-winter/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-28",
  },
  {
    id: 1839,
    url: "https://www.tvmaze.com/shows/1839/monument-guys",
    name: "Monument Guys",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27546.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27546.jpg",
    },
    summary:
      "<p>Some people make history with their actions, and some people make it with molten bronze. At the Crucible Foundry in Norman Oklahoma, brothers Mark and Steve Palmerton, and sculptor Craig Campbell, research, sculpt, and cast bronze statues of deserving heroes—dead and alive, celebrated and forgotten. In small towns across America, these monuments ensure a legacy that will last for thousands of years, and the crew at the Crucible will go to any means to make sure they're done right.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-06",
  },
  {
    id: 1840,
    url: "https://www.tvmaze.com/shows/1840/lost-in-transmission",
    name: "Lost in Transmission",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27547.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27547.jpg",
    },
    summary:
      "<p>Top Gear co-host and automotive aficionado, Rutledge Wood and his friend and fellow car fanatic, George Flanigen, are on a mission: to rescue America's greatest rides from barns and backyards across the South.</p><p>Together Rutledge and George will comb the garages of America to rescue the under-appreciated examples of automotive styling that time forgot, fix them up and get them back on the road. Their journey will take them off the beaten track, where they will get lost in local traditions, meet eccentric characters, and discover the heart of American car culture.</p><p>Two friends on the ultimate road trip saving America's greatest, weirdest and coolest cars.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-07",
  },
  {
    id: 1841,
    url: "https://www.tvmaze.com/shows/1841/dead-end-express",
    name: "Dead End Express",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/296/741554.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/296/741554.jpg",
    },
    summary:
      "<p>On the edge of the American frontier, a few brave men risk their lives delivering vital supplies to people living off the grid. From the dense woodlands of Montana's Flathead National Forest, through the isolated heart of Idaho's Hells Canyon, to the frozen wastelands of Alaska's high tundra, follow five rugged adventurers as they live and breath the high-stakes of hauling critical cargo into these unique tracts of wilderness. Always on the move, these deliverymen have been shaped by the great outdoors, and have learned the hard way how to tackle anything that Mother Nature throws in their path. Yet they all have one thing in common: there's no job too tough. And whether by bush plane, jet boat, snowmachine, dog-sled or pack horse, they'll overcome all obstacles and do whatever it takes to make their delivery.</p>",
    officialSite: "http://channel.nationalgeographic.com/dead-end-express/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-07",
  },
  {
    id: 1842,
    url: "https://www.tvmaze.com/shows/1842/the-island",
    name: "The Island",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/26/67444.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/26/67444.jpg",
    },
    summary:
      "<p>In the hour-long <b>The Island</b>, internationally acclaimed adventurer and survivalist Bear Grylls gives the modern American man the ultimate challenge: Can a man of today's world survive on a deserted island without the luxuries - or even the basics - of contemporary everyday life?</p><p>The Island, based on the hit Shine TV-produced Channel 4 U.K. series of the same name, doesn't include any of the usual reality show trappings. There are no prizes. No eliminations. No winner. No camera teams. The entire series is filmed by the men themselves. The six episodes will show 14 American men isolated on a deserted island with only the clothes on their backs and minimal survival tools, committed to filming every moment themselves.</p><p>These 21st-century American men, who are accustomed to roofs over their heads, restaurants and the benefits of technology, are stripped of all modern conveniences and catapulted back to the basics. They must hunt for food, source water, erect shelter, build community and try to survive using only their strength, determination and know-how. All of the men, including a stay-at-home dad, a trauma surgeon, a firefighter and a criminal defense attorney, have something to prove to themselves and each other. This experiment takes them to the very edge of human endurance. They will test their physical, mental and emotional limits and fight for their very existence.</p>",
    officialSite: "http://nbc.com/the-island",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-25",
  },
  {
    id: 1843,
    url: "https://www.tvmaze.com/shows/1843/golan-the-insatiable",
    name: "Golan the Insatiable",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/26949.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/26949.jpg",
    },
    summary:
      "<p>I do not know how I got to your worthless dimension. I suspect foul wizardry. Nor do I know how to return to my kingdom of Gkruool. I do not like it any more than you insects. Yet here we are and it seems we must make the most of it.</p>",
    officialSite: "http://www.fox.com/golan-the-insatiable/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-11-23",
  },
  {
    id: 1844,
    url: "https://www.tvmaze.com/shows/1844/stitchers",
    name: "Stitchers",
    genres: ["Drama", "Crime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/26950.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/26950.jpg",
    },
    summary:
      "<p>ABC Family's first procedural drama, <b>Stitchers</b>, follows Kirsten a young woman recruited into a covert government agency to be 'stitched' into the minds of the recently deceased, using their memories to investigate murders and decipher mysteries that otherwise would have gone to the grave. Working alongside Kirsten is Cameron, a brilliant neuroscientist whose passion for the program is evident in his work. The secret program is headed by Maggie, a skilled veteran of covert operations, and includes Linus, a socially immature bioelectrical engineer and communications technician. Kirsten's roommate, Camille, a gifted computer science grad student, is also recruited to use her skills to assist Kirsten in her new role as a \"stitcher\".</p>",
    officialSite: "http://freeform.go.com/shows/stitchers",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-02",
  },
  {
    id: 1845,
    url: "https://www.tvmaze.com/shows/1845/maron",
    name: "Maron",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/31/77676.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/31/77676.jpg",
    },
    summary:
      "<p>Marc Maron has been a comedian for 25 years. He's had his problems. He was an angry, drunk, self involved, twice divorced compulsive mess for most of his adult life, but with the popularity of a podcast he does in his garage and a life of sobriety, his life and career are turning around. <b>Maron </b>explores a fictionalized version of Marc's life, his relationships, and his career, including his incredibly popular WTF podcast, which features conversations Marc conducts with celebrities and fellow comedians. Neurosis intact, Maron is uniquely fascinating, absolutely compelling and brutally funny.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 65,
      name: "IFC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-05-03",
  },
  {
    id: 1846,
    url: "https://www.tvmaze.com/shows/1846/sexdrugsrockroll",
    name: "Sex&Drugs&Rock&Roll",
    genres: ["Comedy", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/29/73112.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/29/73112.jpg",
    },
    summary:
      "<p><b>Sex&amp;Drugs&amp;Rock&amp;Roll</b> follows Johnny Rock, lead singer of a legendary early 90s New York band called The Heathens. Known for living up to their name, the band partied so long and so hard that even Keith Richards thought they needed to slow things down. The Heathens were on the brink of becoming famous for their kickass live shows and the release of their highly anticipated first album. Until they broke up. The same day the album dropped. Because lead guitarist Flash found Johnny in bed with his wife. So the band became legendary for all the wrong reasons - like self-destructing sooner than any group in rock 'n' roll history. 25 years later the only thing bigger than Johnny's ego is his prostate. The drugs he really needs now aren't cocaine and marijuana - they're Crestor, Cymbalta and Cialis. He's out of work, out of money and out of show business options. That's when a massively talented young singer named Gigi shows up - with a burning desire to be famous, a throwback appreciation for The Heathens only album, and a stack of cash big enough to bring the whole band back into the studio. Only this time, she is the lead singer and Johnny is just a behind the scenes songwriter. The race is on to see who gets famous first - and for what reason.</p>",
    officialSite:
      "http://www.fxnetworks.com/shows/sex-drugs-rock-roll/episodes",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-16",
  },
  {
    id: 1847,
    url: "https://www.tvmaze.com/shows/1847/wet-hot-american-summer-first-day-of-camp",
    name: "Wet Hot American Summer: First Day of Camp",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/35306.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/35306.jpg",
    },
    summary:
      "<p><b>Wet Hot American Summer: First Day of Camp</b> tells the story of the first day of Camp Firewood's famous summer season, now fourteen years after the film's debut.</p>",
    officialSite: "https://www.netflix.com/title/80039813",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-07-31",
  },
  {
    id: 1848,
    url: "https://www.tvmaze.com/shows/1848/the-spoils-before-dying",
    name: "The Spoils Before Dying",
    genres: ["Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/149/374392.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/149/374392.jpg",
    },
    summary:
      "<p>Get your jazz hands ready, because Jonrosh's story takes viewers into the seedy underbelly of the 1950s jazz scene, in a detective story positively buzzing with erotic charge and a murder investigation that spins out of control.</p>",
    officialSite: "http://www.ifc.com/shows/the-spoils-before-dying",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 65,
      name: "IFC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-08",
  },
  {
    id: 1849,
    url: "https://www.tvmaze.com/shows/1849/tut",
    name: "Tut",
    genres: ["Drama", "Adventure", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/27033.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/27033.jpg",
    },
    summary:
      "<p>Spike's Tut tells the astounding saga of one of history's most extraordinary rulers, Tutankhamun (King Tut), his rise to power and his struggle to lead Egypt to glory, while his closest advisors, friends and lovers scheme for their own nefarious interests. \"Tut\" opens up a fascinating window into a world filled with heart-breaking romance, epic battles, political backstabbing, conspiracy, jealousy, and even murder -- proving his world was not far removed from our own -- and that his reign as the youngest Egyptian king played out as a real-life drama for the ages.</p>",
    officialSite: "http://www.spike.com/shows/tut",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 34,
      name: "Paramount Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-19",
  },
  {
    id: 1850,
    url: "https://www.tvmaze.com/shows/1850/supergirl",
    name: "Supergirl",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/300/750718.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/300/750718.jpg",
    },
    summary:
      "<p><b>Supergirl</b> is an action-adventure drama based on the DC Comics character Kara Zor-El, Superman's (Kal-El) cousin who, after 12 years of keeping her powers a secret on Earth, decides to finally embrace her superhuman abilities and be the hero she was always meant to be.</p>",
    officialSite: "http://www.cwtv.com/shows/supergirl",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-26",
  },
  {
    id: 1851,
    url: "https://www.tvmaze.com/shows/1851/dcs-legends-of-tomorrow",
    name: "DC's Legends of Tomorrow",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/315/787584.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/315/787584.jpg",
    },
    summary:
      "<p>When heroes alone are not enough... the world needs legends. Having seen the future, one he will desperately try to prevent from happening, time-traveling rogue Rip Hunter is tasked with assembling a disparate group of both heroes and villains to confront an unstoppable threat - one in which not only is the planet at stake, but all of time itself. Can this ragtag team defeat an immortal threat unlike anything they have ever known?</p>",
    officialSite: "http://www.cwtv.com/shows/dcs-legends-of-tomorrow",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2016-01-21",
  },
  {
    id: 1852,
    url: "https://www.tvmaze.com/shows/1852/shetland",
    name: "Shetland",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/27060.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/27060.jpg",
    },
    summary:
      "<p>A murder mystery set against the stunning Scottish backdrop of the Shetland Isles.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p01s711r",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-03-10",
  },
  {
    id: 1853,
    url: "https://www.tvmaze.com/shows/1853/partners",
    name: "Partners",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/27173.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/27173.jpg",
    },
    summary:
      "<p>In <b>Partners</b>, two lawyers from different backgrounds develop a partnership that forces them to find balance between their personal &amp; professional differenences</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-08-04",
  },
  {
    id: 1854,
    url: "https://www.tvmaze.com/shows/1854/ben-hur",
    name: "Ben Hur",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/27202.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/27202.jpg",
    },
    summary:
      "<p>About the struggle between the Roman Empire and its rebellious conquest Judaea, and two best friends caught in a terrible moment in history.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 36,
      name: "CBC",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2010-04-04",
  },
  {
    id: 1855,
    url: "https://www.tvmaze.com/shows/1855/blindspot",
    name: "Blindspot",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/250/625131.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/250/625131.jpg",
    },
    summary:
      "<p>A beautiful woman, with no memories of her past, is found naked in Times Square with her body fully covered in intricate tattoos. Her discovery sets off a vast and complex mystery that immediately ignites the attention of the FBI, which begins to follow the road map on her body into a larger conspiracy of crime, while bringing her closer to discovering the truth about her identity.</p>",
    officialSite: "http://www.nbc.com/blindspot",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-21",
  },
  {
    id: 1856,
    url: "https://www.tvmaze.com/shows/1856/dance-academy",
    name: "Dance Academy",
    genres: ["Drama", "Music", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/27269.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/27269.jpg",
    },
    summary:
      "<p>Fifteen year old Tara Webster has grown up on a farm in country Australia and has dreamt of being a dancer ever since she was a little girl. When she makes it into the National Academy of Dance - the best school in the country - she is sure her life is about to be spectacular. What Tara doesn't realise is how far behind she is in her training, and that there's a whole lot more to surviving the Academy than just dancing...</p>",
    officialSite: "http://www.abc.net.au/tv/programs/dance-academy/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 116,
      name: "ABC ME",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2010-05-31",
  },
  {
    id: 1857,
    url: "https://www.tvmaze.com/shows/1857/lekker-nederlands",
    name: "Lekker Nederlands",
    genres: ["Comedy", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/10/27318.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/10/27318.jpg",
    },
    summary:
      "<p>In this new musical program of SBS 6 called <b>Lekker Nederlands</b> will Nick &amp; Simon compete against Jeroen van Koningsbrugge and Dennis van de Ven (Jurk). They will re-write famous Dutch songs like 'Ademnood' and re-write international hits like 'Happy' and 'Waterloo' in a funny or original way.</p>",
    officialSite: "http://www.sbs6.nl/programmas/lekker-nederlands/",
    webChannel: null,
    language: "Dutch",
    status: "Ended",
    network: {
      id: 139,
      name: "SBS 6",
      country: {
        name: "Netherlands",
        code: "NL",
        timezone: "Europe/Amsterdam",
      },
    },
    premiered: "2015-04-18",
  },
  {
    id: 1858,
    url: "https://www.tvmaze.com/shows/1858/minority-report",
    name: "Minority Report",
    genres: ["Action", "Crime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/39/99142.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/39/99142.jpg",
    },
    summary:
      '<p>The future is coming.</p><p>Based on the international blockbuster film by executive producer Steven Spielberg and the first of his films to be adapted for television, <b>Minority Report </b>follows the unlikely partnership between a man haunted by the future and a cop haunted by her past, as they race to stop the worst crimes of the year 2065 before they happen.</p><p>Set in Washington, D.C., it is 10 years after the demise of Precrime, a law enforcement agency tasked with identifying and eliminating criminals…before their crimes were committed. To carry out this brand of justice, the agency used three precogs – "precognitives" Dash, Arthur and Agatha – who were able to see the future. Now, in 2065, crime-solving is different, and justice leans more on sophisticated and trusted technology than on the instincts of the precogs.</p>',
    officialSite: "http://www.fox.com/minority-report",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-21",
  },
  {
    id: 1859,
    url: "https://www.tvmaze.com/shows/1859/lucifer",
    name: "Lucifer",
    genres: ["Drama", "Crime", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/311/778443.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/311/778443.jpg",
    },
    summary:
      "<p>The Devil has come to Los Angeles…</p><p>Based upon the characters created by Neil Gaiman, Sam Kieth and Mike Dringenberg for DC Entertainment's Vertigo imprint, <b>Lucifer</b> is the story of the original fallen angel. Bored and unhappy as the Lord of Hell, Lucifer Morningstar has abandoned his throne and retired to L.A., where he owns Lux, an upscale nightclub.</p><p>Charming, charismatic and devilishly handsome, Lucifer is enjoying his retirement, indulging in a few of his favorite things--wine, women and song-–when a beautiful pop star is brutally murdered outside of Lux. For the first time in roughly 10 billion years, he feels something awaken deep within him as a result of this murder. Compassion? Sympathy? The very thought disturbs him--as well as his best friend and confidante, Mazkeen aka Maze, a fierce demon in the form of a beautiful young woman.</p>",
    officialSite: "https://www.netflix.com/title/80057918",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Running",
    network: null,
    premiered: "2016-01-25",
  },
  {
    id: 1861,
    url: "https://www.tvmaze.com/shows/1861/containment",
    name: "Containment",
    genres: ["Drama", "Horror", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/54/135379.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/54/135379.jpg",
    },
    summary:
      "<p>When a mysterious and deadly epidemic breaks out in Atlanta, a vast urban quarantine is quickly enforced, forcing those stuck on the inside to fight for their lives while local and federal officials desperately search for a cure. Trying to keep the peace on the streets is police officer Lex Carnahan, who has quickly risen through the ranks of the Atlanta PD. But Lex's job becomes even harder when he learns that his longtime girlfriend, Jana, and his best friend and fellow officer Jake, are trapped within the cordoned area. Also quarantined in viral ground zero is 17 year-old Teresa, who is eight months pregnant and now separated from her boyfriend on the other side; Katie Frank, an elementary school teacher now placed on lockdown with her entire class, including her young son; and CDC researcher Dr. Victor Cannerts, the doctor who initially made the controversial call to quarantine the area and is now racing to find a cure for the virus. On the outside, Dr. Sabine Lommers is leading the government efforts to contain the outbreak, and has asked for Lex's help in enforcing the cordon - which grows increasingly difficult as the public trust deteriorates. And the public has reason to be wary, as journalist Leo begins unraveling a conspiracy, finding that something doesn't add up in the official story being told. Torn apart from their loved ones, the survivors trapped within the cordon are fighting against not only fatal infection, but also isolation, fear, and the disintegration of society around them. But as they begin to gain each other's trust, hope remains, and on either side of the cordon unlikely heroes will rise.</p>",
    officialSite: "http://www.cwtv.com/shows/containment",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2016-04-19",
  },
  {
    id: 1862,
    url: "https://www.tvmaze.com/shows/1862/scream-queens",
    name: "Scream Queens",
    genres: ["Comedy", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/85/213832.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/85/213832.jpg",
    },
    summary:
      "<p>The girls of Kappa House are dying for new pledges. <b>Scream Queens</b> is a new killer comedy-horror series from Ryan Murphy, Brad Falchuk and Ian Brennan, the Emmy- and Golden Globe Award-winning executive producers of Glee and American Horror Story. Wallace University is rocked by a string of murders. Kappa House, the most sought-after sorority for pledges, is ruled with an iron fist (in a pink glove) by its Queen Bitch, Chanel Oberlin.</p><p>But when anti-Kappa Dean Munsch decrees that sorority pledging must be open to all students, and not just the school's silver-spooned elite, all hell is about to break loose, as a devil-clad killer begins wreaking havoc, claiming one victim, one episode at a time. Part black comedy, part slasher flick, Scream Queens is a modern take on the classic whodunit, in which every character has a motive for murder... or could easily be the next blood-soaked casualty.</p>",
    officialSite: "http://www.fox.com/scream-queens",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-22",
  },
  {
    id: 1863,
    url: "https://www.tvmaze.com/shows/1863/wicked-city",
    name: "Wicked City",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/26/66540.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/26/66540.jpg",
    },
    summary:
      "<p>Each season <b>Wicked City</b> will follow a different case set in a different noteworthy era of LA history, starting with a murder case from 1982 centered on the rock and roll, cocaine-infused revelry of the Sunset Strip. Alliances are formed between detectives, reporters, drug dealers and club-goers to solve a serial murder case.</p>",
    officialSite: "http://abc.go.com/shows/wicked-city/about-the-show",
    webChannel: {
      id: 2,
      name: "Hulu",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-10-27",
  },
  {
    id: 1864,
    url: "https://www.tvmaze.com/shows/1864/superstore",
    name: "Superstore",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/274/685151.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/274/685151.jpg",
    },
    summary:
      "<p><b>Superstore</b> is a workplace comedy about a unique family of employees at a super-sized megastore. From the bright-eyed newbies and the seen-it-all veterans to the clueless summer hires and in-it-for-life managers, together they hilariously tackle the day-to-day grind of rabid bargain hunters, riot-causing sales and nap-worthy training sessions.</p>",
    officialSite: "http://www.nbc.com/superstore",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-11-30",
  },
  {
    id: 1865,
    url: "https://www.tvmaze.com/shows/1865/dr-ken",
    name: "Dr. Ken",
    genres: ["Comedy", "Family", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52350.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52350.jpg",
    },
    summary:
      "<p>Doctor turned actor/comedian Ken Jeong plays <b>Dr. Ken</b>, a brilliant physician with no bedside manner. He is always trying to be a good doctor, as well as a good husband and dad to his two kids. However, these good intentions have a way of driving everyone crazy at both work and at home. Luckily, his therapist wife Allison is just the right partner to keep things sane.</p>",
    officialSite: "http://abc.go.com/shows/dr-ken",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-02",
  },
  {
    id: 1866,
    url: "https://www.tvmaze.com/shows/1866/the-muppets",
    name: "The Muppets",
    genres: ["Comedy", "Children", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27508.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27508.jpg",
    },
    summary:
      "<p><i>The Muppets</i> return to prime time with a contemporary, documentary-style show that, for the first time ever, will explore the Muppets' personal lives and relationships, both at home and at work, as well as romances, break-ups, achievements, disappointments, wants and desires; a more adult Muppet show, for kids of all ages.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-22",
  },
  {
    id: 1867,
    url: "https://www.tvmaze.com/shows/1867/second-chance",
    name: "Second Chance",
    genres: ["Drama", "Crime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/159/397647.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/159/397647.jpg",
    },
    summary:
      "<p>A thrilling new action-drama about a man brought back to life by two scientists playing god in the quest to save one of their own lives. Seventy-five-year-old Jimmy Pritchard is a shell of his former self. A drinker, a womanizer and a father who always put work before family, Pritchard was forced to resign as L.A. County Sheriff for corrupt conduct more than a decade ago. Now, some 15 unkind years later, he is killed when he stumbles upon a robbery at the home of FBI Agent Duval Pritchard, one of his two children. But death is surprisingly short for Jimmy, who is brought back to life by billionaire tech-genius twins Mary Goodwin and her brother, Otto, founders of the social networking empire, Lookinglass. Resurrected as a younger, better version of himself, with physical abilities of which he never dreamed, a re-animated Pritchard is given a <b>Second Chance</b> at life. What will he do with it? Will he try to repair the damage he did to his family? Will he embrace a new sense of purpose or fall prey to old temptations?</p>",
    officialSite: "http://www.fox.com/lookinglass",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2016-01-13",
  },
  {
    id: 1868,
    url: "https://www.tvmaze.com/shows/1868/rosewood",
    name: "Rosewood",
    genres: ["Drama", "Crime", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/81/204177.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/81/204177.jpg",
    },
    summary:
      "<p>Meet the Beethoven of private pathologists... From executive producer Todd Harthan, <b>Rosewood</b> is the story of Dr. Beaumont Rosewood, Jr., the most brilliant private pathologist in Miami. Using his wildly sophisticated autopsy lab, he performs for-hire autopsies to uncover clues that the Miami PD can't see. His new partner-in-crime is Detective Villa a Miami PD detective with attitude and demons to spare. While she's impressed by Rosewood's incredible abilities, his constant optimism is more annoying than it is infectious. But somehow, week-to-week, this unlikely tag team will solve many crimes together. Joining Rosewood in his practice are his sister and \"toxicology queen,\" Pippy; and DNA specialist Tara Milly Izikoff aka TMI, who is Pippy's fiancée. Plagued with his own set of medical ailments, Rosewood sees that every moment of life should be embraced and lived to the fullest. And those moments of victims' lives that will never be are what drive him the most.</p>",
    officialSite: "http://www.fox.com/rosewood",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-23",
  },
  {
    id: 1869,
    url: "https://www.tvmaze.com/shows/1869/alone",
    name: "Alone",
    genres: ["Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/192/481495.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/192/481495.jpg",
    },
    summary:
      "<p><b>Alone</b> places ten hardcore survivalists alone in the wilderness - no camera crew, no teams, no producers - on a single mission to stay alive. At stake is $500,000 awarded to the person who can last the longest. They will face extreme isolation and psychological distress as they plunge into the unknown, self-documenting their experience.</p>",
    officialSite: "http://www.history.com/shows/alone",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-18",
  },
  {
    id: 1870,
    url: "https://www.tvmaze.com/shows/1870/leepu-pitbull",
    name: "Leepu & Pitbull",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31425.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31425.jpg",
    },
    summary:
      "<p><b>Leepu &amp; Pitbull</b> follows master mechanic Pitbull Steve and renowned Bangladeshi car designer, who is named Leepu, as they transform heaps of metal into a cash-producing business venture. Each week a customer with a beloved clunker, great story and small budget asks this odd couple to convert their bucket of bolts into a cool custom car. In this high-risk and high-octane undertaking, it's up to Leepu &amp; Pitbull to turn their differences into inspiration... as they MacGuyver fixes to build winning wheels, satisfy the customer and rev up the riches.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-23",
  },
  {
    id: 1871,
    url: "https://www.tvmaze.com/shows/1871/mr-robot",
    name: "Mr. Robot",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/211/528026.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/211/528026.jpg",
    },
    summary:
      "<p><b>Mr. Robot</b> follows Elliot, a young programmer who works as a cyber-security engineer by day and as a vigilante hacker by night. Elliot finds himself at a crossroads when the mysterious leader of an underground hacker group recruits him to destroy the firm he is paid to protect. Compelled by his personal beliefs, Elliot struggles to resist the chance to take down the multinational CEOs he believes are running (and ruining) the world.</p>",
    officialSite: "https://www.usanetwork.com/mr-robot",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-24",
  },
  {
    id: 1872,
    url: "https://www.tvmaze.com/shows/1872/cold-justice-sex-crimes",
    name: "Cold Justice: Sex Crimes",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/22/56927.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/22/56927.jpg",
    },
    summary:
      "<p><b>Cold Justice: Sex Crimes</b> is an extremely timely project, especially in light of the sobering statistics for sex-related crimes in America revealing that there are approximately 240,000 survivors of sexual assault in America, including men, women and children. In fact, every two minutes, someone is sexually assaulted in the United States. To combat these numbers and bring justice to the survivors of sexual assault, former Harris County, Texas, prosecutors Casey Garrett and Alicia O'Neill are traveling to small towns around the country to help local law enforcement close cases that have sat dormant for years.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-31",
  },
  {
    id: 1873,
    url: "https://www.tvmaze.com/shows/1873/significant-mother",
    name: "Significant Mother",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/84/210214.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/84/210214.jpg",
    },
    summary:
      "<p>In <b>Significant Mother</b> budding Portland restaurateur Nate's world is turned upside down when he comes back from a business trip to find his lothario best friend and roommate, Jimmy, is now dating his recently separated mother, Lydia. To make matters worse, Nate's previously disinterested dad, Harrison is now determined to win Lydia back and isn't afraid to use Nate to get what he wants. Stuck between his family feud and his best friend's first serious relationship, Nate's \"new normal\" forever changes his relationships with his parents, and severely handicaps his own dating life.</p>",
    officialSite: "https://www.cwtv.com/shows/significant-mother",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-03",
  },
  {
    id: 1874,
    url: "https://www.tvmaze.com/shows/1874/mr-robinson",
    name: "Mr. Robinson",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31449.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31449.jpg",
    },
    summary:
      "<p>As lead singer and keyboardist of the funk band Nasty Delicious, Craig knows a thing or two about working the crowd, but his day job is where he really makes the grade. Every struggling artist knows the drill: You've got to pay the bills while you wait for that big break. So when Craig finds himself short on cash, he takes a job as a substitute high school music teacher. It's an easy gig, right? The school principal believes that rules were made to be strictly upheld. She's none too fond of Craig's unorthodox teaching style, or his crush on the pretty English teacher. It's a constant struggle for Craig, having one foot in the music world with his band, Nasty Delicious, and one foot in the teaching world. But if Craig wants to get the girl of his dreams and teach these kids the joys of music, he'll have to buckle down, shape up and get the funk out. <b>Mr. Robinson</b> is inspired by Robinson's real-life experiences as a music teacher.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-05",
  },
  {
    id: 1875,
    url: "https://www.tvmaze.com/shows/1875/public-morals",
    name: "Public Morals",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/25/64060.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/25/64060.jpg",
    },
    summary:
      "<p>This summer, TNT is going to take viewers to the seedy, gritty streets and the bright, seductive lights of 1960s New York with <b>Public Morals</b>, a powerful, buzz-generating police drama from writer, director, executive producer and star Edward Burns (Saving Private Ryan, The Brothers McMullen, TNT's Mob City). Public Morals also stars Michael Rapaport (Justified, Prison Break) and Elizabeth Masucci (The Americans, Inside Amy Schumer). The series centers on Terry Muldoon (Burns), an officer of the Public Morals Division, which investigates vice crimes in the city. Many of Muldoon's fellow cops in the division walk a thin line between morality and crime as vice-related temptations threaten to snare even the best of officers, including Muldoon's partner, Charlie Bullman (Rapoport). As Muldoon watches the Hells Kitchen streets where he grew up devoured by an escalating war within two factions of the Irish-American Mob, he becomes more determined than ever to fight back against the city's dark underbelly so he can provide a safe place where he and his wife, Christine (Masucci), can raise their family.</p>",
    officialSite:
      "http://www.tntdrama.com/shows/public-morals.html%20?sr=public_morals_tnt",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-25",
  },
  {
    id: 1876,
    url: "https://www.tvmaze.com/shows/1876/todrick",
    name: "Todrick",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31513.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31513.jpg",
    },
    summary:
      "<p>In his new weekly MTV docu-series, quadruple-threat Todrick Hall lets fans into his creative factory and introduces them to the passionate troupe of creative collaborators who pour heart and soul into his weekly videos.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-31",
  },
  {
    id: 1877,
    url: "https://www.tvmaze.com/shows/1877/girl-code-live",
    name: "Girl Code Live",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/16/40913.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/16/40913.jpg",
    },
    summary:
      '<p><i><b>"Girl Code Live"</b></i> is a weekly half-hour late night talk show hosted by three hilarious ladies from "Girl Code" - Nessa, Carly and Awkwafina. The series will feature celebrity guests, musical artists, fun games and candid girl-talk in front of a live studio audience.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-31",
  },
  {
    id: 1878,
    url: "https://www.tvmaze.com/shows/1878/thunderbirds-are-go",
    name: "Thunderbirds Are Go",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/250/627103.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/250/627103.jpg",
    },
    summary:
      "<p><b>Thunderbirds Are Go</b> is a remake of the hit 1960's television show. In the 21st century, Jeff Tracy, a former astronaut, amasses a colossal fortune and decides that he must use it to benefit others. His answer to this desire is to create International Rescue, a unique private emergency response service equipped with customized designed vehicles and equipment that enable the organization to react to any crisis whether it be in sea, air, land, or space. Jeff's five sons volunteer to operate as the pilots and field agents, as well \"Brain\" who acts as the teams engineer. In addition, Jeff's friend, Kyrano and his daughter Tanusha aka Kayo (based on the original series Tin-Tin character) agree to be the support staff. In addition to the field team, IR also maintains an intelligence network with Lady Penelope and her ex-con chauffeur, Parker as the chief agents in this arm. The series depicts this team as they answer various calls for help around and beyond the world while they prevent enemies like the Hood from learning and exploiting their secrets.</p>",
    officialSite: "http://www.thunderbirds.com/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-04-04",
  },
  {
    id: 1879,
    url: "https://www.tvmaze.com/shows/1879/femme-fatales",
    name: "Femme Fatales",
    genres: ["Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27536.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27536.jpg",
    },
    summary:
      "<p>Inspired by and styled in the tradition of pulp stories, film noir and graphic novels, this provocative hit series tells the stories of dangerous women who find extraordinary ways of coping with their problems, channeling their survival instincts and bringing out their inner guile.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 19,
      name: "Cinemax",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-05-13",
  },
  {
    id: 1880,
    url: "https://www.tvmaze.com/shows/1880/no-offence",
    name: "No Offence",
    genres: ["Drama", "Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/48/121682.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/48/121682.jpg",
    },
    summary:
      "<p><b>No Offence</b> follows a team of cops in the heart of crime. This team of cops are tough but big-hearted who go above and beyond to bring down criminals. Set on one of the worst parts of town there is a demoralizing list of crimes: drug labs, arsonists, neo-Nazis and notorious murderers. These are just a days work for this team. However when a serial killer emerges it leaves the team and DI Vivienne Deering reeling. Joined by her right-hand women DC Dinah Kowlaska and DS Joy Freers they must crack the case by whatever means possible.</p>",
    officialSite: "http://www.channel4.com/programmes/no-offence",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-05-05",
  },
  {
    id: 1881,
    url: "https://www.tvmaze.com/shows/1881/ancient-impossible",
    name: "Ancient Impossible",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/224/561196.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/224/561196.jpg",
    },
    summary:
      "<p><b>Ancient Impossible</b>, the H2 series, picks up where History's long running \"Ancient Discoveries\" left off. In this next generation of storytelling, Ancient Impossible reveals how many of today's technological achievements were actually developed centuries ago. Colossal monuments, impossible feats of engineering and technologies so precise they defy reinvention–the ancient world was far more advanced than we ever imagined. We'll travel through history to reveal a radically different picture of the past, with innovations so far ahead of their time, they're still in use today. New science uncovers a lost world more like our own than we ever suspected, and reveals how modern technology has its blueprint in the ancient world.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 74,
      name: "H2",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-06-29",
  },
  {
    id: 1882,
    url: "https://www.tvmaze.com/shows/1882/stan-lees-superhumans",
    name: "Stan Lee's Superhumans",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27585.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27585.jpg",
    },
    summary:
      '<p>Stan Lee, creator of such legendary comic book characters as Spider-man, Hulk, X-Men and the Fantastic Four, will be getting his own History Channel series. Titled <b>Superhumans</b>, the series will "find people who have remarkable abilities because of being genetically different" and will feature Lee as co-shot alongside the world\'s most flexible man, Daniel Browning Smith.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 74,
      name: "H2",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-08-05",
  },
  {
    id: 1883,
    url: "https://www.tvmaze.com/shows/1883/dara-o-briains-science-club",
    name: "Dara O Briain's Science Club",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27586.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27586.jpg",
    },
    summary:
      "<p>Experts and a lively audience join Dara O Briain to tackle the biggest concepts in science and discover the great ideas that are changing the world we live in.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b037mkj3",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-11-06",
  },
  {
    id: 1884,
    url: "https://www.tvmaze.com/shows/1884/wild-palms",
    name: "Wild Palms",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27587.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27587.jpg",
    },
    summary:
      "<p>A dark, sexy, noir Los Angeles of the future is the backdrop for Oliver Stone's haunting, sci-fi saga of greed, treason and virtual reality. Harry Wyckoff is about to become a player in a dark and terrifying battle where everything is at stake and no one is who they seem. Featuring an all-star cast, this story about a cult, a corporation, and a conspiracy to rule the country, is one of the most original movie events in recent history.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-05-16",
  },
  {
    id: 1885,
    url: "https://www.tvmaze.com/shows/1885/vip",
    name: "V.I.P.",
    genres: ["Comedy", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27588.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27588.jpg",
    },
    summary:
      "<p>A campy syndicated series about Vallery Irons, a girl working at a hot-dog stand who accidentally saves a celebrity and is mistaken for a bodyguard. She and a team of beautiful bodyguards form a bodyguard agency called V.I.P. which stands for Vallery Irons Protection. When Vallery Irons first comes to California, she has no idea that her big break will come from a date with a famous action star. While attending a Hollywood premiere, a crazed fan pulls a gun - but her movie hunk turns into a coward, and it's Vallery who becomes the hero. Suddenly, she's thrown into a world of action and danger as owner of a Hollywood protection agency (V.I.P. or Vallery Irons Protection), taking the risks to protect others at a price few are willing to pay.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-09-26",
  },
  {
    id: 1886,
    url: "https://www.tvmaze.com/shows/1886/sweating-bullets",
    name: "Sweating Bullets",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27593.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27593.jpg",
    },
    summary:
      "<p>After an unconventional DEA cop gets fired, he begins a new job as a private investigator in Florida. Feeling at first like he was in paradise, it wasn't long before his eyes were opened to both the ugliness of the crimes and the beauty of the women.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1991-04-08",
  },
  {
    id: 1887,
    url: "https://www.tvmaze.com/shows/1887/this-is-england",
    name: "This is England",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27594.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27594.jpg",
    },
    summary:
      "<p>The first two series of the Channel 4 drama written and directed by Shane Meadows revisiting the characters from his 2007 film <b>This is England</b>. In This is England '86 Thomas Turgoose reprises his role as Shaun, a school-leaver with few prospects in mid-1980s England. Shaun and his friends must attempt to deal with the issues posed by the transition to adulthood in an unstable social climate where 3.4 million people are unemployed and there are strikes, race riots and anti-nuclear protests. The events of This is England '88 take place two years on from the initial spin-off series. Set in and around Christmas, there is a distinct absence of festive spirit as Lol (Vicky McClure) and Woody (Joe Gilgun) struggle to come to terms with events from the past. Shaun, meanwhile, learns first-hand the pain that love can bring.</p>",
    officialSite: "http://www.channel4.com/programmes/this-is-england-90",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-09-07",
  },
  {
    id: 1888,
    url: "https://www.tvmaze.com/shows/1888/the-team",
    name: "The Team",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/164/411992.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/164/411992.jpg",
    },
    summary:
      "<p>Criminals don't stop at borders, and neither should the police. <b>The Team</b> portrays a group of European police officers fighting international crime throughout Europe. The series is written by specialists Peter Thorsboe and Mai Brostrøm (The Eagle, The Protectors) – names that guarantee well-grounded and vividly inventive cases with complex, stimulating characters.</p><p><i>The Team</i> consists of forensics, legal and IT experts, along with profilers and psychologists; their cases take them to Europe's major cities. The series benefits from Europe's huge cultural diversity and is shot in original languages. It sheds light into the reality of today's organized crime, as well as into the fates behind the crimes. <i>The Team</i> sees to it that justice wins and the victims' dignity is restored.</p>",
    officialSite: "http://theteam.zdfe-b2b.de",
    webChannel: null,
    language: "German",
    status: "To Be Determined",
    network: {
      id: 115,
      name: "DR1",
      country: { name: "Denmark", code: "DK", timezone: "Europe/Copenhagen" },
    },
    premiered: "2015-02-28",
  },
  {
    id: 1889,
    url: "https://www.tvmaze.com/shows/1889/taken",
    name: "Taken",
    genres: ["Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27603.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27603.jpg",
    },
    summary:
      '<p>Covering a period from 1947 to the present, <b>Taken </b>focused on three different families, each of whom was profoundly affected by extraterrestrial visitation. The Keys family was headed by WWII bomber pilot Russell Keys, who spent virtually his entire adult life haunted by his "close encounter" with aliens. The Clarkes were originally represented by lonely Texas waitress Sally Clarke, who was impregnated by a charming stranger (John) who turned out to be an alien survivor of the Roswell crash. And the lives of the Crawfords were dictated by ruthless Army officer Owen Crawford, who was determined to prove that the government had covered up the truth about Roswell by dedicating his life to tracking down all space aliens and their half-human descendants. The story was narrated by Allie Keys, a "hybrid" child of the present day, whose story determined the outcome of the final episodes.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-12-02",
  },
  {
    id: 1890,
    url: "https://www.tvmaze.com/shows/1890/stripperella",
    name: "Stripperella",
    genres: ["Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27609.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27609.jpg",
    },
    summary:
      '<p>A stripper-turned-superhero who fends off evil villains such as Dr. Cesarean, a plastic surgeon who gives unsuspecting women explosive breast implants; Cheapo, a frugal villain who makes his henchmen share a gun and Pushy Galore, a former genetic physicist who breeds animals with designer logos on their skin. With the ability to land safely after jumping from tall buildings, courtesy of her enhanced hair, and her patented move called "Scissor-ella" in which she crushes the villains with her thighs, along with the lie detector implanted in her generously-sized chest, Stripperella proves to be one tough superhero unwilling to give up.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 34,
      name: "Paramount Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-06-26",
  },
  {
    id: 1891,
    url: "https://www.tvmaze.com/shows/1891/secret-agent-man",
    name: "Secret Agent Man",
    genres: ["Action", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755286.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755286.jpg",
    },
    summary:
      "<p>A lighthearted espionage show about a cocky spy who teamed with two by-the-book agents to battle global menaces.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 70,
      name: "UPN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-03-07",
  },
  {
    id: 1892,
    url: "https://www.tvmaze.com/shows/1892/sledge-hammer",
    name: "Sledge Hammer",
    genres: ["Comedy", "Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27611.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27611.jpg",
    },
    summary:
      "<p>Meet Inspector <b>Sledge Hammer</b>, a new kind of hero who makes Rambo look like Pee Wee Herman. Sledge is the trigger-happy lawman whose hatred of criminal scum and yogurt eatin' creeps was matched only by his love of excessive force and a .44 Magnum. Over the next two seasons, this hilariously deranged lampoon of Dirty Harry and plenty of other targets became one of the most notorious series in television history and launched a rabid cult of fans that grows to this day.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1986-09-23",
  },
  {
    id: 1893,
    url: "https://www.tvmaze.com/shows/1893/silk-stalkings",
    name: "Silk Stalkings",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27613.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27613.jpg",
    },
    summary:
      "<p>In Palm Beach Florida, crimes of passion are a frequent occurrence among the rich and beautiful. Enter Sgt. Rita Lance and Sgt. Chris Lorenzo the attractive young homicide detectives whose job it is to investigate these high-class murders--or Silk Stalkings, as they call them. Pulsing with illicit affairs, kinky encounters, cold-blooded murders, and their own dark secrets, these are the deadly days and steamy nights of two sexiest cop partners.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1991-11-07",
  },
  {
    id: 1894,
    url: "https://www.tvmaze.com/shows/1894/queen-of-swords",
    name: "Queen of Swords",
    genres: ["Action", "Adventure", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27614.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27614.jpg",
    },
    summary:
      "<p>In 1817, a young Spanish aristocrat, Tessa Alvarado, returns to Spanish California after the death of her father and finds her home in ruins, her father's manservant reduced to stealing. The town where she was born is run by a militaristic governor who abuses his power, resulting in the miscarriage of justice and the poor living conditions of his subjects. Upset about the state of her birthplace and the murder of her father, Tessa's path is revealed to her in a mysterious dream where her father comes to her and talks of his murder, his hidden gold, and of his \"Avenging Angel\". She will take up arms to protect the people from the town's governor and to avenge her father's death. Tessa will do this in disguise behind a mask, becoming that \"Avenging Angel\", <i>The Queen of Swords</i>.</p><p>As the Queen of Swords, Tessa becomes a vision of hope for the people who live in her long oppressed town.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-10-07",
  },
  {
    id: 1895,
    url: "https://www.tvmaze.com/shows/1895/relic-hunter",
    name: "Relic Hunter",
    genres: ["Action", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27618.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27618.jpg",
    },
    summary:
      "<p>Tia Carrere stars as a university professor and black belt who globetrots after lost, stolen and rumored-of artifacts and antiquities.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-09-25",
  },
  {
    id: 1896,
    url: "https://www.tvmaze.com/shows/1896/renegade",
    name: "Renegade",
    genres: ["Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27623.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27623.jpg",
    },
    summary:
      "<p>On the run &amp; on the road! An innocent man on a quest to clear his name! He was a cop, and good at his job. But he committed the ultimate sin, and testified against other cops gone bad. Cops that tried to kill him, but got the woman he loved instead. Framed for murder, now he prowls the badlands. An outlaw hunting outlaws, a bounty hunter, a Renegade.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1992-09-19",
  },
  {
    id: 1897,
    url: "https://www.tvmaze.com/shows/1897/point-pleasant",
    name: "Point Pleasant",
    genres: ["Drama", "Horror", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27628.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27628.jpg",
    },
    summary:
      "<p>All hell is about to break loose in a sleepy New Jersey town when a sudden violent storm washes in more than the tide. The peaceful existence of a small seaside community will dramatically change forever when Christina Nickson is rescued from the ocean by local lifeguard Jesse Parker and brought to the home of local doctor Ben Kramer. The Kramers, including Ben's wife, Meg, and daughter, Judy, take an instant liking to Christina and invite her stay with them as she searches for clues to her past and attempts to find her mother, a Point Pleasant native whom Christina never knew. Unbeknownst to Christina, her presence in the town is having a profound effect on its inhabitants - awakening repressed feelings, unlocking secret desires and heightening emotions. As Christina seeks answers to her mother's disappearance, she will come to realize that she has never known her \"real\" father either - for Christina is the offspring of a mortal woman and the Devil. While Christina struggles to control the demon inside her (and the powers that come with it), the fight for her soul has begun and the town of Point Pleasant has turned into the ultimate battleground of good vs. evil.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-01-19",
  },
  {
    id: 1898,
    url: "https://www.tvmaze.com/shows/1898/gargoyles",
    name: "Gargoyles",
    genres: ["Action", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27638.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27638.jpg",
    },
    summary:
      "<p>For 1,000 years, a race of heroic creatures has been frozen in stone -- the victims of human betrayal. Now, with the magic spell broken, these amazing Gargoyles awaken from their slumber to find themselves transported from the moors of Scotland to the bustling metropolis of New York City.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1994-10-24",
  },
  {
    id: 1899,
    url: "https://www.tvmaze.com/shows/1899/gantz",
    name: "Gantz",
    genres: ["Adventure", "Anime", "Horror", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27649.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27649.jpg",
    },
    summary:
      "<p>Gantz is a sexually-charged sci-fi head-trip' a gory experiment in flesh and blood where the only thing worse than dying is dying again.<br>If you are chosen by the bizarre black sphere known as the Gantz, you are already dead. You remember dying, yet you can eat, sleep, have sex; it feels a lot like life. Strangers join you in this limbo. While some are good, some are very bad. All are dead like you for now. <br>You might be able to reclaim your mortality. But first, the Gantz demands that you undertake missions of brutality and madness, killing aliens hidden among the population. It is your only chance and you have no choice. You must play this disturbing game. You must experience this nightmare. And if you die again and you likely will it's permanent.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 131,
      name: "Fuji TV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2004-04-12",
  },
  {
    id: 1900,
    url: "https://www.tvmaze.com/shows/1900/the-crow-stairway-to-heaven",
    name: "The Crow: Stairway to Heaven",
    genres: ["Action", "Fantasy", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27653.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27653.jpg",
    },
    summary:
      "<p>Exactly one year after being brutally murdered, rock musician Eric Draven returns to Earth, searching for a way to right what has been wronged and to reunite with his missing soulmate, Shelly Webster. Guided by a mystical Spirit Crow, he is neither living nor dead, possessing strange new powers to aid him in his search for revenge, which ultimately must become a quest for redemption.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-09-25",
  },
  {
    id: 1901,
    url: "https://www.tvmaze.com/shows/1901/honey-west",
    name: "Honey West",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27654.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27654.jpg",
    },
    summary:
      "<p>As televisions first title roll female Private Eye, Honey West would take on any tough case. After the death of her father, the sexy private detective took over his high-tech PI firm. Being assisted by the rugged Sam Bolt and her pet ocelot Bruce, she could handle herself mingling with millionaires just as well as scaling a thirty foot wall.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1965-09-17",
  },
  {
    id: 1902,
    url: "https://www.tvmaze.com/shows/1902/black-scorpion",
    name: "Black Scorpion",
    genres: ["Action", "Crime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27655.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27655.jpg",
    },
    summary:
      "<p>After her father is shot by a crooked district attorney, Angel City police Detective Darcy Walker takes to the streets to dispense vigilante justice in the guise of the <b>Black Scorpion</b>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-01-05",
  },
  {
    id: 1903,
    url: "https://www.tvmaze.com/shows/1903/beastmaster",
    name: "Beastmaster",
    genres: ["Action", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27657.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27657.jpg",
    },
    summary:
      "<p>The sword and sorcery adventures of a wandering adventurer who has the ability to communicate with animals.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-10-09",
  },
  {
    id: 1904,
    url: "https://www.tvmaze.com/shows/1904/largo-winch",
    name: "Largo Winch",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27661.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27661.jpg",
    },
    summary:
      "<p>One day, <b>Largo Winch</b> had nothing, the next day he inherited 385 billion dollars and leadership of one of the most powerful multinational companies in the world: Group W. He also inherited many enemies, in particular the Adriatic Commission, who are responsible for his father's death. To aid Largo in his fight against the Commission and against the board of Group W, who are none to happy that he's determined to root out the greed and corruption that are common practice at Group W, he forms a team of advisers consisting of his longtime friend Simon Ovronnaz, Georgy Kerensky, a former KGB agent who's high-tech expert, ex-CIA agent Joy Arden and his father's adviser, John Sullivan. Largo is also struggling with feelings about his father, who never acknowledged him.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-09-07",
  },
  {
    id: 1905,
    url: "https://www.tvmaze.com/shows/1905/bleach",
    name: "Bleach",
    genres: ["Action", "Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27676.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27676.jpg",
    },
    summary:
      "<p>Ichigo Kurosaki is a teenager gifted with the ability to see spirits. His life is drastically changed by the sudden appearance of a Soul Reaper—one who governs the flow of souls between the human world and the afterlife—named Rukia Kuchiki, who arrives in search of a Hollow, a dangerous lost soul. When Rukia is severely wounded defending Ichigo from the Hollow, she attempts to transfer half of her reiatsu energy to Ichigo so that he can defeat the Hollow. However, Ichigo takes almost all of her energy, transforming into a Soul Reaper and allowing him to defeat the Hollow with ease. With her powers diminished, Rukia is left stranded in the human world until she can recover her strength. In the meantime, Ichigo must take over Rukia's role as a Soul Reaper, battling Hollows and guiding souls to the afterlife realm known as the Soul Society.</p>",
    officialSite: "http://www.tv-tokyo.co.jp/anime/bleach/index2.html",
    webChannel: {
      id: 20,
      name: "Crunchyroll",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "Japanese",
    status: "Running",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2004-10-05",
  },
  {
    id: 1906,
    url: "https://www.tvmaze.com/shows/1906/rurouni-kenshin",
    name: "Rurouni Kenshin",
    genres: ["Drama", "Action", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27683.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27683.jpg",
    },
    summary:
      '<p>Welcome to the Meiji Era. Japan is a land experiencing times of troubled peace and renewal after a long and bloody civil war. Swords and killing are outlawed, but all is not as well as it would seem. Lurking in the shadows are many survivors of the revolution awaiting their chance for vengeance. Only the former government assassin, Kenshin Himura can keep the peace. Kenshin gives up the life of "Battousai The Man Slayer" and sets off as a lone wanderer. His travels lead to the Kamiya Dojo where he discovers the chance to start life over.</p>',
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 131,
      name: "Fuji TV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1996-01-10",
  },
  {
    id: 1907,
    url: "https://www.tvmaze.com/shows/1907/robocop",
    name: "RoboCop",
    genres: ["Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27697.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27697.jpg",
    },
    summary:
      '<p>In this continuation of the movie franchise, Alex Murphy is <b>RoboCop</b>, a deceased cop brought back to life through cybernetic technology. Now he fights crime on the streets of Detroit and deals with the machinations of OCP, the company that "created" him.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 48,
      name: "CTV",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "1994-03-18",
  },
  {
    id: 1908,
    url: "https://www.tvmaze.com/shows/1908/robocop-prime-directives",
    name: "RoboCop: Prime Directives",
    genres: ["Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27698.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27698.jpg",
    },
    summary:
      "<p>The OCP, teetering on the brink of bankruptcy, is taken over by a scheming executive; RoboCop and RoboCable work together to save Delta City.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-01-04",
  },
  {
    id: 1909,
    url: "https://www.tvmaze.com/shows/1909/aeon-flux",
    name: "Aeon Flux",
    genres: ["Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27699.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27699.jpg",
    },
    summary:
      "<p>Follow the deftly skilled Aeon on her adventures through a futuristic world brimming with chaos and corruption.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1991-09-01",
  },
  {
    id: 1910,
    url: "https://www.tvmaze.com/shows/1910/bron-broen",
    name: "Bron / Broen",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27700.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27700.jpg",
    },
    summary:
      "<p>When a body is found on the bridge between Denmark and Sweden, right on the border, Danish inspector Martin Rohde and Swedish Saga Norén have to share jurisdiction and work together to find the killer.</p>",
    officialSite: "http://www.svt.se/bron/",
    webChannel: null,
    language: "Swedish",
    status: "Ended",
    network: {
      id: 155,
      name: "SVT1",
      country: { name: "Sweden", code: "SE", timezone: "Europe/Stockholm" },
    },
    premiered: "2011-09-28",
  },
  {
    id: 1911,
    url: "https://www.tvmaze.com/shows/1911/highlander",
    name: "Highlander",
    genres: ["Drama", "Action", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27706.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27706.jpg",
    },
    summary:
      '<p><i>"I am Duncan Macleod, born 400 years ago in the Highlands of Scotland. I am Immortal, and I am not alone. For centuries we have waited for the time of the Gathering, when the stroke of a sword and the fall of a head will release the power of the Quickening. In the end, there can be only one."</i></p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1992-10-03",
  },
  {
    id: 1912,
    url: "https://www.tvmaze.com/shows/1912/highlander-the-raven",
    name: "Highlander: The Raven",
    genres: ["Drama", "Action", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27714.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27714.jpg",
    },
    summary:
      '<p>"She is a creature of legend…like the Raven, a thief who stole the sun and the moon. They sent a warrior to bring her back. He found her, and together they brought light back to the world. Sexy Amanda Derieux, teaming up with freelance security expert, Nick Wolfe, puts her high octane arsenal of charisma and sassy, good looks into full force to charm, confound and, when necessary, destroy Immortals bent on evil</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-09-26",
  },
  {
    id: 1913,
    url: "https://www.tvmaze.com/shows/1913/the-hunger",
    name: "The Hunger",
    genres: ["Drama", "Horror", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27717.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27717.jpg",
    },
    summary:
      "<p><b>The Hunger</b> is a spine-tingling horror anthology series from Executive Producers Tony and Ridley Scott. Each episode will draw you into a mesmerizing world of terrifying characters and erotic encounters, where demons feed on the weakness of men and temptation consumes reason.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1997-07-20",
  },
  {
    id: 1914,
    url: "https://www.tvmaze.com/shows/1914/code-37",
    name: "Code 37",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27719.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27719.jpg",
    },
    summary:
      '<p>Code 37 is a television series of the Flemish broadcaster VTM. Production started in April 2009. At first it was called Erika Maes , but later they still chose a different name. The series started on 31 August 2009.</p><p>The story revolves around a police force specializing in sexual offenses. Code " 37 " is the code used by the prosecutors for the charges of sexual offenses . According to the Belgian Code sexual offenses include rape, incest, (child) pornography, sexual abuse of minors, child abuse, pedophilia, exhibitionism, sexual assault, sexual harassment, sexual discrimination, prostitution and incitement seen or organizing all of the above.</p>',
    officialSite:
      "https://vtm.be/vtmgo/code-37~p2266c87a-d8f3-4591-bf9d-668ae5a4830d",
    webChannel: null,
    language: "Dutch",
    status: "Ended",
    network: {
      id: 156,
      name: "VTM",
      country: { name: "Belgium", code: "BE", timezone: "Europe/Brussels" },
    },
    premiered: "2009-08-31",
  },
  {
    id: 1915,
    url: "https://www.tvmaze.com/shows/1915/death-parade",
    name: "Death Parade",
    genres: ["Anime", "Fantasy", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27724.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27724.jpg",
    },
    summary:
      "<p>There is a place after death that's neither heaven nor hell. A bar that serves you one chance to win. You cannot leave until the game is over, and when it is, your life may be too. From Studio Madhouse (Death Note, Black Lagoon) comes a thrilling new series where the stakes are high and the rules are simple: your life is on the line.</p>",
    officialSite: "http://www.deathparade.jp",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 137,
      name: "NTV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2015-01-10",
  },
  {
    id: 1916,
    url: "https://www.tvmaze.com/shows/1916/tatakau-shisho-the-book-of-bantorra",
    name: "Tatakau Shisho: The Book of Bantorra",
    genres: ["Action", "Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27726.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27726.jpg",
    },
    summary:
      "<p>In another time and place, on a world of pain and sorrow, when someone dies, their soul doesn't go to Heaven or Hell - it becomes a book. A book that reveals the deceased's innermost secrets and that can be read by anyone. Protecting these priceless treasures is the elite organization known as the Armed Librarians. It's their job to keep the books and the knowledge within them safe from those who would misuse or destroy them. It's a tough, dangerous job, so Chief Librarian Hamyuts Maseta recruits only the best and the brightest psychics to join her team of expert fighters. Even so, will they be able to stop the fanatics of the Shindeki Church from wreaking vengeance on the entire world? Only time will tell, but that book hasn't been written yet.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 157,
      name: "Animax",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2009-10-02",
  },
  {
    id: 1918,
    url: "https://www.tvmaze.com/shows/1918/camp",
    name: "Camp",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27727.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27727.jpg",
    },
    summary:
      "<p>The series explores the campers and counselors at Little Otter Family Camp, where summer memories are made.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-07-10",
  },
  {
    id: 1919,
    url: "https://www.tvmaze.com/shows/1919/starhunter",
    name: "Starhunter",
    genres: ["Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27728.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27728.jpg",
    },
    summary:
      "<p>The year is 2275. Earth has colonized the entire solar system, but things are dangerous out there. Enter Dante Montana, a reluctant bounty hunter haunted by his past, who, along with his crew, travels the universe in pursuit of dangerous interplanetary criminals, including The Raiders—an evil force that Dante believes kidnapped his son. Meanwhile, covert forces are waging a desperate war to unlock the secrets of the Divinity Cluster—powerful knowledge that in the wrong hands would mean universal domination...</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 7,
      name: "CTV Sci-Fi Channel",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2000-11-01",
  },
  {
    id: 1920,
    url: "https://www.tvmaze.com/shows/1920/fastlane",
    name: "Fastlane",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/258/646821.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/258/646821.jpg",
    },
    summary:
      "<p>A flashy action series about a pair of mismatched cops taking on L.A.'s lawless with the help of a beautiful boss and a warehouse full of high-end props and confiscated property.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-09-18",
  },
  {
    id: 1921,
    url: "https://www.tvmaze.com/shows/1921/special-unit-2",
    name: "Special Unit 2",
    genres: ["Comedy", "Action", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27783.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27783.jpg",
    },
    summary:
      "<p>A young Chicago cop and a veteran officer battle monsters terrorizing the city in a tongue-in-cheek adventure that suggests the creatures are the missing link between man and apes.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 70,
      name: "UPN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-04-11",
  },
  {
    id: 1922,
    url: "https://www.tvmaze.com/shows/1922/mann-machine",
    name: "Mann & Machine",
    genres: ["Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755289.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755289.jpg",
    },
    summary:
      "<p>Futuristic crime story in which an L.A. cop is partnered with a cyborg partner, who has the sparkle of Data from `Star Trek' combined with the body of Julie Newmar from `My Living Doll.' Plus, as her partner puts it, `She's never had the experience of being wrong.'</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1992-04-05",
  },
  {
    id: 1923,
    url: "https://www.tvmaze.com/shows/1923/bubblegum-crisis-tokyo-2040",
    name: "Bubblegum Crisis: Tokyo 2040",
    genres: ["Action", "Adventure", "Anime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27790.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27790.jpg",
    },
    summary:
      "<p>In the aftermath of the great earthquake, one ruthless corporation stands ready to take over the devastated city of Tokyo with an army of synthetic monsters. Only a single band of female vigilantes opposes the monolithic power of Genom - but in this case, four women are all it takes! Armed with the most incredible combat suits ever designed, the Knight Sabers wage a desperate war in the shadows, combating the monstrous by-products of technology run amuck with courage, sweat and blood!</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1998-10-08",
  },
  {
    id: 1924,
    url: "https://www.tvmaze.com/shows/1924/metal-fighter-miku",
    name: "Metal Fighter Miku",
    genres: ["Action", "Anime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27791.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27791.jpg",
    },
    summary:
      "<p>In the near future, the sports world is dominated by Neo Wrestling. Metal Fighters challenge each other in the ring, their strength and endurance complimented by armored suits. The stakes are high as the girls of the Pretty Four face Team Sapphire. Their skills are stretched to the limit in this game, where beauty, grace, and style are just as important as strength and speed.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1994-07-08",
  },
  {
    id: 1925,
    url: "https://www.tvmaze.com/shows/1925/neon-genesis-evangelion",
    name: "Neon Genesis Evangelion",
    genres: ["Drama", "Action", "Anime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27792.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27792.jpg",
    },
    summary:
      '<p>The year is 2015, and half of the Earth\'s population is dead, victims of the disaster called Second Impact! Answering a summons from his enigmatic father, 14-year-old Shinji Ikari arrives in the rebuilt city of New Tokyo-3 just as a gigantic creature identified as an "Angel" attacks! Forced into the cockpit of a giant bio-mechanical construct known as an Evangelion, Shinji must defend the city from the rampaging Angel or die trying!</p>',
    officialSite: "https://www.evangelion.co.jp/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1995-10-04",
  },
  {
    id: 1926,
    url: "https://www.tvmaze.com/shows/1926/now-and-then-here-and-there",
    name: "Now and Then, Here and There",
    genres: ["Drama", "Action", "Anime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27794.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27794.jpg",
    },
    summary:
      "<p>Dragged through a time warp by a strange machine, Shu is thrust into a hellish future as it explodes into war! Surrounded by fierce warriors enslaved innocents, and enigmatic wanderers, Shu faces the ultimate challenge of survival in a world gone mad!</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 158,
      name: "WOWOW",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2005-01-17",
  },
  {
    id: 1927,
    url: "https://www.tvmaze.com/shows/1927/cats-eye",
    name: "Cat's Eye",
    genres: ["Comedy", "Action", "Adventure", "Anime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27795.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27795.jpg",
    },
    summary:
      "<p>Cat's Eye is the most notorious group of art thieves in Japan. No one knows their identities, but for most of Tokyo, the mystery only heightens their allure. To bumbling detective Utsumi Toshio, Cat's Eye is a colossal pain in the neck. They outwit him and the rest of the police at every turn, making them look ridiculous. He would never dream of being in love with someone in Cat's Eye. Except he already is. Toshio has no idea that Cat's Eye is actually his girlfriend, Hitomi Kisugi, and her sisters Rui and Ai. Running the Cat's Eye Cafe next door to the police station, they bring ''hiding in plain sight'' to a whole new level. But thievery and romance are difficult to balance. Hitomi will need all the help she can get to stop Toshio from discovering her identity - especially when he starts having feelings for her alter-ego!</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 137,
      name: "NTV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1983-07-11",
  },
  {
    id: 1928,
    url: "https://www.tvmaze.com/shows/1928/spawn",
    name: "Spawn",
    genres: ["Action", "Horror", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27796.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27796.jpg",
    },
    summary:
      "<p>Adults-only animated series about a CIA hit man whose death causes him to seal a deal with the devil. But the devil transforms him into 'hell spawn,' a dark warrior who battles the forces of evil on the earth--and in himself.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1997-05-16",
  },
  {
    id: 1929,
    url: "https://www.tvmaze.com/shows/1929/the-avengers",
    name: "The Avengers",
    genres: ["Comedy", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/179/448748.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/179/448748.jpg",
    },
    summary:
      "<p>Urbane John Steed and a variety of partners work for an elite organization tasked with investigating criminal and espionage matters within the UK. Their opponents use everything from standard techniques to robots and other science fiction gadgetry.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1961-01-07",
  },
  {
    id: 1930,
    url: "https://www.tvmaze.com/shows/1930/the-new-avengers",
    name: "The New Avengers",
    genres: ["Action", "Thriller", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27798.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27798.jpg",
    },
    summary:
      '<p>The series picks up the adventures of John Steed as he and his team of "Avengers" fight evil plots and world domination. Whereas in the original series Steed had almost always been partnered with a woman, in the new series he had two partners: Mike Gambit, a top agent, crack marksman and trained martial artist, and Purdey, a former trainee with The Royal Ballet (to which she ascribed the high-kicking skills she frequently used).</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1976-10-22",
  },
  {
    id: 1931,
    url: "https://www.tvmaze.com/shows/1931/youre-under-arrest",
    name: "You're Under Arrest!",
    genres: ["Comedy", "Action", "Anime", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27804.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27804.jpg",
    },
    summary:
      "<p>The craziness begins as Tokyo Highway Patrolwomen Natsumi and Miyuki get off to a bad start when Miyuki busts Natsumi for reckless moped driving on her way to work. Things go from bad to worse when they find out they're going to be partners!</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 159,
      name: "TBS",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1994-09-24",
  },
  {
    id: 1932,
    url: "https://www.tvmaze.com/shows/1932/najica-blitz-tactics",
    name: "Najica: Blitz Tactics",
    genres: ["Action", "Anime", "Crime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27806.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27806.jpg",
    },
    summary:
      "<p>Super-sexy Najica Hiragi fights to save a ruined world from depraved criminals and dangerous androids. While on a mission for the CRI intelligence agency, Najica rescues the Humaritt Lila, an android with super-human strength but not a lick of common sense. Lila becomes Najica's partner, and together they begin taking on the bad guys!</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 160,
      name: "Kids Station",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2001-10-05",
  },
  {
    id: 1933,
    url: "https://www.tvmaze.com/shows/1933/sorcerer-hunters",
    name: "Sorcerer Hunters",
    genres: ["Action", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27808.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27808.jpg",
    },
    summary:
      '<p>On the Spooner Continent, humans are oppressed by evil wizards who rule over them; their only hope lies in the Sorcerer Hunters, five supernatural heroes who fight injustice according to the orders of the goddess-like "Big Momma." The improbable quintet at the center of this 1995 broadcast series is a lot less dignified than their title suggests: blond muscleman Gateau Mocha, elegant Marron Glace (pronounced "GLAYSS," rather than "glah-SAY"), his klutzy brother Carrot (the self-proclaimed "love machine"), and the Misu sisters, Tira and Chocolate.</p>',
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1995-10-03",
  },
  {
    id: 1934,
    url: "https://www.tvmaze.com/shows/1934/boogiepop-phantom",
    name: "Boogiepop Phantom",
    genres: ["Drama", "Anime", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27809.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27809.jpg",
    },
    summary:
      "<p>Five years ago, a string of grisly murders shook the city to its core. Now terror has returned, and this time it has a name: Boogiepop. Everyone knows about Boogiepop: death incarnate, she stalks the night in search of fresh victims. Meet her, and you simply...vanish. In the darkness, glass shatters and time stands still... There's something out there, and it's coming closer. Are you safe?</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2003-07-28",
  },
  {
    id: 1935,
    url: "https://www.tvmaze.com/shows/1935/ghost-in-the-shell-stand-alone-complex",
    name: "Ghost in the Shell: Stand Alone Complex",
    genres: ["Action", "Anime", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27810.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27810.jpg",
    },
    summary:
      "<p>Major Motoko Kusanagi is a beautiful but deadly cyborg that is squad leader of Section 9-the Japanese government's clandestine unit assigned to battle terrorism and cyber warfare. Surrounded by an expertly trained team, Motoko faces her ultimate challenge- the Laughing Man- a terrorist who orchestrated a kidnapping and extortion plot many years ago and has suddenly reappeared. In order to discover the identity of this enigmatic criminal, Motoko and Section 9 are drawn into a deadly labyrinth and they ll have to use all their expertise to survive.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 157,
      name: "Animax",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2002-10-01",
  },
  {
    id: 1936,
    url: "https://www.tvmaze.com/shows/1936/mezzo",
    name: "Mezzo",
    genres: ["Comedy", "Action", "Anime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27812.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27812.jpg",
    },
    summary:
      "<p>Her name is Mikura, and she's all about service with a smile. So what if that service is cracking skulls and the smile happens to be on the other end of a loaded gun? Get ready for this chic with a killer body and vicious skills to wreak havoc and mayhem all in the name of the Danger Service Agency!</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 161,
      name: "TV Kanagawa",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2004-01-04",
  },
  {
    id: 1937,
    url: "https://www.tvmaze.com/shows/1937/mortal-kombat-defenders-of-the-realm",
    name: "Mortal Kombat: Defenders of the Realm",
    genres: ["Action", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27813.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27813.jpg",
    },
    summary:
      "<p><b>Mortal Kombat: Defenders of the Realm</b> is an animated series based on the popula Mortal Kombat fighting game franchise.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-09-21",
  },
  {
    id: 1938,
    url: "https://www.tvmaze.com/shows/1938/serial-experiments-lain",
    name: "Serial Experiments Lain",
    genres: ["Anime", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27814.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27814.jpg",
    },
    summary:
      "<p>Close the World. Open the Next. Decades before the internet was something people carried around in their pockets, these words introduced anime fans to a surreal existence where computer monitors served as portals to brave new worlds. Serial Experiments: Lain and its deceptively \"ordinary\" title character redefined an entire generation's concept of the world wide web, prompting us all to suspiciously take note of humming power lines and central processing units. Follow along as fourteen year old Lain – driven by the abrupt suicide of a classmate – logs on to the Wired and promptly loses herself in a twisted mass of hallucinations, memories, and interconnected-psyches. Close the World. Open the Next. It's as simple as the flip of a switch.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1998-07-06",
  },
  {
    id: 1939,
    url: "https://www.tvmaze.com/shows/1939/psycho-pass",
    name: "Psycho-Pass",
    genres: ["Action", "Anime", "Crime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27816.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27816.jpg",
    },
    summary:
      "<p>Welcome to a world where just thinking about a crime is enough to enough to make you guilty. Bad intentions can no longer be hidden, and the police know exactly which tainted minds are about to cross over to the wrong side of the law. The great equalizer in the war on thugs is the Dominator, a futuristic weapon that can read minds and assess the risk that a citizen will turn criminal. Cops work in teams made up of Enforcers and Inspectors. Enforcers take out the bad guys, Inspectors stop their partners from going rogue, and the all-powerful Sibyl System keeps a watchful eye on us all. Society is paralyzed by its deepest, darkest desires, and trial by jury has been replaced by the wrath of the Dominator. Welcome to the future. How guilty are you?</p>",
    officialSite: "http://psycho-pass.com",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 131,
      name: "Fuji TV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2012-10-12",
  },
  {
    id: 1940,
    url: "https://www.tvmaze.com/shows/1940/kekkai-sensen",
    name: "Kekkai Sensen",
    genres: ["Action", "Anime", "Fantasy", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/130/326154.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/130/326154.jpg",
    },
    summary:
      "<p>A breach between Earth and the netherworlds has opened up over the city of New York, trapping New Yorkers and creatures from other dimensions in an impenetrable bubble. They've lived together for years, in a world of crazy crime sci-fi sensibilities. Now someone is threatening to sever the bubble, and a group of stylish superhumans is working to keep it from happening.</p>",
    officialSite: "http://kekkaisensen.com/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 24,
      name: "MBS",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2015-04-05",
  },
  {
    id: 1942,
    url: "https://www.tvmaze.com/shows/1942/junketsu-no-maria",
    name: "Junketsu No Maria",
    genres: ["Comedy", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27818.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27818.jpg",
    },
    summary:
      "<p>In the midst of the Hundred Years' War lives teenage witch Maria. Hating war in all its forms, Maria interferes in battle after battle—ensuring no victory on either side. But when the heavens themselves have had enough of Maria's meddling, the angels decree that she may no longer use magic in public; and should she ever lose her virginity, she will lose her magic powers completely.</p>",
    officialSite: "http://junketsu-maria.tv/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 132,
      name: "Tokyo MX",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2015-01-11",
  },
  {
    id: 1943,
    url: "https://www.tvmaze.com/shows/1943/saenai-heroine-no-sodatekata",
    name: "Saenai Heroine no Sodatekata",
    genres: ["Comedy", "Anime", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/117/294352.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/117/294352.jpg",
    },
    summary:
      "<p>One day on his way home, hardcore otaku Tomoya encounters a beautiful girl in a scene seemingly torn directly out of a dating simulation game. Inspired, he decides to create his own dating sim based around this girl. There is just one problem: In reality the girl, Megumi, is normal and rather boring—nothing like the heroine of his imagination.</p>",
    officialSite: "http://www.saenai.tv/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 131,
      name: "Fuji TV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2015-01-15",
  },
  {
    id: 1944,
    url: "https://www.tvmaze.com/shows/1944/yatterman-night",
    name: "Yatterman Night",
    genres: ["Comedy", "Action", "Anime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27820.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27820.jpg",
    },
    summary:
      "<p>When ten-year-old Leopard's mother gets sick, Leopard tries to get medicine from the prosperous Yatter Kingdom—only to be shot at by the supposedly heroic Yatterman. As she grieves over her mother's death, she discovers her legacy: Her ancestors were the age old enemies of the Yatterman and the villains of countless stories. But if the Yatterman are actually the evil ones, Leopard decides, then perhaps the stories were wrong and her ancestors were the heroes. Thus, Leopard sets off with her two companions—vowing to teach the Yatterman the error of their ways by giving them the forehead flicking they so richly deserve.</p>",
    officialSite: "http://yatterman.jp/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 132,
      name: "Tokyo MX",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2015-01-11",
  },
  {
    id: 1945,
    url: "https://www.tvmaze.com/shows/1945/fatestay-night",
    name: "Fate/Stay Night",
    genres: ["Action", "Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27822.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27822.jpg",
    },
    summary:
      "<p>Raised by a mysterious sorcerer after the horrific death of his parents, Shiro Emiya has only just begun to help others using the small tidbits of magic that he's learned. However, when he's suddenly caught in a battle between two more powerful Magus, Shiro finds himself performing a spell above his expected ability, summoning the beautiful spirit warrior Saber to protect him! But safety is only momentary as Shiro and Saber now find themselves thrust into in a secret world of dark magic and deadly challenges: a no-holds barred duel to the death known as the Holy Grail War! At stake: a prize of unimaginable power. But can the inexperienced Shiro and Saber survive long enough to even enter the contest? First they'll have to withstand waves of treachery and assassination, even as Shiro scrambles to learn everything he'll need to know to stay alive as seven teams of Magus and Spirit Servants face off in mortal combat! The ultimate game of death and magic unfolds as the Holy War erupts in FATE / STAY NIGHT!</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 162,
      name: "TV Saitama",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2006-01-06",
  },
  {
    id: 1946,
    url: "https://www.tvmaze.com/shows/1946/fatestay-night-unlimited-blade-works",
    name: "Fate/Stay Night: Unlimited Blade Works",
    genres: ["Action", "Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27825.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27825.jpg",
    },
    summary:
      "<p>Fate/Stay Night: Unlimited Blade Works follows seven mages paired with seven legendary heroes from across history all battling it out for the ultimate prize: the wish-granting holy grail.</p>",
    officialSite: "http://www.fate-sn.com/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 132,
      name: "Tokyo MX",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2014-10-11",
  },
  {
    id: 1947,
    url: "https://www.tvmaze.com/shows/1947/the-mighty-boosh",
    name: "The Mighty Boosh",
    genres: ["Comedy", "Fantasy", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/48/121697.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/48/121697.jpg",
    },
    summary:
      "<p>Come with us now on a journey through time and space... to the world of <b>The Mighty Boosh</b>… an off-the-wall adventure based on the Perrier Award-winning comedy show. The Mighty Boosh follows two zoo keepers, Howard Moon and Vince Noir, who work at \"The Zoo-niverse\", a dilapidated but magical zoo. It is run by Bob Fossil, a demented American with a military disposition. Vince is a regular 'Mowgli in flares', due to his affinity with animals and adoration for all things Seventies. Howard likes to think he is more the brains of their zoo-keeping outfit, destined for better things. Each week they get involved in a different adventure. Whether they end up in the Arctic tundra or monkey hell they somehow always manage to get back to the zoo intact...</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b007wds5",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2004-05-18",
  },
  {
    id: 1948,
    url: "https://www.tvmaze.com/shows/1948/noel-fieldings-luxury-comedy",
    name: "Noel Fielding's Luxury Comedy",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27833.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27833.jpg",
    },
    summary:
      "<p>The co-creator of <i>The Mighty Boosh</i> is back and this time he's taken it to another level. <b>Noel Fielding's Luxury Comedy</b> is a psychedelic character based comedy show half filmed and half animated, with music provided by Kasabian‘s Sergio Pizzorno.</p>",
    officialSite:
      "http://www.channel4.com/programmes/noel-fieldings-luxury-comedy",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 41,
      name: "E4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-01-26",
  },
  {
    id: 1949,
    url: "https://www.tvmaze.com/shows/1949/garth-marenghis-darkplace",
    name: "Garth Marenghi's Darkplace",
    genres: ["Comedy", "Horror", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27836.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27836.jpg",
    },
    summary:
      '<p><i><b>"Garth Marenghi\'s Darkplace"</b></i> is the brainchild of celebrated horror writer and self-styled "fabulist" Garth Marenghi, author of such genre classics as Afterbirth (a mutated placenta attacks Bristol) and Crab! ("One of the three best horror books about crabs I\'ve ever read" - Hard Gore Magazine). Back in the 1980s, he branched out into television production, writing and starring in a series so radical, so scary and so downright crazy that when the bosses of Channel 4 saw what they had on their hands, they ran away screaming, like little girls. Only now, twenty years on and amid the worst programming drought in television history, have the station finally allowed the show on the air. Intercut with new interviews with Marenghi himself and his co-stars Dean Learner and Todd Rivers, Garth Marenghi\'s Darkplace is perhaps the most disturbing vision of hospital life ever broadcast.</p>',
    officialSite:
      "http://www.channel4.com/programmes/garth-marenghis-darkplace",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2004-01-29",
  },
  {
    id: 1950,
    url: "https://www.tvmaze.com/shows/1950/look-around-you",
    name: "Look Around You",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27839.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27839.jpg",
    },
    summary:
      "<p>Look around you. Look around you. Just look around you. What do you see? A tree. A weather-vane. A discarded lollipop-wrapper. A traffic shop. All of these things, and any other things you may care to mention, have one thing in common. Can you work out what it is? The first series of this British comedy show, filmed in 2002, was a send-up of the earnest programmes for schools made in the 1960s and 1970s. The second series (2005) is a friendlier spoof of the BBC's own slightly wacky 'Tomorrow's World' programme (1965-2002), and it gives a view from somewhere around 1982 of what life might be like in the early 21st century. The new series is again written by Robert Popper and Peter Serafinowicz and consists of six thirty-minute shows, a big improvement on the ten-minute format of the first series. The new episodes are all wonderfully daft... Remember to have your jotter and your copy book handy!</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p00bt5dl",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2002-10-10",
  },
  {
    id: 1951,
    url: "https://www.tvmaze.com/shows/1951/startalk",
    name: "StarTalk",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/192/480982.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/192/480982.jpg",
    },
    summary:
      '<p>On <b>StarTalk</b> Host Neil deGrasse Tyson brings together celebrities, scientists and comedians to explore a variety of cosmic topics and collide pop culture with science in a way that late-night television has never seen before. Weekly topics range from popular science fiction, space travel, extraterrestrial life, the Big Bang, to the future of Earth and the environment. Tyson is an astrophysicist with a gifted ability to connect with everyone, inspiring us all to to "keep looking up".</p>',
    officialSite:
      "https://www.nationalgeographic.com/tv/shows/startalk-with-neil-degrasse-tyson",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-20",
  },
  {
    id: 1952,
    url: "https://www.tvmaze.com/shows/1952/snuff-box",
    name: "Snuff Box",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/198/497288.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/198/497288.jpg",
    },
    summary:
      '<p>Both actors use their real names for their main characters. Berry plays a hangman ("High Executioner to the King of England"), and Fulcher his assistant. The majority of the programme is set in a "gentlemen\'s club for hangmen", although the show is also interspersed with sequences of sketches, often featuring different characters.</p>',
    officialSite: "http://www.bbc.co.uk/programmes/p00tjpm9",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-02-27",
  },
  {
    id: 1953,
    url: "https://www.tvmaze.com/shows/1953/dexters-laboratory",
    name: "Dexter's Laboratory",
    genres: ["Comedy", "Adventure", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27891.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27891.jpg",
    },
    summary:
      "<p>Deep in the depths of his secret laboratory, boy genius Dexter computes, experiments, invents and builds incredible creations like mom robots, interdimensional portals, talking animals, brain replacements and stealth dodgeball devices, until his ditzy sister Dee Dee ruins his overly-executed plans … if only he could fit her into a test tube!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-04-28",
  },
  {
    id: 1954,
    url: "https://www.tvmaze.com/shows/1954/sym-bionic-titan",
    name: "Sym-Bionic Titan",
    genres: ["Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27895.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27895.jpg",
    },
    summary:
      "<p>Sym-Bionic Titan follows the lives of Ilana, Lance and Octus, three alien teens that crash-land on Earth while attempting to escape an evil General who has taken over their home planet, Galaluna. Ilana, princess of Galaluna, Lance, a rebellious but capable soldier, and Octus, a bio-cybernetic robot, must now blend into everyday life in Sherman, Illinois. Posing as high school students, Lance and Octus work to conceal Princess Ilana from General Modula and his hideous space mutants sent to harm the sole royal heir of Galaluna. This motley trio makes a real effort to navigate high school life, all while saving the planet and themselves from an onslaught of inter-galactic attacks. When called into battle, Octus activates the sym-bionic defense program and Ilana, Lance and Octus come together to form the spectacular cyber-giant Sym-Bionic Titan.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-17",
  },
  {
    id: 1955,
    url: "https://www.tvmaze.com/shows/1955/the-powerpuff-girls",
    name: "The Powerpuff Girls",
    genres: ["Action", "Children", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27896.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27896.jpg",
    },
    summary:
      "<p><b>The Powerpuff Girls</b> is an award-winning animated action series about three super-powered little girls Bubbles, Blossom and Buttercup with one very big mission: saving the world before bedtime.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-11-18",
  },
  {
    id: 1956,
    url: "https://www.tvmaze.com/shows/1956/courage-the-cowardly-dog",
    name: "Courage the Cowardly Dog",
    genres: ["Adventure", "Children", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27898.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27898.jpg",
    },
    summary:
      "<p>The things he does for love! Welcome to the middle of Nowhere, Kansas. Population: one kind old lady, one crabby old man, one timid dog and all sorts of creepy creatures, scary monsters and crazed villains! It's a living nightmare for poor Courage, who faces these unthinkable dangers with his body shaking and his tail between his legs. But Courage loves his sweet Muriel and grumpy Eustace, so he digs deep to find the strength to save his beloved family from deadly weremoles, dark shadows and other sinister elements that pop up all over this terrifying town. With clever nods to classic horror films, this action-packed animated series keeps laughs and scares coming as Courage outwits evil with his singular brand of bravery.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-11-12",
  },
  {
    id: 1957,
    url: "https://www.tvmaze.com/shows/1957/superman-the-animated-series",
    name: "Superman: The Animated Series",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27899.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27899.jpg",
    },
    summary:
      "<p>Superman battles evil while trying to conceal his alter ego, Clark Kent.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-09-06",
  },
  {
    id: 1958,
    url: "https://www.tvmaze.com/shows/1958/china-il",
    name: "China, IL",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27900.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27900.jpg",
    },
    summary:
      "<p>Class is officially back in session at the University of China, IL, the worst college in America. China, IL will return in April with more laughs, more absurd situations and a less education than ever! In its third season, the faculty will continue to provide absolutely no instructive growth for the University's students, thus prolonging both graduation and our delight in the chance to drink.</p>",
    officialSite: "http://www.adultswim.com/videos/china-il",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-10-02",
  },
  {
    id: 1959,
    url: "https://www.tvmaze.com/shows/1959/superjail",
    name: "Superjail!",
    genres: ["Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27901.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27901.jpg",
    },
    summary:
      "<p>The warden is back and the death toll at Superjail continues to rise at an impressive rate! Complete with fist fights galore, baffling love triangles, and psychedelic animation that will melt your face off.</p>",
    officialSite: "http://www.adultswim.com/videos/superjail/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-09-28",
  },
  {
    id: 1960,
    url: "https://www.tvmaze.com/shows/1960/moral-orel",
    name: "Moral Orel",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27902.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27902.jpg",
    },
    summary:
      "<p>Orel is an eleven-year-old boy who loves church. His unbridled enthusiasm for piousness and his misinterpretation of religious morals often lead to disastrous results, including self-mutilation and crack addiction. No matter how much trouble he gets into, his reverence always keeps him cheery to the bitter end.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-12-12",
  },
  {
    id: 1961,
    url: "https://www.tvmaze.com/shows/1961/line-of-fire",
    name: "Line of Fire",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755290.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755290.jpg",
    },
    summary:
      "<p>A unique show from creator Rod Lurie about the life of the mob and the FBI. While the mob boss, Jonah Malloy is trying to run his business away from the interference of the FBI, the FBI is trying everything to bring down his terror team. What Malloy doesn't know is that he has a FBI undercover, Roy Ravelle, working for him. Lisa Cohen heads the FBI team, which also include Paige Van Doren, who recently lost her husband on 9/11.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-12-02",
  },
  {
    id: 1962,
    url: "https://www.tvmaze.com/shows/1962/missing",
    name: "Missing",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27904.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27904.jpg",
    },
    summary:
      "<p>Nicole Scott is an FBI agent who finds missing people with her new partner, a young psychic.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-08-02",
  },
  {
    id: 1963,
    url: "https://www.tvmaze.com/shows/1963/threshold",
    name: "Threshold",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27910.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27910.jpg",
    },
    summary:
      "<p>The suspense drama focuses on a team of experts who, after a strange phenomenon is discovered, must try to thwart the possible global threats that stem from it. </p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-09-16",
  },
  {
    id: 1964,
    url: "https://www.tvmaze.com/shows/1964/kiseijuu",
    name: "Kiseijuu",
    genres: ["Action", "Anime", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27917.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27917.jpg",
    },
    summary:
      "<p>One day, high school boy Shinichi wakes up to find that his hand has been possesses by a talking alien parasite Although he and his parasite are able to form a reluctant symbiotic relationship of sorts, the other parasites on Earth have taken over their hosts' bodies completely. Moreover, there are brutal murders happening all across the country. And while the police are baffled as they look for a killer, Shinichi is the only one who knows the truth: It's not a serial killer. It's the parasites feeding on human flesh.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 137,
      name: "NTV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2014-10-09",
  },
  {
    id: 1965,
    url: "https://www.tvmaze.com/shows/1965/shingeki-no-bahamut-genesis",
    name: "Shingeki no Bahamut Genesis",
    genres: ["Action", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/100/252205.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/100/252205.jpg",
    },
    summary:
      "<p>Favaro is a bounty hunter only concerned with catching his target, blowing the reward money on a night of debauchery, and then doing it all again. However, one night in his drunken boasting, he attracts the attention of Amira, a girl who has recently stolen one half of the key needed to free the most destructive force the world has ever known—the dragon Bahamut. Now Favaro's life is a bit more complicated as he finds himself cursed to travel with Amira as the minions of heaven and hell hunt them across the world.</p>",
    officialSite: "https://shingekinobahamut-virginsoul.jp/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 159,
      name: "TBS",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2014-10-06",
  },
  {
    id: 1966,
    url: "https://www.tvmaze.com/shows/1966/shirobako",
    name: "Shirobako",
    genres: ["Drama", "Anime", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27920.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27920.jpg",
    },
    summary:
      "<p>Back in high school, five friends were in the animation club together. Now they each work (or are in the process of breaking into) the anime industry. One is a production assistant, one a key animator, one a 3D animator, one a voice actor, and one an aspiring script writer. But their lives are far more hectic than the days they spent making anime together as students.</p>",
    officialSite: "http://shirobako-anime.com/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 132,
      name: "Tokyo MX",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2014-10-09",
  },
  {
    id: 1967,
    url: "https://www.tvmaze.com/shows/1967/american-ninja-warrior",
    name: "American Ninja Warrior",
    genres: ["Action", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/205/514741.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/205/514741.jpg",
    },
    summary:
      "<p><b>American Ninja Warrior</b> is an action-packed series that follows competitors as they tackle a series of challenging obstacle courses in both qualifying and finals rounds across the country. Those that successfully complete a course in their designated region move on to the national finals round in Las Vegas, where they face a stunning four-stage course modeled after the famed Mt. Midoriyama in Japan.</p>",
    officialSite: "http://www.nbc.com/american-ninja-warrior",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-12-12",
  },
  {
    id: 1968,
    url: "https://www.tvmaze.com/shows/1968/bullseye",
    name: "Bullseye",
    genres: ["Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28279.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28279.jpg",
    },
    summary:
      '<p><b>Bullseye</b> will challenge four men and four women to test their bodies and brains in three ultimate challenges that ask nothing more than for them to hit the Bullseye - literally. Comedian Godfrey ("The Godfrey Complex") will serve as co-host. Bullseye\'s fierce "weekend warriors" will participate in three levels of extraordinary challenges, all of which involve using their bodies like human darts to hit targets - on land, sea and air. As the rounds advance in this fun-for-the-family summer series, only those with the sharpest aim move forward. The first challenge finds the eight competitors vying to hit the center of a stationary target while leaping from a moving 18-wheeler, being pulled by a helicopter or acting as a human slingshot being projected hundreds of feet through the air. In round two, the remaining four competitors - two men and two women - race to hit as many targets as possible. These competitors may be aiming for targets while descending down a building or jumping between two racing speedboats. In the third and final challenge, the remaining three competitors race against the clock to conquer the ultimate test and hit the final Bullseye.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-27",
  },
  {
    id: 1969,
    url: "https://www.tvmaze.com/shows/1969/becoming-us",
    name: "Becoming Us",
    genres: ["Drama", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27922.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27922.jpg",
    },
    summary:
      '<p>The groundbreaking new unscripted drama series <b>Becoming Us</b> (formerly known as "My Transparent Life") centers on a teenager named Ben who is learning to live with his dad becoming a woman. The series will follow Ben, his family and his friends as they support one another through this unexpected journey and navigate their new world with Charlie now living as Carly. The show is a generational story of a loving family and circle of friends supporting one another through this unfamiliar situation.</p>',
    officialSite:
      "http://abcfamily.go.com/shows/becoming-us/video/latest/VDKA0_04joe00n",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-08",
  },
  {
    id: 1970,
    url: "https://www.tvmaze.com/shows/1970/boom",
    name: "BOOM!",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/82/205461.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/82/205461.jpg",
    },
    summary:
      '<p>From Keshet DCP, <b>BOOM!</b> is a general knowledge quiz show that challenges teams of three players to defuse a series of ticking slime-bombs, by dramatically cutting the wires relating to the correct answers and leaving the wrong answers untouched. Get it right - and the players win big money. Get it wrong or run out of time - and, after a tense countdown, the players - and portions of the audience - are showered with anything from "guacamole" to "mashed potatoes", forcing the players out of the game.</p>',
    officialSite: "http://www.fox.com/boom/full-episodes",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-25",
  },
  {
    id: 1971,
    url: "https://www.tvmaze.com/shows/1971/why-with-hannibal-buress",
    name: "Why? With Hannibal Buress",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755295.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755295.jpg",
    },
    summary:
      '<p>For those intrigued by life\'s curiosities, Comedy Central and comedian Hannibal Buress will give you the answers! The #1 brand in comedy has greenlit eight episodes of the weekly, half-hour series, <b>Why? With Hannibal Buress</b><i><b>,</b></i> it was announced by Kent Alterman, President, Content Development and Original Programming, Comedy Central. "Hannibal keeps asking us \'why\' so we just told him to go find out and we\'ll air it," said Alterman. "I\'m extremely excited to help Comedy Central sell advertising," said Buress. Executive produced by Buress, Jeff Stilson ("The Chris Rock Show" and "Da Ali G Show") and Dave Becky of 3 Arts Entertainment, "Why? With Hannibal Buress," celebrates Buress\' hilariously brilliant off-beat voice and point-of-view. If it\'s in the zeitgeist, Buress will address it, providing his unique perspective on each week\'s topic, answering the burning questions on his mind through stand-up, filmed segments, man-on-the-street interviews and special, in-studio guests. "Why? With Hannibal Buress" will be a weekly, half-hour series shot in front of a studio audience and each episode will tape the same week it airs.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-08",
  },
  {
    id: 1972,
    url: "https://www.tvmaze.com/shows/1972/10-8",
    name: "10-8",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/62/156806.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/62/156806.jpg",
    },
    summary:
      "<p>A former Brooklyn bad boy earns his badge as a rookie L.A. deputy sheriff in this cop-in-training drama from executive producer Aaron Spelling.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-09-28",
  },
  {
    id: 1974,
    url: "https://www.tvmaze.com/shows/1974/that-80s-show",
    name: "That '80s Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27943.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27943.jpg",
    },
    summary:
      "<p>The producers of 'That '70s Show' looked for laughs (and didn't find many) in this sitcom set in 1984 San Diego and focusing on record-store employees and their sardonic boss, a woman who survived the summer of love mostly intact.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-01-23",
  },
  {
    id: 1975,
    url: "https://www.tvmaze.com/shows/1975/the-agency",
    name: "The Agency",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27951.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27951.jpg",
    },
    summary:
      "<p>Spy drama about the inner workings of the CIA and the toll it takes on the lives of its operatives.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-09-27",
  },
  {
    id: 1976,
    url: "https://www.tvmaze.com/shows/1976/aoki-hagane-no-arpeggio-ars-nova",
    name: "Aoki Hagane no Arpeggio: Ars Nova",
    genres: ["Action", "Anime", "Science-Fiction", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27952.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27952.jpg",
    },
    summary:
      "<p>In the year 2039, global warming has caused a sudden rise in sea level, leading mankind to lose a great deal of land territory. At the same time, a fleet of mysterious warships clad in mist, known as the \"Fleet of Fog,\" begin to appear throughout the world's seas, attacking humanity's warships with their powerful superweapons. Humanity threw all the military strength it possessed at the Fleet of Fog in a decisive battle, but was crushed by the fleet's overwhelming might...</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 167,
      name: "AT-X",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2013-10-08",
  },
  {
    id: 1977,
    url: "https://www.tvmaze.com/shows/1977/the-bad-girls-guide",
    name: "The Bad Girl's Guide",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27953.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27953.jpg",
    },
    summary:
      "<p>Cameron Tuttle's sassy rule books for women inspired this short-lived sitcom about an ad exec, who lives life on her own terms, and her friends.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 70,
      name: "UPN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-05-24",
  },
  {
    id: 1978,
    url: "https://www.tvmaze.com/shows/1978/black-sash",
    name: "Black Sash",
    genres: ["Drama", "Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27954.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27954.jpg",
    },
    summary:
      "<p>An ex-cop teaches martial arts to a diverse group of teens in San Francisco.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-03-30",
  },
  {
    id: 1979,
    url: "https://www.tvmaze.com/shows/1979/charles-in-charge",
    name: "Charles in Charge",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27955.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27955.jpg",
    },
    summary:
      "<p>For free room and board, a college student takes care of three kids while still finding time for a social life (apparently his studies tended to get back-burnered).</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1984-10-03",
  },
  {
    id: 1980,
    url: "https://www.tvmaze.com/shows/1980/dark-justice",
    name: "Dark Justice",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27959.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27959.jpg",
    },
    summary:
      "<p>Nicholas Marshall is a judge by day and a motorcycle-riding avenger by night in this late-night vigilante drama. His after-hours exploits began after those responsible for the deaths of his wife and daughter are set free.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1991-04-05",
  },
  {
    id: 1981,
    url: "https://www.tvmaze.com/shows/1981/due-south",
    name: "Due South",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27960.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27960.jpg",
    },
    summary:
      "<p>An upright Mountie cracks cases alongside a savvy Chicago detective in a wry cult series that playfully deconstructs American and Canadian stereotypes, while providing enough cast chemistry and plot surprises to make this one of the more fondly remembered '90s crime dramas.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 48,
      name: "CTV",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "1994-04-26",
  },
  {
    id: 1982,
    url: "https://www.tvmaze.com/shows/1982/eleventh-hour",
    name: "Eleventh Hour",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27965.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27965.jpg",
    },
    summary:
      "<p><b>Eleventh Hour</b> follows Dr. Jacob Hood, a brilliant biophysicist and special science advisor to the government as he investigates scientific crises and oddities. His jurisdiction is absolute and Hood is dogged in his pursuit of those who would abuse and misuse scientific discoveries and breakthroughs for their own gain. His passion and crusade is to protect the substance of science from those with nefarious motives. He is called in at the eleventh hour and he represents the last line of defense. Special Agent Rachel Young is the decorated FBI protection officer assigned to watch Hood's back.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-10-09",
  },
  {
    id: 1983,
    url: "https://www.tvmaze.com/shows/1983/eyes",
    name: "Eyes",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27968.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27968.jpg",
    },
    summary:
      "<p>Impulsive, sharp-witted Harlan Judd runs Judd Risk Management, a discreet, high-tech private investigation firm that handles cases with the highest possible stakes, while operating at the absolute fringes of the law. Along with ruthlessly efficient investigator Nora Gage and a staff of brilliantly skilled, driven individuals -- some with their own agendas and secrets -- Harlan does whatever it takes to prevail in a world of uneasy alliances and uncertain loyalties.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-03-30",
  },
  {
    id: 1984,
    url: "https://www.tvmaze.com/shows/1984/husbands",
    name: "Husbands",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/27973.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/27973.jpg",
    },
    summary:
      "<p>Waking up married after a drunken Vegas weekend used to be an adventure reserved for one man and one woman. But thanks to a new law, athlete Brady Kelly and actor Cheeks find themselves unexpectedly and legally wed. Unwilling to undermine the hard-fought battle with a public quicky divorce, these two decide to make a go of it. They were doing okay when they were dating. But how will it work out, now that they are Husbands?</p>",
    officialSite: "http://www.cwseed.com/shows/husbands/",
    webChannel: {
      id: 13,
      name: "CW Seed",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2011-09-13",
  },
  {
    id: 1985,
    url: "https://www.tvmaze.com/shows/1985/the-tunnel",
    name: "The Tunnel",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/55/137619.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/55/137619.jpg",
    },
    summary:
      "<p>Based on the Swedish series <i>Bron</i>, <b>The Tunnel</b> follows binational pair of French and English detectives Elise Wassermann and Karl Roebuck, solving the crimes committed at the France/UK border, in the <i>Channel Tunnel</i>.</p>",
    officialSite:
      "https://www.sky.com/watch/channel/sky-atlantic/the-tunnel-sabotage",
    webChannel: {
      id: 117,
      name: "Sky Go",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2013-10-16",
  },
  {
    id: 1986,
    url: "https://www.tvmaze.com/shows/1986/my-dad-says",
    name: "$#*! My Dad Says",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/62/157405.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/62/157405.jpg",
    },
    summary:
      "<p><b>$#*! My Dad Says</b> is based on the popular Twitter feed by Justin Halpern about Ed Goodson, a forthright and opinionated dad who relishes expressing his unsolicited and often wildly politically incorrect observations to anyone within earshot. Nobody is immune from Ed's rants, including his sons, Henry, a struggling writer-turned-unpaid blogger; and Vince, the meek half of his husband/wife real estate duo with domineering wife Bonnie. When Henry finds he can no longer afford to pay rent to his pretty roommate -- and secret admirer -- Sam, Ed reveals a soft spot and invites Henry to move in with him. Henry agrees, knowing that the verbal assault will not abate and now there will be no escape.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-23",
  },
  {
    id: 1987,
    url: "https://www.tvmaze.com/shows/1987/100-questions",
    name: "100 Questions",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28018.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28018.jpg",
    },
    summary:
      "<p>Charlotte Payne is looking for love but she has yet to meet Mr. Right. When she joins an online dating site, Charlotte takes a 100-question compatibility test -- and each one requires her to recount a humorous time in her life.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-05-27",
  },
  {
    id: 1988,
    url: "https://www.tvmaze.com/shows/1988/accidentally-on-purpose",
    name: "Accidentally on Purpose",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28020.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28020.jpg",
    },
    summary:
      "<p><b>Accidentally on Purpose</b>, based on the bestselling memoir by Mary F. Pols, is a comedy about a single woman, Billie, who finds herself \"accidentally\" pregnant after a one-night stand with a much younger guy, and decides to keep the baby...and the guy. A newspaper film critic, Billie is barely surviving a humiliating breakup with her charming boss, James, who's still trying to resume their relationship. Pregnant, after a brief fling with her \"boy toy\" Zack, Billie and Zack make an arrangement to live together platonically. Billie's party girl best friend Olivia, and Abby, her conventional, younger married sister, eagerly look forward to the new addition and offer their own brands of advice and encouragement. But when Zack and his freeloading friends, including Davis, start to turn her place into a frat house, Billie isn't sure if she's living with a boyfriend, a roommate, or if she just has another child to raise.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-09-21",
  },
  {
    id: 1989,
    url: "https://www.tvmaze.com/shows/1989/better-with-you",
    name: "Better with You",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28027.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28027.jpg",
    },
    summary:
      "<p><b>Better with You</b> is a comedy about three different couples, intertwined in one family, at various stages in their romantic relationships. There's a couple, Maddie and Ben, in a happy, long-term relationship and not married. Another couple, Mia and Casey, in a brand-new relationship and unexpectedly motivated to make a rush to the altar. Last but not least, there's a long-time married couple, Vicky and Joel, who've been together for 35 years but may have a new take on life. Maddie and Ben have a strong relationship, but they will come to learn that there may be value in Mia and Casey's impulsiveness and spontaneity. And both sisters could surely learn something about relationships from their long-married parents. With three very different relationships, is it free thinkers vs. over-thinkers, or will each couple begin to see things a little bit differently?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-22",
  },
  {
    id: 1990,
    url: "https://www.tvmaze.com/shows/1990/four-kings",
    name: "Four Kings",
    genres: ["Drama", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28034.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28034.jpg",
    },
    summary:
      "<p>Barry, Ben, Bobby and Jason have been best friends their entire lives and haven't even spent a birthday apart. When Ben's grandmother, who has dubbed them the \"Four Kings of New York,\" passes away, Ben inherits her large, posh apartment. Ben, of course, asks his friends to move in with him, but his girlfriend Jenny (guest star Kiele Sanchez) conveniently decides that it's a good time in their relationship for them to move in together. As the guys prepare to make the move, having decided that there's enough room for all of them, Jen gives Ben an ultimatum - his friends or her.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-01-05",
  },
  {
    id: 1991,
    url: "https://www.tvmaze.com/shows/1991/happy-hour",
    name: "Happy Hour",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755296.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755296.jpg",
    },
    summary:
      '<p>Henry\'s girlfriend Heather breaks up with him almost immediately after they move to Chicago together, leaving Henry shell-shocked, broken-hearted, out of a job and out of an apartment - all on the same day. He learns the only apartment opening in their building is with Larry, a vain, flashy, yet loveable rogue who agrees to take Henry on as a roommate now that his previous roommate, Brad, has moved in with his controlling fiance, Tina. Larry relishes the opportunity to "build a better Brad" and mold Henry into an image of himself, but Larry quickly learns there are lessons he can glean from Henry as well.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-09-07",
  },
  {
    id: 1992,
    url: "https://www.tvmaze.com/shows/1992/i-just-want-my-pants-back",
    name: "I Just Want My Pants Back",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28036.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28036.jpg",
    },
    summary:
      "<p><b>I Just Want My Pants Back</b> follows the triumphs and misadventures of a group of friends as they navigate post-college life in Brooklyn.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-08-28",
  },
  {
    id: 1993,
    url: "https://www.tvmaze.com/shows/1993/my-guide-to-becoming-a-rock-star",
    name: "My Guide to Becoming a Rock Star",
    genres: ["Drama", "Comedy", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/184/462053.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/184/462053.jpg",
    },
    summary:
      "<p><b>My Guide to Becoming a Rock Star</b> follows the adventures of Jace Darnell, an aspiring rock god who takes viewers through achieving stardom step-by-step via the adventures of his own band, SlipDog.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-03-14",
  },
  {
    id: 1994,
    url: "https://www.tvmaze.com/shows/1994/him-her",
    name: "Him & Her",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28038.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28038.jpg",
    },
    summary:
      "<p>An intimate anti-romantic comedy about real-life love in its lazy, messy, everyday glory.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p00kqnzv",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-09-06",
  },
  {
    id: 1995,
    url: "https://www.tvmaze.com/shows/1995/mad-dogs",
    name: "Mad Dogs",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28044.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28044.jpg",
    },
    summary:
      "<p>Max Beesley, Philip Glenister, John Simm and Marc Warren go on the holiday from hell in this original British drama that swings from the surprising to the sublimely surreal.</p>",
    officialSite:
      "https://www.sky.com/watch/title/series/37ce2dfc-2a85-422d-b0f3-f307b65b02f1/mad-dogs-37ce2dfc-2a85-422d-b0f3-f307b65b02f1",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 63,
      name: "Sky 1",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-02-10",
  },
  {
    id: 1996,
    url: "https://www.tvmaze.com/shows/1996/complete-savages",
    name: "Complete Savages",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28050.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28050.jpg",
    },
    summary:
      "<p><b>Complete Savages</b> chronicles the amusing and chaotic trials and tribulations of a father single-handedly raising five teenage boys.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-09-24",
  },
  {
    id: 1997,
    url: "https://www.tvmaze.com/shows/1997/endgame",
    name: "Endgame",
    genres: ["Drama", "Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28058.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28058.jpg",
    },
    summary:
      "<p><b>Endgame</b> tells the story of former World Chess Champion Arkady Balagan, who develops a debilitating case of agoraphobia after witnessing the murder of his fiancée. Unable to leave his hotel and running out of money, the arrogant and charismatic Russian inadvertently becomes a detective - using his fierce analytical skills to solve baffling crimes.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 6,
      name: "Showcase",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2011-03-14",
  },
  {
    id: 1998,
    url: "https://www.tvmaze.com/shows/1998/freddie",
    name: "Freddie",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28066.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28066.jpg",
    },
    summary:
      "<p>A successful chef living in Chicago inherits three generations of family: his niece, his sister-in-law, and his grandmother; and learns to survive living with three very different women.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-10-12",
  },
  {
    id: 1999,
    url: "https://www.tvmaze.com/shows/1999/hank",
    name: "Hank",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28073.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28073.jpg",
    },
    summary:
      "<p>Kelsey Grammer stars in this timely comedy as Hank Pryor, a titan of industry who suddenly finds himself out of work, almost out of money and around a wife and kids for whom he's never made much time. Despite his recent setbacks, however, Hank is confident he's on the road back to the top. He knows he is destined to return to greatness. And he is just not the greatness he imagines.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-09-30",
  },
  {
    id: 2000,
    url: "https://www.tvmaze.com/shows/2000/i-dream-of-jeannie",
    name: "I Dream of Jeannie",
    genres: ["Comedy", "Fantasy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28077.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28077.jpg",
    },
    summary:
      "<p><b>I Dream of Jeannie</b> is an American sitcom with a fantasy premise. The show featured a 2,000-year-old genie and an astronaut who becomes her master, with whom she falls in love and eventually marries.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1965-09-18",
  },
  {
    id: 2003,
    url: "https://www.tvmaze.com/shows/2003/my-generation",
    name: "My Generation",
    genres: ["Drama", "Family", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28096.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28096.jpg",
    },
    summary:
      "<p>What a difference ten years can make. In 2000, a documentary crew follows a disparate group of high schoolers from Greenbelt High School in Austin, TX as they prepare for graduation, then revisits these former classmates ten years later as they return home to rediscover that just because they're not where they planned doesn't mean they're not right where they need to be. These students couldn't wait to graduate and head out into the real world. But the world they were entering got very real very fast. As these classmates return home to revisit their old hopes for their future, they'll discover that, even if you don't get exactly what you thought you wanted out of life, it's not too late to get what you need.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-09-23",
  },
  {
    id: 2008,
    url: "https://www.tvmaze.com/shows/2008/skins",
    name: "Skins",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28126.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28126.jpg",
    },
    summary:
      "<p><b>Skins</b> is about the lives and loves of teenagers and the obligations of friendship. The drama series features an ensemble cast of unknown teenage actors as they navigate complex relationships, the politics of friendship and difficulties of daily life in their formative years.</p>",
    officialSite: "http://www.mtv.com/shows/skins",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-01-17",
  },
  {
    id: 2009,
    url: "https://www.tvmaze.com/shows/2009/the-casual-vacancy",
    name: "The Casual Vacancy",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28135.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28135.jpg",
    },
    summary:
      "<p>Pagford is a charming English idyll, but what lies behind the pretty façade is a town at war.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p02h1mb6",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-02-15",
  },
  {
    id: 2010,
    url: "https://www.tvmaze.com/shows/2010/the-pitch",
    name: "The Pitch",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28143.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28143.jpg",
    },
    summary:
      "<p><b>The Pitch</b> chronicles numerous interesting characters as they prepare unique creative campaigns, with big personal stakes, at their advertising agencies to try and win a major new piece of business. The show focuses on the characters who are putting their best work forward and shows the personal stakes involved in winning each client.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 20,
      name: "AMC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-04-08",
  },
  {
    id: 2011,
    url: "https://www.tvmaze.com/shows/2011/the-sing-off",
    name: "The Sing-Off",
    genres: ["Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28144.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28144.jpg",
    },
    summary: "<p>A cappella groups compete for a recording contract.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-12-14",
  },
  {
    id: 2012,
    url: "https://www.tvmaze.com/shows/2012/the-writers-room",
    name: "The Writers' Room",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28149.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28149.jpg",
    },
    summary:
      "<p>Hosted by Academy Award(R) winning screenwriter Jim Rash, <b>The Writers' Room</b> is a six episode half-hour series that takes viewers inside the writers' rooms of the hit television shows that are defining pop culture today.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 33,
      name: "Sundance TV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-07-29",
  },
  {
    id: 2014,
    url: "https://www.tvmaze.com/shows/2014/the-refugees",
    name: "The Refugees",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28154.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28154.jpg",
    },
    summary:
      "<p>Mankind is suffering the biggest exodus in history. 3,000 million people from the future have traveled to the present to escape from an imminent global disaster. All the refugees must obey two rules: they must not talk about the future and they must not contact their families.<br><br>The arrival of the refugees takes everyone by surprise, including the Cruz family. The series centers on their story, the story of Samuel, Emma and little Ani. A shift in their existence after the arrival of a mysterious refugee, Alex, who has an incredible mission that will change their lives, and in order to accomplish his mission, he will not hesitate to do what there is to do: including breaking the rules.</p>",
    officialSite: null,
    webChannel: null,
    language: "Spanish",
    status: "Ended",
    network: {
      id: 148,
      name: "La Sexta",
      country: { name: "Spain", code: "ES", timezone: "Europe/Madrid" },
    },
    premiered: "2015-05-07",
  },
  {
    id: 2015,
    url: "https://www.tvmaze.com/shows/2015/ashes-to-ashes",
    name: "Ashes to Ashes",
    genres: ["Drama", "Crime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/266/665207.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/266/665207.jpg",
    },
    summary:
      "<p>Crime drama series featuring Life on Mars' DCI Gene Hunt. After being shot in 2008, DI Alex Drake lands in 1981, where she finds herself in familiar company.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00jhp3l",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-02-07",
  },
  {
    id: 2016,
    url: "https://www.tvmaze.com/shows/2016/destination-truth",
    name: "Destination Truth",
    genres: ["Adventure", "Mystery", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28180.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28180.jpg",
    },
    summary:
      "<p>Led by intrepid world adventurer Josh Gates, each episode of Destination Truth takes viewers on a trek across the globe as Josh investigates stories of the unexplained. Accompanied by his small crew, Josh dives into the local cultures and searches for clues to the existence of strange creatures and paranormal phenomena.</p>",
    officialSite: "http://www.syfy.com/destinationtruth",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-06-06",
  },
  {
    id: 2019,
    url: "https://www.tvmaze.com/shows/2019/vanished",
    name: "Vanished",
    genres: ["Drama", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28250.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28250.jpg",
    },
    summary:
      "<p>In the series premiere, Sara Collins, the beautiful young wife of prominent Georgia Senator Jeffrey Collins, inexplicably vanishes. As the search for Sara unravels one of the nation's most prominent families, it also exposes evidence that could rock the foundations of American society. Through the eyes of Senior FBI Agent Graham Kelton, ambitious reporter Judy Nash and the distraught members of the Collins family, viewers will journey inside a sensational, thrilling national soap opera. Kelton, partnered with determined Agent Len Mei, uncovers enigmatic clues that suggest Sara's disappearance may be part of a large, sinister conspiracy. At the Collins home, Jeffrey and Sara's dutiful son Max is keeping secrets of his own, while his rebellious sister Marcy is on the verge of eloping with her sketchy boyfriend Ben, whose motives are questionable. Just when things couldn't get any more chaotic for Senator Collins, his ex-wife Jessica Nevins and a man from Sara's past, Peter Manning, mysteriously surface.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-08-21",
  },
  {
    id: 2021,
    url: "https://www.tvmaze.com/shows/2021/unhappily-ever-after",
    name: "Unhappily Ever After",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28265.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28265.jpg",
    },
    summary:
      "<p>This half-hour comedy is about the Malloy family -- headed by schizophrenic father Jack, who discusses his problems with a talking stuffed bunny named Mr. Floppy. This particular dysfunctional family is unashamedly irreverent and politically incorrect.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1995-01-11",
  },
  {
    id: 2023,
    url: "https://www.tvmaze.com/shows/2023/tracker",
    name: "Tracker",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28283.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28283.jpg",
    },
    summary:
      "<p>In a galaxy far away, alien criminals organize a spectacular prison break. Pursued by their home planet's authorities, their leader Zin decides there's only one place to go: through a wormhole that allows instantaneous travel to Earth. Cole is the Alien Tracker who's in hot pursuit of the escaped convicts. When a government group investigating extraterrestrials captures one, Cole must break into the facility and free him before they gather hard evidence they need to prove that Alien life exists on earth.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-10-15",
  },
  {
    id: 2024,
    url: "https://www.tvmaze.com/shows/2024/touching-evil",
    name: "Touching Evil",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28284.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28284.jpg",
    },
    summary:
      "<p>After recovering from being shot in the head, FBI agent David Creegan returns to work at the bureau's Organized and Serial Crime Unit a changed man. His inhibitions are just about gone - which makes him a relentless pursuer of criminals, but also a potential liability to his partner.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-03-12",
  },
  {
    id: 2025,
    url: "https://www.tvmaze.com/shows/2025/traveler",
    name: "Traveler",
    genres: ["Action", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28287.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28287.jpg",
    },
    summary:
      "<p>How well do you know your friends? Would you bet your life on it? That's the question in <b>Traveler</b>, an action-packed drama series that taps into 21st century paranoia with provocative themes, complex characters and pure adrenaline-fueled entertainment.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-05-10",
  },
  {
    id: 2029,
    url: "https://www.tvmaze.com/shows/2029/american-crime-story",
    name: "American Crime Story",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/142/356652.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/142/356652.jpg",
    },
    summary:
      "<p>This anthology series dramatizes historic criminal cases in the U.S.</p>",
    officialSite: "http://www.fxnetworks.com/shows/american-crime-story",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2016-02-02",
  },
  {
    id: 2038,
    url: "https://www.tvmaze.com/shows/2038/paranormal-survivor",
    name: "Paranormal Survivor",
    genres: ["Drama", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/48/122182.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/48/122182.jpg",
    },
    summary:
      "<p>Do you believe in ghosts, poltergeists, and demons? <b>Paranormal Survivor</b> will take you through terrifying real-life encounters with the supernatural. Hear from those who've faced these feared spirits – and watch dramatic recreations that lure people back to the scenes of these harrowing confrontations.</p>",
    officialSite: "https://www.tandetv.com/shows/paranormal-survivor/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 949,
      name: "T+E",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2015-05-31",
  },
  {
    id: 2044,
    url: "https://www.tvmaze.com/shows/2044/martial-law",
    name: "Martial Law",
    genres: ["Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28487.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28487.jpg",
    },
    summary:
      "<p>A Shanghai cop who is a master of martial arts fights crime in the Los Angeles Police Dept.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-09-26",
  },
  {
    id: 2054,
    url: "https://www.tvmaze.com/shows/2054/lovehate",
    name: "Love/Hate",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28667.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28667.jpg",
    },
    summary:
      "<p>He skipped Dublin when a gun was found in his house and he's been living for the past year in Spain but Darren Tracey decides to risk it and come back to Dublin. He's homesick and a party for his brother's release from prison is the perfect excuse. It's only for the weekend but sometimes life is full of surprises - especially if you and your friends are in gangland. When one of the gang is killed, suspicion runs rife and thoughts turn to revenge.</p>",
    officialSite: "http://www.rte.ie/drama/tv/featured/lovehate/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 165,
      name: "RTÉ ONE",
      country: { name: "Ireland", code: "IE", timezone: "Europe/Dublin" },
    },
    premiered: "2010-10-03",
  },
  {
    id: 2055,
    url: "https://www.tvmaze.com/shows/2055/71-degrees-north",
    name: "71 Degrees North",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/64/161628.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/64/161628.jpg",
    },
    summary:
      "<p>Kate Thornton and Gethin Jones present a brand new adventure reality series in which 10 celebrities go on a spectacular and challenging race deep into the Arctic Circle. The stars taking part are Shane Richie, Andrew Castle, Gavin Henson, Michelle Mone, Susie Amy, Diarmuid Gavin, Lauren Socha, Konnie Huq, Marcus Patric and Joe Absolom. Their journey begins with an action-packed dog sled race to win a night in the warm. Then they face a mid-winter swim in the icy waters of a Norwegian fjord - wearing just swimsuits. Each week the group must vote for one person to leave the expedition. Who has what it takes to survive the extreme conditions and make it to the end of the trek?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-09-07",
  },
  {
    id: 2056,
    url: "https://www.tvmaze.com/shows/2056/3-days",
    name: "3 Days",
    genres: ["Drama", "Action", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/63/158846.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/63/158846.jpg",
    },
    summary:
      "<p>A drama about a case that occurs in three days between secret service agents in the Blue House. The South Korean President travels to a villa to enjoy his vacation. After three gunshots are fired, he disappears. His bodyguard Han Tae Kyung attempts to find the President.</p>",
    officialSite: "http://tv.sbs.co.kr/3days/",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 127,
      name: "SBS",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2014-03-05",
  },
  {
    id: 2060,
    url: "https://www.tvmaze.com/shows/2060/sidonia-no-kishi",
    name: "Sidonia no Kishi",
    genres: ["Adventure", "Anime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28724.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28724.jpg",
    },
    summary:
      "<p>A thousand years after the alien Gauna destroyed the Earth, a small remnant of humanity still fights on to survive, fleeing on the gargantuan asteroid-based spaceship Sidonia. But centuries of flight and warfare have changed mankind in incredible ways: genetic engineering has allowed humans to photosynthesize like plants, reproduction occurs through cloning, and a third gender has been created to balance the population. Even though it's been a century since the last encounter with the Gauna, military service is mandatory, with all those able enough enlisted to pilot the Garde robots that stand as Sidonia's front line of defense. For Nagate Tanikaze, whose grandfather secretly hid him in the forgotten bowels of the asteroid, it's a strange new world as he's forced to come to the surface and join the ranks of defenders. Yet his recruitment comes just in time, for the Gauna have suddenly reappeared, and what could be man's last battle will require every resource humanity has left. And what no one knows, yet, is that Nagate is not exactly what he seems, and a secret buried in his past may change the fate of all mankind!</p>",
    officialSite: "http://www.knightsofsidonia.com/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 24,
      name: "MBS",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2014-04-11",
  },
  {
    id: 2062,
    url: "https://www.tvmaze.com/shows/2062/space-dandy",
    name: "Space Dandy",
    genres: ["Comedy", "Anime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28730.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28730.jpg",
    },
    summary:
      "<p><b>Space Dandy</b> is a dandy in space! This dreamy adventurer with a to-die-for pompadour travels across the galaxy in search of aliens no one has ever laid eyes on. Each new species he discovers earns him a hefty reward, but this dandy has to be quick on his feet because it's first come first served! Accompanied by his sidekicks, a rundown robot named QT and Meow the cat-looking space alien, Dandy bravely explores unknown worlds inhabited by a variety aliens. Join the best dressed alien hunter in all of space and time as he embarks on an adventure that ends at the edge of the universe!</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 132,
      name: "Tokyo MX",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2014-01-05",
  },
  {
    id: 2066,
    url: "https://www.tvmaze.com/shows/2066/tokyo-ravens",
    name: "Tokyo Ravens",
    genres: ["Action", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28748.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28748.jpg",
    },
    summary:
      "<p>Harutora may seem like an ordinary guy, but he's actually a descendent of an ancient and powerful clan of omyouji. Born without the family talent for magic, he'd always believed he was destined for a normal, boring existence. All that changed the day Natsume, a beautiful face from Harutora's past, barged back into his life and forever altered the course of his future. When her sudden arrival leads to a violent and tragic encounter with a magical prodigy, Harutora agrees to fulfill a childhood vow by accompanying Natsume to the clandestine Onmyo Academy. Together, along with their incredible onmyouji classmates, they'll attempt to survive life at a school where not even magic can get you out of your homework.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 132,
      name: "Tokyo MX",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2013-10-09",
  },
  {
    id: 2067,
    url: "https://www.tvmaze.com/shows/2067/oniichan-dakedo-ai-sae-areba-kankeinai-yo-ne",
    name: "Oniichan Dakedo Ai Sae Areba Kankeinai Yo Ne!",
    genres: ["Drama", "Anime", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28749.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28749.jpg",
    },
    summary:
      "<p>The story centers around Akito Himenokōji, a boy who was separated from his twin sister Akiko, but they end up living under the same roof together during high school.</p>",
    officialSite: "http://oniai.com/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 167,
      name: "AT-X",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2012-10-05",
  },
  {
    id: 2069,
    url: "https://www.tvmaze.com/shows/2069/fairy-tail",
    name: "Fairy Tail",
    genres: ["Action", "Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/62/156497.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/62/156497.jpg",
    },
    summary:
      "<p>The story follows a teenage girl named Lucy Heartfilla who is determined to join the notorious magical Fairy Tail Guild. During a daring rescue, she encounters Natsu who is part of the guild and eventually offers her a place. They become teammates performing various missions for the Fairy Tail Guild.</p>",
    officialSite: "http://www.tv-tokyo.co.jp/anime/fairytail/index2.html",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2009-10-12",
  },
  {
    id: 2077,
    url: "https://www.tvmaze.com/shows/2077/the-fall-and-rise-of-reginald-perrin",
    name: "The Fall and Rise of Reginald Perrin",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28838.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28838.jpg",
    },
    summary:
      "<p>Leonard Rossiter stars in David Nobbs's black comedy about a sales executive whose mid-life crisis results in him faking his own death.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00hxvdz",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1976-09-08",
  },
  {
    id: 2081,
    url: "https://www.tvmaze.com/shows/2081/splash",
    name: "Splash",
    genres: ["Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28849.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28849.jpg",
    },
    summary:
      "<p>Celebrities dive from extreme heights into a pool. Each week one celebrity is eliminated and the challenge becomes more difficult.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-03-19",
  },
  {
    id: 2082,
    url: "https://www.tvmaze.com/shows/2082/monday-mornings",
    name: "Monday Mornings",
    genres: ["Drama", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28850.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28850.jpg",
    },
    summary:
      "<p>Set at the fictional Chelsea General Hospital in Portland, Oregon, <b>Monday Mornings</b> follows the lives of doctors as they push the limits of their abilities and confront their personal and professional failings. The title refers to the hospital's weekly morbidity and mortality conference, when doctors gather with their peers for a confidential review of complications and errors in patient care.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-02-04",
  },
  {
    id: 2086,
    url: "https://www.tvmaze.com/shows/2086/engrenages",
    name: "Engrenages",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28898.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28898.jpg",
    },
    summary:
      "<p>When the badly beaten body of a young Romanian woman is discovered on a Parisian rubbish dump, the investigation plunges us deep into the murky worlds of prostitution, drugs, business, politics and justice…</p><p>The investigation is led by Pierre Clément, a young recently-named public prosecutor, who teams up with Police Captain Laure Bathaud and investigating magistrate Judge Roban – three indomitable characters with their own methods, beliefs, demons and visions of justice.</p><p>As the young woman's identity and past life are gradually uncovered, it soon becomes apparent that her story is tied to a network of corruption touching the very people charged with uncovering the truth about her.</p>",
    officialSite: "https://www.canalplus.com/series/engrenages/h/4444010_50001",
    webChannel: null,
    language: "French",
    status: "Ended",
    network: {
      id: 105,
      name: "Canal+",
      country: { name: "France", code: "FR", timezone: "Europe/Paris" },
    },
    premiered: "2005-12-13",
  },
  {
    id: 2087,
    url: "https://www.tvmaze.com/shows/2087/surface",
    name: "Surface",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/28907.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/28907.jpg",
    },
    summary:
      "<p>During a routine submarine dive, oceanographer Laura Daughtery discovers an unknown life form and unearths a government cover-up operation led by scientist Dr. Aleksander Cirko. Meanwhile, Louisiana fisherman Richard Beck loses his brother in a suspicious diving accident, and a young boy named Miles sneaks an unusual aquatic egg into his home. From the South Antarctic Sea and the Gulf of Mexico to San Diego and Monterey, there's something lurking beneath the Surface.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-09-19",
  },
  {
    id: 2100,
    url: "https://www.tvmaze.com/shows/2100/the-challenge",
    name: "The Challenge",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/282/707202.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/282/707202.jpg",
    },
    summary:
      '<p>Set in the middle of the jungle, "The Challenge: War of the Worlds 2" returns to a classic team format; 14 Brits will battle it out against 14 Americans for their share of the $1 million-dollar prize.</p>',
    officialSite:
      "https://www.mtv.com/shows/15iqn2/the-challenge-double-agents",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-06-01",
  },
  {
    id: 2101,
    url: "https://www.tvmaze.com/shows/2101/solitary",
    name: "Solitary",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755306.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755306.jpg",
    },
    summary:
      '<p>New twists and turns are guaranteed to test the contestants\' endurance and lead them to the brink of psychological and physical collapse. Nine all new contestants and one returning player will push their mind and body to its limit, while obeying every whim of Val, their omnipresent digital taskmaster. As with the first three seasons, the premise of Solitary v4.0 is simple: the last person to leave their pod small, barren and completely isolated wins bragging rights and $50,000. There are no councils, no alliances, and no votes. No one goes home until they themselves choose to push the red button and quit. All contestants willingly place themselves in their assigned "pods" to undergo grueling tests and treatments assigned by their sarcastic, omniscient digital taskmaster, Val. These individuals are subjected to sleep deprivation, extreme temperatures and other forms of environmental stress meant to "break" them, thus causing them to leave their pod and lose. Perhaps the most challenging part about Solitary is that contestants have no idea what the other contestants are doing or how much longer they must endure the competition.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1061,
      name: "Fox Reality Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-06-05",
  },
  {
    id: 2102,
    url: "https://www.tvmaze.com/shows/2102/dragon-ball",
    name: "Dragon Ball",
    genres: ["Action", "Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/29189.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/29189.jpg",
    },
    summary:
      "<p>This is where it all begins. The story starts with Goku at 12 when he first meets Bulma and is introduced to the legend of the Dragonballs: who ever gets all seven Dragonballs will have their wish granted by Shenron, the Dragon who resides within the balls. As Goku goes along his adventure he meets other characters such as Master Roshi, Krillin and others.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 131,
      name: "Fuji TV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1986-02-26",
  },
  {
    id: 2103,
    url: "https://www.tvmaze.com/shows/2103/dragon-ball-z",
    name: "Dragon Ball Z",
    genres: ["Action", "Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/29190.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/29190.jpg",
    },
    summary:
      "<p>Part 2 of the Dragonball madness, this story starts when Goku is an adult and introduces him to his Saiyan origin. The main theme of Dragonball Z is fighting although it still retains aspects of the humor and adventure from the previous Dragonball series. Characters develop as they grow, mature, and some even have children! Many of Goku's former enemies become his friend they band together to fight greater evils along the way.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 131,
      name: "Fuji TV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1989-04-26",
  },
  {
    id: 2110,
    url: "https://www.tvmaze.com/shows/2110/young-hercules",
    name: "Young Hercules",
    genres: ["Action", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/29372.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/29372.jpg",
    },
    summary:
      '<p>"In an age of light and darkness Zeus, King of the Gods, rules the universe. He had a son, young Hercules. Half-god, half-man, young Hercules longs to find his place in this world... the father he\'s never known, and what it means to be a hero. Before the man became legend... before the legend became myth... came the greatest adventure of all... young Hercules".</p><p>Young version of Hercules first appeared in season 4 of "Hercules: The Legendary Journeys" TV series. He was portrayed by Ian Bohen. In first feature film which serves as  prologue into TV series, Ian Bohen also played young Hercules. In "Young Hercules" TV series the role was given to Ryan Gosling. Both Iolaus and Jason, Hercules\' trusty friends and co-lead characters were played by the same actors throughout everything.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-09-12",
  },
  {
    id: 2111,
    url: "https://www.tvmaze.com/shows/2111/mysterious-ways",
    name: "Mysterious Ways",
    genres: ["Drama", "Fantasy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/29375.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/29375.jpg",
    },
    summary:
      "<p>Anthropology professor Declan Dunn was once buried by an avalanche, but he somehow got out alive. Now he searches for the reasons behind miraculous phenomena. He gets help from his friends: Dr. Peggy Fowler, a psychiatrist at a nearby hospital, and Miranda Feigelsteen, a physics graduate student and Dunn's research assistant.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-07-24",
  },
  {
    id: 2113,
    url: "https://www.tvmaze.com/shows/2113/jessica-simpsons-the-price-of-beauty",
    name: "Jessica Simpson's The Price of Beauty",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/203/507712.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/203/507712.jpg",
    },
    summary:
      '<p>Jessica Simpson is embarking on a world tour...but this time it has nothing to do with music. Jessica, along with her two best friends, Ken Paves and CaCee Cobb, are traveling the globe to explore how different cultures define beauty and the extraordinary lengths that women will go to in order to achieve it.</p><p>Journeying from Tokyo and Thailand, to Paris and Rio, to Uganda, Morocco and India -- the cast is met in each city by a "beauty ambassador" who helps them tackle topics revolving around fashion, fitness, diet and outlandish spa treatments. In each country, Jessica, Ken and CaCee experience firsthand some of the local beauty rituals, from drinking cow urine in India, to being buried up to their necks in Tokyo, to drinking gourds of ghee in a fattening hut in Uganda. But it\'s not all fun and games -- Jessica also explores the high price that some women pay to feel beautiful. Imagine the plight of women in Northern Thailand, who wear 20-pound rings around their necks, crushing their clavicles, to a mother in Rio who cannot afford electricity, but is secretly saving for butt implants.</p><p>Each episode ends in a complete transformation of the cast. Imagine Jessica, Ken and CaCee dressed in ornate kaftans, or camel-back riding to a festive Moroccan party complete with belly dancers and live musicians.</p><p>As Jessica learns how beauty is defined across the globe, and how she "measures up," and her own definition of the word, she is challenged to redefine it along the way, allowing the audience to see a personal, vulnerable and oftentimes hilarious side of Jessica Simpson.</p><p>Each episode culminates in a complete transformation of the cast -- Imagine Jessica, Ken and CaCee dressed in ornate kaftans, riding camel-back to a festive Moroccan party, complete with belly dancers and live musicians. They talk to local women and dance the night away Moroccan style.</p><p>As Jessica learns how beauty is defined in far away lands, her own sense of beauty, and how she "measures up" is challenged and redefined along the way, allowing the audience to see a personal, and often times, vulnerable and hilarious side of Jessica Simpson.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 55,
      name: "VH1",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-03-15",
  },
  {
    id: 2116,
    url: "https://www.tvmaze.com/shows/2116/ancient-discoveries",
    name: "Ancient Discoveries",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/29603.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/29603.jpg",
    },
    summary:
      '<p>In the ancient texts of Homer and the walls of Egyptian tombs lie tantalizing clues that are causing historians to re-think just how sophisticated centuries-old societies were. Drawings show that the Egyptians may have unlocked the secret to flight with primitive helicopter designs, and that the Chinese had a "wind car" in the 6th century AD that could transport them over land at up to 30 miles per hour. Even more amazing are 600-year-old designs from Italy for a Batmobile-like "rocket car" that appeared to be fueled by gunpowder. Mechanical maids that could fetch water for people on their own were created by the inventor Philos in the Third century, a concept we still struggle to perfect today! And discoveries about ancient machines of warfare give a new vision of what truly defined the Egyptian empire. Each week, <b>Ancient Discoveries</b> unearths new clues that connect the present with the past in more startling ways than we had ever imagined.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-12-21",
  },
  {
    id: 2117,
    url: "https://www.tvmaze.com/shows/2117/martin-lawrence-presents-1st-amendment-stand-up",
    name: "Martin Lawrence Presents 1st Amendment Stand-Up",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/29604.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/29604.jpg",
    },
    summary:
      "<p><b>Martin Lawrence Presents 1st Amendment Stand-Up</b> returns for a fifth season with a new host, comedian Sheryl Underwood, and a fresh line-up of rising and seasoned comedy stars. The show, which is Starz' longest running original series, is scheduled to premiere in October. Performances for the fifth season will be taped May 13-16 before a live audience at The Chicago Theatre. Underwood will step in for original host Doug Williams, who will continue to serve as executive producer of the show.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 17,
      name: "Starz",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-04-18",
  },
  {
    id: 2120,
    url: "https://www.tvmaze.com/shows/2120/american-bandstand",
    name: "American Bandstand",
    genres: ["Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/29788.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/29788.jpg",
    },
    summary:
      "<p><b>American Bandstand</b> is an American music-performance show that aired in various versions from 1952 to 1989 and was hosted from 1956 until its final season by Dick Clark, who also served as producer. The show featured teenagers dancing to Top 40 music introduced by Clark; at least one popular musical act—over the decades, running the gamut from Jerry Lee Lewis to Run DMC—would usually appear in person to lip-sync one of their latest singles. Freddy \"Boom Boom\" Cannon holds the record for most appearances at 110.</p><p>The show's popularity helped Dick Clark become an American media mogul and inspired similar long-running music programs, such as Soul Train and Top of the Pops. Clark eventually assumed ownership of the program through his 'Dick Clark Productions' company.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1957-08-05",
  },
  {
    id: 2124,
    url: "https://www.tvmaze.com/shows/2124/green-acres",
    name: "Green Acres",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/29802.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/29802.jpg",
    },
    summary:
      "<p>New York lawyer Oliver Wendell Douglas longs for a simpler way of life. So he buys a farm, sight unseen, and moves there to live off the land, much to the chagrin of his socialite wife, Lisa. The collision of small-town life and Lisa's sophisticated ways -- she insists on wearing full-length gowns and ostentatious jewelry, even on the farm -- provide much of the humor in the show.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1965-09-15",
  },
  {
    id: 2125,
    url: "https://www.tvmaze.com/shows/2125/highway-patrol",
    name: "Highway Patrol",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/29807.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/29807.jpg",
    },
    summary:
      '<p>Packed with fast motorcycles, powerful patrol cars, helicopters and two-way radios, <b>Highway Patrol</b> screamed onto the scene destined to be one of the most popular syndicated television series of all time. This action packed show filled with harrowing roadway adventures sped its way from the TV screen into pop culture with the catch phrase "10-4".</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1955-10-05",
  },
  {
    id: 2136,
    url: "https://www.tvmaze.com/shows/2136/sky-king",
    name: "Sky King",
    genres: ["Action", "Adventure", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/29826.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/29826.jpg",
    },
    summary:
      "<p><b>Sky King</b> was a WWII naval aviator-turned rancher, who flies his twin-engine Cessna high above the Arizona plains. Accompanying Sky on his adventures are his nephew, Clipper and his teen niece, Penny. Starring Kirby Grant and Gloria Winters.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1952-04-05",
  },
  {
    id: 2139,
    url: "https://www.tvmaze.com/shows/2139/the-beverly-hillbillies",
    name: "The Beverly Hillbillies",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/29898.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/29898.jpg",
    },
    summary:
      '<p>An instant hit, the rural comedy was the ultimate fish-out-of-water story. The Clampett family strikes it rich in oil and move from their mountain cabin in the Ozark Mountains to the upscale neighborhood of Beverly Hills. Each hilarious episode revolves around the culture clash between the "uncivilized" Clampetts and the "civilized" culture of their elitist neighbors.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1962-09-26",
  },
  {
    id: 2143,
    url: "https://www.tvmaze.com/shows/2143/the-flintstones",
    name: "The Flintstones",
    genres: ["Comedy", "Adventure", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/11/29907.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/11/29907.jpg",
    },
    summary:
      "<p>Join the fun in the town of Bedrock with the this fabulously famous modern Stone-Age family. Mowing the lawn with a saw-toothed dinosaur, showering with water sprayed from a woolly mammoth's trunk and eating brontosaurus burgers are everyday events for the lovable Fred and Wilma Flintstone and their friends Barney and Betty Rubble. Living in prehistoric times has its drawbacks, but the Flintstones and their neighbors survive in style. So have a yabba-dabba-doo time with the <b>The Flintstones</b>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1960-09-30",
  },
  {
    id: 2154,
    url: "https://www.tvmaze.com/shows/2154/monica-the-medium",
    name: "Monica the Medium",
    genres: ["Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755313.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755313.jpg",
    },
    summary:
      '<p><i><b>"Monica the Medium"</b></i> provides a fascinating look at Monica, a junior at Penn State navigating friends, family, relationships – and the fact that she\'s a medium and can talk to dead people. Her uncommon vocation provides an endless supply of emotional and engaging stories, with a unique millennial perspective.</p>',
    officialSite: "http://abcfamily.go.com/shows/monica-the-medium",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-25",
  },
  {
    id: 2188,
    url: "https://www.tvmaze.com/shows/2188/big-trouble-in-thailand",
    name: "Big Trouble in Thailand",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/81/204517.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/81/204517.jpg",
    },
    summary:
      "<p>Wiith unprecedented behind-the-scenes access to the Thai Tourist Police, Big Trouble in Thailand an action packed fly-on-the-wall series that follows Howard, Louise and Tim, specially recruited British ex-pats who have joined the formidable Thai tourist police force, to aid them in their difficult job policing fellow Westerners unaware and oblivious to Thailand's unfamiliar traditions, culture and rules.</p><p>Attracting nearly 1m British holidaymakers each year, with a good proportion of these completely unaware that fairly minor misdemeanours can mean grave consequences including prison sentences and having guns pulled on you, Bravo's cameras go beyond the idyllic beaches and tropical island life to capture a rare and fascinating insight into British holidaymakers as they party in paradise and discover the horrors that can happen when things go drastically wrong.</p><p>From adrenaline fuelled drug busts, organised tourist scams, scorned lady-boys, violent brothel disputes, bar room brawls, brutal murders, street robberies and sexual assaults, the series is filmed in the popular tourist hotspots of Koh Samui, Phuket, Bangkok, Pattaya and Chang Mai.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 326,
      name: "Bravo",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-09-07",
  },
  {
    id: 2207,
    url: "https://www.tvmaze.com/shows/2207/even-stevens",
    name: "Even Stevens",
    genres: ["Comedy", "Children", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/30563.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/30563.jpg",
    },
    summary:
      "<p>The misadventures of the Stevens family, a family of five from Sacramento, California.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 78,
      name: "Disney Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-06-17",
  },
  {
    id: 2209,
    url: "https://www.tvmaze.com/shows/2209/phil-of-the-future",
    name: "Phil of the Future",
    genres: ["Comedy", "Family", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/249/624809.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/249/624809.jpg",
    },
    summary:
      "<p>Phil is just your average teenager -- whose family crash-landed here from the year 2121. His adventures are out of this world, his futuristic gadgets are definitely outrageous, and his life is totally cool. So will he ever want to go back to the future?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 78,
      name: "Disney Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-06-18",
  },
  {
    id: 2212,
    url: "https://www.tvmaze.com/shows/2212/celebrity-family-feud",
    name: "Celebrity Family Feud",
    genres: ["Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/259/649477.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/259/649477.jpg",
    },
    summary:
      "<p>Teams of celebrities and their families face off to name the top responses to questions posed to 100 people.</p>",
    officialSite: "https://abc.com/shows/celebrity-family-feud",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-21",
  },
  {
    id: 2242,
    url: "https://www.tvmaze.com/shows/2242/car-matchmaker",
    name: "Car Matchmaker",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31090.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31090.jpg",
    },
    summary:
      "<p>Former Seinfeld writer, talk show host and comedian, Spike Feresten, is the guy to go to when you need a new set of wheels. In <b>Car Matchmaker</b>, Spike finds a guy in need of a car, gets to know him, and then draws upon two decades of expertise and instinct to find three different cars perfectly suited to the buyer. At the end of each episode, a car is chosen. But will Spike agree with the buyer's choice? For that matter, will you?</p>",
    officialSite: "http://tv.esquire.com/shows/car-matchmaker",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 184,
      name: "Esquire Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-14",
  },
  {
    id: 2245,
    url: "https://www.tvmaze.com/shows/2245/truth-be-told",
    name: "Truth Be Told",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/16/41485.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/16/41485.jpg",
    },
    summary:
      '<p>If you can think it, they will say it. From the producer of "Ride Along" and the director of "How I Met Your Mother" comes this unabashed new comedy about two diverse couples, who are both neighbors and best friends. As they go through life side by side, they can\'t help but analyze and obsess about EVERYTHING. From topics like sex and race, to the fact that the trusted new babysitter might just be a porn star, nothing is out of bounds for this wildly outspoken foursome.</p>',
    officialSite: "http://www.nbc.com/truth-be-told",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-16",
  },
  {
    id: 2251,
    url: "https://www.tvmaze.com/shows/2251/consumed-the-real-restaurant-business",
    name: "Consumed: The Real Restaurant Business",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/222/555648.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/222/555648.jpg",
    },
    summary:
      "<p>There's nothing more glamorous than running a restaurant – but there's also nothing more difficult. For restaurateurs trying to earn their piece of the pie, the New York food scene is a ruthless, cutthroat jungle where the stakes are high, the margins are razor thin, and success is hard to come by. In a new primetime docu-series, <b>Consumed: The Real Restaurant Business</b>, CNBC takes viewers behind–the-scenes of five very different restaurants in the ultra-competitive New York food scene, chronicling their every struggle and occasional triumph.</p><p>The 8 one-hour episodes will follow five businesses at a crossroads, fighting for their piece of a multi-billion dollar industry: famed NYC hotspot and budding empire The Meatball Shop; Melba's, a Harlem comfort food restaurant and neighborhood joint with national ambitions; Ann &amp; Tony's, a multi-generational restaurant in the Bronx that's struggling to fill seats ─ and preserve its family legacy; Vermilion, an upscale restaurant hoping to win over the critical NY food press with an expensive re-launch; and Seamore's, a bold, but risky new seafood restaurant launching this summer.</p>",
    officialSite:
      "http://www.cnbc.com/live-tv/consumed-the-real-restaurant-business",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 93,
      name: "CNBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-13",
  },
  {
    id: 2253,
    url: "https://www.tvmaze.com/shows/2253/i-escaped-my-killer",
    name: "I Escaped My Killer",
    genres: ["Crime", "Thriller", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31063.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31063.jpg",
    },
    summary:
      "<p><b>I Escaped My Killer</b> tells the true stories of women who were abducted by serial killers, and somehow made it out of their grasp...not only with their own lives but also with the information needed to break the case, save other lives and bring a monster to justice. A true hybrid of storytelling, half the episode is the harrowing, blow-by-blow tale of one woman's struggle for survival against the ultimate evil; the other half is the story of a killer on the loose and the detectives who doggedly work to track him down and stop his reign of terror. Artfully woven together, the two stories finally merge into one in the final act(s) when the stories naturally come together. Each woman who escapes and survives is the key to solving the entire case, the break that investigators have been waiting for. This new format sets the series apart from other survival shows that only follow a single point of view. Our format will show the broader picture from the investigators' whodunit point of view as well as the intimate story of one woman fighting for survival and for justice.</p>",
    officialSite: "http://www.mylifetime.com/movies/i-escaped-my-killer",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 232,
      name: "Lifetime Movies",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-10",
  },
  {
    id: 2263,
    url: "https://www.tvmaze.com/shows/2263/beyond-scared-straight-back-talk",
    name: "Beyond Scared Straight: Back Talk",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/35878.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/35878.jpg",
    },
    summary:
      "<p><b>Beyond Scared Straight: Back Talk</b> features brand-new footage and interviews with the participants involved in original episodes of Beyond Scared Straight. Each episode of Beyond Scared Straight: Back Talk focuses on a different prison program in the United States, following four or five at-risk teens as they attend the program and experience their intensive one-day in-prison session. The program then follows up with them one-month later to see the lasting impressions the program has left on them.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-25",
  },
  {
    id: 2264,
    url: "https://www.tvmaze.com/shows/2264/american-takedown",
    name: "American Takedown",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31594.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31594.jpg",
    },
    summary:
      "<p>From Executive Producer Morgan Spurlock, the new series, <b>American Takedown</b> goes behind the scenes of cases as tactical law-enforcement units work to apprehend America's most dangerous criminals.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-25",
  },
  {
    id: 2279,
    url: "https://www.tvmaze.com/shows/2279/compass-with-sheila-macvicar",
    name: "Compass with Sheila MacVicar",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755201.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755201.jpg",
    },
    summary:
      "<p>Beginning Sunday May 10th, <b>\"Compass with Sheila MacVicar\"</b> will combine Al Jazeera America's commitment to original, unfiltered reporting with award-winning international journalist Sheila MacVicar's ability to put news into a global context and make connections to U.S. foreign policy goals. This unique foreign policy program will also aim to uncover the hidden agendas, strategic failures, political power plays and special interests that may influence America's foreign policy, and play a role in regional politics around the world.</p><p>\"Compass' is about the world, and people's place in it. With Al Jazeera's unparalleled reach, and our ability to report from places no one else covers, we'll go straight to the source of today's most pressing international news,\" said MacVicar. \"With interest in global affairs so strong, and people showing a marked preference for original reporting from the source, this show meets the needs of today's news consumers and delivers on the channel's overall mission of increasing knowledge about global affairs.\"</p>",
    officialSite:
      "http://america.aljazeera.com/tools/pressreleases/al-jazeera-americalaunchesforeignpolicyprogramcompasswithsheilam0.html",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 169,
      name: "Al Jazeera America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-10",
  },
  {
    id: 2285,
    url: "https://www.tvmaze.com/shows/2285/the-night-manager",
    name: "The Night Manager",
    genres: ["Drama", "Thriller", "Espionage"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/177/444463.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/177/444463.jpg",
    },
    summary:
      "<p>Drama series based on the John le Carré novel. A hotel night manager is recruited by a government agent to infiltrate the inner circle of a ruthless arms dealer.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p03g13rt",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2016-02-21",
  },
  {
    id: 2289,
    url: "https://www.tvmaze.com/shows/2289/the-outer-limits",
    name: "The Outer Limits",
    genres: ["Drama", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31574.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31574.jpg",
    },
    summary:
      "<p>Like the classic 1960's series of the same name, each episode is an imaginative exploration of humanity's greatest hopes and darkest fears and include special guest appearances by Alyssa Milano, Ryan Reynolds, Rae Dawn Chong, Beau Bridges, Rebecca De Mornay and Robert Patrick. Winner of the Cable Ace Award for best Dramatic Series, this Emmy® nominated show deals with the consequences of such controversial and thought-provoking topics as genetic manipulation, alien visitation and life after death.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1995-03-26",
  },
  {
    id: 2290,
    url: "https://www.tvmaze.com/shows/2290/beach-flip",
    name: "Beach Flip",
    genres: ["DIY"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/81/202858.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/81/202858.jpg",
    },
    summary:
      "<p><b>Beach Flip</b> is a series where four teams hit the sandy beaches of Gulf Shores, Alabama to battle it out in an epic renovation competition. Hosts Nicole Curtis, Josh Temple and David Bromstad mentor four teams as they transform beachfront bungalows in need of a major makeover. The teams compete weekly to win a cash advantage until their properties are completely transformed from top to bottom. The team who delivers the highest increase in value on their beach bungalow will win $50,000.</p>",
    officialSite: "http://www.hgtv.com/shows/beach-flip",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 192,
      name: "HGTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-05",
  },
  {
    id: 2291,
    url: "https://www.tvmaze.com/shows/2291/fresh-beat-band-of-spies",
    name: "Fresh Beat Band of Spies",
    genres: ["Adventure", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31622.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31622.jpg",
    },
    summary:
      "<p>In this brand-new animated series based on the hit live-action show, the <i>Fresh Beat Band of Spies</i>, the four best friends -- Kiki, Marina, Twist and Shout – are also a group of undercover spies. The pop band uses their individual talents and the coolest transforming spy gadgets to outwit a goofy cast of bad guys and solve an endless series of wild and wacky mysteries. The series, which teaches problem-solving to preschoolers, is created by Nadine van der Velde and Scott Kraft, the same duo behind The Fresh Beat Band.</p>",
    officialSite: "http://www.nickjr.com/fresh-beat-band-of-spies/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 206,
      name: "Nick Jr.",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-13",
  },
  {
    id: 2292,
    url: "https://www.tvmaze.com/shows/2292/over-my-dead-body",
    name: "Over My Dead Body",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31690.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31690.jpg",
    },
    summary:
      "<p>Told through emotional first-person interviews and action-packed reenactments, <b>Over My Dead Body</b> presents empowering stories of women who were attacked and didn't just fight back but turned the tables on their enemy and lived the tell the tale. Actress Linda Hamilton joins as host, channeling her iconic character from the Terminator franchise, damsel-turned-warrior Sarah Connor, to reveal real-life survivors who were stalked and brutalized by an assailant yet somehow found the inner strength to take charge and come out victorious.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-15",
  },
  {
    id: 2296,
    url: "https://www.tvmaze.com/shows/2296/time-traveling-with-brian-unger",
    name: "Time Traveling with Brian Unger",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755198.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755198.jpg",
    },
    summary:
      "<p><b>Time Traveling with Brian Unger</b> goes where ordinary travelers can't, using eye-popping computer-generated graphics to visually travel back in time and tell stories from yesteryear that tourists won't find in the guidebooks. Host Brian Unger is the ultimate tour guide, bringing his irreverent humor and point of view to the fascinating stories that most Americans don't know yet. In each episode, locals agree to accompany Brian to destinations they've never visited before--some off-limits to the general public--or to look at iconic landmarks in a fresh, new way, revealing histories we never knew.</p>",
    officialSite:
      "http://www.travelchannel.com/shows/time-traveling-with-brian-unger",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 82,
      name: "Travel Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-20",
  },
  {
    id: 2297,
    url: "https://www.tvmaze.com/shows/2297/tornado-alley",
    name: "Tornado Alley",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31699.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31699.jpg",
    },
    summary:
      '<p>The Wizard of Oz movie in 1939 helped Kansas and the Great Plains become known as part of <i><b>"Tornado Alley"</b></i> - the region of the United States often visited in late spring and early summer by dangerous, sometimes violent, tornadoes. Part of the reason why is that the "dryline" -- a front separating moist Gulf of Mexico air from dry air from the Southwest -- often sits across these states, helping spawn tornado-producing thunderstorms. The Glossary of Meteorology published by the American Meteorological Society defines <i><b>"Tornado Alley"</b></i> as "a term often used by the media to denote a zone in the Great Plains region of the central United States, often a north-south-oriented region centered on north Texas, Oklahoma, Kansas, and Nebraska, where tornadoes are most frequent."</p>',
    officialSite:
      "http://www.weather.com/tv/shows/tornado-alley/news/tornado-alley-season-two-premiere",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 228,
      name: "The Weather Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-04-28",
  },
  {
    id: 2302,
    url: "https://www.tvmaze.com/shows/2302/doubt",
    name: "Doubt",
    genres: ["Drama", "Crime", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/92/231466.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/92/231466.jpg",
    },
    summary:
      "<p>Sadie Ellis is a brilliant attorney at a boutique firm who starts to fall for her charismatic client, Billy Brennan, an altruistic pediatric surgeon recently accused of murdering his girlfriend 24 years ago. Sadie is hiding her growing feelings from everyone, including her close friend and colleague, Albert Cobb, who thinks he knows everything about her. Working on other cases at the practice is Cameron Wirth, a transgender Ivy League graduate who fights passionately for her clients since she's experienced injustice first hand; Tiffany Simon, a second-year associate who is quickly learning the ropes from Wirth; and Nick, a former felon who earned his degree while serving time. They all consider it a privilege to work for Isaiah Roth, a revered legal lion and \"lefty\" legend, whose approval is their holy grail. Sadie's decision to become involved with her client could put her career, as well as her happiness, at risk if Billy is found guilty, which means she needs to work all the harder to prove reasonable doubt, even if she has some herself.</p>",
    officialSite: "http://www.cbs.com/shows/doubt/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2017-02-15",
  },
  {
    id: 2306,
    url: "https://www.tvmaze.com/shows/2306/rose-red",
    name: "Rose Red",
    genres: ["Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/50/125578.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/50/125578.jpg",
    },
    summary:
      "<p>Dr. Joyce Reardon assembles a team of paranormal talents to investigate an allegedly haunted mansion known as <b>Rose Red</b> in this mini-series written by Stephen King. Can the team survive the horror that they uncover within the walls of this secretive structure? And how far will Reardon go to get the answers she seeks? Welcome to a place that evil calls home...</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-01-27",
  },
  {
    id: 2307,
    url: "https://www.tvmaze.com/shows/2307/watts-world",
    name: "Watt's World",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/32516.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/32516.jpg",
    },
    summary:
      "<p>In <b>Watt's World</b>, follow journalist Nick Watt as he explores the world to answer burning questions such as: Are the French really rude? Do cowboys still exist? Is Albania that weird? Using his quick wit, he'll offer a point of view that is both surprising and entertaining.</p>",
    officialSite: "http://www.travelchannel.com/shows/watts-world",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 82,
      name: "Travel Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-30",
  },
  {
    id: 2308,
    url: "https://www.tvmaze.com/shows/2308/the-meltdown-with-jonah-and-kumail",
    name: "The Meltdown with Jonah and Kumail",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31820.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31820.jpg",
    },
    summary:
      '<p>One of L.A.\'s hottest stand-up shows inspired this series. Both are hosted by comics Jonah Ray and Kumail Nanjiani, who in 2010 began a weekly event that featured top names in the business, including Louis C.K., Robin Williams, Aziz Ansari, Donald Glover, Marc Maron. Filmed at a 200-seat theater tucked behind Meltdown Comics, the half-hour documentary-style program includes performances and backstage clips of comics and stars in the green room. Series guests include Jim Gaffigan, "Weird Al" Yankovic, Garfunkel &amp; Oates, Nick Offerman, Maria Bamford, Chris Hardwick and Maron.</p>',
    officialSite: "http://www.cc.com/shows/the-meltdown-with-jonah-and-kumail",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-23",
  },
  {
    id: 2311,
    url: "https://www.tvmaze.com/shows/2311/food-fighters",
    name: "Food Fighters",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31839.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31839.jpg",
    },
    summary:
      '<p>An incredible lineup of celebrity chefs and the introduction of kids as contestants for the first time ever spice up the second season of "<b>Food Fighters</b>," the high-stakes culinary game returning to NBC on Thursday, July 2 at 8/7c. It\'s the perfect recipe for the ultimate food battle when the best amateur cooks in America put their signature dishes to the test against five professional chefs, with the chance to win as much as $100,000. Television personality, author and food enthusiast Adam Richman ("Man Finds Food," "Fandemonium") hosts the series that takes culinary sparring to an exciting new level.</p><p>"Food Fighters" has only featured adult contestants competing against the pro chefs... until now. This season, kid chefs are also added to the mix, showing off their incredible culinary skills while racing against the clock to try and beat some of the most formidable chefs in the country. In a series of compelling, tension-filled showdowns, a top-notch amateur home cook will face off one by one against five professional chefs from every corner of the world. In the final round, he or she will compete against a celebrity chef, and Season 2 features high-profile chefs Rocco DiSpirito, Nadia G., Lorena Garcia, Duff Goldman, Eric Greenspan, Antonia Lofaso, Brian Malarkey, Aaron McCargo Jr., Marcel Vigneron and Fabio Viviani.</p><p>Armed only with recipes for their best signature dishes, kid contestants and adult players will square off against an expert chef who will have to cook the same dish but with no advance notice of what the dish will be. The completed dishes will then be sampled in a blind taste test by culinary judges known as "The Dinner Party." After the two competing dishes are tested, the verdict determining the winner is given to the host.</p><p>If the home cook wins, he or she earns a cash prize. Even if they don\'t win, home cooks still get to face off again against another culinary expert, climbing a money ladder with increasing cash prizes for every professional chef they knock out. Any amateur cook who wins each of the five rounds will walk away with $100,000. It\'s the ultimate food fight, pitting amateur cooks against the most formidable culinary pros in America to see if they have what it takes to beat the very best.</p>',
    officialSite: "http://www.nbc.com/food-fighters/about",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-22",
  },
  {
    id: 2312,
    url: "https://www.tvmaze.com/shows/2312/mysteries-at-the-hotel",
    name: "Mysteries at the Hotel",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/46/115390.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/46/115390.jpg",
    },
    summary:
      "<p>With 2 million hotel rooms occupied each night in America, it's no wonder that some of the most mysterious and strange events have occurred in hotels.</p>",
    officialSite: "http://www.travelchannel.com/shows/mysteries-at-the-hotel",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 82,
      name: "Travel Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-04-06",
  },
  {
    id: 2313,
    url: "https://www.tvmaze.com/shows/2313/cutting-it-in-the-atl",
    name: "Cutting It: In the ATL",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31865.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31865.jpg",
    },
    summary:
      "<p>Atlanta is home to America's most talented, daring and in-demand hair stylists, and at the top, competition is the most cutthroat. <i><b>\"Cutting It: In the ATL\"</b></i> follows four glamorous and headstrong salon owners as they compete to bring in the most business and dominate the Atlanta hair game. Maja burst into the ATL hair scene and changed the playing field with her chain of quick service and affordable weave salons. She plans to soak up every last dollar Atlanta has to offer, and for her plan to work, she needs the cooperation of the city's top salon owners. Maja finds an ally in the very talented and very outspoken natural hair diva Mushiya. No one does natural hair styling like Mushiya, and she is in the right position to lure clients away from her competitors. Beautii, a true veteran of the ATL hair scene, has survived with cunning and cleverness. She has plenty of ambition and loves a good money-making plan, but doesn't always follow the rules and play nice. Dedra, a polished professional in appearance, drives a wedge into Maja's strategy when her hot temper creates a rift in this circle of businesswomen. Her weave expert, LaKenya, befriends the other salon owners as she follows her dream to open her own salon, but quickly alienates them with her shifting alliances.</p><p>In the battle to reign supreme, find out who is Cutting It in the ATL!</p>",
    officialSite: "http://www.wetv.com/shows/cutting-it-in-the-atl",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 122,
      name: "WE tv",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-21",
  },
  {
    id: 2316,
    url: "https://www.tvmaze.com/shows/2316/3am",
    name: "3AM",
    genres: ["Adult"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/64/160323.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/64/160323.jpg",
    },
    summary:
      "<p>While most respectable folks are tucked in at home, the bolder and braver outlaw set are out defying the norms of acceptable and conventional behavior in a search for love, sex, fame, and notoriety that can only come as the clock strikes 3.</p>",
    officialSite: "http://www.sho.com/sho/3am/home",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-28",
  },
  {
    id: 2317,
    url: "https://www.tvmaze.com/shows/2317/nellyville",
    name: "Nellyville",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31927.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31927.jpg",
    },
    summary:
      "<p><b>Nellyville</b> is a docu-series following Nelly as he navigates his busy career as a hip hop icon, businessman and father to his biological children and his deceased sister's children, while trying to start a new relationship. While we may know Nelly as a hard-working hip hop mogul, fatherhood seems to be his toughest job yet!</p>",
    officialSite: "http://www.bet.com/shows/nellyville.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 56,
      name: "BET",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-25",
  },
  {
    id: 2318,
    url: "https://www.tvmaze.com/shows/2318/limitless-with-theresa-vail",
    name: "Limitless with Theresa Vail",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/35/87675.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/35/87675.jpg",
    },
    summary:
      '<p><i><b>"Limitless with Theresa Vail"</b></i> epitomizes the bold character of the host and chronicles both Vail\'s flair for adventure and love of the outdoors. Through its intricate story lines, <i>Limitless </i>presents the compelling story of a young, grass roots, red-blooded, all-American woman who is on a mission to overcome stereotypes, break barriers, and use her life story as a platform to help transform people\'s opinions of all the things a woman should, could and can be.</p><p>Viewers will get an in-depth look at her back story, including the road to being crowned Miss Kansas, the radical decision to display her tattoos while competing in the pageant, and the determination behind teaching herself the Puccini aria "Nessun Dorma" from the opera "Turandot" in just two short days. During this season, Vail will tie in a 26.2 mile trek in the Bataan Death March in New Mexico, climb Wyoming\'s notorious "Devil\'s Tower," head to the coast of British Columbia in search of grizzlies, and skydive with the West Point Parachute Team.</p><p>In each episode, Vail will be in circumstances where she is constantly pushing the limits and testing boundaries. Viewers will see how she applies the same grit and determination that are essential qualities among America\'s Armed Forces heroes into action-packed journeys for thrill seekers and fearless scenarios for passionate outdoor enthusiasts.</p>',
    officialSite: "http://outdoorchannel.com/showabout.aspx?show-id=23392",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 207,
      name: "Outdoor Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-30",
  },
  {
    id: 2320,
    url: "https://www.tvmaze.com/shows/2320/spy",
    name: "Spy",
    genres: ["Drama", "Espionage"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31987.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31987.jpg",
    },
    summary:
      "<p>The series follows a group of real-life volunteers as they are trained by former spies in espionage techniques, including maintaining a false identity, surveillance, persuasion and recruitment. The programme's psychological challenges, dramatic tension, high production values, and personable cast led to its being called 'the most addictive thing on TV at the moment' by The Daily Telegraph.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2004-07-11",
  },
  {
    id: 2321,
    url: "https://www.tvmaze.com/shows/2321/labyrinth",
    name: "Labyrinth",
    genres: ["Drama", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/45/114055.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/45/114055.jpg",
    },
    summary:
      "<p><b>Labyrinth</b> is a British miniseries based on the 2005 novel of the same name by author Kate Mosse. The mini-series establishes a connection between Alice Tanner, a post-graduate student in 2012, and a teenage girl, Alais, who is present at Carcassone during the Crusader assault in 1209. In the past, Alais, is chosen to protect the Three Books of the Grail, which hold the secret to immortality. In the present, Alice is drawn into a search for the books by individuals who will stop at nothing to achieve their goals. A German-South African co-production, the two-part series was filmed on-location in the medieval town of Carcassonne in southwest France and Cape Town, South Africa.</p>",
    officialSite: "http://www.channel4.com/programmes/labyrinth",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-11-24",
  },
  {
    id: 2322,
    url: "https://www.tvmaze.com/shows/2322/biggest-and-baddest",
    name: "Biggest and Baddest",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/31989.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/31989.jpg",
    },
    summary:
      "<p><b>Biggest and Baddest</b> is a six-part series featuring explorer Niall McCann, to air on Velocity in the U.S. and Animal Planet in Canada. The series sees McCann going after the largest and fiercest animals in the world, following up on reported sightings of legendary creatures and abnormally huge or dangerous animals. After season 1 completed airing all 6 episodes it was renewed for a 2nd season.</p>",
    officialSite: "http://channel.nationalgeographic.com/wild/biggest-baddest/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 83,
      name: "National Geographic WILD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-01-05",
  },
  {
    id: 2324,
    url: "https://www.tvmaze.com/shows/2324/nancy-grace",
    name: "Nancy Grace",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755325.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755325.jpg",
    },
    summary:
      '<p><i><b>"Nancy Grace"</b></i> is television\'s only justice themed/interview/debate show. Nancy Grace re-investigates unforgettable crimes and disappearances that she followed on her daily live show on HLN.</p>',
    officialSite: "http://www.hlntv.com/shows/nancy-grace",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 193,
      name: "HLN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-02-21",
  },
  {
    id: 2327,
    url: "https://www.tvmaze.com/shows/2327/jonathan-strange-mr-norrell",
    name: "Jonathan Strange & Mr. Norrell",
    genres: ["Drama", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/32030.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/32030.jpg",
    },
    summary:
      "<p><b>Jonathan Strange &amp; Mr. Norrell</b> is set during the Napoleonic Wars in an England where magic once existed and is about to return. So begins a dangerous battle between two great men.</p><p>1806. England is beleaguered by the long war with Napoleon and centuries have passed since practical magicians faded into the nation's past. However, scholars of this glorious history discover that one remains — the reclusive and skillful Mr. Norrell. His displays of magic soon thrill the nation. In London, he raises the beautiful Lady Pole from the dead and summons an army of ghostly ships to terrify the French.</p><p>Soon the cautious and fussy Norrell is challenged by the emergence of another magician: the brilliant novice Jonathan Strange. While trying to secure his beloved Arabella's hand in marriage, he meets a vagabond, the magician of Threadneedle Street, Vinculus, who tells him he is destined to be a great magician. Young, handsome and daring, Strange is the very antithesis of Norrell. A dangerous battle ensues between the two great men. Their obsessions and secret dabblings with the dark arts will cause more trouble than they can imagine.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p02mrqzv",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-05-17",
  },
  {
    id: 2329,
    url: "https://www.tvmaze.com/shows/2329/green-wing",
    name: "Green Wing",
    genres: ["Drama", "Comedy", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/32002.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/32002.jpg",
    },
    summary:
      '<p>A British "medical" drama with a mixture of comedy, bizarre soap opera and pure absurdity that would make Scrubs blush. The series was notable for being filmed in a real-live hospital (with genuine patients and doctors as extras), the plot rarely ever touched actual medicine or patient storylines in favor of focusing on the surgeons playing games mid-operations, the love dodecahedron the staff are trapped in, and the misadventures of the HR department. It was nominated for several awards, including 2 BAFTAs, and won "Comedy of the Year" in 2006.</p>',
    officialSite: "http://www.channel4.com/programmes/green-wing",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2004-09-03",
  },
  {
    id: 2332,
    url: "https://www.tvmaze.com/shows/2332/mysteries-at-the-monument",
    name: "Mysteries at the Monument",
    genres: ["Drama", "Mystery", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/32059.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/32059.jpg",
    },
    summary:
      "<p><b>Mysteries at the Monument </b>host and history explorer Don Wildman investigates the world's most impressive - and sometimes obscure - structures, statues and national parks to uncover incredible tales hidden within them.</p>",
    officialSite:
      "http://www.travelchannel.com/shows/mysteries-at-the-monument",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 82,
      name: "Travel Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-05-09",
  },
  {
    id: 2333,
    url: "https://www.tvmaze.com/shows/2333/the-town",
    name: "The Town",
    genres: ["Drama", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/32026.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/32026.jpg",
    },
    summary:
      "<p>Following a family tragedy, 30-year-old Mark Nicholas returns to the town where he grew up. After ten years away, coming home is harder than Mark could ever have imagined.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-12-05",
  },
  {
    id: 2338,
    url: "https://www.tvmaze.com/shows/2338/food-paradise-international",
    name: "Food Paradise International",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/156/391810.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/156/391810.jpg",
    },
    summary:
      "<p>In <b>Food Paradise International</b>, we've combed the world for the tastiest dishes in both legendary and undiscovered hot spots, and our taste buds are bursting! We're talking 2.2 pounds of rosemary-grilled steak in Italy, crispy lobster in Barcelona, shrimp on the barbie in Sydney, and hands-down, the juiciest burgers from all over the world. Topped with everything from pulled pork to fried eggs and served out of food trucks to 5 star restaurants, these burgers will make you drool. We deliver pizza pies from 8 different cities, from Tokyo's table-cooked seafood pizza to a shocking slice served up in South Africa. We eat like an Argentinian cowboy and chow down on crispy Southern BBQ in Paris. Vibes range from the casual to the truly bizarre and you'll want a taste of all the surprises on Food Paradise International. Bon Appetit!</p>",
    officialSite:
      "http://www.travelchannel.com/shows/food-paradise-international",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 82,
      name: "Travel Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-01",
  },
  {
    id: 2339,
    url: "https://www.tvmaze.com/shows/2339/macys-4th-of-july-fireworks-spectacular",
    name: "Macy's 4th of July Fireworks Spectacular",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/32042.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/32042.jpg",
    },
    summary:
      "<p>NBC's annual <b>Macy's 4th of July Fireworks Spectacular</b> celebrates the nation's birthday with all-star performances.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-07-04",
  },
  {
    id: 2345,
    url: "https://www.tvmaze.com/shows/2345/murderland",
    name: "Murderland",
    genres: ["Crime", "Family", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/32063.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/32063.jpg",
    },
    summary:
      "<p>Three-part thriller about a young woman's quest to discover the truth about her mother's death 15 years earlier. The story is told from three different perspectives.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-10-19",
  },
  {
    id: 2349,
    url: "https://www.tvmaze.com/shows/2349/dog-town-usa",
    name: "Dog Town, USA",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755196.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755196.jpg",
    },
    summary:
      "<p><i><b>\"Dog Town, USA\"</b></i> is the country's preeminent facility for abandoned and homeless dogs from all over the world, located in Utah on 33,000 acres of pristine land. The highly skilled staff members includes internationally renowned experts and trusted medical professionals who all work to provide sanctuary, rehabilitation and personal care for each dog in preparation for their move to a ``forever'' home. Each stage of the detailed process is documented as the dogs hopefully end up being placed in loving home with new owners.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-04",
  },
  {
    id: 2354,
    url: "https://www.tvmaze.com/shows/2354/outrageous-acts-of-psych",
    name: "Outrageous Acts of Psych",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/34958.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/34958.jpg",
    },
    summary:
      "<p><b>Outrageous Acts of Psych </b>takes the hidden-camera phenomenon to the next level. Stemming from the hit Science Channel series, <i>Outrageous Acts of Science</i>, OAP uses hidden cameras to show whether people will pay for a VIP experience at a bus stop or a laundromat, or whether men or women are more likely to take a food sample from a person wearing a hazmat suit. Throughout the show, psychologists and human behavior experts offer insights into why we do the things we do.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 77,
      name: "Science",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-02",
  },
  {
    id: 2355,
    url: "https://www.tvmaze.com/shows/2355/pride-and-prejudice",
    name: "Pride and Prejudice",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/32116.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/32116.jpg",
    },
    summary:
      "<p>Re-live the romance and drama of Andrew Davies' lavish adaptation, starring Colin Firth and Jennifer Ehle.</p>",
    officialSite: "https://www.bbc.co.uk/programmes/b009016x",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1995-09-24",
  },
  {
    id: 2359,
    url: "https://www.tvmaze.com/shows/2359/jane-eyre",
    name: "Jane Eyre",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/32138.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/32138.jpg",
    },
    summary: "<p>Dramatisation of Charlotte Bronte's classic novel.</p>",
    officialSite: "https://www.bbc.co.uk/programmes/b00d8rcc",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-09-24",
  },
  {
    id: 2362,
    url: "https://www.tvmaze.com/shows/2362/twenty-twelve",
    name: "Twenty Twelve",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/32144.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/32144.jpg",
    },
    summary:
      '<p><b>Twenty Twelve</b> follows the team responsible for delivering the biggest show on earth: the London Olympics. The actors and creators of some of Britain\'s most iconic comedies come together in this new documentary-style comedy that is not only deliciously topical and wickedly funny but also uncannily close to real life.</p><p>Starring Hugh Bonneville ("Downton Abbey"), Jessica Hynes ("Spaced"), Olivia Colman ("Peep Show"), Amelia Bullmore ("I\'m Alan Partridge"), Vincent Franklin, and Karl Theobald ("Green Wing") and narrated by David Tennant this comedy series takes a close look at the people paddling hard beneath the water to make the Olympics happen in London 2012.</p><p>They have billions of pounds to spend and plenty of time before the deadline; so what can possibly go wrong? Well, what do you do when the much-vaunted wind turbines won\'t turn because there\'s no wind? And how do you cope with athletes who want to help but are just too dull? It\'s all in a day\'s work for the men and women whose job it is to stage the greatest sporting event in the world.</p>',
    officialSite: "http://www.bbc.co.uk/programmes/b01f87nh",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-03-14",
  },
  {
    id: 2364,
    url: "https://www.tvmaze.com/shows/2364/search-for-the-lost-giants",
    name: "Search for the Lost Giants",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/32146.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/32146.jpg",
    },
    summary:
      "<p>Stonemasons Jim and Bill Vieira are on a quest to investigate an incredible theory: that the myths and legends we've all been told about giants are actually rooted in fact. Jim has researched over 1,000 accounts of skeletons seven feet tall or over unearthed across America in the 19th and 20th centuries. SEARCH FOR THE LOST GIANTS will follow the Vieira brothers on their quest to find evidence of these missing bones, which seem to have slipped through the hands of history. They'll dig for secret chambers, explore underground tunnels and dive into the deepest museum storage vaults–all to find that one bone, that one hair, that single strand of giant DNA that will answer the question: did giants walk the Earth?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-04",
  },
  {
    id: 2365,
    url: "https://www.tvmaze.com/shows/2365/underworld-inc",
    name: "Underworld, Inc.",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/32168.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/32168.jpg",
    },
    summary:
      "<p>From the illegal weapons to the underground sex trade, nothing is off limits and everything is for sale in illegal, underground markets. It's an industry that is brutal, exploitative, and corrupt where what you buy isn't always what it seems. Despite efforts to crack down on these illegal trades, more than $625 billion makes it's way into the US economy each year for illegal trade goods. Unprecedented inside access brings light to the inner workings of the last bastion of \"free\" enterprise, charting a global path to the underworld economy. Workers, suppliers, sellers, customers – and the law enforcement trying to keep it in check - share their experience of a hidden world that touches us all.</p>",
    officialSite: "http://channel.nationalgeographic.com/underworld-inc/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-07",
  },
  {
    id: 2366,
    url: "https://www.tvmaze.com/shows/2366/sharkfest",
    name: "SharkFest",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/35874.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/35874.jpg",
    },
    summary:
      "<p>Put on your wetsuit to swim with the sharpest of the sea. This is the one-stop-show-shop for all things shark. No fuss, no muss, just killer episodes.</p>",
    officialSite: "http://channel.nationalgeographic.com/wild/sharkfest/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 83,
      name: "National Geographic WILD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-08-04",
  },
  {
    id: 2368,
    url: "https://www.tvmaze.com/shows/2368/dragon-ball-super",
    name: "Dragon Ball Super",
    genres: ["Action", "Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/32185.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/32185.jpg",
    },
    summary:
      "<p><b>Dragon Ball Super</b>, a brand new television anime inspired by Akira Toriyama's Dragon Ball manga, will premiere on Fuji TV and other channels in July on Sundays at 9:00 a.m. This will be the first new Dragon Ball television series since Dragon Ball GT, which aired from 1996 to 1997.</p><p>The story of the anime is set a few years after the defeat of Majin Buu, when the Earth has become peaceful once again. The voice of Goku, Gohan, and Goten, Masako Nozawa commented on the new anime, saying, \"We've always used the word 'chō' (Super) with Dragon Ball in commercials, games and the like, but the fact that the series titled Dragon Ball Super is beginning is the best thing ever.\"</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 131,
      name: "Fuji TV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2015-07-05",
  },
  {
    id: 2369,
    url: "https://www.tvmaze.com/shows/2369/talia-in-the-kitchen",
    name: "Talia in the Kitchen",
    genres: ["Comedy", "Food", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/35831.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/35831.jpg",
    },
    summary:
      "<p>When 14-year-old Talia visits her grandmother for the summer and starts spending time in her family's restaurant, she discovers she's got a gift. With the help of her special \"salt and pepper sense\" and her late father's magical spices, Talia can whip up some truly life changing cuisine and cook just what each customer needs. She's making magic in the kitchen!</p>",
    officialSite: "http://www.nick.com/talia-in-the-kitchen/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-06",
  },
  {
    id: 2370,
    url: "https://www.tvmaze.com/shows/2370/penn-teller-fool-us",
    name: "Penn & Teller: Fool Us",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/228/570359.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/228/570359.jpg",
    },
    summary:
      "<p><b>Penn &amp; Teller: Fool Us</b> is a British-American television show. Hosted by Jonathan Ross its first two seasons and Alyson Hannigan starting its third, <i>Fool Us</i> was filmed at Fountain Studios in London, England (Seasons 1) and the Rio All-Suites Hotel in Las Vegas (Season 2 onward). <i>Fool Us</i> is a magic competition in which magicians perform tricks in front of American magician-comedian duo Penn &amp; Teller. If Penn &amp; Teller cannot figure out how a trick was done, the magician or magicians who performed it win a five-star trip to Las Vegas to perform as the opening act in Penn &amp; Teller's world-famous show, also at the Rio Hotel &amp; Casino.</p>",
    officialSite: "http://www.cwtv.com/shows/penn-teller-fool-us/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-06-18",
  },
  {
    id: 2372,
    url: "https://www.tvmaze.com/shows/2372/rocky-mountain-law",
    name: "Rocky Mountain Law",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/35872.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/35872.jpg",
    },
    summary:
      "<p>Sheriff Deputies in the counties of Boulder, Eagle and Grand, Colorado fight crime in America's most rugged terrain: The Rocky Mountains. Intense manhunts by foot, skis and snowmobiles; attempting to solve complex murders and drug running mysteries, are all in a day's work while trying to keep the Rockies one of the most beautiful places on earth. Follow officers as they protect and serve both the residents and the majestic mountains.</p>",
    officialSite: "http://channel.nationalgeographic.com/rocky-mountain-law/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-08",
  },
  {
    id: 2376,
    url: "https://www.tvmaze.com/shows/2376/naked-and-afraid-xl",
    name: "Naked and Afraid XL",
    genres: ["Drama", "Adventure", "Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/205/513115.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/205/513115.jpg",
    },
    summary:
      "<p>A group of the best survival experts in the world are taking on an un-survivable situation that has never been attempted before: 12 people. 40 days. 40 nights. No food. No water. No clothes. The ultimate trial of human endurance and will to survive.</p><p><b>Naked and Afraid XL </b>is a 40 day challenge, making it exponentially more difficult than anything that's ever been tried in the past. Six women and six men, all extreme survivalists with their own expertise, find themselves stranded in a remote equatorial jungle of Colombia and this time, they will all be fighting for the same limited resources.</p><p>All being inserted separately, how will these survivalists encounter and respond to each other? Will they band together as one large group or break apart into smaller groups to survive?</p><p>These 12 survivalists have proven that they have physical and mental strength, endurance, intelligence, a fantastic survival skillset, and the will to survive in some of the harshest environments on the planet during their Naked And Afraid challenges. In a challenge this big, however, the survivalists will need to master the environment and push themselves far beyond their breaking point if they want make it out alive. By the 40th day, will even one of them have successfully proven they have what it takes to endure?</p>",
    officialSite: "http://www.discovery.com/tv-shows/naked-and-afraid-xl/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-12",
  },
  {
    id: 2377,
    url: "https://www.tvmaze.com/shows/2377/wizard-wars",
    name: "Wizard Wars",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/268/672330.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/268/672330.jpg",
    },
    summary:
      '<p>Penn &amp; Teller headline this competition series, which takes viewers behind the scenes of magic by challenging a new team of magicians each week to create the most jaw-dropping illusions using an array of random objects and transforming them into eye-popping miracles. The winning team of challengers in the first round then take on the expert "home team" of world-renowned wizards: Two-time World Championship of Magic winner Gregory Wilson; Wynn Resort resident magician Shimshi; YouTube sensation Justin Flom, and internationally renowned mentalist Angela Funovits.</p><p><b>Wizard Wars</b> judges on the show include the aforementioned Penn &amp; Teller, Jason Latimer and Christen Gerhart.</p>',
    officialSite: "http://www.syfy.com/wizardwars/episodes",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-08-19",
  },
  {
    id: 2380,
    url: "https://www.tvmaze.com/shows/2380/clipped",
    name: "Clipped",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/163/408249.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/163/408249.jpg",
    },
    summary:
      "<p><b>Clipped</b> centers on a group of barbershop coworkers who all went to high school together but ran in very different crowds. Now they find themselves working together at Buzzy's.</p>",
    officialSite: "http://www.tbs.com/shows/clipped.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 32,
      name: "TBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-06-16",
  },
  {
    id: 2381,
    url: "https://www.tvmaze.com/shows/2381/jake-20",
    name: "Jake 2.0",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/32302.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/32302.jpg",
    },
    summary:
      '<p><b>Jake 2.0</b> surrounds NSA computer technician Jake Foley who is transformed into a secret agent after he is accidentally infected with nanobots, based on nanotechnology that reduce the size of a computer to the molecular level, which give him superhuman powers. With his new abilities, he can hack into anything electronic and control it. His medical and emotional state is carefully watched over by Dr. Diane Hughes, who is far too human for her job with the NSA. Struggling in his early tasks with the NSA, Jake must prove himself and yield results or be locked up for "research."</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 70,
      name: "UPN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-09-10",
  },
  {
    id: 2384,
    url: "https://www.tvmaze.com/shows/2384/bloedverwanten",
    name: "Bloedverwanten",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/81/204922.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/81/204922.jpg",
    },
    summary:
      "<p>If shareholder Bennie Winter Flowers Winter dies, loses his considerable power to his daughter Esther. Should something happen to her, then her children get everything in your hands.</p>",
    officialSite: null,
    webChannel: null,
    language: "Dutch",
    status: "Ended",
    network: {
      id: 1018,
      name: "NPO 1",
      country: {
        name: "Netherlands",
        code: "NL",
        timezone: "Europe/Amsterdam",
      },
    },
    premiered: "2010-03-04",
  },
  {
    id: 2385,
    url: "https://www.tvmaze.com/shows/2385/going-rv",
    name: "Going RV",
    genres: ["Adventure", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/35870.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/35870.jpg",
    },
    summary:
      "<p>In <b>Going RV</b>, hard-working couples and families decide to ditch ordinary daily life for an adventure out on the open road. Take the ultimate ride as they go on a shopping trip to find their perfect RV. Whether it's upgrading an existing motor home or going all out for a new one with all the bells and whistles, find out what happens when daring homeowners trade walls for wheels.</p>",
    officialSite: "http://www.greatamericancountry.com/shows/going-rv",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 103,
      name: "Great American Country",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-01",
  },
  {
    id: 2386,
    url: "https://www.tvmaze.com/shows/2386/bernhard-schavuit-van-oranje",
    name: "Bernhard, Schavuit van Oranje",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/32324.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/32324.jpg",
    },
    summary:
      "<p><b>Bernhard, Schavuit van Oranje</b>, a four part series, is about more than the turbulent life of a prince consort. It is a riveting drama about a man who tries to escape from a straightjacket, choose his own path and survive deep crises to find out what true love really means. Within the royal family there is really no contradiction to think there is a more flamboyant figure than Prince Bernhard. Whether it's Greet Hofmans, extramarital affairs and daughters, Lockheed and numerous scandals in his life. At the same time Prince Bernhard is popular figure, considered by many as a war hero to be revered. A man of extremes.</p><p>In four parts Bernhard tells the story of his life. Not only to the viewer, but also to Princess Máxima. She will soon be Queen alongside Willem-Alexander, a position similar to Bernhard. From their conversations and discussions it shows how they differ, but also how much they are alike. For Máxima is sometimes very challenging. The story takes us from Soestdijk to the German Recke Walde, Berlin, London, Argentina and Canada. It paints a portrait of the world from the thirties of the twentieth century to the early twenty-first century.</p>",
    officialSite: null,
    webChannel: null,
    language: "Dutch",
    status: "Ended",
    network: {
      id: 1018,
      name: "NPO 1",
      country: {
        name: "Netherlands",
        code: "NL",
        timezone: "Europe/Amsterdam",
      },
    },
    premiered: "2010-01-04",
  },
  {
    id: 2388,
    url: "https://www.tvmaze.com/shows/2388/buying-the-bayou",
    name: "Buying the Bayou",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/99/249723.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/99/249723.jpg",
    },
    summary:
      "<p>There's no place on earth like the Bayou, and there's nothing like its real estate. Featuring one-of-a-kind homes with wild amenities, sometimes set in the difficult and unpredictable swampland, this series meets the needs of gator hunters, catfish noodlers, shrimping and crawfish enthusiast and everything important to Central Louisiana. Some homes float, some are propped up by stilts, while others have prime space for airboat docking.</p>",
    officialSite:
      "http://www.destinationamerica.com/tv-shows/buying-the-bayou/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 107,
      name: "Destination America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-07",
  },
  {
    id: 2392,
    url: "https://www.tvmaze.com/shows/2392/sisterhood-of-hip-hop",
    name: "Sisterhood of Hip Hop",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/12/32357.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/12/32357.jpg",
    },
    summary:
      "<p>Oxygen Media's hit series <b>Sisterhood of Hip Hop</b> is back with a brand new beat for season three premiering Tuesday, July 12 at 9pm ET/PT. Executive produced by Grammy-Award winning artist T.I., the powerful docu-series returns with veterans Siya, Brianna Perry and Diamond, who welcome new femcees on the block, Audra the Rapper and Lee Mazin. And in order to deal with the ups and downs that come with the rap game, the ladies receive guidance from hip hop legends MC Lyte, Irv Gotti, Tank, Trina, YoYo, Jazze Pha and more, providing support, advice, and when necessary, tough love.</p>",
    officialSite: "http://www.oxygen.com/sisterhood-of-hip-hop",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 79,
      name: "Oxygen",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-08-12",
  },
  {
    id: 2407,
    url: "https://www.tvmaze.com/shows/2407/sex-with-brody",
    name: "Sex with Brody",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755195.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755195.jpg",
    },
    summary:
      "<p>Former reality star Brody Jenner hosts this talk show offshoot of his podcast that focuses on love, sex and relationships. Jenner is joined by relationship therapist Mike Dow and actress Stevie Ryan to offer advice to callers who have questions about their relationships and love lives. The panel is joined by guest celebrities who share their opinions on relationship issues that include dealing with exes and the troubles with online dating. Jenner also takes to the streets, encouraging people to reveal their thoughts about the given topics.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 43,
      name: "E!",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-10",
  },
  {
    id: 2408,
    url: "https://www.tvmaze.com/shows/2408/sex-on",
    name: "Sex On//",
    genres: ["Adult"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47828.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47828.jpg",
    },
    summary:
      "<p>This series takes a modern-day look at sex in all of its many varieties.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-09",
  },
  {
    id: 2410,
    url: "https://www.tvmaze.com/shows/2410/carnival-eats",
    name: "Carnival Eats",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/205/513455.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/205/513455.jpg",
    },
    summary:
      "<p><b>Carnival Eats</b> celebrates today's modern gastronomic freak show and takes you on an international, food-frenzied roller coaster of culinary delights, to the new epicenter of carnival life — food! Foods of every imaginable shape, size, color and taste are being created specifically for the connoisseurs who ply midways and fairgrounds, and Carnival Eats is there for every delicious bite.</p>",
    officialSite: "http://www.cookingchanneltv.com/shows/carnival-eats.html",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 174,
      name: "Cooking Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-08-18",
  },
  {
    id: 2413,
    url: "https://www.tvmaze.com/shows/2413/married-at-first-sight-the-first-year",
    name: "Married at First Sight: The First Year",
    genres: ["Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/173/433056.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/173/433056.jpg",
    },
    summary:
      '<p>In the season one finale of <i>Married at First Sight</i>, the three couples had to decide if they were going to stay married or get a divorce. With the extreme social experiment over and their decisions revealed, can the two remaining couples make it and celebrate their first anniversary as husband and wife? In <b>Married at First Sight: The First Year</b><i>, </i>viewers will see Jamie and Doug, and Cortney and Jason, continue their journeys from the six month mark of marriage to their March 2015 one year anniversary. From the holidays to birthdays to moving into new homes--viewers will see the two couples mark many "firsts" together, as well as receive advice and guidance from season one\'s trusted specialists, including: sexologist, Dr. Logan Levkoff; psychologist, Dr. Joseph Cilona; and sociologist, Dr. Pepper Schwartz. The series will also check in with the couple that chose not to stay together – Monet and Vaughn.</p>',
    officialSite:
      "http://www.fyi.tv/shows/married-at-first-sight-the-first-year/episodes",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 125,
      name: "FYI,",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-13",
  },
  {
    id: 2425,
    url: "https://www.tvmaze.com/shows/2425/building-belushi",
    name: "Building Belushi",
    genres: ["Comedy", "DIY"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/99/249514.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/99/249514.jpg",
    },
    summary:
      "<p>One of America's best-loved performers, Jim Belushi, is going rogue--as in the Rogue River in Medford, Oregon. The actor, comedian and singer is trading his microphone for a tool belt and building his dream luxury riverfront cabin complete with its own stage for performing. Follow along as he learns what it takes to not only build an entire house from the ground up, but also how this constantly traveling celebrity found a place to call home.</p>",
    officialSite: "http://www.diynetwork.com/shows/building-belushi",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 90,
      name: "DIY Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-11",
  },
  {
    id: 2427,
    url: "https://www.tvmaze.com/shows/2427/ash-vs-evil-dead",
    name: "Ash vs Evil Dead",
    genres: ["Comedy", "Action", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/145/363490.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/145/363490.jpg",
    },
    summary:
      '<p>Ash is back in <b>Ash vs Evil Dead</b>! 30 years after his last fight, Ash Williams unleashes the Evil in an act of carelessness, bringing Deadite mayhem into his life again. Bruce Campbell will be reprising his role as Ash, the stock boy, aging lothario and chainsaw-handed monster hunter who has spent the last 30 years avoiding responsibility, maturity and the terrors of the Evil Dead. When a Deadite plague threatens to destroy all of mankind, Ash is finally forced to face his demons - personal and literal. Destiny, it turns out, has no plans to release the unlikely hero from its "Evil" grip.</p>',
    officialSite: "http://www.starz.com/originals/ashvsevildead/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 17,
      name: "Starz",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-31",
  },
  {
    id: 2429,
    url: "https://www.tvmaze.com/shows/2429/carries-war",
    name: "Carrie's War",
    genres: ["Drama", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/32556.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/32556.jpg",
    },
    summary:
      "<p>Carrie and her brother Nick are evacuated to Wales during the Second World War. They stay with the bullying Mr Evans, and his gentle but weak sister, whom they call \"Auntie Lou.\" The children befriend another young evacuee, Albert Sandwich, who is staying with Mr Evans' other sister, the dying Mrs Gotobed. They also befriend Mrs. Gotobed's husband's relative, Mister Johnny who has cerebral palsy, and her housekeeper, Hepzibah. The housekeeper tells the children about a curse on the family which concerns a skull kept in the library. According to the tale, the curse would activate if the skull is removed from the house. Carrie keeps going to look at the skull, even though she did not like the look of it.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p031df8m",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1974-01-28",
  },
  {
    id: 2433,
    url: "https://www.tvmaze.com/shows/2433/paw-star-game",
    name: "Paw Star Game",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/32596.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/32596.jpg",
    },
    summary:
      "<p>Get ready for America's newest tradition as the kittens of summer go up to bat in the biggest baseball game of the year! Hallmark Channel opens its stadium doors for <b>Paw Star Game</b>, premiering on Sunday, July 12 at 5/4c for the nation's most adorable, adoptable and agile CATletes to pounce on to the diamond! Beth Stern, TV personality, author and North Shore Animal League America spokesperson, hosts the event along with play-by-play announcers John Sterling, iconic radio voice of the New York Yankees, and award-winning reporter, sports analyst and commentator Mary Carillo. As the kittens take the field to swat balls and catch line drives, they will be cheered on by celebrities including Ed Asner, Maria Menounos, Mario Lopez, Al Roker, Heather McDonald, Tricia Helfer, Deidre Hall, Dawn Olivieri and Camren Bicondova.</p>",
    officialSite:
      "http://www.hallmarkchannel.com/paw-star-game/about-paw-star-game",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 50,
      name: "Hallmark Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-12",
  },
  {
    id: 2435,
    url: "https://www.tvmaze.com/shows/2435/mtv-fandom-awards",
    name: "MTV Fandom Awards",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/35854.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/35854.jpg",
    },
    summary:
      "<p>The <i><b>MTV Fandom Awards</b></i> will honor diehard fangirls and fanboys as well as their favorite shows and movies in a 60-minute special worthy of big-time feels. Tune in to see your favorites win big! Veronica Mars' loyal \"Marshmallows\" once again vaulted their favorite movie into the winners spot of the epic 32-nominee bracket for \"Fandom of the Year,\" while ‘The Vampire Diaries,' ‘Game Of Thrones,' ‘Teen Wolf' and more picked up awards in other categories. See celebs like Chloe Grace Moretz, Channing Tatum, Tyler Posey and Gillian Jacobs dole out awards while author John Green graciously accepts the Visionary Award for his body of work. Rock out to performances from multi-platinum rock band Linkin Park and rising hip-hop star G-Eazy as they shut down the show with a truly epic after party, officially making the whole shindig a series-finale-status can't-miss event.</p>",
    officialSite: "http://www.mtv.com/ontv/fandomawards/about.jhtml",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-27",
  },
  {
    id: 2436,
    url: "https://www.tvmaze.com/shows/2436/the-2000s-a-new-reality",
    name: "The 2000s: A New Reality",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/35865.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/35865.jpg",
    },
    summary:
      "<p>Unpick the profound and epoch-shifting global story of the ten tumultuous years of the 2000s, detailing the technological and social changes that transformed the world and will determine the way we live for many decades to come. Our story begins with the saga of Elian Gonzalez and the ‘hanging chads' controversy, and gives us fresh and unexpected perspectives on everything from 9/11, the Iraq War, the collapse of Enron, and the rise of social networks; to the secrets of the iPhone, Hurricane Katrina, the financial Crash, and the Obama election – all heaped with a big helping of pop culture nostalgia and surprising facts to relive.</p>",
    officialSite:
      "http://channel.nationalgeographic.com/the-2000s-a-new-reality/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-12",
  },
  {
    id: 2438,
    url: "https://www.tvmaze.com/shows/2438/running-wild-with-bear-grylls",
    name: "Running Wild with Bear Grylls",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/299/749174.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/299/749174.jpg",
    },
    summary:
      "<p><b>Running Wild with Bear Grylls</b> is an hour-long alternative series, the famed adventurer, writer and television host will take eight entertainment and sports stars into the most remote and pristine locations in the U.S. and around the world for a 48-hour journey of a lifetime.</p>",
    officialSite:
      "https://www.nationalgeographic.com/tv/shows/running-wild-with-bear-grylls",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-28",
  },
  {
    id: 2439,
    url: "https://www.tvmaze.com/shows/2439/my-giant-life",
    name: "My Giant Life",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/24/61606.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/24/61606.jpg",
    },
    summary:
      "<p>Viewers step into the shoes of women who are seemingly too tall and lofty for the average-sized world, standing at six feet six inches and above. They are faced with challenges every day - some because their extreme height makes performing seemingly mundane tasks like loading the dishwasher and getting into a car extremely difficult and others because the eyes of society are not as friendly to women of their stature. As a young lady that is a foot taller than the average female, life is anything but easy! From dating difficulties to simply going to the grocery store without stares, the stories in each episode get right to the heart of what it means to live life blessed with an extra foot or more.</p>",
    officialSite: "http://www.tlc.com/tv-shows/my-giant-life/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-14",
  },
  {
    id: 2444,
    url: "https://www.tvmaze.com/shows/2444/full-house",
    name: "Full House",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/32794.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/32794.jpg",
    },
    summary:
      "<p>By accident, a big super star and a young woman who wants to become a writer come to live together in the same house where they fall in love with each other.</p>",
    officialSite: null,
    webChannel: null,
    language: "Thai",
    status: "Ended",
    network: {
      id: 1397,
      name: "Channel 8",
      country: { name: "Thailand", code: "TH", timezone: "Asia/Bangkok" },
    },
    premiered: "2014-01-11",
  },
  {
    id: 2446,
    url: "https://www.tvmaze.com/shows/2446/your-pretty-face-is-going-to-hell",
    name: "Your Pretty Face is Going to Hell",
    genres: ["Comedy", "Action", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/223/557862.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/223/557862.jpg",
    },
    summary:
      "<p><b>Your Pretty Face is Going to Hell</b> is a live-action workplace comedy about Gary, an associate demon, as he attempts to capture souls on earth in order to climb the corporate ladder of the underworld. Gary hopes to advance in Hell, but he may be too stupid, lazy and kind-hearted to realize his dreams of promotion. Meanwhile, Gary's intern Claude is more talented, more devious and will do whatever it takes to impress Satan.</p>",
    officialSite:
      "http://www.adultswim.com/videos/your-pretty-face-is-going-to-hell/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-04-18",
  },
  {
    id: 2447,
    url: "https://www.tvmaze.com/shows/2447/digimon-fusion",
    name: "Digimon Fusion",
    genres: ["Action", "Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/32809.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/32809.jpg",
    },
    summary:
      '<p><b>Digimon Fusion</b> is the all-new animated series and sixth installment of the Digimon franchise. The action packed series follows Mikey, a human boy, who is transported into the digital world and must team up with his new "Digimon" or "Digital Monster" friends to defeat evil once and for all. New fusion powers allow Digimon to combine and fuse, creating endless battle possibilities.</p>',
    officialSite: "http://nicktoons.nick.com/shows/digimon-fusion/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 263,
      name: "TV Asahi",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2010-07-06",
  },
  {
    id: 2448,
    url: "https://www.tvmaze.com/shows/2448/death-row-stories",
    name: "Death Row Stories",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/229/574124.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/229/574124.jpg",
    },
    summary:
      "<p><b>Death Row Stories</b> is a series of one-hour documentaries. Each episode attempts to unravel the truth behind a different capital murder case. These stories call into question various beliefs surrounding America's justice system and the death penalty.</p>",
    officialSite: "http://www.cnn.com/shows/death-row-stories",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 193,
      name: "HLN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-03-09",
  },
  {
    id: 2451,
    url: "https://www.tvmaze.com/shows/2451/southern-fried-road-trip",
    name: "Southern Fried Road Trip",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755341.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755341.jpg",
    },
    summary:
      "<p>Southern pride and Southern food go together like biscuits and gravy, and no one knows good ol' Southern cooking quite like Bobby Deen and Jamie Deen. Now they're going on a road trip to find everything from the best gumbo and 'gator in Louisiana to creamy Kentucky Hot Browns and even fried bologna sandwiches in Alabama. The Deen brothers will get a taste of the South while celebrating all the people and places that put the pride of Dixie into all that they do.</p>",
    officialSite:
      "http://www.foodnetwork.com/shows/southern-fried-road-trip.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 81,
      name: "Food Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-13",
  },
  {
    id: 2453,
    url: "https://www.tvmaze.com/shows/2453/bbq-rules",
    name: "BBQ Rules",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/32924.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/32924.jpg",
    },
    summary:
      "<p>On Saturday, July 11, Discovery's Destination America will premiere <b>BBQ Rules</b>, a brand-new show from a familiar face in American barbecue — pitmaster Myron Mixon. Mixon, whom you have seen on Destination America shows BBQ Pitmasters and Pitwars, will teach you the rules of barbecue alongside his son, Michael.</p><p>And trust us, if there's anyone who can teach you what you need to know about barbecue, it's Myron Mixon, whose position as the three-time winner of the World Championship Barbecue has earned him the nickname \"the winningest man in barbecue\".</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 107,
      name: "Destination America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-11",
  },
  {
    id: 2468,
    url: "https://www.tvmaze.com/shows/2468/blunt-talk",
    name: "Blunt Talk",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/73/182750.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/73/182750.jpg",
    },
    summary:
      "<p><b>Blunt Talk</b> is set in Los Angeles where the story follows Walter Blunt, a British import intent on conquering the world of American cable news and the fallout from his well-intentioned, but mostly misguided decision-making, both on and off the air. Through the platform of his nightly cable news show, Blunt is on a mission to impart his wisdom and guidance on how Americans should live, think and behave. Besieged by network bosses, a dysfunctional news staff, numerous ex-wives and children of all ages, Blunt's only support is the heavy-drinking, devoted manservant he transplanted from the U.K. to join him in Los Angeles.</p>",
    officialSite: "http://www.starz.com/originals/blunttalk/featured",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 17,
      name: "Starz",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-22",
  },
  {
    id: 2478,
    url: "https://www.tvmaze.com/shows/2478/surviving-jack",
    name: "Surviving Jack",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/33203.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/33203.jpg",
    },
    summary:
      "<p>Set in Southern California, in 1991, the series centers on Jack Dunlevy, an ex-military man and no-nonsense guy who becomes a full-time parent when his wife decides to go to law school. He takes an unorthodox approach to keeping his teenagers, Frankie and Rachel, in line.</p>",
    officialSite: "https://www.fox.com/surviving-jack/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-03-27",
  },
  {
    id: 2483,
    url: "https://www.tvmaze.com/shows/2483/darker-than-black",
    name: "Darker Than Black",
    genres: ["Drama", "Action", "Anime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/33257.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/33257.jpg",
    },
    summary:
      "<p>In Tokyo, an impenetrable field known as \"Hell's Gate\" appeared ten years ago. At the same time, psychics who wield paranormal powers at the cost of their conscience also emerged. Hei is one of the most powerful of these psychic agents, and along with his blind associate, Yin, works for one of the many rival agencies vying to unlock the mysteries of Hell's Gate.</p>",
    officialSite: "http://www.d-black.net/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 24,
      name: "MBS",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2007-04-05",
  },
  {
    id: 2485,
    url: "https://www.tvmaze.com/shows/2485/man-fire-food",
    name: "Man Fire Food",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/205/513145.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/205/513145.jpg",
    },
    summary:
      "<p><b>Man Fire Food</b> features the inventive ways people cook with fire. From small campfires to creative custom-made grills and smokers, we visit home cooks, pit masters and chefs who are fascinated by fire and food. The smoke signals take host Roger Mooking to Hawaii, wine country in Northern California, New England and the great American South to meet the passionate people who celebrate the building of and cooking over live fire.</p>",
    officialSite: "http://www.cookingchanneltv.com/shows/man-fire-food.html",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 174,
      name: "Cooking Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-09-18",
  },
  {
    id: 2486,
    url: "https://www.tvmaze.com/shows/2486/steak-out-with-kix-brooks",
    name: "Steak Out with Kix Brooks",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/33262.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/33262.jpg",
    },
    summary:
      "<p>Famed Country musician Kix Brooks is passionate about a lot of different things, from music, to wine, to raising cattle. For his next big adventure he is setting out across the states to find some of America's best steakhouses. Up first is Chicago; here we visit high-end up-and-comer Chicago Cut, South American inspired Zed451, and old-school classic Gibson's. Next we travel to Louisville where we first stop at a low-key roadhouse that is serving up top of the line beef at a blue-collar price. From there we venture down the road a piece to a packed Jeff Ruby's where a father-daughter team are serving up the highest quality product with a dramatic flair. And finally we head to Nashville to visit a couple of Kix Brooks' local haunts like the Cork &amp; Cow and The Standard.</p>",
    officialSite:
      "http://www.cookingchanneltv.com/shows/steak-out-with-kix-brooks/specials/steak-out-with-kix-brooks.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 174,
      name: "Cooking Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-14",
  },
  {
    id: 2488,
    url: "https://www.tvmaze.com/shows/2488/masters-of-illusion",
    name: "Masters of Illusion",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/33323.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/33323.jpg",
    },
    summary:
      "<p>In <b>Masters of Illusion</b>, the world's greatest magicians and illusionists perform magic in front of a live studio audience. There are no camera or computer tricks involved and you'll see tricks such as women turning into tigers, birds appearing from nowhere and sleight of hands in the blink of an eye! From one amazing trick to another, the performances are shown to you non-stop in a spectacular show filled with reality-twisting, mind-blowing magic.</p>",
    officialSite: "https://www.cwtv.com/shows/masters-of-illusion/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-08-01",
  },
  {
    id: 2491,
    url: "https://www.tvmaze.com/shows/2491/de-oorlog",
    name: "De Oorlog",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/33344.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/33344.jpg",
    },
    summary:
      "<p>De Oorlog is a new Dutch television serie about World War II. The series are produced by the NPO.</p>",
    officialSite: null,
    webChannel: null,
    language: "Dutch",
    status: "Ended",
    network: {
      id: 1019,
      name: "NPO 2",
      country: {
        name: "Netherlands",
        code: "NL",
        timezone: "Europe/Amsterdam",
      },
    },
    premiered: "2009-10-25",
  },
  {
    id: 2493,
    url: "https://www.tvmaze.com/shows/2493/sniper-standoff",
    name: "Sniper Standoff",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/33360.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/33360.jpg",
    },
    summary:
      "<p>Sniper Lee Ho Yeung (Michael Tse) left the Special Duties Unit as he failed in an operation, and since then he has gradually developed personal enmity towards his co-worker and good friend Ko Chun Kin (Eddie Cheung).</p><p>Ho Yeung becomes a yacht merchant and then becomes a president of a Firearms Association, colluding with organised crime syndicates on the sly. Taking advantage of the trust laid upon him by a detective of the Organised Crime and Triad Bureau, Seung Koon Ming Chu (Kate Tsui), he has quite a grasp on police operations that raid on the crime syndicates. On top of that, with his girlfriend Lai Chan (Eliza Sam) being a member of the Special Duties Unit, Ho Yeung gains first-move advantage in all respects. On the flip side, Chun Kin has been kept in the dark for the whole time, until he finds there is something suspicious regarding the criminal's modus operandi in several murder cases. Later on, owing to a money laundering case, Ho Yeung deliberately approaches Chun Kin's good friend, Wong Yeuk Ling (Kathy Chow), who learns that Chun Kin was the sniper who shot her in the head many years ago. Without anyone noticing, a tense standoff between the brothers is about to unfold.</p>",
    officialSite: null,
    webChannel: null,
    language: "Chinese",
    status: "Ended",
    network: {
      id: 241,
      name: "TVB",
      country: { name: "Hong Kong", code: "HK", timezone: "Asia/Hong_Kong" },
    },
    premiered: "2013-09-09",
  },
  {
    id: 2508,
    url: "https://www.tvmaze.com/shows/2508/bbq-pit-wars",
    name: "BBQ Pit Wars",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/81/202840.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/81/202840.jpg",
    },
    summary:
      "<p><b>BBQ Pit Wars</b> follows top competitors in the BBQ circuit as they engage in heated BBQ battle to dethrone the King of ‘Cue, Myron Mixon. They are considered the most successful pitmasters around, but every competition is a clean slate and an imposing challenge. Join these superstars of sauce behind the grill as they compete at some of the most prestigious and demanding BBQ competitions to see what it's really like when you're in the thick of BBQ battle.</p>",
    officialSite: "http://www.destinationamerica.com/tv-shows/bbq-pit-wars/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 107,
      name: "Destination America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-05-26",
  },
  {
    id: 2513,
    url: "https://www.tvmaze.com/shows/2513/burgers-brew-que",
    name: "Burgers, Brew & 'Que",
    genres: ["Food", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/33527.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/33527.jpg",
    },
    summary:
      "<p>Meat lovers, rejoice! Michael Symon is taking a summer road trip to taste the best of the American classics: burgers and barbecue. Whether it's mouthwatering, mile-high cheeseburgers or slow-smoked, fall-off-the-bone ribs, Michael is going to eat and meet his way through some of the best all-American spots to get your grub on. And what better way to wash it all down than with local beers and brews, sure to make any meal a perfect 10. So, get ready to get full, because you don't want to miss the delicious flavors of <b>Burgers, Brew &amp; 'Que</b>.</p>",
    officialSite: "https://www.cookingchanneltv.com/shows/burgers-brew-and-que",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 174,
      name: "Cooking Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-17",
  },
  {
    id: 2515,
    url: "https://www.tvmaze.com/shows/2515/new-japan-pro-wrestling-on-axs-tv",
    name: "New Japan Pro Wrestling on AXS TV",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/33589.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/33589.jpg",
    },
    summary:
      "<p><b>New Japan Pro Wrestling</b> presents the biggest stars and best matches from the premier wrestling organization in Japan and the second largest and fastest growing wrestling promotion in the world. WWE Hall of Fame commentator Jim Ross and former UFC Heavyweight champion and NJPW veteran Josh Barnett provide English language commentary for the series.</p>",
    officialSite: "http://www.axs.tv/programs/new-japan-pro-wrestling/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 170,
      name: "AXS TV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-16",
  },
  {
    id: 2516,
    url: "https://www.tvmaze.com/shows/2516/hit-record-on-tv-with-joseph-gordon-levitt",
    name: "Hit Record on TV with Joseph Gordon-Levitt",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/33591.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/33591.jpg",
    },
    summary:
      '<p><i><b>"Hit Record on TV with Joseph Gordon-Levitt"</b></i> is a new take on the variety show, hosted by Joseph Gordon-Levitt who directs countless artists from his global online community — hitRECord — to create short films, live performances, music, animation, conversation, and of course, more! Each episode focuses on a different theme as Joe invites and encourages anybody with an internet connection to join him and contribute. Are you RECording?</p>',
    officialSite:
      "http://www.takepart.com/pivot/hitrecord-on-tv-with-joseph-gordon-levitt",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 211,
      name: "Pivot",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-18",
  },
  {
    id: 2517,
    url: "https://www.tvmaze.com/shows/2517/my-babysitters-a-vampire",
    name: "My Babysitter's a Vampire",
    genres: ["Comedy", "Action", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/33604.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/33604.jpg",
    },
    summary:
      "<p><b>My Babysitter's a Vampire</b> is a comedic spin on pop culture vampires and scary movies in general, tells the story of three teens who believe their new babysitter is a real bloodsucking creature of the night -- and it's now up to them to rid their sleepy little town of the menace.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 78,
      name: "Disney Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-06-27",
  },
  {
    id: 2521,
    url: "https://www.tvmaze.com/shows/2521/the-henry-fords-innovation-nation",
    name: "The Henry Ford's Innovation Nation",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755187.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755187.jpg",
    },
    summary:
      "<p>Hosted by CBS News correspondent Mo Rocca, each episode of <b>The Henry Ford's Innovation Nation </b>will tell the fascinating stories behind the world's greatest inventions — and the perseverance, passion and price required to bring them to life.</p>",
    officialSite: "https://www.thehenryford.org/innovationnation/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-27",
  },
  {
    id: 2522,
    url: "https://www.tvmaze.com/shows/2522/dog-whisperer-with-cesar-millan-family-edition",
    name: "Dog Whisperer with Cesar Millan: Family Edition",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/33781.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/33781.jpg",
    },
    summary:
      "<p>In <b>Dog Whisperer with Cesar Millan: Family Edition</b>, renowned dog behaviorist Cesar Millan travels far and wide to help pups and their families. Millan rehabilitates dogs and trains families to achieve a balance and natural relationship between people and their pets, and goes directly into the homes of dog owners to document the remarkable transformations that occur.</p>",
    officialSite:
      "http://www.cwtvpr.com/the-cw/shows/dog-whisperer-with-cesar-millan-family-edition/about",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-04",
  },
  {
    id: 2530,
    url: "https://www.tvmaze.com/shows/2530/rokka-no-yuusha",
    name: "Rokka no Yuusha",
    genres: ["Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/33959.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/33959.jpg",
    },
    summary:
      "<p>When the Majin awoke from the depths of darkness, the deity of fate chose six heroes and bequeathed them with the power to save the world. Adlet, a boy who proclaims himself the strongest on Earth, was selected among the Rokka no Yūsha (Braves of the Six Flowers), and he goes to the rendezvous point — but seven have gathered there. The heroes suspect that someone among the seven is the enemy, and the initial suspicion falls on Adlet.</p>",
    officialSite: "http://rokka-anime.jp/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 24,
      name: "MBS",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2015-07-05",
  },
  {
    id: 2540,
    url: "https://www.tvmaze.com/shows/2540/marvels-avengers-assemble",
    name: "Marvel's Avengers Assemble",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/270/676806.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/270/676806.jpg",
    },
    summary:
      "<p>With an all-star roster consisting of Iron Man, Captain America, Thor, Hulk, Hawkeye, Falcon and, occasionally--when she feels like it and only when she feels like it--Black Widow, the Avengers are a team in the truest sense. The Avengers save the world from the biggest threats imaginable - threats no single super hero could withstand.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 25,
      name: "Disney XD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-05-26",
  },
  {
    id: 2541,
    url: "https://www.tvmaze.com/shows/2541/future-worm",
    name: "Future-Worm!",
    genres: ["Action", "Adventure", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/66/166710.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/66/166710.jpg",
    },
    summary:
      "<p>In <b>Future-Worm!</b> a 12-year-old boy creates a time machine lunch box and befriends a fearless worm from the future.</p>",
    officialSite: "http://www.disneyabcpress.com/disneyxd/shows/future-worm/",
    webChannel: {
      id: 83,
      name: "DisneyNOW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: {
      id: 25,
      name: "Disney XD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2016-08-01",
  },
  {
    id: 2548,
    url: "https://www.tvmaze.com/shows/2548/emmerdale",
    name: "Emmerdale",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/34218.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/34218.jpg",
    },
    summary:
      "<p><b>Emmerdale</b> is a British soap focusing on the lives of several families and locals living around an estate, a farm and the nearby village in the Yorkshire Dales. It is the second longest British soap in television history since airing its first episode on ITV in 1972, as 'Emmerdale Farm', the show was renamed in 1989.</p>",
    officialSite: "https://www.itv.com/emmerdale",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1972-10-16",
  },
  {
    id: 2550,
    url: "https://www.tvmaze.com/shows/2550/escaping-polygamy",
    name: "Escaping Polygamy",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/120/302414.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/120/302414.jpg",
    },
    summary:
      "<p><b>Escaping Polygamy</b> follows the work of three sisters who left the Kingston clan, a secretive polygamist group based in Salt Lake City, Utah known as the Order, as they help both loved ones and strangers break free of polygamy. The series follows three sisters – Andrea, Jessica and Shanell – who, over 10 years ago, bravely escaped polygamy. Now, their mission in life is to help other young men, women and children escape the abusive polygamous lifestyle into which they were born and raised, and manage their new lives on the outside.</p>",
    officialSite: "http://www.mylifetime.com/movies/escaping-polygamy",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-14",
  },
  {
    id: 2554,
    url: "https://www.tvmaze.com/shows/2554/daria",
    name: "Daria",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/34298.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/34298.jpg",
    },
    summary:
      "<p>The people of Lawndale just don't get Daria Morgendorffer. She's cool with that. See, Daria was born alienated, and now she's just trying to make it through high school with as little human contact as possible. Popularity, friends, activities... whatever. Daria lacks enthusiasm, but she makes up for it with sarcasm. Daria is the spin-off of MTV's most sucessful cartoon, Beavis and Butt-Head.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1997-03-03",
  },
  {
    id: 2565,
    url: "https://www.tvmaze.com/shows/2565/the-fairly-oddparents",
    name: "The Fairly OddParents",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/34324.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/34324.jpg",
    },
    summary:
      "<p><b>The Fairly OddParents</b> follows the comedic adventures of Timmy Turner , a 10-year-old boy who overcomes typical kid obstacles with the help of his wand-wielding wish-granting fairy godparents, Cosmo and Wanda. These wishes fix problems that include everything from an aggravating babysitter to difficult homework assignments. With their eagerness to help Timmy, Cosmo and Wanda always succeed in messing things up.</p>",
    officialSite: "http://www.nick.com/fairly-oddparents/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 73,
      name: "Nicktoons",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-03-30",
  },
  {
    id: 2571,
    url: "https://www.tvmaze.com/shows/2571/rustys-rockfeast-backstage-with-zac-brown-band",
    name: "Rusty's Rockfeast: Backstage with Zac Brown Band",
    genres: ["Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/34390.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/34390.jpg",
    },
    summary:
      '<p>In <i><b>"Rusty\'s RockFeast: Backstage with Zac Brown Band",</b></i> Chef Rusty, Southern Ground\'s Executive Chef, tours across the U.S. with Zac and the band, cooking up southern cuisine in a state-of-the-art, 18-wheel mobile kitchen named "Cookie." At every tour stop, Chef Rusty and his rock-star culinary team prepare for their famous "Eat &amp; Greets," an intimate, one-of-a-kind, sit-down meal for a few hundred fans of the Zac Brown Band.</p><p>Get ready to see the entire meal process, beginning with Chef Rusty and his team arriving in a new city on the band\'s tour. The culinary team then only has a few hours to source all the ingredients needed for the meal. They explore local farms and markets, and with each menu improvised on the spot from the freshest ingredients available that day, every tour stop presents a new set of obstacles for Chef Rusty and his intrepid team to overcome. To make sure the fans have an experience they won\'t forget, they never serve the same menu twice.</p>',
    officialSite:
      "http://www.fyi.tv/shows/rustys-rockfeast-backstage-with-zac-brown-band/about/season-1",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 125,
      name: "FYI,",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-23",
  },
  {
    id: 2583,
    url: "https://www.tvmaze.com/shows/2583/mr-show",
    name: "Mr. Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/34454.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/34454.jpg",
    },
    summary:
      "<p><b>Mr. Show</b> was the insanely funny, critically loved but HBO-loathed sketch comedy that ran on the channel for 4 years from 1995-1998. The show was created, executive produced, written and starred comics/writers Bob Odenkirk and David Cross. The show also starred Tom Kenny, Jill Talley and John Ennis. Featured performers/writers included Paul F. Tompkins, Jerry Minor, B.J. Porter, Scott Aukerman, Brian Posehn, and Jay Johnston. Featured performers included Mary-Lynn Rajskub, Brett Paesal, and Sarah Silverman. The show has spawned a movie based on popular character Ronnie Dobbs in Run Ronnie Run. Bob's wife, Naomi Odenkirk, has compiled everything you could ever want to know about the show in her wonderful book, Mr. Show: What Happened.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1995-11-03",
  },
  {
    id: 2586,
    url: "https://www.tvmaze.com/shows/2586/randall-hopkirk-deceased",
    name: "Randall & Hopkirk (Deceased)",
    genres: ["Drama", "Comedy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/34459.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/34459.jpg",
    },
    summary:
      "<p>A modern day version of the 1969 detective series about Private Investigator Jeff Randall, who is aided in cases by the ghost of his deceased partner Marty Hopkirk.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2000-03-18",
  },
  {
    id: 2587,
    url: "https://www.tvmaze.com/shows/2587/the-ricky-gervais-show",
    name: "The Ricky Gervais Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/34462.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/34462.jpg",
    },
    summary:
      "<p>Based on the series of podcasts that Gervais did with longtime partner Stephen Merchant, this comedy team convenes to bring HBO an animated series about their hilarious friend Karl Pilkington.</p>",
    officialSite: "http://www.hbo.com/the-ricky-gervais-show",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-02-19",
  },
  {
    id: 2589,
    url: "https://www.tvmaze.com/shows/2589/stewart-lees-comedy-vehicle",
    name: "Stewart Lee's Comedy Vehicle",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/181/454802.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/181/454802.jpg",
    },
    summary:
      "<p>The show marks the triumphant television return of one of the finest stand-ups working in Britain today, enthralling a live audience with his uniquely cynical and hilariously condescending take on the world around him. Each episode sees Stewart exploring a different theme in a stand-up routine, often illustrated with sketches featuring an ensemble cast. They are performed in a way that deconstructs comedy itself; literally a vehicle for Lee's idiosyncratic style. Starring alongside Stewart are: Tony Law, Tara Flynn, Paul Putner, Kevin Eldon, Miles Jupp, Simon Munnery, Job Angus and Michael Redmond. Peter Serafinowicz provides voiceovers.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b0112b65",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-03-16",
  },
  {
    id: 2599,
    url: "https://www.tvmaze.com/shows/2599/boston-ems",
    name: "Boston EMS",
    genres: ["Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/82/205654.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/82/205654.jpg",
    },
    summary:
      "<p>Viewers will ride along with the proud men and women of the Boston Emergency Services, one of America's most seasoned team of first responders: the first step in the chain of trauma care. It was this same group that answered the desperate calls of runners and spectators two years ago when the bombs went off at the Boston Marathon. Treating the injured and ferrying the wounded to hospitals, the <b>Boston EMS</b> earned the gratitude of a shell-shocked and grief-stricken city with their cool-headed professionalism. In Boston EMS, viewers will meet some of the heroes of that terrible day as they answer new calls and respond to a daily dose of trauma and mayhem.</p>",
    officialSite: "http://abc.go.com/shows/boston-ems",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-25",
  },
  {
    id: 2612,
    url: "https://www.tvmaze.com/shows/2612/we-bare-bears",
    name: "We Bare Bears",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/223/557683.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/223/557683.jpg",
    },
    summary:
      "<p><b>We Bare Bears</b> is about three brother bears who awkwardly attempt to find their place in civilized society, whether they're looking for food, trying to make human friends, or scheming to become famous on the internet. Grizzly, Panda and Ice Bear stack atop one another when they leave their cave and explore the hipster environs of the San Francisco Bay Area, and it's clear the siblings have a lot to learn about a technologically driven world. By their side on many adventures are best friend Chloe (the only human character in the cast), fame-obsessed panda Nom Nom, and Charlie, aka Bigfoot.</p>",
    officialSite:
      "http://www.cartoonnetwork.com/video/we-bare-bears/index.html?atclk_vn=nav_We-Bare-Bears",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-27",
  },
  {
    id: 2617,
    url: "https://www.tvmaze.com/shows/2617/wwe-quick-hits",
    name: "WWE Quick Hits",
    genres: ["Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/13/34800.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/13/34800.jpg",
    },
    summary:
      "<p><b>WWE Quick Hits</b> brings you some of the most unique, entertaining, and sometimes outrageous clips, unearthed from the depths of WWE Network.</p>",
    officialSite: "http://www.wwe.com/inside/networkschedule",
    webChannel: {
      id: 15,
      name: "WWE Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "To Be Determined",
    network: null,
    premiered: "2014-12-27",
  },
  {
    id: 2618,
    url: "https://www.tvmaze.com/shows/2618/wwe-unfiltered-with-renee-young",
    name: "WWE Unfiltered with Renee Young",
    genres: ["Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755352.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755352.jpg",
    },
    summary:
      "<p><b>WWE Unfiltered</b> (also known as WWE Unfiltered with Renee Young) is a 30 minute long interview session hosted by WWE backstage interviewer Renee Young with 1 WWE Superstar!</p>",
    officialSite: "http://www.wwe.com/inside/networkschedule",
    webChannel: {
      id: 15,
      name: "WWE Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-04-28",
  },
  {
    id: 2624,
    url: "https://www.tvmaze.com/shows/2624/fantomworks",
    name: "FantomWorks",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/251/629759.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/251/629759.jpg",
    },
    summary:
      "<p>In <b>FantomWorks</b>, restoration expert Dan Short and his team only have a heart for those who genuinely love their cars. Every car has a story, but if you can't prove to Dan that you truly care about your car and want The Job done right then he won't accept your business. Dan's bustling shop, FantomWorks, is the largest automotive restoration shop in America. Leaning on of years automotive restoration experience in addition to the qualities of discipline and precision Dan acquired in the military, the FantomWorks team runs a busy production pipeline in order to meticulously refurbish some of America's favorite rides. Every week old cars come with new obstacles including irate car owners, personality clashes, cost over-runs, parts problems and walkouts.</p>",
    officialSite: "http://www.velocity.com/tv-shows/fantomworks/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 142,
      name: "MotorTrend",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-06-30",
  },
  {
    id: 2631,
    url: "https://www.tvmaze.com/shows/2631/la-hair",
    name: "L.A. Hair",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/35305.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/35305.jpg",
    },
    summary:
      "<p>When it comes to coiffing the heads of Hollywood's elite, celebrity stylist Kim Kimble is at the height of haute couture hair trends. Having already solidified her reputation as the A-List go-to hair diva, Kim and her crew of fiery stylists open up the doors of their ultra-exclusive salon to show the world the sheer madness of high-end hair. With some of the biggest names in movies, music and fashion gracing the seats of the Kim Kimble studio, the drama and competition reaches epic heights as each stylist attempts to cut their name next to Kim's in the pantheon of Hollywood hair.</p><p>In Season 4 of <b>L.A. Hair</b>, Kim Kimble is back, and ruling her empire has become harder than ever! First, Kim shakes up the salon when she hires a brash new stylist from Atlanta. Then she gets an offer she can't refuse from the bad boy of Hollywood Hair, Jonathan Antin, who wants to break into the lucrative world of wigs and extensions. When Jonathan turns from friend to foe, and Kim discovers an informant in her salon, the shears come out as \"Hair Majesty\" fights to defend her throne.</p>",
    officialSite: "http://www.wetv.com/shows/la-hair",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 122,
      name: "WE tv",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-05-31",
  },
  {
    id: 2640,
    url: "https://www.tvmaze.com/shows/2640/banged-up-abroad",
    name: "Banged Up Abroad",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/46/115710.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/46/115710.jpg",
    },
    summary:
      '<p><b>Banged Up Abroad</b> is a British documentary/docudrama television series that was produced for Channel Five and that premiered in March 2006. It is broadcast under the title "Locked Up Abroad" in the United States and other parts of the world on the National Geographic Channel. It features stories of people who have been arrested while travelling abroad, usually for trying to smuggle illegal drugs out of a particular country and have received lengthy prison sentences as a result. Among the stories to have been told is that of British woman Sandra Gregory, who spent several years in the Klong Prem Central Prison after being convicted of trying to smuggle heroin out of Thailand. A second series was broadcast in 2007 with a third series during August and September 2008, and a fourth in October 2008.</p>',
    officialSite:
      "https://www.nationalgeographic.co.uk/video/tv/banged-up-abroad",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 242,
      name: "National Geographic Channel",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2007-07-24",
  },
  {
    id: 2644,
    url: "https://www.tvmaze.com/shows/2644/air-aces",
    name: "Air Aces",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/35025.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/35025.jpg",
    },
    summary:
      "<p><b>Air Aces</b> is a ground breaking new series that tells the stories of the most heroic airborne combat missions in history. Using real vintage aircrafts, the series films the impossible by re-creating mid-air combat sequences. Featuring Spitfires, Lancaster bombers, and Phantom fighters, aerial stunt teams, and state-of-the-art camera technology, the series dramatizes the exploits of the world's greatest Air Aces. The series also features revealing interviews with the last surviving veterans and military historians, rare archival footage, and cutting edge CGI.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-08-04",
  },
  {
    id: 2646,
    url: "https://www.tvmaze.com/shows/2646/the-day-i-almost-died",
    name: "The Day I Almost Died",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/52/130339.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/52/130339.jpg",
    },
    summary:
      '<p><i><b>"THE DAY I ALMOST DIED"</b></i> is about accidents that occur without warning, but what if it was your own doing that put yourself into a deadly situation? THE DAY I ALMOST DIED is a series that combines astounding first-person accounts with stunning dramatic recreations and real life footage to reveal that anyone, at any time, can fall victim to a fatal self-inflicted injury. From falling off a boat only to be sucked under the motor, to shooting a nail gun through your heart, or getting nearly crushed by a big rig, each episode features three harrowing stories of people who almost accidentally killed themselves.</p>',
    officialSite:
      "http://www.discoverylife.com/tv-shows/the-day-i-almost-died/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 177,
      name: "Discovery Life",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-11",
  },
  {
    id: 2651,
    url: "https://www.tvmaze.com/shows/2651/premier-boxing-champions-the-next-round",
    name: "Premier Boxing Champions: The Next Round",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/35859.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/35859.jpg",
    },
    summary:
      "<p>Premier Boxing Champions (PBC) comes to Bounce TV on Sunday, August 2 at 9:00 p.m. (ET), with the debut of the new monthly series, <b>Premier Boxing Champions: The Next Round</b>, which will showcase the sport's future stars and potential champions.</p>",
    officialSite: "http://www.bouncetv.com/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 261,
      name: "BOUNCE TV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-02",
  },
  {
    id: 2653,
    url: "https://www.tvmaze.com/shows/2653/ultimate-homes",
    name: "Ultimate Homes",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/52/130340.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/52/130340.jpg",
    },
    summary:
      '<p>In <i><b>"Ultimate Homes"</b></i> six homeowners create dream homes in different parts of the U.S.A.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-10",
  },
  {
    id: 2654,
    url: "https://www.tvmaze.com/shows/2654/geeks-who-drink",
    name: "Geeks Who Drink",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/35292.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/35292.jpg",
    },
    summary:
      '<p>In each installment of <b>Geeks Who Drink</b>, two teams of self-proclaimed "trivia geeks" battle it out in rapid-fire quizzes that cover topics from pop culture to science fiction. Each team consists of three players – a celebrity team captain and two trivia pros. After three rounds of raucous game-play and (mostly) friendly competition, the winning team will earn bragging rights, a spot on the Geeks Who Drink leaderboard and a bevy of prizes to geek out over.</p>',
    officialSite: "http://www.syfy.com/geekswhodrink",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-16",
  },
  {
    id: 2655,
    url: "https://www.tvmaze.com/shows/2655/on-the-record-with-mick-rock",
    name: "On the Record with Mick Rock",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/15/37856.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/15/37856.jpg",
    },
    summary:
      "<p>Mick Rock (aka, \"The Man Who Shot the Seventies\"). Today, Mick is as in-demand as ever; photographing legends-in-the-making like Snoop Dog, Daft Punk, The Killers, Cee Lo Green, and the Black Keys, among many others, but this summer, he'll come out from behind the camera to host his own show: <b>On the Record with Mick Rock</b>.</p><p>Featuring guest stars Josh Groban, Kings of Leon, The Flaming Lips and Patti LaBelle, <i>On the Record with Mick Rock</i> goes into each of the artists' hometowns to check out the sights and sounds that inspire them. A unique spin on the musician profile series, the show's stripped-down style and Mick's unapologetic rapport with his guests produces candid conversations and musical performances not usually seen on television.</p>",
    officialSite:
      "http://www.ovationtv.com/series/on-the-record-with-mick-rock/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 208,
      name: "Ovation",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-02",
  },
  {
    id: 2658,
    url: "https://www.tvmaze.com/shows/2658/epic-attractions",
    name: "Epic Attractions",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/35324.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/35324.jpg",
    },
    summary:
      "<p>The biggest and most insane theme parks in the world are run like well-oiled machines. These parks are high tech and high dollar. Join amusement expert Chris Perry as he reveals the industry's insider secrets for success in <b>Epic Attractions</b>.</p>",
    officialSite: "http://www.travelchannel.com/shows/epic-attractions",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 82,
      name: "Travel Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-09",
  },
  {
    id: 2660,
    url: "https://www.tvmaze.com/shows/2660/buying-the-rockies",
    name: "Buying the Rockies",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/99/249721.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/99/249721.jpg",
    },
    summary:
      "<p><b>Buying the Rockies</b> follows a real American family looking to leave conventional homes behind and find the log cabin of their dreams in the Rocky Mountains. In each episode, prospective buyers tour three stunning homes in the hope of finding their new dream getaway. Travel a mile up in the sky, where mountain views mingle with the clouds and the properties range from primitive cabins to million-dollar log homes with modern conveniences.</p>",
    officialSite:
      "http://www.destinationamerica.com/tv-shows/buying-the-rockies/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 107,
      name: "Destination America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-13",
  },
  {
    id: 2671,
    url: "https://www.tvmaze.com/shows/2671/bitchin-rides-beyond-bitchin",
    name: "Bitchin' Rides: Beyond Bitchin'",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/226/567054.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/226/567054.jpg",
    },
    summary:
      "<p><b>Bitchin' Rides: Beyond Bitchin'</b> is a one hour long special series that airs extended episodes with extra information and unseen footage from the show <i>Bitchin' Rides</i>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 142,
      name: "MotorTrend",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-04",
  },
  {
    id: 2673,
    url: "https://www.tvmaze.com/shows/2673/west-texas-investors-club",
    name: "West Texas Investors Club",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/140/350541.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/140/350541.jpg",
    },
    summary:
      "<p><b>West Texas Investors Club</b> is a series that takes place deep in the heart of Texas, where self-made multimillionaires Rooster McConaughey and Butch Gilliam carved their fortunes from a harsh and unforgiving land. For the past several years, they've chosen to pass on that success by investing in promising entrepreneurs – but only on their turf and their terms. Along with their close friend and confidante Gil Prather, Rooster and Butch invite ambitious entrepreneurs from across the country to come down to West Texas and make their case. These folks know that they're getting a once-in-a-lifetime chance to secure funding…but what they don't know is that clever products and beautiful balance sheets will only get you so far with these investors. No, Rooster and Butch won't make a deal until they've peered into your heart and soul – and taken the true measure of your character and your company.</p>",
    officialSite: "http://www.cnbcprime.com/west-texas/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 93,
      name: "CNBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-04",
  },
  {
    id: 2675,
    url: "https://www.tvmaze.com/shows/2675/american-titans",
    name: "American Titans",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/15/37638.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/15/37638.jpg",
    },
    summary:
      "<p>Rockefeller, Carnegie, Edison, Tesla, Hearst, and Pulitzer: their legacies live down through the ages, emblazoned on museums, universities, banks, charities, and the richest of American real estate. Ferocious drive, innovation and often sheer recklessness took these visionaries to the top of the rich-and-powerful list and ultimately made America the mightiest nation on earth. Despite their wealth and power, these titans of industry and captains of commerce were not always philanthropic, often driven by greed, ambition, jealousy and revenge. You can't build a fortune without making a few enemies. From Edison and Tesla's high-voltage war of the currents to Rockefeller and Scott's row over the growth of oil, <b>American Titans</b> relies on cinematic recreations and expert commentary to reveal what it took for the founding fathers of the Fortune 500 to steer the Industrial Revolution into the Gilded Age. During this era of incredible industrial potential, there were many on the road to absolute power – these are the stories of those who out-fought, out-spent, and out-smarted their rivals to reserve their chapter in the history books and make America what it is today.</p>",
    officialSite: "http://www.ahctv.com/american-titans/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 229,
      name: "AHC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-04",
  },
  {
    id: 2679,
    url: "https://www.tvmaze.com/shows/2679/a-wicked-offer",
    name: "A Wicked Offer",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/68/171627.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/68/171627.jpg",
    },
    summary:
      "<p>In the outrageous, darkly comic, one-hour docuseries <b>A Wicked Offer</b>, couples who need some extra help in making their dreams a reality are presented with a series of Faustian bargains, as they must decide to complete various scandalous and controversial tasks involving their unsuspecting friends, families, and co-workers for cash prizes. With each challenge testing the couple's moral and ethical boundaries, the couples must weigh the potential havoc wreaked on their relationship with each other and with everyone involved. As each task is completed, the stakes and the cash value are raised, forcing the couple to decide how far they're willing to go for money.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-05",
  },
  {
    id: 2681,
    url: "https://www.tvmaze.com/shows/2681/behind-bars-rookie-year",
    name: "Behind Bars: Rookie Year",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/72/180208.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/72/180208.jpg",
    },
    summary:
      "<p><b>Behind Bars: Rookie Year</b> follows a group of new recruits at the New Mexico Corrections Academy (NMCA) who are training or have recently joined the ranks at the Penitentiary of New Mexico (PNM). These rookies come face-to-face with rapists, murderers, and gang members who take pleasure in preying on weakness. Every new recruit hoping to join the department goes through a rigorous training program designed to test their fortitude and give them the tools needed to survive one of the most dangerous working environments on the planet. But as each day passes, the physical and emotional demands often prove too much for some, and even the best training can't prepare a rookie for the unexpected. Whether they're cadets in training or brand new on the line, the officers all wrestle with a critical life-or-death question: Is it worth it?</p>",
    officialSite: "http://www.aetv.com/behind-bars-rookie-year",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-06",
  },
  {
    id: 2684,
    url: "https://www.tvmaze.com/shows/2684/live-at-the-apollo",
    name: "Live at the Apollo",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/36031.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/36031.jpg",
    },
    summary:
      "<p><b>Live at the Apollo</b> (formerly titled <i>Jack Dee Live at the Apollo</i>) is a British stand-up comedy programme performed from the Hammersmith Apollo Theatre in west London.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b008cnxn",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2004-09-06",
  },
  {
    id: 2685,
    url: "https://www.tvmaze.com/shows/2685/animals-lol",
    name: "Animals LOL",
    genres: ["Comedy", "Family", "Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/36038.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/36038.jpg",
    },
    summary:
      "<p>Animals and Pets can do some of the craziest and cookies things at time that make you Laugh out Loud and <b>Animals LOL</b> catches them in the act with tons of video clips not only from viewers but also from the Internet.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 176,
      name: "Discovery Family",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-07",
  },
  {
    id: 2686,
    url: "https://www.tvmaze.com/shows/2686/sneaky-pete",
    name: "Sneaky Pete",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/193/483552.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/193/483552.jpg",
    },
    summary:
      "<p><b>Sneaky Pete</b> centers on a thirty-something con man who, upon leaving prison, takes cover from his past by assuming the identity of his cellmate. He begins working at his family run bail bond business where he secretly uses this as a cover to help catch bigger criminals than he ever was. He works alongside his beautiful cousin who is not too sure what his underlying motives are.</p>",
    officialSite: "http://www.amazon.com/Sneaky-Pete-Season-1/dp/B013488XFS",
    webChannel: { id: 3, name: "Amazon Prime Video", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-08-07",
  },
  {
    id: 2689,
    url: "https://www.tvmaze.com/shows/2689/lee-soon-shin-is-the-best",
    name: "Lee Soon Shin is the Best",
    genres: ["Comedy", "Family", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/164/411211.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/164/411211.jpg",
    },
    summary:
      "<p>Because of her father's sudden death, Lee Soon Shin and her mother fall in trouble. They both attempt to find happiness, while Lee Soon Shin falls in love.</p><p>Meanwhile Shin Joon Ho is the president of an entertainment management company. He is over confident, arrogant and cold-blooded. By meeting Lee Soon Shin, he realizes the meaning of true success and also changes.</p>",
    officialSite: "http://www.kbs.co.kr/drama/soonsin/about/cast/index.html#",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 128,
      name: "KBS2",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2013-03-09",
  },
  {
    id: 2692,
    url: "https://www.tvmaze.com/shows/2692/comrades",
    name: "Comrades",
    genres: ["Drama", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/36176.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/36176.jpg",
    },
    summary:
      "<p>This drama commemorates the soldiers who gave their lives in the Korean War, fought between North and South Korea between 1950 and 1953, and is designed to remind people that the heavy cost of human lives far outweigh any national glory. Lee Hyun Joong is a South Korean squad commander and war veteran who is dedicated to protecting the lives of the soldiers serving under him, despite his jaded outlook. His chance meeting with Lee Tae Ran on the battlefield stirs memories of the past, but she is now a lieutenant of the North Korean army.</p>",
    officialSite: "http://www.kbs.co.kr/drama/625/",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 262,
      name: "KBS1",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2010-06-19",
  },
  {
    id: 2695,
    url: "https://www.tvmaze.com/shows/2695/america-the-beautiful",
    name: "America the Beautiful",
    genres: ["Nature", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/215/537827.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/215/537827.jpg",
    },
    summary:
      "<p>America's vast and iconic landscapes host climates and terrains that are as diverse as its people. In advance of the National Park Service's 2016 centennial celebration, Travel Channel's <b>America the Beautiful</b>, narrated by Robert Redford, takes viewers well beyond ordinary sightseeing and showcases truly immersive experiences in some of America's most beloved national parks.</p>",
    officialSite: "http://www.travelchannel.com/shows/america-the-beautiful",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 82,
      name: "Travel Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-09",
  },
  {
    id: 2699,
    url: "https://www.tvmaze.com/shows/2699/gunslingers",
    name: "Gunslingers",
    genres: ["Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/36267.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/36267.jpg",
    },
    summary:
      "<p>American Heroes Channel's new series <i><b>\"Gunslingers\"</b></i> reveals the infamous tales of survival and courage from the Wild West. Exposing little-known facts about America's first villains and heroes, the six-part series features the stories of Wyatt Earp, Billy the Kid, Jesse James, Wild Bill Hickok, John Wesley Hardin and Tom Horn. Juxtaposed with vivid reenactments, expert commentary is layered throughout each episode to ensure the authenticity and historical accuracy of each story. Contributors include: David Milch, the creator of Deadwood; Bob Boze Bell, the executive editor of True West Magazine; and actor Kurt Russell (Tombstone).</p>",
    officialSite: "http://www.ahctv.com/tv-shows/gunslingers/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 229,
      name: "AHC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-20",
  },
  {
    id: 2700,
    url: "https://www.tvmaze.com/shows/2700/port-protection-alaska",
    name: "Port Protection Alaska",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/310/775836.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/310/775836.jpg",
    },
    summary:
      "<p><b>Port Protection Alaska </b>profiles individuals trying to survive way above the Lower 48. Surrounded by the North Pacific, Port Protection is a remote community tucked into the northwest corner of Prince of Wales Island, Alaska. The approximately 100 residents who call the rugged, unforgiving land home push the limits of survival, living an isolated and risky existence of self-reliance with no roads, government or law enforcement. However, they think the risk is worth the profound reward: a world of beauty with the security of community without the constraints of bureaucracy.</p>",
    officialSite:
      "https://www.nationalgeographic.com/tv/shows/port-protection-alaska",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-19",
  },
  {
    id: 2707,
    url: "https://www.tvmaze.com/shows/2707/epitafios",
    name: "Epitafios",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/36426.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/36426.jpg",
    },
    summary:
      "<p>Five years after a hostage situation where four students were tragically burned alive, a man starts to kill people related to the case. Eugenio Benítez (the sheriff), Laura Santini (a psychologist) and Renzo Márquez (a retired policeman who now works as a taxi driver) become caught up in the maelstrom of the new crimes due to their involvement with the course of the original crime.</p>",
    officialSite: null,
    webChannel: null,
    language: "Spanish",
    status: "Ended",
    network: {
      id: 110,
      name: "HBO Latin America",
      country: { name: "Chile", code: "CL", timezone: "America/Santiago" },
    },
    premiered: "2005-12-07",
  },
  {
    id: 2710,
    url: "https://www.tvmaze.com/shows/2710/playing-house",
    name: "Playing House",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/117/294873.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/117/294873.jpg",
    },
    summary:
      "<p>In <b>Playing House</b>, when pregnant Maggie discovers her husband cheating, her BFF Emma gives up her career to help Maggie raise the baby. Now the lifelong friends must navigate their biggest and most hilarious adventure yet, in the best way they know how - together.</p>",
    officialSite: "http://www.usanetwork.com/playinghouse",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-04-29",
  },
  {
    id: 2714,
    url: "https://www.tvmaze.com/shows/2714/ties-that-bind",
    name: "Ties That Bind",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/39/99000.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/39/99000.jpg",
    },
    summary:
      "<p>Allison McLean is a tough and experienced police detective in suburban Seattle. Like most working women, her hands are already full, balancing a demanding and dangerous job and a family — husband Matt, and teenagers Jeff and Rachel. But when she and her partner, Devin, must arrest her brother, Tim, for aggravated assault, her world drastically changes as Tim is convicted and sent to prison leaving his two teenagers Cameron and Mariah teetering on the brink of foster care. Having done the right thing as an officer of the law, Allison now feels compelled to do the right thing as a sister and aunt; she brings Tim's two very unhappy teens into her home. Squeezing four teenagers under one roof proves to be an additional test of Allison's strength and patience. It won't be easy for her husband, her children or Tim's kids either. In addition to investigating local crimes, the UP Original Series <b>Ties That Bind</b> will also focus on the joys and struggles of the teens as they adjust to their new home, their new high school, make new friends and experience love, romance, anger and jealousy.</p>",
    officialSite: "http://uptv.com/shows/ties-that-bind/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 227,
      name: "UP TV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-12",
  },
  {
    id: 2716,
    url: "https://www.tvmaze.com/shows/2716/garage-squad",
    name: "Garage Squad",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/36648.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/36648.jpg",
    },
    summary:
      "<p>You know that \"project car\" you've been working on for the last five years? The car just sitting in your garage collecting dust? Well, today could be the day you can finally drive that project out of your garage. Velocity's series <b>Garage Squad</b>, surprises the people working on car projects with the opportunity to get expert help to finally finish them. The <i>Garage Squad</i> team of ace mechanics searches auto parts stores across America for worthy backyard automotive restorers, and walks out with them ready to take those cars from DIY to DONE.</p>",
    officialSite: "https://watch.motortrend.com/tv-shows/garage-squad/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 142,
      name: "MotorTrend",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-08-01",
  },
  {
    id: 2720,
    url: "https://www.tvmaze.com/shows/2720/gran-reserva",
    name: "Gran Reserva",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/36774.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/36774.jpg",
    },
    summary:
      "<p>The storyline of the spanish drama, <b>Gran Reserva</b> revolves around two families of Rioja winemakers: the Cortázar, who see wine as a lucrative business, and Reverte, for whom the vineyard and land are a way of life. Despite their differences, both families live in a balance that dramatically breaks when someone tries to kill Miguel, Cortázar's firstborn. Although the young man survives, he loses his memory, and that changes their world forever.</p>",
    officialSite: null,
    webChannel: null,
    language: "Spanish",
    status: "Ended",
    network: {
      id: 99,
      name: "TVE",
      country: { name: "Spain", code: "ES", timezone: "Europe/Madrid" },
    },
    premiered: "2010-04-15",
  },
  {
    id: 2722,
    url: "https://www.tvmaze.com/shows/2722/make-me-a-millionaire-inventor",
    name: "Make Me a Millionaire Inventor",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/36793.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/36793.jpg",
    },
    summary:
      "<p><b>Make Me a Millionaire Inventor</b> is on a mission to find the best inventions NEVER made and give them new life. Inventors will be given the resources and help they need to take their products from concept to reality.</p>",
    officialSite: "http://www.cnbcprime.com/millionaire-inventor/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 93,
      name: "CNBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-12",
  },
  {
    id: 2723,
    url: "https://www.tvmaze.com/shows/2723/manhunt-kill-or-capture",
    name: "Manhunt: Kill or Capture",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/279/698267.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/279/698267.jpg",
    },
    summary:
      "<p><b>Manhunt: Kill or Capture</b> featuring the most memorable manhunts, task force shutdowns and undercover infiltrations of infamous masterminds in the history of American law enforcement.</p><p>Each one-hour episode of <i>Manhunt: Kill or Capture</i> profiles the thrilling chase and ultimate takedown of a notorious criminal leader. With special access to in-depth interviews with the agents, policemen, intelligence agents and eye witnesses who brought these criminals to justice, viewers are given an inside look at how the complex operations were executed to bring down the world's most ruthless and elusive targets.</p>",
    officialSite: "http://www.ahctv.com/manhunt-kill-or-capture/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 229,
      name: "AHC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-12",
  },
  {
    id: 2725,
    url: "https://www.tvmaze.com/shows/2725/swamp-murders",
    name: "Swamp Murders",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/36798.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/36798.jpg",
    },
    summary:
      "<p>From the swampy bayou of Louisiana to the Great Lake o' the Cherokees in Missouri and even rivers and lakes in Georgia, Texas, and Florida, <b>Swamp Murders</b> proves that even muddied waters eventually bring secrets to the surface. The premiere episode on June 4 at 10 PM profiles wholesome 19-year-old Kathy Bonney. When Kathy doesn't come home one day, her concerned father, Tom, turns to police for help. But when Kathy's bullet-ridden body is pulled from Virginia's Great Dismal Swamp, detectives discover that Kathy wasn't as angelic as everyone was led to believe - and her father wasn't as clueless as he let on.</p>",
    officialSite:
      "http://www.investigationdiscovery.com/tv-shows/swamp-murders/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-06-04",
  },
  {
    id: 2726,
    url: "https://www.tvmaze.com/shows/2726/beach-eats-usa",
    name: "Beach Eats USA",
    genres: ["Food", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755365.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755365.jpg",
    },
    summary:
      "<p>Curtis Stone is on a journey to find the ultimate beach spots in America that serve fresh and fantastic fare along with spectacular sunsets. Put on your sandals and sunscreen, 'cause these places don't require forks and knives — just hungry appetites for amazing eats along the water in <b>Beach Eats USA</b>.<i><br /></i></p>",
    officialSite: "http://www.foodnetwork.com/shows/beach-eats-usa.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 81,
      name: "Food Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-12",
  },
  {
    id: 2727,
    url: "https://www.tvmaze.com/shows/2727/man-v-fly",
    name: "Man v Fly",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755366.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755366.jpg",
    },
    summary:
      "<p>GSN has acquired 50 three-minute episodes of the interstitial series <b>Man v Fly</b>, which will run on air; GSN also will put the show into half-hour series development. In the history of television, a higher stakes battle for dominance has never been waged! In Man v Fly, Brave human warriors are placed into a sealed white box with a cunning, dastardly housefly. Every contestant is allowed one weapon of choice to aid in battle: a cleaning lady wields her vacuum, a knight in armor swings his broadsword, a scuba diver brandishes a fish. Each has only 60 seconds to bring down the fly, or leave in disgrace. Two will enter…but only one will leave. Off-camera sports commentators announce the play-by-play with hysterically deadpan wit. Cheering for the fly is encouraged.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 189,
      name: "Game Show Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-12",
  },
  {
    id: 2730,
    url: "https://www.tvmaze.com/shows/2730/thirteen",
    name: "Thirteen",
    genres: ["Drama", "Thriller", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/144/360158.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/144/360158.jpg",
    },
    summary:
      "<p>After thirteen years held captive by her kidnapper, Ivy Moxam escapes. Piecing back together the version of family life that existed before is no easy task.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p03kbqgf",
    webChannel: {
      id: 71,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2016-02-28",
  },
  {
    id: 2743,
    url: "https://www.tvmaze.com/shows/2743/supermansion",
    name: "SuperMansion",
    genres: ["Comedy", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/206/515192.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/206/515192.jpg",
    },
    summary:
      "<p>In <b>SuperMansion</b>, a group of elderly superheroes, the League of Freedom, were once renowned throughout the world. Now under the leadership of Titanium Rex, they attempt to stay relevant in a world that has passed them by.</p>",
    officialSite: "http://www.crackle.com/c/supermansion",
    webChannel: {
      id: 4,
      name: "Crackle",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Running",
    network: null,
    premiered: "2015-10-08",
  },
  {
    id: 2754,
    url: "https://www.tvmaze.com/shows/2754/moonbeam-city",
    name: "Moonbeam City",
    genres: ["Drama", "Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/47238.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/47238.jpg",
    },
    summary:
      "<p>The animated series, <b>Moonbeam City</b> stars Rob Lowe as Dazzle Novak, a detective in America's most fluorescent metropolis, whose desire to serve is second only to his nonstop sex drive. But with Chief Pizzaz Miller cramping his style and his rival Rad Cunningham undermining him at every turn, he may have to face the (very synthy) music and do some actual police work.</p>",
    officialSite: "http://www.cc.com/shows/moonbeam-city",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-16",
  },
  {
    id: 2758,
    url: "https://www.tvmaze.com/shows/2758/mercy-street",
    name: "Mercy Street",
    genres: ["Drama", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50132.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50132.jpg",
    },
    summary:
      "<p>Based on real events, <b>Mercy Street</b> takes viewers beyond the battlefield and into the lives of Americans on the Civil War home front as they face the unprecedented challenges of one of the most turbulent times in our nation's history.</p><p>Set in Virginia in the spring of 1862, the series follows the lives of two volunteer nurses on opposite sides of the conflict; Mary Phinney, a staunch New England abolitionist, and Emma Green, a naive young Confederate belle. The two collide at Mansion House, the Green family's luxury hotel that has been taken over and transformed into a Union Army Hospital in Alexandria, a border town between North and South and the longest-occupied Confederate city of the war. Ruled under martial law, Alexandria is now the melting pot of the region, filled with soldiers, civilians, female volunteers, doctors, wounded fighting men from both sides, runaway slaves, prostitutes, speculators and spies.</p><p>The intersection of North and South within the confines of a small occupied town creates a rich world that is chaotic, conflicted, corrupt, dynamic and even hopeful — a cauldron within which these characters strive, fight, love, laugh, betray, sacrifice and, at times, act like scoundrels. This series is not about battles and glory, it's about the drama and unexpected humor of everyday life behind the front lines. It's a fresh twist on an iconic story, one that resonates with larger themes we still struggle with today.</p>",
    officialSite: "http://www.pbs.org/mercy-street/home/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 85,
      name: "PBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2016-01-17",
  },
  {
    id: 2769,
    url: "https://www.tvmaze.com/shows/2769/dinotrux",
    name: "Dinotrux",
    genres: ["Action", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/102/257276.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/102/257276.jpg",
    },
    summary:
      "<p><b>Dinotrux</b> is an all-new action-packed original series featuring hybrid dinosaur-construction characters who are set to build and battle over three seasons. Based on Chris Gall‘s award-winning book series, DreamWorks Animation's Dinotrux is set in a fantastical world filled with lava-flowing volcanoes, lush forests and a megaton cast of loveable characters who are half-dinosaur, half-mechanical construction vehicle and all fun!</p>",
    officialSite: "https://www.netflix.com/title/80049903",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-08-14",
  },
  {
    id: 2772,
    url: "https://www.tvmaze.com/shows/2772/flcl",
    name: "FLCL",
    genres: ["Drama", "Comedy", "Anime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/117/292507.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/117/292507.jpg",
    },
    summary:
      "<p>Naota is a normal Japanese 6th grade boy (although a little cynical), but when his older brother leaves for America to play baseball, his brother leaves his homeless 17-year-old girlfriend Mamimi behind. Mamimi is sending mixed signals and advances to Naota, and he doesn't know what to do about her. But to make matters worse, Naota's world is totally turned upside down when he is run over by a woman on a Vespa. During their first encounter, she hits him over the head with her bass guitar, which then causes a horn to grow out of his forehead. She calls herself \"Haruko\" and her presence changes Naota's life to even further insanity.</p>",
    officialSite: "http://flcl-anime.com",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-08-05",
  },
  {
    id: 2778,
    url: "https://www.tvmaze.com/shows/2778/operation-good-guys",
    name: "Operation Good Guys",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/14/37455.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/14/37455.jpg",
    },
    summary:
      "<p>Comedy series following the fortunes of an elite underground police unit, fronted by DI Jim Beach, who have been assembled to bring down a major crime lord.</p>",
    officialSite: "http://www.bbc.co.uk/comedy/operationgoodguys/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1997-12-29",
  },
  {
    id: 2787,
    url: "https://www.tvmaze.com/shows/2787/airline",
    name: "Airline",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/75/189520.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/75/189520.jpg",
    },
    summary:
      "<p><b>Airline</b> focuses on the ups and downs of passengers and Southwest's staff and crew at Los Angeles International (LAX), Chicago Midway, Baltimore/Washington International, and Houston Hobby airports. Follow Southwest's staff and crew, from the customer-focused flight crews to the hard-working ground crews who are often on the receiving end of a frustrated customer's wrath. America's fourth-largest carrier, Southwest Airlines promotes the concept of low-cost, no-frills travel and carries 65 million passengers every year.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-01-05",
  },
  {
    id: 2798,
    url: "https://www.tvmaze.com/shows/2798/oda-nobuna-no-yabou",
    name: "Oda Nobuna no Yabou",
    genres: ["Comedy", "Action", "Anime", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/15/37757.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/15/37757.jpg",
    },
    summary:
      '<p>Ordinary high schooler Yoshiharu gets pulled into a time slip to the warring states period. There he meets Nobuna Oda - not Nobunaga, Nobuna. In this world, all the famous warlords of the era are female. Nobuna recruits Sagara, who she dubs "Monkey," to help her in her quest to rule the world.</p>',
    officialSite: "http://odanobuna.com/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2012-07-09",
  },
  {
    id: 2806,
    url: "https://www.tvmaze.com/shows/2806/big-time-rv",
    name: "Big Time RV",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/127/319011.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/127/319011.jpg",
    },
    summary:
      "<p>On <b>Big Time RV</b>, RV experts at America's largest and most prestigious RV dealership assist RV lovers looking to buy or rent the biggest, most over-the-top RVs.</p>",
    officialSite: "http://www.travelchannel.com/shows/big-time-rv",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 82,
      name: "Travel Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-27",
  },
  {
    id: 2813,
    url: "https://www.tvmaze.com/shows/2813/36-hours",
    name: "36 Hours",
    genres: ["Food", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/64/160255.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/64/160255.jpg",
    },
    summary:
      "<p>In each 1-hour episode of <b>36 Hours</b>, co-hosts Kristen Kish and Kyle Martino arrive in a new city, where they'll have 36 Hours to explore the most delicious foods and hot spots, meet fascinating local insiders and experience the best attractions unique to each destination. Their itineraries will be informed by New York Times editors and contributors, who bring extensive research and expertise to each locale. Each episode will be timed to coincide with new or updated New York Times 36 Hours newspaper columns. There also will be companion editorial and video content across platforms on NYTimes.com and Travel Channel digital properties.</p>",
    officialSite:
      "http://www.travelchannel.com/shows/whats-new-on-travel-channel/articles/coming-soon-36-hours",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 82,
      name: "Travel Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-17",
  },
  {
    id: 2815,
    url: "https://www.tvmaze.com/shows/2815/dirty-great-machines",
    name: "Dirty Great Machines",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/15/38131.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/15/38131.jpg",
    },
    summary:
      "<p><b>Dirty Great Machines</b> introduces us to the might of the biggest, most awe-inspiring and technologically advanced drilling, excavation and tunnelling equipment known to man. Across the four episodes we document some of the most mind-blowing machines ever created and explore how they work. From bucket wheel excavators to monster maritime machines and mighty drills, witness these incredible pieces of equipment in action as they take on some of the world's most challenging engineering projects. In the first episode, get up close and personal with diggers burrowing below the world's cities - a massive boring machine facing the challenge of excavating Britain's deepest-ever tunnel in London and a giant mechanical worm making the earth move just metres beneath Mexico's soaring skyscrapers.</p>",
    officialSite:
      "http://press.discovery.com/emea/dsc/programs/dirty-great-machines/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 77,
      name: "Science",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-03",
  },
  {
    id: 2855,
    url: "https://www.tvmaze.com/shows/2855/wwe-ppv-on-wwe-network",
    name: "WWE PPV on WWE Network",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/114/285019.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/114/285019.jpg",
    },
    summary:
      "<p>Beginning with the 2014 Extreme Rules Pay-Per-View on 4 May 2014 the WWE began airing all of their Wrestling Pay-Per-Views exclusively on the WWE Network. Subscribers who pay the $9.95 monthly fee will be able to view any Pay-Per-Views past, present and in the future exclusively on the WWE Network at no additional charge as long as their monthly fees are paid up-to-date.</p>",
    officialSite: "http://www.wwe.com/events",
    webChannel: {
      id: 347,
      name: "Peacock",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Running",
    network: null,
    premiered: "1985-03-31",
  },
  {
    id: 2856,
    url: "https://www.tvmaze.com/shows/2856/nowhere-to-hide",
    name: "Nowhere to Hide",
    genres: ["Drama", "Crime", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/138/345211.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/138/345211.jpg",
    },
    summary:
      "<p>Investigation Discovery's compelling new crime and justice series <b>Nowhere to Hide</b> follows New York City private investigator extraordinaire, Steven Rambam, as he recounts the most dramatic stories from his extensive casebook. Just when criminals think they have escaped the long arm of the law, the world-renowned PI finds them and brings them to justice. Driven by his determination to uncover the truth, Rambam will stop at nothing – from utilizing the help of legendary rock band KISS to capture a charlatan who left his wife destitute, to solving the mystery of the Infamous ‘Prince of Austria' by surrendering to his own arrest!</p>",
    officialSite:
      "http://www.investigationdiscovery.com/tv-shows/nowhere-to-hide/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-08-04",
  },
  {
    id: 2861,
    url: "https://www.tvmaze.com/shows/2861/marks-no-yama",
    name: "Marks no Yama",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/15/38908.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/15/38908.jpg",
    },
    summary:
      "<p>20 years ago a half-frozen boy was rescuded in the mountains after his parents apparent sucide. He gets released from a mental institution and his girlfriend notices him talking about a dark mountain shadow. Meanwhile a murder happens in a residential area in Tokyo. Assistant Inspector Goda Yuichiro takes on the investigation. Soon an official of the Ministery of Justice gets murdered in a similar fashion pointing towards a serial killer. Yet, Goda receives a strange order from above: he's not to further investigate in this direction. He senses a huge mystery behind the case and starts chasing after the psychopath killer called Marks. Somehow a journalist's research about a corrupt construction magnate and another unsolved murder that happend in the mountains 13 years ago are also linked to the case.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 158,
      name: "WOWOW",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2010-10-17",
  },
  {
    id: 2867,
    url: "https://www.tvmaze.com/shows/2867/ed-stafford-into-the-unknown",
    name: "Ed Stafford: Into the Unknown",
    genres: ["Adventure", "Mystery", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/125/313366.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/125/313366.jpg",
    },
    summary:
      "<p><b>Ed Stafford: Into the Unknown</b> sees Ed on a mission to investigate the planet's newest mysteries. With photographs of Earth from the International Space Station and spy satellites showing strange and unexplained markings in some some of the most remote and inaccessible places on the planet, Ed will set out to find the target, and solve the riddle. From investigating gigantic white lines popping up on satellite images in remote West Papua to a strange pattern of circular dots in the middle of the Danakil Desert, Each astonishing image captures something hard to classify, previously unseen or anomalous. Ed will call on all of his expertise in extreme terrain and climate to uncover the truth.</p>",
    officialSite:
      "http://www.discoveryuk.com/shows/ed-stafford-into-the-unknown/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 143,
      name: "Discovery Channel",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-08-27",
  },
  {
    id: 2871,
    url: "https://www.tvmaze.com/shows/2871/ace-of-diamond",
    name: "Ace of Diamond",
    genres: ["Drama", "Anime", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/15/39518.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/15/39518.jpg",
    },
    summary:
      "<p>A meeting with catcher Kazuya Miyuki changed the 15-year-old Eijun Sawamura's life. He said goodbye to all his friends and knocked upon the door of Seidou, a prestigious baseball school, intent on testing his own strength. There, he met many proud baseball players who were betting everything on the sport! A classic tale, yet new and fresh.</p>",
    officialSite: "http://diaace.com/",
    webChannel: null,
    language: "Japanese",
    status: "To Be Determined",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2013-10-06",
  },
  {
    id: 2873,
    url: "https://www.tvmaze.com/shows/2873/trair-e-cocar-e-so-comecar",
    name: "Trair e Coçar é Só Começar",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/15/39521.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/15/39521.jpg",
    },
    summary:
      '<p>Success in the theater for over 30 years, "Betray And Scratching is Only Getting" comes to TV in the new series of Brazilian television Multishow. With the play script creator, Marcos Caruso, the series tells the story of bumbling maid Olímpia (Cacau Protásio) who is forced to be divided between his two newly separated bosses, Inês (Marcia Cabrita) and Eduardo (Cássio Scapin) . Decide to unite the couple, she will prepare several confusions with the help of Lígia (Dani Valente), Cristiano (Marcelo Flores), Zilda (Gorete Miracles) and Joel (Vinícius Marins).</p>',
    officialSite: null,
    webChannel: null,
    language: "Portuguese",
    status: "Running",
    network: {
      id: 282,
      name: "Multishow",
      country: { name: "Brazil", code: "BR", timezone: "America/Noronha" },
    },
    premiered: "2014-11-24",
  },
  {
    id: 2876,
    url: "https://www.tvmaze.com/shows/2876/the-fighting-season",
    name: "The Fighting Season",
    genres: ["War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/15/39531.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/15/39531.jpg",
    },
    summary:
      "<p><b>The Fighting Season</b> is a docuseries about the war in Afghanistan produced by Ricky Schroder Productions.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 31,
      name: "Audience Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-19",
  },
  {
    id: 2881,
    url: "https://www.tvmaze.com/shows/2881/basketball-wives-la",
    name: "Basketball Wives LA",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/15/39590.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/15/39590.jpg",
    },
    summary:
      "<p>VH1's hit series <b>Basketball Wives: LA</b> is back for an explosive fourth season. Returning from last season are Draya Michele, Malaysia Pargo, Brandi Maxiell, and Jackie Christie. With Queen Bee and Executive Producer, Shaunie O'Neal, joining the LA crew, and the addition of three new ladies, the bar is set for a very exciting season. Jackie brings in friend and basketball girlfriend, Mehgan James. Also joining the clique are wife of player Eddy Curry and Malaysia's friend, Patrice Curry, and Draya's friend, fashion designer and ex- girlfriend of Tyreke Evens, Angel Brinks. Between the new personalities, major life challenges, and old resentments, sparks will fly. Shaunie O'Neal joins the LA ladies for some West coast fun but soon realizes that they are a very challenging group. When her old time East coast buddy, Tami Roman, joins the cast, the Basketball Wives: Miami / LA cast divide is set in stone.</p>",
    officialSite: "http://www.vh1.com/shows/basketball-wives-la",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 55,
      name: "VH1",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-08-29",
  },
  {
    id: 2883,
    url: "https://www.tvmaze.com/shows/2883/married-to-medicine",
    name: "Married to Medicine",
    genres: ["Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/15/39592.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/15/39592.jpg",
    },
    summary:
      "<p>On <b>Married to Medicine</b>, the ladies of Atlanta's exclusive medical inner circle Dr. Jacqueline Walters, Dr. Simone Whitmore, Dr. Heavenly Kimes, Toya Bush-Harris, Quad Webb-Lunceford and Lisa Nicole Cloud return with more patients, less patience and a few heart palpitations along the way.</p>",
    officialSite: "http://www.bravotv.com/married-to-medicine",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-03-24",
  },
  {
    id: 2886,
    url: "https://www.tvmaze.com/shows/2886/dont-be-tardy",
    name: "Don't Be Tardy...",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/205/513186.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/205/513186.jpg",
    },
    summary:
      "<p><b>Don't Be Tardy...</b> follows Kim and Kroy Biermann as their family grows bigger and new problems arise every day.</p>",
    officialSite: "http://www.bravotv.com/dont-be-tardy",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-04-26",
  },
  {
    id: 2891,
    url: "https://www.tvmaze.com/shows/2891/black-sheep-squadron",
    name: "Black Sheep Squadron",
    genres: ["Drama", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/15/39722.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/15/39722.jpg",
    },
    summary:
      "<p>In World War II Marine Corps Major Greg 'Pappy' Boyington commanded a squadron of fighter pilots. They were a collection of misfits and screwballs who became the terrors of the South Pacific. They were known as the Black Sheep.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1976-09-21",
  },
  {
    id: 2896,
    url: "https://www.tvmaze.com/shows/2896/de-enclave",
    name: "De Enclave",
    genres: ["Drama", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/15/39745.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/15/39745.jpg",
    },
    summary:
      "<p>Three-part drama series about the role the war of Srebrenica and the fall of the enclave plays in the lives of three people eight years later, who were involved in the war: Dutchbattolk Ibro Hadzic, Darko Bokan sergeant of the Bosnian Serb army, who are on trial in front of the Yugoslavia war crimes tribunal, and the late Defense Minister George Terhoef.</p>",
    officialSite: null,
    webChannel: null,
    language: "Dutch",
    status: "Ended",
    network: {
      id: 1020,
      name: "NPO 3",
      country: {
        name: "Netherlands",
        code: "NL",
        timezone: "Europe/Amsterdam",
      },
    },
    premiered: "2002-04-14",
  },
  {
    id: 2904,
    url: "https://www.tvmaze.com/shows/2904/wheeler-dealers-trading-up",
    name: "Wheeler Dealers: Trading Up",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/15/39764.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/15/39764.jpg",
    },
    summary:
      "<p>Mike Brewer is the ultimate motoring wheeler dealer and now he is travelling all over the world, from India to Poland, to prove his credentials internationally. With just $3,000 in used notes in his back pocket, Mike's mission is to trade his way across the globe from a cheap runabout to a super car. It's the car trade journey of a lifetime, over 85,000 miles - and it's also a journey that's not just about car trading, but about car culture as Mike explores the strange and crazy things different nations get up to on their wheels. In the first episode Mike heads to India, which has one of the fastest growing car markets in the world. Mike gets hit with a massive culture shock, but he is determined to find the best deals in town.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 143,
      name: "Discovery Channel",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-04-02",
  },
  {
    id: 2910,
    url: "https://www.tvmaze.com/shows/2910/free-agents",
    name: "Free Agents",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/15/39810.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/15/39810.jpg",
    },
    summary:
      "<p>This new six-part comedy stars Stephen Mangan, Sharon Horgan and Anthony Head.</p><p>Alex is a talent agent suffering the emotional fall-out from his divorce. Helen, his fellow agent, has the office next to him and is also in pain; overcome with grief from a recent bereavement. Deluded Alex believes they are perfect for one another. Helen thinks quite the opposite. Yes she's slept with him – twice – but there is absolutely no way she is doing it again...</p><p>Free Agents depicts a world in which the agents' boss, their clients, friends, relatives, accountants and even ex-girlfriends are as bizarrely dysfunctional as Alex and Helen themselves. This is a comedy about an on-(mostly)-off, romance between two people who might just have a positive future together if they can shake off their pasts.</p>",
    officialSite: "http://www.channel4.com/programmes/free-agents",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-02-13",
  },
  {
    id: 2915,
    url: "https://www.tvmaze.com/shows/2915/motorhead-garage",
    name: "Motorhead Garage",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/15/39914.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/15/39914.jpg",
    },
    summary:
      "<p>The most widely repsected, and original stars of 'how-to mechanic TV,'' Sam Memmolo and Dave Bowman, formerly of Two Guys Garage, Shade Tree Mechanic, and Crank and Chrome, are the hosts of the <i><b>\"Motorhead Garage\"</b></i> weekly series. All rides are represented throughout. You will see amazing installations in Sam and Dave's garage, and as they take their skills on-location visiting companies nationwide, and Canada. The format is the top platform for Industry Innovators to be represented in front of more viewers at one time, than any other media. Each episode goes in-depth with industry pros, focusing on all types of rides, including 'reefers', hot rods, off road, and race cars. Each segment tailors specifically to one, or more important industry aspect, including latest innovations, specialty parts, motors, anything to do with mechanics, extreme outfitting, vehicle electronics, aftermarket cosmetics, and accessories. Sam and Dave go hands-on turning wrenches along with each specialist who visits their Motorhead Garage!</p>",
    officialSite: "http://www.velocity.com/tv-shows/motorhead-garage/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 142,
      name: "MotorTrend",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-07-02",
  },
  {
    id: 2916,
    url: "https://www.tvmaze.com/shows/2916/car-warriors",
    name: "Car Warriors",
    genres: ["Drama", "Action", "DIY"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/15/39919.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/15/39919.jpg",
    },
    summary:
      "<p>Two teams, two cars, 72 hours. That's the basic premise for a new action-packed custom-car competition, <b>Car Warriors</b>, that brings the highest levels of automotive expertise together for a non-stop battle of artistry and craftsmanship. <br><br>Each episode of Car Warriors lets viewers witness the fast-forward creation of custom performance cars by two eight-member teams of top-notch professionals – the Car Warriors All Stars vs. a variety of challenger teams – who take their projects from stripped-down shells to high-performance works of art. <br><br>But there's a catch: each team has just 72 hours from the time they first lay eyes on the primered bodies until they roll out their beautiful custom cars that are ready for judging. That's 72 hours of round-the-clock, high-pressure car building.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 284,
      name: "Speed TV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-02-23",
  },
  {
    id: 2928,
    url: "https://www.tvmaze.com/shows/2928/mockpocalypse",
    name: "MOCKpocalypse",
    genres: ["Comedy", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/16/40028.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/16/40028.jpg",
    },
    summary:
      "<p>Making its debut in AXS TV's Thursday night comedy lineup is the half-hour comedic panel series, <b>MOCKpocalypse</b>. This series features a panel of today's top comedians who provide their own humorous takes on the hottest topics and trends in the music industry. The series is the brainchild of acclaimed comedy quintet Dr. God, and is executive-produced by Dr. God founders Neil Garguilo and Dave Park.</p>",
    officialSite: "http://www.axs.tv/programs/mockpocalypse/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 170,
      name: "AXS TV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-06-12",
  },
  {
    id: 2929,
    url: "https://www.tvmaze.com/shows/2929/rock-legends",
    name: "Rock Legends",
    genres: ["Music", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/16/40029.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/16/40029.jpg",
    },
    summary:
      "<p>Each 30-minute episode of <b>Rock Legends</b> focuses on one legendary act, examining the story of their lives and the impact they made on popular culture through in-depth interviews, archival footage, and live performances.</p>",
    officialSite: "http://www.axs.tv/programs/rock-legends/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 170,
      name: "AXS TV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-06-03",
  },
  {
    id: 2930,
    url: "https://www.tvmaze.com/shows/2930/hey-rookie-welcome-to-the-nfl",
    name: "Hey Rookie, Welcome to the NFL",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/16/40030.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/16/40030.jpg",
    },
    summary:
      '<p><b>Hey Rookie, Welcome to the NFL </b>each year will track first-year pro football players known as "Rookies" through the previous year\'s season.</p>',
    officialSite:
      "http://espn.go.com/watchespn/index/_/id/1105781/hey-rookie-welcome-nfl-part-i",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 39,
      name: "ESPN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-09-06",
  },
  {
    id: 2932,
    url: "https://www.tvmaze.com/shows/2932/say-yes-to-the-dress",
    name: "Say Yes to the Dress",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/320/800038.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/320/800038.jpg",
    },
    summary:
      '<p><b>Say Yes to the Dress</b> delves into the heart of world famous Kleinfeld Bridal where the staff face immense pressure to help each bride find the dress if her dreams. Take a peak at the brides as they try on their dream dresses! The show brings us up close and into the dressing room as brides prepare for their big day. Moms, bridemaids and friends all express their opinions and often frustrate both bride and staff. In the end though, most brides find that "dream dress" and walk down with their grooms into wedded bliss.</p>',
    officialSite: "https://www.tlc.com/tv-shows/say-yes-to-the-dress/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-10-12",
  },
  {
    id: 2933,
    url: "https://www.tvmaze.com/shows/2933/say-yes-to-the-dress-atlanta",
    name: "Say Yes to the Dress: Atlanta",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/16/40170.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/16/40170.jpg",
    },
    summary:
      "<p><b>Say Yes to the Dress: Atlanta </b>is a weekly half hour series that takes viewers inside Bridals by Lori - Atlanta's biggest and best bridal boutique. Owner Lori Allen is considered one of the country's leading experts on bridal wear. Designers often call on her as they are putting their lines together to get her input on what brides are looking for. Lori spends much of her time out on the floor working with the brides. She also prides herself on having the most informed sales consultants in the business.</p>",
    officialSite: "https://www.tlc.com/tv-shows/say-yes-to-the-dress-atlanta/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-07-30",
  },
  {
    id: 2938,
    url: "https://www.tvmaze.com/shows/2938/super-high-roller-bowl",
    name: "Super High Roller Bowl",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/16/40189.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/16/40189.jpg",
    },
    summary:
      '<p>Fans of high stakes poker action will want to mark their calendars for the debut broadcast of the <b>Super High Roller Bowl</b> this Friday, August 28 at 8:00 p.m. ET on NBCSN. The event features 43 of the world\'s top poker players who each paid an entry fee of $500,000 to create a prize pool of more than $21 million. Payouts went to the top seven finishers, with the champion receiving a whopping $7,525,000. In fact, the top six finishers all grabbed a million-dollar payday. The only in-the-money player not to win seven figures was 7th place, who had to settle for $860,000 – a profit of "only" $360,000.</p>',
    officialSite: "https://www.superhighroller.com/tv-schedule",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 272,
      name: "CBS Sports Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-28",
  },
  {
    id: 2942,
    url: "https://www.tvmaze.com/shows/2942/childhoods-end",
    name: "Childhood's End",
    genres: ["Drama", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/31/78541.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/31/78541.jpg",
    },
    summary:
      '<p>Written by Arthur C. Clarke and hailed as a revolutionary work of science fiction since its publishing in 1953, <b>Childhood\'s End </b>follows the peaceful alien invasion of Earth by the mysterious "Overlords," whose arrival begins decades of apparent utopia under indirect alien rule, at the cost of human identity and culture.</p>',
    officialSite: "http://www.syfy.com/childhoodsend",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-12-14",
  },
  {
    id: 2946,
    url: "https://www.tvmaze.com/shows/2946/say-it-to-my-face",
    name: "Say It to My Face",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/171/429555.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/171/429555.jpg",
    },
    summary:
      "<p>Never before have faceless online critics had so much power over the success or failure of restaurants. A chef can be on their game 99% of the time, but one mistake with one disgruntled customer, and they're facing an uphill battle to get diners back through the doors. In <b>Say It to My Face!</b>, restaurants and critics meet face-to-face, for the first time, to air grievances. With the mentorship of chef co-hosts, Andrew Gruel and Anthony Dispensa, each owner and chef will make-over their restaurant. From the menu, to the décor and staffing – they will look to elevate their business in hopes that their toughest online critics will change their reviews, while helping to encourage new customers to come through the door.</p><p>With over 18 years in the culinary business, Andrew is the CEO and Founder of Slapfish Restaurant Group, and Anthony is the West Coast Director of Operations for the restaurant group. A proponent in the power of social media when it comes to food and dining, Andrew personally responds to negative online reviews for his own restaurant business. From first-hand experience, Andrew and Anthony will help owners and chefs learn that listening to customer's criticism, while having an open mind, will prove to be beneficial in salvaging a restaurant's reputation before it's too late.</p>",
    officialSite: "http://www.fyi.tv/shows/say-it-to-my-face",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 125,
      name: "FYI,",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-09",
  },
  {
    id: 2948,
    url: "https://www.tvmaze.com/shows/2948/you-me-and-the-apocalypse",
    name: "You, Me and the Apocalypse",
    genres: ["Drama", "Comedy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/29/73997.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/29/73997.jpg",
    },
    summary:
      "<p><b>You, Me and the Apocalypse</b> is a bold, adrenaline-fuelled comedy drama about the last days of mankind - boasting a relentlessly entertaining mix of action, adventure, romance and wit set against a backdrop of apocalyptic chaos. The story follows an eclectic group of seemingly unconnected characters around the world as their lives start to intersect in the most unexpected ways. All triggered by the news that a comet is on an unavoidable collision course towards earth. And when we say 'eclectic', we specifically mean, a rebellious priest, an unhinged white supremacist, a mild mannered bank manager, a germ-phobic cyber-terrorist, an American 5 star general and a child who (possibly) rose from the dead. Some of the above are destined to make it to a bunker deep beneath the suburbs of Slough, and as a result will become the hugely unlikely (and frankly, somewhat unsuitable) future of mankind.</p>",
    officialSite:
      "http://go.sky.com/tvboxsets/series/content/series/74bced9b7a200510VgnVCM1000000b43150a____",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 63,
      name: "Sky 1",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-09-30",
  },
  {
    id: 2949,
    url: "https://www.tvmaze.com/shows/2949/amazing-spaces-shed-of-the-year",
    name: "Amazing Spaces Shed of the Year",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/16/40348.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/16/40348.jpg",
    },
    summary:
      "<p>George Clarke discovers what is really happening in the Great British shed with the Shed of the Year competition - from an intricate shell grotto inside a war bunker to a disco shed that plays the biggest festivals in the country. There's also a Dad's Army enthusiast who's built an entire museum full of memorabilia and a man who's converted his shed into a 1970s amusement arcade. George travels the length and breadth of the British Isles with his Amazing Spaces team of master craftsman Will Hardie, designer Max McMurdo and architect Laura Jane Clarke. At the end of the series the very best design will be crowned Shed of the Year. The competition is split into categories - Unique, Normal, Eco, Cabin &amp; Summerhouse, Workshop &amp; Studio, Garden Office, Pub and Tardis. The competition was dreamed up by Andrew Wilcox, who set up the readersheds website that hosts the competition that...</p>",
    officialSite:
      "http://www.channel4.com/programmes/amazing-spaces-shed-of-the-year",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-07-24",
  },
  {
    id: 2950,
    url: "https://www.tvmaze.com/shows/2950/the-great-british-bake-off",
    name: "The Great British Bake Off",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/273/682879.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/273/682879.jpg",
    },
    summary:
      "<p>Over 10 weeks, 12 of the best amateur bakers in Britain will whisk, knead, ice, beat and bake their way through classic British cakes, perfect patisserie, Italian delights, sticky caramel constructions and elaborate layered puddings. All 12 will be hoping to impress with their skill, creativity, knowledge and passion to clinch the Bake Off Crown. Each of the 30 new challenges have been carefully designed by judges Paul Hollywood and Prue Leith to reveal just who is a star baker. But it's not just a new experience for the bakers. Also joining the tent for the first time are Sandi Toksvig and Noel Fielding, who will be with the bakers every step of the way, ready with a pertinent pep talk, a helpful hand or just a sympathetic shoulder to cry on.</p>",
    officialSite:
      "https://www.channel4.com/programmes/the-great-british-bake-off",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-08-17",
  },
  {
    id: 2951,
    url: "https://www.tvmaze.com/shows/2951/the-great-british-bake-off-an-extra-slice",
    name: "The Great British Bake Off: An Extra Slice",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/273/682885.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/273/682885.jpg",
    },
    summary:
      "<p>Jo Brand is joined by three different Celebrity Bake Off fans to shine a spotlight on the good, the bad and the soggy bottomed from the most recent episode.</p>",
    officialSite:
      "https://www.channel4.com/programmes/the-great-british-bake-off-an-extra-slice",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-08-08",
  },
  {
    id: 2952,
    url: "https://www.tvmaze.com/shows/2952/gadget-man",
    name: "Gadget Man",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/16/40355.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/16/40355.jpg",
    },
    summary:
      "<p><b>Gadget Man</b> shows the world's collection of handy gadgets throughout the ages, from today's smart devices to decades old electronics to even older mechanical devices. Stephen Fry presented Series One, with Richard Ayoade taking over for Series Two onward.</p>",
    officialSite: "http://www.channel4.com/programmes/gadget-man",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-11-19",
  },
  {
    id: 2953,
    url: "https://www.tvmaze.com/shows/2953/dragons-den",
    name: "Dragons' Den",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/232/581100.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/232/581100.jpg",
    },
    summary:
      "<p>Series in which budding entrepreneurs get three minutes to pitch their business ideas to five multi-millionaires willing to invest their own cash.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006vq92",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2005-01-04",
  },
  {
    id: 2955,
    url: "https://www.tvmaze.com/shows/2955/taskmaster",
    name: "Taskmaster",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/16/40368.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/16/40368.jpg",
    },
    summary:
      "<p>Greg Davies is the <b>Taskmaster</b>, and with the help of his ever-loyal assistant Alex Horne, they will set out to test the wiles, wit, wisdom and skills of fivecelebrity contestants. At the end of the series, who will be crowned the Taskmaster champion?</p>",
    officialSite: "https://www.channel4.com/programmes/taskmaster",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-07-28",
  },
  {
    id: 2957,
    url: "https://www.tvmaze.com/shows/2957/would-i-lie-to-you",
    name: "Would I Lie to You?",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/16/40370.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/16/40370.jpg",
    },
    summary:
      '<p>A comedic panel show featuring team captains Lee Mack and David Mitchell plus two guests per side, hosted by Rob Brydon (formerly Angus Deayton). Each person must reveal embarrassing facts and outrageous lies during a series of different rounds including "Ring of Truth", "This is My..." and "Quickfire Lies". It is up to the opposing team to tell tall tales from fantastic facts.</p>',
    officialSite: "http://www.bbc.co.uk/programmes/b007r3n8",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2007-06-16",
  },
  {
    id: 2964,
    url: "https://www.tvmaze.com/shows/2964/britains-got-talent",
    name: "Britain's Got Talent",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/190/475429.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/190/475429.jpg",
    },
    summary:
      "<p>The search for the next big variety act in the UK is on with ITV's <b>Britain's Got Talent</b>. Popular comedians and hosts Ant and Dec join the judges Simon Cowell, David Williams, Alesha Dixon and Amanda Holden on this highly anticipated show that will culminate in not only a big cash prize of £100,000 for the winning act, but also a starring slot in a performance attended by Her Majesty the Queen.</p>",
    officialSite: "http://www.itv.com/britainsgottalent",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2007-06-09",
  },
  {
    id: 2969,
    url: "https://www.tvmaze.com/shows/2969/big-school",
    name: "Big School",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/16/40402.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/16/40402.jpg",
    },
    summary:
      "<p>Set in an urban secondary school, <b>Big School</b> is a comedy about a dysfunctional staff room, unrequited love and interactive white boards.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b04g6pq3",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-08-16",
  },
  {
    id: 2972,
    url: "https://www.tvmaze.com/shows/2972/genius",
    name: "Genius",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/16/40414.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/16/40414.jpg",
    },
    summary:
      "<p>Comedy series where Dave Gorman and celebrity guests chew over the ridiculous, unworkable but sometimes genius inventions, schemes and policies pitched by members of the public.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00vc3rz",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-03-20",
  },
  {
    id: 2974,
    url: "https://www.tvmaze.com/shows/2974/tamiou",
    name: "Tamiou",
    genres: ["Drama", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/16/40417.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/16/40417.jpg",
    },
    summary:
      "<p>One day, the current prime minister of Japan, Muto Taizan, and his useless son, Sho, suddenly discover that they have switched bodies. With no known cause or solution at hand, Sho reluctantly ends up appearing in the Diet on his father's behalf. But he completely cannot follow the deliberations as well as the questions and answers because it has been his routine to skip his studies. He is also repeatedly caught making childish responses or misreading kanji in documents. However, untainted by the adult world, Sho's straightforward opinions and genuine feelings start to mobilise the Diet and the public. On the other hand, Taizan has to lead the life of a university student and search for a job on behalf of his son, but with the brains of a prime minister. He refutes arrogant interviewers with his overwhelming knowledge and debating skills. Although Taizan wins the war of words, he is an absolute failure in the interviews itself. Furthermore, several peculiar girls whom Sho has had relationships with appear and makes Taizan more bewildered</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 263,
      name: "TV Asahi",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2015-07-24",
  },
  {
    id: 2982,
    url: "https://www.tvmaze.com/shows/2982/saigon-lete-de-nos-20-ans",
    name: "Saïgon, l'été de nos 20 ans",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/281/703892.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/281/703892.jpg",
    },
    summary: null,
    officialSite: null,
    webChannel: null,
    language: "French",
    status: "Ended",
    network: {
      id: 249,
      name: "France 3",
      country: { name: "France", code: "FR", timezone: "Europe/Paris" },
    },
    premiered: "2011-12-17",
  },
  {
    id: 2983,
    url: "https://www.tvmaze.com/shows/2983/robsons-extreme-fishing-challenge",
    name: "Robson's Extreme Fishing Challenge",
    genres: ["Adventure", "Travel", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/16/40486.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/16/40486.jpg",
    },
    summary:
      "<p><b>Robson's Extreme Fishing Challenge</b> follows Robson Green as he undertakes a round-the-world trip to experience some of the most extreme fishing destinations. Each week he also challenges local experts to five rounds of angling to see who can catch the biggest fish.</p>",
    officialSite:
      "http://www.channel5.com/shows/robsons-extreme-fishing-challenge",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 135,
      name: "Channel 5",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-04-09",
  },
  {
    id: 2985,
    url: "https://www.tvmaze.com/shows/2985/giada-in-italy",
    name: "Giada in Italy",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/205/513453.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/205/513453.jpg",
    },
    summary:
      "<p>In <b>Giada in Italy</b> follow Giada De Laurentiis back to her birthplace for an extended holiday, as she revisits family, friends and the flavors that inspire her life's work. Whether digging into her grandmother's ancient recipe book with Aunt Raffy, exploring the site of her grandfather's former pasta factory, inspiring her to make homemade noodles \"the old fashioned way,\" or cheering on and then making a California-inspired feast for her uncle's soccer team, this trip is all about the bounty and beauty of Italy, enjoyed with friends and family.</p>",
    officialSite: "http://www.foodnetwork.com/shows/giada-in-italy.html",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 81,
      name: "Food Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-19",
  },
  {
    id: 2997,
    url: "https://www.tvmaze.com/shows/2997/the-voice-of-holland",
    name: "The Voice of Holland",
    genres: ["Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/16/41040.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/16/41040.jpg",
    },
    summary:
      "<p><b>The Voice of Holland</b> is a Dutch reality singing competition hosted by Martijn Krabbé and Wendy van Dijk. One of the important premises of the show is the quality of the singing talent. Four coaches, themselves popular performing artists, train the talents in their group and occasionally perform with them. Talents are selected in blind auditions, where the coaches cannot see, but can only hear the talents. The show's music is provided by a live band: the Edwin Evers Band.</p>",
    officialSite: null,
    webChannel: null,
    language: "Dutch",
    status: "Running",
    network: {
      id: 112,
      name: "RTL4",
      country: {
        name: "Netherlands",
        code: "NL",
        timezone: "Europe/Amsterdam",
      },
    },
    premiered: "2010-09-17",
  },
  {
    id: 2998,
    url: "https://www.tvmaze.com/shows/2998/the-dance-in-the-sky",
    name: "The Dance in the Sky",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/61/153154.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/61/153154.jpg",
    },
    summary:
      "<p>This drama will depict a serious love story. These days love is taken for granted and the purity of love is often secondary on the list. However, for anyone that has experienced true love they will understand the depths and to-the-core experience love can bring. Some will risk their lives, while others will walk away… The Dance In The Sky revolves around the story of love and revenge between four characters. Some will undergo great sacrifice for their love, some will fight to the death, and some will seek revenge.</p>",
    officialSite: "http://tv.sbs.co.kr/bichunmu/",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 127,
      name: "SBS",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2008-02-01",
  },
  {
    id: 3006,
    url: "https://www.tvmaze.com/shows/3006/snuf-de-hond",
    name: "Snuf de Hond",
    genres: ["Drama", "Adventure", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/16/41217.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/16/41217.jpg",
    },
    summary:
      "<p>The series begins during the Second World War as the Netherlands is struggling under the German occupation and Tom takes care of Snuf, a German shepherd. The dog is being directed by the mysterious Haaksma. And it is thanks to this training expertise Snuf is able to save his boss and his friends from many adventures.</p>",
    officialSite: "http://www.eo.nl/archief/tv/snufdehond/",
    webChannel: null,
    language: "Dutch",
    status: "Ended",
    network: {
      id: 1020,
      name: "NPO 3",
      country: {
        name: "Netherlands",
        code: "NL",
        timezone: "Europe/Amsterdam",
      },
    },
    premiered: "2008-10-11",
  },
  {
    id: 3010,
    url: "https://www.tvmaze.com/shows/3010/in-their-own-words",
    name: "In Their Own Words",
    genres: ["Drama", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755386.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755386.jpg",
    },
    summary:
      "<p><b>In Their Own Words</b> is a unique and stylish new biography series that explores an elite few of the 20th century's greatest figures. The inaugural season features episodes on a diverse trio of extraordinary subjects: three-time World Heavyweight Champion boxer Muhammad Ali, Muppets creator Jim Henson and Britain's long-reigning monarch Queen Elizabeth II.</p><p>Each chapter in these artfully crafted biographies is inspired and marked by some of the most memorable words spoken by these world icons: words that describe the subject creatively and intimately. These memorable quotes keynote the storytelling, as each sequence sheds new light on key moments in our subjects' lives — illuminating their fascinating personalities and spotlighting their profound cultural and historical impact for a new generation of television viewers. Stylized, evocative recreations of significant moments in the subjects' lives add texture to the visual storytelling and also serve as background for some of the featured quotes.</p><p>This non-linear approach to the top of each episode alerts veiwers to the fact that <i>In Their Own Words</i> is a biography series unlike anything they've seen. The majority of the narrative is carried by deeply personal interviews with those who know the subjects intimately: family, co-workers, colleagues, biographers, etc.</p>",
    officialSite: "http://www.pbs.org/program/in-their-own-words/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 85,
      name: "PBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-01",
  },
  {
    id: 3012,
    url: "https://www.tvmaze.com/shows/3012/drurys-thirteen",
    name: "Drury's THIRTEEN",
    genres: ["Action", "Adventure", "Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/16/41312.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/16/41312.jpg",
    },
    summary:
      "<p>What does it take to produce <b>Drury's THIRTEEN</b> original episodes for Outdoor Channel? The yearlong commitment, preparation, sweat equity involved in really doing it right. All while respecting the animal that we chase and cherish so much! This all new venture protected by Under Armour pits Man vs. Mother Nature, Drury's vs Deer in a season long knock down drag out battle royal. We wrote the script....but Mother Nature RIPPED it apart!! EHD, drought, moon phase, high temps, nocturnal deer movement...you name it....she threw out everything but the kitchen sink trying to stop us from our objective. The tips, the tactics, the information, is at an all-time high in this new series chronicling Mark &amp; Terry Drury's season long quest for those mature whitetails that we think about 24/7 - 365. They break it down to Drury's THIRTEEN phases of the deer season....but it was the season that literally drove Drury Outdoors to the brink! With a little help from a cast of characters like Matt &amp; Taylor Drury, Jim Thome &amp; Gary LeVox you'll follow the ups and downs of Drury's THIRTEEN!</p>",
    officialSite: "http://outdoorchannel.com/drurys-thirteen",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 207,
      name: "Outdoor Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-01",
  },
  {
    id: 3020,
    url: "https://www.tvmaze.com/shows/3020/suspicion",
    name: "Suspicion",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/43860.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/43860.jpg",
    },
    summary:
      "<p>It's human nature to question things - especially when your safety may be at risk - but when a grim suspicion turns into a horrid reality, it may be time to take things into your own hands. Investigation Discovery's (ID) new series <b>Suspicion</b> reveals the terrifying journeys of real people who suspected imminent danger and became fixated on finding the truth. From stalkers to criminal cover-ups and killers on the loose, the stories in <i>Suspicion</i> start building suspense from the moment something feels amiss. Emotional first-person interviews detail the endless twists and turns that come with following a dangerous hunch, leaving viewers anxious to learn who the culprit is until the very end. Did I really just see that? Will anyone believe me? Am I imagining things? Can I trust anyone? Nothing is as it seems and everyone is a suspect.</p>",
    officialSite: "http://www.investigationdiscovery.com/tv-shows/suspicion/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-02",
  },
  {
    id: 3022,
    url: "https://www.tvmaze.com/shows/3022/future-man",
    name: "Future Man",
    genres: ["Comedy", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/250/625130.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/250/625130.jpg",
    },
    summary:
      "<p><b>Future Man</b> chronicles a janitor by day, world-ranked gamer by night who is tasked with preventing the extinction of humans after mysterious visitors from the future declare him to be the key to defeating the imminent super-race invasion.</p>",
    officialSite: "https://www.hulu.com/future-man",
    webChannel: {
      id: 2,
      name: "Hulu",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2017-11-14",
  },
  {
    id: 3043,
    url: "https://www.tvmaze.com/shows/3043/death-by-gossip-with-wendy-williams",
    name: "Death by Gossip with Wendy Williams",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/46643.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/46643.jpg",
    },
    summary:
      "<p>Investigation Discovery proves that talk may be cheap, but gossip can be deadly with the greenlight of a new series <b>Death by Gossip with Wendy Williams</b>, with the Diva of Dish serving as host and executive producer. Premiering in the fall of 2015, idle chitchat turns dark and dangerous as ID uncovers crimes fueled by rumors and sordid half-truths that lead to the ultimate betrayal…murder.</p>",
    officialSite:
      "http://www.investigationdiscovery.com/tv-shows/death-by-gossip-with-wendy-williams/death-by-gossip-with-wendy-williams-videos/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-04",
  },
  {
    id: 3044,
    url: "https://www.tvmaze.com/shows/3044/hbd",
    name: "HBD",
    genres: ["Music"],
    image: null,
    summary:
      "<p><b>HBD</b> is a series of occasional specials during which Fuse celebrates the birthday of an iconic musical artist by showing a marathon of that singer's music videos. In the series premiere, Fuse aired two hours of the best Beyonce videos to celebrate her birthday.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 186,
      name: "FUSE TV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-04",
  },
  {
    id: 3052,
    url: "https://www.tvmaze.com/shows/3052/beasts-behaving-badly",
    name: "Beasts Behaving Badly",
    genres: ["Drama", "Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755392.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755392.jpg",
    },
    summary:
      '<p>What happens when the wild world and "real" world collide?</p><p><b>Beasts Behaving Badly</b> features the authentic stories behind the best clips of wild animals invading human spaces.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 176,
      name: "Discovery Family",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-16",
  },
  {
    id: 3075,
    url: "https://www.tvmaze.com/shows/3075/braindead",
    name: "BrainDead",
    genres: ["Drama", "Comedy", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/267/668787.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/267/668787.jpg",
    },
    summary:
      "<p><b>BrainDead </b>is a comic-thriller set in the world of Washington, D.C. politics that follows Laurel, a young, fresh-faced Hill staffer who discovers two things: the government has stopped working, and bugs are eating the brains of congress members and Hill staffers. The daughter of a Democratic political dynasty who left Washington, D.C. to become a documentary filmmaker, Laurel is pulled back into the family business when her brother, Luke, the Democratic whip Senator from Maryland, needs her help running his senate office. On the Hill, Laurel becomes unlikely friends with Gareth, the smart, hardworking Legislative Director to a top Republican, Senator Red Wheatus. Her other allies include Gustav, an eccentric genius who is the first in D.C. to recognize that something sinister is attacking the Capitol, and Rochelle, a medical student who teams up with Laurel and Gustav to protect and defend the citizens of D.C. from an untimely fate. As the tiny bugs continue to multiply, Laurel and her allies must work quickly to identify the other-worldly creatures, stop their infiltration and ultimately save the world.</p>",
    officialSite: "http://www.cbs.com/shows/braindead/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2016-06-13",
  },
  {
    id: 3082,
    url: "https://www.tvmaze.com/shows/3082/krypton",
    name: "Krypton",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/192/480621.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/192/480621.jpg",
    },
    summary:
      "<p>Set two generations before the destruction of Superman's home planet, <b>Krypton</b> follows Seg-El, the legendary Man of Steel's grandfather—whose House of El was ostracized and shamed. With Krypton's leadership in disarray, Seg-El encounters Earthly time-traveler Adam Strange who warns he's under the clock to save his beloved world from chaos. Fighting to redeem his family's honor and protect the ones he loves, Seg is also faced with a life and death conflict—save his home planet or let it be destroyed in order to restore the fate of his future grandson.</p>",
    officialSite: "http://www.syfy.com/krypton",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2018-03-21",
  },
  {
    id: 3088,
    url: "https://www.tvmaze.com/shows/3088/this-is-not-my-life",
    name: "This is Not My Life",
    genres: ["Drama", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/251/628523.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/251/628523.jpg",
    },
    summary:
      "<p>In the peaceful, leafy New Zealand suburb of Waimoana, a man wakes up in a lovely home, to his lovely wife and children. The only problem is that he can't remember anything. Not who he is, ever having a wife and kids, not even his own name. The people around him call him Alec Ross, but he only has their word for that. Setting out to discover what's going on, he stumbles upon the truth - this is not his life. Now he must try and unravel the mystery of Waimoana - and get out alive!</p>",
    officialSite:
      "http://tvnz.co.nz/this-is-not-my-life/not-my-life-index-group-3631491",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1031,
      name: "TVNZ 1",
      country: {
        name: "New Zealand",
        code: "NZ",
        timezone: "Pacific/Auckland",
      },
    },
    premiered: "2010-07-29",
  },
  {
    id: 3090,
    url: "https://www.tvmaze.com/shows/3090/jono-and-ben",
    name: "Jono And Ben",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/68/170727.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/68/170727.jpg",
    },
    summary:
      "<p>New Zealand's premiere comedy duo, Jono Pryor and Ben Boyce are again joined by award-winning comedian Guy Williams for the third series of TV3's Friday night hit comedy show, <b>Jono And Ben</b>.</p>",
    officialSite: "http://www.tv3.co.nz/Shows/JonoandBen/About.aspx",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 292,
      name: "Three",
      country: {
        name: "New Zealand",
        code: "NZ",
        timezone: "Pacific/Auckland",
      },
    },
    premiered: "2012-07-13",
  },
  {
    id: 3102,
    url: "https://www.tvmaze.com/shows/3102/spartan-race",
    name: "Spartan Race",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/24/60439.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/24/60439.jpg",
    },
    summary:
      "<p>Described as the ultimate in team competition, <b>Spartan Race</b> features friends, families and co-workers working together and pushing each other to their mental and physical limits as they race across specially designed Spartan courses engineered to test their determination, endurance, and will. Teams of five — comprised of two men, two women, and an elite Spartan athlete — will battle over mud, water, and fire for a chance to win a large cash prize.</p>",
    officialSite: "http://www.spartan.com/en/media/video",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-22",
  },
  {
    id: 3111,
    url: "https://www.tvmaze.com/shows/3111/adam-ruins-everything",
    name: "Adam Ruins Everything",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/22/56984.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/22/56984.jpg",
    },
    summary:
      "<p>In <b>Adam Ruins Everything</b>, host and investigative comedian Adam Conover embarks on a comically inventive yet unrelentingly serious quest to reveal the hidden truths behind everything you know and love. Tackling topics ranging from the workplace and voting to forensic science and security, he gives you not just fun facts to share with your friends, but information that will make you see the world in a whole new way. If knowledge is power, then Adam Conover will have you laughing all the way to the top.</p>",
    officialSite: "http://www.trutv.com/shows/adam-ruins-everything/index.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 84,
      name: "truTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-29",
  },
  {
    id: 3121,
    url: "https://www.tvmaze.com/shows/3121/stephen-fry-in-central-america",
    name: "Stephen Fry in Central America",
    genres: ["Adventure", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/43067.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/43067.jpg",
    },
    summary:
      "<p>Seven years ago, Stephen Fry travelled through all fifty states of the USA in a black cab. But he's always been fascinated by events south of the border, so now, in this brand new four-part series, he embarks on an adventure into America's backyard.</p><p>Travelling through Mexico and the entire Central American isthmus, to the Panamanian border with South America, it's a remarkable trip through some of the oldest civilisations on the planet – Mayan, Aztec and Olmec.</p><p>He visits some of the most dangerous, but breathtakingly beautiful, countries as he learns all about the people, the places, the wildlife and the history.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-08-27",
  },
  {
    id: 3122,
    url: "https://www.tvmaze.com/shows/3122/the-trials-of-jimmy-rose",
    name: "The Trials of Jimmy Rose",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/43069.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/43069.jpg",
    },
    summary:
      "<p>After a 12-year prison sentence for armed robbery, Jimmy Rose returns home to mixed emotions from his family. His daughter and grandson welcome him with open arms, but his wife and son are cold and indifferent, having learned to live life without him.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-08-30",
  },
  {
    id: 3123,
    url: "https://www.tvmaze.com/shows/3123/alaska-haunting",
    name: "Alaska Haunting",
    genres: ["Drama", "Horror", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/22/56785.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/22/56785.jpg",
    },
    summary:
      "<p>In Alaska, no one can hear you when you scream. Miles of forest separate neighbors in America's northern-most state, but hauntings are so common there that locals turn to the Internet to share their terrifying tales. In <b>Alaska Haunting</b>, the last frontier becomes the backdrop for scary ghost stories, where frigid winter weather leaves victims frozen in fear with nowhere to run.</p>",
    officialSite:
      "https://www.destinationamerica.com/tv-shows/alaska-haunting/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 107,
      name: "Destination America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-20",
  },
  {
    id: 3128,
    url: "https://www.tvmaze.com/shows/3128/critical",
    name: "Critical",
    genres: ["Drama", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/43073.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/43073.jpg",
    },
    summary:
      "<p>Critical is a 13-part series set in a state-of-the-art Major Trauma Centre, a unit which treats only the most gravely ill or seriously injured. Each episode features a new and distinctive case told with thrilling intensity. Whether that patient lives or dies is determined by knife-edge decisions and procedures, but can the diverse team of medical professionals knit together and rise to the challenge? It's a series about medicine where our team hold a life in their hands but in every case they face the agonisingly real fear that it could slip through their fingers.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 63,
      name: "Sky 1",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-02-24",
  },
  {
    id: 3129,
    url: "https://www.tvmaze.com/shows/3129/eve",
    name: "Eve",
    genres: ["Drama", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/43083.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/43083.jpg",
    },
    summary:
      "<p><b>Eve</b> is the star of a brand new sci-fi drama from CBBC. She's no ordinary girl – Eve is the result of an incredibly advanced robotics experiment.</p>",
    officialSite: "http://www.bbc.co.uk/cbbc/shows/eve",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 60,
      name: "CBBC",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-01-05",
  },
  {
    id: 3130,
    url: "https://www.tvmaze.com/shows/3130/the-hotel-inspector",
    name: "The Hotel Inspector",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/43086.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/43086.jpg",
    },
    summary:
      "<p>Look who's coming to stay! Hotelier Alex Polizzi is on a quest to turn Britain's hotels of horror into relaxing retreats.</p>",
    officialSite: "http://www.channel5.com/shows/the-hotel-inspector",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 135,
      name: "Channel 5",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2005-09-29",
  },
  {
    id: 3131,
    url: "https://www.tvmaze.com/shows/3131/the-sky-at-night",
    name: "The Sky at Night",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/43088.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/43088.jpg",
    },
    summary:
      "<p>Our team of astronomers tell us what's on view in the night sky. From comets to quasars, there is always something fascinating to discuss in the Universe.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006mk7h",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 51,
      name: "BBC Four",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1957-04-24",
  },
  {
    id: 3134,
    url: "https://www.tvmaze.com/shows/3134/the-amazing-world-of-gumball",
    name: "The Amazing World of Gumball",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/43096.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/43096.jpg",
    },
    summary:
      "<p><b>The Amazing World of Gumball </b>is about an amusing blue cat named Gumball and his best buddy Darwin, a pet goldfish, combines 2D and 3D animation in a live-action setting.</p>",
    officialSite: "http://www.theamazingworldofgumball.com/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-05-03",
  },
  {
    id: 3135,
    url: "https://www.tvmaze.com/shows/3135/mike-tyson-mysteries",
    name: "Mike Tyson Mysteries",
    genres: ["Comedy", "Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/205/513104.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/205/513104.jpg",
    },
    summary:
      "<p>In <b>Mike Tyson Mysteries</b>, Mike Tyson is taking the fight from the boxing ring to the streets... by solving mysteries! Aided by the Mike Tyson Mystery Team - the Ghost of the Marquess of Queensberry, Mike's adopted Korean daughter Yung Hee, and a pigeon who was once a man - Mike Tyson will answer any plea sent to him. If you have a problem that needs solving, Iron Mike is in your corner.</p>",
    officialSite:
      "http://www.adultswim.com/videos/mike-tyson-mysteries/?sr=mike_tyson_mysteries_adult_swim",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-27",
  },
  {
    id: 3136,
    url: "https://www.tvmaze.com/shows/3136/nathan-for-you",
    name: "Nathan for You",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/326/816434.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/326/816434.jpg",
    },
    summary:
      "<p>Nathan Fielder is a business advisor who implements strategies that no traditional consultant would dare attempt. Whether it's creating a coffee shop called Dumb Starbucks, inventing a poo-flavored yogurt or staging an elaborate video where a pig saves a goat, no idea is too daring. And while Nathan's efforts may not always succeed, they always have big results. This is <b>Nathan for You</b>.</p>",
    officialSite: "http://www.cc.com/shows/nathan-for-you",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-02-28",
  },
  {
    id: 3145,
    url: "https://www.tvmaze.com/shows/3145/dirty-rotten-survival",
    name: "Dirty Rotten Survival",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/54011.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/54011.jpg",
    },
    summary:
      '<p><i><b>"Dirty Rotten Survival"</b></i> is an outdoor adventure trek seasoned with a dash of grit, "man-genuity," and a whole lot of MacGyver\'ing. National Geographic Channel challenged a survival savant, an engineer-inventor and a construction guru to hit the road and test their mettle by competing in location-inspired outdoor challenges across several states using a different, limited set of tools in each episode.</p>',
    officialSite:
      "http://channel.nationalgeographic.com/dirty-rotten-survival/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-15",
  },
  {
    id: 3149,
    url: "https://www.tvmaze.com/shows/3149/behind-bars-overtime",
    name: "Behind Bars: Overtime",
    genres: ["Drama", "Action", "Crime"],
    image: null,
    summary:
      "<p><b>Behind Bars: Overtime</b> will air new scenes and interviews and enhance previous episodes of <i>Behind Bars: Rookie Year</i>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-08-22",
  },
  {
    id: 3151,
    url: "https://www.tvmaze.com/shows/3151/david-attenboroughs-natural-curiosities",
    name: "David Attenborough's Natural Curiosities",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/43206.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/43206.jpg",
    },
    summary:
      "<p>Sir David shines the spotlight on some of nature's evolutionary anomalies and reveals how these curious animals continue to fascinate.</p>",
    officialSite:
      "http://watch.uktv.co.uk/shows/david-attenboroughs-natural-curiosities/",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 295,
      name: "W",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-01-29",
  },
  {
    id: 3158,
    url: "https://www.tvmaze.com/shows/3158/suntrap",
    name: "SunTrap",
    genres: ["Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/43215.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/43215.jpg",
    },
    summary:
      "<p>Crime comedy. An undercover reporter and his former mentor join forces to solve mysteries on a Spanish island.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b05x7tvm",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-05-27",
  },
  {
    id: 3169,
    url: "https://www.tvmaze.com/shows/3169/tantei-no-tantei",
    name: "Tantei no tantei",
    genres: ["Action", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/43323.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/43323.jpg",
    },
    summary:
      "<p>The cool, beautiful Sasaki Rena is the lone investigator who works for for a medium-sized research agency called Suma Research Agency. Because of her past related to her sister's death, she became a detective that investigates and pursues unscrupulous detectives. Her beloved younger sister was murdered by a stalker and she has been searching for the investigator who caused her sister's death in order to take revenge.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 131,
      name: "Fuji TV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2015-07-09",
  },
  {
    id: 3174,
    url: "https://www.tvmaze.com/shows/3174/the-greatest-love",
    name: "The Greatest Love",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/43347.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/43347.jpg",
    },
    summary:
      "<p>A romantic comedy about a former star singer named Koo Ae-jeong who finds herself entangled in a relationship with Dokgo Jin, the biggest celebrity in the country.</p>",
    officialSite: "http://content.mbc.co.kr/program/drama/2600093_64285.html",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 166,
      name: "MBC",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2011-05-04",
  },
  {
    id: 3183,
    url: "https://www.tvmaze.com/shows/3183/aftermash",
    name: "AfterMASH",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/43393.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/43393.jpg",
    },
    summary:
      "<p>This two-season sitcom explores of the lives of three members of the 4077th after they return home. Colonel Potter returns home and takes a job as a doctor at General General, a veteran's hospital in Hannibal, Missouri. He recruits Klinger as an administrative assistant, and Father Mulcahy joins them as the hospital's Catholic chaplain.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1983-09-26",
  },
  {
    id: 3186,
    url: "https://www.tvmaze.com/shows/3186/wwe-breaking-ground",
    name: "WWE Breaking Ground",
    genres: ["Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/27/69795.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/27/69795.jpg",
    },
    summary:
      "<p><b>WWE Breaking Ground</b> will look at the WWE Performance Center and what it takes to become a WWE Superstar.</p>",
    officialSite: "http://www.wwe.com/inside/networkschedule",
    webChannel: {
      id: 15,
      name: "WWE Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Running",
    network: null,
    premiered: "2015-10-26",
  },
  {
    id: 3191,
    url: "https://www.tvmaze.com/shows/3191/i-didnt-do-it",
    name: "I Didn't Do It",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/43431.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/43431.jpg",
    },
    summary:
      "<p>Each episode of <b>I Didn't Do It</b> starts at the end, sort of. As the episode begins, an adventure has just ended for a group of five teenage friends. The gang then tries to explain, through flashbacks, exactly what happened on their adventure that inevitably went haywire. Booksmart Lindy is the quick thinker of the group who often saves the day when they are in trouble, while her confident twin brother, Logan, has street smarts. Fashionista Jasmine, voice of reason Garrett and oddball Delia are the twins' friends who make up the rest of the group.</p>",
    officialSite: "http://disneychannel.disney.com/i-didn-t-do-it",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 78,
      name: "Disney Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-17",
  },
  {
    id: 3193,
    url: "https://www.tvmaze.com/shows/3193/marvels-hulk-and-the-agents-of-smash",
    name: "Marvel's Hulk and the Agents of S.M.A.S.H.",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/55/138244.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/55/138244.jpg",
    },
    summary:
      "<p>The Incredible Hulk teams up with Red Hulk, She-Hulk, Skaar, and Rick Jones aka A-Bomb to battle the forces of evil in front of cameras for Rick's web-based series to show the Hulk is more hero than monster.</p>",
    officialSite:
      "http://disneyxd.disney.com/marvels-hulk-and-the-agents-of-smash",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 25,
      name: "Disney XD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-08-11",
  },
  {
    id: 3194,
    url: "https://www.tvmaze.com/shows/3194/a-daughter-just-like-you",
    name: "A Daughter Just Like You",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/65/163843.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/65/163843.jpg",
    },
    summary:
      "<p>This family-oriented show revolves around three different families clashing through a lot of misunderstandings as they become in-laws with each other: a popular female host on a shopping channel and her three daughters who are a college professor, high-powered consultant and doctor, a divorced spouse who loves to regale stories about his time in the Marines, he has dried skin from doing the dishes every day; and a daughter from a rich family that that runs a successful fashion designer company. Their problems clear up slowly through love and understanding that result in a healing process.</p>",
    officialSite: "http://content.mbc.co.kr/program/drama/2603484_64285.html",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 166,
      name: "MBC",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2015-05-18",
  },
  {
    id: 3198,
    url: "https://www.tvmaze.com/shows/3198/shine-or-go-crazy",
    name: "Shine or Go Crazy",
    genres: ["Drama", "Fantasy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/81/204099.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/81/204099.jpg",
    },
    summary:
      '<p>Wang So, a Goryeo prince, was born with the name, "Shine". Shin Yul is a woman hailing from the Balhae kingdom and believed to have the powers of an oracle. A prince who suffered vile remarks because of a cursed prophecy finds himself attracted to a former princess from a fallen kingdom who faces death because of her fate to become the light of another kingdom. Their love is at a point of either shining or flaming out.</p>',
    officialSite: "http://content.mbc.co.kr/program/drama/2590664_64285.html",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 166,
      name: "MBC",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2015-01-19",
  },
  {
    id: 3199,
    url: "https://www.tvmaze.com/shows/3199/kill-me-heal-me",
    name: "Kill Me, Heal Me",
    genres: ["Comedy", "Romance", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/43477.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/43477.jpg",
    },
    summary:
      "<p>A romantic comedy between a third-generation billionaire with Dissociative Identity Disorder and a first-year Psychiatrist resident who treats him secretly.</p><p>After a traumatic experience in his childhood, Cha Do Hyun suffers memory lapses and his personality then fractured into seven different identities. He tries to regain control over his life with the help of Oh Ri Jin, a first-year psychiatric resident who treats him secretly. But Ri Jin's twin brother, Oh Ri Ohn, is a famous mystery novelist who investigates about Do Hyun and his family.</p>",
    officialSite: "http://content.mbc.co.kr/program/drama/2590657_64285.html",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 166,
      name: "MBC",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2015-01-07",
  },
  {
    id: 3209,
    url: "https://www.tvmaze.com/shows/3209/brain-games",
    name: "Brain Games",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/236/591512.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/236/591512.jpg",
    },
    summary:
      "<p>Get ready to have your mind messed with! <b>Brain Games</b> uses interactive experiments, misdirection and tricks to demonstrate how our brains create the illusion of seamless reality through our memory, through our sensory perception, and how we focus our attention.</p>",
    officialSite: "https://www.nationalgeographic.com/tv/shows/brain-games",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-10-09",
  },
  {
    id: 3211,
    url: "https://www.tvmaze.com/shows/3211/finding-your-roots-with-henry-louis-gates-jr",
    name: "Finding Your Roots with Henry Louis Gates Jr.",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/186/465363.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/186/465363.jpg",
    },
    summary:
      "<p>Since the premiere of his groundbreaking series <i>African American Lives</i> through the first season of <b>Finding Your Roots</b>, noted Harvard scholar Henry Louis Gates, Jr. has been helping people discover long-lost relatives hidden for generations within the branches of their family trees. Professor Gates utilizes a team of genealogists to reconstruct the paper trail left behind by our ancestors and the world's leading geneticists to decode our DNA and help us travel thousands of years into the past to discover the origins of our earliest forebears.</p>",
    officialSite: "http://www.pbs.org/wnet/finding-your-roots/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 85,
      name: "PBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-03-25",
  },
  {
    id: 3217,
    url: "https://www.tvmaze.com/shows/3217/hotel-showdown",
    name: "Hotel Showdown",
    genres: [],
    image: null,
    summary:
      "<p><i>Hotel Showdown</i> is a winner-take-all competition in which 4 hotels go head-to-head for a $25,000 prize. The hotel owners will spend a night in one another's establishments with an exacting eye for detail, awarding points for their stays.</p>",
    officialSite: "http://www.travelchannel.com/shows/hotel-showdown",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 82,
      name: "Travel Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-13",
  },
  {
    id: 3222,
    url: "https://www.tvmaze.com/shows/3222/on-the-rocks",
    name: "On the Rocks",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/43518.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/43518.jpg",
    },
    summary:
      "<p>John Green knows bars. As a top-level consultant, he's designed, staffed and launched some of the most prestigious bars and nightclubs in the world. Whether he's shaking hands or shaking a martini, John knows the business behind the bar and now he's bringing that expertise to struggling bars across America. John quickly assesses the location, identifies the problems and finds the solution. This expert can help any bar that's \"on the rocks\" get back into the black. <br /><br /></p>",
    officialSite: "http://www.foodnetwork.com/shows/on-the-rocks/episodes.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 81,
      name: "Food Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-11-17",
  },
  {
    id: 3236,
    url: "https://www.tvmaze.com/shows/3236/the-spring-day-of-my-life",
    name: "The Spring Day of My Life",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/43564.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/43564.jpg",
    },
    summary:
      "<p>Facing a terminal illness, a woman finds a new lease on life when she gets a heart transplant. When she meets the husband of the person whose heart she received, she falls in love in love with him and his children in this splendid story of a karmic connection.</p>",
    officialSite: "http://content.mbc.co.kr/program/drama/2591218_64285.html",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 166,
      name: "MBC",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2014-09-10",
  },
  {
    id: 3255,
    url: "https://www.tvmaze.com/shows/3255/sherlock-holmes",
    name: "Sherlock Holmes",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/101/254529.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/101/254529.jpg",
    },
    summary:
      "<p><b>Sherlock Holmes</b> is one of the world's greatest and most popular fictional detectives. His acute perception and powers of observation are called upon in solving a compendium of crime. As ever, Dr. Watson is on hand as his indispensable assistant.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1984-04-24",
  },
  {
    id: 3277,
    url: "https://www.tvmaze.com/shows/3277/teen-mom-og",
    name: "Teen Mom OG",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/294/736317.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/294/736317.jpg",
    },
    summary:
      "<p>Motherhood hasn't always been easy over the years for Catelynn, Cheyenne, Maci, Mackenzie and Amber, but they've tackled its many challenges head-on.</p>",
    officialSite: "http://www.mtv.com/shows/teen-mom-og",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-12-08",
  },
  {
    id: 3281,
    url: "https://www.tvmaze.com/shows/3281/americas-book-of-secrets",
    name: "America's Book of Secrets",
    genres: ["Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/314/786119.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/314/786119.jpg",
    },
    summary:
      "<p><b>America's Book of Secrets</b> on goes deeper, farther and wider than ever in its unceasing effort to bring viewers the truth behind today's most shocking headlines. From the facts behind the NSA spying scandals (\"Big Brother\") and the Boston Bombings (\"American Terrorists\") to America's secret prisons, Scientology, the Gold conspiracy and America's doomsday plans, this thought-provoking informational series features in-depth interviews with top journalists, law enforcement officials and even whistleblowers. It gets past the spin and straight to the heart of what everyone needs to know, whether the government wants you to or not.</p>",
    officialSite: "http://www.history.com/shows/americas-book-of-secrets",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-01-15",
  },
  {
    id: 3289,
    url: "https://www.tvmaze.com/shows/3289/the-twilight-zone",
    name: "The Twilight Zone",
    genres: ["Fantasy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/43916.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/43916.jpg",
    },
    summary:
      "<p>Travel into the fifth dimension once again with <b>The Twilight Zone</b>, testing the limits of reality and exploring the mysteries of the universe. Airing from 1985 to 1989, this critically acclaimed anthology series carried on the legacy of the original Rod Serling program and attracted a brand new audience of fans.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1985-09-27",
  },
  {
    id: 3291,
    url: "https://www.tvmaze.com/shows/3291/the-world-at-war",
    name: "The World at War",
    genres: ["War", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/43921.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/43921.jpg",
    },
    summary:
      "<p>Laurence Olivier narrates the landmark 26-part British documentary series telling the story of World War II, profiling its main campaigns and highlighting the human cost on all sides of the conflict.</p>",
    officialSite: "https://yesterday.uktv.co.uk/shows/the-world-at-war/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1973-10-31",
  },
  {
    id: 3295,
    url: "https://www.tvmaze.com/shows/3295/hetty-feather",
    name: "Hetty Feather",
    genres: ["Drama", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/88/222048.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/88/222048.jpg",
    },
    summary:
      "<p>Drama series set in Victorian-era London. Based on the book by Jacqueline Wilson.</p>",
    officialSite: "http://www.bbc.co.uk/cbbc/shows/hetty-feather",
    webChannel: {
      id: 26,
      name: "BBC iPlayer",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-05-11",
  },
  {
    id: 3309,
    url: "https://www.tvmaze.com/shows/3309/the-waltons",
    name: "The Waltons",
    genres: ["Drama", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/44012.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/44012.jpg",
    },
    summary:
      "<p>Enjoy the heart-warming stories of the Waltons family, living in a rural community during the Depression and World War II. John and Olivia Walton are the proud parents of three girls and five boys: John-Boy, Jason, Mary Ellen, Erin, Ben, twins Jim-Bob &amp; Joseph, and Elizabeth; Joseph died at birth. Grandma and Grandpa Walton (Esther and Zeb) are John's parents are also an integral part of the family.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1972-09-14",
  },
  {
    id: 3310,
    url: "https://www.tvmaze.com/shows/3310/shipping-wars",
    name: "Shipping Wars",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/44015.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/44015.jpg",
    },
    summary:
      "<p>A&amp;E presents the new original real-life series <b>Shipping Wars</b>, which follows six independent shippers who have discovered that fortunes can be made transporting items that traditional carriers won't touch.</p>",
    officialSite: "http://www.aetv.com/shipping-wars",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-01-10",
  },
  {
    id: 3315,
    url: "https://www.tvmaze.com/shows/3315/guys-big-bite",
    name: "Guy's Big Bite",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/44034.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/44034.jpg",
    },
    summary:
      "<p>Guy Fieri's bleached blonde hair, goatee and skateboarder shorts make a strong statement – you are what you eat! Whether it's his Mojito Chicken, Pepperoni Lasagna or Jambalaya Sandwich, one thing is certain – Guy Fieri's food is as fun, fearless and fundamental as his larger-than-life personality. We hope you're hungry, because this Guy's imagination knows no limits. Open wide for <b>Guy's Big Bite</b>.</p>",
    officialSite: "http://www.foodnetwork.com/shows/guys-big-bite.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 81,
      name: "Food Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-06-25",
  },
  {
    id: 3325,
    url: "https://www.tvmaze.com/shows/3325/matroesjkas",
    name: "Matroesjka's",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/44044.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/44044.jpg",
    },
    summary:
      "<p>Each year hundreds of women are taken from their homes and forced into a life of prostitution and sexual slavery. This is the story of ten of them. A Belgian criminal gang head east to Lithuania to recruit young women desperate to leave their impoverished lives. Promising a glamorous life as members of a stage dance troupe, the girls are eager to sign up. From the training in Cyprus, to the strip clubs and illegal brothers in Belgium, the girls from the start are forced into a life of rape, abuse, murder and misery. The police are slow and corrupt, and the gangsters are always one step ahead of the law.</p>",
    officialSite: null,
    webChannel: null,
    language: "Dutch",
    status: "Ended",
    network: {
      id: 156,
      name: "VTM",
      country: { name: "Belgium", code: "BE", timezone: "Europe/Brussels" },
    },
    premiered: "2005-01-05",
  },
  {
    id: 3338,
    url: "https://www.tvmaze.com/shows/3338/what-would-you-do",
    name: "What Would You Do?",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/320/801954.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/320/801954.jpg",
    },
    summary:
      "<p>When you think no one is watching… What Would You Do?</p><p>Using hidden cameras, <b>What Would You Do?</b> establishes everyday scenarios and then captures people's reactions. Whether people are compelled to act or mind their own business, John Quiñones reports on their split-second and often surprising decision-making process.</p>",
    officialSite: "http://abcnews.go.com/WhatWouldYouDo",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-02-26",
  },
  {
    id: 3339,
    url: "https://www.tvmaze.com/shows/3339/empresses-in-the-palace",
    name: "Empresses in the Palace",
    genres: ["Drama", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/44115.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/44115.jpg",
    },
    summary:
      "<p>It tells the story of one of Emperor Yongzheng's concubines, Zhen Huan, who's the mother of Prince Hongli (the famous Emperor Qianlong).This drama, adapted from popular Internet novel of the same name, will tell the story of the heroine, Zhen Huan, who joined the palace harem with her sister. She was selected to be Emperor Yongzheng's concubine. When Zhen Huan first enters the palace, she is innocent and gullible, but gradually learnd the hard way to fend for herself when she inadvertently becomes caught up in the schemes between the Empress and Concubine Hua. Through cunning and deceit, Zhen Huan finally succeeds in becoming Empress. However, she arouses Emperor Yongzheng's suspicion about her loyalty and is forced to poison her true love, 17th Prince. Finally, when Emperor Yongzheng dies and Hong Li ascends the throne, Concubine Zhen Huan</p>",
    officialSite: null,
    webChannel: null,
    language: "Chinese",
    status: "Ended",
    network: {
      id: 302,
      name: "Dragon TV",
      country: { name: "China", code: "CN", timezone: "Asia/Shanghai" },
    },
    premiered: "2012-03-26",
  },
  {
    id: 3340,
    url: "https://www.tvmaze.com/shows/3340/family-secrets",
    name: "Family Secrets",
    genres: ["Drama", "Family", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/44122.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/44122.jpg",
    },
    summary:
      "<p>A revenge melodrama about a mother from a well-off family who had lost her son to a tragic accident and later her only daughter went missing as well. Her world is turned upside down when she discovers that her daughter was kidnapped by someone from her own family.</p>",
    officialSite: "http://program.interest.me/tvn/familysecret",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 280,
      name: "tvN",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2014-10-27",
  },
  {
    id: 3341,
    url: "https://www.tvmaze.com/shows/3341/fixer-upper",
    name: "Fixer Upper",
    genres: ["DIY"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755415.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755415.jpg",
    },
    summary:
      "<p>The first rule of real estate is location, location, location, but what happens when a buyer's only option in the right location is a house with dreadful design and a clunky layout? We say buy it — then fix it! <b>Fixer Upper</b> pairs renovation, design and real estate pros Chip and Joanna Gaines, a hilarious married couple, with Waco/Dallas, Texas-area buyers to renovate the wrong house that's in the right location.</p>",
    officialSite: "http://www.hgtv.com/shows/fixer-upper",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 192,
      name: "HGTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-04-17",
  },
  {
    id: 3346,
    url: "https://www.tvmaze.com/shows/3346/project-greenlight",
    name: "Project Greenlight",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/44174.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/44174.jpg",
    },
    summary:
      "<p><b>Project Greenlight</b> is a documentary series about filmmaking from executive producers Matt Damon and Ben Affleck. Starting with a digital competition on July 24, the series will be a revealing and uncensored look at the challenges facing a first-time director as cameras roll from pre-production and casting through principal photography and post-production.</p>",
    officialSite: "http://www.hbo.com/project-greenlight",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-12-02",
  },
  {
    id: 3353,
    url: "https://www.tvmaze.com/shows/3353/kuhna",
    name: "Кухня",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/44266.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/44266.jpg",
    },
    summary:
      '<p>"At all times, the food was close to the people. It tempts, inspires, delights, turns away. But man can not live without food, so the one who makes a meal, can rule the world ... ". So thought Maxim Lavrov, when he went to carry out his dream - to get a cook in one of the most expensive restaurants in the capital.</p><p>The dream has come true, that\'s just the reality did not turn out so good. The chef, Viktor Barinov - the real star gastronomic glitterati who knows how to please a demanding public. The flip side of this ideal image - alcohol abuse, gambling and insufferable character. In anger Barinov terrible on the loose - invincible.</p><p>Art director Victoria Goncharova - a real ice queen, careerist with a heart of ice, but it was Max spends a night before going to a new job. A whole team of cooks is just waiting blunders beginner to a good laugh.</p>',
    officialSite: null,
    webChannel: null,
    language: "Russian",
    status: "Ended",
    network: {
      id: 304,
      name: "СТС",
      country: {
        name: "Russian Federation",
        code: "RU",
        timezone: "Asia/Kamchatka",
      },
    },
    premiered: "2012-10-22",
  },
  {
    id: 3355,
    url: "https://www.tvmaze.com/shows/3355/assembly",
    name: "Assembly",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/44272.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/44272.jpg",
    },
    summary:
      "<p>When a working-class man stands up for his rights and finds himself pulled into the world of politics, can he survive? Jin Sang Pil is a welder at a shipyard who fights for his fellow workers' rights against a layoff, only to find that his convictions and principles get him elected to become a rookie politician in the National Assembly. In this foreign environment, Sang Pil relies heavily on his political aide, Choi In Kyung, a whip-smart woman who knows all the ins and outs of the National Assembly. Can they work together to fight for the common man in the most powerful political corridors in the country?</p>",
    officialSite: "http://www.kbs.co.kr/drama/assembly/index.html",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 128,
      name: "KBS2",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2015-07-15",
  },
  {
    id: 3356,
    url: "https://www.tvmaze.com/shows/3356/blue",
    name: "Blue",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/44273.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/44273.jpg",
    },
    summary:
      "<p><b>Blue</b> is a mother with a secret life. She'll do anything to keep it from her son. But her past has other plans.</p>",
    officialSite: null,
    webChannel: {
      id: 2,
      name: "Hulu",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2012-06-11",
  },
  {
    id: 3357,
    url: "https://www.tvmaze.com/shows/3357/hatufim",
    name: "Hatufim",
    genres: ["Drama", "Thriller", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/44275.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/44275.jpg",
    },
    summary:
      "<p>The series, set in 2008, depicts three Israeli soldiers who were captured 17 years previously while on a secret mission with their unit in Lebanon.</p>",
    officialSite: null,
    webChannel: null,
    language: "Hebrew",
    status: "Ended",
    network: {
      id: 781,
      name: "Channel 2",
      country: { name: "Israel", code: "IL", timezone: "Asia/Jerusalem" },
    },
    premiered: "2010-03-06",
  },
  {
    id: 3358,
    url: "https://www.tvmaze.com/shows/3358/scooby-doo-where-are-you",
    name: "Scooby-Doo, Where Are You!",
    genres: ["Comedy", "Children", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/44284.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/44284.jpg",
    },
    summary:
      "<p>Brainiac Velma, jock Fred, fashionista Daphne, hippie Shaggy, and Shaggy's highstrung, talking Great Dane, Scooby-Doo, climb into their green van, the Mystery Machine, and hit the road in search of weird phenomena to solve. And even when Scooby and the gang aren't actively searching for them, mysteries just have a way of falling into their laps. Ruh-roh!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1969-09-13",
  },
  {
    id: 3367,
    url: "https://www.tvmaze.com/shows/3367/urban-explorers",
    name: "Urban Explorers",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/46610.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/46610.jpg",
    },
    summary:
      "<p><b>Urban Explorers</b> is an adventure into the past: four trekkers entering into dangerous terrain to uncover secrets about some of America's greatest cities. The team of experts includes an urban historian, a structural engineer and two world-class, urban climbers. From abandoned train stations, theaters and hospitals to sewers, underground railways and hidden hideaways, they will discover hidden gems and a unique insight into this nation's meteoric growth. But look quick - these secrets are fast being eroded and it is up to the Urban Explorers to find them before it is too late.</p>",
    officialSite:
      "http://press.discovery.com/emea/wrld/programs/urban-explorers/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 143,
      name: "Discovery Channel",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-04-13",
  },
  {
    id: 3371,
    url: "https://www.tvmaze.com/shows/3371/unforgotten",
    name: "Unforgotten",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/301/753584.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/301/753584.jpg",
    },
    summary:
      "<p><b>Unforgotten</b> focuses on a ‘cold' murder case of 39 years ago, when the bones of a young man are found beneath the footings of a demolished house. An investigation begins that will unravel the lives of four people who have been waiting for this moment for nearly forty years, as they discover that the past can't, and won't, stay buried for ever.</p>",
    officialSite: "http://www.itv.com/hub/unforgotten/2a3372",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-10-08",
  },
  {
    id: 3373,
    url: "https://www.tvmaze.com/shows/3373/paul-ogrady-for-the-love-of-dogs",
    name: "Paul O'Grady: For the Love of Dogs",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/44358.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/44358.jpg",
    },
    summary:
      "<p>Presenter and comedian Paul O'Grady loves dogs and joins the team to help out at Battersea Dogs and Cats Home.</p>",
    officialSite:
      "https://www.itv.com/hub/paul-ogrady-for-the-love-of-dogs/2a1672",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-09-03",
  },
  {
    id: 3377,
    url: "https://www.tvmaze.com/shows/3377/breakfast",
    name: "Breakfast",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/320/801159.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/320/801159.jpg",
    },
    summary:
      "<p>The latest news, sport, business and weather from the BBC's Breakfast team.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006v5tb",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2002-09-27",
  },
  {
    id: 3394,
    url: "https://www.tvmaze.com/shows/3394/peter-kays-car-share",
    name: "Peter Kay's Car Share",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/107/268560.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/107/268560.jpg",
    },
    summary:
      "<p>John and Kayleigh have been thrown together in a company car share scheme.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b08l2cn9",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-04-29",
  },
  {
    id: 3397,
    url: "https://www.tvmaze.com/shows/3397/remember-me",
    name: "Remember Me",
    genres: ["Drama", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/44645.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/44645.jpg",
    },
    summary:
      "<p>Three-part contemporary ghost story set in Yorkshire. Tom Parfitt's arrival at a local retirement home leads to an eerie unexpected death.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-11-23",
  },
  {
    id: 3399,
    url: "https://www.tvmaze.com/shows/3399/doctors",
    name: "Doctors",
    genres: ["Drama", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/105/264564.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/105/264564.jpg",
    },
    summary:
      "<p><b>Doctors </b>is a British medical soap opera. The first episode was first broadcast in the UK on BBC One on 26 March 2000. The drama focuses around the staff and their families of a doctor's surgery set in a fictional Midlands town of Letherbridge.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006mh9v",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2000-03-26",
  },
  {
    id: 3403,
    url: "https://www.tvmaze.com/shows/3403/the-divide",
    name: "The Divide",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/44685.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/44685.jpg",
    },
    summary:
      "<p><b>The Divide</b> is an exploration of personal morality and how all people – especially ambitious people – struggle with the shades of gray found in the absence of a simple, ordered moral universe. The show probes how truth coexists in the modern justice system alongside ambition, ethics, politics and race.</p><p>As an impassioned case worker with The Innocence Initiative, Christine Rosa delves into the case of a death-row inmate she believes was wrongly convicted of a young family's heinous murder 11 years earlier. She chases down new evidence in a search for the truth and confronts an equally passionate district attorney, Adam Page, whose view of justice is colored by shades of gray. Throughout the journey, Christine and Adam's pasts resurface as they are faced with the question of one man's guilt or innocence intertwined with their own personal histories.</p>",
    officialSite: "http://www.wetv.com/shows/the-divide",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 122,
      name: "WE tv",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-16",
  },
  {
    id: 3405,
    url: "https://www.tvmaze.com/shows/3405/this-is-not-happening",
    name: "This is Not Happening",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/44729.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/44729.jpg",
    },
    summary:
      "<p>Hosted by Ari Shaffir, <b>This is Not Happening</b> features long-form storytelling from stand-up comedians. From Keegan-Michael Key spending a day as a crackhead's chauffeur to Steve Rannazzisi drunkenly instigating a fight with an armed man in a convenience store parking lot to Joe Rogan getting caught in a hotel fire, these comedians' incredible stories prove that there is nothing as crazy as the truth.</p>",
    officialSite: "http://www.cc.com/shows/this-is-not-happening",
    webChannel: {
      id: 73,
      name: "CC: Studios",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2013-06-04",
  },
  {
    id: 3409,
    url: "https://www.tvmaze.com/shows/3409/animals-gone-wild",
    name: "Animals Gone Wild",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/77/193966.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/77/193966.jpg",
    },
    summary:
      "<p>How outrageous can the animal kingdom get? Whether it's out-of-bounds behavior or savage instincts run amok, when animals act out they're a force to be reckoned with. From the mysterious depths of the deep blue sea to the jungle's untamed edge, see just how rough, rowdy, and lawless Mother Nature's most unruly creatures can be.</p>",
    officialSite: "http://natgeotv.com/uk/animals-gone-wild",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 638,
      name: "Nat Geo Wild",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-05-16",
  },
  {
    id: 3415,
    url: "https://www.tvmaze.com/shows/3415/tomorrows-worlds-the-unearthly-history-of-science-fiction",
    name: "Tomorrow's Worlds: The Unearthly History of Science Fiction",
    genres: ["Science-Fiction", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/57/143270.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/57/143270.jpg",
    },
    summary:
      "<p>Historian Dominic Sandbrook and leading creators tell the story of science fiction.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p01yqk7d",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-11-22",
  },
  {
    id: 3418,
    url: "https://www.tvmaze.com/shows/3418/anzac-girls",
    name: "ANZAC Girls",
    genres: ["Drama", "War", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/17/44896.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/17/44896.jpg",
    },
    summary:
      "<p>Honouring the Centenary of the commencement of WW1, <b>ANZAC Girls</b> is a moving new six-part series based on the unique, and rarely told true stories of Australian and New Zealand nurses serving at Gallipoli and the Western Front.</p>",
    officialSite: "http://www.abc.net.au/tv/programs/anzac-girls/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 114,
      name: "ABC",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2014-08-10",
  },
  {
    id: 3421,
    url: "https://www.tvmaze.com/shows/3421/antiques-road-trip",
    name: "Antiques Road Trip",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/34/86883.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/34/86883.jpg",
    },
    summary:
      "<p>Antiques experts compete against one another at various auctions across the country to try and earn the most money by the end of the week.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00xgqvf",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-03-08",
  },
  {
    id: 3423,
    url: "https://www.tvmaze.com/shows/3423/maids",
    name: "Maids",
    genres: ["Drama", "Romance", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/45085.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/45085.jpg",
    },
    summary:
      "<p>Guk In-yeob is the only daughter of a Joseon nobleman, and her beauty and style has her surrounded by plentiful admirers, among them Kim Eun-gi, a young scholar from an important family who's loved In-yeob since they were young. But one day In-yeob's father is branded a traitor, causing her family to be forced into ruin, and overnight the city's most popular young lady becomes a slave. In-yeob has difficulty adjusting from her pampered past to her present life as the lowly maid to her former rival. She learns to survive by her wits and befriends her fellow slaves, including Mumyeong (meaning \"nameless\"), a mysterious manservant who once saved her when she was still an aristocrat. Although Eun-gi remains devoted to In-yeob, her changed social status becomes an obstacle to his promising future, and meanwhile, she begins to fall for the stoic, level-headed but charismatic Mumyeong, who unbeknownst to all is a warrior on an undercover assignment regarding matters of political import.<br></p>",
    officialSite: "http://drama.jtbc.joins.com/housemaid/",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 268,
      name: "jTBC",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2014-12-12",
  },
  {
    id: 3426,
    url: "https://www.tvmaze.com/shows/3426/homes-under-the-hammer",
    name: "Homes Under the Hammer",
    genres: ["DIY"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/147/369492.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/147/369492.jpg",
    },
    summary:
      "<p>Martin Roberts, Martel Maxwell and Dion Dublin uncover the various tricks of the property auction trade.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006v5kb",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-03-11",
  },
  {
    id: 3428,
    url: "https://www.tvmaze.com/shows/3428/miss-mamma-mia",
    name: "Miss Mamma Mia",
    genres: ["Family", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/45156.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/45156.jpg",
    },
    summary:
      "<p>Seo Young-joo was abandoned by her parents as a child and betrayed by the man she loved. But despite all that, she stays positive as she raises her five-year-old daughter on her own while working part-time jobs.</p>",
    officialSite:
      "http://www.kbsn.co.kr/drama/program_self_intro.do?pageIndex=1&searchBrdcstSn=0000000013&searchBdcstCode=&searchOnslfMnfctAt=&searchMenuSn=39&searchMenuKnd=0001&searchCondition=0&searchKeyword=%EB%A7%98%EB%A7%88%EB%AF%B8%EC%95%84",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 311,
      name: "KBS Drama",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2015-01-28",
  },
  {
    id: 3429,
    url: "https://www.tvmaze.com/shows/3429/victoria-derbyshire",
    name: "Victoria Derbyshire",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/108/270632.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/108/270632.jpg",
    },
    summary:
      "<p>Victoria Derbyshire presents the daily news and current affairs programme with original stories, exclusive interviews and daily audience debate on the breaking news.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b05qqk5c",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-04-07",
  },
  {
    id: 3431,
    url: "https://www.tvmaze.com/shows/3431/daily-politics",
    name: "Daily Politics",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/34/86885.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/34/86885.jpg",
    },
    summary:
      "<p>The days politics are analysed and reviewed on both a national and international level.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006mjxb",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2003-01-08",
  },
  {
    id: 3435,
    url: "https://www.tvmaze.com/shows/3435/terry-and-masons-great-food-trip",
    name: "Terry and Mason's Great Food Trip",
    genres: ["Food", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/37/94499.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/37/94499.jpg",
    },
    summary:
      "<p>Terry Wogan and Mason McQueen seek out the most weird and wonderful regional British cuisine, looking at how our tastes have evolved over the years.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b069cjc0",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-08-31",
  },
  {
    id: 3436,
    url: "https://www.tvmaze.com/shows/3436/the-evermoor-chronicles",
    name: "The Evermoor Chronicles",
    genres: ["Adventure", "Family", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/45238.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/45238.jpg",
    },
    summary:
      '<p>American teen, Tara Crossley, moves to a spooky English village with her mum, a famous novelist and new step family. There, Tara discovers a magic tapestry that tells the future. The Tapestry is tended to by the sinister "Everines" who are determined to get rid of our heroine and her family at any cost…</p>',
    officialSite:
      "http://www.disney.co.uk/disney-channel/shows/the-evermoor-chronicles",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 312,
      name: "Disney Channel",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-10-10",
  },
  {
    id: 3437,
    url: "https://www.tvmaze.com/shows/3437/this-wild-life",
    name: "This Wild Life",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/97/244664.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/97/244664.jpg",
    },
    summary:
      "<p>Documentary series following the life of wildlife expert Saba Douglas-Hamilton, who with her husband Frank and their three young children, have moved to Sambaru National Reserve in Kenya to run a safari camp.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p02cjpsv",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-08-31",
  },
  {
    id: 3439,
    url: "https://www.tvmaze.com/shows/3439/great-british-menu",
    name: "Great British Menu",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/42/107064.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/42/107064.jpg",
    },
    summary:
      "<p>Top chefs from across the nation compete for the chance to cook a four-course banquet for a high-profile figure.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b0071y6r",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-04-10",
  },
  {
    id: 3443,
    url: "https://www.tvmaze.com/shows/3443/lifeline",
    name: "Lifeline",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/38/95734.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/38/95734.jpg",
    },
    summary:
      "<p><b>Lifeline</b> is a monthly charity appeal programme presented by a well-known personality.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006nb6j",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2016-01-17",
  },
  {
    id: 3445,
    url: "https://www.tvmaze.com/shows/3445/max-shred",
    name: "Max & Shred",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/45350.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/45350.jpg",
    },
    summary:
      "<p><b>Max &amp; Shred</b>is a buddy comedy about the unlikely friendship that forms when easygoing superstar snowboarder, Max Asher, moves in with anxious academic, Alvin Ackerman, and his family. The show centers on the boys' odd couple relationship as they help and hinder each other through the trials of teenage life. Abby, Alvin's driven older sister, and Howie, Alvin's super smart eight-year-old protégé aid the boys in their adventures. Each half hour multi-cam episode will comically highlight the challenges of the young science whiz living with a celebrity athlete in the bustling ski town of Blizzard Springs. It's gonna be siiiick!</p>",
    officialSite: "http://www.nick.com/max-and-shred",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 73,
      name: "Nicktoons",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-06",
  },
  {
    id: 3447,
    url: "https://www.tvmaze.com/shows/3447/give-out-girls",
    name: "Give Out Girls",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/45365.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/45365.jpg",
    },
    summary:
      "<p><b>Give Out Girls</b> is a fresh new sitcom about the stories and secrets of a gang of four girls, two guys and their boss who work in the world of promotions. Being ignored or verbally abused is just part of the job for these girls as they vie to become the all important top seller of the day. <i>Give Out Girls</i> follows the team as they are let loose flogging dodgy goods in even dodgier locations, whilst injecting as much mischief into the day as they can to make it pass as quickly as possible.</p>",
    officialSite: "http://www.comedycentral.co.uk/give-out-girls",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 309,
      name: "Comedy Central",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-10-14",
  },
  {
    id: 3449,
    url: "https://www.tvmaze.com/shows/3449/inside-homicide",
    name: "Inside Homicide",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/45411.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/45411.jpg",
    },
    summary:
      "<p>With only 15 percent of homicide detectives in the U.S. being women, the working lives of female detectives are not as well documented as those of their male counterparts. INSIDE HOMICIDE takes a ride along with three female homicide detectives who work in the Cincinnati and Atlanta areas, conveying the high intensity of working the homicide unit in real-time. With dogged determination, Detectives Summer Benton, Jenny Luke and Jennifer Mitsch work relentlessly to bring closure to victims' families. From the actual 911 call to on-site questioning with witnesses and even real interrogation footage with suspects, viewers dive into the raw and gritty action that's part of these women's everyday lives.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-09",
  },
  {
    id: 3456,
    url: "https://www.tvmaze.com/shows/3456/boomers",
    name: "Boomers",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/82/205458.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/82/205458.jpg",
    },
    summary:
      "<p>Sitcom following the ups and downs of three retired couples living in Thurnemouth, 'Norfolk's only West-facing resort'.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b06v0nv1",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-08-15",
  },
  {
    id: 3463,
    url: "https://www.tvmaze.com/shows/3463/todd-the-book-of-pure-evil",
    name: "Todd & The Book of Pure Evil",
    genres: ["Comedy", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/45520.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/45520.jpg",
    },
    summary:
      "<p>Imagine a book of awesome power. A book that will make your deepest, darkest dreams come true… but at a horrifying cost. This is The Book of Pure Evil, and it's loose in Crowley High. Anyone who possesses it is unable to resist the temptation to use its power for their own teen-angst fueled desires. Thankfully, one horny teenager stands between The Book of Pure Evil and the end of the world as we know it. His name is Todd. He's flunking math, but he'll save our asses, whether he likes it or not.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 7,
      name: "CTV Sci-Fi Channel",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2010-09-29",
  },
  {
    id: 3465,
    url: "https://www.tvmaze.com/shows/3465/k3-zoekt-k3",
    name: "K3 zoekt K3",
    genres: ["Children", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/45674.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/45674.jpg",
    },
    summary:
      "<p>Karen, Kristel &amp; Josje are quiting with K3, but not till they found three worthy candidates to replace them. They'll do this via a new talentshow called; K3 zoekt K3.</p>",
    officialSite: "http://vtm.be/k3-zoekt-k3",
    webChannel: null,
    language: "Dutch",
    status: "Ended",
    network: {
      id: 156,
      name: "VTM",
      country: { name: "Belgium", code: "BE", timezone: "Europe/Brussels" },
    },
    premiered: "2015-09-04",
  },
  {
    id: 3472,
    url: "https://www.tvmaze.com/shows/3472/vincent",
    name: "Vincent",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/46268.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/46268.jpg",
    },
    summary:
      "<p>This exciting, fast-paced new drama series follows ex-cop Vincent Gallagher, head of a team of private investigators who are the last resort for troubled people with nowhere left to turn.</p>",
    officialSite: "https://itvstudios.com/programmes/vincent",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2005-10-10",
  },
  {
    id: 3480,
    url: "https://www.tvmaze.com/shows/3480/infinite-challenge",
    name: "Infinite Challenge",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/46328.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/46328.jpg",
    },
    summary:
      '<p><b>Infinite Challenge</b> is a Korean television entertainment program that is distributed and syndicated by MBC. It is recognized as the first "real variety" show in Korean television history. The program is largely unscripted and follows a similar format of challenge-based reality television programs, familiar to some audiences in the West.</p><p>The challenges are often silly, absurd, or impossible to achieve, so the program takes on the aspect of a satirical comedy variety show rather than a more standard reality or contest program. In earlier episodes, the show\'s six hosts and staff would continuously proclaim that, in order to achieve its comedic purposes, the program was 3-D: Dirty, Dangerous, and Difficult.</p>',
    officialSite: "http://www.imbc.com/broad/tv/ent/challenge/main.html",
    webChannel: null,
    language: "Korean",
    status: "Running",
    network: {
      id: 166,
      name: "MBC",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2005-04-23",
  },
  {
    id: 3484,
    url: "https://www.tvmaze.com/shows/3484/invasion-earth",
    name: "Invasion: Earth",
    genres: ["Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/46286.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/46286.jpg",
    },
    summary:
      "<p>In the lonely Scottish highlands, a small band of military personnel fight a desperate battle against a formidable alien intruder to prevent an invasion of the Earth</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1998-05-08",
  },
  {
    id: 3497,
    url: "https://www.tvmaze.com/shows/3497/backpackers",
    name: "Backpackers",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/46315.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/46315.jpg",
    },
    summary:
      '<p>In an attempt to get over a serious case of cold feet, recently engaged Ryan and Beth embark on separate European vacations with the mantra "what happens in Europe, stays in Europe". But hours into his adventure with his party animal and womanizing best friend Brandon, Ryan realizes he\'s made a huge mistake and sets off in search of Beth. His one problem? He has no idea where she could be.</p>',
    officialSite: "http://cwseed.com/shows/backpackers",
    webChannel: {
      id: 13,
      name: "CW Seed",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2013-08-15",
  },
  {
    id: 3508,
    url: "https://www.tvmaze.com/shows/3508/gogglebox",
    name: "Gogglebox",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/46626.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/46626.jpg",
    },
    summary:
      "<p><b>Gogglebox</b> is a British observational documentary television show which has aired on Channel 4 since 2013. The show focuses on families, friends and couples from around the country in their living rooms watching the last week's of British television.</p>",
    officialSite: "http://www.channel4.com/programmes/gogglebox",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-03-07",
  },
  {
    id: 3511,
    url: "https://www.tvmaze.com/shows/3511/men-into-space",
    name: "Men Into Space",
    genres: ["Drama", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/151/378321.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/151/378321.jpg",
    },
    summary:
      "<p>In the not-so-distant future, Man makes the leap into space. Under the leadership of Colonel Ed McCauley of the USAF, Mankind leaps into orbit, colonizes the Moon, and by the end of the series is launching the first spacecraft to Mars. In this relatively realistic portrayal of manned space flight, many of the episodes stem around problems caused by the actual problems of space exploration.There are no aliens of other science fiction elements, and everything is grounded in scientific fact.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1959-09-30",
  },
  {
    id: 3518,
    url: "https://www.tvmaze.com/shows/3518/memphis-beat",
    name: "Memphis Beat",
    genres: ["Drama", "Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/46507.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/46507.jpg",
    },
    summary:
      "<p>Jason Lee (My Name Is Earl) stars as a Memphis police detective with an intimate connection to the city, a passion for its music and a very demanding boss.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-06-22",
  },
  {
    id: 3520,
    url: "https://www.tvmaze.com/shows/3520/71-grader-nord",
    name: "71 Grader Nord",
    genres: ["Drama", "Adventure", "Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/46519.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/46519.jpg",
    },
    summary:
      "<p>Who is the fastest from Lindesnes to Nordkapp? The title alludes to the goal of the trip, which runs from Lindesnes to Nordkapp at <b>71° north</b>. Along the way, participants should (men and women) fight through beautiful but at times dangerous nature. At each stage they have deadlines to be respected for that mission to be approved, and rewards received. They will try their physical and particularly their mental strength on the road to the north.</p>",
    officialSite: "https://www.discoveryplus.no/programmer/71-nord",
    webChannel: null,
    language: "Norwegian",
    status: "To Be Determined",
    network: {
      id: 314,
      name: "TVNorge",
      country: { name: "Norway", code: "NO", timezone: "Europe/Oslo" },
    },
    premiered: "1999-09-06",
  },
  {
    id: 3527,
    url: "https://www.tvmaze.com/shows/3527/garage-sale-mystery",
    name: "Garage Sale Mystery",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/171/428059.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/171/428059.jpg",
    },
    summary:
      "<p>Jennifer Shannon can always find a diamond in the rough - when it comes to garage sales, that is! Whether it's a new antique to sell at her consignment shop, an Atari game for her son or a piece of furniture for her handy husband Jason to refurbish, she has made a career out of her treasure hunting prowess. But, when a string of burglaries hits her town, Jennifer must use her keen eye for detail and her natural problem solving instincts to help her piece together the clues and catch the criminal before it's too late!</p><p>As she gets closer to the truth, Jennifer learns that crime solving can be far more dangerous than any garage sale. Can she uncover the <b>Garage Sale Mystery</b>, or will her investigation create problems that not even Jennifer can solve?</p>",
    officialSite:
      "http://www.hallmarkmoviesandmysteries.com/garage-sale-mystery",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 252,
      name: "Hallmark Movies & Mysteries",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-14",
  },
  {
    id: 3536,
    url: "https://www.tvmaze.com/shows/3536/roommate",
    name: "Roommate",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/46646.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/46646.jpg",
    },
    summary:
      "<p><b>Roommate</b> is a South Korean reality show; originally a part of SBS's Good Sunday line-up. The show features eleven celebrities living together in a share house, sharing common spaces such as the kitchen, living room, and washrooms, as well as household tasks. The house features sixty cameras and five bedrooms. The program is a response to society today where single-person households are dramatically increasing and aims to show the life, troubles, and joys of eleven different celebrities as they form friendships, relationships and possibly enemies living together under one roof.</p>",
    officialSite:
      "http://program.sbs.co.kr/builder/programMainList.do?pgm_id=22000002481",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 127,
      name: "SBS",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2014-05-04",
  },
  {
    id: 3551,
    url: "https://www.tvmaze.com/shows/3551/the-jewel-in-the-crown",
    name: "The Jewel in the Crown",
    genres: ["Drama", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/46681.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/46681.jpg",
    },
    summary:
      "<p><b>The Jewel in the Crown</b> is a brilliant adaptation of Paul Scott's Raj Quartet. This award winning mini-series tells the epic story of men and women caught up in a struggle of race and class during the last five years of British rule in India.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1984-01-09",
  },
  {
    id: 3572,
    url: "https://www.tvmaze.com/shows/3572/ellery-queen",
    name: "Ellery Queen",
    genres: ["Drama", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/46784.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/46784.jpg",
    },
    summary:
      '<p>In this adaptation of the mystery novels of the authors who wrote under the pen name <b>Ellery Queen</b>, 1940s amateur sleuth Ellery Queen helps his father, the chief of police, to solve baffling crimes. Each episode concludes with a "challenge to the viewers" presented by Ellery himself, asking who they think that the killer is. Ellery then gathers all the suspects and presents his case, and identifies the killer.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1975-09-11",
  },
  {
    id: 3577,
    url: "https://www.tvmaze.com/shows/3577/fault-lines",
    name: "Fault Lines",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/25/63081.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/25/63081.jpg",
    },
    summary:
      "<p>We live in a world run through with Fault Lines. Al Jazeera's <b>Fault Lines</b> takes you beyond the headlines and holds the powerful to account as we examine the US' role in the world.</p>",
    officialSite: "http://america.aljazeera.com/watch/shows/fault-lines.html",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 169,
      name: "Al Jazeera America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-11-14",
  },
  {
    id: 3594,
    url: "https://www.tvmaze.com/shows/3594/the-crown",
    name: "The Crown",
    genres: ["Drama", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/228/570372.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/228/570372.jpg",
    },
    summary:
      "<p><b>The Crown</b> tells the inside story of two of the most famous addresses in the world -- Buckingham Palace and 10 Downing Street - and the intrigues, love lives and machinations behind the great events that shaped the second half of the 20th century. Two houses, two courts, one Crown.</p>",
    officialSite: "https://www.netflix.com/title/80025678",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Running",
    network: null,
    premiered: "2016-11-04",
  },
  {
    id: 3607,
    url: "https://www.tvmaze.com/shows/3607/police-interceptors",
    name: "Police Interceptors",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/46894.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/46894.jpg",
    },
    summary:
      "<p>Follow the action-packed lives of the high-speed police interception unit. Led by specially trained officers and equipped with the fastest vehicles in the force, the team tackles the most difficult-to-catch criminals on a daily basis.</p>",
    officialSite: "http://www.channel5.com/shows/police-interceptors",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 135,
      name: "Channel 5",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-05-09",
  },
  {
    id: 3608,
    url: "https://www.tvmaze.com/shows/3608/dallas-cowboys-cheerleaders-making-the-team",
    name: "Dallas Cowboys Cheerleaders: Making the Team",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/284/711952.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/284/711952.jpg",
    },
    summary:
      "<p>Kelli Finglass, the DCC director, has a mandate to have a squad of 36, making this a super competitive year. New to the mix of judges this year are two celebrities -- former DCC and Dancing with the Stars winner Melissa Rycroft and platinum-selling country music recording artist Neil McCoy. With 55 high caliber new girls making it to finals, it's intimidating for the 30 veterans as they must fight to keep their place on the team. Unfortunately for a few vets, it's the end of the line. For the super talented 43 who make training camp, the exhilaration is short lived as the reality of the most demanding dance audition in professional sports becomes real. Season nine brings everything you love -- girls reaching for their dreams and the emotional, drama-ridden journey to make them come true. The payoff is becoming part of the best team in the business -- the Dallas Cowboys Cheerleaders.</p>",
    officialSite:
      "http://www.cmt.com/shows/dallas-cowboys-cheerleaders-making-the-team",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 173,
      name: "CMT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-09-29",
  },
  {
    id: 3611,
    url: "https://www.tvmaze.com/shows/3611/10-things-you-dont-know-about",
    name: "10 Things You Don't Know About",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/46917.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/46917.jpg",
    },
    summary:
      "<p>In <b>10 Things You Don't Know About</b>, punk rock icon Henry Rollins uncovers crazy new twists and tidbits behind the historical tales, figures and places you only thought you knew. He's taking a break from writing and performing to focus on his other passion — history. Henry wants to see the odd, the fascinating and the shocking — and he's taking viewers on a journey into the past unlike any other.</p><p><br>.</p>",
    officialSite: "http://www.history.com/shows/10-things-you-dont-know-about",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 74,
      name: "H2",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-02-27",
  },
  {
    id: 3614,
    url: "https://www.tvmaze.com/shows/3614/lawman",
    name: "Lawman",
    genres: ["Drama", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/46937.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/46937.jpg",
    },
    summary:
      "<p>Marshal Dan Troop keeps law in the Old West town of Laramie. Helping him is his loyal deputy, Johnny McKay, and the local saloon owner, Lily Merrill.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1958-10-05",
  },
  {
    id: 3621,
    url: "https://www.tvmaze.com/shows/3621/mission-impossible",
    name: "Mission: Impossible",
    genres: ["Action", "Adventure", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/46969.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/46969.jpg",
    },
    summary:
      '<p>In this sequel to the original 1960s series, IMF agent Jim Phelps comes out of retirement when a protégé is killed. He creates a new team of agents, and decides to stick around after his protégé is avenged. Jim and his team take on "impossible missions" for the government, dealing with spies and criminals that normal agencies can\'t touch.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1988-10-23",
  },
  {
    id: 3627,
    url: "https://www.tvmaze.com/shows/3627/de-lamas",
    name: "De Lama's",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/47028.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/47028.jpg",
    },
    summary:
      "<p>An Improvisation Comedy group performing impressive, and overall hilarious impressions, parodies and improvisation comedy, often using random artifacts to act out situations.</p>",
    officialSite: "http://factsheets.bnn.nl/56/de-lama-s-/home",
    webChannel: null,
    language: "Dutch",
    status: "Ended",
    network: {
      id: 1020,
      name: "NPO 3",
      country: {
        name: "Netherlands",
        code: "NL",
        timezone: "Europe/Amsterdam",
      },
    },
    premiered: "2004-06-28",
  },
  {
    id: 3629,
    url: "https://www.tvmaze.com/shows/3629/the-michael-mcintyre-chat-show",
    name: "The Michael McIntyre Chat Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/60/152358.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/60/152358.jpg",
    },
    summary:
      "<p><b>The Michael McIntyre Chat Show </b>is a weekly chat show from award-winning comedian Michael McIntyre. In each episode McIntyre interviews three celebrity guests, incorporating lively chat and audience participation.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b03y7ncw",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-03-10",
  },
  {
    id: 3639,
    url: "https://www.tvmaze.com/shows/3639/undrafted",
    name: "Undrafted",
    genres: ["Drama", "Action", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/47243.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/47243.jpg",
    },
    summary:
      "<p>The Emmy-nominated series <b>Undrafted</b> returns for a second season with a special premiere on CBS Wednesday, September 16 at 10:00 PM ET. Undrafted premieres on NFL Network Tuesdays at 8:00 PM, ET beginning September 22 through November 3, with a special encore presentation of each of the eight episodes Thursday following the Thursday Night Football postgame show. Every year, thousands of college football players leave school with dreams of a career in the National Football League. Of those thousands, 256 players are selected in the NFL Draft. The remaining - the Undrafted - must convince coaches, executives, and the pro football community that they deserve a coveted roster spot on an NFL team. All eight episodes of Undrafted tell the stories of players who were undrafted and are currently working to make their dream of playing the NFL a reality. The following players are profiled this season on <i>Undrafted</i>.</p>",
    officialSite: "http://www.nfl.com/videos/undrafted",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 272,
      name: "CBS Sports Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-30",
  },
  {
    id: 3645,
    url: "https://www.tvmaze.com/shows/3645/hunted",
    name: "Hunted",
    genres: ["Drama", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/47269.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/47269.jpg",
    },
    summary:
      "<p><b>Hunted</b> is a real-life thriller where 14 ordinary people go on the run from a team of expert hunters.</p>",
    officialSite: "http://www.channel4.com/programmes/hunted",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-09-10",
  },
  {
    id: 3648,
    url: "https://www.tvmaze.com/shows/3648/new-captain-scarlet",
    name: "New Captain Scarlet",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/47287.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/47287.jpg",
    },
    summary:
      "<p>Imaginative and fantastical Supermarionation fun in the year 2065 when Earth's security organisation, Spectrum, spearheads an expedition to Mars.</p>",
    officialSite: "https://itvstudios.com/programmes/captain-scarlet",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2005-02-12",
  },
  {
    id: 3655,
    url: "https://www.tvmaze.com/shows/3655/codename-icarus",
    name: "Codename: Icarus",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/34/86886.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/34/86886.jpg",
    },
    summary:
      "<p>Codename Icarus is a British television series produced by the BBC in 1981.<br>The series combined elements of teenage drama and conspiracy thriller. It involved child prodigies being manipulated as the basis for a complex scheme involving nuclear missiles and the mysterious Icarus Foundation's plot to take over the world.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1981-12-08",
  },
  {
    id: 3657,
    url: "https://www.tvmaze.com/shows/3657/falcon",
    name: "Falcón",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/47306.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/47306.jpg",
    },
    summary:
      "<p>Falcón is a drama series which sees Inspector Javier Falcon being brought to life from Robert Wilson's iconic books. The series focuses on Javier Falcón, a Chief Inspector in the Seville police whose personal and professional life end up being compromised by dark secrets from the past.</p>",
    officialSite: "http://www.sky.com/tv/show/falcon",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 113,
      name: "Sky Atlantic",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-11-15",
  },
  {
    id: 3660,
    url: "https://www.tvmaze.com/shows/3660/the-infinite-worlds-of-hg-wells",
    name: "The Infinite Worlds of H.G. Wells",
    genres: ["Drama", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/47316.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/47316.jpg",
    },
    summary:
      "<p><b>The Infinite Worlds of H.G. Wells</b> three-part miniseries kicks off the new Hallmark Channel (formerly Odyssey Network) in style by bringing Wells' short stories to television for the first time. The miniseries opens in 1946, as newspaper reporter Ellen McGillivray (Best) pays a visit to a cranky 80-year-old H.G. Wells (Ward) with hopes of finding out what led to his visionary storytelling.</p><p>Wells is ready to give her the boot, but there is something about the young woman and her desire to learn more about his past and the secrets he knows that stops him. Wells relents and begins his tale a half-century earlier at London's Imperial College of Science, when he met Jane Robbins (Carmichael), a lovely scientist and teacher who holds the same fascination for unexplained phenomenon that he does. Wells and Jane soon find themselves slipping into amazing adventures that cross the bounds of time, space and science itself.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 50,
      name: "Hallmark Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-08-05",
  },
  {
    id: 3661,
    url: "https://www.tvmaze.com/shows/3661/jack-irish",
    name: "Jack Irish",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/47317.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/47317.jpg",
    },
    summary:
      "<p><b>Jack Irish</b> is a man getting his life back together again. A former criminal lawyer whose world imploded, he now spends his days as a part-time investigator, debt collector, apprentice cabinet maker, punter and sometime lover – the complete man really. An expert in finding those who don't want to be found – dead or alive, Jack helps out his mates while avoiding the past. That is until the past finds him.</p>",
    officialSite: "http://www.abc.net.au/tv/programs/jack-irish/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 114,
      name: "ABC",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2012-10-14",
  },
  {
    id: 3662,
    url: "https://www.tvmaze.com/shows/3662/jack-taylor",
    name: "Jack Taylor",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/47329.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/47329.jpg",
    },
    summary:
      "<p>Self-destructive, pigheaded, and over-fond of the bottle, Jack Taylor is a forty-something ex-cop trying to earn a living as a private detective in his native Galway. Taylor has burned a lot of bridges, but he still has a knack for uncovering ugly truths. Set against the rugged backdrop of western Ireland, this crime noir series depicts a country in transition, caught between the certainties of the past and the anxieties of a post-bubble future. Those same strains play out in the life of Jack Taylor, a man seeking to reinvent himself in a community with a long memory and an uneasy attitude towards change.</p><p>Based on the bestselling crime fiction by Ken Bruen.</p>",
    officialSite: "http://jacktaylorfilms.com",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 323,
      name: "Virgin Media One",
      country: { name: "Ireland", code: "IE", timezone: "Europe/Dublin" },
    },
    premiered: "2010-08-02",
  },
  {
    id: 3666,
    url: "https://www.tvmaze.com/shows/3666/pathfinders-to-mars",
    name: "Pathfinders to Mars",
    genres: ["Drama", "Children", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/47343.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/47343.jpg",
    },
    summary:
      "<p>In <b>Pathfinders to Mars</b>, sequel to <i>Pathfinders in Space</i>, Conway Henderson (Flood) consents to pilot a new interstellar rocket. Young Geoffrey Wedgewood will be one of the crew and Henderson's niece, Margaret (Hester Cameron) - due for a holiday with her uncle - persuades him to take her, too. Meanwhile the place of Professor Dyson is taken by an unidentified man believed by Wedgewood and the rocket crew to be Dyson. The imposter, Harcourt Brown (George Coulouris), sabotages the rocket's radio receiver so that Henderson and the rest don't discover his real identity. Working for the mysterious \"Sector Ten\" Brown manages to take control of the rocket and hold Margaret as hostage.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1960-12-11",
  },
  {
    id: 3675,
    url: "https://www.tvmaze.com/shows/3675/the-sweeney",
    name: "The Sweeney",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/47377.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/47377.jpg",
    },
    summary:
      "<p><i><b>\"The Sweeney\"</b></i> was one of the finest British police series of the mid 1970s. Jack Regan is a hard edged detective in the Flying Squad of London's Metropolitan police (called 'the Sweeney' from the Cockney rhyming slang 'Sweeney Todd' = 'Flying Squad\"). He pursues villains by methods which are underhand, often illegal, frequently violent, and more often than not, successful.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1975-01-02",
  },
  {
    id: 3676,
    url: "https://www.tvmaze.com/shows/3676/the-tomorrow-people",
    name: "The Tomorrow People",
    genres: ["Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/47381.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/47381.jpg",
    },
    summary:
      '<p>The Tomorrow People are British teens who have special powers. They can communicate to each other using telepathy. They can also transport themselves (they call it "Jaunting"). With the help of Tim their talking computer they battle the bad people of earth and space.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1973-04-30",
  },
  {
    id: 3679,
    url: "https://www.tvmaze.com/shows/3679/voyage-to-the-bottom-of-the-sea",
    name: "Voyage to the Bottom of the Sea",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/47398.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/47398.jpg",
    },
    summary:
      "<p>In this 60s show, the first of four Irwin Allen science fiction productions, the advanced submarine Seaview takes on all kinds of missions for the American government. Under the leadership of Admiral Nelson and Captain Crane, the Seaview takes on a variety of gritty real-world missions with spies, missile launches, deep-sea exploration, etc.</p><p>Unfortunately, then <i>Batman</i> caught on and Allen decided that camp and far-out science was the way to go. Increasingly, episodes dealt with mind control, aliens, werewolves, evil puppets, monsters in cheap-looking rubber suits, etc. After three more seasons, the show came to an end due to low ratings.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1964-09-14",
  },
  {
    id: 3686,
    url: "https://www.tvmaze.com/shows/3686/space-voyages",
    name: "Space Voyages",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/47424.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/47424.jpg",
    },
    summary:
      "<p>From Mercury to Gemini, from Apollo to Curiosity, NASA's giant leaps in engineering and science over the last 60 years have been nothing short of astronomical. Blast off on a celestial voyage as we explore the first half-century of the Space Age. Celebrate the triumphs, lament the tragedies, and learn how modern engineers are using the past as a blueprint, refining yesterday's technologies in hopes of sending humans off to Mars and beyond.</p>",
    officialSite:
      "http://www.smithsonianchannel.com/shows/space-voyages/1003182",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 86,
      name: "Smithsonian Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-12-23",
  },
  {
    id: 3687,
    url: "https://www.tvmaze.com/shows/3687/the-javone-prince-show",
    name: "The Javone Prince Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/18/47425.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/18/47425.jpg",
    },
    summary:
      "<p>Stand-up, sketches and live music. <i>Javone</i> gives his take on modern-day life in Britain.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-07-19",
  },
  {
    id: 3701,
    url: "https://www.tvmaze.com/shows/3701/outlaws",
    name: "Outlaws",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/209/523671.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/209/523671.jpg",
    },
    summary:
      "<p>Four outlaws in the Old West are hunted down by their former leader, Sheriff Jonathan Grail. Grail corners them at an old Indian cemetery, and a bolt of lightning strikes the five men... transporting them forward a hundred years in time to 1986. Forced to band together, the five men adapt to modern times as best they can and start a company, the Double-Eagle Detective Agency. Helping them is Maggie Randall, a local police officer.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1986-12-28",
  },
  {
    id: 3712,
    url: "https://www.tvmaze.com/shows/3712/she-wolf-of-london",
    name: "She-Wolf of London",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47527.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47527.jpg",
    },
    summary:
      "<p>While touring the UK and planning to meet mythology professor Ian Matheson, graduate student Randi Wallace is bitten by a werewolf. Now when the full is moon, Randi transforms into a werewolf herself. With the aid of Ian and his unwitting family, Randi and Ian investigate other supernatural incidents in England. After 14 episodes, the joint-production UK/American crew migrated to L.A. where Ian got a job as a talk-show host and acquired an agent, Skip Seville. The show was retitled <i>Love and Curses</i>, and was cancelled after six more episodes.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1990-10-09",
  },
  {
    id: 3713,
    url: "https://www.tvmaze.com/shows/3713/switch",
    name: "Switch",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47528.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47528.jpg",
    },
    summary:
      "<p>Pete Ryan is a smooth-talking con man, and bunco cop Frank MacBride is the man who put him away. When Pete gets out and Frank retires, they decide to form a detective agency using their knowledge of crime and cons to take down the bad guys. Helping them are their secretary Maggie and Pete's shady acquaintance, Malcolm.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1975-09-09",
  },
  {
    id: 3715,
    url: "https://www.tvmaze.com/shows/3715/hex",
    name: "Hex",
    genres: ["Drama", "Fantasy", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47530.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47530.jpg",
    },
    summary:
      '<p>The show opens with a girl named Cassie who yearns to be popular and liked in her school. She wishes she was in the "in-crowd", however, she goes about unnoticed in school every day. The only girl who truly notices her is her best friend Thelma. For some strange reason though, Cassie feels like she is being followed by a man. This is only the beginning of her problem...</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 63,
      name: "Sky 1",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2004-10-17",
  },
  {
    id: 3719,
    url: "https://www.tvmaze.com/shows/3719/toast-of-london",
    name: "Toast of London",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47539.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47539.jpg",
    },
    summary:
      "<p>Comedy series following Steven Toast, an eccentric middle-aged actor with a chequered past who spends more time dealing with his problems off stage than performing on it.</p>",
    officialSite: "http://www.channel4.com/programmes/toast-of-london",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-08-20",
  },
  {
    id: 3722,
    url: "https://www.tvmaze.com/shows/3722/stephen-kings-it",
    name: "Stephen King's It",
    genres: ["Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47542.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47542.jpg",
    },
    summary:
      "<p>A creature from beyond the stars can take on the shape of your worst fear... or a clown, because everyone loves clowns. Every 27 years the creature--It--emerges from hibernation to feed on children. But seven children stopped It during its last cycle. Now It is back, and the children who had the power of faith and imagination are 27 years older... and may be easy prey.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1990-11-18",
  },
  {
    id: 3724,
    url: "https://www.tvmaze.com/shows/3724/tenspeed-and-brown-shoe",
    name: "Tenspeed and Brown Shoe",
    genres: ["Comedy", "Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47552.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47552.jpg",
    },
    summary:
      '<p>Lionel Whitney is an accountant fascinated by the noir detective novels of fictional PI Mark Savage. During the events leading up to his wedding, Lionel crosses paths with E.L. "Tenspeed" Turner, a smooth-talking fast-thinking con artist. When Tenspeed needs a job to make parole, Lionel fulfills his life\'s ambition, start a detective agency, and hires Tenspeed as his partner. Now the two men take on whatever cases come their way.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1980-01-27",
  },
  {
    id: 3730,
    url: "https://www.tvmaze.com/shows/3730/a-gentlemans-dignity",
    name: "A Gentleman's Dignity",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47618.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47618.jpg",
    },
    summary:
      "<p><b>A Gentleman's Dignity</b> is a drama about the careers and love lives of urban professionals. It tells the story of four men in their forties as they go through love, breakup, success and failure. Kim Do Jin, an architect with a scathing tongue, has a romantic relationship with strict high school teacher Seo Yi Soo, who moonlights as an umpire at amateur baseball games. Im Tae San is dating a cold-hearted woman but wonders if there is someone else out there for him. Choi Yoon tries to heal his heart after losing his wife seven years ago. Lee Jung-rok marries an older woman for money but may lose his comfortable lifestyle in a divorce.</p>",
    officialSite: "http://tv.sbs.co.kr/sinsa/",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 127,
      name: "SBS",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2012-05-26",
  },
  {
    id: 3736,
    url: "https://www.tvmaze.com/shows/3736/wallykazam",
    name: "Wallykazam!",
    genres: ["Comedy", "Adventure", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47646.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47646.jpg",
    },
    summary:
      "<p><b>Wallykazam!</b> is about Wally Trollman is an adventurous 6-year-old troll with a power that lets him make words come to life using a magic stick. Wally uses those words to transform the world around him by creating objects that start with the same letter as the first letter in the word he has animated -- such as creating a castle and catapult out of words that begin with C. Wally uses his magic for more than fun, though; he uses it to solve problems, help friends, and overcome the antics of resident troublemaker Bobgoblin. But the young troll must be careful because his magic stick sometimes creates unexpected results that can make the entire forest go dark or send his house galloping away. Going with Wally on his adventures are pet dragon Norville and friends Gina Giant, Ogre Doug and Libby Light Sprite.</p>",
    officialSite: "http://www.nickjr.com/wallykazam/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 206,
      name: "Nick Jr.",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-02-03",
  },
  {
    id: 3739,
    url: "https://www.tvmaze.com/shows/3739/the-alfred-hitchcock-hour",
    name: "The Alfred Hitchcock Hour",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47747.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47747.jpg",
    },
    summary:
      "<p>Previously <i>Alfred Hitchcock Presents</i>, the series expanded to an hour. Master of the macabre Alfred Hitchcock introduces and concludes tales of suspense and crime. Hitchcock's speeches are filled with black humor and jabs at his network sponsors.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1962-09-20",
  },
  {
    id: 3745,
    url: "https://www.tvmaze.com/shows/3745/the-bachelor-australia",
    name: "The Bachelor Australia",
    genres: ["Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/125/314893.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/125/314893.jpg",
    },
    summary:
      "<p><b>The Bachelor Australia</b> is an Australian adaption of the U.S. series of the same name.</p>",
    officialSite: "http://tenplay.com.au/channel-ten/the-bachelor",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 149,
      name: "Network 10",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2013-09-08",
  },
  {
    id: 3755,
    url: "https://www.tvmaze.com/shows/3755/top-coppers",
    name: "Top Coppers",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47774.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47774.jpg",
    },
    summary:
      "<p>Action-packed cop-show comedy that follows the adventures of detectives John Mahogany and Mitch Rust as they attempt to rid the fictional world of Justice City of its deranged criminal underworld.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b066vv61",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-08-19",
  },
  {
    id: 3757,
    url: "https://www.tvmaze.com/shows/3757/ice-road-rescue",
    name: "Ice Road Rescue",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/269/672718.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/269/672718.jpg",
    },
    summary:
      "<p>The mountain passes of Norway are some of the most dangerous roads in all of Europe.</p><p>And when winter hits, the transport roads turn into treacherous bobsleigh tracks with trucks and cars skidding and sliding everywhere, blocking vital trade routes and in extreme cases, causing fatal accidents.</p><p>But never fear, up and down Norway there are brigades of brave rescue workers, who work around the clock to keep the roads safe and open.</p><p>It takes a special breed of men to pull off the perfect <b>Ice Road Rescue</b>...from a driver smuggling nappies (of all things!) out of Norway, to a truck in trouble full of fresh fish threatening to go bad – the rescue teams of Norway have their work cut out in this nail-biting series!</p>",
    officialSite:
      "https://www.natgeotv.com/no/serier/natgeo/vinterveiens-helter-norge",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 1288,
      name: "National Geographic",
      country: { name: "Norway", code: "NO", timezone: "Europe/Oslo" },
    },
    premiered: "2015-08-31",
  },
  {
    id: 3761,
    url: "https://www.tvmaze.com/shows/3761/time-crashers",
    name: "Time Crashers",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47803.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47803.jpg",
    },
    summary:
      "<p>Ten celebrities are about to leave their 21st century lives to become <i>time</i> travellers in <i>Channel 4</i> s brand new entertainment series.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-08-23",
  },
  {
    id: 3762,
    url: "https://www.tvmaze.com/shows/3762/alan-carr-chatty-man",
    name: "Alan Carr: Chatty Man",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/32/80636.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/32/80636.jpg",
    },
    summary:
      "<p>Alan Carr's chat show, packed with celebrity guests, topical showbiz news and highlights from the world of telly and the web.</p>",
    officialSite: "http://www.channel4.com/programmes/alan-carr-chatty-man",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-06-14",
  },
  {
    id: 3766,
    url: "https://www.tvmaze.com/shows/3766/join-or-die-with-craig-ferguson",
    name: "Join or Die with Craig Ferguson",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/45/114193.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/45/114193.jpg",
    },
    summary:
      "<p><b>Join or Die with Craig Ferguson</b> features the comedian debating provocative and timely topics in his unorthodox and iconoclastic manner. Each episode features a panel of guests which will include celebrities, comedians and experts, as well as the American public through social media. Topics will include: biggest presidential campaign flop, greatest founding father and which invention was history's greatest game-changer.</p>",
    officialSite:
      "http://www.history.com/shows/join-or-die-with-craig-ferguson",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2016-02-18",
  },
  {
    id: 3767,
    url: "https://www.tvmaze.com/shows/3767/archie-bunkers-place",
    name: "Archie Bunker's Place",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47887.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47887.jpg",
    },
    summary:
      "<p>Archie opens up a tavern in Queens complete with a liberal new business partner Murray Klein.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1979-09-23",
  },
  {
    id: 3768,
    url: "https://www.tvmaze.com/shows/3768/years-of-living-dangerously",
    name: "Years of Living Dangerously",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47893.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47893.jpg",
    },
    summary:
      "<p>This groundbreaking documentary event series explores the human impact of climate change. From the damage wrought by Hurricane Sandy to the upheaval caused by drought in the Middle East, <b>Years of Living Dangerously</b> combines the blockbuster storytelling styles of top Hollywood movie makers with the reporting expertise of Hollywood's brightest stars and today's most respected journalists.</p><p>National Geographic Channel (NGC) (@NatGeoChannel) and The Years Project announced today, 17 September 2015 the return of the Emmy® award-winning documentary series Years of Living Dangerously, a thought-provoking and ambitious cinematic television event that will delve even deeper into the highly debated issue of climate change. The new season of the critically acclaimed series will air exclusively on NGC in 2016 in 171 countries and 45 languages. Years of Living Dangerously will once again feature some of Hollywood's biggest influencers who are passionate about environmental issues, and will reveal emotional and hard-hitting accounts of the effects of climate change from across the planet.</p><p>Correspondents will include Jack Black, Ty Burrell, James Cameron, Thomas Friedman, Joshua Jackson, David Letterman, Aasif Mandvi, Olivia Munn, Arnold Schwarzenegger, Ian Somerhalder andCecily Strong— with more names to be announced soon — all giving first-person accounts from locations, shockingly close to home, where the effects of climate change are most prevalent. They will cover crucial issues like severe hurricanes, historic droughts and the rapidly increasing extinction rate of our planet's wildlife. The result will be a gritty and raw look at not only how our species has impacted our planet, but also how we can save it for future generations.</p><p>The Emmy-winning climate change series, returns for a second season. From Executive Producers James Cameron, Jerry Weintraub, and Arnold Schwarzenegger, the new season premiers on National Geographic Channel at a special date and time on Sunday, October 30, at 8/7c, before moving to its regularly scheduled time of Wednesday's at 10/9c.</p><p>Season two correspondents will include David Letterman, Narendra Modi, Cecily Strong, Jack Black, Ian Somerhalder, Gisele Bündchen, Ty Burrell, Arnold Schwarzenegger, Thomas Friedman, Nikki Reed, Aasif Mandvi, Bradley Whitford, America Ferrera, Sigourney Weaver.</p>",
    officialSite: "http://yearsoflivingdangerously.com",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-04-13",
  },
  {
    id: 3770,
    url: "https://www.tvmaze.com/shows/3770/ross-kemp-on-gangs",
    name: "Ross Kemp on Gangs",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47900.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47900.jpg",
    },
    summary:
      "<p><b>Ross Kemp on Gangs</b> sees former star of BBC's Eastenders and journalist Ross Kemp travelling the world and meeting with some of the most dangerous people in the world. Thanks to the determination and dedication of the team that made this series, it was rightly awarded a BAFTA in 2007 for 'Best Factual Series'.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 63,
      name: "Sky 1",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-06-08",
  },
  {
    id: 3771,
    url: "https://www.tvmaze.com/shows/3771/the-real-football-factories",
    name: "The Real Football Factories",
    genres: ["Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47902.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47902.jpg",
    },
    summary: "<p>Documentary about hooligan firms in the UK.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 326,
      name: "Bravo",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-05-11",
  },
  {
    id: 3772,
    url: "https://www.tvmaze.com/shows/3772/the-real-football-factories-international",
    name: "The Real Football Factories International",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47904.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47904.jpg",
    },
    summary: "<p>Documentary about hooligan firms all around the globe.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 326,
      name: "Bravo",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2007-05-21",
  },
  {
    id: 3775,
    url: "https://www.tvmaze.com/shows/3775/the-chronicle",
    name: "The Chronicle",
    genres: ["Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47912.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47912.jpg",
    },
    summary:
      "<p>Fresh young reporter Tucker Burns gets a job with <b>The Chronicle</b>, a tabloid newspaper that publishes stories about aliens and headless horsemen. He soon discovers that <i>The Chronicle</i> isn't making up its stories, and helps investigate all matter of supernatural occurrences.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-07-14",
  },
  {
    id: 3776,
    url: "https://www.tvmaze.com/shows/3776/the-fbi",
    name: "The F.B.I.",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47920.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47920.jpg",
    },
    summary:
      "<p>Agent Lewis Erskine and Special Agent Jim Rhodes rely on real-life FBI detection techniques (and the occasional hunch) as they track lawbreakers ranging from organized crime bosses and extortionists to saboteurs and escaped convicts.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1965-09-19",
  },
  {
    id: 3778,
    url: "https://www.tvmaze.com/shows/3778/the-herculoids",
    name: "The Herculoids",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47925.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47925.jpg",
    },
    summary:
      "<p>Somewhere out in deep space - and out of the creative imagination of the animation aces of Hanna-Barbera Studios - live the Herculoids. Humanoid Zandor, along with his wife Tara and son Dorno, lead a group of unique creatures: Zok the flying dragon, powerful simian Igoo (who possesses rock-like skin), rhinoceros hybrid Tundro, and two protoplasmic wonders appropriately named Gloop and Gleep. Together, they use their diverse super strengths to defend their utopian planet against attack from such sinister invaders as the Pod Creatures, the Reptons, and the Mutoids.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1967-09-09",
  },
  {
    id: 3781,
    url: "https://www.tvmaze.com/shows/3781/farmed-and-dangerous",
    name: "Farmed and Dangerous",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47928.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47928.jpg",
    },
    summary:
      "<p>A Chipotle original comedy series that explores the outrageously twisted and utterly unsustainable world of industrial agriculture.</p>",
    officialSite: "http://farmedanddangerous.com/#",
    webChannel: {
      id: 2,
      name: "Hulu",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2014-02-17",
  },
  {
    id: 3786,
    url: "https://www.tvmaze.com/shows/3786/construction-squad-operation-homefront",
    name: "Construction Squad: Operation Homefront",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/118/295747.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/118/295747.jpg",
    },
    summary:
      "<p>Assembling its very own ‘A-Team' of ex-military personnel for one more tour of duty, the series is spearheaded by former Royal Engineer and Special Forces soldier Kev Godlington. Joining him are a handpicked unit of specialists – Royal Engineer demolitions expert Charlie Brooks, Warrant Officer Taff Evans (aka The Enforcer), Combat Engineer Kaz Smith and Sapper Stu Mendelson.</p><p>Their mission is to use the skills they learned in the forces to rescue ailing community projects across the nation. They will do whatever it takes to get the job done in a matter of days, not weeks. Attempting massive projects that would have a civilian contractor running for cover; can Kev and his ex-military team pull off mission impossible?</p>",
    officialSite:
      "http://www.channel5.com/shows/construction-squad-operation-homefront",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 135,
      name: "Channel 5",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-08-30",
  },
  {
    id: 3787,
    url: "https://www.tvmaze.com/shows/3787/conspiracy-365",
    name: "Conspiracy 365",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47944.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47944.jpg",
    },
    summary:
      "<p>On New Year's Eve, Cal is chased down the street by a staggering sick man with a deadly warning...</p>",
    officialSite: "http://www.conspiracy365.com",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 327,
      name: "Family Movie Channel",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2012-01-14",
  },
  {
    id: 3788,
    url: "https://www.tvmaze.com/shows/3788/the-briefs",
    name: "The Briefs",
    genres: ["Crime", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47945.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47945.jpg",
    },
    summary:
      "<p>A two-part documentary which looks at the cut-throat world of criminal law, with unprecedented access to Britain's busiest legal aid practice, Tuckers in Manchester.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-08-02",
  },
  {
    id: 3789,
    url: "https://www.tvmaze.com/shows/3789/the-happenings",
    name: "The Happenings",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47947.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47947.jpg",
    },
    summary:
      "<p>Illusionists Barry and Stuart set about making the unbelievable believable to the unsuspecting residents of towns across the UK and America. Using magic, misdirection and suggestion, they slowly create a rumour amongst the town folk that something extraordinary is happening in the quiet place they call home. Creating a whirlwind of press interest and buzz among the town's unsuspecting residents they go about creating weird and wonderful stories similar to a movie experience as ghosts, alien invasions, vampires and a secret psychic army take over.</p>",
    officialSite: "http://channel.nationalgeographic.com/the-happenings/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-12-09",
  },
  {
    id: 3790,
    url: "https://www.tvmaze.com/shows/3790/aliens-in-america",
    name: "Aliens in America",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: null,
    summary:
      "<p><b>Aliens in America</b> chronicles alien encounters that are reported by people from across America. Each one-hour episode documents three stories, including those of: two men in South Carolina, who survived an extraordinary alien abduction; twin sisters, who were used as a breeders for aliens; cold-blooded, sewer-dwelling reptoids, which are said to lurk beneath Los Angeles; one couple, who claims they survived a terrifying abduction; two police helicopter pilots, who find themselves in air combat with a UFO trying to shoot them down; and one man, who endures the unthinkable on a nightly basis.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 107,
      name: "Destination America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-17",
  },
  {
    id: 3791,
    url: "https://www.tvmaze.com/shows/3791/indian-food-made-easy",
    name: "Indian Food Made Easy",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47952.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47952.jpg",
    },
    summary:
      "<p>Anjum Anand teaches novice cooks how to cook delicious, healthy Indian food.</p>",
    officialSite: "http://www.bbc.co.uk/food/programmes/b007szxr",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2007-07-09",
  },
  {
    id: 3792,
    url: "https://www.tvmaze.com/shows/3792/inquisition",
    name: "Inquisition",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47956.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47956.jpg",
    },
    summary:
      "<p><b>Inquisition</b> is a shocking four-part series exploring bloody and menacing persecutions of heresy from history.</p>",
    officialSite: "http://yesterday.uktv.co.uk/shows/inquisition/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 345,
      name: "Yesterday",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-07-16",
  },
  {
    id: 3793,
    url: "https://www.tvmaze.com/shows/3793/instant-restaurant",
    name: "Instant Restaurant",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/175/439674.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/175/439674.jpg",
    },
    summary:
      "<p>Two amateur cooks go head to head to see if they've got what it takes to create a restaurant in their own homes for one night only - and make a profit.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00r0tj5",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-02-15",
  },
  {
    id: 3794,
    url: "https://www.tvmaze.com/shows/3794/instruments-of-death",
    name: "Instruments of Death",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47958.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47958.jpg",
    },
    summary:
      "<p><i><b>\"Instruments of Death\"</b></i> is the gripping series that places some of history's deadliest weapons in your hands. Through a series of innovative tests and modern experiments, viewers get a close look at the effects of blades and bullets on the human body. Ever wonder what it would have been like to take a crushing blow from a battle-axe or be struck by a deadly arrow? Wonder no more. It can be gruesome to watch, but it's always compelling.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 118,
      name: "History",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2012-04-01",
  },
  {
    id: 3795,
    url: "https://www.tvmaze.com/shows/3795/london-irish",
    name: "London Irish",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47960.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47960.jpg",
    },
    summary:
      "<p>Comedy series following the antics of four Northern Irish Twenty-somethings living in London.</p>",
    officialSite: "http://www.channel4.com/programmes/london-irish",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-09-24",
  },
  {
    id: 3796,
    url: "https://www.tvmaze.com/shows/3796/love-matters",
    name: "Love Matters",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47962.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47962.jpg",
    },
    summary:
      "<p>Introducing... <b>Love Matters</b>, written by and starring some of the leading lights on the UK comedy scene, <i>Love Matters</i> is a season of six stand-alone comedies. Starting from Thursday 28th March, each week two perfectly paired half-hour films will paint a picture of real romance in the 21st century.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 44,
      name: "Sky Witness",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-03-28",
  },
  {
    id: 3797,
    url: "https://www.tvmaze.com/shows/3797/the-marriage-of-reason-and-squalor",
    name: "The Marriage of Reason and Squalor",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48110.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48110.jpg",
    },
    summary:
      "<p>Rhys Ifans and Sophie Kennedy Clark star in Turner Prize-nominated visual artist Jake Chapman's wildly-imaginative, hypnotic and strangely unsettling drama.<br><br>In the highly original twisted 'romance', our heroine Lydia has been gifted a desert island by her fiancée as a wedding present. She goes to the island to wait for him but meets Helmut, a reclusive and misshapen author who exerts a strange control over her. Battling with her emotions, Lydia begins to suspect that all is not what it seems on the island...</p>",
    officialSite:
      "http://www.sky.com/tv/show/the-marriage-of-reason-and-squalor",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 69,
      name: "Sky Arts",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-06-11",
  },
  {
    id: 3798,
    url: "https://www.tvmaze.com/shows/3798/maximum-choppage",
    name: "Maximum Choppage",
    genres: ["Comedy", "Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47964.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47964.jpg",
    },
    summary:
      "<p>Simon Chan has returned to his hometown after many years training in a faraway martial arts temple. He is a born hero, defender of the weak and champion of the honest people of Cabramatta... Well, not really. For Simon, it's only a matter of time before everyone discovers he's just an ordinary guy, because Simon has a secret. Whilst everyone thinks he was training at a legendary martial arts school in Beijing, the truth is Simon was at Marshall's Art School, in Melbourne. Now back in Cabramatta, armed with a fistful of pastels and a crippling sense of obligation, Simon knows that eventually the truth will hurt... literally. He could lose his life - or worse - disappoint his mother. The world Simon returns to is familiar yet oddly different to the Cabramatta you may know. It's a mix of Asian traditions, absurd superstition and colourful contradictions. A world where brutal gangs terrorise the community with violence and bad karaoke singing; where a magical duck recipe can cast a horny spell and where pirated DVD's are the new crack cocaine. In this town, evil spirits attack nail-and-beauty parlours, council debates are settled via K-Pop dance battles and car parking spots are more valuable than gold. The only thing that stands against all this craziness is Simon. When the ferocious gang leader/karaoke singer Kai Le threatens to destroy his mother's beauty parlour-cum-DVD shop, Simon is joined by his two best friends: Egg, a quick-buck entrepreneur and Petal, a groin-kicking kung fu girl. But can they really protect Simon's family from the Kylie Minogue obsessed gang lord? Will they uncover the corrupt Mayo's secret plan for the town? And can Simon keep his mind off the mayor's daughter for long enough to be (or at least pretend to be) the person everyone thinks he is? Cabramatta needs a hero. Instead they got Simon, Egg and Petal. Welcome to <i>Maximum Choppage</i>, a painfully funny 6 x 30 min comedy series.</p>",
    officialSite: "http://www.abc.net.au/tv/programs/maximum-choppage/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 114,
      name: "ABC",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2015-02-24",
  },
  {
    id: 3799,
    url: "https://www.tvmaze.com/shows/3799/murder-in-successville",
    name: "Murder in Successville",
    genres: ["Comedy", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47966.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47966.jpg",
    },
    summary:
      "<p>Successville is a surreal place with a high celebrity homicide count.</p><p>Each week Successville's loveable detective DI Sleet enlists the help of a celebrity sidekick to solve the latest high-profile murder in this improvised comedy murder mystery series.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b07h1mnp",
    webChannel: {
      id: 71,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-05-06",
  },
  {
    id: 3800,
    url: "https://www.tvmaze.com/shows/3800/murder-on-the-home-front",
    name: "Murder on the Home Front",
    genres: ["Drama", "Crime", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47967.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47967.jpg",
    },
    summary:
      "<p><b>Murder on the Home Front</b> is a two-part drama series based on on the memoirs of Molly Lefebure, the secretary to the Home Office Pathologist, Keith Simpson and is set during the London Blitz of World War II.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-05-09",
  },
  {
    id: 3801,
    url: "https://www.tvmaze.com/shows/3801/vet-school",
    name: "Vet School",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/25/64100.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/25/64100.jpg",
    },
    summary:
      "<p>Grab your stethoscope, leave your nerves at the door and step into the high-pressure, big-reward world at one of the top vet schools in the country, Cornell University College of Veterinary Medicine. Follow along with the first-year students who are learning to master the basics and fourth-year students, handling difficult cases from hamsters to horses. Students must quickly master tasks including restraining animals, repairing a bone fracture in a horse's leg, inserting a pacemaker into a dog and removing an abscess from a pet turkey. All in a day's work for <b>Vet School</b>.</p>",
    officialSite: "http://channel.nationalgeographic.com/wild/vet-school/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 83,
      name: "National Geographic WILD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-19",
  },
  {
    id: 3802,
    url: "https://www.tvmaze.com/shows/3802/off-their-rockers",
    name: "Off Their Rockers",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47968.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47968.jpg",
    },
    summary:
      "<p><b>Off Their Rockers </b>is a hidden camera series that sees senior citizens attempting to turn the tables on unsuspecting members of the public in different hilarious and unexpected pranks.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-04-08",
  },
  {
    id: 3803,
    url: "https://www.tvmaze.com/shows/3803/open-slather",
    name: "Open Slather",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47971.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47971.jpg",
    },
    summary:
      "<p>The biggest names in Australian comedy are joining forces with a group of rising new stars for <b>Open Slather</b>, Foxtel's highly anticipated, original production. Creating a comedy ‘hot pot', Open Slather casts a satirical eye across the pop culture landscape and combines the talents of comedy legends who have made us laugh for years, (Glenn Robbins, Magda Szubanski, Shane Jacobson, Marg Downey, Gina Riley, Stephen Curry, Michael Veitch and Jane Turner) with 12 rising stars including Ben Gerrard, Ben Lomas, Dave Eastgate, Demi Lardner, Emily Taheny, George H. Xanthis, Hannah Bath, Holly Austin, Ilai Swindells, Jay K Cagatay, Laura Hughes and Miles O'Neil. Filmed in Melbourne, Open Slather will be a no holds barred send up of popular culture, politics, sport, music and media – all the things that capture the imagination of the public and get people laughing.</p>",
    officialSite: "http://www.thecomedychannel.com.au/shows/open-slather/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 330,
      name: "FOX Comedy",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2015-05-24",
  },
  {
    id: 3804,
    url: "https://www.tvmaze.com/shows/3804/pat-cabbage",
    name: "Pat & Cabbage",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47975.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47975.jpg",
    },
    summary:
      "<p><i><b>\"Pat &amp; Cabbage\"</b></i> is a comedy about the ever-changing generation shifts in today's modern world. Finding themselves single for the first time in decades, <i>Pat &amp; Cabbage</i> have finally acquired financial, familial and moral freedom and they're exploiting it to the max. Pat and her best friend Cabbage have no intention of growing old gracefully - although their children really wish they would.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-09-05",
  },
  {
    id: 3805,
    url: "https://www.tvmaze.com/shows/3805/rabbids-invasion",
    name: "Rabbids Invasion",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47976.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47976.jpg",
    },
    summary:
      "<p><b>Rabbids Invasion </b>brings to television the hysterical physical comedy that is the hallmark in Ubisoft's wildly successful Rabbids video games. Irreverent, unpredictable and silly, the Rabbids are a mysterious breed of rabbit-like creatures that explore, and often wreak havoc, in the human world. Everything is a source of wonder and amusement, and these indestructible and uncontrollable creatures have absolutely no respect for the social rules that govern society. For them, there are no laws, no rules of the road. It's all about having fun and saying \"Bwaaaaaah!\"</p>",
    officialSite: "http://www.nick.com/rabbids-invasion",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 73,
      name: "Nicktoons",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-08-03",
  },
  {
    id: 3806,
    url: "https://www.tvmaze.com/shows/3806/raised-by-wolves",
    name: "Raised by Wolves",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/213/532542.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/213/532542.jpg",
    },
    summary:
      "<p>Comedy series written by Caitlin and Caroline Moran, set on a Wolverhampton council estate and follows six socially-isolated homeschooled siblings and their formidable single mother., it's a modern-day reimagining of the brilliant chaos of the Morans' own childhood</p>",
    officialSite: "http://www.channel4.com/programmes/raised-by-wolves",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-03-16",
  },
  {
    id: 3808,
    url: "https://www.tvmaze.com/shows/3808/small-time-gangster",
    name: "Small Time Gangster",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47984.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47984.jpg",
    },
    summary:
      "<p>Wickedly funny and totally addictive, <b>Small Time Gangster</b> follows the journey of Tony Piccolo, an average Aussie bloke who works hard to support his wife and two kids. They think he's a whizz at cleaning carpets – but Tony's real profession, as a brutal standover man, takes ‘cleaning' to a whole new level. When his two worlds collide, he's going to need a damn sight more than cleaning fluid to clear up the mess.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 140,
      name: "SBS",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2011-04-19",
  },
  {
    id: 3809,
    url: "https://www.tvmaze.com/shows/3809/starlings",
    name: "Starlings",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47985.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47985.jpg",
    },
    summary:
      '<p><i><b>"Starlings"</b></i> follows the lives of a typical working-class brood who live near Matlock in Derbyshire. Granddad has recently moved in, following a rabble-rousing incident at the old folks\' home. Rather than see him unhappy, Terry and his warm-hearted wife, Jan, decide to move his father in to their already crammed family home.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 63,
      name: "Sky 1",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-05-13",
  },
  {
    id: 3810,
    url: "https://www.tvmaze.com/shows/3810/sunnyside",
    name: "Sunnyside",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47987.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47987.jpg",
    },
    summary:
      "<p>Welcome to <b>Sunnyside</b>, the not-so-typical neighbourhood where anything can happen, and almost always does.</p><p>From hipsters and yoga moms to meth addicts and romantic crooks, <i>Sunnyside</i> is a quirky neighbourhood in transition, where residents aren't always what they seem and surprises lurk around every slightly dingy corner. Book clubs and coffee shops are just steps away from speakeasies and an underground baby-fighting ring. Plus, this odd little world has just a touch of magic in it, including an occult store that can alter reality, a superhero shopping cart that comes to the rescue, and a mysterious manhole that can answer residents' burning questions.</p><p>Life might have a dark side, but we never lose sight of the <i>Sunnyside</i>.</p><p><i>Sunnyside</i> is a sketch-comedy series created by award winners Gary Pearson and Dan Redican and stars top Canadian comedic talent, including Kathleen Phillips and Pat Thornton.</p>",
    officialSite: "http://www.citytv.com/toronto/shows/sunnyside/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 151,
      name: "Citytv",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2015-01-08",
  },
  {
    id: 3811,
    url: "https://www.tvmaze.com/shows/3811/the-suspicions-of-mr-whicher",
    name: "The Suspicions of Mr. Whicher",
    genres: ["Drama", "Crime", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47988.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47988.jpg",
    },
    summary:
      "<p><b>The Suspicions of Mr. Whicher </b>is based on Kate Summerscale's account of a Victorian murder case that shocked the whole country. Detective Inspector Jack Whicher finds himself traveling to a remote country house where he investigates the murder of a young child. He soon manages to discover a web of lies and concealment amid the family living there, which he thinks vindicates the police's chief suspect in the murder case.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-04-25",
  },
  {
    id: 3812,
    url: "https://www.tvmaze.com/shows/3812/talking-to-the-dead",
    name: "Talking to the Dead",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47995.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47995.jpg",
    },
    summary:
      "<p>In <b>Talking to the Dead</b>, Sophie Rundle plays a young rookie cop with a brilliant mind, a mysterious past and a deep empathy with the dead. The drama also features Russell Tovey, Keith Allen and Michael Smiley.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 44,
      name: "Sky Witness",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-10-15",
  },
  {
    id: 3814,
    url: "https://www.tvmaze.com/shows/3814/this-is-littleton",
    name: "This is Littleton",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/47999.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/47999.jpg",
    },
    summary:
      "<p>An exhaustive nationwide search has secured a new generation of comedy talent...The four-part character-based sketch comedy series, This is Littleton showcases Australia's brightest new comedy talent.</p>",
    officialSite: "http://www.abc.net.au/tv/programs/this-is-littleton/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 114,
      name: "ABC",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2014-02-20",
  },
  {
    id: 3815,
    url: "https://www.tvmaze.com/shows/3815/tractor-monkeys",
    name: "Tractor Monkeys",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48000.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48000.jpg",
    },
    summary:
      "<p>Join host Merrick Watts and team captains Dave O'Neil and Monty Dimond as they go back through time to celebrate Australia at its best and best forgotten during the hilarious new season. #TractorMonkeys</p>",
    officialSite: "http://www.abc.net.au/tv/programs/tractor-monkeys/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 114,
      name: "ABC",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2012-03-20",
  },
  {
    id: 3817,
    url: "https://www.tvmaze.com/shows/3817/yes-prime-minister",
    name: "Yes, Prime Minister",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48004.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48004.jpg",
    },
    summary:
      "<p>Following on directly from <i>Yes, Minister</i> and set after Jim Hacker's unexpected general election win, <b>Yes, Prime Minister</b> sees Jim Hacker become more statesmanlike, with grand ideas and grand speeches, that still land him into trouble.</p>",
    officialSite: "http://gold.uktv.co.uk/shows/yes-prime-minister/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 388,
      name: "Gold",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-01-15",
  },
  {
    id: 3818,
    url: "https://www.tvmaze.com/shows/3818/your-face-sounds-familiar",
    name: "Your Face Sounds Familiar",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48005.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48005.jpg",
    },
    summary:
      "<p><b>Your Face Sounds Familiar</b> is a talent competition where a group of well known personalities take on a new identity as an iconic music performer. Every week, the celebrities find out who they have to impersonate by simply pressing a buzzer. But the catch is they could find themselves transformed into someone far older, younger or even of the opposite sex. A panel of judges and competing celebrities award points based on singing, style and believability. There are no eliminations. The scores are tallied in each show, ranking the contestants from first to last. After each performance, the celebrities must press the buzzer again to find out who they will impersonate the following week. Towards the end, only the four celebrities who accumulated the most points throughout the show qualify for the series final. After their very last performance, the celebrity with the most points receives th...</p>",
    officialSite: null,
    webChannel: null,
    language: "Bulgarian",
    status: "Running",
    network: {
      id: 332,
      name: "Nova TV",
      country: { name: "Bulgaria", code: "BG", timezone: "Europe/Sofia" },
    },
    premiered: "2013-03-13",
  },
  {
    id: 3819,
    url: "https://www.tvmaze.com/shows/3819/house-vs-house",
    name: "House vs. House",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755427.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755427.jpg",
    },
    summary:
      "<p><b>House vs. House</b> is a new home makeover competition series where amateur and experienced renovation teams compete for the chance to win $10,000 by proving they can create the better DIY projects in their home. From painting and decorating, to one-of-a-kind, imaginative projects, each episode features two teams will go head-to-head in grueling challenges. Tanya McQueen, a DIY design expert, and David Brian Sanders, an architect and designer, will determine which team completes the most impressive transformation and award the cash prize.</p>",
    officialSite: "http://www.fyi.tv/shows/house-vs-house",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 125,
      name: "FYI,",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-22",
  },
  {
    id: 3820,
    url: "https://www.tvmaze.com/shows/3820/dora-and-friends-into-the-city",
    name: "Dora and Friends: Into the City!",
    genres: ["Comedy", "Adventure", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/75/188155.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/75/188155.jpg",
    },
    summary:
      '<p>Young viewers and parents familiar with Dora, Diego and the rest of the "Dora the Explorer" gang have new characters to learn about, as Dora heads to school in the city of Playa Verde. She works alongside her friends to give back to the community, while going on a variety of adventures. Her pals include artistic Kate, intelligent Naiya, musical Emma, athletic Alana and playful Pablo. Also helping Dora solve mysteries is new technology; rather than relying on a paper map, she now navigates the city using a map app on her smartphone, and overcomes obstacles with the aid of a magical charm bracelet in <b>Dora and Friends: Into the City!</b></p>',
    officialSite: "http://www.nickjr.com/dora-and-friends/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 206,
      name: "Nick Jr.",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-08-18",
  },
  {
    id: 3822,
    url: "https://www.tvmaze.com/shows/3822/taken",
    name: "Taken",
    genres: ["Action", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/137/343530.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/137/343530.jpg",
    },
    summary:
      "<p>From Executive Producer Luc Besson comes a thrilling new addition to his iconic blockbuster action-film franchise. This new, modern-day, edge-of-your-seat thriller follows the origin story of younger, hungrier, former Green Beret Bryan Mills as he deals with a personal tragedy that shakes his world. As he fights to overcome the incident and exact revenge, Mills is pulled into a career as a deadly CIA operative, a job that awakens his very particular, and very dangerous, set of skills.</p>",
    officialSite: "http://www.nbc.com/taken",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2017-02-27",
  },
  {
    id: 3823,
    url: "https://www.tvmaze.com/shows/3823/dog-with-a-blog",
    name: "Dog with a Blog",
    genres: ["Drama", "Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48043.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48043.jpg",
    },
    summary:
      "<p><b>Dog with a Blog </b>is a sitcom that is told from the pup's perspective. The show is about a newly blended family led by parents Bennett and Ellen, whose kids--Tyler, Avery and Chloe--are trying to adjust to life as stepsiblings. Tyler and Avery are typical teenagers and are slowly learning to communicate with each other. When they discover a secret about the family's recently adopted pet dog, Stan, they decide to keep it a secret -- even from their parents. What is Stan's secret? He talks and blogs. Complicating their attempt to keep the secret is younger sister Chloe, who thinks it's normal to have a talking pooch after she overhears him. But thankfully the parents just chalk it up to Chloe's overactive imagination. As for Stan, he has a knack for getting himself, Tyler and Avery into sticky situations, which helps teach the kids how important family is and how much they need to work together to keep Stan's secret safe.</p>",
    officialSite: "http://disneychannel.disney.com/dog-with-a-blog/blog",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 78,
      name: "Disney Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-10-12",
  },
  {
    id: 3824,
    url: "https://www.tvmaze.com/shows/3824/i-love-lucy",
    name: "I Love Lucy",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48076.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48076.jpg",
    },
    summary:
      "<p><b>I Love Lucy</b> follows the antics of stay-at-home mom Lucy Ricardo as she tries to outsmart her Cuban band-leader husband, Ricky, and get into show business. Along the way she usually ends up dragging her landlords and best friends, Fred and Ethel Mertz, into one of her wacky schemes which can create some hilarious situations.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1951-03-02",
  },
  {
    id: 3825,
    url: "https://www.tvmaze.com/shows/3825/the-honeymooners",
    name: "The Honeymooners",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48082.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48082.jpg",
    },
    summary:
      "<p>Ralph Kramden is a New York bus driver who dreams of a better life. With his eccentric good friend, Ed Norton the sewer worker, he constantly tries crackpot schemes to strike it rich. All the while, his exasperated wife, Alice, is always there to bring him down to earth or to pick him up if he beats her to it. For as much as they fight, even dunderhead Ralph knows that she is the greatest and vice versa.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1952-09-20",
  },
  {
    id: 3826,
    url: "https://www.tvmaze.com/shows/3826/weird-science",
    name: "Weird Science",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48090.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48090.jpg",
    },
    summary:
      "<p><b>Weird Science</b> is a show based on the 1985 John Hughes movie of the same name. High school geeks Wyatt Donnelly and Gary Wallace create their dream girl, a magical genie named Lisa, on Wyatt's computer. Having a genie leads up to five seasons of unique adventures for the guys.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1994-03-05",
  },
  {
    id: 3827,
    url: "https://www.tvmaze.com/shows/3827/respectable",
    name: "Respectable",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48092.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48092.jpg",
    },
    summary:
      "<p>Created by late comedy writer Harry Thompson, Respectable is a comedy series about several women working and bonding at a suburban brothel, which is run by a chainsmoking grandma who has seen everything.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 135,
      name: "Channel 5",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-08-30",
  },
  {
    id: 3828,
    url: "https://www.tvmaze.com/shows/3828/titchmarsh-on-capability-brown",
    name: "Titchmarsh on Capability Brown",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/160/401806.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/160/401806.jpg",
    },
    summary:
      "<p>Alan Titchmarsh celebrates the 300th anniversary of his horticultural hero by helping create one of Brown's lost masterpieces at Belvoir Castle, Leicestershire.</p>",
    officialSite:
      "http://www.channel4.com/programmes/titchmarsh-on-capability-brown",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-09-17",
  },
  {
    id: 3829,
    url: "https://www.tvmaze.com/shows/3829/con-man",
    name: "Con Man",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/88/220561.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/88/220561.jpg",
    },
    summary:
      "<p><b>Con Man</b> centers on the post-show life of Wray Nerely the co-star of <i>Spectrum</i>, a sci-fi series, which was canceled before its time and went on to become a cult classic beloved by fans. Wray's good friend, Jack Moore, starred as the series' Captain and has gone on to become a major celebrity, while Wray hasn't found his desired level of stardom. Wray is the begrudging guest of sci-fi conventions, comic book store appearances, and different pop culture events; however, everything is not as it seems from the outside. The series will explore these events and all the weird and crazy things that happen to them along the way.</p>",
    officialSite: "http://conmantheseries.com/",
    webChannel: { id: 106, name: "Comic-Con HQ", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-09-30",
  },
  {
    id: 3830,
    url: "https://www.tvmaze.com/shows/3830/descendants-wicked-world",
    name: "Descendants: Wicked World",
    genres: ["Adventure", "Children", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48121.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48121.jpg",
    },
    summary:
      "<p><b>Descendants: Wicked World</b> is an animated short-form series based on the Disney Channel movie <i>Descendants</i>. It premiered on September 18, 2015 on the Disney Channel and its digital platforms, including WATCH Disney Channel. The series picks up after the film and introduces new characters. Providing the voices of the animated characters are the movie's stars: Dove Cameron as Mal, Sofia Carson as Evie, Cameron Boyce as Carlos, Booboo Stewart as Jay, Mitchell Hope as Ben, Brenna D'Amico as Jane, Sarah Jeffery as Audrey and Dianne Doan as Lonnie.</p>",
    officialSite:
      "https://www.disneychannel.disney.com/descendants/wicked-world",
    webChannel: {
      id: 83,
      name: "DisneyNOW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: {
      id: 78,
      name: "Disney Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-18",
  },
  {
    id: 3831,
    url: "https://www.tvmaze.com/shows/3831/trauma-seconds-to-live",
    name: "Trauma: Seconds to Live",
    genres: ["Drama", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755428.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755428.jpg",
    },
    summary:
      "<p><b>Trauma: Seconds to Live</b> explores the life-and-death decisions facing doctors in the first critical hour of emergency care. Each one-hour episode features at least three cases, including: a doctor who performs open-heart surgery in the street on a woman in cardiac arrest; an 11-year-old who goes mysteriously blind after being hit by a car; a tree-trimmer who falls 20 feet onto concrete; a motorcyclist who is bleeding to death after a crash; a 77-year-old woman who presents at the hospital with a suspected stroke; and many more critical medical emergencies.</p>",
    officialSite:
      "http://www.discoverylife.com/tv-shows/trauma-seconds-to-live/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 177,
      name: "Discovery Life",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-02",
  },
  {
    id: 3832,
    url: "https://www.tvmaze.com/shows/3832/texas-flip-n-move",
    name: "Texas Flip N' Move",
    genres: ["DIY"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/205/514753.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/205/514753.jpg",
    },
    summary:
      "<p>Three teams of hard working Texas real estate entrepreneurs compete head-to-head in a fast-paced and thrilling real estate flipping competition. Our flippers are under the gun to buy low, work fast and sell high. But they have one major hurdle to overcome, when they buy a house at auction, they have to move it off the property that day, a task that can be downright dangerous. Once the house is moved to their lot, it's a race against time to get it renovated and ready for auction. Who will turn the biggest profit? Who will gamble it all and lose big? Who will destroy their house mid-move? And who will get their chops busted by their annoying rivals on <b>Texas Flip N' Move</b>?</p>",
    officialSite: "http://www.diynetwork.com/shows/texas-flip-and-move",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 90,
      name: "DIY Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-11",
  },
  {
    id: 3833,
    url: "https://www.tvmaze.com/shows/3833/hidden-palms",
    name: "Hidden Palms",
    genres: ["Drama", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48222.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48222.jpg",
    },
    summary:
      "<p>Johnny Miller was a happy, well-adjusted 15-year-old with good grades and a roomful of sports trophies until the terrible night a year ago that his father committed suicide. Now, Johnny lives in the surreal, sun-drenched city of Palm Springs with his mother and her new husband. On the outside, Palm Springs is a shimmering paradise of resorts, swimming pools, golf courses and country clubs. But as Johnny learns the secrets that lie just beneath the surface of this seemingly typical neighborhood, he and his family are forced to ask the question: how well do you really know the people who live right next door?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-05-30",
  },
  {
    id: 3834,
    url: "https://www.tvmaze.com/shows/3834/are-you-there-chelsea",
    name: "Are You There, Chelsea?",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/107/268898.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/107/268898.jpg",
    },
    summary:
      '<p>Do you remember where you were when you had a life-changing realization? (In other words, a DUI?) For Chelsea Newman, it was in the drunk tank at her local jail. And maybe "life-changing" is a slight exaggeration - her version of a wake-up call is realizing that the way to avoid driving drunk is to get an apartment within walking distance from work! But hey, baby steps, right?</p><p>Chelsea is young, strong-willed, and a force of nature determined to live life to the fullest and make no apologies. Her friends are along for the ride, but they all know it\'s Chelsea\'s way or the highway. Her fiery Cuban BFF accuses her of "collecting weirdoes", but to Chelsea, different types of people - including Todd, (a little person) who always has her back - just make life more interesting. Into her posse comes a new roommate who is Chelsea\'s polar opposite (sheltered, shy, a virgin) so you can probably guess which way the influence will go. Chelsea works at her local bar (how appropriate!) where her co-workers are just as crazy as she is.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-01-11",
  },
  {
    id: 3835,
    url: "https://www.tvmaze.com/shows/3835/i-hate-my-teenage-daughter",
    name: "I Hate My Teenage Daughter",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/177/442567.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/177/442567.jpg",
    },
    summary:
      "<p>Two best friends and single moms struggle to raise their difficult and over-privileged teenage daughters.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-11-30",
  },
  {
    id: 3836,
    url: "https://www.tvmaze.com/shows/3836/in-case-of-emergency",
    name: "In Case of Emergency",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48251.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48251.jpg",
    },
    summary:
      "<p>Jason (David Arquette), Harry (Jonathan Silverman), Sherman (Greg Germann) and Kelly (Kelly Hu) are old friends from high school who find themselves at that stage where they realize that their lives havent turned out exactly the way theyd planned. Unhappily divorced greeting card writer Harry goes for a relaxing massage only to discover his scantily clad therapist is Kelly, their high school valedictorian, whos had her own fall from grace. Diet Guru Sherman returns home to discover his wife has left him and taken everything he owns; devastated by the loss, he hijacks a bakery truck and binges on all its contents. Faced with imprisonment for his role in a corporate scandal, financial whiz Jason botches his suicide attempt only to shoot himself in the foot literally.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-01-03",
  },
  {
    id: 3837,
    url: "https://www.tvmaze.com/shows/3837/keeping-up-appearances",
    name: "Keeping Up Appearances",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48263.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48263.jpg",
    },
    summary:
      "<p>Played with aplomb by Patricia Routledge, Hyacinth is a character with few, if any, saving graces. Her pompous, self-serving attitude makes life miserable for all around her.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006xtbg",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1990-10-29",
  },
  {
    id: 3838,
    url: "https://www.tvmaze.com/shows/3838/killer-instinct",
    name: "Killer Instinct",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48271.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48271.jpg",
    },
    summary:
      "<p>Detective Jack Hale took a hiatus from the force when his partner died in the line of duty. Now back at work for the San Francisco Police Department's Deviant Crime Unit, Hale is taking on the bizarre and deviant crimes committed by San Francisco's most aberrant criminals.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-09-23",
  },
  {
    id: 3839,
    url: "https://www.tvmaze.com/shows/3839/the-forgotten",
    name: "The Forgotten",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48272.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48272.jpg",
    },
    summary:
      "<p>A team of dedicated amateurs work on cases involving unidentified victims. After the police have given up, this group must first solve the puzzle of the victim's identity in order to then help catch the killer. They work to give the deceased back their names, lest they become -- <b>The Forgotten</b>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-09-22",
  },
  {
    id: 3840,
    url: "https://www.tvmaze.com/shows/3840/trauma",
    name: "Trauma",
    genres: ["Drama", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48282.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48282.jpg",
    },
    summary:
      "<p>Like an adrenaline shot to the heart, <b>Trauma</b> is the first medical drama series set exclusively where the real action takes place – in the field. Cliff Curtis and Derek Luke star as ambitious heroes dedicated to one of the most dangerous professions in the world: first responder paramedics. When emergencies occur, the trauma team from San Francisco City Hospital is first on the scene, traveling by land, sea or air to reach their victims in time. From the heights of the city's Transamerica Pyramid to the depths of the bay, they must face the most extreme conditions to save lives – and give meaning to their own existence in the process.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-09-28",
  },
  {
    id: 3841,
    url: "https://www.tvmaze.com/shows/3841/iyanla-fix-my-life",
    name: "Iyanla: Fix My Life",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/186/465489.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/186/465489.jpg",
    },
    summary:
      "<p><b>Iyanla: Fix My Life</b> is the reality show you have never seen before. Iyanla Vanzant, accomplished author, inspirational speaker, talk show host and living testament to the value in life's valleys and the power of acting on faith, goes behind closed doors and deep inside people's lives for emotional, rivetingconversations.<br /><br />Iyanla has had a unique life filled with many personal struggles, which she has overcome and used to become stronger. Now, she's back, helping people fix their lives, using her past to help others' futures. Secrets will be revealed, truths will be uncovered and emotions will come out as Iyanla teaches us how topull back the curtain on what is broken in our lives.</p>",
    officialSite: "http://www.oprah.com/app/iyanla-fix-my-life.html",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 236,
      name: "Oprah Winfrey Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-06-02",
  },
  {
    id: 3842,
    url: "https://www.tvmaze.com/shows/3842/oprah-where-are-they-now",
    name: "Oprah: Where Are They Now?",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48293.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48293.jpg",
    },
    summary:
      "<p><b>Oprah: Where Are They Now?</b> is an American reality television series on the Oprah Winfrey Network that takes a look back at what happened to some of the biggest headline makers on The Oprah Winfrey Show plus updates on their current life.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 236,
      name: "Oprah Winfrey Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-10-02",
  },
  {
    id: 3843,
    url: "https://www.tvmaze.com/shows/3843/the-hitchhiker",
    name: "The Hitchhiker",
    genres: ["Drama", "Horror", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48297.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48297.jpg",
    },
    summary:
      "<p><b>The Hitchhiker</b> is a half-hour dramatic anthology series presenting modern morality tales with contemporary players. In 85 chilling stories, men and women struggle with the best and worst in themselves, battling with - and all too often succumbing to - their deepest lusts, obsessions and fears.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1983-11-23",
  },
  {
    id: 3844,
    url: "https://www.tvmaze.com/shows/3844/the-immortal",
    name: "The Immortal",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48299.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48299.jpg",
    },
    summary:
      '<p>Raphael Cain is a 17th century Dutch sailor "blessed" with immortality by the father of his wife. When demons kill her, Raphael swears an oath to walk the earth as long as there are demons left to die. He makes the acquaintance of a young man, Goodwin, who he takes on as his squire. Now in the modern day, Raphael and Goodwin join forces with parapsychologist Dr. Sara Beckman to battle demons wherever they may find them.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-10-07",
  },
  {
    id: 3845,
    url: "https://www.tvmaze.com/shows/3845/the-immortal",
    name: "The Immortal",
    genres: ["Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48301.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48301.jpg",
    },
    summary:
      "<p>Ben Richards is a test car driver who has never been sick and looks twenty years younger than he actually is. When a millionaire receives a blood transfusion from Ben, he discovers that Ben is immune to disease and thus will live 5-10 times longer than a normal human. The millionaire tries to hold Ben captive to use him as a perpetual blood bank. Ben escapes and the millionaire dies, but another one learns of his rare blood and sends a team led by Fletcher to find him. Each week, Ben must stay on the run, avoid his pursuers, and help those he encounters.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 114,
      name: "ABC",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "1970-09-24",
  },
  {
    id: 3846,
    url: "https://www.tvmaze.com/shows/3846/the-master",
    name: "The Master",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48303.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48303.jpg",
    },
    summary:
      "<p>John Peter McAllister, an American veteran, is the only American ever accepted for training as a ninja. He finally leaves his clan to seek out his daughter in America. The ninja consider his abandoning them dishonorable and send one of their own, Osaka, to kill McAllister. Meanwhile, McAllister makes the acquaintance of a young wannabe knight errant, Max Keller, and agrees to train him in the ways of the ninja. As they travel the U.S. in Max's van, Max and McAllister help those that they meet.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1984-01-20",
  },
  {
    id: 3847,
    url: "https://www.tvmaze.com/shows/3847/the-mod-squad",
    name: "The Mod Squad",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48304.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48304.jpg",
    },
    summary:
      "<p>The Mod Squad involved three hipper-than-hip undercover cops with a touch of menace and plenty of attitude. Younger looking than they were, these three police officers were able to earn the confidence of the bad guys, infiltrate their domain, and then bust their backsides while still looking good. <i>Miami Vice </i>was still a decade away. The Mod Squad paved the way for hip and happening PO-lice on TV!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1968-09-24",
  },
  {
    id: 3848,
    url: "https://www.tvmaze.com/shows/3848/the-outsider",
    name: "The Outsider",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755430.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755430.jpg",
    },
    summary:
      "<p>David Ross is a typical PI: an ex-con, alone in the world, few family and friends but many contacts and acquaintances. Ross lives in a cheap apartment and works out of an even cheaper office. But he gets by on his grit and his determination, solving cases for enough money to keep going another day.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1968-09-18",
  },
  {
    id: 3849,
    url: "https://www.tvmaze.com/shows/3849/the-ray-bradbury-theater",
    name: "The Ray Bradbury Theater",
    genres: ["Fantasy", "Horror", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48305.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48305.jpg",
    },
    summary:
      "<p>This anthology series takes each episode from the short stories of fantasist Ray Bradbury, and present tales of horror, science fiction, and sometimes just everyday life. Bradbury opens each episode with a brief visit of his office, and in the earlier seasons provides opening narration as well.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1985-05-21",
  },
  {
    id: 3850,
    url: "https://www.tvmaze.com/shows/3850/cooks-country-from-americas-test-kitchen",
    name: "Cook's Country from America's Test Kitchen",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/272/682494.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/272/682494.jpg",
    },
    summary:
      "<p><i><b>\"Cook's Country from America's Test Kitchen\"</b></i> is a half-hour cooking show distributed to public television stations (reruns airing on Create) in the United States, which are also available in most Canadian markets. The show's hosts are Julia Collin Davison &amp; Bridget Lancaster; the show and the magazine are affiliated, and the magazine's test kitchen facility in Brookline, Massachusetts, is used as a set for the show. <i>Cook's Illustrated'</i>s parent company, Boston Common Press, while retaining its corporate name, has marketed its publishing and media activities under the <i>America's Test Kitchen</i> brand beginning in 2004.</p>",
    officialSite: "https://www.cookscountry.com/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 85,
      name: "PBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-09-06",
  },
  {
    id: 3851,
    url: "https://www.tvmaze.com/shows/3851/to-the-contrary",
    name: "To the Contrary",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/117/294897.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/117/294897.jpg",
    },
    summary:
      "<p><b>To The Contrary</b> (TTC,) public television's successful all-female news analysis series, is now in its 22nd season on air. The program was launched in 1992, dubbed the \"Year of the Woman in American Politics\" as women's representation in Congress blossomed. With women in the forefront of politics and on the cutting edge of national agendas, To The Contrary continues as an essential, timely forum for women to discuss national and international issues and policies. The program covers news and offers a platform to views that are rarely, if ever, available elsewhere on television. It is true appointment television.</p><p>With more women in Congress, in the Cabinet and on the Supreme Court, women's perspectives are more high-profile than ever before. Americans have cast strong votes of confidence in women leaders and leaders who promote concerns embraced by women. To The Contrary, available in 91% of television markets and a leader in women's news and perspectives, will continue to make women's voices heard as we cover all issues affecting women, families and communities of color.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 430,
      name: "World",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2017-01-07",
  },
  {
    id: 3852,
    url: "https://www.tvmaze.com/shows/3852/rodzinkapl",
    name: "Rodzinka.pl",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48322.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48322.jpg",
    },
    summary: null,
    officialSite: "https://rodzinka.vod.tvp.pl/",
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 333,
      name: "TVP2",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2011-03-02",
  },
  {
    id: 3853,
    url: "https://www.tvmaze.com/shows/3853/the-andy-griffith-show",
    name: "The Andy Griffith Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/229/572754.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/229/572754.jpg",
    },
    summary:
      "<p>Down-home humor and an endearing cast of characters helped to make <b>The Andy Griffith Show</b> one of the most beloved comedies in the history of television. Introduced as a spinoff from The Danny Thomas Show in 1960, The Andy Griffith Show ran for eight seasons in prime time. Widower Andy Taylor divides his time between raising his young son, Opie, and his job as sheriff (and Justice of the Peace) of the sleepy North Carolina town, Mayberry. Andy and Opie live with Andy's Aunt Bee, who serves as a surrogate mother to both father and son. Andy's nervous cousin, Barney Fife, is his deputy sheriff whose utter incompetence is tolerated because Mayberry is virtually crime-free.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1960-10-03",
  },
  {
    id: 3854,
    url: "https://www.tvmaze.com/shows/3854/world-series-of-fighting",
    name: "World Series of Fighting",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48349.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48349.jpg",
    },
    summary:
      "<p><b>World Series of Fighting</b> is a mixed martial arts promotion series that features former fighters from Ultimate Fighting Championship (UFC), Strikeforce and Bellator, as well as its own competitors.</p>",
    officialSite: "http://www.wsof.com/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 104,
      name: "NBCSN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-11-03",
  },
  {
    id: 3855,
    url: "https://www.tvmaze.com/shows/3855/pj-masks",
    name: "PJ Masks",
    genres: ["Action", "Adventure", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48364.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48364.jpg",
    },
    summary:
      "<p>Based on Romuald Racioppo's picture book series Les Pyjamasques, <b>PJ Masks </b>is an animated series that follows the night-time adventures of three young friends and their superhero alter egos, who go into the night to save the day.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 78,
      name: "Disney Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-18",
  },
  {
    id: 3862,
    url: "https://www.tvmaze.com/shows/3862/nicky-ricky-dicky-dawn",
    name: "Nicky, Ricky, Dicky & Dawn",
    genres: ["Comedy", "Children", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/147/369373.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/147/369373.jpg",
    },
    summary:
      '<p>In <b>Nicky, Ricky, Dicky &amp; Dawn</b>, Dawn Harper doesn\'t have much in common with brothers Nicky, Ricky and Dicky except for a birthday. Sibling rivalry often consumes the quadruplets, but they can come together to solve problems that arise. Dawn acts as leader of the pack but, really, is just one of the quartet; quirky Nicky has the answer to almost everything; Ricky has a high IQ but gets into trouble with his siblings; charming Dicky always has a way with words. Situations show the preteens planning their own "grown-up" birthday parties and seeing a scary movie for the first time.</p>',
    officialSite: "http://www.nick.com/nicky-ricky-dicky-and-dawn/",
    webChannel: {
      id: 263,
      name: "Nick App",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-13",
  },
  {
    id: 3863,
    url: "https://www.tvmaze.com/shows/3863/d-day",
    name: "D-Day",
    genres: ["Drama", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48598.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48598.jpg",
    },
    summary:
      "<p>A natural disaster strikes the city of Seoul. The whole city becomes paralyzed. Doctors and emergency personnel struggle to save the people.</p>",
    officialSite: "http://drama.jtbc.joins.com/dday/",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 268,
      name: "jTBC",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2015-09-18",
  },
  {
    id: 3864,
    url: "https://www.tvmaze.com/shows/3864/the-virtual-bride",
    name: "The Virtual Bride",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48629.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48629.jpg",
    },
    summary:
      "<p>Old Boy lived in captivity for 15 years and so did Rapunzel for 18 years in a castle.<br>Yet, the most frightening castle is Mother's Castle.<br><br>One day, some women are trying to invade this impregnable castle. <br>They are daughter-in-laws!<br><br>Will these brave daughter-in-laws survive in the mother's castle defeating this formidable enemy, mother-in-law?</p>",
    officialSite:
      "http://kbsworld.kbs.co.kr/programs/programs_intro.html?no=945",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 128,
      name: "KBS2",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2015-08-17",
  },
  {
    id: 3865,
    url: "https://www.tvmaze.com/shows/3865/the-merchant-gaekju-2015",
    name: "The Merchant: Gaekju 2015",
    genres: ["Drama", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48630.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48630.jpg",
    },
    summary:
      "<p>In late Joseon, a poor man named Chun Bong-sam inherits a decrepit inn and honestly works his way up to becoming a powerful merchant. As tradesmen clash against the bureaucratic powers that attempt to oppress them by rigging bad deals, Bong-sam never loses sight of his humble beginnings as a peddler even after achieving great success and eventually shapes the way that industry and business are done in his time.</p>",
    officialSite: "http://www.kbs.co.kr/drama/gaekjoo/",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 128,
      name: "KBS2",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2015-09-23",
  },
  {
    id: 3866,
    url: "https://www.tvmaze.com/shows/3866/all-about-my-mom",
    name: "All About My Mom",
    genres: ["Drama", "Adventure", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48631.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48631.jpg",
    },
    summary:
      "<p>Jinae never wanted to live like her mother Sanok, but she has no choice but to follow her mother's path. Then, Jinae gets to meet another mother Youngseon. She cannot help but struggle between two mothers. After all, she embraces both of them as her family in this adventure-family drama.</p>",
    officialSite:
      "http://kbsworld.kbs.co.kr/programs/programs_intro.html?no=940",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 128,
      name: "KBS2",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2015-08-15",
  },
  {
    id: 3867,
    url: "https://www.tvmaze.com/shows/3867/my-love-eun-dong",
    name: "My Love Eun Dong",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48632.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48632.jpg",
    },
    summary:
      "<p>A renowned actor who is still pining over the loss of his first real love writes an autobiography about his memories of her, hoping to reconnect.</p>",
    officialSite: "http://drama.jtbc.joins.com/eundonga/",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 268,
      name: "jTBC",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2015-05-29",
  },
  {
    id: 3868,
    url: "https://www.tvmaze.com/shows/3868/a-divorce-lawyer-in-love",
    name: "A Divorce Lawyer in Love",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/65/163858.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/65/163858.jpg",
    },
    summary:
      "<p>Go Chuk Hee and So Jung Woo once worked together at a law firm; she was a divorce lawyer, and he was her office manager. She treated him like her inferior, while he constantly irked her by pointing out her mistakes and calling her \"Chucky\" behind her back. But Chuk Hee is so ambitious, so determined to win every case for her clients, that her unethical misdeeds catch up to her, causing her license to be suspended.</p><p>Meanwhile, Jung Woo studies and gets his law degree. Years later, they end up working together again for a different law firm. But this time, the tables have turned: he's the divorce lawyer, and she's the office manager. And Jung-woo relishes getting his petty revenge.</p>",
    officialSite: "http://tv.sbs.co.kr/divorcelawyer/",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 127,
      name: "SBS",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2015-04-18",
  },
  {
    id: 3869,
    url: "https://www.tvmaze.com/shows/3869/ex-girlfriend-club",
    name: "Ex-Girlfriend Club",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48643.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48643.jpg",
    },
    summary:
      "<p>Bang Myung Soo is a popular writer of webtoons. He then writes a webtoon series about his past relationships, specifically his three ex-girlfriends, which includes an older, wealthy divorcee, a chic and successful woman who works at an investment firm, and a third-rate, airhead actress. The webtoon reveals plenty of details about Myung Soo's love life, and it becomes a huge hit. Soon, Myung Soo is considered a cross between Public Enemy Number One and National Heartthrob, and his webtoon gets adapted into a movie.</p><p>Kim Soo Jin is a film producer who's prepared to do whatever it takes to save their failing production company. Because of this, she accepts the assignment to produce a webtoon adaptation. But to her horror, Soo Jin belatedly finds out that the webtoon artist is her ex-boyfriend Myung Soo, who is writing about his ex-girlfriends. And as the movie starts shooting, the project also brings Myung Soo's other ex-girlfriends back into his life all at the same time.</p>",
    officialSite: "http://program.interest.me/tvn/exgirlclub",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 280,
      name: "tvN",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2015-05-08",
  },
  {
    id: 3870,
    url: "https://www.tvmaze.com/shows/3870/falling-for-innocence",
    name: "Falling for Innocence",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48646.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48646.jpg",
    },
    summary:
      "<p>After enduring both business and family upheavals, a ruthless investment director has a heart transplant and finds a new way to look at life and love.</p>",
    officialSite: "http://drama.jtbc.joins.com/soonjung/",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 268,
      name: "jTBC",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2015-04-03",
  },
  {
    id: 3871,
    url: "https://www.tvmaze.com/shows/3871/mecum-auctions-collector-cars-more",
    name: "Mecum Auctions: Collector Cars & More",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48665.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48665.jpg",
    },
    summary:
      '<p><i><b>"Mecum Auctions: Collector Cars &amp; More"</b></i> is a reality series run by the Mecum Auction Company which is the world leader of collector car, vintage and antique motorcycle, and Road Art sales, hosting auctions throughout the United States. The company has been specializing in the sale of collector cars for 28 years, now offering more than 15,000 vehicles per year and averaging more than one auction each month. Established by President Dana Mecum in 1988, Mecum Auctions remains a family-run company headquartered in Walworth, Wis.</p>',
    officialSite: "https://www.mecum.com/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 104,
      name: "NBCSN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-17",
  },
  {
    id: 3872,
    url: "https://www.tvmaze.com/shows/3872/a-football-life",
    name: "A Football Life",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/65/163918.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/65/163918.jpg",
    },
    summary:
      "<p><b>A Football Life</b> showcases the lives and careers of legendary players, coaches and executives, NFL Films examines the untold stories of the most influential NFL icons with unprecedented access. Each film tells the story of how their legacy is forever intertwined in the fabric of NFL history.</p>",
    officialSite: "http://www.nfl.com/videos/a-football-life",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 205,
      name: "NFL Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-15",
  },
  {
    id: 3873,
    url: "https://www.tvmaze.com/shows/3873/tyler-perrys-for-better-or-worse",
    name: "Tyler Perry's For Better or Worse",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/270/676682.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/270/676682.jpg",
    },
    summary:
      "<p><b>Tyler Perry's For Better or Worse</b> is a not-so-subtle situation comedy that follows the zany and sometimes tumultuous relationship of a lovesick married couple, Marcus and Angela Williams. Marcus and Angela were first introduced to the world in Tyler's hit feature films <i>Why Did I Get Married</i> and <i>Why Did I Get Married Too</i>. Tasha Smith and Michael Jai White are back to reprise their roles in the half-hour show. Michael plays Marcus, a football player–turned–sports commentator who owns his own sports talk show. Tasha Smith also resumes her role as Angela, the edgy and outspoken wife of Marcus, who is dedicated to her husband, children and marriage. The show follows the lives of Marcus' and Angela's friends as well. There's Joseph, Marcus' best friend and business partner. Joseph is left devastated by his breakup with his longtime girlfriend, Leslie. Tired of waiting for a proposal from Joseph, Leslie has moved on to bigger and better things while staying focused on her career and her undying friendship with Angela. Keisha, Marcus' ex,continues to cause a world of trouble for the group of friends and colleagues. And, Jennifer and Todd are still as crazy as ever.<br /><br /><i>For Better or Worse</i> is groundbreaking television and one of the biggest TV shows movie mogul Tyler Perry has ever produced. The sets, high fashion and the strikingly good-looking cast come together to create a truly sexy and provocative half hour of television. Viewers will experience a fresh approach to the traditional sitcom format that will provide all the elements of well-crafted storytelling and the raw intrigue of reality TV. <i>For Better or Worse</i> explores the controversial and joyous moments associated with marriage and dating in a 21st-century world. And like always, viewers will leave with life-changing messages that have become a trademark of Tyler's brand of entertainment.</p>",
    officialSite: "http://www.oprah.com/app/for-better-or-worse.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 236,
      name: "Oprah Winfrey Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-11-25",
  },
  {
    id: 3874,
    url: "https://www.tvmaze.com/shows/3874/cmt-crossroads",
    name: "CMT Crossroads",
    genres: ["Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/237/593511.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/237/593511.jpg",
    },
    summary:
      "<p><b>CMT Crossroads</b> is where country music stars collaborate with performers from other musical genres and exchange stories about their mutual love for music. Some of the pairings that have been featured on the show include: Willie Nelson and Sheryl Crow; Sugarland and Bon Jovi; Taylor Swift and Def Leppard.</p>",
    officialSite: "http://www.cmt.com/shows/cmt_crossroads/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 173,
      name: "CMT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-01-13",
  },
  {
    id: 3875,
    url: "https://www.tvmaze.com/shows/3875/rick-stein-from-venice-to-istanbul",
    name: "Rick Stein: From Venice to Istanbul",
    genres: ["Food", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48669.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48669.jpg",
    },
    summary:
      "<p>Rick Stein embarks on a new gastronomic road trip from Venice to Istanbul through the countries of the former Byzantine Empire - a melting pot of east and west.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b0667qf6",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-08-07",
  },
  {
    id: 3876,
    url: "https://www.tvmaze.com/shows/3876/riverboat",
    name: "Riverboat",
    genres: ["Action", "Adventure", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48670.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48670.jpg",
    },
    summary:
      "<p>In this series set prior to the Civil War, Grey Holden is the owner of a riverboat named Enterprise. He runs cargo up and down the Mississippi with the help of pilot Ben Frazer. After Ben left, Grey took on a partner, Bill Blake.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1959-09-13",
  },
  {
    id: 3877,
    url: "https://www.tvmaze.com/shows/3877/the-rifleman",
    name: "The Rifleman",
    genres: ["Action", "Adventure", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48671.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48671.jpg",
    },
    summary:
      "<p>Lucas McCain is an ex-soldier who loses his wife after the birth of one son, Mark. Lucas and Mark move to North Fork and attempt to make a living as farmers. However, outlaws and criminals ride into North Fork regularly, and Lucas' past comes back to haunt him from time to time. Inevitably, Lucas has to pick up his rifle and uses his marksmanship skills to deal with trouble.<br></p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1958-09-30",
  },
  {
    id: 3878,
    url: "https://www.tvmaze.com/shows/3878/the-saint",
    name: "The Saint",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48675.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48675.jpg",
    },
    summary:
      "<p>Simon Templar is... <b>The Saint</b>! A gentleman adventurer, Simon travels around the world living the life of a wealthy playboy. He's made his money by taking cash from the unsaintly--criminals--and giving much of it back to their victims while keeping a bit for himself. This modern-day Robin Hood takes on criminals, spies, and conmen of all varieties.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1962-10-04",
  },
  {
    id: 3879,
    url: "https://www.tvmaze.com/shows/3879/the-sixth-sense",
    name: "The Sixth Sense",
    genres: ["Drama", "Mystery", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48677.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48677.jpg",
    },
    summary:
      "<p>Dr. Michael Rhoades is a parapsychologist who investigates cases of the strange and macabre: incidents of the supernatural.<br></p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1972-01-15",
  },
  {
    id: 3880,
    url: "https://www.tvmaze.com/shows/3880/the-twilight-zone",
    name: "The Twilight Zone",
    genres: ["Fantasy", "Horror", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48680.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48680.jpg",
    },
    summary:
      "<p>In this continuation of the original CBS series, each hour-long episode presents two half-hour stories of the strange, the science fiction, and the supernatural. Several of the stories are remakes and sequels to stories from the original, but most are all-new tales of horror and imagination.<br></p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 70,
      name: "UPN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-09-18",
  },
  {
    id: 3883,
    url: "https://www.tvmaze.com/shows/3883/kindred-the-embraced",
    name: "Kindred: The Embraced",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48682.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48682.jpg",
    },
    summary:
      '<p>The series focused on San Francisco Police Detective Frank Kohanek who discovers his city is home to numerous vampires while investigating alleged mobster, Julian Luna. Julian is the "Prince" of the city, ruler of five groups of vampires in the city, collectively called "The Kindred". The vampires survive through the "masquerade", disguising themselves as humans, and Julian strictly enforces the laws that govern them to protect their anonymity. Julian and Frank form an uneasy bond as they work together to try to prevent a vampire war and Julian struggles with his romantic feelings for human reporter Caitlin Byrne.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-04-02",
  },
  {
    id: 3884,
    url: "https://www.tvmaze.com/shows/3884/the-munsters",
    name: "The Munsters",
    genres: ["Comedy", "Family", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48683.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48683.jpg",
    },
    summary:
      "<p><b>The Munsters</b> is just your typical American family of Monsters. Herman works for an undertaker. Lily is a homemaker. Marilyn is the daughter of Lily's sister who lives with them and has problems keeping boyfriends once they see her parents. Eddie is just a typical schoolboy with werewolf tenancies. Grandpa is hundreds of years old and the Count from Transylvania. They deal with the normal problems of a family in unique ways.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1964-09-24",
  },
  {
    id: 3885,
    url: "https://www.tvmaze.com/shows/3885/masterchef-new-zealand",
    name: "MasterChef New Zealand",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48690.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48690.jpg",
    },
    summary:
      "<p><b>MasterChef New Zealand</b> is a New Zealand competitive reality television cooking show based on the original British version of <i>MasterChef</i>. The first episode aired on 3 February 2010 at 7:30pm on TV ONE. The show currently features judges Ray McVinnie, Josh Emett and Simon Gault. The series is similar to the format of <i>MasterChef Australia</i> whereby contestants compete in weekly elimination challenges, including team challenges. The major difference is the New Zealand series only has one episode per week compared to Australia's five per week. The first series was won by Brett McGregor, over runner-up Kelly Young, in the grand finale which was screened on 28 April 2010. Nadia Lim won the second series, beating runner-up Jax Hamilton in the finale. The third series was won by Chelsea Winter, who beat runner-up Ana Schwarz in the finale.</p>",
    officialSite:
      "http://tvnz.co.nz/masterchef-new-zealand/ta-ent-masterchefnz-index-group-3125704",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1031,
      name: "TVNZ 1",
      country: {
        name: "New Zealand",
        code: "NZ",
        timezone: "Pacific/Auckland",
      },
    },
    premiered: "2010-02-02",
  },
  {
    id: 3886,
    url: "https://www.tvmaze.com/shows/3886/lenny-henrys-got-the-blues",
    name: "Lenny Henry's Got the Blues",
    genres: ["Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/34/86322.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/34/86322.jpg",
    },
    summary:
      "<p>Lenny Henry talks to Van Morrison, Tinie Tempah and Jools Holland on a quest to discover why the UK has never produced a single black blues singer of international fame.</p><p>The three-part series culminates in a live performance in London where Lenny will be joined on stage by talented friends including Lulu, Mica Paris and Laura Mvula.</p>",
    officialSite: "http://www.sky.com/tv/show/lenny-henrys-got-the-blues",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 69,
      name: "Sky Arts",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-09-18",
  },
  {
    id: 3887,
    url: "https://www.tvmaze.com/shows/3887/bedlam",
    name: "Bedlam",
    genres: ["Drama", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48692.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48692.jpg",
    },
    summary:
      "<p>Set in Bedlam Heights - an apartment building converted from a pre-Victorian lunatic asylum - the inhabitants in this sexy, contemporary paranormal program experience the darker side of the building's history when former asylum spirits come back to claim what they believe to be theirs and seek revenge on those who have wronged them. The terrifying hauntings that follow reveal that sometimes when you scratch away the surface, things aren't always what they seem.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 44,
      name: "Sky Witness",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-02-07",
  },
  {
    id: 3888,
    url: "https://www.tvmaze.com/shows/3888/terry-pratchetts-going-postal",
    name: "Terry Pratchett's Going Postal",
    genres: ["Comedy", "Fantasy", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48698.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48698.jpg",
    },
    summary:
      "<p>Based on Terry Pratchett's 33rd Discworld novel involves a skillful con artist Moist Von Lipwig who finds the tables turned and it's he himself who conned into becoming the Ankh-Morpork Postmaster General. A position that has not been filled in years.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 63,
      name: "Sky 1",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-05-30",
  },
  {
    id: 3889,
    url: "https://www.tvmaze.com/shows/3889/messiah",
    name: "Messiah",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48709.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48709.jpg",
    },
    summary:
      "<p>Crime drama series following the investigations of DCI Red Metcalfe.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b008vj2j",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2001-05-26",
  },
  {
    id: 3890,
    url: "https://www.tvmaze.com/shows/3890/the-andromeda-strain",
    name: "The Andromeda Strain",
    genres: ["Drama", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48710.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48710.jpg",
    },
    summary:
      '<p>In <b>The Andromeda Strain</b>, a U.S. military satellite crashes in a small town and unleashes a deadly plague killing all but two survivors. As the military quarantines the area, a team of highly specialized scientists is assembled to find a cure to the pathogen code-named "Andromeda," and a reporter investigates a government conspiracy only to discover what he is chasing wants him silenced.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-05-26",
  },
  {
    id: 3891,
    url: "https://www.tvmaze.com/shows/3891/the-phantom",
    name: "The Phantom",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48717.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48717.jpg",
    },
    summary:
      "<p>Law student Chris Moore is an urban daredevil who gets his kicks from racing across rooftops. When a secret organization approaches him with proof that he is actually the son of a legendary international crimefighter called <b>The Phantom</b>, he is thrust into a world he never knew existed - a world of exotic islands, secret lairs and a heritage that borders on royalty. Reimagined and reloaded, the classic superhero is upgraded for the 21st century with a new, state-of-the-art costume and a newly formed rivalry against some of the most techno-savvy villains to ever terrorize the world! It's explosive action and nonstop adventure from start to finish as The Phantom comes to life.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 38,
      name: "The Movie Network",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2009-12-22",
  },
  {
    id: 3892,
    url: "https://www.tvmaze.com/shows/3892/tin-man",
    name: "Tin Man",
    genres: ["Drama", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48719.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48719.jpg",
    },
    summary:
      '<p>DG is a waitress ripped out of her boring life by a cyclone that drops her into "The O.Z." (Outer Zone). She learns that this new land is beautiful and deadly, since it lies in thrall to Azkadellia, a ruthless sorceress who has seized power. All Azkadellia needs to make her conquest complete is the Emerald of the Eclipse, but the location is buried in DG\'s subconscious. As DG follows her dangerous path along the Old Brick Road, she is joined by brainless Glitch, troubled former lawman Wyatt Cain, and terrified oracle Raw.</p>',
    officialSite: "http://www.syfy.com/tinman",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-12-02",
  },
  {
    id: 3893,
    url: "https://www.tvmaze.com/shows/3893/brigada",
    name: "Бригада",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48725.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48725.jpg",
    },
    summary:
      "<p><b>Brigada</b> (Russian: <i>Бригада</i>), also known as <i>Law of the Lawless</i>, is a Russian 15-episode crime miniseries that debuted in 2002. It became very popular, but received mixed reviews due to accusations in aestheticization of violence. The miniseries follows the story of four best friends from 1989 to 2000, mainly concentrating on the leader of the group, Sasha Belov, played bySergei Bezrukov. The fifteen-part miniseries were written by Igor Porublyov and Aleksei Sidorov and were directed by Aleksei Sidorov.</p>",
    officialSite: "http://russia.tv/brand/show/brand_id/22965/",
    webChannel: null,
    language: "Russian",
    status: "Ended",
    network: {
      id: 239,
      name: "Россия 1",
      country: {
        name: "Russian Federation",
        code: "RU",
        timezone: "Asia/Kamchatka",
      },
    },
    premiered: "2002-09-23",
  },
  {
    id: 3894,
    url: "https://www.tvmaze.com/shows/3894/mirror-mirror",
    name: "Mirror Mirror",
    genres: ["Adventure", "Children", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48726.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48726.jpg",
    },
    summary:
      "<p>When Jo Tiegan is given an oval-shaped mirror, as a gift, by the elderly owner of an antique shop, she is amazed to see another girl's image in the mirror instead of her own reflection. It is also quite obvious that the other girl can see her just as clearly. Jo (from the 1990's) and 'the girl in the mirror', Louisa Iredale (from 1919), later accidently find that they can also travel to each other's times through the mirror - following upon which discovery a relentless sequence of events is set in motion.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 149,
      name: "Network 10",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "1995-09-30",
  },
  {
    id: 3895,
    url: "https://www.tvmaze.com/shows/3895/storm-of-the-century",
    name: "Storm of the Century",
    genres: ["Drama", "Horror", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48727.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48727.jpg",
    },
    summary:
      '<p>A small village off the mainland is about to receive a huge winter storm. It won\'t be just another storm for them. A strange visitor named Andre Linoge comes to the small village and gives the residents havoc. He knows everything about them, and when he tells the truth about one of them, that person denies it. The town constable, Mike Anderson, tries to keep everyone in check with the huge storm and Linoge. Linoge keeps telling the people, "Give me what I want and I will go away"</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-02-14",
  },
  {
    id: 3896,
    url: "https://www.tvmaze.com/shows/3896/kuchenne-rewolucje",
    name: "Kuchenne rewolucje",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48739.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48739.jpg",
    },
    summary: null,
    officialSite: null,
    webChannel: null,
    language: "Polish",
    status: "Running",
    network: {
      id: 334,
      name: "TVN",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2011-02-11",
  },
  {
    id: 3898,
    url: "https://www.tvmaze.com/shows/3898/top-model-poland",
    name: "Top Model Poland",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49071.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49071.jpg",
    },
    summary: null,
    officialSite: "https://www.tvn.pl/programy/top-model,49,pc",
    webChannel: null,
    language: "Polish",
    status: "Running",
    network: {
      id: 334,
      name: "TVN",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2015-09-07",
  },
  {
    id: 3899,
    url: "https://www.tvmaze.com/shows/3899/masterchef-poland",
    name: "MasterChef Poland",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48740.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48740.jpg",
    },
    summary: null,
    officialSite: "https://masterchef.tvn.pl",
    webChannel: null,
    language: "Polish",
    status: "Running",
    network: {
      id: 334,
      name: "TVN",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2012-09-02",
  },
  {
    id: 3900,
    url: "https://www.tvmaze.com/shows/3900/project-runway-poland",
    name: "Project Runway Poland",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49558.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49558.jpg",
    },
    summary:
      "<p>On <b>Project Runway Poland</b>, thirteen of ambitious designers able to fight for the title of the best designer of the Polish edition of Project Runway, prestige, fame and a chance to create its own brand. On the way to the summit, the participants will face with unconventional tasks that will test not only their imagination, creativity, talent, but also character. Under the watchful eye of mentor will design original creations, and the results of their work will evaluate the professional jury. In each episode being eliminated by the weakest of the project, and the name of the winner will go on the list of major names in the industry.</p>",
    officialSite: "http://projectrunway.tvn.pl/",
    webChannel: null,
    language: "Polish",
    status: "Running",
    network: {
      id: 334,
      name: "TVN",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2014-03-02",
  },
  {
    id: 3901,
    url: "https://www.tvmaze.com/shows/3901/ugotowani",
    name: "Ugotowani",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49149.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49149.jpg",
    },
    summary: "",
    officialSite: "http://ugotowani.tvn.pl/",
    webChannel: null,
    language: "Polish",
    status: "Running",
    network: {
      id: 334,
      name: "TVN",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2015-09-06",
  },
  {
    id: 3902,
    url: "https://www.tvmaze.com/shows/3902/top-chef",
    name: "Top Chef",
    genres: ["Food"],
    image: null,
    summary:
      "<p><b>Top Chef </b>is a Polish program type reality show in which cooks - professionals compete against each other in culinary tasks.The program was created under license from the American program of the same name, broadcast on the Bravo cable television, hosted by Padma Lakshmi. Polish adaptation is broadcast on TV Polsat, starting from 11 September 2013.</p>",
    officialSite: "http://www.polsat.pl/Nasze_Programy,2846/Top_Chef,1323189/",
    webChannel: null,
    language: "Polish",
    status: "Running",
    network: {
      id: 335,
      name: "Polsat",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2013-09-11",
  },
  {
    id: 3903,
    url: "https://www.tvmaze.com/shows/3903/rolnik-szuka-zony",
    name: "Rolnik szuka żony",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49146.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49146.jpg",
    },
    summary: null,
    officialSite: "http://www.rolnikszukazony.tvp.pl/",
    webChannel: null,
    language: "Polish",
    status: "Running",
    network: {
      id: 336,
      name: "TVP1",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2014-05-21",
  },
  {
    id: 3905,
    url: "https://www.tvmaze.com/shows/3905/the-silk-road-past-present-future",
    name: "The Silk Road: Past Present Future",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755431.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755431.jpg",
    },
    summary:
      "<p><b>The Silk Road: Past Present Future</b> travels east to west along this ancient trade route, exploring how traditional culture, arts, and trade have developed in the 21st century. Beginning in China, and ending in northern Italy, the journey will focus on a different country each month.</p>",
    officialSite: "https://edition.cnn.com/specials/asia/the-silk-road",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 40,
      name: "CNN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: null,
  },
  {
    id: 3907,
    url: "https://www.tvmaze.com/shows/3907/museum-secrets",
    name: "Museum Secrets",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/120/300736.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/120/300736.jpg",
    },
    summary:
      "<p>Hidden in the backrooms, basements, and restricted areas of the most famous museums lie some of history's most fascinating mysteries and tales. Embark on a behind-the-scenes, around-the-world tour that includes Madrid's Palacio Real, the Chateau of Versailles, and the Smithsonian Institution. Discover King Herod's tomb, how a leather shield can work better than steel, and the connection between an ancient amulet and Star Trek's Mr. Spock. We examine collections, celebrated and obscure, and use cutting edge research to unlock their secrets.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 118,
      name: "History",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2011-01-06",
  },
  {
    id: 3908,
    url: "https://www.tvmaze.com/shows/3908/somebodys-gotta-do-it",
    name: "Somebody's Gotta Do It",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/312/781961.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/312/781961.jpg",
    },
    summary:
      "<p>In the inaugural season of <b>Somebody's Gotta Do It</b> with Mike Rowe, one of the nation's most unique storytellers introduced us to fascinating tradespeople, innovators and entrepreneurs who bring a wonderful passion to their work. Rowe will return to the network for a second season of <i>Somebody's Gotta Do It</i>, which since its launch in October, has more than doubled MSNBC in the key demo rating and posted growth versus prior programming in the time period.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 40,
      name: "CNN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-08",
  },
  {
    id: 3909,
    url: "https://www.tvmaze.com/shows/3909/the-great-british-sewing-bee",
    name: "The Great British Sewing Bee",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/290/725998.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/290/725998.jpg",
    },
    summary:
      "<p>Amateur sewers take on challenges as they compete to be named Britain's best home sewer.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b03myqj2",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-04-02",
  },
  {
    id: 3910,
    url: "https://www.tvmaze.com/shows/3910/comedy-central-stand-up-presents",
    name: "Comedy Central Stand-Up Presents…",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/127/317594.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/127/317594.jpg",
    },
    summary:
      "<p><b>Comedy Central Stand-Up Presents…</b> showcases the sharpest, most distinct voices in comedy with a brand new season of half hour stand-up specials. </p>",
    officialSite: "http://www.cc.com/shows/comedy-central-stand-up-presents",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-05-11",
  },
  {
    id: 3911,
    url: "https://www.tvmaze.com/shows/3911/common-law",
    name: "Common Law",
    genres: ["Drama", "Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48779.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48779.jpg",
    },
    summary:
      "<p>In <b>Common Law</b>, Travis Marks (Ealy) and Wes Mitchell (Kole) have a problem - each other. Despite their differences, this odd couple set of detectives are incredible at what they love most - enforcing the law - and have a seven-year track record as the LAPD's finest in the Robbery-Homicide Division. But when their constant bickering begins to have a major impact on their caseload, their new-age captain (McGee) institutes mandatory couples' therapy to bring back the flame in their \"work marriage.\" Tough-as-nails therapist Dr. Ryan (Walger) is brought in to help them understand and resolve their conflicts and confront their demons in order to enhance their ability to continue solving crimes.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-05-11",
  },
  {
    id: 3912,
    url: "https://www.tvmaze.com/shows/3912/the-dead-files",
    name: "The Dead Files",
    genres: ["Fantasy", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/207/518315.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/207/518315.jpg",
    },
    summary:
      "<p>Physical medium Amy Allan and retired NYPD homicide detective Steve DiSchiavi combine their unique and often conflicting skills to solve unexplained paranormal phenomena in haunted locations across America.</p>",
    officialSite: "http://www.travelchannel.com/shows/the-dead-files",
    webChannel: { id: 173, name: "discovery+", country: null },
    language: "English",
    status: "Running",
    network: null,
    premiered: "2011-09-23",
  },
  {
    id: 3913,
    url: "https://www.tvmaze.com/shows/3913/bj-and-the-bear",
    name: "B.J. and the Bear",
    genres: ["Comedy", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48789.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48789.jpg",
    },
    summary:
      "<p>A trucker and his pet chimp travel the highways of America, getting into various adventures and misadventures along the way.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1979-02-10",
  },
  {
    id: 3914,
    url: "https://www.tvmaze.com/shows/3914/the-misadventures-of-sheriff-lobo",
    name: "The Misadventures of Sheriff Lobo",
    genres: ["Comedy", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48791.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48791.jpg",
    },
    summary:
      "<p>Sheriff Lobo's the corrupt sheriff from Orly County who appeared in several episodes during the first season of <i>B.J. and the Bear</i> (1979), as B.J.'s occasional nemesis. He now stars in his own series. He is not as corrupt as he was on B.J.'s show, but he is still trying to make a buck by cooking up schemes or hoping to be given the reward money for property he recovers or criminals he apprehends.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1979-09-25",
  },
  {
    id: 3915,
    url: "https://www.tvmaze.com/shows/3915/dateline-on-tlc",
    name: "Dateline on TLC",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/40/102375.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/40/102375.jpg",
    },
    summary:
      '<p><b>Dateline on TLC</b> is a spinoff form the newsmagazine show "Dateline NBC". Each week, Dateline on TLC features an array of stories that range from mysteries and breaking news, to hidden-camera investigations and documentaries.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-12",
  },
  {
    id: 3916,
    url: "https://www.tvmaze.com/shows/3916/jake-and-the-never-land-pirates",
    name: "Jake and the Never Land Pirates",
    genres: ["Comedy", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48803.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48803.jpg",
    },
    summary:
      '<p><b>Jake and the Never Land Pirates</b> is an animated series that is a new take on the classic "Peter Pan" story, follows the Never Land adventures of a group of child pirates -- Jake, Izzy and Cubby -- as they try to outwit Captain Hook and Smee. The show features original music performed by the Never Land Pirate Band.</p>',
    officialSite:
      "http://disneyjunior.disney.com/jake-and-the-never-land-pirates",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1039,
      name: "Disney Junior",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-02-14",
  },
  {
    id: 3917,
    url: "https://www.tvmaze.com/shows/3917/miles-from-tomorrowland",
    name: "Miles from Tomorrowland",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/155/389016.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/155/389016.jpg",
    },
    summary:
      "<p>Space adventurer Miles Callisto is always ready for action, traveling through the universe with his family and his best friend, a robo-ostrich named Merc. The family includes mom Phoebe, the ship's captain who sets a good example and encourages her family on every mission; dad Leo, a laid-back pilot and inventor who isn't afraid to try new things; and big sister Loretta, who is a brilliant computer coder and always has her brother's back. Together, they use teamwork and problem solving as they encounter obstacles while completing missions throughout outer space for the Tomorrowland Transit Authority. The Callistos' home base is a floating space station called the Stellosphere, and the StarJetter is the vehicle they use to go to other planets and galaxies. Each episode features a fact related to space or science that inspires the storyline for <b>Miles from Tomorrowland</b>.</p>",
    officialSite: "http://disneyjunior.disney.com/miles-from-tomorrowland",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1039,
      name: "Disney Junior",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-02-06",
  },
  {
    id: 3918,
    url: "https://www.tvmaze.com/shows/3918/natural-born-monsters",
    name: "Natural Born Monsters",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755432.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755432.jpg",
    },
    summary:
      "<p>Adventurer Sean Duggan heads to some of the most remote places on Earth in search of mysterious creatures -- from land-prowling fish to giant predatory reptiles -- in <b>Natural Born Monsters</b>. When he unearths the creatures, he investigates how they have adapted to extreme weather conditions to survive in their often-dangerous environments and how weather has shaped the animals themselves. Duggan often enlists the help of local experts to locate and investigate the creatures and get the information he seeks.</p>",
    officialSite: "http://www.theweathercompany.com/tags/natural-born-monsters",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 228,
      name: "The Weather Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-21",
  },
  {
    id: 3919,
    url: "https://www.tvmaze.com/shows/3919/celebrity-name-game",
    name: "Celebrity Name Game",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48809.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48809.jpg",
    },
    summary:
      '<p>Early on in game shows, when stars took part, they aided players -- to guess secret words on "Password", for instance. Now they\'re helping them guess names of VIPs in host Craig Ferguson\'s four-round competition set in a party atmosphere on <b>Celebrity Name Game</b>. The celebrity/contestant pairs must identify the famous -- actors, athletes, politicians, cartoon characters, etc. -- based on improvised clues for a chance to win $20,000. The celebrity connection extends behind the cameras; actors Courteney Cox and David Arquette are among executive producers of a show based on board game "Identity Crisis".</p>',
    officialSite: "http://www.celebnamegame.com/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 88,
      name: "Pop",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-22",
  },
  {
    id: 3920,
    url: "https://www.tvmaze.com/shows/3920/bazillion-dollar-club",
    name: "Bazillion Dollar Club",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/81/202813.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/81/202813.jpg",
    },
    summary:
      "<p><b>Bazillion Dollar Club</b> follows Dave McClure, a relentless drill sergeant who founded software accelerator 500 Startups, and Brady Forrest, the quirky and creative mind behind the hardware accelerator Highway1. Their companies offer two of the world's most aggressive accelerator programs that mentor startups leading up to the launch of their billion (and perhaps bazillion) dollar idea.</p><p>In every episode, Dave and Brady mentor a different hardware or software startup (which they've also invested in, P.S.) through an accelator program (read: startup boot camp). At the end, each company must present their product to a group of potential investors who hold the power to take the startup to the next level...or not.</p>",
    officialSite: "http://www.syfy.com/bazilliondollarclub",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-22",
  },
  {
    id: 3921,
    url: "https://www.tvmaze.com/shows/3921/road-spill",
    name: "Road Spill",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/28/70212.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/28/70212.jpg",
    },
    summary:
      '<p>Get ready to hit the road with <i><b>"Road Spill"</b></i>, a series that shows what people really discuss in the comfort of their cars. Warning: debates, road rage, and other hilarious moments will ensue.</p>',
    officialSite: "http://www.trutv.com/shows/road-spill/about.html",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 84,
      name: "truTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-23",
  },
  {
    id: 3922,
    url: "https://www.tvmaze.com/shows/3922/senora-acero",
    name: "Señora Acero",
    genres: ["Drama", "Action", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48843.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48843.jpg",
    },
    summary:
      '<p>Eagle Sara Bermudez is a 28-year-old has everything a person would want to have. The day he decides to get married by the Church with her husband Vicente Acero, at the request of his son Salvador, a murderous command her husband made mark forever the life of Sarah as he realizes that the man she loved not He was the person I thought.The government seized all assets and bank accounts of the deceased "major" and enemies pursue her late husband to demand the payment of their dirty business that she had no knowledge. Sara has to run away and start a new life, but that ordinary woman will end up protected by the major Mexican drug lords, who manages to win using his two most dangerous weapons: her beauty and intelligence all on <b>Señora Acero</b> .</p>',
    officialSite:
      "http://www.telemundo.com/novelas/senora-acero/videos/senora-acero-temporada-2/los-expedientes-de-senora-acero/los-expedientes-de-senora-acero-episodio-7-el-indio-amaro-regreso-de-la-muerte-y-busca-957616",
    webChannel: null,
    language: "Spanish",
    status: "Ended",
    network: {
      id: 219,
      name: "Telemundo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-23",
  },
  {
    id: 3923,
    url: "https://www.tvmaze.com/shows/3923/gorongosa-park-rebirth-of-paradise",
    name: "Gorongosa Park: Rebirth of Paradise",
    genres: ["Action", "Adventure", "Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755435.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755435.jpg",
    },
    summary:
      "<p>Experience the incredible and inspiring rebirth of an African wilderness through the eyes of an Emmy-winning wildlife cameraman. American-born, African-raised Bob Poole embarks on an amazing adventure: spending two years living in Gorongosa National Park, Mozambique, Southern Africa, joining scientists and conservationists in the battle to re-wild this once-legendary national park. The fabric of life across this million-acre paradise was shredded during a long civil war. Now, teams of international and Mozambican scientists and conservationists have assembled to repair it. It's one of the most ambitious wilderness restoration projects ever attempted.</p><p>This is no ordinary filming assignment for Poole. Instead of just staying behind the lens filming the action, he gets roped in and becomes a core part of it. He helps scientists dart and track the park's elusive lions, decode the behavior of the park's elephants, wrestle and study massive crocs, and truck in herds of animals to replace the ones that were lost during the civil war. In addition to giving us stunning images of Africa's iconic wildlife, large and small, hoofed and winged, Bob Poole and <b>Gorongosa Park: Rebirth of Paradise</b> takes us by the scruff of the neck into one of the most exciting conservation stories happening in the world today.</p><p>Having grown up in Kenya, but now living in Idaho, Poole was keen to return to the Africa of his idyllic childhood. And this assignment fulfills his life-long dream of working in an African national park — combining his passion for conservation with his lifelong career filming the world's beautiful but vulnerable wild animals.</p>",
    officialSite: "http://www.pbs.org/gorongosa/home/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 85,
      name: "PBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-22",
  },
  {
    id: 3924,
    url: "https://www.tvmaze.com/shows/3924/wife-swap-abroad",
    name: "Wife Swap: Abroad",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/188/471294.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/188/471294.jpg",
    },
    summary:
      "<p>Have you ever wondered whether the grass is greener on the other side of the fence? Two wives discover that it often isn't when they hand over the keys to their homes and literally switch families for two weeks. At the end of the show, the two couples meet for the first time. In a highly-charged exchange of views, they make a frank assessment of each other and talk about what they've learned from the experience on <b>Wife Swap: Abroad</b>.</p>",
    officialSite: "http://www.mylifetime.com/shows/wife-swap/about",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-22",
  },
  {
    id: 3925,
    url: "https://www.tvmaze.com/shows/3925/tyler-perrys-the-haves-and-the-have-nots",
    name: "Tyler Perry's The Haves and the Have Nots",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48892.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48892.jpg",
    },
    summary:
      "<p><b>Tyler Perry's The Haves and the Have Nots</b> is a television drama from the prolific writer, director and producer Tyler Perry. The show follows the complicated dynamic between the rich and powerful Cryer family and the hired help who work in their opulent Savannah, Georgia, mansion.<br><br> From the outside, the Cryers are the enviable face of success and wealth, but behind the veil, the family's dysfunction threatens to destroy their world of privilege. Cryer family patriarch Jim Cryer (John Schneider) is a powerful judge whose double life, including tawdry affairs with high-priced escorts, puts his family and political ambitions at risk. His wife, Katheryn Cryer (Renée Lawless), is the ultimate matriarch, portraying a loving and dutiful wife, but she is willing to do anything to protect her family's status. Their son, Wyatt (Aaron O'Connell), is a troubled, angry jock who cares little for his own image and finds himself in and out of rehab. His sister, Amanda (Jacyln Betham), a struggling law student, tries harder to live up to her parents' expectations but unknowingly has befriended a scurrilous young woman, Candace Young, with the power to ruin the entire family.</p>",
    officialSite: "http://www.oprah.com/app/the-haves-and-the-have-nots.html",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 236,
      name: "Oprah Winfrey Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-05-28",
  },
  {
    id: 3926,
    url: "https://www.tvmaze.com/shows/3926/earths-natural-wonders",
    name: "Earth's Natural Wonders",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/145/362633.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/145/362633.jpg",
    },
    summary:
      "<p><b>Earth's Natural Wonders</b> will reveal a handful of places that can lay claim to being the greatest landscapes on our planet. Viewers will be taken on a landmark tour of Earth, discovering connections between some incredible places and the life and death struggles of the animals and humans that inhabit them. Everest, the Grand Canyon, Victoria Falls — they seem to have little in common other than taking your breath away. But they share one other thing: All were created by our planet's most dynamic forces. These remarkable wonders were sculpted, etched or molded by unimaginably powerful energies, unleashed by the Earth. This series is the definitive story of some of the most amazing places on our planet.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b09rbswh",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-08-05",
  },
  {
    id: 3927,
    url: "https://www.tvmaze.com/shows/3927/pizza-masters",
    name: "Pizza Masters",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48952.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48952.jpg",
    },
    summary:
      '<p>Sal Basille and Francis Garcia are first cousins and best friends. Together they own some of the most successful pizza shops in New York City. The cousins are always on the search for the best food in town -- and not just pizza. Join in the fun as the cousins set off on a culinary adventure to find the greatest spots across the country. From mom and pop joints to legendary establishments, these "Pizza Masters" know good pizza and good food when they find it, and are always up for having a good time along the way.</p>',
    officialSite: "http://www.cookingchanneltv.com/shows/pizza-masters.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 174,
      name: "Cooking Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-12-16",
  },
  {
    id: 3928,
    url: "https://www.tvmaze.com/shows/3928/the-daily-show-with-trevor-noah",
    name: "The Daily Show with Trevor Noah",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/295/737765.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/295/737765.jpg",
    },
    summary:
      "<p>An irreverent skewering of the news and pop culture with South African comedian Trevor Noah, who took over for Jon Stewart when he left the anchor desk after 17 seasons.</p>",
    officialSite: "http://thedailyshow.cc.com/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-28",
  },
  {
    id: 3929,
    url: "https://www.tvmaze.com/shows/3929/summerland",
    name: "Summerland",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48967.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48967.jpg",
    },
    summary:
      "<p>Bradin, Nikki and Derrick are 3 kids from an average normal Kansas household. Their whole life is thrown upside-down when their parents are tragically killed in a car accident. Ava Gregory (their aunt) gets custody of her niece and nephews and they move into her Californian home (in Summerland). Ava, a struggling clothes designer, lives with her best friend and business partner, Susannah Rexford, her friend, an ex- pro.surfer, Jay Robertson and her ex-boyfriend, real estate agent, Johnny Durrant. All four of them are highly unequipped to handle children and are not use to including them in their everyday lives.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-06-01",
  },
  {
    id: 3930,
    url: "https://www.tvmaze.com/shows/3930/i-shouldnt-be-alive",
    name: "I Shouldn't Be Alive",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/128/321058.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/128/321058.jpg",
    },
    summary:
      "<p>What lengths would you go to in order to survive in the wild where you have to battle the forces of nature and the elements? I SHOULDN'T BE ALIVE presents viewers with this very question, allowing them to re-live the harrowing, true stories of real people who survived fascinatingly dire circumstances and lived to tell about it. Viewers find the experience of I SHOULDN'T BE ALIVE to be an emotional one - the featured tales often deal with unimaginable scenarios, moral dilemmas, split-second decisions and chance occurrences that determine life or death. This highly engaging series constantly leaves viewers in awe and forces them to ponder: Do I have it within me to do the same?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 92,
      name: "Animal Planet",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-10-28",
  },
  {
    id: 3931,
    url: "https://www.tvmaze.com/shows/3931/privileged",
    name: "Privileged",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48977.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48977.jpg",
    },
    summary:
      "<p>A Yale-educated journalism major reluctantly becomes a live-in tutor for two spoiled grand-daughters of a Palm Beach cosmetics business magnate.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-09-09",
  },
  {
    id: 3932,
    url: "https://www.tvmaze.com/shows/3932/johnny-bravo",
    name: "Johnny Bravo",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48986.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48986.jpg",
    },
    summary:
      "<p><b>Johnny Bravo</b> tells the story of a biceps-bulging, karate-chopping free spirit who believes he is a gift from God to the women of the earth. Unfortunately for Johnny, everyone else sees him as a narcissistic Mama's boy with big muscles and even bigger hair. In short, he is the quintessential guy who 'just doesn't get it.' No matter what he does, or where he finds himself, he always winds up being his own worst enemy.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1997-07-07",
  },
  {
    id: 3933,
    url: "https://www.tvmaze.com/shows/3933/silk",
    name: "Silk",
    genres: ["Drama", "Crime", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48987.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48987.jpg",
    },
    summary:
      "<p>Series about life at the Bar, the dilemmas and problems that modern day barristers have to face, and what it means to become a silk.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b01hzsch",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-02-22",
  },
  {
    id: 3934,
    url: "https://www.tvmaze.com/shows/3934/borgen",
    name: "Borgen",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48992.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48992.jpg",
    },
    summary:
      "<p>Internationally acclaimed Danish political drama from the producers of The Killing.</p>",
    officialSite: "https://www.dr.dk/drtv/saeson/borgen_-i_184479",
    webChannel: null,
    language: "Danish",
    status: "Running",
    network: {
      id: 115,
      name: "DR1",
      country: { name: "Denmark", code: "DK", timezone: "Europe/Copenhagen" },
    },
    premiered: "2010-09-26",
  },
  {
    id: 3935,
    url: "https://www.tvmaze.com/shows/3935/mad-love",
    name: "Mad Love",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/48998.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/48998.jpg",
    },
    summary:
      "<p><b>Mad Love</b> is a comedy about a quartet of New Yorkers - two who are falling in love and two who despise each other... at least for now. Ben, a lawyer, is a hopeless romantic trying to build a relationship with Kate, a beautiful, smart girl whom Ben thinks is the woman of his dreams. Larry, Ben's unrefined best friend and co-worker, is a guy who doesn't believe in love and has a long track record as the third wheel. Connie, Kate's roommate, works as a nanny and finds Larry aggravating... or does she? Larry and Connie have a lot in common, but refuse to let their guard down long enough to see it.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-02-14",
  },
  {
    id: 3936,
    url: "https://www.tvmaze.com/shows/3936/gary-unmarried",
    name: "Gary Unmarried",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49004.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49004.jpg",
    },
    summary:
      "<p><b>Gary Unmarried</b> follows the life of a middle-class single dad as he tries to navigate his way through life with his kids, ex-wife, and a new-found romance.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-09-24",
  },
  {
    id: 3937,
    url: "https://www.tvmaze.com/shows/3937/this-is-life-with-lisa-ling",
    name: "This is Life with Lisa Ling",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/234/586545.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/234/586545.jpg",
    },
    summary:
      "<p>In <b>This is Life with Lisa Ling</b>, award-winning journalist and author Lisa Ling reports on unconventional lifestyles in the U.S. The former co-host of \"The View'' introduces viewers to subcultures and communities that are extraordinary and sometimes dangerous, and her interpersonal skills prompt interviewees to discuss matters they don't share with close friends or even family. \"I have always believed that the more we know about each other, the more evolved we become,'' Ling says about the intent of the hourlong documentaries.</p>",
    officialSite: "http://www.cnn.com/shows/this-is-life-with-lisa-ling",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 40,
      name: "CNN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-28",
  },
  {
    id: 3938,
    url: "https://www.tvmaze.com/shows/3938/close-to-home",
    name: "Close to Home",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49015.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49015.jpg",
    },
    summary:
      "<p>Returning from maternity leave, Deputy Prosecutor Annabeth Chase learns how to balance her nearly-perfect conviction record with a new boss and adjusting to life as a wife and mother in Indianapolis.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-09-20",
  },
  {
    id: 3939,
    url: "https://www.tvmaze.com/shows/3939/kid-nation",
    name: "Kid Nation",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49018.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49018.jpg",
    },
    summary:
      "<p>Forty over-achieving kids are given free reign to create their own society in this new reality-based offering from CBS. Forty kids are given forty days free of adult supervision in an abandoned New Mexico town to build a new world. At the end of every episode, the kids have a town meeting. At the meeting the kids award one child a gold star worth $20,000. The finale will end with the biggest test, the biggest awards, and a special surprise.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-09-19",
  },
  {
    id: 3940,
    url: "https://www.tvmaze.com/shows/3940/animal-practice",
    name: "Animal Practice",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49019.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49019.jpg",
    },
    summary:
      "<p><b>Animal Practice</b> follows Dr. George Coleman, a top veterinarian with an impressive list of famous animal patients at the Crane Animal Hospital - a bustling New York City veterinary practice where it often seems as if the patients are running the place. Despite his unorthodox style, George has an undeniable gift with animals of all kinds - except the human kind. Much to his chagrin, George recently learned that his ex-girlfriend Dorothy Crane has inherited the family business and is now George's boss. Whip-smart and ambitious, Dorothy shakes up the hospital as she brings order to the chaos and butts heads with George's animal-friendly administration.</p>",
    officialSite: "http://www.nbc.com/animal-practice",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-08-12",
  },
  {
    id: 3941,
    url: "https://www.tvmaze.com/shows/3941/sons-of-tucson",
    name: "Sons of Tucson",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49027.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49027.jpg",
    },
    summary:
      "<p>Three young brothers hire a charming, wayward schemer to stand in as their father when their real one goes to prison.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-03-14",
  },
  {
    id: 3942,
    url: "https://www.tvmaze.com/shows/3942/roommates",
    name: "Roommates",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49032.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49032.jpg",
    },
    summary:
      "<p><b>Roommates</b> follows the lives of a group of friends who are making their way through life after graduating from college.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-03-23",
  },
  {
    id: 3943,
    url: "https://www.tvmaze.com/shows/3943/viva-la-bam",
    name: "Viva La Bam",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49038.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49038.jpg",
    },
    summary:
      "<p>After MTV's hit show Jackass ended in 2002, what was a boy like pro prankster Bam Margera to do with his idle time and boundless energy? Seeing as there was no stopping him, MTV decided to give him his own show, <b>Viva La Bam</b>, where he spent five seasons playfully tormenting his ever-patient parents, April (aka Ape) and Phil, with his outrageous antics. What was Bam able to get away with? Whatever the @#!% he wanted! Margera and his CKY crew -- Ryan Dunn, Brandon DiCamillo, Raab Himself and Rake Yohn -- played every practical joke imaginable on Bam's family, always with hilarious results. Viva La Bam usually revolved around destroying Ape and Phil's home and forcing family members to compete for \"prizes.\" From outrageous scavenger hunts to converting the family home into a skate park to loading elephants onto the front lawn, Bam and his clan always managed to up the ante and push his parents' sanity to the limits. Each episode of Viva La Bam revolved around a challenge, mission or theme that would be completed through a series of stunts involving Bam's friends and family. Bearing the brunt of physical abuse was Bam's uncle Don Vito, who was often duct taped to chairs, held down as motorcycles jumped over his head or forced to complete a \"slobstacle course.\" Season 1 of Viva La Bam ended with Ape and Phil's house being \"blown up,\" and the family was forced to move because the neighbors had had enough of the Margeras' antics. But moving the family to a bigger house in a quieter neighborhood during season 2 only encouraged Bam and his CKY crew to try even crazier stunts, including holding a demolition derby in the backyard. By season 4 of Viva La Bam, Bam and his clan had caused so much trouble in their new neighborhood that Ape and Phil dragged them across the Atlantic, where they pranked their way through Europe. Guests that appeared on Viva La Bam included rockers like HIM, the Bloodhound Gang, Hanoi Rocks, Gwar and Billy Idol, as well as freestyle motocross team Metal Mulisha and skateboarding legend Tony Hawk. Although Viva La Bam ended in 2005, Bam continued his wild ways on Bam's Unholy Union. This time around, though, Bam played his over-the-top tricks on his fiancée, Missy, while she struggled to plan their wedding. During Viva La Bam's five seasons, Bam proudly put Ape, Phil and Don Vito through more hell than anyone could have ever imagined -- probably even Bam himself...</p>",
    officialSite: "http://www.mtv.com/shows/viva_la_bam/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-10-26",
  },
  {
    id: 3944,
    url: "https://www.tvmaze.com/shows/3944/the-soul-man",
    name: "The Soul Man",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755436.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755436.jpg",
    },
    summary:
      "<p>An R&amp;B superstar-turned-minister takes over as preacher of his father's church.</p>",
    officialSite: "http://www.tvland.com/shows/the-soul-man",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 57,
      name: "TV Land",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-06-20",
  },
  {
    id: 3945,
    url: "https://www.tvmaze.com/shows/3945/angie-tribeca",
    name: "Angie Tribeca",
    genres: ["Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/137/342740.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/137/342740.jpg",
    },
    summary:
      "<p>Lone-wolf detective Angie Tribeca and a squad of committed LAPD detectives investigate the most serious cases, from the murder of a ventriloquist to a rash of baker suicides.</p>",
    officialSite: "http://www.tbs.com/shows/angie-tribeca.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 32,
      name: "TBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2016-01-17",
  },
  {
    id: 3946,
    url: "https://www.tvmaze.com/shows/3946/bordertown",
    name: "Bordertown",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/82/205525.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/82/205525.jpg",
    },
    summary:
      "<p><b>Bordertown</b> centers on two clans: the Buckwalds and the Gonzalezes. Bud Buckwald is a married father of three and a Border Patrol agent who is just a tad behind the times and feels slightly threatened by the cultural changes transforming his neighborhood. He lives next door to Ernesto Gonzalez, an ambitious family man, who has been in the country less than 10 years, but is already doing better than Bud – which, it turns out, is a bit of an issue for Bud.</p><p>On May 12, 2016, Fox cancelled the series after one season.</p>",
    officialSite: "http://www.fox.com/bordertown",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2016-01-03",
  },
  {
    id: 3947,
    url: "https://www.tvmaze.com/shows/3947/million-dollar-listing-miami",
    name: "Million Dollar Listing: Miami",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49047.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49047.jpg",
    },
    summary:
      "<p>Million Dollar Listing has expanded into the sexy city of Miami where three luxury real estate agents battle it out in the world of high-end real estate on <b>Million Dollar Listing: Miami</b>. With a surging market in South Florida, properties are selling for record rates and agents are cashing in on massive commissions like never before. The mansions are bigger, the high-rises are taller, the amenities are more lux and the locals have access to amazing views, beaches and a lifestyle unlike anywhere else in the world. Business can get heated as the brokers attempt to make a name for themselves and outshine their competition by landing the next big listing in America's hottest city.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-06-25",
  },
  {
    id: 3948,
    url: "https://www.tvmaze.com/shows/3948/how-do-they-do-it",
    name: "How Do They Do It?",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49048.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49048.jpg",
    },
    summary:
      "<p>As the modern world becomes increasingly sophisticated and mechanised, we grow further removed from the way things are made and how things are done - from the miraculous feats of engineering which underpin life in the 21st Century.</p>",
    officialSite:
      "http://www.discoverychannel.co.in/tv-shows/how-do-they-do-it/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 143,
      name: "Discovery Channel",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-05-06",
  },
  {
    id: 3949,
    url: "https://www.tvmaze.com/shows/3949/a-series-of-unfortunate-events",
    name: "A Series of Unfortunate Events",
    genres: ["Drama", "Family", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/177/444262.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/177/444262.jpg",
    },
    summary:
      "<p>Based on the internationally best-selling series of books by Lemony Snicket and starring Emmy and Tony Award winner Neil Patrick Harris, <b>A Series of Unfortunate Events</b> recounts the tragic tale of the Baudelaire orphans -- Violet, Klaus, and Sunny - whose evil guardian Count Olaf will stop at nothing to get his hands on their inheritance. The siblings must outsmart Olaf at every turn, foiling his many devious plans and disguises, in order to discover clues to their parents' mysterious death.</p>",
    officialSite: "https://www.netflix.com/title/80050008",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2017-01-13",
  },
  {
    id: 3950,
    url: "https://www.tvmaze.com/shows/3950/mystery-girls",
    name: "Mystery Girls",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49049.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49049.jpg",
    },
    summary:
      "<p>Two former detective TV show starlets brought back together by a real-life mystery. Charlie Contour is a suburban housewife and mother, while Holly Hamilton longs for her glory days in the 90's when she was on television. Both of their lives are disrupted when Nick, a witness to a crime and a <b>Mystery Girls</b> fanatic, will only speak to the infamous duo, and the former friends must reunite and put their TV crime-solving skills to the test.</p>",
    officialSite: "http://abcfamily.go.com/shows/mystery-girls",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-06-25",
  },
  {
    id: 3951,
    url: "https://www.tvmaze.com/shows/3951/still-open-all-hours",
    name: "Still Open All Hours",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/140/351579.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/140/351579.jpg",
    },
    summary:
      "<p><b>Still Open All Hours</b> is a BBC television sitcom, a sequel to the 1973 series <i>Open All Hours</i>. The show was based around Granville, now running the corner shop with his son Leroy after inheriting the shop from his Uncle Arkwright.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b04xd2nw",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-11-26",
  },
  {
    id: 3952,
    url: "https://www.tvmaze.com/shows/3952/nana",
    name: "Nana",
    genres: ["Drama", "Anime", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49054.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49054.jpg",
    },
    summary:
      "<p>Nana Osaki is a guarded and ambitious young woman with a strong will and a rough past. She is the vocalist for a punk band called Black Stones and she desires fame and recognition more than anything else. Nana Komatsu is an outgoing and flighty young woman with a weak will and a stable past. Her life revolves around her desire to find love and marriage. The two meet for the first time while traveling to Tokyo - in pursuit of their respective dreams - and they later decide to be roommates. Although drastically different people, the two become very close and together they find out if their biggest dreams have room for their best friend.</p><p>(Source: ANN)</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 137,
      name: "NTV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2006-04-05",
  },
  {
    id: 3953,
    url: "https://www.tvmaze.com/shows/3953/100-code",
    name: "100 Code",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/155/388120.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/155/388120.jpg",
    },
    summary:
      "<p>Over the past 16 months, young, blonde, blue-eyed women have been found dead and buried in a field of asphodels. Tracking the killer from New York to Stockholm, NYPD detective Conley is on a special dispensation to observe and advise the Stockholm PD.</p>",
    officialSite: null,
    webChannel: { id: 330, name: "HBO Nordic", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-03-11",
  },
  {
    id: 3954,
    url: "https://www.tvmaze.com/shows/3954/jackass",
    name: "Jackass",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49063.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49063.jpg",
    },
    summary:
      "<p><b>Jackass</b> is an American reality series, originally shown on MTV from 2000 to 2002, featuring people performing various dangerous, crude, self-injuring stunts and pranks. The show served as a launchpad for the television and acting careers of Bam Margera, Steve-O and Johnny Knoxville, who previously had only minor acting roles.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-04-12",
  },
  {
    id: 3955,
    url: "https://www.tvmaze.com/shows/3955/bams-unholy-union",
    name: "Bam's Unholy Union",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49065.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49065.jpg",
    },
    summary:
      "<p>Pro skateboarder and MTV Jackass alum Bam Margera chronicles the moments leading up to his wedding where he will marry Melissa Rothstein who he has known since they were little kids.</p>",
    officialSite: "http://www.mtv.com/shows/bams_unholy_union/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-01-30",
  },
  {
    id: 3956,
    url: "https://www.tvmaze.com/shows/3956/wildboyz",
    name: "Wildboyz",
    genres: ["Comedy", "Action", "Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/32/80648.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/32/80648.jpg",
    },
    summary:
      "<p>From the creators of MTV's Jackass comes <b>Wildboyz</b>, an action/adventure show spearheaded by its two stars of low moral caliber, Chris Pontius and Steve-O. In each episode, the boys travel afar to exotic lands of wonder, mystery and intrigue as America's foremost ambassadors of absurd goodwill. Engaging in close cultural encounters with a diversity of dangerous wildlife and native peoples, Chris and Steve-O discover just how far off the evolutionary mark they may actually be.</p>",
    officialSite:
      "https://web.archive.org/web/20060806073043/http://www.mtv.com/onair/wildboyz/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-10-26",
  },
  {
    id: 3957,
    url: "https://www.tvmaze.com/shows/3957/the-dudesons",
    name: "The Dudesons",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49069.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49069.jpg",
    },
    summary:
      "<p>In this tv-show we'll get to follow <b>The Dudesons</b>, who are a four-man stunt group from Finland. They will try out some extreme stunts but also some exaggerated pranks, and while they're already doing it; they'll do some random retarded shit too.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 338,
      name: "Sub.",
      country: { name: "Finland", code: "FI", timezone: "Europe/Helsinki" },
    },
    premiered: "2006-07-06",
  },
  {
    id: 3958,
    url: "https://www.tvmaze.com/shows/3958/dirty-sanchez",
    name: "Dirty Sanchez",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49072.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49072.jpg",
    },
    summary:
      "<p>This is the story of three mates from the Welsh valleys and one warped Southener. They met through a mutual love of skateboarding and are bound by a complete disregard for their own personal safety. Their juvenile behaviour leads them into ridiculous circumstances as they constantly strive to achieve their next hit of twisted humour. This is <b>Dirty Sanchez</b>.</p>",
    officialSite: "http://www.mtv.co.uk/dirty-sanchez",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 94,
      name: "MTV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2003-07-02",
  },
  {
    id: 3959,
    url: "https://www.tvmaze.com/shows/3959/pure-pwnage-teh-tv-show",
    name: "Pure Pwnage: Teh TV Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49073.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49073.jpg",
    },
    summary:
      '<p>Pure Pwnage started as an Internet-distributed mockumentary series about the life and adventures of Jeremy (played by Jarett Cale), a Canadian self-proclaimed "pro gamer". Inspired by the style of Trailer Park Boys, the show has now migrated to TV on Canadian channel Showcase. This TV series is somewhat separate from the web series in that is does not strictly follow on from it\'s story, instead re-imagining some episodes from the web series for the new TV audience. The web series is also still in production and new episodes of that are forthcoming.</p>',
    officialSite: "http://www.purepwnage.com",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 6,
      name: "Showcase",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2010-03-12",
  },
  {
    id: 3960,
    url: "https://www.tvmaze.com/shows/3960/the-prime-minister-and-i",
    name: "The Prime Minister and I",
    genres: ["Comedy", "Family", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49076.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49076.jpg",
    },
    summary:
      "<p>Kwon Yul, a South Korea's youngest Prime Minister who is 100% capable in his work but 0% capable in parenting, he struggles in raising his 3 kids alone. Nam Da Jung, a young reporter who full of enthusiasm but always ends up missing big scoops. She accidentally gets into a scandal with Prime Minister and to keep his position, they get married. She enters his house and becomes a young affectionate mother to his kids like a Christmas present and that's when the love story begins.</p>",
    officialSite: "http://www.kbs.co.kr/drama/primeminister/index.html",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 128,
      name: "KBS2",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2013-12-09",
  },
  {
    id: 3961,
    url: "https://www.tvmaze.com/shows/3961/boarding-house-no-24",
    name: "Boarding House No. 24",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/95/238030.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/95/238030.jpg",
    },
    summary:
      "<p>A sitcom about seven boarders who have different personalities and situations. It is depicting dreams, careers, love and friendship of young people in their 20s who live under the same roof due to the plot of the house owner Kim Kwang Kyu.</p>",
    officialSite: "http://www.mbcplus.com/lodge",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 1277,
      name: "MBC Every1",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2014-09-23",
  },
  {
    id: 3962,
    url: "https://www.tvmaze.com/shows/3962/against-the-wall",
    name: "Against the Wall",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49095.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49095.jpg",
    },
    summary:
      "<p><b>Against the Wall</b> follows the trials and tribulations of Abby Kowalski, a single Chicago police officer who finally scores her dream job as a detective; but it turns out a nightmare for her close-knit family of cops. As the newest hire in the department's Internal Affairs division, Abby suddenly finds herself at odds with her fellow officers, including her father and three brothers. She must now figure out how she can pursue her dream of being a detective while keeping her family intact.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-07-31",
  },
  {
    id: 3963,
    url: "https://www.tvmaze.com/shows/3963/ikke-gjor-dette-hjemme",
    name: "Ikke gjør dette hjemme",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/255/637848.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/255/637848.jpg",
    },
    summary:
      '<p><b>Ikke gjør dette hjemme</b> is a Norwegian comedy-"docureality" TV series that aired on NRK1 from 2011 to 2017, with a total of 6 seasons. A Canadian remake was made for Discovery Channel (Canada) in 2013.</p>',
    officialSite: "https://tv.nrk.no/serie/ikke-gjoer-dette-hjemme",
    webChannel: null,
    language: "Norwegian",
    status: "Ended",
    network: {
      id: 91,
      name: "NRK1",
      country: { name: "Norway", code: "NO", timezone: "Europe/Oslo" },
    },
    premiered: "2011-01-06",
  },
  {
    id: 3964,
    url: "https://www.tvmaze.com/shows/3964/okkupert",
    name: "Okkupert",
    genres: ["Drama", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/229/574419.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/229/574419.jpg",
    },
    summary:
      "<p>In the near future, Norway is occupied by Russia on behalf of the European Union, due to the fact that the newly elected environmental friendly Norwegian government has stopped the all important oil- and gas-production in the North Sea.</p>",
    officialSite: "https://viaplay.no/serier/okkupert",
    webChannel: { id: 103, name: "Viaplay", country: null },
    language: "Norwegian",
    status: "Ended",
    network: null,
    premiered: "2015-10-04",
  },
  {
    id: 3965,
    url: "https://www.tvmaze.com/shows/3965/never-ever-do-this-at-home",
    name: "Never Ever Do This at Home",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49112.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49112.jpg",
    },
    summary:
      "<p><b>Never Ever Do This at Home</b> is a comedy-reality TV show that airs on Discovery Channel (Canada). Based on Ikke gjør dette hjemme, the show features hosts Teddy Wilson and Norm Sousa, who ignore the warning labels on a variety of household items, with varying results. The show made its debut on May 6, 2013 with two back-to-back episodes. The show has been bought by Spike TV to air in the United States. Reruns also air on MTV in Canada.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 298,
      name: "Discovery Channel",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2013-05-06",
  },
  {
    id: 3966,
    url: "https://www.tvmaze.com/shows/3966/the-chasers-media-circus",
    name: "The Chaser's Media Circus",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49115.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49115.jpg",
    },
    summary:
      "<p>The game show about the news game. It's Lateline meets Who's The Boss? but with hints of Naughtiest Home Videos. Hosted by Craig Reucassel, interrupted by Chas Licciardello. #MediaCircus</p>",
    officialSite: "https://iview.abc.net.au/show/chasers-media-circus",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 114,
      name: "ABC",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2014-10-15",
  },
  {
    id: 3967,
    url: "https://www.tvmaze.com/shows/3967/check-it-out-with-dr-steve-brule",
    name: "Check It Out! with Dr. Steve Brule",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49119.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49119.jpg",
    },
    summary:
      '<p>Channel 5\'s Dr.Steve Brule has a new show! Brule hits the streets this time around. Jam-Packed with interviews! Popular segments like "On the Spot" and "Doctor to Doctor" lets Steve experience things first-hand. Check it Out!</p>',
    officialSite:
      "http://www.adultswim.com/videos/check-it-out-with-dr-steve-brule/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-05-16",
  },
  {
    id: 3968,
    url: "https://www.tvmaze.com/shows/3968/match-of-the-day",
    name: "Match of the Day",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49117.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49117.jpg",
    },
    summary:
      "<p>Highlights and key analysis from all the day's games in the Barclays Premier League.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b007t9y1",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1964-08-22",
  },
  {
    id: 3969,
    url: "https://www.tvmaze.com/shows/3969/match-of-the-day-2",
    name: "Match of the Day 2",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/153/383741.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/153/383741.jpg",
    },
    summary: "<p>A round-up of the weekend's football action.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b007t9yb",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-08-17",
  },
  {
    id: 3970,
    url: "https://www.tvmaze.com/shows/3970/the-eric-andre-show",
    name: "The Eric André Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/125/312956.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/125/312956.jpg",
    },
    summary: null,
    officialSite: "http://www.adultswim.com/videos/the-eric-andre-show/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-05-21",
  },
  {
    id: 3971,
    url: "https://www.tvmaze.com/shows/3971/off-the-air",
    name: "Off the Air",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49128.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49128.jpg",
    },
    summary:
      '<p><i><b>"Off the Air"</b></i> is a series on Cartoon Network\'s Adult Swim programming block. The series lacks storylines and plots, and consists only of a collection of animations, internet videos, and archival footage, which are held loosely together by a theme. The series does not air on a regular schedule, with new episodes airing unannounced.</p>',
    officialSite: "http://www.adultswim.com/videos/off-the-air/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-01-01",
  },
  {
    id: 3972,
    url: "https://www.tvmaze.com/shows/3972/shaun-micallefs-mad-as-hell",
    name: "Shaun Micallef's MAD AS HELL",
    genres: ["Comedy", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49132.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49132.jpg",
    },
    summary:
      "<p><b>Shaun Micallef's MAD AS HELL</b> is a fantasy sitcom which follows the exploits of a TV comedian (played by Shaun Micallef), who, while shopping at a used car lot for a new station wagon, instead purchases a dilapidated 1928 Porter touring car. Shaun hears the car call his name in a woman's voice. The car turns out to be the reincarnation of his dead mother (voiced by Francis Greenslade). The car is coveted by a fanatical collector named Captain Manzini (Roz Hammond).</p>",
    officialSite: "https://iview.abc.net.au/show/shaun-micallef-s-mad-as-hell",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 114,
      name: "ABC",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2012-05-25",
  },
  {
    id: 3973,
    url: "https://www.tvmaze.com/shows/3973/the-increasingly-poor-decisions-of-todd-margaret",
    name: "The Increasingly Poor Decisions of Todd Margaret",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49139.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49139.jpg",
    },
    summary:
      "<p><b>The Increasingly Poor Decisions of Todd Margaret</b> is a comedy about an inept American placed in charge of sales at his company's London branch. He has no experience with British culture, knows nothing about sales, and has only one employee, Dave. Each episode begins with a scene of Margaret appearing in dire circumstances — in season one, he is a defendant in a British court, with a long list of charges against him being read; in season two, he is in what appears to be a North Korean nuclear missile base, being forced to press a launch button — then flashes back to portray the events leading to his sad fate.</p>",
    officialSite: "http://www.ifc.com/shows/todd-margaret",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 65,
      name: "IFC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-10-01",
  },
  {
    id: 3974,
    url: "https://www.tvmaze.com/shows/3974/the-job-lot",
    name: "The Job Lot",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49152.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49152.jpg",
    },
    summary:
      "<p>Sitcom set in a job centre. Under pressure to hit targets, Karl and George are on an ill-fated stakeout, while Natalie resorts to teaching Bryony some dubious new work skills.</p>",
    officialSite: "https://www.itv.com/itvplayer/the-job-lot",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 54,
      name: "ITV2",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-04-29",
  },
  {
    id: 3975,
    url: "https://www.tvmaze.com/shows/3975/rehab-addict",
    name: "Rehab Addict",
    genres: ["DIY"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/294/737022.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/294/737022.jpg",
    },
    summary:
      "<p>Nicole Curtis is saving historic houses, one broken-down fireplace at a time. Working in Detroit and Minneapolis, Nicole takes ramshackle homes from the wrecking ball to their original stunning glory. Whether it's managing her rugged crew or wrangling city officials, this single mom wields her hammer with skill and returns condemned properties to their place as the pride of the neighborhood.</p>",
    officialSite: "http://www.diynetwork.com/shows/rehab-addict",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 90,
      name: "DIY Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-10-14",
  },
  {
    id: 3976,
    url: "https://www.tvmaze.com/shows/3976/bar-karma",
    name: "Bar Karma",
    genres: ["Drama", "Science-Fiction", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/80/201778.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/80/201778.jpg",
    },
    summary:
      "<p>When one door closes, another one opens. And when that door opens into the most mysterious bar in the universe, strange things begin to happen. <b>Bar Karma</b>, a mystical watering hole that travels through time and space, pops into its patrons' lives when they need more than a stiff drink. Every happy hour, the Bar Karma staff guides one lost soul through a crossroads in his or her life, using eerie glimpses into the past, present and many possible futures. Some think it's destiny, others believe free will brought them to the bar. But none of them will pass through the Bar Karma doors without being changed forever.</p><p>Harnessing innovative technology from the mind of video game legend Will Wright and storytelling expertise from television hit-maker Albie Hecht, Creation Studios is looking to revolutionize the way TV is made. And that's by including you in the creative process of a new television series called Bar Karma - the first show of its kind. Utilizing Will Wright's StoryMaker Engine, you can develop the stories and characters you want to see. You'll also be able to vote on ideas submitted by other members of the Creation Studios community. The most popular ideas will become contenders for the actual plot developments on the show, written and filmed by our professional production team. It's not reality television; it's real television made by real people, including you.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 340,
      name: "Current TV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-02-11",
  },
  {
    id: 3977,
    url: "https://www.tvmaze.com/shows/3977/my-own-worst-enemy",
    name: "My Own Worst Enemy",
    genres: ["Drama", "Science-Fiction", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49172.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49172.jpg",
    },
    summary:
      "<p>The series followed the life of American secret agent Edward Albright and his cover, Henry Spivey, who had no knowledge of his double life. Albright was implanted with a chip allowing his handlers to physically switch Albright's personality to that of his cover.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-10-13",
  },
  {
    id: 3978,
    url: "https://www.tvmaze.com/shows/3978/metropolis",
    name: "Metropolis",
    genres: ["Travel", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49181.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49181.jpg",
    },
    summary:
      "<p><b>Metropolis</b> explores one important world city, uncovering rich historical secrets behind its extraordinary location.</p>",
    officialSite: "http://www.travelchannel.com/shows/metropolis",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 82,
      name: "Travel Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-01-04",
  },
  {
    id: 3979,
    url: "https://www.tvmaze.com/shows/3979/coma",
    name: "Coma",
    genres: ["Drama", "Science-Fiction", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49183.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49183.jpg",
    },
    summary:
      "<p>An adaptation of Robin Cook's novel about a doctor who suspects foul play at her hospital after seemingly healthy patients fall into comas.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-09-03",
  },
  {
    id: 3980,
    url: "https://www.tvmaze.com/shows/3980/the-beast",
    name: "The Beast",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49195.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49195.jpg",
    },
    summary:
      "<p>An unorthodox but effective FBI veteran, Charles Barker, who takes on a rookie partner, Ellis Dove, to train in his hard-edged and psychologically clever style of agenting.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-01-15",
  },
  {
    id: 3981,
    url: "https://www.tvmaze.com/shows/3981/the-unusuals",
    name: "The Unusuals",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49200.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49200.jpg",
    },
    summary:
      "<p>The Unusuals is a detective New York dramedy that stars Amber Tamblyn, from The Sisterhood of the Traveling Pants, and Adam Goldberg, who has starred in Friends, Medium and much more. Also signed on to The Unusuals is Lost star Harold Perrineau.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-04-08",
  },
  {
    id: 3982,
    url: "https://www.tvmaze.com/shows/3982/traffic-light",
    name: "Traffic Light",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/122/305877.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/122/305877.jpg",
    },
    summary:
      "<p>A comedy about how friendships and romances both enhance and complicate our lives, which centers on three longtime friends and their attempts to navigate the demands of their relationships.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-02-08",
  },
  {
    id: 3983,
    url: "https://www.tvmaze.com/shows/3983/a-league-of-their-own",
    name: "A League of Their Own",
    genres: ["Comedy", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/176/441341.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/176/441341.jpg",
    },
    summary:
      "<p><b>A League of Their Own</b> is a British sports-based comedy panel game that was first broadcast on Sky 1 on 11 March 2010. It is hosted by Gavin and Stacey star James Corden and features Andrew Flintoff and Jamie Redknapp as team captains. John Bishop and Georgie Thompson were regular panellists for the first four series alongside two weekly guests. Jack Whitehall joined the cast as a regular panellist from the fifth series onwards.</p>",
    officialSite:
      "https://www.sky.com/watch/title/series/40df65ca-31d4-4f26-9c59-8c54899e8d3b",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 63,
      name: "Sky 1",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-03-11",
  },
  {
    id: 3984,
    url: "https://www.tvmaze.com/shows/3984/backchat-with-jack-whitehall-and-his-dad",
    name: "Backchat with Jack Whitehall and His Dad",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49218.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49218.jpg",
    },
    summary:
      "<p>Jack Whitehall hosts a comedy chat show with a twist: he's joined by his dad.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b0460s1s",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-11-20",
  },
  {
    id: 3985,
    url: "https://www.tvmaze.com/shows/3985/the-big-fish-off",
    name: "The Big Fish Off",
    genres: ["Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49223.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49223.jpg",
    },
    summary:
      "<p>This brand new show for ITV4 pits two celebrities against each other in a battle to become top fisherman.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 310,
      name: "ITV4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-02-11",
  },
  {
    id: 3986,
    url: "https://www.tvmaze.com/shows/3986/cuckoo",
    name: "Cuckoo",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/191/479977.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/191/479977.jpg",
    },
    summary:
      "<p><b>Cuckoo</b> is every parent's worst nightmare - a slacker full of outlandish, New Age ideas.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b04d72n6",
    webChannel: {
      id: 71,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2012-09-25",
  },
  {
    id: 3987,
    url: "https://www.tvmaze.com/shows/3987/dynamo-magician-impossible",
    name: "Dynamo: Magician Impossible",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49233.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49233.jpg",
    },
    summary:
      "<p><b>Dynamo: Magician Impossible</b> is a fly on the wall documentary series which follows the life of English magician Steven Frayne, better known as Dynamo. The show is produced by Phil McIntyre Productions and Inner Circle Films for UKTV channel Watch and Universal Networks International. In 2012, the show was shortlisted at the 17th National Television Awards for Best Entertainment Program but lost to Michael McIntyre's Comedy Roadshow.</p>",
    officialSite: "http://w.uktv.co.uk/shows/dynamo-magician-impossible/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 295,
      name: "W",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-07-07",
  },
  {
    id: 3988,
    url: "https://www.tvmaze.com/shows/3988/facejacker",
    name: "Facejacker",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49234.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49234.jpg",
    },
    summary:
      "<p>The man of mystery returns. But he's put down his phone and now he's up close and personal!</p>",
    officialSite:
      "https://web.archive.org/web/20170425131128/http://www.channel4.com/programmes/facejacker",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-04-16",
  },
  {
    id: 3989,
    url: "https://www.tvmaze.com/shows/3989/fashionably-late-with-rachel-zoe",
    name: "Fashionably Late with Rachel Zoe",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/55/137507.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/55/137507.jpg",
    },
    summary:
      '<p>A new weekly talk show is coming to Lifetime, hosted by the renowned stylist and designer, Rachel Zoe. Straight from Zoe\'s fashion empire headquarters on Melrose Avenue, <i><b>"Fashionably Late with Rachel Zoe"</b></i> gives viewers the definitive inside look into what\'s hot and what\'s not in fashion, beauty and pop culture. Joined by fashion insider and Harper\'s Bazaar Editor-At-Large Derek Blasberg, Zoe\'s husband Rodger Berman, and their celebrity friends, each episode will be a fun, glamour-packed look at the world around us through the lens of fashion. The half-hour talker premieres Thursday, September 24, at 10:30pm ET/PT, following all-new episodes of "Project Runway."<br /><br />"Fashionably Late with Rachel Zoe" is produced by Hudsun Media with Michael Rourke, Kay O\'Connell, Rachel Zoe and Rodger Berman serving as executive producers. Eli Lehrer, Mary Donahue and David Hillman of Lifetime also executive produce. A total of eight episodes have been ordered for this season, adding to Lifetime\'s roster of fashion-centric programming that includes Emmy nominated "Project Runway," "Project Runway All Stars" and upcoming new series, "Project Runway Junior."</p>',
    officialSite:
      "http://www.mylifetime.com/shows/fashionably-late-with-rachel-zoe",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-24",
  },
  {
    id: 3990,
    url: "https://www.tvmaze.com/shows/3990/rob-dyrdeks-fantasy-factory",
    name: "Rob Dyrdek's Fantasy Factory",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49238.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49238.jpg",
    },
    summary:
      "<p>Rob Dyrdek has spent most of his life turning fantasy into reality. Even as a young skateboarder, Rob defied all odds by going pro at the age of 16. Since then, Rob has always believed that even the wildest fantasies are possible if you commit to making them real. Fans of MTV's Rob and Big know that he proves it by embracing, pursuing and achieving the products of his own imagination.</p>",
    officialSite: "http://www.mtv.com/shows/rob-dyrdeks-fantasy-factory",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-02-08",
  },
  {
    id: 3991,
    url: "https://www.tvmaze.com/shows/3991/the-green-green-grass",
    name: "The Green Green Grass",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49243.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49243.jpg",
    },
    summary:
      "<p>Sitcom spin-off from <i>Only Fools and Horses</i>, featuring the characters of Boycie and Marlene adapting to life in rural Shropshire. Starring John Challis and Sue Holderness.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b0073l35",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2005-09-09",
  },
  {
    id: 3992,
    url: "https://www.tvmaze.com/shows/3992/heartbreak-high",
    name: "Heartbreak High",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49247.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49247.jpg",
    },
    summary:
      "<p><b>Heartbreak High</b> is a hip and realistic series about the lives of teenage students, their families and teachers at a high school.</p><p>Heartbreak High is set in an inner city school at Sydney Beach, Hartley High, within a multi-racial area. Heartbreak High was originally a stage play which producer, Ben Gannon, turned into a successful film The Heartbreak Kid in 1993. The show captured more than 70 per cent of the youth audience in its first five weeks of broadcast in Australia.</p>",
    officialSite: "http://www.abc.net.au/heartbreak/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 114,
      name: "ABC",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "1995-02-11",
  },
  {
    id: 3993,
    url: "https://www.tvmaze.com/shows/3993/ideal",
    name: "Ideal",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49248.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49248.jpg",
    },
    summary:
      "<p>Sitcom about a small-time dope dealer and his strange collection of acquaintances.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006w7b3",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2005-01-11",
  },
  {
    id: 3995,
    url: "https://www.tvmaze.com/shows/3995/step-it-up",
    name: "Step It Up",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49250.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49250.jpg",
    },
    summary:
      '<p>In the all-new Lifetime docu-series <i><b>"Step It Up"</b>,</i> Traci Young-Byron, a former Miami Heat Dancer and longtime team captain, is the owner of the elite dance company, the Young Contemporary Dance Theatre (YCDT). Traci\'s competitiveness, especially her fierce rivalry with "Bring It!\'s" Miss D and her Dancing Dolls, leads her to use unconventional methods to motivate her co-ed dance team. For this company, the biggest competition isn\'t other teams; it\'s each other, as they must dance their hearts out to earn a coveted spot in a high-stakes performance each week. "Step It Up" (#StepItUp), premieres Friday, September 25, at 10pm ET/PT following the "Bring It!" season finale.</p><p>The following week, the series moves to its regular time period airing on Friday, October 2 at 9pm ET/PT. Over the course of eight hour-long episodes, the YCDT dancers push themselves to the limit to perform at high-profile events. Traci\'s tough, no-nonsense attitude prepares her meticulously trained and always-on-point dancers, who vary in age, for the myriad dance genres they face, including ballet, modern, contemporary, jazz, West African and hip-hop.</p>',
    officialSite: "http://www.mylifetime.com/shows/step-it-up",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-25",
  },
  {
    id: 3996,
    url: "https://www.tvmaze.com/shows/3996/blaze-and-the-monster-machines",
    name: "Blaze and the Monster Machines",
    genres: ["Comedy", "Action", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49252.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49252.jpg",
    },
    summary:
      "<p><b>Blaze and the Monster Machines</b> is about AJ who is an 8-year-old techie who drives monster-truck Blaze, the top racer in Axle City. The two go on adventures that have them taking on problems involving science and math. Many predicaments they face are caused by Blaze's rival, Crusher, a tractor-trailer that will do anything to beat other vehicles to the finish line. The animated series is billed as the first TV show for preschoolers to comprehensively cover areas of science, technology, engineering and math. Each episode introduces different STEM concepts, including buoyancy and trajectory.</p>",
    officialSite: "http://www.nickjr.com/blaze-and-the-monster-machines/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-13",
  },
  {
    id: 3997,
    url: "https://www.tvmaze.com/shows/3997/damien",
    name: "Damien",
    genres: ["Drama", "Horror", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/47/118738.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/47/118738.jpg",
    },
    summary:
      "<p><b>Damien</b> is a follow-up to the classic horror film, The Omen. The show follows the adult life of Damien Thorn, the mysterious child from the 1976 motion picture, who has grown up seemingly unaware of the satanic forces around him. Haunted by his past, Damien must now come to terms with his true destiny - that he is the Antichrist.</p>",
    officialSite: "http://www.aetv.com/shows/damien",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2016-03-07",
  },
  {
    id: 3998,
    url: "https://www.tvmaze.com/shows/3998/do-not-disturb",
    name: "Do Not Disturb",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49278.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49278.jpg",
    },
    summary:
      "<p>When a top New York newspaper designates The Inn as one of New York's hippest hotels, Neal jumps on the opportunity to be the face of the hotel for the article. But when the hotel's crass owner comes to town, Neal must vie for his place in the limelight while keeping his hotel looking top-notch.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-09-10",
  },
  {
    id: 3999,
    url: "https://www.tvmaze.com/shows/3999/the-philanthropist",
    name: "The Philanthropist",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49285.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49285.jpg",
    },
    summary:
      "<p><b>The Philanthropist</b> chronicles the heroic adventures of a billionaire playboy turned vigilante philanthropist. Teddy Rist is a successful tycoon whose life is forever changed after rescuing a young boy during a hurricane in the Nigerian town he was visiting. Rist is spontaneous and impulsive and quickly decides to channel his passion, power and money into helping those in need. Rist's actions are not just about helping others - he is purging his soul to help exorcise the inner demons which have been festering ever since his young son died and he lost everything he truly loved. Since the death of his son, the danger and risk to his life is the only way he can feel genuinely alive and he'll do anything in order to achieve his goals. A man who has everything but can feel nothing, Rist keeps his adrenaline pumping by putting his business head and money-making skills to good use through bargaining with the self-righteous, making deals with drug barons and trading with the nefarious. Teddy's business partner and friend is Philip Maidstone and Olivia is Philip's wife who also runs the charitable foundation set up by the two billionaires.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-06-24",
  },
  {
    id: 4000,
    url: "https://www.tvmaze.com/shows/4000/frozen-planet",
    name: "Frozen Planet",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49291.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49291.jpg",
    },
    summary:
      "<p>David Attenborough travels to the end of the earth, taking viewers on an extraordinary journey across the polar regions of our planet.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00mfl7n",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-10-26",
  },
  {
    id: 4001,
    url: "https://www.tvmaze.com/shows/4001/how-earth-made-us",
    name: "How Earth Made Us",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49294.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49294.jpg",
    },
    summary:
      "<p>Iain Stewart tells the epic story of how the planet has shaped our history. With spectacular images, surprising stories and a compelling narrative, the series discovers the central role played in human history by four different planetary forces.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00qclqx",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-01-19",
  },
  {
    id: 4002,
    url: "https://www.tvmaze.com/shows/4002/the-incredible-human-journey",
    name: "The Incredible Human Journey",
    genres: ["Adventure", "Travel", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/59/149710.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/59/149710.jpg",
    },
    summary:
      "<p>On <b>The Incredible Human Journey</b>, Dr. Alice Roberts travels the globe to discover the incredible story of how humans left Africa to colonise the world.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00klf6j",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-05-10",
  },
  {
    id: 4003,
    url: "https://www.tvmaze.com/shows/4003/apocalypse-the-second-world-war",
    name: "Apocalypse: The Second World War",
    genres: ["War", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49300.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49300.jpg",
    },
    summary:
      "<p><b>Apocalypse: The Second World War</b> is the story of World War II, told in painstakingly digitally colorized and evocative footage, and through the personal testimony of those who were there. More than six hundred hours of video taken by front-line soldiers, top-secret operatives, resistance fighters, and private citizens have been declassified and restored in full-color high definition. This six-part series, containing never-before-seen footage, will forever change the way we look at the Second World War.</p>",
    officialSite:
      "https://www.smithsonianchannel.com/shows/apocalypse-the-second-world-war/694",
    webChannel: null,
    language: "French",
    status: "Ended",
    network: {
      id: 106,
      name: "France 2",
      country: { name: "France", code: "FR", timezone: "Europe/Paris" },
    },
    premiered: "2009-09-08",
  },
  {
    id: 4004,
    url: "https://www.tvmaze.com/shows/4004/inside-combat-rescue",
    name: "Inside Combat Rescue",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49305.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49305.jpg",
    },
    summary:
      "<p>On <b>Inside Combat Rescue</b>, the elite Combat Rescue members of the U.S. Air Force, Pararescuemen, or PJs, have one mission which is to rescue American or Allied forces in extreme danger.</p>",
    officialSite: "http://channel.nationalgeographic.com/inside-combat-rescue/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-02-18",
  },
  {
    id: 4005,
    url: "https://www.tvmaze.com/shows/4005/web-of-lies",
    name: "Web of Lies",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/68/172392.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/68/172392.jpg",
    },
    summary:
      "<p>In a 21st-century world, we're increasingly living our lives online, sharing everything in one quick click from vacation photos and observances of daily life to breaking news stories and expressions of our deepest insecurities. It's easy to ignore or forget the millions of people who suddenly have access to your life online, but behind the clever screen names and witty captions hides a dark digital world with real dangers and risks.</p>",
    officialSite:
      "https://www.investigationdiscovery.com/tv-shows/web-of-lies/",
    webChannel: { id: 173, name: "discovery+", country: null },
    language: "English",
    status: "To Be Determined",
    network: null,
    premiered: "2014-01-08",
  },
  {
    id: 4006,
    url: "https://www.tvmaze.com/shows/4006/mobsters",
    name: "Mobsters",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49316.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49316.jpg",
    },
    summary:
      "<p>Features the true stories behind the mob legends who have ruthlessly clawed and fought their own precarious versions of the American Dream. Featuring such legendary figures as Whitey Bulger, John Gotti, and Murder, Inc. among others, Mobsters investigates their violent lives their struggles to grab and hold on to power, wealth and prestige, as well as ultimately, their violent deaths as justice prevails.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 341,
      name: "Biography Channel",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2007-06-05",
  },
  {
    id: 4007,
    url: "https://www.tvmaze.com/shows/4007/fbi-criminal-pursuit",
    name: "FBI: Criminal Pursuit",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49317.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49317.jpg",
    },
    summary:
      "<p><b>FBI: Criminal Pursuit</b> profiles the modern Federal Bureau of Investigation and explores the determination required to solve some of the most mystifying cases of the 21st Century. The challenges range from combating arsonists to tracking down terrorists, and the goal is always to bring the culprits to justice. This series not only showcases the heroes behind high-profile investigations, but the role high-tech investigative techniques play in solving these extraordinary cases.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-03-11",
  },
  {
    id: 4008,
    url: "https://www.tvmaze.com/shows/4008/monsters-inside-me",
    name: "Monsters Inside Me",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/131/329304.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/131/329304.jpg",
    },
    summary:
      "<p>These days, we're faced with the atrocious fear of viruses like Ebola because we've seen it cross our borders. But there's more than Ebola out there. Prepare to be shocked, disgusted and afraid... very, very afraid. An organism could be inside you, feeding on you or infecting you at this very moment! A parasitic, bacterial, viral or fungal attack is like a tumultuous roller coaster within the body that can take terrifying - sometimes deadly - twists and turns. <i>H</i>ost/biologist Dan Riskin provides scientific perspective throughout this 10-part series that vividly recounts the stories of people tormented by sinister creatures that have invaded their bodies.</p>",
    officialSite: "http://www.animalplanet.com/tv-shows/monsters-inside-me/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 92,
      name: "Animal Planet",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-07-01",
  },
  {
    id: 4009,
    url: "https://www.tvmaze.com/shows/4009/untold-stories-of-the-er",
    name: "Untold Stories of the E.R.",
    genres: ["Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/205/513122.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/205/513122.jpg",
    },
    summary:
      "<p><b>Untold Stories of the E.R.</b> is an inside look at some the craziest stories and cases to enter an emergency room.</p>",
    officialSite: "https://www.tlc.com/tv-shows/untold-stories-of-the-er",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-04-04",
  },
  {
    id: 4010,
    url: "https://www.tvmaze.com/shows/4010/the-book-of-negroes",
    name: "The Book of Negroes",
    genres: ["Drama", "War", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49320.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49320.jpg",
    },
    summary:
      "<p>Abducted from her village in West Africa, eleven-year-old Aminata Diallo is forced into a slave coffle and must endure a horrific ocean crossing. She is brought to a South Carolina plantation where she makes herself useful by using midwifery skills learned at her mother's side, all the while keeping the attentions of her jealous slave master, Robinson Appleby, at bay. Soon after Aminata reencounters Chekura, a fellow slave from West Africa, they are married in a clandestine ceremony. When their first baby is brutally abducted and sold by Appleby she vows to return one day to her homeland.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 36,
      name: "CBC",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2015-01-07",
  },
  {
    id: 4011,
    url: "https://www.tvmaze.com/shows/4011/kenny-vs-spenny",
    name: "Kenny vs. Spenny",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49328.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49328.jpg",
    },
    summary:
      "<p>Kenny and Spenny are two best friends who compete against each other. Their competitions are ridiculous, immature and totally intense.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 6,
      name: "Showcase",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2003-08-26",
  },
  {
    id: 4012,
    url: "https://www.tvmaze.com/shows/4012/reelside",
    name: "Reelside",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49363.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49363.jpg",
    },
    summary:
      "<p><b>Reelside</b> is a documentary series that seeks to capture the mythology of the film and television industry by exploring the making, makers and mentors involved. Each episode follows a different filmmaker on a journey, experiencing moments with the best, brightest, and most celebrated the industry has to offer. These moments serve as guideposts in the filmmaker's arc and story.</p>",
    officialSite: "http://www.themovienetwork.ca/reelside",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 38,
      name: "The Movie Network",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2015-06-05",
  },
  {
    id: 4013,
    url: "https://www.tvmaze.com/shows/4013/hells-kitchen-piekielna-kuchnia",
    name: "Hell's Kitchen Piekielna kuchnia",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/279/699499.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/279/699499.jpg",
    },
    summary:
      '<p>This is not a program for the weak. Culinary skill, race against time, gigantic stress and pressure. Emotions on the border of hysteria, fighting each other in the pursuit of a perfect dish. This and many other challenges await at the door of the world\'s most famous restaurant, "Hell\'s Kitchen". The order in the most inferior restaurant in Poland is guarded by the head Michał Bryś.</p><p>Only a few will survive here and leave the program with the raised forehead. They are awaiting the infernal tasks and above all, He - Michał Bryś, chef and co-owner of the L\'enfant Terrible restaurant in Warsaw, named "Head of Tomorrow 2016" by Gault &amp; Millau - Polish edition of one of the most prestigious culinary guides in the world. For ten weeks the participants have to play under his baton, even if everything will be against them.</p>',
    officialSite: "http://www.hellskitchen.polsat.pl/",
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 335,
      name: "Polsat",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2014-04-08",
  },
  {
    id: 4014,
    url: "https://www.tvmaze.com/shows/4014/masterchef",
    name: "MasterChef",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/236/591000.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/236/591000.jpg",
    },
    summary:
      "<p><b>MasterChef Italia</b> is the Italian version of culinary talent show <i>MasterChef</i>. Home cooks are tested and judged by professional chefs to find a future <i>MasterChef</i>.</p>",
    officialSite: "https://masterchef.sky.it/",
    webChannel: null,
    language: "Italian",
    status: "Running",
    network: {
      id: 299,
      name: "Sky Uno",
      country: { name: "Italy", code: "IT", timezone: "Europe/Rome" },
    },
    premiered: "2011-09-21",
  },
  {
    id: 4015,
    url: "https://www.tvmaze.com/shows/4015/fame-kills",
    name: "Fame Kills",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/23/58315.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/23/58315.jpg",
    },
    summary:
      "<p>Lurking behind the red carpets, swanky homes and star-studded parties is a seedier side of celebrity filled with jealousy, competition, greed and murder. <b>Fame Kills</b> shares the stories of rising stars whose journeys toward the privileged world of celebrity were cut short during deadly encounters. With re-enactments, interviews with friends, family, witnesses and detectives from the case, each hour-long episode covers one mesmerizing story from rise to fall, from unsolved crime to closed case and the characters are straight out of a classic whodunit film - but these stories are real and the endings are anything but happy.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 75,
      name: "REELZ",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-26",
  },
  {
    id: 4016,
    url: "https://www.tvmaze.com/shows/4016/behind-the-screams",
    name: "Behind the Screams",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/23/58316.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/23/58316.jpg",
    },
    summary:
      "<p>Psycho, The Exorcist and The Silence of the Lambs are some of the most terrifying horror movies ever put on screen but the shocking reality is these movies were inspired by actual events. <b>Behind the Screams</b> presents these iconic images of horror - a young boy gripped by demonic possession, an axe-murderer chasing a teen through the woods - and pulls back the curtain to reveal the real story. From serial killers to documented paranormal encounters, truth is sometimes stranger than fiction and each one-hour episode examines the hair-raising true incidents that sparked some of the most gripping big screen stories.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 75,
      name: "REELZ",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-26",
  },
  {
    id: 4017,
    url: "https://www.tvmaze.com/shows/4017/beyond-the-headlines",
    name: "Beyond the Headlines",
    genres: ["Drama", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/324/811460.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/324/811460.jpg",
    },
    summary:
      "<p><b>Beyond the Headlines</b> is a documentary series telling a more detailed story about what's on the headlines.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-01-31",
  },
  {
    id: 4018,
    url: "https://www.tvmaze.com/shows/4018/ninas-world",
    name: "Nina's World",
    genres: ["Comedy", "Adventure", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49391.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49391.jpg",
    },
    summary:
      "<p><b>Nina's World</b> is the animated adventures of a 6-year-old girl, her plushy toy Star (who only speaks when Nina is alone) and her abuelita (grandmother), voiced by 83-year-old powerhouse Rita Moreno.</p>",
    officialSite: "http://www.sproutonline.com/shows/ninas-world",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 342,
      name: "Universal Kids",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-09",
  },
  {
    id: 4019,
    url: "https://www.tvmaze.com/shows/4019/true-nightmares",
    name: "True Nightmares",
    genres: ["Crime", "Thriller", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/148/370424.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/148/370424.jpg",
    },
    summary:
      "<p>True stories of murder and mayhem morph into urban legends like the boogeyman or the monster under the bed – haunting our childhoods and scaring us throughout our lives. Investigation Discovery's (ID) upcoming series <b>True Nightmares</b> brings to life the true stories that spawned these hair-raising tales, proving once again that truth will <i>always</i> be scarier than fiction. Performer Todd Robbins, best known for his fascination with eccentric and arcane forms of entertainment, brings his shadowy and sardonic self to deliver six spine-tingling episodes, revealing that sometimes, our fears aren't mere figments of our imagination after all. Acting as an on-screen narrator, Robbins appears in and out of scenes, using his ominous tone and eerie charisma to masterfully weave together three stories each hour, playfully hinting that there is always more to the story to reveal.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-14",
  },
  {
    id: 4020,
    url: "https://www.tvmaze.com/shows/4020/past-life",
    name: "Past Life",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49531.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49531.jpg",
    },
    summary:
      "<p>Psychologist Dr. Kate McGinn and her partner, former detective Price Whatley, attempt to help Noah, a teen suffering from regression episodes - repressed memories from a past life - in which Noah remembers a previous life's kidnapping and murder. Together with Dr. Malachi Talmadge and Dr. Rishi Karna, McGinn and Whatley work to track down the perpetrator of a crime committed 14 years earlier</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-02-09",
  },
  {
    id: 4021,
    url: "https://www.tvmaze.com/shows/4021/the-keith-lemon-sketch-show",
    name: "The Keith Lemon Sketch Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49536.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49536.jpg",
    },
    summary:
      "<p>Fast-paced sketch show in which Keith Lemon affectionately spoofs the world of TV, film and famous faces.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 54,
      name: "ITV2",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-02-05",
  },
  {
    id: 4022,
    url: "https://www.tvmaze.com/shows/4022/60-minutes",
    name: "60 Minutes",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/237/592639.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/237/592639.jpg",
    },
    summary:
      "<p><b>60 Minutes</b> has been on the air since 1968, beginning on a Tuesday, but spending most of its time on Sundays, where it remains today. This popular news magazine provides both hard hitting investigations, interviews and features, along with people in the news and current events. 60 Minutes has set unprecedented records in the Nielsen's ratings with a number 1 rating, five times, making it among the most successful TV programs in all of television history. This series has won more Emmy awards than any other news program and in 2003, Don Hewitt, the creator (back in 1968), was awarded the Lifetime Achievement Emmy, along with the 60 Minute correspondents. Added to the 11 Peabody awards, this phenomenally long-lived series has collected 78 awards up to the 2005 season and remains among the viewers top choice for news magazine features.</p>",
    officialSite: "http://www.cbsnews.com/60-minutes/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1968-09-24",
  },
  {
    id: 4023,
    url: "https://www.tvmaze.com/shows/4023/crimewatch",
    name: "Crimewatch",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/299/749807.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/299/749807.jpg",
    },
    summary:
      "<p>Help us solve some of the UK's biggest cases. Join the team for dramatic reconstructions, CCTV footage and our wanted faces. Your call could be all it takes to put an offender behind bars. <b>Crimewatch</b> (formerly <i>Crimewatch UK</i>) is a long-running and high-profile British television programme produced by the BBC, that reconstructs major unsolved crimes in order to gain information from the public which may assist in solving the case. The programme was originally broadcast once a month on BBC One, although in more recent years the programme has more usually been broadcast roughly once every two months. It was announced on 15 October 2008 that the BBC would move the production of shows such as <i>Crimewatch</i> to studios in Cardiff. The show was first broadcast on 7 June 1984, and is based on the German TV show <i>Aktenzeichen XY … ungelöst</i> (which translates as <i>File Reference XY … Unsolved</i>). It was first presented by Nick Ross and Sue Cook. When Cook left in 1995, she was replaced by Jill Dando. After Dando's murder in April 1999, Fiona Bruce took over. Kirsty Young, Sonali Shah and Martin Bayfield currently front the show; following the departures of Ross and Bruce in 2007, Rav Wilding in December 2011 and Matthew Amroliwala in March 2015.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006ppmq",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1984-06-07",
  },
  {
    id: 4024,
    url: "https://www.tvmaze.com/shows/4024/in-with-the-flynns",
    name: "In with the Flynns",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49564.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49564.jpg",
    },
    summary:
      "<p>A family comedy set in Manchester. Will Mellor and Niky Wardley play parents who are young and vibrant, as much in love with life as they are with each other and their kids.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b01m2ng0",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-06-08",
  },
  {
    id: 4025,
    url: "https://www.tvmaze.com/shows/4025/lead-balloon",
    name: "Lead Balloon",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49567.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49567.jpg",
    },
    summary:
      "<p>Sitcom about Rick Spleen, a disillusioned stand-up comedian and writer whose career has not gone to plan.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006t889",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-10-04",
  },
  {
    id: 4027,
    url: "https://www.tvmaze.com/shows/4027/the-osbournes",
    name: "The Osbournes",
    genres: ["Drama", "Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/60/151112.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/60/151112.jpg",
    },
    summary:
      "<p>The Cleavers, the Bradys, the Huxtables...and now the Osbournes. It's the next generation of family-oriented sitcom, a reality-based comedy that follows the lives of Ozzy Osbourne and his family. There's no script, the situations are real, the family is normal...well, sort of. Theme song: Crazy, but hey that's how it goes. Millions of people living as foes--maybe it's not too late...to learn how to love, and forget how to hate!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-03-05",
  },
  {
    id: 4028,
    url: "https://www.tvmaze.com/shows/4028/rob-big",
    name: "Rob & Big",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49582.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49582.jpg",
    },
    summary:
      '<p>In this reality buddy comedy, professional street skater Rob Dyrdek and his best friend and bodyguard, Christopher "Big Black" Boykin, share a house in the Hollywood Hills, bouncing from one ridiculous moment to the next.</p>',
    officialSite: "http://www.mtv.com/shows/rob-and-big",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-11-02",
  },
  {
    id: 4029,
    url: "https://www.tvmaze.com/shows/4029/teachers",
    name: "Teachers",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49584.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49584.jpg",
    },
    summary:
      "<p>Irreverent comedy drama following the chaotic lives; loves and drinking sessions of a group of hapless teachers. They might be qualified to teach, but they've got a lot to learn...</p>",
    officialSite: "http://www.channel4.com/programmes/teachers",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2001-03-21",
  },
  {
    id: 4030,
    url: "https://www.tvmaze.com/shows/4030/the-royle-family",
    name: "The Royle Family",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49586.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49586.jpg",
    },
    summary:
      "<p>On the surface, <b>The Royle Family</b> appeared to be humdrum and low on incident - but such ordinary appearances belie the fact that it was a groundbreaking work of exceptional comedy invention.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006mbfy",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1998-09-14",
  },
  {
    id: 4031,
    url: "https://www.tvmaze.com/shows/4031/two-pints-of-lager-and-a-packet-of-crisps",
    name: "Two Pints of Lager and a Packet of Crisps",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49587.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49587.jpg",
    },
    summary:
      "<p>Sitcom about the lives and loves of five twenty-somethings in Runcorn.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006m8nj",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2001-02-26",
  },
  {
    id: 4032,
    url: "https://www.tvmaze.com/shows/4032/virtually-famous",
    name: "Virtually Famous",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/94/236939.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/94/236939.jpg",
    },
    summary:
      "<p>The panel show celebrating the people behind the best things in the news and on the web. Inimitable host Chris Ramsey does his best to keep control of team captains Vicky Pattison and Seann Walsh and regular panellist Scarlett Moffatt, plus a raft of celebrity guests, as they attempt to win points for knowing the most about the biggest online viral content of the week. From memes to viral vids and from filters to hashtags, this show features the funniest and the best.</p>",
    officialSite: "http://www.channel4.com/programmes/virtually-famous",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 41,
      name: "E4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-07-21",
  },
  {
    id: 4033,
    url: "https://www.tvmaze.com/shows/4033/new-looney-tunes",
    name: "New Looney Tunes",
    genres: ["Comedy", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49594.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49594.jpg",
    },
    summary:
      "<p><b>New Looney Tunes </b>is a Looney Tunes Production focusing on Bugs Bunny with new adventures in the form of shorts. The hilarious, heroic and mischievous Bugs Bunny you love is back! From Warner Bros. Animation, Bugs stars in an all-new series consisting of comedic shorts that find the iconic carrot-loving rabbit matching wits against (and getting the best of) classic characters like Yosemite Sam and Wile E. Coyote. Along the way, Bugs will encounter brand-new foes…and he'll have some help from new friends like Bigfoot and Squeaks the Squirrel.</p>",
    officialSite:
      "http://www.cartoonnetwork.com/video/wabbit/episodes/index.html",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-21",
  },
  {
    id: 4034,
    url: "https://www.tvmaze.com/shows/4034/quick-draw",
    name: "Quick Draw",
    genres: ["Comedy", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49601.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49601.jpg",
    },
    summary:
      "<p><b>Quick Draw</b> is an improvised comedy about Sheriff John Henry Hoyle's attempts to bring order to a raucous frontier town. With a fresh, unscripted feel, this show brings a riotous spontaneity to Hoyle's hunt for the Wild West's most dangerous criminals.</p>",
    officialSite: "http://www.hulu.com/quick-draw",
    webChannel: {
      id: 2,
      name: "Hulu",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2013-08-05",
  },
  {
    id: 4035,
    url: "https://www.tvmaze.com/shows/4035/cheap-eats",
    name: "Cheap Eats",
    genres: ["Food", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49602.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49602.jpg",
    },
    summary:
      "<p>If you're hungry for big flavors without breaking the bank, these unique cheap eats will deliver. In the windy city, a honky-tonk whiskey bar serves amazing tacos, and a small restaurant dresses house-made haute hot dogs and sausages with global flavors. In downtown New York, students flock to a delicious Cambodian sandwich shop the size of a dorm room. And in Williamsburg, New York, a quirky Venezuelan restaurant offers seventeen different arepas that will fill you up quickly on <b>Cheap Eats</b>.</p>",
    officialSite: "https://www.cookingchanneltv.com/shows/cheap-eats",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 174,
      name: "Cooking Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-22",
  },
  {
    id: 4036,
    url: "https://www.tvmaze.com/shows/4036/all-hail-king-julien",
    name: "All Hail King Julien",
    genres: ["Comedy", "Children", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49603.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49603.jpg",
    },
    summary:
      "<p>The world's biggest party animal is getting ready to ascend to the throne in <b>All Hail King Julien</b>. Long before the Zoosters arrive on Madagascar, King Julien holds court - not to mention nightly revelries - over a colorful cast that includes fan favorites Mort and Maurice, along with a host of all-new jungle dwellers as they take on the craziest adventures and wildest parties the jungle has to offer.</p>",
    officialSite: "https://www.netflix.com/title/80018987",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2014-12-19",
  },
  {
    id: 4037,
    url: "https://www.tvmaze.com/shows/4037/the-penguins-of-madagascar",
    name: "The Penguins of Madagascar",
    genres: ["Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49604.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49604.jpg",
    },
    summary:
      "<p>While Alex, Marty, Gloria, and Melman are still relaxing in Africa, the four penguins: Skipper, Kowalski, Private and Rico, have returned to New York City in Central Park Zoo. The Penguins will rule the roost at their Central Park Zoo home, doing secret missions in the heart of New York City. At times their secret missions beckon them to venture out of the zoo. Just as the team thinks it has its urban acreage under control, a new neighbor moves in next door: Julien, King of the Lemurs. Now the penguins must compete against him for the supreme leader of Central Park Zoo.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-11-28",
  },
  {
    id: 4038,
    url: "https://www.tvmaze.com/shows/4038/the-adventures-of-puss-in-boots",
    name: "The Adventures of Puss in Boots",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/101/254447.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/101/254447.jpg",
    },
    summary:
      "<p><b>The Adventures of Puss in Boots</b> is about the world's greatest feline fighter, lover and milk connoisseur takes on daring adventures in exotic locations in this family-friendly comedy series.</p>",
    officialSite: "https://www.netflix.com/title/80018988",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-01-16",
  },
  {
    id: 4039,
    url: "https://www.tvmaze.com/shows/4039/kung-fu-panda-legends-of-awesomeness",
    name: "Kung Fu Panda: Legends of Awesomeness",
    genres: ["Adventure", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49606.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49606.jpg",
    },
    summary:
      "<p><b>Kung Fu Panda: Legends of Awesomeness</b> is based on DreamWorks Animation's hit feature film, Kung Fu Panda which has grossed over $630 million at the worldwide box office and became the studio's most successful original feature film ever. Kung Fu Panda garnered an Oscar nomination for Best Animated Feature Film of the Year and a Golden Globe nomination for Best Animated Feature Film.</p>",
    officialSite: "http://www.nick.com/kung-fu-panda-legends-of-awesomeness/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 73,
      name: "Nicktoons",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-19",
  },
  {
    id: 4040,
    url: "https://www.tvmaze.com/shows/4040/cheyenne",
    name: "Cheyenne",
    genres: ["Action", "Adventure", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49608.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49608.jpg",
    },
    summary:
      "<p>Cheyenne Bodie was a big man, a former army scout who went west after the American Civil War and drifted from job to job, here a cowboy, there a lawman, and always a larger-than-life hero.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1955-09-20",
  },
  {
    id: 4041,
    url: "https://www.tvmaze.com/shows/4041/gilligans-island",
    name: "Gilligan's Island",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49609.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49609.jpg",
    },
    summary:
      "<p>Seven people go on a three hour tour out of Hawaii. A bad storm hits and they end up shipwrecked on a deserted island. Many zany adventures ensue, mainly due to Gilligan's ineptness. The group includes the Skipper, Gilligan, Mr. &amp; Mrs. Howell, two married millionaires, Ginger Grant a movie star, Mary Ann the simple girl next door and The Professor who seems to have a very wide field of knowledge.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1964-09-26",
  },
  {
    id: 4042,
    url: "https://www.tvmaze.com/shows/4042/the-addams-family",
    name: "The Addams Family",
    genres: ["Comedy", "Family", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49618.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49618.jpg",
    },
    summary:
      '<p><b>The Addams Family</b> is the creation of American cartoonist Charles Addams. A satirical inversion of the ideal of the perfect American nuclear family, they are an eccentric wealthy family who delight in everything grotesque and macabre, and are never really aware that people find them bizarre or frightening. In fact, they themselves are often terrified by "normal" people.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1964-09-18",
  },
  {
    id: 4043,
    url: "https://www.tvmaze.com/shows/4043/banacek",
    name: "Banacek",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49628.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49628.jpg",
    },
    summary:
      '<p>Thomas Banacek is an investigator who takes on "impossible cases" for insurance companies. In return for a finder\'s fee, Banacek will find a missing insured item. If a football player disappears in the middle of a play in front of thousands of fans, or an experimental rocket engine disappears in full view of a hundred witnesses at an exhibition hall... <b>Banacek</b> is the man to find them.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1972-09-13",
  },
  {
    id: 4044,
    url: "https://www.tvmaze.com/shows/4044/jonny-quest",
    name: "Jonny Quest",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49629.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49629.jpg",
    },
    summary:
      '<p>The adventures of <i><b>"Jonny Quest"</b></i> and his father Dr. Benton Quest. Along for the adventure is the multi-faceted "Race" Bannon, the mystical Hadji, and Jonny\'s dog, the irrepressible Bandit. They solve mysteries and try to thwart the evil of Dr. Zin.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1964-09-18",
  },
  {
    id: 4045,
    url: "https://www.tvmaze.com/shows/4045/gidget",
    name: "Gidget",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49631.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49631.jpg",
    },
    summary:
      "<p>Surf-mad, boy-crazy Gidget's adventures in school, at home and on the beach form the basis of this 1960s series starring a young Sally Field.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1965-09-15",
  },
  {
    id: 4046,
    url: "https://www.tvmaze.com/shows/4046/hr-pufnstuf",
    name: "H.R. Pufnstuf",
    genres: ["Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49632.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49632.jpg",
    },
    summary:
      "<p><b>H.R. Pufnstuf</b> is the story of Jimmy, a boy with a talking golden flute, whose adventure begins when he climbs into an abandoned sailboat on the shore of a lake. But it is Witchiepoo's trick to capture the boy to get his magic flute. He and the flute are rescued by a kindly dragon named H.R. Pufnstuf on Living Island where almost everything talks. All would be happy–what with dancing trees, singing frogs and a lollipop that owns a candy store–if it wasn't for that mean ol' Witchiepoo who keeps coming after the flute.</p>",
    officialSite: "http://www.sidandmartykrofft.com/show/h-r-pufnstuf/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1969-09-06",
  },
  {
    id: 4047,
    url: "https://www.tvmaze.com/shows/4047/the-monkees",
    name: "The Monkees",
    genres: ["Comedy", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49633.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49633.jpg",
    },
    summary:
      "<p><b>The Monkees</b> follows the adventures of four young men trying to make a name for themselves as rock 'n roll singers.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1966-09-12",
  },
  {
    id: 4048,
    url: "https://www.tvmaze.com/shows/4048/harlem-globe-trotters",
    name: "Harlem Globe Trotters",
    genres: ["Adventure", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50665.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50665.jpg",
    },
    summary:
      '<p>Harlem Globetrotters (called <b>Harlem Globe Trotters</b> in the opening titles) is a Saturday morning cartoon produced by Hanna-Barbera and CBS Productions, featuring animated versions of players from the famous basketball team, Harlem Globetrotters. Broadcast from September 12, 1970, to September 2, 1972 on CBS, and later re-run on NBC as The Go-Go Globetrotters, the show featured cartoon versions of George "Meadowlark" Lemon, Freddie "Curly" Neal, Hubert "Geese" Ausbie, J.C. "Gip" Gipson, Bobby Joe Mason, and Pablo Robertson, alongside their fictional bus driver and manager, Granny, and their dog mascot. Dribbles. The series worked to a formula where the team travels somewhere and typically get involved in a local conflict that leads to one of the Globetrotters proposing a basketball game to settle the issue.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1970-09-12",
  },
  {
    id: 4049,
    url: "https://www.tvmaze.com/shows/4049/the-banana-splits-adventure-hour",
    name: "The Banana Splits Adventure Hour",
    genres: ["Comedy", "Children", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49635.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49635.jpg",
    },
    summary:
      "<p><b>The Banana Splits Adventure Hour</b> was an hour-long, packaged television variety program featuring The Banana Splits, a fictional rock band composed of four funny animal characters. The costumed hosts of the show were Fleegle (guitar), Bingo (drums), Drooper (bass) and Snorky (keyboards).</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1968-09-07",
  },
  {
    id: 4050,
    url: "https://www.tvmaze.com/shows/4050/the-mary-tyler-moore-show",
    name: "The Mary Tyler Moore Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49640.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49640.jpg",
    },
    summary:
      "<p><b>The Mary Tyler Moore Show</b> was one of the most literate, realistic, and enduring situation comedies of the 1970s. Mary Richards was the idealized single career woman. She had come to Minneapolis after breaking up with a man she had been dating for four years. Ambitious, and looking for new friends, she moved into an older apartment building and went to work as an assistant producer of the local news show on television station WJM-TV. In her early 30s, Mary symbolized the independent woman of the 1970s.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1970-09-19",
  },
  {
    id: 4051,
    url: "https://www.tvmaze.com/shows/4051/the-hardy-boysnancy-drew-mysteries",
    name: "The Hardy Boys/Nancy Drew Mysteries",
    genres: ["Action", "Adventure", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49650.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49650.jpg",
    },
    summary:
      "<p><b>The Hardy Boys/Nancy Drew Mysteries</b> recount the adventures of the famous teenage sleuths, based on the two series of juvenile mystery novels by the Edward Stratemeyer syndicate under the names Franklin W. Dixon and Carolyn Keene. Frank and Joe Hardy are the sons of a private detective, and Nancy Drew is the daughter of a criminal attorney. In the first season, stories alternated week by week between the two families, but in the second season the independent Nancy Drew adventures were phased out so that all were working as a team. In the third season, Nancy Drew was eliminated completely and the Hardys became more involved in cases of international intrigue.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1977-01-30",
  },
  {
    id: 4052,
    url: "https://www.tvmaze.com/shows/4052/spider-man-and-his-amazing-friends",
    name: "Spider-Man and His Amazing Friends",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49654.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49654.jpg",
    },
    summary:
      '<p>Peter Parker (Spider-Man), Bobby Drake (Iceman), and Angelica Jones (Firestar) are all college students at Empire State University. After working together to defeat the Beetle and recovering the "Power Booster" he stole from Tony Stark (a.k.a. Iron Man) the trio decide to team-up permanently as the Spider-Friends.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1981-09-12",
  },
  {
    id: 4053,
    url: "https://www.tvmaze.com/shows/4053/jem",
    name: "Jem",
    genres: ["Drama", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/44/110920.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/44/110920.jpg",
    },
    summary:
      "<p>This fabulous 80's cartoon was every little girls dream come true. Jerrica Benton's father has left her a very special gift. It's Synergy, a holographic projection system that can create illusions of anything, anywhere, anytime. Jerrica uses Synergy to create Jem, her alter ego and the lead singer of Jem and The Holograms to save her father's company: Starlight Music. This popular cartoon series chronicles this band's adventures as well as their arch rivals The Misfits and their friends The Stingers. The music of these three groups is definately the highlight of the show. Jem is a \"truly outrageous\" cartoon with a message of love, friendship, ambition, and rock-n-roll.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1985-10-06",
  },
  {
    id: 4054,
    url: "https://www.tvmaze.com/shows/4054/father-dowling-mysteries",
    name: "Father Dowling Mysteries",
    genres: ["Drama", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49656.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49656.jpg",
    },
    summary:
      "<p>The show began as an NBC Made for TV Movie in 1987 and the show was to have begun weekly in 1988 though because of a writer's strike in 1988 it didn't begin weekly until 1989. After it's 1st season the show left NBC and ABC took the show from 1990 until 1991.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1989-01-20",
  },
  {
    id: 4055,
    url: "https://www.tvmaze.com/shows/4055/cto-gde-kogda",
    name: "Что? Где? Когда?",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49665.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49665.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "Russian",
    status: "Running",
    network: {
      id: 307,
      name: "Первый канал",
      country: {
        name: "Russian Federation",
        code: "RU",
        timezone: "Asia/Kamchatka",
      },
    },
    premiered: "1975-09-04",
  },
  {
    id: 4056,
    url: "https://www.tvmaze.com/shows/4056/big-red-the-original-outlaw-racer",
    name: "Big Red: The Original Outlaw Racer",
    genres: ["Drama", "Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755437.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755437.jpg",
    },
    summary:
      "<p><b>Big Red: The Original Outlaw Racer</b> takes viewers deep inside the operation for an intimate and authentic look at the true core of the Team Big Red spirit and reveals what it takes to make a 1969 Camaro competitive in numerous and distinctly different disciplines of modern auto racing.</p>",
    officialSite: "http://www.nbcsnauto360.com/big-red-camaro.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 104,
      name: "NBCSN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-27",
  },
  {
    id: 4057,
    url: "https://www.tvmaze.com/shows/4057/titus",
    name: "Titus",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49668.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49668.jpg",
    },
    summary:
      "<p>In this dark comedy based on the life of comedian Christopher Titus and his stand-up routine \"Norman Rockwell is Bleeding\", Titus plays himself trying to run a custom car shop. He has to deal with his overbearing jerk of a father Ken, his crazy half-brother Dave, his prim proper friend Tommy, and his girlfriend Erin. Titus narrates the show, typically from his Neutral Room, a black-and-white empty room, and regularly interrupts the story for off-the-cuff flashbacks from his childhood or Ken's many's failed incidents of romance and fatherhood. Many of the incidents presented are taken from Titus' life.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-03-20",
  },
  {
    id: 4059,
    url: "https://www.tvmaze.com/shows/4059/the-war-next-door",
    name: "The War Next Door",
    genres: ["Comedy", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49727.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49727.jpg",
    },
    summary:
      "<p>In this comedy from the creators of <i>Pete &amp; Pete</i>, secret agent Kennedy Smith retires to the suburbs to live a quiet life with his family. However, master villain Kriegman and his henchwoman Barbara Bush move in next door to continue their campaign against their archenemesis Smith. Now Smith must navigate the normal everyday life that he never had, reconnect with his family, and... thwart death threats and inter-neighbor rivalries with Kriegman. Confusing matters further, each episode either Smith or Kriegman dies... but the next week, everything is back to normal.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-07-23",
  },
  {
    id: 4060,
    url: "https://www.tvmaze.com/shows/4060/duck-quacks-dont-echo",
    name: "Duck Quacks Don't Echo",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49725.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49725.jpg",
    },
    summary:
      "<p>Can dogs catch yawns from humans? Is it possible to sneeze with your eyes open? And do duck quacks indeed echo? Luckily, Lee Mack's on hand to answer these important questions in a brand new comedy panel series.</p><p>Each week, three celebrity guests will offer up an incredible fact for discussion. With the help of some plucky boffins, they'll attempt to prove to their fellow panelists - and the nation - it's true. The first episode features Ruth Jones, alongside Dara O'Briain and Spice Girl, Melanie C.</p><p>No stone will be left unturned in pursuit of the truth, whether it involves gluing celebs to the ceiling or giving electric shocks to the general public - for research purposes, of course.</p><p>Panelists will score one another as they strive to unearth the most mind-blowing facts and the winner each week will take part in a daring studio stunt in the name of science (and great telly).</p><p>\"I'm really, really excited at the prospect of finally putting to the test such important, profound and meaningful debates as, 'Do cows with names really provide more milk?'\" says Lee Mack.</p><p>Well, do they?</p>",
    officialSite: "http://www.sky.com/tv/show/duck-quacks-dont-echo",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 63,
      name: "Sky 1",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-02-07",
  },
  {
    id: 4061,
    url: "https://www.tvmaze.com/shows/4061/educating-cardiff",
    name: "Educating Cardiff",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49726.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49726.jpg",
    },
    summary:
      "<p><b>Educating Cardiff</b> captures every detail of what life is like for the students and staff at Willows High School.</p>",
    officialSite: "http://www.channel4.com/programmes/educating-cardiff",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-08-25",
  },
  {
    id: 4062,
    url: "https://www.tvmaze.com/shows/4062/never-mind-the-buzzcocks",
    name: "Never Mind the Buzzcocks",
    genres: ["Comedy", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49728.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49728.jpg",
    },
    summary:
      "<p>Irreverent pop quiz, with guest competitors and regular captains from the worlds of music, TV and comedy lining up in two teams.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006v0dz",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1996-11-12",
  },
  {
    id: 4063,
    url: "https://www.tvmaze.com/shows/4063/the-island-with-bear-grylls",
    name: "The Island with Bear Grylls",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49731.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49731.jpg",
    },
    summary:
      "<p>Bear Grylls drops groups of men and women on desert islands in the Pacific. Can they survive?</p>",
    officialSite:
      "http://www.channel4.com/programmes/the-island-with-bear-grylls",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-05-05",
  },
  {
    id: 4064,
    url: "https://www.tvmaze.com/shows/4064/the-zeta-project",
    name: "The Zeta Project",
    genres: ["Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/300/751947.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/300/751947.jpg",
    },
    summary:
      "<p>In this spinoff from <i>Batman Beyond</i>, Zeta is a robot with a holographic projector and built-in weaponry, allowing it to disguise himself as any human being so that he can assassinate his targets. The government designs Zeta for black-op missions, but it develops sentience and a will of its own... and goes on the run. Helping him is a runaway, Ro Rowan.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-01-27",
  },
  {
    id: 4065,
    url: "https://www.tvmaze.com/shows/4065/the-zoo-gang",
    name: "The Zoo Gang",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49768.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49768.jpg",
    },
    summary:
      "<p>An international team of four former French Resistance fighters meet again in the 60s. Despite their age, they vow to stick together and use their skills to avenge the death of one of their own, Claude, and raise the funds to build a hospital in his name. Claude's son Georges, an inspector with the French police, reluctantly helps them in their exploits along the French Riviera.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1974-04-05",
  },
  {
    id: 4066,
    url: "https://www.tvmaze.com/shows/4066/master-ps-family-empire",
    name: "Master P's Family Empire",
    genres: ["Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755438.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755438.jpg",
    },
    summary:
      "<p>Music mogul Master P is opening the doors to his family home on the network's original series, <b>Master P's Family Empire</b>. Master P, whose real name is Percy Miller, is a single father who made it his mission to forge the Miller family empire—but with five kids ranging in age from nine to 25 it's not always easy keeping his business interests in order, let alone keeping his kids on track. How will he manage his own projects along with the singing, modeling, acting and sports careers of his children without losing his mind? <i>Master P's Family Empire</i> will give an inside look at how this single father skillfully juggles his roles as entrepreneur, philanthropist and hip-hop artist with his most important role: being a dad.</p>",
    officialSite: "http://www.reelz.com/master-p/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 75,
      name: "REELZ",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-11-28",
  },
  {
    id: 4067,
    url: "https://www.tvmaze.com/shows/4067/the-way-we-live-now",
    name: "The Way We Live Now",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49776.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49776.jpg",
    },
    summary:
      "<p>Set in the railway boom of the 1870s, <b>The Way We Live Now</b> captures the turmoil as the old order is swept aside by the brash new forces of business and finance. It contains all the elements that made Trollope the most popular novelist of his day - the trials and tribulations of young love, the enduring values of honourable men; but also the raw energy and excitement of the most powerful city the world had ever seen, and the greed and corruption that lay just below its glittering surface. It is packed with incident - elopement, scandal, suicide, fortunes made and lost, love lost and won.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p02zn08f",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2001-11-11",
  },
  {
    id: 4068,
    url: "https://www.tvmaze.com/shows/4068/love-at-first-kiss",
    name: "Love at First Kiss",
    genres: ["Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/150/375009.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/150/375009.jpg",
    },
    summary:
      "<p>The provocative eight-episode series, from <i>The Bachelor</i> creator Mike Fleiss and Warner Horizon Television, will bring together two strangers, both single and looking for love, who use a kiss as their initial greeting and first and only impression. The experiment is as simple as it sounds - walk up to a complete stranger, kiss, and then decide if there's enough chemistry to want to get to know each other better. The series will explore the captivating power of a first kiss between two strangers. These sometimes-steamy, sometimes-awkward smooches in the \"Kiss Room\" can either fall flat or lead to a two-minute speed date, and eventually a full-on date. Can one kiss truly lead to true romance? Cameras will catch all of the can't-miss moments, candid confessions as well as physical and emotional connections.</p>",
    officialSite: "http://www.tlc.com/tv-shows/love-at-first-kiss/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2016-08-03",
  },
  {
    id: 4069,
    url: "https://www.tvmaze.com/shows/4069/sweat-inc",
    name: "Sweat Inc.",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/25/63492.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/25/63492.jpg",
    },
    summary:
      "<p>Over the last decade, a rising health consciousness has led 30,000 fitness clubs to open across the country, serving more than 58 million members annually. Valued at well over 20 billion dollars, the exercise industry is always on the lookout for the next big idea to continue its rapid growth. With that in mind, on Tuesday, October 20 at 10/9c, Spike debuts <b>Sweat Inc.</b>, an unscripted competition series hosted and judged by acclaimed health and wellness expert, Jillian Michaels. <i>Sweat Inc.</i> sets out to find America's next big fitness phenomenon and help turn it into an exercise craze. The winner of the competition will receive $100,000, the opportunity to develop their brand and launch their program at multiple Retro Fitness locations across the country, as well as a feature in Women's Health Magazine.</p>",
    officialSite: "http://www.spike.com/shows/sweat-inc",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 34,
      name: "Paramount Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-20",
  },
  {
    id: 4070,
    url: "https://www.tvmaze.com/shows/4070/pretty-strong",
    name: "Pretty. Strong.",
    genres: ["Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50577.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50577.jpg",
    },
    summary:
      '<p>Featuring the fierce and fit women of the Legends Football League, the fastest-growing, all-female American football organization. Following the league\'s two-time reigning champions the Chicago Bliss, this series delves into the lives of eight women of the gridiron as they navigate life both on and off the field. Wide receiver Alli Alberts, center Jamie Barwick, offensive lineman Deena Fagiano, quarterback Heather Furr, running back ChrisDell "Chrissy" Harris, offensive/defensive lineman Nneka "Nani" Nwani, defensive lineman Yashi Rice and defensive lineman Chantell "Telli" Taylor have full-time careers by day, and are breaking gender barriers playing tackle football by night. With a work hard, play hard mentality, these women are on a mission to inspire, blaze trails and defy the odds.</p>',
    officialSite: "https://www.oxygen.com/pretty-strong",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 79,
      name: "Oxygen",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-06",
  },
  {
    id: 4071,
    url: "https://www.tvmaze.com/shows/4071/las-fierbinti",
    name: "Las Fierbinți",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49780.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49780.jpg",
    },
    summary: null,
    officialSite: "http://lasfierbinti.protv.ro",
    webChannel: null,
    language: "Romanian",
    status: "Running",
    network: {
      id: 344,
      name: "PRO TV",
      country: { name: "Romania", code: "RO", timezone: "Europe/Bucharest" },
    },
    premiered: "2012-03-01",
  },
  {
    id: 4072,
    url: "https://www.tvmaze.com/shows/4072/beyblade",
    name: "Beyblade",
    genres: ["Action", "Anime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/253/634524.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/253/634524.jpg",
    },
    summary:
      "<p>Thirteen-year-old Tyson Granger (Takao Kinomiya), along with his fellow teammates, Kai Hiwatari, Max Tate (Max Mizuhura), and Ray Kon (Rei Kon), strive to become the greatest Beybladers in the world. With the technical help of the team's resident genius, Kenny (Kyouju), and with the powerful strength of their BitBeasts, the Bladebreakers armed with their tops (AKA: Blades) attempt to reach their goal.</p>",
    officialSite: "http://www.beyblade.com/splash?redir=1",
    webChannel: { id: 21, name: "YouTube", country: null },
    language: "Japanese",
    status: "Running",
    network: null,
    premiered: "2001-01-08",
  },
  {
    id: 4073,
    url: "https://www.tvmaze.com/shows/4073/river-monsters",
    name: "River Monsters",
    genres: ["Action", "Adventure", "Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49797.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49797.jpg",
    },
    summary:
      "<p>In <b>River Monsters</b>, join host, biologist and extreme angler Jeremy Wade, as he catches the extraordinary and supersized fish that lurk in our planet's rivers and lakes. Traveling the globe and risking his life, he searches for mysterious freshwater predators, on a mission to test the myths surrounding these almost supernatural creatures.</p>",
    officialSite: "http://www.animalplanet.com/tv-shows/river-monsters/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 92,
      name: "Animal Planet",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-04-05",
  },
  {
    id: 4076,
    url: "https://www.tvmaze.com/shows/4076/legends-with-jbl",
    name: "Legends with JBL",
    genres: ["Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49826.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49826.jpg",
    },
    summary:
      '<p><b>Legends with JBL</b> is where former WWE Wrestler &amp; Hall of Famer "JBL", John Bradshaw Layfield sits done with and interviews some of the greats of the wrestling world past &amp; present. He will interview Wrestlers, Managers, General Mangers, Owners, Valets and much more.</p>',
    officialSite: "http://www.wwe.com/inside/networkschedule",
    webChannel: {
      id: 15,
      name: "WWE Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-09-21",
  },
  {
    id: 4077,
    url: "https://www.tvmaze.com/shows/4077/sports-jeopardy",
    name: "Sports Jeopardy!",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49836.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49836.jpg",
    },
    summary:
      "<p>The first season of new television quiz show <b>Sports Jeopardy!</b> with Dan Patrick will premiere on Wednesday, September 24 on Crackle and all Crackle platforms. Hosted by Emmy®-Award winning sportscaster Dan Patrick (The Dan Patrick Show), Sports Jeopardy! is a weekly 30-minute program that combines the excitement and prestige of Emmy Award® winning quiz show Jeopardy! with the rich and diverse world of sports. New episodes will be available to stream on demand year round every Wednesday for a total of 52 episodes each year.</p><p>More than 30,000 contestants registered online for auditions held this past summer in Los Angeles, Las Vegas, Dallas, Chicago and New York. Each contestant was then presented with a qualifying test of 30 clues in 30 sports-related categories for the first phase of the audition process. For those who passed that initial test, the second phase of auditions featured mock game play and a short interview. Qualified contestants who passed the test and interview and met all eligibility requirements went on to appear on the show.</p>",
    officialSite: "http://www.sportsjeopardy.com",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 104,
      name: "NBCSN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-24",
  },
  {
    id: 4079,
    url: "https://www.tvmaze.com/shows/4079/ill-have-what-phils-having",
    name: "I'll Have What Phil's Having",
    genres: ["Adventure", "Food", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49867.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49867.jpg",
    },
    summary:
      "<p>Expect the unexpected as host Phil Rosenthal, Emmy award winning producer and creator of <i>Everybody Loves Raymond</i>, brings his unique brand of humor to his search for the world's best food. <b>I'll Have What Phil's Having</b> is an unforgettable 6-part food and travel series that dishes up sublime fare bursting onto the international culinary scene, hidden delicacies, and a healthy dose of laughs.</p>",
    officialSite: "https://www.netflix.com/title/80068216",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-09-28",
  },
  {
    id: 4080,
    url: "https://www.tvmaze.com/shows/4080/sugar-showdown",
    name: "Sugar Showdown",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/41/103188.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/41/103188.jpg",
    },
    summary:
      "<p><b>Sugar Showdown</b> is a fun and intense competition series that celebrates all things sweet and delicious. Three expert bakers enter the Sugar Showdown studio and compete in episodes that feature cakes, pies, cupcakes or donuts. First, the competitors must make their best dessert incorporating one mystery ingredient. After three distinguished judges eliminate one competitor, the finalists must make creations based on a theme. One baker will be crowned the champion, winning bragging rights and $10,000.</p>",
    officialSite: "http://www.cookingchanneltv.com/shows/sugar-showdown.html",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 174,
      name: "Cooking Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-01",
  },
  {
    id: 4081,
    url: "https://www.tvmaze.com/shows/4081/the-revolution",
    name: "The Revolution",
    genres: ["War", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49871.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49871.jpg",
    },
    summary:
      "<p>The American Revolution (1775-83) is also known as the American Revolutionary War and the U.S. War of Independence. The conflict arose from growing tensions between residents of Great Britain's 13 North American colonies and the colonial government, which represented the British crown. Skirmishes between British troops and colonial militiamen in Lexington and Concord in April 1775 kicked off the armed conflict, and by the following summer, the rebels were waging a full-scale war for their independence. France entered the American Revolution on the side of the colonists in 1778, turning what had essentially been a civil war into an international conflict. After French assistance helped the Continental Army force the British surrender at Yorktown, Virginia, in 1781, the Americans had effectively won their independence, though fighting would not formally end until 1783.</p>",
    officialSite:
      "http://www.history.com/topics/american-revolution/american-revolution-history",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-06-04",
  },
  {
    id: 4083,
    url: "https://www.tvmaze.com/shows/4083/growing-pains",
    name: "Growing Pains",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49872.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49872.jpg",
    },
    summary:
      "<p><b>Growing Pains</b> follows the life of Jason Seaver, a psychiatrist who works out of an office at home while his wife Maggie goes back to work at the local news studio as a reporter. Both have their hands full with their 3 kids: wild child and ladies' man Mike, bookworm and honor student Carol, and rambunctious Ben. A few years after Maggie goes back to work, the family gets a surprise when fourth child Chrissy is born.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1985-09-24",
  },
  {
    id: 4084,
    url: "https://www.tvmaze.com/shows/4084/code-monkeys",
    name: "Code Monkeys",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49873.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49873.jpg",
    },
    summary:
      "<p>Two game developers try to survive their crazy Texas billionaire boss and his rich prissy son in 1983.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 248,
      name: "G4",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-09-11",
  },
  {
    id: 4085,
    url: "https://www.tvmaze.com/shows/4085/university-challenge",
    name: "University Challenge",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49875.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49875.jpg",
    },
    summary:
      "<p>Academic quiz show where teams of students from UK universities answer questions on all manner of subjects.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006t6l0",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1962-09-21",
  },
  {
    id: 4086,
    url: "https://www.tvmaze.com/shows/4086/the-next-step",
    name: "The Next Step",
    genres: ["Drama", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49876.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49876.jpg",
    },
    summary:
      "<p><b>The Next Step</b> is a Canadian teen drama series created by Frank van Keeken and produced by Temple Street Productions. Shot in a dramatic mockumentary style, the series focuses on a group of dancers who attend The Next Step Dance Studio as they strive to win a series of dance competitions</p>",
    officialSite: "http://www.family.ca/not-available.php",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 100,
      name: "Family Channel",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2013-03-08",
  },
  {
    id: 4087,
    url: "https://www.tvmaze.com/shows/4087/top-buzzer",
    name: "Top Buzzer",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49877.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49877.jpg",
    },
    summary:
      "<p><b>Top Buzzer</b> was a British sitcom written by Johnny Vaughan and Ed Allen, styled as television's first ever \"dope opera\". It was shown on MTV in 2004 and later repeated on Five. It revolves around two small-time cannabis dealers, Lee (Stephen Graham) and Sticky (James Lance), and their customers. Sticky fancies himself to be the next Richard Branson, while Lee aspires to be the Kriss Payne of 'Super Pot'.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-12-01",
  },
  {
    id: 4088,
    url: "https://www.tvmaze.com/shows/4088/cyderdelic",
    name: "Cyderdelic",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49878.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49878.jpg",
    },
    summary:
      "<p><b>Cyderdelic</b> was a spoof mockumentary about a group of over-zealous West Country wannabe revolutionaries.</p>",
    officialSite: "http://www.bbc.co.uk/comedy/cyderdelic/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2002-01-07",
  },
  {
    id: 4089,
    url: "https://www.tvmaze.com/shows/4089/freddys-nightmares",
    name: "Freddy's Nightmares",
    genres: ["Drama", "Horror", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49879.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49879.jpg",
    },
    summary:
      "<p><b>Freddy's Nightmares</b> (full title: Freddy's Nightmares: A Nightmare on Elm Street: The Series) is an American horror anthology series, which aired in syndication from October 1988 until March 1990. A spin-off from the Nightmare on Elm Street series, each story was introduced by Freddy Krueger (played, as in the movies, by Robert Englund).</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1988-10-09",
  },
  {
    id: 4090,
    url: "https://www.tvmaze.com/shows/4090/fonejacker",
    name: "Fonejacker",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/40/101753.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/40/101753.jpg",
    },
    summary:
      "<p>Turning miscommunication into an art-form, the Fonejacker is a man on a mission. He's addicted to making prank telephone calls to spread comical confusion throughout the nation...</p>",
    officialSite:
      "https://web.archive.org/web/20161223050323/https://www.channel4.com/programmes/fonejacker",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 41,
      name: "E4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2007-07-05",
  },
  {
    id: 4091,
    url: "https://www.tvmaze.com/shows/4091/rwby",
    name: "RWBY",
    genres: ["Action", "Adventure", "Anime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/281/704487.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/281/704487.jpg",
    },
    summary:
      "<p>The future-fantasy world of Remnant is filled with ravenous monsters, treacherous terrain, and more villains than you can shake a sniper-scythe at. Fortunately, Beacon Academy is training Huntsman and Huntresses to battle the evils of the world, and Ruby, Weiss, Blake, and Yang are ready for their first day of class.</p>",
    officialSite: "https://roosterteeth.com/series/rwby",
    webChannel: {
      id: 32,
      name: "Rooster Teeth",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Running",
    network: null,
    premiered: "2013-07-18",
  },
  {
    id: 4092,
    url: "https://www.tvmaze.com/shows/4092/seraph-of-the-end-vampire-reign",
    name: "Seraph of the End: Vampire Reign",
    genres: ["Action", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49888.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49888.jpg",
    },
    summary:
      "<p>One day, a mysterious virus appeared on Earth which killed every infected human over the age of 13. At the same time, vampires emerged from the world's dark recesses and enslaved mankind. Enter Hyakuya Yuuichirou, a young boy, who along with the rest of the children from his orphanage, are treated as livestock by the vampires. Even in captivity, Yuuichirou dreams big. He dreams of killing vampires. He dreams of killing them all.</p>",
    officialSite: "http://owarino-seraph.jp/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 132,
      name: "Tokyo MX",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2015-04-04",
  },
  {
    id: 4093,
    url: "https://www.tvmaze.com/shows/4093/galactik-football",
    name: "Galactik Football",
    genres: ["Action", "Science-Fiction", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49889.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49889.jpg",
    },
    summary:
      "<p><b>Galactik Football</b> is a French animated television series, co-produced by Alphanim, France 2, Jetix and Welkin-Animation. It follows the story of a futuristic football team - The Snow Kids - as they try to win the Galactik Football Cup for their home planet Akillian, with the help of The Flux - a mystical energy, specific for every planet.</p>",
    officialSite: null,
    webChannel: null,
    language: "French",
    status: "Ended",
    network: {
      id: 106,
      name: "France 2",
      country: { name: "France", code: "FR", timezone: "Europe/Paris" },
    },
    premiered: "2006-06-03",
  },
  {
    id: 4094,
    url: "https://www.tvmaze.com/shows/4094/oban-star-racers",
    name: "Oban Star-Racers",
    genres: ["Action", "Adventure", "Anime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49890.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49890.jpg",
    },
    summary:
      "<p>Eva's birthday has just passed, and she hasn't heard from her father. Despising the Boarding School she attends, she escapes using her Rocket Bike that she just completed. Taking on the alias \"Molly,\" Eva sneaks with the Earth team to Alwas for the Great Race because the winner of the race gets any one wish granted. Little does the Earth Team know what danger awaits them...</p>",
    officialSite: "http://www.obanstarracers.com",
    webChannel: null,
    language: "French",
    status: "Ended",
    network: {
      id: 249,
      name: "France 3",
      country: { name: "France", code: "FR", timezone: "Europe/Paris" },
    },
    premiered: "2006-04-12",
  },
  {
    id: 4095,
    url: "https://www.tvmaze.com/shows/4095/log-horizon",
    name: "Log Horizon",
    genres: ["Action", "Adventure", "Anime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49892.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49892.jpg",
    },
    summary:
      "<p>One day, while playing the online game Elder Tales, 30,000 players suddenly find themselves trapped in another world. There, eight-year veteran gamer Shiroe also gets left behind. The trapped players are still alive, but they remain in combat with the monsters. The players don't understand what has happened to them, and they flee to Akiba, the largest city in Tokyo, where they are thrown into chaos. Once proud of his loner lifestyle, Shiroe forms a guild called Log Horizon with his old friend Naotsugu, female assassin Akatsuki and others.</p>",
    officialSite: "http://www.nhk.or.jp/anime/loghorizon/",
    webChannel: null,
    language: "Japanese",
    status: "Running",
    network: {
      id: 281,
      name: "NHK",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2013-10-05",
  },
  {
    id: 4096,
    url: "https://www.tvmaze.com/shows/4096/medabots",
    name: "Medabots",
    genres: ["Action", "Adventure", "Anime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49895.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49895.jpg",
    },
    summary:
      "<p>A boy named Ikki Tenryou, using his Metabee, participates in Robottles; fights that square off robots, or 'Medarot', against eachother. Ikki must also stop the plans of the nefarious \"RoboRobo Dan\".</p>",
    officialSite: "http://www.tv-tokyo.co.jp/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2001-09-01",
  },
  {
    id: 4097,
    url: "https://www.tvmaze.com/shows/4097/shaman-king",
    name: "Shaman King",
    genres: ["Action", "Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49896.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49896.jpg",
    },
    summary:
      "<p>Asakura You is a shaman, one who can see and communicate with spirits. You is training to become the Shaman King, strongest among all the Shamans. The ones helping him are Manta, a short boy who can see ghosts and Amidamaru, who is an old samurai spirit and You's partner. However there are also others who are trying to get the title Shaman King.</p>",
    officialSite: "http://www.tv-tokyo.co.jp/anime/shaman/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2001-07-04",
  },
  {
    id: 4099,
    url: "https://www.tvmaze.com/shows/4099/yu-gi-oh-duel-monsters",
    name: "Yu-Gi-Oh! Duel Monsters",
    genres: ["Action", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49898.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49898.jpg",
    },
    summary:
      '<p>Legend says that the enigmatic Millennium Puzzle will grant one wish to whoever deciphers its ancient secrets. Upon solving it, high school student Yuugi Mutou unleashes "another Yuugi," a peculiar presence contained inside. Now, whenever he is faced with a dilemma, this mysterious alter ego makes an appearance and aids him in his troubles.</p><p>Wishing to unravel the mystery behind this strange spirit, Yuugi and his companions find themselves competing with several opponents in "Duel Monsters," a challenging card game used by people seeking to steal the Millennium Puzzle in a desperate attempt to harness the great power within. As the questions pile on, it is not long before they figure out that there is more than pride on the line in these duels.</p>',
    officialSite: "http://www.yugioh.com/yu-gi-oh",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2000-04-18",
  },
  {
    id: 4100,
    url: "https://www.tvmaze.com/shows/4100/yu-gi-oh-gx",
    name: "Yu-Gi-Oh! GX",
    genres: ["Action", "Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49899.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49899.jpg",
    },
    summary:
      "<p>Set several years after the previous Yu-Gi-Oh! series, GX follows a new generation of duelists at the prestigious Duel Academy—a highly competitive boarding school where pencils and books have been replaced by Duel Disks and monster cards! Still, it's not just about making the grade for these up and coming students – it's about becoming the next King of Games!</p>",
    officialSite: "http://www.yugioh.com/yu-gi-oh-gx",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2004-10-06",
  },
  {
    id: 4101,
    url: "https://www.tvmaze.com/shows/4101/ancient-assassins",
    name: "Ancient Assassins",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/224/561092.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/224/561092.jpg",
    },
    summary:
      "<p><b>Ancient Assassins</b> on AHC features elite men from a wide swath of history who were trained to perfection, skilled with a devastating array of weaponry.</p>",
    officialSite: "http://www.ahctv.com/tv-shows/ancient-assassins/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 229,
      name: "AHC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-03",
  },
  {
    id: 4102,
    url: "https://www.tvmaze.com/shows/4102/monarch-of-the-glen",
    name: "Monarch of the Glen",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49901.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49901.jpg",
    },
    summary:
      "<p>Set against the spectacular scenery of the Scottish Highlands, this immensely popular, heart-warming drama centers around an ancient castle, a collection of tartan-clad eccentrics and the handsome new master of the impoverished estate.</p>",
    officialSite: "http://www.bbc.co.uk/scotland/tv/monarch/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2000-02-27",
  },
  {
    id: 4103,
    url: "https://www.tvmaze.com/shows/4103/tower-prep",
    name: "Tower Prep",
    genres: ["Drama", "Fantasy", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755440.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755440.jpg",
    },
    summary:
      "<p>In this s.f. series, teenagers with unique superhuman abilities are taken from their homes without their consent and brought to Tower Prep, a unique academy cut off from the outside world where they are raised in an isolated environment. They are given an education, trained in the use of their powers, and encouraged to fit in... whether they want to or not. Some try to escape, and even fewer succeed.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-10-16",
  },
  {
    id: 4104,
    url: "https://www.tvmaze.com/shows/4104/chosen",
    name: "Chosen",
    genres: ["Drama", "Action", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/206/515178.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/206/515178.jpg",
    },
    summary:
      "<p><b>Chosen</b> follows Ian Mitchell -- a husband, father and lawyer -- who awakens one morning to discover a mysterious box on his doorstep containing a loaded gun and a photo of a stranger he must kill within the next three days. Ian quickly learns that if he doesn't kill this man, he may be killed himself along with his daughter who is being held hostage. Confused and desperate, Ian is transformed from an ordinary man into an unwilling assassin who must risk everything to protect his family.</p>",
    officialSite: null,
    webChannel: {
      id: 4,
      name: "Crackle",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2013-01-11",
  },
  {
    id: 4105,
    url: "https://www.tvmaze.com/shows/4105/apocalypse-world-war-one",
    name: "Apocalypse: World War One",
    genres: ["War", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49912.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49912.jpg",
    },
    summary:
      "<p>In the trenches, In the heads of Soldier, Governors and through the lives of Civilians behind the line, discover one of the most devastating conflicts of humanity.</p>",
    officialSite:
      "http://apocalypse.france2.fr/premiere-guerre-mondiale/fr/home",
    webChannel: null,
    language: "French",
    status: "Ended",
    network: {
      id: 106,
      name: "France 2",
      country: { name: "France", code: "FR", timezone: "Europe/Paris" },
    },
    premiered: "2014-03-18",
  },
  {
    id: 4106,
    url: "https://www.tvmaze.com/shows/4106/hillbilly-blood-a-hardscrabble-life",
    name: "Hillbilly Blood: A Hardscrabble Life",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49913.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49913.jpg",
    },
    summary:
      "<p>In the backwoods of Cold Mountain, N.C., known for fascinating characters and deep-rooted tradition, folks live off the land just like their parents, grandparents, and great-grandparents before them; carrying on the custom of getting by with little and making do with less. This season highlights even more of Eugene and Spencer's methodical ingenuity and wilderness expertise in creating handmade contraptions using skills the pair has been honing their entire lives in preparation for surviving off the grid. From Lincoln log drying sheds to hillbilly cooling pads, follow these mountain men as they construct intricate gadgets and engineering machines out of scrap parts.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 107,
      name: "Destination America",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-12-18",
  },
  {
    id: 4107,
    url: "https://www.tvmaze.com/shows/4107/spider-man",
    name: "Spider-Man",
    genres: ["Action", "Adventure", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49914.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49914.jpg",
    },
    summary:
      "<p>First airing on the ABC television network in 1967, the series revolves around the scientific-minded teenager Peter Parker who, after being bitten by a radioactive spider, develops amazing strength and spider-like powers. He decides to become a crime-fighting, costumed superhero; all the while dealing with his personal problems and the insecurities resulting from being a teenager.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1967-09-09",
  },
  {
    id: 4108,
    url: "https://www.tvmaze.com/shows/4108/tripping-the-rift",
    name: "Tripping the Rift",
    genres: ["Comedy", "Fantasy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49916.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49916.jpg",
    },
    summary:
      "<p>Upon being confronted by a mysterious stranger, Youko is told of her destiny and pulled away into another world. Thus begins Youko's perilous journey to the Kingdom of Kei on an epic road of espionage, terror, and betrayal. The mystic world of The Twelve Kingdoms assails her with one challange after another. Will Youko embrace her destiny?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-03-04",
  },
  {
    id: 4109,
    url: "https://www.tvmaze.com/shows/4109/cia-declassified",
    name: "CIA Declassified",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49959.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49959.jpg",
    },
    summary:
      "<p>Drawing from recently declassified documents from the CIA and insider accounts from the agents who were there, <b>CIA Declassified</b> peels back the curtain to tell the real stories behind the manhunts and covert operations that delivered lethal justice.</p>",
    officialSite: "http://www.ahctv.com/tv-shows/cia-declassified/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 229,
      name: "AHC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-02-06",
  },
  {
    id: 4110,
    url: "https://www.tvmaze.com/shows/4110/fbi-takedowns",
    name: "FBI Takedowns",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49918.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49918.jpg",
    },
    summary:
      "<p>An electrifying ride, <b>FBI Takedowns</b> follows the pursuit and capture of deadly criminals who have committed some of the most violent attacks on this generation. </p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 229,
      name: "AHC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-03-18",
  },
  {
    id: 4111,
    url: "https://www.tvmaze.com/shows/4111/the-wrong-coast",
    name: "The Wrong Coast",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49958.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49958.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 38,
      name: "The Movie Network",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2004-04-07",
  },
  {
    id: 4112,
    url: "https://www.tvmaze.com/shows/4112/forbidden-history",
    name: "Forbidden History",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/254/635802.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/254/635802.jpg",
    },
    summary:
      "<p>Jamie Theakston's <b>Forbidden History</b> uncovers the truth behind great myths, conspiracy theories, ancient treasures, lost civilisations and war time secrets.</p>",
    officialSite: "https://www.sciencechannel.com/tv-shows/forbidden-history",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 77,
      name: "Science",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-27",
  },
  {
    id: 4113,
    url: "https://www.tvmaze.com/shows/4113/mafias-greatest-hits",
    name: "Mafia's Greatest Hits",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49921.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49921.jpg",
    },
    summary:
      "<p>Unravel the secrets of the Mafia's most notorious members, including Sam Giancana, who had ties to the Kennedys and Frank Sinatra; John Gotti, known as ‘Teflon Don' after being acquitted three times; Carmine Galante, who profited from his drug empire while in prison; and the real Donnie Brasco, an FBI agent who worked undercover to bring the Mafia down from within.\t\t</p>",
    officialSite: "http://www.ahctv.com/tv-shows/mafias-greatest-hits/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 229,
      name: "AHC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-05-18",
  },
  {
    id: 4114,
    url: "https://www.tvmaze.com/shows/4114/myth-hunters",
    name: "Myth Hunters",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49923.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49923.jpg",
    },
    summary:
      "<p><b>Myth Hunters</b> reveals true stories of quests seeking legendary objects – hordes of lost Spanish gold, the Temple of Solomon, the body of King Arthur, the relics of Joan of Arc; objects that offer their finder either unlimited power or wealth - or both. For most of us, these are the stuff of fantasy and movies as seen in Indiana Jones or The Mummy; but these are the real stories of real adventurers who thought these myths were true. These true life action adventures are exciting stories filmed in HD. The series features dramatic reconstruction, expert witness testimonies, specially shot location material and archive footage.</p>",
    officialSite: "http://www.ahctv.com/tv-shows/myth-hunters/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 229,
      name: "AHC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-12-19",
  },
  {
    id: 4115,
    url: "https://www.tvmaze.com/shows/4115/nazi-collaborators",
    name: "Nazi Collaborators",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49924.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49924.jpg",
    },
    summary:
      "<p>Out of so many questions of why and how, one still looms large in the 21st century - how could so many people have collaborated with the Nazis before and during World War II, even though the regime under Hitler was rampaging through Europe, ghettoising and exterminating all that stood in its way?</p>",
    officialSite: "http://yesterday.uktv.co.uk/shows/nazi-collaborators/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 345,
      name: "Yesterday",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-11-22",
  },
  {
    id: 4116,
    url: "https://www.tvmaze.com/shows/4116/nazi-hunters",
    name: "Nazi Hunters",
    genres: ["War", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49925.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49925.jpg",
    },
    summary:
      "<p>It's one of the greatest true detective stories ever. Nazi Hunters tells how a select band of secret agents hunted down some of the most evil men in history…and finally brought them to justice. Intense, visceral, and narrated by real-life Nazi hunters, each spellbinding episode focuses on one electrifying mission. And, from Klaus Barbie's dramatic pursuit in Bolivia, to the audacious Mossad operation to kidnap Adolf Eichmann in Buenos Aires, recounts how the Nazis finally met their nemesis.</p>",
    officialSite: "http://natgeotv.com/ca/nazi-hunters",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-12-01",
  },
  {
    id: 4117,
    url: "https://www.tvmaze.com/shows/4117/nazi-hunters",
    name: "Nazi Hunters",
    genres: ["War", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49926.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49926.jpg",
    },
    summary: null,
    officialSite: "http://www.ahctv.com/tv-shows/nazi-hunters/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 229,
      name: "AHC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-25",
  },
  {
    id: 4118,
    url: "https://www.tvmaze.com/shows/4118/royal-inquest",
    name: "Royal Inquest",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49946.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49946.jpg",
    },
    summary:
      "<p>A close look at the royal families from around the world and the mysteries behind their palace walls.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-03-29",
  },
  {
    id: 4119,
    url: "https://www.tvmaze.com/shows/4119/secret-war",
    name: "Secret War",
    genres: ["War", "History", "Espionage"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49927.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49927.jpg",
    },
    summary:
      '<p><i><b>"Secret War"</b></i> goes inside Churchill\'s secret army, to a dangerous WWII world of secret agents. It tells the story of the Special Operations Executive agents and others who went behind enemy lines to conduct intelligence-gathering, sabotage, and assassination.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 229,
      name: "AHC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-06-20",
  },
  {
    id: 4120,
    url: "https://www.tvmaze.com/shows/4120/secrets-of-world-war-ii",
    name: "Secrets of World War II",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49928.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49928.jpg",
    },
    summary:
      "<p>Stephen Fry reveals the secret of a unique World War Two building in Norfolk.</p><p>Known affectionately as the Christmas Pudding, the Langham Dome holds a special place not only in the history of warfare but also in the development of 21st-century entertainment. Recently rescued from ruin by a dedicated bunch of enthusiasts after 50 years, its secrets are finally revealed.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b05wdql2",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1998-01-01",
  },
  {
    id: 4121,
    url: "https://www.tvmaze.com/shows/4121/the-american-revolution",
    name: "The American Revolution",
    genres: ["War", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49929.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49929.jpg",
    },
    summary:
      "<p>This compelling new series chronicles the rise of the rebellion, failures and setbacks of the colonial mission, and the ultimate comeback that resulted in the birth of a nation. Through expert interviews, re-enactments and cutting-edge animations, the series brings more than a dozen indispensable players to the front lines, like John Glover, who helped row Washington's forces across the Delaware to secure victory at Trenton. Also featured is Salem Poor, who was born into slavery but served heroically under Washington at the Battle of White Plains and Bunker Hill. Many women also answered the call, like Nancy Hart, a patriot spy who disguised herself as a man and wandered through British encampments to gather intelligence.</p>",
    officialSite: "http://www.ahctv.com/tv-shows/the-american-revolution/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 229,
      name: "AHC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-12-15",
  },
  {
    id: 4122,
    url: "https://www.tvmaze.com/shows/4122/the-fbi-files",
    name: "The FBI Files",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49930.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49930.jpg",
    },
    summary:
      "<p>Through re-enactments of high profile cases involving the FBI, the show reveals how agents solve these crimes behind the scene. The show producers work with FBI special agents and examiners in high tech crime labs to portrait each case accurately. You will learn how the FBI protects the lives of Americans and brings the most notorious criminals to justice. The FBI was originally established to address crime that covered cities, counties, and spread across state lines. The country needed a federal law-enforcement entity to do those investigations. And over the years, as the country has grown and as the world, by the same token, has grown smaller, the FBI's mission has changed to meet the various threats.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-10-20",
  },
  {
    id: 4123,
    url: "https://www.tvmaze.com/shows/4123/world-war-ii-in-hd-colour",
    name: "World War II in HD Colour",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49931.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49931.jpg",
    },
    summary:
      "<p>A new collection of rare and unseen footage of World War II and the very latest colorization techniques come together in WORLD WAR II IN HD COLOUR . With satellite-delivered terrain mapping and state-of-the-art graphics, this new series reveals the epic conflict of the 20th century in a fresh light. Narrated by English actor Robert Powell, WORLD WAR II IN HD COLOUR is a vivid, in-depth experience that provides viewers with new insights and information. Newly divulged documents, files and photographs, code breaking revelations, and recently released government papers on both sides of the Atlantic add a different dimension to our understanding of the strategies and battles of World War II.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 143,
      name: "Discovery Channel",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-09-04",
  },
  {
    id: 4124,
    url: "https://www.tvmaze.com/shows/4124/wildside",
    name: "Wildside",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49949.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49949.jpg",
    },
    summary:
      '<p>Five outlaws decided to go straight and retire to California. One of them, J. Wendell Summerhayes, manages to become the governor of California. The other four--Brodie Hollister, Varges de la Cosa, Bannister Sparks, and Prometheus Jones--retire to the town of Wildside, CA, and become respectable businessmen. But when trouble arises, or Summerhayes needs their help, the four men put together a "hunting party" and use their unique skills--sharp shooting, bolo- and knife-throwing, explosives, and lassos--to take down the bad guys.</p><p>Helping them is Brodie\'s son Sutton, also an expert sharpshooter, who was raised in the East and has traveled to California to join his father. Together, the five men are the Chamber of Commerce of Wildside... and heaven help anyone who gets in their way.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1985-03-21",
  },
  {
    id: 4125,
    url: "https://www.tvmaze.com/shows/4125/river-cottage",
    name: "River Cottage",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49966.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49966.jpg",
    },
    summary:
      "<p>Hugh Fearnley-Whittingstall goes back to the land and the sea in search of an alternative culinary lifestyle. Hugh grows his own produce and sees if he can make vegetables the stars of any meal.</p>",
    officialSite: "http://www.channel4.com/programmes/river-cottage",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1999-03-18",
  },
  {
    id: 4126,
    url: "https://www.tvmaze.com/shows/4126/the-birth-of-empire-the-east-india-company",
    name: "The Birth of Empire: The East India Company",
    genres: ["Travel", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/19/49999.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/19/49999.jpg",
    },
    summary:
      "<p>Dan Snow travels through India in the footsteps of the company that revolutionised the British lifestyle and laid the foundations of today's global trading systems.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b04b3njw",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-04-30",
  },
  {
    id: 4127,
    url: "https://www.tvmaze.com/shows/4127/natures-weirdest-events",
    name: "Nature's Weirdest Events",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50001.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50001.jpg",
    },
    summary:
      "<p>Chris Packham examines some of the weirdest natural events on the planet. With the help of footage taken by eyewitnesses and news crews, he unravels the facts behind each story.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b01pqmqq",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-01-03",
  },
  {
    id: 4128,
    url: "https://www.tvmaze.com/shows/4128/chappelles-show",
    name: "Chappelle's Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/326/815523.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/326/815523.jpg",
    },
    summary:
      "<p>It's not just a show -- it's a social phenomenon. Dave Chappelle's singular point of view is unleashed through a combination of stand-up bits and street-smart sketches. Hailed by critics and beloved by fans, Chappelle's Show brings the funk and the noise -- and some of the funniest comedy on television.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-01-22",
  },
  {
    id: 4129,
    url: "https://www.tvmaze.com/shows/4129/george-lopez",
    name: "George Lopez",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50007.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50007.jpg",
    },
    summary:
      "<p>George Lopez is a guy who has made lemonade from lemons at every turn. Since he became the plant manager at an L.A. airplane parts factory, George has handled a complicated and tumultuous job including mergers, vandals and even a Presidential visit -- with his sense of humor intact. Though his affable and loyal friend and leader Ernie and former compadres on the floor consider him a buddy, they continue to rib him and have their fun with his new found position of power. Dealing with his tough and acerbic but loving mother Benny while sifting through her vast assortment of lies about his childhood, and maintaining a civil relationship presents a constant challenge, both at work and at home. Fortunately George's devoted wife, Angie, possesses the patience of a saint and copes surprisingly well with Benny's questionable behavior.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-03-27",
  },
  {
    id: 4130,
    url: "https://www.tvmaze.com/shows/4130/the-greatest-event-in-television-history",
    name: "The Greatest Event in Television History",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50009.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50009.jpg",
    },
    summary:
      "<p>Join host Jeff Probst and actual person Adam Scott as they call in all of their celebrity favors for four separate attempts to create the single <b>Greatest Event in</b> <b>Television History</b></p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-10-11",
  },
  {
    id: 4131,
    url: "https://www.tvmaze.com/shows/4131/kenan-kel",
    name: "Kenan & Kel",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50011.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50011.jpg",
    },
    summary:
      "<p><b>Kenan &amp; Kel</b> features Kenan Rockmore, a high schooler who works at Rigby's mini grocery store. Kel Kimble is his orange soda-loving best friend. Chris Potter is Kenan's boss at Rigby's. In Kenan's home life there is his mother Sheryl, his bald father Roger, and his Kel-loving sister Kyra.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-08-17",
  },
  {
    id: 4132,
    url: "https://www.tvmaze.com/shows/4132/threes-company",
    name: "Three's Company",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50015.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50015.jpg",
    },
    summary:
      "<p><b>Three's Company</b> was a groundbreaking comedy series that tripped and jiggled through a world of slapstick pratfalls and some of the most scandalously titillating comedy America had ever seen, and hasn't seen since.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1977-03-15",
  },
  {
    id: 4133,
    url: "https://www.tvmaze.com/shows/4133/mister-ed",
    name: "Mister Ed",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50027.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50027.jpg",
    },
    summary:
      "<p>Architect Wilbur Post (Alan Young, <i>The Time Machine</i>) and his wife Carol (Connie Hines) move into a beautiful new home complete with a barn in the backyard. When Wilbur takes a look in his new barn, he finds that the former owner left his horse behind. This horse is no ordinary horse . . . he can talk, but only to Wilbur, which leads to all sorts of misadventures for Wilbur and his trouble-making sidekick <b>Mister Ed</b>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1961-01-05",
  },
  {
    id: 4134,
    url: "https://www.tvmaze.com/shows/4134/mccloud",
    name: "McCloud",
    genres: ["Drama", "Adventure", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/286/715788.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/286/715788.jpg",
    },
    summary:
      "<p>Deputy Marshal Sam McCloud of the Taos police travels to NYC to track down a criminal. He ends up loaned to the NYPD as a special investigator, and his laid-back cowboy ways are a strict contrast to the rough-and-tumble NY police officers that he works with.</p><p>The series was part of NBC's <i>Sunday Mystery Movie,</i> and brought in high ratings as it rotated with <i>Columbo</i> and <i>McMillan and Wife</i>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1970-02-17",
  },
  {
    id: 4135,
    url: "https://www.tvmaze.com/shows/4135/the-jacksons-next-generation",
    name: "The Jacksons: Next Generation",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/129/322733.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/129/322733.jpg",
    },
    summary:
      "<p>Lifetime's all-new docuseries <b>The Jacksons: Next Generation</b> (#JacksonsNextGen) focuses on the third generation of the famed Jackson family -- Taj, Taryll and TJ -- Tito Jackson's sons and nephews of the famed Jackson 5. Premiering Friday, October 2, at 10PM ET/PT, the series features the brothers as they work to balance a career and their lives as traditional family men while living up to the pressures and demands that comes with their last name. The siblings, known as the music group 3T, have toured and sold more than three million records worldwide just off their debut album. Still impacted by the loss of their mother, Dee Dee, the brothers are raising their children and managing the day-to-day tasks within their families, just like everyone else. Their quest for normalcy, however, often collides head-on with the good and bad of living with one of history's most renowned last names. The series reveals what it's like for them living with the last name Jackson including how they deal with constant rumors, stalkers, and frauds who all want a piece of anything and anyone related to the family's legacy.</p>",
    officialSite:
      "http://www.mylifetime.com/shows/the-jacksons-next-generation/about",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-02",
  },
  {
    id: 4136,
    url: "https://www.tvmaze.com/shows/4136/love-at-first-swipe",
    name: "Love at First Swipe",
    genres: ["Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755441.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755441.jpg",
    },
    summary:
      "<p>For the modern dater, online profiles have become just as important as what you see in person. While swiping through hundreds of pages to find the perfect match, some have mastered the art of the selfie and the perfectly-written caption, but others are making bad choices that hurt their chances at finding love. Enter former <i>What Not to Wear</i> host and style expert, Clinton Kelly and online dating guru, Devyn Simone who help these women become their best self, inside and out <i>and</i> online in <b>Love at First Swipe</b>. The series is about identifying the mistakes people make online and then transforming their style and profiles. From oversexed photos to depressing status updates, these online dating profile disasters just aren't clicking.</p><p>In each episode, Clinton and Devyn unearth the rationale behind the photo and status update choices for each unlucky, online dater and then help them transform their look and online presence. Clinton takes each woman for a style makeover that better represents her whole personality - whether it is a mom looking to dress more conservatively or an introvert looking to express herself better through a new wardrobe. After these physical transformations, Devyn gives the women an online dating tutorial complete with new photos and an updated profile. The women then put their new look to the test when Clinton and Devyn share the new and improved profile with 100 potential mates, and then the women choose a date from one of the men that liked her profile. From online disaster to dating in style, these women leave with new-found confidence to conquer the online dating world.</p>",
    officialSite: "http://www.tlc.com/tv-shows/love-at-first-swipe/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-02",
  },
  {
    id: 4137,
    url: "https://www.tvmaze.com/shows/4137/sex-in-public",
    name: "Sex in Public",
    genres: [],
    image: null,
    summary:
      "<p>Therapist Jill Dictrow goes undercover in the most unsuspecting of places in an attempt to get real people to open up about the good, the bad, and the un-sexy when it comes to their personal lives. <b>Sex in Public</b> is more than just talking about sex – it's about helping people who are too shy, too nervous, or too embarrassed to go to a friend, relative, or even a therapist to seek help on their relationships. Sometimes, it's easier for people to speak with complete strangers, and you won't believe what Jill finds out when she starts talking about <i>Sex in Public </i>on Friday, October 2nd at 10/9c on TLC.</p><p>Jill is going undercover and setting up hidden cameras, offering free advice to people in some of the least private locations – the mall, a bridal shop, a park, and more. <i>Sex in Public</i> is an unprecedented way for couples, friends and individuals to work on their sexual, dating, and emotional issues. Each week, Jill puts herself in seemingly awkward situations, with the goal of helping complete strangers resolve the topics they're most eager to talk about, but most hesitant.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 177,
      name: "Discovery Life",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-02",
  },
  {
    id: 4138,
    url: "https://www.tvmaze.com/shows/4138/whatshesaid",
    name: "#WhatSheSaid",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50105.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50105.jpg",
    },
    summary:
      "<p><b>#WhatSheSaid</b> features some of the country's foremost female comics commiserating, venting, and speaking the truth about being mothers in these crazy modern times. Things like social media, timesaving secrets, and no-nonsense attitudes come together for a real conversation -- with lots of laughter -- about the chaos of life and motherhood.</p>",
    officialSite: "http://www.tlc.com/tv-shows/what-she-said/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 80,
      name: "TLC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-10",
  },
  {
    id: 4139,
    url: "https://www.tvmaze.com/shows/4139/coronation-street",
    name: "Coronation Street",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755288.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755288.jpg",
    },
    summary:
      "<p><b>Coronation Street</b> is the story of working people and the city street in which they live. The show has been seen all around the world and has remained in the top viewing ratings throughout its long lifetime.</p>",
    officialSite: "http://www.itv.com/hub/coronation-street",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1960-12-09",
  },
  {
    id: 4141,
    url: "https://www.tvmaze.com/shows/4141/american-justice",
    name: "American Justice",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755442.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755442.jpg",
    },
    summary:
      "<p>Documentary focusing on Crime in America, and the American Criminal Justice System.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1992-10-07",
  },
  {
    id: 4142,
    url: "https://www.tvmaze.com/shows/4142/cold-case-files",
    name: "Cold Case Files",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50126.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50126.jpg",
    },
    summary:
      "<p>Murders go unsolved. Killers slip through the cracks. With the passage of time, families lose hope and another unsolved homicide file settles into obscurity. The pattern is familiar, but changing, thanks to the efforts of a special breed of detectives. <b>Cold Case Files</b> tells the story of their work.</p>",
    officialSite: "http://www.aetv.com/shows/cold-case-files/about",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-01-01",
  },
  {
    id: 4143,
    url: "https://www.tvmaze.com/shows/4143/city-confidential",
    name: "City Confidential",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755443.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755443.jpg",
    },
    summary:
      "<p>A documentary series on crimes committed in American cities.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-11-22",
  },
  {
    id: 4144,
    url: "https://www.tvmaze.com/shows/4144/imposters",
    name: "Imposters",
    genres: ["Drama", "Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/153/382966.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/153/382966.jpg",
    },
    summary:
      "<p><b>Imposters </b>is a dark comedy that follows Ava, a master-of-disguise con-artist who gets men and women to fall in love with her, marries them and then disappears with their money and just enough dirty inside information to guarantee they will never go to the police. But things get complicated when she falls in love with her latest mark, and three of her last victims join together to track her down.</p>",
    officialSite: "http://www.bravotv.com/imposters",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2017-02-07",
  },
  {
    id: 4145,
    url: "https://www.tvmaze.com/shows/4145/evil-up-close",
    name: "Evil Up Close",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/175/439682.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/175/439682.jpg",
    },
    summary:
      "<p>Meet the neighbour who waves politely, the friend who is the life and soul of a party, the colleague who buys the coffee. All are ready to kill, rape or harm. They live cheek by jowl with us; they look, sound and behave like us but they are evil and their crimes have shocked the world.</p><p><b>Evil Up Close</b> hears from the people who knew, loved or trusted those hunted for vicious crimes, of those who lived alongside, laughed with or felt the warmth of a monster; the wives and daughters, husbands and sons, the friends, neighbours, detectives and prosecutors who have eye-balled evil in the dock.</p>",
    officialSite: "http://www.crimeandinvestigation.co.uk/shows/evil-up-close",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 346,
      name: "Crime & Investigation",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-05-15",
  },
  {
    id: 4150,
    url: "https://www.tvmaze.com/shows/4150/gintama",
    name: "Gintama",
    genres: ["Comedy", "Action", "Anime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50206.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50206.jpg",
    },
    summary:
      "<p>Life isn't easy in feudal Japan... especially since the aliens landed and conquered everything! Oh sure, the new health care is great, but the public ban on the use of swords has left a lot of defeated samurai with a difficult decision to make concerning their future career paths! This is especially true if, as in the case of Gintoki Sakata, they're not particularly inclined towards holding a day job, which is why Gintoki's opted for the freelance route, taking any job that's offered to him as long as the financial remuneration sounds right. Unfortunately, in a brave new world filled with stray bug-eyed monsters, upwardly mobile Yakuza and overly ambitious E.T. entrepreneurs, those jobs usually don't pay as well as they should for the pain, suffering and indignities endured!</p>",
    officialSite: "http://www.tv-tokyo.co.jp/anime/gintama/index2.html",
    webChannel: null,
    language: "Japanese",
    status: "To Be Determined",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2006-04-04",
  },
  {
    id: 4151,
    url: "https://www.tvmaze.com/shows/4151/justice-files",
    name: "Justice Files",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50210.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50210.jpg",
    },
    summary:
      "<p>A study of crime in America features film footage and eyewitness accounts. Also: how certain cases have impacted on the U.S. legal system.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 346,
      name: "Crime & Investigation",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: null,
  },
  {
    id: 4152,
    url: "https://www.tvmaze.com/shows/4152/fools-gold",
    name: "Fools Gold",
    genres: ["Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50219.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50219.jpg",
    },
    summary:
      "<p>A ragtag crew looks to strike it rich in the gold-laden hills of Northern Ontario. The only problem? They don't know what they're doing!</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 298,
      name: "Discovery Channel",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2014-05-13",
  },
  {
    id: 4153,
    url: "https://www.tvmaze.com/shows/4153/warren-the-ape",
    name: "Warren the Ape",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50223.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50223.jpg",
    },
    summary:
      '<p><b>Warren the Ape</b> is a parody of "the life of a celebrity" reality show, focused on the trials and tribulations of a D-grade celebrity puppet who is attempting to clean up his act, patch up his relationships and scramble his way back into the Hollywood limelight with the help of his doctor, Dr. Drew Pinsky. Warren "The Ape" Demontague is a brash, cantankerous, out-of-work actor. Having had a brief taste of success on the former sitcom "Greg the Bunny", Warren\'s life has been in a downward spiral ever since the show got cancelled. Over the past few years, Warren has paid more attention to drugs, booze and women than his career, which as of late has mostly consisted of a series of seedy exploitation films, obscure industrials, low-rent theatre productions and a regrettable string of skin flicks.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-06-14",
  },
  {
    id: 4154,
    url: "https://www.tvmaze.com/shows/4154/newsradio",
    name: "NewsRadio",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50224.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50224.jpg",
    },
    summary:
      "<p><b>NewsRadio</b> showcases the hilarious antics of the whimsical #2 news radio station in New York City. The corral of characters are eccentric and witty, and they surprise each other with their back-and-forth banter. Their workplace humor also supplies an abundance of laughs amidst this unlikely bunch of colleagues.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1995-03-21",
  },
  {
    id: 4155,
    url: "https://www.tvmaze.com/shows/4155/penelope-keiths-hidden-villages",
    name: "Penelope Keith's Hidden Villages",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/76/190062.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/76/190062.jpg",
    },
    summary:
      "<p>Penelope Keith takes to the road to explore our changing relationship with that most quintessential of British institutions, the village.</p><p>Cream teas, bunting, thatched cottages swathed in roses. For generations this rural idyll of the village has conjured the very best of Britain.</p><p>Penelope Keith explores our relationship with the village, discovering traditions under threat and communities undergoing huge changes, as she looks at what the future holds for rural communities.</p>",
    officialSite:
      "http://www.channel4.com/programmes/penelope-keiths-hidden-villages",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-11-11",
  },
  {
    id: 4156,
    url: "https://www.tvmaze.com/shows/4156/24-hours-in-police-custody",
    name: "24 Hours in Police Custody",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50236.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50236.jpg",
    },
    summary:
      "<p>Bedfordshire Police allowed more than 80 cameras to follow their work for this landmark documentary series from the makers of 24 Hours in A&amp;E.</p>",
    officialSite:
      "http://www.channel4.com/programmes/24-hours-in-police-custody",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-09-29",
  },
  {
    id: 4157,
    url: "https://www.tvmaze.com/shows/4157/murphys-law-of-love",
    name: "Murphy's Law of Love",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50238.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50238.jpg",
    },
    summary:
      "<p>When Love meets Murphy's law… Usually, the more you say you can't be with one person, the more likely you'll end up with that person!? The dilemma in love, do you want the perfect 4G guy or the brash guy? Can it be that falling in love with him is inevitable?</p>",
    officialSite: null,
    webChannel: null,
    language: "Chinese",
    status: "Ended",
    network: {
      id: 347,
      name: "SET TV",
      country: {
        name: "Taiwan, Province of China",
        code: "TW",
        timezone: "Asia/Taipei",
      },
    },
    premiered: "2015-03-20",
  },
  {
    id: 4158,
    url: "https://www.tvmaze.com/shows/4158/quarry",
    name: "Quarry",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/73/184949.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/73/184949.jpg",
    },
    summary:
      "<p><b>Quarry</b> is the story of Mac Conway, a Marine who returns home to Memphis from Vietnam in 1972 and finds himself shunned by those he loves and demonized by the public. As he struggles to cope with his experiences at war, Conway is drawn into a network of killing and corruption that spans the length of the Mississippi River.</p>",
    officialSite: "http://www.cinemax.com/quarry/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 19,
      name: "Cinemax",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2016-09-09",
  },
  {
    id: 4159,
    url: "https://www.tvmaze.com/shows/4159/teenage-mutant-ninja-turtles",
    name: "Teenage Mutant Ninja Turtles",
    genres: ["Comedy", "Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50244.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50244.jpg",
    },
    summary:
      "<p>Distinctly different from the grim, violent, and dark MIRAGE comics from which the Turtles originated, this version of the franchise has remained the longest running, and most memorable, version of all. Four turtles fall into the sewers and are befriended by Hamato Yoshi a Japanese man sent to New York who was forced to live in the sewers. One day he sees a strange green glow which transforms the four turtles into human-like creatures. Hamato (now Master Splinter) changes into a giant rat from the green glow and teaches the turtles the skills of the ninja as they team up with Channel 6 news reporter April O'Neil to battle against Yoshi's arch enemy Shredder and Krang, an alien warlord from Dimension X.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1987-12-10",
  },
  {
    id: 4160,
    url: "https://www.tvmaze.com/shows/4160/smeris",
    name: "Smeris",
    genres: ["Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/307/767899.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/307/767899.jpg",
    },
    summary:
      "<p>Theo Kamp (Jeroen van Koningsbrugge) is the best, but also most dashing homicide detective Tilburg. When he steps out of line for the umpteenth time in the search for top criminal Freddy van Nuenen, he is taken off the case and as punishment, transfered over to the hemp team. Here he is aspected to lay low under the supervision of his new partner William Niessen (Dennis van de Ven), the most correct detective of the corps. Theo is not going to give up his investigation. Will he manage, with the disadvantage of having William as his watchdog, to still catch Freddy van Nuenen and also get his old job back?</p>",
    officialSite: null,
    webChannel: null,
    language: "Dutch",
    status: "Ended",
    network: {
      id: 1020,
      name: "NPO 3",
      country: {
        name: "Netherlands",
        code: "NL",
        timezone: "Europe/Amsterdam",
      },
    },
    premiered: "2014-03-17",
  },
  {
    id: 4161,
    url: "https://www.tvmaze.com/shows/4161/manhunt",
    name: "Manhunt",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50252.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50252.jpg",
    },
    summary:
      '<p><b>Manhunt</b>, which debuted August 3 on UPN, sent 13 contestants on a six-day journey through Kauai while being chased by paintball gun-wielding "hunters". Inspired by the short story "The Most Dangerous Game", "Manhunt" takes 13 contestants to the Hawaiian island Kauai. Each day, a vote is held and one contestant must run a capture-the-flag relay through a "gauntlet", where three "hunters" fire paintballs at them. If hit, the contestant is disqualified. The last contestant remaining wins the $250,000 grand prize.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 70,
      name: "UPN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-08-03",
  },
  {
    id: 4162,
    url: "https://www.tvmaze.com/shows/4162/the-tonight-show-with-conan-obrien",
    name: "The Tonight Show with Conan O'Brien",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50267.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50267.jpg",
    },
    summary:
      "<p>Conan O'Brien followed Jay Leno as host on this popular late Night Show that was renamed The <b>Tonight Show with Conan O'Brien</b>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-06-01",
  },
  {
    id: 4163,
    url: "https://www.tvmaze.com/shows/4163/auction-kings",
    name: "Auction Kings",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50269.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50269.jpg",
    },
    summary:
      "<p>Discovery Channel's series <b>Auction Kings</b> delves into the world of unique items - from vampire-hunting kits to meteorites to jewel-encrusted pencils - and the emotional process of their acquisition and loss.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-10-26",
  },
  {
    id: 4164,
    url: "https://www.tvmaze.com/shows/4164/mind-games",
    name: "Mind Games",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50270.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50270.jpg",
    },
    summary:
      "<p>With a little bit of science, a dash of con-artistry, plus a smattering of Jedi mind tricks, brothers Ross and Clark Edwards can tailor a plan to influence any life-altering situation, thereby making their clients' dreams come true and their nightmares go away. They are partners in Edwards and Associates, an unusual business based on the belief that people's decisions are influenced by their environment in ways they're not aware. By using the hard science of psychological manipulation, the brothers commit to solving their clients' problems. With Clark's expertise and Ross's con artist ways, each believing to know what makes people tick, and with their unique staff to help them, the brothers will use psychology and science to offer clients an alternative to their fates.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-02-25",
  },
  {
    id: 4165,
    url: "https://www.tvmaze.com/shows/4165/stromberg",
    name: "Stromberg",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50276.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50276.jpg",
    },
    summary:
      "<p>A comedy centered around the incompetent boss of a German insurance office.</p><p>Based loosely on the UK Series <i>The Office</i>.</p>",
    officialSite: null,
    webChannel: null,
    language: "German",
    status: "Ended",
    network: {
      id: 348,
      name: "ProSieben",
      country: { name: "Germany", code: "DE", timezone: "Europe/Busingen" },
    },
    premiered: "2004-10-11",
  },
  {
    id: 4166,
    url: "https://www.tvmaze.com/shows/4166/toy-hunter",
    name: "Toy Hunter",
    genres: ["Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50284.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50284.jpg",
    },
    summary:
      "<p>Jordan Hembrough travels across the globe in search of rare vintage items to sell at the New York Comic Con.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 82,
      name: "Travel Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-08-15",
  },
  {
    id: 4167,
    url: "https://www.tvmaze.com/shows/4167/we-are-men",
    name: "We Are Men",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50286.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50286.jpg",
    },
    summary:
      "<p><b>We Are Men</b> is about four single guys living in a short-term apartment complex who unexpectedly find camaraderie over their many missteps in love. Carter is the youngest and most recent addition to the group, having moved in after being ditched at the altar mid-ceremony and is now eager to re-enter the dating scene and get on with his life with some guidance from his \"band of brothers\": Frank Russo, a successful middle-aged clothing manufacturer and four-time divorcée who still fancies himself a ladies man; Gil Bartis, a small business owner who was caught having the world's worst affair; and Stuart Strickland, a speedo-wearing OB/GYN who's hiding his assets until his second divorce is settled. Jill is Frank's charming and attractive daughter, who stands as the one positive remnant from his failed relationships. Armed with a hot tub, pool-side barbeque and plenty of questionable advice, these losers in the marriage department take Carter under their wing to impart their own brand of wisdom about the opposite sex.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-30",
  },
  {
    id: 4168,
    url: "https://www.tvmaze.com/shows/4168/wilfred",
    name: "Wilfred",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50294.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50294.jpg",
    },
    summary:
      "<p>A boy, a girl and a bong smoking dog who thinks he's human…continue their dysfunctional love triangle. When Adam asks Sarah to marry him and she says \"yes\", her jealous mutt Wilfred unleashes his own special brand of hell.</p><p>Then there are the gladbag of guest stars who will join he, Adam and Sarah over eight hysterical weeks, including Sarah's nudist parents, Richmond's sexiest cat and a handful of dogs who fight, fornicate and make friends with Australia's most loved walking, talking four legged freak.</p><p>Hang on to your souls Australia, this is a show that takes love, hate, humour and healing to unheard of places. Put the kettle on and refrain from doing the naughty boy because Wilfred is back and he's got a very itchy arse.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 140,
      name: "SBS",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2007-03-19",
  },
  {
    id: 4169,
    url: "https://www.tvmaze.com/shows/4169/the-confession",
    name: "The Confession",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50298.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50298.jpg",
    },
    summary:
      "<p>A unique story of redemption and an exploration of good and evil featuring a hit man and a priest.</p>",
    officialSite: null,
    webChannel: {
      id: 2,
      name: "Hulu",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2011-03-14",
  },
  {
    id: 4170,
    url: "https://www.tvmaze.com/shows/4170/tabletop",
    name: "TableTop",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50301.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50301.jpg",
    },
    summary:
      "<p>In this hit show, geek icon Wil Wheaton and a slew of celebrity guests gather to play their favorite board games. Who will win the Trophy of Awesome?</p>",
    officialSite: "http://geekandsundry.com/shows/tabletop/",
    webChannel: { id: 21, name: "YouTube", country: null },
    language: "English",
    status: "Running",
    network: null,
    premiered: "2012-04-02",
  },
  {
    id: 4171,
    url: "https://www.tvmaze.com/shows/4171/the-guild",
    name: "The Guild",
    genres: ["Comedy", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50302.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50302.jpg",
    },
    summary:
      "<p><b>The Guild</b> is a comedy web series about a group of online gamers. The show started in 2007, and for the first season, was solely supported by LOYAL FANS through Paypal, before Kickstarter was created. From seasons 2-5 the show was sponsored by Xbox in a groundbreaking web video deal that kept the show independently owned, and then ended its run on YouTube in 2012 with the final season 6.</p>",
    officialSite: null,
    webChannel: { id: 21, name: "YouTube", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2007-07-27",
  },
  {
    id: 4173,
    url: "https://www.tvmaze.com/shows/4173/co-optitude",
    name: "Co-Optitude",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50310.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50310.jpg",
    },
    summary:
      "<p><b>Co-Optitude</b> is all about Felicia Day and Ryon Day hilariously playing through the retro games that their parents never let them have.</p>",
    officialSite: null,
    webChannel: { id: 21, name: "YouTube", country: null },
    language: "English",
    status: "Running",
    network: null,
    premiered: "2013-05-27",
  },
  {
    id: 4174,
    url: "https://www.tvmaze.com/shows/4174/30-grader-i-februari",
    name: "30 grader i februari",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50313.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50313.jpg",
    },
    summary:
      "<p>A few people goes to Thailand in hope to find a happier life.</p><p>The worked out mother of two children Kajsa, is having a stroke and decides to move to Thailand with her daughters in hope of finding peace and quiet. She leaves her home and job in Sweden and takes her family to the bungalow hotel Happiness where they stayed on their previous vacation. When they get there, Happiness is closed and for sale, so Kajsa decides to buy it.</p><p>Majlis don't ever want to leave the vacation in Thailand. She want to retire there together with her husband and live on his pension. But the cranky old man doesn't want anything but to go home to Sweden.</p><p>Glenn is 45 years old, alone and a virgin. He dreams of a family with children and tried desperately to find a woman to share his dream with. After having several failures in finding a woman in Sweden, he decides to go to Thailand and try his luck there.</p>",
    officialSite: "https://www.svt.se/30-grader-i-februari",
    webChannel: null,
    language: "Swedish",
    status: "Ended",
    network: {
      id: 155,
      name: "SVT1",
      country: { name: "Sweden", code: "SE", timezone: "Europe/Stockholm" },
    },
    premiered: "2012-02-06",
  },
  {
    id: 4175,
    url: "https://www.tvmaze.com/shows/4175/hollyoaks",
    name: "Hollyoaks",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/73/183727.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/73/183727.jpg",
    },
    summary:
      "<p><b>Hollyoaks</b> follows the lives of a group of residents living in the fictional village of Chester.</p>",
    officialSite: "http://www.channel4.com/programmes/hollyoaks",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1995-10-23",
  },
  {
    id: 4177,
    url: "https://www.tvmaze.com/shows/4177/war-of-the-worlds",
    name: "War of the Worlds",
    genres: ["Drama", "Science-Fiction", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/79/199471.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/79/199471.jpg",
    },
    summary:
      "<p>In this sequel to the highly acclaimed 1953 movie, it is revealed that the alien invaders weren't killed by the bacteria: they went into a state of suspended animation. An incident at a nuclear plant exposes them to radiation, which they can survive but which kills the bacteria, restoring them to life. Now they plan a new invasion of Earth, using their ability to merge with human bodies and take control of them. However, they have to continue exposing themselves to radiation to destroy new bacteria as it enters their bodies.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1988-10-07",
  },
  {
    id: 4178,
    url: "https://www.tvmaze.com/shows/4178/dr-ks-exotic-animal-er",
    name: "Dr. K's Exotic Animal ER",
    genres: ["Drama", "Nature", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50449.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50449.jpg",
    },
    summary:
      "<p>Dr. Susan Kelleher owns and operates one of the busiest exotic animal care practices located in South Florida, Broward Avian and Exotics Animal Hospital. \"Everything but dogs and cats. If it will fit through the door, I'll treat it!\" is Dr. K's motto. And through the door they come. Rabbits, reptiles and birds of all shapes and sizes, foxes, ferrets, fish, marsupials, and even primates all on <b>Dr. K's Exotic Animal ER</b>.</p>",
    officialSite:
      "http://channel.nationalgeographic.com/wild/dr-ks-exotic-animal-er/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 83,
      name: "National Geographic WILD",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-14",
  },
  {
    id: 4179,
    url: "https://www.tvmaze.com/shows/4179/1066-the-battle-for-middle-earth",
    name: "1066: The Battle for Middle Earth",
    genres: ["Drama", "Action", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/197/494131.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/197/494131.jpg",
    },
    summary:
      "<p><b>1066: The Battle for Middle Earth</b> is an epic drama that reveals the untold story of the Norman Conquest through the eyes of the ordinary villagers caught up in the chaos.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-05-18",
  },
  {
    id: 4180,
    url: "https://www.tvmaze.com/shows/4180/sword-of-honour",
    name: "Sword of Honour",
    genres: ["Drama", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50401.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50401.jpg",
    },
    summary:
      "<p>Award-winning writer William Boyd's adaptation of Evelyn Waugh's epic Second World War trilogy into a lavish two-part drama starring Daniel Craig, Megan Dodds and Leslie Phillips.</p>",
    officialSite: "http://www.channel4.com/programmes/sword-of-honour",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2001-01-02",
  },
  {
    id: 4181,
    url: "https://www.tvmaze.com/shows/4181/kitchen-confidential",
    name: "Kitchen Confidential",
    genres: ["Comedy", "Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50412.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50412.jpg",
    },
    summary:
      '<p>Celebrity chef Jack Bourdain, currently making pizzas at a chain restaurant, is offered an opportunity to become head chef of Nolita, a hip New York City restaurant. Pino, the owner of the establishment, has 300 reservations on the bookS and no food, crew or chef. He gives Jack the job and 48 hours to get it done. Jack raids other kitchens, bringing in an all-star team of chefs from his past. When a food critic Jack met during his wild days comes to Nolita, things have a horrible way of going wrong. Chaos ensues, but there is hope - the food critic gives Nolita a rave review on the "Exile on Main Street".</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-09-19",
  },
  {
    id: 4182,
    url: "https://www.tvmaze.com/shows/4182/coffee-prince",
    name: "Coffee Prince",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50419.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50419.jpg",
    },
    summary:
      '<p>The life of Go Eun Chan is not easy; she works many jobs to pay off debts and even gave up her feminine image. Choi Han Kyul is the heir of a big food company, but his grandmother wants him to settle down, so she arranged many dates for him. After Eun Chan bumped into Han Kyul and was mistaken for a boy, Han Kyul decided to hire Eun Chan to be his gay lover in order to avoid the arranged dates. Desperately in need of money, Eun Chan had no choice but to accept. Han Kyul\'s grandmother also made Han Kyul in charge of a filthy coffee shop in danger of being bankrupt. Eun Chan begged to work at the coffee shop, and not long after, feelings start to spark, except, how would Han Kyul accept his "homosexuality"?</p>',
    officialSite: "http://imbc.com/broad/tv/drama/coffeeprince/",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 166,
      name: "MBC",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2007-07-02",
  },
  {
    id: 4183,
    url: "https://www.tvmaze.com/shows/4183/izmeny",
    name: "Измены",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/191/479147.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/191/479147.jpg",
    },
    summary:
      "<p>Невероятная история молодой женщины, у которой был муж и трое любовников. В сериале рассказывается о том, что происходит с судьбами людей, которые и которым изменяют.</p>",
    officialSite: "http://izmeny.tnt-online.ru/",
    webChannel: null,
    language: "Russian",
    status: "Ended",
    network: {
      id: 308,
      name: "ТНТ",
      country: {
        name: "Russian Federation",
        code: "RU",
        timezone: "Asia/Kamchatka",
      },
    },
    premiered: "2015-09-21",
  },
  {
    id: 4184,
    url: "https://www.tvmaze.com/shows/4184/master-i-margarita",
    name: "Мастер и Маргарита",
    genres: ["Drama", "Fantasy", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/248/620275.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/248/620275.jpg",
    },
    summary: "",
    officialSite: "http://www.masterimargarita.ru",
    webChannel: null,
    language: "Russian",
    status: "Ended",
    network: {
      id: 239,
      name: "Россия 1",
      country: {
        name: "Russian Federation",
        code: "RU",
        timezone: "Asia/Kamchatka",
      },
    },
    premiered: "2005-12-19",
  },
  {
    id: 4185,
    url: "https://www.tvmaze.com/shows/4185/dnevnik-doktora-zajcevoj",
    name: "Дневник доктора Зайцевой",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50429.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50429.jpg",
    },
    summary: "",
    officialSite: "http://ctc.ru/projects/serials/dnevnik-doktora-zaytsevoy/",
    webChannel: null,
    language: "Russian",
    status: "Ended",
    network: {
      id: 304,
      name: "СТС",
      country: {
        name: "Russian Federation",
        code: "RU",
        timezone: "Asia/Kamchatka",
      },
    },
    premiered: "2012-01-16",
  },
  {
    id: 4186,
    url: "https://www.tvmaze.com/shows/4186/ouran-high-school-host-club",
    name: "Ouran High School Host Club",
    genres: ["Comedy", "Anime", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50432.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50432.jpg",
    },
    summary:
      '<p>Haruhi Fujioka is a bright scholarship candidate with no rank or title to speak of—a rare species at Ouran High School, an elite academy for students of high pedigree. When she opens the door to Music Room #3 hoping to find a quiet place to study, Haruhi unexpectedly stumbles upon the Host Club. Led by the princely Tamaki, the club—whose other members include the "Shadow King" Kyouya, the mischievous Hitachiin twins, and the childlike Haninozuka "Honey" and his strong protector Mori—is where handsome boys with too much time on their hands entertain the girls in the academy.<br /><br />In a frantic attempt to remove herself from the hosts, Haruhi ends up breaking a vase worth eight million yen and is forced into becoming the eccentric group\'s general errand boy to repay her enormous debt. However, thanks to her convincingly masculine appearance, her naturally genial disposition toward girls, and fascinating commoner status, she is soon promoted to full-time male host and plunged headlong into a glitzy whirlwind of elaborate cosplays, rich food, and exciting shenanigans that only the immensely wealthy Ouran Host Club can pull off.</p>',
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 137,
      name: "NTV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2006-04-04",
  },
  {
    id: 4187,
    url: "https://www.tvmaze.com/shows/4187/10-oclock-live",
    name: "10 O'Clock Live",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50433.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50433.jpg",
    },
    summary:
      "<p>A weekly, live comedy and current affairs show hosted by David Mitchell, Jimmy Carr, Charlie Brooker and Lauren Laverne.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-01-20",
  },
  {
    id: 4188,
    url: "https://www.tvmaze.com/shows/4188/modus",
    name: "Modus",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/139/348089.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/139/348089.jpg",
    },
    summary:
      "<p>During a snowy Christmas season in Sweden, psychologist and profiler Inger Johanne Vik finds not only herself but also her autistic daughter drawn into the investigation of a number of disturbing deaths, through which she meets detective Ingvar Nyman at the Stockholm Police. Nyman is dispatched to Uppsala to investigate the shocking Christmas Eve murder of bishop Elisabeth Lindgren. In Stockholm, the bodies keep turning up - though the causes of death vary. But before long, Inger Johanne starts noticing a pattern. <b>Modus</b> is a thrilling story that raises questions about religion, human rights, and the very nature of love itself. It goes beyond conventional crime and peppers the story with red-hot political issues and criticizing intolerance.</p>",
    officialSite: "http://www.tv4.se/modus",
    webChannel: null,
    language: "Swedish",
    status: "Ended",
    network: {
      id: 123,
      name: "TV4",
      country: { name: "Sweden", code: "SE", timezone: "Europe/Stockholm" },
    },
    premiered: "2015-09-23",
  },
  {
    id: 4189,
    url: "https://www.tvmaze.com/shows/4189/general-hospital",
    name: "General Hospital",
    genres: ["Drama", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/115/287759.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/115/287759.jpg",
    },
    summary:
      "<p><b>General Hospital</b>, which celebrated its golden anniversary on April 1, 2013, continues its tradition of passion, intrigue and adventure that takes place in the fictional town of Port Charles in upstate New York. The glamour and excitement of those who have come to find their destinies in this familiar seaport town intertwine with the lives, loves and fortunes of beloved, well-known faces. As always, love, danger and mind blowing plot twists continue to abound on General Hospital with contemporary storylines and unforgettable characters.</p>",
    officialSite: "http://abc.go.com/shows/general-hospital",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1963-04-01",
  },
  {
    id: 4190,
    url: "https://www.tvmaze.com/shows/4190/howstuffworks",
    name: "HowStuffWorks",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50448.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50448.jpg",
    },
    summary:
      "<p><b>HowStuffWorks</b> is about the stuff that makes the world go ‘round. It's truly incredible to see the ingenious lengths people go to in order to extract rubber and iron, corn and wheat, and water and salt from the earth. Equally amazing is the number of different and varied products that can be derived from something so fundamental. Who would guess that furniture, diesel additives, crayons, solvents, candles, shampoo and tofu can all be derived from the humble soybean? Follow the incredible journey of these goods from the ground to your table, car, closet, medicine cabinet and places you may have never imagined.</p>",
    officialSite:
      "http://www.discovery.com/tv-shows/other-shows/videos/other-shows-how-stuff-works-videos/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 66,
      name: "Discovery Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-11-13",
  },
  {
    id: 4191,
    url: "https://www.tvmaze.com/shows/4191/art-breakers",
    name: "Art Breakers",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50453.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50453.jpg",
    },
    summary:
      "<p><b>Art Breakers </b>features two of the top art advisors in the country, Miller Gaffney and Carol Lee Brosseau, on their quest to find the hottest artists, commission show-stopping works, and save their clients from spending their millions on junk. In each episode, Miller and Carol Lee tackle a new business challenge to accommodate their clients'eclectic tastes and sometimes bizarre requests. Whether it's soliciting a nude portrait for a quirky client, throwing a star-studded gallery opening, or digging through celebrity estate sales to turn up the best in Hollywood memorabilia, these undaunted pros are the art world's best match-makers.</p><p>\"Miller and Carol Lee didn't get to be the top art advisors for nothing. They're young, in demand and know the art world inside and out,\" said Scott Woodward, EVP, Programming and Production, Ovation TV. \"In this series, Ovation viewers will get a ring-side seat as they take us along on some of their most challenging assignments.\"</p>",
    officialSite:
      "http://www.ovationtv.com/ovation-tv-green-lights-new-original-series-for-the-fall-art-breakers/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 208,
      name: "Ovation",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-04",
  },
  {
    id: 4193,
    url: "https://www.tvmaze.com/shows/4193/halloween-baking-championship",
    name: "Halloween Baking Championship",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/132/331331.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/132/331331.jpg",
    },
    summary:
      "<p>Making everything from spider cupcakes to mummy macarons, seven of the country's top bakers will compete to create Halloween's spookiest confections on <b>Halloween Baking Championship</b>, premiering Monday, Oct. 5 at 9|8c. To survive this haunted competition, hosted by Richard Blais, contestants must prove their baking abilities and impress judges Ron Ben-Israel, Carla Hall and Sherry Yard. Only one winner will take home the grand prize of $25,000 and earn the title of Halloween Baking Champion.</p>",
    officialSite:
      "http://www.foodnetwork.com/shows/halloween-baking-championship",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 81,
      name: "Food Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-05",
  },
  {
    id: 4194,
    url: "https://www.tvmaze.com/shows/4194/the-weapon-hunter",
    name: "The Weapon Hunter",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/315/788938.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/315/788938.jpg",
    },
    summary:
      "<p>A shootout between five WWII sniper rifles and two Civil War cannons. A massive rebuild of a tank destroyer and the fierce Quad 50 mobile machine gun. An epic cross-continent hunt for an ultra-rare rifle and an operational flamethrower. Military history buff Paul Shull is on a mission to touch, hold, and fire some of the greatest pieces of weaponry on the planet. Get an up-close look at some of the most iconic weapons of the last 150 years and witness the awesome firepower they still have on <b>The Weapon Hunter</b>.</p>",
    officialSite:
      "http://www.smithsonianchannel.com/shows/the-weapon-hunter/1003807",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 86,
      name: "Smithsonian Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-05",
  },
  {
    id: 4195,
    url: "https://www.tvmaze.com/shows/4195/richard-hammonds-jungle-quest",
    name: "Richard Hammond's Jungle Quest",
    genres: ["Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50480.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50480.jpg",
    },
    summary:
      "<p>Richard Hammond achieves a childhood dream as he treks through the Amazon rainforest, camera in hand, in this two part series.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 63,
      name: "Sky 1",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-09-16",
  },
  {
    id: 4196,
    url: "https://www.tvmaze.com/shows/4196/america-facts-vs-fiction",
    name: "America: Facts vs. Fiction",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50482.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50482.jpg",
    },
    summary:
      "<p>History as we generally know it is full of holes or half-truths, and a mother lode of juicy details have been lost, distorted, covered up or simply ignored along the way. Military Channel's new series, <b>America: Facts vs. Fiction</b> is on a mission to set the record straight. Hosted by former Naval officer and actor Jamie Kaler, America: Facts vs. Fiction is a wake-up call about the surprising hidden facts behind the most familiar and beloved stories from our nation's and military's past, filling in the blanks, debunking the occasional myth, and exploring why we sometimes get our own history, well, slightly wrong. Examining the past with a fresh perspective, this all-new series reveals that the \"story\" of America is just that - and far more remarkable than we ever thought.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 229,
      name: "AHC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-07-10",
  },
  {
    id: 4197,
    url: "https://www.tvmaze.com/shows/4197/beyond-belief-fact-or-fiction",
    name: "Beyond Belief: Fact or Fiction",
    genres: ["Science-Fiction", "Thriller", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50484.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50484.jpg",
    },
    summary:
      "<p>\"Within this hour we will tell you five stories, some real, some fake, you decide. Your call\". This weekly series first premiered in May 1997. Back then with host, James Brolin. He then left, and Jonathan Frakes, made it very interesting as host there on after. This series has been on and off, with 'burnoffs' that included over 1997/1998, where they just brought it back for one day on Friday, which made people confused because it didn't air the week after that. But again, FOX revived it was brought back for the Summer 2002. Creepy true stories like the boy vanishing in the closet, and false stories, like the dog coming back to life, and the couple struggling with money finds the Gone with the Wind dresses in their closet. Watch <b>Beyond Belief: Fact or Fiction?</b> on the Sci-Fi Channel every Wednesday at 7:00pm EST. Also check out the Marathon on Wednesday, Oct. 27th starting at 8:00am.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1997-05-25",
  },
  {
    id: 4198,
    url: "https://www.tvmaze.com/shows/4198/ani-tore-ex",
    name: "Ani Tore! EX",
    genres: ["Comedy", "Anime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/80/200965.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/80/200965.jpg",
    },
    summary:
      "<p>Five girls who are aiming to become idols, lead the viewer through practicing various types of training, such as push-up, sit-up, back extension, dance, yoga, stretch, trunk training, and Tai Chi, while talking to viewers.</p>",
    officialSite: "http://anime-training.com/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 132,
      name: "Tokyo MX",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2015-10-12",
  },
  {
    id: 4199,
    url: "https://www.tvmaze.com/shows/4199/shinmai-maou-no-testament",
    name: "Shinmai Maou no Testament",
    genres: ["Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50488.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50488.jpg",
    },
    summary:
      "<p>Hey, you said you wanted a little sister, right?\" First year highschool student, Toujo Basara, was suddenly asked by his father and fell into a state of panic. On top of that, the eccentric father told him he will be getting remarried. He then departed overseas after bringing Basara two beautiful step-sisters. But Mio and Maria's true forms are actually the newbie Demon Lord and a succubus!? Basara was almost entered into a master and servant contract with Mio, but a \"reversed\" contract was formed by mistake, and Basara is now the master!? Moreover, Basara is being hit by one ecchi situation after another due to the contract, but Mio's life is being pursued by other demon tribes and hero tribes! The most powerful contractor's desire action drama begins!</p>",
    officialSite: "http://anime-shinmaimaou.com/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 132,
      name: "Tokyo MX",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2015-01-08",
  },
  {
    id: 4200,
    url: "https://www.tvmaze.com/shows/4200/hidan-no-aria",
    name: "Hidan no Aria",
    genres: ["Drama", "Action", "Anime", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50490.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50490.jpg",
    },
    summary:
      '<p>Tokyo Butei High School is a special school where armed detectives—"Butei"—are trained to use weapons. Kinji Tōyama is a second year student who has a special ability, but he keeps it a secret to maintain an ordinary, peaceful life. However, when he gets caught in a bombing on the way to school, he encounters Aria H. Kanzaki, the most powerful S-Rank Butei student in Assault Studies.</p>',
    officialSite: "http://ariaaa.tv/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 159,
      name: "TBS",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2011-04-14",
  },
  {
    id: 4201,
    url: "https://www.tvmaze.com/shows/4201/one-punch-man",
    name: "One-Punch Man",
    genres: ["Comedy", "Action", "Anime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/177/444456.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/177/444456.jpg",
    },
    summary:
      "<p><b>One-Punch Man</b> is a super hero who has trained so hard that his hair has fallen out, and who can overcome any enemy with one punch. However, because he is so strong, he has become bored and frustrated with winning all his battles so easily.</p>",
    officialSite: "http://onepunchman-anime.net/",
    webChannel: null,
    language: "Japanese",
    status: "To Be Determined",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2015-10-06",
  },
  {
    id: 4202,
    url: "https://www.tvmaze.com/shows/4202/monogatari-series",
    name: "Monogatari Series",
    genres: ["Comedy", "Anime", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50493.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50493.jpg",
    },
    summary:
      "<p>Araragi Koyomi is a third year high school student who is almost human again after having briefly become a vampire. One day, a classmate named Senjougahara Hitagi, who infamously never talks to anyone, falls down the stairs into Koyomi's arms. He discovers that Hitagi weighs next to nothing, in defiance of physics and common sense alike. Despite being threatened by her, Koyomi offers her help, and introduces her to Oshino Meme, a middle-aged homeless man who helped him stop being a vampire.</p>",
    officialSite: "http://www.monogatari-series.com/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 132,
      name: "Tokyo MX",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2009-07-03",
  },
  {
    id: 4204,
    url: "https://www.tvmaze.com/shows/4204/storage-wars-miami",
    name: "Storage Wars: Miami",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/22/56363.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/22/56363.jpg",
    },
    summary:
      "<p><b>Storage Wars: Miami</b> is the 6th spin-off series in A&amp;E's Storage Wars franchise, which follows teams of bidders looking to score it big in the high stakes world of storage auctions, ranks as A&amp;E's number one series of all time among adults 25-54. During its first season, the series averaged 2.8 million viewers per episode and peaked at 3.8 million. The <i>Storage Wars</i> franchise heads to the sexy city of Miami to follow the most colorful bidders in South Florida in the hour-long premiere of the brand new 10-episode original series <i>Storage Wars: Miami</i>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-06",
  },
  {
    id: 4205,
    url: "https://www.tvmaze.com/shows/4205/storage-wars-texas",
    name: "Storage Wars: Texas",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50578.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50578.jpg",
    },
    summary:
      "<p><i>Storage Wars</i> ranks as A&amp;E's top-rated series of all time -- \"Yuuuuup!'' -- so it's no surprise the franchise has expanded to include Texas-based characters searching for auction gold. Each half-hour episode follows a group of bidders looking to strike it rich by buying repossessed storage units. They're at once detectives and gamblers, as they get only a quick flashlight-aided peek inside the units before they decide if they want to make a bid, and for how much. It's a high-stakes game that can pay off big time ... or leave one sifting through the equivalent of trash on <b>Storage Wars: Texas </b>also known as <i>Storage Wars: Dallas</i>.</p>",
    officialSite: "http://www.aetv.com/storage-wars-texas",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-12-06",
  },
  {
    id: 4206,
    url: "https://www.tvmaze.com/shows/4206/storage-wars-new-york",
    name: "Storage Wars: New York",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50579.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50579.jpg",
    },
    summary:
      "<p>A&amp;E Network is breaking the locks off the tri-state area's abandoned storage units with the season premiere of its latest hit series <b>Storage Wars: New York</b>. The East Coast treasure hunters are back for an action packed new season, and the drama that brews in the Big Apple is almost good enough to eat! Back-to-back new episodes of <i>Storage Wars: New York</i> premiere Tuesday, July 9 at 9PM and 9:30PM ET/PT.</p><p><i>Storage Wars: New York</i> follows a group of urban explorers in a modern-day treasure hunt for forgotten gems. In the nation's most populated city, with its notoriously small apartments and storage dilemmas, there's no telling what amazing valuables might exist within the storage units of New York and its surrounding areas.</p>",
    officialSite: "http://www.aetv.com/shows/storage-wars-new-york",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 29,
      name: "A&E",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-01-01",
  },
  {
    id: 4207,
    url: "https://www.tvmaze.com/shows/4207/storage-wars-canada",
    name: "Storage Wars: Canada",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50581.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50581.jpg",
    },
    summary:
      "<p>On a daily basis, high-stakes buyers descend upon repossessed and forgotten storage units all across Canada. OLN's <b>Storage Wars: Canada</b> follows four teams hoping to score big on a modern treasure hunt. Following Roy Dirnbeck, Cindy Hayden and Rick Coffill, Ursula Stolf and father-son duo Paul and Bogart Kenny, the series explores the world of these experienced and determined buyers. Having just five minutes to explore the unit before it goes up for auction, the buyers bid for a locker full of what could be a load of trash, or a grand treasure. With all levels of experience, these teams do whatever it takes to find the next big deal.</p>",
    officialSite: "http://www.oln.ca/shows/storage-wars-canada/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 350,
      name: "OLN",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2013-08-29",
  },
  {
    id: 4208,
    url: "https://www.tvmaze.com/shows/4208/tremors",
    name: "Tremors",
    genres: ["Action", "Horror", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50618.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50618.jpg",
    },
    summary:
      "<p>In this sequel to the theatrical and direct-to-video movies, the desert town of Perfection, Nevada, is under government protection because of the endangered species known as Graboids: large earth-burrowing worm-like creatures. Most of the residents of Perfection have refused to move, and now they have to cope with the Graboids and their variations, government agents, real-estate developers, other experiments from the same scientists who created the Graboids, and more.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 16,
      name: "Syfy",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-03-28",
  },
  {
    id: 4209,
    url: "https://www.tvmaze.com/shows/4209/mummies-alive",
    name: "Mummies Alive!",
    genres: ["Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50624.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50624.jpg",
    },
    summary:
      "<p>In this animated series, five mummies from ancient Egypt are revived in modern-day San Francisco. They were the bodyguards of the pharaoh's son, Rapses, and are brought back to life to battle Scarab, the evil sorcerer who killed Rapses millennia ago. Scarab is back and trying to find Rapses reincarnated spirit, which is found in the body of a boy named Presley Carnovan.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1997-09-15",
  },
  {
    id: 4211,
    url: "https://www.tvmaze.com/shows/4211/collision",
    name: "Collision",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/286/715183.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/286/715183.jpg",
    },
    summary:
      "<p>Police drama series. Troubled detective John Tolin returns to work after an extended period of leave, and is handed a complicated case involving a shocking road traffic accident.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-11-09",
  },
  {
    id: 4212,
    url: "https://www.tvmaze.com/shows/4212/masterchef-asia",
    name: "MasterChef Asia",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50645.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50645.jpg",
    },
    summary:
      "<p>Lifetime brings together 15 aspiring home cooks from across Asia in the first season of this pan-regional, English version of <b>Masterchef Asia</b>. Judged by Hong Kong-born, culinary genius Susur Lee; 3-Michelin Starred chef Bruno Ménard; and Singapore-born, Audra Morrice, a <i>MasterChef Australia</i> finalist. From the <i>MasterChef</i> kitchen to off-site and overseas challenges, the 15 episodes will culminate in one home-cook winning the title of the first ever <i>MasterChef Asia</i> winner.</p>",
    officialSite: "http://www.msn.com/en-sg/lifestyle/masterchefasia",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 351,
      name: "Lifetime Asia",
      country: { name: "Singapore", code: "SG", timezone: "Asia/Singapore" },
    },
    premiered: "2015-09-03",
  },
  {
    id: 4213,
    url: "https://www.tvmaze.com/shows/4213/high-hopes",
    name: "High Hopes",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50784.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50784.jpg",
    },
    summary:
      "<p><b>High Hopes</b> is a surreal comedy, set in the South Wales valleys. It follows the ups and downs of four people from the wrong side of the tracks as they form themselves into an unlikely but close-knit family group - Fagin, Mam, Hoffman and Charlie.</p>",
    officialSite: "http://www.bbc.co.uk/wales/highhopes/sites/content/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 352,
      name: "BBC One Wales",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2002-10-02",
  },
  {
    id: 4214,
    url: "https://www.tvmaze.com/shows/4214/satellite-city",
    name: "Satellite City",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50652.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50652.jpg",
    },
    summary: "<p>Comedy series written by Jane and Boyd Clack.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00fd750",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 353,
      name: "BBC Two Wales",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1996-10-04",
  },
  {
    id: 4215,
    url: "https://www.tvmaze.com/shows/4215/komori-san-wa-kotowarenai",
    name: "Komori-san wa Kotowarenai!",
    genres: ["Comedy", "Anime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50654.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50654.jpg",
    },
    summary:
      "<p>Shuri Komori is a 14-year-old girl, who is so nice that she can not turn down people's request. She gains amazing abilities while she fulfills people's request. There are many fun &amp; happy things in her life, since she is an adolescent middle school student after all!</p>",
    officialSite: "http://komori-anime.com/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 132,
      name: "Tokyo MX",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2015-10-04",
  },
  {
    id: 4216,
    url: "https://www.tvmaze.com/shows/4216/lizard-lick-towing",
    name: "Lizard Lick Towing",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50655.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50655.jpg",
    },
    summary:
      "<p>Are you ready to get licked? Welcome to the freewheeling, always colorful world of Lizard Lick Towing &amp; Recovery. Set in rural North Carolina, Lizard Lick is owned and operated by Ron Shirley, former college football player and ordained minister, and his wife, Amy, former power lifter and trained MMA fighter. Watch Ron, Amy and the rest of the crew as they dodge brawls and bullets in order to get the goods, stay ahead of the competition and keep their customers satisfied.</p>",
    officialSite: "http://www.trutv.com/shows/lizard-lick-towing/index.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 84,
      name: "truTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-02-07",
  },
  {
    id: 4217,
    url: "https://www.tvmaze.com/shows/4217/south-beach-tow",
    name: "South Beach Tow",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50658.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50658.jpg",
    },
    summary:
      '<p>The <b>South Beach Tow</b> crew returns to the streets of Miami, where the zaniness is in full force from the start. Bernice and her mom kick off their own food truck business, Kosgrove "encounters" the elusive Swamp Ape, and J-Money gets a side-kick who isn\'t even old enough to drive. From rapping mermaids to angry female body builders to a tiny smart car owner that really "flips" out, there is nothing too bizarre for this tow company. Get ready for a burst of energy that\'s jam-packed with fun and laughs!</p>',
    officialSite: "http://www.trutv.com/shows/south-beach-tow/index.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 84,
      name: "truTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-07-20",
  },
  {
    id: 4218,
    url: "https://www.tvmaze.com/shows/4218/noragami",
    name: "Noragami",
    genres: ["Comedy", "Action", "Anime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50667.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50667.jpg",
    },
    summary:
      "<p>Yato may just be a minor god now, but he's determined to make it big and he's got a plan. Unfortunately, things just don't seem to be going his way. He doesn't have a single shrine dedicated to him, his partner has just quit, and now he's got to find a new divine weapon. Just when things look bleak, he meets a girl named Hiyori and changes her life forever.</p>",
    officialSite: "http://noragami-anime.net/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 132,
      name: "Tokyo MX",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2014-01-05",
  },
  {
    id: 4219,
    url: "https://www.tvmaze.com/shows/4219/heavy-object",
    name: "Heavy Object",
    genres: ["Action", "Anime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50668.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50668.jpg",
    },
    summary:
      "<p>Quenser came to the Alaskan military base to study Objects, the new weapons that have completely revolutionized war as we know it—battles are fought by soldiers controlling Objects far away from harm; however, when he starts to get close to Object pilot Milinda, will he discover the grim truth behind Heavy Objects?</p>",
    officialSite: "http://heavyobject.net/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 132,
      name: "Tokyo MX",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2015-10-03",
  },
  {
    id: 4220,
    url: "https://www.tvmaze.com/shows/4220/testees",
    name: "Testees",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50673.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50673.jpg",
    },
    summary:
      '<p><b>Testees</b> is a half-hour comedy from Kenny Hotz (creator of Kenny vs. Spenny) about two best friends and roommates who make a living as guinea pigs for "Testico", a drug and product testing facility. In each episode, the guys just try to live their lives while dealing with the often surprising side effects and highly unusual occupational hazards. The show is produced by FX Productions and Blueprint Entertainment Inc.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-10-09",
  },
  {
    id: 4221,
    url: "https://www.tvmaze.com/shows/4221/the-head",
    name: "The Head",
    genres: ["Comedy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50676.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50676.jpg",
    },
    summary:
      "<p><b>The Head</b> is the story of Jim, a trade-school student in New York City who awakens one morning to find that his cranium has enlarged to mammoth proportions. A week later, out bursts Roy, a little purple alien with an odd sense of humor who has taken up residence in Jim's head. Roy needed a place to stay to adapt to the Earth's environment while on a mission to save the world from a power-hungry alien named Gork. Aiding Jim and Roy are Jim's girlfriend, Madelyn; his personal physician, Dr. Richard Axel; and a group of \"human anomalies\". The theme of the story is to reinforce the value of diversity, tolerance, acceptance of differences, and working together to solve problems.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1994-12-19",
  },
  {
    id: 4222,
    url: "https://www.tvmaze.com/shows/4222/glenn-martin-dds",
    name: "Glenn Martin, DDS",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755444.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755444.jpg",
    },
    summary:
      "<p>It's me, Glenn Martin, father, dentist, Facebooker. Our house burned down, so my family and I are traveling around in an RV on a never-ending roadtrip.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 62,
      name: "nick@nite",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-08-17",
  },
  {
    id: 4223,
    url: "https://www.tvmaze.com/shows/4223/captain-tsubasa",
    name: "Captain Tsubasa",
    genres: ["Drama", "Anime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50685.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50685.jpg",
    },
    summary:
      "<p>Tsubasa Ozora moves to the town Nankatsu to increase his skills as a soccer player. He is challanged by the Super Goalkeeper Genzo Wakabayashi. He then agree to compete and see who was the best soccer player there.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1983-10-13",
  },
  {
    id: 4224,
    url: "https://www.tvmaze.com/shows/4224/echo-beach",
    name: "Echo Beach",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50688.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50688.jpg",
    },
    summary:
      "<p><b>Echo Beach</b> was created by Tony Jordan and is set in the fictional seaside town of Polnarren in Cornwall. The story follows the lives of ex lovers Daniel Marrack and Susan Penwarden as well as the teenagers living in the town.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-01-10",
  },
  {
    id: 4225,
    url: "https://www.tvmaze.com/shows/4225/mako-mermaids",
    name: "Mako Mermaids",
    genres: ["Drama", "Family", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50690.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50690.jpg",
    },
    summary:
      "<p>A boy is magically turned a merman, and discovers his underwater origins, after he comes in contact with the magic waters at the mysterious Mako Island guarded by a trio of mermaids.</p>",
    officialSite: "https://www.netflix.com/title/70281343",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2013-07-27",
  },
  {
    id: 4226,
    url: "https://www.tvmaze.com/shows/4226/little-dorrit",
    name: "Little Dorrit",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50703.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50703.jpg",
    },
    summary:
      "<p>Fourteen-part adaptation of Dickens' powerful story of love, honour, debt and hope in 1820s London, written by Andrew Davies.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00fcm3b",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-10-26",
  },
  {
    id: 4227,
    url: "https://www.tvmaze.com/shows/4227/transformers",
    name: "Transformers",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/62/156745.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/62/156745.jpg",
    },
    summary:
      "<p><b>Transformers</b> is an animated television series depicting a war between giant robots who could transform into vehicles, animals, and other objects.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1984-09-17",
  },
  {
    id: 4228,
    url: "https://www.tvmaze.com/shows/4228/beast-wars-transformers",
    name: "Beast Wars: Transformers",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50737.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50737.jpg",
    },
    summary:
      "<p>Trapped on a primitive planet, two opposing factions, the Maximals and the Predacons, of Transformers, a race of sentient robots, fight over its precious Energon. Soon they discover that there are other forces at work on the planet - a powerful alien race that does not approve of their presence. And as they delve deeper into the planet's history, they uncover a terrible secret, one that must not be allowed to fall into the wrong hands, or their entire race's very existence could be threatened. <b>Beast Wars</b> was a spin-off from the 80s Transformers cartoon. It was later followed by Beast Machines, which continues this show. Another interesting series to note that Beast Wars may have started as Beast Wars Neo, completely done in Japanese and yet to be dubbed; it is vaguely reminiscent of Gundam Wing, and many other popular mobile suit animes.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-09-16",
  },
  {
    id: 4229,
    url: "https://www.tvmaze.com/shows/4229/bravestarr",
    name: "BraveStarr",
    genres: ["Action", "Fantasy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/82/206451.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/82/206451.jpg",
    },
    summary:
      "<p>The discovery of Kerium, a rare and powerful magic crystal, brings an infinite number of colonists from all the corners of the galaxy to the distant planet New Texas. Some are good and honest, others very malicious but no one is more dangerous than Tex Hex the leader of the Carrion Bunch, a group of outlaws under the control of the mysterious group Stampede. Hex seeks to control this immense mineral richness at all costs than is Kerium. Only one person can put a stop on his plans: <b>BraveStarr</b>. When there was an obstacle in the way, BraveStarr called for the power of a particular animal and used that ability to move the obstacle, like using the strength of a bear to move a boulder, or the speed of a puma to catch the criminal, the eyes of a hawk, or the ears of a wolf. To help him in the fight for the cause of justice, he had Thirty-Thirty, his horse that can transform into a human-like cr...</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1987-09-14",
  },
  {
    id: 4230,
    url: "https://www.tvmaze.com/shows/4230/he-man-and-the-masters-of-the-universe",
    name: "He-Man and the Masters of the Universe",
    genres: ["Action", "Fantasy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50749.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50749.jpg",
    },
    summary:
      "<p>Prince Adam is the young son of Eternia's rulers, King Randor and Queen Marlena. Whenever Prince Adam uses the Sword of Power by holding it aloft and saying the magic words \"By the Power of Grayskull, I HAVE THE POWER\" he is transformed into He-Man, the most powerful man in the universe. Together with his close allies, Battle Cat, The Sorceress, Teela, Man-At-Arms and Orko, He-Man uses his powers to defend Eternia from the evil forces of Skeletor. Skeletor's main goal is to conquer the mysterious fortress of Castle Grayskull, from which He-Man draws his powers. If he succeeds, Skeletor would conquer the world of Eternia, and possibly the whole universe.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1983-09-05",
  },
  {
    id: 4231,
    url: "https://www.tvmaze.com/shows/4231/he-man-and-the-masters-of-the-universe",
    name: "He-Man and the Masters of the Universe",
    genres: ["Action", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50777.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50777.jpg",
    },
    summary:
      "<p><b>He-Man and the Masters of the Universe</b> was a revival of the classic 80's cartoon. These new episodes focus on the early adventures of Prince Adam, who having just become Eternia's most powerful guardian, grapples with his new awesome powers. As He-Man, Prince Adam must lead the Masters of the Universe into battle against the villanous Skeletor and his evil henchmen, who scheme to rule Eternia and spread chaos through the kingdom.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-08-16",
  },
  {
    id: 4232,
    url: "https://www.tvmaze.com/shows/4232/saber-rider-and-the-star-sheriffs",
    name: "Saber Rider and the Star Sheriffs",
    genres: ["Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755445.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755445.jpg",
    },
    summary: null,
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1987-09-14",
  },
  {
    id: 4233,
    url: "https://www.tvmaze.com/shows/4233/the-adventures-of-the-galaxy-rangers",
    name: "The Adventures of the Galaxy Rangers",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50780.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50780.jpg",
    },
    summary:
      "<p>The series combined sci-fi stories with traditional wild west themes. It was one of the first anime-style shows produced mainly in the USA, although the actual animation was done by the Japanese animation studio Tokyo Movie Shinsha. At the time it aired, <b>The Adventures of the Galaxy Rangers</b> was considered a revolutionary children's show.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1986-09-14",
  },
  {
    id: 4234,
    url: "https://www.tvmaze.com/shows/4234/stella",
    name: "Stella",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50782.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50782.jpg",
    },
    summary:
      "<p>Set in the town of Pontyberry, in the heart of the Welsh Valleys, <b>Stella</b> is a heartwarming comedy-drama written by and starring Ruth Jones.</p><p>Ruth plays Stella, a single mum of three. She doesn't have a lot of money, but she manages to keep the wolf from the door, and she's got a lot of love.</p><p>Now training to be a nurse, <i>Stella</i> navigates the dramas of small-town life - chiefly her own - and a rather complicated love life. But could new neighbour Michael Jackson be the route to happiness?</p>",
    officialSite: "http://www.sky.com/tv/show/stella",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 63,
      name: "Sky 1",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-01-06",
  },
  {
    id: 4235,
    url: "https://www.tvmaze.com/shows/4235/stranger-than-nature",
    name: "Stranger Than Nature",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50812.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50812.jpg",
    },
    summary:
      "<p>Investigating weird and wonderful real-life stories from the natural world. Each episode of <b>Stranger Than Nature</b> unravels three wild mysteries, combining groundbreaking scientific discoveries with classic detective work.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-11-07",
  },
  {
    id: 4236,
    url: "https://www.tvmaze.com/shows/4236/love-monkey",
    name: "Love Monkey",
    genres: ["Drama", "Comedy", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50813.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50813.jpg",
    },
    summary:
      "<p>Based on the best-selling book by Kyle Smith, <b>Love Monkey</b> follows Tom Farrell, an up-and-coming record executive trying to balance his career and dating life.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-01-17",
  },
  {
    id: 4237,
    url: "https://www.tvmaze.com/shows/4237/prokurator",
    name: "Prokurator",
    genres: ["Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50828.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50828.jpg",
    },
    summary: null,
    officialSite: "http://www.prokurator.tvp.pl",
    webChannel: null,
    language: "Polish",
    status: "Running",
    network: {
      id: 333,
      name: "TVP2",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2015-09-03",
  },
  {
    id: 4238,
    url: "https://www.tvmaze.com/shows/4238/czas-honoru",
    name: "Czas Honoru",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50833.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50833.jpg",
    },
    summary:
      '<p>Set during World War II in German-occupied Poland, the story follows a group of "Cichociemni", members of the elite special operations unit of the Polish underground. Parachuted into Poland, they must face not only the German intelligence, but also more serious dangers.</p>',
    officialSite: "http://www.czashonoru.tvp.pl",
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 333,
      name: "TVP2",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2008-09-07",
  },
  {
    id: 4239,
    url: "https://www.tvmaze.com/shows/4239/reguly-gry",
    name: "Reguły Gry",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50839.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50839.jpg",
    },
    summary: null,
    officialSite: null,
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 336,
      name: "TVP1",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2012-02-16",
  },
  {
    id: 4240,
    url: "https://www.tvmaze.com/shows/4240/the-fantastic-four",
    name: "The Fantastic Four",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50840.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50840.jpg",
    },
    summary:
      "<p><b>Fantastic Four</b> features a brilliant quartet of amazing superheroes - Mr. Fantastic, the Invisible Woman, the Human Torch and The Thing. These once-normal humans gained superpowers after exposure to cosmic rays during a scientific mission to outer space on a starship test flight gone wrong. Since that pivotal incident, they have devoted themselves to the exploration of the unknown and the preservation of the Earth from destructive, and sometimes alien, forces who confront them at every turn. <br /><br /><i>Fantastic Four</i> premiered in September 1994 as part of one half of the syndicated <i>The Marvel Action Hour </i>programming block alongside <i>Iron Man</i>. After poorly-received first season, which ran for thirteen episodes, the series was revamped in the second season in 1995. The thirteen episode second season featured completely revamped character designs, more complex stories, and a more mature tone.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1994-09-24",
  },
  {
    id: 4241,
    url: "https://www.tvmaze.com/shows/4241/the-incredible-hulk",
    name: "The Incredible Hulk",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50843.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50843.jpg",
    },
    summary:
      "<p>When research scientist Bruce Banner is blasted with a gamma ray bomb during an experiment gone wrong, he develops a dangerous alter ego -- a mean, green monster known as the Incredible Hulk -- who emerges when he gets angry.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 70,
      name: "UPN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-09-08",
  },
  {
    id: 4242,
    url: "https://www.tvmaze.com/shows/4242/rollator-banden",
    name: "Rollator Banden",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50847.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50847.jpg",
    },
    summary: "",
    officialSite:
      "https://www.facebook.com/Rollatorbanden-158705034178650/timeline/",
    webChannel: null,
    language: "Danish",
    status: "Ended",
    network: {
      id: 246,
      name: "Kanal 5",
      country: { name: "Denmark", code: "DK", timezone: "Europe/Copenhagen" },
    },
    premiered: "2011-02-28",
  },
  {
    id: 4243,
    url: "https://www.tvmaze.com/shows/4243/iron-man",
    name: "Iron Man",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50854.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50854.jpg",
    },
    summary:
      "<p><b>Iron Man</b>, also known as <i>Iron Man: The Animated Series</i>, is an American animated television series based on Marvel Comics' superhero Iron Man. The series aired from 1994 to 1996 in syndication as part of The Marvel Action Hour, which packaged Iron Man with another animated series based on Marvel properties, the Fantastic Four, with one half-hour episode from each series airing back-to-back. The show was backed by a toy line that featured many armor variants.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1994-09-24",
  },
  {
    id: 4244,
    url: "https://www.tvmaze.com/shows/4244/silver-surfer",
    name: "Silver Surfer",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50857.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50857.jpg",
    },
    summary:
      "<p>The adventures of the cosmic wanderer as he seeks his lost home after rebelling from his master.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1457,
      name: "Fox Kids",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-02-07",
  },
  {
    id: 4245,
    url: "https://www.tvmaze.com/shows/4245/fantastic-four-worlds-greatest-heroes",
    name: "Fantastic Four: Worlds Greatest Heroes",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50858.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50858.jpg",
    },
    summary:
      "<p>The Fantastic Four return yet again in a new cartoon series. As before, exposure to cosmic rays turn four normal people into super-powered heroes. Reed Richards, scientist extraordinaire, becomes the stretchable Mr. Fantastic. Susan Storm becomes Invisible Woman, Johnny Storm transforms into the Human Torch, and Ben Grimm becomes the Thing.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-09-02",
  },
  {
    id: 4246,
    url: "https://www.tvmaze.com/shows/4246/yu-yu-hakusho-ghost-files",
    name: "Yu Yu Hakusho: Ghost Files",
    genres: ["Comedy", "Action", "Anime", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50863.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50863.jpg",
    },
    summary:
      "<p>From cutting classes to brawling in the streets, Yusuke Urameshi is not your typical role model. In fact, this kid's nothing more than a fourteen-year-old delinquent with a talent for trouble. But in a single selfless act Yusuke dies while saving another. For such noble sacrifice he is given a second chance at life, but it's to be a life far different than the one left behind. Now a Spirit Detective, the young man must track down demons and humans alike who desire to rule over the three realms of reality.<br><br>Granted with amazing new powers to be used in the cause of good versus evil, Yusuke sets out on his first assignment. He will gather together those who will fight alongside him: Kuwabara, Yusuke's intellectually challenged formal rival from high school; Kurama, an infamous thief from the Demon World who inhabits a human body; and Hiei, a hot-headed demon skilled with both the sword and the third eye. Together, these four set forth to do battle with monsters, beasts and men.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 131,
      name: "Fuji TV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1992-10-10",
  },
  {
    id: 4247,
    url: "https://www.tvmaze.com/shows/4247/inuyasha",
    name: "InuYasha",
    genres: ["Action", "Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50879.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50879.jpg",
    },
    summary:
      "<p>Based on the Shogakukan award-winning manga of the same name, <b>InuYasha</b> follows Kagome Higurashi, a fifteen-year-old girl whose normal life ends when a demon drags her into a cursed well on the grounds of her family's Shinto shrine. Instead of hitting the bottom of the well, Kagome ends up 500 years in the past during Japan's violent Sengoku period with the demon's true target, a wish-granting jewel called the Shikon Jewel, reborn inside of her.<br /><br /> After a battle with a revived demon accidentally causes the sacred jewel to shatter, Kagome enlists the help of a young hybrid dog-demon/human named Inuyasha to help her collect the shards and prevent them from falling into the wrong hands. Joining Kagome and Inuyasha on their quest are the orphan fox-demon Shippo, the intelligent monk Miroku, and the lethal demon slayer Sango. Together, they must set aside their differences and work together to find the power granting shards spread across feudal Japan and deal with the threats that arise.</p><p>The last season (Season 8) of this show is also called \"<i>Inuyasha: The Final Act</i>\".</p>",
    officialSite:
      "http://www.sunrise-inc.co.jp/yasya/ ; http://www.ytv.co.jp/inuyasha/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 476,
      name: "YTV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2000-10-16",
  },
  {
    id: 4248,
    url: "https://www.tvmaze.com/shows/4248/kenichi-the-mightiest-disciple",
    name: "Kenichi the Mightiest Disciple",
    genres: ["Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50880.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50880.jpg",
    },
    summary:
      "<p>The story focuses on Kenichi Shirahama, an average 16-year-old high school student who has been picked on his whole life. However, on his first day of class, he meets and befriends the mysterious transfer student, Miu Fūrinji. Driven by his desire to become stronger, he follows her to Ryōzanpaku, a dojo housing several masters of diverse martial arts, led by her grandfather Hayato Fūrinji, who is known as the strongest man on Earth. After learning basics from Miu, Kenichi is able to beat a high-ranking member of the school's karate club, and becomes a target for all the delinquents in the school. While initially training to get stronger and protect himself, Kenichi eventually becomes a full-fledged disciple of Ryōzanpaku, working hard to fulfill his oath to protect the ones in need, especially Miu, with whom he falls in love. Subsequently, Kenichi's daily routine is divided between h...</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2006-10-07",
  },
  {
    id: 4249,
    url: "https://www.tvmaze.com/shows/4249/samurai-7",
    name: "Samurai 7",
    genres: ["Drama", "Action", "Adventure", "Anime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50881.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50881.jpg",
    },
    summary:
      "<p>Kanna, a small village, is being persecuted by mechanized samurai called Nobuseri. The Nobuseri return every harvest to seize the village's crops. Faced with starvation, the villagers send out a mission to find and recruit some samurai to defend them. With no pay to offer except rice, and knowing full well that only helpless and eager samurai would even consider accepting such a deal, the villagers can only hope that their saviors will appear before the rice is ready for harvest. Samurai 7 is based on Akira Kurosawa's classic movie, \"The Seven Samurai\" or Shichinin no samurai. The Japanese promo for the series aired on April 15, 2004 and the Japanese preview aired on June 13, 2004.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 157,
      name: "Animax",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2004-06-12",
  },
  {
    id: 4250,
    url: "https://www.tvmaze.com/shows/4250/sam-cat",
    name: "Sam & Cat",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/150/376015.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/150/376015.jpg",
    },
    summary:
      "<p>Prepare to meet the strangest match made in bestie heaven -- <b>Sam &amp; Cat</b>! Sam is loud, independent, and tough as nails, while Cat is sweet as pie and super flighty. But that doesn't stop this unlikely pair from becoming best buds and roomies! Together, they're a power duo with a love for fun and adventure -- it's just too bad that it doesn't come cheap. A booming out-of-home babysitting business quickly becomes the answer to their empty-pocket problems, but also an extra reason for countless wacky adventures to come!</p>",
    officialSite: "http://www.nick.com/sam-and-cat",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-06-08",
  },
  {
    id: 4251,
    url: "https://www.tvmaze.com/shows/4251/rita",
    name: "Rita",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/198/495742.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/198/495742.jpg",
    },
    summary:
      "<p>Independent, outspoken and adored by her students, private school teacher Rita fares less well with adults in this comedy-drama from Denmark.</p>",
    officialSite: "http://programmer.tv2.dk/rita",
    webChannel: null,
    language: "Danish",
    status: "Ended",
    network: {
      id: 322,
      name: "TV2",
      country: { name: "Denmark", code: "DK", timezone: "Europe/Copenhagen" },
    },
    premiered: "2012-02-09",
  },
  {
    id: 4252,
    url: "https://www.tvmaze.com/shows/4252/our-girl",
    name: "Our Girl",
    genres: ["Drama", "War", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/133/334764.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/133/334764.jpg",
    },
    summary:
      "<p>Drama following the extraordinary adventures of female medics in the British Army.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p0260ych",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-09-21",
  },
  {
    id: 4253,
    url: "https://www.tvmaze.com/shows/4253/ninja-scroll",
    name: "Ninja Scroll",
    genres: ["Action", "Adventure", "Anime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50927.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50927.jpg",
    },
    summary:
      "<p>Ten years after his popular feature <b>Ninja Scroll</b> (1993), Yoshiaki Kawajiri returned to the adventures of super-ninja Jubei Kibagami in a broadcast series. A wanderer who can cleave enemies in two with a single sword-stroke, Jubei gets drawn into a ghoulish war while trying to get a peaceful night's sleep. The Hiruko and Kimon ninja clans are fighting over the mysterious Dragon Stone, which confers extraordinary wealth and power. It's somehow linked to Shigure, a woman whom the ninjas call the Light Maiden. With some faltering help from thief Tsubute and Dakuan, an aged but powerful monk, Jubei sets out to deliver the magical Stone to Shigure. What follows is a repetitious gore-fest: Jubei splits, beheads, and skewers an endless array of bizarre-looking demons. At one point, a ship literally floats away on a sea of blood. Despite some simple computer animated effects, <i>Ninja Scroll</i> looks more like a series from the mid-'80s than 2003. The designs of the characters, endless duels, and meandering storyline recall <i>Fist of the North Star</i> and other early, blood-soaked epics.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 158,
      name: "WOWOW",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2003-04-15",
  },
  {
    id: 4254,
    url: "https://www.tvmaze.com/shows/4254/slam-dunk",
    name: "Slam Dunk",
    genres: ["Drama", "Comedy", "Action", "Anime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50928.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50928.jpg",
    },
    summary:
      '<p>Hanamichi Sakuragi, an entering Shohoku high school freshman, holds a record for being rejected by 50 girls during middle school. His nearly 2 meters height and bright red hair causes most students to write him off as a delinquent.</p><p>One day, a girl named Haruko Akagi approaches Hanamichi without any fear. When she asks Hanamichi "do you like basketball?" Hanamichi falls head over heels for the girl of his dreams. Without missing a beat, Hanamichi tells her he loves basketball, and the two head to the gymnasium where Hanamichi learns about the slam dunk. He also learns of Rukawa, one of the country\'s top basketball prospects, also a freshman at Shohoku.</p>',
    officialSite: "http://www.toei-anim.com/slamdunk.html",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 263,
      name: "TV Asahi",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1993-10-16",
  },
  {
    id: 4255,
    url: "https://www.tvmaze.com/shows/4255/canals-the-making-of-a-nation",
    name: "Canals: The Making of a Nation",
    genres: ["Travel", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50929.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50929.jpg",
    },
    summary:
      "<p>Liz McIvor looks at who built the nation's canal network, who funded it, those who worked on it and how they were regenerated following WWII.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b0689qmh",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 51,
      name: "BBC Four",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-09-01",
  },
  {
    id: 4256,
    url: "https://www.tvmaze.com/shows/4256/about-a-girl",
    name: "About a Girl",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50930.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50930.jpg",
    },
    summary:
      "<p>Chronicling the misadventures of college sophomore Amy Ryan, who moves in with four male roommates after she opts out of her disappointing campus dorm.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 814,
      name: "E!",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2007-10-05",
  },
  {
    id: 4257,
    url: "https://www.tvmaze.com/shows/4257/after-youve-gone",
    name: "After You've Gone",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50936.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50936.jpg",
    },
    summary:
      "<p>Family sitcom following the misadventures of the only man in Britain to get divorced and end up with his mother-in-law.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006rgj2",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2007-01-12",
  },
  {
    id: 4258,
    url: "https://www.tvmaze.com/shows/4258/one-of-us",
    name: "One of Us",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/72/180787.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/72/180787.jpg",
    },
    summary:
      "<p>A horrific double murder rocks the lives of two families living side-by-side in isolated rural Scotland. But instead of focusing on the investigation, <b>One of Us</b> explores the fallout for the grieving relatives, and the dark consequences that threaten to shatter their lives.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b07r26py",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2016-08-23",
  },
  {
    id: 4259,
    url: "https://www.tvmaze.com/shows/4259/mr-mrs-smith",
    name: "Mr. & Mrs. Smith",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50942.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50942.jpg",
    },
    summary:
      '<p>A spy known only as Mr. Smith works for a private security organization known as "The Factory". Using covert operatives and the latest technology they gather information on technology, science, and economics in an effort to protect corporate America from espionage. They are also hired out as private security or to help with covert operations like the recovery of stolen Stinger missiles. In the pilot, a rival named Mrs. Smith becomes entangled on a case with Mr. Smith. After losing her job when her mission fails, The Factory hires her and assigns them to work together. Though they often bicker, and know nothing about each other\'s personal lives, including real names, they make a good team.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-09-20",
  },
  {
    id: 4260,
    url: "https://www.tvmaze.com/shows/4260/the-filthy-rich-guide",
    name: "The Filthy Rich Guide",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50944.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50944.jpg",
    },
    summary:
      "<p><b>The Filthy Rich Guide</b> is a fast-paced guide to how the .00001 percent spend their money. From the entrepreneur who ran up a $500,000 bar tab to the junk bond king with 39 bathrooms and the casino owner who's paying to be cryogenically frozen, this series is an inside look at a world where the party never ends, the cash always flows and the toys are the biggest in the world.</p>",
    officialSite: "http://www.cnbcprime.com/filthy-rich-guide/",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 93,
      name: "CNBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-10-08",
  },
  {
    id: 4261,
    url: "https://www.tvmaze.com/shows/4261/zorro",
    name: "Zorro",
    genres: ["Comedy", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/99/249235.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/99/249235.jpg",
    },
    summary:
      "<p><b>Zorro</b> was set in Spanish California, this often-refilmed story chronicles the adventures of Don Diego de la Vega, a young nobleman who lives a double live as El Zorro ('the Fox'), protector of the people of the Pueblo de Los Angeles during the early 1800s. Hiding behind the mannerisms of a bookish fop, Diego keeps his second identity hidden from everyone but his servant, Felipe. Zorro's greatest enemy is always the Alcalde, who personifies the distant Spanish government in Los Angeles. Cantina-owner (and independent woman far ahead of her time) Victoria Escalante provides the love interest.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 354,
      name: "The Family Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1990-01-05",
  },
  {
    id: 4262,
    url: "https://www.tvmaze.com/shows/4262/zorro",
    name: "Zorro",
    genres: ["Comedy", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50956.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50956.jpg",
    },
    summary:
      "<p>In the early nineteenth century, back from Spain, where he was studying, Don Diego de la Vega discovers that Los Angeles is tyrannized by the garrison commander of this small town of Spanish California. The young nobleman decides to fight these abuses of power and takes up arms in the name of <b>Zorro</b> (Spanish for fox), a masked horseman dressed in black. Don Diego is assisted by his faithful mute servant Bernardo, who is in secret, and his black horse, Tornado.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1957-10-10",
  },
  {
    id: 4263,
    url: "https://www.tvmaze.com/shows/4263/belief",
    name: "Belief",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/50979.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/50979.jpg",
    },
    summary:
      '<p>Oprah Winfrey presents <b>Belief</b>, a groundbreaking television event exploring humankind\'s ongoing search to connect with something greater than ourselves. This original series invites viewers to witness some of the world\'s most fascinating spiritual journeys through the eyes of the believers.<br /><br />Journeying to the far reaches of the world, and to places cameras have rarely been, "Belief" searches the origins of diverse faiths and the heart of what really matters. From the epic to the intimate, webbed throughout each hour are stories of people on spiritual journeys, taking them to sacred spaces, including:the largest peaceful gathering in the history of the world as a group of believers seek redemption along the banks of a holy river; a free climber on the side of a mountain who believes there is no greater power than just being present as he climbs without rope; inside the ceremonies of the past as a 21st centurywoman seeks to find a miracle cure using ancient ceremonial treatments; the quiet of the night as a culture seeks to hang on to its 50,000 year-old history by searching the stars for insight to share with future generations; and, a courtroom and prison where a grieving mother must grapple with forgiveness asshe comes face-to-face with her son\'s killer. These stories and others will all lead us to ask: "What do you believe?"</p>',
    officialSite: "http://www.oprah.com/app/belief.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 236,
      name: "Oprah Winfrey Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-18",
  },
  {
    id: 4264,
    url: "https://www.tvmaze.com/shows/4264/why-the-bleep-am-i-still-single",
    name: "Why the BLEEP Am I Still Single?",
    genres: ["Drama", "Romance"],
    image: null,
    summary:
      "<p>With the help of Dr. Pepper Schwartz from Married at First Sight, two people with common dating issues are given 21 days to see if they can break their bad dating habits and find true love on <b>Why the BLEEP Am I Still Single?</b></p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 125,
      name: "FYI,",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-27",
  },
  {
    id: 4265,
    url: "https://www.tvmaze.com/shows/4265/gigi-does-it",
    name: "Gigi Does It",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/30/75927.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/30/75927.jpg",
    },
    summary:
      '<p>IFC is joining Gigi on her new and unexpected lease on life with <b>Gigi Does It</b>, starring David Krumholtz(<i>This Is The End</i>, <i>Numb3rs</i>, <i>10 Things I Hate About You</i>). Gertrude Rotblum, aka "Gigi," just lost her beloved husband Harold, but has gained a new lease on life with the help of her unexpected inheritance and trusty male sidekick played by Ricky Mabe (<i>Goon</i>, <i>Zach &amp; Miri Make A Porno</i>).</p>',
    officialSite: "http://www.ifc.com/shows/gigi-does-it",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 65,
      name: "IFC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-01",
  },
  {
    id: 4266,
    url: "https://www.tvmaze.com/shows/4266/the-inspectors",
    name: "The Inspectors",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/26/67251.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/26/67251.jpg",
    },
    summary:
      "<p><b>The Inspectors</b> is a dramatic series set in Washington, D.C., inspired by compelling real cases handled by the United States Postal Inspection Service. In the series, Preston Wainwright (Bret Green), a determined teen who is thriving after being paralyzed in a car accident, works as an intern for his U.S. Postal Inspector mom, Amanda (Jessica Lundy), helping to solve crimes ranging from Internet scams, identity and mail theft, to consumer fraud.</p><p>The Inspectors strives to educate young people about making the right choices in their daily lives, encourages open communication between teens and parents and includes positive messaging regarding living with disabilities, overcoming challenges, beating the odds and the power of perseverance. Also starring in the series are Terry Serpico, Harrison Knight and Erica-Marie Sanchez. The United States Postal Inspection Service, the nation's oldest federal law enforcement agency, will serve as the show's official programming resource.</p>",
    officialSite: "http://cbsdreamteam.com/the-inspectors/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-03",
  },
  {
    id: 4267,
    url: "https://www.tvmaze.com/shows/4267/circus-boy",
    name: "Circus Boy",
    genres: ["Adventure", "Family", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/235/589370.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/235/589370.jpg",
    },
    summary:
      "<p>Set in the late 1890s, the title of the series refers to a boy named Corky. After his parents, \"The Flying Falcons\", were killed in a trapeze accident, young Corky was adopted by Joey the Clown, and the whole Burke and Walsh Circus family.</p><p>The young boy quickly found a role with the circus as water boy to Bimbo, a baby elephant whom Corky would come to consider his pet. Riding Bimbo's back, Corky dealt with adolescent problems, and helped the show's adults including Joey, owner/promoter Big Tim Champion. and head canvasman Pete, keep the circus successful as the traveling show moved from town to town each week.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1956-09-23",
  },
  {
    id: 4268,
    url: "https://www.tvmaze.com/shows/4268/accel-world",
    name: "Accel World",
    genres: ["Drama", "Anime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51105.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51105.jpg",
    },
    summary:
      "<p>The year is 2046. Haruyuki Arita is a young boy who finds himself on the lowest social rungs of his school. Ashamed of his miserable life, Haruyuki can only cope by indulging in virtual games. But that all changes when Kuroyukihime, the most popular girl in school, introduces him to a mysterious program called Brain Burst and a virtual reality called the <b>Accel World</b>.</p>",
    officialSite: "http://accel-world.net/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 24,
      name: "MBS",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2012-04-06",
  },
  {
    id: 4269,
    url: "https://www.tvmaze.com/shows/4269/free-radio",
    name: "Free Radio",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51109.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51109.jpg",
    },
    summary:
      '<p>What happens when a legendary morning shock-jock abandons his post, leaving the feeble-minded intern in charge? Carnage and mayhem...but funny carnage and mayhem. <b>Free Radio</b> is improvised comedy that chronicles the Cinderella story of one dim-witted intern, Lance (played by Lance Krall) who answers his call to greatness by jumping in to host a popular radio show when the real host defects to satellite radio. What follows is a glorious train wreck of botched celebrity interviews, on-air tantrums and generally lovable buffoonery. The twist? Lance\'s hosting effort is so spectacularly awful, that ratings actually go up. This, of course, forces his frustrated manager, James (played by Brian Huskey) and co-host, Anna, (played by Anna Vocino) to put up with him for the sake of the ratings. The new show, "Moron in the Morning" continues to be a fan favorite. Completely improvised, Free Radio offers a fresh alternative to the typical sitcom, showing just how far real A-List celebrities will go to tolerate a complete moron. In season two, luminaries from "Lost\'s" Dominic Monaghan to actor Hank Azaria and musical artist Akon are subjected to the idiot storm that is Lance and "Moron in the Morning." While runaway celebrity interviews make up the bulk of the show, Free Radio also goes behind the scenes to depict our loveably dim hero\'s struggle to deal with his newfound fame and earn the respect of his co-workers.</p>',
    officialSite: "http://www.vh1.com/shows/free_radio/series.jhtml",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 55,
      name: "VH1",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-02-03",
  },
  {
    id: 4270,
    url: "https://www.tvmaze.com/shows/4270/overlord",
    name: "Overlord",
    genres: ["Action", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51110.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51110.jpg",
    },
    summary:
      "<p>When a popular fantasy MMORPG shuts down its servers, one guild leader, the skeleton mage, Momonga, finds himself transported to a real fantasy world trapped inside the body of his avatar. His guild's fortress has been transported to an unfamiliar world and the inhabiting NPC characters gain sentience and look to Momonga as their supreme ruler–an overlord as it were. With his extensive knowledge of magic and powerful, fanatic minions following his every whim, Momonga continues to roleplay the part of the evil overlord to the extent that domination of this new world is not an entirely unappealing option.</p>",
    officialSite: "http://overlord-anime.com/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 167,
      name: "AT-X",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2015-07-07",
  },
  {
    id: 4271,
    url: "https://www.tvmaze.com/shows/4271/mongrels",
    name: "Mongrels",
    genres: ["Comedy", "Adult"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51111.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51111.jpg",
    },
    summary:
      "<p>Nelson 'the urbane fox' and his anthropomorphic animal friends navigate the urban jungle from their home in the East End in a puppet sitcom for adults.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b010t19z",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-06-22",
  },
  {
    id: 4272,
    url: "https://www.tvmaze.com/shows/4272/pes",
    name: "Пёс",
    genres: ["Comedy", "Action", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51113.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51113.jpg",
    },
    summary:
      '<p>Max once was the best detective in town. But now he is an alcoholic. Because of that Max lost his job at the police, and his wife left him for his best friend.<br />Once his mentor texted him only one word: "Rose", Max finds him with the bullet in the chest and the wounded dog above his body.<br />So, now Max has got vodka-craving, ex-job, ex-wife, ex-best-friend, self-willed dog and the mystery of the murder.<br />Would Max become a good detective again?<br />And who would be the best detective in town, Max or Dog?</p>',
    officialSite: "https://serial.ictv.ua/pes/",
    webChannel: null,
    language: "Russian",
    status: "To Be Determined",
    network: {
      id: 355,
      name: "ICTV",
      country: { name: "Ukraine", code: "UA", timezone: "Europe/Zaporozhye" },
    },
    premiered: "2015-09-01",
  },
  {
    id: 4274,
    url: "https://www.tvmaze.com/shows/4274/clarissa-explains-it-all",
    name: "Clarissa Explains It All",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51116.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51116.jpg",
    },
    summary:
      "<p><b>Clarissa Explains It All</b> focuses on the life of teenage Clarissa and her family, consisting of her annoying know-it-all younger brother, Ferguson, her eccentric health-conscious mother, Janet and her architect father, Marshall.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 27,
      name: "Nickelodeon",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1991-03-01",
  },
  {
    id: 4275,
    url: "https://www.tvmaze.com/shows/4275/the-buccaneers",
    name: "The Buccaneers",
    genres: ["Drama", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51117.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51117.jpg",
    },
    summary:
      "<p>Deemed nouveau riche and shunned by elitist New York society, sisters Nan and Virginia St. George, along with their friends Lizzy Elmsworth and Conchita Closson, try their luck in London. The girls' New World spontaneity and impertinence constitute nothing less than a social invasion of Old World society and they soon find themselves courted by a coterie of fascinated admirers. But as the old and new worlds come to clash, something has to give.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1995-02-05",
  },
  {
    id: 4276,
    url: "https://www.tvmaze.com/shows/4276/janet-king",
    name: "Janet King",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/47/119724.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/47/119724.jpg",
    },
    summary:
      "<p>Created as a spin-off from the 2011 legal drama Crownies. Janet King follows the story of Senior Crown Prosecutor Janet King, tracing her journey in Series 1 in the Department of Public Prosecutions to a Royal Commission into Serious Firearm Crime in Series 2 to the National Crime Commission in Series 3.</p>",
    officialSite: "http://www.abc.net.au/tv/programs/janet-king/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 114,
      name: "ABC",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2014-02-27",
  },
  {
    id: 4277,
    url: "https://www.tvmaze.com/shows/4277/the-business",
    name: "The Business",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51119.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51119.jpg",
    },
    summary:
      "<p>Take a misadventure into indie film-land with this new IFC series, <b>The Business</b>. We first met Vic Morgenstein (Rob deLeeuw) at the Mountain United Film Festival (MUFF) where he picked up Rufus Marquez's (Nicolas Wright) award winning film. Vic, infamous for his soft-core smut DVDs, is now trying to make a reputable name for himself in the indie film industry.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 65,
      name: "IFC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-08-04",
  },
  {
    id: 4278,
    url: "https://www.tvmaze.com/shows/4278/strutter",
    name: "Strutter",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51120.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51120.jpg",
    },
    summary:
      '<p>Mike Strutter presents the filthiest, most obscene and outrageous clips show on TV!! In between clips of stupid people doing stupid things (mocked mercilessly by big Mike) your host flogs his unique wares: his "Strutter Gear" to an unsuspecting viewing public...</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-11-16",
  },
  {
    id: 4279,
    url: "https://www.tvmaze.com/shows/4279/argumental",
    name: "Argumental",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51121.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51121.jpg",
    },
    summary:
      '<p>The hit panel show gets a spring clean with Sean Lock in the hot seat, while "Peep Show" and "That Mitchell and Webb\'s" Robert Webb, and up and coming stand-up Seann Walsh, are the new team captains.</p>',
    officialSite: "http://dave.uktv.co.uk/shows/argumental/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 59,
      name: "Dave",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-10-27",
  },
  {
    id: 4280,
    url: "https://www.tvmaze.com/shows/4280/opposite-sex",
    name: "Opposite Sex",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51125.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51125.jpg",
    },
    summary:
      "<p>A teenager moves to northern California with his newly widowed father, enrolls in Evergreen Academy, and discovers that he is one of only three boys in a previously all-female school.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-07-17",
  },
  {
    id: 4281,
    url: "https://www.tvmaze.com/shows/4281/baddiel-skinner-unplanned",
    name: "Baddiel & Skinner Unplanned",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51129.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51129.jpg",
    },
    summary:
      '<p><b>Baddiel &amp; Skinner Unplanned</b> is a free-form talk show hosted by British comedians/personalities David Baddiel and Frank Skinner. The show features the two hosts sitting on a couch on-stage and responding to questions from the audience - at times rather seriously, but usually with bizarre digressions into satirical comedy. An audience member is chosen as "Secretary" and has the job of keeping a note of the topics covered on a white board. In practice, the personality of the secretary will also prompt many jokes - usually at his or her expense.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2000-05-28",
  },
  {
    id: 4282,
    url: "https://www.tvmaze.com/shows/4282/bionic-six",
    name: "Bionic Six",
    genres: ["Action", "Children", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51131.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51131.jpg",
    },
    summary:
      "<p>In the near future, Professor Sharp, head of the Special Projects Labs (SPL), creates a new form of technology to augment humans through bionics. His first subject was Jack Bennett, a test pilot who secretly acted as Sharp's field agent, Bionic-1. On a family ski vacation in the Himalayas, an alien spacecraft triggers an avalanche that buries the entire family, exposing them to the unusual radiation of a mysterious buried object. Jack frees himself but discovers his family in a comatose state. Theorizing that Jack's bionics protected him from the radiation, Professor Sharp implants bionic technology in the others, awakening them. Afterward, the family operates incognito as a publicly lauded team of adventuring superheroes, the <b>Bionic Six</b>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1987-04-19",
  },
  {
    id: 4283,
    url: "https://www.tvmaze.com/shows/4283/samanka",
    name: "Шаманка",
    genres: ["Drama", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52668.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52668.jpg",
    },
    summary: "",
    officialSite: "http://russia.tv/brand/show/brand_id/59661",
    webChannel: null,
    language: "Russian",
    status: "Ended",
    network: {
      id: 366,
      name: "1-й Балтийский канал",
      country: { name: "Latvia", code: "LV", timezone: "Europe/Riga" },
    },
    premiered: "2015-04-11",
  },
  {
    id: 4284,
    url: "https://www.tvmaze.com/shows/4284/the-dukes-of-hazzard",
    name: "The Dukes of Hazzard",
    genres: ["Comedy", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51133.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51133.jpg",
    },
    summary:
      '<p>Cousins Bo and Luke Duke and their car "General Lee", assisted by Cousin Daisy and Uncle Jesse, have a running battle with the authorities of Hazzard County (Boss Hogg and Sheriff Coltrane), plus a string of ne\'er-do-wells often backed by the scheming Hogg.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1979-01-26",
  },
  {
    id: 4285,
    url: "https://www.tvmaze.com/shows/4285/13-posterunek",
    name: "13 posterunek",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51151.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51151.jpg",
    },
    summary:
      "<p>Clumsy policemen work at a small police station in the outskirts of Warsaw.</p>",
    officialSite: null,
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 273,
      name: "Canal+",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "1997-12-24",
  },
  {
    id: 4286,
    url: "https://www.tvmaze.com/shows/4286/the-new-scooby-doo-movies",
    name: "The New Scooby-Doo Movies",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51150.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51150.jpg",
    },
    summary:
      "<p>In <b>The New Scooby-Doo Movies</b>, Scooby and friends find themselves solving crimes while rubbing elbows with various famous guest stars.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1972-09-09",
  },
  {
    id: 4287,
    url: "https://www.tvmaze.com/shows/4287/39-i-pol",
    name: "39 i pół",
    genres: ["Drama", "Comedy", "Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51160.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51160.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 334,
      name: "TVN",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2008-03-04",
  },
  {
    id: 4288,
    url: "https://www.tvmaze.com/shows/4288/agentki",
    name: "Agentki",
    genres: ["Comedy"],
    image: null,
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 335,
      name: "Polsat",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2008-10-01",
  },
  {
    id: 4289,
    url: "https://www.tvmaze.com/shows/4289/halo-hans",
    name: "Halo Hans!",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51169.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51169.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 335,
      name: "Polsat",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2007-12-01",
  },
  {
    id: 4290,
    url: "https://www.tvmaze.com/shows/4290/hela-w-opalach",
    name: "Hela w opałach",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51280.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51280.jpg",
    },
    summary:
      "<p><b>Hela w opałach</b> (Hela in Trouble), Helen of Troy was divorced. The energetic mother of three unruly - Casper, Nell and Hansel - begins a new life. For starters take a job at the power plant. Despite a failed marriage and numerous problems with the children Hela is optimistic. All the time to help her friends, colleagues and neighbors - Edith and Rysiek.</p>",
    officialSite: null,
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 334,
      name: "TVN",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2006-09-10",
  },
  {
    id: 4291,
    url: "https://www.tvmaze.com/shows/4291/i-kto-tu-rzadzi",
    name: "I kto tu rządzi?",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51174.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51174.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 335,
      name: "Polsat",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2007-04-05",
  },
  {
    id: 4292,
    url: "https://www.tvmaze.com/shows/4292/game-on",
    name: "Game On!",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51175.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51175.jpg",
    },
    summary:
      "<p>Comedy series about three flatmates who, despite being young, bright and sexy, just don't seem to be enjoying themselves.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00qg5lj",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1995-02-27",
  },
  {
    id: 4293,
    url: "https://www.tvmaze.com/shows/4293/emerald-city",
    name: "Emerald City",
    genres: ["Drama", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/92/230428.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/92/230428.jpg",
    },
    summary:
      "<p>Swept up into the eye of a tornado, 20-year-old Dorothy Gale is transported to another world - a mystical land where an all-powerful ruler governs over one kingdom, has outlawed magic, and faces not only the wrath of a growing cauldron of witches but a looming disaster brought on by a mythical force. Epic, romantic and fantastical, <b>Emerald City</b> is an empowering tale of a young woman finding her true strength and identity even as she battles to bring a divided world together.</p>",
    officialSite: "http://www.nbc.com/emerald-city",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2017-01-06",
  },
  {
    id: 4294,
    url: "https://www.tvmaze.com/shows/4294/mammon",
    name: "Mammon",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51180.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51180.jpg",
    },
    summary:
      "<p><b>Mammon</b> is a thriller series in the spirit of \"All the Presidents men\". However, in this story not all journalists are good, and the hunt for truth far more personal. Peter Verås is an uncompromising journalist in the most respected newspaper in Norway. He makes his life's biggest mistake when he gets hold of evidence of a financial fraud from an anonymous source. It turns out the evidence points to his own brother. As he still pursues and the story breaks, the brother commits suicide. Peter tries to track down the anonymous source, only to discover that the source was the brother himself. A search for the truth has commenced that involves media, high – ranked politicians as well as the financial elite. The closer he gets to the truth, the more dangerous it becomes for him and his brother's family.</p>",
    officialSite: "https://tv.nrk.no/serie/mammon",
    webChannel: null,
    language: "Norwegian",
    status: "Ended",
    network: {
      id: 91,
      name: "NRK1",
      country: { name: "Norway", code: "NO", timezone: "Europe/Oslo" },
    },
    premiered: "2014-01-01",
  },
  {
    id: 4295,
    url: "https://www.tvmaze.com/shows/4295/ducktales",
    name: "DuckTales",
    genres: ["Adventure", "Children", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/62/156739.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/62/156739.jpg",
    },
    summary:
      "<p>When Donald Duck decides to join the Navy, he leaves his nephews, Huey, Dewey and Louie, in the care of his cantankerous Uncle Scrooge. He is an eccentric and miserly billionare who loves to literally swim in his money that is held in his corporate headquarters/vault known as the Money Bin. While the initial meeting was less than pleasant, events soon have them, along with a newly hired nanny, her daughter and Scrooge's stupid but skilled pilot, on countless adventures as the group goes around the world looking for treasure, or defending Scrooge's current assets from enemies like the Beagle Boys or Magica De Spell.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 78,
      name: "Disney Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1987-09-18",
  },
  {
    id: 4296,
    url: "https://www.tvmaze.com/shows/4296/the-tom-and-jerry-show",
    name: "The Tom and Jerry Show",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51195.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51195.jpg",
    },
    summary:
      "<p>The famous cat and mouse duo is back in an all-new series, <b>The Tom and Jerry Show</b>. Premiering Wednesday April 9 at 5:30 p.m. (ET/PT) on Cartoon Network, The Tom and Jerry Show is a fresh take on the iconic frenemies that preserves the look, core characters and sensibilities of the original theatrical shorts. Comprised of two 11-minute elements, each episode will feature Tom the cat and Jerry the mouse plotting against each other-with Tom's determination matched only by Jerry's own cleverness in evading capture. But this time the cartoon mayhem will not be limited to only Tom and Jerry's familiar suburban setting. In The Tom and Jerry Show, the title characters' nonstop game of cat and mouse will expand to also include more fantastic worlds, from a witch's cabin to a mad scientist's lab.</p>",
    officialSite: "http://www.cartoonnetwork.com/video/tomjerry/episodes/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-04-09",
  },
  {
    id: 4297,
    url: "https://www.tvmaze.com/shows/4297/fullmetal-alchemist",
    name: "Fullmetal Alchemist",
    genres: ["Action", "Adventure", "Anime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51196.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51196.jpg",
    },
    summary:
      "<p>Edward Elric, a young, brilliant alchemist, has lost much in his twelve-year life: when he and his brother Alphonse try to resurrect their dead mother through the forbidden act of human transmutation, Edward loses his family as well as two of his limbs. With his supreme alchemy skills, Edward binds Alphonse's soul to a large suit of armor.<br><br>A year later, Edward, now promoted to the fullmetal alchemist of the state, embarks on a journey with his younger brother to obtain the Philosopher's Stone. The fabled mythical object is rumored to be capable of amplifying an alchemist's abilities by leaps and bounds, thus allowing them to override the fundamental law of alchemy: to gain something, an alchemist must sacrifice something of equal value. Edward hopes to draw into the military's resources to find the fabled stone with his power and restore his and Alphonse's bodies to normal. However, the Elric brothers soon discover that there is more to the legendary stone than meets the eye, as they are led to the epicenter of a far darker battle than they could have ever imagined.</p><p>(Source: MyAnimeList)</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 157,
      name: "Animax",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2003-10-04",
  },
  {
    id: 4298,
    url: "https://www.tvmaze.com/shows/4298/cuffs",
    name: "Cuffs",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/162/406477.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/162/406477.jpg",
    },
    summary:
      "<p><b>Cuffs</b> is a fresh, authentic and visceral drama that will take the audience on an exhilarating ride through the challenges of front-line policing. Adrenalized and vibrant, the show is packed full of dramatic incidents and colourful characters. From a booby trapped cannabis farm in a suburban semi to an elderly farmer's wife with a shotgun, the stories are surprising and exciting. There will be more absurd altercations - such as a middle-class dog-napping or fisticuffs between pensioners - as well as the daily grind of speeding drivers, city-centre shoplifters and Saturday night drinkers.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b06ncgm7",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-10-28",
  },
  {
    id: 4299,
    url: "https://www.tvmaze.com/shows/4299/the-real-ghostbusters",
    name: "The Real Ghostbusters",
    genres: ["Action", "Adventure", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51197.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51197.jpg",
    },
    summary:
      "<p><b>The Real Ghostbusters</b> continues where the first movie left off, with the four Ghostbusters facing forces of the supernatural. Helping out the Ghostbusters would be their secretary, Janine Melnitz, and (eventually) Louis Tully. Also joining in would be the green ghost busted at the Sedgewick Hotel in the first movie, which was given the name Slimer.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1986-09-13",
  },
  {
    id: 4300,
    url: "https://www.tvmaze.com/shows/4300/age-of-love",
    name: "Age of Love",
    genres: ["Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755447.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755447.jpg",
    },
    summary:
      '<p>30-year-old Australian tennis superstar Mark Philippoussis attempts to find true love among women ranging in age from 21-48 in this unique series based on the current phenomenon of younger men dating older women. Philippoussis begins to date 13 women from two very different groups -- the "Kittens," six fun, enthusiastic women in their 20\'s, and the "Cougars," seven beautiful, sophisticated women in their 40\'s. Initially unaware of the show\'s concept, Mark is first introduced to the women in their 40s on top of a high-rise in downtown Los Angeles where they will all live together. As he meets them one by one, their ages increase much to his surprise. After a beautiful fireside evening with the women, Mark must eliminate one woman. Later, he (along with the unsuspecting 40-year-old women) learns theres a second group of much younger women -- the "Kittens" -- the group of 20-year-olds who will also be attempting to vie for his affections.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-06-18",
  },
  {
    id: 4301,
    url: "https://www.tvmaze.com/shows/4301/super-mario-world",
    name: "Super Mario World",
    genres: ["Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51204.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51204.jpg",
    },
    summary:
      "<p>Mario, Luigi, Yoshi and Princess Toadstool are on Dinosaur Island foiling the plans of King Koopa and his Koopa kids.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1991-09-14",
  },
  {
    id: 4302,
    url: "https://www.tvmaze.com/shows/4302/fight-kickers",
    name: "Fight Kickers",
    genres: ["Anime", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51205.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51205.jpg",
    },
    summary:
      "<p>The Kickers are first and foremost a football team. Actually, they're only playing for their school, but haven't exactly covered themselves with glory. When the new player, Gregor (Daichi Kakeru) arrives at the school, they just had faced a resounding defeat again. However, thanks to Gregor, things are going to change. Highly motivated, they'll try to get rid of their \"always-loser-team\" image. Their strongest enemy are the Devils, who Gregor provokes right from the start. However, it's not all about football. When the captain, Mario (Hongou Masaru), is not pursued by his female fans, the Kickers often hang around and do stuff together.</p><p>(Source: AniDB)</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 137,
      name: "NTV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1986-10-15",
  },
  {
    id: 4303,
    url: "https://www.tvmaze.com/shows/4303/perfect-couples",
    name: "Perfect Couples",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51210.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51210.jpg",
    },
    summary:
      "<p><b>Perfect Couples</b> is a romantic comedy that follows three flawed pairs trying to get it right.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-12-20",
  },
  {
    id: 4304,
    url: "https://www.tvmaze.com/shows/4304/perfect-strangers",
    name: "Perfect Strangers",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51218.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51218.jpg",
    },
    summary:
      "<p><b>Perfect Strangers</b> follows Balki Bartokomous, a humble sheep herder from a generic Mediterranean country called Mypos, who moves to Chicago to live with his American cousin, Larry Appleton.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1986-03-25",
  },
  {
    id: 4305,
    url: "https://www.tvmaze.com/shows/4305/personal-affairs",
    name: "Personal Affairs",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51221.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51221.jpg",
    },
    summary:
      "<p>Off-beat, fast-paced, funny, sexy and candid depiction of office life, following the fortunes of four personal assistants in the City of London.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00l9rmv",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-06-21",
  },
  {
    id: 4306,
    url: "https://www.tvmaze.com/shows/4306/trigun",
    name: "Trigun",
    genres: ["Action", "Adventure", "Anime", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51222.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51222.jpg",
    },
    summary:
      "<p>Vash the Stampede is the most infamous outlaw on the planet Gunsmoke and with a 60 billion double dollar price on his head the most sought after!</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1998-04-01",
  },
  {
    id: 4307,
    url: "https://www.tvmaze.com/shows/4307/jay-lenos-garage",
    name: "Jay Leno's Garage",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/120/301492.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/120/301492.jpg",
    },
    summary:
      "<p>Hosted by legendary comedian and \"Tonight Show\" host Jay Leno, the series explores our obsession with all things automotive. From classic cars to supercars and everything in-between, Jay is hitting the road to discover the most exciting, weird and wonderful vehicles ever made and meet the passionate people behind their wheels. Each one-hour themed episode features a mix of stunts, challenges, reviews, and celebrity interviews that showcases the colorful history of the automobile. Whether he's exploring the story of an iconic brand, road-testing the newest super car, or investigating the latest automotive innovations, there is no wheel Jay won't get behind to tell the story of our love affair with the car.</p>",
    officialSite: "https://www.cnbc.com/jay-lenos-garage/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 93,
      name: "CNBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-07",
  },
  {
    id: 4308,
    url: "https://www.tvmaze.com/shows/4308/romans-empire",
    name: "Roman's Empire",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51228.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51228.jpg",
    },
    summary: "<p>Comedy series about self-made millionaire Roman Pretty.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00732xh",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2007-04-12",
  },
  {
    id: 4309,
    url: "https://www.tvmaze.com/shows/4309/romantically-challenged",
    name: "Romantically Challenged",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51230.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51230.jpg",
    },
    summary:
      "<p>Smart and beautiful Rebecca is recently divorced after 15 years of marriage. Having never really dated before she was married - and not having been on a date since Clinton was in office -- she finds it scary to start over now. Although a gifted mom and lawyer, she is clueless about dating and hopes to get some help from her equally romantically challenged friends. Perry is Rebecca's best friend since childhood. He is a rugged man's man and a tremendously successful financial planner -- but also one of Pittsburgh's most sensitive hopeless romantics. When it comes to matters of the heart, Perry is a romance-aholic who falls in love with women 20 minutes after meeting them. After 40 minutes, he's already naming their future children. A struggling novelist, the witty and affable Shawn has been Perry's best friend and rent-free roommate for six years. Shawn is the emotionally unavailable cynic to Perry's hopeless romantic. He has never had a relationship more serious than a three-night stand - and even those send him running for the door. Rounding out the group is Rebecca's petite, baby sister, Lisa. Behind her deceptively sweet appearance is a sassy pit bull ready to protect her older sister. Although a nurturing kindergarten teacher, she has a wild side too, and sees a \"threesome\" as \"second base.\" Will these four romantically challenged friends ever find lasting love? Or even someone who lasts until next Thursday?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-04-19",
  },
  {
    id: 4310,
    url: "https://www.tvmaze.com/shows/4310/great-wild-north",
    name: "Great Wild North",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/25/64075.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/25/64075.jpg",
    },
    summary:
      "<p>In the frozen wilderness that borders Alaska and the Yukon, a group of brave souls pursue an ancient and dangerous way of life. For these men, women and their families, winter trapping is not only a deep passion–it's their job. And they risk their lives to do it. In temperatures that reach 40 below—where skin freezes, snowmobiles break down, daylight fades fast, thin ice looms and predators are a constant threat—one wrong move can cost you everything. Centuries ago, trapping and fur trading played a vital role in the expansion of North America's western frontier. Today, these fearless men and women are trying to uphold that legacy, living on the land and off the grid. At peace in the great outdoors, they trap during the legally sanctioned season which, in Alaska and the Yukon, runs just four months in the dead of winter. Deep in the bush, the pressure is on to get iron in the ground and catch fur. They must also navigate the inhospitable terrain on the trap line, which features deadly half-frozen rivers, brutal wind storms, and wolf packs. Miles from the nearest town, help is never close by.</p><p>But these diehards are undeterred. They've spent their life mastering the skills needed to survive and carve out a living in one of the most hostile places on earth. And they will protect their way of life at any cost. Welcome to the <b>Great Wild North</b>.</p>",
    officialSite:
      "http://www.history.com/shows/great-wild-north/videos/great-wild-north-preview",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-22",
  },
  {
    id: 4311,
    url: "https://www.tvmaze.com/shows/4311/ruby-the-rockits",
    name: "Ruby & The Rockits",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51235.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51235.jpg",
    },
    summary:
      "<p><b>Ruby &amp; The Rockits</b> follows Patrick Gallagher, a former teen idol who has chosen to lead a quiet life with his wife and two sons. But when his former Rockits band mate and brother, David, shows up unexpectedly with his new-found teenage daughter in tow, the Gallagher family's life becomes anything but normal. David, who refuses to give up his past glory days, comes to Patrick for help in raising Ruby while he continues to perform. Patrick must now put the past with David behind them in order to help raise Ruby and keep order within the rest of the Gallagher clan.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-07-21",
  },
  {
    id: 4312,
    url: "https://www.tvmaze.com/shows/4312/investigating-history",
    name: "Investigating History",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51237.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51237.jpg",
    },
    summary:
      "<p>Using the latest techniques of forensic science, investigators re-explore some of the legendary figures and events of history in order to determine how much of what has come down to us is a true account. There is no editor for this show. If you would like to be the editor look here for details.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-04-19",
  },
  {
    id: 4313,
    url: "https://www.tvmaze.com/shows/4313/voroniny",
    name: "Воронины",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/217/543741.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/217/543741.jpg",
    },
    summary: null,
    officialSite: "http://ctc.ru/projects/serials/voroniny/",
    webChannel: null,
    language: "Russian",
    status: "Ended",
    network: {
      id: 304,
      name: "СТС",
      country: {
        name: "Russian Federation",
        code: "RU",
        timezone: "Asia/Kamchatka",
      },
    },
    premiered: "2009-11-16",
  },
  {
    id: 4314,
    url: "https://www.tvmaze.com/shows/4314/molodezka",
    name: "Молодёжка",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51278.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51278.jpg",
    },
    summary:
      "<p><i><b>Molodezhka</b></i> is a Russian TV series which airs on STS. The series tells the story of a junior hockey club named The Bears.</p>",
    officialSite: "http://ctc.ru/projects/serials/molodezhka/",
    webChannel: null,
    language: "Russian",
    status: "Ended",
    network: {
      id: 304,
      name: "СТС",
      country: {
        name: "Russian Federation",
        code: "RU",
        timezone: "Asia/Kamchatka",
      },
    },
    premiered: "2013-10-07",
  },
  {
    id: 4315,
    url: "https://www.tvmaze.com/shows/4315/poslednij-iz-magikan",
    name: "Последний из Магикян",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51249.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51249.jpg",
    },
    summary: null,
    officialSite: "http://ctc.ru/projects/serials/posledniy-iz-magikyan/",
    webChannel: null,
    language: "Russian",
    status: "Ended",
    network: {
      id: 304,
      name: "СТС",
      country: {
        name: "Russian Federation",
        code: "RU",
        timezone: "Asia/Kamchatka",
      },
    },
    premiered: "2013-09-16",
  },
  {
    id: 4316,
    url: "https://www.tvmaze.com/shows/4316/chicken-soup-for-the-souls-hidden-heroes",
    name: "Chicken Soup for the Soul's Hidden Heroes",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/26/67260.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/26/67260.jpg",
    },
    summary:
      "<p><b>Hidden Heroes</b>, hosted by Brooke Burke-Charvet, is a hidden camera television show developed for teens in which each episode reveals the widespread goodwill in our world by secretly capturing heroes in action as they demonstrate acts of kindness, compassion and commitment to others. Highlighted by funny, light-hearted moments, the show shines a bright light on everyday people who selflessly share their positive attitudes towards society and life with others by doing good deeds.</p>",
    officialSite:
      "http://cbsdreamteam.com/chicken-soup-for-the-souls-hidden-heroes/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-03",
  },
  {
    id: 4317,
    url: "https://www.tvmaze.com/shows/4317/samurai-girl",
    name: "Samurai Girl",
    genres: ["Drama", "Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51263.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51263.jpg",
    },
    summary:
      "<p>A nineteen-year-old girl called Heaven discovers that the well-to-do businessman who adopted her as an infant is actually the head of Yakuza, the Japanese mafia responsible for murdering her brother. Upon leaving her family Heaven decides to become a samurai with the help of her new American friends, and grows determined to take down her father's empire. This series is based on the popular novels for young people. </p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-09-05",
  },
  {
    id: 4318,
    url: "https://www.tvmaze.com/shows/4318/baki-the-grappler",
    name: "Baki the Grappler",
    genres: ["Action", "Adventure", "Anime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51270.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51270.jpg",
    },
    summary:
      "<p>The 24 episode anime aired in Japan between January 8, 2001 and June 25, 2001. A second 24 episode series called Grappler Baki Maximum Tournament aired from July 22, 2001 to December 24, 2001. The story revolves around Baki Hanma and his quest to proclaim himself as the strongest grappler in the world, thus taking the title from his father. Baki also fights to gain the trust of his overly psychotic mother. The anime was licensed and distributed by FUNimation Entertainment in the US. The OVA was released by Manga Entertainment in Australia and the UK and previously released by Central Park Media in the US. Gutsoon! Entertainment released the first 46 chapters of the original manga in English in the pages of Raijin Comics, their anthology magazine.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2001-01-09",
  },
  {
    id: 4319,
    url: "https://www.tvmaze.com/shows/4319/bbq-blitz",
    name: "BBQ Blitz",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/81/202833.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/81/202833.jpg",
    },
    summary:
      "<p>Game on! Food Network Star winner and former NFL player Eddie Jackson is taking a barbecue battle on the road in <b>BBQ Blitz</b>. In each city, three of the best grillers, smokers, and fire-roasters will cook off for a chance to win $5,000 and the title of best barbecue chef.</p>",
    officialSite: "http://www.foodnetwork.com/shows/bbq-blitz.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 81,
      name: "Food Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-09",
  },
  {
    id: 4320,
    url: "https://www.tvmaze.com/shows/4320/they-took-our-child-we-got-her-back",
    name: "They Took Our Child: We Got Her Back",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/34/86628.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/34/86628.jpg",
    },
    summary:
      "<p>LMN presents <b>They Took Our Child: We Got Her Back</b>, a new original series that reveals the stories of abducted children who escaped from the hands of their kidnappers; and the families who never gave up hope on getting them home safely. Every day in America, over 1200 children are reported missing. Most are taken by a family member but for those few taken by strangers, if they are not found within the first 24 hours, the odds of them returning back alive are daunting. In the new LMN series, <i>They Took Our Child: We Got Her Back</i>, stories of children who were kidnapped by strangers, and who beat the odds and returned safely home are told.</p><p>Each episode features a single story, told by the formerly kidnapped child and the family members and investigators who tirelessly searched for them. Viewers will hear about the parents' frantic and relentless search for their child, and how they worked with law enforcement to bring them home. Through first-hand accounts, archival materials and true-to-life recreations, viewers will learn how the child was safely returned and how the perpetrator was captured. Episodes culminate with an emotional present day reunion between the adult child and the key person who helped save them from their kidnapper.</p>",
    officialSite:
      "http://www.mylifetime.com/movies/they-took-our-child-we-got-her-back",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 232,
      name: "Lifetime Movies",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-07",
  },
  {
    id: 4323,
    url: "https://www.tvmaze.com/shows/4323/ugly-americans",
    name: "Ugly Americans",
    genres: ["Comedy", "Fantasy", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51315.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51315.jpg",
    },
    summary:
      '<p><b>Ugly Americans</b> is an animated horror-comedy series that follows Mark Lilly, social worker at the Department of Integration, as he helps human and "other" citizens adapt to life in the Big Apple. There are vampires, land-whales, werewolves, a demon ex-girlfriend and a zombie roommate to contend with, but Mark\'s up to the challenge.</p>',
    officialSite: "http://www.cc.com/shows/ugly-americans",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-03-17",
  },
  {
    id: 4324,
    url: "https://www.tvmaze.com/shows/4324/airshow",
    name: "Airshow",
    genres: ["Drama", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/114/285518.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/114/285518.jpg",
    },
    summary:
      "<p>Filmed during the 2013 and 2014 seasons, crashes, mechanical problems, and tornadic weather hamper the pilots' and performers' ability to take to the sky.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 298,
      name: "Discovery Channel",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2015-01-26",
  },
  {
    id: 4326,
    url: "https://www.tvmaze.com/shows/4326/welcome-to-the-captain",
    name: "Welcome to the Captain",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51335.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51335.jpg",
    },
    summary:
      '<p>This single-camera comedy follows the life of Josh, a writer, and how his life changes after he moves into an old Hollywood apartment building. "The Captain" is the building and it is home to a number of eccentric washed up actors and "Hollywood folk".</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-02-04",
  },
  {
    id: 4327,
    url: "https://www.tvmaze.com/shows/4327/the-call-centre",
    name: "The Call Centre",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51384.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51384.jpg",
    },
    summary:
      "<p>Fly-on-the wall documentary series following the ups and downs of Swansea call centre CEO Nev Wilshire and his staff of extraordinary characters.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b03mtjjh",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-06-04",
  },
  {
    id: 4328,
    url: "https://www.tvmaze.com/shows/4328/klan-uvelirov",
    name: "Клан ювелиров",
    genres: ["Drama", "Crime", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51467.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51467.jpg",
    },
    summary:
      "<p>In the world of big money, lie and intrigue a danger threatens anyone who dares against the rules of the game. <br>Lovers Zoe and Timur fall into the epicenter of the confrontation between two warring jewelry clans. They will look into the face of death and fight the destiny for their right for happiness.</p>",
    officialSite: "http://yuvelir.kanalukraina.tv/ru",
    webChannel: null,
    language: "Russian",
    status: "Ended",
    network: {
      id: 365,
      name: "Україна",
      country: { name: "Ukraine", code: "UA", timezone: "Europe/Zaporozhye" },
    },
    premiered: "2015-08-17",
  },
  {
    id: 4329,
    url: "https://www.tvmaze.com/shows/4329/death-valley",
    name: "Death Valley",
    genres: ["Comedy", "Crime", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51388.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51388.jpg",
    },
    summary:
      "<p>MTV's horror-comedy <b>Death Valley</b> is a scripted series that follows the 'Undead Task Force' (UTF), a newly formed division of the LAPD, documentary-style, as they capture the monsters that roam the streets of California's San Fernando Valley. In a world where vampires, werewolves and zombies live freely, \"Death Valley\" is a fun, comedic non-stop thrill ride featuring chases, hardcore kills and bizarre encounters.</p>",
    officialSite: "http://www.mtv.com/shows/death_valley/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-08-29",
  },
  {
    id: 4330,
    url: "https://www.tvmaze.com/shows/4330/crownies",
    name: "Crownies",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51398.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51398.jpg",
    },
    summary:
      "<p><b>CROWNIES</b> follows five young solicitors as they face the pressures and endearing madness of modern single life - in a fast paced workplace that highlights the moral dilemmas and big issues facing an apparently civilized society.</p><p>In a world that exists solely to see ‘wrong-doers' brought to justice, and where the average age of the solicitors is 27, there is a big divide between these young solicitors and the barristers at the top. Yet they are the initial point of contact with the police, and it is they who do most of the liaising with the victims and the witnesses - and recommend what goes to court.</p><p>They are committed, idealistic and hard-working, but their lives away from the office are filled with aspirations, explorations, fragile relationships and partying.</p>",
    officialSite: "http://www.abc.net.au/tv/crownies/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 114,
      name: "ABC",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2011-07-14",
  },
  {
    id: 4331,
    url: "https://www.tvmaze.com/shows/4331/posh-pawn",
    name: "Posh Pawn",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51405.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51405.jpg",
    },
    summary:
      "<p>From helicopters to Lamborghinis, mini-submarines and Hermes handbags, <b>Posh Pawn</b> uncovers the hidden world of high-end pawnbroking.</p>",
    officialSite: "http://www.channel4.com/programmes/posh-pawn",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-04-17",
  },
  {
    id: 4332,
    url: "https://www.tvmaze.com/shows/4332/100-days-of-summer",
    name: "100 Days of Summer",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51406.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51406.jpg",
    },
    summary:
      "<p><b>100 Days of Summer </b>chronicles a group of young, successful and driven Chicagoans as they navigate the ups and downs of their personal, professional, and social lives in the Windy City over one intense summer.</p><p>Hooked into Chi-Town's hottest industries, these nightlife impresarios, fashionistas, real estate moguls and entrepreneurs include Vincent Anzalone, Ray Austin, Tara Clack, Phillips Demming, Jay Michael and Pascale Wellin. They all work hard in business, play hard in life and attempt to navigate the sometimes murky waters that fall in between. In desperate need of relief from Chicago's long-lasting winters, these go-getters only have a scant 100 days to accomplish the lofty personal and professional goals they set for themselves. Some will succeed and some will fail, but they all will be changed forever.</p>",
    officialSite: "http://www.bravotv.com/100-days-of-summer",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 52,
      name: "Bravo",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-07",
  },
  {
    id: 4333,
    url: "https://www.tvmaze.com/shows/4333/count-arthur-strong",
    name: "Count Arthur Strong",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/124/311557.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/124/311557.jpg",
    },
    summary:
      "<p>The world of ex-variety star Count Arthur Strong is livened up by the arrival of Michael, the son of his old comedy partner.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b04xwh7r",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-07-08",
  },
  {
    id: 4334,
    url: "https://www.tvmaze.com/shows/4334/comic-relief",
    name: "Comic Relief",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/299/749924.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/299/749924.jpg",
    },
    summary:
      "<p><b>Comic Relief</b> is an operating British charity, founded in 1985 by the comedy scriptwriter Richard Curtis and comedian Lenny Henry in response to famine in Ethiopia. The highlight of Comic Relief's appeal is Red Nose Day, a biennial telethon held in March, alternating with sister project Sport Relief.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006zrvr",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1986-04-25",
  },
  {
    id: 4335,
    url: "https://www.tvmaze.com/shows/4335/good-cop",
    name: "Good Cop",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51424.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51424.jpg",
    },
    summary:
      "<p>A dutiful Liverpool beat cop discovers what he is truly capable of after his partner is brutally murdered in a targeted attack by a local gang.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p00szy7c",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-08-30",
  },
  {
    id: 4336,
    url: "https://www.tvmaze.com/shows/4336/drifters",
    name: "Drifters",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51430.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51430.jpg",
    },
    summary:
      "<p>Comedy series about life after university, focusing on three female friends.</p>",
    officialSite: "http://www.channel4.com/programmes/drifters",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 41,
      name: "E4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-10-31",
  },
  {
    id: 4337,
    url: "https://www.tvmaze.com/shows/4337/chozen",
    name: "Chozen",
    genres: ["Comedy", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51434.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51434.jpg",
    },
    summary:
      '<p>Chozen is an animated comedy about its title character, "Chozen," a gay white rapper fresh out of prison. Armed with a new message, Chozen is on a quest for redemption and to claim his rightful position as the world\'s top rap artist. His music and lyrics take aim at the stereotypes of machismo and misogyny that is synonymous with rap music. And his new world view has been shaped by his time in prison.</p>',
    officialSite: "http://www.fxnetworks.com/chozen",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-01-13",
  },
  {
    id: 4338,
    url: "https://www.tvmaze.com/shows/4338/east-los-high",
    name: "East Los High",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/140/350852.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/140/350852.jpg",
    },
    summary:
      '<p><b>East Los High</b> is an English-language Hulu Original Series that deals with the experiences of teens navigating life in a fictional inner city high school in East Los Angeles, CA. At the center of the series are the underrepresented voices of young Latinos living in the U.S. whose characters take on the challenges and joys of teen drama with sexy, humorous, suspenseful and transformative storylines. Perceived as a "game changer" by industry insiders,<i>East Los High</i> was the first English-language show with an all-Latino cast, creators, and writers. The series is not only addictive with its unique storytelling format but thought-provoking on a social level. Currently in its third season, <i>East Los High</i> continues to garner critical acclaim.</p>',
    officialSite: "http://eastloshigh.com/",
    webChannel: {
      id: 2,
      name: "Hulu",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2013-06-03",
  },
  {
    id: 4339,
    url: "https://www.tvmaze.com/shows/4339/bad-robots",
    name: "Bad Robots",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51442.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51442.jpg",
    },
    summary:
      "<p>Hidden camera show in which technology acts up, much to the bemusement of unsuspecting members of the public.</p>",
    officialSite: "http://www.channel4.com/programmes/bad-robots/episode-guide",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 41,
      name: "E4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-11-11",
  },
  {
    id: 4340,
    url: "https://www.tvmaze.com/shows/4340/get-smart",
    name: "Get Smart",
    genres: ["Comedy", "Science-Fiction", "Espionage"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51443.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51443.jpg",
    },
    summary:
      "<p>In 1965 the cold war was made a little warmer and a lot funnier due in part to the efforts of an inept, underpaid, overzealous spy: Maxwell Smart, Agent 86. The hit comedy series <b>Get Smart</b> is the creation of comic geniuses Buck Henry and Mel Brooks.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1965-09-18",
  },
  {
    id: 4341,
    url: "https://www.tvmaze.com/shows/4341/bodyshockers",
    name: "Bodyshockers",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51447.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51447.jpg",
    },
    summary:
      "<p>From tattoos to piercings and big boobs, Katie Piper meets people planning major body modifications, and people who've already had them and regret it. Can they persuade the newbies to think again?</p>",
    officialSite:
      "http://www.channel4.com/programmes/bodyshockers-nips-tucks-and-tattoos",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-01-30",
  },
  {
    id: 4342,
    url: "https://www.tvmaze.com/shows/4342/lucky-7",
    name: "Lucky 7",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51448.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51448.jpg",
    },
    summary:
      "<p>In Astoria, Queens, a group of seven gas station employees have been chipping into a lottery pool for months, never thinking they'd actually win. Money could solve problems for each of them: Matt (Matt Long) could get his girlfriend and two kids out of his mother's house; Matt's brother, Nicky (Stephen Louis Grush), an ex-con, could pay off a dangerous debt; Samira (Summer Bishil), a second-generation Pakistani immigrant, could afford to go to Juilliard; Denise (Lorraine Bruce), a plucky cashier, could focus on rebuilding her crumbling marriage; Leanne (Anastasia Phillips), a young mother, could help her daughter realize her dreams.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-24",
  },
  {
    id: 4343,
    url: "https://www.tvmaze.com/shows/4343/offspring",
    name: "Offspring",
    genres: ["Drama", "Family", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51453.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51453.jpg",
    },
    summary:
      "<p><b>Offspring</b> follows Nina's quest to manage the intensity of her job delivering babies along with the challenges of raising her daughter Zoe in the midst of the fabulously unpredictable Proudman family - all while trying to establish a decent love life for herself.</p>",
    officialSite: "http://tenplay.com.au/channel-ten/offspring",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 149,
      name: "Network 10",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2010-08-22",
  },
  {
    id: 4344,
    url: "https://www.tvmaze.com/shows/4344/the-young-and-the-restless",
    name: "The Young and the Restless",
    genres: ["Drama", "Family", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/233/583614.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/233/583614.jpg",
    },
    summary:
      "<p><b>The Young and the Restless</b> revolves around the rivalries, romances, hopes and fears of the residents of the fictional Midwestern metropolis, Genoa City. The lives and loves of a wide variety of characters mingle through the generations, dominated by the Newman, Abbott, Chancellor, Baldwin and Winters families. ­ When The Young and the Restless premiered in 1973, it revolutionized the daytime drama. It continues to set the standard with strong characters, socially conscious storylines, romance and sensuality.</p>",
    officialSite: "http://www.cbs.com/shows/the_young_and_the_restless/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1990-01-03",
  },
  {
    id: 4345,
    url: "https://www.tvmaze.com/shows/4345/the-mr-peabody-and-sherman-show",
    name: "The Mr. Peabody and Sherman Show",
    genres: ["Comedy", "Adventure", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51474.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51474.jpg",
    },
    summary:
      "<p>Mr. Peabody, the smartest dog in the world, and his boy Sherman host a zany late-night comedy show broadcast from their swanky penthouse in front of a live studio audience. Anything can happen in this show jam-packed with exciting segments, great musical acts and very special guests like outrageous neighbors and hilarious time travelers they meet with the WABAC machine.</p>",
    officialSite: "https://www.netflix.com/title/80050007",
    webChannel: { id: 1, name: "Netflix", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2015-10-09",
  },
  {
    id: 4346,
    url: "https://www.tvmaze.com/shows/4346/true-monsters",
    name: "True Monsters",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/140/352287.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/140/352287.jpg",
    },
    summary:
      "<p><b>True Monsters </b>sorts the fiction from the often-muddled facts about the most terrifying monsters, awe-inspiring myths, and timeless legends in history. From monstrous creatures to wrathful gods, this series tells the incredible stories that reveal the surprising truths.</p>",
    officialSite: "http://www.history.com/shows/true-monsters",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-09",
  },
  {
    id: 4347,
    url: "https://www.tvmaze.com/shows/4347/the-brain-with-david-eagleman",
    name: "The Brain with David Eagleman",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755453.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755453.jpg",
    },
    summary:
      '<p><b>The Brain with David Eagleman</b> is six one-hour episodes that tell the story of the inner workings of the brain and take viewers on a visually spectacular journey into why they feel and think the things they do.</p><p>The series, hosted by Dr. David Eagleman, neuroscientist, New York Times best-selling author and a Guggenheim Fellow, will reveal the human story by blending scientific truth with innovative visual effects and compelling personal stories. With barely a brain scanner or a white coat in sight, <i>The Brain</i> focuses on understanding the fundamental truths of what it means to be human now and in the coming centuries, while communicating these elegant and simple ideas as they apply to us and our experiences.</p><p>Dr. Eagleman\'s exciting multi-disciplinary approach has earned him respect — and fans — across the globe. He will take viewers on a fascinating journey through our inner cosmos, exploring the brain\'s neural landscape while asking profound questions like "What is reality?" and "Who is in control?" He will also look at the darker side of humanity in order to understand why the brain drives us towards certain actions and behaviors.</p>',
    officialSite:
      "http://www.pbs.org/about/news/archive/2014/the-brain-eagleman/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 85,
      name: "PBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-14",
  },
  {
    id: 4348,
    url: "https://www.tvmaze.com/shows/4348/hunting-hitler",
    name: "Hunting Hitler",
    genres: ["Drama", "War", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/171/429548.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/171/429548.jpg",
    },
    summary:
      "<p>The FBI declassified over 700 pages of secret documents suggesting the possibility that Adolf Hitler may have survived and fled to South America after the fall of Nazi Germany. A recently unearthed memo from legendary FBI Director J. Edgar Hoover states, \"American Army officials in Germany have not located Hitler's body nor is there any reliable source that will say definitely that Hitler is dead\". HISTORY'S new eight-part series <b>Hunting Hitler </b>follows a team of renowned investigators as they reopen the world's most famous cold case in a definitive search to discover if one of history's most notorious war criminals, Adolf Hitler, actually survived World War II.</p>",
    officialSite: "http://www.history.com/shows/hunting-hitler",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-10-28",
  },
  {
    id: 4349,
    url: "https://www.tvmaze.com/shows/4349/mysteries-at-the-museum",
    name: "Mysteries at the Museum",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/205/513168.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/205/513168.jpg",
    },
    summary:
      "<p>In <b>Mysteries at the Museum</b>, Don Wildman visits America's museums, where strange and curious remnants of the past are revealed.</p>",
    officialSite: "http://www.travelchannel.com/shows/mysteries-at-the-museum",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 82,
      name: "Travel Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-11-02",
  },
  {
    id: 4350,
    url: "https://www.tvmaze.com/shows/4350/in-the-club",
    name: "In the Club",
    genres: ["Drama", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/69/173585.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/69/173585.jpg",
    },
    summary:
      "<p>Drama following the lives of six pregnant women and their partners who meet at a local parentcraft class.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b076t4r3",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-08-05",
  },
  {
    id: 4351,
    url: "https://www.tvmaze.com/shows/4351/the-john-bishop-show",
    name: "The John Bishop Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51613.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51613.jpg",
    },
    summary:
      "<p>Comedy entertainment series hosted by award-winning comedian John Bishop. John introduces his favourite comics from all over the world, as well as music guests and variety acts.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b05y37c3",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-05-30",
  },
  {
    id: 4352,
    url: "https://www.tvmaze.com/shows/4352/diy-sos",
    name: "DIY SOS",
    genres: ["DIY"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51614.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51614.jpg",
    },
    summary:
      "<p>Nick Knowles and the team issue a call to arms and recruit friends, family and local trades to help transform the homes of families across Britain.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006pnjk",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1999-10-07",
  },
  {
    id: 4354,
    url: "https://www.tvmaze.com/shows/4354/great-ormond-street",
    name: "Great Ormond Street",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51617.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51617.jpg",
    },
    summary:
      "<p>Cameras follow <b>Great Ormond Street</b> Hospital's doctors as they come face-to-face with the most difficult ethical dilemmas on a daily basis.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b01hn8t9",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-04-06",
  },
  {
    id: 4355,
    url: "https://www.tvmaze.com/shows/4355/homefront",
    name: "Homefront",
    genres: ["Drama", "War"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/130/325276.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/130/325276.jpg",
    },
    summary:
      "<p>Series about the lives of the wives and a mother of soldiers serving in Afghanistan.</p>",
    officialSite: "https://itvstudios.com/programmes/homefront",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-09-26",
  },
  {
    id: 4356,
    url: "https://www.tvmaze.com/shows/4356/the-job-centre",
    name: "The Job Centre",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51619.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51619.jpg",
    },
    summary:
      "<p><b>The Job Centre</b> follows exuberant Jane Vincent, who owns a lively Bradford recruitment agency, and her straight-talking team, as they seek out jobs for their extraordinary customers.</p>",
    officialSite: "http://www.channel4.com/programmes/the-job-centre",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-05-20",
  },
  {
    id: 4357,
    url: "https://www.tvmaze.com/shows/4357/me-and-mrs-jones",
    name: "Me and Mrs. Jones",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51620.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51620.jpg",
    },
    summary:
      "<p>A comedy series following the complex life of Mrs. Jones as she balances love, sex and motherhood.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p00wzj1c",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-10-12",
  },
  {
    id: 4358,
    url: "https://www.tvmaze.com/shows/4358/mr-pickles",
    name: "Mr. Pickles",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51628.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51628.jpg",
    },
    summary:
      "<p><b>Mr. Pickles</b> is set in the small, old-fashioned world of Old Town that is slowly being taken over by the modern world. The series centers on the lives of the Goodman family and their innocent six-year-old son Tommy, whose best friend is the family's lovable border collie, Mr. Pickles.</p>",
    officialSite: "http://www.adultswim.com/videos/mr-pickles/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-21",
  },
  {
    id: 4359,
    url: "https://www.tvmaze.com/shows/4359/the-jump",
    name: "The Jump",
    genres: ["Action", "Adventure", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51629.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51629.jpg",
    },
    summary:
      "<p>Celebrities take on some of the most challenging and dangerous winter sports as they bid to be crowned champion of <b>The Jump</b>.</p>",
    officialSite: "http://www.channel4.com/programmes/the-jump",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-01-26",
  },
  {
    id: 4360,
    url: "https://www.tvmaze.com/shows/4360/super-soul-sunday",
    name: "Super Soul Sunday",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51630.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51630.jpg",
    },
    summary:
      "<p><b>Super Soul Sunday</b> features Oprah's inspirational interviews with today's top thinkers, visionaries and spiritual leaders designed to help viewers awaken to their best selves and discover a deeper connection to the world around them.</p>",
    officialSite: "http://www.oprah.com/app/super-soul-sunday.html",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 236,
      name: "Oprah Winfrey Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-10-16",
  },
  {
    id: 4361,
    url: "https://www.tvmaze.com/shows/4361/halloween-wars",
    name: "Halloween Wars",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51631.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51631.jpg",
    },
    summary:
      "<p>Under the watchful eye of host Rossi Morreale, five teams composed of a pumpkin carving expert, cake artist and sugar artist will battle it out as they create Halloween-themed edible displays that will send chills up your spine. In each episode, teams will face two grueling challenges. First, they'll face off in the Small Scare, where they must create a Halloween-themed design in just 45 minutes. One winning team gets an advantage in the big battle - the Spine Chiller. In the end, their creations will be judged by renowned cake decorator Shinmin Li and make-up artist Brian Kinney, and a rotating panel of celebrity guest judges who are legends in the horror genre. One team will be eliminated after each episode. In the end only one team will be declared <b>Halloween Wars</b> Champion, and walk away with a $50,000 grand prize.</p>",
    officialSite: "http://www.foodnetwork.com/shows/halloween-wars.html",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 81,
      name: "Food Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-10-02",
  },
  {
    id: 4362,
    url: "https://www.tvmaze.com/shows/4362/chemistry",
    name: "Chemistry",
    genres: ["Drama", "Comedy", "Adult"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/133/334579.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/133/334579.jpg",
    },
    summary:
      "<p>Passions ignite and the sexual sparks fly in this sultry series from Cinemax, which just proves that there's no denying <b>Chemistry</b>.</p>",
    officialSite: "http://www.cinemax.com/after-dark/chemistry/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 19,
      name: "Cinemax",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-08-19",
  },
  {
    id: 4363,
    url: "https://www.tvmaze.com/shows/4363/forbidden-science",
    name: "Forbidden Science",
    genres: ["Drama", "Science-Fiction", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/148/370441.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/148/370441.jpg",
    },
    summary:
      "<p>Passion and science collide in this compilation of episodes from the futuristic erotic series that follows life at a corporation that builds clones.</p>",
    officialSite: "http://www.cinemax.com/after-dark/forbidden-science/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 19,
      name: "Cinemax",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-01-10",
  },
  {
    id: 4364,
    url: "https://www.tvmaze.com/shows/4364/southern-at-heart",
    name: "Southern at Heart",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51639.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51639.jpg",
    },
    summary:
      "<p>True Southern cooking is an act of love, and Chef Damaris Phillips takes on the traditions of the South with achievable, bright recipes designed to help build confidence for new cooks. <b>Southern at Heart</b> captures her infectious spirit and celebrates the flavors of Kentucky, where locally sourced special ingredients and romantic backstories are turned into sure-fire crowd pleasers that will inspire anyone to elevate their cooking.</p>",
    officialSite: "http://www.foodnetwork.com/shows/southern-at-heart.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 81,
      name: "Food Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-10-27",
  },
  {
    id: 4365,
    url: "https://www.tvmaze.com/shows/4365/3-scientists-walk-into-a-bar",
    name: "3 Scientists Walk Into a Bar",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755454.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755454.jpg",
    },
    summary:
      "<p><b>3 Scientists Walk Into a Bar</b> is both a new original series on The Weather Channel and curated science community on Facebook featuring Anthony Carboni, Tara Long and Travis Taylor.</p>",
    officialSite:
      "http://www.weather.com/tv/shows/three-scientists-walk-into-a-bar",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 228,
      name: "The Weather Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-05-31",
  },
  {
    id: 4366,
    url: "https://www.tvmaze.com/shows/4366/who-do-you-think-you-are",
    name: "Who Do You Think You Are?",
    genres: ["Family", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51641.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51641.jpg",
    },
    summary:
      "<p>Series in which celebrities trace their ancestry, discovering secrets and surprises from their past.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b007t575",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2004-10-12",
  },
  {
    id: 4367,
    url: "https://www.tvmaze.com/shows/4367/botched-up-bodies",
    name: "Botched Up Bodies",
    genres: ["Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51642.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51642.jpg",
    },
    summary:
      "<p>Our Love of the body beautiful has spawned a billion pound business. From the top of our heads to the tip of our toes, there's nothing that's off limits when it comes to cosmetic surgery. But with all surgery comes risks and many people are being left with <b>Botched up Bodies</b>. In this series we follow the country's top surgeons as they set about repairing the damage.</p>",
    officialSite: "http://www.channel5.com/shows/botched-up-bodies",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 135,
      name: "Channel 5",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-01-14",
  },
  {
    id: 4368,
    url: "https://www.tvmaze.com/shows/4368/the-brokenwood-mysteries",
    name: "The Brokenwood Mysteries",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/222/555417.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/222/555417.jpg",
    },
    summary:
      "<p><b>The Brokenwood Mysteries</b> is set in a seemingly quiet New Zealand country town where the town's newest resident, Detective Inspector Mike Shepherd, finds that murder lurks in even the most homely location.</p>",
    officialSite: "http://thebrokenwoodmysteries.com",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 358,
      name: "Prime",
      country: {
        name: "New Zealand",
        code: "NZ",
        timezone: "Pacific/Auckland",
      },
    },
    premiered: "2014-09-28",
  },
  {
    id: 4369,
    url: "https://www.tvmaze.com/shows/4369/britains-busiest-airport-heathrow",
    name: "Britain's Busiest Airport - Heathrow",
    genres: ["Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/268/671994.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/268/671994.jpg",
    },
    summary:
      "<p>Documentary series going behind the scenes at Britain's busiest and biggest international airport - London Heathrow.</p>",
    officialSite: "https://www.itv.com/hub/heathrow-britains-busiest-airport/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-06-04",
  },
  {
    id: 4370,
    url: "https://www.tvmaze.com/shows/4370/patagonia-earths-secret-paradise",
    name: "Patagonia: Earth's Secret Paradise",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51648.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51648.jpg",
    },
    summary:
      "<p>Documentary series delving into a rarely seen South American wilderness, home to surprising creatures who survive from the mighty Andes Mountains to Cape Horn.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b06dpmbx",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-09-25",
  },
  {
    id: 4371,
    url: "https://www.tvmaze.com/shows/4371/mockingbird-lane",
    name: "Mockingbird Lane",
    genres: ["Comedy", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51649.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51649.jpg",
    },
    summary:
      "<p>In <b>Mockingbird Lane</b>, sweet little Eddie Munster (Cook) is a normal kid about to enter the horrors of puberty. The truth is, he's about to discover that, for him, becoming a teenager means growing hair in truly unexpected places - as in all over his body - every time the moon is full! Eddie's got it pretty good though. His loving, supportive, run-of-the-mill family includes his mom Lily (de Rossi), the daughter of Dracula, his dad Herman (O'Connell), who brings new meaning to \"Frankenstein,\" and Grandpa (Izzard), who would give Dracula a run for his money if he weren't actually Dracula! Of course, there's creepy cousin Marilyn (Wakefield), who's really the odd one because she's so completely normal.</p><p>Buying a house these days is a nightmare, so Herman and Lily are shocked that no one scooped up the rambling Victorian mansion at 1313 Mockingbird Lane that was the site of a series of grisly hobo murders. Settling into their new place, they're quickly onto the mission at hand: to gently ease Eddie into the reality of his werewolf adolescence. But it's not always so easy to accept that your child is a little \"different\" from the rest of the kids. Meanwhile, Herman, who works as a funeral director, is suffering from a heart condition. Since he's made up mostly of spare parts, he knew his makeshift heart would eventually give out. No worries though, because Grandpa, who is pretty good at procuring body parts, is on the case. All Herman cares about is finding a new heart with the same capacity to love Lily as much as he has for so many decades.</p>",
    officialSite: "http://www.nbc.com/classic-tv/mockingbird-lane",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-10-26",
  },
  {
    id: 4372,
    url: "https://www.tvmaze.com/shows/4372/you-have-been-watching",
    name: "You Have Been Watching",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51656.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51656.jpg",
    },
    summary:
      "<p>Celebrity guests join Charlie Brooker to interpret the highs and lows of TV in his comedy quiz show.</p>",
    officialSite:
      "https://web.archive.org/web/20170311153302/http://www.channel4.com/programmes/you-have-been-watching",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-07-07",
  },
  {
    id: 4373,
    url: "https://www.tvmaze.com/shows/4373/was-it-something-i-said",
    name: "Was It Something I Said?",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51657.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51657.jpg",
    },
    summary:
      "<p>David Mitchell hosts a battle of word play in the series where two teams answer questions about quotes, tweets and autobiographies.</p>",
    officialSite: "http://somethingisaid.channel4.com",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-10-06",
  },
  {
    id: 4374,
    url: "https://www.tvmaze.com/shows/4374/way-to-go",
    name: "Way to Go",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51658.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51658.jpg",
    },
    summary:
      "<p>Darkly comic series about three ordinary guys who find themselves forced by an extraordinary set of circumstances into setting up an assisted-suicide business.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b01pzgl0",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-01-17",
  },
  {
    id: 4375,
    url: "https://www.tvmaze.com/shows/4375/the-girl-from-uncle",
    name: "The Girl from U.N.C.L.E.",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51660.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51660.jpg",
    },
    summary:
      "<p><b>The Girl from U.N.C.L.E. </b>was a spin-off of the highly successful series <i>The Man from U.N.C.L.E.</i> and Leo G. Carroll played Mr. Waverly in both and the first actor to be in two series simultaneously.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1966-09-13",
  },
  {
    id: 4376,
    url: "https://www.tvmaze.com/shows/4376/laredo",
    name: "Laredo",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51673.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51673.jpg",
    },
    summary:
      "<p><b>Laredo</b> combined action with humor to tell the tales of three Company B Texas Rangers. Reese Bennett is older then his two partners, Chad Cooper and Joe Riley. Reese is in his forties and was previously a Union Army Officer. Chad was in the Border Patrol during the Civil War but is originally from New Orleans. He joined the Rangers to search for the gunrunners who helped ambush fellow border patrolmen. Joe was a gunfighter who was at times on the wrong side of the law and joined the rangers as protection from a sheriff or two. Chad and Joe love to tease Reese about his age. They had a Gunga Din like camaraderie. They are lead by Captain Parmalee who was stern and disciplined. He would send them on their missions and many times was not amused by the shenanigans they got into. Erik Hunter joined them in the second season</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1965-09-16",
  },
  {
    id: 4377,
    url: "https://www.tvmaze.com/shows/4377/sugarfoot",
    name: "Sugarfoot",
    genres: ["Drama", "Action", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51662.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51662.jpg",
    },
    summary:
      '<p>Tom Brewster is an Easterner who headed west to seek his fortune with hopes of becoming an attorney. Though basically mild-mannered and peaceful, Brewster frequently found himself in violent situations and usually tried to use reason rather than gunplay to get himself out of these tight spots. Because of his peaceful nature and because he hailed from the East, Brewster found himself stuck with the nickname of "Sugarfoot" which was one notch lower than a tenderfoot.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1957-09-17",
  },
  {
    id: 4378,
    url: "https://www.tvmaze.com/shows/4378/bonanza",
    name: "Bonanza",
    genres: ["Drama", "Action", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51664.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51664.jpg",
    },
    summary:
      '<p><b>Bonanza </b>chronicles the weekly adventures of the Cartwright family, headed by the thrice-widowed patriarch Ben Cartwright. He had three sons, each by a different wife: the eldest was the urbane architect Adam Cartwright who built the ranch house; the second was the warm and lovable giant Eric "Hoss" Cartwright; and the youngest was the hotheaded and impetuous Joseph or "Little Joe". The family\'s cook was the Chinese immigrant Hop Sing.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1959-09-12",
  },
  {
    id: 4379,
    url: "https://www.tvmaze.com/shows/4379/bat-masterson",
    name: "Bat Masterson",
    genres: ["Drama", "Action", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51668.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51668.jpg",
    },
    summary:
      "<p><b>Bat Masterson</b> is loosely based on the life and adventures of real life lawman, army scout, gunfighter and journalist. Dressed-up dandy (derby and cane), gambler and lawman roams the West charming women and defending the unjustly accused. His primary weapon was his wit (and cane) rather than his gun.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1958-10-08",
  },
  {
    id: 4380,
    url: "https://www.tvmaze.com/shows/4380/wanted-dead-or-alive",
    name: "Wanted: Dead or Alive",
    genres: ["Drama", "Action", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51669.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51669.jpg",
    },
    summary:
      '<p><b>Wanted: Dead or Alive</b> originally aired in black and white on CBS. The pilot aired on the series "Trackdown" in March 1958. Bounty hunter Josh Randall was unlike any bounty hunter, he usually gave half or all of his reward money to good causes. He was a gentlemen and very respectful of the elderly. He was a man of few words and seemed to lack emotion but he was adept at using his gun, not an ordinary gun but a .44-.40 sawed-off 1892 Winchester carbine which he had on his "Mare\'s Leig", BUT the cartridges in his belt were .45-.70! His catch phrase in almost every episode was "Let\'s Go" which he spoke softly and sounded more like les goo. A treasure one not to be missed, especially to see Mr. Cool himself, Steve McQueen.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1958-09-06",
  },
  {
    id: 4381,
    url: "https://www.tvmaze.com/shows/4381/hopalong-cassidy",
    name: "Hopalong Cassidy",
    genres: ["Drama", "Comedy", "Action", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51670.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51670.jpg",
    },
    summary:
      "<p>In <b>Hopalong Cassidy</b> played by William Boyd Hopalong and his horse Topper catch bad guys with Red Connors for comic relief.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1952-09-19",
  },
  {
    id: 4382,
    url: "https://www.tvmaze.com/shows/4382/route-66",
    name: "Route 66",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51672.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51672.jpg",
    },
    summary:
      "<p>Martin Milner as Tod Stiles, from a once-wealthy family, inherited only a Corvette when his father died, so he and George Maharis as Buz Murdock (suddenly jobless because he worked for Tod's father's company) strike out across North America, especially along the iconic Route 66 from Chicago to L.A. which the Okies traveled. Tod and Buz take local jobs (such as shrimping, shipbuilding, oil rigging) to support their wanderings. The 2 socially conscious knights of the road, encourage, champion, and learn from oppressed and troubled people they encounter.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1960-10-07",
  },
  {
    id: 4383,
    url: "https://www.tvmaze.com/shows/4383/alex-polizzi-the-fixer",
    name: "Alex Polizzi: The Fixer",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51674.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51674.jpg",
    },
    summary:
      "<p>Alex Polizzi sets out to wage a one woman campaign to save Britain's family businesses.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b01qwflg",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-01-31",
  },
  {
    id: 4384,
    url: "https://www.tvmaze.com/shows/4384/all-change-at-longleat",
    name: "All Change at Longleat",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51677.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51677.jpg",
    },
    summary:
      "<p>Documentary following one of the country's most extraordinary aristocratic families and the people who work for them.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b06cxkzv",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-09-14",
  },
  {
    id: 4385,
    url: "https://www.tvmaze.com/shows/4385/ant-decs-saturday-night-takeaway",
    name: "Ant & Dec's Saturday Night Takeaway",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/245/613083.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/245/613083.jpg",
    },
    summary:
      "<p><b>Ant &amp; Dec's Saturday Night Takeaway</b>, often referred to simply as Saturday Night Takeaway or SNT, is a British television variety show presented and executively produced by Ant &amp; Dec. The show was first broadcast on 8 June 2002 on ITV.</p>",
    officialSite: "http://www.itv.com/saturdaynighttakeaway",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2002-06-08",
  },
  {
    id: 4386,
    url: "https://www.tvmaze.com/shows/4386/autumnwatch",
    name: "Autumnwatch",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51679.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51679.jpg",
    },
    summary: "<p>Following UK wildlife in the autumn.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b0079t1p",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2007-11-05",
  },
  {
    id: 4387,
    url: "https://www.tvmaze.com/shows/4387/badults",
    name: "Badults",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/80/201222.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/80/201222.jpg",
    },
    summary:
      "<p>As kids, Tom, Ben and Matthew made a pact to live together when they grew up. Now, they live together - but it's unclear if they've actually grown up.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p01y5vs8",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-07-23",
  },
  {
    id: 4388,
    url: "https://www.tvmaze.com/shows/4388/benidorm-er",
    name: "Benidorm ER",
    genres: ["Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51681.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51681.jpg",
    },
    summary:
      "<p>Fly-on-the-wall series following events at Clinica Benidorm.</p>",
    officialSite: "http://www.channel5.com/show/benidorm-er",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 135,
      name: "Channel 5",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-10-24",
  },
  {
    id: 4389,
    url: "https://www.tvmaze.com/shows/4389/big-stars-little-star",
    name: "Big Star's Little Star",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51682.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51682.jpg",
    },
    summary:
      "<p><b>Big Star's Little Star</b> will give viewers a peak into the star's home life. What embarrassing secrets or cringe worthy crushes will come to light to leave their parents red faced...</p>",
    officialSite: "https://itvstudios.com/programmes/big-star-s-little-star",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-09-04",
  },
  {
    id: 4390,
    url: "https://www.tvmaze.com/shows/4390/bob-servant-independent",
    name: "Bob Servant Independent",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51684.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51684.jpg",
    },
    summary:
      "<p>A local cheeseburger tycoon enters a by-election. That man is Bob Servant, Independent.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b04tc4bx",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 51,
      name: "BBC Four",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-01-23",
  },
  {
    id: 4391,
    url: "https://www.tvmaze.com/shows/4391/bring-back-borstal",
    name: "Bring Back Borstal",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51685.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51685.jpg",
    },
    summary:
      "<p>A fascinating four-part series which follows a social experiment in which 13 young offenders volunteer to experience the strict regime of a 1930s-style Borstal for four weeks.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-01-08",
  },
  {
    id: 4392,
    url: "https://www.tvmaze.com/shows/4392/catchphrase",
    name: "Catchphrase",
    genres: ["Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51686.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51686.jpg",
    },
    summary:
      "<p>Stephen Mulhern hosts a brand new contemporary remake of the iconic 80s gameshow, where two contestants have to identify a familiar catchphrase from an animation clip.</p>",
    officialSite:
      "https://www.itv.com/hub/catchphrase-celebrity-special/2a5716a0024",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-04-07",
  },
  {
    id: 4393,
    url: "https://www.tvmaze.com/shows/4393/the-fixer",
    name: "The Fixer",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51691.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51691.jpg",
    },
    summary:
      '<p>Ellie Molaro (Kathleen Robertson - <i>Murder in the First</i>) is an investigator with the NTSB - the US federal body which determines the causes of major accidents. She becomes suspicious of the "official answers" to an oil rig disaster, spearheads a private investigation with a secret tipster named Carter (Eric Dane - <i>The Last Ship</i>).</p><p>Carter claims that a conspiracy of "Fixers" are behind some of the worst global disasters, all rigged to manipulate the stock market, and reap billions for a select few.</p><p>Now, their largest operation in decades is an impending, catastrophic event targeting Washington, D.C. and the only way they can succeed is if Ellie and Carter are among the casualties.</p>',
    officialSite: "http://www.sky.com/tv/show/the-fixer",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-04",
  },
  {
    id: 4394,
    url: "https://www.tvmaze.com/shows/4394/strictly-come-dancing-it-takes-two",
    name: "Strictly Come Dancing - It Takes Two",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/84/210650.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/84/210650.jpg",
    },
    summary:
      "<p><b>Strictly Come Dancing: It Takes Two</b>, or simply, <i>Strictly: It Takes Two</i>, is a British television programme, the companion show to the popular BBC One programme <i>Strictly Come Dancing</i>. It is broadcast on weeknights during the run of the main show on BBC Two at 6:30pm. Claudia Winkleman originally presented the show, however she left in 2011 and now presents the main show. Since then, the presenter has been previous contestant and finalist on the series Zoë Ball.</p><p>Before 2010, BBC Two Scotland did not broadcast the show on Thursdays, when locally produced Gaelic language programming aired in the slot instead, though during the 2008 and 2009 series the Thursday night show was carried as an alternative digital stream via BBC Red Button.</p><p><i>It Takes Two</i> started to broadcast during the second series of the main show, replacing the companion show to the first series, <i>Strictly Come Dancing: On Three</i>, which had been broadcast on the digital channel BBC Three.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006mgww",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2004-10-25",
  },
  {
    id: 4395,
    url: "https://www.tvmaze.com/shows/4395/strictly-come-dancing",
    name: "Strictly Come Dancing",
    genres: ["Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51694.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51694.jpg",
    },
    summary:
      "<p>Are today's celebrities fleet of foot or do they have two left feet? That's the question Tess Daly and Claudia Winkleman will be finding the answer to when they present <b>Strictly Come Dancing</b>.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006m8dq",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2004-05-15",
  },
  {
    id: 4396,
    url: "https://www.tvmaze.com/shows/4396/ai-no-wakakusa-monogatari",
    name: "Ai no Wakakusa Monogatari",
    genres: ["Drama", "Anime", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51695.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51695.jpg",
    },
    summary:
      "<p>Meg, faithful and gentle, Jo, independent and energetic, Beth, quiet and shy, Amy, amiable and precocious–the four sisters live vigorously and happily at home with their gentle mother while waiting for their father to return from the Civil War. Helping each other, they challenge their fates and grow up to become wonderful women.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 137,
      name: "NTV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1987-01-11",
  },
  {
    id: 4397,
    url: "https://www.tvmaze.com/shows/4397/takarajima",
    name: "Takarajima",
    genres: ["Action", "Adventure", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51696.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51696.jpg",
    },
    summary:
      "<p>Around the Golden Age of Piracy, Jim Hawkins is a lively young boy helping his mother run the Admiral Benbow Inn located near Black Hill, a small town in England. On a dreary rainy night, they receive a new customer. A mysterious sailor paranoid of being followed whenever he isn't drunk. From him, Jim acquires an invaluable item: the treasure map of Flint, one of the most feared pirates of his epoch. With the help of the friends of his late father, Jim embarks on an incredible adventure in search of what could be a legendary fortune.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 137,
      name: "NTV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1978-10-08",
  },
  {
    id: 4398,
    url: "https://www.tvmaze.com/shows/4398/rob",
    name: "¡Rob!",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51697.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51697.jpg",
    },
    summary:
      "<p><b>¡Rob!</b> is a comedy starring Rob Schneider as a lifelong bachelor who just married into a tight-knit Mexican-American family. Rob is a successful landscape architect who, after a whirlwind romance, marries Maggie, a beautiful, smart fashion boutique owner, who is way out of his league. After eloping in Las Vegas, Maggie and Rob must break the news to her overprotective, judgmental parents, Rosa and Fernando, that they are married. Shocked by news that they've eloped, the family remains skeptical of Maggie's choice for a husband, with the exception of her uncle Hector, the black sheep of the family, who takes to Rob immediately, and possibly Maggie's grandmother, Abuelita. With domineering in-laws and lots of aunts and uncles, Rob hopes he will one day win over the rest of the family and live happily ever after with his one true love, Maggie.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-01-12",
  },
  {
    id: 4400,
    url: "https://www.tvmaze.com/shows/4400/mask",
    name: "M.A.S.K.",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/140/350953.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/140/350953.jpg",
    },
    summary:
      "<p>After the death of his teenage brother Andy, multi-millionaire Matt Trakker uncovers an international criminal organization known as V.E.N.O.M...</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1985-09-30",
  },
  {
    id: 4401,
    url: "https://www.tvmaze.com/shows/4401/major-lazer",
    name: "Major Lazer",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51705.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51705.jpg",
    },
    summary:
      '<p>The reggae dancehall grooves of <i>Major Lazer</i> are just one of the highlights in <b>Major Lazer</b>. The animated series tells the story of a superhero named <i>Major Lazer</i> who, with the help of his two teenaged friends, Penny and BLKMRKT, fights against the villains that populate the futuristic dystopia that is Jamaica. A self-proclaimed "Guardian of the Groove", <i>Major Lazer</i> vows to fight for the rights of the Jamaican people and to bring down the ruthless curmudgeon, President Whitewall. Part of Animation Domination.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 47,
      name: "FXX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-04-17",
  },
  {
    id: 4402,
    url: "https://www.tvmaze.com/shows/4402/china-beach",
    name: "China Beach",
    genres: ["Drama", "War", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51706.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51706.jpg",
    },
    summary:
      "<p>A group of women just trying to do their jobs at the 510th Evac Hospital at <b>China Beach</b> Vietnam in 1967 includes cool but callous Army nurse Colleen McMurphy, naive Red Cross newcomer Cherry White, singer Laurette Barber, and cynical civilian worker/prostitute K.C. Koloski. They are trying to cope with the horrors of war which are never far away from the base and deal with their own lives.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1988-04-26",
  },
  {
    id: 4403,
    url: "https://www.tvmaze.com/shows/4403/monroe",
    name: "Monroe",
    genres: ["Drama", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51707.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51707.jpg",
    },
    summary:
      "<p>Award-winning actor James Nesbitt returns as genius neurosurgeon Monroe, Britain's answer to House.</p>",
    officialSite: "https://itvstudios.com/programmes/monroe",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-03-10",
  },
  {
    id: 4404,
    url: "https://www.tvmaze.com/shows/4404/yukon-gold",
    name: "Yukon Gold",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51711.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51711.jpg",
    },
    summary:
      "<p>This high stakes series captures the physical and emotional struggles four sets of gold miners face as they chase their individual goals over the 16-week Yukon gold mining season.</p>",
    officialSite: "http://www.history.ca/yukon-gold/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 118,
      name: "History",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2013-03-13",
  },
  {
    id: 4405,
    url: "https://www.tvmaze.com/shows/4405/weissensee",
    name: "Weißensee",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51714.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51714.jpg",
    },
    summary: null,
    officialSite:
      "http://www.daserste.de/unterhaltung/serie/weissensee/index.html",
    webChannel: null,
    language: "German",
    status: "Ended",
    network: {
      id: 360,
      name: "Das Erste",
      country: { name: "Germany", code: "DE", timezone: "Europe/Busingen" },
    },
    premiered: "2010-09-14",
  },
  {
    id: 4406,
    url: "https://www.tvmaze.com/shows/4406/legends-football-league",
    name: "Legends Football League",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755163.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755163.jpg",
    },
    summary:
      "<p>The <b>Legends Football League</b> (LFL) is a women's 7-on-7 tackle American football league, with games played in the spring and summer at NBA, NFL, NHL and MLS arenas and stadiums. The league was founded in 2009 as the <i>Lingerie Football League</i> and was rebranded as the Legends Football League in 2013. The concept of the LFL originated from an alternative Super Bowl halftime television special called the Lingerie Bowl, a pay-per-view event broadcast opposite the Super Bowl halftime show.</p>",
    officialSite: "https://www.fuse.tv/shows/legends-football-league",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 186,
      name: "FUSE TV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-09-04",
  },
  {
    id: 4407,
    url: "https://www.tvmaze.com/shows/4407/lingerie",
    name: "Lingerie",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51715.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51715.jpg",
    },
    summary:
      "<p><b>Lingerie</b> is a sexy new series featuring an ensemble cast of beautiful people who design, photograph or model lingerie in New York City's fashion industry. Most of the stories revolve around Lacey Summers, who left a successful modeling career to become a designer. Lacey lives in a large loft that doubles as her design studio. Her younger brother, Cody, also lives in the building but in a much smaller apartment with his wing man Russ. What Cody lacks in ambition he makes up with in charm and good looks. He's constantly popping in and out of Lacey's place helping himself to her food and occasionally to her models.</p>",
    officialSite: "http://www.cinemax.com/after-dark/lingerie/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 19,
      name: "Cinemax",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-07-04",
  },
  {
    id: 4408,
    url: "https://www.tvmaze.com/shows/4408/48-hours",
    name: "48 Hours",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/24/62177.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/24/62177.jpg",
    },
    summary:
      "<p><b>48 Hours</b> is a CBS news magazine that investigates intriguing crime and justice cases that touch on all aspects of the human experience. Over its long run, the show has helped exonerate wrongly convicted people, driven the reopening -- and resolution -- of cold cases, and changed numerous lives. CBS News correspondents offer an in-depth look into each story, with the emphasis on solving the mystery at its heart. The program and its team have earned critical acclaim, including 20 Emmys and three Peabody Awards.</p>",
    officialSite: "http://www.cbsnews.com/48-hours/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1988-01-19",
  },
  {
    id: 4409,
    url: "https://www.tvmaze.com/shows/4409/ibiza-weekender",
    name: "Ibiza Weekender",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/269/672722.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/269/672722.jpg",
    },
    summary:
      "<p>The Weekender returns and this time we are going to Ibiza! The cast will grow, giving us more scope for soap opera storylines.</p>",
    officialSite: "https://www.itv.com/hub/ibiza-weekender/2a3296a0046",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 54,
      name: "ITV2",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-01-06",
  },
  {
    id: 4410,
    url: "https://www.tvmaze.com/shows/4410/the-bridge",
    name: "The Bridge",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51718.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51718.jpg",
    },
    summary:
      "<p><b>The Bridge</b> is a police district which a includes a wealthy, upscale suburb and a lower-class, crime-plagued neighborhood, with the two separated by a highway bridge. Frank Leo, the newly elected police union head with an angry attitude and no patience for the corruption that permeates the force, does whatever is called for to protect the beat cops in Bridge District from the brass as they do a difficult an underappreciated job.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 48,
      name: "CTV",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2010-03-05",
  },
  {
    id: 4411,
    url: "https://www.tvmaze.com/shows/4411/the-fixer",
    name: "The Fixer",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51726.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51726.jpg",
    },
    summary:
      '<p>John Mercer (Andy Buchan) is an assassin for the state - beholden to his sinister master but not the boundaries of the law.</p><p>Released from prison unexpectedly early, Mercer is introduced to Lenny Douglas, a police officer retired on the grounds of "ill health". He quickly realises his newfound freedom comes at a price. Douglas runs an unofficial operation with a single brief: dealing with untouchable criminals and disorganising crime. Mercer\'s role is that of hitman.</p><p>On hand to help Mercer fulfil each hit are Calum, whose main interests are girls, drugs and music, and the sharp tongued but seductive Rose, an ex-copper forced out of the police by scandal. The team are brought together to bring order where the law has failed. But can operating outside the usual parameters of the law – even under the pretext of protecting it - ever be justified?</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-03-10",
  },
  {
    id: 4412,
    url: "https://www.tvmaze.com/shows/4412/the-mountain",
    name: "The Mountain",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51731.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51731.jpg",
    },
    summary:
      '<p>Boundary Mountain is an escapist playground for wealthy tourists and extreme sports enthusiasts, but to the Carver family, it\'s home. <i><b>"The Mountain"</b></i> chronicles the larger-than-life saga of the Carvers, whose colorful patriarch, David Carver, Sr. founded the town and its internationally famous ski resort after winning the land in a poker game. When this legendary man unexpectedly dies, his choice of an heir sends shockwaves throughout the community. Free-spirited David Carver, Jr. left home years ago to pursue his dream of becoming a world-class motocross racer, while his older brother Will diligently attended business school with every expectation of taking over the family empire. No one, least of all the brothers themselves, expected David to inherit the Mountain. Now, David finds himself saddled with a responsibility he never wanted and a brother who r...</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-09-22",
  },
  {
    id: 4413,
    url: "https://www.tvmaze.com/shows/4413/sullivan-son",
    name: "Sullivan & Son",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51732.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51732.jpg",
    },
    summary:
      "<p>Steve Sullivan surprises his parents when he leaves his job as a corporate lawyer to take over a bar owned by his father in Pittsburgh.</p>",
    officialSite: "http://www.tbs.com/shows/sullivan-son.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 32,
      name: "TBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-07-19",
  },
  {
    id: 4414,
    url: "https://www.tvmaze.com/shows/4414/the-protector",
    name: "The Protector",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51741.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51741.jpg",
    },
    summary:
      "<p>Gloria Sheppard, a divorced mother, must juggle her job as an LAPD homicide detective in addition to raising her two sons with some help from her younger brother Davey.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-06-12",
  },
  {
    id: 4415,
    url: "https://www.tvmaze.com/shows/4415/charlie-jade",
    name: "Charlie Jade",
    genres: ["Drama", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51747.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51747.jpg",
    },
    summary:
      "<p>Charlie Jade is a rogue private detective in a world dominated by greedy multinational corporations. While on an investigation, Charlie explores a secret desert facility. A massive explosion propels him from his own universe (alphaverse) to a strange parallel universe (betaverse). Soon, Charlie is drawn into a conflict that involves these two universes and one other pacifist universe (gammaverse) with unsuspected terror at its heart.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 7,
      name: "CTV Sci-Fi Channel",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2005-04-16",
  },
  {
    id: 4416,
    url: "https://www.tvmaze.com/shows/4416/captain-planet-and-the-planeteers",
    name: "Captain Planet and the Planeteers",
    genres: ["Adventure", "Children", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51753.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51753.jpg",
    },
    summary:
      "<p>The show focuses on five teenagers who are all given magic rings by Gaia, the Spirit of Earth. Kwame from Africa, Wheeler from North America, Linka from Soviet Union (changed to Eastern Europe after the Soviet Union's collapse), Gi from Asia and Ma-Ti from South America. When the powers of the five rings are combined (Earth, Fire, Wind, Water and Heart), an environmental superhero, Captain Planet, is summoned.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 32,
      name: "TBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1990-09-15",
  },
  {
    id: 4417,
    url: "https://www.tvmaze.com/shows/4417/free-agents",
    name: "Free Agents",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51754.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51754.jpg",
    },
    summary:
      "<p>This crooked workplace/romantic comedy proves you can try to put yourself back out there, but sometimes what you need is right in front of you. Even if it's a really bad idea.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-09-14",
  },
  {
    id: 4418,
    url: "https://www.tvmaze.com/shows/4418/declassified",
    name: "Declassified",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51757.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51757.jpg",
    },
    summary:
      "<p><b>Declassified</b> is a television series produced by Ten Worlds Productions on The History Channel that originally aired on November 9, 2004. The series takes viewers inside vaults and archives around the world to reveal the untold stories of modern history. With the fall of the Iron Curtain and the advent of market economies worldwide, new footage and materials are flooding out of formerly secret organizations like East Germany's Stasi, the Kremlin, the CIA, and state television in Korea. Declassified reveals the stories behind the previously-unseen footage with relentless, fast-cut montage and a rock beat. Declassified fuses modern graphics and editing, story-telling, rock music and expert interviews to bring to light the thrilling and secret tales of our modern era. The show's director Kosh, winner of three Grammy Awards, is the former creative director for Apple Records and designer for the Beatles and Eagles. Produced and created by Susan Shearer, John J. Flynn and Kosh. Executive produced by Carl Lindahl for the History Channel.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-11-08",
  },
  {
    id: 4419,
    url: "https://www.tvmaze.com/shows/4419/junior-paramedics",
    name: "Junior Paramedics",
    genres: ["Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51758.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51758.jpg",
    },
    summary:
      "<p>Series following the lives of nine student paramedics as they go on their first ever placement with the East Midlands Ambulance Service.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b03ws35k",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-02-27",
  },
  {
    id: 4420,
    url: "https://www.tvmaze.com/shows/4420/the-palace",
    name: "The Palace",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51759.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51759.jpg",
    },
    summary:
      "<p>The sudden death of the old King means the crown passes to Richard, the 24 year-old Prince of Wales. Richard is thrown into a role he thought he'd have twenty years to perfect, whilst the nation waits for him to mend his ways and fill his father's shoes. He gets support, of a fashion, from the Royal Family: His brother Prince George, his glamorous and ambitious sister Princess Eleanor and his beautiful but damaged mother Queen Charlotte; each of whom have their own agendas and personal problems. He will be guided by his all-knowing Private Secretaries and a downstairs team of Pages, Valets and Footmen, and they're going to enjoy all the fun of working in the smartest address in the world. But in a tabloid culture where sensation rules, and love must give way to duty, Richard will be forced to question whether his quest to become a suitable ruler is really worth the price…</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-01-14",
  },
  {
    id: 4421,
    url: "https://www.tvmaze.com/shows/4421/teachers",
    name: "Teachers",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51767.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51767.jpg",
    },
    summary:
      "<p>Filmore is a New Jersey school that has its share of problems, including apathetic teachers, antiquated rules and a majority of students who are more interested in text-messaging than in textbooks.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-03-28",
  },
  {
    id: 4422,
    url: "https://www.tvmaze.com/shows/4422/the-knights-of-prosperity",
    name: "The Knights of Prosperity",
    genres: ["Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51768.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51768.jpg",
    },
    summary:
      "<p>For nearly 20 years, Eugene Gurkin (Eugene Gurkin) has dreamed of opening a bar, but the income he receives from janitorial job is hardly enough to fund an expensive bottle of booze. After a co-worker's death and an episode of television, Eugene had an epiphany. Following the idea he has, Eugene recruits a group who will work together to pull of a heist in order to fund their dreams. Their target: Mick Jagger's posh Central Park apartment.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-01-03",
  },
  {
    id: 4423,
    url: "https://www.tvmaze.com/shows/4423/rescue-special-ops",
    name: "Rescue: Special Ops",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/148/370462.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/148/370462.jpg",
    },
    summary:
      "<p>Dean and Chase Gallagher are brothers. Competitive alpha males, they argue over everything, agree on nothing, but defend each other from outsiders no matter what. They're also members of the Special Operations Rescue Unit. Experienced paramedics in peak physical condition, they're called in for complex search and rescue operations. With the latest in tools and training, they can access anyone, anywhere, under any conditions.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 120,
      name: "Nine Network",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2009-08-02",
  },
  {
    id: 4424,
    url: "https://www.tvmaze.com/shows/4424/republic-of-doyle",
    name: "Republic of Doyle",
    genres: ["Drama", "Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51778.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51778.jpg",
    },
    summary:
      "<p>Jake is in jail, arrested for the murder of former Mayor Clarke, and is trying to come to terms with what happened to Leslie. Also, the Doyles are reeling from Sloan's theft and are flat broke. With no way to get Jake out of jail – and with no leads to evidence that might exonerate Jake, it's going to be a hard climb back for everyone. Will the Doyles lose everything they've worked for? Is Jake going to win back his freedom? Is Leslie still alive?</p>",
    officialSite: "http://www.cbc.ca/republicofdoyle/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 36,
      name: "CBC",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2010-01-06",
  },
  {
    id: 4425,
    url: "https://www.tvmaze.com/shows/4425/the-last-leg",
    name: "The Last Leg",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51787.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51787.jpg",
    },
    summary:
      "<p>Adam Hills and co-hosts Josh Widdicombe and Alex Brooker provide some offbeat commentary on the significant moments of the past seven days.</p>",
    officialSite: "http://www.channel4.com/programmes/the-last-leg",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-01-25",
  },
  {
    id: 4426,
    url: "https://www.tvmaze.com/shows/4426/junior-doctors",
    name: "Junior Doctors",
    genres: ["Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51788.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51788.jpg",
    },
    summary:
      "<p>Documentary series following newly-qualified medics as they start working on hospital wards for the first time.</p>",
    officialSite: "https://www.bbc.co.uk/programmes/b013fdbd",
    webChannel: {
      id: 71,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    language: "English",
    status: "To Be Determined",
    network: null,
    premiered: "2011-02-22",
  },
  {
    id: 4427,
    url: "https://www.tvmaze.com/shows/4427/lets-dance-for-comic-relief",
    name: "Let's Dance for Comic Relief",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51789.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51789.jpg",
    },
    summary:
      "<p>Celebrities perform famous dance routines in front of a panel of judges to raise money for the Comic Relief appeal, with viewers voting for their favourites.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00z1q37",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-02-21",
  },
  {
    id: 4428,
    url: "https://www.tvmaze.com/shows/4428/its-a-funny-old-week-with-jason-manford",
    name: "It's a Funny Old Week with Jason Manford",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51791.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51791.jpg",
    },
    summary:
      "<p>Jason Manford discusses weekly events from the worlds of news, showbiz, culture and sport. From the biggest news stories of the week to what's slipped under the radar, Jason will cast his comic eye over it.</p>",
    officialSite:
      "https://www.itv.com/itvplayer/it-s-a-funny-old-week-with-jason-manford/series-2/episode-1",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-06-15",
  },
  {
    id: 4429,
    url: "https://www.tvmaze.com/shows/4429/cane",
    name: "Cane",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51793.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51793.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-09-25",
  },
  {
    id: 4430,
    url: "https://www.tvmaze.com/shows/4430/wilderness-walks-with-ray-mears",
    name: "Wilderness Walks with Ray Mears",
    genres: ["Adventure", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/26/67462.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/26/67462.jpg",
    },
    summary:
      "<p><b>Wilderness Walks with Ray Mears</b> follows the popular presenter as he takes the viewers at home on a trail of discovery along rivers, through forests and across mountains as he looks for some of the country's greatest natural treasures.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-09-10",
  },
  {
    id: 4431,
    url: "https://www.tvmaze.com/shows/4431/lego-star-wars-the-yoda-chronicles",
    name: "LEGO Star Wars: The Yoda Chronicles",
    genres: ["Action", "Children", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/210/525492.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/210/525492.jpg",
    },
    summary:
      "<p>Non-canonical series of shorts depicting a humorous look at the events of the Star Wars universe, as well as the training &amp; growth of the various characters with a distinct Lego personality.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-05-29",
  },
  {
    id: 4433,
    url: "https://www.tvmaze.com/shows/4433/freshers",
    name: "Freshers",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/108/271723.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/108/271723.jpg",
    },
    summary:
      "<p>Reality entertainment series exploring the experiences and personal stories of freshers as they laugh, cry, party and panic through their way through the first week at university.</p>",
    officialSite: "https://www.itv.com/itvplayer/freshers/series-2/episode-2",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 54,
      name: "ITV2",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-10-16",
  },
  {
    id: 4434,
    url: "https://www.tvmaze.com/shows/4434/the-secret-life-of-students",
    name: "The Secret Life of Students",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51805.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51805.jpg",
    },
    summary:
      "<p><b>The Secret Life of Students</b> follows 12 freshers in their first year at university, exploring the drama of their new experiences and sharing their texts, tweets, pictures, videos and status update.</p>",
    officialSite:
      "http://www.channel4.com/programmes/the-secret-life-of-students",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-07-03",
  },
  {
    id: 4435,
    url: "https://www.tvmaze.com/shows/4435/chug",
    name: "Chug",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51808.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51808.jpg",
    },
    summary:
      "<p>Rum company owner, world traveler, and drink aficionado, Zane Lamprey, travels the globe to explore drinking customs and cultures by tossing back a few with the locals. As he explores the libations of the region, Zane visits watering holes, breweries, distilleries and wineries. In every episode, he journeys by train to the outskirts of the big cities, chugging off to get a taste of local spirits.</p>",
    officialSite: "http://channel.nationalgeographic.com/chug/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-11-24",
  },
  {
    id: 4436,
    url: "https://www.tvmaze.com/shows/4436/voetbal-inside",
    name: "Voetbal Inside",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51815.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51815.jpg",
    },
    summary:
      "<p>Voetbal International continues as Voetbal Inside. A talk show about Football. Wilfred Genee leads the the discussion on the latest updates of King Football. Together with Johan Derksen, Rene van der Gijp and their guests they will analyze matches, strategies and leading players without minding their own words.</p>",
    officialSite: "http://www.voetbalinside.nl/",
    webChannel: null,
    language: "Dutch",
    status: "Running",
    network: {
      id: 361,
      name: "RTL7",
      country: {
        name: "Netherlands",
        code: "NL",
        timezone: "Europe/Amsterdam",
      },
    },
    premiered: "2015-08-10",
  },
  {
    id: 4437,
    url: "https://www.tvmaze.com/shows/4437/north-woods-law",
    name: "North Woods Law",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51811.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51811.jpg",
    },
    summary:
      "<p>In the state of Maine, the elite Game Warden Service patrols more than eighteen million acres of rugged terrain filled with wild animals... and wild people. Each Autumn brings the hunting season, the Warden's busiest and most dangerous time of year. These 'State Police of the Woods' never know what to expect from one moment to the next. <b>North Woods Law</b> follows Maine's elite Game Wardens as they navigate the Pine Tree State's rugged terrain and twisted back roads. This year the wardens cover deer, moose, and fowl hunting seasons - the busiest and most perilous times of the year. Each punch of the time clock is a ticket to extreme danger and drama as undercover stings and intense rescues are all in a day's work. Whether they're tracking bears on dangerous mountains or busting drunk drivers on ATVs, the Maine Game Wardens risk life and limb to protect animals and serve the people of Maine.</p>",
    officialSite: "http://www.animalplanet.com/tv-shows/north-woods-law/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 92,
      name: "Animal Planet",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-03-11",
  },
  {
    id: 4438,
    url: "https://www.tvmaze.com/shows/4438/on-the-case-with-paula-zahn",
    name: "On the Case with Paula Zahn",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51812.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51812.jpg",
    },
    summary:
      "<p>Led by Emmy Award-winning journalist Paula Zahn, On the Case features in-depth interviews and original reporting that go beyond the headlines in search of fascinating mysteries from within our nation's justice system. Each episode is highlighted by Zahn's riveting exclusive interviews, which draw out different viewpoints from the people personally connected to tragedies that rocked their local community and the investigations that attempted to piece together the truth <b>On the Case with Paula Zahn</b>.</p>",
    officialSite:
      "https://www.investigationdiscovery.com/tv-shows/on-the-case-with-paula-zahn/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 89,
      name: "Investigation Discovery",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-10-18",
  },
  {
    id: 4439,
    url: "https://www.tvmaze.com/shows/4439/24-hours-in-ae",
    name: "24 Hours in A&E",
    genres: ["Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/320/802288.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/320/802288.jpg",
    },
    summary:
      "<p>Cameras film around the clock in some of Britain's busiest A&amp;E departments.</p>",
    officialSite: "http://www.channel4.com/programmes/24-hours-in-ae",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-05-11",
  },
  {
    id: 4440,
    url: "https://www.tvmaze.com/shows/4440/bad-bridesmaid",
    name: "Bad Bridesmaid",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51814.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51814.jpg",
    },
    summary:
      "<p>Six brides-to-be must pass off an undercover actor as a real member of their bridal party in a bid to win their dream honeymoon.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 54,
      name: "ITV2",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-09-11",
  },
  {
    id: 4441,
    url: "https://www.tvmaze.com/shows/4441/children-in-need",
    name: "Children in Need",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/282/707077.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/282/707077.jpg",
    },
    summary:
      "<p><b>Children in Need </b>provide grants to projects in the UK which focus on children and young people who are disadvantaged. We are local to people in all corners of the UK and support small and large organisations which empower children and extend their life choices. The BBC Children in Need Appeal Night takes place every year in November. The Appeal show is a whole evening of entertainment on BBC One with celebrities singing, dancing, and doing all sorts of crazy things to help raise money.</p>",
    officialSite: "http://www.bbc.co.uk/corporate2/childreninneed",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1980-11-21",
  },
  {
    id: 4442,
    url: "https://www.tvmaze.com/shows/4442/monks",
    name: "Monks",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51817.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51817.jpg",
    },
    summary:
      "<p>Long-running anthology series of one-off sitcoms, many of which launched other classic comedy series.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b043nmd4",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-05-13",
  },
  {
    id: 4443,
    url: "https://www.tvmaze.com/shows/4443/you-me-them",
    name: "You, Me & Them",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51820.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51820.jpg",
    },
    summary:
      "<p>Lauren (Eve Myles) and Ed (Anthony Head) are madly in love, despite their almost 30-year age gap, and are looking forward to starting their new life living together. The only problem is that Lauren's family and everyone around them seems to have an opinion on the subject. With Ed's ex-wife Lydia renting the house opposite and trying to cause trouble whenever she can, Lauren's meddling family and Ed's friends all thinking she's a trophy girlfriend; their relationship will have to be ironclad to weather these obstacles they're facing.</p>",
    officialSite: "http://gold.uktv.co.uk/shows/you-me-them/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 388,
      name: "Gold",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-10-23",
  },
  {
    id: 4444,
    url: "https://www.tvmaze.com/shows/4444/trollied",
    name: "Trollied",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/44/110942.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/44/110942.jpg",
    },
    summary:
      "<p>Following the hapless staff of the fictional bargain supermarket chain Valco in Warrington.</p>",
    officialSite: "http://www.sky.com/new-search/trollied?q=Trollied",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 63,
      name: "Sky 1",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-08-04",
  },
  {
    id: 4445,
    url: "https://www.tvmaze.com/shows/4445/wild-britain-with-ray-mears",
    name: "Wild Britain with Ray Mears",
    genres: ["Adventure", "Nature", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51830.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51830.jpg",
    },
    summary:
      "<p>Adventurer and nature lover Ray Mears explores some of Britain's more inaccessible countryside to discover the wildlife living just outside our front door.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 135,
      name: "Channel 5",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-10-11",
  },
  {
    id: 4446,
    url: "https://www.tvmaze.com/shows/4446/us-them",
    name: "Us & Them",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51832.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51832.jpg",
    },
    summary:
      "<p>After six months of online flirting, a neurotic pharmaceutical copywriter named Gavin and a printing press employee named Stacey decide to meet -- with their best friends in tow. While Gavin lives in a New York apartment right below his parents, Stacey lives with her widowed mother, Gwen, in a tiny Pennsylvania town. Gwen is unnerved by her daughter's online relationship, as is Stacey's uncle, Brian, who has taken on the role of family protector. Gavin's mother lacks a filter and volume control, and his father unrealistically considers himself the family's voice of reason. As Stacey and Gavin try to make their relationship work, they learn that their family and friends turn out to be the biggest complications.</p><p><b>Us &amp; Them</b> is an American television series based on the British series Gavin &amp; Stacey created by James Corden and Ruth Jones, adapted to an American audience by David J. Rosen. On October 11, 2013, it was revealed that Fox had cut back the episode order from thirteen to seven episodes. In summer 2014, Vulture revealed that Fox would not air the show. The series was first broadcast in South Africa on M-Net. Entire 7 episodes were available on Korean major IPTV networks. However, in September 2018, streaming service Sony Crackle announced it would be streaming all seven episodes starting October 1, finally giving the show its American release.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1030,
      name: "M-Net",
      country: {
        name: "South Africa",
        code: "ZA",
        timezone: "Africa/Johannesburg",
      },
    },
    premiered: "2014-07-14",
  },
  {
    id: 4447,
    url: "https://www.tvmaze.com/shows/4447/czego-sie-boja-faceci-czyli-seks-w-mniejszym-miescie",
    name: "Czego się boją faceci, czyli seks w mniejszym mieście",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/175/439683.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/175/439683.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 335,
      name: "Polsat",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2003-09-12",
  },
  {
    id: 4448,
    url: "https://www.tvmaze.com/shows/4448/lets-dance-for-sport-relief",
    name: "Let's Dance for Sport Relief",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/34/86889.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/34/86889.jpg",
    },
    summary:
      "<p>Celebrities perform famous dance routines in front of a panel of judges to raise money for the Sport Relief appeal, with viewers voting for their favourites.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b01cmk9b",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-02-20",
  },
  {
    id: 4449,
    url: "https://www.tvmaze.com/shows/4449/satisfaction",
    name: "Satisfaction",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/32/82228.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/32/82228.jpg",
    },
    summary:
      "<p>Fresh and sexy, <b>Satisfaction</b> stars award-winning comedian Ryan Belleville <i>(The L.A. Complex)</i>, Luke Macfarlane <i>(Brothers &amp; Sisters)</i>, and Leah Renee <i>(The Playboy Club)</i>. The 13-episode comedy series centres on couple Maggie Bronson (Leah Renee) and Jason Howell (Luke Macfarlane), and their perpetually single friend and roommate Mark Movenpick (Ryan Belleville). Mining the trials and tribulations of young adulthood, <i>Satisfaction</i> is about struggling with the next step when you're torn between your immature past, and your potential future. Based on real-life experiences, <i>Satisfaction</i> takes a humorous look at everything from the fear of opening a joint bank account, to using a scurvy diagnosis to get out of a new job, to finally making friends with a new couple who turn out to be swingers.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 48,
      name: "CTV",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2013-06-24",
  },
  {
    id: 4450,
    url: "https://www.tvmaze.com/shows/4450/save-me",
    name: "Save Me",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51837.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51837.jpg",
    },
    summary:
      "<p>After choking on a hero sandwich in her kitchen and suffering a dramatic near-death experience, Beth Harper - an absentee wife and mother - is revived and claims she can now talk to God. Her teenage daughter Emily is horrified and her husband Tom is skeptical. To make matters worse, Tom's ex-mistress Carly McKenna is in a coma after a close encounter with lightning in the Harper's front yard.</p><p>As Beth warms up to her new life, she strives to make amends to the people she has alienated over the years, including friends and neighbors Jenna Dennings and Maggie Tompkins. Despite everyone's initial hesitancy, Beth begins to win people over with her new positive attitude, cheerful optimism and unbridled love.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-05-23",
  },
  {
    id: 4451,
    url: "https://www.tvmaze.com/shows/4451/saved",
    name: "Saved",
    genres: ["Drama", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51844.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51844.jpg",
    },
    summary:
      "<p>Wyatt Cole, a complicated yet charming young man struggling to find his place in life while coping with the breakneck pace of his consequence-ridden job as a paramedic on the streets of Portland, Oregon.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-06-12",
  },
  {
    id: 4452,
    url: "https://www.tvmaze.com/shows/4452/saved-by-the-bell-the-college-years",
    name: "Saved by the Bell: The College Years",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51845.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51845.jpg",
    },
    summary:
      '<p><b>Saved by the Bell: The College Years</b> was a spin-off of "Saved by the Bell". Zack, Screech, Slater, and Kelly went off to attend California University. They shared a dorm suite with two more girls, Alex and Leslie.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-05-22",
  },
  {
    id: 4453,
    url: "https://www.tvmaze.com/shows/4453/saved-by-the-bell-the-new-class",
    name: "Saved by the Bell: The New Class",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51846.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51846.jpg",
    },
    summary:
      "<p>The final chapter of the Saved by the Bell franchise features a new class after Zack and the others left. Mr. Belding is still there to make sure the kids don't get out of control, however things don't always go as planned at Bayside High School.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-09-11",
  },
  {
    id: 4454,
    url: "https://www.tvmaze.com/shows/4454/side-order-of-life",
    name: "Side Order of Life",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51850.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51850.jpg",
    },
    summary:
      '<p><b>Side Order of Life</b> is a thought-provoking and comedic drama centering on a young magazine photographer who suddenly re-evaluates her life and impending nuptials after receiving a "wake-up call from the universe."</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-07-15",
  },
  {
    id: 4455,
    url: "https://www.tvmaze.com/shows/4455/smith",
    name: "Smith",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51855.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51855.jpg",
    },
    summary:
      '<p><b>Smith</b> delves into the world of high stakes robberies, where Bobby Stevens (Liotta) finds himself leading a double life as the leader of a band of thieves who pull off intricate and ingenious jobs and then goes back to being the typical nine-to-five, suburban family man. The series, from executive producer John Wells, creator of "ER," will premiere with limited commercial interruption. Leading this close-knit crew of career criminals is Bobby Stevens (Liotta), who appears to be a regular family man with a nine-to-five job, but is actually an expert thief who is seeking just two or three more big paydays so he can finally leave the business for a comfortable, lawful lifestyle with his wife, Hope (Madsen), and their two children. While Bobby never discusses his illegal pursuits, Hope is growing suspicious. Bobby\'s second family, his core band of partners, each bring their own areas of expertise to pulling off the biggest and most sophisticated armed robberies. Joe (Franky G) is in charge of all things transportation oriented; Jeff (Baker), who is the most reckless of the bunch, is responsible for the firepower; Tom (Miller), is on parole after being busted during a previous caper and his sometime lover, Annie (Smart), is a beautiful master of disguise who can manipulate any situation with her looks. The FBI\'s, Agent Dodd (Bauer), has been following the robberies for some time, and remains determined to catch the team but is most interested in capturing "Smith," the police codename for the crew\'s mysterious leader and the brains behind the entire operation. It remains to be seen whether Bobby will be able to extricate himself in time from the scores that give him such a rush, or if his retirement will be a forced one -- behind bars.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-09-19",
  },
  {
    id: 4456,
    url: "https://www.tvmaze.com/shows/4456/sold",
    name: "Sold",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51863.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51863.jpg",
    },
    summary:
      "<p>A comedy drama about Matt, an estate agent, who inherits another branch and in turn Danny, who is an estate agent like no other. This is because he likes to find the buyers the perfect home rather than making a profit much to the dislike of Matt, who along with his team are used to playing dirty to make sure they get what they want.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2007-11-15",
  },
  {
    id: 4457,
    url: "https://www.tvmaze.com/shows/4457/south-beach",
    name: "South Beach",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51870.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51870.jpg",
    },
    summary:
      "<p>In <b>South Beach</b>, best friends Matt Evans and Vincent abandon their world as they know it and head to the alluring paradise of sandy beaches, beautiful people and hot spots in glamorous South Beach. Matt's preoccupation with his old girlfriend, fashion model Arielle, has him diving head first into her thrilling new life, even though she has moved on, and Vincent, willing to do anything to get ahead, uncovers the dangerous and seedy underbelly of one of the world's most sizzling locales.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 70,
      name: "UPN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-01-11",
  },
  {
    id: 4458,
    url: "https://www.tvmaze.com/shows/4458/spider-man",
    name: "Spider-Man",
    genres: ["Action", "Adventure", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51873.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51873.jpg",
    },
    summary:
      "<p><b>Spider-Man</b> continues where the successful live action feature film of the same name left off. The series follows the adventures of superhero Peter Parker and his friends, Harry Osborne and Mary Jane Watson, during their first year of college at Empire State University. Parker must juggle academics, a job as a Web designer/photographer for the Daily Bugle and an on-again, off-again relationship with the love of his life, all while fighting to protect the world from super-villains.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-07-11",
  },
  {
    id: 4459,
    url: "https://www.tvmaze.com/shows/4459/spooks-code-9",
    name: "Spooks: Code 9",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51875.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51875.jpg",
    },
    summary:
      "<p>In an alternative 2013, London has been evacuated following a nuclear bomb. Six new MI5 recruits take up the challenge of gathering intelligence in the fightback.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00d33bt",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-08-10",
  },
  {
    id: 4460,
    url: "https://www.tvmaze.com/shows/4460/st-elsewhere",
    name: "St. Elsewhere",
    genres: ["Drama", "Comedy", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51876.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51876.jpg",
    },
    summary:
      "<p>St. Eligius Hospital in South Boston was not exactly the world's best health care center. Despite its flaws, it featured some of the most caring doctors and nurses you could ever meet. Led by Dr. Donald Westphall (and later by Dr. Benjamin Gideon), St. Eligius became a sanctuary for the underdog and the downtrodden. <b>St. Elsewhere</b> ran on NBC for six seasons. Originally a ratings flop, NBC picked it up for a second season for the sole purpose of grabbing some additional Emmy nominations. It eventually became a minor hit for The Peacock, until burnout by the writers resulted in its 1988 cancellation. The series was nominated for 63 Emmy Awards and won 13.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1982-10-26",
  },
  {
    id: 4461,
    url: "https://www.tvmaze.com/shows/4461/stacked",
    name: "Stacked",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51877.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51877.jpg",
    },
    summary:
      "<p>You can't judge a book by its cover, especially when it's only covered by a miniskirt and baby-tee! A workplace ensemble comedy, <b>Stacked</b> revolves around beautiful Skyler Dayton who is tired of her non-stop partying lifestyle and bad choices in boyfriends. Wanting a major life change, she wanders into \"The Stacks,\" a small family-run bookstore owned by Gavin DeWitt and his brother, Stuart. Divorced and unlucky in love himself, Gavin's inclined to regard Skyler as an embodiment of the vacuous, image-obsessed culture he has come to abhor. Stuart, however, is dazzled by Skyler's beauty and, much to Gavin's horror, offers her a job at their store, which she happily accepts as the first step in her quest for a steadier lifestyle. Unhappy that she's going to be minding the till next to such an intimidating bombshell is the store's sole other employee, Katrina.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-04-13",
  },
  {
    id: 4462,
    url: "https://www.tvmaze.com/shows/4462/stark-raving-mad",
    name: "Stark Raving Mad",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755455.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755455.jpg",
    },
    summary:
      "<p><b>Stark Raving Mad</b> centers on eccentric horror author Ian Stark whose first novel, Below Ground, turns him into an overnight sensation. A practical-joker by nature, Ian spends the bulk of his time harassing his uptight new editor, Henry McNeely. Sharing Ian's loft apartment are Jake Donovan, his mindless assistant, and lovable but horny mutt Edgar. Living across the hall is Maddie Keller, who tends bar downstairs in the pub that the gang frequents. Henry's snobby girlfriend Tess Faraday spends a lot of time hanging out with Henry's new friends, though she resents them for taking up so much of Henry's time.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-09-23",
  },
  {
    id: 4463,
    url: "https://www.tvmaze.com/shows/4463/suddenly-susan",
    name: "Suddenly Susan",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/55/139977.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/55/139977.jpg",
    },
    summary:
      "<p>Workplace situation comedy centered on the character of Susan, a \"somewhat sheltered\" magazine writer who has dumped her rich fiancé at the altar and must now cope with being suddenly single - complicated by the fact that her boss at hip San Francisco magazine The Gate is her ex's brother Jack. He has promoted her from copy editor to writer of a column on being single in the '90s, thus irritating her co-workers: caustic lifestyle columnist Vicki, Cuban playboy. Susan's main support is her loving grandmother Nana. In highly publicized trouble before it ever aired, Suddenly Susan had to switch formats from a bookstore to a magazine workplace setting - sort of Mary Richards going to work for Lou Grant at the Trib.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-09-19",
  },
  {
    id: 4464,
    url: "https://www.tvmaze.com/shows/4464/the-adventures-of-superboy",
    name: "The Adventures of Superboy",
    genres: ["Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51886.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51886.jpg",
    },
    summary:
      "<p><b>Superboy </b>is a half-hour live-action television series based on the fictional DC Comics comic book character Superman's early years as Superboy. The show ran from 1988–1992 in syndication. It was renamed <b>The Adventures of Superboy</b> at the start of the third season.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1988-10-08",
  },
  {
    id: 4465,
    url: "https://www.tvmaze.com/shows/4465/surviving-suburbia",
    name: "Surviving Suburbia",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51887.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51887.jpg",
    },
    summary:
      "<p>In the family-centered tradition of Roseanne and Home Improvement, Surviving Suburbia opens the curtain to follow Saget (How I Met Your Mother, Full House) and Stevenson (Men in Trees, Dead Like Me) as Steve and Anne Patterson, a seemingly normal couple who have been married for 20 years, have two children and a cookie cutter house in the idyllic suburbs. But Steve maintains a rather cynical point of view on family, friends, neighbors, society -- pretty much everyone and everything -- as he tries to survive suburban life. Surviving Suburbia takes a contemporary look at family life and the reasons one might have to question the system -- How does exchanging keys with a neighbor for emergencies result in house sitting? Why do kids' classroom projects inevitably become the parents' responsibility? When did we start needing mediators to handle disagreements between adults? all of which goes to prove that it's never just another sunny day in the suburbs.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-04-06",
  },
  {
    id: 4466,
    url: "https://www.tvmaze.com/shows/4466/sweet-valley-high",
    name: "Sweet Valley High",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51888.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51888.jpg",
    },
    summary:
      "<p>Based on the best-selling book series, this show revolved around the lives of the Wakefield twins and their friends. Although they are absolutely identical, they have totally different personalities; Liz is everyone's best friend while Jessica is manipulative and devious. The show started out very drama-like, there was little comedic relief and dealt with serious, if not somber issues. As it progressed it took on a more lighthearted, comedic position. Although there were cast changes every season, a few stayed for all four years, including Brittany and Cynthia Daniel who played the Wakefield twins. Not only was the theme song an original song created just for the show, but the songs used throughout the episodes were too. A soundtrack was released in 1995 featuring the songs from the series.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 70,
      name: "UPN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1994-09-05",
  },
  {
    id: 4467,
    url: "https://www.tvmaze.com/shows/4467/t-j-hooker",
    name: "T. J. Hooker",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51889.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51889.jpg",
    },
    summary:
      "<p>After his partner was murdered, veteran plain clothes Detective <b>T.J. Hooker</b> had reverted back to his former role as Sergeant, and returned to the beat to rid the streets of the type of scum that was responsible for his partner's death. Back in uniform, Hooker was assigned to train the academy recruits, and was partnered with brash, sometimes hot-headed young rookie Vince Romano. With Romano much his junior, Hooker acted as his trainer and mentor on both a professional and social level. The age difference generally being the key hook of the partnership, the pair quickly became good friends and a good team. Hooker's tough, no-nonsense ways saw him often clashing with station Captain Sheridan, but he always got the job done and was highly respected as a result.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1982-03-13",
  },
  {
    id: 4468,
    url: "https://www.tvmaze.com/shows/4468/princesse-sarah",
    name: "Princesse Sarah",
    genres: ["Drama", "Anime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51891.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51891.jpg",
    },
    summary:
      "<p>Sara, a pretty girl born into a rich British family in India, is treated like a little princess at a dormitory school in London. Sara's sweet school life turns to tragedy when she learns of her father's death and the family's bankruptcy. However, Sara endures her hard luck with kindness and imagination and escapes from her misery through fantasies.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 131,
      name: "Fuji TV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1985-01-06",
  },
  {
    id: 4469,
    url: "https://www.tvmaze.com/shows/4469/tarzan",
    name: "Tarzan",
    genres: ["Drama", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51895.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51895.jpg",
    },
    summary:
      "<p>This thrilling, contemporary twist on the timeless legend of Tarzan turns the popular tale into an urban adventure, an intriguing mystery and, most of all, an unconventional crime drama. Two decades ago, young John Clayton's parents died in a plane crash and left him alone in the African jungle, where he grew up among apes and other wild animals. A solitary human in the pure and primal order of this untamed world, John Clayton emerged as the fearless <i>Tarzan</i> (newcomer Travis Fimmel). Captured by his billionaire uncle, Richard Clayton (Mitch Pileggi, The X-Files), the CEO of powerful Greystoke Industries, <i>Tarzan</i> is returned, against his will, to his family's home in New York City. Within the Clayton family, <i>Tarzan's</i> return has unleashed rivalries that have festered for decades. His uncle Richard is bitterly estranged from his younger sister Katherine Clayton the witty, sardonic and...</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-10-05",
  },
  {
    id: 4470,
    url: "https://www.tvmaze.com/shows/4470/the-rose-of-versailles",
    name: "The Rose of Versailles",
    genres: ["Drama", "Anime", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51901.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51901.jpg",
    },
    summary:
      "<p>General Jarjayes - so desperate for a son to preserve the family name and noble standing - names his newborn daughter ''Oscar'' and chooses to raise her as a boy. Fourteen years later, Oscar is a masterful duelist, marksman, and the newly appointed Commander of the French Royal Guards. Her first task: to protect Marie Antoinette, who is engaged to the French prince and future king, Louis-Auguste.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 157,
      name: "Animax",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1979-10-10",
  },
  {
    id: 4471,
    url: "https://www.tvmaze.com/shows/4471/the-best-laid-plans",
    name: "The Best Laid Plans",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51898.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51898.jpg",
    },
    summary:
      "<p>Parliament is a secret and esoteric world with its own culture, customs and language. THE BEST LAID PLANS is a rollicking journey into this cosseted world. Our guide is the earnest, hopeful, English PhD, Daniel Addison (played by Jonas Chernick), head speech writer for the Leader of the Opposition. When Daniel catches his girlfriend and her boss in flagrante delicto he decides to return to academe as assistant professor of English at the University of Ottawa. But you don't just walk away from the Opposition Party — freedom has a price and in this case it's finding a candidate in a riding 50 kilometers away and managing the campaign in the next election, scheduled in approximately eight weeks. The catch: the riding in question has voted solidly for the Government Party since Confederation and the incumbent is Eric Cameron, the extremely popular finance minister whose plurality in the last election was over 90%.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 36,
      name: "CBC",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2014-01-05",
  },
  {
    id: 4472,
    url: "https://www.tvmaze.com/shows/4472/the-best-years",
    name: "The Best Years",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51903.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51903.jpg",
    },
    summary:
      '<p><i><b>"The Best Years"</b></i>, the highly anticipated hour-long drama created by Aaron Martin (Degrassi: The Next Generation), follows orphaned and full-ride scholar, Samantha Best, as she starts her freshman year at the prestigious Charles University in Boston, Massachusetts. Samantha has been shuffled through the foster care system her entire life and is finally looking forward to a future of new opportunities and friendships. She has to contend with the ins and outs of college as she struggles to find her own identity.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 67,
      name: "Global",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2007-05-22",
  },
  {
    id: 4473,
    url: "https://www.tvmaze.com/shows/4473/the-bill-engvall-show",
    name: "The Bill Engvall Show",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51904.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51904.jpg",
    },
    summary:
      "<p><b>The Bill Engvall Show</b> follows Bill Pearson, a family counselor who's just struggling to understand his own children. There's his wife, Susan Pearson, who is a stay-at-home mom determined to keep her family in line, his teenage son, Trent Pearson who's attempting to live a teenage boy's life while trying to live up to his father's hopes, their teenage daughter, Lauren Pearson, who is struggling between the choices of going with her parents wishes or being rebellious and defying them, and then Bill's young son, Bryan Pearson, who is just being a the little kid he is and constantly getting into trouble for such things as his pet snake getting loose.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 32,
      name: "TBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-07-17",
  },
  {
    id: 4474,
    url: "https://www.tvmaze.com/shows/4474/defenders-of-the-earth",
    name: "Defenders of the Earth",
    genres: ["Action", "Fantasy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51905.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51905.jpg",
    },
    summary:
      "<p><b>Defenders of the Earth</b> is an animated television series of the 1980s featuring three characters from comic strips distributed by King Features Syndicate - Flash Gordon, The Phantom, and Mandrake the Magician - battling the Flash Gordon villain Ming the Merciless in the year 2015. Supporting characters include their children Rick Gordon, Jedda Walker (daughter of The Phantom), Kshin (adopted son of Mandrake), Mandrake's assistant Lothar, and Lothar's son L.J. The show lasted for 62 episodes; there was also a short-lived comic book series published by Star Comics (an imprint of Marvel Comics).</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1986-09-08",
  },
  {
    id: 4475,
    url: "https://www.tvmaze.com/shows/4475/the-border",
    name: "The Border",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51906.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51906.jpg",
    },
    summary:
      "<p><b>The Border</b> is a hard-driving drama series set against the backdrop of a post-9/11 turbulent world, confronting Canada's toughest border-security issues by focusing on the elite Immigration and Customs Security (ICS) Squad, who are charged with bringing order amid trafficking, terrorism, human cargo, asylum seekers and political corruption.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 36,
      name: "CBC",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2008-01-07",
  },
  {
    id: 4476,
    url: "https://www.tvmaze.com/shows/4476/thundercats",
    name: "ThunderCats",
    genres: ["Action", "Adventure", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51915.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51915.jpg",
    },
    summary:
      '<p>The inhabitants of the planet Thundera evacuate just before it is destroyed. They were pursued by a band of mutants. All but one of their escape ships was destroyed. Only a small group of Thunderans <i>(ThunderCats</i>) remained. With only half engine power, the group, which was led by Jaga, had to set a course for the nearest planet. Jaga commanded their ship while the other 7 were in their stasis tubes. Jaga died on their journey to Third Earth and their ship crashed there. Soon they made friends with various groups in the area and they designed a fortress. Mumm-Ra the centuries-old embodiment of evil, along with the mutants that destroyed the rest of the Thunderans are a constant threat. But Lion-O, the new leader of the ThunderCats, with his weapon the "Sword of Omens" will help the <i>Thundercats</i> to have a standing chance.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1985-01-23",
  },
  {
    id: 4477,
    url: "https://www.tvmaze.com/shows/4477/the-good-guys",
    name: "The Good Guys",
    genres: ["Comedy", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51927.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51927.jpg",
    },
    summary:
      "<p><b>The Good Guys</b> is an action-packed and comedic look at what happens when a washed-up, old-school cop and a by-the-book, modern-day detective try to expose the big picture of small crime.</p>",
    officialSite: "http://www.fox.com/goodguys/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-05-19",
  },
  {
    id: 4478,
    url: "https://www.tvmaze.com/shows/4478/the-super-mario-bros-super-show",
    name: "The Super Mario Bros. Super Show!",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51933.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51933.jpg",
    },
    summary:
      "<p>The Mario Bros; Mario and Luigi, were two plumbers from Brooklyn. On one of their plumbing jobs, they were in the middle of unclogging a bathtub drainpipe. Without any warning, the drain suddenly pulled the brothers in, and warped them to the Mushroom Kingdom. Upon their arrival, they rescued Princess Toadstool and Toad from King Koopa and his army. Although Princess Toadstool and Toad are now safe, the Koopas are still at large. On top of that, the warp zone leading to Brooklyn had closed. It's up to Mario and Luigi to not only liberate the Mushroom World from King Koopa, but to find a way back to Brooklyn.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1989-09-04",
  },
  {
    id: 4479,
    url: "https://www.tvmaze.com/shows/4479/the-goodwin-games",
    name: "The Goodwin Games",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51936.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51936.jpg",
    },
    summary:
      "<p>The inventive family comedy tells the story of three estranged siblings who return home after the loss of their beloved father, and unexpectedly find themselves poised to inherit more than $20 million - if, and only if, they can adhere to their late father's wishes.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-05-20",
  },
  {
    id: 4480,
    url: "https://www.tvmaze.com/shows/4480/the-help",
    name: "The Help",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51944.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51944.jpg",
    },
    summary:
      "<p>This outrageous satire centers on idealistic, 22-year-old Maria, who was on her way to becoming a beautician when a family crisis forced her to take a new path, and she now finds herself employed as the maid for the extremely wealthy Ridgeway family. As one of many servants who dote on the demented and dysfunctional family, Maria discovers there's not only a class struggle between the upstairs and the downstairs, but there's an all out war among <b>The Help</b>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-03-05",
  },
  {
    id: 4481,
    url: "https://www.tvmaze.com/shows/4481/the-hogan-family",
    name: "The Hogan Family",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51945.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51945.jpg",
    },
    summary:
      "<p><b>The Hogan Family</b> was originally titled Valerie, and was about Valerie Hogan and her husband Michael, an airline pilot. His job took him away from home quite regularly so Valerie was left to raise their three sons, David, and the fraternal twins, Mark and Willie. David was the oldest and girl crazy, Mark was the brain and a perfectionist and Willie was the carefree clown who seemed to always be in trouble.</p><p>At the beginning of the third season, the Valerie Hogan character was written out of the show and replaced by the boys' aunt, Sandy Hogan, acting as the surrogate mom. The show's title was changed to Valerie's Family, then The Hogans, and finally The Hogan Family.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1986-03-01",
  },
  {
    id: 4482,
    url: "https://www.tvmaze.com/shows/4482/the-adventures-of-super-mario-bros-3",
    name: "The Adventures of Super Mario Bros. 3",
    genres: ["Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51946.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51946.jpg",
    },
    summary:
      "<p>Everyone thought King Koopa had left the Mushroom Kingdom. Then his Doom Ship attacked! King Koopa is back with the greatest danger ever known: his Koopa kids. Using their new powers, the Super Mario Brothers must rescue Princess Toadstool and beat back the evil Koopa family.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1990-09-08",
  },
  {
    id: 4483,
    url: "https://www.tvmaze.com/shows/4483/norm",
    name: "Norm",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51947.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51947.jpg",
    },
    summary:
      "<p>The show focuses on the life of Norm Henderson, a former NHL hockey player who is banned for life from hockey due to gambling and tax evasion. In order to avoid jail time for these crimes, Norm must perform five years of community service as a full-time social worker.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-03-24",
  },
  {
    id: 4484,
    url: "https://www.tvmaze.com/shows/4484/tiny-toon-adventures",
    name: "Tiny Toon Adventures",
    genres: ["Comedy", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51954.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51954.jpg",
    },
    summary:
      "<p><b>Tiny Toon Adventures</b> is a kids-version of the classic Warner Bros. stars and their cartoons. This show is hosted by Buster and Babs Bunny (No relation!) and their friends Plucky Duck, an egotistical power crazy duck much like Daffy Duck, and Hamton Pig, a shy, kind-hearted pig with low self-esteem just like Porky Pig. The toons are constantly terrorized by Dizzy Devil, a purple version of Taz; Elmyra Duff, a dangerously childish, animal loving freak of nature which makes any animal who comes near her run; and rich kid Montana Max, who goes by the philosophy that rich people never pay and hates everyone and everything.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1990-09-14",
  },
  {
    id: 4485,
    url: "https://www.tvmaze.com/shows/4485/silverhawks",
    name: "SilverHawks",
    genres: ["Action", "Crime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51956.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51956.jpg",
    },
    summary:
      "<p>In the far-flung future, the Galaxy of Limbo is in dire need of some heroes. Terrorized by the ruthless villain Mon-Star and his intergalactic horde, the only hope against this tyranny are the partly metal, partly real cybernetically enhanced super-team: The <b>SilverHawks</b>. Led by the daring Quicksilver, the <i>SilverHawks</i> use their amazingly enhanced bodies, their razor sharp wits, and a steely resolve to battle Mon-Star and the forces of evil across the galaxy.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1986-09-08",
  },
  {
    id: 4489,
    url: "https://www.tvmaze.com/shows/4489/the-slap-maxwell-story",
    name: "The Slap Maxwell Story",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51965.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51965.jpg",
    },
    summary:
      "<p>Dabney Coleman played a self-centered sports writer with a lot of problems - among them, his ex-wife.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1987-09-23",
  },
  {
    id: 4490,
    url: "https://www.tvmaze.com/shows/4490/the-spectacular-spider-man",
    name: "The Spectacular Spider-Man",
    genres: ["Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/51967.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/51967.jpg",
    },
    summary:
      "<p>The line of Super Villains determined to take down Spidey seems never ending. There's Venom, Electro, Dr. Octopus, Sandman and Rhino - just to name a few. These criminals are almost more than he can handle and the stress would be enough to send a lesser Super Hero over the edge, but it's all in a day's work for <b>The Spectacular Spider-Man</b>™</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-03-08",
  },
  {
    id: 4501,
    url: "https://www.tvmaze.com/shows/4501/three-rivers",
    name: "Three Rivers",
    genres: ["Drama", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52001.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52001.jpg",
    },
    summary:
      "<p><b>Three Rivers</b> is a medical drama that goes inside the emotionally complex lives of organ donors, the recipients and the surgeons at the preeminent transplant hospital in the country, where every moment counts. However, dealing with donor families in their darkest hour and managing the fears and concerns of apprehensive recipients takes much more than just a sharp scalpel. Leading the elite team is Dr. Andy Yablonski, the highly-skilled workaholic lead organ transplant surgeon, whose good-natured personality and sarcastic wit makes him popular with his patients and colleagues. His co-workers include Dr. Miranda Foster, a surgical fellow with a rebellious streak and fiery temper who strives to live up to her deceased father's excellent surgical reputation; Dr. David Lee, a womanizing surgical resident who has broken as many hearts as he has replaced; Ryan Abbott, the inexperienced new transplant coordinator who arranges the intricately choreographed process of quickly and carefully transporting organs from donor to patient; Dr. Sophia Jordan, a brilliant surgeon at the top of her field and the head of surgery for the hospital, who has trained throughout the world, which gives her an extremely diverse point of view; Pam Acosta, Andy's no-nonsense operating assistant and best friend; and Dr. Lisa Reed, an E.R. doctor who is haunted by her past and compensates by doing everything she can to spare her patients from the pain she experienced at an early age. In this high stakes arena in which every case is a race against the clock, these tenacious surgeons and medical professionals are the last hope for their patients.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-10-04",
  },
  {
    id: 4505,
    url: "https://www.tvmaze.com/shows/4505/wanted",
    name: "Wanted",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52016.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52016.jpg",
    },
    summary:
      "<p><b>Wanted</b> is a pumping, stylistic, no-holds-barred look at an elite team of crime fighters from various federal and local law enforcement agencies as they track down the city's 100 most wanted fugitives. Each law officer brings something unique to this undercover strike force. This specialized team, the one the city calls on when the LAPD, SWAT and other units can't find the suspect.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-07-31",
  },
  {
    id: 4512,
    url: "https://www.tvmaze.com/shows/4512/my-favorite-martian",
    name: "My Favorite Martian",
    genres: ["Comedy", "Family", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52039.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52039.jpg",
    },
    summary:
      "<p>A Martian crash-lands on Earth and is taken in by young newspaper reporter Tim O'Hara. Disguised asTim's Uncle Martin, he attempts to repair his ship and keep himself out of trouble. But Tim's nosy landlady, Mrs. Brown, takes a liking to Uncle Martin, which complicates things, as does Uncle Martin's tendency to use his Martian powers at the wrong time.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1963-09-29",
  },
  {
    id: 4515,
    url: "https://www.tvmaze.com/shows/4515/camera-cafe",
    name: "Camera Café",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52042.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52042.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 334,
      name: "TVN",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: null,
  },
  {
    id: 4516,
    url: "https://www.tvmaze.com/shows/4516/four-rooms",
    name: "Four Rooms",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52043.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52043.jpg",
    },
    summary:
      "<p>New series in which people who believe they have a valuable artefact get a chance to sell it to four of the country's leading buyers. But, once they turn down an offer, there's no going back.</p>",
    officialSite: "http://www.channel4.com/programmes/four-rooms",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-05-24",
  },
  {
    id: 4517,
    url: "https://www.tvmaze.com/shows/4517/saint-seiya",
    name: "Saint Seiya",
    genres: ["Action", "Adventure", "Anime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52044.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52044.jpg",
    },
    summary:
      "<p>Ages ago, the goddess Athena was served by fighters called Saints who channeled the power of the Cosmos within them. Now a youth named Seiya has trained to become a Saint himself by earning the mystical Cloth of Pegasus. He is joined by other Saints with Cloths of their own to fight for Athena.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 263,
      name: "TV Asahi",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1986-10-11",
  },
  {
    id: 4520,
    url: "https://www.tvmaze.com/shows/4520/good-morning-miss-bliss",
    name: "Good Morning, Miss Bliss",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52054.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52054.jpg",
    },
    summary:
      '<p><b>Good Morning Miss Bliss</b> was about the life of Miss Carrie Bliss and her classmates. Her 8th grade students were Zack Morris, a charming, scheming boy, Lisa Turtle, a rich, fashionable girl, Samuel "Screech" Powers, an awkward nerd with a major crush on Lisa, Mikey Gonzalez, Zack\'s best friend who was often shy around girls, and Nicole "Nikki" Coleman, a smart, outspoken young girl who was good friends with Zack as well.</p><p>The show also featured eccentric, quirky teacher, Miss Tina Palladrino, who was Miss Bliss\' friend that she would often share her personal life with; Mr. Mylo Williams, the school maintenance supervisor who always followed the rules, and the principal, Mr. Richard Belding, who kept the school in line.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 78,
      name: "Disney Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1988-11-30",
  },
  {
    id: 4521,
    url: "https://www.tvmaze.com/shows/4521/the-larry-sanders-show",
    name: "The Larry Sanders Show",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/270/675623.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/270/675623.jpg",
    },
    summary:
      "<p>Comic Garry Shandling draws upon his own talk show experiences to create the character of Larry Sanders, a paranoid, insecure host of a late night talk show. Larry, along with his obsequious TV sidekick Hank Kingsley and his fiercely protective producer Artie, allows Garry Shandling and his talented writers to look behind the scenes and to show us a convincing slice of behind the camera life.</p>",
    officialSite: "https://www.hbo.com/the-larry-sanders-show",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 8,
      name: "HBO",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1992-08-15",
  },
  {
    id: 4524,
    url: "https://www.tvmaze.com/shows/4524/daleko-od-noszy-2",
    name: "Daleko od noszy 2",
    genres: ["Comedy", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52062.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52062.jpg",
    },
    summary: null,
    officialSite: null,
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 335,
      name: "Polsat",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2010-03-13",
  },
  {
    id: 4525,
    url: "https://www.tvmaze.com/shows/4525/rodney",
    name: "Rodney",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52063.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52063.jpg",
    },
    summary:
      "<p>Rodney Hamilton is a down-to-earth guy's guy who, with his own heartland intelligence, is never afraid to speak the truth. In the middle of real, everyday America, Rodney's life revolves around his family -- wife Trina and their two boys, Jack and Bo, his longtime friend, Barry, and his man-hungry sister-in-law, Charlie, a frequent visitor to the Hamilton house.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-09-21",
  },
  {
    id: 4527,
    url: "https://www.tvmaze.com/shows/4527/unnatural-history",
    name: "Unnatural History",
    genres: ["Action", "Adventure", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52065.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52065.jpg",
    },
    summary:
      "<p>Cartoon Network's first live-action mystery series delivers a new case of cinematic, action-packed comedic adventure each week. Unnatural History centers on Henry Griffin (Kevin G. Schmidt), a teenager with exceptional skills acquired through years of globetrotting with his anthropologist parents. When his parents think it's time for him to lead a normal high school life, they pack him off to live with his Uncle Bryan (Martin Donovan) and cousin Jasper (Jordan Gavaris) in Washington D.C. But this isn't just any high school; it's located on the grounds of The National Museum Complex. And as Henry, Jasper and their friend Maggie (Italia Ricci) soon learn, this museum is chock full of mysteries that will put Henry's worldly skills to the test.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-06-13",
  },
  {
    id: 4530,
    url: "https://www.tvmaze.com/shows/4530/toriko",
    name: "Toriko",
    genres: ["Adventure", "Anime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52077.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52077.jpg",
    },
    summary:
      "<p>Toriko is a hunter of precious foods regularly hired by restaurants and the rich. A man with superior skills to capture the ferocious, evasive and rare animals that complete the ultimate dinner courses. Komatsu, his current accomplice, is a timid chef inspired by Toriko's greatness. Together, Toriko and Komatsu, journey on the quest for the course of their lives.</p>",
    officialSite: "http://www.toei-anim.co.jp/tv/toriko/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 131,
      name: "Fuji TV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2011-04-03",
  },
  {
    id: 4531,
    url: "https://www.tvmaze.com/shows/4531/killer-couples",
    name: "Killer Couples",
    genres: ["Action", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/205/513101.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/205/513101.jpg",
    },
    summary:
      "<p><b>Killer Couples</b> features couples whose passion drives them to commit terrible criminal acts. Through recreations and gripping firsthand accounts, each episode takes a deep dive into the stories behind the couples' romance, how their relationship evolved once love turned into manipulation and what ultimately drove them to commit the crime.</p>",
    officialSite: "http://www.oxygen.com/killer-couples",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 79,
      name: "Oxygen",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-03-10",
  },
  {
    id: 4532,
    url: "https://www.tvmaze.com/shows/4532/biker-mice-from-mars",
    name: "Biker Mice from Mars",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52079.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52079.jpg",
    },
    summary:
      "<p>When their home planet, Mars is on the verge of destruction by the Plutarkians, a species of fish-like aliens who are searching for resources from other planets, a bunch of Humanoid Mice escape their world. Throttle, Vinnie, and Modo, a trio of Biker Mice from Mars were shot down by a Plutarkian Ship, and crash landed on Earth. On Chicago, Illinois, they become allies with a human mechanic named Charley. The Mice discover that the Plutarkians have started to make their move on th Earth. The Biker Mice quickly investigate, and discover that one of the city's leading citizens, Lawrence Limburger, is actually a Plutarkian in disguise, who is sending the land back to Plutark.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 70,
      name: "UPN",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1993-09-18",
  },
  {
    id: 4534,
    url: "https://www.tvmaze.com/shows/4534/tom-jerry-hanna-barbera-era",
    name: "Tom & Jerry (Hanna-Barbera era)",
    genres: ["Comedy", "Children", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52080.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52080.jpg",
    },
    summary:
      "<p>Created by William Hanna and Joseph Barbera, <i>Tom &amp; Jerry</i> is a classic animated cartoon centered on the never-ending rivalry between a cat (Tom) and mouse (Jerry), with an occasional appearance by the bulldog named Spike.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1940-02-10",
  },
  {
    id: 4536,
    url: "https://www.tvmaze.com/shows/4536/falcon-beach",
    name: "Falcon Beach",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52084.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52084.jpg",
    },
    summary:
      "<p>Filmed in the cottage community of Winnipeg Beach, the 13-part, one-hour series centres on a group of young people summering in the fictional lakeside resort town of Falcon Beach. It's about summer. It's about freedom. It's about young adults trying to define themselves for their lives ahead. But it's also about two worlds colliding -- that of the summer cottagers and that of the townies who live and work in Falcon Beach year-round. The show, which returns to Global in fall 2005 after a successful two-hour pilot episode, is a co-production of Toronto-based Insight Productions and Manitoba-based Original Pictures. Two slightly different versions have been produced: one for Canada and one for the United States, where the series airs on ABC Family and SOAPNet. Changes for the U.S. version include that the local town is in New England and that the Bradshaws are from Boston.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 67,
      name: "Global",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2006-01-05",
  },
  {
    id: 4537,
    url: "https://www.tvmaze.com/shows/4537/father-knows-best",
    name: "Father Knows Best",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52090.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52090.jpg",
    },
    summary:
      '<p><b>Father Knows Best</b> portrayed a family that was surprising similar to real people. The parents managed to ride through almost any family situation without violent injury to their dignity, and the three Anderson youngsters were presented as decently behaved children who respected and loved their parents. A newspaper critic at the time wrote that "Jim Anderson may be the first intelligent father permitted on TV since they invented the thing".</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1954-10-03",
  },
  {
    id: 4538,
    url: "https://www.tvmaze.com/shows/4538/hazel",
    name: "Hazel",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52120.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52120.jpg",
    },
    summary:
      "<p>Based on the Saturday Evening Post cartoons, the series centered around Hazel Burke, a maid, who for the first four seasons worked for the Baxter family. George Baxter was the head of the family which consisted of his wife, Dorothy and their son, Harold. Hazel ran the household and often preempted George's authority. The next door neighbors, Herbert and Harriet Johnson were occasionally seen. When the series moved to CBS in the fall of 1965, Hazel was given a new family to look after. George and Dorothy were transferred to the Middle East leaving Hazel and Harold behind. They moved in with George's brother, Steve and his family, which consisted of Steve's wife, Barbara and their daughter Susie.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1961-09-28",
  },
  {
    id: 4540,
    url: "https://www.tvmaze.com/shows/4540/eastwick",
    name: "Eastwick",
    genres: ["Drama", "Horror", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52094.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52094.jpg",
    },
    summary:
      '<p>Three very different women find themselves drawn together by a mysterious man who unleashes unique powers in each of them, and this small New England town will never be the same. The series is based on the popular movie "The Witches of Eastwick" and on the novel of the same title by John Updike.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-09-23",
  },
  {
    id: 4541,
    url: "https://www.tvmaze.com/shows/4541/easy-money",
    name: "Easy Money",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52108.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52108.jpg",
    },
    summary:
      "<p>Led by business-savvy matriarch Bobette Buffkin, Prestige Payday Loans is a thriving quick-cash company in the Southwest. But trouble soon comes from thuggish new competitors, and it's up to middle son Morgan to quash any tension. Morgan, though, is having some tension of his own. Having always felt out of place in the Buffkin household, Morgan investigates a childhood secret with the help of beautiful grad student Julia Miller much to Bobette's chagrin. Morgan has always been Prestige's heavy, running down ne'er-do-wells and gambling addicts, but he's ashamed to admit that fact to Julia. It doesn't help that Morgan's older, but less mature, brother Cooper knocks heads with corrupt local Detective Yapp who, in turn, blackmails Morgan. If Morgan can find a way to fend off the local yokels and unlock the secrets of his past, he just might be able to spend more time with Julia and find a better life for himself.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-10-05",
  },
  {
    id: 4542,
    url: "https://www.tvmaze.com/shows/4542/family-tools",
    name: "Family Tools",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52109.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52109.jpg",
    },
    summary:
      "<p><b>Family Tools</b> is a family comedy that proves mixing family with business is never easy.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-05-01",
  },
  {
    id: 4543,
    url: "https://www.tvmaze.com/shows/4543/fast-track",
    name: "Fast Track",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52116.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52116.jpg",
    },
    summary:
      '<p><b>Fast Track</b> was a drama set at the auto race track in the fictional U.S. town of Eagle Ridge, focusing on the track doctor who\'s also a former driver. Other characters included the morally ambivalent owner of the track, his younger sister/associate who had a thing for "Dr. Beckett", a photographer, the ex-"Mrs. Chandler" and former love of "Beckett"\'s, and Rogers (who also served as a technical consultant) the owner of the local bar. Even with a number of diverse characters and the potential for a fast pased series, Fast Track was cancelled after first season.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1997-08-03",
  },
  {
    id: 4544,
    url: "https://www.tvmaze.com/shows/4544/ferris-bueller",
    name: "Ferris Bueller",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52119.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52119.jpg",
    },
    summary:
      '<p>Based on the popular feature film "Ferris Bueller\'s Day Off," this half hour situation comedy followed the high school adventures of Ferris Bueller and his friends.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1990-08-23",
  },
  {
    id: 4545,
    url: "https://www.tvmaze.com/shows/4545/free-ride",
    name: "Free Ride",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52121.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52121.jpg",
    },
    summary:
      "<p><b>Free Ride</b> is a partially improvised comedy that follows recent UC Santa Barbara graduate Nate Stahlings as he boomerangs home to move back in with his parents in their small Midwestern town, Johnson City, MO.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-03-01",
  },
  {
    id: 4546,
    url: "https://www.tvmaze.com/shows/4546/americas-secret-slang",
    name: "America's Secret Slang",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/322/807241.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/322/807241.jpg",
    },
    summary:
      "<p>Horse of a Different Color. Black Sheep. Wrong Side of the Tracks. These are common expressions we use every day in America. But what's the history behind these phrases? Find out in the new season of <b>America's Secret Slang</b>, where in each episode host Zach Selwyn will reveal the hidden history behind our favorite sayings, clichés and oddly sounding words.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-04-14",
  },
  {
    id: 4547,
    url: "https://www.tvmaze.com/shows/4547/big-history",
    name: "Big History",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52123.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52123.jpg",
    },
    summary:
      "<p>Each episode of <b>Big History</b> will begin with an iconic topic from the pages of traditional history such as the Great Pyramids, The Titanic or the American Revolution but then will spin into surprising journeys through other fields, weaving together insights and evidence from various disciplines such as astronomy, physics, chemistry, biology, anthropology, history and economics. Spanning 13.7 billion years, Big History will ultimately pull together the puzzle pieces from all 16 half-hour episodes into an epic two-hour finale, creating one grand narrative and revealing the unifying link among all events.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-11-02",
  },
  {
    id: 4548,
    url: "https://www.tvmaze.com/shows/4548/decoding-the-past",
    name: "Decoding the Past",
    genres: ["Mystery", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52125.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52125.jpg",
    },
    summary:
      "<p>The History Channel series examining ancient mysteries related not only to a possible Bible Code and predictions of catastrophes, but also the prophecies of Nostramdamus, the Shroud of Turin, and secret societies said to guard forbidden knowledge.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-07-25",
  },
  {
    id: 4549,
    url: "https://www.tvmaze.com/shows/4549/historys-mysteries",
    name: "History's Mysteries",
    genres: ["Mystery", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52126.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52126.jpg",
    },
    summary:
      "<p><b>History's Mysteries</b> explores stories, events and legends that have intrigued us for generations and started debate in countless time periods. No subject is left untouched in this shows quest for answers.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-01-01",
  },
  {
    id: 4550,
    url: "https://www.tvmaze.com/shows/4550/hooked-illegal-drugs-and-how-they-got-that-way",
    name: "Hooked: Illegal Drugs and How They Got That Way",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52127.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52127.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-01-01",
  },
  {
    id: 4551,
    url: "https://www.tvmaze.com/shows/4551/mega-disasters",
    name: "Mega Disasters",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52128.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52128.jpg",
    },
    summary:
      "<p>Massive natural disasters have shaped the planet on which we live for millions of years, and the only thing we know for sure is that the future holds more. Earthquakes have triggered massive tsunamis and released methane gas that killed most of the life in the ocean. Asteroids have laid waste to nearly all the life on earth. Volcanoes have blocked the sun's rays for months. How would today's world hold up to such fury? As the devastation caused by Hurricane Katrina and the 2004 Indian Ocean tsunami have dramatically demonstrated, we are all vulnerable to unexpected disasters, both natural and man-made. Combining science and history, MEGA DISASTERS visits the sites of previous disasters, then recreates them in modern times and locations, using state-of-the-art computer animation. Whether it's the city of Memphis crashing into the Mississippi River during an earthquake or a mile-wide asteroid destroying Los Angeles, each week is a hair-raising look at just how vulnerable our complex society really is to the power of Mother Nature.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-05-23",
  },
  {
    id: 4552,
    url: "https://www.tvmaze.com/shows/4552/good-morning-miami",
    name: "Good Morning, Miami",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52129.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52129.jpg",
    },
    summary:
      "<p>A failing TV talk show lures a hotshot producer, who's initially attracted to its attractive hairstylist, but seems less interested in the problems of the bickering cohosts and the flustered station manager.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-09-26",
  },
  {
    id: 4553,
    url: "https://www.tvmaze.com/shows/4553/good-sports",
    name: "Good Sports",
    genres: ["Comedy", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52130.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52130.jpg",
    },
    summary:
      "<p>Farrah Fawcett plays Gayle Roberts, a former model and Sports Illustrated cover girl who wants to be taken seriously as a broadcast journalist She's a co-anchor on an all-sports network along the lines of ESPN. Ryan O'Neal plays \"Downtown\" Bobby Tannen, a man whose talents have always been overshadowed by his self-destructiveness. A star receiver on the Jets' Super Bowl champion team back in '69, Bobby is famous mostly for wasted talent. He once quit football to marry and manage the career of a juggling stripper. His return to the NFL was cut short, first when he punched out a reporter and then when he ended up in jail for tax evasion. Now. he's a 42-year-old pizza delivery man.</p><p>But the on-camera death of Gayle's co-anchor leaves an opening at RSCN. Mr. Rappaport (Lane Smith), a Ted Turnerish cable mogul, spots Bobby on \"Where Are They Now\" and immediately tabs him as the new co-anchor.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1991-01-10",
  },
  {
    id: 4554,
    url: "https://www.tvmaze.com/shows/4554/growing-up-fisher",
    name: "Growing Up Fisher",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52131.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52131.jpg",
    },
    summary:
      "<p><b>Growing Up Fisher </b>follows Mel Fisher, the proud family patriarch who does not let his blindness affect him as a father, husband and breadwinner.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-02-23",
  },
  {
    id: 4555,
    url: "https://www.tvmaze.com/shows/4555/shootout",
    name: "Shootout!",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52137.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52137.jpg",
    },
    summary:
      "<p>Take aim from both sides of the fight. <b>Shootout!</b> examines the personalities, the weapons, the firepower, and the leadership needed to defeat the enemy. With 3D CGI animation sequences and testimony from scholars and experts, the battles come alive as they looked to the soldiers and shooters themselves.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-07-19",
  },
  {
    id: 4556,
    url: "https://www.tvmaze.com/shows/4556/hearts-afire",
    name: "Hearts Afire",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52138.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52138.jpg",
    },
    summary:
      "<p><b>Hearts Afire</b> was a romantic comedy set in Washington, D.C. and centered on a senator's aide and a political reporter whose professional disagreements masked a growing attraction for one another. The series was itself a satire on current affairs in Washington, D.C.</p><p>In the second season, the show abruptly changed its setting to the Southern town where John Hartman grew up; he returns to take over the town's failing newspaper, and his wife and several of the other cast members joined him there.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1992-09-14",
  },
  {
    id: 4557,
    url: "https://www.tvmaze.com/shows/4557/intelligence",
    name: "Intelligence",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52139.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52139.jpg",
    },
    summary:
      "<p>A police/crime drama in which major figures on both sides of the law - a mob boss and the head of a police intelligence unit - make a deal that benefits each but could ultimately destroy them both.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 36,
      name: "CBC",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2006-10-10",
  },
  {
    id: 4558,
    url: "https://www.tvmaze.com/shows/4558/aliens-in-america",
    name: "Aliens in America",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52140.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52140.jpg",
    },
    summary:
      "<p><b>Aliens in America</b> is about an American teenager in Wisconsin whose family takes in a Muslim foreign exchange student from Pakistan.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-10-01",
  },
  {
    id: 4559,
    url: "https://www.tvmaze.com/shows/4559/american-body-shop",
    name: "American Body Shop",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52146.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52146.jpg",
    },
    summary:
      "<p>Smashed windshield? Dented fender? Beat paint job? Think it's time to bring your ride in for some TLC? Well, maybe you should think again. If you drop your car off at Desert Body &amp; Custom, it may be the last time you ever see it. In one piece, at least. Sam is the head of <b>American Body Shop's </b>dysfunctional family, fighting to raise his fledgling business from bankruptcy while simultaneously trying to keep his employees — Tim, Denise, Rob, Luis and Brooklyn Johnny — from killing each other and themselves.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 23,
      name: "Comedy Central",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-07-08",
  },
  {
    id: 4560,
    url: "https://www.tvmaze.com/shows/4560/american-dreams",
    name: "American Dreams",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755456.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755456.jpg",
    },
    summary:
      '<p>In 1963 Philadelphia, the Pryors are a close Irish-Catholic family. World War II veteran John "Jack" Pryor owns a television and radio store. He and his homemaker wife Helen have five children: High school senior and football player "JJ", younger sisters Meg and Patty, and younger brother Will, who is lame from polio. </p><p>The show depicts historical events, such as the assassination of John F. Kennedy, 1964 Philadelphia race riot, and American involvement in—and opposition to—the Vietnam War.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-09-29",
  },
  {
    id: 4561,
    url: "https://www.tvmaze.com/shows/4561/first-dates",
    name: "First Dates",
    genres: ["Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/321/802990.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/321/802990.jpg",
    },
    summary:
      "<p>The<b> First Dates</b> restaurant throws open its doors to single people looking for love.</p>",
    officialSite: "http://www.channel4.com/programmes/first-dates",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-06-20",
  },
  {
    id: 4562,
    url: "https://www.tvmaze.com/shows/4562/young-james-herriot",
    name: "Young James Herriot",
    genres: ["Drama", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52150.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52150.jpg",
    },
    summary:
      "<p>The adventures of James Herriot in his early years as a student vet at Glasgow Veterinary College. Inspired by the character and early works of James Herriot.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b018tvsq",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-12-18",
  },
  {
    id: 4563,
    url: "https://www.tvmaze.com/shows/4563/cops",
    name: "C.O.P.S.",
    genres: ["Action", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52198.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52198.jpg",
    },
    summary:
      "<p><b>C.O.P.S.</b> (Central Organization of Police Specialists) is an American animated television series released by DIC Entertainment (distributed by Claster Television) and Celebrity Home Entertainment (some VHS tapes went through Golden Book Video, though). This cartoon, which ran from 1988 to 1989, used the tag line: \"Fighting crime in a future time, protecting Empire City from Big Boss and his gang of crooks\". In 1993, the series was shown in reruns on CBS Saturday mornings as CyberCOPS, the name change due to the 1989 debut of the unrelated primetime reality show of the same name. The show was based on Hasbro's 1988 line of action figures called C.O.P.S 'N' Crooks.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1988-10-05",
  },
  {
    id: 4564,
    url: "https://www.tvmaze.com/shows/4564/tom-jerry-chuck-jones-era",
    name: "Tom & Jerry (Chuck Jones era)",
    genres: ["Comedy", "Children", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52199.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52199.jpg",
    },
    summary:
      "<p>The following 34 cartoons were produced by Chuck Jones in Hollywood, California, and released to theaters by Metro-Goldwyn-Mayer.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1963-07-27",
  },
  {
    id: 4565,
    url: "https://www.tvmaze.com/shows/4565/tom-jerry-gene-deitch-era",
    name: "Tom & Jerry (Gene Deitch era)",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/290/726122.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/290/726122.jpg",
    },
    summary:
      "<p>After the end of the Original 160 Shorts made by William Hanna &amp; Joseph Barbera ,MGM revived the <i>Tom and Jerry</i> franchise, and contracted European animation studio Rembrandt Films to produce 13 <i>Tom and Jerry</i> shorts  All were directed by Gene Deitch and produced by William L. Snyder.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1961-09-07",
  },
  {
    id: 4566,
    url: "https://www.tvmaze.com/shows/4566/odyssey-5",
    name: "Odyssey 5",
    genres: ["Drama", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52201.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52201.jpg",
    },
    summary:
      "<p>This is the story of four astronauts, a scientist, and a television news reporter. During a routine shuttle mission in 2007, they watch in astonishment as the Earth rapidly dissolves into a fiery ball and then suddenly implodes. Resigned to death, the crew is saved by an alien known only as the Seeker. The Seeker has been trying to discover what is causing the destruction that has befallen the Earth and many other planets. He has always arrived too late, until now. He offers the crew of the Odyssey a chance to go back in time five years, try to find out what will cause the Earth to explode and prevent it. While the team searches for the truth and for who or what is behind it, they must also deal with being back in the past with memories of what is to come. Along the way they learn that their actions in the past can have a direct outcome for the future.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-06-21",
  },
  {
    id: 4567,
    url: "https://www.tvmaze.com/shows/4567/how-not-to-live-your-life",
    name: "How Not to Live Your Life",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52207.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52207.jpg",
    },
    summary:
      "<p>Sitcom about 20-something Don, a man with bad luck and even worse instincts.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00hwcjg",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-08-12",
  },
  {
    id: 4568,
    url: "https://www.tvmaze.com/shows/4568/auction-hunters",
    name: "Auction Hunters",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52210.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52210.jpg",
    },
    summary:
      '<p>Clinton "Ton" Jones and Allen Haff, are two of the best auction prospectors in the business. Every day in America, over ten thousand abandoned storage units are put up for public auction. Add to that the countless estate, boat, car and consignment auctions and the potential to hit a goldmine is staggering. This series follows Allen and Ton in their quest to win auctions, acquire treasure, and sell it for profit.</p>',
    officialSite: "http://www.spike.com/shows/auction-hunters",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 34,
      name: "Paramount Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-12-09",
  },
  {
    id: 4569,
    url: "https://www.tvmaze.com/shows/4569/bent",
    name: "Bent",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52211.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52211.jpg",
    },
    summary:
      '<p><b>Bent</b> is a romantic comedy about a recently divorced "type A" single mother who tries hard not to fall for the sexy "surfer-dude" contractor she hires to re-do her kitchen.</p>',
    officialSite: "https://www.nbc.com/bent",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-03-21",
  },
  {
    id: 4570,
    url: "https://www.tvmaze.com/shows/4570/brotherhood",
    name: "Brotherhood",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52212.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52212.jpg",
    },
    summary:
      '<p>Set against the disparate worlds of politicians and mob bosses, looks at how gray good and evil can be. Placed in a fictional Irish neighborhood in Providence, Rhode Island known as "The Hill," the series explores what lengths people go to achieve the elusive American dream. Focusing on two brothers on opposite sides of the law, determined to protect the neighborhood and what is theirs by whatever means necessary, the show is a gritty look at politics and the Mafia.</p>',
    officialSite: "http://www.sho.com/brotherhood",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-07-09",
  },
  {
    id: 4571,
    url: "https://www.tvmaze.com/shows/4571/boy-meets-girl",
    name: "Boy Meets Girl",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52219.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52219.jpg",
    },
    summary:
      "<p>Dreamer Danny Reed's life is turned upside down when he is struck by lightning and wakes to find himself trapped in a woman's body. Instead of being a scruffy DIY store worker with no prospects, he has now swapped lives with glamorous female fashion journalist Veronica Burton. Danny suddenly must learn how to walk in stilettos and put on a bra, deal with the amorous advances of Veronica's boyfriend Jay and pass himself off as a fashion expert while also finding out what has happened to his old self.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-05-01",
  },
  {
    id: 4572,
    url: "https://www.tvmaze.com/shows/4572/demons",
    name: "Demons",
    genres: ["Drama", "Action", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52221.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52221.jpg",
    },
    summary:
      "<p><b>Demons</b> is set above and beneath the streets of modern-day London, and follows a character called Luke, who is destined to fight vampires.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-01-03",
  },
  {
    id: 4573,
    url: "https://www.tvmaze.com/shows/4573/dear-john",
    name: "Dear John",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52226.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52226.jpg",
    },
    summary:
      "<p>John Lacey joins a support group for divorced and widowed people.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1988-10-06",
  },
  {
    id: 4575,
    url: "https://www.tvmaze.com/shows/4575/drop-dead-gorgeous",
    name: "Drop Dead Gorgeous",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/34/86891.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/34/86891.jpg",
    },
    summary: "<p>Comedy drama series about a young model and her family.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b007w3jz",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-06-11",
  },
  {
    id: 4577,
    url: "https://www.tvmaze.com/shows/4577/lax",
    name: "LAX",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52232.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52232.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-09-13",
  },
  {
    id: 4578,
    url: "https://www.tvmaze.com/shows/4578/attack-no1",
    name: "Attack No.1",
    genres: ["Drama", "Anime", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52240.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52240.jpg",
    },
    summary:
      "<p>Kozue is a highschool girl and enthusiastic volleyball player. Her dream is to play in the Japanese national volleyball team. During the series she makes it from the school district league up to the Japanese volleyball finals, step by step till the international volleyball championship. But the faster and higher Kozue climbs the career ladder up, the more she gets confronted with the dark side of success: too high expectations, self-conceit and envy are progressing towards serious problems.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 131,
      name: "Fuji TV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "1969-12-07",
  },
  {
    id: 4579,
    url: "https://www.tvmaze.com/shows/4579/inspector-gadget",
    name: "Inspector Gadget",
    genres: ["Action", "Adventure", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52242.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52242.jpg",
    },
    summary:
      "<p>A police officer (with a cyborg body full of gadgets and also a transforming car) works criminal cases for the Chief of Police, fighting various schemes by criminal organization M.A.D (with hidden help from his genius niece Penny and her pet dog Brain).</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1983-09-10",
  },
  {
    id: 4580,
    url: "https://www.tvmaze.com/shows/4580/made-in-jersey",
    name: "Made in Jersey",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52244.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52244.jpg",
    },
    summary:
      "<p><b>Made in Jersey</b> is a drama about a young working-class woman who uses her street smarts to compete among her pedigreed Manhattan colleagues at a prestigious New York law firm. Martina Garretti finds her firm's cutthroat landscape challenging, but what she lacks in an Ivy League education she more than makes up for with tenacity and blue-collar insight. After just a few weeks, firm founder Donovan Stark takes note of Martina's ingenuity and resourcefulness, as does third-year chair Nolan Adams, who is part of Manhattan's royal literati; Riley Prescott, a second-year at Stark &amp; Rowan and the daughter of the former U.S. Ambassador to Sweden; her sassy secretary, Cyndi Vega; and River, a former LAPD detective turned firm investigator. With the support of her big Italian family, including her sexy older sister Bonnie and her encouraging mother Darlene, Martina is able to stay true to her roots as a bold, passionate lawyer on the rise in a new intimidating environment.</p>",
    officialSite: "http://www.cbs.com/shows/made_in_jersey/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-09-28",
  },
  {
    id: 4582,
    url: "https://www.tvmaze.com/shows/4582/the-jungle-book",
    name: "The Jungle Book",
    genres: ["Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52250.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52250.jpg",
    },
    summary:
      "<p>In the jungles of India, an orphaned human infant named Mowgli is taken in by a wolf pack under the sponsorship of the black panther, Bagheera. As Mowgli grows up with his canine family, he finds that he has a lot to learn about life in the jungle under the tutelage of Bagheera and Baloo the Bear. At the same time, Mowgli learns to thrive in his own way as he handles the threat of the tiger, Shere Khan and his minions. Throughout the boy's adventures, there is also the growing mystery of his origins and humanity that would change his life forever.</p>",
    officialSite: null,
    webChannel: null,
    language: "French",
    status: "Ended",
    network: {
      id: 795,
      name: "V",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: null,
  },
  {
    id: 4583,
    url: "https://www.tvmaze.com/shows/4583/the-smurfs",
    name: "The Smurfs",
    genres: ["Children", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52251.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52251.jpg",
    },
    summary:
      '<p><i><b>"The Smurfs"</b></i> is a comic and television franchise centred on a group of small blue fictional creatures called Smurfs, created and first introduced as a series of comic strips by the Belgian cartoonist Peyo (pen name of Pierre Culliford) on October 23, 1958. The original term and the accompanying language came during a meal Peyo was having with his colleague and friend André Franquin at the Belgian Coast. Having momentarily forgotten the word "salt", Peyo asked him (in French) to pass the schtroumpf. Franquin jokingly replied: "Here\'s the Schtroumpf — when you are done schtroumpfing, schtroumpf it back..." and the two spent the rest of that weekend speaking in "schtroumpf language". The name was later translated into Dutch as Smurf, which was adopted in English.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1981-09-12",
  },
  {
    id: 4584,
    url: "https://www.tvmaze.com/shows/4584/tom-jerry-kids-show",
    name: "Tom & Jerry Kids Show",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52253.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52253.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1990-09-08",
  },
  {
    id: 4585,
    url: "https://www.tvmaze.com/shows/4585/stone-cold-podcast-live",
    name: "Stone Cold Podcast Live",
    genres: ["Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52254.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52254.jpg",
    },
    summary:
      "<p>Each month immediately following <i>Monday Night Raw</i>, the WWE Hall of Famer Stone Cold Steve Austin will sit down with the biggest names in WWE on <b>Stone Cold Podcast Live</b> including Hulk Hogan, The Undertaker, Sting and other celebrities from the world of sports and entertainment for an exclusive interview on WWE Network.</p>",
    officialSite: "http://network.wwe.com/shows/original/stone-cold-podcast",
    webChannel: {
      id: 15,
      name: "WWE Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2014-12-01",
  },
  {
    id: 4586,
    url: "https://www.tvmaze.com/shows/4586/andy-barker-pi",
    name: "Andy Barker, P.I.",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52255.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52255.jpg",
    },
    summary:
      "<p>Andy Richter re-teams with Conan O'Brien in this comedy as he portrays Andy Barker, an earnest, hard-working CPA who has succeeded at everything -- until his new accounting business fails to take off. But when he's mistaken for Lew Staziak, the retired private detective who used to occupy his storefront office, Andy embraces the twist of fate and dives into his double life. Andy's relentlessly supportive wife Jen isn't sold on this risky new venture, that is, until she notices a sudden boost in Andy's self-confidence. Andy's fellow strip-mall neighbors -- Simon and Wally join him in the dicey investigation.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-03-15",
  },
  {
    id: 4587,
    url: "https://www.tvmaze.com/shows/4587/andy-richter-controls-the-universe",
    name: "Andy Richter Controls the Universe",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52256.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52256.jpg",
    },
    summary:
      "<p><b>Andy Richter Controls the Universe</b><i>.</i> His own Universe! And we get to see what that looks and sounds like every moment. Even when the moments are not pretty. Andy is a short story writer, who makes his living by working at a huge faceless company in present day Chicago, writing Technical Manuals. In his active, fertile, writer's imagination, we see (and hear as he narrates) the stories of his daily life, as they should be, could be, might be, and even actually how they are. Andy shares his office with the company's newest employee, and Andy's newest friend, the frail, jumpy, odd, loveable Byron. Also inhabiting Andy's world is his best friend Keith, who is \"so good looking\" that Andy must fight his own \"prejudice against the 'attractive,' who seem to get everything they want, unlike ordinary humans.\" Supervisor Jessica.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-03-19",
  },
  {
    id: 4588,
    url: "https://www.tvmaze.com/shows/4588/anything-but-love",
    name: "Anything But Love",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/63/158536.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/63/158536.jpg",
    },
    summary:
      "<p><b>Anything But Love</b> was the story of Hannah Miller and her relationship with Marty Gold. After they meet Marty gets Hannah a job in research at the magazine where he works. Hannah, an aspiring writer, sees this as an opportunity to get into the business. The show was created by Wendy Kout and developed by Dennis Koenig. Creative differences between Wendy, Jamie &amp; Richard caused her to leave the series after the 1st season. When the show was picked up for the following fall season it had some revisions to the format. Marty, Hannah and Jules still worked at the magazine but other characters were replaced. A hip new editor was brought in and played to the hilt by performance artist Ann Magnuson. Holly Fulger was added to give Hannah a best friend to confide her thoughts about Marty with. One of the running bits between Hannah and Robin was that they called each other Mrs.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1989-03-07",
  },
  {
    id: 4589,
    url: "https://www.tvmaze.com/shows/4589/back-in-the-game",
    name: "Back in the Game",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52263.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52263.jpg",
    },
    summary:
      "<p>Terry Gannon Jr. was an All Star softball player until life threw her a few curve balls -- a baby, a lost college scholarship and a loser for a husband. After striking out on her own, Terry and her son, Danny, move in with her estranged father, Terry Sr., aka \"The Cannon\". The Cannon is an opinionated, beer-guzzling, ex-athlete who never quite made the cut either as a single father or professional baseball player. As hard as Terry tries to keep Danny away from the sports-driven lifestyle of her youth, Tommy wants to play Little League. His stunning lack of baseball skills (he doesn't even know which hand the mitt goes on) makes him the laughing stock of the baseball field and of his grandfather's living room. When Danny and a group of other athletically-challenged hopefuls fail to make the team, Danny's disappointment forces Terry to face her past. So when a wealthy neighbor volunteers to finance a team for the rejected kids, Terry reluctantly offers to coach the team of misfits.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-25",
  },
  {
    id: 4590,
    url: "https://www.tvmaze.com/shows/4590/beaver-falls",
    name: "Beaver Falls",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52272.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52272.jpg",
    },
    summary:
      "<p>Three British graduates blag jobs at an elite American summer camp. The guys want a summer of fun, but they have to set an example to the gorgeous teenage offspring of California's rich and powerful.</p>",
    officialSite: "http://www.channel4.com/programmes/beaver-falls",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 41,
      name: "E4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-07-27",
  },
  {
    id: 4591,
    url: "https://www.tvmaze.com/shows/4591/stacey-dooley-in-the-usa",
    name: "Stacey Dooley in the USA",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52390.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52390.jpg",
    },
    summary:
      "<p>Stacey Dooley reveals some shocking faces of youth in America.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b048vy8l",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-10-22",
  },
  {
    id: 4592,
    url: "https://www.tvmaze.com/shows/4592/sport-relief",
    name: "Sport Relief",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52391.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52391.jpg",
    },
    summary:
      "<p>Fundraising entertainment featuring famous faces from the worlds of sport and television.</p>",
    officialSite: "http://www.sportrelief.com",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2002-07-13",
  },
  {
    id: 4593,
    url: "https://www.tvmaze.com/shows/4593/springwatch",
    name: "Springwatch",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/320/801200.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/320/801200.jpg",
    },
    summary:
      "<p>Springwatch is an annual BBC television series which charts the fortunes of British wildlife during the changing of the seasons in the United Kingdom.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b007qgm3",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2005-05-30",
  },
  {
    id: 4594,
    url: "https://www.tvmaze.com/shows/4594/stacey-dooley-investigates",
    name: "Stacey Dooley Investigates",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52393.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52393.jpg",
    },
    summary:
      "<p>Series of documentaries in which Stacey Dooley investigates current affairs issues affecting young people around the world.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b03h2nqh",
    webChannel: {
      id: 71,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    language: "English",
    status: "To Be Determined",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-10-01",
  },
  {
    id: 4595,
    url: "https://www.tvmaze.com/shows/4595/project-runway-all-stars",
    name: "Project Runway All Stars",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52395.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52395.jpg",
    },
    summary:
      '<p>It\'s judgement day ... again on <b>Project Runway All Stars</b>! "Project Runway" fans – and more than a dozen of the Emmy® Award-nominated series\' past contestants – will have to wait no more. World-famous designers Isaac Mizrahi and Georgina Chapman will serve as judges on the new series, which will be hosted by supermodel Angela Lindvall and feature fashion tastemaker and Marie Claire Editor-in-Chief Joanna Coles as mentor for the "Runway" veterans. Guest judges include the iconic Miss Piggy, supermodel Miranda Kerr, musician and producer Pharrell Williams.</p>',
    officialSite: "http://www.mylifetime.com/shows/project-runway-all-stars",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 18,
      name: "Lifetime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-01-05",
  },
  {
    id: 4596,
    url: "https://www.tvmaze.com/shows/4596/rupauls-drag-race-all-stars",
    name: "RuPaul's Drag Race: All Stars",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/257/644412.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/257/644412.jpg",
    },
    summary:
      "<p>They come armed with stilettos, feathers, and sequins, prepared for a battle where one false move-or eyelash-could spell doom. They are the best of the best, the top queens from Drag Race seasons 1-4, and they're ready to lip-synch for their lives to determine which of these all-stars will claim the ultimate title and be declared Queen amongst queens. Join RuPaul as he welcomes back the most celebrated queens of the past for a special edition of Drag Race <b>RuPaul's Drag Race: All Stars</b> that promises to be the wildest, most jaw-dropping and outrageous Drag Race yet.</p>",
    officialSite:
      "https://www.paramountplus.com/shows/rupauls-drag-race-all-stars/",
    webChannel: { id: 107, name: "Paramount+", country: null },
    language: "English",
    status: "Running",
    network: null,
    premiered: "2012-10-22",
  },
  {
    id: 4597,
    url: "https://www.tvmaze.com/shows/4597/mary-queen-of-the-high-street",
    name: "Mary Queen of the High Street",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52397.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52397.jpg",
    },
    summary:
      "<p><b>Mary Queen of the High Street</b> follows Mary Portas as she fights for the country's failing high streets. With around 100 shops closing a week, she takes on the challenge of coming up with a 28-point plan, the Portas Review, to help breathe new life back into the high street.</p>",
    officialSite:
      "http://www.channel4.com/programmes/mary-queen-of-the-high-street",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-05-07",
  },
  {
    id: 4598,
    url: "https://www.tvmaze.com/shows/4598/motorway-cops",
    name: "Motorway Cops",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52399.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52399.jpg",
    },
    summary:
      "<p>Documentary series following the work of the traffic police as they enforce the law on some of Britain's busiest and most dangerous roads.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b01rqj3c",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-09-25",
  },
  {
    id: 4599,
    url: "https://www.tvmaze.com/shows/4599/mountain-goats",
    name: "Mountain Goats",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52400.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52400.jpg",
    },
    summary:
      "<p>Set around the antics of a ragtag group of Mountain Rescue volunteers, Mountain Goats celebrates the Highlands of Scotland, with proper kilt wearing maniacs fighting disaster on a weekly basis against the stunning backdrop of the Glencoe hills. When our heroes aren't out rescuing people, or being rescued themselves, they spend their time in 'The Old Goat' pub - a place of great warmth and camaraderie, where people come in for a quick pint and never want to leave. The regulars in the pub are Jimmy, an old school mountain goat with a fag burn in his jumper and a glint of mischief in his bloodshot eyes, the wild and mysterious Bill; Bernie, a cheery, hard-working woman, who keeps the others on the straight and narrow; and Conor, a handsome, easy-going young man who is more than a little bit naive. Their HQ is in the local pub, and the landlady is Jules - a formidable force of nature.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b066gfc7",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-08-14",
  },
  {
    id: 4600,
    url: "https://www.tvmaze.com/shows/4600/moving-on",
    name: "Moving On",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/143/359175.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/143/359175.jpg",
    },
    summary:
      "<p>Series of dramas linked by a central theme: how to 'move on' and pass turning points in life.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00vt2q1",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-05-18",
  },
  {
    id: 4601,
    url: "https://www.tvmaze.com/shows/4601/rhod-gilberts-work-experience",
    name: "Rhod Gilbert's Work Experience",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52402.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52402.jpg",
    },
    summary:
      "<p>Following comedian Rhod Gilbert as he tries out different jobs across Wales.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00zf3m1",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 352,
      name: "BBC One Wales",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-01-19",
  },
  {
    id: 4602,
    url: "https://www.tvmaze.com/shows/4602/world-trigger",
    name: "World Trigger",
    genres: ["Action", "Anime", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52403.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52403.jpg",
    },
    summary:
      "<p>A gate to another dimension has burst open, and from it emerge gigantic invincible creatures that threaten all of humanity. Earth's only defense is a mysterious group of warriors who have co-opted the alien technology in order to fight back!</p>",
    officialSite: "http://worldtrigger.info/",
    webChannel: null,
    language: "Japanese",
    status: "Running",
    network: {
      id: 263,
      name: "TV Asahi",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2014-10-05",
  },
  {
    id: 4603,
    url: "https://www.tvmaze.com/shows/4603/safe-house",
    name: "Safe House",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/52/130560.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/52/130560.jpg",
    },
    summary:
      "<p>Tom and Sam's world is turned upside down when news of a shocking crime breaks. Years previously Tom investigated a series of abductions perpetrated by an assailant known as 'The Crow', who took wives away from their husbands as they helplessly watched.</p>",
    officialSite: "http://www.itv.com/drama/safe-house",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-04-20",
  },
  {
    id: 4604,
    url: "https://www.tvmaze.com/shows/4604/gruen",
    name: "Gruen",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52407.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52407.jpg",
    },
    summary:
      '<p><i>The Gruen Transfer</i> is about advertising, how it works, and how it works on us. It decodes and defuses the commercial messages that swirl through our lives, with the help of a panel of ad industry experts. From Season 5 the show was renamed "Gruen Planet" and expanded the topics covered to include political and commercial "spin" as well as advertising. In 2015 it is re-named as <b>Gruen</b>.</p>',
    officialSite: "https://iview.abc.net.au/show/gruen/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 114,
      name: "ABC",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2008-05-28",
  },
  {
    id: 4605,
    url: "https://www.tvmaze.com/shows/4605/solsidan",
    name: "Solsidan",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52410.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52410.jpg",
    },
    summary:
      '<p>Felix Herngren\'s immensely popular comedy series "<b>Solsidan</b>" is about four friends who live in Saltsjöbaden outside Stockholm. Together, they struggle with problems and challenges that arise in life with housing, career, parenthood and relationships.</p>',
    officialSite: "http://www.tv4.se/solsidan",
    webChannel: null,
    language: "Swedish",
    status: "Running",
    network: {
      id: 123,
      name: "TV4",
      country: { name: "Sweden", code: "SE", timezone: "Europe/Stockholm" },
    },
    premiered: "2010-01-29",
  },
  {
    id: 4606,
    url: "https://www.tvmaze.com/shows/4606/diffrent-strokes",
    name: "Diff'rent Strokes",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52416.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52416.jpg",
    },
    summary:
      "<p><b>Diff'rent Strokes</b> is a sitcom that centered around millionaire widower Phillip Drummond, his two black adopted sons Arnold and Willis, and daughter Kimberly. Later seasons saw Drummond remarry and bring a new child, Sam, into the family. The show lasted eight seasons on two networks.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1978-11-03",
  },
  {
    id: 4607,
    url: "https://www.tvmaze.com/shows/4607/the-facts-of-life",
    name: "The Facts of Life",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52417.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52417.jpg",
    },
    summary:
      "<p>A group of girls attending a boarding school experience the joys and the trials of adolescence under the guiding hand of housemother Edna Garrett. Later in the series, Mrs. Garrett is promoted to school dietician, and four of the girls move into new quarters above the cafeteria. Eventually she leaves the school and opens her own business, with help from her girls.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1979-08-24",
  },
  {
    id: 4608,
    url: "https://www.tvmaze.com/shows/4608/duza-przerwa",
    name: "Duża przerwa",
    genres: [],
    image: null,
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 335,
      name: "Polsat",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2000-09-02",
  },
  {
    id: 4609,
    url: "https://www.tvmaze.com/shows/4609/dziupla-cezara",
    name: "Dziupla Cezara",
    genres: [],
    image: null,
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 335,
      name: "Polsat",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2004-03-20",
  },
  {
    id: 4610,
    url: "https://www.tvmaze.com/shows/4610/faceci-do-wziecia",
    name: "Faceci do wzięcia",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/175/439687.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/175/439687.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 336,
      name: "TVP1",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2006-09-10",
  },
  {
    id: 4611,
    url: "https://www.tvmaze.com/shows/4611/graczykowie-czyli-bula-i-spola",
    name: "Graczykowie, czyli Buła i spóła",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52418.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52418.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 335,
      name: "Polsat",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2001-01-14",
  },
  {
    id: 4612,
    url: "https://www.tvmaze.com/shows/4612/body-bizarre",
    name: "Body Bizarre",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/73/184179.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/73/184179.jpg",
    },
    summary:
      "<p>Criss-crossing the globe, <b>Body Bizarre</b> embarks on a voyage of discovery unlike any other. From India's child snake charmers to the world's hairiest girl, this series uncovers the real human stories behind the headlines. With deeply personal interviews and footage from the most unusual of day-to-day routines, it's an adventure through the truly astonishing.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 645,
      name: "TLC",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-07-14",
  },
  {
    id: 4613,
    url: "https://www.tvmaze.com/shows/4613/graczykowie",
    name: "Graczykowie",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52419.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52419.jpg",
    },
    summary: null,
    officialSite: null,
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 335,
      name: "Polsat",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "1999-02-02",
  },
  {
    id: 4614,
    url: "https://www.tvmaze.com/shows/4614/sunday-night-at-the-palladium",
    name: "Sunday Night at the Palladium",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52420.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52420.jpg",
    },
    summary:
      '<p><i><b>"Sunday Night at the Palladium"</b></i> features different acts from the world of show business performing in front of an audience at the famous London Palladium theatre.</p>',
    officialSite:
      "https://itvstudios.com/programmes/sunday-night-at-the-palladium",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-09-14",
  },
  {
    id: 4615,
    url: "https://www.tvmaze.com/shows/4615/supervet-in-the-field",
    name: "Supervet in the Field",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/176/440052.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/176/440052.jpg",
    },
    summary:
      "<p>Noel Fitzpatrick leaves his surgery to stage festivals for different dog lovers.</p>",
    officialSite: "https://www.thesupervet.com",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-08-12",
  },
  {
    id: 4616,
    url: "https://www.tvmaze.com/shows/4616/the-mill",
    name: "The Mill",
    genres: ["Drama", "History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52422.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52422.jpg",
    },
    summary:
      "<p>Powerful historical drama series, based on the lives of real people, telling the story of young 19th-century apprentices taking their lives into their own hands for the first time.</p>",
    officialSite: "http://www.channel4.com/programmes/the-mill",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-07-28",
  },
  {
    id: 4617,
    url: "https://www.tvmaze.com/shows/4617/paul-ogradys-animal-orphans",
    name: "Paul O'Grady's Animal Orphans",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52423.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52423.jpg",
    },
    summary:
      "<p>Animal lover Paul O'Grady travels to South Africa and Zambia to meet animals that have been orphaned in the wild in this new factual series.</p>",
    officialSite:
      "https://itvstudios.com/programmes/paul-o-grady-s-animal-orphans",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-01-14",
  },
  {
    id: 4618,
    url: "https://www.tvmaze.com/shows/4618/playhouse-presents",
    name: "Playhouse Presents",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52424.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52424.jpg",
    },
    summary:
      "<p>This Sky Arts series presents a new play each week, showcasing the best of British talent in writing, acting, and directing.</p>",
    officialSite: "http://www.sky.com/tv/show/playhouse-presents",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 69,
      name: "Sky Arts",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-04-12",
  },
  {
    id: 4619,
    url: "https://www.tvmaze.com/shows/4619/the-supervet-noel-fitzpatrick",
    name: "The Supervet: Noel Fitzpatrick",
    genres: ["Nature", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/321/804443.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/321/804443.jpg",
    },
    summary:
      "<p>Noel Fitzpatrick runs one of the most advanced veterinary practices in Britain and is known as the Bionic Vet. Some of the hardest-to-cure pets from across the country receive cutting-edge treatments and surgery here, from a team of over a hundred surgeons, nurses, ward attendants and physiotherapists. This series follows Noel and his team as they use their pioneering techniques to attempt to cure pets that might otherwise be beyond saving.</p>",
    officialSite: "http://www.channel4.com/programmes/the-supervet",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-05-07",
  },
  {
    id: 4620,
    url: "https://www.tvmaze.com/shows/4620/surprise-surprise",
    name: "Surprise, Surprise",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52426.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52426.jpg",
    },
    summary:
      "<p><b>Surprise, Surprise</b> sees different members of the studio audience being surprised as they are reunited with relatives they had not seen for a long time or they are offered the chance to make their dreams come true.</p>",
    officialSite:
      "https://itvstudios.com/studios/uk/programmes/surprise-surprise",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-10-21",
  },
  {
    id: 4621,
    url: "https://www.tvmaze.com/shows/4621/russell-howards-stand-up-central",
    name: "Russell Howard's Stand Up Central",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52427.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52427.jpg",
    },
    summary:
      "<p>In his first new show since 2009, Russell performs at the legendary Electric Ballroom alongside some of the best comics in the country. It's Russell's first ever TV stand up show and every week he's joined on the bill by two hand-picked comedians. He'll be performing brand new material while also answering questions from twitter and delving into the live audience.</p>",
    officialSite:
      "http://www.comedycentral.co.uk/russell-howards-stand-up-central",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 309,
      name: "Comedy Central",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-04-29",
  },
  {
    id: 4622,
    url: "https://www.tvmaze.com/shows/4622/sweat-the-small-stuff",
    name: "Sweat the Small Stuff",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/51/128144.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/51/128144.jpg",
    },
    summary:
      "<p>Nick Grimshaw hosts the panel show that makes a big deal about the little things in life.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b03dwndk",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-04-30",
  },
  {
    id: 4623,
    url: "https://www.tvmaze.com/shows/4623/pramface",
    name: "Pramface",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52444.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52444.jpg",
    },
    summary:
      "<p>Jamie and his best friend Mike are looking forward to a carefree summer as their exams are over and they're on mission to crash the sixth form party and get laid. 18-year-old Laura is convinced by her friend to attend the same party. Laura ends up in Jamie's nervous but willing arms. A few weeks later Laura realises that she's pregnant. When she informs Jamie she is shocked to find out that he's only 16.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p00n8w54",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-02-23",
  },
  {
    id: 4624,
    url: "https://www.tvmaze.com/shows/4624/take-me-out",
    name: "Take Me Out",
    genres: ["Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52454.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52454.jpg",
    },
    summary:
      "<p><b>Take Me Out</b> is a dating show presented by Paddy McGuinness. The show him playing matchmaker to 30 single women all of which are hoping to meet the man of their dreams. Different single men have to try and impress the women as they watch and the ladies can press a light to give their views on what they have seen.</p>",
    officialSite: "http://www.itv.com/takemeout#",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-01-02",
  },
  {
    id: 4625,
    url: "https://www.tvmaze.com/shows/4625/take-me-out-the-gossip",
    name: "Take Me Out: The Gossip",
    genres: ["Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52455.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52455.jpg",
    },
    summary:
      "<p><b>Take Me Out: The Gossip</b> is a spin off show from the popular <i>Take Me Out</i>. The show is presented by Zoe Hardman and Mark Wright and features behind-the-scenes activity and dating tales and trials.</p>",
    officialSite: "http://www.itv.com/takemeout",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 54,
      name: "ITV2",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-01-03",
  },
  {
    id: 4626,
    url: "https://www.tvmaze.com/shows/4626/teachers",
    name: "Teachers",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/158/395476.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/158/395476.jpg",
    },
    summary:
      "<p>Written by and starring acclaimed comedy troupe The Katydids, <b>Teachers</b> shows their hilariously warped perspective as six elementary school teachers trying to mold young minds, even though their own lives aren't really together.</p>",
    officialSite: "http://www.tvland.com/shows/teachers",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 57,
      name: "TV Land",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2016-01-13",
  },
  {
    id: 4627,
    url: "https://www.tvmaze.com/shows/4627/betrayal",
    name: "Betrayal",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52457.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52457.jpg",
    },
    summary:
      "<p>On <b>Betrayal</b>, a chance meeting between photographer Sara Hadley (Hannah Ware) and Attorney Jack McAllister (Stuart Townsend) leads to an instant and undeniable attraction. Sarah's husband, Drew (Chris Johnson), is a successful prosecutor with political aspirations, while Jack is married to Elaine (Wendy Moniz), the daughter of his boss, Thacher Karsten (James Cromwell). When Karsten's brother-in-law Lou is murdered, all evidence points to Karsten's son, T.J. (Henry Thomas). Jack, the company's lead counsel, will have to defend him, but for Sara's prosecutor husband, Drew, this is the kind of high-profile murder case that can secure his political future. Just as Sara and Jack's affair is starting, the lovers find themselves in an impossible situation -- on opposite sides of a murder investigation.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-29",
  },
  {
    id: 4628,
    url: "https://www.tvmaze.com/shows/4628/are-we-there-yet",
    name: "Are We There Yet?",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/78/196724.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/78/196724.jpg",
    },
    summary:
      "<p>America's favorite blended family is back in the neighborhood. Terry Crews and Essence Atkins star in this popular sitcom as a newly married couple adjusting to life as newlyweds and the complexities of raising children, while also dealing with the everyday challenges of romance, friendship and the drama of extended family. Teala Dunn and Coy Stewart co-star as Nick and Suzanne's children, 14-year-old Lindsey and 10-year-old Kevin. Keesha Sharp is Suzanne's best friend and coworker, Gigi, who has a taste for men and the finer things in life. Special guest star, Ice Cube will return as Suzanne's brother, Terrence. Recurring characters include Nick's best friend, Martin, played by comedian Christian Finnegan and Suzanne's mother, Marilyn, played by Telma Hopkins.</p>",
    officialSite: "http://www.tbs.com/shows/are-we-there-yet.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 32,
      name: "TBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-06-02",
  },
  {
    id: 4629,
    url: "https://www.tvmaze.com/shows/4629/co-ed-confidential",
    name: "Co-Ed Confidential",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/20/52492.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/20/52492.jpg",
    },
    summary:
      "<p>James and his friends return in the fourth installment of Cinemax's sexy collegiate romp, <b>Co-ed Confidential</b>. This time, the seniors face the challenges of senior year -- finances, career choice, commitment, and the prospect of life-after-college.</p>",
    officialSite: "http://www.cinemax.com/after-dark/co-ed-confidential/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 19,
      name: "Cinemax",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-11-02",
  },
  {
    id: 4630,
    url: "https://www.tvmaze.com/shows/4630/life-on-top",
    name: "Life on Top",
    genres: ["Drama", "Romance", "Adult"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52516.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52516.jpg",
    },
    summary:
      '<p>In the second season of <b>Life on Top</b>, the girls -- Bella, Melissa, Regina and Tippi -- search for love in the most unexpected places while living <i>"Life on Top"</i>. In the Season Two premiere, Bella explores her options for her career and her love life. Meanwhile, her roommate Melissa lands a gig as a party promoter at a new club; Regina discovers her old sexual bucket list and decides to check off a few more items; and Bella is intrigued by Vincent\'s new workout regimen.</p>',
    officialSite: "http://www.cinemax.com/after-dark/life-on-top/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 19,
      name: "Cinemax",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-10-03",
  },
  {
    id: 4631,
    url: "https://www.tvmaze.com/shows/4631/mork-mindy",
    name: "Mork & Mindy",
    genres: ["Drama", "Comedy", "Science-Fiction"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52522.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52522.jpg",
    },
    summary:
      "<p><b>Mork &amp; Mindy </b>is a spin-off from an episode of <i>Happy Days</i> seen in February 1978, in which an alien from the planet Ork lands on Earth and attempts to kidnap Richie. Mork is a misfit on his own planet because of his sense of humor, so the humorless Orkans send him off to study Earthlings, whose 'crazy' customs they had never been able to understand. Mork lands, in a giant eggshell, near Boulder, Colorado and is befriended by pretty Mindy McConnell, a clerk at a music store run by her father. Mork looks human, but his strange mixture of Orkan and Earthling customs leads most people to think of him as a nut.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1978-09-14",
  },
  {
    id: 4632,
    url: "https://www.tvmaze.com/shows/4632/modern-men",
    name: "Modern Men",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52527.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52527.jpg",
    },
    summary:
      "<p><b>Modern Men</b> offers a fresh male perspective on modern relationships. Tim Clarke, Kyle Brewster, and Doug Reynolds are childhood friends who, now in their late twenties, have arrived at different places in their lives when it comes to women. Desperate for advice and guidance in matters of the heart, they seek the help of Dr. Victoria Stangel, a renowned and beautiful life coach. The problems these three friends have with women are all over the emotional map. Doug can't move on from Allie, his high school sweetheart and ex-wife. Learning how to date again is especially tough for Doug since the last time he was single and looking was when he was 15. Kyle has the opposite problem. An inveterate Lothario, Kyle cavalierly jumps from woman to woman in order to hide the fact that, secretly, he's terrified that no one out there pictures him as the one.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-03-17",
  },
  {
    id: 4633,
    url: "https://www.tvmaze.com/shows/4633/midnight-caller",
    name: "Midnight Caller",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52537.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52537.jpg",
    },
    summary:
      "<p><b>Midnight Caller</b> is the moody drama starring Gary Cole as Jack Killian, a San Francisco cop who accidentally killed his partner. After leaving the police force, he ended up the host of a late-night radio talk show--with a penchant for getting involved with the problems of his listeners.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1988-10-25",
  },
  {
    id: 4634,
    url: "https://www.tvmaze.com/shows/4634/mvp-the-secret-lives-of-hockey-wives",
    name: "MVP: The Secret Lives of Hockey Wives",
    genres: ["Drama", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52539.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52539.jpg",
    },
    summary:
      "<p>His pampered wife ends up on the street. Their daughter sleeps with the hot new rookie. ...And the season hasn't even started yet! Welcome to the sexy, scandalous, fabulous world of MVP.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 36,
      name: "CBC",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2008-01-11",
  },
  {
    id: 4635,
    url: "https://www.tvmaze.com/shows/4635/my-secret-identity",
    name: "My Secret Identity",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52542.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52542.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 72,
      name: "Syndication",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1988-10-09",
  },
  {
    id: 4636,
    url: "https://www.tvmaze.com/shows/4636/my-two-dads",
    name: "My Two Dads",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52545.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52545.jpg",
    },
    summary:
      "<p>Joey and Michael, who fought over the same woman 13 years ago now have, upon her death, been awarded joint custody of her daughter - who might be either of theirs. So how do the men settle their problems? With a paternity test? No way. Instead, they all move in together to raise Nicole as a two-dad nuclear family. Under the watchful eye of the family court judge, dads and daughter adjust to their new situation.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1987-09-20",
  },
  {
    id: 4637,
    url: "https://www.tvmaze.com/shows/4637/property-brothers",
    name: "Property Brothers",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/214/536932.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/214/536932.jpg",
    },
    summary:
      "<p>Drew and Jonathan Scott have become household names in real estate and home renovation. And on <b>Property Brothers</b>, they're as determined as ever to help couples find, buy, and transform extreme fixer-uppers into incredible dream homes. First, real estate specialist Drew tracks down hidden gems with untapped potential, and then it's up to identical twin brother and contractor Jonathan to expertly overhaul these ramshackle properties. Convincing homebuyers to take a radical risk is their first challenge. Then they've got to deliver these ambitious renovation projects on time and on budget.</p>",
    officialSite: "https://www.hgtv.com/shows/property-brothers/episodes",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 192,
      name: "HGTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-01-04",
  },
  {
    id: 4638,
    url: "https://www.tvmaze.com/shows/4638/gortimer-gibbons-life-on-normal-street",
    name: "Gortimer Gibbon's Life on Normal Street",
    genres: ["Drama", "Mystery", "Supernatural"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/167/419276.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/167/419276.jpg",
    },
    summary:
      "<p>Life is anything but normal for Gortimer and his two best friends, Ranger and Mel, as they navigate Normal Street - an ordinary suburb that has a hint of something magical just beneath the surface.</p>",
    officialSite: "http://www.amazon.com/gp/video/detail/B00I3MPPDY/",
    webChannel: { id: 3, name: "Amazon Prime Video", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2014-02-06",
  },
  {
    id: 4639,
    url: "https://www.tvmaze.com/shows/4639/conspiracy-test",
    name: "Conspiracy Test",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755457.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755457.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 53,
      name: "History",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-08-13",
  },
  {
    id: 4640,
    url: "https://www.tvmaze.com/shows/4640/squadra-antimafia-palermo-oggi",
    name: "Squadra Antimafia - Palermo Oggi",
    genres: ["Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52555.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52555.jpg",
    },
    summary: "",
    officialSite: "http://www.fiction.mediaset.it/squadra/squadra.php",
    webChannel: null,
    language: "Italian",
    status: "Running",
    network: {
      id: 364,
      name: "Canale 5",
      country: { name: "Italy", code: "IT", timezone: "Europe/Rome" },
    },
    premiered: "2009-03-31",
  },
  {
    id: 4641,
    url: "https://www.tvmaze.com/shows/4641/corner-gas",
    name: "Corner Gas",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/206/515201.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/206/515201.jpg",
    },
    summary:
      "<p>Following the adventures of a bunch of nobodies who get up to a whole lot of nothing in the fictional prairie town of Dog River, Saskatchewan, <b>Corner Gas</b> focuses on the life (or lack thereof) of Brent LeRoy, proprietor of a gas station that is the only stop for miles around and a hub of action on the Prairies.</p>",
    officialSite: "https://www.cornergas.com/sitcom/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 48,
      name: "CTV",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2004-01-22",
  },
  {
    id: 4642,
    url: "https://www.tvmaze.com/shows/4642/heist",
    name: "Heist",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52574.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52574.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-03-22",
  },
  {
    id: 4643,
    url: "https://www.tvmaze.com/shows/4643/cheo-yong",
    name: "Cheo Yong",
    genres: ["Crime", "Fantasy", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52576.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52576.jpg",
    },
    summary:
      "<p>Detective Yoon Cheo Yong is able to see and hear ghosts since he was born. He solves mysteries and cases with the tough female detective Ha Sun Wo and the ghost of high school student Han Na Young.</p>",
    officialSite: "http://program.interest.me/ocn/cheo-yong",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 267,
      name: "OCN",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2014-02-09",
  },
  {
    id: 4644,
    url: "https://www.tvmaze.com/shows/4644/big-day",
    name: "Big Day",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52591.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52591.jpg",
    },
    summary:
      "<p>Alice and Danny find numerous obstacles plus unexpected details as they prepare to tie the knot. Their unusual friends and family with their expectations become a problem.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-11-28",
  },
  {
    id: 4645,
    url: "https://www.tvmaze.com/shows/4645/bosom-buddies",
    name: "Bosom Buddies",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52593.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52593.jpg",
    },
    summary:
      "<p><b>Bosom Buddies</b> follows the adventures of Kip Wilson and Henry Desmond, junior ad-men at Livingston Gentry and Mishkin Advertising Agency. Kip was an illustrator, but aspired to be a painter, and Henry, a copywriter and aspiring novelist. When their building is demolished, they dress as women to stay with co-worker Amy Cassidy in her apartment at the Susan B. Anthony Hotel, where men are forbidden anywhere above the lobby. Kip and Henry decide to invent alter egos Buffy and Hildegarde (their fictional sisters) to move into an empty (and cheap) apartment at the hotel; Henry, to write an expose about the experience, and Kip, to get closer to Amy's beautiful roommate, Sonny Lumet, nurse, and part-time dancer. </p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1980-11-27",
  },
  {
    id: 4646,
    url: "https://www.tvmaze.com/shows/4646/big-wolf-on-campus",
    name: "Big Wolf on Campus",
    genres: ["Comedy", "Action", "Horror"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52595.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52595.jpg",
    },
    summary:
      "<p><b>Big Wolf on Campus</b> is about star football player, Tommy Dawkins, who was bitten by a werewolf and has transformed into one. He has problems with fleas and during certain events, he can change into a werewolf immediately without any control. Not only that, he has to battle vampires, cat women, ghosts, and zombies. On his side to help, are his best friends, Merton J. Dingle and Lori Baxter. All this can happen and more in his hometown, Pleasantville. Thomas P. Dawkins (Tommy) was just a regular all-star football player in High School, trying to pursue his football career, but his life changed when he is bitten by a werewolf, and becomes a werewolf himself. Unlike others, Tommy is a good-natured werewolf who protects the citizens of Pleasantville. With his good friend Merton and Lori, he battles all kinds of creatures, monsters, and aliens roaming around the town. Tommy transforms when hurt or when he gets emotional, including guilt. And you can't forget the occasional full moon.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 144,
      name: "YTV",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "1999-04-02",
  },
  {
    id: 4647,
    url: "https://www.tvmaze.com/shows/4647/public-enemies",
    name: "Public Enemies",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52597.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52597.jpg",
    },
    summary:
      "<p><b>Public Enemies</b> explores the relationship between a convicted murderer, released after serving 10 years in prison, and his probation officer.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b0196wrt",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-01-04",
  },
  {
    id: 4648,
    url: "https://www.tvmaze.com/shows/4648/hotel-babylon",
    name: "Hotel Babylon",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52605.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52605.jpg",
    },
    summary:
      "<p>Drama series set in the sexy world of the luxury five star hotel, on a journey beyond the facade of the smiling faces and glittering chandeliers and into the frenetic, non-stop world of the staff.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006wym5",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-01-19",
  },
  {
    id: 4649,
    url: "https://www.tvmaze.com/shows/4649/49-days",
    name: "49 Days",
    genres: ["Drama", "Fantasy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52625.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52625.jpg",
    },
    summary:
      "<p>A young woman named Ji Hyun was enjoying absolute bliss as she was about to be married with her fiancé, but her perfect life is shattered in a car accident that left her in a coma. She is given a second chance at life by a reaper, but it comes with a condition: she has to find three people outside of her family who would cry genuine tears for her. In order to do this, she borrows the body of Yi Kyung, a part-time employee at a convenience store.</p>",
    officialSite: "http://tv.sbs.co.kr/49/",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 127,
      name: "SBS",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2011-03-16",
  },
  {
    id: 4650,
    url: "https://www.tvmaze.com/shows/4650/billable-hours",
    name: "Billable Hours",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52630.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52630.jpg",
    },
    summary:
      "<p>Two best friends are working at a Toronto law firm. So you're over-worked and sometimes get very bored. So you turn to really dumb thing, but hey that's what sometimes happens at the law firm.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 6,
      name: "Showcase",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2006-04-16",
  },
  {
    id: 4651,
    url: "https://www.tvmaze.com/shows/4651/kick",
    name: "Kick",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52634.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52634.jpg",
    },
    summary:
      "<p>They came from worlds apart to live together to find love on Wog Street. Miki Mavros, a 26-year-old Greek, alternative arty type, is on a serious losing streak and has to retreat back home to Wog Street. There she meets Doctor Joe, a 25 year old Maori with a straight girlfriend and a yuppie dream. Miki and Joe are living proof that opposites attract. Will Miki answer the call of the road or will she be able to commit to the love she gradually discovers in the old neighborhood?</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 140,
      name: "SBS",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2007-06-09",
  },
  {
    id: 4652,
    url: "https://www.tvmaze.com/shows/4652/hunter",
    name: "Hunter",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52641.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52641.jpg",
    },
    summary:
      "<p>L.A.P.D. Sgt. Rick Hunter is a tough-minded, Dirty Harry-type policeman who can't stand the creeps, thieves, rapists, and especially murderers who prowl the streets of Los Angeles. Unfortunately his method of doing things doesn't sit well with his precinct captains, which lead to their efforts to get rid of him. Because of his heavy-handed approach, he is unable to keep partners for any significant time frame, and is assigned to Sgt. Dee Dee 'The Brass Cupcake' McCall.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1984-09-18",
  },
  {
    id: 4653,
    url: "https://www.tvmaze.com/shows/4653/the-gene-autry-show",
    name: "The Gene Autry Show",
    genres: ["Action", "Adventure", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52642.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52642.jpg",
    },
    summary:
      "<p>The already legendary singing cowboy rode with his comic pal Pat Buttram from town to town bringing justice, song and his horse Champion to the old Southwest on <b>The Gene Autry Show</b>.</p>",
    officialSite:
      "http://www.geneautry.com/geneautry/television/television_firstshow.html",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1950-07-23",
  },
  {
    id: 4654,
    url: "https://www.tvmaze.com/shows/4654/white-christmas",
    name: "White Christmas",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52644.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52644.jpg",
    },
    summary:
      "<p>Kim Yo Han is a psychiatrist who gets involved in a serial murder when his car broke down on Christmas Eve during a sudden storm and he is forced to take shelter at a private high school. Seven students and a teacher are also there over the winter break, but they are gradually murdered one by one as they receive letters from a killer who wants revenge for the death of his mother and sister.</p>",
    officialSite:
      "http://www.kbs.co.kr/end_program/drama/series/drama/christmas/",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 262,
      name: "KBS1",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2011-01-30",
  },
  {
    id: 4655,
    url: "https://www.tvmaze.com/shows/4655/jonny-zero",
    name: "Jonny Zero",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/44/111237.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/44/111237.jpg",
    },
    summary:
      "<p>In this new drama from John Wells, Franky G stars as Jonny. Jonny is freshly released from prison for drug possession and is now caught between his need to redeem himself in the eyes of his family, and the temptations and influences of his own dark past. Jonny goes back to work for his former boss, shady club owner Joseph Garret but this time he uses his criminal knowledge of New York's club scene to solve crimes. Meanwhile, the FBI is trying to force him to go undercover and bust his old friends in the underworld.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-01-14",
  },
  {
    id: 4656,
    url: "https://www.tvmaze.com/shows/4656/hope-faith",
    name: "Hope & Faith",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52659.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52659.jpg",
    },
    summary:
      "<p><b>Hope &amp; Faith</b> is a comedy about what happens when the fast lane collides with the carpool lane. It's about the moments that make you want to hug your sister... and the times you have to resist the urge to kill her. Hope is a down-to-earth, happily married mom of three in Columbus Ohio, who had her tidy world up-ended by the arrival of her celebrity sister Faith. Faith was living the high life in Hollywood as a daytime soap opera star until her soap's character, Ashley Storm, was suddenly and unceremoniously killed off on \"The Sacred and the Sinful\" by her evil twin. After a year under her roof wreaking occasional havoc, Hope can attest that you can kill the diva off on the daytime drama, but you can't take the drama out of the diva.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-09-26",
  },
  {
    id: 4657,
    url: "https://www.tvmaze.com/shows/4657/street-fighter-assassins-fist",
    name: "Street Fighter: Assassin's Fist",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52669.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52669.jpg",
    },
    summary:
      "<p>A multi-layered series that looks back to the formative years of Ryu and Ken as they live a traditional warrior's life in secluded Japan. The boys are, unknowingly, the last practitioners of the ancient fighting style known as \"Ansatsuken\" (Assassin's Fist). The series follows them as they learn about the mysterious past of their master, Goken, and the tragic, dark legacy of the Ansatsuken style. Can their destiny be changed, or will history repeat itself?</p>",
    officialSite: "http://www.streetfighteraf.com",
    webChannel: {
      id: 8,
      name: "Machinima.com",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2014-05-23",
  },
  {
    id: 4658,
    url: "https://www.tvmaze.com/shows/4658/f-troop",
    name: "F Troop",
    genres: ["Comedy", "Western"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52731.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52731.jpg",
    },
    summary:
      "<p>The end of the Civil War was near when quite accidentally, A hero who sneezed abruptly seized retreat and reversed it to victory; His medal of honor pleased and thrilled his proud little family group. While pinning it on some blood was spilled and so it was planned he'd command F Troop! Where Indian fights are colorful sights and nobody takes a lickin' When pale-face and red-skin both turn chicken; When drilling and fighting get them down they know their morale can't droop. As long as they all relax in town, before they resume with a bang and a boom, <b>F Troop!</b></p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1965-09-14",
  },
  {
    id: 4659,
    url: "https://www.tvmaze.com/shows/4659/lost-faces-of-the-bible",
    name: "Lost Faces of the Bible",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52741.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52741.jpg",
    },
    summary:
      "<p><b>Lost Faces of the Bible</b>, a four-part documentary series, blends myth-busting archaeology with dramatic recreations and forensic investigation. Having been granted unprecedented access to four ancient skulls from the Holy Land, each episode seeks to accurately reconstruct a famous face</p>",
    officialSite:
      "http://channel.nationalgeographic.com/lost-faces-of-the-bible/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-11-25",
  },
  {
    id: 4660,
    url: "https://www.tvmaze.com/shows/4660/explorer",
    name: "Explorer",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/236/591581.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/236/591581.jpg",
    },
    summary:
      "<p><b>Explorer</b>, the longest-running documentary series in cable television history, honored with nearly 60 Emmys and hundreds of other awards, continues as a series of major specials on the National Geographic Channel. In the course of more than two thousand films, Explorer has taken viewers to more than 120 countries, opening a window on hidden parts of the world, unlocking mysteries both ancient and modern, and investigating stories of science, nature, and culture.</p>",
    officialSite: "https://www.nationalgeographic.com/tv/explorer/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1985-04-07",
  },
  {
    id: 4661,
    url: "https://www.tvmaze.com/shows/4661/kasia-i-tomek",
    name: "Kasia i Tomek",
    genres: ["Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52744.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52744.jpg",
    },
    summary: "<p>Everyday life of a man and a woman in their 30s.</p>",
    officialSite: null,
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 334,
      name: "TVN",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2002-09-03",
  },
  {
    id: 4662,
    url: "https://www.tvmaze.com/shows/4662/vratice-se-rode",
    name: "Vratiće se rode",
    genres: ["Drama", "Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/175/439688.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/175/439688.jpg",
    },
    summary: "",
    officialSite: "http://www.b92.net/jesen2007/rode.php",
    webChannel: null,
    language: "Serbian",
    status: "Ended",
    network: {
      id: 367,
      name: "B92",
      country: { name: "Serbia", code: "RS", timezone: "Europe/Belgrade" },
    },
    premiered: "2007-11-09",
  },
  {
    id: 4663,
    url: "https://www.tvmaze.com/shows/4663/ja-to-mam-szczescie",
    name: "Ja to mam szczęście",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52752.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52752.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 333,
      name: "TVP2",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2012-03-07",
  },
  {
    id: 4664,
    url: "https://www.tvmaze.com/shows/4664/klub-szalonych-dziewic",
    name: "Klub szalonych dziewic",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52753.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52753.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 334,
      name: "TVN",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2010-03-02",
  },
  {
    id: 4665,
    url: "https://www.tvmaze.com/shows/4665/licencja-na-wychowanie",
    name: "Licencja na wychowanie",
    genres: [],
    image: null,
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "Polish",
    status: "Ended",
    network: {
      id: 333,
      name: "TVP2",
      country: { name: "Poland", code: "PL", timezone: "Europe/Warsaw" },
    },
    premiered: "2010-03-03",
  },
  {
    id: 4666,
    url: "https://www.tvmaze.com/shows/4666/dan-for-mayor",
    name: "Dan for Mayor",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52758.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52758.jpg",
    },
    summary:
      "<p>Dan Phillips is a 30-something bartender who lives and works in the city of Wessex. His only serious relationship was with Claire Kendal, only now Claire is engaged to someone else. She hasn't broken the news to Dan yet, felling that the news might upset him. When she does, Dan reacts the way most of us would, by telling her that he's running for mayor.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 48,
      name: "CTV",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2010-03-01",
  },
  {
    id: 4667,
    url: "https://www.tvmaze.com/shows/4667/raines",
    name: "Raines",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52760.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52760.jpg",
    },
    summary:
      "<p>Michael Raines (Jeff Goldblum), a 'mentally haunted' LAPD detective, who interacts with imaginary manifestations of dead crime victims in order to solve criminal cases. Raines must deal with his unique, unintentional method, as it causes problems with his co-workers and in his personal life.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-03-15",
  },
  {
    id: 4668,
    url: "https://www.tvmaze.com/shows/4668/hooperman",
    name: "Hooperman",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52768.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52768.jpg",
    },
    summary:
      "<p>Free-wheeling San Francisco cop Harry Hooperman inherits a run down apartment building, and the building owner's mean, hateful and just plain annoying dog Bijoux. Not having the time to maintain the building and tend to his police work, Hooperman hires feisty aspiring writer Susan Smith as his superintendent/maintenance person. He and Smith soon begin a relationship, and the series chronicles the ups and downs of the relationship, along with Hooperman's efforts as a policeman.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1987-09-23",
  },
  {
    id: 4669,
    url: "https://www.tvmaze.com/shows/4669/the-archie-show",
    name: "The Archie Show",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52774.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52774.jpg",
    },
    summary:
      '<p>Inspired by the beloved comic book series, <i><b>"The Archie Show"</b></i> chronicles the adventures of America\'s favorite redhead and his hip friends Betty, Veronica, Reggie and Jughead, plus their mascot Hot Dog. Watch as they sing, dane and laugh their way through the ups and downs, hits and misses of being teenagers. Every Episode of the popular series features an original song and dance by the Grooviest band in Riverdale and accross the USA!</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1968-09-14",
  },
  {
    id: 4670,
    url: "https://www.tvmaze.com/shows/4670/off-the-hook",
    name: "Off the Hook",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/73/184171.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/73/184171.jpg",
    },
    summary:
      "<p>Comedy series set on one of life's great frontiers. Danny starts his first week at university looking forward to leaving his past behind him.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00mqzm9",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 49,
      name: "BBC Three",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-09-10",
  },
  {
    id: 4671,
    url: "https://www.tvmaze.com/shows/4671/the-rebels",
    name: "The Rebels",
    genres: ["Comedy", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/227/569569.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/227/569569.jpg",
    },
    summary:
      "<p>Julie is in over her head when her husband suddenly dies leaving her as sole owner of a pro-football team.</p>",
    officialSite:
      "https://www.amazon.com/gp/video/detail/B00I3MOG6G?ie=UTF8&*Version*=1&*entries*=0",
    webChannel: { id: 3, name: "Amazon Prime Video", country: null },
    language: "English",
    status: "Ended",
    network: null,
    premiered: "2014-02-07",
  },
  {
    id: 4672,
    url: "https://www.tvmaze.com/shows/4672/my-beautiful-bride",
    name: "My Beautiful Bride",
    genres: ["Action", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52785.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52785.jpg",
    },
    summary:
      "<p>Kim Do Hyung goes on an all-out mission to track down his fiancée, Joo Young, when she suddenly goes missing. Left in the wake of her disappearance as the prime suspect, Do Hyung drives himself to the extremes in order to find his bride-to-be and prove his innocence, eventually compromising his morals. As Do Hyung falls deeper into the rabbit hole, he discovers Joo Young is up to more than meets the eye.</p>",
    officialSite: "http://program.interest.me/ocn/mybride",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 267,
      name: "OCN",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2015-06-20",
  },
  {
    id: 4673,
    url: "https://www.tvmaze.com/shows/4673/boston-public",
    name: "Boston Public",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52786.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52786.jpg",
    },
    summary:
      "<p>An Emmy and Peabody award winning dramatic, sometimes comedic, behind-the-scenes look at the personal and professional lives of teachers and administrators at Boston's Winslow High School.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2000-10-23",
  },
  {
    id: 4674,
    url: "https://www.tvmaze.com/shows/4674/dempsey-and-makepeace",
    name: "Dempsey and Makepeace",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52787.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52787.jpg",
    },
    summary:
      "<p>British action adventure at it's greatest as Jim Dempsey, Michael Brandon, and Harriet 'Harry' Makepeace, Glynis Barber, take on the criminals of London, and sometimes each other.</p>",
    officialSite: "https://itvstudios.com/programmes/dempsey-and-makepeace",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1985-01-11",
  },
  {
    id: 4675,
    url: "https://www.tvmaze.com/shows/4675/a-love-to-kill",
    name: "A Love to Kill",
    genres: ["Drama", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52789.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52789.jpg",
    },
    summary:
      "<p>Kang Bok Gu grew up in a foster home with his elder brother, Kang Min Gu. After a misunderstanding occurs between Min Gu and his girlfriend Cha Eun Seok, an emotionally wounded Min Gu falls from a rooftop and is diagnosed with comma. Driven by anger and thirst for revenge, Bok Gu approaches Eun Seok as a bodyguard in order to cause her the pain and suffering she caused his brother. But as he spends time with her, he gets increasingly burdened by the forbidden love he develops. Meanwhile, Eun Seok - not knowing about her ex's relationship with Bok Gu - falls in love with him not knowing that his intention is to destroy her life.</p>",
    officialSite: "http://www.kbs.co.kr/drama/ijuksa/",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 128,
      name: "KBS2",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2005-10-31",
  },
  {
    id: 4676,
    url: "https://www.tvmaze.com/shows/4676/code-blue",
    name: "Code Blue",
    genres: ["Drama", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/120/302228.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/120/302228.jpg",
    },
    summary:
      '<p>If it can be treated one second earlier, the heart might start beating again. If there is one extra helicopter, another life in danger may be saved. If one more life can be saved, the Japanese medical community may regain trust. There are more lives in this country that can be saved. The "Doctor Helicopter" system was legalized in Japan in June 2007. A medical team is dispatched to the patients on a helicopter to provide medical care in the field as soon as possible. One day, four young physicians are assigned to this latest medical system. The doctors experience traumatic medical situations, deal with personal ambitions, witness the fragility of life, and they grow personally and professionally.</p>',
    officialSite: "http://www.fujitv.co.jp/codeblue/index.html",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 131,
      name: "Fuji TV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2008-07-03",
  },
  {
    id: 4677,
    url: "https://www.tvmaze.com/shows/4677/honest",
    name: "Honest",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52797.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52797.jpg",
    },
    summary:
      "<p>Meet the Carters, a family of tricksters, thieves and blackmailers on first-name terms with the old bill. They've been a mini crime wave for years but things are about to change. Mum Lindsay decides enough is enough when dad Mack is banged up for robbery: it's time the family went straight. But some of her children have other ideas. The eldest, twin sons Taylor and Vin, may look identical but the similarities end there. While mum's favourite Taylor toils away at law school, Vin's more interested in following in dad's footsteps. But is Taylor quite as innocent as he looks? And then there's Kacie, who dreams of a career on the catwalk, but in the meantime has to get by on jobseeker's allowance. The youngest, 15-year-old Lianna, is the smartest of the lot. But even she's no angel, blackmailing her deputy headmistress so she can bunk off school.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-01-09",
  },
  {
    id: 4678,
    url: "https://www.tvmaze.com/shows/4678/gap-dong",
    name: "Gap Dong",
    genres: ["Crime", "Thriller", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52800.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52800.jpg",
    },
    summary:
      "<p>Moo Yum's father killed himself twenty years ago as he was suspected to be the <b>Gap Dong </b>in a serial murder case. Now, Moo Yum became a detective in order to capture the real Gap Dong, but is forced to give up due to the expiring of statue of limitations and resigns thinking that the real killer is dead. When new clues appear in front of him, he sets out once again to capture him.</p>",
    officialSite: "http://program.interest.me/tvn/gabdong2/12/Contents/Html",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 280,
      name: "tvN",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2014-04-11",
  },
  {
    id: 4679,
    url: "https://www.tvmaze.com/shows/4679/gods-gift-14-days",
    name: "God's Gift - 14 Days",
    genres: ["Drama", "Thriller", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/124/312498.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/124/312498.jpg",
    },
    summary:
      "<p>Kim Soo Hyun experiences the unfathomable when her daughter is kidnapped and murdered. Discovering a miraculous ability to go back in time exactly two weeks before the event, Soo Hyun races against the clock to unravel the plot and save her daughter. But when a private investigator sheds new light on the crime, Soo Hyun uncovers a secret far more treacherous than she could have ever imagined.</p>",
    officialSite: "http://wizard2.sbs.co.kr/14days/",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 127,
      name: "SBS",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2014-03-03",
  },
  {
    id: 4680,
    url: "https://www.tvmaze.com/shows/4680/california-dreams",
    name: "California Dreams",
    genres: ["Comedy", "Family", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52815.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52815.jpg",
    },
    summary:
      "<p><b>California Dreams</b> is a show about a group of high school teens that form their own band, The California Dreams. The show follows the group through their problems in high school as well as their problems in trying to score a record deal. The theme song to California Dreams is an original song performed by the season's current bandmates.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1992-09-12",
  },
  {
    id: 4681,
    url: "https://www.tvmaze.com/shows/4681/played",
    name: "Played",
    genres: ["Drama", "Action", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52816.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52816.jpg",
    },
    summary:
      '<p><b>Played</b> tracks the CIU (Covert Investigations Unit) as it risks going undercover to infiltrate and bring down criminal organizations. In this new style of intense, short-term undercover work, each covert "play" is crafted quickly and executed at an even faster pace. Placed into various worlds of crime without a safety net, the cops are in constant danger, as they repeatedly go off the grid. Wearing wires, coaxing confessions, and setting up stings, the cops of the CIU must think quickly, talk smoothly, and rely on pure instinct. They slip in and out of characters so often that, sometimes, they lose track of who they really are. The team of highly-skilled and brave detectives is led by John Moreland, a cop at the top of his game with great instincts who is usually in charge... Until the new CIU is established and consummate strategist Rebecca Ellis is given the reigns.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 48,
      name: "CTV",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2013-10-03",
  },
  {
    id: 4682,
    url: "https://www.tvmaze.com/shows/4682/sign",
    name: "Sign",
    genres: ["Drama", "Crime", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52823.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52823.jpg",
    },
    summary:
      "<p>A medical investigation drama about forensic doctors solving murder cases. Go Da Kyung is an eager rookie investigator who gets paired with the famous forensic doctor, Yoon Ji Hoon. They initially clash due to their different styles of investigation as well as their opposing personalities - Da Kyung's energetic nature is a source of irritation for the prickly Ji Hoon - but later develop a complex relationship as the two strive to uncover the truth through science.</p>",
    officialSite: "http://tv.sbs.co.kr/sign/",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 127,
      name: "SBS",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2011-01-05",
  },
  {
    id: 4683,
    url: "https://www.tvmaze.com/shows/4683/caroline-in-the-city",
    name: "Caroline in the City",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52824.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52824.jpg",
    },
    summary:
      "<p>Caroline Duffy is a successful cartoonist in Manhattan whose eclectic friends are sometimes the subjects of her comic strip. Her best friend, Annie, helps her stay in focus while Caroline's convoluted relationship with her colorist, Richard, also keeps her guessing. Through it all, Caroline maintains a funny outlook on life that inspires the hilarity of her cartoon strip.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1995-09-21",
  },
  {
    id: 4684,
    url: "https://www.tvmaze.com/shows/4684/north-shore",
    name: "North Shore",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52827.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52827.jpg",
    },
    summary:
      "<p><b>North Shore</b> is a lush drama that captures the passion, intrigue and heart of Hawaii. This 20-something ensemble series is set at the Grand Waimea, a luxury hotel, where Jason Matthews is the popular general manager and his ex-girlfriend Nicole Booth is the newly hired head of guest relations, having left her father's hotel empire to make her own way in the business and in life. Working side by side causes much tension between them, but their romantic relationship may be far from over. Just as interesting as the hotel's clientele is its staff, which is filled with friends, thrill-seekers, former con artists and dreamers in paradise. Waitress MJ Bevans, Jason's surrogate little sister and roommate, is just waiting for her t-shirt design business to blossom into a fashion empire...</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-06-14",
  },
  {
    id: 4685,
    url: "https://www.tvmaze.com/shows/4685/carpoolers",
    name: "Carpoolers",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52832.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52832.jpg",
    },
    summary:
      "<p><b>Carpoolers</b> focused on the everyday lives of four male suburbanites with different occupations, who took their private lives and issues along for the ride during their daily commute to and from work.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-10-02",
  },
  {
    id: 4686,
    url: "https://www.tvmaze.com/shows/4686/men-behaving-badly",
    name: "Men Behaving Badly",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52843.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52843.jpg",
    },
    summary:
      "<p>This series is the US version of the UK series of the same name that was created by Simon Nye. When shown in countries that have already seen the UK version, the US series is retitled It's a Man's World. The theme song \"Bad Boy\" written by Larry Williams is performed by Marshall Crenshaw.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-09-18",
  },
  {
    id: 4687,
    url: "https://www.tvmaze.com/shows/4687/committed",
    name: "Committed",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52845.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52845.jpg",
    },
    summary:
      '<p><b>Committed</b> follows two single and extremely eccentric New Yorkers who are subject to constant interference when they begin dating from their equally eccentric friends and one roommate, known only as "Dying Clown" or "Clown".</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-01-04",
  },
  {
    id: 4688,
    url: "https://www.tvmaze.com/shows/4688/e-ring",
    name: "E-Ring",
    genres: ["Drama", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/216/540126.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/216/540126.jpg",
    },
    summary:
      '<p><b>E-Ring</b>, described as "The West Wing" set at the Pentagon, was created by David McKenna and Ken Robinson, a former Green Beret who consults for CNN on terrorism and military intelligence. McKenna penned the pilot script. Jerry Bruckheimer will executive produce as well as his production studio will produce the project.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-09-21",
  },
  {
    id: 4689,
    url: "https://www.tvmaze.com/shows/4689/jesse",
    name: "Jesse",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52860.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52860.jpg",
    },
    summary:
      "<p>A single mother tries to find love again with her new boyfriend Diego, of whom her father disapproves. She gets help from her two brothers (one voluntarily mute) and two girlfriends at work (her father's bar). Complicating matters is her ex-husband, who walked out on her 7 years before, but is back to try and reinsert himself into the family. The last thing <b>Jesse</b> Warner needs is another man in her life. A single mom in Buffalo who works in her dad's bar, she has her hands full looking after her father, son and two brothers (one a deep thinker who refuses to speak, the other a gadfly who dreams up get-rick-quick schemes). Jesse has no time for romance, that is, until a handsome Chilean moves in next door.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1998-09-24",
  },
  {
    id: 4690,
    url: "https://www.tvmaze.com/shows/4690/plus-one",
    name: "Plus One",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/48/122388.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/48/122388.jpg",
    },
    summary:
      "<p>Inspired comedy about love and revenge. What do you do when your girlfriend leaves you to marry Duncan from Blue? You find the perfect date to outshine them on their wedding day, that's what...</p>",
    officialSite:
      "https://web.archive.org/web/20180629065859/http://www.channel4.com/programmes/plus-one",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-01-09",
  },
  {
    id: 4691,
    url: "https://www.tvmaze.com/shows/4691/desperate-romantics",
    name: "Desperate Romantics",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52867.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52867.jpg",
    },
    summary:
      "<p>A BBC six-part drama following the Pre-Raphaelite brotherhood - the men who blew the art world apart</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00lvyq2",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-07-21",
  },
  {
    id: 4692,
    url: "https://www.tvmaze.com/shows/4692/do-over",
    name: "Do Over",
    genres: ["Drama", "Comedy", "Fantasy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52870.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52870.jpg",
    },
    summary:
      "<p>Joel Larsen is an unmarried, dissatisfied 34-year-old when a freak accident jettisons him 20 years into the past to his freshman year of high school. Back in 1981, Joel has the chance to make things turn out differently, both for him and his dysfunctional family.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-09-19",
  },
  {
    id: 4693,
    url: "https://www.tvmaze.com/shows/4693/drexells-class",
    name: "Drexell's Class",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52871.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52871.jpg",
    },
    summary:
      "<p>Otis Drexell is a corporate raider who is known for getting the deal done. He is then caught red handed for dodging taxes, and given a suspended sentence so long as he works as a school teacher at an elementary school until the back taxes are paid. Every week, Otis would do the best he could of making the adjustment of going from the boardroom to the classroom with the help of his two daughters.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1991-09-19",
  },
  {
    id: 4694,
    url: "https://www.tvmaze.com/shows/4694/glory-daze",
    name: "Glory Daze",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52872.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52872.jpg",
    },
    summary:
      "<p>Centers on a group of friends who are trying to navigate college life in 1980s Wisconsin. From being out on their own for the first time to pledging a fraternity, they discover how challenging the next few years are going to be.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 32,
      name: "TBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-11-16",
  },
  {
    id: 4695,
    url: "https://www.tvmaze.com/shows/4695/the-bubble",
    name: "The Bubble",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52932.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52932.jpg",
    },
    summary:
      "<p>The comedy news-quiz which plays on the fact that some news stories are so hard to believe you'd think they'd been made up. In this show some of them have.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00qzjnq",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-02-19",
  },
  {
    id: 4696,
    url: "https://www.tvmaze.com/shows/4696/frank-skinners-opinionated",
    name: "Frank Skinner's Opinionated",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52933.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52933.jpg",
    },
    summary:
      "<p>Frank Skinner is joined by two fellow comedians and a studio audience to unpick the week's most talked-about news stories.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00s3vmr",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-04-16",
  },
  {
    id: 4697,
    url: "https://www.tvmaze.com/shows/4697/nitro-circus",
    name: "Nitro Circus",
    genres: ["Action", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52934.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52934.jpg",
    },
    summary:
      "<p><b>Nitro Circus</b> is a television show centered around the world's greatest freestyle motocross rider Travis Pastrana and his crew of top action sport athlete buddies. There is a special chemistry with this group. Whether they are trying to double back-flip a motorcycle, jump out of a plane without a parachute, or flip a Big Wheel over a 70-foot gap, these guys are going hard 24/7 and there is no downtime--it's just fast and faster. The show follows Travis and the Nitro Circus Crew as they travel around the world setting up outrageous stunts and pushing the human body to the limit, constantly looking to innovate the world of action sports. Travis' compound in Annapolis houses a full motocross course, foam pits and a home-made waterslide carved into a hill creating a self contained extreme sports circus. Whether they are base jumping, sky diving, riding, driving or relaxing, this group of tight-knit, highly-skilled, adrenaline-fueled friends always take the action \"to eleven\" with the hammer down.</p>",
    officialSite: "http://www.mtv.com/shows/nitro_circus/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-02-08",
  },
  {
    id: 4698,
    url: "https://www.tvmaze.com/shows/4698/nitro-circus-live",
    name: "Nitro Circus Live",
    genres: ["Action", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755458.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755458.jpg",
    },
    summary:
      '<p><b>Nitro Circus Live</b> takes viewers on a behind the scenes ride of a lifetime as the crazy Nitro Circus crew do everything from camel racing and sheep shearing in the Australian outback, to jumping en masse out of an airplane riding bikes, trikes, snow skis and bodyboards... through to tow-surfing and jetboat racing. Along the way, the crew meets some interesting and truly inspirational people, including Aaron "Wheelz" Fotheringham, the first wheelchair athlete to backflip his chair off the 60 foot high Gigant-A-Ramp. Plus X Games Gold medalist Cam Sinclair, who almost died performing the most dangerous trick in action sports, the double backflip, then trying it again for the first time on the Nitro tour. Get ready to be inspired, to be shocked and to laugh til it hurts.</p>',
    officialSite: "http://www.mtv.com/shows/nitro_circus/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 145,
      name: "MTV2",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-03-27",
  },
  {
    id: 4699,
    url: "https://www.tvmaze.com/shows/4699/frankie-boyles-tramadol-nights",
    name: "Frankie Boyle's Tramadol Nights",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52936.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52936.jpg",
    },
    summary:
      "<p><b>Frankie Boyle's Tramadol Nights</b> was a comedy sketch show created in 2010 by Frankie Boyle, starring Boyle himself alongside Jim Muir, Tom Stade, Robert Florence and Thaila Zucchi.</p>",
    officialSite:
      "https://web.archive.org/web/20170409211513/https://www.channel4.com/programmes/frankie-boyles-tramadol-nights",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-11-30",
  },
  {
    id: 4700,
    url: "https://www.tvmaze.com/shows/4700/full-english",
    name: "Full English",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52938.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52938.jpg",
    },
    summary:
      "<p><b>Full English</b> revolves around the lives of members of a suburban family called the Johnsons. Hard-working Edgar, the father, is employed by Ken, his borderline-evil father-in law, while his house-proud wife, Wendy, looks after their children: the freaky weirdo Dusty, the amiable idiot Jason and the highly strung emo, Eve. Ken's only friend in the show is a large green figment of his imagination called Squidge, who makes him do unpleasant things.</p>",
    officialSite: "http://www.channel4.com/programmes/full-english/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-11-12",
  },
  {
    id: 4701,
    url: "https://www.tvmaze.com/shows/4701/the-guess-list",
    name: "The Guess List",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52939.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52939.jpg",
    },
    summary:
      "<p>Each show pits two members of the public against one another as they compete for an exclusive tailor-made prize. With questions based on modern life and relationships, they'll need some expert advice. Thankfully, five celebrity guests are at hand to lend their support as Rob draws up a Guess List of answers.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b041cwvy",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-04-12",
  },
  {
    id: 4702,
    url: "https://www.tvmaze.com/shows/4702/the-matt-lucas-awards",
    name: "The Matt Lucas Awards",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52940.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52940.jpg",
    },
    summary:
      "<p>Matt Lucas is joined by guests to host his own brand-new awards ceremony - the perfectly-titled Lucases.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p00xxtjz",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-04-10",
  },
  {
    id: 4703,
    url: "https://www.tvmaze.com/shows/4703/wwe-tough-enough",
    name: "WWE Tough Enough",
    genres: ["Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52941.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52941.jpg",
    },
    summary:
      '<p>Each week, one cast member will be eliminated until one man and one woman are considered "Tough Enough", with each earning a one-year, $250,000 WWE contract. Chris Jericho will be joined by a panel of experts comprised of WWE Superstar Daniel Bryan, WWE Diva Paige and WWE Superstar This Miz and throughout the competition, the contestants will be trained by WWE Legends Booker T, Billy Gunn and Lita.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2001-06-21",
  },
  {
    id: 4704,
    url: "https://www.tvmaze.com/shows/4704/just-legal",
    name: "Just Legal",
    genres: ["Drama", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52944.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52944.jpg",
    },
    summary:
      "<p><b>Just Legal </b>is a fast-paced procedural drama with humor starring Jay Baruchel and Don Johnson as lawyers who save their clients, and in the process, save themselves.<br><br>David Skip Ross, 19, a brilliant legal prodigy, dreams of becoming a great trial lawyer. When he can't land a job at a prestigious L.A. firm because he's too young, Skip ends up working for Grant Cooper. Once a great lawyer, now burnt-out by the realities of life, Cooper is barely scraping by in his beachfront law office.<br><br>Together, Skip and Cooper become defenders of the accused and crusaders for the unjustly wronged. Their cases vary from stories ripped from today's headlines to clever mysteries with procedural twists.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 71,
      name: "The WB",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-09-19",
  },
  {
    id: 4705,
    url: "https://www.tvmaze.com/shows/4705/justice",
    name: "Justice",
    genres: ["Drama", "Crime", "Legal"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52948.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52948.jpg",
    },
    summary:
      "<p>Set in Los Angeles, the entertainment and high-profile trial capital of the world, <b>Justice</b> centers on four brilliant lawyers who, together, tackle the cases that captivate the country and provide compelling fodder for everything from water cooler chit-chat to tabloid glossies to 24-hour news channels. Combining their unique skill sets and personal charisma with the most cutting-edge forensic technology, these lawyers are a formidable presence in any courtroom. When the stakes are as high as they can be, you want Trott, Nicholson, Tuller &amp; Graves in your corner.</p><p>When California's most prominent residents need the best legal representation, they hire TNT&amp;G. Even if they are convicted in the eyes of the media, led by the infotainment court show \"American Crime\", TNT&amp;G mounts a defense using state-of-the-art forensic interpretation, jury consultants, mock juries, experts and masterful media spin to save their clients -- no matter what the cost.</p><p>Ultimately, each episode will conclude with the series' signature epilogue. In a flashback to the scene of the crime, we see what no lawyer can ever see: what really happened, and whether <i>justice</i> has been served.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-08-30",
  },
  {
    id: 4706,
    url: "https://www.tvmaze.com/shows/4706/life-is-wild",
    name: "Life is Wild",
    genres: ["Drama", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52953.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52953.jpg",
    },
    summary:
      "<p>A New York vet moves his second wife and their two sets of children to a South African game reserve run by his father-in-law. This new drama is based on the eponymous British series named <i>Wild at Heart</i>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-10-07",
  },
  {
    id: 4707,
    url: "https://www.tvmaze.com/shows/4707/junjou-romantica",
    name: "Junjou Romantica",
    genres: ["Drama", "Anime", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52965.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52965.jpg",
    },
    summary:
      "<p>Junjou Romantica is an anime that follows the lives and loves of three shonen-ai (boy-love) couples. The stories are divided into 3 groups: Junjou Romantica, Junjou Egoist, and Junjou Terrorist. The first couple is Misaki and Akihito. It is the story about Misaki having to live with his brother's childhood friend, Akihito. Akihito is completely in love with Misaki's older brother, so he would do anything he asks of him, even if it means putting up with his idiotic, little brother. But, after Misaki's older brother gets marries, how will Akihito deal with the heartbreak? The story continues will Misaki consoling Akihito, but sometimes consoling turns into romance. Also, there is Hiroki, another one of Akihito's childhood friends, who is very in love with Akihito. The problem is, Akihito doesn't think of Hiroki in any way other than friendship. Luckily for Hiroki, he meets Nowaki. Nowak</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 132,
      name: "Tokyo MX",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2008-04-10",
  },
  {
    id: 4708,
    url: "https://www.tvmaze.com/shows/4708/men-behaving-badly",
    name: "Men Behaving Badly",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52966.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52966.jpg",
    },
    summary:
      "<p>Gary needs a lodger to help pay the mortgage on his flat. Unfortunately, neither of his lodgers seems to be able (or willing) to pay any rent at all! First there's Dermot and then Tony. Both of these fall for Deborah, who owns the flat upstairs, but get nowhere. Gary also has thoughts in that direction - his problem being the fact that he has a regular girlfriend, Dorothy, who he lives with!</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00hx5p2",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1992-02-18",
  },
  {
    id: 4709,
    url: "https://www.tvmaze.com/shows/4709/lincoln-heights",
    name: "Lincoln Heights",
    genres: ["Drama", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52967.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52967.jpg",
    },
    summary:
      "<p>High school student Cassie Sutton finds her world turned upside-down when her father Eddie Sutton, an ambitious cop, moves their family to a tough inner-city neighborhood.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 26,
      name: "FreeForm",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-01-08",
  },
  {
    id: 4710,
    url: "https://www.tvmaze.com/shows/4710/mr-brain",
    name: "Mr. Brain",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52968.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52968.jpg",
    },
    summary:
      "<p>Tsukumo Ryusuke is a quirky, yet brilliant neuroscientist working for the National Research Institute of Police Science. Wielding a unique perspective and psychology, Tsukumo tackles the nation's most baffling crimes and scandals, going head-to-head with the most brilliant and twisted criminal minds. But his eccentricities and poor social timing can also aggravate people and circumstances, further complicating matters.</p>",
    officialSite: null,
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 136,
      name: "Nagoya Broadcasting Network",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2009-05-23",
  },
  {
    id: 4711,
    url: "https://www.tvmaze.com/shows/4711/i-live-with-models",
    name: "I Live with Models",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52969.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52969.jpg",
    },
    summary:
      "<p>Tommy heads to New York City with Scarlet as they look to make it big, but will he make a good impression with the new roommates?</p>",
    officialSite: "http://www.comedycentral.co.uk/i-live-with-models",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 309,
      name: "Comedy Central",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-02-23",
  },
  {
    id: 4712,
    url: "https://www.tvmaze.com/shows/4712/death-note",
    name: "Death Note",
    genres: ["Drama", "Thriller", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52970.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52970.jpg",
    },
    summary:
      "<p>Light Yagami is an ordinary university student. One day, he receives a death note which changes his life. The death note awakens his warped sense of justice and genius. He becomes murderer Kira and punishes criminals. L is a well known private detective. L appears in front of Light Yagami. L defines Kira as evil and decides to catch Kira. Then N, who has a beautiful appearance but dangerous existence, appears.</p>",
    officialSite: "http://www.ntv.co.jp/drama-deathnote/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 137,
      name: "NTV",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2015-07-05",
  },
  {
    id: 4713,
    url: "https://www.tvmaze.com/shows/4713/the-crystal-maze",
    name: "The Crystal Maze",
    genres: ["Adventure", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52979.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52979.jpg",
    },
    summary:
      "<p>This highly popular Channel 4 game show saw a team of six contestants (three male, three female) led around four time zones by the host Richard O'Brien, playing games and winning crystals as prizes. <b>The Crystal Maze</b> wasn't really a maze at all. It can be better described as: a circuit of four inter-connecting play areas or \"time zones\" with the crystal dome in the centre.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1990-02-15",
  },
  {
    id: 4714,
    url: "https://www.tvmaze.com/shows/4714/hebburn",
    name: "Hebburn",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52980.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52980.jpg",
    },
    summary:
      "<p>North East-based sitcom following the ups and downs of life for a newly married couple.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b03hcm69",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-10-18",
  },
  {
    id: 4715,
    url: "https://www.tvmaze.com/shows/4715/the-word",
    name: "The Word",
    genres: ["Comedy", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/34/86895.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/34/86895.jpg",
    },
    summary:
      "<p>Live and controversial night magazine format talk show with interviews, live music, comedy gameshow elements and other odd segments.</p>",
    officialSite: "http://www.channel4.com/programmes/best-of-the-word",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1990-08-24",
  },
  {
    id: 4716,
    url: "https://www.tvmaze.com/shows/4716/hope-springs",
    name: "Hope Springs",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52982.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52982.jpg",
    },
    summary:
      "<p>Drama about four fabulous female ex-cons trying to go straight. When their plan goes terribly wrong, the women end up in hiding in Hope Springs, a remote Scottish Highland village.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00l5zr2",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-06-07",
  },
  {
    id: 4717,
    url: "https://www.tvmaze.com/shows/4717/gamesmaster",
    name: "GamesMaster",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52983.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52983.jpg",
    },
    summary:
      "<p><b>GamesMaster</b> was a British television show, screened on Channel 4 from 7th January 1992 to 3rd February 1998, and was the first-ever UK television show dedicated to computer and video games.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1992-01-07",
  },
  {
    id: 4718,
    url: "https://www.tvmaze.com/shows/4718/special-affairs-team-ten",
    name: "Special Affairs Team TEN",
    genres: ["Action", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/49/122643.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/49/122643.jpg",
    },
    summary:
      "<p><b>Special Affairs Team TEN</b> is a criminal investigation unit that tackles the most violent crimes in South Korea. These crimes usually have less than a 10% rate for arrests. They chase the most notorious killers who attempt to commit the perfect crimes</p>",
    officialSite: "http://ten2.interest.me/?rcnt=1",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 267,
      name: "OCN",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2011-11-18",
  },
  {
    id: 4719,
    url: "https://www.tvmaze.com/shows/4719/help-me-help-you",
    name: "Help Me Help You",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52986.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52986.jpg",
    },
    summary:
      "<p><b>Help Me Help You</b> follows a collection of eccentric individuals in group therapy with a respected therapist -- who may quite possibly have more problems than his patients.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-09-26",
  },
  {
    id: 4720,
    url: "https://www.tvmaze.com/shows/4720/mercy",
    name: "Mercy",
    genres: ["Drama", "Medical"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/82/205569.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/82/205569.jpg",
    },
    summary:
      "<p><b>Mercy</b> is an ensemble drama set in the fictional Mercy Hospital in Jersey City, New Jersey. The show focuses on the lives of three nurses. Veronica Flanagan Callahan is a nurse who has just returned from a tour of duty in Iraq, while Sonia Jimenez, her best friend, has become seriously involved with a police officer, and Chloe Payne is a recent nursing graduate who is thrown into the world of nursing and is unprepared for what it entails.</p>",
    officialSite: "https://www.nbc.com/mercy",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-09-23",
  },
  {
    id: 4721,
    url: "https://www.tvmaze.com/shows/4721/banzai",
    name: "Banzai",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52997.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52997.jpg",
    },
    summary:
      "<p><b>Banzai</b> was a comedy gambling game show spoofing Japanese game shows and general television style. It was produced by Radar, part of RDF Media. Each segment of the show was a silly or bizarre contest. Members of the viewing audience were encouraged to bet with each other on the outcome of each segment. The Japanese characters seen on screen during the programme are meaningless.</p>",
    officialSite: "http://www.channel4.com/programmes/banzai",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 41,
      name: "E4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2001-01-18",
  },
  {
    id: 4722,
    url: "https://www.tvmaze.com/shows/4722/joanie-loves-chachi",
    name: "Joanie Loves Chachi",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/52999.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/52999.jpg",
    },
    summary:
      "<p>This spin-off of <i>Happy Days</i> follows Chachi Arcola as he moves out and tries to make it on his own with a rock band and a music career. In between holding down a job and keeping his girlfriend, Joanie Cunningham, happy, he must also deal with the often unwanted, but sometimes needed, advice and interference from his friends, relatives and neighbors.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1982-03-23",
  },
  {
    id: 4723,
    url: "https://www.tvmaze.com/shows/4723/reunion",
    name: "Reunion",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53000.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53000.jpg",
    },
    summary:
      "<p>An unusual drama following six high-school friends over the course of 20 years (with each year a separate episode), told in flashbacks as a detective investigates the recent murder of one of the group.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-09-08",
  },
  {
    id: 4724,
    url: "https://www.tvmaze.com/shows/4724/robot-wars",
    name: "Robot Wars",
    genres: ["Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/140/350176.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/140/350176.jpg",
    },
    summary:
      "<p><b>Robot Wars </b>is a British game show modelled on a US-based competition of the same name. Teams of amateur and professional roboteers make their own robots to fight against each other in both friendly and tournament matches.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 135,
      name: "Channel 5",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1998-02-20",
  },
  {
    id: 4725,
    url: "https://www.tvmaze.com/shows/4725/men-with-brooms",
    name: "Men with Brooms",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53002.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53002.jpg",
    },
    summary:
      "<p>On the surface, there's not all that much to say about Long Bay. It's small town, much like any one of a thousand other small towns that dot the country – the corner doughnut shop, the struggling economy, the small manufacturers, the crazy characters … and the local five-sheet curling club with carpet from the forties and greasy fish &amp; chips. But you can't judge a book by its cover, and you can't judge Long Bay by its surface. Men With Brooms picks up the ongoing story of Long Bay through the adventures and misadventures of four careworn young men brought together by a love of \"shuffleboard-on-ice.\" And while not great curlers, they're frequent curlers – and what they lack in skill they make up for in enthusiasm.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 36,
      name: "CBC",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2010-10-04",
  },
  {
    id: 4726,
    url: "https://www.tvmaze.com/shows/4726/going-straight",
    name: "Going Straight",
    genres: ["Comedy", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53011.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53011.jpg",
    },
    summary:
      "<p>Sitcom sequel to <i>Porridge</i>. Fletch is finally released from Slade Prison, will he be able to stop himself from going back?</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p00trc6x",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1978-02-24",
  },
  {
    id: 4727,
    url: "https://www.tvmaze.com/shows/4727/retired-at-35",
    name: "Retired at 35",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/300/751946.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/300/751946.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 57,
      name: "TV Land",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2011-01-19",
  },
  {
    id: 4728,
    url: "https://www.tvmaze.com/shows/4728/quintuplets",
    name: "Quintuplets",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53018.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53018.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-06-16",
  },
  {
    id: 4729,
    url: "https://www.tvmaze.com/shows/4729/scrapheap-challenge",
    name: "Scrapheap Challenge",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53019.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53019.jpg",
    },
    summary:
      "<p>Before there was a <i>Junkyard Wars</i> in the States there was <b>Scrapheap Challenge</b> in the UK (Which gave birth to <i>Junkyard Wars</i>). Two teams of engineers give mechanical life to a pile of junk and go head to head over whose creation dominates.</p>",
    officialSite: "http://www.channel4.com/programmes/scrapheap-challenge",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1998-04-12",
  },
  {
    id: 4730,
    url: "https://www.tvmaze.com/shows/4730/miami-medical",
    name: "Miami Medical",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53020.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53020.jpg",
    },
    summary:
      "<p><b>Miami Medical</b> (formerly titled Miami Trauma) is a medical drama television series created by Jeffrey Lieber. It follows the professional and private lives of a team of trauma surgeons. The series was produced by Jerry Bruckheimer Television and Warner Bros. Television. It premiered on CBS on April 2, 2010. In May 2010, CBS announced that the series had been canceled, with the final episode airing on July 2, 2010. (Wikipedia)</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-04-02",
  },
  {
    id: 4731,
    url: "https://www.tvmaze.com/shows/4731/never-better",
    name: "Never Better",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53026.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53026.jpg",
    },
    summary:
      "<p>Black comedy series centred on Keith Merchant, a recovering alcoholic, as he makes his way through his new sober life</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b008qr5h",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-01-10",
  },
  {
    id: 4732,
    url: "https://www.tvmaze.com/shows/4732/beachfront-bargain-hunt",
    name: "Beachfront Bargain Hunt",
    genres: ["Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/205/513110.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/205/513110.jpg",
    },
    summary:
      "<p>Each week we follow a family making their beachfront living dreams come true — on a budget! On <b>Beachfront Bargain Hunt</b> we'll follow them on the house hunt as we discover some of the most surprisingly affordable beachfront locales that prove you don't need to be a millionaire to live right on the beach.</p>",
    officialSite: "http://www.hgtv.com/shows/beachfront-bargain-hunt",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 192,
      name: "HGTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-02",
  },
  {
    id: 4733,
    url: "https://www.tvmaze.com/shows/4733/nyc-22",
    name: "NYC 22",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53027.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53027.jpg",
    },
    summary:
      '<p>Upper Manhattan, where students, longtime residents and newcomers cross paths — not always peacefully — is the setting for this new crime drama focusing on six rookie cops learning about police work, themselves and life in general. Daniel "Yoda" Dean is the officer in charge of their field training.</p><p>Though those involved with a show are always quick to dismiss the notion that it\'s anything we have seen before, this is a procedural cop show, albeit one with excellent credentials: Robert De Niro and Jane Rosenthal are executive producers, and Richard Price created it. It could not be more authentic New York, given the people behind it.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-04-15",
  },
  {
    id: 4734,
    url: "https://www.tvmaze.com/shows/4734/the-gadget-show",
    name: "The Gadget Show",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/102/257082.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/102/257082.jpg",
    },
    summary:
      '<p>Each week, the show previews and reviews the latest gadgets, and broadcasts the latest technology news. The show is aimed at giving the mass consumer an insight into the gadget world and in addition, it aims to give enough information for the more "geeky" audience, but still making it accessible to the more casual viewer. The show has featured HD DVDs, video cameras, MP3 players and other technologies. A segment showing viewers how to get the most out of their technology is also included along with a competition to win anything from £5,000 to £12,000 worth of new gadgets. Each series usually contains a special episode focusing on a particular technology conference or expo. Past conferences include CeBIT and The Next Fest.</p>',
    officialSite: "http://www.channel5.com/show/the-gadget-show",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 135,
      name: "Channel 5",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2004-06-07",
  },
  {
    id: 4735,
    url: "https://www.tvmaze.com/shows/4735/bread",
    name: "Bread",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/82/206491.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/82/206491.jpg",
    },
    summary:
      '<p><b>Bread</b> was the #1 comedy show of it\'s time in the UK and was watched by 21 million people. It was based on the Liverpuddlian family, The Boswells and showed them in all sorts of situations trying to earn money for the week (hence the title "Bread").</p>',
    officialSite: "http://www.bbc.co.uk/programmes/p02zm1qc",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1986-05-01",
  },
  {
    id: 4736,
    url: "https://www.tvmaze.com/shows/4736/married-to-the-kellys",
    name: "Married to the Kellys",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53038.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53038.jpg",
    },
    summary:
      "<p>When Tom married Susan he thought he was only getting a new wife. He never even considered that he would be getting a brand new family as well. Included in this new family are mother Sandy, the rule-maker of the house, and father Bill, once an only child, who could be the one person Tom can relate to the most. There's also Susan's competitive sister Mary and her husband Chris, who considers himself Bill and Sandy's favorite son-in-law and finds Tom as somewhat of a threat. And finally there's Susan's brother Lewis, a shy and awkward young man who has made a career of collecting bugs. Other family members who occasionally dropped by included Uncle Dave, the big-shot of the family, and Lisa, the youngest daughter who wants to back-pack around Europe and become an art major.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-10-03",
  },
  {
    id: 4737,
    url: "https://www.tvmaze.com/shows/4737/married-single-other",
    name: "Married Single Other",
    genres: ["Drama", "Comedy", "Romance"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53040.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53040.jpg",
    },
    summary:
      "<p><b>Married Single Other</b> is a romantic comedy drama series featuring three very different couples who are all connected to each other in some way. Each of the couples are at different stages in their relationships.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-02-22",
  },
  {
    id: 4738,
    url: "https://www.tvmaze.com/shows/4738/method-red",
    name: "Method & Red",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53039.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53039.jpg",
    },
    summary:
      "<p>Popular rap moguls Method Man and Redman give new meaning to the phrase \"won't you be my neighbor\" when they move to an affluent, gated community in northern New Jersey along with Method Man's feisty old-school mother Dorothea. Their next-door neighbor in the posh Nottingham Estates is Nancy Blaford, a powerful realtor who's trying to get the community board to evict the rappers, while her 12-year-old son Skyler openly admires the dynamic, but totally laid-back duo. Late-night parties, hot ladies and heavy bass SUV's aside, Method Man is a lovable momma's boy who talks to his pet goldfish, \"Goldie.\" Redman, the Abbott to Meth's Costello, realizes they need to connect with their neighbors and become a part of the community. With Dorothea keeping them PG-13, Method &amp; Red change tactics using spirit, kindness and fruit cake to ingratiate th...</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2004-06-16",
  },
  {
    id: 4739,
    url: "https://www.tvmaze.com/shows/4739/flowers-for-algernon",
    name: "Flowers for Algernon",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53041.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53041.jpg",
    },
    summary:
      "<p>Shiratori Sakuto is 28, but has the intelligence of a 6-year-old boy. He works for Dream Flower Service, a flower distribution centre which provides employment for problem youth. One day, he and a colleague, Yanagawa Ryuichi, delivers a rose bouquet to the apartment building where Mochizuki Haruka lives. Because Haruka does not know that the deliveryman is mentally challenged, she is shocked by his response and tries to call the police. Haruka works for a brain physiology research centre where Professor Hachisuka Daigo has been studying the improvement of mental performance. He has succeeded in lab experiments on a white mouse called Algernon. Sakuto is transformed into a genius through surgery. But Algernon's new intelligence begins to fade, and he dies. Sakuto realises that his genius, too, is destined to leave him.</p>",
    officialSite: "http://www.tbs.co.jp/algernon2015/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 136,
      name: "Nagoya Broadcasting Network",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2015-04-10",
  },
  {
    id: 4740,
    url: "https://www.tvmaze.com/shows/4740/brookside",
    name: "Brookside",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53049.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53049.jpg",
    },
    summary:
      "<p><b>Brookside</b> is a British soap opera set in Liverpool, England. The series began on the launch night of Channel 4 on 2 November 1982, and ran for 21 years until 4 November 2003. Originally intended to be called 'Meadowcroft', the series was produced by Mersey Television and it was conceived by Phil Redmond who also devised Grange Hill (1978–2008) and Hollyoaks (1995–present).</p>",
    officialSite: "http://www.channel4.com/programmes/brookside",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1982-11-02",
  },
  {
    id: 4741,
    url: "https://www.tvmaze.com/shows/4741/unsolved-mysteries",
    name: "Unsolved Mysteries",
    genres: ["Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53051.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53051.jpg",
    },
    summary:
      "<p><b>Unsolved Mysteries</b> explores unsolved cases in which you, the viewer, can call in or write and solve them. The show looks at cases such as: lost loves, missing persons, homicide, supernatural, the unexplained, wanted, etc. <i>Unsolved Mysteries</i> usually has four segments in one show, and sometimes shows updates. <i>Unsolved Mysteries</i> has solved 40% of their featured cases, that is 300 cases solved out of about 1,200.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 1,
      name: "NBC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1988-10-05",
  },
  {
    id: 4742,
    url: "https://www.tvmaze.com/shows/4742/ghost",
    name: "Ghost",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53052.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53052.jpg",
    },
    summary:
      "<p><b>Ghost</b> tells the story of the cyber investigation squad fights against the cyber crimes. Kim Woo Hyun is the only son of a high ranking police officer. Woo Hyun entered the police academy ranked first and graduated from the academy ranked first. As a detective, he then joins the cyber investigation department. Woo Hyun then works to reveal the secrets of those that hide within the cyber world.</p>",
    officialSite: "http://tv.sbs.co.kr/phantom/",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 127,
      name: "SBS",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2012-05-30",
  },
  {
    id: 4743,
    url: "https://www.tvmaze.com/shows/4743/grange-hill",
    name: "Grange Hill",
    genres: ["Drama", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53059.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53059.jpg",
    },
    summary:
      "<p><b>Grange Hill</b> is one of the most successful television children's dramas of all time. The drama takes a look at teenagers and their dilemmas in a Secondary school. Grange Hill has been running for over 20 years and many of the actors have gone on to star in other well known programmes such as Brookside, ER and Eastenders. Its Powerful storyline's, brilliant characters and superb cast. It's no wonder Grange Hill is a brilliant success. Grange Hill was previously filmed in London but now the show creator Phil Redmond has moved filming up to Liverpool so a lot of Actors have not made the move from London to Liverpool.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b0092k1v",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1978-02-08",
  },
  {
    id: 4744,
    url: "https://www.tvmaze.com/shows/4744/the-sarah-millican-television-programme",
    name: "The Sarah Millican Television Programme",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/34/86896.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/34/86896.jpg",
    },
    summary:
      "<p>Award-winning comedian Sarah Millican talks television, combining brilliant stand up inspired by what she has seen on screen and unique interviews with television people who have impressed her.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b01d94vq",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-03-08",
  },
  {
    id: 4745,
    url: "https://www.tvmaze.com/shows/4745/quiz-me-quick",
    name: "Quiz Me Quick",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53061.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53061.jpg",
    },
    summary: "",
    officialSite: null,
    webChannel: null,
    language: "Dutch",
    status: "Ended",
    network: {
      id: 121,
      name: "één",
      country: { name: "Belgium", code: "BE", timezone: "Europe/Brussels" },
    },
    premiered: "2012-10-21",
  },
  {
    id: 4746,
    url: "https://www.tvmaze.com/shows/4746/raising-the-bar",
    name: "Raising the Bar",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53062.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53062.jpg",
    },
    summary:
      "<p>A group of young lawyers, all former classmates, find themselves going up against one another as public defenders trying to help the down and out.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 14,
      name: "TNT",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-09-01",
  },
  {
    id: 4747,
    url: "https://www.tvmaze.com/shows/4747/trawlermen",
    name: "Trawlermen",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53072.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53072.jpg",
    },
    summary:
      "<p><b>Trawlermen</b> is a BBC television documentary programme focusing on the work of a number of trawler crews based in Peterhead. The programme is narrated by the actor Ken Stott.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b006t12t",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-07-31",
  },
  {
    id: 4748,
    url: "https://www.tvmaze.com/shows/4748/the-catch",
    name: "The Catch",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53073.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53073.jpg",
    },
    summary:
      "<p>The show offers an unprecedented insight into the reality of life at sea with deep-sea fishing being one of the most dangerous jobs in Britain.</p>",
    officialSite: "http://www.channel4.com/programmes/the-catch/",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-08-31",
  },
  {
    id: 4749,
    url: "https://www.tvmaze.com/shows/4749/jake-in-progress",
    name: "Jake in Progress",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53074.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53074.jpg",
    },
    summary:
      "<p>Life moves at a non-stop pace for Jake Phillips, a New-York based publicist-to-the-stars who's the key player at Magnum PR Agency. Handsome, incredibly well-dressed, he's on call 24/7 to meet the needs of his A-list clientele. Whether it's a macho action star caught in an embarrassing clinch, an older actress trying to dump her much-younger (and even more famous) boyfriend, or two warring teen divas - Jake is there to spin the facts and control his client's image, a task that often leads him into unexpectedly funny situations. Complicating his work life even further is his boss, Naomi, a woman in a people profession who frankly can't stand people, and who often uses Jake to act as her go-between when things get too personal with the staff or the clients. The fact that Naomi is an expectant single mom in the difficult final stretch of her first pregnancy doesn't help matters. Brooke is an...</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-03-13",
  },
  {
    id: 4750,
    url: "https://www.tvmaze.com/shows/4750/keen-eddie",
    name: "Keen Eddie",
    genres: ["Drama", "Comedy", "Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53075.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53075.jpg",
    },
    summary:
      "<p>A wisecracking N.Y. cop with no respect for authority, finds himself a fish out of water when he ends up being assigned to a police precinct in the U.K.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 4,
      name: "FOX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-06-03",
  },
  {
    id: 4751,
    url: "https://www.tvmaze.com/shows/4751/less-than-perfect",
    name: "Less Than Perfect",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/79/199914.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/79/199914.jpg",
    },
    summary:
      "<p><b>Less Than Perfect</b> follows Claude Casey, her friends and colleagues at fictional television network GCB.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2002-10-01",
  },
  {
    id: 4752,
    url: "https://www.tvmaze.com/shows/4752/im-with-her",
    name: "I'm with Her",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53088.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53088.jpg",
    },
    summary:
      "<p>Writer Chris Henchy's real life marriage to Brooke Shields is the inspiration for this fresh romantic comedy: He's an average guy living with a woman who can't even pick up their dry cleaning without being asked for an autograph! Which means he's got plenty of funny stories to bring to this series about a high school teacher who falls for a movie star.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2003-09-23",
  },
  {
    id: 4753,
    url: "https://www.tvmaze.com/shows/4753/in-justice",
    name: "In Justice",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53091.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53091.jpg",
    },
    summary:
      "<p><b>In Justice</b> stars Kyle MacLachlan as David Swain, an attorney who decides to head the Justice Project, which is a non-profit organization that is made up of young associates who try to overturn wrongful convictions, and to bring the falsely accused out of jail and put the real criminal behind bars. The investigator to help Swain is former cop Charles Conti who also helps keep Swain on his toes.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2006-01-01",
  },
  {
    id: 4754,
    url: "https://www.tvmaze.com/shows/4754/insecurity",
    name: "InSecurity",
    genres: ["Comedy", "Espionage"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53092.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53092.jpg",
    },
    summary:
      "<p>A comedy action series that revolves around a team of incompetent spy-catchers who work for the Canadian National Intelligence and Security Agency (NISA), a fictional intelligence gathering agency.</p><p>Secret agent Alex Cranston and her team of spies juggle dates, terrorists, pets, ex-boyfriends and the safety of the nation. But the only thing harder than protecting the country is protecting themselves from their own insecurity.</p>",
    officialSite: "http://www.cbc.ca/insecurity/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 36,
      name: "CBC",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2011-01-04",
  },
  {
    id: 4755,
    url: "https://www.tvmaze.com/shows/4755/rock-chips",
    name: "Rock & Chips",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53099.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53099.jpg",
    },
    summary:
      "<p>The prequel to <i>Only Fools and Horses</i> allows one to take a trip back in time and pay a visit to the ever popular Trotter family, circa 1960. Del Boy's mother Joan is less than happy with work dodger husband Reg. Her head is instantly turned following the return of jailbird and gentleman thief, Freddie 'The Frog' Robdal.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00x2zb7",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-01-25",
  },
  {
    id: 4756,
    url: "https://www.tvmaze.com/shows/4756/tv-heaven-telly-hell",
    name: "TV Heaven, Telly Hell",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53100.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53100.jpg",
    },
    summary:
      "<p>Comedian Sean Lock hosts celebrity guests on this talk show about television. Guests weigh in on their television tastes as they watch a variety of clips.</p>",
    officialSite: "http://www.channel4.com/programmes/tv-heaven-telly-hell",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2006-03-26",
  },
  {
    id: 4757,
    url: "https://www.tvmaze.com/shows/4757/trigger-happy-tv",
    name: "Trigger Happy TV",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/61/152846.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/61/152846.jpg",
    },
    summary:
      "<p>A hidden camera comedy programme starring Dom Joly deliberately entering into ludicrous or embarrassing situations in public places, all filmed surreptitiously. Sketches took place in a variety of locations primarily on the streets of Central London and Cheltenham. The humour is derived through the public's reactions to Joly's shenanigans rather than the usual format, where members of the public are themselves pranked.</p>",
    officialSite: "http://www.channel4.com/programmes/trigger-happy-tv",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2000-01-14",
  },
  {
    id: 4758,
    url: "https://www.tvmaze.com/shows/4758/hidden-identity",
    name: "Hidden Identity",
    genres: ["Action", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/60/150164.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/60/150164.jpg",
    },
    summary:
      "<p>Investigation 5 is a new undercover united specialized in fighting dangerous and violent crimes. A team of young and experienced officers under command by Superintendent Jang Moon Won are tasked to infiltrate dangerous crime syndicates with new identities. No back up, but only their wits and poker faces to their disposal, they have to fight crime and complete their missions without revealing their cover.</p>",
    officialSite: "http://program.interest.me/tvn/hidden?Main",
    webChannel: null,
    language: "Korean",
    status: "Ended",
    network: {
      id: 280,
      name: "tvN",
      country: {
        name: "Korea, Republic of",
        code: "KR",
        timezone: "Asia/Seoul",
      },
    },
    premiered: "2015-06-16",
  },
  {
    id: 4759,
    url: "https://www.tvmaze.com/shows/4759/the-rob-brydon-show",
    name: "The Rob Brydon Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53103.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53103.jpg",
    },
    summary:
      "<p><b>The Rob Brydon Show</b> is a British chat show hosted by comedian Rob Brydon. The first series started on 17 September 2010 and consists of six regular episodes, a compilation episode and a Christmas special. The second series had six regular episodes, a Christmas special and a compilation episode. The third and final series had six regular episodes.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b0117gwf",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-09-17",
  },
  {
    id: 4760,
    url: "https://www.tvmaze.com/shows/4760/extreme-fishing-with-robson-green",
    name: "Extreme Fishing with Robson Green",
    genres: ["Adventure", "Travel", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53104.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53104.jpg",
    },
    summary:
      "<p>Robson Green an experienced fly-fisherman embarks on a fishing trip of colossal proportions that sees him attempting to land some of the wildest and most elusive sea creatures in the world. On his journey, Robson casts out for such exotic destinations as Africa, Europe, America and China, where he meets some of the world's most skilled fishermen.</p>",
    officialSite:
      "http://www.channel5.com/shows/extreme-fishing-with-robson-green",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 135,
      name: "Channel 5",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2008-09-01",
  },
  {
    id: 4762,
    url: "https://www.tvmaze.com/shows/4762/robson-green-extreme-fisherman",
    name: "Robson Green: Extreme Fisherman",
    genres: ["Adventure", "Travel", "Sports"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53106.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53106.jpg",
    },
    summary:
      "<p>Not long ago, Robson Green was an enthusiastic amateur angler. For the last five years he's been on a fishing odyssey, experiencing fishing as he's never seen it before. With the extreme fishing series moving from Channel 5 to Quest, the title was changed to reflect that he is now one of the world's most experienced fishermen, rather than the mere amateur he was before, so in a brand new series, Robson is taking extreme fishing to a different level. This time, he will be using all the skills he's learned over the last five years – and testing himself to the limit to outwit the most extreme fish ever: the biggest, the weirdest, the most aggressive, the hardest to catch.</p>",
    officialSite: "http://www.questtv.co.uk/robson-green-extreme-fisherman/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 368,
      name: "Quest",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-08-04",
  },
  {
    id: 4763,
    url: "https://www.tvmaze.com/shows/4763/runs-house",
    name: "Run's House",
    genres: ["Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/22/55409.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/22/55409.jpg",
    },
    summary:
      "<p>Run's had his hands full with his lovely wife and family. Oh, and don't forget about his comeback album. Roll with Rev Run and fam in this reality sitcom. Who's house? Run's House!</p>",
    officialSite: "http://www.mtv.com/shows/runs_house/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 22,
      name: "MTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-10-13",
  },
  {
    id: 4764,
    url: "https://www.tvmaze.com/shows/4764/border-security-americas-front-line",
    name: "Border Security: America's Front Line",
    genres: ["Crime", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/62/155847.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/62/155847.jpg",
    },
    summary:
      "<p><b>Border Security: America's Front Line</b> follows the work of US Customs and Border Protection (CBP) officers and agents as they clear travelers at land, air and marine ports of entry, inspect cargo and secure America's borders. In search of illegal travelers, weapons, and contraband, there's never a dull moment for the men and women who work for CBP.</p>",
    officialSite: "http://www.globaltv.com/bordersecurity/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 67,
      name: "Global",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2012-09-06",
  },
  {
    id: 4765,
    url: "https://www.tvmaze.com/shows/4765/border-security-australias-front-line",
    name: "Border Security: Australia's Front Line",
    genres: ["Crime", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/82/205531.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/82/205531.jpg",
    },
    summary:
      "<p><b>Border Security: Australia's Front Line</b> is a fascinating insight into the daily workings of the thousands of officers who dedicate their lives to protecting Australia's border.</p><p>With unprecedented access to all areas of national security we patrol the front line with the men and woman of Customs and Border Protection, Immigration and Biosecurity.</p><p>No more than now has Australia's border been at such risk and Border Security is there capturing all the real-life drama at Australia's busiest airports, sea ports, cargo facilities, mail centres, and on operations in the community.</p>",
    officialSite: "https://7plus.com.au/border-security-australias-front-line",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 251,
      name: "Seven Network",
      country: { name: "Australia", code: "AU", timezone: "Australia/Sydney" },
    },
    premiered: "2004-10-13",
  },
  {
    id: 4766,
    url: "https://www.tvmaze.com/shows/4766/la-la-land",
    name: "La La Land",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53107.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53107.jpg",
    },
    summary:
      "<p><b>La La Land</b> is a half-hour series about three wannabes struggling to find fame and fortune in Los Angeles. La La Land is a hybrid of documentary and comedy – Marc plays fictitious characters but everybody else in the show, including his accomplices such as Kiki (Brendan's assistant), Chico (Shirley's driver) and Ruta (Gary's mentor), is completely real and utterly unaware they are talking to an actor.</p>",
    officialSite: "http://www.sho.com/site/lalaland/home.do",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 9,
      name: "Showtime",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-01-25",
  },
  {
    id: 4767,
    url: "https://www.tvmaze.com/shows/4767/garage-gold",
    name: "Garage GOLD",
    genres: ["DIY"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53112.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53112.jpg",
    },
    summary:
      "<p>When everything has to go, the Garage Brothers get to work. The company, based in Raleigh, N.C., specializes in cleaning out garages, basements, attics and work spaces overflowing with clutter that would make any hoarder envious. Led by owner Kraig Bantle, Garage Brothers organize each space and then redesign it into something the homeowners can enjoy. In exchange, Kraig and his team get to keep any valuables they find in the clean-out process, hoping there are some hidden treasures buried in the trash that they can sell at a profit. They also give many of the items they haul away to charities on <b>Garage GOLD</b>.</p>",
    officialSite: "http://www.diynetwork.com/shows/garage-gold",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 90,
      name: "DIY Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-04-06",
  },
  {
    id: 4768,
    url: "https://www.tvmaze.com/shows/4768/jonny-briggs",
    name: "Jonny Briggs",
    genres: ["Children", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/25/64640.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/25/64640.jpg",
    },
    summary:
      "<p><b>Jonny Briggs</b> is a Children's BBC kitchen sink realism television programme first broadcast in 1985. It revolves around the exploits of a young boy, the eponymous hero (played by Richard Holian), his pet dog, Razzle, and his eccentric family members: Mam (Jane Lowe) and Dad (Leslie Schofield), older sister Rita (Sue Devaney) and older brothers Albert (Tommy Robinson) and Humph (Humphrey) (Jeremy Austin). Another older sister, Marilyn, is mentioned but never seen. The stories often centre on Jonny's school life, where he and his best friend Pam are constantly in battle with the dreadful twins Ginny and Josie.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1985-11-11",
  },
  {
    id: 4770,
    url: "https://www.tvmaze.com/shows/4770/harry-hills-tv-burp",
    name: "Harry Hill's TV Burp",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53111.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53111.jpg",
    },
    summary:
      "<p>Harry Hill stars in this surreal comedy show, revolving around the previous week's shows on British television.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2002-11-14",
  },
  {
    id: 4771,
    url: "https://www.tvmaze.com/shows/4771/from-darkness",
    name: "From Darkness",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/23/57631.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/23/57631.jpg",
    },
    summary:
      "<p>Psychological crime drama. An ex-constable hiding from the guilt of her past is slowly drawn back to confront her darkness.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b06h7yy4",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-10-04",
  },
  {
    id: 4772,
    url: "https://www.tvmaze.com/shows/4772/the-f-word",
    name: "The F Word",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53113.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53113.jpg",
    },
    summary:
      "<p><b>The F-Word</b> is a British cooking show featuring chef Gordon Ramsay. The programme covers a wide range of topics, from recipes to food preparation and celebrity food fads.</p>",
    officialSite: "http://www.channel4.com/programmes/gordon-ramsays-f-word",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2005-10-27",
  },
  {
    id: 4773,
    url: "https://www.tvmaze.com/shows/4773/the-sunday-night-project",
    name: "The Sunday Night Project",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/61/152834.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/61/152834.jpg",
    },
    summary:
      "<p><b>The Sunday Night Project</b> was a British comedy-variety show by Princess Productions that first aired on Channel 4 in February 2005 under the title <i>The Friday Night Project</i>. Originally broadcast on Friday nights, the show moved to Sunday nights for its seventh series in 2008. Each week the regular hosts (from series 2 onwards) Justin Lee Collins and Alan Carr are joined by a celebrity guest host. These guests provide an opening monologue, are interviewed by Alan and Justin and take questions from the studio audience. They also take part in comedy sketches, hidden camera stunts and a game show where someone from the audience is selected to win prizes. When the show was called The Friday Night Project, it was not live; it was recorded at The London Studios on the night before it was broadcast on Channel 4. When the show became The Sunday Night Project, the show retained its Thursday night taping schedule.</p>",
    officialSite: "http://www.channel4.com/fnp",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2005-02-04",
  },
  {
    id: 4774,
    url: "https://www.tvmaze.com/shows/4774/educating-essex",
    name: "Educating Essex",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53115.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53115.jpg",
    },
    summary:
      "<p>What is life really like for today's students and teachers? This series has unprecedented access to an English secondary school to follow a group of GCSE students, and the staff who teach them, as they face the most important year in their education. Passmores School in Harlow, Essex, is a successful school in a challenging area. Under headteacher Vic Goddard, it's been awarded Academy status and is rated 'outstanding' by Ofsted. The school has been rigged with 65 fixed cameras - from the corridors to the canteen, and from the headteacher's office to the detention hall - to reveal every detail of daily life.</p>",
    officialSite: "http://www.channel4.com/programmes/educating-essex",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-09-22",
  },
  {
    id: 4775,
    url: "https://www.tvmaze.com/shows/4775/celebrity-conversations",
    name: "Celebrity Conversations",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53119.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53119.jpg",
    },
    summary:
      '<p>Film critic David Poland sits down with the biggest names in entertainment for an in-depth conversation about their art, craft and life on <i><b>"Celebrity Conversations"</b>.</i></p>',
    officialSite: "http://www.ovationtv.com/series/celebrity-conversations/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 208,
      name: "Ovation",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-07-12",
  },
  {
    id: 4776,
    url: "https://www.tvmaze.com/shows/4776/total-drama-pahkitew-island",
    name: "Total Drama Pahkitew Island",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53122.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53122.jpg",
    },
    summary:
      '<p>It was time to find a new home for Chris McLean and the Total Drama Crew. As we all know, the Cree word for "explode" is pahkitew… so when we found Pahkitew Island in Western Canada – success! Welcome to Total Drama Pahkitew Island! And, since they were starting anew, it only seemed right to bring in 14 brand new victims. Did we say victims? We meant contestants, but… tomatotomahto! Once again teen freaks, geeks, egos and cowards smash, crash, and bash their way through horrifying challenges with one goal in mind: winning that one million dollar prize! Who will take it home? No one knows until number 13 drops and the pain finally stops, here on <i><b>"Total Drama Pahkitew Island"</b></i>!</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-07-07",
  },
  {
    id: 4777,
    url: "https://www.tvmaze.com/shows/4777/total-drama-revenge-of-the-island",
    name: "Total Drama Revenge of the Island",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/255/639250.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/255/639250.jpg",
    },
    summary:
      "<p>After Chris took the show worldwide, Camp Wawanakwa has been abandoned and turned into a toxic nuclear waste dump. It will provide a great place for all-new challenges and risks as thirteen new players fight to win the million dollar prize.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-01-05",
  },
  {
    id: 4778,
    url: "https://www.tvmaze.com/shows/4778/total-drama-action",
    name: "Total Drama Action",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53125.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53125.jpg",
    },
    summary:
      '<p><i><b>"Total Drama Action"</b></i> is the second season of the Canadian animated television series Total Drama Island. The show premiered in Teletoon Canada 6:30 et/pt[2] on January 11, 2009. This series was also created by the makers of 6Teen, another Teletoon program. Like its predecessor, Total Drama Island, this season\'s series is an "animated reality show" starring fifteen teenagers. This series still portrays likeliness towards other physical and social shows, like Fear Factor and The Real World. The original twenty-two "campers" were cut down to fifteen "cast-mates" after the reunion special\'s dramatic ending between these seasons. Both host and assistant Chris McClean and Chef Hatchet will return as the cast-mates\' supervisors and challenge distributors. The theme of this series is "Cinematography".</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-01-11",
  },
  {
    id: 4779,
    url: "https://www.tvmaze.com/shows/4779/total-drama-island",
    name: "Total Drama Island",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53150.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53150.jpg",
    },
    summary:
      "<p>This animated take on the reality genre sees twenty-two teens competing in physical challenges in a dilapidated summer camp setting over a sixty day period.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-07-08",
  },
  {
    id: 4780,
    url: "https://www.tvmaze.com/shows/4780/total-drama-all-stars",
    name: "Total Drama All-Stars",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53151.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53151.jpg",
    },
    summary:
      '<p><i><b>"Total Drama All-Stars"</b></i> is a fictional titular reality show that follows the competition of fourteen returning teenagers at Camp Wawanakwa, a fictional island located in an unspecified area in Muskoka, Ontario, The campers participate in themed challenges and must avoid being voted off the island by their fellow campers. At the end of the series, the winning contestant or the last camper to stand on the island will win C$1,000,000. The competition is hosted by Chris McLean, who is assisted by the camp\'s chef, Chef Hatchet.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-09-10",
  },
  {
    id: 4781,
    url: "https://www.tvmaze.com/shows/4781/total-drama-world-tour",
    name: "Total Drama World Tour",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/255/639249.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/255/639249.jpg",
    },
    summary:
      '<p>Fifteen contestants are taken around the world throughout international based challenges and are required to break into song whenever Chris McLean rings a special chime, or face instant elimination. As the contestants are eliminated, they take the "Drop of Shame" by parachuting out of the plane in which the elimination ceremonies take place. When eliminated, they lose the chance at the million dollars (though such an elimination may not be permanent).</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-06-10",
  },
  {
    id: 4782,
    url: "https://www.tvmaze.com/shows/4782/total-drama-the-ridonculous-race",
    name: "Total Drama The Ridonculous Race",
    genres: ["Comedy", "Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/255/639251.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/255/639251.jpg",
    },
    summary:
      "<p>While parodying the Amazing Race, teams of two made up of Total Drama characters and new contestants will travel the globe to win the one million dollar prize.</p>",
    officialSite:
      "http://www.cartoonnetwork.com/video/total-drama-ridonculous-race/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 11,
      name: "Cartoon Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2015-09-07",
  },
  {
    id: 4783,
    url: "https://www.tvmaze.com/shows/4783/newsreaders",
    name: "Newsreaders",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53232.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53232.jpg",
    },
    summary:
      "<p><b>Newsreaders</b> is an absurd take on the television news magazine format, a show that goes behind the stories nobody else thinks are stories - because they're not. From the team behind Adult Swim's Emmy Award-winning comedy, Childrens Hospital.</p>",
    officialSite: "http://www.adultswim.com/videos/newsreaders/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 10,
      name: "Adult Swim",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-01-18",
  },
  {
    id: 4784,
    url: "https://www.tvmaze.com/shows/4784/educating-the-east-end",
    name: "Educating the East End",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/35/87900.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/35/87900.jpg",
    },
    summary:
      "<p>Playground high jinks, inspirational lessons and life-changing friendships and events, from Frederick Bremer School in East London.</p>",
    officialSite: "http://www.channel4.com/programmes/educating-the-east-end",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-09-04",
  },
  {
    id: 4785,
    url: "https://www.tvmaze.com/shows/4785/educating-yorkshire",
    name: "Educating Yorkshire",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53234.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53234.jpg",
    },
    summary:
      "<p>A warm and humorous exploration of what it's like to grow up or work in a secondary school in the heart of a diverse northern community.</p>",
    officialSite: "http://www.channel4.com/programmes/educating-yorkshire",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-09-05",
  },
  {
    id: 4786,
    url: "https://www.tvmaze.com/shows/4786/coppers",
    name: "Coppers",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53235.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53235.jpg",
    },
    summary:
      "<p>Filmed across Britain, from inner cities to country beats, <b>Coppers</b> reveals what the police are up against every day of their working lives.</p>",
    officialSite: "http://www.channel4.com/programmes/coppers",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-11-01",
  },
  {
    id: 4787,
    url: "https://www.tvmaze.com/shows/4787/killer-karaoke",
    name: "Killer Karaoke",
    genres: ["Comedy", "Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53236.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53236.jpg",
    },
    summary:
      "<p>Each week on <b>Killer Karaoke</b>, contestants will try to sing a hit song while being put through the most wild, fun and unexpected physical challenges imaginable. The hits just keep on coming as contestants try to carry a tune under fire. It's the game show that hits all the wrong notes in the best possible way.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 84,
      name: "truTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-11-23",
  },
  {
    id: 4788,
    url: "https://www.tvmaze.com/shows/4788/dr-steve-o",
    name: "Dr. Steve-O",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53237.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53237.jpg",
    },
    summary:
      '<p><b>Dr. Steve-O</b> is a reality TV show where Steve-O acts as a doctor, hence the name "Dr. Steve-O", to help males overcome their fears, thus the headline created by Steve-O, "Turning wussies into men". This means that in the shows, the subjects are known as "wussies". In every episode, Dr. Steve-O helps three different men, and makes them complete three challenges to overcome their fear.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 30,
      name: "USA Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2007-10-01",
  },
  {
    id: 4789,
    url: "https://www.tvmaze.com/shows/4789/clean-break",
    name: "Clean Break",
    genres: ["Drama", "Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/256/642427.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/256/642427.jpg",
    },
    summary:
      "<p>There's nothing like money - or the lack of it to bring out the worst in people. Frank Mallon, a car dealer running out of fiscal rope, catapults himself into serious trouble with the botched tiger kidnapping of local bank manager Desmond Rane's family, the repercussions of which rock his hometown and all the people around him.</p>",
    officialSite: "http://www.rte.ie/drama/tv/featured/cleanbreak/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 165,
      name: "RTÉ ONE",
      country: { name: "Ireland", code: "IE", timezone: "Europe/Dublin" },
    },
    premiered: "2015-09-27",
  },
  {
    id: 4790,
    url: "https://www.tvmaze.com/shows/4790/capture",
    name: "Capture",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53240.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53240.jpg",
    },
    summary:
      '<p><b>Capture</b> is a intense new wilderness competition, 12 teams of 2 will enter "The Arena", a fenced-in enclosure in the middle of the wild, where they must live for one month and compete against each other for scarce resources. With $250,000 on the line, it\'s a winner-take-all battle in which the teams must hunt each other down to survive.</p>',
    officialSite: "http://www.cwtv.com/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-07-30",
  },
  {
    id: 4791,
    url: "https://www.tvmaze.com/shows/4791/auf-wiedersehen-pet",
    name: "Auf Wiedersehen, Pet",
    genres: ["Drama", "Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53254.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53254.jpg",
    },
    summary:
      "<p><b>Auf Wiedersehen, Pet</b> is a story of the rise and fall of seven very different people. There are three Geordies, one Scouser, one Brummie, one Cockney and one from Bristol. <i>Auf Wiedersehen, Pet</i> shows what life was really like for self - employed workers in the 1980's. And after 20 years they are reunited and begin working together again.</p>",
    officialSite: "http://www.bbc.co.uk/drama/pet/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1983-11-11",
  },
  {
    id: 4792,
    url: "https://www.tvmaze.com/shows/4792/spitting-image",
    name: "Spitting Image",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53255.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53255.jpg",
    },
    summary:
      "<p><b>Spitting Image</b> is a British satirical puppet show, created by Peter Fluck, Roger Law and Martin Lambie-Nairn. The series was produced by 'Spitting Image Productions' for Central Independent Television over 18 series which aired on the ITV network. The series was nominated and won numerous awards during its run including 10 BAFTA Television Awards, including one for editing in 1989 and two Emmy Awards in 1985 and 1986 in the Popular Arts Category.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1984-02-26",
  },
  {
    id: 4793,
    url: "https://www.tvmaze.com/shows/4793/building-wild",
    name: "Building Wild",
    genres: ["DIY"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53256.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53256.jpg",
    },
    summary:
      "<p>It's the most rugged construction show ever built. Each week, Paulie and Tuffy - the Cabin Kings - meet a new client with a wild piece of property and a dream of building the perfect wilderness getaway. The Cabin Kings have just one week to conquer the elements and unveil this new backwoods paradise.</p>",
    officialSite: "http://channel.nationalgeographic.com/building-wild/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-05-19",
  },
  {
    id: 4794,
    url: "https://www.tvmaze.com/shows/4794/dragons-den",
    name: "Dragons' Den",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53257.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53257.jpg",
    },
    summary:
      "<p><b>Dragons' Den</b>, an original CBC Production and audience favourite, returns to delight viewers for a new season.</p><p>Aspiring entrepreneurs from across Canada vie for a coveted spot in the Den to pitch potentially profitable business investments to some of the nation's most successful tycoons. The Dragons use their own money and know-how and have the power to catapult companies into home-grown business success stories.</p><p>Every episode theatre and venture capital collide. Stakes are high as good deals may be rewarded, but there's also the risk that bad ideas will get burned. <i>Dragons' Den</i> offers the audience a front-row view as the country's top business moguls wheel and deal with entrepreneurs who dare to brave the Den.</p>",
    officialSite: "http://www.cbc.ca/dragonsden/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 36,
      name: "CBC",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2006-10-04",
  },
  {
    id: 4795,
    url: "https://www.tvmaze.com/shows/4795/and-then-there-were-none",
    name: "And Then There Were None",
    genres: ["Drama", "Crime", "Mystery"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/77/192526.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/77/192526.jpg",
    },
    summary:
      "<p>Europe teeters on the brink of war. Ten strangers are invited to Soldier Island, an isolated rock near the Devon coast. Cut off from the mainland, with their generous hosts Mr and Mrs U.N. Owen mysteriously absent, they are each accused of a terrible crime. When one of the party dies suddenly they realise they may be harbouring a murderer among their number.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b06v2v52",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-12-26",
  },
  {
    id: 4796,
    url: "https://www.tvmaze.com/shows/4796/a-pup-named-scooby-doo",
    name: "A Pup Named Scooby-Doo",
    genres: ["Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/201/504042.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/201/504042.jpg",
    },
    summary:
      '<p>For more than a decade, it looked as if this would be the final weekly Scooby Doo series. Following the unsuccessful run of The 13 Ghosts of Scooby-Doo, the creators went back to the drawing board and turned the original "Mystery Inc." characters into small children, who now worked under the title of "The Scooby Doo Detective Agency." Gone were the days of a pup named Scrappy-Doo, this series ushered in the age of a pup named Scooby-Doo! Although they would have been this age in the \'50s or \'60s, the kids were far more like kids of the \'80s, with computers, skateboards, and gadgets that were popularized far later. As in the original series, the villains of this series were always bad guys in rubber masks, a concept that they had gotten away from when Scrappy entered the show and the ghosts became real. More cartoonish than the rest of the shows, the characters seemed to nod back to...</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 3,
      name: "ABC",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1988-09-10",
  },
  {
    id: 4797,
    url: "https://www.tvmaze.com/shows/4797/king-of",
    name: "King of...",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53263.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53263.jpg",
    },
    summary:
      "<p><b>King of...</b> is a chat show hosted by Claudia Winkleman. The series takes a witty, informative and passionate look at the nation's favourite different things. Claudia, her different celebrity guests and the studio audience deliberate and debate to find the crème de la crème in various different categories.</p>",
    officialSite: "http://www.channel4.com/programmes/king-of",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-06-17",
  },
  {
    id: 4798,
    url: "https://www.tvmaze.com/shows/4798/micky-flanagans-detour-de-france",
    name: "Micky Flanagan's Detour de France",
    genres: ["Comedy", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/47/118426.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/47/118426.jpg",
    },
    summary:
      "<p>Bon voyage Micky! For his first-ever documentary series, the comedian is heading across the Channel to take in the sights and sounds of France, hopping on a bike to put his spin on the Tour de France - think Champagne vineyards, Belgian beer and nudist camps. Along for the ride is Flanagan's best pal of some 15 years, Noel Lynch - a brickie and cycling enthusiast.</p>",
    officialSite: "http://www.sky.com/tv/show/micky-flanagans-detour-de-france",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 63,
      name: "Sky 1",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-11-03",
  },
  {
    id: 4799,
    url: "https://www.tvmaze.com/shows/4799/band-of-gold",
    name: "Band of Gold",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53265.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53265.jpg",
    },
    summary:
      "<p>After kicking her abusive husband out and in debt to a loan shark, Gina Dickson meets Carol, a prostitute who introduces her to life on the game. Confronted with the reality of life on the streets, Gina and friends decide to start their own business, in an attempt to escape the influence of loan sharks, pimps and police.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1995-03-12",
  },
  {
    id: 4800,
    url: "https://www.tvmaze.com/shows/4800/balls-of-steel",
    name: "Balls of Steel",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53267.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53267.jpg",
    },
    summary:
      '<p>Mark Dolan (host) challenges a team of comedians and performers to a range of stupid stunts, undercover set-ups and loads more hilarious things that make them look stupid and juvenile. And they all want to prove that they have the biggest "Balls of Steel".</p>',
    officialSite: "http://www.channel4.com/programmes/balls-of-steel",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2005-08-19",
  },
  {
    id: 4801,
    url: "https://www.tvmaze.com/shows/4801/chris-moyles-quiz-night",
    name: "Chris Moyles' Quiz Night",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53266.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53266.jpg",
    },
    summary:
      "<p>Channel 4 has got the fabulous Chris Moyles on board to host a brand new quiz show - and he's putting up his own possessions as prizes! Chris will pit his wits against the celebrity guests each week in an attempt to keep hold of his stuff, otherwise his flat will begin to look rather empty... While the winner takes a bit of Chris' home, er, home, the loser will have to close out the show with a specially chosen karaoke song - accompanied by an eight-piece, all-female big band. With personal possessions and karaoke embarrassment on national telly at stake, tension will be high. The quiz is hosted by a different celebrity guest who will set the questions for the show, but with the master of mischief Moyles at the helm, expect energy and exuberance on tap.</p>",
    officialSite: "http://www.channel4.com/programmes/chris-moyles-quiz-night",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-03-22",
  },
  {
    id: 4802,
    url: "https://www.tvmaze.com/shows/4802/ask-rhod-gilbert",
    name: "Ask Rhod Gilbert",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53268.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53268.jpg",
    },
    summary:
      "<p>Comedy panel show in which comedian Rhod Gilbert and guests field questions from the general public as well as a host of well-known faces.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b0153zw9",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2010-09-27",
  },
  {
    id: 4803,
    url: "https://www.tvmaze.com/shows/4803/michael-mcintyres-comedy-roadshow",
    name: "Michael McIntyre's Comedy Roadshow",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53269.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53269.jpg",
    },
    summary:
      "<p>From the team behind BBC One's Live at the Apollo, <b>Michael McIntyre's Comedy Roadshow</b> travels around Britain visiting six of the UK's most prestigious and iconic venues, unearthing a raft of comedy's brightest new talent and finest comedians en route. In each episode Michael McIntyre introduces a very special guest headline act, plus three of the best stand ups from the UK comedy circuit who are new to a BBC One Saturday night audience. Michael McIntyre's Comedy Roadshow keeps its finger firmly on the pulse of the booming UK comedy scene.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b00ty5p5",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2009-06-06",
  },
  {
    id: 4804,
    url: "https://www.tvmaze.com/shows/4804/bams-bad-ass-game-show",
    name: "Bam's Bad Ass Game Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53270.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53270.jpg",
    },
    summary:
      "<p>Each week on <b>Bam's Bad Ass Game Show</b>, competitors will vie for $10,000 by facing off against each other in incredibly demented, potentially dangerous and occasionally painful challenges, like answering trivia questions while dangling above a pool of trash-filled water or dropping a watermelon on a target after being shot out of a cannon. The loser of each challenge is eliminated until there's only one contestant left standing to take home the cash prize.</p>",
    officialSite: "http://www.tbs.com/shows/bams-bad-ass-game-show/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 32,
      name: "TBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-04-14",
  },
  {
    id: 4805,
    url: "https://www.tvmaze.com/shows/4805/the-met-policing-london",
    name: "The Met: Policing London",
    genres: ["Crime"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53272.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53272.jpg",
    },
    summary:
      "<p><b>The Met: Policing London</b> is a documentary series filmed over the course of a year. The cameras follow officers from Britain's biggest and busiest police service as they deal with life, death, crime and its victims all over London.</p>",
    officialSite: "https://www.bbc.co.uk/programmes/b08s7cgb",
    webChannel: null,
    language: "English",
    status: "To Be Determined",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2015-06-08",
  },
  {
    id: 4806,
    url: "https://www.tvmaze.com/shows/4806/fort-boyard",
    name: "Fort Boyard",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53271.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53271.jpg",
    },
    summary:
      "<p><b>Fort Boyard</b> is a French game show created by Jacques Antoine that was first broadcast on 7 July 1990 (as <i>Les Clés de Fort Boyard</i>, shortened to <i>Fort Boyard</i> from the second series in 1991) and is popular to this day. It has been re-made around the world, successfully in many countries over a 25-year period.</p>",
    officialSite: "https://www.fort-boyard.fr/emissions.php",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 106,
      name: "France 2",
      country: { name: "France", code: "FR", timezone: "Europe/Paris" },
    },
    premiered: "1990-07-07",
  },
  {
    id: 4807,
    url: "https://www.tvmaze.com/shows/4807/parkinson",
    name: "Parkinson",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/26/67084.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/26/67084.jpg",
    },
    summary:
      "<p>Michael Parkinson was a showbiz veteran on BBC1 hosting his talk show. After his first few series he had already interviewed many a star from the time and had built up a fan base. People liked his interviewing technique where he would take a step back and let the guests say what they wanted to say. Although Michael began to be unhappy, after his Saturday 9pm slot kept having to be changed because of the football. So ITV decided to make him an offer he couldn't refuse, he would be able to continue his famous talk show, at his normal slot yet on ITV1. He agreed. Parkinson has just finished his second ITV series, and has interviewed such stars as Lauren Bacall and Bob Geldoff. With rumours afoot that he could possibly be hosting a special interview with the latest royal couple Charles &amp; Camilla, the show looks like it will continue to maintain the success it had done on BBC1.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2004-09-04",
  },
  {
    id: 4808,
    url: "https://www.tvmaze.com/shows/4808/brand-x-with-russell-brand",
    name: "Brand X with Russell Brand",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53273.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53273.jpg",
    },
    summary:
      "<p>The series premiere of Brand X, FX's new late-night comedy starring acclaimed actor/comedian Russell Brand, will debut, at 11:00 PM E/P. The series features Brand's unvarnished, unfiltered take on current events, politics and pop culture. The network has ordered six half-hour installments of the series that will be shot in front of a live audience. The format will draw heavily on Brand's interaction with that audience. The series is produced by FX Productions in association with Branded Films and Dakota Films. This marks the first television deal for Branded Films. Executive Producers are Russell Brand, Troy Miller and Nik Linnen. Miller also serves as Director of the series. The series was originally scheduled for the spring, but was pushed to the summer due to a film production starring Brand.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2012-06-28",
  },
  {
    id: 4809,
    url: "https://www.tvmaze.com/shows/4809/lee-macks-all-star-cast",
    name: "Lee Mack's All Star Cast",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53275.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53275.jpg",
    },
    summary:
      "<p>Comedian Lee Mack hosts a new Saturday night entertainment show. Packed full of celebrity guests, stand-up comedy and the great British public, everyone gets their moment in the spotlight.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b011kmcy",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-06-18",
  },
  {
    id: 4810,
    url: "https://www.tvmaze.com/shows/4810/da-ali-g-show",
    name: "Da Ali G Show",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53274.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53274.jpg",
    },
    summary:
      "<p>The Staines junglist provides his inimitable mix of global reportage and celebrity chat, ably assisted by Kazakhstan's finest journalist, Borat, and the glamorous Bruno (one name - like Madonna).</p>",
    officialSite: "http://www.channel4.com/programmes/da-ali-g-show",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 45,
      name: "Channel 4",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2000-03-30",
  },
  {
    id: 4811,
    url: "https://www.tvmaze.com/shows/4811/art-attack",
    name: "Art Attack",
    genres: ["Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53276.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53276.jpg",
    },
    summary:
      "<p><b>Art Attack </b>is a British children's television series revolving around art. The brand new series launched on Disney Junior (UK &amp; Ireland) on June 6th 2011 and is presented by Jassa Ahluwalia. Each show involves Jassa producing three works of art, taking the viewer through the various stages of production step by step. The original series was one of ITV's longest running programmes, running from 1990 to 2007, and was presented throughout by Neil Buchanan.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1990-06-15",
  },
  {
    id: 4812,
    url: "https://www.tvmaze.com/shows/4812/lemon-la-vida-loca",
    name: "Lemon La Vida Loca",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53278.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53278.jpg",
    },
    summary:
      "<p>Fly-on-the-wall spoof reality show documenting the celebrity lifestyle of Keith Lemon, the fake-tanned, tousled-haired presenter and star of Celebrity Juice and LemonAid. Keith's long-term girlfriend Rosie moves down to London and the couple set out to buy their dream home.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 54,
      name: "ITV2",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-08-02",
  },
  {
    id: 4813,
    url: "https://www.tvmaze.com/shows/4813/half-pint-brawlers",
    name: "Half Pint Brawlers",
    genres: ["Action"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53279.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53279.jpg",
    },
    summary:
      '<p>The world of little person wrestling is explored in this series, a combination of Jackass and Little People, Big World, says Spike. It features the often absurd adventures of "The Brawlers", a self-proclaimed hardcore performance wrestling group led by its founder, Puppet "The Psycho Dwarf", who has his hands full trying to keep his rambunctious crew in line -- both in and out of the ring -- as they travel to shows all across the country.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 34,
      name: "Paramount Network",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-06-02",
  },
  {
    id: 4814,
    url: "https://www.tvmaze.com/shows/4814/hogan-knows-best",
    name: "Hogan Knows Best",
    genres: ["Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53280.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53280.jpg",
    },
    summary:
      '<p>Hulk Hogan\'s famous "Grr" extends way beyond the wrestling ring and into his home. Not only is he a world famous wrestler - he\'s also a very "red state" suburban dad who lives on a 20,000-square-foot estate in Florida with wife Linda, 16 year-old daughter Brooke, who he won\'t allow to date and 14 year-old son Nick, who wants to be a race car driver. <b>Hogan Knows Best</b> takes you inside the Hogan household as Hulk and Linda wrestle with being PG parents in an increasingly R-rated world.</p>',
    officialSite: "http://www.vh1.com/shows/hogan_knows_best/series.jhtml",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 55,
      name: "VH1",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2005-07-10",
  },
  {
    id: 4815,
    url: "https://www.tvmaze.com/shows/4815/brooke-knows-best",
    name: "Brooke Knows Best",
    genres: ["Drama"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/43/108940.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/43/108940.jpg",
    },
    summary:
      "<p>Growing up with her overprotective father Hulk Hogan, Brooke wasn't allowed to date or be alone with a boy. But now that's she's turning 20, she's moving out and renting an apartment in Miami Beach, facing new responsibilities and opportunities as she tries to build a career as singer. Despite their recent divorce, both Mom and Dad help Brooke with the move. But will Hulk be able to let go of his little girl?</p>",
    officialSite: "http://www.vh1.com/shows/brooke_knows_best/series.jhtml",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 55,
      name: "VH1",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2008-07-13",
  },
  {
    id: 4816,
    url: "https://www.tvmaze.com/shows/4816/comedy-rocks-with-jason-manford",
    name: "Comedy Rocks with Jason Manford",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53282.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53282.jpg",
    },
    summary:
      "<p>Award winning comedian Jason Manford hosts these hour-long comedy and music entertainment shows for ITV1. Each week Jason will introduce some of the best new names from the comedy circuit, and each week he will also be joined by a well-known musical act too.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-01-14",
  },
  {
    id: 4817,
    url: "https://www.tvmaze.com/shows/4817/the-big-quiz",
    name: "The Big Quiz",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/175/439734.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/175/439734.jpg",
    },
    summary:
      "<p><b>The Big Quiz</b> is an entertainment quiz show hosted by Stephen Mulhern. The first episode aired on Friday 16 December 2011 with the teams consisting of the cast of Coronation Street's Jennie McAlpine, Malcolm Hebden, Patti Clare and Jack P Shepherd and Emmerdale's Mark Charnock, Natalie Anderson, Danny Miller and Meg Johnson. The second episode aired at 8.00pm on Sunday 15 April 2012 on ITV1, with the teams consisting of the cast of the hit comedy Benidorm: Jake Canuso, Crissy Rock, Janine Duvitski and Shelley Longworth take on reality show The Only Way is Essex consisting of Joey Essex, Lauren Goodger, James Argent and Gemma Collins. The contestants face questions on memorable moments from both programmesThe third show will be titled as 'The Big Sports Quiz' which will also be hosted by Stephen Mulhern, seeing boys and girls battle for who's best at sport.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2011-12-16",
  },
  {
    id: 4822,
    url: "https://www.tvmaze.com/shows/4822/bad-lads-army",
    name: "Bad Lads Army",
    genres: ["Action", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53286.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53286.jpg",
    },
    summary:
      "<p><b>Bad Lads Army</b> is a British reality TV programme, specifically of the kind that constitutes a historically derived social experiment - other examples being The 1900 House and The Frontier House. Shown on ITV, Bad Lads Army is based on the premise of subjecting delinquent individuals to the conditions of British National Service of the 1950s in order to see if this could rehabilitate them.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2004-07-08",
  },
  {
    id: 4823,
    url: "https://www.tvmaze.com/shows/4823/at-home-with-the-eubanks",
    name: "At Home with the Eubanks",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53329.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53329.jpg",
    },
    summary:
      "<p><b>At Home with the Eubanks</b> was a short-lived reality show starring British boxer Chris Eubank and his family which was broadcast on Channel Five.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 135,
      name: "Channel 5",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2003-09-02",
  },
  {
    id: 4825,
    url: "https://www.tvmaze.com/shows/4825/the-krypton-factor",
    name: "The Krypton Factor",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53288.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53288.jpg",
    },
    summary:
      '<p><b>The Krypton Factor</b> was a British game show produced by Granada Television for broadcast on ITV. Contestants from across the United Kingdom and Ireland competed in a series of rounds that tested their physical stamina and mental attributes. The title of the show is a reference to Superman\'s home planet Krypton, the title perceiving that the contestants had strong superhuman "powers" for taking part in the challenges they were set.</p>',
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1977-09-07",
  },
  {
    id: 4838,
    url: "https://www.tvmaze.com/shows/4838/ground-warfare",
    name: "Ground Warfare",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53313.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53313.jpg",
    },
    summary:
      "<p>Explore the nitty-gritty of Ground Warfare in an engaging and unpredictable way.</p><p>From Ancient Egypt to Afghanistan in 2008; Crusader castle-builders to 21st century robotics experts and from Roman slashing weapons to AK47s - we tell the fascinating story of how Ground Warfare has evolved through more than 3000 years of Human Experience.</p><p>Featuring hands-on demonstrations, lively reconstruction archaeology interspersed with dramatic archive footage and itnernational expert opinion, this powerful four-part series demonstrates everything from how chain mail stops an arrow and how night-vision goggles can make a mouse look the size of a small dog, to how cutting edge 'invisibility shields' can hide a tank.<br></p>",
    officialSite: "http://natgeotv.com/ca/ground-warfare",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 42,
      name: "National Geographic Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2009-10-03",
  },
  {
    id: 4840,
    url: "https://www.tvmaze.com/shows/4840/the-house-that-100k-built",
    name: "The House That £100k Built",
    genres: ["DIY"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53325.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53325.jpg",
    },
    summary:
      "<p>Architectural journalist and critic Kieran Long and award winning architect Piers Taylor are following self-builders as they take on the biggest gamble of their lives.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b062rfkr",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-09-18",
  },
  {
    id: 4843,
    url: "https://www.tvmaze.com/shows/4843/ancient-egypt-life-and-death-in-the-valley-of-the-kings",
    name: "Ancient Egypt: Life and Death in the Valley of the Kings",
    genres: ["History"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53337.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53337.jpg",
    },
    summary:
      "<p>Egyptologist Dr. Joann Fletcher investigates what everyday life was like in ancient Egypt for an ordinary person. What was it like to live and die in ancient Egypt, 3,500 years ago? Egyptologist Dr. Joann Fletcher goes on a fascinating journey in search of people like us - not the great Pharaohs but the ordinary people who built and populated this incredible ancient civilization. This investigation reveals a strange and mysterious world: the ancient Egyptian afterlife. To the ancient Egyptians, life was just a dress rehearsal for the perfect afterlife they were trying to reach. Joann clambers into rarely visited tombs, explores a treasure trove of long-buried objects and examines spectacular mummies to discover just why the Egyptians spent a fortune preparing for death - and what they hoped to find when they got there.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b01sc0xx",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-03-22",
  },
  {
    id: 4844,
    url: "https://www.tvmaze.com/shows/4844/aaagh-its-the-mr-hell-show",
    name: "Aaagh! It's the Mr. Hell Show!",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53338.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53338.jpg",
    },
    summary:
      "<p><b>Aaagh! It's the Mr. Hell Show!</b> is a British/Canadian co-produced animated sketch show. It is hosted by Mr. Hell, a cartoon devil voiced by the comic legend Bob Monkhouse.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2001-10-28",
  },
  {
    id: 4850,
    url: "https://www.tvmaze.com/shows/4850/food-factory",
    name: "Food Factory",
    genres: ["Food"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53354.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53354.jpg",
    },
    summary:
      "<p>This season <b>Food Factory</b> is celebrating special occasions! From Valentine's Day to Easter, birthday bashes to fun filled fiestas, we dish up an entire season of sassy and delicious themed episodes. Along the way, <i>Food Factory</i> reveals the mouthwatering secrets behind your favourite tasty treats. Whether lovingly handcrafted in small artisanal batches, or mass-produced by robots on a mega-industrial scale; it's a wild culinary ride as mountains of raw ingredients are transformed into the delectable delicacies we all know and love.</p>",
    officialSite: "http://www.foodnetwork.ca/shows/food-factory/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 325,
      name: "Food Network",
      country: { name: "Canada", code: "CA", timezone: "America/Halifax" },
    },
    premiered: "2012-08-30",
  },
  {
    id: 4855,
    url: "https://www.tvmaze.com/shows/4855/the-100k-house-tricks-of-the-trade",
    name: "The £100K House: Tricks of the Trade",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53364.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53364.jpg",
    },
    summary:
      "<p>Kieran Long and Piers Taylor come to the aid of homeowners as they take on ambitious building projects.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b04gvdlb",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 37,
      name: "BBC Two",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-09-02",
  },
  {
    id: 4859,
    url: "https://www.tvmaze.com/shows/4859/the-voice-uk",
    name: "The Voice UK",
    genres: ["Music"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/203/508255.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/203/508255.jpg",
    },
    summary:
      "<p>Join will.i.am and our other superstar coaches on their mission to find the next big thing for the music business. Alongside Will we have award-winning Jennifer Hudson, Lord of rock Gavin Rossdale and the legend that is Sir Tom Jones - all on the look out for the next big superstar. Will is promising magic, drama and lots of talent - and we can guarantee that this series of <b>The Voice UK</b> will not disappoint! The prize is a life-changing record deal with Polydor Records, one of the industry's most successful labels.</p>",
    officialSite: "http://www.itv.com/thevoice",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 35,
      name: "ITV",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2012-03-24",
  },
  {
    id: 4887,
    url: "https://www.tvmaze.com/shows/4887/fatal-attraction",
    name: "Fatal Attraction",
    genres: ["Drama", "Crime", "Thriller"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53500.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53500.jpg",
    },
    summary:
      "<p>Each pulse-pounding hour-long episode of <b>Fatal Attraction</b> centers around an incredible and dangerous romance. Shocking crime, kidnapping or even murder is only half of the story! In the end, the \"true love\" that draws these couples together isn't the kind that celebrates silver anniversaries – instead it leads to cross-country manhunts, bizarre cover-ups and dramatic trials. Driven by powerful, real-life stories, Fatal Attraction weaves together intimate, first-person interviews, exclusive interrogation footage and rare archival material. Along the way, it gives you a glimpse into the dark heart of a dangerous romance. Listen as the key players, family of the survivors and those that investigated the horrific crimes reveal the secrets to each sordid tale. Fatal Attraction…because love doesn't just hurt. It can kill!</p>",
    officialSite: "http://tvone.tv/category/shows/fatal-attraction/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 224,
      name: "TV One",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-06-03",
  },
  {
    id: 4895,
    url: "https://www.tvmaze.com/shows/4895/saint-george",
    name: "Saint George",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53539.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53539.jpg",
    },
    summary:
      '<p>A newly divorced working man-turned-entrepreneur balances the clashing culture of his all-American ex-wife, his over-bearing mother, his free-loading uncle, his cousin, his son and his school\'s "tough and sexy", assistant principal.</p>',
    officialSite:
      "https://web.archive.org/web/20140511083344/http://www.fxnetworks.com:80/saintgeorge/",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 13,
      name: "FX",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-03-06",
  },
  {
    id: 4910,
    url: "https://www.tvmaze.com/shows/4910/aerial-america",
    name: "Aerial America",
    genres: ["Nature", "Travel"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/103/257588.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/103/257588.jpg",
    },
    summary:
      "<p>Take off on a thrilling flight across America. This epic series offers rare glimpses of our nation's most treasured landmarks, all seen from breathtaking heights. From busy cityscapes to quiet landscapes, we capture the history and the pageantry of our amazing country, which is as diverse as the people who occupy it.</p>",
    officialSite: "http://www.smithsonianchannel.com/shows/aerial-america/701",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 86,
      name: "Smithsonian Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-07-10",
  },
  {
    id: 4912,
    url: "https://www.tvmaze.com/shows/4912/promised-land",
    name: "Promised Land",
    genres: ["Drama", "Adventure"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/302/755459.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/302/755459.jpg",
    },
    summary:
      "<p>When Russell Greene loses his job, he decides to go on the road with his family. So he gathers his family including his wife Claire, his son Josh, his daughter Dinah his mother, Hattie, and his nephew Nathaniel and hits the road. With only an old Suburban, a trailer, and a dream, Russell and his family are now traveling across the country in search of adventure and helping many people along the way. </p><p><b>Promised Land</b> was a spinoff of the series <i>Touched by an Angel</i> and had several crossover episodes with that series, as well as one with <i>Diagnosis Murder</i>.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 2,
      name: "CBS",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1996-09-17",
  },
  {
    id: 4940,
    url: "https://www.tvmaze.com/shows/4940/secrets-of-the-earth",
    name: "Secrets of the Earth",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53723.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53723.jpg",
    },
    summary:
      "<p><b>Secrets of the Earth</b>, from <b>The Weather Channel</b>, uses satellites to reveal stunning imagery of our planet's surface, oceans, and atmosphere.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 228,
      name: "The Weather Channel",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-05-23",
  },
  {
    id: 4957,
    url: "https://www.tvmaze.com/shows/4957/iheartradio-jingle-ball",
    name: "iHeartRadio Jingle Ball",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53807.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53807.jpg",
    },
    summary:
      "<p>The CW will remain the home of the annual iHeartRadio Music Festival for several more years, the company announced Monday. The broadcast network signed a new multi-year with iHeartMedia which will allow it to remain the exclusive TV broadcaster of the Las Vegas concert and the annual holiday <b>iHeartRadio Jingle Ball</b> concert.</p>",
    officialSite: "http://news.iheart.com/features/jingle-ball-2015-22/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 5,
      name: "The CW",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2013-12-18",
  },
  {
    id: 4958,
    url: "https://www.tvmaze.com/shows/4958/mutant-planet",
    name: "Mutant Planet",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/53808.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/53808.jpg",
    },
    summary:
      "<p><b>Mutant Planet </b>is a breath-taking, blue-chip documentary series that explores the unusual, the unexpected... and the downright bizarre. This series reveals incredible habitats where nature has allowed mutant animals, extraordinary adaptations, and curious patterns of behaviour to flourish through the miracle of natural selection and the wonder of evolution.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 92,
      name: "Animal Planet",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2010-12-04",
  },
  {
    id: 4963,
    url: "https://www.tvmaze.com/shows/4963/bitchin-rides",
    name: "Bitchin' Rides",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/232/580009.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/232/580009.jpg",
    },
    summary:
      "<p>Dave Kindig, owner and operator of Kindig-It Design in Salt Lake City, Utah turns out one-of-a-kind vehicles for his demanding (and sometimes famous) clientele. In Velocity's <b>Bitchin' Rides</b>, viewers will see Kindig and his team working on all types and periods of cars. From rendering and design to building and restoring, viewers see vehicles being made from the ground up before being revealed to the car's owner.</p>",
    officialSite: "https://watch.motortrend.com/tv-shows/bitchin-rides/",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 142,
      name: "MotorTrend",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "2014-09-02",
  },
  {
    id: 4980,
    url: "https://www.tvmaze.com/shows/4980/foute-vrienden",
    name: "Foute Vrienden",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/54126.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/54126.jpg",
    },
    summary: "",
    officialSite: "http://www.rtl.nl/foute-vrienden/#!/",
    webChannel: null,
    language: "Dutch",
    status: "Running",
    network: {
      id: 373,
      name: "RTL5",
      country: {
        name: "Netherlands",
        code: "NL",
        timezone: "Europe/Amsterdam",
      },
    },
    premiered: "2015-03-12",
  },
  {
    id: 4981,
    url: "https://www.tvmaze.com/shows/4981/fc-de-kampioenen",
    name: "F.C. De Kampioenen",
    genres: ["Comedy"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/23/58777.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/23/58777.jpg",
    },
    summary:
      "<p>This popular, long-running show was initially about Oscar Crucke, the coach of amateur football team 'F.C. De Kampioenen', who's referred to as \"De Kampioen\" (The Champion). The series follows the adventures of his family, the chairman and sponsor of the team Balthazar Boma as well as forward Pico, goalkeeper Xavier and their wives. Football unites these people, while the focus is mainly based on their daily lives.</p>",
    officialSite: null,
    webChannel: null,
    language: "Dutch",
    status: "Ended",
    network: {
      id: 121,
      name: "één",
      country: { name: "Belgium", code: "BE", timezone: "Europe/Brussels" },
    },
    premiered: "1990-10-06",
  },
  {
    id: 4987,
    url: "https://www.tvmaze.com/shows/4987/house-hunters",
    name: "House Hunters",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/114/285577.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/114/285577.jpg",
    },
    summary:
      "<p><b>House Hunters</b> takes viewers behind the scenes as individuals, couples and families learn what to look for and decide whether or not a home is meant for them. Focusing on the emotional experience of finding and purchasing a new home, each episode shows the process as buyers search for a home.</p>",
    officialSite: "http://www.hgtv.com/shows/house-hunters",
    webChannel: null,
    language: "English",
    status: "Running",
    network: {
      id: 192,
      name: "HGTV",
      country: {
        name: "United States",
        code: "US",
        timezone: "America/New_York",
      },
    },
    premiered: "1999-09-30",
  },
  {
    id: 4992,
    url: "https://www.tvmaze.com/shows/4992/angry-birds-toons",
    name: "Angry Birds Toons",
    genres: ["Comedy", "Children"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/54205.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/54205.jpg",
    },
    summary:
      "<p><b>Angry Birds Toons</b> tells how life is not always easy on Piggie Island. Red and angry feathered companions, Chuck, Mathilda, Bomb, Blues and Terence must come together to protect their eggs - and future - of cunning plots of Bad Piggies. Having only guides for their intelligence and determination, they absolutely must thwart the advanced technology Piggies are also incredibly too many. Nevertheless, they have a huge advantage ... the incredible stupidity of the Piggies! Angry Birds Toon gives life to characters and adventures of one of the most popular games in history and presents the amusing world, and cunning of Birds and their sworn enemies, the Piggies.</p>",
    officialSite: null,
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 372,
      name: "MTV3",
      country: { name: "Finland", code: "FI", timezone: "Europe/Helsinki" },
    },
    premiered: "2013-03-16",
  },
  {
    id: 4993,
    url: "https://www.tvmaze.com/shows/4993/penguins-spy-in-the-huddle",
    name: "Penguins: Spy in the Huddle",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/33/82621.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/33/82621.jpg",
    },
    summary:
      "<p><b>Penguins: Spy in the Huddle</b> spends nearly a year in their close company of penguins, deploying 50 spycams to capture as never before the true character of these birds.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p01460gm",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2013-02-11",
  },
  {
    id: 4994,
    url: "https://www.tvmaze.com/shows/4994/neko-zamurai",
    name: "Neko Zamurai",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/54208.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/54208.jpg",
    },
    summary:
      "<p>Madarame Kyutaro is a swordsman who was feared by people at one time. Now, he is poor and lives alone quietly. Kyutaro doesn't know how to earn money without using his sword. By chance, Sakichi happens to see Kyutaro's swordsmanship and offers to hire him for a job. Sakichi wants Kyutaro to kill a white cat named Tama-no-jyo which his boss Yozaemon is fascinated by. According to Sakichi, after Yozaemon began to raise the cat, he changed to a childlike person. Kyutaro initially turns him down thinking its an absurd request, but decides to take the job for the money. When Kyutaro opens the door to where the cat is, he sees the lovely white cat.</p>",
    officialSite: "http://nekozamurai.info/",
    webChannel: null,
    language: "Japanese",
    status: "Ended",
    network: {
      id: 76,
      name: "TV Tokyo",
      country: { name: "Japan", code: "JP", timezone: "Asia/Tokyo" },
    },
    premiered: "2013-10-13",
  },
  {
    id: 4996,
    url: "https://www.tvmaze.com/shows/4996/the-life-of-birds",
    name: "The Life of Birds",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/54209.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/54209.jpg",
    },
    summary:
      "<p>David Attenborough's epic series uncovers new research into the behaviour of these popular, perfectly adapted, skillul conquerors of the air. In this series, the secrets of birds' great successes comes to light - their remarkable strategies for finding food, their complex social systems, and their ingenious and often bizarre ways of mating and breeding. From high speed aerial hunters and long distance migrants to brilliantly coloured nectar-grazers, the comical and the bizarre, this is the definitive series on birds.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/b007qn69",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "1998-10-21",
  },
  {
    id: 4998,
    url: "https://www.tvmaze.com/shows/4998/hidden-kingdoms",
    name: "Hidden Kingdoms",
    genres: ["Nature"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/43/108067.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/43/108067.jpg",
    },
    summary:
      "<p>Immerse yourself in the lives of extraordinary characters that stand a few inches tall. From chipmunks to mice, be entertained and spellbound by the creatures that call the Hidden Kingdoms home.</p>",
    officialSite: "http://www.bbc.co.uk/programmes/p01nppg8",
    webChannel: null,
    language: "English",
    status: "Ended",
    network: {
      id: 12,
      name: "BBC One",
      country: {
        name: "United Kingdom",
        code: "GB",
        timezone: "Europe/London",
      },
    },
    premiered: "2014-01-16",
  },
  {
    id: 4999,
    url: "https://www.tvmaze.com/shows/4999/kvn-vyssaa-liga",
    name: "КВН - Высшая лига",
    genres: ["Comedy", "Family"],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/21/54212.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/21/54212.jpg",
    },
    summary:
      "<p>KVN is a Russian humour TV show and competition where teams compete by giving funny answers to questions and showing prepared sketches. The programme was first aired by the First Soviet Channel on November 8, 1961. Eleven years later, in 1972, when few programmes were being broadcast live, Soviet censors found the students' impromptu jokes offensive and anti-Soviet and banned KVN. The show was revived fourteen years later during the Perestroika era in 1986, with Alexander Maslyakov as its host. It is one of the longest-running TV programmes on Russian Television. It also has its own holiday on November 8, the birthday of the game, which KVN players celebrate every year since it was announced and widely celebrated for the first time in 2001.</p>",
    officialSite: "http://kvn.ru/",
    webChannel: null,
    language: "Russian",
    status: "Running",
    network: {
      id: 307,
      name: "Первый канал",
      country: {
        name: "Russian Federation",
        code: "RU",
        timezone: "Asia/Kamchatka",
      },
    },
    premiered: "1986-05-25",
  },
  {
    id: 5000,
    url: "https://www.tvmaze.com/shows/5000/bitva-ekstrasensov",
    name: "Битва Экстрасенсов",
    genres: [],
    image: {
      medium:
        "https://static.tvmaze.com/uploads/images/medium_portrait/275/688154.jpg",
      original:
        "https://static.tvmaze.com/uploads/images/original_untouched/275/688154.jpg",
    },
    summary: null,
    officialSite: "http://bitvaextrasensov.tnt-online.ru/",
    webChannel: null,
    language: "Russian",
    status: "Running",
    network: {
      id: 308,
      name: "ТНТ",
      country: {
        name: "Russian Federation",
        code: "RU",
        timezone: "Asia/Kamchatka",
      },
    },
    premiered: "2007-02-25",
  },
];
